export default function (editor: any, opt: any = {}) {
    const blockManager = editor.BlockManager;
    const category = opt.category;


    blockManager.add('careerum-header-2', {
        label: 'Хэдер',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: {type: "careerum-header-2"}
	});

    blockManager.add('careerum-header-2-tablet', {
        label: 'Хэдер (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: {type: "careerum-header-2-tablet"}
	});

    blockManager.add('careerum-header-2-mobile', {
        label: 'Хэдер (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: {type: "careerum-header-2-mobile"}
	});


    

    blockManager.add('careerum-footer-2', {
        label: 'Футер',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: {type: "careerum-footer-2"}
	});


    blockManager.add('careerum-footer-2-tablet', {
        label: 'Футер (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: {type: "careerum-footer-2-tablet"}
	});


    blockManager.add('careerum-footer-2-mobile', {
        label: 'Футер (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: {type: "careerum-footer-2-mobile"}
	});


    




    blockManager.add('career-request', {
        label: 'Курсы Найти работу',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="career-request">
        <div>
            <div>
                <div>
                    <div>
                        <h1>Найти<br><span>работу</span></h1>
                    </div>
                    <div>
                        <div class="careerum-flex-row">
                            <div class="careerum-course-tab-item">
                                <div>  
                                    <p>Курс</p>
                                    <p>2 часа 16 мин.</p>
                                </div>  
                                <h3>Продающее резюме</h3>
                                <p>Научитесь грамотно формулировать свои достижения и создадите сильное резюме на двух языках, которое точно рассмотрят</p>
                            </div>
                            <div class="careerum-flex-column">
                                <div class="careerum-master-tab-item">                                
                                    <div>  
                                        <p>Мастер-класс</p>
                                        <p>2 часа 39 мин.</p>
                                    </div>  
                                    <div>
                                        <h3>Great Deal: как<br> получить оффер мечты</h3>
                                        <p>Изучите секреты ведения переговоров, чтобы получать желаемую зарплату и другие привлекательные условия</p>
                                    </div>
                                </div>
                                <div class="careerum-master-tab-item">                                
                                    <div>  
                                        <p>Мастер-класс</p>
                                        <p>27 минут</p>
                                    </div>  
                                    <div>
                                        <h3>Менталитет продавца</h3>
                                        <p>Преодолеете внутреннее сопротивление к продаже своих навыков, умений<br> и идей</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="careerum-getcourse-email-form">
                            <div class="careerum-form-tab-item">
                                <div>
                                    <h3>Поиск работы может стать утомительным квестом</h3>
                                    <p>Скачайте бесплатный гайд «Как найти работу<br> на международном рынке», чтобы сохранить<br> нервы и получить желаемый оффер</p>
                                </div>
                                <div class="careerum-registration-form">
                                    <form class="deva-form getcourse-email-signup" name="devaRegistrationForm" data-gjs-type="deva-registration-form">
                                        <input name="email" type="email" value="" required>
                                        <span>Почта</span>
                                        <div>
                                            <input type="checkbox" name="" id="carerum-form-agr">
                                            <label data-toggle-checkbox="true"></label>
                                            <p>Я даю согласие на обработку моих персональных данных в соотвествии <br>с <a href="#">Политикой конфиденциальности</a>
                                        </div>
                                        <a class="submit-btn">Скачать гайд</a>
                                    </form>
                                </div>
                            </div>
                            <div class="careerum-form-success-tab-item">
                                <div>
                                    <h3>Письмо с ссылкой для скачивания<br> уже у вас на почте</h3>
                                </div>
                                
                            </div>
                        </div>    
                        <div class="careerum-flex-row">
                            <div class="careerum-flex-column">
                                <div class="careerum-master-tab-item">                                
                                    <div>  
                                        <p>Мастер-класс</p>
                                        <p>46 минут</p>
                                    </div>  
                                    <div>
                                        <h3>Hooked: как написать цепляющее сопрово-дительное письмо</h3>
                                        <p>Научитесь писать сопроводительное письмо, которое поможет выделиться среди других соискателей<br> и получить оффер</p>
                                    </div>
                                </div>
                                <div class="careerum-flex-row">
                                    <div class="careerum-course-tab-item">
                                        <div>  
                                            <p>Курс</p>
                                            <p>1 час 14 мин.</p>
                                        </div>  
                                        <h3>Connect: как использовать нетворкинг для жизни и карьеры</h3>
                                        <p>Поймете как выстроить крепкий нетворк</p>
                                    </div>
                                    <div class="careerum-course-tab-item">
                                        <div>  
                                            <p>Курс</p>
                                            <p>8 часов 37 мин.</p>
                                        </div>  
                                        <h3>Высокий<br> старт: как попасть в консалтинг</h3>
                                        <p>Узнаете, какие перспективы есть в консалтинге для разных специалистов </p>
                                    </div>
                                </div>
                                <div class="careerum-flex-row">
                                    <div class="careerum-vebinar-tab-item">
                                        <div>  
                                            <p>Вебинар</p>
                                            <p>2 часа 21 мин.</p>
                                        </div>  
                                            <h3>Как попасть<br> в Google: секреты<br> и подводные камни</h3>
                                    </div>
                                    <div class="careerum-vebinar-tab-item">
                                        <div>  
                                            <p>Вебинар</p>
                                            <p>1 час 37 мин.</p>
                                        </div>  
                                            <h3>The other side: recruiter’s view<br> on a job search</h3>
                                    </div>
                                </div>
                            </div>
                            <div class="careerum-flex-column">
                                <div class="careerum-course-tab-item">
                                    <div>  
                                        <p>Курс</p>
                                        <p>2 часа 33 мин.</p>
                                    </div>  
                                    <h3>Эффективное интервью</h3>
                                    <p>Поймете, как выгодно подать <br>себя на интервью и научитесь<br> отвечать даже на самые<br> сложные вопросы рекрутера</p>
                                </div>
                                <div class="careerum-course-tab-item">
                                    <div>  
                                        <p>Курс</p>
                                        <p>2 часа 16 мин.</p>
                                    </div>  
                                    <h3>Умная стратегия поиска<br> работы</h3>
                                    <p>Создадите пошаговый план <br>поиска работы, который<br> приведет вас к офферу мечты</p>
                                </div>                                
                            </div>
                        </div>  
                    </div>
                </div>
                <div>
                    <div class="careerum-scroll-from-top">
                        <p>Материалы<br> доступны только<br> после вступления<br> в Careerum.Club</p>
                        <a href="#">Вступить в клуб</a>
                    </div>
                </div>
            </div>
        </div>
    </div>`
	});


    blockManager.add('career-request-tablet', {
        label: 'Курсы Найти работу (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="career-request-tablet">
        <div>
            <div>
                <div>
                    <div>
                        <h1>Найти<br><span>работу</span>
                        </h1>
                    </div>
                    <div>
                        <div class="careerum-flex-row">
                            <div class="careerum-course-tab-item">
                                <div>
                                    <p>Курс</p>
                                    <p>2 часа 16 мин.</p>
                                </div>
                                <h3>Умная стратегия поиска работы</h3>
                                <p>Создадите пошаговый план <br>поиска работы, который<br> приведет вас к офферу мечты
                                </p>
                            </div>
                            <div class="careerum-course-tab-item">
                                <div>
                                    <p>Курс</p>
                                    <p>2 часа 16 мин.</p>
                                </div>
                                <h3>Продающее резюме</h3>
                                <p>Научитесь грамотно формулировать свои достижения и создадите сильное резюме на двух
                                    языках, которое точно рассмотрят</p>
                            </div>
                        </div>
                        <div class="careerum-master-tab-item">
                            <div>
                                <p>Мастер-класс</p>
                                <p>46 минут</p>
                            </div>
                            <div>
                                <h3>Hooked: как написать цепляющее сопрово-дительное письмо</h3>
                                <p>Научитесь писать сопроводительное письмо, которое выделит вас среди других соискателей</p>
                            </div>
                        </div>
                        <div class="careerum-getcourse-email-form-tablet">
                            <div class="careerum-form-tab-item-tablet">
                                <div>
                                    <h3>Поиск работы может<br> стать утомительным<br> квестом</h3>
                                    <p>Скачайте бесплатный гайд «Как найти работу<br> на международном рынке» чтобы сохранить
                                        нервы<br> и получить желаемый оффер</p>
                                </div>
                                <div class="careerum-registration-form-tablet">
                                    <form class="deva-form getcourse-email-signup" name="devaRegistrationForm" data-gjs-type="deva-registration-form">
                                        <input name="email" type="email" value="" required>
                                        <span>Почта</span>
                                        <a class="submit-btn">Скачать гайд</a>
                                        <div>
                                            <input type="checkbox" name="" id="carerum-form-agr-tablet">
                                            <label data-toggle-checkbox="true"></label>
                                            <p>Я даю согласие на обработку моих персональных<br> данных в соотвествии с <a
                                                    href="#">Политикой конфиденциальности</a>
                                        </div>
                                    </form>
                                </div>
                            </div>
                            <div class="careerum-form-success-tab-item-tablet">
                                <div>
                                    <h3>Письмо с ссылкой<br> для скачивания<br> уже у вас на почте</h3>
                                </div>
                                
                            </div>
                        </div>
                        <div class="careerum-flex-row">
                            <div class="careerum-flex-column">
                                <div class="careerum-vebinar-tab-item">
                                    <div>
                                        <p>Вебинар</p>
                                        <p>1 час 37 мин.</p>
                                    </div>
                                    <h3>The other side: recruiter’s view<br> on a job search</h3>
                                </div>
                                <div class="careerum-vebinar-tab-item">
                                    <div>
                                        <p>Вебинар</p>
                                        <p>2 часа 21 мин.</p>
                                    </div>
                                    <h3>Как попасть<br> в Google: секреты<br> и подводные камни</h3>
                                </div>
                            </div>
                            <div class="careerum-course-tab-item">
                                <div>
                                    <p>Курс</p>
                                    <p>2 часа 33 мин.</p>
                                </div>
                                <h3>Эффективное интервью</h3>
                                <p>Поймете, как выгодно подать себя на интервью и научитесь отвечать даже на самые сложные вопросы рекрутера</p>
                            </div>
                        </div>
                        <div class="careerum-master-tab-item">
                            <div>
                                <p>Мастер-класс</p>
                                <p>27 минут</p>
                            </div>
                            <div>
                                <h3>Менталитет<br> продавца</h3>
                                <p>Преодолеете внутреннее сопротивление к продаже своих навыков, умений<br> и идей</p>
                            </div>
                        </div>
                        <div class="careerum-flex-row">
                            <div class="careerum-course-tab-item">
                                <div>
                                    <p>Курс</p>
                                    <p>1 час 14 мин.</p>
                                </div>
                                <h3>Connect: как использовать нетворкинг<br> для жизни и карьеры</h3>
                                <p>Поймете как выстроить крепкий нетворк</p>
                            </div>
                            <div class="careerum-course-tab-item">
                                <div>
                                    <p>Курс</p>
                                    <p>8 часов 37 мин.</p>
                                </div>
                                <h3>Высокий<br> старт: как попасть в консалтинг</h3>
                                <p>Узнаете, какие перспективы есть в консалтинге для<br> разных специалистов </p>
                            </div>
                        </div>
                        <div class="careerum-master-tab-item">
                            <div>
                                <p>Мастер-класс</p>
                                <p>2 часа 39 мин.</p>
                            </div>
                            <div>
                                <h3>Great Deal: как<br> получить оффер мечты</h3>
                                <p>Изучите секреты ведения переговоров, чтобы получать желаемую зарплату и другие  условия</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <div class="careerum-scroll-from-top">
                        <p>Материалы<br> доступны только<br> после вступления<br> в Careerum.Club</p>
                        <a href="#">Вступить в клуб</a>
                    </div>
                </div>
            </div>
        </div>
    </div>`
	});


    blockManager.add('career-request-mobile', {
        label: 'Курсы Найти работу (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="career-request-mobile">
        <div>
            <div>
                <div>
                    <div>
                        <h1>Найти<br><span>работу</span>
                        </h1>
                    </div>
                    <div>
                        <div class="careerum-scroll-from-top">
                            <a href="#">Вступить в Careerum.Club и получить материалы</a>
                        </div>
                    </div>
                    <div>
                        <div class="careerum-course-tab-item">
                            <div>
                                <p>Курс</p>
                                <p>2 часа 16 мин.</p>
                            </div>
                            <h3>Умная стратегия<br> поиска работы</h3>
                            <p>Создадите пошаговый план <br>поиска работы, который приведет вас к офферу мечты
                            </p>
                        </div>
                        <div class="careerum-vebinar-tab-item">
                            <div>
                                <p>Вебинар</p>
                                <p>2 часа 21 мин.</p>
                            </div>
                            <h3>Как попасть<br> в Google: секреты<br> и подводные камни</h3>
                        </div>
                        <div class="careerum-course-tab-item">
                            <div>
                                <p>Курс</p>
                                <p>2 часа 16 мин.</p>
                            </div>
                            <h3>Продающее резюме</h3>
                            <p>Научитесь грамотно формулировать свои достижения и создадите сильное резюме на двух
                                языках, которое точно рассмотрят</p>
                        </div>
                        <div class="careerum-getcourse-email-form-mobile">
                            <div class="careerum-form-tab-item-mobile">
                                <div>
                                    <h3>Поиск работы может<br> стать утомительным<br> квестом</h3>
                                    <p>Скачайте бесплатный гайд «Как<br> найти работу на международном<br> рынке» чтобы сохранить
                                        нервы<br> и получить желаемый оффер</p>
                                </div>
                                <div class="careerum-registration-form-mobile">
                                    <form class="deva-form getcourse-email-signup" name="devaRegistrationForm" data-gjs-type="deva-registration-form">
                                        <input name="email" type="email" value="" required>
                                        <span>Почта</span>
                                        
                                        <div>
                                            <input type="checkbox" name="" id="carerum-form-agr-mobile">
                                            <label data-toggle-checkbox="true"></label>
                                            <p>Я даю согласие на обработку моих персональных данных в соотвествии <br>с <a
                                                    href="#">Политикой конфиденциальности</a>
                                        </div>
                                        <a class="submit-btn">Скачать гайд</a>
                                    </form>
                                </div>
                            </div>
                            <div class="careerum-form-success-tab-item-mobile">
                                <div>
                                    <h3>Письмо с ссылкой<br> для скачивания<br> уже у вас на почте</h3>
                                </div>
                            </div>
                        </div>
                        <div class="careerum-master-tab-item">
                            <div>
                                <p>Мастер-класс</p>
                                <p>46 минут</p>
                            </div>
                            <div>
                                <h3>Hooked: как написать цепляющее сопрово-дительное письмо</h3>
                                <p>Научитесь писать сопроводительное письмо, которое поможет <br>выделиться среди других<br> соискателей и получить оффер</p>
                            </div>
                        </div>
                        <div class="careerum-master-tab-item">
                            <div>
                                <p>Мастер-класс</p>
                                <p>27 минут</p>
                            </div>
                            <div>
                                <h3>Менталитет продавца</h3>
                                <p>Преодолеете внутреннее сопротивление к продаже своих навыков, умений и идей</p>
                            </div>
                        </div>
                        <div class="careerum-course-tab-item">
                            <div>
                                <p>Курс</p>
                                <p>2 часа 33 мин.</p>
                            </div>
                            <h3>Эффективное<br> интервью</h3>
                            <p>Поймете, как выгодно подать себя<br> на интервью и научитесь отвечать<br> даже на самые сложные
                                вопросы<br> рекрутера</p>
                        </div>
                        <div class="careerum-vebinar-tab-item">
                            <div>
                                <p>Вебинар</p>
                                <p>1 час 37 мин.</p>
                            </div>
                            <h3>The other side: recruiter’s view<br> on a job search</h3>
                        </div>
                        <div class="careerum-master-tab-item">
                            <div>
                                <p>Мастер-класс</p>
                                <p>2 часа 39 мин.</p>
                            </div>
                            <div>
                                <h3>Great Deal: как<br> получить оффер мечты</h3>
                                <p>Изучите секреты ведения<br> переговоров, чтобы получать<br> желаемую зарплату и другие<br> привлекательные условия</p>
                            </div>
                        </div>
                        <div class="careerum-course-tab-item">
                            <div>
                                <p>Курс</p>
                                <p>1 час 14 мин.</p>
                            </div>
                            <h3>Connect: как<br> использовать<br> нетворкинг для<br> жизни и карьеры</h3>
                            <p>Поймете как выстроить<br> крепкий нетворк</p>
                        </div>
                        <div class="careerum-course-tab-item">
                            <div>
                                <p>Курс</p>
                                <p>8 часов 37 мин.</p>
                            </div>
                            <h3>Высокий старт: как <br>попасть в консалтинг</h3>
                            <p>Узнаете, какие перспективы <br>есть в консалтинге для разных специалистов  </p>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>`
	});


    

    blockManager.add('careerum-new-tariffs', {
        label: 'Новые тарифы',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: [
            { type: 'careerum-new-tariffs-eng'},
            { type: 'careerum-new-tariffs-rus'},
        ]
	});

    blockManager.add('careerum-new-tariffs-tablet', {
        label: 'Новые тарифы (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: [
            { type: 'careerum-new-tariffs-tablet-eng'},
            { type: 'careerum-new-tariffs-tablet-rus'},
        ]
	});

    blockManager.add('careerum-new-tariffs-mobile', {
        label: 'Новые тарифы (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: [
            { type: 'careerum-new-tariffs-mobile-eng'},
            { type: 'careerum-new-tariffs-mobile-rus'},
        ]
	});


    
    blockManager.add('careerum-getcourse-email-form', {
        label: 'Лид форма',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="careerum-getcourse-email-form">
        <div class="careerum-form-tab-item">
            <div>
                <h3>Поиск работы может стать утомительным квестом</h3>
                <p>Скачайте бесплатный гайд «Как найти работу<br> на международном рынке», чтобы сохранить<br> нервы и получить желаемый оффер</p>
            </div>
            <div class="careerum-registration-form">
                <form class="deva-form getcourse-email-signup" name="devaRegistrationForm" data-gjs-type="deva-registration-form">
                    <input name="email" type="email" value="" required>
                    <span>Почта</span>
                    <div>
                        <input type="checkbox" name="" id="carerum-form-agr">
                        <label data-toggle-checkbox="true"></label>
                        <p>Я даю согласие на обработку моих персональных данных в соотвествии <br>с <a href="#">Политикой конфиденциальности</a>
                    </div>
                    <a class="submit-btn">Скачать гайд</a>
                </form>
            </div>
        </div>
        <div class="careerum-form-success-tab-item">
            <div>
                <h3>Письмо с ссылкой для скачивания<br> уже у вас на почте</h3>
            </div>
            
        </div>
    </div>`
    });
    
    blockManager.add('careerum-getcourse-email-form-tablet', {
        label: 'Лид форма (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="careerum-getcourse-email-form-tablet">
        <div class="careerum-form-tab-item-tablet">
            <div>
                <h3>Поиск работы может<br> стать утомительным<br> квестом</h3>
                <p>Скачайте бесплатный гайд «Как найти работу<br> на международном рынке» чтобы сохранить
                    нервы<br> и получить желаемый оффер</p>
            </div>
            <div class="careerum-registration-form-tablet">
                <form class="deva-form getcourse-email-signup" name="devaRegistrationForm" data-gjs-type="deva-registration-form">
                    <input name="email" type="email" value="" required>
                    <span>Почта</span>
                    <a class="submit-btn">Скачать гайд</a>
                    <div>
                        <input type="checkbox" name="" id="carerum-form-agr-tablet">
                        <label data-toggle-checkbox="true"></label>
                        <p>Я даю согласие на обработку моих персональных<br> данных в соотвествии с <a
                                href="#">Политикой конфиденциальности</a>
                    </div>
                </form>
            </div>
        </div>
        <div class="careerum-form-success-tab-item-tablet">
            <div>
                <h3>Письмо с ссылкой<br> для скачивания<br> уже у вас на почте</h3>
            </div>
            
        </div>
    </div>`
    });
    
    blockManager.add('careerum-getcourse-email-form-mobile', {
        label: 'Лид форма (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="careerum-getcourse-email-form-mobile">
        <div class="careerum-form-tab-item-mobile">
            <div>
                <h3>Поиск работы может<br> стать утомительным<br> квестом</h3>
                <p>Скачайте бесплатный гайд «Как<br> найти работу на международном<br> рынке» чтобы сохранить
                    нервы<br> и получить желаемый оффер</p>
            </div>
            <div class="careerum-registration-form-mobile">
                <form class="deva-form getcourse-email-signup" name="devaRegistrationForm" data-gjs-type="deva-registration-form">
                    <input name="email" type="email" value="" required>
                    <span>Почта</span>
                    
                    <div>
                        <input type="checkbox" name="" id="carerum-form-agr-mobile">
                        <label data-toggle-checkbox="true"></label>
                        <p>Я даю согласие на обработку моих персональных данных в соотвествии <br>с <a
                                href="#">Политикой конфиденциальности</a>
                    </div>
                    <a class="submit-btn">Скачать гайд</a>
                </form>
            </div>
        </div>
        <div class="careerum-form-success-tab-item-mobile">
            <div>
                <h3>Письмо с ссылкой<br> для скачивания<br> уже у вас на почте</h3>
            </div>
        </div>
    </div>`
    });

      

    blockManager.add('careerum-another-goals', {
        label: 'Другие карьерные цели',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="careerum-another-goals">
        <div>
            <div><h2>Другие<br> карьерные<br> цели</h2></div>
            <div>
                <div>
                    <a href="#">Получить повышение</a>
                    <a href="#">Зарабатывать больше </a>
                    <a href="#">Переехать по работе</a>
                    <a href="#">Выйти из декрета</a>
                    <a href="#">Расти в кризис</a>
                </div>
                <div>
                    <a href="#">Сменить сферу</a>
                    <a href="#">Понять, куда двигаться</a>
                    <a href="#">Укрепить самооценку</a>
                    <a href="#">Полюбить свою работу</a>
                    <a href="#">Найти работу</a>
                </div>
            </div>
        </div>
    </div>`
	});


    blockManager.add('careerum-another-goals-tablet', {
        label: 'Другие карьерные цели (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="careerum-another-goals-tablet">
        <div>
            <div>
                <h2>Другие<br> карьерные<br> цели</h2>
            </div>
            <div>
                <div>
                    <a href="#">Получить повышение</a>
                    <a href="#">Зарабатывать больше </a>
                    <a href="#">Переехать по работе</a>
                    <a href="#">Выйти из декрета</a>
                    <a href="#">Сменить сферу</a>
                    <a href="#">Понять, куда двигаться</a>
                    <a href="#">Укрепить самооценку</a>
                    <a href="#">Полюбить свою работу</a>
                    <a href="#">Расти в кризис</a>
                </div>
            </div>
        </div>
    </div>`
	});


    blockManager.add('careerum-another-goals-mobile', {
        label: 'Другие карьерные цели (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="careerum-another-goals-mobile">
        <div>
            <div>
                <h2>Другие<br> карьерные<br> цели</h2>
            </div>
            <div>
                <div>
                    <a href="#">Получить повышение</a>
                    <a href="#">Зарабатывать больше </a>
                    <a href="#">Переехать по работе</a>
                    <a href="#">Выйти из декрета</a>
                    <a href="#">Сменить сферу</a>
                    <a href="#">Понять, куда двигаться</a>
                    <a href="#">Укрепить самооценку</a>
                    <a href="#">Полюбить свою работу</a>
                    <a href="#">Расти в кризис</a>
                </div>
            </div>
        </div>
    </div>`
	});



    
    blockManager.add('careerum-club-main', {
        label: 'Разворот клуба',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="careerum-club-main">
        <div>
            <div>
                <h1><span>Careerum.Club </span><br>Пространство карьерного<br> развития профессионалов<br> со всего мира
                </h1>
            </div>
            <div>
                <div>
                    <p>15 обучающих программ под любой карьерный запрос</p>
                </div>
                <div>
                    <p>Социальная сеть <br>с русскоязычными профессионалами из 28 стран</p>
                </div>
                <div>
                    <p>Поддержка международных коучей и CV-эксперта </p>
                </div>
            </div>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-club-main-tablet', {
        label: 'Разворот клуба (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="careerum-club-main-tablet">
        <div>
            <div>
                <h1><span>Careerum.Club </span><br>Пространство<br> карьерного развития<br> профессионалов<br> со всего мира
                </h1>
            </div>
            <div>
                <div>
                    <p>15 обучающих программ под любой карьерный запрос</p>
                </div>
                <div>
                    <p>Социальная сеть <br>с русскоязычными профессионалами из 28 стран</p>
                </div>
                <div>
                    <p>Поддержка международных коучей и CV-эксперта </p>
                </div>
            </div>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-club-main-mobile', {
        label: 'Разворот клуба (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="careerum-club-main-mobile">
        <div>
            <div class="careerum-club-main-header">
                <h1><span>Careerum.Club </span><br>Пространство<br> карьерного<br> развития<br> профессионалов<br> со всего мира
                </h1>
            </div>
            <div id="careerum-main-header-amination-1"></div>
            <div id="careerum-main-header-amination-2"></div>
            <div id="careerum-main-header-amination-3"></div>
        </div>
    </div>`
    });


    
    blockManager.add('careerum-for-you-or-not', {
        label: 'Клуб (не) для вас',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="careerum-block-switcher">
        <div>
            <div>
                <input type="checkbox" name="" id="block-switcher-input">
                <label for="block-switcher-input"> <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1656674362435.svg" alt=""></label>
            </div>
        </div>
    </div>
    <div class="careerum-why-for-you-true">
        <div>
            <div>
                <h2>Клуб для вас, <br>если вы</h2>
            </div>
            <div>
                <div>
                    <p>Стремитесь получать повышения в зарплате<br> и в должности</p>
                </div>
                <div>
                    <p>Планируете развивать карьеру на международном рынке</p>
                </div>
                <div>
                    <p>Хотите выгодно выделяться в конкурентной среде</p>
                </div>
                <div>
                    <p>Готовы вкладывать время и силы в развитие своей карьеры</p>
                </div>
            </div>
            <div>
                <a href="#">Хочу в клуб!</a>
            </div>
        </div>
    </div>
    <div class="careerum-why-for-you-false">
        <div>
            <div>
                <h2>Клуб не для вас, <br>если вы</h2>
            </div>
            <div>
                <div>
                    <p>Уверены, что не можете влиять на свое повышение и зарплатуи</p>
                </div>
                <div>
                    <p>Думаете, что на международном рынке «мы никому не нужны»</p>
                </div>
                <div>
                    <p>Находитесь <br>в состоянии выгорания<br> и нуждаетесь в отдыхе</p>
                </div>
                <div>
                    <p>Расчитываете расти <br>в карьере, не затратив время и усилия</p>
                </div>
            </div>
            <div>
                <a href="#">Всё равно хочу в клуб</a>
            </div>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-for-you-or-not-tablet', {
        label: 'Клуб (не) для вас (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="careerum-block-switcher-tablet">
        <div>
            <div>
                <input type="checkbox" name="" id="block-switcher-input-tablet">
                <label for="block-switcher-input-tablet"> <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1656673692646.svg" alt=""></label>
            </div>
        </div>
    </div>
    <div class="careerum-why-for-you-true-tablet">
        <div>
            <div>
                <h2>Клуб для вас, <br>если вы</h2>
            </div>
            <div>
                <div>
                    <p>Стремитесь получать повышения<br> в зарплате<br> и в должности</p>
                </div>
                <div>
                    <p>Планируете<br> развивать карьеру<br> на международном рынке</p>
                </div>
                <div>
                    <p>Хотите выгодно выделяться<br> в конкурентной среде</p>
                </div>
                <div>
                    <p>Готовы вкладывать время и силы<br> в развитие своей карьеры</p>
                </div>
            </div>
            <div>
                <a href="#">Хочу в клуб!</a>
            </div>
        </div>
    </div>
    <div class="careerum-why-for-you-false-tablet">
        <div>
            <div>
                <h2>Клуб не для вас, <br>если вы</h2>
            </div>
            <div>
                <div>
                    <p>Уверены, что<br> не можете влиять<br> на свое повышение <br>и зарплатуи</p>
                </div>
                <div>
                    <p>Думаете, что<br> на международном<br> рынке «мы никому<br> не нужны»</p>
                </div>
                <div>
                    <p>Находитесь <br>в состоянии выгорания<br> и нуждаетесь<br> в отдыхе</p>
                </div>
                <div>
                    <p>Расчитываете расти <br>в карьере,<br> не затратив время<br> и усилия</p>
                </div>
            </div>
            <div>
                <a href="#">Всё равно хочу в клуб</a>
            </div>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-for-you-or-not-mobile', {
        label: 'Клуб (не) для вас (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="careerum-block-switcher-mobile">
        <div>
            <div>
                <input type="checkbox" name="" id="block-switcher-input-mobile">
                <label for="block-switcher-input-mobile"> <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1656673735966.svg" alt=""></label>
            </div>
        </div>
    </div>
    <div class="careerum-why-for-you-true-mobile">
        <div>
            <div>
                <h2>Клуб для вас, <br>если вы</h2>
            </div>
            <div>
                <div>
                    <div>
                        <p>Стремитесь получать повышения<br> в зарплате<br> и в должности</p>
                    </div>
                    <div>
                        <p>Планируете<br> развивать карьеру<br> на международном рынке</p>
                    </div>
                    <div>
                        <p>Хотите выгодно выделяться<br> в конкурентной среде</p>
                    </div>
                    <div>
                        <p>Готовы вкладывать время и силы<br> в развитие своей карьеры</p>
                    </div>
                </div>
            </div>
            <div>
                <a href="#">Хочу в клуб!</a>
            </div>
        </div>
    </div>
    <div class="careerum-why-for-you-false-mobile">
        <div>
            <div>
                <h2>Клуб не для вас, <br>если вы</h2>
            </div>
            <div>
                <div>
                    <div>
                        <p>Уверены, что<br> не можете влиять<br> на свое повышение <br>и зарплатуи</p>
                    </div>
                    <div>
                        <p>Думаете, что<br> на международном<br> рынке «мы никому<br> не нужны»</p>
                    </div>
                    <div>
                        <p>Находитесь <br>в состоянии выгорания<br> и нуждаетесь<br> в отдыхе</p>
                    </div>
                    <div>
                        <p>Расчитываете расти <br>в карьере,<br> не затратив время<br> и усилия</p>
                    </div>
                </div>
            </div>
            <div>
                <a href="#">Всё равно хочу в клуб</a>
            </div>
        </div>
    </div>`
    });


    
    
    blockManager.add('careerum-study-process', {
        label: 'Как учатся в Клубе',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="careerum-study-process">
        <div>
            <div>
                <h2>Как учатся в Careerum.Club? </h2>
            </div>
            <div>
                <div>
                    <h3>Курсы и мастер-классы</h3>
                </div>
                <div>
                    <p>Выбирайте любую из <br>15 учебных программ<br> под ваш запрос</p>
                </div>
                <div>
                    <p>Учитесь когда<br> удобно: материалы<br> доступны 24/7</p>
                </div>
                <div>
                    <p>Получайте новые навыки<br> и запускайте карьерную<br> ракету в космос</p>
                </div>
            </div>
            <div>
                <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1656690942581.svg" alt=""></div>
                <div>
                    <h3>Онлайн-ивенты</h3>
                    <p>Прокачивайте навыки<br> в live-формате и<br> задавайте вопросы<br> экспертам на<br>
                        регулярных<br> мероприятиях клуба</p>
                </div>
            </div>
            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1656691047703.svg" alt="">
        </div>
    </div>
    <div class="careerum-study-process-2">
        <div>
            <div>
                <h3>Социальная сеть</h3>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1656690983704.svg" alt="">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1656690999149.svg" alt="">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1656691020549.png" alt="">
                </div>
            </div>
            <div>
                <div>
                    <p>Знакомьтесь с<br> людьми из нужных<br> вам сфер и компаний</p>
                </div>
                <div>
                    <p>Выстраивайте экологичное<br> общение</p>
                </div>
                <div>
                    <p>Получайте поддержку одноклубовцев на карьерном пути</p>
                </div>
            </div>
            <div>
                <div>
                    <iframe width="757" height="438" src="https://www.youtube.com/embed/lqFfk8USYtg"
                        title="YouTube video player" frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen></iframe>
                </div>
                <div>
                    <h3>Нетворкинговые встречи</h3>
                    <p>Участвуйте онлайн в<br> языковых и книжных клубах,<br> воркшопах, «шоу историй»<br> и
                        мастер-майндах</p>
                    <p>Заряжайтесь вдохновением<br> офлайн на бизнес-завтраках<br> с участниками и экспертами </p>
                    <a href="#">Вступить в клуб</a>
                </div>
            </div>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-study-process-tablet', {
        label: 'Как учатся в Клубе (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="careerum-study-process-tablet">
        <div>
            <div>
                <h2>Как учатся в Careerum.Club? </h2>
            </div>
            <div>
                <div>
                    <h3>Курсы и мастер-классы</h3>
                </div>
                <div>
                    <p>Выбирайте любую<br> из 15 учебных<br> программ<br> под ваш запрос</p>
                </div>
                <div>
                    <p>Учитесь когда<br> удобно:<br> материалы<br> доступны 24/7</p>
                </div>
                <div>
                    <p>Получайте новые<br> навыки и запускайте<br> карьерную ракету<br> в космос</p>
                </div>
            </div>
            <div>
                <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1656691101181.svg" alt=""></div>
                <div>
                    <h3>Онлайн-ивенты</h3>
                    <p>Прокачивайте навыки<br> в live-формате<br>и задавайте вопросы<br> экспертам<br> на
                        регулярных<br> мероприятиях клуба</p>
                </div>
            </div>
            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1656691122677.svg" alt="">
        </div>
    </div>
    <div class="careerum-study-process-2-tablet">
        <div>
            <div>
                <h3>Социальная сеть</h3>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1656691137146.svg" alt="">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1656691150564.svg" alt="">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1656691164389.png" alt="">
                </div>
            </div>
            <div>
                <div>
                    <p>Знакомьтесь<br> с людьми из нужных<br> вам сфер и компаний</p>
                </div>
                <div>
                    <p>Выстраивайте<br> экологичное<br> общение</p>
                </div>
                <div>
                    <p>Получайте поддержку<br> одноклубовцев<br> на карьерном пути</p>
                </div>
            </div>
            <div>
                <div>
                    <h3>Нетворкинговые встречи</h3>
                    <p>Участвуйте онлайн в языковых и книжных<br> клубах, воркшопах, «шоу историй» и
                            мастер-майндах</p>
                    <p>Заряжайтесь вдохновением офлайн<br> на бизнес-завтраках с участниками<br> и экспертами </p>
                </div>
                <div><a href="#">Вступить в клуб</a></div>
            </div>
            <div>
                <iframe width="682" height="392" src="https://www.youtube.com/embed/lqFfk8USYtg"
                        title="YouTube video player" frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen></iframe>
            </div>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-study-process-mobile', {
        label: 'Как учатся в Клубе (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="careerum-study-process-mobile">
        <div>
            <div>
                <h2>Как учатся <br>в Careerum.Club? </h2>
            </div>
            <div>
                <div>
                    <h3>Курсы и мастер-<br>классы</h3>
                </div>
                <div>
                    <p>Выбирайте любую из 15 учебных<br> программ под ваш запрос</p>
                </div>
                <div>
                    <p>Учитесь когда удобно:<br> материалы доступны 24/7</p>
                </div>
                <div>
                    <p>Получайте новые навыки<br> и запускайте карьерную ракету<br> в космос</p>
                </div>
            </div>
            <div>
                <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1656693314088.svg" alt=""></div>
                <div>
                    <h3>Онлайн-ивенты</h3>
                    <p>Прокачивайте навыкив live-<br>формате и задавайте вопросы<br> экспертам на
                        регулярных<br> мероприятиях клуба</p>
                </div>
            </div>
            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1656691230747.svg" alt="">
        </div>
    </div>
    <div class="careerum-study-process-2-mobile">
        <div>
            <div>
                <h3>Социальная сеть</h3>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1656691246256.svg" alt="">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1656691261960.svg" alt="">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1656691275801.png" alt="">
                </div>
            </div>
            <div>
                <div>
                    <p>Знакомьтесь с людьми из<br> нужных вам сфер и компаний</p>
                </div>
                <div>
                    <p>Выстраивайте<br> экологичное общение</p>
                </div>
                <div>
                    <p>Получайте<br> поддержку<br> на карьерном<br> пути</p>
                </div>
            </div>
            <div>
                <div>
                    <h3>Нетворкинговые<br> встречи</h3>
                    <p>Участвуйте онлайн<br> в языковых и книжных<br> клубах, воркшопах, «шоу<br> историй» и
                            мастер-майндах</p>
                    <p>Заряжайтесь вдохновением<br> офлайн на бизнес-завтраках<br> с участниками и экспертами </p>
                </div>
                <iframe width="300" height="174" src="https://www.youtube.com/embed/lqFfk8USYtg"
                title="YouTube video player" frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen></iframe>
                <div><a href="#">Вступить в клуб</a></div>
            </div>
        </div>
    </div>`
    });

    
    
    blockManager.add('careerum-coach-support', {
        label: 'Поддержка коучей',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="careerum-coach-support">
        <div>
            <div>
                <div>
                    <h3>Поддержка международных коучей и CV-эксперта</h3>
                </div>
                <div>
                    <div>
                        <p>Задавайте вопросы коучам в чате, делитесь ситуациями на работе</p>
                    </div>
                    <div>
                        <p>Прорабатывайте ваш запрос на видеосессиях с коучем</p>
                    </div>
                    <div>
                        <p>Достигайте своих целей, благодаря глубокой и системной работе</p>
                    </div>
                </div>
            </div>
            <div>
                <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1656710716290.svg" alt="" class="prewarr-coach"></div>
                <div class="coach-slider">
                    <div class="coach-slider-item-main">
                        <h3>Коучинг <br>по любым карьерным запросам</h3>
                        <p>Все коучи имеют<br> аккредитацию International Coach Federation и опыт<br> работы в Google,
                            Тинькофф,<br> Microsoft и Яндекс и других международных компаниях </p>
                        <p>Формат работы с коучем зависит от выбранного тарифа</p>
                        <a href="#">Выбрать тариф</a>
                    </div>
                    <div class="coach-slider-item">
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1656710743354.png" alt="">
                        </div>
                        <div>
                            <h4>Светлана Баран</h4>
                            <p>Коуч ICF. Специализация — релокация, смена сферы.</p>
                            <p>Работала в Италии, Польше, Португалии, Японии и Нидерландах. Помогла 3200+ участникам
                                Careerum.Club.</p>
                            <p>Италия</p>
                        </div>
                    </div>
                    <div class="coach-slider-item">
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1656710759514.png" alt="">
                        </div>
                        <div>
                            <h4>Марина Веденичева</h4>
                            <p>Коуч ICF PCC.Специализация — карьерный рост, увеличение дохода.</p>
                            <p>15+ лет в HR, работала в BetterUp и Modern Health. Провела 600+ коучинговых сессий и
                                помогла 1000+ участников в Careerum.Club.</p>
                            <p>Великобритания</p>
                        </div>
                    </div>
                    <div class="coach-slider-item">
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1656710787910.png" alt="">
                        </div>
                        <div>
                            <h4>София Бессонова</h4>
                            <p>CV-специалист, коуч ICF.</p>
                            <p>1500+ часов ведения тренингов в крупных международных компаниях. Более 100 успешных
                                кейсов, в том числе при релокации и поиске работы в кризис.</p>
                            <p>Израиль</p>
                        </div>
                    </div>
                    <div class="coach-slider-item">
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1656710805173.png" alt="">
                        </div>
                        <div>
                            <h4>Ирина Феоктистова</h4>
                            <p>Коуч AFC. Специализация — work-life баланс и тайм менеджмент.</p>
                            <p>Диплом профессионального коуча в РУДН и 100+ часов коучинговой практики.</p>
                            <p>Россия</p>
                        </div>
                    </div>
                    <div class="coach-slider-item">
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1656710820221.png" alt="">
                        </div>
                        <div>
                            <h4>Елена Эльзенбах</h4>
                            <p>Коуч ICF. Специализация — увеличение дохода и выгорание.</p>
                            <p>Работала в качестве коуча с сотрудниками Lamoda и PromWad. Провела 100+ часов
                                индивидуальной и групповой коучинговой практики.</p>
                            <p>Россия</p>
                        </div>
                    </div>
                    <div class="coach-slider-item">
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1656710837702.png" alt="">
                        </div>
                        <div>
                            <h4>Елена Добринская</h4>
                            <p>Коуч ICF. Специализация — мотивация и самооценка. </p>
                            <p>Работала в Deloitte и Tele2. Опыт — 100+ часов коучинговой практики. Помогла 600+
                                участникам Careerum.Club прийти к карьерной цели.</p>
                            <p>ОАЭ</p>
                        </div>
                    </div>
                </div>

                <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1656710850052.svg" alt="" class="nextarr-coach"></div>
            </div>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-coach-support-tablet', {
        label: 'Поддержка коучей (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="careerum-coach-support-tablet">
        <div>
            <div>
                <div>
                    <h3>Поддержка<br> международных коучей<br> и CV-эксперта</h3>
                </div>
                <div>
                    <div>
                        <p>Задавайте вопросы<br> коучам в чате, делитесь<br> ситуациями на работе</p>
                    </div>
                    <div>
                        <p>Прорабатывайте ваш<br> запрос на видеосессиях<br> с коучем</p>
                    </div>
                    <div>
                        <p>Достигайте своих целей,<br> благодаря глубокой<br> и системной работе</p>
                    </div>
                </div>
            </div>
            <div>
                <div>
                    <div>
                        <h3>Коучинг по<br> любым карьер-ным запросам</h3>
                        <p>Все коучи имеют<br> аккредитацию International Coach Federation и опыт<br> работы в Google,
                            Тинькофф,<br> Microsoft и Яндекс и других международных компаниях </p>
                        <p>Формат работы с коучем зависит от выбранного тарифа</p>
                        <a href="#">Выбрать тариф</a>
                    </div>
                    <div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1656710889162.png" alt="">
                        </div>
                        <div>
                            <h4>Светлана Баран</h4>
                            <p>Коуч ICF. Специализация — релокация, смена сферы.</p>
                            <p>Работала в Италии,<br> Польше, Португалии,<br> Японии и Нидерландах.<br> Помогла 3200+ участникам<br>
                                Careerum.Club.</p>
                            <p>Италия</p>
                        </div>
                    </div>
                    <div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1656710902664.png" alt="">
                        </div>
                        <div>
                            <h4>Марина Веденичева</h4>
                            <p>Коуч ICF PCC. Специализация — карьерный рост,<br> увеличение дохода.</p>
                            <p>15+ лет в HR, работала <br>в BetterUp и Modern Health. Провела 600+ коучинговых сессий и
                                помогла 1000+ участников в Careerum.Club.</p>
                            <p>Великобритания</p>
                        </div>
                    </div>
                    <div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1656710914630.png" alt="">
                        </div>
                        <div>
                            <h4>София Бессонова</h4>
                            <p>CV-специалист, коуч ICF.</p>
                            <p>1500+ часов ведения тренингов в крупных международных компаниях. Более 100 успешных
                                кейсов, в том числе при релокации и поиске работы<br> в кризис.</p>
                            <p>Израиль</p>
                        </div>
                    </div>
                    <div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1656710926131.png" alt="">
                        </div>
                        <div>
                            <h4>Ирина Феоктистова</h4>
                            <p>Коуч AFC. Специализация — work-life баланс и тайм менеджмент.</p>
                            <p>Диплом<br> профессионального коуча<br> в РУДН и 100+ часов коучинговой практики.</p>
                            <p>Россия</p>
                        </div>
                    </div>
                    <div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1656710937639.png" alt="">
                        </div>
                        <div>
                            <h4>Елена Эльзенбах</h4>
                            <p>Коуч ICF. Специализация — увеличение дохода и выгорание.</p>
                            <p>Работала в качестве коуча с сотрудниками Lamoda <br>и PromWad. Провела 100+ часов
                                индивидуальной и групповой коучинговой практики.</p>
                            <p>Россия</p>
                        </div>
                    </div>
                    <div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1656710949791.png" alt="">
                        </div>
                        <div>
                            <h4>Елена Добринская</h4>
                            <p>Коуч ICF. Специализация — мотивация и самооценка. </p>
                            <p>Работала в Deloitte и Tele2. Опыт — 100+ часов коучинговой практики. Помогла 600+
                                участникам Careerum.Club прийти к карьерной цели.</p>
                            <p>ОАЭ</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-coach-support-mobile', {
        label: 'Поддержка коучей (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="careerum-coach-support-mobile">
        <div>
            <div>
                <div>
                    <h3>Поддержка<br> международных<br> коучей и CV-эксперта</h3>
                </div>
                <div>
                    <div>
                        <p>Задавайте вопросы коучам<br> в чате, делитесь ситуациями<br> на работе</p>
                    </div>
                    <div>
                        <p>Прорабатывайте ваш запрос<br> на видеосессиях с коучем</p>
                    </div>
                    <div>
                        <p>Достигайте своих целей, благодаря<br> глубокой и системной работе</p>
                    </div>
                </div>
            </div>
            <div>
                <div>
                    <div>
                        <h3>Коучинг по<br> любым карьер-ным запросам</h3>
                        <p>Все коучи имеют<br> аккредитацию International Coach Federation и опыт<br> работы в Google,
                            Тинькофф,<br> Microsoft и Яндекс и других международных компаниях </p>
                        <p>Формат работы с коучем зависит от выбранного тарифа</p>
                        <a href="#">Выбрать тариф</a>
                    </div>
                    <div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1656710988352.png" alt="">
                        </div>
                        <div>
                            <h4>Светлана Баран</h4>
                            <p>Коуч ICF. Специализация — релокация, смена сферы.</p>
                            <p>Работала в Италии,<br> Польше, Португалии,<br> Японии и Нидерландах.<br> Помогла 3200+ участникам<br>
                                Careerum.Club.</p>
                            <p>Италия</p>
                        </div>
                    </div>
                    <div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1656711001345.png" alt="">
                        </div>
                        <div>
                            <h4>Марина Веденичева</h4>
                            <p>Коуч ICF PCC. Специализация — карьерный рост,<br> увеличение дохода.</p>
                            <p>15+ лет в HR, работала <br>в BetterUp и Modern Health. Провела 600+ коучинговых сессий и
                                помогла 1000+ участников в Careerum.Club.</p>
                            <p>Великобритания</p>
                        </div>
                    </div>
                    <div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1656711012936.png" alt="">
                        </div>
                        <div>
                            <h4>София Бессонова</h4>
                            <p>CV-специалист, коуч ICF.</p>
                            <p>1500+ часов ведения тренингов в крупных международных компаниях. Более 100 успешных
                                кейсов, в том числе при релокации и поиске работы<br> в кризис.</p>
                            <p>Израиль</p>
                        </div>
                    </div>
                    <div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1656711024323.png" alt="">
                        </div>
                        <div>
                            <h4>Ирина Феоктистова</h4>
                            <p>Коуч AFC. Специализация — work-life баланс и тайм менеджмент.</p>
                            <p>Диплом<br> профессионального коуча<br> в РУДН и 100+ часов коучинговой практики.</p>
                            <p>Россия</p>
                        </div>
                    </div>
                    <div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1656711034781.png" alt="">
                        </div>
                        <div>
                            <h4>Елена Эльзенбах</h4>
                            <p>Коуч ICF. Специализация — увеличение дохода и выгорание.</p>
                            <p>Работала в качестве коуча с сотрудниками Lamoda <br>и PromWad. Провела 100+ часов
                                индивидуальной и групповой коучинговой практики.</p>
                            <p>Россия</p>
                        </div>
                    </div>
                    <div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1656711045742.png" alt="">
                        </div>
                        <div>
                            <h4>Елена Добринская</h4>
                            <p>Коуч ICF. Специализация — мотивация и самооценка. </p>
                            <p>Работала в Deloitte и Tele2. Опыт — 100+ часов коучинговой практики. Помогла 600+
                                участникам Careerum.Club прийти к карьерной цели.</p>
                            <p>ОАЭ</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>`
    });

    
    
    blockManager.add('careerum-calendar', {
        label: 'Календарь событий',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: {type: "careerum-calendar"}
    });
    
    blockManager.add('careerum-calendar-tablet', {
        label: 'Календарь событий (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: {type: "careerum-calendar-tablet"}
    });
    
    blockManager.add('careerum-calendar-mobile', {
        label: 'Календарь событий (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: {type: "careerum-calendar-mobile"}
    });
    

    
    blockManager.add('careerum-results-new', {
        label: 'Результаты участников',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="careerum-results-new">
        <div>
            <div>
                <div>
                    <h2>Результаты участников </h2>
                </div>
                <div>
                    <div>
                        <h3>450%</h3>
                        <p>рекорд повышения зарплаты в Careerum</p>
                    </div>
                    <div>
                        <h3>82%</h3>
                        <p>среднее увеличение зарплаты участников</p>
                    </div>
                    <div>
                        <h3>720+</h3>
                        <p>офферов <br>получено</p>
                    </div>
                    <div>
                        <h3>130+</h3>
                        <p>релокаций, <br>даже в кризисы</p>
                    </div>
                </div>
            </div>
            <div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1656759250911.svg" alt="" class="prewarr-coach-r">
                </div>
                <div class="results-new-slider">
                    <div class="results-new-slider-item">
                        <div>
                            <div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1656759231064.png" alt="">
                                    <a href="#"></a>
                                </div>
                                <div>
                                    <h4>Елена<br> Гранина</h4>
                                    <p>Partner Success Manager, Австрия</p>
                                </div>
                            </div>
                            <div>
                                <p>#поискработы<br>#работазарубежом</p>
                            </div>
                        </div>
                        <div>
                            <p>Я успешно прошла 40 собеседований, получила <br>3 оффера, выбрала тот, который отвечал
                                моим целям и ценностям. Сейчас у меня полноценное трудоустройство<br> в соответствии с
                                законода-тельством Австрии в компании с адекватной корпоративной культурой, нетоксичным
                                руководством и перспективой роста.</p>
                        </div>
                    </div>
                    <div class="results-new-slider-item">
                        <div>
                            <div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1656759215735.png" alt="">
                                    <a href="#"></a>
                                </div>
                                <div>
                                    <h4>Наиля<br> Ленерт </h4>
                                    <p>Maintenance Engineer, Германия</p>
                                </div>
                            </div>
                            <div>
                                <p>#сменасферы <br>#карьерныйвыбор </p>
                            </div>
                        </div>
                        <div>
                            <p>Новая должность в компании мечты! Из техника я перешла<br> в инженеры, с повышением
                                дохода в +54% оплаты, не считая бонусов в виде 13<br> и 14 зарплаты. Я мечтала попасть в
                                эту компанию, и у<br> меня получилось — благодаря знаниям, которые я получила<br> в
                                клубе.</p>
                        </div>
                    </div>
                    <div class="results-new-slider-item">
                        <div>
                            <div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1656759202517.png" alt="">
                                    <a href="#"></a>
                                </div>
                                <div>
                                    <h4>Дарья<br> Волкова</h4>
                                    <p>Продакт-менеджер, Россия</p>
                                </div>
                            </div>
                            <div>
                                <p>#поискработы<br>#работазарубежом<br>#сменасферы</p>
                            </div>
                        </div>
                        <div>
                            <p>В клубе я проанализировала «Хочу-Могу-Надо», поняла свои сильные стороны и перестала
                                обесценивать опыт с прошлой работы. Стала подавать резюме<br> по эффективным каналам<br>
                                и начала получать отклики.<br> В итоге мне сделали оффер<br> в международную
                                компанию<br> с уровнем зарплаты выше, чем<br> у продакт-менеджера middle-уровня в
                                России.</p>
                        </div>
                    </div>
                    <div class="results-new-slider-item">
                        <div>
                            <div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1656759187231.png" alt="">
                                    <a href="#"></a>
                                </div>
                                <div>
                                    <h4>Полина<br> Туманова</h4>
                                    <p>Treasure & Reporting Manager, Ирландия</p>
                                </div>
                            </div>
                            <div>
                                <p>#карьерныйвыбор<br>
                                    #повышение</p>
                            </div>
                        </div>
                        <div>
                            <p>За 1,5 года в клубе у меня: в 3 раза вырос уровень дохода, в 6 раз увеличилась команда, в
                                зоне ответственности — 3 ключевых направления в финансах, релокация в Ирландию и впереди
                                еще одна релокация. А кроме этого: несколько успешных проектов, крутая мотивированная
                                команда и прекрасные отношения с руководством.</p>
                        </div>
                    </div>
                    <div class="results-new-slider-item">
                        <div>
                            <div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1656759173053.png" alt="">
                                    <a href="#"></a>
                                </div>
                                <div>
                                    <h4>Ясмина<br> Ступак</h4>
                                    <p>Project Manager, Словакия</p>
                                </div>
                            </div>
                            <div>
                                <p>#поискработы <br>#работазарубежом</p>
                            </div>
                        </div>
                        <div>
                            <p>Среди 250 кандидатов на позицию выбрали меня в одну из топ-10 европейских бизнес-школ.
                                Предложили контракт на 3 года и помощь с документами и видом на жительство.</p>
                        </div>
                    </div>
                    <div class="results-new-slider-item">
                        <div>
                            <div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1656759157279.png" alt="">
                                    <a href="#"></a>
                                </div>
                                <div>
                                    <h4>Роман<br> Малышев</h4>
                                    <p>Project/Product Manager, Черногория</p>
                                </div>
                            </div>
                            <div>
                                <p>#повышение<br>#карьерныйвыбор</p>
                            </div>
                        </div>
                        <div>
                            <p>В результате разговора с руководителем получил увеличение оклада на 38%. Изменились
                                глобальные цели — от «сменить работу с увеличением дохода» к «работать на позиции в
                                компании, которая соответствует моим ценностям». Понял, что не хочу менять
                                специальность, а буду прокачиваться в ее рамках.</p>
                        </div>
                    </div>
                    <div class="results-new-slider-item">
                        <div>
                            <div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1656759144177.png" alt="">
                                    <a href="#"></a>
                                </div>
                                <div>
                                    <h4>Валентина<br> Телушкина</h4>
                                    <p>Senior Manager, Великобритания</p>
                                </div>
                            </div>
                            <div>
                                <p>#работазарубежом<br>#повышение</p>
                            </div>
                        </div>
                        <div>
                            <p>Оказалось, что достаточно четырех верных шагов, чтобы достичь моей карьерной цели.
                                <br><br>

                                Я училась проходить интервью, тренировала навык коммуникации, работу с обратной связью и
                                получила повышение до позиции Senior Manager с прибавкой к зарплате в 33%.</p>
                        </div>
                    </div>
                    <div class="results-new-slider-item">
                        <div>
                            <div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1656759130883.png" alt="">
                                    <a href="#"></a>
                                </div>
                                <div>
                                    <h4>Людмила <br>Левитина</h4>
                                    <p>Targeting Analyst<br> в НКО, Германия</p>
                                </div>
                            </div>
                            <div>
                                <p>#поискработы<br>#работазарубежом<br>#сменасферы</p>
                            </div>
                        </div>
                        <div>
                            <p>В клубе я получила оффер на позицию аналитика — после 3,5 лет декрета, в Германии, без
                                международного опыта и знания немецкого и с ростом зарплаты на 450%. До этого я много
                                смотрела англоязычные карьерные каналы и читала инструкции по резюме, но нигде не
                                встречала такого же качества информации, как здесь.</p>
                        </div>
                    </div>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1656759114228.svg" alt="" class="nextarr-coach-r">
                </div>
            </div>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-results-new-tablet', {
        label: 'Результаты участников (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="careerum-results-new-tablet">
        <div>
            <div>
                <div>
                    <h2>Результаты участников </h2>
                </div>
                <div>
                    <div>
                        <h3>450%</h3>
                        <p>рекорд повышения зарплаты в Careerum</p>
                    </div>
                    <div>
                        <h3>82%</h3>
                        <p>среднее увеличение зарплаты участников</p>
                    </div>
                    <div>
                        <h3>720+</h3>
                        <p>офферов <br>получено</p>
                    </div>
                    <div>
                        <h3>130+</h3>
                        <p>релокаций, <br>даже в кризисы</p>
                    </div>
                </div>
            </div>
            <div>
                <div>
                    <div>
                        <div>
                            <div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1656759093391.png" alt="">
                                    <a href="#"></a>
                                </div>
                                <div>
                                    <h4>Елена Гранина</h4>
                                    <p>Partner Success Manager, Австрия</p>
                                </div>
                            </div>
                            <div>
                                <p>#поискработы<br>#работазарубежом</p>
                            </div>
                        </div>
                        <div>
                            <p>Я успешно прошла 40 собеседований, получила <br>3 оффера, выбрала тот, который отвечал
                                моим целям и ценностям. Сейчас у меня полноценное трудоустройство<br> в соответствии с
                                законода-тельством Австрии в компании <br>с адекватной корпоративной культурой, нетоксичным
                                руководством и перспективой роста.</p>
                        </div>
                    </div>
                    <div>
                        <div>
                            <div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1656759077365.png" alt="">
                                    <a href="#"></a>
                                </div>
                                <div>
                                    <h4>Наиля Ленерт </h4>
                                    <p>Maintenance Engineer, Германия</p>
                                </div>
                            </div>
                            <div>
                                <p>#сменасферы <br>#карьерныйвыбор </p>
                            </div>
                        </div>
                        <div>
                            <p>Новая должность в компании мечты! Из техника я перешла<br> в инженеры, с повышением
                                дохода в +54% оплаты, не считая бонусов в виде 13<br> и 14 зарплаты. Я мечтала попасть в
                                эту компанию, и у<br> меня получилось — благодаря знаниям, которые я получила<br> в
                                клубе.</p>
                        </div>
                    </div>
                    <div>
                        <div>
                            <div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1656759064195.png" alt="">
                                    <a href="#"></a>
                                </div>
                                <div>
                                    <h4>Дарья Волкова</h4>
                                    <p>Продакт-менеджер, Россия</p>
                                </div>
                            </div>
                            <div>
                                <p>#поискработы<br>#работазарубежом</p>
                            </div>
                        </div>
                        <div>
                            <p>В клубе я проанализировала «Хочу-Могу-Надо», поняла свои сильные стороны и перестала
                                обесценивать опыт с прошлой работы. Стала подавать резюме<br> по эффективным каналам<br>
                                и начала получать отклики.<br> В итоге мне сделали оффер<br> в международную
                                компанию<br> с уровнем зарплаты выше, чем<br> у продакт-менеджера middle-уровня в
                                России.</p>
                        </div>
                    </div>
                    <div>
                        <div>
                            <div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1656759023196.png" alt="">
                                    <a href="#"></a>
                                </div>
                                <div>
                                    <h4>Полина Туманова</h4>
                                    <p>Treasure & Reporting Manager, Ирландия</p>
                                </div>
                            </div>
                            <div>
                                <p>#карьерныйвыбор<br>
                                    #повышение</p>
                            </div>
                        </div>
                        <div>
                            <p>За 1,5 года в клубе у меня: в 3 раза вырос уровень дохода, в 6 раз увеличилась команда, в
                                зоне ответственности — 3 ключевых направления в финансах, релокация в Ирландию и впереди
                                еще одна релокация. А кроме этого: несколько успешных проектов, крутая мотивированная
                                команда и прекрасные отношения с руководством.</p>
                        </div>
                    </div>
                    <div>
                        <div>
                            <div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1656759044041.png" alt="">
                                    <a href="#"></a>
                                </div>
                                <div>
                                    <h4>Ясмина Ступак</h4>
                                    <p>Project Manager, Словакия</p>
                                </div>
                            </div>
                            <div>
                                <p>#поискработы <br>#работазарубежом</p>
                            </div>
                        </div>
                        <div>
                            <p>Среди 250 кандидатов на позицию выбрали меня в одну из топ-10 европейских бизнес-школ.
                                Предложили контракт на 3 года и помощь с документами и видом на жительство.</p>
                        </div>
                    </div>
                    <div>
                        <div>
                            <div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1656758989741.png" alt="">
                                    <a href="#"></a>
                                </div>
                                <div>
                                    <h4>Роман Малышев</h4>
                                    <p>Project Manager, Черногория</p>
                                </div>
                            </div>
                            <div>
                                <p>#повышение<br>#карьерныйвыбор</p>
                            </div>
                        </div>
                        <div>
                            <p>В результате разговора с руководителем получил увеличение оклада на 38%. Изменились
                                глобальные цели — от «сменить работу с увеличением дохода» к «работать на позиции в
                                компании, которая соответствует моим ценностям». Понял, что не хочу менять
                                специальность, а буду прокачиваться в ее рамках.</p>
                        </div>
                    </div>
                    <div>
                        <div>
                            <div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1656758974495.png" alt="">
                                    <a href="#"></a>
                                </div>
                                <div>
                                    <h4>Валентина Телушкина</h4>
                                    <p>Senior Manager, Великобритания</p>
                                </div>
                            </div>
                            <div>
                                <p>#работазарубежом<br>#повышение</p>
                            </div>
                        </div>
                        <div>
                            <p>Оказалось, что достаточно четырех верных шагов, чтобы достичь моей карьерной цели.
                                <br><br>

                                Я училась проходить интервью, тренировала навык коммуникации, работу с обратной связью и
                                получила повышение до позиции Senior Manager с прибавкой к зарплате в 33%.</p>
                        </div>
                    </div>
                    <div>
                        <div>
                            <div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1656758958216.png" alt="">
                                    <a href="#"></a>
                                </div>
                                <div>
                                    <h4>Людмила Левитина</h4>
                                    <p>Targeting Analyst<br> в НКО, Германия</p>
                                </div>
                            </div>
                            <div>
                                <p>#работазарубежом<br>#сменасферы</p>
                            </div>
                        </div>
                        <div>
                            <p>В клубе я получила оффер на позицию аналитика — после 3,5 лет декрета, в Германии, без
                                международного опыта и знания немецкого и с ростом зарплаты на 450%. До этого я много
                                смотрела англоязычные карьерные каналы и читала инструкции по резюме, но нигде не
                                встречала такого же качества информации, как здесь.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-results-new-mobile', {
        label: 'Результаты участников (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="careerum-results-new-mobile">
        <div>
            <div>
                <div>
                    <h2>Результаты участников </h2>
                </div>
                <div>
                    <div>
                        <h3>450%</h3>
                        <p>рекорд повышения зарплаты в Careerum</p>
                    </div>
                    <div>
                        <h3>700+</h3>
                        <p>офферов <br>получено</p>
                    </div>
                    <div>
                        <h3>82%</h3>
                        <p>среднее увеличение зарплаты участников</p>
                    </div>
                    <div>
                        <h3>130+</h3>
                        <p>релокаций, <br>даже в кризисы</p>
                    </div>
                    <div><p>*на основании результатов наших участников</p></div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1656758836897.svg" alt="">
                    </div>
                </div>
            </div>
            <div>
                <div>
                    <div>
                        <div>
                            <div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1656758812499.png" alt="">
                                    <a href="#"></a>
                                </div>
                                <div>
                                    <h4>Елена Гранина</h4>
                                    <p>Partner Success Manager, Австрия</p>
                                </div>
                            </div>
                            <div>
                                <p>#поискработы<br>#работазарубежом</p>
                            </div>
                        </div>
                        <div>
                            <p>Я успешно прошла 40 собеседований, получила <br>3 оффера, выбрала тот, который отвечал
                                моим целям и ценностям. Сейчас у меня полноценное трудоустройство<br> в соответствии с
                                законода-тельством Австрии в компании <br>с адекватной корпоративной культурой, нетоксичным
                                руководством и перспективой роста.</p>
                        </div>
                    </div>
                    <div>
                        <div>
                            <div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1656758784860.png" alt="">
                                    <a href="#"></a>
                                </div>
                                <div>
                                    <h4>Наиля Ленерт </h4>
                                    <p>Maintenance Engineer, Германия</p>
                                </div>
                            </div>
                            <div>
                                <p>#сменасферы <br>#карьерныйвыбор </p>
                            </div>
                        </div>
                        <div>
                            <p>Новая должность в компании мечты! Из техника я перешла<br> в инженеры, с повышением
                                дохода в +54% оплаты, не считая бонусов в виде 13<br> и 14 зарплаты. Я мечтала попасть в
                                эту компанию, и у<br> меня получилось — благодаря знаниям, которые я получила<br> в
                                клубе.</p>
                        </div>
                    </div>
                    <div>
                        <div>
                            <div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1656758769812.png" alt="">
                                    <a href="#"></a>
                                </div>
                                <div>
                                    <h4>Дарья Волкова</h4>
                                    <p>Продакт-менеджер, Россия</p>
                                </div>
                            </div>
                            <div>
                                <p>#поискработы<br>#работазарубежом</p>
                            </div>
                        </div>
                        <div>
                            <p>В клубе я проанализировала «Хочу-Могу-Надо», поняла свои сильные стороны и перестала
                                обесценивать опыт с прошлой работы. Стала подавать резюме<br> по эффективным каналам<br>
                                и начала получать отклики.<br> В итоге мне сделали оффер<br> в международную
                                компанию<br> с уровнем зарплаты выше, чем<br> у продакт-менеджера middle-уровня в
                                России.</p>
                        </div>
                    </div>
                    <div>
                        <div>
                            <div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1656758751331.png" alt="">
                                    <a href="#"></a>
                                </div>
                                <div>
                                    <h4>Полина Туманова</h4>
                                    <p>Treasure & Reporting Manager, Ирландия</p>
                                </div>
                            </div>
                            <div>
                                <p>#карьерныйвыбор<br>
                                    #повышение</p>
                            </div>
                        </div>
                        <div>
                            <p>За 1,5 года в клубе у меня: в 3 раза вырос уровень дохода, в 6 раз увеличилась команда, в
                                зоне ответственности — 3 ключевых направления в финансах, релокация в Ирландию и впереди
                                еще одна релокация. А кроме этого: несколько успешных проектов, крутая мотивированная
                                команда и прекрасные отношения с руководством.</p>
                        </div>
                    </div>
                    <div>
                        <div>
                            <div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1656758733438.png" alt="">
                                    <a href="#"></a>
                                </div>
                                <div>
                                    <h4>Ясмина Ступак</h4>
                                    <p>Project Manager, Словакия</p>
                                </div>
                            </div>
                            <div>
                                <p>#поискработы <br>#работазарубежом</p>
                            </div>
                        </div>
                        <div>
                            <p>Среди 250 кандидатов на позицию выбрали меня в одну из топ-10 европейских бизнес-школ.
                                Предложили контракт на 3 года и помощь с документами и видом на жительство.</p>
                        </div>
                    </div>
                    <div>
                        <div>
                            <div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1656758541296.png" alt="">
                                    <a href="#"></a>
                                </div>
                                <div>
                                    <h4>Роман Малышев</h4>
                                    <p>Project Manager, Черногория</p>
                                </div>
                            </div>
                            <div>
                                <p>#повышение<br>#карьерныйвыбор</p>
                            </div>
                        </div>
                        <div>
                            <p>В результате разговора с руководителем получил увеличение оклада на 38%. Изменились
                                глобальные цели — от «сменить работу с увеличением дохода» к «работать на позиции в
                                компании, которая соответствует моим ценностям». Понял, что не хочу менять
                                специальность, а буду прокачиваться в ее рамках.</p>
                        </div>
                    </div>
                    <div>
                        <div>
                            <div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1656758524402.png" alt="">
                                    <a href="#"></a>
                                </div>
                                <div>
                                    <h4>Валентина Телушкина</h4>
                                    <p>Senior Manager, Великобритания</p>
                                </div>
                            </div>
                            <div>
                                <p>#работазарубежом<br>#повышение</p>
                            </div>
                        </div>
                        <div>
                            <p>Оказалось, что достаточно четырех верных шагов, чтобы достичь моей карьерной цели.
                                <br><br>

                                Я училась проходить интервью, тренировала навык коммуникации, работу с обратной связью и
                                получила повышение до позиции Senior Manager с прибавкой к зарплате в 33%.</p>
                        </div>
                    </div>
                    <div>
                        <div>
                            <div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1656758496306.png" alt="">
                                    <a href="#"></a>
                                </div>
                                <div>
                                    <h4>Людмила Левитина</h4>
                                    <p>Targeting Analyst<br> в НКО, Германия</p>
                                </div>
                            </div>
                            <div>
                                <p>#работазарубежом<br>#сменасферы</p>
                            </div>
                        </div>
                        <div>
                            <p>В клубе я получила оффер на позицию аналитика — после 3,5 лет декрета, в Германии, без
                                международного опыта и знания немецкого и с ростом зарплаты на 450%. До этого я много
                                смотрела англоязычные карьерные каналы и читала инструкции по резюме, но нигде не
                                встречала такого же качества информации, как здесь.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>`
    });



    
    
    blockManager.add('careerum-main-block', {
        label: 'Главный разворот',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="careerum-main-block">
        <div>
            <div>
                <div>
                    <h1>
                        Платформа <span>карьерного</span> развития
                    </h1>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1656793410687.png" alt=".">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1656793445456.png" alt=".">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1656793476052.svg" alt="">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1656793494904.svg" alt="">
                </div>
            </div>
            <div>
                <a href="#">Хочу строить карьеру!</a>
            </div>
            <div>
                <div>
                    <p>
                        350+ часов обучающего контента<br> под любой карьерный запрос
                    </p>
                    <p>
                        Собственная соцсеть — обменивайтесь опытом и выстраивайте нетворк
                    </p>
                    <p>
                        Практические рекомендации от международных коучей и экспертов
                    </p>
                </div>
                <div>
                    <div>
                        <div>
                            <p>450%</p>
                            <p>рекорд повышения зарплаты в Careerum</p>
                        </div>
                        <div>
                            <p>80%</p>
                            <p>среднее увеличение зарплаты участников</p>
                        </div>
                        <div>
                            <p>700+</p>
                            <p>офферов<br> получено</p>
                        </div>
                        <div>
                            <p>130+</p>
                            <p>релокаций,<br> даже в кризисы</p>
                        </div>
                    </div>
                    <div>
                        <p>*на основании результатов наших участников</p>
                    </div>

                </div>
            </div>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-main-block-tablet', {
        label: 'Главный разворот (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="careerum-main-block-tablet">
        <div>
            <div>
                <div>
                    <h1>
                        Платформа <span>карьерного</span> развития
                    </h1>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1656793528265.svg" alt=".">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1656793555455.png" alt=".">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1656793575062.svg" alt="">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1656793590950.svg" alt="">
                </div>
            </div>
            <div>
                <a href="#">Хочу строить карьеру!</a>
            </div>
            <div>
                <div>
                    <p>
                        350+ часов обучающего контента<br> под любой карьерный запрос
                    </p>
                    <p>
                        Собственная соцсеть — обменивайтесь опытом и выстраивайте нетворк
                    </p>
                    <p>
                        Практические рекомендации от международных коучей и экспертов
                    </p>
                </div>
                <div>
                    <div>
                        <div>
                            <p>450%</p>
                            <p>рекорд повышения зарплаты в Careerum</p>
                        </div>
                        <div>
                            <p>80%</p>
                            <p>среднее увеличение зарплаты участников</p>
                        </div>
                        <div>
                            <p>700+</p>
                            <p>офферов<br> получено</p>
                        </div>
                        <div>
                            <p>130+</p>
                            <p>релокаций, даже <br>в кризисы</p>
                        </div>
                    </div>
                    <div>
                        <p>*на основании результатов наших участников</p>
                    </div>

                </div>
            </div>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-main-block-mobile', {
        label: 'Главный разворот (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="careerum-main-block-mobile">
        <div>
            <div>
                <div>
                    <h1>
                        Платформа <span>карьерного</span> развития
                    </h1>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1656793620929.svg" alt=".">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1656793826305.png" alt=".">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1656793859858.svg" alt="">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1656793882531.svg" alt="">
                </div>
            </div>
            <div>
                <a href="#">Хочу строить карьеру!</a>
            </div>
            <div>
                <div>
                    <p>
                        350+ часов обучающего контента<br> под любой карьерный запрос
                    </p>
                    <p>
                        Собственная соцсеть — обмен опытом и выстраивание нетворка
                    </p>
                    <p>
                        Практические рекомендации от международных коучей и экспертов
                    </p>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1656793913061.svg" alt="">
                </div>
                <div>
                    <div>
                        <div>
                            <p>450%</p>
                            <p>рекорд повышения зарплаты в Careerum</p>
                        </div>
                        <div>
                            <p>700+</p>
                            <p>офферов<br> получено</p>
                        </div>
                        <div>
                            <p>80%</p>
                            <p>среднее увеличение зарплаты участников</p>
                        </div>
                        <div>
                            <p>130+</p>
                            <p>релокаций, даже <br>в кризисы</p>
                        </div>
                    </div>
                    <div>
                        <p>*на основании результатов наших участников</p>
                    </div>

                </div>
            </div>
        </div>
    </div>`
    });

    

    blockManager.add('careerum-tales-with-header', {
        label: 'Каждый может',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="careerum-tales-with-header">
        <div>
            <div>
                <h2>
                    Каждый может построить<br> карьеру, о которой мечтает
                </h2>
            </div>
            <div>
                <div>
                    <p>Сменить страну,<br> сферу или<br> профессию</p>
                </div>
                <div>
                    <p>Вырасти в зарплате<br> и должности<br> быстро, не работая<br> 24/7</p>
                </div>
                <div>
                    <p>Выстроить<br> нетворк и<br> получить офферы<br> от топ-компаний</p>
                </div>
                <div>
                    <p>Достичь<br> своих целей<br> без выгорания</p>
                </div>
            </div>
        </div>
    </div>`
	});

    blockManager.add('careerum-tales-with-header-tablet', {
        label: 'Каждый может (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="careerum-tales-with-header-tablet">
        <div>
            <div>
                <h2>
                    Каждый может построить<br> карьеру, о которой мечтает
                </h2>
            </div>
            <div>
                <div>
                    <p>Сменить страну,<br> сферу или<br> профессию</p>
                </div>
                <div>
                    <p>Вырасти в зарплате<br> и должности<br> быстро, не работая<br> 24/7</p>
                </div>
                <div>
                    <p>Выстроить<br> нетворк и<br> получить офферы<br> от топ-компаний</p>
                </div>
                <div>
                    <p>Достичь<br> своих целей<br> без выгорания</p>
                </div>
            </div>
        </div>
    </div>`
	});

    blockManager.add('careerum-tales-with-header-mobile', {
        label: 'Каждый может (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="careerum-tales-with-header-mobile">
        <div>
            <div>
                <h2>
                    Каждый может<br> построить<br> карьеру, о<br> которой мечтает
                </h2>
            </div>
            <div>
                <div>
                    <p>Сменить страну,<br> сферу или<br> профессию</p>
                </div>
                <div>
                    <p>Вырасти в зарплате<br> и должности быстро,<br> не работая 24/7</p>
                </div>
                <div>
                    <p>Выстроить нетворк<br> и получить офферы<br> от топ-компаний</p>
                </div>
                <div>
                    <p>Достичь<br> своих целей<br> без выгорания</p>
                </div>
            </div>
        </div>
    </div>`
	});



    blockManager.add('careerum-video-and-buttons', {
        label: 'Учитесь, как вам удобно',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="careerum-video-and-buttons">
        <div>
            <div>
                <h2>
                    Учитесь, как <span>вам</span> удобно
                </h2>
            </div>
            <div>
                <div>
                    <div>
                        <h3>
                            Careerum.Club
                        </h3>
                    </div>
                    <div>
                        <p>
                            15 образовательных программ<br> от экспертов Google, McKinsey,<br> Сколково, Тинькофф
                        </p>
                        <p>
                            Сообщество русскоязычных<br> профессионалов со всего<br> мира 
                        </p>
                        <p>
                            Поддержка<br> коучей<br> и экспертов
                        </p>
                    </div>
                    <div>
                        <iframe width="693" height="402" src="https://www.youtube.com/embed/lqFfk8USYtg" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                    </div>
                    <a href="#">Присоединиться к клубу</a>
                </div>
            </div>
        </div>
    </div>`
	});

    blockManager.add('careerum-video-and-buttons-tablet', {
        label: 'Учитесь, как вам удобно (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="careerum-video-and-buttons-tablet">
        <div>
            <div>
                <h2>
                    Учитесь, как <span>вам</span> удобно
                </h2>
            </div>
            <div>
                <div>
                    <div>
                        <h3>
                            Careerum.Club
                        </h3>
                    </div>
                    <div>
                        <p>
                            15 образовательных<br> программ от<br> экспертов Google,<br> McKinsey, Сколково,<br> Тинькофф
                        </p>
                        <p>
                            Сообщество<br> русскоязычных<br> профессионалов<br> со всего мира 
                        </p>
                        <p>
                            Поддержка<br> коучей<br> и экспертов
                        </p>
                    </div>
                    <div>
                        <iframe width="436" height="253" src="https://www.youtube.com/embed/lqFfk8USYtg" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                    </div>
                    <a href="#">Присоединиться к клубу</a>
                </div>
            </div>
        </div>
    </div>`
	});

    blockManager.add('careerum-video-and-buttons-mobile', {
        label: 'Учитесь, как вам удобно (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-video-and-buttons-mobile">
        <div>
            <div>
                <h2>
                    Учитесь, как <span>вам</span> удобно
                </h2>
            </div>
            <div>
                <div>
                    <div>
                        <h3>
                            Careerum.Club
                        </h3>
                    </div>
                    <div>
                        <p>
                            15 образовательных программ от<br> экспертов Google, McKinsey, Сколково,<br> Тинькофф
                        </p>
                        <p>
                            Сообщество русскоязычных<br> профессионалов со всего мира 
                        </p>
                        <p>
                            Поддержка коучей и экспертов
                        </p>
                    </div>
                    <div>
                        <iframe width="300" height="222" src="https://www.youtube.com/embed/lqFfk8USYtg" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                    </div>
                    <a href="#">Присоединиться к клубу</a>
                </div>
            </div>
        </div>
    </div>`
	});


    
    blockManager.add('careerum-banner-with-buttons', {
        label: 'Баннер Careerum.Tips',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="careerum-banner-with-buttons">
        <div>
            <div>  
                <h3>
                    Не знаете,<br> чего хотите<br> от карьеры? 
                </h3>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1656797997113.svg" alt="">
                <p>
                    Пройдите короткий тест,<br> и мы определим ваш<br> карьерный запрос
                </p>
                <a href="#">Пройти тест</a>
            </div>
        </div>
        <div>
            <div>
                <h3>
                    Careerum.Tips
                </h3>
                <p>
                    70 еженедельных писем<br> о карьере
                </p>
                <p>
                    Практические рекомендации<br> о том, как стать увереннее в себе,<br>  расти в должности и зарплате<br> и работать в удовольствие
                </p>
                <a href="#">Получать карьерные письма</a>
            </div>
            <div>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1656798029071.png" alt="">
            </div>
        </div>
    </div>`
	});

    blockManager.add('careerum-banner-with-buttons-tablet', {
        label: 'Баннер Careerum.Tips (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="careerum-banner-with-buttons-tablet">
        <div>
            <div>  
                <h3>
                    Не знаете,<br> чего хотите<br> от карьеры? 
                </h3>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1656798050352.svg" alt="">
                <p>
                    Пройдите тест<br> и определите ваш<br> карьерный запрос
                </p>
                <a href="#">Пройти тест</a>
            </div>
        </div>
        <div>
            <div>
                <h3>
                    Careerum.Tips
                </h3>
                <p>
                    70 еженедельных писем о карьере
                </p>
                <p>
                    Практические рекомендации<br> о том, как стать увереннее в себе,<br>  расти в должности и зарплате<br> и работать в удовольствие
                </p>
                <a href="#">Получать карьерные письма</a>
            </div>
            <div>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1656798067280.svg" alt="">
            </div>
        </div>
    </div>`
	});

    blockManager.add('careerum-banner-with-buttons-mobile', {
        label: 'Баннер Careerum.Tips (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="careerum-banner-with-buttons-mobile">
        <div>
            <div>
                <div>
                    <h3>
                        Careerum.Tips
                    </h3>
                    <p>
                        70 еженедельных писем о карьере
                    </p>
                    <p>
                        Практические рекомендации о том,<br> как стать увереннее в себе, расти<br> в должности и зарплате и работать<br> в удовольствие
                    </p>
                    <a href="#">Получать карьерные письма</a>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1656798092103.svg" alt="">
                </div>
            </div>
            <div>
                <div>
                    <h3>Не знаете, чего хотите от карьеры? </h3>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1656798109270.svg" alt="">
                    <p>Пройдите тест и определите ваш карьерный запрос</p>
                    <a href="#">Пройти тест</a>
                </div>
            </div>
        </div>
    </div>`
	});


    

    blockManager.add('careerum-tabs-horizontal', {
        label: 'Горизонтальные табы',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="careerum-tabs-horizontal">
        <div>
            <div>
                <h2>Что приведет вас к результату</h2>
            </div>
            <div>
                <div>
                    <form action="">
                        <label class="selected"><p>Учебная платформа</p><input type="radio" name="tabs" id="" checked></label>
                        <label><p>Персональная поддержка</p><input type="radio" name="tabs" id=""></label>
                        <label><p>Комьюнити</p><input type="radio" name="tabs" id=""></label>
                        <label><p>Нетворк-боты</p><input type="radio" name="tabs" id=""></label>
                    </form>                    
                </div>
                <div class="careerum-tiles-rezult">
                    <div data-tile-name="Учебная платформа">
                        <div>
                            <p>Выбирайте любую из 15 карьерных<br> программ, исходя из вашей цели</p>
                            <p>Проходите курсы и мастер-классы<br> от международных экспертов и<br> получайте новые навыки
                            </p>
                            <p>Посещайте новые мероприятия,<br> которые проходят в клубе несколько<br> раз в месяц</p>
                            <a href="#">Вступить в клуб</a>
                        </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1656801855550.gif" alt="">
                        </div>
                    </div>
                    <div data-tile-name="Персональная поддержка">
                        <div>
                            <p>Получайте рекомендации<br> карьерного коуча в чате</p>
                            <p>Участвуйте в видеосессиях,<br> чтобы системно работать над<br> своим запросом</p>
                            <p>Усиливайте резюме вместе<br> с CV-экспертом</p>
                            <a href="#">Вступить в клуб</a>
                        </div>
                        <div>
                            <div>
                                <div>
                                    <div class="careerum-tiles-item-1">
                                        <h3>Ирина Феоктистова</h3>
                                        <p>Коуч AFC. Work-life<br> баланс и тайм-<br>менеджмент</p>
                                        <p>Россия</p>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1656801827117.png" alt="">
                                    </div>
                                    <div class="careerum-tiles-item-2">
                                        <h3>Марина Веденичева</h3>
                                        <p>Коуч ICF PCC.<br> Карьерный рост,<br> увеличение дохода</p>
                                        <p>Великобритания</p>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1656801809501.png" alt="">
                                    </div>
                                </div>
                                <div  class="careerum-tiles-item-3">
                                    <h3>Ольга Лермонтова</h3>
                                    <p>Международный коуч<br> ICF, CEO Careerum.</p>
                                    <p>Италия</p>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1656801791127.png" alt="">
                                </div>
                            </div>
                            <div>
                                <div class="careerum-tiles-item-4">
                                    <h3>София Бессонова</h3>
                                    <p>CV-специалист,<br> коуч ICF</p>
                                    <p>Израиль</p>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1656801768764.png" alt="">
                                </div>
                                <div class="careerum-tiles-item-5">
                                    <h3>Светлана Баран</h3>
                                    <p>Коуч ICF. Релокация,<br> смена сферы</p>
                                    <p>Италия</p>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1656801748270.png" alt="">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div data-tile-name="Комьюнити">
                        <div>
                            <p>Общайтесь с русскоязычными<br> профессионалами со всего мира<br> в нашей собственной соцсети</p>
                            <p>Находите людей по интересам<br> и расширяйте сеть знакомств</p>
                            <p>Участвуйте в нетворк-встречах<br> по интересам онлайн и офлайн </p>
                            <a href="#">Вступить в клуб</a>
                        </div>
                        <div>
                            <iframe width="692" height="430" src="https://www.youtube.com/embed/lqFfk8USYtg" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                        </div>
                    </div>
                    <div data-tile-name="Нетворк-боты">
                        <div>
                            <p>Знакомьтесь с помощью умного<br> алгоритма Coffee Buddy</p>
                            <p>Узнавайте об особенностях<br> компаний, в которых работают<br> другие участники</p>
                            <p>Учитесь в группах для практики<br> навыков с помощью алгоритма<br> Connector</p>
                            <a href="#">Вступить в клуб</a>
                        </div>
                        <div>
                            <div class="careerum-tab-json-animate">                            
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>`
	});

    blockManager.add('careerum-tabs-horizontal-tablet', {
        label: 'Горизонтальные табы (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="careerum-tabs-horizontal-tablet">
        <div>
            <div>
                <h2>Что приведет вас к результату</h2>
            </div>
            <div>
                <div>
                    <form action="">
                        <label class="selected"><p>Учебная платформа</p><input type="radio" name="tabs" id="" checked></label>
                        <label><p>Персональная поддержка</p><input type="radio" name="tabs" id=""></label>
                        <label><p>Комьюнити</p><input type="radio" name="tabs" id=""></label>
                        <label><p>Нетворк-боты</p><input type="radio" name="tabs" id=""></label>
                    </form>                    
                </div>
                <div class="careerum-tiles-rezult">
                    <div data-tile-name="Учебная платформа">
                        <div>
                            <p>Выбирайте любую<br> из 15 карьерных программ,<br> исходя из вашей цели</p>
                            <p>Проходите курсы и мастер-<br>классы от международных<br> экспертов и получайте<br> новые навыки
                            </p>
                            <p>Посещайте новые<br> мероприятия, которые<br> проходят в клубе<br> несколько раз в месяц</p>
                            <a href="#">Вступить в клуб</a>
                        </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1656801688158.png" alt="">
                        </div>
                    </div>
                    <div data-tile-name="Персональная поддержка">
                        <div>
                            <p>Получайте рекомендации<br> карьерного коуча в чате</p>
                            <p>Участвуйте в видеосессиях,<br> чтобы системно работать<br> над своим запросом</p>
                            <p>Усиливайте резюме вместе<br> с CV-экспертом</p>
                            <a href="#">Вступить в клуб</a>
                        </div>
                        <div>
                            <div>
                                <div class="careerum-tiles-item-1">
                                    <h3>Марина<br> Веденичева</h3>
                                    <p>Коуч ICF PCC.<br> Карьерный рост,<br> увеличение<br> дохода</p>
                                    <p>Великобритания</p>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1656801664341.png" alt="">
                                </div>
                                <div class="careerum-tiles-item-2">
                                    <h3>Ольга<br> Лермонтова</h3>
                                    <p>Международный<br> коуч ICF, CEO<br> Careerum</p>
                                    <p>Италия</p>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1656801647636.png" alt="">
                                </div>
                            </div>
                            <div>
                                <div class="careerum-tiles-item-3">
                                    <h3>Светлана<br> Баран</h3>
                                    <p>Коуч ICF.<br> Релокация, смена<br> сферы</p>
                                    <p>Италия</p>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1656801629257.png" alt="">
                                </div>
                                <div class="careerum-tiles-item-4">
                                    <h3>София<br> Бессонова</h3>
                                    <p>CV-специалист,<br> коуч ICF</p>
                                    <p>Израиль</p>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1656801610734.png" alt="">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div data-tile-name="Комьюнити">
                        <div>
                            <p>Общайтесь с<br> русскоязычными <br>профессионалами<br> со всего мира в нашей<br> собственной соцсети</p>
                            <p>Находите людей по<br> интересам и расширяйте<br> сеть знакомств</p>
                            <p>Участвуйте в нетворк-<br>встречах по интересам<br> онлайн и офлайн </p>
                            <a href="#">Вступить в клуб</a>
                        </div>
                        <div>
                            <iframe width="470" height="292" src="https://www.youtube.com/embed/lqFfk8USYtg" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                        </div>
                    </div>
                    <div data-tile-name="Нетворк-боты">
                        <div>
                            <p>Знакомьтесь с помощью<br> умного алгоритма Coffee<br> Buddy</p>
                            <p>Узнавайте об особенностях<br> компаний, в которых<br> работают другие участники</p>
                            <p>Учитесь в группах для<br> практики навыков с<br> помощью алгоритма<br> Connector</p>
                            <a href="#">Вступить в клуб</a>
                        </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1656801583932.png" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>`
	});

    blockManager.add('careerum-tabs-horizontal-mobile', {
        label: 'Горизонтальные табы (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="careerum-tabs-horizontal-mobile">
        <div>
            <div>
                <h2>Что приведет<br> вас к результату</h2>
            </div>
            <div>
                <div>
                    <form action="">
                        <label class="selected"><p>Учебная платформа</p><input type="radio" name="tabs" id="" checked></label>
                        <label><p>Персональная поддержка</p><input type="radio" name="tabs" id=""></label>
                        <label><p>Комьюнити</p><input type="radio" name="tabs" id=""></label>
                        <label><p>Нетворк-боты</p><input type="radio" name="tabs" id=""></label>
                    </form>                    
                </div>
                <div class="careerum-tiles-rezult">
                    <div data-tile-name="Учебная платформа">
                        <div>
                            <div>
                                <p>Выбирайте любую из 15 карьерных<br> программ, исходя из вашей цели</p>
                                <p>Проходите курсы и мастер-классы от <br>международных экспертов и получайте<br> новые навыки</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1656801547570.png" alt="">
                            </div>                        
                            <a href="#">Вступить в клуб</a>
                        </div>
                    </div>
                    <div data-tile-name="Персональная поддержка">
                        <div>
                            <div>
                                <p>Получайте рекомендации карьерного<br> коуча в чате и усиливайте резюме вместе<br> с CV-экспертом</p>
                                <p>Участвуйте в видеосессиях, чтобы системно<br> работать над своим запросом</p>
                            </div>
                            <div>
                                <div>
                                    <div>
                                        <div class="careerum-tiles-item-1">
                                            <h3>Ольга Лермонтова</h3>
                                            <p>Международный<br> коуч ICF, CEO<br> Careerum</p>
                                            <p>Италия</p>
                                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1656801524867.png" alt="">
                                        </div>
                                        <div class="careerum-tiles-item-2">
                                            <h3>Марина Веденичева</h3>
                                            <p>Коуч ICF PCC.<br> Карьерный рост,<br> увеличение дохода</p>
                                            <p>Великобритания</p>
                                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1656801504185.png" alt="">
                                        </div>
                                        <div class="careerum-tiles-item-3">
                                            <h3>Ирина Феоктистова</h3>
                                            <p>Коуч AFC.<br> Work-life<br> баланс и тайм-<br>менеджмент</p>
                                            <p>Россия</p>
                                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1656801474652.png" alt="">
                                        </div>
                                        <div class="careerum-tiles-item-4">
                                            <h3>Светлана Баран</h3>
                                            <p>Коуч ICF. Релокация,<br> смена сферы</p>
                                            <p>Италия</p>
                                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1656801452341.png" alt="">
                                        </div>
                                        <div class="careerum-tiles-item-5">
                                            <h3>София Бессонова</h3>
                                            <p>CV-специалист,<br> коуч ICF</p>
                                            <p>Израиль</p>
                                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1656801410399.png" alt="">
                                        </div>
                                    </div>
                                </div>
                                <div><a href="#">Вступить в клуб</a></div>
                            </div>
                        </div>
                    </div>
                    <div data-tile-name="Комьюнити">
                        <div>
                            <div>
                                <p>Общайтесь с русскоязычными <br>профессионалами со всего мира<br> в нашей собственной соцсети</p>
                                <p>Находите людей по интересам<br> и расширяйте сеть знакомств</p>
                            </div>
                            <div>
                                <iframe width="294" height="182" src="https://www.youtube.com/embed/lqFfk8USYtg" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                            </div>
                            <a href="#">Вступить в клуб</a>
                        </div>
                    </div>
                    <div data-tile-name="Нетворк-боты">
                        <div>
                            <div>
                                <p>Знакомьтесь с помощью умного<br> алгоритма Coffee Buddy</p>
                                <p>Учитесь в группах для практики<br> навыков с помощью алгоритма<br> Connector</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1656801370268.png" alt="">
                            </div>
                            <a href="#">Вступить в клуб</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>`
	});




    blockManager.add('careerum-tabs-vertical', {
        label: 'Вертикальные табы',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: {type: "careerum-tabs-vertical"}
	});

    blockManager.add('careerum-tabs-vertical-tablet', {
        label: 'Вертикальные табы (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: {type: "careerum-tabs-vertical-tablet"}
	});

    blockManager.add('careerum-tabs-vertical-mobile', {
        label: 'Вертикальные табы (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: {type: "careerum-tabs-vertical-mobile"}
	});


    
    
    blockManager.add('careerum-three-tales', {
        label: 'А что дальше',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="careerum-three-tales">
        <div>
            <div>
                <h2>Мне все понятно. <br>А что <span>дальше?</span></h2>
            </div>
            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1656801314503.svg" alt="">
            <div>
                <div>
                    <h3><span>Подпишитесь на рассылку Careerum.Tips</span><br> и делайте первые самостоятельные шаги</h3>
                    <p>≈ от 10 минут в неделю</p>
                    <a href="#">Получать советы</a>
                </div>
                <div>
                    <h3><span>Подпишитесь на бота Райана и</span> получайте бесплатные материалы<br> о карьере</h3>
                    <p>≈ от 3 минут в неделю</p>
                    <a href="#">Поговорить с Райаном</a>
                </div>
                <div>
                    <h3><span>Станьте участником<br> Careerum.Club —</span> учитесь<br> строить карьеру в<br> любой стране и больше <br>зарабатывать</h3>
                    <p>≈ от 3 часов в неделю</p>
                    <a href="#">Присоединиться к клубу</a>
                </div>
            </div>
        </div>
    </div>`
	});

    blockManager.add('careerum-three-tales-tablet', {
        label: 'А что дальше (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="careerum-three-tales-tablet">
        <div>
            <div>
                <h2>Мне все понятно. <br>А что <span>дальше?</span></h2>
            </div>
            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1656801275988.svg" alt="">
            <div>
                <div>
                    <h3><span>Подпишитесь<br> на рассылку<br> Careerum.Tips</span><br> и делайте первые самостоятельные шаги</h3>
                    <p>≈ от 10 минут в неделю</p>
                    <a href="#">Получать советы</a>
                </div>
                <div>
                    <h3><span>Подпишитесь на бота Райана и</span> получайте бесплатные материалы о карьере</h3>
                    <p>≈ от 3 минут в неделю</p>
                    <a href="#">Поговорить с Райаном</a>
                </div>
                <div>
                    <h3><span>Станьте участником<br> Careerum.Club —</span><br> учитесь строить<br> карьеру в любой<br> стране и больше <br>зарабатывать</h3>
                    <p>≈ от 3 часов в неделю</p>
                    <a href="#">Присоединиться к клубу</a>
                </div>
            </div>
        </div>
    </div>`
	});

    blockManager.add('careerum-three-tales-mobile', {
        label: 'А что дальше (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="careerum-three-tales-mobile">
        <div>
            <div>
                <h2>Мне все понятно. <br>А что <span>дальше?</span></h2>
            </div>
            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1656801227708.svg" alt="">
            <div>
                <div>
                    <h3><span>Подпишитесь на <br>рассылку Careerum.Tips</span><br> и делайте первые самостоятельные шаги</h3>
                    <p>≈ от 10 минут в неделю</p>
                    <a href="#">Получать советы</a>
                </div>
                <div>
                    <h3><span>Подпишитесь на бота Райана и</span> получайте бесплатные материалы о карьере</h3>
                    <p>≈ от 3 минут в неделю</p>
                    <a href="#">Поговорить с Райаном</a>
                </div>
                <div>
                    <h3><span>Станьте участником<br> Careerum.Club —</span> учитесь строить карьеру в любой стране и больше зарабатывать</h3>
                    <p>≈ от 3 часов в неделю</p>
                    <a href="#">Присоединиться к клубу</a>
                </div>
            </div>
        </div>
    </div>`
	});

    
    
    blockManager.add('careerum-vacancy', {
        label: 'Вакансии',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="careerum-vacancy">
        <div>
            <div>
                <h1>Станьте частью<br> команды <span>Careerum</span></h1>
                <p>Получите опыт в крупнейшем карьерном EdTech<br>проекте России и СНГ, профессиональный<br> рост и поддержку сильной команды</p>
            </div>
            <div>
                <div>
                    <div>
                        <h3>Карьерный эксперт</h3>
                        <p>Создавать и проводить обучающие ивенты на тему карьеры</p>
                        <a href="#">Откликнуться</a>
                    </div>
                    <div>
                        <h3>CV-специалист</h3>
                        <p>Помогать участникам <br>Careerum усиливать резюме <br>для поиска подходящей <br>работы</p>
                        <a href="#">Откликнуться</a>
                    </div>
                    <div>
                        <h3>Менеджер поддержки</h3>
                        <p>Поддерживать клиентов<br> на каждом этапе — от<br> знакомства с Careerum<br> до процесса обучения</p>
                        <a href="#">Откликнуться</a>
                    </div>
                </div>
                <div>
                    <div>
                        <h3>HR-специалист</h3>
                        <p>Подбирать сотрудников<br> в команду</p>
                        <a href="#">Откликнуться</a>
                    </div>
                    <div>
                        <h3>Менеджер междуна-<br>родного развития</h3>
                        <p>Выводить Careerum<br> на зарубежный рынок</p>
                        <a href="#">Откликнуться</a>
                    </div>
                </div>
                <div>
                    <div>
                        <div>
                            <h3>Не нашли подходящую вакансию?</h3>
                            <p>Заполните анкету — <br>расскажите, как вы можете<br> быть полезны Careerum,<br> и мы свяжемся с вами</p>
                        </div>
                        <a href="#">Заполнить анкету</a>
                    </div>
                </div>
            </div>
        </div>
    </div>`
	});

    blockManager.add('careerum-vacancy-tablet', {
        label: 'Вакансии (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="careerum-vacancy-tablet">
        <div>
            <div>
                <h1>Станьте частью<br> команды <span>Careerum</span></h1>
                <p>Получите опыт в крупнейшем карьерном EdTech<br>проекте России и СНГ, профессиональный<br> рост и поддержку сильной команды</p>
            </div>
            <div>
                <div>
                    <div>
                        <h3>Карьерный эксперт</h3>
                        <p>Создавать и проводить обучающие ивенты на тему карьеры</p>
                        <a href="#">Откликнуться</a>
                    </div>
                    <div>
                        <h3>CV-специалист</h3>
                        <p>Помогать участникам <br>Careerum усиливать резюме <br>для поиска подходящей <br>работы</p>
                        <a href="#">Откликнуться</a>
                    </div>
                    <div>
                        <h3>Менеджер поддержки</h3>
                        <p>Поддерживать клиентов<br> на каждом этапе — <br>от знакомства с Careerum<br> до процесса обучения</p>
                        <a href="#">Откликнуться</a>
                    </div>
                </div>
                <div>
                    <div>
                        <h3>HR-специалист</h3>
                        <p>Подбирать сотрудников<br> в команду</p>
                        <a href="#">Откликнуться</a>
                    </div>
                    <div>
                        <h3>Менеджер междуна-<br>родного развития</h3>
                        <p>Выводить Careerum<br> на зарубежный рынок</p>
                        <a href="#">Откликнуться</a>
                    </div>
                </div>
                <div>
                    <div>
                        <div>
                            <h3>Не нашли подходящую вакансию?</h3>
                            <p>Заполните анкету — расскажите,<br> как вы можете быть полезны<br> Careerum, и мы свяжемся с вами</p>
                        </div>
                        <a href="#">Заполнить анкету</a>
                    </div>
                </div>
            </div>
        </div>
    </div>`
	});

    blockManager.add('careerum-vacancy-mobile', {
        label: 'Вакансии (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="careerum-vacancy-mobile">
        <div>
            <div>
                <h1>Станьте частью<br> команды <span>Careerum</span></h1>
                <p>Получите опыт в крупнейшем карьерном EdTech проекте России и СНГ, профессиональный рост и поддержку сильной команды</p>
            </div>
            <div>
                <div>
                    <div>
                        <h3>Карьерный эксперт</h3>
                        <p>Создавать и проводить обучающие ивенты на тему карьеры</p>
                        <a href="#">Откликнуться</a>
                    </div>
                    <div>
                        <h3>CV-специалист</h3>
                        <p>Помогать участникам Careerum<br> усиливать резюме для поиска<br> подходящей работы</p>
                        <a href="#">Откликнуться</a>
                    </div>
                    <div>
                        <h3>Менеджер поддержки</h3>
                        <p>Поддерживать клиентов<br> на каждом этапе — от знакомства<br> с Careerum до процесса обучения</p>
                        <a href="#">Откликнуться</a>
                    </div>
                    <div>
                        <h3>HR-специалист</h3>
                        <p>Подбирать сотрудников в команду</p>
                        <a href="#">Откликнуться</a>
                    </div>
                    <div>
                        <h3>Менеджер международ-ного развития</h3>
                        <p>Выводить Careerum на зарубежный рынок</p>
                        <a href="#">Откликнуться</a>
                    </div>
                </div>
                <div>
                    <div>
                        <div>
                            <h3>Не нашли подходящую вакансию?</h3>
                            <p>Заполните анкету —<br> расскажите, как вы можете<br> быть полезны Careerum,<br> и мы свяжемся с вами</p>
                        </div>
                        <a href="#">Заполнить анкету</a>
                    </div>
                </div>
            </div>
        </div>
    </div>`
	});



    
    blockManager.add('careerum-upsale-main', {
        label: 'Апсейлы - главная',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="careerum-upsale-main">
        <div>
            <div>
                <h1>Поздравляем! Скоро вы<br> направите свою карьерную<br> ракету к звездам</h1>
            </div>
            <div>
                <div>
                    <p>Вас ждет 1 месяц обучения и развития<br> в Careerum.Club на тарифе «С поддержкой»</p>
                </div>
                <div>
                    <p>Приветственное письмо <br>уже отправили вам на почту</p>
                </div>
            </div>
        </div>
    </div>`
	});

    blockManager.add('careerum-upsale-main-tablet', {
        label: 'Апсейлы - главная (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="careerum-upsale-main-tablet">
        <div>
            <div>
                <h1>Поздравляем! Скоро вы<br> направите свою карьерную<br> ракету к звездам</h1>
            </div>
            <div>
                <div>
                    <p>Вас ждет 1 месяц обучения и развития<br> в Careerum.Club на тарифе «С поддержкой»</p>
                </div>
                <div>
                    <p>Приветственное письмо <br>уже отправили вам на почту</p>
                </div>
            </div>
        </div>
    </div>`
	});

    blockManager.add('careerum-upsale-main-mobile', {
        label: 'Апсейлы - главная (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="careerum-upsale-main-mobile">
        <div>
            <div>
                <h1>Поздравляем! Скоро вы<br> направите свою карьерную ракету<br> к звездам</h1>
            </div>
            <div>
                <div>
                    <p>Вас ждет 1 месяц обучения<br> и развития в Careerum.Club<br> на тарифе «С поддержкой»</p>
                </div>
                <div>
                    <p>Приветственное письмо <br>уже отправили вам на почту</p>
                </div>
            </div>
        </div>
    </div>`
	});



    
    blockManager.add('careerum-upsale-tariffs-three', {
        label: 'Апсейлы - 3 тарифа',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="careerum-upsale-tariffs-three">
        <div>
            <div>
                <div>
                    <h2>Оплатите сразу<br> несколько месяцев<br> в клубе и сэкономьте<br> до 23 000 ₽</h2>
                </div>
                <div>
                    <ul>
                        <li>Предложение действует, <br>пока вы видите эту страницу</li>
                        <li>Докупленные месяцы суммируются с предыдущей покупкой</li>
                        <li>Подписка будет продлеваться автоматически, отменить можно в любой момент</li>
                    </ul>
                </div>
            </div>
            <div>
                <div>
                    <h3>3 месяца</h3>
                    <ul>
                        <li>Поймете, чего<br> хотите от карьеры</li>
                        <li>Построите собственный<br> карьерный план</li>
                        <li>Сделаете первые шаги<br> к работе мечты или<br> повышению</li>
                    </ul>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1657535537256.svg" alt="">
                        <div>
                            <p>20 000 ₽</p>
                            <p>23 800 ₽</p>
                        </div>
                        <p>10 633 ₽ в месяц</p>
                        <a href="#">Доплатить за 2 месяца</a>
                    </div>
                </div>
                <div>
                    <h3>6 месяцев</h3>
                    <ul>
                        <li>Повысите<br> профессиональную<br> самооценку</li>
                        <li>Найдете опору в своих<br> талантах</li>
                        <li>Достигните первой цели — <br>получите работу или <br>повышение</li>
                    </ul>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1657535464676.svg" alt="">
                        <div>
                            <p>50 000 ₽</p>
                            <p>59 500 ₽</p>
                        </div>
                        <p>10 316 ₽ в месяц</p>
                        <a href="#">Доплатить за 5 месяцев</a>
                    </div>
                </div>
                <div>
                    <h3>12 месяцев</h3>
                    <ul>
                        <li>Научитесь<br> всегда работать<br> в радость</li>
                        <li>Укрепите soft skills</li>
                        <li>Освоите навык решения<br> любых карьерных задач,<br> даже самых сложных</li>
                    </ul>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1657535274288.svg" alt="">
                        <div>
                            <p>108 000 ₽</p>
                            <p>130 900 ₽</p>
                        </div>
                        <p>9 991 ₽ в месяц</p>
                        <a href="#">Доплатить за 11 месяцев</a>
                    </div>
                </div>
            </div>
        </div>
    </div>`
	});

    blockManager.add('careerum-upsale-tariffs-three-tablet', {
        label: 'Апсейлы - 3 тарифа (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="careerum-upsale-tariffs-three-tablet">
        <div>
            <div>
                <div>
                    <h2>Оплатите сразу<br> несколько<br> месяцев в клубе<br> и сэкономьте<br> до 23 000 ₽</h2>
                </div>
                <div>
                    <ul>
                        <li>Предложение действует, <br>пока вы видите эту страницу</li>
                        <li>Докупленные месяцы суммируются <br>с предыдущей покупкой</li>
                        <li>Подписка будет продлеваться автоматически, отменить можно<br> в любой момент</li>
                    </ul>
                </div>
            </div>
            <div>
                <div>
                    <h3>3 месяца</h3>
                    <ul>
                        <li>Поймете, чего<br> хотите от карьеры</li>
                        <li>Построите собственный<br> карьерный план</li>
                        <li>Сделаете первые шаги<br> к работе мечты или<br> повышению</li>
                    </ul>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1657535568382.svg" alt="">
                        <div>
                            <p>20 000 ₽</p>
                            <p>23 800 ₽</p>
                        </div>
                        <p>10 633 ₽ в месяц</p>
                        <a href="#">Доплатить за 2 месяца</a>
                    </div>
                </div>
                <div>
                    <h3>6 месяцев</h3>
                    <ul>
                        <li>Повысите<br> профессиональную<br> самооценку</li>
                        <li>Найдете опору в <br>своих талантах</li>
                        <li>Достигните первой<br> цели — получите<br> работу или <br>повышение</li>
                    </ul>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1657535400430.svg" alt="">
                        <div>
                            <p>50 000 ₽</p>
                            <p>59 500 ₽</p>
                        </div>
                        <p>10 316 ₽ в месяц</p>
                        <a href="#">Доплатить за 5 месяцев</a>
                    </div>
                </div>
                <div>
                    <h3>12 месяцев</h3>
                    <ul>
                        <li>Научитесь<br> всегда работать<br> в радость</li>
                        <li>Укрепите soft skills</li>
                        <li>Освоите навык<br> решения любых<br> карьерных задач,<br> даже самых сложных</li>
                    </ul>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1657535189349.svg" alt="">
                        <div>
                            <p>108 000 ₽</p>
                            <p>130 900 ₽</p>
                        </div>
                        <p>9 991 ₽ в месяц</p>
                        <a href="#">Доплатить за 11 месяцев</a>
                    </div>
                </div>
            </div>
        </div>
    </div>`
	});

    blockManager.add('careerum-upsale-tariffs-three-mobile', {
        label: 'Апсейлы - 3 тарифа (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="careerum-upsale-tariffs-three-mobile">
        <div>
            <div>
                <div>
                    <h2>Оплатите сразу<br> несколько месяцев<br> в клубе и сэкономьте<br> до 23 000 ₽</h2>
                </div>
            </div>
            <div>
                <div>
                    <div>
                        <h3>3 месяца</h3>
                        <ul>
                            <li>Поймете, чего<br> хотите от карьеры</li>
                            <li>Построите<br> собственный<br> карьерный план</li>
                            <li>Сделаете первые шаги<br> к работе мечты или<br> повышению</li>
                        </ul>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1657535588606.svg" alt="">
                            <div>
                                <p>20 000 ₽</p>
                                <p>23 800 ₽</p>
                            </div>
                            <p>10 633 ₽ в месяц</p>
                            <a href="#">Доплатить за 2 месяца</a>
                        </div>
                    </div>
                    <div>
                        <h3>6 месяцев</h3>
                        <ul>
                            <li>Повысите<br> профессиональную<br> самооценку</li>
                            <li>Найдете опору <br>в своих талантах</li>
                            <li>Достигните первой<br> цели — получите<br> работу или повышение</li>
                        </ul>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1657535400430.svg" alt="">
                            <div>
                                <p>50 000 ₽</p>
                                <p>59 500 ₽</p>
                            </div>
                            <p>10 316 ₽ в месяц</p>
                            <a href="#">Доплатить за 5 месяцев</a>
                        </div>
                    </div>
                    <div>
                        <h3>12 месяцев</h3>
                        <ul>
                            <li>Научитесь<br> всегда работать<br> в радость</li>
                            <li>Укрепите soft skills</li>
                            <li>Освоите навык<br> решения любых<br> карьерных задач,<br> даже самых сложных</li>
                        </ul>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1657534957346.svg" alt="">
                            <div>
                                <p>108 000 ₽</p>
                                <p>130 900 ₽</p>
                            </div>
                            <p>9 991 ₽ в месяц</p>
                            <a href="#">Доплатить за 11 месяцев</a>
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <ul>
                    <li>Предложение действует, <br>пока вы видите эту страницу</li>
                    <li>Докупленные месяцы суммируются <br>с предыдущей покупкой</li>
                    <li>Подписка будет продлеваться автоматически, отменить можно<br> в любой момент</li>
                </ul>
            </div>
        </div>
    </div>`
	});


    
    blockManager.add('careerum-upsale-tariffs-two', {
        label: 'Апсейлы - 2 тарифа',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="careerum-upsale-tariffs-two">
        <div>
            <div>
                <div>
                    <h2>Оплатите сразу несколько<br> месяцев в клубе и<br> сэкономьте до 23 000 ₽</h2>
                </div>
            </div>
            <div>
                <div>
                    <ul>
                        <li>Предложение действует, <br>пока вы видите эту страницу</li>
                        <li>Докупленные месяцы<br> суммируются с предыдущей<br> покупкой</li>
                        <li>Стоимость тарифа будет<br> списываться автоматически</li>
                        <li>Подписку можно отменить <br>в любой момент</li>
                    </ul>
                </div>
                <div>
                    <h3>6 месяцев</h3>
                    <ul>
                        <li>Повысите<br> профессиональную<br> самооценку</li>
                        <li>Найдете опору в своих<br> талантах</li>
                        <li>Достигните первой цели — <br>получите работу или <br>повышение</li>
                    </ul>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1657535464676.svg" alt="">
                        <div>
                            <p>30 000 ₽</p>
                            <p>35 700 ₽</p>
                        </div>
                        <p>10 316 ₽ в месяц</p>
                        <a href="#">Доплатить за 3 месяца</a>
                    </div>
                </div>
                <div>
                    <h3>12 месяцев</h3>
                    <ul>
                        <li>Научитесь<br> всегда работать<br> в радость</li>
                        <li>Укрепите soft skills</li>
                        <li>Освоите навык решения<br> любых карьерных задач,<br> даже самых сложных</li>
                    </ul>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1657535274288.svg" alt="">
                        <div>
                            <p>88 000 ₽</p>
                            <p>107 100 ₽</p>
                        </div>
                        <p>9 991 ₽ в месяц</p>
                        <a href="#">Доплатить за 9 месяцев</a>
                    </div>
                </div>
            </div>
        </div>
    </div>`
	});

    blockManager.add('careerum-upsale-tariffs-two-tablet', {
        label: 'Апсейлы - 2 тарифа (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="careerum-upsale-tariffs-two-tablet">
        <div>
            <div>
                <div>
                    <h2>Оплатите сразу<br> несколько<br> месяцев в клубе<br> и сэкономьте <br>до 23 000 ₽</h2>
                </div>
                <div>
                    <ul>
                        <li>Предложение действует, <br>пока вы видите эту страницу</li>
                        <li>Докупленные месяцы суммируются<br> с предыдущей покупкой</li>
                        <li>Стоимость тарифа будет<br> списываться автоматически</li>
                        <li>Подписку можно отменить <br>в любой момент</li>
                    </ul>
                </div>
            </div>
            <div>
                <div>
                    <h3>6 месяцев</h3>
                    <ul>
                        <li>Повысите<br> профессиональную<br> самооценку</li>
                        <li>Найдете опору в<br> своих талантах</li>
                        <li>Достигните первой<br> цели — получите<br> работу или <br>повышение</li>
                    </ul>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1657535400430.svg" alt="">
                        <div>
                            <p>30 000 ₽</p>
                            <p>35 700 ₽</p>
                        </div>
                        <p>10 316 ₽ в месяц</p>
                        <a href="#">Доплатить за 3 месяца</a>
                    </div>
                </div>
                <div>
                    <h3>12 месяцев</h3>
                    <ul>
                        <li>Научитесь<br> всегда работать<br> в радость</li>
                        <li>Укрепите soft skills</li>
                        <li>Освоите навык<br> решения любых<br> карьерных задач,<br> даже самых сложных</li>
                    </ul>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1657535189349.svg" alt="">
                        <div>
                            <p>88 000 ₽</p>
                            <p>107 100 ₽</p>
                        </div>
                        <p>9 991 ₽ в месяц</p>
                        <a href="#">Доплатить за 9 месяцев</a>
                    </div>
                </div>
            </div>
        </div>
    </div>`
	});

    blockManager.add('careerum-upsale-tariffs-two-mobile', {
        label: 'Апсейлы - 2 тарифа (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="careerum-upsale-tariffs-two-mobile">
        <div>
            <div>
                <div>
                    <h2>Оплатите сразу<br> несколько месяцев<br> в клубе и сэкономьте <br>до 23 000 ₽</h2>
                </div>
            </div>
            <div>
                <div>
                    <div>
                        <h3>6 месяцев</h3>
                        <ul>
                            <li>Повысите<br> профессиональную<br> самооценку</li>
                            <li>Найдете опору<br> в своих талантах</li>
                            <li>Достигните первой<br> цели — получите<br> работу или повышение</li>
                        </ul>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1657535400430.svg" alt="">
                            <div>
                                <p>30 000 ₽</p>
                                <p>35 700 ₽</p>
                            </div>
                            <p>10 316 ₽ в месяц</p>
                            <a href="#">Доплатить за 3 месяца</a>
                        </div>
                    </div>
                    <div>
                        <h3>12 месяцев</h3>
                        <ul>
                            <li>Научитесь<br> всегда работать<br> в радость</li>
                            <li>Укрепите soft skills</li>
                            <li>Освоите навык<br> решения любых<br> карьерных задач,<br> даже самых сложных</li>
                        </ul>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1657534957346.svg" alt="">
                            <div>
                                <p>88 000 ₽</p>
                                <p>107 100 ₽</p>
                            </div>
                            <p>9 991 ₽ в месяц</p>
                            <a href="#">Доплатить за 9 месяцев</a>
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <ul>
                    <li>Предложение действует, <br>пока вы видите эту страницу</li>
                    <li>Докупленные месяцы суммируются<br> с предыдущей покупкой</li>
                    <li>Стоимость тарифа будет<br> списываться автоматически</li>
                    <li>Подписку можно отменить <br>в любой момент</li>
                </ul>
            </div>
        </div>
    </div>`
	});

    
    blockManager.add('careerum-upsale-tariffs-one', {
        label: 'Апсейлы - 1 тариф',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="careerum-upsale-tariffs-one">
        <div>
            <div>
                <div>
                    <h2>Оплатите сразу<br> 12 месяцев в клубе<br> и сэкономьте 23 000 ₽</h2>
                </div>
                <div>
                    <ul>
                        <li>Предложение действует, <br>пока вы видите эту страницу</li>
                        <li>Стоимость тарифа будет<br> списываться автоматически</li>
                        <li>Докупленные месяцы<br> суммируются с предыдущей<br> покупкой</li>
                        <li>Подписку можно отменить <br>в любой момент</li>
                    </ul>
                </div>
            </div>
            <div>
                <div>
                    <h3>12 месяцев</h3>
                    <ul>
                        <li>Научитесь<br> всегда работать<br> в радость</li>
                        <li>Укрепите soft skills</li>
                        <li>Освоите навык решения<br> любых карьерных задач,<br> даже самых сложных</li>
                    </ul>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1657535274288.svg" alt="">
                        <div>
                            <p>58 900 ₽</p>
                            <p>71 400 ₽</p>
                        </div>
                        <p>9 991 ₽ в месяц</p>
                        <a href="#">Доплатить за 6 месяцев</a>
                    </div>
                </div>
            </div>
        </div>
    </div>`
	});

    blockManager.add('careerum-upsale-tariffs-one-tablet', {
        label: 'Апсейлы - 1 тариф (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="careerum-upsale-tariffs-one-tablet">
        <div>
            <div>
                <div>
                    <h2>Оплатите сразу<br> несколько<br> месяцев в клубе<br> и сэкономьте<br> до 23 000 ₽</h2>
                </div>
                <div>
                    <ul>
                        <li>Предложение действует, <br>пока вы видите эту страницу</li>
                        <li>Докупленные месяцы суммируются<br> с предыдущей покупкой</li>
                        <li>Стоимость тарифа будет<br> списываться автоматически</li>
                        <li>Подписку можно отменить <br>в любой момент</li>
                    </ul>
                </div>
            </div>
            <div>
                <div>
                    <h3>12 месяцев</h3>
                    <ul>
                        <li>Научитесь<br> всегда работать<br> в радость</li>
                        <li>Укрепите soft skills</li>
                        <li>Освоите навык<br> решения любых<br> карьерных задач,<br> даже самых сложных</li>
                    </ul>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1657535189349.svg" alt="">
                        <div>
                            <p>58 900 ₽</p>
                            <p>71 400 ₽</p>
                        </div>
                        <p>9 991 ₽ в месяц</p>
                        <a href="#">Доплатить за 6 месяцев</a>
                    </div>
                </div>
            </div>
        </div>
    </div>`
	});

    blockManager.add('careerum-upsale-tariffs-one-mobile', {
        label: 'Апсейлы - 1 тариф (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="careerum-upsale-tariffs-one-mobile">
        <div>
            <div>
                <div>
                    <h2>Оплатите сразу <br>12 месяцев в клубе<br> и сэкономьте 23 000 ₽</h2>
                </div>
            </div>
            <div>
                <div>
                    <h3>12 месяцев</h3>
                    <ul>
                        <li>Научитесь<br> всегда работать<br> в радость</li>
                        <li>Укрепите soft skills</li>
                        <li>Освоите навык<br> решения любых<br> карьерных задач,<br> даже самых сложных</li>
                    </ul>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1657534957346.svg" alt="">
                        <div>
                            <p>58 900 ₽</p>
                            <p>71 400 ₽</p>
                        </div>
                        <p>9 991 ₽ в месяц</p>
                        <a href="#">Доплатить за 6 месяцев</a>
                    </div>
                </div>
            </div>
            <div>
                <ul>
                    <li>Предложение действует, <br>пока вы видите эту страницу</li>
                    <li>Докупленные месяцы суммируются<br> с предыдущей покупкой</li>
                    <li>Стоимость тарифа будет<br> списываться автоматически</li>
                    <li>Подписку можно отменить <br>в любой момент</li>
                </ul>
            </div>
        </div>
    </div>`
	});



    // VEBINAR
    
    blockManager.add('careerum-veb-main', {
        label: 'Вебинар - главная',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="careerum-veb-main">
        <div>
            <div>
                <h3>Бесплатный вебинар</h3>
                <h1>2022: как строить карьеру<br> и зарабатывать<br> в новых реалиях</h1>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1657725193683.svg" alt="">
                <ul>
                    <li>28 мая в 12:00–14:00 МСК</li>
                    <li>Бонус всем участникам — чек-лист «Моя устойчивость к кризисам»</li>
                </ul>
            </div>
            <div>
                <div class="careerum-registration-form">
                    <form class="deva-form getcourse-email-signup" name="devaRegistrationForm" data-gjs-type="deva-registration-form">
                        <div><input type="text" name="firstname" id="" required><span>Имя</span></div>
                        <div><input type="text" name="lastname" id="" required><span>Фамилия</span></div>
                        <div><input type="email" name="email" id="" required><span>Почта</span></div>
                        <div><input type="tel" name="tel" id="" required><span>Номер телефона</span></div>                                
                        <div>
                            <label><input type="checkbox" name="agree" id=""></label>
                            <p>Я даю согласие на обработку моих персональных данных в соотвествии с <a href="#">Политикой конфиденциальности</a></p>
                        </div>
                        <a href="#" disabled class="submit-btn">Зарегистрироваться</a>
                    </form>
                </div>
            </div>
        </div>
    </div>`
	});

    blockManager.add('careerum-veb-main-tablet', {
        label: 'Вебинар - главная (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="careerum-veb-main-tablet">
        <div>
            <div>
                <h3>Бесплатный вебинар</h3>
                <h1>2022: как строить<br> карьеру и зарабатывать<br> в новых реалиях</h1>
            </div>
            <div>
                <div class="careerum-registration-form-tablet">
                    <form class="deva-form getcourse-email-signup" name="devaRegistrationForm" data-gjs-type="deva-registration-form">
                        <div><input type="text" name="firstname" id="" required><span>Имя</span></div>
                        <div><input type="text" name="lastname" id="" required><span>Фамилия</span></div>
                        <div><input type="email" name="email" id="" required><span>Почта</span></div>
                        <div><input type="tel" name="tel" id="" required><span>Номер телефона</span></div>                                
                        <div>
                            <label><input type="checkbox" name="agree" id=""></label>
                            <p>Я даю согласие на обработку моих персональных данных в соотвествии с <a href="#">Политикой конфиденциальности</a></p>
                        </div>
                        <a href="#" disabled class="submit-btn">Зарегистрироваться</a>
                    </form>
                </div>
                <div>
                    <ul>
                        <li>28 мая в 12:00–14:00 МСК</li>
                        <li>Бонус всем участникам — чек-лист «Моя устойчивость к кризисам»</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>`
	});

    blockManager.add('careerum-veb-main-mobile', {
        label: 'Вебинар - главная (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="careerum-veb-main-mobile">
        <div>
            <div>
                <h3>Бесплатный вебинар</h3>
                <h1>2022: как строить<br> карьеру <br>и зарабатывать<br> в новых реалиях</h1>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1657725298650.svg" alt="">
            </div>
            <div>
                <ul>
                    <li>28 мая в 12:00–14:00 МСК</li>
                    <li>Бонус всем участникам — чек-лист «Моя устойчивость к кризисам»</li>
                </ul>
                <div class="careerum-registration-form-mobile">
                    <form class="deva-form getcourse-email-signup" name="devaRegistrationForm" data-gjs-type="deva-registration-form">
                        <div><input type="text" name="firstname" id="" required><span>Имя</span></div>
                        <div><input type="text" name="lastname" id="" required><span>Фамилия</span></div>
                        <div><input type="email" name="email" id="" required><span>Почта</span></div>
                        <div><input type="tel" name="tel" id="" required><span>Номер телефона</span></div>
                        <div>
                            <label><input type="checkbox" name="agree" id=""></label>
                            <p>Я даю согласие на обработку моих персональных данных в соотвествии<br> с <a
                                    href="#">Политикой конфиденциальности</a></p>
                        </div>
                        <a href="#" disabled class="submit-btn">Зарегистрироваться</a>
                    </form>
                </div>
            </div>
        </div>
    </div>`
	});


    
    blockManager.add('careerum-veb-for-you', {
        label: 'Вебинар для вас',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="careerum-veb-for-you">
        <div>
            <h2>Вебинар для вас,<br> если вы</h2>
            <div>
                <p>Растеряны и не понимаете, как развивать карьеру в текущих реалиях мирового кризиса</p>
                <p>Хотите разобраться, что происходит на рынке труда, чтобы выстроить грамотную стратегию</p>
                <p>Думаете о релокации, но не уверены, что сможете найти работу в новой стране, не меняя сферу</p>
                <p>Хотите остаться востребованным даже в условиях максимальной конкуренции</p>
            </div>
        </div>
    </div>`
	});

    blockManager.add('careerum-veb-for-you-tablet', {
        label: 'Вебинар для вас (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="careerum-veb-for-you-tablet">
        <div>
            <h2>Вебинар для <br>вас, если вы</h2>
            <div>
                <p>Растеряны и не понимаете, как развивать карьеру <br>в текущих реалиях мирового кризиса</p>
                <p>Хотите разобраться, что происходит на рынке труда, чтобы выстроить грамотную стратегию</p>
                <p>Думаете о релокации, но не уверены, что сможете найти работу в новой стране, не меняя сферу</p>
                <p>Хотите остаться востребованным даже в условиях максимальной конкуренции</p>
            </div>
        </div>
    </div>`
	});

    blockManager.add('careerum-veb-for-you-mobile', {
        label: 'Вебинар для вас (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="careerum-veb-for-you-mobile">
        <div>
            <h2>Вебинар для вас, если вы</h2>
            <div>
                <div>
                    <p>Растеряны и не понимаете, как развивать карьеру <br>в текущих реалиях мирового кризиса</p>
                    <p>Хотите разобраться,<br> что происходит<br> на рынке труда,<br> чтобы выстроить<br> грамотную
                        стратегию</p>
                    <p>Думаете о релокации, но не уверены, что сможете найти работу в новой стране, <br>не меняя сферу
                    </p>
                    <p>Хотите остаться востребованным<br> даже в условиях максимальной конкуренции</p>
                </div>
            </div>
        </div>
    </div>`
	});


    
    blockManager.add('careerum-veb-author', {
        label: 'Автор вебинара',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="careerum-veb-author">
        <div>
            <div><h2>Автор и ведущая вебинара — Ольга Лермонтова</h2></div>
            <div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1657725405398.png" alt="">
                </div>
                <div>
                    <p>Международный коуч ICF, CEO Careerum. </p>
                    <p>14+ лет успешной международной карьеры в 5 странах в компаниях Google, Microsoft. Степень MBA<br> от топовой бизнес-школы INSEAD.</p>
                    <p>Помогла 8000+ человек открыть в себе таланты, полюбить свою работу и сделать ее источником энергии.</p>
                    <p>Италия</p>
                </div>
            </div>
        </div>
    </div>`
	});

    blockManager.add('careerum-veb-author-tablet', {
        label: 'Автор вебинара (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="careerum-veb-author-tablet">
        <div>
            <div><h2>Автор и ведущая программы —<br> Ольга Лермонтова</h2></div>
            <div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1657725459309.png" alt="">
                </div>
                <div>
                    <p>Международный коуч ICF, CEO<br> Careerum. </p>
                    <p>14+ лет успешной карьеры <br>в 5 странах в компаниях Google,<br> Microsoft. Степень MBA от<br> топовой бизнес-школы INSEAD</p>
                    <p>Помогла 10 000+ человек<br> полюбить свою работу</p>
                    <p>Италия</p>
                </div>
            </div>
        </div>
    </div>`
	});

    blockManager.add('careerum-veb-author-mobile', {
        label: 'Автор вебинара (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="careerum-veb-author-mobile">
        <div>
            <div>
                <h2>Автор и ведущая программы — Ольга Лермонтова</h2>
            </div>
            <div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1657725504525.png" alt="">
                </div>
                <div>
                    <p>Международный коуч ICF, CEO Careerum. </p>
                    <p>14+ лет успешной карьеры <br>в 5 странах в компаниях Google, Microsoft. Степень MBA от топовой
                        бизнес-школы INSEAD</p>
                    <p>Помогла 10 000+ человек<br> полюбить свою работу</p>
                    <p>Италия</p>
                </div>
            </div>
        </div>
    </div>`
	});


    
    blockManager.add('careerum-veb-rezult', {
        label: 'По итогам вебинара',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="careerum-veb-rezult">
        <div>
            <div>
                <h2>По итогам<br> вебинара вы</h2>
                <a href="#">Зарегистрироваться на вебинар</a>
            </div>
            <div>
                <ul>
                    <li>Узнаете, что ждет мировой рынок труда в 2022 году</li>
                    <li>Поймете, какие карьерные ошибки совершают люди в кризис</li>
                    <li>Поймете, какие навыки помогут вам быть востребованным специалистом в кризис</li>
                </ul>
            </div>
        </div>
    </div>`
	});

    blockManager.add('careerum-veb-rezult-tablet', {
        label: 'По итогам вебинара (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="careerum-veb-rezult-tablet">
        <div>
            <div>
                <h2>По итогам<br> вебинара вы</h2>
                <a href="#">Зарегистрироваться на вебинар</a>
            </div>
            <div>
                <ul>
                    <li>Узнаете, что ждет<br> мировой рынок<br> труда в 2022 году</li>
                    <li>Поймете, какие<br> карьерные ошибки<br> совершают люди<br> в кризис</li>
                    <li>Поймете, какие навыки<br> помогут вам быть <br>востребованным<br> специалистом в кризис</li>
                </ul>
            </div>
        </div>
    </div>`
	});

    blockManager.add('careerum-veb-rezult-mobile', {
        label: 'По итогам вебинара (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="careerum-veb-rezult-mobile">
        <div>
            <div>
                <h2>По итогам<br> вебинара вы</h2>
            </div>
            <div>
                <ul>
                    <li>Узнаете, что ждет мировой <br>рынок труда в 2022 году</li>
                    <li>Поймете, какие карьерные <br>ошибки совершают люди<br> в кризис</li>
                    <li>Поймете, какие навыки помогут вам быть востребованным специалистом в кризис</li>
                </ul>
                <a href="#">Зарегистрироваться</a>
            </div>
        </div>
    </div>`
	});


    
    blockManager.add('careerum-veb-rezult-2col', {
        label: 'По итогам вебинара - 2col',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
            <div class="careerum-veb-rezult-2col veb41-switch-currency">
                <div>
                    <div>
                        <h2>По итогам<br> вебинара вы</h2>
                        <a href="#">Зарегистрироваться на вебинар</a>
                        <div class="veb41-price-wrapper" data-price-rub="4 900 ₽" data-price-eur="49 €"
                            data-price-rub-old="4 900 ₽" data-price-eur-old="149 €₽" data-link-rub="#popup-rub"
                            data-link-eur="#popup-eur">
                            <div class="veb41-tariffs-curr-wrapper position-relative z-20">
                                <div class="veb41-tariffs-curr careerum-flex-fsst">
                                    <ul class="careerum-flex-fsfs">
                                        <li data-currency="eur">EUR</li>
                                        <li data-currency="rub" class="active">RUB</li>
                                    </ul>
                                    <div class="veb41-tariffs-notif careerum-flex-cc">
                                        <div class="veb41-tariffs-notif-icon">
                                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723134336723-hWN6k-Warn.svg"
                                                alt="">
                                        </div>
                                        <div class="veb41-tariffs-notif-content">
                                            <p>Оплата в российских рублях возможна только
                                                картой российского банка. В&nbsp;евро — картой
                                                зарубежного банка</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="veb41-tariffs__swicher-block">
                                    <div class="veb41-tariffs__swicher-top">
                                        <p class="veb41-tariffs__swicher-header">
                                            Посмотреть цены в
                                            <span>EUR</span>
                                        </p><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                            fill="none" class="veb41-tariffs__swicher-arrow">
                                            <path d="M7 9.5L12 14.5L17 9.5H7Z" fill="black"></path>
                                        </svg>
                                    </div>
                                    <div class="veb41-tariffs__swicher-bottom">
                                        <ul>
                                            <li data-currency="rub" class="active">
                                                RUB
                                            </li>
                                            <li data-currency="eur">
                                                EUR
                                            </li>
                                        </ul>
                                        <p>
                                            Обратите внимание,<br> что оплата в российских
                                            рублях
                                            возможна только<br> с карты
                                            российского банка. Оплата в евро — с карты зарубежного банка
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="careerum-flex-fsc position-relative z-10">
                                <p class="veb41-price-new">4 900 ₽</p>
                                <p class="veb41-price-old">14900 ₽</p>
                                <p class="veb41-price-percent">— 70%</p>
                            </div>
                            <a href="#popup" class="veb41-price-link btn-color-main-dark-orange">Купить курс</a>
                        </div>
                    </div>
                    <div>
                        <ul>
                            <li>Узнаете, что ждет мировой рынок труда<br> в 2022 году</li>
                            <li>Поймете, какие карьерные ошибки совершают люди<br> в кризис</li>
                        </ul>
                        <ul>
                            <li>Получите инструменты, чтобы начать действовать уже сейчас</li>
                            <li>Развеете топ-3 мифа, которые мешают вам делать карьеру сейчас</li>
                        </ul>
                    </div>
                </div>
            </div>`
	});

    blockManager.add('careerum-veb-rezult-2col-tablet', {
        label: 'По итогам вебинара - 2col (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
            <div class="careerum-veb-rezult-2col-tablet veb41-switch-currency">
                <div>
                    <div>
                        <h2>По итогам<br> вебинара вы</h2>
                        <a href="#">Зарегистрироваться</a>
                        <div class="veb41-price-wrapper" data-price-rub="4 900 ₽" data-price-eur="49 €"
                            data-price-rub-old="4 900 ₽" data-price-eur-old="149 €₽" data-link-rub="#popup-rub"
                            data-link-eur="#popup-eur">
                            <div class="veb41-tariffs-curr-wrapper position-relative z-20">
                                <div class="veb41-tariffs-curr careerum-flex-fsst">
                                    <ul class="careerum-flex-fsfs">
                                        <li data-currency="eur">EUR</li>
                                        <li data-currency="rub" class="active">RUB</li>
                                    </ul>
                                    <div class="veb41-tariffs-notif careerum-flex-cc">
                                        <div class="veb41-tariffs-notif-icon">
                                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723134336723-hWN6k-Warn.svg"
                                                alt="">
                                        </div>
                                        <div class="veb41-tariffs-notif-content">
                                            <p>Оплата в российских рублях возможна только
                                                картой российского банка. В&nbsp;евро — картой
                                                зарубежного банка</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="veb41-tariffs__swicher-block">
                                    <div class="veb41-tariffs__swicher-top">
                                        <p class="veb41-tariffs__swicher-header">
                                            Посмотреть цены в
                                            <span>EUR</span>
                                        </p><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                            fill="none" class="veb41-tariffs__swicher-arrow">
                                            <path d="M7 9.5L12 14.5L17 9.5H7Z" fill="black"></path>
                                        </svg>
                                    </div>
                                    <div class="veb41-tariffs__swicher-bottom">
                                        <ul>
                                            <li data-currency="rub" class="active">
                                                RUB
                                            </li>
                                            <li data-currency="eur">
                                                EUR
                                            </li>
                                        </ul>
                                        <p>
                                            Обратите внимание,<br> что оплата в российских
                                            рублях
                                            возможна только<br> с карты
                                            российского банка. Оплата в евро — с карты зарубежного банка
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="careerum-flex-fsc position-relative z-10">
                                <p class="veb41-price-new">4 900 ₽</p>
                                <p class="veb41-price-old">14900 ₽</p>
                                <p class="veb41-price-percent">— 70%</p>
                            </div>
                            <a href="#popup" class="veb41-price-link btn-color-main-dark-orange">Купить курс</a>
                        </div>
                    </div>
                    <div>
                        <ul>
                            <li>Узнаете, что ждет мировой рынок труда в 2022 году</li>
                            <li>Поймете, какие карьерные ошибки совершают люди<br> в кризис</li>
                        </ul>
                        <ul>
                            <li>Получите инстру-<br>менты, чтобы начать действовать уже сейчас</li>
                            <li>Развеете топ-3 мифа, которые мешают вам делать карьеру сейчас</li>
                        </ul>
                    </div>
                </div>
            </div>`
	});

    blockManager.add('careerum-veb-rezult-2col-mobile', {
        label: 'По итогам вебинара - 2col (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
            <div class="careerum-veb-rezult-2col-mobile veb41-switch-currency">
                <div>
                    <div class="position-relative">
                        <h2>Бонусные<br> материалы</h2>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1745252599136-0GrO1-Vect.svg" alt=""
                            class="position-absolute">
                    </div>
                    <div>
                        <ul>
                            <li>Узнаете, что ждет мировой рынок труда в 2022 году</li>
                            <li>Поймете, какие карьерные ошибки совершают люди<br> в кризис</li>
                        </ul>
                        <ul>
                            <li>Получите инстру-<br>менты, чтобы начать действовать уже сейчас</li>
                            <li>Развеете топ-3 мифа, которые мешают вам делать карьеру сейчас</li>
                        </ul>
                    </div>
                    <div class="veb41-price-wrapper" data-price-rub="4 900 ₽" data-price-eur="49 €"
                        data-price-rub-old="4 900 ₽" data-price-eur-old="149 €₽" data-link-rub="#popup-rub"
                        data-link-eur="#popup-eur">
                        <div class="veb41-tariffs-curr-wrapper position-relative z-20">
                            <div class="veb41-tariffs-curr careerum-flex-fsst">
                                <ul class="careerum-flex-fsfs">
                                    <li data-currency="eur">EUR</li>
                                    <li data-currency="rub" class="active">RUB</li>
                                </ul>
                                <div class="veb41-tariffs-notif careerum-flex-cc">
                                    <div class="veb41-tariffs-notif-icon">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723134336723-hWN6k-Warn.svg"
                                            alt="">
                                    </div>
                                    <div class="veb41-tariffs-notif-content">
                                        <p>Оплата в российских рублях возможна только
                                            картой российского банка. В&nbsp;евро — картой
                                            зарубежного банка</p>
                                    </div>
                                </div>
                            </div>
                            <div class="veb41-tariffs__swicher-block">
                                <div class="veb41-tariffs__swicher-top">
                                    <p class="veb41-tariffs__swicher-header">
                                        Посмотреть цены в
                                        <span>EUR</span>
                                    </p><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" class="veb41-tariffs__swicher-arrow">
                                        <path d="M7 9.5L12 14.5L17 9.5H7Z" fill="black"></path>
                                    </svg>
                                </div>
                                <div class="veb41-tariffs__swicher-bottom">
                                    <ul>
                                        <li data-currency="rub" class="active">
                                            RUB
                                        </li>
                                        <li data-currency="eur">
                                            EUR
                                        </li>
                                    </ul>
                                    <p>
                                        Обратите внимание,<br> что оплата в российских
                                        рублях
                                        возможна только<br> с карты
                                        российского банка. Оплата в евро — с карты зарубежного банка
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="careerum-flex-fsc position-relative z-10">
                            <p class="veb41-price-new">4 900 ₽</p>
                            <p class="veb41-price-old">14900 ₽</p>
                            <p class="veb41-price-percent">— 70%</p>
                        </div>
                        <a href="#popup" class="veb41-price-link btn-color-main-dark-orange">Купить курс</a>
                    </div>
                </div>
            </div>`
	});


    
    blockManager.add('careerum-veb-speakers', {
        label: 'Спикеры программы',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="careerum-veb-speakers">
        <div>
            <div>
                <div>
                    <h2>Создатели и спикеры программы</h2>
                </div>
            </div>
            <div>
                <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1657725551352.svg" alt="" class="prewarr-speakers"></div>
                <div class="speakers-slider">
                    <div class="speakers-slider-item">
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1657725610658.png" alt="">
                        </div>
                        <div>
                            <h4>Ольга Лермонтова</h4>
                            <p>Автор программы, спикер</p>
                            <p>Международный коуч ICF, CEO Careerum. 14+ лет успешной международной карьеры в 5 странах в компаниях Google, Microsoft. Степень MBA <br>от топовой бизнес-школы INSEAD</p>
                            <p>Италия</p>
                        </div>
                    </div>
                    <div class="speakers-slider-item">
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1657725647825.png" alt="">
                        </div>
                        <div>
                            <h4>Sophie Vurpillot</h4>
                            <p>Спикер</p>
                            <p>Международный рекрутер, ментор и коуч международных бизнес-школ, предпринимательница. Planet Expat, The H Factor</p>
                            <p>Испания</p>
                        </div>
                    </div>
                    <div class="speakers-slider-item">
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1657725676117.png" alt="">
                        </div>
                        <div>
                            <h4>Наталья Токарь</h4>
                            <p>Спикер</p>
                            <p>Эксперт по коммуникации в международной компании, ментор по коммуникациям в чикагском акселераторе для фондов Emerging Managers Incubator</p>
                            <p>США</p>
                        </div>
                    </div>
                    <div class="speakers-slider-item">
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1657725740423.png" alt="">
                        </div>
                        <div>
                            <h4>Montse Lorente</h4>
                            <p>Спикер</p>
                            <p>Международный карьерный консультант, жила и работала в Испании, Боливии, Чили. MBA бизнес-школы ESADE</p>
                            <p>Перу</p>
                        </div>
                    </div>
                </div>

                <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1657725774751.svg" alt="" class="nextarr-speakers"></div>
            </div>
        </div>
    </div>`
	});

    blockManager.add('careerum-veb-speakers-tablet', {
        label: 'Спикеры программы (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="careerum-veb-speakers-tablet">
        <div>
            <div>
                <div>
                    <h2>Создатели и спикеры<br> программы</h2>
                </div>
            </div>
            <div>
                <div>
                    <div class="speakers-slider-item">
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1657725808615.png" alt="">
                        </div>
                        <div>
                            <h4>Ольга Лермонтова</h4>
                            <p>Автор программы, спикер</p>
                            <p>Международный коуч<br> ICF, CEO Careerum. 14+ лет<br> успешной международной карьеры в 5 странах <br>в компаниях Google, Microsoft. Степень MBA <br>от бизнес-школы INSEAD</p>
                            <p>Италия</p>
                        </div>
                    </div>
                    <div class="speakers-slider-item">
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1657725834036.png" alt="">
                        </div>
                        <div>
                            <h4>Sophie Vurpillot</h4>
                            <p>Спикер</p>
                            <p>Международный<br> рекрутер, ментор и коуч международных бизнес-школ, предпринима-<br>тельница. Planet Expat, <br>The H Factor</p>
                            <p>Испания</p>
                        </div>
                    </div>
                    <div class="speakers-slider-item">
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1657725855376.png" alt="">
                        </div>
                        <div>
                            <h4>Наталья Токарь</h4>
                            <p>Спикер</p>
                            <p>Эксперт по коммуникации в международной компании, ментор по коммуникациям<br> в чикагском акселераторе для фондов Emerging Managers Incubator</p>
                            <p>США</p>
                        </div>
                    </div>
                    <div class="speakers-slider-item">
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1657725875152.png" alt="">
                        </div>
                        <div>
                            <h4>Montse Lorente</h4>
                            <p>Спикер</p>
                            <p>Международный<br> карьерный консультант,<br> жила и работала <br>в Испании, Боливии, Чили.<br> MBA бизнес-школы ESADE</p>
                            <p>Перу</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>`
	});

    blockManager.add('careerum-veb-speakers-mobile', {
        label: 'Спикеры программы (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="careerum-veb-speakers-mobile">
        <div>
            <div>
                <div>
                    <h2>Создатели и спикеры<br> программы</h2>
                </div>
            </div>
            <div>
                <div>
                    <div class="speakers-slider-item">
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1657725904672.png" alt="">
                        </div>
                        <div>
                            <h4>Ольга Лермонтова</h4>
                            <p>Автор программы, спикер</p>
                            <p>Международный коуч<br> ICF, CEO Careerum. 14+ лет<br> успешной международной карьеры в 5
                                странах <br>в компаниях Google, Microsoft. Степень MBA <br>от бизнес-школы INSEAD</p>
                            <p>Италия</p>
                        </div>
                    </div>
                    <div class="speakers-slider-item">
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1657725926325.png" alt="">
                        </div>
                        <div>
                            <h4>Sophie Vurpillot</h4>
                            <p>Спикер</p>
                            <p>Международный<br> рекрутер, ментор и коуч международных бизнес-школ,
                                предпринима-<br>тельница. Planet Expat, <br>The H Factor</p>
                            <p>Испания</p>
                        </div>
                    </div>
                    <div class="speakers-slider-item">
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1657725943559.png" alt="">
                        </div>
                        <div>
                            <h4>Наталья Токарь</h4>
                            <p>Спикер</p>
                            <p>Эксперт по коммуникации в международной компании, ментор по коммуникациям<br> в чикагском
                                акселераторе для фондов Emerging Managers Incubator</p>
                            <p>США</p>
                        </div>
                    </div>
                    <div class="speakers-slider-item">
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1657725964516.png" alt="">
                        </div>
                        <div>
                            <h4>Montse Lorente</h4>
                            <p>Спикер</p>
                            <p>Международный<br> карьерный консультант,<br> жила и работала <br>в Испании, Боливии,
                                Чили.<br> MBA бизнес-школы ESADE</p>
                            <p>Перу</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>`
	});


    
    blockManager.add('careerum-veb-tariffs', {
        label: 'Тарифы вебинара',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div>
        <div class="careerum-veb-tariffs" hide-by-geo="not_russia">
            <div>
                <div>
                    <div>
                        <h2>Сделайте шаг к осознанному поиску работы за рубежом</h2>
                    </div>
                    <div>
                        <div class="careerum-new-geochanger">
                            <div>
                                <div>                                
                                    <label class="geo-new-label">
                                        <p>RUB</p>
                                        <input type="checkbox">
                                        <div class="geo-new-changer">
                                            <p data-currency="Other" class="geo-selector">EUR</p>
                                        </div>
                                    </label>                                
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <div>
                        <h3>Пройти обучающую программу</h3>
                        <ul>
                            <li class="active">Запись занятий</li>
                            <li class="active">Шаблоны для резюме</li>
                            <li class="unactive">Помощь CV-специалиста</li>
                            <li class="unactive">Нетворк на платформе</li>
                            <li class="unactive">Поддержка коуча</li>
                            <li class="unactive">15 обучающих программ</li>
                        </ul>
                        <div>
                            <p>9 900 ₽</p>
                        </div>
                        <a href="#">Купить курс</a>
                    </div>
                    <div class="best-offer">
                        <h3>Вступить <br>в Careerum.Club <br>и получить больше</h3>
                        <ul>
                            <li class="active">Запись занятий</li>
                            <li class="active">Шаблоны для резюме</li>
                            <li class="active">Помощь CV-специалиста</li>
                            <li class="active">Нетворк на платформе</li>
                            <li class="active">Поддержка коуча</li>
                            <li class="active">15 обучающих программ</li>
                        </ul>
                        <div>
                            <p>от 8 900 ₽</p>
                        </div>
                        <a href="#">Выбрать тариф</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="careerum-veb-tariffs" hide-by-geo="russia">
            <div>
                <div>
                    <div>
                        <h2>Сделайте шаг к осознанному поиску работы за рубежом</h2>
                    </div>
                    <div>
                        <div class="careerum-new-geochanger">
                            <div>
                                <div>                                
                                    <label class="geo-new-label">
                                        <p>EUR</p>
                                        <input type="checkbox">
                                        <div class="geo-new-changer">
                                            <p data-currency="Russia" class="geo-selector">RUB</p>
                                        </div>
                                    </label>                                
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <div>
                        <h3>Пройти обучающую программу</h3>
                        <ul>
                            <li class="active">Запись занятий</li>
                            <li class="active">Шаблоны для резюме</li>
                            <li class="unactive">Помощь CV-специалиста</li>
                            <li class="unactive">Нетворк на платформе</li>
                            <li class="unactive">Поддержка коуча</li>
                            <li class="unactive">15 обучающих программ</li>
                        </ul>
                        <div>
                            <p>9 900 ₽</p>
                        </div>
                        <a href="#">Купить курс</a>
                    </div>
                    <div class="best-offer">
                        <h3>Вступить <br>в Careerum.Club <br>и получить больше</h3>
                        <ul>
                            <li class="active">Запись занятий</li>
                            <li class="active">Шаблоны для резюме</li>
                            <li class="active">Помощь CV-специалиста</li>
                            <li class="active">Нетворк на платформе</li>
                            <li class="active">Поддержка коуча</li>
                            <li class="active">15 обучающих программ</li>
                        </ul>
                        <div>
                            <p>от 8 900 ₽</p>
                        </div>
                        <a href="#">Выбрать тариф</a>
                    </div>
                </div>
            </div>
        </div>
    </div>`
	});

    blockManager.add('careerum-veb-tariffs-tablet', {
        label: 'Тарифы вебинара (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div>
        <div class="careerum-veb-tariffs-tablet" hide-by-geo="not_russia">
            <div>
                <div>
                    <div>
                        <h2>Сделайте шаг<br> к осознанному поиску работы</h2>
                    </div>
                    <div>
                        <div class="careerum-new-geochanger">
                            <div>
                                <div>                                
                                    <label class="geo-new-label">
                                        <p>RUB</p>
                                        <input type="checkbox">
                                        <div class="geo-new-changer">
                                            <p data-currency="Other" class="geo-selector">EUR</p>
                                        </div>
                                    </label>                                
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <div>
                        <h3>Пройти обучающую программу</h3>
                        <ul>
                            <li class="active">Запись занятий</li>
                            <li class="active">Шаблоны для резюме</li>
                            <li class="unactive">Помощь CV-специалиста</li>
                            <li class="unactive">Нетворк на платформе</li>
                            <li class="unactive">Поддержка коуча</li>
                            <li class="unactive">15 обучающих программ</li>
                        </ul>
                        <div>
                            <p>9 900 ₽</p>
                        </div>
                        <a href="#">Купить курс</a>
                    </div>
                    <div class="best-offer">
                        <h3>Вступить <br>в Careerum.Club <br>и получить больше</h3>
                        <ul>
                            <li class="active">Запись занятий</li>
                            <li class="active">Шаблоны для резюме</li>
                            <li class="active">Помощь CV-специалиста</li>
                            <li class="active">Нетворк на платформе</li>
                            <li class="active">Поддержка коуча</li>
                            <li class="active">15 обучающих программ</li>
                        </ul>
                        <div>
                            <p>от 8 900 ₽</p>
                        </div>
                        <a href="#">Выбрать тариф</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="careerum-veb-tariffs-tablet" hide-by-geo="russia">
            <div>
                <div>
                    <div>
                        <h2>Сделайте шаг к осознанному поиску работы</h2>
                    </div>
                    <div>
                        <div class="careerum-new-geochanger">
                            <div>
                                <div>                                
                                    <label class="geo-new-label">
                                        <p>EUR</p>
                                        <input type="checkbox">
                                        <div class="geo-new-changer">
                                            <p data-currency="Russia" class="geo-selector">RUB</p>
                                        </div>
                                    </label>                                
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <div>
                        <h3>Пройти обучающую программу</h3>
                        <ul>
                            <li class="active">Запись занятий</li>
                            <li class="active">Шаблоны для резюме</li>
                            <li class="unactive">Помощь CV-специалиста</li>
                            <li class="unactive">Нетворк на платформе</li>
                            <li class="unactive">Поддержка коуча</li>
                            <li class="unactive">15 обучающих программ</li>
                        </ul>
                        <div>
                            <p>9 900 ₽</p>
                        </div>
                        <a href="#">Купить курс</a>
                    </div>
                    <div class="best-offer">
                        <h3>Вступить <br>в Careerum.Club <br>и получить больше</h3>
                        <ul>
                            <li class="active">Запись занятий</li>
                            <li class="active">Шаблоны для резюме</li>
                            <li class="active">Помощь CV-специалиста</li>
                            <li class="active">Нетворк на платформе</li>
                            <li class="active">Поддержка коуча</li>
                            <li class="active">15 обучающих программ</li>
                        </ul>
                        <div>
                            <p>от 8 900 ₽</p>
                        </div>
                        <a href="#">Выбрать тариф</a>
                    </div>
                </div>
            </div>
        </div>
    </div>`
	});

    blockManager.add('careerum-veb-tariffs-mobile', {
        label: 'Тарифы вебинара (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div>
        <div class="careerum-veb-tariffs-mobile" hide-by-geo="not_russia">
            <div>
                <div>
                    <div>
                        <h2>Сделайте шаг<br> к осознанному поиску работы</h2>
                    </div>
                </div>
                <div>
                    <div>
                        <div>
                            <h3>Пройти курс<br> «Продающее<br> резюме»</h3>
                            <ul>
                                <li class="active">Запись занятий</li>
                                <li class="active">Шаблоны для резюме</li>
                                <li class="unactive">Помощь CV-специалиста</li>
                                <li class="unactive">Нетворк на платформе</li>
                                <li class="unactive">Поддержка коуча</li>
                                <li class="unactive">15 обучающих программ</li>
                            </ul>
                            <div>
                                <p>9 900 ₽</p>
                            </div>
                            <a href="#">Купить курс</a>
                        </div>
                        <div class="best-offer">
                            <h3>Вступить <br>в Careerum.Club <br>и получить больше</h3>
                            <ul>
                                <li class="active">Запись занятий</li>
                                <li class="active">Шаблоны для резюме</li>
                                <li class="active">Помощь CV-специалиста</li>
                                <li class="active">Нетворк на платформе</li>
                                <li class="active">Поддержка коуча</li>
                                <li class="active">15 обучающих программ</li>
                            </ul>
                            <div>
                                <p>от 8 900 ₽</p>
                            </div>
                            <a href="#">Выбрать тариф</a>
                        </div>
                    </div>
                </div>
                <div>
                    <div class="careerum-new-geochanger">
                        <div>
                            <div>
                                <label class="geo-new-label">
                                    <p>RUB</p>
                                    <input type="checkbox">
                                    <div class="geo-new-changer">
                                        <p data-currency="Other" class="geo-selector">EUR</p>
                                    </div>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="careerum-veb-tariffs-mobile" hide-by-geo="russia">
            <div>
                <div>
                    <div>
                        <h2>Сделайте шаг<br> к осознанному поиску работы</h2>
                    </div>
                </div>
                <div>
                    <div>
                        <div>
                            <h3>Пройти курс<br> «Продающее<br> резюме»</h3>
                            <ul>
                                <li class="active">Запись занятий</li>
                                <li class="active">Шаблоны для резюме</li>
                                <li class="unactive">Помощь CV-специалиста</li>
                                <li class="unactive">Нетворк на платформе</li>
                                <li class="unactive">Поддержка коуча</li>
                                <li class="unactive">15 обучающих программ</li>
                            </ul>
                            <div>
                                <p>9 900 ₽</p>
                            </div>
                            <a href="#">Купить курс</a>
                        </div>
                        <div class="best-offer">
                            <h3>Вступить <br>в Careerum.Club <br>и получить больше</h3>
                            <ul>
                                <li class="active">Запись занятий</li>
                                <li class="active">Шаблоны для резюме</li>
                                <li class="active">Помощь CV-специалиста</li>
                                <li class="active">Нетворк на платформе</li>
                                <li class="active">Поддержка коуча</li>
                                <li class="active">15 обучающих программ</li>
                            </ul>
                            <div>
                                <p>от 8 900 ₽</p>
                            </div>
                            <a href="#">Выбрать тариф</a>
                        </div>
                    </div>
                </div>
                <div>
                    <div class="careerum-new-geochanger">
                        <div>
                            <div>
                                <label class="geo-new-label">
                                    <p>EUR</p>
                                    <input type="checkbox">
                                    <div class="geo-new-changer">
                                        <p data-currency="Russia" class="geo-selector">RUB</p>
                                    </div>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>`
	});


    
    blockManager.add('careerum-veb-find-work', {
        label: 'Программа по подписке',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="careerum-veb-find-work">
        <div>
            <div>
                <div>
                    <div>
                        <div>
                            <p>Программа</p>
                            <p>11 часов 49 мин.</p>
                            <p>Доступ по подписке в Careerum.Club</p>
                        </div>
                        <h1>«Real Me» — <br>найти себя в работе<br> и жизни</h1>
                        <div class="careerum-veb-find-work-tale">
                            <div>
                                <div>
                                    <p>Только 2 дня скидка 60%</p>
                                </div>
                                <div>
                                    <p>Welcome-бонус<br> от Careerum</p>
                                </div>
                            </div>
                            <div>
                                <div>
                                    <p>12 500 ₽</p>
                                </div>
                                <div>
                                    <p>4 990 ₽ </p>
                                </div>
                            </div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1707513460927.svg" alt="">
                        </div>
                    </div>
                    <div>
                        <h3>Что входит в обучение</h3>
                        <div class="careerum-session-tab-item">
                            <div>  
                                <p>Сессия 1</p>
                                <p>3 урока</p>
                                <p>1 час 1 мин.</p>
                            </div>  
                            <div>
                                <h3>Ваши ограничители</h3>
                                <p>Определите, какие ограничивающие<br> убеждения мешают вашему развитию, и<br> замените их на полезные, используя алгоритм</p>
                            </div>
                        </div>  
                        <div class="careerum-session-tab-item">
                            <div>  
                                <p>Сессия 2</p>
                                <p>6 уроков</p>
                                <p>2 часа 17 мин.</p>
                            </div>  
                            <div>
                                <h3>Ваши таланты<br> и ценности</h3>
                                <p>Узнаете, как открыть в себе минимум 7 талантов,<br> которые помогут вам реализоваться в карьере<br> и двигаться вперед</p>
                            </div>
                        </div>  
                        <div class="careerum-session-tab-item">
                            <div>  
                                <p>Сессия 3</p>
                                <p>3 урока</p>
                                <p>2 часа 17 мин.</p>
                            </div>  
                            <div>
                                <h3>Ваши<br> мотиваторы</h3>
                                <p>Найдете свои источники энергии, научитесь<br> ими пользоваться и избавитесь от факторов,<br> которые ежедневно забирают ваши силы</p>
                            </div>
                        </div>  
                        <div class="careerum-session-tab-item">
                            <div>  
                                <p>Сессия 4</p>
                                <p>5 уроков</p>
                                <p>2 часа 40 мин.</p>
                            </div>  
                            <div>
                                <h3>Ваши<br> возможности</h3>
                                <p>Решите, нужно ли вам менять компанию,<br> профессию или сферу прямо сейчас, а также <br>проанализируете международный рынок </p>
                            </div>
                        </div>  
                        <div class="careerum-session-tab-item">
                            <div>  
                                <p>Сессия 5</p>
                                <p>5 уроков</p>
                                <p>1 час 59 мин.</p>
                            </div>  
                            <div>
                                <h3>Ваш карьерный план</h3>
                                <p>Сформулируете свою главную карьерную цель,<br> проложите путь к ней и выясните, какие навыки вам<br> понадобятся, чтобы прийти к этой цели</p>
                            </div>
                        </div>  
                        <div class="careerum-session-tab-item">
                            <div>  
                                <p>Сессия 6</p>
                                <p>2 урока</p>
                                <p>1 час 35 мин.</p>
                            </div>  
                            <div>
                                <h3>Ответы<br> на вопросы </h3>
                                <p>Узнаете ответы на все самые популярные<br> и важные вопросы по курсу и проанализируете<br> свои дальнейшие шаги</p>
                            </div>
                        </div>  
                        <div class="careerum-form-tab-item">
                            <div>
                                <h3>Узнайте, как сделать<br> правильный<br> карьерный выбор </h3>
                                <p>Оставьте почту и получите<br> бесплатный демоурок из программы<br> «Real Me»</p>
                            </div>
                            <div class="careerum-registration-form">
                                <form class="deva-form getcourse-email-signup" name="devaRegistrationForm" data-gjs-type="deva-registration-form">
                                    <input name="email" type="email" value="" required>
                                    <span>Почта</span>
                                    <div>
                                        <input type="checkbox" name="" id="carerum-form-agr">
                                        <label data-toggle-checkbox="true"></label>
                                        <p>Я даю согласие на обработку моих персональных данных в соотвествии <br>с <a href="#">Политикой конфиденциальности</a>
                                    </div>
                                    <a class="submit-btn">Получить демоурок</a>
                                </form>
                            </div>
                        </div>
                        <div class="careerum-form-success-tab-item">
                            <div>
                                <h3>Письмо с ссылкой для скачивания<br> уже у вас на почте</h3>
                            </div>
                            
                        </div>
                        <div class="careerum-course-button-tab-item">
                            <div>  
                                <p>Курс</p>
                                <p>3 часа 39 мин.</p>
                            </div>
                            <div>
                                <h3>«Эффективное интервью»</h3>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1686766281895.svg" alt="">
                                <div>
                                    <p class="careerum-course-button-tab-old-price">9 900 ₽</p>
                                    <p class="careerum-course-button-tab-price">2 450 ₽</p>
                                    <a href="#buy" class="btn-color-main-dark-orange">Купить курс</a>
                                </div>
                            </div>
                        </div>  
                    </div>
                </div>
                <div>
                    <div class="careerum-scroll-from-top">
                        <p>Найдете свои таланты и сильные стороны <br>и сможете опираться на них, чтобы построить успешную карьеру «по любви»</p>
                        <a href="#">Пройти курс</a>
                    </div>
                </div>
            </div>
        </div>
    </div>`
	});

    blockManager.add('careerum-veb-find-work-tablet', {
        label: 'Программа по подписке (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="careerum-veb-find-work-tablet">
        <div>
            <div>
                <div>
                    <div>
                        <div>
                            <p>Программа</p>
                            <p>11 часов 49 мин.</p>
                            <p>Доступ по подписке в Careerum.Club</p>
                        </div>
                        <h1>«Real Me» — <br>найти себя в работе<br> и жизни</h1>
                        <div class="careerum-veb-find-work-tale">
                            <div>
                                <div>
                                    <p>Только 2 дня скидка 60%</p>
                                </div>
                                <div>
                                    <p>Welcome-бонус<br> от Careerum</p>
                                </div>
                            </div>
                            <div>
                                <div>
                                    <p>12 500 ₽</p>
                                </div>
                                <div>
                                    <p>4 990 ₽ </p>
                                </div>
                            </div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1707514493502.svg" alt="">
                        </div>
                    </div>
                    <div>
                        <h3>Что входит в обучение</h3>
                        <div class="careerum-session-tab-item-tablet">
                            <div>  
                                <p>Сессия 1</p>
                                <p>3 урока</p>
                                <p>1 час 1 мин.</p>
                            </div>  
                            <div>
                                <h3>Ваши ограничители</h3>
                                <p>Определите, какие ограничивающие<br> убеждения мешают вашему развитию, и<br> замените их на полезные, используя алгоритм</p>
                            </div>
                        </div>  
                        <div class="careerum-session-tab-item-tablet">
                            <div>  
                                <p>Сессия 2</p>
                                <p>6 уроков</p>
                                <p>2 часа 17 мин.</p>
                            </div>  
                            <div>
                                <h3>Ваши таланты<br> и ценности</h3>
                                <p>Узнаете, как открыть в себе минимум 7 талантов,<br> которые помогут вам реализоваться в карьере<br> и двигаться вперед</p>
                            </div>
                        </div>  
                        <div class="careerum-session-tab-item-tablet">
                            <div>  
                                <p>Сессия 3</p>
                                <p>3 урока</p>
                                <p>2 часа 17 мин.</p>
                            </div>  
                            <div>
                                <h3>Ваши<br> мотиваторы</h3>
                                <p>Найдете свои источники энергии, научитесь<br> ими пользоваться и избавитесь от факторов,<br> которые ежедневно забирают ваши силы</p>
                            </div>
                        </div>  
                        <div class="careerum-session-tab-item-tablet">
                            <div>  
                                <p>Сессия 4</p>
                                <p>5 уроков</p>
                                <p>2 часа 40 мин.</p>
                            </div>  
                            <div>
                                <h3>Ваши<br> возможности</h3>
                                <p>Решите, нужно ли вам менять компанию,<br> профессию или сферу прямо сейчас, а также <br>проанализируете международный рынок </p>
                            </div>
                        </div>  
                        <div class="careerum-session-tab-item-tablet">
                            <div>  
                                <p>Сессия 5</p>
                                <p>5 уроков</p>
                                <p>1 час 59 мин.</p>
                            </div>  
                            <div>
                                <h3>Ваш карьерный план</h3>
                                <p>Сформулируете свою главную карьерную цель,<br> проложите путь к ней и выясните, какие навыки вам<br> понадобятся, чтобы прийти к этой цели</p>
                            </div>
                        </div>  
                        <div class="careerum-session-tab-item-tablet">
                            <div>  
                                <p>Сессия 6</p>
                                <p>2 урока</p>
                                <p>1 час 35 мин.</p>
                            </div>  
                            <div>
                                <h3>Ответы<br> на вопросы </h3>
                                <p>Узнаете ответы на все самые популярные<br> и важные вопросы по курсу и проанализируете<br> свои дальнейшие шаги</p>
                            </div>
                        </div>  
                        <div class="careerum-form-tab-item-tablet">
                            <div>
                                <h3>Узнайте, как сделать правильный<br> карьерный выбор </h3>
                                <p>Оставьте почту и получите<br> бесплатный демоурок<br> из программы «Real Me»</p>
                            </div>
                            <div class="careerum-registration-form-tablet">
                                <form class="deva-form getcourse-email-signup" name="devaRegistrationForm" data-gjs-type="deva-registration-form">
                                    <input name="email" type="email" value="" required>
                                    <span>Почта</span>
                                    <a class="submit-btn">Получить демоурок</a>
                                    <div>
                                        <input type="checkbox" name="" id="carerum-form-agr-tablet">
                                        <label data-toggle-checkbox="true"></label>
                                        <p>Я даю согласие на обработку моих персональных<br> данных в соотвествии с <a href="#">Политикой конфиденциальности</a>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div class="careerum-form-success-tab-item-tablet">
                            <div>
                                <h3>Письмо с ссылкой<br> для скачивания<br> уже у вас на почте</h3>
                            </div>
                            
                        </div>
                        <div class="careerum-course-button-tab-item-tablet">
                            <div>  
                                <p>Курс</p>
                                <p>3 часа 39 мин.</p>
                            </div>
                            <div>
                                <h3>«Эффективное <br>интервью»</h3>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1686766348451.svg" alt="">
                                <div>
                                    <p class="careerum-course-button-tab-old-price">9 900 ₽</p>
                                    <p class="careerum-course-button-tab-price">2 450 ₽</p>
                                    <a href="#buy" class="btn-color-main-dark-orange">Купить курс</a>
                                </div>
                            </div>
                        </div>  
                    </div>
                </div>
                <div>
                    <div class="careerum-scroll-from-top">
                        <p>Найдете свои таланты и сможете опираться на них, чтобы построить успешную карьеру «по любви»</p>
                        <a href="#">Вступить в клуб</a>
                    </div>
                </div>
            </div>
        </div>
    </div>`
	});

    blockManager.add('careerum-veb-find-work-mobile', {
        label: 'Программа по подписке (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="careerum-veb-find-work-mobile">
        <div>
            <div>
                <div>
                    <p>Программа</p>
                    <p>11 часов 49 мин.</p>
                </div>
                <h2>«Real Me» — <br>найти себя<br> в работе и жизни</h2>
                <div class="careerum-veb-find-work-tale">
                    <div>
                        <div>
                            <p>Только 2 дня скидка 60%</p>
                        </div>
                        <div>
                            <p>Welcome-бонус от Careerum</p>
                        </div>
                    </div>
                    <div>
                        <div>
                            <p>12 500 ₽</p>
                        </div>
                        <div>
                            <p>4 990 ₽ </p>
                        </div>
                    </div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1707514856347.svg" alt="">
                </div>
                <ul>
                    <li>Найдете свои таланты и сильные стороны и узнаете, как именно вам построить успешную карьеру «по любви»</li>
                    <li>Программа доступна <br>по подписке Careerum.Club </li>
                </ul>
            </div>
            <div>
                <div class="careerum-scroll-from-top">
                    <a href="#">Вступить в Careerum.Club и получить программу</a>
                </div>
            </div>
            <div>
                <h3>Что входит в обучение</h3>
                <div class="careerum-session-tab-item-mobile">
                    <div>
                        <p>Сессия 1</p>
                        <p>3 урока</p>
                        <p>1 час 1 мин.</p>
                    </div>
                    <div>
                        <h3>Ваши ограничители</h3>
                        <p>Определите, какие убеждения мешают вашему профессиональному развитию, и замените их на полезные, используя алгоритм</p>
                    </div>
                </div>
                <div class="careerum-session-tab-item-mobile">
                    <div>
                        <p>Сессия 2</p>
                        <p>6 уроков</p>
                        <p>2 часа 17 мин.</p>
                    </div>
                    <div>
                        <h3>Ваши таланты<br> и ценности</h3>
                        <p>Узнаете, как открыть в себе минимум 7 талантов, которые помогут вам реализоваться в карьере <br>и заставят вас двигаться дальше</p>
                    </div>
                </div>
                <div class="careerum-session-tab-item-mobile">
                    <div>
                        <p>Сессия 3</p>
                        <p>3 урока</p>
                        <p>2 часа 17 мин.</p>
                    </div>
                    <div>
                        <h3>Ваши мотиваторы</h3>
                        <p>Найдете свои источники энергии, научитесь ими пользоваться и избавитесь от факторов, которые ежедневно забирают ваши силы</p>
                    </div>
                </div>
                <div class="careerum-form-tab-item-mobile">
                    <div>
                        <h3>Поиск работы может стать утомительным квестом </h3>
                        <p>Оставьте почту и получите<br> бесплатный демоурок из программы «Real Me»</p>
                    </div>
                    <div class="careerum-registration-form-mobile">
                        <form class="deva-form getcourse-email-signup" name="devaRegistrationForm" data-gjs-type="deva-registration-form">
                            <input name="email" type="email" value="" required>
                            <span>Почта</span>
                            <div>
                                <input type="checkbox" name="" id="carerum-form-agr-mobile">
                                <label data-toggle-checkbox="true"></label>
                                <p>Я даю согласие на обработку моих персональных данных в соотвествии<br> с <a href="#">Политикой конфиденциальности</a>
                            </div>
                            <a class="submit-btn">Получить демоурок</a>
                        </form>
                    </div>
                </div>
                <div class="careerum-form-success-tab-item-mobile">
                    <div>
                        <h3>Письмо с ссылкой<br> для скачивания<br> уже у вас на почте</h3>
                    </div>

                </div>
                <div class="careerum-session-tab-item-mobile">
                    <div>
                        <p>Сессия 4</p>
                        <p>5 уроков</p>
                        <p>2 часа 40 мин.</p>
                    </div>
                    <div>
                        <h3>Ваши возможности</h3>
                        <p>Решите, нужно ли вам менять компанию, профессию или сферу прямо сейчас, а также проанализируете международный рынок </p>
                    </div>
                </div>
                <div class="careerum-session-tab-item-mobile">
                    <div>
                        <p>Сессия 5</p>
                        <p>5 уроков</p>
                        <p>1 час 59 мин.</p>
                    </div>
                    <div>
                        <h3>Ваш карьерный план</h3>
                        <p>Сформулируете свою главную карьерную цель, проложите путь <br>к ней и выясните, какие навыки вам понадобятся, чтобы прийти к этой цели</p>
                    </div>
                </div>
                <div class="careerum-session-tab-item-mobile">
                    <div>
                        <p>Сессия 6</p>
                        <p>2 урока</p>
                        <p>1 час 35 мин.</p>
                    </div>
                    <div>
                        <h3>Ответы на вопросы </h3>
                        <p>Узнаете ответы на все самые популярные и важные вопросы <br>по курсу, проанализируете свои дальнейшие шаги</p>
                    </div>
                </div>
                <div class="careerum-course-button-tab-item-mobile">
                    <div>  
                        <p>Курс</p>
                        <p>3 часа 39 мин.</p>
                    </div>
                    <div>
                        <h3>«Эффективное <br>интервью»</h3>
                        <div>
                            <p class="careerum-course-button-tab-old-price">9 900 ₽</p>
                            <p class="careerum-course-button-tab-price">2 450 ₽</p>
                            <a href="#buy" class="btn-color-main-dark-orange">Купить курс</a>
                        </div>
                    </div>
                </div>  
            </div>
        </div>
    </div>`
	});



    
    
    blockManager.add('careerum-veb-rezults', {
        label: 'Вебинар - отзывы',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="careerum-veb-results veb41-switch-currency">
        <div>
            <div>
                <div>
                    <h2>8 238 человек уже посмотрели<br> программу «Real Me».<br> Вот что они говорят</h2>
                </div>
            </div>
            <div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1657725095366.svg" alt="" class="prewarr-veb-res">
                </div>
                <div class="veb-results-slider">
                    <div class="veb-results-slider-item">
                        <div>
                            <div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1657610293991.png" alt="">
                                    <a href="#"></a>
                                </div>
                                <div>
                                    <h4>Мария<br> Михайлова</h4>
                                    <p>Старший консультант, Норвегия</p>
                                </div>
                            </div>
                            <div>
                                <p>#повышение<br>#поискработы</p>
                            </div>
                        </div>
                        <div>
                            <p>Курс очень классный <br>и просто must have для всех! Помог структурировать, что <br>я на самом деле люблю делать, что для меня важно, какого типа компанию я хочу найти <br>и с каким руководителем работать. В итоге я определилась со сферой<br> и получила оффер в желаемой компании с потенциалом для развития и повышением зарплаты на 20%!</p>
                        </div>
                    </div>
                    <div class="veb-results-slider-item">
                        <div>
                            <div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1657610263700.png" alt="">
                                    <a href="#"></a>
                                </div>
                                <div>
                                    <h4>Екатерина<br>Комисарова</h4>
                                    <p>Научный сотрудник, Россия</p>
                                </div>
                            </div>
                            <div>
                                <p>#поискработы<br>#сменасферы</p>
                            </div>
                        </div>
                        <div>
                            <p>Изначально я пришла в клуб ради курса Real Me, потому <br>что хотела сформулировать четкую цель в моей карьерной стратегии (хотела сменить сферу и страну), что особенно сложно после выгорания. <br>Мне понравились и глубина проработки, и сложность (иногда приходилось бороться <br>с собой), и инсайты, родившиеся во взаимодействии <br>с напарниками.</p>
                        </div>
                    </div>
                    <div class="veb-results-slider-item">
                        <div>
                            <div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1657610222039.png" alt="">
                                    <a href="#"></a>
                                </div>
                                <div>
                                    <h4>Елена<br> Луценко</h4>
                                    <p>HR-менеджер,<br> Россия</p>
                                </div>
                            </div>
                            <div>
                                <p>#поискработы<br>#работазарубежом</p>
                            </div>
                        </div>
                        <div>
                            <p>Самой ценной в курсе для меня стала возможность узнать и понять себя лучше благодаря последовательной проработке заданий в группе. А еще — мотивирующая и поддержи-вающая среда. После курса<br> я обрела уверенность в том, <br>что двигаюсь в нужном мне направлении, и продумала, <br>как я могу влиять на развитие карьеры.</p>
                        </div>
                    </div>
                    <div class="veb-results-slider-item">
                        <div>
                            <div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1657610172771.png" alt="">
                                    <a href="#"></a>
                                </div>
                                <div>
                                    <h4>Кристина <br>Хейс</h4>
                                    <p>Customer success <br>manager, США</p>
                                </div>
                            </div>
                            <div>
                                <p>#повышение<br>#поискработы</p>
                            </div>
                        </div>
                        <div>
                            <p>Я пришла на курс, чтобы понять, подходит ли мне профессия проджект-менеджера,<br>и определить, какие навыки <br>у меня есть для этой роли.<br> На курсе я выявила свои сильные стороны и поменяла фокус с поиска работы в project management на customer success management. В итоге<br> я получила оффер от компании,<br> в которой все мои «хочу» и «могу» полностью совпали. </p>
                        </div>
                    </div>
                    <div class="veb-results-slider-item">
                        <div>
                            <div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1657610145918.png" alt="">
                                    <a href="#"></a>
                                </div>
                                <div>
                                    <h4>Наталья <br>Калицева</h4>
                                    <p>Бренд-менеджер,<br> бизнес-тренер, Россия</p>
                                </div>
                            </div>
                            <div>
                                <p>#поискработы<br>#выходиздекрета</p>
                            </div>
                        </div>
                        <div>
                            <p>Я хотела определить, что делать после декрета и стоит<br> ли менять работу. На курсе осознала, что нынешняя работа полностью мне откликается, <br>а единственный минус — нет возможности работать удаленно. Проштудировав материалы о том, как преподносить идеи руководителю, я предложила <br>ему план моей удаленной работы. План согласовали!</p>
                        </div>
                    </div>
                    <div class="veb-results-slider-item">
                        <div>
                            <div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1657610128842.png" alt="">
                                    <a href="#"></a>
                                </div>
                                <div>
                                    <h4>Олеся<br> Барлыбаева</h4>
                                    <p>Аккаунт-менеджер, Россия</p>
                                </div>
                            </div>
                            <div>
                                <p>#повышение<br>#поискработы</p>
                            </div>
                        </div>
                        <div>
                            <p>По итогу курса я порефлексировала и поняла,<br> что мне нравится строить процессы, общаться с клиентами и на основе данных дорабатывать продукт. Я нашла интересную вакансию в сервисе онлайн-доставки и после прохождения двух этапов интервью поняла, что это то место, где я по-настоящему хотела бы работать.</p>
                        </div>
                    </div>
                    <div class="veb-results-slider-item">
                        <div>
                            <div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1657610104382.png" alt="">
                                    <a href="#"></a>
                                </div>
                                <div>
                                    <h4>Екатерина Асекритова</h4>
                                    <p>Product launch manager, Россия</p>
                                </div>
                            </div>
                            <div>
                                <p>#повышение<br>#поискработы</p>
                            </div>
                        </div>
                        <div>
                            <p>Самое ценное на курсе — клуб <br>и группа единомышленников. Именно в групповой работе <br>я нашла то, что искала. После курса я обрела уверенность <br>в собственных силах, а мой поиск работы стал гораздо эффективнее. Я перестала судорожно изучать все подряд, <br>а начала сразу отметать неподходящие варианты.</p>
                        </div>
                    </div>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1657609976894.svg" alt="" class="nextarr-veb-res">
                </div>
            </div>
            <div class="veb41-price-wrapper" data-price-rub="4 900 ₽" data-price-eur="49 €" data-price-rub-old="4 900 ₽"
                data-price-eur-old="149 €₽" data-link-rub="#popup-rub" data-link-eur="#popup-eur">
                <div class="veb41-tariffs-curr-wrapper position-relative z-20">
                    <div class="veb41-tariffs-curr careerum-flex-fsst">
                        <ul class="careerum-flex-fsfs">
                            <li data-currency="eur">EUR</li>
                            <li data-currency="rub" class="active">RUB</li>
                        </ul>
                        <div class="veb41-tariffs-notif careerum-flex-cc">
                            <div class="veb41-tariffs-notif-icon">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723134336723-hWN6k-Warn.svg"
                                    alt="">
                            </div>
                            <div class="veb41-tariffs-notif-content">
                                <p>Оплата в российских рублях возможна только
                                    картой российского банка. В&nbsp;евро — картой
                                    зарубежного банка</p>
                            </div>
                        </div>
                    </div>
                    <div class="veb41-tariffs__swicher-block">
                        <div class="veb41-tariffs__swicher-top">
                            <p class="veb41-tariffs__swicher-header">
                                Посмотреть цены в
                                <span>EUR</span>
                            </p><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" class="veb41-tariffs__swicher-arrow">
                                <path d="M7 9.5L12 14.5L17 9.5H7Z" fill="black"></path>
                            </svg>
                        </div>
                        <div class="veb41-tariffs__swicher-bottom">
                            <ul>
                                <li data-currency="rub" class="active">
                                    RUB
                                </li>
                                <li data-currency="eur">
                                    EUR
                                </li>
                            </ul>
                            <p>
                                Обратите внимание,<br> что оплата в российских
                                рублях
                                возможна только<br> с карты
                                российского банка. Оплата в евро — с карты зарубежного банка
                            </p>
                        </div>
                    </div>
                </div>
                <div class="careerum-flex-fsc position-relative z-10">
                    <p class="veb41-price-new">4 900 ₽</p>
                    <p class="veb41-price-old">14900 ₽</p>
                    <p class="veb41-price-percent">— 70%</p>
                </div>
                <a href="#popup" class="veb41-price-link btn-color-main-dark-orange">Купить курс</a>
            </div>
        </div>
    </div>`
	});

    blockManager.add('careerum-veb-rezults-tablet', {
        label: 'Вебинар - отзывы (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="careerum-veb-results-tablet veb41-switch-currency">
        <div>
            <div>
                <div>
                    <h2>8 238 человек уже посмотрели<br> программу «Real Me».<br> Вот что они говорят</h2>
                </div>
            </div>
            <div>
                <div>
                    <div class="veb-results-slider-item">
                        <div>
                            <div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1657609937699.png" alt="">
                                    <a href="#"></a>
                                </div>
                                <div>
                                    <h4>Мария<br> Михайлова</h4>
                                    <p>Старший консультант, Норвегия</p>
                                </div>
                            </div>
                            <div>
                                <p>#поискработы</p>
                            </div>
                        </div>
                        <div>
                            <p>Курс очень классный <br>и просто must have для всех! Помог структурировать, что <br>я на самом деле люблю делать, что для меня важно, какого типа компанию я хочу найти <br>и с каким руководителем работать. В итоге я определилась со сферой<br> и получила оффер в желаемой компании с потенциалом для развития и повышением зарплаты на 20%!</p>
                        </div>
                    </div>
                    <div class="veb-results-slider-item">
                        <div>
                            <div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1657609918958.png" alt="">
                                    <a href="#"></a>
                                </div>
                                <div>
                                    <h4>Екатерина<br>Комисарова</h4>
                                    <p>Научный сотрудник, Россия</p>
                                </div>
                            </div>
                            <div>
                                <p>#поискработы<br>#сменасферы</p>
                            </div>
                        </div>
                        <div>
                            <p>Изначально я пришла в клуб ради курса Real Me, потому <br>что хотела сформулировать четкую цель в моей карьерной стратегии (хотела сменить сферу и страну), что особенно сложно после выгорания. <br>Мне понравились и глубина проработки, и сложность (иногда приходилось бороться <br>с собой), и инсайты, родившиеся во взаимодействии <br>с напарниками.</p>
                        </div>
                    </div>
                    <div class="veb-results-slider-item">
                        <div>
                            <div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1657609874611.png" alt="">
                                    <a href="#"></a>
                                </div>
                                <div>
                                    <h4>Елена<br> Луценко</h4>
                                    <p>HR-менеджер,<br> Россия</p>
                                </div>
                            </div>
                            <div>
                                <p>#поискработы<br>#работазарубежом</p>
                            </div>
                        </div>
                        <div>
                            <p>Самой ценной в курсе для меня стала возможность узнать и понять себя лучше благодаря последовательной проработке заданий в группе. А еще — мотивирующая и поддержи-вающая среда. После курса<br> я обрела уверенность в том, <br>что двигаюсь в нужном мне направлении, и продумала, <br>как я могу влиять на развитие карьеры.</p>
                        </div>
                    </div>
                    <div class="veb-results-slider-item">
                        <div>
                            <div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1657609858250.png" alt="">
                                    <a href="#"></a>
                                </div>
                                <div>
                                    <h4>Кристина <br>Хейс</h4>
                                    <p>Customer success <br>manager, США</p>
                                </div>
                            </div>
                            <div>
                                <p>#повышение<br>#поискработы</p>
                            </div>
                        </div>
                        <div>
                            <p>Я пришла на курс, чтобы понять, подходит ли мне профессия проджект-менеджера,<br>и определить, какие навыки <br>у меня есть для этой роли.<br> На курсе я выявила свои сильные стороны и поменяла фокус с поиска работы в project management на customer success management. В итоге<br> я получила оффер от компании,<br> в которой все мои «хочу» и «могу» полностью совпали. </p>
                        </div>
                    </div>
                    <div class="veb-results-slider-item">
                        <div>
                            <div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1657607613325.png" alt="">
                                    <a href="#"></a>
                                </div>
                                <div>
                                    <h4>Наталья <br>Калицева</h4>
                                    <p>Бренд-менеджер,<br> бизнес-тренер, Россия</p>
                                </div>
                            </div>
                            <div>
                                <p>#поискработы<br>#выходиздекрета</p>
                            </div>
                        </div>
                        <div>
                            <p>Я хотела определить, что делать после декрета и стоит<br> ли менять работу. На курсе осознала, что нынешняя работа полностью мне откликается, <br>а единственный минус — нет возможности работать удаленно. Проштудировав материалы о том, как преподносить идеи руководителю, я предложила <br>ему план моей удаленной работы. План согласовали!</p>
                        </div>
                    </div>
                    <div class="veb-results-slider-item">
                        <div>
                            <div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1657607635178.png" alt="">
                                    <a href="#"></a>
                                </div>
                                <div>
                                    <h4>Олеся<br> Барлыбаева</h4>
                                    <p>Аккаунт-менеджер, Россия</p>
                                </div>
                            </div>
                            <div>
                                <p>#повышение<br>#поискработы</p>
                            </div>
                        </div>
                        <div>
                            <p>По итогу курса я порефлексировала и поняла,<br> что мне нравится строить процессы, общаться с клиентами и на основе данных дорабатывать продукт. Я нашла интересную вакансию в сервисе онлайн-доставки и после прохождения двух этапов интервью поняла, что это то место, где я по-настоящему хотела бы работать.</p>
                        </div>
                    </div>
                    <div class="veb-results-slider-item">
                        <div>
                            <div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1657607308221.png" alt="">
                                    <a href="#"></a>
                                </div>
                                <div>
                                    <h4>Екатерина Асекритова</h4>
                                    <p>Product launch manager, Россия</p>
                                </div>
                            </div>
                            <div>
                                <p>#повышение<br>#поискработы</p>
                            </div>
                        </div>
                        <div>
                            <p>Самое ценное на курсе — клуб <br>и группа единомышленников. Именно в групповой работе <br>я нашла то, что искала. После курса я обрела уверенность <br>в собственных силах, а мой поиск работы стал гораздо эффективнее. Я перестала судорожно изучать все подряд, <br>а начала сразу отметать неподходящие варианты.</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="veb41-price-wrapper" data-price-rub="4 900 ₽" data-price-eur="49 €" data-price-rub-old="4 900 ₽"
                data-price-eur-old="149 €₽" data-link-rub="#popup-rub" data-link-eur="#popup-eur">
                <div class="veb41-tariffs-curr-wrapper position-relative z-20">
                    <div class="veb41-tariffs-curr careerum-flex-fsst">
                        <ul class="careerum-flex-fsfs">
                            <li data-currency="eur">EUR</li>
                            <li data-currency="rub" class="active">RUB</li>
                        </ul>
                        <div class="veb41-tariffs-notif careerum-flex-cc">
                            <div class="veb41-tariffs-notif-icon">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723134336723-hWN6k-Warn.svg"
                                    alt="">
                            </div>
                            <div class="veb41-tariffs-notif-content">
                                <p>Оплата в российских рублях возможна только
                                    картой российского банка. В&nbsp;евро — картой
                                    зарубежного банка</p>
                            </div>
                        </div>
                    </div>
                    <div class="veb41-tariffs__swicher-block">
                        <div class="veb41-tariffs__swicher-top">
                            <p class="veb41-tariffs__swicher-header">
                                Посмотреть цены в
                                <span>EUR</span>
                            </p><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" class="veb41-tariffs__swicher-arrow">
                                <path d="M7 9.5L12 14.5L17 9.5H7Z" fill="black"></path>
                            </svg>
                        </div>
                        <div class="veb41-tariffs__swicher-bottom">
                            <ul>
                                <li data-currency="rub" class="active">
                                    RUB
                                </li>
                                <li data-currency="eur">
                                    EUR
                                </li>
                            </ul>
                            <p>
                                Обратите внимание,<br> что оплата в российских
                                рублях
                                возможна только<br> с карты
                                российского банка. Оплата в евро — с карты зарубежного банка
                            </p>
                        </div>
                    </div>
                </div>
                <div class="careerum-flex-fsc position-relative z-10">
                    <p class="veb41-price-new">4 900 ₽</p>
                    <p class="veb41-price-old">14900 ₽</p>
                    <p class="veb41-price-percent">— 70%</p>
                </div>
                <a href="#popup" class="veb41-price-link btn-color-main-dark-orange">Купить курс</a>
            </div>
        </div>
    </div>`
	});

    blockManager.add('careerum-veb-rezults-mobile', {
        label: 'Вебинар - отзывы (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="careerum-veb-results-mobile veb41-switch-currency">
        <div>
            <div>
                <div>
                    <h2>8 238 человек уже посмотрели<br> программу «Real Me».<br> Вот что они говорят</h2>
                </div>
            </div>
            <div>
                <div>
                    <div class="veb-results-slider-item">
                        <div>
                            <div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1657607272418.png" alt="">
                                    <a href="#"></a>
                                </div>
                                <div>
                                    <h4>Мария<br> Михайлова</h4>
                                    <p>Старший консультант, Норвегия</p>
                                </div>
                            </div>
                            <div>
                                <p>#поискработы</p>
                            </div>
                        </div>
                        <div>
                            <p>Курс очень классный <br>и просто must have для всех! Помог структурировать, что <br>я на
                                самом деле люблю делать, что для меня важно, какого типа компанию я хочу найти <br>и с
                                каким руководителем работать. В итоге я определилась со сферой<br> и получила оффер в
                                желаемой компании с потенциалом для развития и повышением зарплаты на 20%!</p>
                        </div>
                    </div>
                    <div class="veb-results-slider-item">
                        <div>
                            <div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1657607242617.png" alt="">
                                    <a href="#"></a>
                                </div>
                                <div>
                                    <h4>Екатерина<br>Комисарова</h4>
                                    <p>Научный сотрудник, Россия</p>
                                </div>
                            </div>
                            <div>
                                <p>#поискработы<br>#сменасферы</p>
                            </div>
                        </div>
                        <div>
                            <p>Изначально я пришла в клуб ради курса Real Me, потому <br>что хотела сформулировать
                                четкую цель в моей карьерной стратегии (хотела сменить сферу и страну), что особенно
                                сложно после выгорания. <br>Мне понравились и глубина проработки, и сложность (иногда
                                приходилось бороться <br>с собой), и инсайты, родившиеся во взаимодействии <br>с
                                напарниками.</p>
                        </div>
                    </div>
                    <div class="veb-results-slider-item">
                        <div>
                            <div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1657607215848.png" alt="">
                                    <a href="#"></a>
                                </div>
                                <div>
                                    <h4>Елена<br> Луценко</h4>
                                    <p>HR-менеджер,<br> Россия</p>
                                </div>
                            </div>
                            <div>
                                <p>#поискработы<br>#работазарубежом</p>
                            </div>
                        </div>
                        <div>
                            <p>Самой ценной в курсе для меня стала возможность узнать и понять себя лучше благодаря
                                последовательной проработке заданий в группе. А еще — мотивирующая и поддержи-вающая
                                среда. После курса<br> я обрела уверенность в том, <br>что двигаюсь в нужном мне
                                направлении, и продумала, <br>как я могу влиять на развитие карьеры.</p>
                        </div>
                    </div>
                    <div class="veb-results-slider-item">
                        <div>
                            <div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1657607187520.png" alt="">
                                    <a href="#"></a>
                                </div>
                                <div>
                                    <h4>Кристина <br>Хейс</h4>
                                    <p>Customer success <br>manager, США</p>
                                </div>
                            </div>
                            <div>
                                <p>#повышение<br>#поискработы</p>
                            </div>
                        </div>
                        <div>
                            <p>Я пришла на курс, чтобы понять, подходит ли мне профессия проджект-менеджера,<br>и
                                определить, какие навыки <br>у меня есть для этой роли.<br> На курсе я выявила свои
                                сильные стороны и поменяла фокус с поиска работы в project management на customer
                                success management. В итоге<br> я получила оффер от компании,<br> в которой все мои
                                «хочу» и «могу» полностью совпали. </p>
                        </div>
                    </div>
                    <div class="veb-results-slider-item">
                        <div>
                            <div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1657607162197.png" alt="">
                                    <a href="#"></a>
                                </div>
                                <div>
                                    <h4>Наталья <br>Калицева</h4>
                                    <p>Бренд-менеджер,<br> бизнес-тренер, Россия</p>
                                </div>
                            </div>
                            <div>
                                <p>#поискработы<br>#выходиздекрета</p>
                            </div>
                        </div>
                        <div>
                            <p>Я хотела определить, что делать после декрета и стоит<br> ли менять работу. На курсе
                                осознала, что нынешняя работа полностью мне откликается, <br>а единственный минус — нет
                                возможности работать удаленно. Проштудировав материалы о том, как преподносить идеи
                                руководителю, я предложила <br>ему план моей удаленной работы. План согласовали!</p>
                        </div>
                    </div>
                    <div class="veb-results-slider-item">
                        <div>
                            <div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1657607139565.png" alt="">
                                    <a href="#"></a>
                                </div>
                                <div>
                                    <h4>Олеся<br> Барлыбаева</h4>
                                    <p>Аккаунт-менеджер, Россия</p>
                                </div>
                            </div>
                            <div>
                                <p>#повышение<br>#поискработы</p>
                            </div>
                        </div>
                        <div>
                            <p>По итогу курса я порефлексировала и поняла,<br> что мне нравится строить процессы,
                                общаться с клиентами и на основе данных дорабатывать продукт. Я нашла интересную
                                вакансию в сервисе онлайн-доставки и после прохождения двух этапов интервью поняла, что
                                это то место, где я по-настоящему хотела бы работать.</p>
                        </div>
                    </div>
                    <div class="veb-results-slider-item">
                        <div>
                            <div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1657607103318.png" alt="">
                                    <a href="#"></a>
                                </div>
                                <div>
                                    <h4>Екатерина Асекритова</h4>
                                    <p>Product launch manager, Россия</p>
                                </div>
                            </div>
                            <div>
                                <p>#повышение<br>#поискработы</p>
                            </div>
                        </div>
                        <div>
                            <p>Самое ценное на курсе — клуб <br>и группа единомышленников. Именно в групповой работе
                                <br>я нашла то, что искала. После курса я обрела уверенность <br>в собственных силах, а
                                мой поиск работы стал гораздо эффективнее. Я перестала судорожно изучать все подряд,
                                <br>а начала сразу отметать неподходящие варианты.</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="veb41-price-wrapper" data-price-rub="4 900 ₽" data-price-eur="49 €" data-price-rub-old="4 900 ₽"
                data-price-eur-old="149 €₽" data-link-rub="#popup-rub" data-link-eur="#popup-eur">
                <div class="veb41-tariffs-curr-wrapper position-relative z-20">
                    <div class="veb41-tariffs-curr careerum-flex-fsst">
                        <ul class="careerum-flex-fsfs">
                            <li data-currency="eur">EUR</li>
                            <li data-currency="rub" class="active">RUB</li>
                        </ul>
                        <div class="veb41-tariffs-notif careerum-flex-cc">
                            <div class="veb41-tariffs-notif-icon">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723134336723-hWN6k-Warn.svg"
                                    alt="">
                            </div>
                            <div class="veb41-tariffs-notif-content">
                                <p>Оплата в российских рублях возможна только
                                    картой российского банка. В&nbsp;евро — картой
                                    зарубежного банка</p>
                            </div>
                        </div>
                    </div>
                    <div class="veb41-tariffs__swicher-block">
                        <div class="veb41-tariffs__swicher-top">
                            <p class="veb41-tariffs__swicher-header">
                                Посмотреть цены в
                                <span>EUR</span>
                            </p><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" class="veb41-tariffs__swicher-arrow">
                                <path d="M7 9.5L12 14.5L17 9.5H7Z" fill="black"></path>
                            </svg>
                        </div>
                        <div class="veb41-tariffs__swicher-bottom">
                            <ul>
                                <li data-currency="rub" class="active">
                                    RUB
                                </li>
                                <li data-currency="eur">
                                    EUR
                                </li>
                            </ul>
                            <p>
                                Обратите внимание,<br> что оплата в российских
                                рублях
                                возможна только<br> с карты
                                российского банка. Оплата в евро — с карты зарубежного банка
                            </p>
                        </div>
                    </div>
                </div>
                <div class="careerum-flex-fsc position-relative z-10">
                    <p class="veb41-price-new">4 900 ₽</p>
                    <p class="veb41-price-old">14900 ₽</p>
                    <p class="veb41-price-percent">— 70%</p>
                </div>
                <a href="#popup" class="veb41-price-link btn-color-main-dark-orange">Купить курс</a>
            </div>
        </div>
    </div>`
	});
    
    blockManager.add('careerum-veb-subscribe', {
        label: 'Вебинар - подписка',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-veb-subscribe">
            <div>
                <div>
                    <h2>Достигайте не менее<br /> впечатляющих<br /> результатов. Оформите<br /> подписку на Careerum.Club</h2>
                </div>
                <div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680687236921.svg" alt="">
                        <p>350+ часов материалов на обучающей платформе</p>
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680687251014.svg" alt="">
                        <p>Карьерные консультации с коучем и CV-специалистом</p>
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680687270622.svg" alt="">
                        <p>Нетворк-площадка для обмена опытом</p>
                    </div>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680687354036.svg" alt="">
                    <a href="/ru-ru/club/#buy" class="btn-color-main-dark-orange">Выбрать тариф</a>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-veb-subscribe-tablet', {
        label: 'Вебинар - подписка (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-veb-subscribe-tablet">
            <div>
                <div>
                    <h2>Достигайте не менее впечатляющих<br /> результатов. Оформите подписку<br /> на Careerum.Club</h2>
                </div>
                <div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680687236921.svg" alt="">
                        <p>350+ часов материалов<br> на обучающей платформе</p>
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680687251014.svg" alt="">
                        <p>Карьерные консультации<br> с коучем и CV-специалистом</p>
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680687270622.svg" alt="">
                        <p>Нетворк-площадка для<br> обмена опытом</p>
                    </div>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680687364453.svg" alt="">
                    <a href="/ru-ru/club/#buy" class="btn-color-main-dark-orange">Выбрать тариф</a>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-veb-subscribe-mobile', {
        label: 'Вебинар - подписка (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-veb-subscribe-mobile">
            <div>
                <div>
                    <h2>Достигайте не менее<br /> впечатляющих<br /> результатов.<br /> Оформите подписку<br /> на Careerum.Club</h2>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680687367412.svg" alt="">
                </div>
                <div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680687393308.svg" alt="">
                        <p>350+ часов материалов<br> на обучающей платформе</p>
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680687414486.svg" alt="">
                        <p>Карьерные консультации<br> с коучем и CV-специалистом</p>
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680687428224.svg" alt="">
                        <p>Нетворк-площадка для<br> обмена опытом</p>
                    </div>
                </div>
                <div>
                    <a href="/ru-ru/club/#buy" class="btn-color-main-dark-orange">Выбрать тариф</a>
                </div>
            </div>
        </div>`
	});



    
    blockManager.add('careerum-tariff-page', {
        label: 'Новые тарифы',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="careerum-tariff-page" data-price-1-month-rub="8900 ₽" data-price-3-months-rub="9900 ₽" data-price-6-months-rub="10900 ₽" data-price-12-months-rub="11900 ₽" data-price-1-month-eur="900 €" data-price-3-months-eur="1 000 €" data-price-6-months-eur="1 100 €" data-price-12-months-eur="1 200 €" data-offer-1-month-rub="28" data-offer-3-months-rub="29" data-offer-6-months-rub="30" data-offer-12-months-rub="31" data-offer-1-month-eur="49" data-offer-3-months-eur="50" data-offer-6-months-eur="51" data-offer-12-months-eur="52" data-crossed-price-3-months-rub="26 700 ₽" data-crossed-price-6-months-rub="53 400 ₽" data-crossed-price-12-months-rub="106 800 ₽" data-crossed-price-3-months-eur="327 €" data-crossed-price-6-months-eur="654 €" data-crossed-price-12-months-eur="1 308 €" data-per-month-price-3-months-rub="(8 300 ₽/месяц)" data-per-month-price-6-months-rub="(8 150 ₽/месяц)" data-per-month-price-12-months-rub="(8 050 ₽/месяц)" data-per-month-price-3-months-eur="(103 €/месяц)" data-per-month-price-6-months-eur="(100 €/месяц)" data-per-month-price-12-months-eur="(98 €/месяц)">
        <div>
            <div>
                <a href="#">Вернуться к тарифам</a>
            </div>
            <div>
                <h1>Оформление подписки </h1>
                <ul>
                    <li>Подписка будет продлеваться автоматически<br> на выбранное количество месяцев</li>
                    <li>После оплаты вы получите<br> письмо с инструкцией</li>
                    <li>Вы можете отменить<br> подписку в любой момент</li>
                </ul>
            </div>
            <div>
                <div>
                    <p>Тариф</p>
                    <h3>Самостоятельный</h3>
                    <ul>
                        <li>Обучение</li>
                        <li>Нетворкинг</li>
                        <li class="unactive">Поддержка коуча</li>
                        <li class="unactive">Помощь эксперта по резюме</li>
                        <li class="unactive">Личные сессии с коучем</li>
                    </ul>
                </div>
                    <div>
                        <div>
                            <h4>Способ оплаты</h4>
                            <label class="tooltip">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1657894707924.svg" alt="">
                                <input type="checkbox" name="" id="">
                                <div>
                                    <div><p>Оплата в российских рублях возможна только с карты российского банка. Оплата<br> в евро — с карты<br> зарубежного банка. При смене способа оплаты изменится договор-оферта.</p></div>
                                </div>
                            </label>
                        </div>
                        <form action="" class="top-form">
                            <label class="active"><input type="radio" name="country" id="" data-loc="rub" checked>Оплата картой российского банка</label>
                            <label><input type="radio" name="country" id="" data-loc="eur">Оплата картой зарубежного банка</label>
                        </form>
                        <h4>Количество месяцев</h4>
                        <form action="" class="bottom-form">
                            <label class="active" data-period="1-month"><input type="radio" name="period" id="" checked>1 месяц</label>
                            <label data-period="3-months"><input type="radio" name="period" id="">3 месяца</label>
                            <label data-period="6-months"><input type="radio" name="period" id="">6 месяцев</label>
                            <label data-period="12-months"><input type="radio" name="period" id="">12 месяцев</label>
                        </form>
                        <p class="price">8 900 ₽</p>
                    </div>
                    <div>
                        <div class="careerum-registration-form">
                            <form class="deva-form" name="devaRegistrationForm">
                                <div><input type="text" name="firstname" id="" required><span>Имя</span></div>
                                <div><input type="text" name="lastname" id="" required><span>Фамилия</span></div>
                                <div><input type="email" name="email" id="" required><span>Почта</span></div>
                                <div><input type="tel" name="phone" id="" required><span>Номер телефона</span></div>                                
                                <div>
                                    <label><input type="checkbox" name="agree" id=""></label>
                                    <p>Я принимаю условия <a href="#">Публичной оферты</a> и даю<br> согласие на обработку своих персональных данных<br> в соответствии с <a href="#">Политикой конфиденциальности</a></p>
                                </div>
                                <a href="#" disabled class="submit-btn">Оплатить</a>
                                <input type="hidden" name="offerID" required>
                            </form>
                        </div>
                    </div>
            </div>
        </div>
    </div>`
	});

    blockManager.add('careerum-tariff-page-tablet', {
        label: 'Новые тарифы (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="careerum-tariff-page-tablet" data-price-1-month-rub="8900 ₽" data-price-3-months-rub="9900 ₽" data-price-6-months-rub="10900 ₽" data-price-12-months-rub="11900 ₽" data-price-1-month-eur="900 €" data-price-3-months-eur="1 000 €" data-price-6-months-eur="1 100 €" data-price-12-months-eur="1 200 €" data-offer-1-month-rub="28" data-offer-3-months-rub="29" data-offer-6-months-rub="30" data-offer-12-months-rub="31" data-offer-1-month-eur="49" data-offer-3-months-eur="50" data-offer-6-months-eur="51" data-offer-12-months-eur="52" data-crossed-price-3-months-rub="26 700 ₽" data-crossed-price-6-months-rub="53 400 ₽" data-crossed-price-12-months-rub="106 800 ₽" data-crossed-price-3-months-eur="327 €" data-crossed-price-6-months-eur="654 €" data-crossed-price-12-months-eur="1 308 €" data-per-month-price-3-months-rub="(8 300 ₽/месяц)" data-per-month-price-6-months-rub="(8 150 ₽/месяц)" data-per-month-price-12-months-rub="(8 050 ₽/месяц)" data-per-month-price-3-months-eur="(103 €/месяц)" data-per-month-price-6-months-eur="(100 €/месяц)" data-per-month-price-12-months-eur="(98 €/месяц)">
        <div>
            <div>
                <a href="#">Вернуться к тарифам</a>
            </div>
            <div>
                <div>
                    <h1>Оформление подписки </h1>
                    <ul>
                        <li>Подписка будет продлеваться автоматически на выбранное количество месяцев</li>
                        <li>После оплаты вы получите<br> письмо с инструкцией</li>
                        <li>Вы можете отменить подписку <br>в любой момент</li>
                    </ul>
                </div>
                <div>
                    <p>Тариф</p>
                    <h3>Самостоятельный</h3>
                    <ul>
                        <li>Обучение</li>
                        <li>Нетворкинг</li>
                        <li class="unactive">Поддержка коуча</li>
                        <li class="unactive">Помощь эксперта по резюме</li>
                        <li class="unactive">Личные сессии с коучем</li>
                    </ul>
                </div>
            </div>
            <div>
                    <div>
                        <div>
                            <h4>Способ оплаты</h4>
                            <label  class="tooltip">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1657894707924.svg" alt="">
                                <input type="checkbox" name="" id="">
                                <div>
                                    <div><p>Оплата в российских рублях возможна только с карты российского банка. Оплата<br> в евро — с карты<br> зарубежного банка. При смене способа оплаты изменится договор-оферта.</p></div>
                                </div>
                            </label>
                        </div>
                        <form action="" class="top-form">
                            <label class="active"><input type="radio" name="country" id="" data-loc="rub" checked>Оплата картой российского банка</label>
                            <label><input type="radio" name="country" id="" data-loc="eur">Оплата картой зарубежного банка</label>
                        </form>
                        <h4>Количество месяцев</h4>
                        <form action="" class="bottom-form">
                            <label class="active" data-period="1-month"><input type="radio" name="period" id="" checked>1 месяц</label>
                            <label data-period="3-months"><input type="radio" name="period" id="">3 месяца</label>
                            <label data-period="6-months"><input type="radio" name="period" id="">6 месяцев</label>
                            <label data-period="12-months"><input type="radio" name="period" id="">12 месяцев</label>
                        </form>
                        <p class="price">8 900 ₽</p>
                    </div>
                    <div>
                        <div class="careerum-registration-form-tablet">
                            <form class="deva-form" name="devaRegistrationForm">
                                <div><input type="text" name="firstname" id="" required><span>Имя</span></div>
                                <div><input type="text" name="lastname" id="" required><span>Фамилия</span></div>
                                <div><input type="email" name="email" id="" required><span>Почта</span></div>
                                <div><input type="tel" name="phone" id="" required><span>Номер телефона</span></div>                                
                                <div>
                                    <label><input type="checkbox" name="agree" id=""></label>
                                    <p>Я принимаю условия <a href="#">Публичной оферты</a> и даю<br> согласие на обработку своих персональных данных<br> в соответствии с <a href="#">Политикой конфиденциальности</a></p>
                                </div>
                                <a href="#" disabled class="submit-btn">Оплатить</a>
                                <input type="hidden" name="offerID" required>
                            </form>
                        </div>
                    </div>
            </div>
        </div>
    </div>`
	});

    blockManager.add('careerum-tariff-page-mobile', {
        label: 'Новые тарифы (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="careerum-tariff-page-mobile" data-price-1-month-rub="8900 ₽" data-price-3-months-rub="9900 ₽" data-price-6-months-rub="10900 ₽" data-price-12-months-rub="11900 ₽" data-price-1-month-eur="900 €" data-price-3-months-eur="1 000 €" data-price-6-months-eur="1 100 €" data-price-12-months-eur="1 200 €" data-offer-1-month-rub="28" data-offer-3-months-rub="29" data-offer-6-months-rub="30" data-offer-12-months-rub="31" data-offer-1-month-eur="49" data-offer-3-months-eur="50" data-offer-6-months-eur="51" data-offer-12-months-eur="52" data-crossed-price-3-months-rub="26 700 ₽" data-crossed-price-6-months-rub="53 400 ₽" data-crossed-price-12-months-rub="106 800 ₽" data-crossed-price-3-months-eur="327 €" data-crossed-price-6-months-eur="654 €" data-crossed-price-12-months-eur="1 308 €" data-per-month-price-3-months-rub="(8 300 ₽/месяц)" data-per-month-price-6-months-rub="(8 150 ₽/месяц)" data-per-month-price-12-months-rub="(8 050 ₽/месяц)" data-per-month-price-3-months-eur="(103 €/месяц)" data-per-month-price-6-months-eur="(100 €/месяц)" data-per-month-price-12-months-eur="(98 €/месяц)">
        <div>
            <div>
                <a href="#">Вернуться к тарифам</a>
            </div>
            <div>
                <div>
                    <h1>Оформление подписки </h1>
                </div>
                <div>
                    <div>
                        <p>Тариф</p>
                        <h3>Самостоятельный</h3>
                        <ul>
                            <li>Обучение</li>
                            <li>Нетворкинг</li>
                            <li class="unactive">Поддержка коуча</li>
                            <li class="unactive">Помощь эксперта по резюме</li>
                            <li class="unactive">Личные сессии с коучем</li>
                        </ul>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1657895010632.svg" alt="">
                    </div>
                    <div>
                        <div>
                            <h4>Способ оплаты</h4>
                            <label  class="tooltip">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1657895034282.svg" alt="">
                                <input type="checkbox" name="" id="">
                                <div>
                                    <div><p>Оплата в российских рублях возможна только с карты российского банка. Оплата в евро — с карты зарубежного банка. При смене способа оплаты изменится договор-оферта.</p></div>
                                </div>
                            </label>
                        </div>
                        <form action="" class="top-form">
                            <label class="active"><input type="radio" name="country" id="" data-loc="rub" checked>Оплата картой российского банка</label>
                            <label><input type="radio" name="country" id="" data-loc="eur">Оплата картой зарубежного банка</label>
                        </form>
                        <h4>Количество месяцев</h4>
                        <form action="" class="bottom-form">
                            <label class="active" data-period="1-month"><input type="radio" name="period" id="" checked>1 месяц</label>
                            <label data-period="3-months"><input type="radio" name="period" id="">6 месяцев</label>
                            <label data-period="6-months"><input type="radio" name="period" id="">3 месяца</label>
                            <label data-period="12-months"><input type="radio" name="period" id="">12 месяцев</label>
                        </form>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1657895053034.svg" alt="">
                        <p class="price">8 900 ₽</p>
                    </div>
                </div>
            </div>
            <div>
                    
                    <div>
                        <div class="careerum-registration-form-mobile">
                            <form class="deva-form" name="devaRegistrationForm">
                                <div><input type="text" name="firstname" id="" required><span>Имя</span></div>
                                <div><input type="text" name="lastname" id="" required><span>Фамилия</span></div>
                                <div><input type="email" name="email" id="" required><span>Почта</span></div>
                                <div><input type="tel" name="phone" id="" required><span>Номер телефона</span></div>                                
                                <div>
                                    <label><input type="checkbox" name="agree" id=""></label>
                                    <p>Я принимаю условия <a href="#">Публичной оферты</a><br> и даю согласие на обработку своих<br> персональных данных в соответствии<br> с <a href="#">Политикой конфиденциальности</a></p>
                                </div>
                                <a href="#" disabled class="submit-btn">Оплатить</a>
                                <input type="hidden" name="offerID" required>
                            </form>
                        </div>
                    </div>
            </div>
            <div>
                
                <ul>
                    <li>Подписка будет продлеваться автоматически на выбранное количество месяцев</li>
                    <li>После оплаты вы получите<br> письмо с инструкцией</li>
                    <li>Вы можете отменить подписку <br>в любой момент</li>
                </ul>
            </div>
        </div>
    </div>`
	});



    
    blockManager.add('careerum-one-tariff-page', {
        label: 'Новые тарифы - 1 оффер',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="careerum-tariff-page">
        <div>
            <div>
                <a href="#">Вернуться к тарифам</a>
            </div>
            <div>
                <h1>Оформление подписки </h1>
                <ul>
                    <li>Подписка будет продлеваться автоматически<br> на выбранное количество месяцев</li>
                    <li>После оплаты вы получите<br> письмо с инструкцией</li>
                    <li>Вы можете отменить<br> подписку в любой момент</li>
                </ul>
            </div>
            <div>
                <div>
                    <p>Тариф</p>
                    <h3>Самостоятельный</h3>
                    <ul>
                        <li>Обучение</li>
                        <li>Нетворкинг</li>
                        <li class="unactive">Поддержка коуча</li>
                        <li class="unactive">Помощь эксперта по резюме</li>
                        <li class="unactive">Личные сессии с коучем</li>
                    </ul>
                    <h3 class="tarif-price">20 000 ₽</h3>
                </div>
                <div class="hidden"></div>
                <div>
                    <div class="careerum-registration-form">
                        <form class="deva-form" name="devaRegistrationForm">
                            <div><input type="text" name="firstname" id="" required><span>Имя</span></div>
                            <div><input type="text" name="lastname" id="" required><span>Фамилия</span></div>
                            <div><input type="email" name="email" id="" required><span>Почта</span></div>
                            <div><input type="tel" name="phone" id="" required><span>Номер телефона</span></div>                                
                            <div>
                                <label><input type="checkbox" name="agree" id=""></label>
                                <p>Я принимаю условия <a href="#">Публичной оферты</a> и даю<br> согласие на обработку своих персональных данных<br> в соответствии с <a href="#">Политикой конфиденциальности</a></p>
                            </div>
                            <a href="#" disabled class="submit-btn">Оплатить</a>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>`
	});

    blockManager.add('careerum-one-tariff-page-tablet', {
        label: 'Новые тарифы - 1 оффер (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="careerum-tariff-page-tablet">
        <div>
            <div>
                <a href="#">Вернуться к тарифам</a>
            </div>
            <div>
                <div>
                    <h1>Оформление подписки </h1>
                    <ul>
                        <li>Подписка будет продлеваться автоматически на выбранное количество месяцев</li>
                        <li>После оплаты вы получите<br> письмо с инструкцией</li>
                        <li>Вы можете отменить подписку <br>в любой момент</li>
                    </ul>
                </div>
                <div>
                    <p>Тариф</p>
                    <h3>Самостоятельный</h3>
                    <ul>
                        <li>Обучение</li>
                        <li>Нетворкинг</li>
                        <li class="unactive">Поддержка коуча</li>
                        <li class="unactive">Помощь эксперта по резюме</li>
                        <li class="unactive">Личные сессии с коучем</li>
                    </ul>
                    <h3 class="tarif-price">20 000 ₽</h3>
                </div>
            </div>
            <div>
                <div class="hidden"></div>
                <div>
                    <div class="careerum-registration-form-tablet">
                        <form class="deva-form" name="devaRegistrationForm">
                            <div><input type="text" name="firstname" id="" required><span>Имя</span></div>
                            <div><input type="text" name="lastname" id="" required><span>Фамилия</span></div>
                            <div><input type="email" name="email" id="" required><span>Почта</span></div>
                            <div><input type="tel" name="phone" id="" required><span>Номер телефона</span></div>                                
                            <div>
                                <label><input type="checkbox" name="agree" id=""></label>
                                <p>Я принимаю условия <a href="#">Публичной оферты</a> и даю<br> согласие на обработку своих персональных данных<br> в соответствии с <a href="#">Политикой конфиденциальности</a></p>
                            </div>
                            <a href="#" disabled class="submit-btn">Оплатить</a>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>`
	});

    blockManager.add('careerum-one-tariff-page-mobile', {
        label: 'Новые тарифы - 1 оффер (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="careerum-tariff-page-mobile">
        <div>
            <div>
                <a href="#">Вернуться к тарифам</a>
            </div>
            <div>
                <div>
                    <h1>Оформление подписки </h1>
                </div>
                <div>
                    <div>
                        <p>Тариф</p>
                        <h3>Самостоятельный</h3>
                        <ul>
                            <li>Обучение</li>
                            <li>Нетворкинг</li>
                            <li class="unactive">Поддержка коуча</li>
                            <li class="unactive">Помощь эксперта по резюме</li>
                            <li class="unactive">Личные сессии с коучем</li>
                        </ul>
                        <h3 class="tarif-price">20 000 ₽</h3>
                    </div>
                    <div class="hidden"></div>
                </div>
            </div>
            <div>
                <div>
                    <div class="careerum-registration-form-mobile">
                        <form class="deva-form" name="devaRegistrationForm">
                            <div><input type="text" name="firstname" id="" required><span>Имя</span></div>
                            <div><input type="text" name="lastname" id="" required><span>Фамилия</span></div>
                            <div><input type="email" name="email" id="" required><span>Почта</span></div>
                            <div><input type="tel" name="phone" id="" required><span>Номер телефона</span></div>                                
                            <div>
                                <label><input type="checkbox" name="agree" id=""></label>
                                <p>Я принимаю условия <a href="#">Публичной оферты</a><br> и даю согласие на обработку своих<br> персональных данных в соответствии<br> с <a href="#">Политикой конфиденциальности</a></p>
                            </div>
                            <a href="#" disabled class="submit-btn">Оплатить</a>
                        </form>
                    </div>
                </div>
            </div>
            <div>
                
                <ul>
                    <li>Подписка будет продлеваться автоматически на выбранное количество месяцев</li>
                    <li>После оплаты вы получите<br> письмо с инструкцией</li>
                    <li>Вы можете отменить подписку <br>в любой момент</li>
                </ul>
            </div>
        </div>
    </div>`
	});


    blockManager.add('careerum-registration-form', {
        label: 'Форма с ФИО',  // can contain any HTML markup
        category: 'Forms', // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-registration-form">
            <form class="deva-form" name="devaRegistrationForm">
                <div><input type="text" name="firstname" id="" required><span>Имя</span></div>
                <div><input type="text" name="lastname" id="" required><span>Фамилия</span></div>
                <div><input type="email" name="email" id="" required><span>Почта</span></div>
                <div><input type="tel" name="phone" id="" required><span>Номер телефона</span></div>                                
                <div>
                    <label><input type="checkbox" name="agree" id=""></label>
                    <p>Я принимаю условия <a href="#">Публичной оферты</a> и даю<br> согласие на обработку своих персональных данных<br> в соответствии с <a href="#">Политикой конфиденциальности</a></p>
                </div>
                <a href="#" disabled class="submit-btn">Оплатить</a>
            </form>
        </div>`
	});

    blockManager.add('careerum-registration-form-tablet', {
        label: 'Форма с ФИО (tablet)',  // can contain any HTML markup
        category: 'Forms', // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-registration-form-tablet">
            <form class="deva-form" name="devaRegistrationForm">
                <div><input type="text" name="firstname" id="" required><span>Имя</span></div>
                <div><input type="text" name="lastname" id="" required><span>Фамилия</span></div>
                <div><input type="email" name="email" id="" required><span>Почта</span></div>
                <div><input type="tel" name="phone" id="" required><span>Номер телефона</span></div>                                
                <div>
                    <label><input type="checkbox" name="agree" id=""></label>
                    <p>Я принимаю условия <a href="#">Публичной оферты</a> и даю<br> согласие на обработку своих персональных данных<br> в соответствии с <a href="#">Политикой конфиденциальности</a></p>
                </div>
                <a href="#" disabled class="submit-btn">Оплатить</a>
            </form>
        </div>`
	});

    blockManager.add('careerum-registration-form-mobile', {
        label: 'Форма с ФИО (mobile)',  // can contain any HTML markup
        category: 'Forms', // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-registration-form-mobile">
            <form class="deva-form" name="devaRegistrationForm">
                <div><input type="text" name="firstname" id="" required><span>Имя</span></div>
                <div><input type="text" name="lastname" id="" required><span>Фамилия</span></div>
                <div><input type="email" name="email" id="" required><span>Почта</span></div>
                <div><input type="tel" name="phone" id="" required><span>Номер телефона</span></div>                                
                <div>
                    <label><input type="checkbox" name="agree" id=""></label>
                    <p>Я принимаю условия <a href="#">Публичной оферты</a><br> и даю согласие на обработку своих<br> персональных данных в соответствии<br> с <a href="#">Политикой конфиденциальности</a></p>
                </div>
                <a href="#" disabled class="submit-btn">Оплатить</a>
            </form>
        </div>`
	});

    
    blockManager.add('careerum-course-tab-item', {
        label: 'Карточка курса',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-course-tab-item">
            <div>  
                <p>Курс</p>
                <p>2 часа 16 мин.</p>
            </div>  
            <h3>Продающее резюме</h3>
            <p>Научитесь грамотно формулировать свои достижения и создадите сильное резюме на двух языках, которое точно рассмотрят</p>
        </div>`
	});

    blockManager.add('careerum-course-tab-item-tablet', {
        label: 'Карточка курса (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-course-tab-item-tablet">
            <div>
                <p>Курс</p>
                <p>2 часа 16 мин.</p>
            </div>
            <h3>Умная стратегия поиска работы</h3>
            <p>Создадите пошаговый план <br>поиска работы, который<br> приведет вас к офферу мечты
            </p>
        </div>`
	});

    blockManager.add('careerum-course-tab-item-mobile', {
        label: 'Карточка курса (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-course-tab-item-mobile">
            <div>
                <p>Курс</p>
                <p>2 часа 16 мин.</p>
            </div>
            <h3>Умная стратегия<br> поиска работы</h3>
            <p>Создадите пошаговый план <br>поиска работы, который приведет вас к офферу мечты
            </p>
        </div>`
	});
    
    blockManager.add('careerum-master-tab-item', {
        label: 'Карточка мастер-класса',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-master-tab-item">                                
            <div>  
                <p>Мастер-класс</p>
                <p>2 часа 39 мин.</p>
            </div>  
            <div>
                <h3>Great Deal: как<br> получить оффер мечты</h3>
                <p>Изучите секреты ведения переговоров, чтобы получать желаемую зарплату и другие привлекательные условия</p>
            </div>
        </div>`
	});

    blockManager.add('careerum-master-tab-item-tablet', {
        label: 'Карточка мастер-класса (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-master-tab-item-tablet">                                
            <div>  
                <p>Мастер-класс</p>
                <p>2 часа 39 мин.</p>
            </div>  
            <div>
                <h3>Great Deal: как<br> получить оффер мечты</h3>
                <p>Изучите секреты ведения переговоров, чтобы получать желаемую зарплату и другие привлекательные условия</p>
            </div>
        </div>`
	});

    blockManager.add('careerum-master-tab-item-mobile', {
        label: 'Карточка мастер-класса (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-master-tab-item-mobile">                                
            <div>  
                <p>Мастер-класс</p>
                <p>2 часа 39 мин.</p>
            </div>  
            <div>
                <h3>Great Deal: как<br> получить оффер мечты</h3>
                <p>Изучите секреты ведения переговоров, чтобы получать желаемую зарплату и другие привлекательные условия</p>
            </div>
        </div>`
	});
    
    blockManager.add('careerum-vebinar-tab-item', {
        label: 'Карточка вебинара',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-vebinar-tab-item">
            <div>  
                <p>Вебинар</p>
                <p>2 часа 21 мин.</p>
            </div>  
                <h3>Как попасть<br> в Google: секреты<br> и подводные камни</h3>
        </div>`
	});

    blockManager.add('careerum-vebinar-tab-item-tablet', {
        label: 'Карточка вебинара (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-vebinar-tab-item-tablet">
            <div>  
                <p>Вебинар</p>
                <p>2 часа 21 мин.</p>
            </div>  
                <h3>Как попасть<br> в Google: секреты<br> и подводные камни</h3>
        </div>`
	});

    blockManager.add('careerum-vebinar-tab-item-mobile', {
        label: 'Карточка вебинара (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-vebinar-tab-item-mobile">
            <div>  
                <p>Вебинар</p>
                <p>2 часа 21 мин.</p>
            </div>  
                <h3>Как попасть<br> в Google: секреты<br> и подводные камни</h3>
        </div>`
	});
    
    blockManager.add('careerum-404', {
        label: 'Страница 404',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-404">
            <div>
                <h1>404</h1>
                <p>К сожалению, страница не найдена.<br> Но вы можете найти работу, сменить<br> сферу или получить повышение при<br> помощи <a href="#">Careerum.Club</a></p>
            </div>
        </div>`
	});

    blockManager.add('careerum-404-tablet', {
        label: 'Страница 404 (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-404-tablet">
            <div>
                <h2>404</h2>
                <p>К сожалению, страница не найдена.<br> Но вы можете найти работу, сменить сферу или<br> получить повышение при помощи <a href="#">Careerum.Club</a></p>
            </div>
        </div>`
	});

    blockManager.add('careerum-404-mobile', {
        label: 'Страница 404 (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-404-mobile">
            <div>
                <h2>404</h2>
                <p>К сожалению, страница<br> не найдена. Но вы можете найти<br> работу, сменить сферу или<br> получить повышение при помощи<br> 
                    <a href="#">Careerum.Club</a>
                </p>
            </div>
        </div>`
	});

    blockManager.add('careerum-instagram-main', {
        label: 'Инста главная',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-instagram-main">
            <div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1658786962755.png" alt="">
                </div>
                <div>
                    <div>
                        <h1>
                            <span>Привет, я — Ольга Лермонтова,</span> карьерный коуч и стратег
                        </h1>
                        <p>Со мной вы поймете, кем хотите быть, «когда вырастете»<br> и сможете построить карьру мечты на российском или<br> международном рынке</p>
                    </div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1658786986065.svg" alt="">
                    <div class="careerum-instagram-main-about">
                        <div>
                            <div>
                                <h2>Обо мне</h2>
                            </div>
                            <div>
                                <p>Основала Careerum — крупнейшую в России<br> и СНГ платформу карьерного развития</p>
                            </div>
                            <div>
                                <p>Окончила MBA в школе INSEAD (Сингапур); получила коучинговую сертификацию ICF</p>
                            </div>
                        </div>
                        <div>
                            <div>
                                <p class="instagram-main-subheader">
                                    15
                                </p>
                                <p>лет карьеры в 5 странах, в том числе на <a href="#">руководящих должностях</a> в топ компаниях Google и Microsoft</p>
                            </div>
                            <div>
                                <p class="instagram-main-subheader">
                                    10 000+
                                </p>
                                <p>человек нашли любимую работу и получили повышение при помощи <a href="#">Careerum</a></p>
                            </div>
                            <div>
                                <p class="instagram-main-subheader">
                                    7 000+
                                </p>
                                <p>печатных и электронных экземпляров <a href="#">книги<br>«Работа по любви»</a> было продано за 1,5 месяца</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
    });
    
    blockManager.add('careerum-instagram-main-tablet', {
        label: 'Инста главная (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-instagram-main-tablet">
            <div>
                    <div class="careerum-instagram-main-top">
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1658787083743.png" alt="">
                        </div>
                        <div>
                            <h2>
                                <span>Привет, я — Ольга Лермонтова,</span> карьерный коуч<br> и стратег
                            </h2>
                            <p>Со мной вы поймете, кем хотите быть, «когда вырастете» и сможете построить карьру мечты<br> на российском или международном рынке</p>
                        </div>
                    </div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1658787108893.svg" alt="">
                    <div class="careerum-instagram-main-about">
                        <div>
                            <div>
                                <h3>Обо мне</h3>
                            </div>
                            <div>
                                <p>Основала Careerum — крупнейшую в России<br> и СНГ платформу карьерного развития</p>
                            </div>
                            <div>
                                <p>Окончила MBA в школе INSEAD (Сингапур); получила коучинговую сертификацию ICF</p>
                            </div>
                        </div>
                        <div>
                            <div>
                                <p class="instagram-main-subheader">
                                    15
                                </p>
                                <p>лет карьеры в 5 странах, в том числе на <a href="#">руководящих должностях</a> в топ компаниях Google и Microsoft</p>
                            </div>
                            <div>
                                <p class="instagram-main-subheader">
                                    10 000+
                                </p>
                                <p>человек нашли любимую работу и получили повышение при помощи <a href="#">Careerum</a></p>
                            </div>
                            <div>
                                <p class="instagram-main-subheader">
                                    7 000+
                                </p>
                                <p>печатных и электронных экземпляров <a href="#">книги<br>«Работа по любви»</a> было продано за 1,5 месяца</p>
                            </div>
                        </div>
                    </div>
            </div>
        </div>`
    });
    
    blockManager.add('careerum-instagram-main-mobile', {
        label: 'Инста главная (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-instagram-main-mobile">
            <div>
                <div class="careerum-scroll-button-wrapper">
                    <a href="#" class="btn-color-main-dark-orange careerum-scroll-button">Получить бесплатные материалы</a>
                </div>
                <div class="careerum-instagram-main-top">
                    <div>
                        <h2>
                            <span>Привет, я — Ольга Лермонтова,</span> карьерный коуч<br> и стратег
                        </h2>
                        <p>Со мной вы поймете, кем хотите быть, «когда вырастете» и сможете построить карьру мечты на
                            российском или международном рынке</p>
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1658787163860.png" alt="">
                    </div>
                </div>
                <div class="careerum-instagram-main-about">
                    <div>
                        <div>
                            <h3>Обо мне</h3>
                        </div>
                        <div>
                            <p>Основала Careerum —<br> крупнейшую в России и СНГ<br> платформу карьерного развития</p>
                        </div>
                        <div>
                            <p>Окончила MBA в школе INSEAD (Сингапур); получила коучинговую сертификацию ICF</p>
                        </div>
                    </div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1658787191823.svg" alt="">
                    <div>
                        <div>
                            <p class="instagram-main-subheader">
                                15 лет
                            </p>
                            <p>карьеры в 5 странах, в том числе на<br> <a href="#">руководящих должностях</a> в топ
                                компаниях Google и Microsoft</p>
                        </div>
                        <div>
                            <p class="instagram-main-subheader">
                                10 000+ <br>человек
                            </p>
                            <p>нашли любимую работу и получили<br> повышение при помощи <a href="#">Careerum</a></p>
                        </div>
                        <div>
                            <p class="instagram-main-subheader">
                                7 000+<br> экземпляров
                            </p>
                            <p> <a href="#">книги «Работа по любви»</a><br> было продано за
                                1,5 месяца</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
    });

    blockManager.add('careerum-free-materials', {
        label: 'Бесплатные материалы',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-free-materials">
            <div>
                <h2>Начните с бесплатных <br>карьерных материалов</h2>
                <div class="careerum-free-materials-tiles">
                    <div>
                        <p class="careerum-free-materials-tile-type">
                            Гайд
                        </p>
                        <p class="careerum-free-materials-tile-header">
                            Как найти<br> работу на<br> междунаро-<br>дном рынке
                        </p>
                        <p class="careerum-free-materials-tile-content">
                            Избавитесь от тревоги и поймете, что нужно делать, чтобы найти работу мечты в любой стране
                        </p>
                        <a href="#" class="btn-color-main-bright-orange">
                            Скачать
                        </a>
                    </div>
                    <div>
                        <p class="careerum-free-materials-tile-type">
                            Гайд
                        </p>
                        <p class="careerum-free-materials-tile-header">
                            Как найти<br> работу по<br> душе
                        </p>
                        <p class="careerum-free-materials-tile-content">
                            Узнаете, как вывести свою карьеру на новый уровень, поработав со своими ограничивающими убеждениями
                        </p>
                        <a href="#" class="btn-color-main-bright-orange">
                            Скачать
                        </a>
                    </div>
                    <div>
                        <p class="careerum-free-materials-tile-type">
                            Чек-лист
                        </p>
                        <p class="careerum-free-materials-tile-header">
                            Как написать продающее резюме
                        </p>
                        <p class="careerum-free-materials-tile-content">
                            Получите четкую пошаговую инструкцию, как превратить обычное резюме в то, которое обязательно рассмотрят
                        </p>
                        <a href="#" class="btn-color-main-bright-orange">
                            Скачать
                        </a>
                    </div>
                    <div>
                        <p class="careerum-free-materials-tile-type">
                            Чек-лист
                        </p>
                        <p class="careerum-free-materials-tile-header">
                            Как получить повышение
                        </p>
                        <p class="careerum-free-materials-tile-content">
                            Узнаете, какие 5 шагов могут приблизить ваше повышение в ближайшие 6 месяцев и на примерах поймете, как их реализовать
                        </p>
                        <a href="#" class="btn-color-main-bright-orange">
                            Скачать
                        </a>
                    </div>
                    <div>
                        <p class="careerum-free-materials-tile-type">
                            Гайд
                        </p>
                        <p class="careerum-free-materials-tile-header">
                            5 сложных вопросов на собеседовании
                        </p>
                        <p class="careerum-free-materials-tile-content">
                            Разберете 5 самых сложных вопросов, которые задают рекрутеры и научитесь правильно на них отвечать
                        </p>
                        <a href="#" class="btn-color-main-bright-orange">
                            Скачать
                        </a>
                    </div>
                    <div>
                        <p class="careerum-free-materials-tile-type">
                            Демоурок
                        </p>
                        <p class="careerum-free-materials-tile-header">
                            Как строить карьеру в кризис
                        </p>
                        <p class="careerum-free-materials-tile-content">
                            Научитесь гибко реагировать на меняющиеся обстоятельства и «делать из лимонов лимонад», пока другие сетуют на кризис
                        </p>
                        <a href="#" class="btn-color-main-bright-orange">
                            Смотреть
                        </a>
                    </div>
                </div>
            </div>
        </div>`
    });
    
    blockManager.add('careerum-free-materials-tablet', {
        label: 'Бесплатные материалы (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-free-materials-tablet">
            <div>
                <h2>Начните с бесплатных <br>карьерных материалов</h2>
                <div class="careerum-free-materials-tiles">
                    <div>
                        <p class="careerum-free-materials-tile-type">
                            Гайд
                        </p>
                        <p class="careerum-free-materials-tile-header">
                            Как найти работу<br> на международном рынке
                        </p>
                        <p class="careerum-free-materials-tile-content">
                            Избавитесь от тревоги и поймете,<br> что нужно делать, чтобы найти работу мечты в любой стране
                        </p>
                        <a href="#" class="btn-color-main-bright-orange">
                            Скачать
                        </a>
                    </div>
                    <div>
                        <p class="careerum-free-materials-tile-type">
                            Гайд
                        </p>
                        <p class="careerum-free-materials-tile-header">
                            5 сложных<br> вопросов на <br>собеседовании
                        </p>
                        <p class="careerum-free-materials-tile-content">
                            Разберете 5 сложных вопросов, которые задают рекрутеры и научитесь правильно на них отвечать
                        </p>
                        <a href="#" class="btn-color-main-bright-orange">
                            Скачать
                        </a>
                    </div>
                    <div>
                        <p class="careerum-free-materials-tile-type">
                            Гайд
                        </p>
                        <p class="careerum-free-materials-tile-header">
                            Как найти<br> работу по душе
                        </p>
                        <p class="careerum-free-materials-tile-content">
                            Узнаете, как вывести свою<br> карьеру на новый уровень,<br> поработав со своими<br> ограничивающими убеждениями
                        </p>
                        <a href="#" class="btn-color-main-bright-orange">
                            Скачать
                        </a>
                    </div>
                    <div>
                        <p class="careerum-free-materials-tile-type">
                            Чек-лист
                        </p>
                        <p class="careerum-free-materials-tile-header">
                            Как получить повышение
                        </p>
                        <p class="careerum-free-materials-tile-content">
                            Узнаете, какие 5 шагов могут приблизить ваше повышение в ближайшие 6 месяцев и на примерах поймете, как их реализовать
                        </p>
                        <a href="#" class="btn-color-main-bright-orange">
                            Скачать
                        </a>
                    </div>
                    <div>
                        <p class="careerum-free-materials-tile-type">
                            Гайд
                        </p>
                        <p class="careerum-free-materials-tile-header">
                            Как написать продающее резюме
                        </p>
                        <p class="careerum-free-materials-tile-content">
                            Получите четкую пошаговую инструкцию, как превратить обычное резюме в то, которое обязательно рассмотрят
                        </p>
                        <a href="#" class="btn-color-main-bright-orange">
                            Скачать
                        </a>
                    </div>
                    <div>
                        <p class="careerum-free-materials-tile-type">
                            Демоурок
                        </p>
                        <p class="careerum-free-materials-tile-header">
                            Как строить<br> карьеру в кризис
                        </p>
                        <p class="careerum-free-materials-tile-content">
                            Научитесь гибко реагировать на меняющиеся обстоятельства и «делать из лимонов лимонад», пока другие сетуют на кризис
                        </p>
                        <a href="#" class="btn-color-main-bright-orange">
                            Смотреть
                        </a>
                    </div>
                </div>
            </div>
        </div>`
    });
    
    blockManager.add('careerum-free-materials-mobile', {
        label: 'Бесплатные материалы (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-free-materials-mobile">
            <div>
                <h2>Начните <br>с бесплатных <br>карьерных материалов</h2>
                <div class="careerum-free-materials-tiles">
                    <div>
                        <p class="careerum-free-materials-tile-type">
                            Гайд
                        </p>
                        <p class="careerum-free-materials-tile-header">
                            Как найти работу<br> на международном рынке
                        </p>
                        <p class="careerum-free-materials-tile-content">
                            Избавитесь от тревоги и поймете,<br> что нужно делать, чтобы найти работу мечты в любой стране
                        </p>
                        <a href="#" class="btn-color-main-light-blue">
                            Скачать
                        </a>
                    </div>
                    <div>
                        <p class="careerum-free-materials-tile-type">
                            Гайд
                        </p>
                        <p class="careerum-free-materials-tile-header">
                            Как найти<br> работу по душе
                        </p>
                        <p class="careerum-free-materials-tile-content">
                            Узнаете, как вывести свою<br> карьеру на новый уровень,<br> поработав со своими<br>
                            ограничивающими убеждениями
                        </p>
                        <a href="#" class="btn-color-main-light-blue">
                            Скачать
                        </a>
                    </div>
                    <div>
                        <p class="careerum-free-materials-tile-type">
                            Гайд
                        </p>
                        <p class="careerum-free-materials-tile-header">
                            Как написать продающее резюме
                        </p>
                        <p class="careerum-free-materials-tile-content">
                            Получите четкую пошаговую инструкцию, как превратить обычное резюме в то, которое обязательно
                            рассмотрят
                        </p>
                        <a href="#" class="btn-color-main-light-blue">
                            Скачать
                        </a>
                    </div>
                    <div>
                        <p class="careerum-free-materials-tile-type">
                            Чек-лист
                        </p>
                        <p class="careerum-free-materials-tile-header">
                            Как получить повышение
                        </p>
                        <p class="careerum-free-materials-tile-content">
                            Узнаете, какие 5 шагов могут приблизить ваше повышение в ближайшие 6 месяцев и на примерах
                            поймете, как их реализовать
                        </p>
                        <a href="#" class="btn-color-main-light-blue">
                            Скачать
                        </a>
                    </div>
                    <div>
                        <p class="careerum-free-materials-tile-type">
                            Гайд
                        </p>
                        <p class="careerum-free-materials-tile-header">
                            5 сложных вопросов<br> на собеседовании
                        </p>
                        <p class="careerum-free-materials-tile-content">
                            Разберете 5 самых сложных вопросов, которые задают рекрутеры и научитесь правильно на них отвечать
                        </p>
                        <a href="#" class="btn-color-main-light-blue">
                            Скачать
                        </a>
                    </div>
                    <div>
                        <p class="careerum-free-materials-tile-type">
                            Демоурок
                        </p>
                        <p class="careerum-free-materials-tile-header">
                            Как строить<br> карьеру в кризис
                        </p>
                        <p class="careerum-free-materials-tile-content">
                            Научитесь гибко реагировать<br> на меняющиеся обстоятельства<br> и «делать из лимонов лимонад»,<br> пока
                            другие сетуют на кризис
                        </p>
                        <a href="#" class="btn-color-main-light-blue">
                            Смотреть
                        </a>
                    </div>
                </div>
            </div>
        </div>`
    });

    blockManager.add('careerum-instagram-goals', {
        label: 'Инста цели',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-instagram-goals">
            <div>
                <h2>У вас есть цель, а у меня — три способа помочь вам ее достичь</h2>
                <div class="careerum-instagram-goals-tales">
                    <div>
                        <p class="careerum-instagram-goals-tale-header">
                            Careerum.Club 
                        </p>
                        <p class="careerum-instagram-goals-tale-subheader">
                            350+ часов учебных материалов, чтобы:
                        </p>
                        <ul>
                            <li>Найти работу мечты</li>
                            <li>Расти в должности<br> и зарплате</li>
                            <li>Переехать по работе<br> в страну мечты</li>
                        </ul>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1658788227468.svg" alt="">
                            <p class="careerum-instagram-goals-tale-subscription">
                                От 3 часов в неделю на обучение. Ежемесячная подписка от 8 900 ₽
                            </p>
                            <a href="#" class="btn-color-main-dark-orange">Присоединиться к клубу</a>
                        </div>
                    </div>
                    <div>
                        <p class="careerum-instagram-goals-tale-header">
                            Рассылка Careerum.Tips
                        </p>
                        <p class="careerum-instagram-goals-tale-subheader">70 полезных писем<br> о карьере, чтобы:</p>
                        <ul>
                            <li>Каждый понедельник получать заряд мотивации</li>
                            <li>Делать самостоятельные шаги к целям</li>
                        </ul>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1658788227468.svg" alt="">
                            <p class="careerum-instagram-goals-tale-subscription">
                                От 3 часов в неделю<br> на обучение. Ежемесячная подписка от 390 ₽
                            </p>
                            <a href="#" class="btn-color-main-light-orange">Получать советы</a>
                        </div>
                    </div>
                    <div>
                        <p class="careerum-instagram-goals-tale-header">
                            Личные консультации 
                        </p>
                        <p class="careerum-instagram-goals-tale-subheader">Персональная поддержка от меня, чтобы:</p>
                        <ul>
                            <li>Глубоко проработать<br> ваш запрос </li>
                            <li>Достичь любую, даже очень амбициозную, карьерную цель</li>
                        </ul>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1658788227468.svg" alt="">
                            <p class="careerum-instagram-goals-tale-subscription">
                                Пакет из 5 коуч-сессий —<br> 199 500 ₽. Каждая сессия длится 50 минут
                            </p>
                            <a href="#" class="btn-color-main-light-blue">Записаться</a>
                        </div>
                    </div>
                </div>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1658788264959.svg" alt="">
            </div>
        </div>`
    });
    
    blockManager.add('careerum-instagram-goals-tablet', {
        label: 'Инста цели (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-instagram-goals-tablet">
            <div>
                <h2>У вас есть цель,<br> а у меня — три способа<br> помочь вам ее достичь</h2>
                <div class="careerum-instagram-goals-tales">
                    <div>
                        <div>
                            <p class="careerum-instagram-goals-tale-header">
                                Careerum.<br>Club 
                            </p>
                            <p class="careerum-instagram-goals-tale-subheader">
                                350+ часов учебных материалов, чтобы:
                            </p>
                            <ul>
                                <li>Найти работу мечты</li>
                                <li>Расти в должности<br> и зарплате</li>
                                <li>Переехать по работе<br> в любую страну</li>
                            </ul>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1658788309746.svg" alt="" class="careerum-instagram-goals-tale-hr">
                                <p class="careerum-instagram-goals-tale-subscription">
                                    От 3 часов в неделю на обучение. Ежемесячная подписка от 8 900 ₽
                                </p>
                                <a href="#" class="btn-color-main-dark-orange">Присоединиться</a>
                            </div>
                        </div>
                        <div>
                            <p class="careerum-instagram-goals-tale-header">
                                Рассылка Careerum.Tips
                            </p>
                            <p class="careerum-instagram-goals-tale-subheader">70 полезных писем<br> о карьере, чтобы:</p>
                            <ul>
                                <li>Каждый понедельник получать заряд мотивации</li>
                                <li>Делать самостоятельные шаги к целям</li>
                            </ul>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1658788309746.svg" alt="" class="careerum-instagram-goals-tale-hr">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1658788337057.svg" alt="" class="careerum-instagram-goals-tale-bg">
                                <p class="careerum-instagram-goals-tale-subscription">
                                    От 3 часов в неделю<br> на обучение. Ежемесячная подписка от 390 ₽
                                </p>
                                <a href="#" class="btn-color-main-light-orange">Получать советы</a>
                            </div>
                        </div>
                        <div>
                            <p class="careerum-instagram-goals-tale-header">
                                Личные консультации 
                            </p>
                            <p class="careerum-instagram-goals-tale-subheader">Персональная<br> поддержка, чтобы:</p>
                            <ul>
                                <li>Глубоко проработать<br> ваш запрос </li>
                                <li>Достичь любую, даже очень амбициозную, карьерную цель</li>
                            </ul>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1658788309746.svg" alt="" class="careerum-instagram-goals-tale-hr">
                                <p class="careerum-instagram-goals-tale-subscription">
                                    Пакет из 5 коуч-сессий —<br> 199 500 ₽. Каждая сессия длится 50 минут
                                </p>
                                <a href="#" class="btn-color-main-light-blue">Подробнее</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
    });
    
    blockManager.add('careerum-instagram-goals-mobile', {
        label: 'Инста цели (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-instagram-goals-mobile">
            <div>
                <h2>У вас есть цель,<br> а у меня — три способа помочь<br> вам ее достичь</h2>
                <div class="careerum-instagram-goals-tales">
                    <div>
                        <div>
                            <p class="careerum-instagram-goals-tale-header">
                                Careerum.<br>Club
                            </p>
                            <p class="careerum-instagram-goals-tale-subheader">
                                350+ часов учебных материалов, чтобы:
                            </p>
                            <ul>
                                <li>Найти работу мечты</li>
                                <li>Расти в должности<br> и зарплате</li>
                                <li>Переехать по работе<br> в любую страну</li>
                            </ul>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1658788370813.svg" alt="" class="careerum-instagram-goals-tale-hr">
                                <p class="careerum-instagram-goals-tale-subscription">
                                    От 3 часов в неделю на обучение. Ежемесячная подписка от 8 900 ₽
                                </p>
                                <a href="#" class="btn-color-main-dark-orange">Присоединиться</a>
                            </div>
                        </div>
                        <div>
                            <p class="careerum-instagram-goals-tale-header">
                                Рассылка Careerum.Tips
                            </p>
                            <p class="careerum-instagram-goals-tale-subheader">70 полезных писем<br> о карьере, чтобы:</p>
                            <ul>
                                <li>Каждый понедельник получать заряд мотивации</li>
                                <li>Делать самостоятельные шаги к целям</li>
                            </ul>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1658788370813.svg" alt="" class="careerum-instagram-goals-tale-hr">
                                <p class="careerum-instagram-goals-tale-subscription">
                                    От 3 часов в неделю<br> на обучение. Ежемесячная подписка от 390 ₽
                                </p>
                                <a href="#" class="btn-color-main-light-orange">Получать советы</a>
                            </div>
                        </div>
                        <div>
                            <p class="careerum-instagram-goals-tale-header">
                                Личные консультации
                            </p>
                            <p class="careerum-instagram-goals-tale-subheader">Персональная<br> поддержка, чтобы:</p>
                            <ul>
                                <li>Глубоко проработать<br> ваш запрос </li>
                                <li>Достичь любую, даже очень амбициозную, карьерную цель</li>
                            </ul>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1658788370813.svg" alt="" class="careerum-instagram-goals-tale-hr">
                                <p class="careerum-instagram-goals-tale-subscription">
                                    Пакет из 5 коуч-сессий —<br> 199 500 ₽. Каждая сессия длится 50 минут
                                </p>
                                <a href="#" class="btn-color-main-light-blue">Подробнее</a>
                            </div>
                        </div>
                    </div>
                </div>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1658788403336.svg" alt="">
            </div>
        </div>`
    });

    blockManager.add('careerum-instagram-subscribe', {
        label: 'Инста подписка',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-instagram-subscribe">
            <div>
                <div>
                    <h2>Подпишитесь, смотрите<br> и читайте</h2>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1658788597244.svg" alt="">
                </div>
                <div>
                    <p><a href="#">YouTube-канал,</a> который помогает<br> менять карьеру на 180°</p>
                    <p><a href="#">Подкаст</a> о том, как не стать<br> «рабом» своей работы</p>
                    <p><a href="#">Telegram-бот Райан</a> — ваш очаровательный виртуальный проводник в мир Careerum</p>
                    <p><a href="#">Подробная история<br>моего карьерного пути</a> </p>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1658788620461.svg" alt="">
                    <p>Задать вопросы о Careerum —<br><a href="#">hello@careerum.ru</a></p>
                    <p>Предложить варианты сотрудничества —<br><a href="#">marketing@careerum.com</a></p>
                    <p>Узнать о вакансиях и стать<br> частью команды Careerum —<br><a href="#">career@careerum.com</a></p>
                </div>
            </div>
        </div>`
    });
    
    blockManager.add('careerum-instagram-subscribe-tablet', {
        label: 'Инста подписка (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-instagram-subscribe-tablet">
            <div>
                <div>
                    <h2>Подпишитесь, смотрите<br> и читайте</h2>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1658788656372.svg" alt="">
                </div>
                <div>
                    <p><a href="#">YouTube-канал,</a> который<br> помогает менять карьеру на 180°</p>
                    <p><a href="#">Подкаст</a> о том, как не стать<br> «рабом» своей работы</p>
                    <p><a href="#">Telegram-бот Райан</a> — ваш очаровательный виртуальный проводник в мир Careerum</p>
                    <p><a href="#">Подробная история<br>моего карьерного пути</a> </p>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1658788676751.svg" alt="">
                    <p>Задать вопросы о Careerum —<br><a href="#">hello@careerum.ru</a></p>
                    <p>Предложить варианты сотрудничества —<br><a href="#">marketing@careerum.com</a></p>
                    <p>Узнать о вакансиях и стать<br> частью команды Careerum —<br><a href="#">hr@careerum.com</a></p>
                </div>
            </div>
        </div>`
    });
    
    blockManager.add('careerum-instagram-subscribe-mobile', {
        label: 'Инста подписка (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-instagram-subscribe-mobile">
            <div>
                <div>
                    <h2>Подпишитесь, смотрите и читайте</h2>
                </div>
                <div>
                    <p><a href="#">YouTube-канал,</a> который<br> помогает менять карьеру на 180°</p>
                    <p><a href="#">Подкаст</a> о том, как не стать<br> «рабом» своей работы</p>
                    <p><a href="#">Telegram-бот Райан</a> — ваш очаровательный виртуальный проводник в мир Careerum</p>
                    <p><a href="#">Подробная история<br>моего карьерного пути</a> </p>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1658788719963.svg" alt=""></div>
                    <p>Задать вопросы о Careerum —<br><a href="#">hello@careerum.ru</a></p>
                    <p>Предложить варианты сотрудничества —<br><a href="#">marketing@careerum.com</a></p>
                    <p>Узнать о вакансиях и стать частью команды Careerum —<br><a href="#">hr@careerum.com</a></p>
                </div>
            </div>
        </div>`
    });
    
    blockManager.add('careerum-tips-main', {
        label: 'Tips главный',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-tips-main">
            <div>
                <h1>Careerum.Tips — 70 писем, которые помогут прийти <br>к карьерным целям</h1>
                <div><a href="" class="btn-color-main-bright-orange">Подписаться</a></div>
            </div>
        </div>`
	});

    blockManager.add('careerum-tips-main-tablet', {
        label: 'Tips главный (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-tips-main-tablet">
            <div>
                <h2>Careerum.Tips — 70 писем,<br> которые помогут прийти <br>к карьерным целям</h2>
                <div><a href="" class="btn-color-main-bright-orange">Подписаться</a></div>
            </div>
        </div>`
	});

    blockManager.add('careerum-tips-main-mobile', {
        label: 'Tips главный (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-tips-main-mobile">
            <div>
                <h2>Careerum.Tips — <br>70 писем, которые<br> помогут прийти <br>к карьерным<br> целям</h2>
                <div><a href="" class="btn-color-main-bright-orange">Подписаться</a></div>
            </div>
        </div>`
	});
    
    blockManager.add('careerum-tips-about', {
        label: 'Tips about',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-tips-about">
            <div>
                <h2>70 писем 
                    <span><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1658998583554.svg" alt=""></span>
                    70 еженедельных<br> карьерных уроков для тех, кто:</h2>
                <div>
                    <div><p>Стремится<br> к международной карьере в стране мечты</p></div>
                    <div><p>Хочет получить мотивацию на полтора года вперед</p></div>
                    <div><p>Понимает силу маленьких шагов и готов действовать</p></div>
                    <div><p>Идет к своей карьерной цели осознанно<br> и экологично</p></div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-tips-about-tablet', {
        label: 'Tips about (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-tips-about-tablet">
            <div>
                <h2>70 писем 
                    <span><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1658998561599.svg" alt=""></span>
                    70 еженедельных<br> карьерных уроков для тех, кто:</h2>
                <div>
                    <div><p>Стремится<br> к международной карьере в стране мечты</p></div>
                    <div><p>Хочет получить мотивацию<br> на полтора года вперед</p></div>
                    <div><p>Понимает силу маленьких шагов и готов действовать</p></div>
                    <div><p>Идет к своей карьерной цели осознанно<br> и экологично</p></div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-tips-about-mobile', {
        label: 'Tips about (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-tips-about-mobile">
            <div>
                <h2>70 писем 
                    <span><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1658998537500.svg" alt=""></span><br>
                    70 еженедельных<br> карьерных уроков<br> для тех, кто:</h2>
                <div>
                    <div>
                        <div><p>Стремится<br> к международной карьере в стране мечты</p></div>
                        <div><p>Хочет получить мотивацию на<br> полтора года вперед</p></div>
                        <div><p>Понимает силу маленьких шагов <br>и готов действовать</p></div>
                        <div><p>Идет к своей карьерной цели осознанно<br> и экологично</p></div>
                    </div>
                </div>
            </div>
        </div>`
	});
    
    blockManager.add('careerum-tips-tabs', {
        label: 'Tips табы',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-tips-tabs">
            <div>
                <h2>Более 10 000 читателей. Письма,<br> которые нравятся им больше всего</h2>
                <div class="careerum-tips-tabs-items">
                    <div class="careerum-tips-tabs-selectors">
                        <form action="">
                            <label class="active"><p>Найти работу</p><input type="radio" name="careerum-tips-radio"></label>
                            <label><p>Получить повышение</p><input type="radio" name="careerum-tips-radio"></label>
                            <label><p>Зарабатывать больше </p><input type="radio" name="careerum-tips-radio"></label>
                            <label><p>Переехать по работе</p><input type="radio" name="careerum-tips-radio"></label>
                            <label><p>Укрепить самооценку</p><input type="radio" name="careerum-tips-radio"></label>
                        </form>
                        <p>Это всего лишь фрагмент письма. Подпишитесь, чтобы прочитать все<br> 70 писем целиком</p>
                        <a href="" class="btn-color-main-bright-orange">Подписаться</a>
                    </div>
                    <div class="careerum-tips-tabs-content">
                        <div class="careerum-tips-tab" data-tab-id="Найти работу">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659001579946.svg" alt="">
                            <div class="careerum-tips-tab-text">
                                <p class="careerum-tips-tab-header">
                                    Что видит в вас руководитель:<br> <span class="careerum-tips-tab-header-blue">3 признака успешного кандидата</span>
                                </p>
                                <p class="careerum-tips-tab-body">Давайте разберем, чего руководители ждут от кандидатов и почему могут отказывать тем, кто, по мнению рекрутеров, подходит идеально.<br><br>Профессионализм. Прежде всего, начальник хочет быть уверен, что новый сотрудник справится со всем фронтом своих задач. Для босса это гарантия, что не придется самому переделывать за него работу, тратить много времени на обучение и т. д. <br><br>Расспрашивая кандидата о его опыте, он хочет понять, способен ли человек качественно выполнять конкретные задачи. Поэтому он отбирает соискателей, которые «заточены» под определенные функции. <br><br>Совет: подготовьте 5-10 историй о том, как вам удалось достичь хороших результатов, как вы выстраивали бизнес-процессы, с какими сложностями сталкивались раньше и как с ними справлялись. </p>
                            </div>
                            <div class="careerum-tips-tab-blur"></div>
                        </div>
                        <div class="careerum-tips-tab" data-tab-id="Получить повышение">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659001579946.svg" alt="">
                            <div class="careerum-tips-tab-text">
                                <p class="careerum-tips-tab-header">
                                    А еще кружок по фото,<br> а еще мне петь охота
                                </p>
                                <p class="careerum-tips-tab-body">Недавно одна читательница в Instagram задала мне вопрос:<br> «Ольга, как мне строить карьеру, если я увлекающийся человек и не могу выбрать одно-единственное дело?»<br><br>
    
                                    Во-первых, выдохнуть. Часто увлекающиеся люди паникуют, считая себя «какими-то не такими» из-за того, что не могут быть постоянно преданы одному делу. И напрасно. Писательница и мотивационный спикер Барбара Шер опубликовала несколько книг, которые стали настоящим откровением для таких людей. Они, наконец, поняли, что быть увлекающимся человеком — это нормально. А способность испытывать страсть ко множеству занятий — настоящий дар, а не проклятие. <br><br>
                                    
                                    Барбара даже нашла для таких людей подходящее определение — «сканеры». Потому что их стратегия — сканировать самые разные занятия, искать себя в разных сферах. «Сканер» может увлечься программированием, а через полгода с таким же азартом погрузиться в разведение комнатных растений. Он постоянно хочет попробовать новое, но при этом терзается чувством вины: «а это вообще норма</p>
                            </div>
                            <div class="careerum-tips-tab-blur"></div>
                        </div>
                        <div class="careerum-tips-tab" data-tab-id="Зарабатывать больше ">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659001579946.svg" alt="">
                            <div class="careerum-tips-tab-text">
                                <p class="careerum-tips-tab-header">
                                    4 шага, чтобы повысить свою<br> зарплату <span class="careerum-tips-tab-header-orange">в ближайшие месяцы</span></span>
                                </p>
                                <p class="careerum-tips-tab-body">Как часто бывает, что к концу февраля новогоднее желание поехать летом в Париж начинает казаться невыполнимым, и многие готовы с этим смириться. Но только не вы, правда? Вместо того чтобы терять мотивацию, лучше обойти конкурентов с помощью наших советов и повысить свою зарплату уже через несколько месяцев. <br><br> 
                                    1. Оцените свою стоимость на рынке труда. <br>
                                    Посмотрите, какие зарплаты указаны в вакансиях на работных сайтах. Отбирайте только вакансии на тот же уровень должности, с тем же функционалом и опытом работы, что и у вас, в компаниях такого же размера, как ваша. <br><br>                                 
                                    «Средняя температура по больнице» — это и есть объективная зарплата. Если вам сейчас платят меньше, то вы недооценены, а если больше, то поздравляю! В любом случае вашей зарплате всегда есть куда расти.</p>
                            </div>
                            <div class="careerum-tips-tab-blur"></div>
                        </div>
                        <div class="careerum-tips-tab" data-tab-id="Переехать по работе">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659001579946.svg" alt="">
                            <div class="careerum-tips-tab-text">
                                <p class="careerum-tips-tab-header">
                                    <span class="careerum-tips-tab-header-blue">Как заполнить профиль в LinkedIn,</span> чтобы<br> работодатели находили вас сами
                                </p>
                                <p class="careerum-tips-tab-body">«Ольга, вы часто говорите, что можно искать работу через LinkedIn. Я заполнила профиль, мне стали приходить оповещения о вакансиях, но они все нерелевантные для меня. Как сделать так, чтобы в этой соцсети мне предлагали только ту работу, которая мне нужна?». Такое письмо я получила на днях и решила рассказать, как заполнить профиль в LinkedIn правильно.<br><br>
    
                                    1. Определитесь со страной. <br>
                                    Если ваша цель — найти работу за границей, сразу создавайте профиль на английском.  Профили, изначально заполненные на русском, а потом переведенные на английский, переводятся не полностью, что снижает вашу видимость для иностранных работодателей.<br><br>2. Заполните профиль на 100%.<br> Обязательно заполните все поля, чтобы индикатор эффективности профиля на вашей странице полностью окрасился. Тогда рекрутеры увидят ее в результатах поиска выше страниц тех, кто не заполнил профиль до конца.<br><br>
                                    
                                    2. Позаботьтесь о первом впечатлении.<br>
                                    Не ставьте в профиль любую фотографию, на которой «Вроде неплохо вышли». Бокал или тарелка в руках, неестественная поза, слишком обтягивающая одежда, грустное или неуверенное выражение лица — все это может создать у hr-менеджера не то впечатление, на которое вы рассчитываете. 
                                    </p>
                            </div>
                            <div class="careerum-tips-tab-blur"></div>
                        </div>
                        <div class="careerum-tips-tab" data-tab-id="Укрепить самооценку">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659001579946.svg" alt="">
                            <div class="careerum-tips-tab-text">
                                <p class="careerum-tips-tab-header">
                                    6 шагов, чтобы отрастить<br> <span class="careerum-tips-tab-header-orange">здоровую самооценку</span>
                                </p>
                                <p class="careerum-tips-tab-body">Как часто я встречаю прекрасных профессионалов, которые продолжают считать себя «не очень» и думать, что все достижения — случайное стечение обстоятельств, а не их собственная заслуга.<br><br>
    
                                    Миллиардер и основатель компании Atlassian Майк Кэннон-Брукс на конференции TED рассказал, как он живёт с синдромом самозванца. Несмотря на успех компании (которая, кстати, сотрудничает с NASA), он продолжает сомневаться, что заслуживает признания: «Я до сих пор ожидаю, что однажды на пороге появится человек с черной папкой в руках и скажет, что всё кончено и меня разоблачили». <br><br>
                                    
                                    Вот видите, проблемы с самооценкой бывают даже у миллиардеров. Дело в том, что неуверенность часто не связана с нашей истинной ценностью или уровнем успеха. Причина в искаженных установках, которые были заложены в детстве или появились в результате прошлых ошибок. В моем подкасте я подробно рассказала о том, как низкая самооценка влияет на вашу карьеру. Послушайте.
                                    </p>
                            </div>
                            <div class="careerum-tips-tab-blur"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-tips-tabs-tablet', {
        label: 'Tips табы (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-tips-tabs-tablet">
            <div>
                <h2>Более 10 000 читателей. Письма,<br> которые нравятся им больше всего</h2>
                <div class="careerum-tips-tabs-items">
                    <div class="careerum-tips-tabs-selectors">
                        <form action="">
                            <label class="active"><p>Найти работу</p><input type="radio" name="careerum-tips-radio"></label>
                            <label><p>Получить повышение</p><input type="radio" name="careerum-tips-radio"></label>
                            <label><p>Зарабатывать больше </p><input type="radio" name="careerum-tips-radio"></label>
                            <label><p>Переехать по работе</p><input type="radio" name="careerum-tips-radio"></label>
                            <label><p>Укрепить самооценку</p><input type="radio" name="careerum-tips-radio"></label>
                        </form>
                    </div>
                    <div class="careerum-tips-tabs-content">
                        <div class="careerum-tips-tab" data-tab-id="Найти работу">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659001556230.svg" alt="">
                            <div class="careerum-tips-tab-text">
                                <p class="careerum-tips-tab-header">
                                    Что видит в вас руководитель:<br> <span class="careerum-tips-tab-header-blue">3 признака успешного кандидата</span>
                                </p>
                                <p class="careerum-tips-tab-body">Давайте разберем, чего руководители ждут от кандидатов и почему могут отказывать тем, кто, по мнению рекрутеров, подходит идеально.<br><br>Профессионализм. Прежде всего, начальник хочет быть уверен, что новый сотрудник справится со всем фронтом своих задач. Для босса это гарантия, что не придется самому переделывать за него работу, тратить много времени на обучение и т. д. <br><br>Расспрашивая кандидата о его опыте, он хочет понять, способен ли человек качественно выполнять конкретные задачи. Поэтому он отбирает соискателей, которые «заточены» под определенные функции. <br><br>Совет: подготовьте 5-10 историй о том, как вам удалось достичь хороших результатов, как вы выстраивали бизнес-процессы, с какими сложностями сталкивались раньше и как с ними справлялись. </p>
                            </div>
                            <div class="careerum-tips-tab-blur"></div>
                        </div>
                        <div class="careerum-tips-tab" data-tab-id="Получить повышение">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659001556230.svg" alt="">
                            <div class="careerum-tips-tab-text">
                                <p class="careerum-tips-tab-header">
                                    А еще кружок по фото,<br> а еще мне петь охота
                                </p>
                                <p class="careerum-tips-tab-body">Недавно одна читательница в Instagram задала мне вопрос:<br> «Ольга, как мне строить карьеру, если я увлекающийся человек и не могу выбрать одно-единственное дело?»<br><br>
    
                                    Во-первых, выдохнуть. Часто увлекающиеся люди паникуют, считая себя «какими-то не такими» из-за того, что не могут быть постоянно преданы одному делу. И напрасно. Писательница и мотивационный спикер Барбара Шер опубликовала несколько книг, которые стали настоящим откровением для таких людей. Они, наконец, поняли, что быть увлекающимся человеком — это нормально. А способность испытывать страсть ко множеству занятий — настоящий дар, а не проклятие. <br><br>
                                    
                                    Барбара даже нашла для таких людей подходящее определение — «сканеры». Потому что их стратегия — сканировать самые разные занятия, искать себя в разных сферах. «Сканер» может увлечься программированием, а через полгода с таким же азартом погрузиться в разведение комнатных растений. Он постоянно хочет попробовать новое, но при этом терзается чувством вины: «а это вообще норма</p>
                            </div>
                            <div class="careerum-tips-tab-blur"></div>
                        </div>
                        <div class="careerum-tips-tab" data-tab-id="Зарабатывать больше ">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659001556230.svg" alt="">
                            <div class="careerum-tips-tab-text">
                                <p class="careerum-tips-tab-header">
                                    4 шага, чтобы повысить свою<br> зарплату <span class="careerum-tips-tab-header-orange">в ближайшие месяцы</span></span>
                                </p>
                                <p class="careerum-tips-tab-body">Как часто бывает, что к концу февраля новогоднее желание поехать летом в Париж начинает казаться невыполнимым, и многие готовы с этим смириться. Но только не вы, правда? Вместо того чтобы терять мотивацию, лучше обойти конкурентов с помощью наших советов и повысить свою зарплату уже через несколько месяцев. <br><br> 
                                    1. Оцените свою стоимость на рынке труда. <br>
                                    Посмотрите, какие зарплаты указаны в вакансиях на работных сайтах. Отбирайте только вакансии на тот же уровень должности, с тем же функционалом и опытом работы, что и у вас, в компаниях такого же размера, как ваша. <br><br>                                 
                                    «Средняя температура по больнице» — это и есть объективная зарплата. Если вам сейчас платят меньше, то вы недооценены, а если больше, то поздравляю! В любом случае вашей зарплате всегда есть куда расти.</p>
                            </div>
                            <div class="careerum-tips-tab-blur"></div>
                        </div>
                        <div class="careerum-tips-tab" data-tab-id="Переехать по работе">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659001556230.svg" alt="">
                            <div class="careerum-tips-tab-text">
                                <p class="careerum-tips-tab-header">
                                    <span class="careerum-tips-tab-header-blue">Как заполнить профиль в LinkedIn,</span> чтобы<br> работодатели находили вас сами
                                </p>
                                <p class="careerum-tips-tab-body">«Ольга, вы часто говорите, что можно искать работу через LinkedIn. Я заполнила профиль, мне стали приходить оповещения о вакансиях, но они все нерелевантные для меня. Как сделать так, чтобы в этой соцсети мне предлагали только ту работу, которая мне нужна?». Такое письмо я получила на днях и решила рассказать, как заполнить профиль в LinkedIn правильно.<br><br>
    
                                    1. Определитесь со страной. <br>
                                    Если ваша цель — найти работу за границей, сразу создавайте профиль на английском.  Профили, изначально заполненные на русском, а потом переведенные на английский, переводятся не полностью, что снижает вашу видимость для иностранных работодателей.<br><br>2. Заполните профиль на 100%.<br> Обязательно заполните все поля, чтобы индикатор эффективности профиля на вашей странице полностью окрасился. Тогда рекрутеры увидят ее в результатах поиска выше страниц тех, кто не заполнил профиль до конца.<br><br>
                                    
                                    2. Позаботьтесь о первом впечатлении.<br>
                                    Не ставьте в профиль любую фотографию, на которой «Вроде неплохо вышли». Бокал или тарелка в руках, неестественная поза, слишком обтягивающая одежда, грустное или неуверенное выражение лица — все это может создать у hr-менеджера не то впечатление, на которое вы рассчитываете. 
                                    </p>
                            </div>
                            <div class="careerum-tips-tab-blur"></div>
                        </div>
                        <div class="careerum-tips-tab" data-tab-id="Укрепить самооценку">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659001556230.svg" alt="">
                            <div class="careerum-tips-tab-text">
                                <p class="careerum-tips-tab-header">
                                    6 шагов, чтобы отрастить<br> <span class="careerum-tips-tab-header-orange">здоровую самооценку</span>
                                </p>
                                <p class="careerum-tips-tab-body">Как часто я встречаю прекрасных профессионалов, которые продолжают считать себя «не очень» и думать, что все достижения — случайное стечение обстоятельств, а не их собственная заслуга.<br><br>
    
                                    Миллиардер и основатель компании Atlassian Майк Кэннон-Брукс на конференции TED рассказал, как он живёт с синдромом самозванца. Несмотря на успех компании (которая, кстати, сотрудничает с NASA), он продолжает сомневаться, что заслуживает признания: «Я до сих пор ожидаю, что однажды на пороге появится человек с черной папкой в руках и скажет, что всё кончено и меня разоблачили». <br><br>
                                    
                                    Вот видите, проблемы с самооценкой бывают даже у миллиардеров. Дело в том, что неуверенность часто не связана с нашей истинной ценностью или уровнем успеха. Причина в искаженных установках, которые были заложены в детстве или появились в результате прошлых ошибок. В моем подкасте я подробно рассказала о том, как низкая самооценка влияет на вашу карьеру. Послушайте.
                                    </p>
                            </div>
                            <div class="careerum-tips-tab-blur"></div>
                        </div>
                    </div>
                    
                    <p>Это всего лишь фрагмент письма.<br> Подпишитесь, чтобы прочитать все 70 писем целиком</p>
                    <a href="" class="btn-color-main-bright-orange">Подписаться</a>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-tips-tabs-mobile', {
        label: 'Tips табы (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-tips-tabs-mobile">
            <div>
                <h2>Более 10 000<br> читателей. Письма,<br> которые нравятся<br> им больше всего</h2>
                <div class="careerum-tips-tabs-items">
                    <div class="careerum-tips-tabs-selectors">
                        <form action="">
                            <label class="active"><p>Найти работу</p><input type="radio" name="careerum-tips-radio"></label>
                            <label><p>Получить повышение</p><input type="radio" name="careerum-tips-radio"></label>
                            <label><p>Зарабатывать больше </p><input type="radio" name="careerum-tips-radio"></label>
                            <label><p>Переехать по работе</p><input type="radio" name="careerum-tips-radio"></label>
                            <label><p>Укрепить самооценку</p><input type="radio" name="careerum-tips-radio"></label>
                        </form>
                    </div>
                    <div class="careerum-tips-tabs-content">
                        <div class="careerum-tips-tab" data-tab-id="Найти работу">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659001489888.svg" alt="">
                            <div class="careerum-tips-tab-text">
                                <p class="careerum-tips-tab-header">
                                    Что видит в вас<br> руководитель:<br> <span class="careerum-tips-tab-header-blue">3 признака успешного<br> кандидата</span>
                                </p>
                                <p class="careerum-tips-tab-body">Давайте разберем, чего руководители<br> ждут от кандидатов и почему могут<br> отказывать тем, кто, по мнению<br> рекрутеров, подходит идеально.<br><br>Профессионализм. Прежде всего,<br> начальник хочет быть уверен, что новый<br> сотрудник справится со всем фронтом<br> своих задач. Для босса это гарантия, что<br> не придется самому переделывать за него<br> работу, тратить много времени<br> на обучение и т. д. <br><br>Расспрашивая кандидата о его опыте, он<br> хочет понять, способен ли человек<br> качественно выполнять конкретные<br> задачи. </p>
                            </div>
                            <div class="careerum-tips-tab-blur"></div>
                        </div>
                        <div class="careerum-tips-tab" data-tab-id="Получить повышение">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659001489888.svg" alt="">
                            <div class="careerum-tips-tab-text">
                                <p class="careerum-tips-tab-header">
                                    А еще кружок по фото,<br> а еще мне петь охота
                                </p>
                                <p class="careerum-tips-tab-body">Недавно одна читательница в Instagram задала мне вопрос:<br> «Ольга, как мне строить карьеру, если я увлекающийся человек и не могу выбрать одно-единственное дело?»<br><br>
    
                                    Во-первых, выдохнуть. Часто увлекающиеся люди паникуют, считая себя «какими-то не такими» из-за того, что не могут быть постоянно преданы одному делу. И напрасно. Писательница и мотивационный спикер Барбара Шер опубликовала несколько книг, которые стали настоящим откровением для таких людей. Они, наконец, поняли, что быть увлекающимся человеком — это нормально.<br> А способность испытывать страсть ко множеству занятий — настоящий дар, а не проклятие. <br><br>
                                    
                                    Барбара даже нашла для таких людей подходящее определение — «сканеры». Потому что их стратегия — сканировать самые разные занятия, искать себя в разных сферах. «Сканер» может увлечься программированием, а через полгода с таким же азартом погрузиться в разведение комнатных растений. Он постоянно хочет попробовать новое, но при этом терзается чувством вины: «а это вообще норма</p>
                            </div>
                            <div class="careerum-tips-tab-blur"></div>
                        </div>
                        <div class="careerum-tips-tab" data-tab-id="Зарабатывать больше ">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659001489888.svg" alt="">
                            <div class="careerum-tips-tab-text">
                                <p class="careerum-tips-tab-header">
                                    4 шага, чтобы повысить<br> свою зарплату <br><span class="careerum-tips-tab-header-orange">в ближайшие месяцы</span></span>
                                </p>
                                <p class="careerum-tips-tab-body">Как часто бывает, что к концу февраля новогоднее желание поехать летом в Париж начинает казаться невыполнимым, и многие готовы с этим смириться. Но только не вы, правда? Вместо того чтобы терять мотивацию, лучше обойти конкурентов с помощью наших советов и повысить свою зарплату уже через несколько месяцев. <br><br> 
                                    1. Оцените свою стоимость на рынке труда. <br>
                                    Посмотрите, какие зарплаты указаны<br> в вакансиях на работных сайтах. Отбирайте только вакансии на тот же уровень должности, с тем же функционалом и опытом работы, что<br> и у вас, в компаниях такого же размера, как ваша. <br><br>                                 
                                    «Средняя температура по больнице» — это и есть объективная зарплата. Если вам сейчас платят меньше, то вы недооценены, а если больше, то поздравляю! В любом случае вашей зарплате всегда есть куда расти.</p>
                            </div>
                            <div class="careerum-tips-tab-blur"></div>
                        </div>
                        <div class="careerum-tips-tab" data-tab-id="Переехать по работе">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659001489888.svg" alt="">
                            <div class="careerum-tips-tab-text">
                                <p class="careerum-tips-tab-header">
                                    <span class="careerum-tips-tab-header-blue">Как заполнить профиль<br> в LinkedIn,</span> чтобы<br> работодатели<br> находили вас сами
                                </p>
                                <p class="careerum-tips-tab-body">«Ольга, вы часто говорите, что можно искать работу через LinkedIn. Я заполнила профиль, мне стали приходить оповещения о<br> вакансиях, но они все нерелевантные для меня. Как сделать так, чтобы в этой соцсети мне предлагали только ту работу, которая<br> мне нужна?». Такое письмо я получила<br> на днях и решила рассказать, как заполнить профиль в LinkedIn правильно.<br><br>
    
                                    1. Определитесь со страной. <br>
                                    Если ваша цель — найти работу за границей, сразу создавайте профиль на английском.  Профили, изначально заполненные на русском, а потом переведенные на английский, переводятся не полностью, что снижает вашу видимость для иностранных работодателей.<br><br>2. Заполните профиль на 100%.<br> Обязательно заполните все поля, чтобы индикатор эффективности профиля на вашей странице полностью окрасился. Тогда рекрутеры увидят ее в результатах поиска выше страниц тех, кто не заполнил профиль до конца.<br><br>
                                    
                                    </p>
                            </div>
                            <div class="careerum-tips-tab-blur"></div>
                        </div>
                        <div class="careerum-tips-tab" data-tab-id="Укрепить самооценку">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659001489888.svg" alt="">
                            <div class="careerum-tips-tab-text">
                                <p class="careerum-tips-tab-header">
                                    6 шагов, чтобы отрастить<br> <span class="careerum-tips-tab-header-orange">здоровую самооценку</span>
                                </p>
                                <p class="careerum-tips-tab-body">Как часто я встречаю прекрасных профессионалов, которые продолжают считать себя «не очень» и думать, что все достижения — случайное стечение обстоятельств, а не их собственная заслуга.<br><br>
    
                                    Миллиардер и основатель компании Atlassian Майк Кэннон-Брукс на конференции TED рассказал, как он живёт с синдромом самозванца. Несмотря на успех компании (которая, кстати, сотрудничает с NASA), он продолжает сомневаться, что заслуживает признания: «Я до сих пор ожидаю, что однажды на пороге появится человек с черной папкой в руках и скажет, что всё кончено и меня разоблачили». <br><br>
                                    
                                    Вот видите, проблемы с самооценкой бывают даже у миллиардеров. Дело в том, что неуверенность часто не связана с нашей истинной ценностью или уровнем успеха. Причина в искаженных установках, которые были заложены в детстве или появились в результате прошлых ошибок. В моем подкасте я подробно рассказала о том, как низкая самооценка влияет на вашу карьеру. Послушайте.
                                    </p>
                            </div>
                            <div class="careerum-tips-tab-blur"></div>
                        </div>
                    </div>
                    
                    <p>Это всего лишь фрагмент письма.<br> Подпишитесь, чтобы прочитать все<br> 70 писем целиком</p>
                    <a href="" class="btn-color-main-bright-orange">Подписаться</a>
                </div>
            </div>
        </div>`
	});
    
    blockManager.add('careerum-tips-subscribe', {
        label: 'Tips форма',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-tips-subscribe">
            <div>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659002032917.svg" alt="">
                <div class="careerum-getcourse-email-form-2-fields">
                    <div class="careerum-form-tab-item-2-fields">
                        <div>
                            <h3>Получите письмо<br> Careerum.Tips<br> бесплатно</h3>
                            <p>Оставьте адрес электронной почты, и мы<br> пришлем вам одно из карьерных писем, чтобы<br> вам проще было принять решение о подписке</p>
                        </div>
                        <div class="careerum-registration-form">
                            <form class="deva-form getcourse-email-signup" name="devaRegistrationForm" data-gjs-type="deva-registration-form">
                                <div>
                                    <div class="careerum-form-tab-item-2-fields-field-name">
                                        <input type="text" name="name" value="" required>
                                        <span>Имя</span>
                                    </div>
                                    <div class="careerum-form-tab-item-2-fields-field-email">
                                        <input type="email" name="email" value="" required>
                                        <span>Почта</span>
                                    </div>
                                </div>
                                <div class="careerum-form-tab-item-2-fields-field-agree">
                                    <input type="checkbox" name="" id="carerum-form-agr">
                                    <label data-toggle-checkbox="true"></label>
                                    <p>Я даю согласие на обработку моих персональных данных в соотвествии <br>с <a href="#">Политикой конфиденциальности</a>
                                </div>
                                <a href="#" disabled class="submit-btn">Получить письмо</a>
                            </form>
                        </div>
                    </div>
                    <div class="careerum-form-success-tab-item">
                        <div>
                            <h3>Бесплатное письмо<br> Careerum.Tips<br> уже у вас на почте</h3>
                        </div>                    
                    </div>                    
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-tips-subscribe-tablet', {
        label: 'Tips форма (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-tips-subscribe-tablet">
            <div>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659001982344.svg" alt="">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659002006935.svg" alt="">
                <div>
                <div class="careerum-getcourse-email-form-2-fields-tablet">
                    <div class="careerum-form-tab-item-2-fields-tablet">
                        <div>
                            <h3>Получите письмо<br> Careerum.Tips<br> бесплатно</h3>
                            <p>Оставьте адрес электронной почты, и мы пришлем <br>вам одно из карьерных писем, чтобы вам проще было<br> принять решение о подписке</p>
                        </div>
                        <div class="careerum-registration-form-tablet">
                            <form class="deva-form getcourse-email-signup" name="devaRegistrationForm" data-gjs-type="deva-registration-form">
                                <div>
                                    <div class="careerum-form-tab-item-2-fields-field-name">
                                        <input type="text" name="name" value="" required>
                                        <span>Имя</span>
                                    </div>
                                    <div class="careerum-form-tab-item-2-fields-field-email">
                                        <input type="email" name="email" value="" required>
                                        <span>Почта</span>
                                    </div>
                                </div>
                                <div class="careerum-form-tab-item-2-fields-field-agree">
                                    <input type="checkbox" name="" id="carerum-form-agr">
                                    <label data-toggle-checkbox="true"></label>
                                    <p>Я даю согласие на обработку моих персональных данных в соотвествии <br>с <a href="#">Политикой конфиденциальности</a>
                                </div>
                                <a href="#" disabled class="submit-btn">Получить письмо</a>
                            </form>
                        </div>
                    </div>
                    <div class="careerum-form-success-tab-item-tablet">
                        <div>
                            <h3>Бесплатное письмо<br> Careerum.Tips<br> уже у вас на почте</h3>
                        </div>
                        
                    </div>
                </div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-tips-subscribe-mobile', {
        label: 'Tips форма (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-tips-subscribe-mobile">
            <div>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659001927233.svg" alt="">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659001958110.svg" alt="">
                <div>
                    <div class="careerum-getcourse-email-form-2-fields-mobile">
                        <div class="careerum-form-tab-item-2-fields-mobile">
                            <div>
                                <h3>Получите письмо<br> Careerum.Tips<br> бесплатно</h3>
                                <p>Оставьте адрес электронной почты,<br> и мы пришлем вам одно из<br> карьерных писем, чтобы вам проще было принять решение о подписке</p>
                            </div>
                            <div class="careerum-registration-form-mobile">
                                <form class="deva-form getcourse-email-signup" name="devaRegistrationForm" data-gjs-type="deva-registration-form">
                                    <div>
                                        <div class="careerum-form-tab-item-2-fields-field-name">
                                            <input type="text" name="name" value="" required>
                                            <span>Имя</span>
                                        </div>
                                        <div class="careerum-form-tab-item-2-fields-field-email">
                                            <input type="email" name="email" value="" required>
                                            <span>Почта</span>
                                        </div>
                                    </div>
                                    <div class="careerum-form-tab-item-2-fields-field-agree">
                                        <input type="checkbox" name="" id="carerum-form-agr">
                                        <label data-toggle-checkbox="true"></label>
                                        <p>Я даю согласие на обработку своих персональных данных в соотвествии <br>с <a href="#">Политикой конфиденциальности</a>
                                    </div>
                                    <a href="#" disabled class="submit-btn">Получить письмо</a>
                                </form>
                            </div>
                        </div>
                        <div class="careerum-form-success-tab-item-mobile">
                            <div>
                                <h3>Бесплатное письмо<br> Careerum.Tips<br> уже у вас на почте</h3>
                            </div>
                            
                        </div>
                    </div>
                </div>
            </div>
        </div>`
	});
    
    blockManager.add('careerum-getcourse-email-form-2-fields', {
        label: 'Лид форма 2 поля',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-getcourse-email-form-2-fields">
            <div class="careerum-form-tab-item-2-fields">
                <div>
                    <h3>Получите письмо<br> Careerum.Tips<br> бесплатно</h3>
                    <p>Оставьте адрес электронной почты, и мы<br> пришлем вам одно из карьерных писем, чтобы<br> вам проще было принять решение о подписке</p>
                </div>
                <div class="careerum-registration-form">
                    <form class="deva-form getcourse-email-signup" name="devaRegistrationForm" data-gjs-type="deva-registration-form">
                        <div>
                            <div class="careerum-form-tab-item-2-fields-field-name">
                                <input name="name" type="text" value="" required>
                                <span>Имя</span>
                            </div>
                            <div class="careerum-form-tab-item-2-fields-field-email">
                                <input name="email" type="email" value="" required>
                                <span>Почта</span>
                            </div>
                        </div>
                        <div class="careerum-form-tab-item-2-fields-field-agree">
                            <input type="checkbox" name="" id="carerum-form-agr">
                            <label data-toggle-checkbox="true"></label>
                            <p>Я даю согласие на обработку моих персональных данных в соотвествии <br>с <a href="#">Политикой конфиденциальности</a>
                        </div>
                        <a href="#" disabled class="submit-btn">Получить письмо</a>
                    </form>
                </div>
            </div>
            <div class="careerum-form-success-tab-item">
                <div>
                    <h3>Письмо с ссылкой для скачивания<br> уже у вас на почте</h3>
                </div>
                
            </div>
        </div>`
	});

    blockManager.add('careerum-getcourse-email-form-2-fields-tablet', {
        label: 'Лид форма 2 поля (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-getcourse-email-form-2-fields-tablet">
            <div class="careerum-form-tab-item-2-fields-tablet">
                <div>
                    <h3>Получите письмо<br> Careerum.Tips<br> бесплатно</h3>
                    <p>Оставьте адрес электронной почты, и мы пришлем <br>вам одно из карьерных писем, чтобы вам проще было<br> принять решение о подписке</p>
                </div>
                <div class="careerum-registration-form-tablet">
                    <form class="deva-form getcourse-email-signup" name="devaRegistrationForm" data-gjs-type="deva-registration-form">
                        <div>
                            <div class="careerum-form-tab-item-2-fields-field-name">
                                <input name="name" type="text" value="" required>
                                <span>Имя</span>
                            </div>
                            <div class="careerum-form-tab-item-2-fields-field-email">
                                <input name="email" type="email" value="" required>
                                <span>Почта</span>
                            </div>
                        </div>
                        <div class="careerum-form-tab-item-2-fields-field-agree">
                            <input type="checkbox" name="" id="carerum-form-agr">
                            <label data-toggle-checkbox="true"></label>
                            <p>Я даю согласие на обработку моих персональных данных в соотвествии <br>с <a href="#">Политикой конфиденциальности</a>
                        </div>
                        <a href="#" disabled class="submit-btn">Получить письмо</a>
                    </form>
                </div>
            </div>
            <div class="careerum-form-success-tab-item-tablet">
                <div>
                    <h3>Письмо с ссылкой<br> для скачивания<br> уже у вас на почте</h3>
                </div>
                
            </div>
        </div>`
	});

    blockManager.add('careerum-getcourse-email-form-2-fields-mobile', {
        label: 'Лид форма 2 поля (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-getcourse-email-form-2-fields-mobile">
                <div class="careerum-form-tab-item-2-fields-mobile">
                    <div>
                        <h3>Получите письмо<br> Careerum.Tips<br> бесплатно</h3>
                        <p>Оставьте адрес электронной почты,<br> и мы пришлем вам одно из<br> карьерных писем, чтобы вам проще было принять решение о подписке</p>
                    </div>
                    <div class="careerum-registration-form-mobile">
                        <form class="deva-form getcourse-email-signup" name="devaRegistrationForm" data-gjs-type="deva-registration-form">
                            <div>
                                <div class="careerum-form-tab-item-2-fields-field-name">
                                    <input name="name" type="text" value="" required>
                                    <span>Имя</span>
                                </div>
                                <div class="careerum-form-tab-item-2-fields-field-email">
                                    <input name="email" type="email" value="" required>
                                    <span>Почта</span>
                                </div>
                            </div>
                            <div class="careerum-form-tab-item-2-fields-field-agree">
                                <input type="checkbox" name="" id="carerum-form-agr">
                                <label data-toggle-checkbox="true"></label>
                                <p>Я даю согласие на обработку своих персональных данных в соотвествии <br>с <a href="#">Политикой конфиденциальности</a>
                            </div>
                            <a href="#" disabled class="submit-btn">Получить письмо</a>
                        </form>
                    </div>
                </div>
                <div class="careerum-form-success-tab-item-mobile">
                    <div>
                        <h3>Письмо с ссылкой<br> для скачивания<br> уже у вас на почте</h3>
                    </div>
                </div>
        </div>`
	});

    
    
    blockManager.add('careerum-getcourse-email-form-3-fields', {
        label: 'Лид форма 3 поля',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-getcourse-email-form-3-fields">
            <div class="careerum-form-tab-item-3-fields-block">
                <div>
                    <h3>Забронируйте свое <br>место в Careerum.Club</h3>
                    <p>Сейчас в клубе учится максимальное количество<br> участников. Оставьте заявку, а мы пригласим вас,<br> как только появится место. В среднем ожидание<br> занимает 2 дня.<br> Укажите ваш e-mail и номер телефона.</p>
                </div>
                <div class="careerum-registration-form">
                    <form class="deva-form getcourse-email-signup" name="devaRegistrationForm" data-gjs-type="deva-registration-form">
                        <div>
                            <div class="careerum-form-tab-item-3-fields-field-name">
                                <input type="text" name="name" value="" required>
                                <span>Имя</span>
                            </div>
                            <div class="careerum-form-tab-item-3-fields-field-email">
                                <input type="text" name="email" value="" required>
                                <span>Почта</span>
                            </div>
                            <div class="careerum-form-tab-item-3-fields-field-tel">
                                <input value="" required class="itl-input">
                            </div>
                        </div>
                        <input type="hidden" class="itl-input-number">
                        <div class="careerum-form-tab-item-3-fields-field-agree">
                            <input type="checkbox" name="">
                            <label data-toggle-checkbox="true"></label>
                            <p>Я даю согласие на обработку моих персональных данных в соотвествии <br>с <a
                                    href="#">Политикой конфиденциальности</a>
                        </div>
                        <a href="#" disabled class="submit-btn">Получить демоурок</a>
                    </form>
                </div>
            </div>
            <div class="careerum-form-success-tab-item">
                <div>
                    <h3>Бесплатное письмо<br> Careerum.Tips<br> уже у вас на почте</h3>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-getcourse-email-form-3-fields-tablet', {
        label: 'Лид форма 3 поля (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-getcourse-email-form-3-fields-tablet">
            <div class="careerum-form-tab-item-3-fields-block-tablet">
                <div>
                    <h3>Забронируйте свое <br>место в Careerum.Club</h3>
                    <p>Сейчас в клубе учится максимальное количество<br> участников. Оставьте заявку, а мы пригласим вас,<br> как только появится место. В среднем ожидание<br> занимает 2 дня.<br> Укажите ваш e-mail и номер телефона.</p>
                </div>
                <div class="careerum-registration-form-tablet">
                    <form class="deva-form getcourse-email-signup" name="devaRegistrationForm" data-gjs-type="deva-registration-form">
                        <div>
                            <div class="careerum-form-tab-item-3-fields-field-name">
                                <input type="text" name="name" value="" required>
                                <span>Имя</span>
                            </div>
                            <div class="careerum-form-tab-item-3-fields-field-email">
                                <input type="text" name="email" value="" required>
                                <span>Почта</span>
                            </div>
                            <div class="careerum-form-tab-item-3-fields-field-tel">
                                <input value="" required class="itl-input">
                            </div>
                        </div>
                        <input type="hidden" class="itl-input-number">
                        <div class="careerum-form-tab-item-3-fields-field-agree">
                            <input type="checkbox" name="">
                            <label data-toggle-checkbox="true"></label>
                            <p>Я даю согласие на обработку моих персональных данных в соотвествии <br>с <a
                                    href="#">Политикой конфиденциальности</a>
                        </div>
                        <a href="#" disabled class="submit-btn">Получить демоурок</a>
                    </form>
                </div>
            </div>
            <div class="careerum-form-success-tab-item-tablet">
                <div>
                    <h3>Письмо с ссылкой<br> для скачивания<br> уже у вас на почте</h3>
                </div>
                
            </div>
        </div>`
	});

    blockManager.add('careerum-getcourse-email-form-3-fields-mobile', {
        label: 'Лид форма 3 поля (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-getcourse-email-form-3-fields-mobile">
            <div class="careerum-form-tab-item-3-fields-block-mobile">
                <div>
                    <h3>Забронируйте свое <br>место в Careerum.Club</h3>
                    <p>Сейчас в клубе учится максимальное количество участников. Оставьте<br> заявку, а мы пригласим вас, как только появится место. В среднем ожидание занимает 2 дня.<br> Укажите ваш e-mail и номер телефона.</p>
                </div>
                <div class="careerum-registration-form-mobile">
                    <form class="deva-form getcourse-email-signup" name="devaRegistrationForm" data-gjs-type="deva-registration-form">
                        <div>
                            <div class="careerum-form-tab-item-3-fields-field-name">
                                <input type="text" name="name" value="" required>
                                <span>Имя</span>
                            </div>
                            <div class="careerum-form-tab-item-3-fields-field-email">
                                <input type="text" name="email" value="" required>
                                <span>Почта</span>
                            </div>
                            <div class="careerum-form-tab-item-3-fields-field-tel">
                                <input value="" required class="itl-input">
                            </div>
                        </div>
                        <input type="hidden" class="itl-input-number">
                        <div class="careerum-form-tab-item-3-fields-field-agree">
                            <input type="checkbox" name="">
                            <label data-toggle-checkbox="true"></label>
                            <p>Я даю согласие на обработку моих персональных данных в соотвествии <br>с <a
                                    href="#">Политикой конфиденциальности</a>
                        </div>
                        <a href="#" disabled class="submit-btn">Получить демоурок</a>
                    </form>
                </div>
            </div>
            <div class="careerum-form-success-tab-item-mobile">
                <div>
                    <h3>Письмо с ссылкой<br> для скачивания<br> уже у вас на почте</h3>
                </div>
            </div>
        </div>`
	});
    
    blockManager.add('careerum-tips-tariffs', {
        label: 'Tips тарифы',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div>
        <div class="careerum-tips-tariffs" hide-by-geo="russia">
            <div>
                <div>
                    <div>
                        <h2>Выберите удобный формат подписки</h2>
                    </div>
                    <div>
                        <div class="careerum-new-geochanger">
                            <div>
                                <div>                                
                                    <label class="geo-new-label">
                                        <p>EUR</p>
                                        <input type="checkbox">
                                        <div class="geo-new-changer">
                                            <p data-currency="Russia" class="geo-selector">RUB</p>
                                        </div>
                                    </label>                                
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="careerum-tips-tariffs-wrapper">
                    <div>
                        <p class="careerum-tariffs-subheader">
                            Порциями
                        </p>
                        <p class="careerum-tariffs-header"><span>4 письма</span><br>на 1 месяц</p>
                        <p>Оплатите 4 письма, чтобы попробовать. </p>
                        <p>Письма будут приходить каждый понедельник в течение месяца. Если захотите продлить подписку — просто оплатите следующий месяц.</p>
                        <div>
                            <div>
                                <p class="careerum-tariffs-price">390 €</p>
                                <p class="careerum-tariffs-price-per-item">97 € за письмо</p>
                            </div>
                            <a href="#" class="btn-color-main-bright-orange">Платить ежемесячно</a>
                        </div>
                    </div>
                    <div>
                        <p class="careerum-tariffs-subheader">
                            Все письма
                        </p>
                        <p class="careerum-tariffs-header"><span>70 писем</span><br>на 18 месяцев</p>
                        <p>Оплатите все 70 писем сразу — это выгоднее, чем оплачивать подписку помесячно. </p>
                        <p>Письма будут приходить каждый понедельник в течение полутора лет.</p>
                        <div>
                            <div>
                                <p class="careerum-tariffs-price">4 900 €</p>
                                <p class="careerum-tariffs-price-per-item">70 € за письмо</p>
                            </div>
                            <a href="#" class="btn-color-main-bright-orange">Оплатить все сразу</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="careerum-tips-tariffs" hide-by-geo="not_russia">
            <div>
                <div>
                    <div>
                        <h2>Выберите удобный формат подписки</h2>
                    </div>
                    <div>
                        <div class="careerum-new-geochanger">
                            <div>
                                <div>                                
                                    <label class="geo-new-label">
                                        <p>RUB</p>
                                        <input type="checkbox">
                                        <div class="geo-new-changer">
                                            <p data-currency="Other" class="geo-selector">EUR</p>
                                        </div>
                                    </label>                                
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="careerum-tips-tariffs-wrapper">
                    <div>
                        <p class="careerum-tariffs-subheader">
                            Порциями
                        </p>
                        <p class="careerum-tariffs-header"><span>4 письма</span><br>на 1 месяц</p>
                        <p>Оплатите 4 письма, чтобы попробовать. </p>
                        <p>Письма будут приходить каждый понедельник в течение месяца. Если захотите продлить подписку — просто оплатите следующий месяц.</p>
                        <div>
                            <div>
                                <p class="careerum-tariffs-price">390 ₽</p>
                                <p class="careerum-tariffs-price-per-item">97 ₽ за письмо</p>
                            </div>
                            <a href="#" class="btn-color-main-bright-orange">Платить ежемесячно</a>
                        </div>
                    </div>
                    <div>
                        <p class="careerum-tariffs-subheader">
                            Все письма
                        </p>
                        <p class="careerum-tariffs-header"><span>70 писем</span><br>на 18 месяцев</p>
                        <p>Оплатите все 70 писем сразу — это выгоднее, чем оплачивать подписку помесячно. </p>
                        <p>Письма будут приходить каждый понедельник в течение полутора лет.</p>
                        <div>
                            <div>
                                <p class="careerum-tariffs-price">4 900 ₽</p>
                                <p class="careerum-tariffs-price-per-item">70 ₽ за письмо</p>
                            </div>
                            <a href="#" class="btn-color-main-bright-orange">Оплатить все сразу</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </div>`
	});

    blockManager.add('careerum-tips-tariffs-tablet', {
        label: 'Tips тарифы (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div>
        <div class="careerum-tips-tariffs-tablet" hide-by-geo="russia">
            <div>
                <div>
                    <div>
                        <h2>Выберите удобный формат подписки</h2>
                    </div>
                    <div>
                        <div class="careerum-new-geochanger">
                            <div>
                                <div>                                
                                    <label class="geo-new-label">
                                        <p>EUR</p>
                                        <input type="checkbox">
                                        <div class="geo-new-changer">
                                            <p data-currency="Russia" class="geo-selector">RUB</p>
                                        </div>
                                    </label>                                
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="careerum-tips-tariffs-wrapper">
                    <div>
                        <p class="careerum-tariffs-subheader">
                            Порциями
                        </p>
                        <p class="careerum-tariffs-header"><span>4 письма</span><br>на 1 месяц</p>
                        <p>Оплатите 4 письма, чтобы попробовать. </p>
                        <p>Письма будут приходить каждый понедельник в течение месяца. <br>Если захотите продлить подписку — просто оплатите следующий <br>месяц.</p>
                        <div>
                            <div>
                                <p class="careerum-tariffs-price">390 €</p>
                                <p class="careerum-tariffs-price-per-item">97 € за письмо</p>
                            </div>
                            <a href="#" class="btn-color-main-bright-orange">Платить ежемесячно</a>
                        </div>
                    </div>
                    <div>
                        <p class="careerum-tariffs-subheader">
                            Все письма
                        </p>
                        <p class="careerum-tariffs-header"><span>70 писем</span><br>на 18 месяцев</p>
                        <p>Оплатите все 70 писем сразу — <br>это выгоднее, чем оплачивать подписку помесячно. </p>
                        <p>Письма будут приходить каждый понедельник в течение полутора лет.</p>
                        <div>
                            <div>
                                <p class="careerum-tariffs-price">4 900 €</p>
                                <p class="careerum-tariffs-price-per-item">70 € за письмо</p>
                            </div>
                            <a href="#" class="btn-color-main-bright-orange">Оплатить все сразу</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="careerum-tips-tariffs-tablet" hide-by-geo="not_russia">
            <div>
                <div>
                    <div>
                        <h2>Выберите удобный формат подписки</h2>
                    </div>
                    <div>
                        <div class="careerum-new-geochanger">
                            <div>
                                <div>                                
                                    <label class="geo-new-label">
                                        <p>RUB</p>
                                        <input type="checkbox">
                                        <div class="geo-new-changer">
                                            <p data-currency="Other" class="geo-selector">EUR</p>
                                        </div>
                                    </label>                                
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="careerum-tips-tariffs-wrapper">
                    <div>
                        <p class="careerum-tariffs-subheader">
                            Порциями
                        </p>
                        <p class="careerum-tariffs-header"><span>4 письма</span><br>на 1 месяц</p>
                        <p>Оплатите 4 письма, чтобы попробовать. </p>
                        <p>Письма будут приходить каждый понедельник в течение месяца.<br> Если захотите продлить подписку — просто оплатите следующий <br>месяц.</p>
                        <div>
                            <div>
                                <p class="careerum-tariffs-price">390 ₽</p>
                                <p class="careerum-tariffs-price-per-item">97 ₽ за письмо</p>
                            </div>
                            <a href="#" class="btn-color-main-bright-orange">Платить ежемесячно</a>
                        </div>
                    </div>
                    <div>
                        <p class="careerum-tariffs-subheader">
                            Все письма
                        </p>
                        <p class="careerum-tariffs-header"><span>70 писем</span><br>на 18 месяцев</p>
                        <p>Оплатите все 70 писем сразу — <br>это выгоднее, чем оплачивать подписку помесячно. </p>
                        <p>Письма будут приходить каждый понедельник в течение полутора лет.</p>
                        <div>
                            <div>
                                <p class="careerum-tariffs-price">4 900 ₽</p>
                                <p class="careerum-tariffs-price-per-item">70 ₽ за письмо</p>
                            </div>
                            <a href="#" class="btn-color-main-bright-orange">Оплатить все сразу</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </div>`
	});

    blockManager.add('careerum-tips-tariffs-mobile', {
        label: 'Tips тарифы (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div>
        <div class="careerum-tips-tariffs-mobile" hide-by-geo="not_russia">
            <div>
                <div>
                    <div>
                        <h2>Выберите удобный формат подписки</h2>
                    </div>
                </div>
                <div>
                    <div class="careerum-tips-tariffs-wrapper">
                        <div>
                            <p class="careerum-tariffs-subheader">
                                Порциями
                            </p>
                            <p class="careerum-tariffs-header"><span>4 письма</span><br>на 1 месяц</p>
                            <p>Оплатите 4 письма, чтобы попробовать. </p>
                            <p>Письма будут приходить каждый понедельник<br> в течение месяца. Если захотите продлить подписку — просто оплатите следующий <br>месяц.</p>
                            <div>
                                <div>
                                    <p class="careerum-tariffs-price">390 ₽</p>
                                    <p class="careerum-tariffs-price-per-item">97 ₽ за письмо</p>
                                </div>
                                <a href="#" class="btn-color-main-bright-orange">Платить ежемесячно</a>
                            </div>
                        </div>
                        <div>
                            <p class="careerum-tariffs-subheader">
                                Все письма
                            </p>
                            <p class="careerum-tariffs-header"><span>70 писем</span><br>на 18 месяцев</p>
                            <p>Оплатите все 70 писем сразу — это выгоднее,<br> чем оплачивать подписку помесячно. </p>
                            <p>Письма будут приходить каждый понедельник в течение полутора лет.</p>
                            <div>
                                <div>
                                    <p class="careerum-tariffs-price">4 900 ₽</p>
                                    <p class="careerum-tariffs-price-per-item">70 ₽ за письмо</p>
                                </div>
                                <a href="#" class="btn-color-main-bright-orange">Оплатить все сразу</a>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <div class="careerum-new-geochanger">
                        <div>
                            <div>
                                <label class="geo-new-label">
                                    <p>RUB</p>
                                    <input type="checkbox">
                                    <div class="geo-new-changer">
                                        <p data-currency="Other" class="geo-selector">EUR</p>
                                    </div>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="careerum-tips-tariffs-mobile" hide-by-geo="russia">
            <div>
                <div>
                    <div>
                        <h2>Выберите удобный формат подписки</h2>
                    </div>
                </div>
                <div>
                    <div class="careerum-tips-tariffs-wrapper">
                        <div>
                            <p class="careerum-tariffs-subheader">
                                Порциями
                            </p>
                            <p class="careerum-tariffs-header"><span>4 письма</span><br>на 1 месяц</p>
                            <p>Оплатите 4 письма, чтобы попробовать. </p>
                            <p>Письма будут приходить каждый понедельник<br> в течение месяца. Если захотите продлить подписку — просто оплатите следующий <br>месяц.</p>
                            <div>
                                <div>
                                    <p class="careerum-tariffs-price">390 €</p>
                                    <p class="careerum-tariffs-price-per-item">97 € за письмо</p>
                                </div>
                                <a href="#" class="btn-color-main-bright-orange">Платить ежемесячно</a>
                            </div>
                        </div>
                        <div>
                            <p class="careerum-tariffs-subheader">
                                Все письма
                            </p>
                            <p class="careerum-tariffs-header"><span>70 писем</span><br>на 18 месяцев</p>
                            <p>Оплатите все 70 писем сразу — это выгоднее,<br> чем оплачивать подписку помесячно. </p>
                            <p>Письма будут приходить каждый понедельник в течение полутора лет.</p>
                            <div>
                                <div>
                                    <p class="careerum-tariffs-price">4 900 €</p>
                                    <p class="careerum-tariffs-price-per-item">70 € за письмо</p>
                                </div>
                                <a href="#" class="btn-color-main-bright-orange">Оплатить все сразу</a>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <div class="careerum-new-geochanger">
                        <div>
                            <div>
                                <label class="geo-new-label">
                                    <p>EUR</p>
                                    <input type="checkbox">
                                    <div class="geo-new-changer">
                                        <p data-currency="Russia" class="geo-selector">RUB</p>
                                    </div>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </div>`
	});
    
    
    blockManager.add('careerum-vacancy-main', {
        label: 'Команда главный',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-vacancy-main">
            <div>
                <h1>Команда Careerum.<br>
                    Верим в то, что делаем</h1>
                <p class="careerum-vacancy-main-mission">Наша миссия — популяризировать идею карьерного<br> образования и
                    осознанного отношения к карьере</p>
                <p class="careerum-vacancy-main-manifest">Наш манифест — pray what you preach. Мы знаем<br> ответы на
                    вопросы: «Как получать от работы<br> больше удовольствия? Как приносить компании<br> больше пользы?»</p>
            </div>
        </div>`
	});

    blockManager.add('careerum-vacancy-main-tablet', {
        label: 'Команда главный (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-vacancy-main-tablet">
            <div>
                <h2>Команда Careerum.<br>
                    Верим в то, что делаем</h2>
                <p class="careerum-vacancy-main-mission">Наша миссия — популяризировать идею карьерного образования и<br>
                    осознанного отношения к карьере</p>
                <p class="careerum-vacancy-main-manifest">Наш манифест — pray what you preach. Мы знаем ответы<br> на
                    вопросы: «Как получать от работы больше удовольствия? Как<br> приносить компании больше пользы?»</p>
            </div>
        </div>`
	});

    blockManager.add('careerum-vacancy-main-mobile', {
        label: 'Команда главный (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-vacancy-main-mobile">
            <div>
                <h2>Команда Careerum.<br>
                    Верим в то,<br> что делаем</h2>
                <p class="careerum-vacancy-main-mission">Наша миссия — популяризировать<br> идею карьерного образования<br> и
                    осознанного отношения<br> к карьере</p>
                <p class="careerum-vacancy-main-manifest">Наш манифест — pray what you<br> preach. Мы знаем ответы на
                    вопросы:<br> «Как получать от работы больше<br> удовольствия? Как приносить<br> компании больше пользы?»</p>
            </div>
        </div>`
	});
    
    blockManager.add('careerum-vacancy-tiles', {
        label: 'Команда плитки',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-vacancy-tiles">
            <div>
                <div class="careerum-vacancy-tiles-wrapper">
                    <div class="careerum-vacancy-tiles-tile">
                        <p class="careerum-vacancy-tiles-tile-header">Будь частью команды</p>
                        <p class="careerum-vacancy-tiles-tile-content">Выстраивай экологичное общение, обсуждай трудности,
                            совместно находи решения </p>
                    </div>
                    <div class="careerum-vacancy-tiles-tile">
                        <p class="careerum-vacancy-tiles-tile-header">Следуй за талантами<br> и<br> ценностями</p>
                        <p class="careerum-vacancy-tiles-tile-content">Опирайся на свои истинные желания, таланты и сильные
                            стороны </p>
                    </div>
                    <div class="careerum-vacancy-tiles-tile">
                        <p class="careerum-vacancy-tiles-tile-header">Выходи<br> за рамки стандартов</p>
                        <p class="careerum-vacancy-tiles-tile-content">Помни про job crafting — выстраивай работу так, чтобы
                            получать от нее удовольствие</p>
                    </div>
                    <div class="careerum-vacancy-tiles-tile">
                        <p class="careerum-vacancy-tiles-tile-header">Работай<br> не 24/7,<br> а головой</p>
                        <p class="careerum-vacancy-tiles-tile-content">Ставь цели, следуя принципу Парето: думай не о
                            количестве рабочих часов, а о результате</p>
                    </div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-vacancy-tiles-tablet', {
        label: 'Команда плитки (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-vacancy-tiles-tablet">
            <div>
                <div class="careerum-vacancy-tiles-wrapper">
                    <div class="careerum-vacancy-tiles-tile">
                        <p class="careerum-vacancy-tiles-tile-header">Будь<br> частью команды</p>
                        <p class="careerum-vacancy-tiles-tile-content">Выстраивай экологичное<br> общение, обсуждай трудности,
                            совместно находи решения </p>
                    </div>
                    <div class="careerum-vacancy-tiles-tile">
                        <p class="careerum-vacancy-tiles-tile-header">Следуй за талантами<br> и<br> ценностями</p>
                        <p class="careerum-vacancy-tiles-tile-content">Опирайся на свои истинные желания и сильные стороны — получишь и удовольствие, и результат</p>
                    </div>
                    <div class="careerum-vacancy-tiles-tile">
                        <p class="careerum-vacancy-tiles-tile-header">Выходи<br> за рамки стандартов</p>
                        <p class="careerum-vacancy-tiles-tile-content">Помни про job crafting — выстраивай работу так, чтобы
                            получать от нее удовольствие</p>
                    </div>
                    <div class="careerum-vacancy-tiles-tile">
                        <p class="careerum-vacancy-tiles-tile-header">Работай<br> не 24/7,<br> а головой</p>
                        <p class="careerum-vacancy-tiles-tile-content">Ставь цели, следуя принципу Парето, думая не о количестве рабочих часов, а о результате</p>
                    </div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-vacancy-tiles-mobile', {
        label: 'Команда плитки (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-vacancy-tiles-mobile">
            <div>
                <div class="careerum-vacancy-tiles-wrapper">
                    <div class="careerum-vacancy-tiles-tile">
                        <p class="careerum-vacancy-tiles-tile-header">Будь частью<br> команды</p>
                        <p class="careerum-vacancy-tiles-tile-content">Выстраивай экологичное<br> общение, обсуждай трудности,
                            совместно находи решения </p>
                    </div>
                    <div class="careerum-vacancy-tiles-tile">
                        <p class="careerum-vacancy-tiles-tile-header">Следуй за талантами<br> и<br> ценностями</p>
                        <p class="careerum-vacancy-tiles-tile-content">Опирайся на свои истинные желания и сильные стороны — получишь и удовольствие, и результат</p>
                    </div>
                    <div class="careerum-vacancy-tiles-tile">
                        <p class="careerum-vacancy-tiles-tile-header">Выходи<br> за рамки стандартов</p>
                        <p class="careerum-vacancy-tiles-tile-content">Помни про job crafting — выстраивай работу так, чтобы
                            получать от нее удовольствие</p>
                    </div>
                    <div class="careerum-vacancy-tiles-tile">
                        <p class="careerum-vacancy-tiles-tile-header">Работай<br> не 24/7,<br> а головой</p>
                        <p class="careerum-vacancy-tiles-tile-content">Ставь цели, следуя принципу Парето, думая не о количестве рабочих часов, а о результате</p>
                    </div>
                </div>
            </div>
        </div>`
	});
    
    blockManager.add('careerum-vacancy-tabs', {
        label: 'Команда табы',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-vacancy-tabs careerum-vacancy-color-blue">
            <div>
                <h2>Careerum в лицах</h2>
                <div class="careerum-vacancy-tabs-items">
                    <div class="careerum-vacancy-tabs-selectors">
                        <form action="">
                            <label class="active" data-color="blue">
                                <p>Продуктово-проектная команда</p><input type="radio" name="careerum-vacancy-radio">
                            </label>
                            <label data-color="orange">
                                <p>Команда маркетинга</p><input type="radio" name="careerum-vacancy-radio">
                            </label>
                            <label data-color="grey">
                                <p>Техническая команда</p><input type="radio" name="careerum-vacancy-radio">
                            </label>
                            <label data-color="mediumblue">
                                <p>Коучи</p><input type="radio" name="careerum-vacancy-radio">
                            </label>
                            <label data-color="darkorange">
                                <p>Эксперты</p><input type="radio" name="careerum-vacancy-radio">
                            </label>
                        </form>
                    </div>
                    <div class="careerum-vacancy-tabs-content">
                        <div class="careerum-vacancy-tab" data-tab-id="Продуктово-проектная команда">
                            <div>
                                <div class="careerum-vacancy-tab-image">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659036179809.png" alt="">
                                </div>
                                <div class="careerum-vacancy-tab-content">
                                    <p class="careerum-vacancy-tab-content-name">Ольга Лермонтова</p>
                                    <p class="careerum-vacancy-tab-content-position">Основательница и топ-эксперт Careerum</p>
                                    <p class="careerum-vacancy-tab-content-description">Руководит бизнес-процессами, разрабатывает стратегии и ведет большую часть курсов и мастер-классов. Работала в 5 странах, в том числе на руководящих должностях в Google и Microsoft.</p>
                                    <p class="careerum-vacancy-tab-content-country">Италия</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-vacancy-tab-image">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659036214093.png" alt="">
                                </div>
                                <div class="careerum-vacancy-tab-content">
                                    <p class="careerum-vacancy-tab-content-name">Юлиана Керт</p>
                                    <p class="careerum-vacancy-tab-content-position">Директор по продукту</p>
                                    <p class="careerum-vacancy-tab-content-description">Руководит продуктовой<br> и экспертной командами. Владеет тремя мертвыми языками и использует их практически каждый день.</p>
                                    <p class="careerum-vacancy-tab-content-country">Россия</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-vacancy-tab-image">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659036239676.png" alt="">
                                </div>
                                <div class="careerum-vacancy-tab-content">
                                    <p class="careerum-vacancy-tab-content-name">Марго Масленникова</p>
                                    <p class="careerum-vacancy-tab-content-position">Операционный директор</p>
                                    <p class="careerum-vacancy-tab-content-description">Отвечает за инфраструктуру, процессы, ресурсы и запуск стратегических проектов. Получила от друзей грамоту «Почетный делец Авито»<br> за продажи на более 300 тысяч рублей.</p>
                                    <p class="careerum-vacancy-tab-content-country">Турция</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-vacancy-tab-image">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659036277846.png" alt="">
                                </div>
                                <div class="careerum-vacancy-tab-content">
                                    <p class="careerum-vacancy-tab-content-name">Виктория Фадеева</p>
                                    <p class="careerum-vacancy-tab-content-position">Менеджер проектов</p>
                                    <p class="careerum-vacancy-tab-content-description">Руководит проектами, связанными с разработкой (нетворкинговая платформа, сайт, CRM, LMS, инструменты автоматизации работы). Умеет находить подход к любому разработчику.</p>
                                    <p class="careerum-vacancy-tab-content-country">Россия</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-vacancy-tab-image">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659036293149.png" alt="">
                                </div>
                                <div class="careerum-vacancy-tab-content">
                                    <p class="careerum-vacancy-tab-content-name">Мария Бродская</p>
                                    <p class="careerum-vacancy-tab-content-position">Продакт-менеджер</p>
                                    <p class="careerum-vacancy-tab-content-description">Создает образовательные курсы, вебинары и фокус-кэмпы, начиная с определения потребностей участников клуба<br> и заканчивая приемкой готового материала и анализом результата. Знает 7 языков.</p>
                                    <p class="careerum-vacancy-tab-content-country">Россия</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-vacancy-tab-image">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659036311261.png" alt="">
                                </div>
                                <div class="careerum-vacancy-tab-content">
                                    <p class="careerum-vacancy-tab-content-name">Ольга Капуста</p>
                                    <p class="careerum-vacancy-tab-content-position">Комьюнити-менеджер</p>
                                    <p class="careerum-vacancy-tab-content-description">Развивает сообщество клуба, курирует нетворкинговые активности и работу амбассадоров. Организовывает тимбилдинги для команды Careerum. Любую историю может рассказать как стендап.</p>
                                    <p class="careerum-vacancy-tab-content-country">Беларусь</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-vacancy-tab-image">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659036328477.png" alt="">
                                </div>
                                <div class="careerum-vacancy-tab-content">
                                    <p class="careerum-vacancy-tab-content-name">Ксения Павлова</p>
                                    <p class="careerum-vacancy-tab-content-position">Методолог</p>
                                    <p class="careerum-vacancy-tab-content-description">Проектирует курсы, создает обучающий опыт, придумывает игровые механики. До Careerum c нуля построила несколько бизнесов и одну онлайн-школу.
                                    </p>
                                    <p class="careerum-vacancy-tab-content-country">Канада</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-vacancy-tab-image">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659036343135.png" alt="">
                                </div>
                                <div class="careerum-vacancy-tab-content">
                                    <p class="careerum-vacancy-tab-content-name">Оксана Богданова</p>
                                    <p class="careerum-vacancy-tab-content-position">Пишущий редактор</p>
                                    <p class="careerum-vacancy-tab-content-description">Редактирует образовательные материалы клуба, создает контент для нетворкинговой платформы и пишет письма клубовцам. В карманах прячет желуди и ракушки.</p>
                                    <p class="careerum-vacancy-tab-content-country">Россия</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-vacancy-tab-image">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659036356147.png" alt="">
                                </div>
                                <div class="careerum-vacancy-tab-content">
                                    <p class="careerum-vacancy-tab-content-name">Карина Кириша</p>
                                    <p class="careerum-vacancy-tab-content-position">Юрист</p>
                                    <p class="careerum-vacancy-tab-content-description">Оказывает юридическую поддержку Careerum. Защищает интеллектуальную собственность и не только. В школе ненавидела право,<br> но стала юристом.</p>
                                    <p class="careerum-vacancy-tab-content-country">Украина</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-vacancy-tab-image">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659036369957.png" alt="">
                                </div>
                                <div class="careerum-vacancy-tab-content">
                                    <p class="careerum-vacancy-tab-content-name">Дарина Байжанова</p>
                                    <p class="careerum-vacancy-tab-content-position">Проектный ассистент</p>
                                    <p class="careerum-vacancy-tab-content-description">Поддерживает порядок<br> в хранилищах команды, помогает актуализировать материалы, модерирует вебинары, курирует планерки. Разговаривает на 5 языках.</p>
                                    <p class="careerum-vacancy-tab-content-country">Франция</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-vacancy-tab-image">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659036381178.png" alt="">
                                </div>
                                <div class="careerum-vacancy-tab-content">
                                    <p class="careerum-vacancy-tab-content-name">Оксана Наливайко</p>
                                    <p class="careerum-vacancy-tab-content-position">Ведущий дизайнер</p>
                                    <p class="careerum-vacancy-tab-content-description">Управляет созданием <br>и внедрением айдентики, запускает маркетинговые активности, руководит кросс-командными процессами. Знает разницу между UX и UI дизайном и успешно применяет это в жизни.</p>
                                    <p class="careerum-vacancy-tab-content-country">Грузия</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-vacancy-tab-image">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659036396143.png" alt="">
                                </div>
                                <div class="careerum-vacancy-tab-content">
                                    <p class="careerum-vacancy-tab-content-name">Татьяна Погребняк</p>
                                    <p class="careerum-vacancy-tab-content-position">Руководитель команды поддержки пользователей </p>
                                    <p class="careerum-vacancy-tab-content-description">Работает с обращениями клиентов, отвечает за улуч-шение процессов поддержки. Любит людей и не перестает у них учиться.</p>
                                    <p class="careerum-vacancy-tab-content-country">Россия</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-vacancy-tab-image">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659036413806.png" alt="">
                                </div>
                                <div class="careerum-vacancy-tab-content">
                                    <p class="careerum-vacancy-tab-content-name">Бахытжан Абдумаликов</p>
                                    <p class="careerum-vacancy-tab-content-position">Аналитик данных</p>
                                    <p class="careerum-vacancy-tab-content-description">Выстраивает аналитику компании и занимается анализом данных. Знает 4 языка и каждый день катается на велосипеде. </p>
                                    <p class="careerum-vacancy-tab-content-country">Казахстан</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-vacancy-tab-image">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659036430464.png" alt="">
                                </div>
                                <div class="careerum-vacancy-tab-content">
                                    <p class="careerum-vacancy-tab-content-name">Юлия Кобец</p>
                                    <p class="careerum-vacancy-tab-content-position">Дизайнер</p>
                                    <p class="careerum-vacancy-tab-content-description">Оформляет учебные материалы Careerum.Club, создает макеты для социальных сетей. Любит глупые комедии.</p>
                                    <p class="careerum-vacancy-tab-content-country">Россия</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-vacancy-tab-image">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659036445467.png" alt="">
                                </div>
                                <div class="careerum-vacancy-tab-content">
                                    <p class="careerum-vacancy-tab-content-name">Карина Кадеркаева</p>
                                    <p class="careerum-vacancy-tab-content-position">Карьерный эксперт</p>
                                    <p class="careerum-vacancy-tab-content-description">Создает экспертный контент новых курсов и фокус-кэмпов<br> и улучшает текущие материалы клуба. Воспитывает немецкую овчарку и хаски. В качестве хобби собирает личную библиотеку.</p>
                                    <p class="careerum-vacancy-tab-content-country">Россия</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-vacancy-tab-content-full">
                                    <p class="careerum-vacancy-tab-content-header">Хочешь<br> стать частью продуктовой команды Careerum?</p>
                                    <a href="#" class="btn-color-main-light-blue">Посмотреть вакансии</a>
                                </div>
                            </div>
                        </div>
                        <div class="careerum-vacancy-tab" data-tab-id="Команда маркетинга">
                            <div>
                                <div class="careerum-vacancy-tab-image">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659036478227.png" alt="">
                                </div>
                                <div class="careerum-vacancy-tab-content">
                                    <p class="careerum-vacancy-tab-content-name">Юлиана Логинова</p>
                                    <p class="careerum-vacancy-tab-content-position">Директор по маркетингу</p>
                                    <p class="careerum-vacancy-tab-content-description">Руководит всем маркетингом и контентом Careerum, делает так, чтобы как можно больше людей узнали о компании и смогли улучшить свою карьеру. 6 лет работала продюсером в Comedy Club Production.</p>
                                    <p class="careerum-vacancy-tab-content-country">Россия</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-vacancy-tab-image">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659036523852.png" alt="">
                                </div>
                                <div class="careerum-vacancy-tab-content">
                                    <p class="careerum-vacancy-tab-content-name">Юлия Орлова</p>
                                    <p class="careerum-vacancy-tab-content-position">Проджект-менеджер</p>
                                    <p class="careerum-vacancy-tab-content-description">Занимается подкастами и YouTube-каналом Careerum, организует выступления спикеров клуба. Фея рассылок и подруга бота Райана. Боится высоты, но прыгала с парашютом, боится глубины, но каталась на серфе. </p>
                                    <p class="careerum-vacancy-tab-content-country">Россия</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-vacancy-tab-image">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659036540068.png" alt="">
                                </div>
                                <div class="careerum-vacancy-tab-content">
                                    <p class="careerum-vacancy-tab-content-name">Дарья Московкина</p>
                                    <p class="careerum-vacancy-tab-content-position">Старший контент-менеджер</p>
                                    <p class="careerum-vacancy-tab-content-description">Управляет созданием контента в соцсетях. С первой стажировки работает в сфере карьеры и образования. </p>
                                    <p class="careerum-vacancy-tab-content-country">Россия</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-vacancy-tab-image">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659036553095.png" alt="">
                                </div>
                                <div class="careerum-vacancy-tab-content">
                                    <p class="careerum-vacancy-tab-content-name">Ирина Скоклеенко</p>
                                    <p class="careerum-vacancy-tab-content-position">Копирайтер</p>
                                    <p class="careerum-vacancy-tab-content-description">Создает посты и сценарии для наших читателей в соцсетях, делает контент информативным, понятным и вирусным. Владеет китайским языком.</p>
                                    <p class="careerum-vacancy-tab-content-country">Россия</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-vacancy-tab-image">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659036568337.png" alt="">
                                </div>
                                <div class="careerum-vacancy-tab-content">
                                    <p class="careerum-vacancy-tab-content-name">Евгения Карелина</p>
                                    <p class="careerum-vacancy-tab-content-position">Копирайтер, редактор</p>
                                    <p class="careerum-vacancy-tab-content-description">Создает и редактирует тексты для корпоративного сайта, отдельных лендингов и некоторых продуктов. Настолько любит кинематограф, что на досуге пишет статьи о кино и почти дописала свой сценарий.</p>
                                    <p class="careerum-vacancy-tab-content-country">Армения</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-vacancy-tab-image">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659036582912.png" alt="">
                                </div>
                                <div class="careerum-vacancy-tab-content">
                                    <p class="careerum-vacancy-tab-content-name">Анна Устинова</p>
                                    <p class="careerum-vacancy-tab-content-position">Копирайтер</p>
                                    <p class="careerum-vacancy-tab-content-description">Создает контент для социальных сетей, структурирует и готовит к публикации истории о результатах наших учеников. 10 лет занималась фортепиано и даже думала связать свою жизнь с музыкой. </p>
                                    <p class="careerum-vacancy-tab-content-country">Россия</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-vacancy-tab-image">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659036595367.png" alt="">
                                </div>
                                <div class="careerum-vacancy-tab-content">
                                    <p class="careerum-vacancy-tab-content-name">Анастасия Власова</p>
                                    <p class="careerum-vacancy-tab-content-position">Младший контент-менеджер</p>
                                    <p class="careerum-vacancy-tab-content-description">Оформляет контент в Инстаграм Ольги Лермонтовой. Жуткий эмпат, поэтому всегда расстраивается, когда у близких людей плохое настроение.</p>
                                    <p class="careerum-vacancy-tab-content-country">Россия</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-vacancy-tab-content-full">
                                    <p class="careerum-vacancy-tab-content-header">Хочешь<br> стать частью продуктовой команды Careerum?</p>
                                    <a href="#" class="btn-color-main-light-blue">Посмотреть вакансии</a>
                                </div>
                            </div>
                        </div>
                        <div class="careerum-vacancy-tab" data-tab-id="Техническая команда">
                            <div>
                                <div class="careerum-vacancy-tab-image">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659036615290.png" alt="">
                                </div>
                                <div class="careerum-vacancy-tab-content">
                                    <p class="careerum-vacancy-tab-content-name">Иннокентий Солнцев</p>
                                    <p class="careerum-vacancy-tab-content-position">Технический директор</p>
                                    <p class="careerum-vacancy-tab-content-description">Отвечает за работу технических сервисов, составляющих платформу Careerum. Взлетал на самолете больше раз, чем приземлялся.</p>
                                    <p class="careerum-vacancy-tab-content-country">Италия</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-vacancy-tab-image">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659036630703.png" alt="">
                                </div>
                                <div class="careerum-vacancy-tab-content">
                                    <p class="careerum-vacancy-tab-content-name">Артем Покатилов</p>
                                    <p class="careerum-vacancy-tab-content-position">Веб-разработчик</p>
                                    <p class="careerum-vacancy-tab-content-description">Разрабатывает внутреннюю CRM-систему, конструктор сайтов, инструменты аналитики и другие полезности. Проводит ретриты как инструктор духовной практики.</p>
                                    <p class="careerum-vacancy-tab-content-country">Россия</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-vacancy-tab-image">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659036646429.png" alt="">
                                </div>
                                <div class="careerum-vacancy-tab-content">
                                    <p class="careerum-vacancy-tab-content-name">Виктор Некрасов</p>
                                    <p class="careerum-vacancy-tab-content-position">Руководитель технической команды</p>
                                    <p class="careerum-vacancy-tab-content-description">Разрабатывает нетворкинговую платформу. Отвечает за техническую часть и организует командную разработку. Поет джаз и играет на этнических музыкальных инструментах.</p>
                                    <p class="careerum-vacancy-tab-content-country">Россия</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-vacancy-tab-image">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659036658963.png" alt="">
                                </div>
                                <div class="careerum-vacancy-tab-content">
                                    <p class="careerum-vacancy-tab-content-name">Александр Рудецкий</p>
                                    <p class="careerum-vacancy-tab-content-position">Фронтенд-разработчик</p>
                                    <p class="careerum-vacancy-tab-content-description">Разрабатывает социальную сеть Careerum, участвует в создании CRM-системы. Ночью гораздо продуктивнее, чем днём.</p>
                                    <p class="careerum-vacancy-tab-content-country">Россия</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-vacancy-tab-image">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659036674185.png" alt="">
                                </div>
                                <div class="careerum-vacancy-tab-content">
                                    <p class="careerum-vacancy-tab-content-name">Сергей Нечаев</p>
                                    <p class="careerum-vacancy-tab-content-position">Программист</p>
                                    <p class="careerum-vacancy-tab-content-description">Разрабатывает нетворкинговую платформу. А в свободное время ездит на собаках.</p>
                                    <p class="careerum-vacancy-tab-content-country">Россия</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-vacancy-tab-content-full">
                                    <p class="careerum-vacancy-tab-content-header">Хочешь<br> стать частью продуктовой команды Careerum?</p>
                                    <a href="#" class="btn-color-main-light-blue">Посмотреть вакансии</a>
                                </div>
                            </div>
                        </div>
                        <div class="careerum-vacancy-tab" data-tab-id="Коучи">
                            <div>
                                <div class="careerum-vacancy-tab-image">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659036687775.png" alt="">
                                </div>
                                <div class="careerum-vacancy-tab-content">
                                    <p class="careerum-vacancy-tab-content-name">Светлана Баран</p>
                                    <p class="careerum-vacancy-tab-content-position">Коуч ICF, старший коуч Careerum</p>
                                    <p class="careerum-vacancy-tab-content-description">Помогает клубовцам построить план действий и прийти к цели, руководит командой коучей Careerum. Жила в 10 странах и говорит на 8 языках.</p>
                                    <p class="careerum-vacancy-tab-content-country">Италия</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-vacancy-tab-image">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659036698896.png" alt="">
                                </div>
                                <div class="careerum-vacancy-tab-content">
                                    <p class="careerum-vacancy-tab-content-name">Ирина Феоктистова</p>
                                    <p class="careerum-vacancy-tab-content-position">Коуч AFC</p>
                                    <p class="careerum-vacancy-tab-content-description">Специализируется на темах баланса работы и личной жизни, а также смены сферы. Когда-то работала переводчиком с языка суахили.</p>
                                    <p class="careerum-vacancy-tab-content-country">Россия</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-vacancy-tab-image">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659036713295.png" alt="">
                                </div>
                                <div class="careerum-vacancy-tab-content">
                                    <p class="careerum-vacancy-tab-content-name">Марина Веденичева</p>
                                    <p class="careerum-vacancy-tab-content-position">Коуч ICF PCC</p>
                                    <p class="careerum-vacancy-tab-content-description">Специализируется на темах лидерства, менеджмента и карьерного роста. На заре  карьеры работала на телевидении, с тех пор крайне редко смотрит телевизор (особенно новости).</p>
                                    <p class="careerum-vacancy-tab-content-country">Великобритания</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-vacancy-tab-image">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659036726477.png" alt="">
                                </div>
                                <div class="careerum-vacancy-tab-content">
                                    <p class="careerum-vacancy-tab-content-name">Астра Висаева</p>
                                    <p class="careerum-vacancy-tab-content-position">Коуч AFC</p>
                                    <p class="careerum-vacancy-tab-content-description">Помогает изменить ограничивающие привычки мышления и обрести свое истинное Я. Кроме коучинга имеет профессиональное образование в финансах и танцах.</p>
                                    <p class="careerum-vacancy-tab-content-country">Россия</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-vacancy-tab-image">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659036737726.png" alt="">
                                </div>
                                <div class="careerum-vacancy-tab-content">
                                    <p class="careerum-vacancy-tab-content-name">Елена Эльзенбах</p>
                                    <p class="careerum-vacancy-tab-content-position">Коуч ICF</p>
                                    <p class="careerum-vacancy-tab-content-description">Помогает участникам Careerum.Club находить ответы на карьерные вопросы, повышать уверенность в себе и справляться с выгоранием. Более 10 лет волонтерит на разных мероприятиях.</p>
                                    <p class="careerum-vacancy-tab-content-country">Россия</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-vacancy-tab-image">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659036752073.png" alt="">
                                </div>
                                <div class="careerum-vacancy-tab-content">
                                    <p class="careerum-vacancy-tab-content-name">Елена Добринская</p>
                                    <p class="careerum-vacancy-tab-content-position">Коуч ICF</p>
                                    <p class="careerum-vacancy-tab-content-description">Специализируется на темах: самоопределение, мотивация и самооценка. Живет на искусственном острове в форме пальмы.</p>
                                    <p class="careerum-vacancy-tab-content-country">ОАЭ</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-vacancy-tab-content-full">
                                    <p class="careerum-vacancy-tab-content-header">Хочешь<br> стать частью продуктовой команды Careerum?</p>
                                    <a href="#" class="btn-color-main-light-blue">Посмотреть вакансии</a>
                                </div>
                            </div>
                        </div>
                        <div class="careerum-vacancy-tab" data-tab-id="Эксперты">
                            <div>
                                <div class="careerum-vacancy-tab-image">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659036767410.png" alt="">
                                </div>
                                <div class="careerum-vacancy-tab-content">
                                    <p class="careerum-vacancy-tab-content-name">Елена Федорова</p>
                                    <p class="careerum-vacancy-tab-content-position">Эксперт по трудовому праву</p>
                                    <p class="careerum-vacancy-tab-content-description">Пишет материалы и отвечает на вопросы, связанные с трудовым и гражданским правом. Работала в Google.</p>
                                    <p class="careerum-vacancy-tab-content-country">Россия</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-vacancy-tab-image">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659036778599.png" alt="">
                                </div>
                                <div class="careerum-vacancy-tab-content">
                                    <p class="careerum-vacancy-tab-content-name">София Бессонова</p>
                                    <p class="careerum-vacancy-tab-content-position">CV-специалист, коуч ICF</p>
                                    <p class="careerum-vacancy-tab-content-description">Помогает участникам усилить резюме и посмотреть на него с точки зрения работодателей. 2 года преподавала в университете психологию, считает себя адептом темы психологического выгорания.</p>
                                    <p class="careerum-vacancy-tab-content-country">Израиль</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-vacancy-tab-image">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659036790870.png" alt="">
                                </div>
                                <div class="careerum-vacancy-tab-content">
                                    <p class="careerum-vacancy-tab-content-name">Арина Хома</p>
                                    <p class="careerum-vacancy-tab-content-position">Эксперт, бизнес-тренер</p>
                                    <p class="careerum-vacancy-tab-content-description">Ведет мастерские по коммуникации и работе со стрессом, пишет экспертные статьи о сложных переговорах. Закончила юрфак МГУ и 5 лет работала судебным юристом.</p>
                                    <p class="careerum-vacancy-tab-content-country">Россия</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-vacancy-tab-content-full">
                                    <p class="careerum-vacancy-tab-content-header">Хочешь<br> стать частью продуктовой команды Careerum?</p>
                                    <a href="#" class="btn-color-main-light-blue">Посмотреть вакансии</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-vacancy-tabs-tablet', {
        label: 'Команда табы (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-vacancy-tabs-tablet careerum-vacancy-color-blue">
            <div>
                <h2>Careerum в лицах</h2>
                <div class="careerum-vacancy-tabs-items">
                    <div class="careerum-vacancy-tabs-selectors">
                        <form action="">
                            <label class="active" data-color="blue">
                                <p>Продуктово-проектная команда</p><input type="radio" name="careerum-vacancy-radio">
                            </label>
                            <label data-color="orange">
                                <p>Команда маркетинга</p><input type="radio" name="careerum-vacancy-radio">
                            </label>
                            <label data-color="grey">
                                <p>Техническая команда</p><input type="radio" name="careerum-vacancy-radio">
                            </label>
                            <label data-color="mediumblue">
                                <p>Коучи</p><input type="radio" name="careerum-vacancy-radio">
                            </label>
                            <label data-color="darkorange">
                                <p>Эксперты</p><input type="radio" name="careerum-vacancy-radio">
                            </label>
                        </form>
                    </div>
                    <div class="careerum-vacancy-tabs-content">
                        <div class="careerum-vacancy-tab" data-tab-id="Продуктово-проектная команда">
                            <div>
                                <div class="careerum-vacancy-tab-image">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659037119344.png" alt="">
                                </div>
                                <div class="careerum-vacancy-tab-content">
                                    <p class="careerum-vacancy-tab-content-name">Ольга Лермонтова</p>
                                    <p class="careerum-vacancy-tab-content-position">Основательница и топ-эксперт Careerum</p>
                                    <p class="careerum-vacancy-tab-content-description">Руководит процессами, разрабатывает стратегии и ведет курсы и мастер-классы. Работала в 5 странах, в том числе на руководящих должно-стях в Google и Microsoft.</p>
                                    <p class="careerum-vacancy-tab-content-country">Италия</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-vacancy-tab-image">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659037130179.png" alt="">
                                </div>
                                <div class="careerum-vacancy-tab-content">
                                    <p class="careerum-vacancy-tab-content-name">Юлиана Керт</p>
                                    <p class="careerum-vacancy-tab-content-position">Директор по продукту</p>
                                    <p class="careerum-vacancy-tab-content-description">Руководит продуктовой<br> и экспертной командами. Владеет тремя мертвыми языками и использует их практически каждый день.</p>
                                    <p class="careerum-vacancy-tab-content-country">Россия</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-vacancy-tab-image">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659037148084.png" alt="">
                                </div>
                                <div class="careerum-vacancy-tab-content">
                                    <p class="careerum-vacancy-tab-content-name">Марго Масленникова</p>
                                    <p class="careerum-vacancy-tab-content-position">Операционный директор</p>
                                    <p class="careerum-vacancy-tab-content-description">Отвечает за инфраструк-туру, процессы, ресурсы и запуск стратегических проектов. Получила<br> от друзей грамоту «Почетный делец Авито» за продажи на более 300 тысяч рублей.</p>
                                    <p class="careerum-vacancy-tab-content-country">Турция</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-vacancy-tab-image">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659037158513.png" alt="">
                                </div>
                                <div class="careerum-vacancy-tab-content">
                                    <p class="careerum-vacancy-tab-content-name">Виктория Фадеева</p>
                                    <p class="careerum-vacancy-tab-content-position">Менеджер проектов</p>
                                    <p class="careerum-vacancy-tab-content-description">Руководит проектами, связанными с разработкой (нетворкинговая платформа, сайт, CRM, LMS, инструменты автома-тизации работы). Умеет находить подход к любому разработчику.</p>
                                    <p class="careerum-vacancy-tab-content-country">Россия</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-vacancy-tab-image">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659037169087.png" alt="">
                                </div>
                                <div class="careerum-vacancy-tab-content">
                                    <p class="careerum-vacancy-tab-content-name">Мария Бродская</p>
                                    <p class="careerum-vacancy-tab-content-position">Продакт-менеджер</p>
                                    <p class="careerum-vacancy-tab-content-description">Создает курсы, вебинары и фокус-кэмпы, начиная с определения потребностей участников клуба и заканчивая приемкой готового материала и анализом результата. Знает 7 языков.</p>
                                    <p class="careerum-vacancy-tab-content-country">Россия</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-vacancy-tab-image">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659037180448.png" alt="">
                                </div>
                                <div class="careerum-vacancy-tab-content">
                                    <p class="careerum-vacancy-tab-content-name">Ольга Капуста</p>
                                    <p class="careerum-vacancy-tab-content-position">Комьюнити-менеджер</p>
                                    <p class="careerum-vacancy-tab-content-description">Развивает сообщество клуба, курирует нетворк-инговые активности и работу амбассадоров. Организовывает тим-билдинги. Любую историю может рассказать как стендап.</p>
                                    <p class="careerum-vacancy-tab-content-country">Беларусь</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-vacancy-tab-image">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659037190581.png" alt="">
                                </div>
                                <div class="careerum-vacancy-tab-content">
                                    <p class="careerum-vacancy-tab-content-name">Ксения Павлова</p>
                                    <p class="careerum-vacancy-tab-content-position">Методолог</p>
                                    <p class="careerum-vacancy-tab-content-description">Проектирует курсы, создает обучающий опыт, придумывает игровые механики. До Careerum c нуля построила несколько бизнесов и одну онлайн-школу.</p>
                                    <p class="careerum-vacancy-tab-content-country">Канада</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-vacancy-tab-image">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659037201402.png" alt="">
                                </div>
                                <div class="careerum-vacancy-tab-content">
                                    <p class="careerum-vacancy-tab-content-name">Оксана Богданова</p>
                                    <p class="careerum-vacancy-tab-content-position">Пишущий редактор</p>
                                    <p class="careerum-vacancy-tab-content-description">Редактирует образовательные материалы клуба, создает контент для нетворк-инговой платформы и пишет письма клубовцам. В карманах прячет желуди и ракушки.</p>
                                    <p class="careerum-vacancy-tab-content-country">Россия</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-vacancy-tab-image">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659037212916.png" alt="">
                                </div>
                                <div class="careerum-vacancy-tab-content">
                                    <p class="careerum-vacancy-tab-content-name">Дарина Байжанова</p>
                                    <p class="careerum-vacancy-tab-content-position">Проектный ассистент</p>
                                    <p class="careerum-vacancy-tab-content-description">Поддерживает порядок в хранилищах команды, помогает актуализировать материалы, модерирует вебинары, курирует планерки. Разговаривает на 5 языках.</p>
                                    <p class="careerum-vacancy-tab-content-country">Франция</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-vacancy-tab-image">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659037221208.png" alt="">
                                </div>
                                <div class="careerum-vacancy-tab-content">
                                    <p class="careerum-vacancy-tab-content-name">Оксана Наливайко</p>
                                    <p class="careerum-vacancy-tab-content-position">Ведущий дизайнер</p>
                                    <p class="careerum-vacancy-tab-content-description">Управляет созданием айдентики, запускает маркетинговые активности, руководит кросс-командными процессами. Знает разницу между UX и UI дизайном и успешно применяет это в жизни.</p>
                                    <p class="careerum-vacancy-tab-content-country">Грузия</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-vacancy-tab-image">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659037231669.png" alt="">
                                </div>
                                <div class="careerum-vacancy-tab-content">
                                    <p class="careerum-vacancy-tab-content-name">Татьяна Погребняк</p>
                                    <p class="careerum-vacancy-tab-content-position">Руководитель команды поддержки пользователей </p>
                                    <p class="careerum-vacancy-tab-content-description">Работает с обращениями клиентов, отвечает за улуч-шение процессов поддержки. Любит людей и не перестает у них учиться.</p>
                                    <p class="careerum-vacancy-tab-content-country">Россия</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-vacancy-tab-image">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659037251286.png" alt="">
                                </div>
                                <div class="careerum-vacancy-tab-content">
                                    <p class="careerum-vacancy-tab-content-name">Бахытжан Абдумаликов</p>
                                    <p class="careerum-vacancy-tab-content-position">Аналитик данных</p>
                                    <p class="careerum-vacancy-tab-content-description">Выстраивает аналитику компании и занимается анализом данных. Знает 4 языка и каждый день катается на велосипеде. </p>
                                    <p class="careerum-vacancy-tab-content-country">Казахстан</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-vacancy-tab-image">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659037261828.png" alt="">
                                </div>
                                <div class="careerum-vacancy-tab-content">
                                    <p class="careerum-vacancy-tab-content-name">Юлия Кобец</p>
                                    <p class="careerum-vacancy-tab-content-position">Дизайнер</p>
                                    <p class="careerum-vacancy-tab-content-description">Оформляет учебные материалы Careerum.Club, создает макеты для социальных сетей. Любит глупые комедии.</p>
                                    <p class="careerum-vacancy-tab-content-country">Россия</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-vacancy-tab-image">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659037272022.png" alt="">
                                </div>
                                <div class="careerum-vacancy-tab-content">
                                    <p class="careerum-vacancy-tab-content-name">Карина Кадеркаева</p>
                                    <p class="careerum-vacancy-tab-content-position">Карьерный эксперт</p>
                                    <p class="careerum-vacancy-tab-content-description">Создает экспертный контент новых курсов и фокус-кэмпов и улучшает текущие материалы клуба. Воспитывает немецкую овчарку и хаски. В качестве хобби собирает личную библиотеку.</p>
                                    <p class="careerum-vacancy-tab-content-country">Россия</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-vacancy-tab-image">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659037282525.png" alt="">
                                </div>
                                <div class="careerum-vacancy-tab-content">
                                    <p class="careerum-vacancy-tab-content-name">Карина Кириша</p>
                                    <p class="careerum-vacancy-tab-content-position">Юрист</p>
                                    <p class="careerum-vacancy-tab-content-description">Оказывает юридическую поддержку Careerum. Защищает интеллект-уальную собственность и не только. В школе ненавидела право, но стала юристом.</p>
                                    <p class="careerum-vacancy-tab-content-country">Украина</p>
                                </div>
                            </div>
                        </div>
                        <div class="careerum-vacancy-tab" data-tab-id="Команда маркетинга">
                            <div>
                                <div class="careerum-vacancy-tab-image">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659037296953.png" alt="">
                                </div>
                                <div class="careerum-vacancy-tab-content">
                                    <p class="careerum-vacancy-tab-content-name">Юлиана Логинова</p>
                                    <p class="careerum-vacancy-tab-content-position">Директор по маркетингу</p>
                                    <p class="careerum-vacancy-tab-content-description">Руководит всем маркетингом и контентом Careerum, делает так, чтобы как можно больше людей узнали о компании и улучшили свою карьеру. 6 лет работала продюсером в Comedy Club Production.</p>
                                    <p class="careerum-vacancy-tab-content-country">Россия</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-vacancy-tab-image">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659037310228.png" alt="">
                                </div>
                                <div class="careerum-vacancy-tab-content">
                                    <p class="careerum-vacancy-tab-content-name">Юлия Орлова</p>
                                    <p class="careerum-vacancy-tab-content-position">Проджект-менеджер</p>
                                    <p class="careerum-vacancy-tab-content-description">Занимается подкастами и YouTube-каналом Careerum, организует выступления спикеров клуба. Фея рассылок и подруга бота Райана. Боится высоты, но прыгала с парашютом.</p>
                                    <p class="careerum-vacancy-tab-content-country">Россия</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-vacancy-tab-image">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659037321942.png" alt="">
                                </div>
                                <div class="careerum-vacancy-tab-content">
                                    <p class="careerum-vacancy-tab-content-name">Дарья Московкина</p>
                                    <p class="careerum-vacancy-tab-content-position">Старший контент-менеджер</p>
                                    <p class="careerum-vacancy-tab-content-description">Управляет созданием контента в соцсетях. С первой стажировки работает в сфере карьеры и образования. </p>
                                    <p class="careerum-vacancy-tab-content-country">Россия</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-vacancy-tab-image">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659037331023.png" alt="">
                                </div>
                                <div class="careerum-vacancy-tab-content">
                                    <p class="careerum-vacancy-tab-content-name">Ирина Скоклеенко</p>
                                    <p class="careerum-vacancy-tab-content-position">Копирайтер</p>
                                    <p class="careerum-vacancy-tab-content-description">Создает посты и сценарии для наших читателей в соцсетях, делает контент информативным, понятным и вирусным. Владеет китайским языком.</p>
                                    <p class="careerum-vacancy-tab-content-country">Россия</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-vacancy-tab-image">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659037346850.png" alt="">
                                </div>
                                <div class="careerum-vacancy-tab-content">
                                    <p class="careerum-vacancy-tab-content-name">Анна Устинова</p>
                                    <p class="careerum-vacancy-tab-content-position">Копирайтер</p>
                                    <p class="careerum-vacancy-tab-content-description">Создает контент для социальных сетей, готовит к публикации истории о результатах наших учеников. 10 лет занималась фортепиано и даже думала связать свою жизнь с музыкой.  </p>
                                    <p class="careerum-vacancy-tab-content-country">Россия</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-vacancy-tab-image">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659037360291.png" alt="">
                                </div>
                                <div class="careerum-vacancy-tab-content">
                                    <p class="careerum-vacancy-tab-content-name">Евгения Карелина</p>
                                    <p class="careerum-vacancy-tab-content-position">Копирайтер, редактор</p>
                                    <p class="careerum-vacancy-tab-content-description">Создает тексты для корпоративного сайта, отдельных лендингов и продуктов. Настолько любит кинематограф, что на досуге пишет статьи о кино и почти дописала свой сценарий.</p>
                                    <p class="careerum-vacancy-tab-content-country">Армения</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-vacancy-tab-image">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659037370672.png" alt="">
                                </div>
                                <div class="careerum-vacancy-tab-content">
                                    <p class="careerum-vacancy-tab-content-name">Анастасия Власова</p>
                                    <p class="careerum-vacancy-tab-content-position">Младший контент-менеджер</p>
                                    <p class="careerum-vacancy-tab-content-description">Оформляет контент в Инстаграм Ольги Лермонтовой. Жуткий эмпат, поэтому всегда расстраивается, когда у близких людей плохое настроение.</p>
                                    <p class="careerum-vacancy-tab-content-country">Россия</p>
                                </div>
                            </div>
                        </div>
                        <div class="careerum-vacancy-tab" data-tab-id="Техническая команда">
                            <div>
                                <div class="careerum-vacancy-tab-image">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659037381330.png" alt="">
                                </div>
                                <div class="careerum-vacancy-tab-content">
                                    <p class="careerum-vacancy-tab-content-name">Иннокентий Солнцев</p>
                                    <p class="careerum-vacancy-tab-content-position">Технический директор</p>
                                    <p class="careerum-vacancy-tab-content-description">Отвечает за работу технических сервисов, составляющих платформу Careerum. Взлетал на самолете больше раз, чем приземлялся.</p>
                                    <p class="careerum-vacancy-tab-content-country">Италия</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-vacancy-tab-image">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659037391248.png" alt="">
                                </div>
                                <div class="careerum-vacancy-tab-content">
                                    <p class="careerum-vacancy-tab-content-name">Артем Покатилов</p>
                                    <p class="careerum-vacancy-tab-content-position">Веб-разработчик</p>
                                    <p class="careerum-vacancy-tab-content-description">Разрабатывает внутреннюю CRM-систему, конструктор сайтов, инструменты аналитики и другие полезности. Проводит ретриты как инструктор духовной практики.</p>
                                    <p class="careerum-vacancy-tab-content-country">Россия</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-vacancy-tab-image">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659037405603.png" alt="">
                                </div>
                                <div class="careerum-vacancy-tab-content">
                                    <p class="careerum-vacancy-tab-content-name">Виктор Некрасов</p>
                                    <p class="careerum-vacancy-tab-content-position">Руководитель технической команды</p>
                                    <p class="careerum-vacancy-tab-content-description">Разрабатывает нетворк-инговую платформу. Отвечает за техническую часть и организует командную разработку. Поет джаз и играет на этнических инструментах.</p>
                                    <p class="careerum-vacancy-tab-content-country">Россия</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-vacancy-tab-image">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659037415169.png" alt="">
                                </div>
                                <div class="careerum-vacancy-tab-content">
                                    <p class="careerum-vacancy-tab-content-name">Александр Рудецкий</p>
                                    <p class="careerum-vacancy-tab-content-position">Фронтенд-разработчик</p>
                                    <p class="careerum-vacancy-tab-content-description">Разрабатывает социальную сеть Careerum, участвует в создании CRM-системы. Ночью гораздо продуктивнее, чем днём.</p>
                                    <p class="careerum-vacancy-tab-content-country">Россия</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-vacancy-tab-image">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659037426591.png" alt="">
                                </div>
                                <div class="careerum-vacancy-tab-content">
                                    <p class="careerum-vacancy-tab-content-name">Сергей Нечаев</p>
                                    <p class="careerum-vacancy-tab-content-position">Программист</p>
                                    <p class="careerum-vacancy-tab-content-description">Разрабатывает нетворкинговую платформу. А в свободное время ездит на собаках.</p>
                                    <p class="careerum-vacancy-tab-content-country">Россия</p>
                                </div>
                            </div>
                        </div>
                        <div class="careerum-vacancy-tab" data-tab-id="Коучи">
                            <div>
                                <div class="careerum-vacancy-tab-image">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659037442991.png" alt="">
                                </div>
                                <div class="careerum-vacancy-tab-content">
                                    <p class="careerum-vacancy-tab-content-name">Светлана Баран</p>
                                    <p class="careerum-vacancy-tab-content-position">Коуч ICF, старший коуч Careerum</p>
                                    <p class="careerum-vacancy-tab-content-description">Помогает клубовцам построить план действий и прийти к цели, руководит командой коучей Careerum. Жила в 10 странах и говорит на 8 языках.</p>
                                    <p class="careerum-vacancy-tab-content-country">Италия</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-vacancy-tab-image">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659037451770.png" alt="">
                                </div>
                                <div class="careerum-vacancy-tab-content">
                                    <p class="careerum-vacancy-tab-content-name">Марина Веденичева</p>
                                    <p class="careerum-vacancy-tab-content-position">Коуч ICF PCC</p>
                                    <p class="careerum-vacancy-tab-content-description">Специализируется на темах лидерства, менеджмента и карьерного роста. На заре карьеры работала на телевидении, с тех пор крайне редко смотрит телевизор (особенно новости).</p>
                                    <p class="careerum-vacancy-tab-content-country">Великобритания</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-vacancy-tab-image">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659037464902.png" alt="">
                                </div>
                                <div class="careerum-vacancy-tab-content">
                                    <p class="careerum-vacancy-tab-content-name">Астра Висаева</p>
                                    <p class="careerum-vacancy-tab-content-position">Коуч AFC</p>
                                    <p class="careerum-vacancy-tab-content-description">Помогает изменить ограничивающие привычки мышления и обрести свое истинное Я. Кроме коучинга имеет профессиональное образование в финансах и танцах.</p>
                                    <p class="careerum-vacancy-tab-content-country">Россия</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-vacancy-tab-image">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659037474447.png" alt="">
                                </div>
                                <div class="careerum-vacancy-tab-content">
                                    <p class="careerum-vacancy-tab-content-name">Ирина Феоктистова</p>
                                    <p class="careerum-vacancy-tab-content-position">Коуч AFC</p>
                                    <p class="careerum-vacancy-tab-content-description">Специализируется на темах баланса работы и личной жизни, а также смены сферы. Когда-то работала переводчиком с языка суахили.</p>
                                    <p class="careerum-vacancy-tab-content-country">Россия</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-vacancy-tab-image">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659037485464.png" alt="">
                                </div>
                                <div class="careerum-vacancy-tab-content">
                                    <p class="careerum-vacancy-tab-content-name">Елена Эльзенбах</p>
                                    <p class="careerum-vacancy-tab-content-position">Коуч ICF</p>
                                    <p class="careerum-vacancy-tab-content-description">Помогает находить ответы на карьерные вопросы, повышать уверенность в себе и справляться с выгоранием. Более 10 лет волонтерит на разных мероприятиях.</p>
                                    <p class="careerum-vacancy-tab-content-country">Россия</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-vacancy-tab-image">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659037495857.png" alt="">
                                </div>
                                <div class="careerum-vacancy-tab-content">
                                    <p class="careerum-vacancy-tab-content-name">Елена Добринская</p>
                                    <p class="careerum-vacancy-tab-content-position">Коуч ICF</p>
                                    <p class="careerum-vacancy-tab-content-description">Специализируется на темах: самоопределение, мотивация и самооценка. Живет на искусственном острове в форме пальмы.</p>
                                    <p class="careerum-vacancy-tab-content-country">ОАЭ</p>
                                </div>
                            </div>
                        </div>
                        <div class="careerum-vacancy-tab" data-tab-id="Эксперты">
                            <div>
                                <div class="careerum-vacancy-tab-image">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659037506979.png" alt="">
                                </div>
                                <div class="careerum-vacancy-tab-content">
                                    <p class="careerum-vacancy-tab-content-name">Елена Федорова</p>
                                    <p class="careerum-vacancy-tab-content-position">Эксперт по трудовому праву</p>
                                    <p class="careerum-vacancy-tab-content-description">Пишет материалы и отвечает на вопросы, связанные с трудовым и гражданским правом. Работала в Google.</p>
                                    <p class="careerum-vacancy-tab-content-country">Россия</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-vacancy-tab-image">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659037516684.png" alt="">
                                </div>
                                <div class="careerum-vacancy-tab-content">
                                    <p class="careerum-vacancy-tab-content-name">София Бессонова</p>
                                    <p class="careerum-vacancy-tab-content-position">CV-специалист, коуч ICF</p>
                                    <p class="careerum-vacancy-tab-content-description">Помогает участникам усилить резюме и посмотреть на него с точки зрения работодателей. 2 года преподавала психологию, считает себя адептом темы выгорания.</p>
                                    <p class="careerum-vacancy-tab-content-country">Израиль</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-vacancy-tab-image">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659037527729.png" alt="">
                                </div>
                                <div class="careerum-vacancy-tab-content">
                                    <p class="careerum-vacancy-tab-content-name">Арина Хома</p>
                                    <p class="careerum-vacancy-tab-content-position">Эксперт, бизнес-тренер</p>
                                    <p class="careerum-vacancy-tab-content-description">Ведет мастерские по коммуникации и работе со стрессом, пишет эксперт-ные статьи о сложных переговорах. Закончила юрфак МГУ и 5 лет работала судебным юристом.</p>
                                    <p class="careerum-vacancy-tab-content-country">Россия</p>
                                </div>
                            </div>
                        </div>  
                    </div> 
                    <div class="careerum-vacancy-tab-content-full">
                        <p class="careerum-vacancy-tab-content-header">Хочешь стать частью<br> продуктовой команды Careerum?</p>
                        <a href="#" class="btn-color-main-light-blue">Посмотреть вакансии</a>
                    </div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-vacancy-tabs-mobile', {
        label: 'Команда табы (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-vacancy-tabs-mobile careerum-vacancy-color-blue">
            <div>
                <h2>Careerum в лицах</h2>
                <div class="careerum-vacancy-tabs-items">
                    <div class="careerum-vacancy-tabs-selectors">
                        <form action="">
                            <label class="active" data-color="blue">
                                <p>Продуктово-проектная команда</p><input type="radio" name="careerum-vacancy-radio">
                            </label>
                            <label data-color="orange">
                                <p>Команда маркетинга</p><input type="radio" name="careerum-vacancy-radio">
                            </label>
                            <label data-color="grey">
                                <p>Техническая команда</p><input type="radio" name="careerum-vacancy-radio">
                            </label>
                            <label data-color="mediumblue">
                                <p>Коучи</p><input type="radio" name="careerum-vacancy-radio">
                            </label>
                            <label data-color="darkorange">
                                <p>Эксперты</p><input type="radio" name="careerum-vacancy-radio">
                            </label>
                        </form>
                    </div>
                    <div class="careerum-vacancy-tabs-content">
                        <div class="careerum-vacancy-tab" data-tab-id="Продуктово-проектная команда">
                            <div>
                                <div class="careerum-vacancy-tab-image">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659037119344.png" alt="">
                                </div>
                                <div class="careerum-vacancy-tab-content">
                                    <p class="careerum-vacancy-tab-content-name">Ольга Лермонтова</p>
                                    <p class="careerum-vacancy-tab-content-position">Основательница и топ-эксперт Careerum</p>
                                    <p class="careerum-vacancy-tab-content-description">Руководит процессами, разрабатывает стратегии и ведет курсы и мастер-классы. Работала в 5 странах, в том числе на руководящих должно-стях в Google и Microsoft.</p>
                                    <p class="careerum-vacancy-tab-content-country">Италия</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-vacancy-tab-image">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659037130179.png" alt="">
                                </div>
                                <div class="careerum-vacancy-tab-content">
                                    <p class="careerum-vacancy-tab-content-name">Юлиана Керт</p>
                                    <p class="careerum-vacancy-tab-content-position">Директор по продукту</p>
                                    <p class="careerum-vacancy-tab-content-description">Руководит продуктовой<br> и экспертной командами. Владеет тремя мертвыми языками и использует их практически каждый день.</p>
                                    <p class="careerum-vacancy-tab-content-country">Россия</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-vacancy-tab-image">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659037148084.png" alt="">
                                </div>
                                <div class="careerum-vacancy-tab-content">
                                    <p class="careerum-vacancy-tab-content-name">Марго Масленникова</p>
                                    <p class="careerum-vacancy-tab-content-position">Операционный директор</p>
                                    <p class="careerum-vacancy-tab-content-description">Отвечает за инфраструк-туру, процессы, ресурсы и запуск стратегических проектов. Получила<br> от друзей грамоту «Почетный делец Авито» за продажи на более 300 тысяч рублей.</p>
                                    <p class="careerum-vacancy-tab-content-country">Турция</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-vacancy-tab-image">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659037158513.png" alt="">
                                </div>
                                <div class="careerum-vacancy-tab-content">
                                    <p class="careerum-vacancy-tab-content-name">Виктория Фадеева</p>
                                    <p class="careerum-vacancy-tab-content-position">Менеджер проектов</p>
                                    <p class="careerum-vacancy-tab-content-description">Руководит проектами, связанными с разработкой (нетворкинговая платформа, сайт, CRM, LMS, инструменты автома-тизации работы). Умеет находить подход к любому разработчику.</p>
                                    <p class="careerum-vacancy-tab-content-country">Россия</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-vacancy-tab-image">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659037169087.png" alt="">
                                </div>
                                <div class="careerum-vacancy-tab-content">
                                    <p class="careerum-vacancy-tab-content-name">Мария Бродская</p>
                                    <p class="careerum-vacancy-tab-content-position">Продакт-менеджер</p>
                                    <p class="careerum-vacancy-tab-content-description">Создает курсы, вебинары и фокус-кэмпы, начиная с определения потребностей участников клуба и заканчивая приемкой готового материала и анализом результата. Знает 7 языков.</p>
                                    <p class="careerum-vacancy-tab-content-country">Россия</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-vacancy-tab-image">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659037180448.png" alt="">
                                </div>
                                <div class="careerum-vacancy-tab-content">
                                    <p class="careerum-vacancy-tab-content-name">Ольга Капуста</p>
                                    <p class="careerum-vacancy-tab-content-position">Комьюнити-менеджер</p>
                                    <p class="careerum-vacancy-tab-content-description">Развивает сообщество клуба, курирует нетворк-инговые активности и работу амбассадоров. Организовывает тим-билдинги. Любую историю может рассказать как стендап.</p>
                                    <p class="careerum-vacancy-tab-content-country">Беларусь</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-vacancy-tab-image">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659037190581.png" alt="">
                                </div>
                                <div class="careerum-vacancy-tab-content">
                                    <p class="careerum-vacancy-tab-content-name">Ксения Павлова</p>
                                    <p class="careerum-vacancy-tab-content-position">Методолог</p>
                                    <p class="careerum-vacancy-tab-content-description">Проектирует курсы, создает обучающий опыт, придумывает игровые механики. До Careerum c нуля построила несколько бизнесов и одну онлайн-школу.</p>
                                    <p class="careerum-vacancy-tab-content-country">Канада</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-vacancy-tab-image">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659037201402.png" alt="">
                                </div>
                                <div class="careerum-vacancy-tab-content">
                                    <p class="careerum-vacancy-tab-content-name">Оксана Богданова</p>
                                    <p class="careerum-vacancy-tab-content-position">Пишущий редактор</p>
                                    <p class="careerum-vacancy-tab-content-description">Редактирует образовательные материалы клуба, создает контент для нетворк-инговой платформы и пишет письма клубовцам. В карманах прячет желуди и ракушки.</p>
                                    <p class="careerum-vacancy-tab-content-country">Россия</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-vacancy-tab-image">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659037212916.png" alt="">
                                </div>
                                <div class="careerum-vacancy-tab-content">
                                    <p class="careerum-vacancy-tab-content-name">Дарина Байжанова</p>
                                    <p class="careerum-vacancy-tab-content-position">Проектный ассистент</p>
                                    <p class="careerum-vacancy-tab-content-description">Поддерживает порядок в хранилищах команды, помогает актуализировать материалы, модерирует вебинары, курирует планерки. Разговаривает на 5 языках.</p>
                                    <p class="careerum-vacancy-tab-content-country">Франция</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-vacancy-tab-image">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659037221208.png" alt="">
                                </div>
                                <div class="careerum-vacancy-tab-content">
                                    <p class="careerum-vacancy-tab-content-name">Оксана Наливайко</p>
                                    <p class="careerum-vacancy-tab-content-position">Ведущий дизайнер</p>
                                    <p class="careerum-vacancy-tab-content-description">Управляет созданием айдентики, запускает маркетинговые активности, руководит кросс-командными процессами. Знает разницу между UX и UI дизайном и успешно применяет это в жизни.</p>
                                    <p class="careerum-vacancy-tab-content-country">Грузия</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-vacancy-tab-image">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659037231669.png" alt="">
                                </div>
                                <div class="careerum-vacancy-tab-content">
                                    <p class="careerum-vacancy-tab-content-name">Татьяна Погребняк</p>
                                    <p class="careerum-vacancy-tab-content-position">Руководитель команды поддержки пользователей </p>
                                    <p class="careerum-vacancy-tab-content-description">Работает с обращениями клиентов, отвечает за улуч-шение процессов поддержки. Любит людей и не перестает у них учиться.</p>
                                    <p class="careerum-vacancy-tab-content-country">Россия</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-vacancy-tab-image">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659037251286.png" alt="">
                                </div>
                                <div class="careerum-vacancy-tab-content">
                                    <p class="careerum-vacancy-tab-content-name">Бахытжан Абдумаликов</p>
                                    <p class="careerum-vacancy-tab-content-position">Аналитик данных</p>
                                    <p class="careerum-vacancy-tab-content-description">Выстраивает аналитику компании и занимается анализом данных. Знает 4 языка и каждый день катается на велосипеде. </p>
                                    <p class="careerum-vacancy-tab-content-country">Казахстан</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-vacancy-tab-image">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659037261828.png" alt="">
                                </div>
                                <div class="careerum-vacancy-tab-content">
                                    <p class="careerum-vacancy-tab-content-name">Юлия Кобец</p>
                                    <p class="careerum-vacancy-tab-content-position">Дизайнер</p>
                                    <p class="careerum-vacancy-tab-content-description">Оформляет учебные материалы Careerum.Club, создает макеты для социальных сетей. Любит глупые комедии.</p>
                                    <p class="careerum-vacancy-tab-content-country">Россия</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-vacancy-tab-image">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659037272022.png" alt="">
                                </div>
                                <div class="careerum-vacancy-tab-content">
                                    <p class="careerum-vacancy-tab-content-name">Карина Кадеркаева</p>
                                    <p class="careerum-vacancy-tab-content-position">Карьерный эксперт</p>
                                    <p class="careerum-vacancy-tab-content-description">Создает экспертный контент новых курсов и фокус-кэмпов и улучшает текущие материалы клуба. Воспитывает немецкую овчарку и хаски. В качестве хобби собирает личную библиотеку.</p>
                                    <p class="careerum-vacancy-tab-content-country">Россия</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-vacancy-tab-image">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659037282525.png" alt="">
                                </div>
                                <div class="careerum-vacancy-tab-content">
                                    <p class="careerum-vacancy-tab-content-name">Карина Кириша</p>
                                    <p class="careerum-vacancy-tab-content-position">Юрист</p>
                                    <p class="careerum-vacancy-tab-content-description">Оказывает юридическую поддержку Careerum. Защищает интеллект-уальную собственность и не только. В школе ненавидела право, но стала юристом.</p>
                                    <p class="careerum-vacancy-tab-content-country">Украина</p>
                                </div>
                            </div>
                        </div>
                        <div class="careerum-vacancy-tab" data-tab-id="Команда маркетинга">
                            <div>
                                <div class="careerum-vacancy-tab-image">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659037296953.png" alt="">
                                </div>
                                <div class="careerum-vacancy-tab-content">
                                    <p class="careerum-vacancy-tab-content-name">Юлиана Логинова</p>
                                    <p class="careerum-vacancy-tab-content-position">Директор по маркетингу</p>
                                    <p class="careerum-vacancy-tab-content-description">Руководит всем маркетингом и контентом Careerum, делает так, чтобы как можно больше людей узнали о компании и улучшили свою карьеру. 6 лет работала продюсером в Comedy Club Production.</p>
                                    <p class="careerum-vacancy-tab-content-country">Россия</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-vacancy-tab-image">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659037310228.png" alt="">
                                </div>
                                <div class="careerum-vacancy-tab-content">
                                    <p class="careerum-vacancy-tab-content-name">Юлия Орлова</p>
                                    <p class="careerum-vacancy-tab-content-position">Проджект-менеджер</p>
                                    <p class="careerum-vacancy-tab-content-description">Занимается подкастами и YouTube-каналом Careerum, организует выступления спикеров клуба. Фея рассылок и подруга бота Райана. Боится высоты, но прыгала с парашютом.</p>
                                    <p class="careerum-vacancy-tab-content-country">Россия</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-vacancy-tab-image">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659037321942.png" alt="">
                                </div>
                                <div class="careerum-vacancy-tab-content">
                                    <p class="careerum-vacancy-tab-content-name">Дарья Московкина</p>
                                    <p class="careerum-vacancy-tab-content-position">Старший контент-менеджер</p>
                                    <p class="careerum-vacancy-tab-content-description">Управляет созданием контента в соцсетях. С первой стажировки работает в сфере карьеры и образования. </p>
                                    <p class="careerum-vacancy-tab-content-country">Россия</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-vacancy-tab-image">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659037331023.png" alt="">
                                </div>
                                <div class="careerum-vacancy-tab-content">
                                    <p class="careerum-vacancy-tab-content-name">Ирина Скоклеенко</p>
                                    <p class="careerum-vacancy-tab-content-position">Копирайтер</p>
                                    <p class="careerum-vacancy-tab-content-description">Создает посты и сценарии для наших читателей в соцсетях, делает контент информативным, понятным и вирусным. Владеет китайским языком.</p>
                                    <p class="careerum-vacancy-tab-content-country">Россия</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-vacancy-tab-image">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659037346850.png" alt="">
                                </div>
                                <div class="careerum-vacancy-tab-content">
                                    <p class="careerum-vacancy-tab-content-name">Анна Устинова</p>
                                    <p class="careerum-vacancy-tab-content-position">Копирайтер</p>
                                    <p class="careerum-vacancy-tab-content-description">Создает контент для социальных сетей, готовит к публикации истории о результатах наших учеников. 10 лет занималась фортепиано и даже думала связать свою жизнь с музыкой.  </p>
                                    <p class="careerum-vacancy-tab-content-country">Россия</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-vacancy-tab-image">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659037360291.png" alt="">
                                </div>
                                <div class="careerum-vacancy-tab-content">
                                    <p class="careerum-vacancy-tab-content-name">Евгения Карелина</p>
                                    <p class="careerum-vacancy-tab-content-position">Копирайтер, редактор</p>
                                    <p class="careerum-vacancy-tab-content-description">Создает тексты для корпоративного сайта, отдельных лендингов и продуктов. Настолько любит кинематограф, что на досуге пишет статьи о кино и почти дописала свой сценарий.</p>
                                    <p class="careerum-vacancy-tab-content-country">Армения</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-vacancy-tab-image">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659037370672.png" alt="">
                                </div>
                                <div class="careerum-vacancy-tab-content">
                                    <p class="careerum-vacancy-tab-content-name">Анастасия Власова</p>
                                    <p class="careerum-vacancy-tab-content-position">Младший контент-менеджер</p>
                                    <p class="careerum-vacancy-tab-content-description">Оформляет контент в Инстаграм Ольги Лермонтовой. Жуткий эмпат, поэтому всегда расстраивается, когда у близких людей плохое настроение.</p>
                                    <p class="careerum-vacancy-tab-content-country">Россия</p>
                                </div>
                            </div>
                        </div>
                        <div class="careerum-vacancy-tab" data-tab-id="Техническая команда">
                            <div>
                                <div class="careerum-vacancy-tab-image">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659037381330.png" alt="">
                                </div>
                                <div class="careerum-vacancy-tab-content">
                                    <p class="careerum-vacancy-tab-content-name">Иннокентий Солнцев</p>
                                    <p class="careerum-vacancy-tab-content-position">Технический директор</p>
                                    <p class="careerum-vacancy-tab-content-description">Отвечает за работу технических сервисов, составляющих платформу Careerum. Взлетал на самолете больше раз, чем приземлялся.</p>
                                    <p class="careerum-vacancy-tab-content-country">Италия</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-vacancy-tab-image">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659037391248.png" alt="">
                                </div>
                                <div class="careerum-vacancy-tab-content">
                                    <p class="careerum-vacancy-tab-content-name">Артем Покатилов</p>
                                    <p class="careerum-vacancy-tab-content-position">Веб-разработчик</p>
                                    <p class="careerum-vacancy-tab-content-description">Разрабатывает внутреннюю CRM-систему, конструктор сайтов, инструменты аналитики и другие полезности. Проводит ретриты как инструктор духовной практики.</p>
                                    <p class="careerum-vacancy-tab-content-country">Россия</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-vacancy-tab-image">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659037405603.png" alt="">
                                </div>
                                <div class="careerum-vacancy-tab-content">
                                    <p class="careerum-vacancy-tab-content-name">Виктор Некрасов</p>
                                    <p class="careerum-vacancy-tab-content-position">Руководитель технической команды</p>
                                    <p class="careerum-vacancy-tab-content-description">Разрабатывает нетворк-инговую платформу. Отвечает за техническую часть и организует командную разработку. Поет джаз и играет на этнических инструментах.</p>
                                    <p class="careerum-vacancy-tab-content-country">Россия</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-vacancy-tab-image">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659037415169.png" alt="">
                                </div>
                                <div class="careerum-vacancy-tab-content">
                                    <p class="careerum-vacancy-tab-content-name">Александр Рудецкий</p>
                                    <p class="careerum-vacancy-tab-content-position">Фронтенд-разработчик</p>
                                    <p class="careerum-vacancy-tab-content-description">Разрабатывает социальную сеть Careerum, участвует в создании CRM-системы. Ночью гораздо продуктивнее, чем днём.</p>
                                    <p class="careerum-vacancy-tab-content-country">Россия</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-vacancy-tab-image">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659037426591.png" alt="">
                                </div>
                                <div class="careerum-vacancy-tab-content">
                                    <p class="careerum-vacancy-tab-content-name">Сергей Нечаев</p>
                                    <p class="careerum-vacancy-tab-content-position">Программист</p>
                                    <p class="careerum-vacancy-tab-content-description">Разрабатывает нетворкинговую платформу. А в свободное время ездит на собаках.</p>
                                    <p class="careerum-vacancy-tab-content-country">Россия</p>
                                </div>
                            </div>
                        </div>
                        <div class="careerum-vacancy-tab" data-tab-id="Коучи">
                            <div>
                                <div class="careerum-vacancy-tab-image">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659037442991.png" alt="">
                                </div>
                                <div class="careerum-vacancy-tab-content">
                                    <p class="careerum-vacancy-tab-content-name">Светлана Баран</p>
                                    <p class="careerum-vacancy-tab-content-position">Коуч ICF, старший коуч Careerum</p>
                                    <p class="careerum-vacancy-tab-content-description">Помогает клубовцам построить план действий и прийти к цели, руководит командой коучей Careerum. Жила в 10 странах и говорит на 8 языках.</p>
                                    <p class="careerum-vacancy-tab-content-country">Италия</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-vacancy-tab-image">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659037451770.png" alt="">
                                </div>
                                <div class="careerum-vacancy-tab-content">
                                    <p class="careerum-vacancy-tab-content-name">Марина Веденичева</p>
                                    <p class="careerum-vacancy-tab-content-position">Коуч ICF PCC</p>
                                    <p class="careerum-vacancy-tab-content-description">Специализируется на темах лидерства, менеджмента и карьерного роста. На заре карьеры работала на телевидении, с тех пор крайне редко смотрит телевизор (особенно новости).</p>
                                    <p class="careerum-vacancy-tab-content-country">Великобритания</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-vacancy-tab-image">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659037464902.png" alt="">
                                </div>
                                <div class="careerum-vacancy-tab-content">
                                    <p class="careerum-vacancy-tab-content-name">Астра Висаева</p>
                                    <p class="careerum-vacancy-tab-content-position">Коуч AFC</p>
                                    <p class="careerum-vacancy-tab-content-description">Помогает изменить ограничивающие привычки мышления и обрести свое истинное Я. Кроме коучинга имеет профессиональное образование в финансах и танцах.</p>
                                    <p class="careerum-vacancy-tab-content-country">Россия</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-vacancy-tab-image">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659037474447.png" alt="">
                                </div>
                                <div class="careerum-vacancy-tab-content">
                                    <p class="careerum-vacancy-tab-content-name">Ирина Феоктистова</p>
                                    <p class="careerum-vacancy-tab-content-position">Коуч AFC</p>
                                    <p class="careerum-vacancy-tab-content-description">Специализируется на темах баланса работы и личной жизни, а также смены сферы. Когда-то работала переводчиком с языка суахили.</p>
                                    <p class="careerum-vacancy-tab-content-country">Россия</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-vacancy-tab-image">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659037485464.png" alt="">
                                </div>
                                <div class="careerum-vacancy-tab-content">
                                    <p class="careerum-vacancy-tab-content-name">Елена Эльзенбах</p>
                                    <p class="careerum-vacancy-tab-content-position">Коуч ICF</p>
                                    <p class="careerum-vacancy-tab-content-description">Помогает находить ответы на карьерные вопросы, повышать уверенность в себе и справляться с выгоранием. Более 10 лет волонтерит на разных мероприятиях.</p>
                                    <p class="careerum-vacancy-tab-content-country">Россия</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-vacancy-tab-image">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659037495857.png" alt="">
                                </div>
                                <div class="careerum-vacancy-tab-content">
                                    <p class="careerum-vacancy-tab-content-name">Елена Добринская</p>
                                    <p class="careerum-vacancy-tab-content-position">Коуч ICF</p>
                                    <p class="careerum-vacancy-tab-content-description">Специализируется на темах: самоопределение, мотивация и самооценка. Живет на искусственном острове в форме пальмы.</p>
                                    <p class="careerum-vacancy-tab-content-country">ОАЭ</p>
                                </div>
                            </div>
                        </div>
                        <div class="careerum-vacancy-tab" data-tab-id="Эксперты">
                            <div>
                                <div class="careerum-vacancy-tab-image">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659037506979.png" alt="">
                                </div>
                                <div class="careerum-vacancy-tab-content">
                                    <p class="careerum-vacancy-tab-content-name">Елена Федорова</p>
                                    <p class="careerum-vacancy-tab-content-position">Эксперт по трудовому праву</p>
                                    <p class="careerum-vacancy-tab-content-description">Пишет материалы и отвечает на вопросы, связанные с трудовым и гражданским правом. Работала в Google.</p>
                                    <p class="careerum-vacancy-tab-content-country">Россия</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-vacancy-tab-image">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659037516684.png" alt="">
                                </div>
                                <div class="careerum-vacancy-tab-content">
                                    <p class="careerum-vacancy-tab-content-name">София Бессонова</p>
                                    <p class="careerum-vacancy-tab-content-position">CV-специалист, коуч ICF</p>
                                    <p class="careerum-vacancy-tab-content-description">Помогает участникам усилить резюме и посмотреть на него с точки зрения работодателей. 2 года преподавала психологию, считает себя адептом темы выгорания.</p>
                                    <p class="careerum-vacancy-tab-content-country">Израиль</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-vacancy-tab-image">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1659037527729.png" alt="">
                                </div>
                                <div class="careerum-vacancy-tab-content">
                                    <p class="careerum-vacancy-tab-content-name">Арина Хома</p>
                                    <p class="careerum-vacancy-tab-content-position">Эксперт, бизнес-тренер</p>
                                    <p class="careerum-vacancy-tab-content-description">Ведет мастерские по коммуникации и работе со стрессом, пишет эксперт-ные статьи о сложных переговорах. Закончила юрфак МГУ и 5 лет работала судебным юристом.</p>
                                    <p class="careerum-vacancy-tab-content-country">Россия</p>
                                </div>
                            </div>
                        </div>  
                    </div> 
                    <div class="careerum-vacancy-tab-content-full">
                        <p class="careerum-vacancy-tab-content-header">Хочешь<br> стать частью<br> продуктовой команды Careerum?</p>
                        <a href="#" class="btn-color-main-light-blue">Посмотреть вакансии</a>
                    </div>
                </div>
            </div>
        </div>`
	});

    
    blockManager.add('careerum-interblock-timer', {
        label: 'Таймер между блоков',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-interblock-timer"
        data-redirect="no"
        data-url=""
        data-static="yes"
        data-offset="" 
        data-timer-end="08/19/2022 22:01 GMT+0300">
            <div>
                <div>
                    <p>Ваше приглашение<br> в клуб сгорит через</p>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1660638709275.svg" alt="">
                </div>
                <div>
                    <div>
                        <p class="timer-day-number">00</p>
                        <p class="timer-day-text">дни</p>
                    </div>
                    <div>
                        <p class="timer-hour-number">00</p>
                        <p class="timer-hour-text">часы</p>
                    </div>
                    <div>
                        <p class="timer-min-number">00</p>
                        <p class="timer-min-text">минуты</p>
                    </div>
                    <div>
                        <p class="timer-sec-number">00</p>
                        <p class="timer-sec-text">секунды</p>
                    </div>
                </div>
                <div>
                    <a href="#" class="btn-color-main-dark-orange">Вступить в клуб</a>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-interblock-timer-tablet', {
        label: 'Таймер между блоков (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-interblock-timer-tablet"
        data-redirect="no"
        data-url=""
        data-static="yes"
        data-offset="" 
        data-timer-end="08/19/2022 22:01 GMT+0300">
            <div>
                <div>
                    <p>Ваше приглашение<br> в клуб сгорит через</p>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1660638766394.svg" alt="">
                </div>
                <div>
                    <div>
                        <p class="timer-day-number">00</p>
                        <p class="timer-day-text">дни</p>
                    </div>
                    <div>
                        <p class="timer-hour-number">00</p>
                        <p class="timer-hour-text">часы</p>
                    </div>
                    <div>
                        <p class="timer-min-number">00</p>
                        <p class="timer-min-text">минуты</p>
                    </div>
                    <div>
                        <p class="timer-sec-number">00</p>
                        <p class="timer-sec-text">секунды</p>
                    </div>
                </div>
                <div>
                    <a href="#" class="btn-color-main-dark-orange">Вступить в клуб</a>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-interblock-timer-mobile', {
        label: 'Таймер между блоков (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-interblock-timer-mobile"
        data-redirect="no"
        data-url=""
        data-static="yes"
        data-offset="" 
        data-timer-end="08/19/2022 22:01 GMT+0300">
            <div>
                <div>
                    <p>Ваше приглашение в клуб сгорит через</p>
                </div>
                <div>
                    <div>
                        <p class="timer-day-number">00</p>
                        <p class="timer-day-text">дни</p>
                    </div>
                    <div>
                        <p class="timer-hour-number">00</p>
                        <p class="timer-hour-text">часы</p>
                    </div>
                    <div>
                        <p class="timer-min-number">00</p>
                        <p class="timer-min-text">минуты</p>
                    </div>
                    <div>
                        <p class="timer-sec-number">00</p>
                        <p class="timer-sec-text">секунды</p>
                    </div>
                </div>
            </div>
        </div>`
	});
    
    blockManager.add('careerum-reserve-main', {
        label: 'Бронь места',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-reserve-main">
            <div>
                <div>
                    <a href="#">Назад</a>
                </div>
                <div>
                    <h2>Бронь места в клубе</h2>
                    <p>Сейчас клуб закрыт — оформить подписку можно раз в 3-4 месяца. Заполните короткую<br> анкету, мы внесем вас в лист ожидания и раньше всех сообщим об открытии клуба </p>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1661321438076.svg" alt="">
                </div>
                <div>
                    <div>
                        <div>
                            <p class="form-header">
                                Ваша ближайшая<br> карьерная цель
                            </p>
                            <form>
                                <ul>
                                    <li>
                                        <label class="active">
                                            <p>Найти новую работу</p>
                                            <input type="radio" name="goal-input">
                                        </label>
                                    </li>
                                    <li>
                                        <label>
                                            <p>Получить повышение в зарплате<br> и должности на текущей работе</p>
                                            <input type="radio" name="goal-input">
                                        </label>
                                    </li>
                                    <li>
                                        <label>
                                            <p>Понять, в какой сфере<br> мне развиваться</p>
                                            <input type="radio" name="goal-input">
                                        </label>
                                    </li>
                                    <li>
                                        <label>
                                            <p>Строить карьеру более быстро,<br> легко и осознанно</p>
                                            <input type="radio" name="goal-input">
                                        </label>
                                    </li>
                                </ul>
                            </form>
                        </div>
                        <div>
                            <p class="form-header">
                                Покупали ли вы какой-либо из наших продуктов?
                            </p>
                            <form>
                                <ul class="ul-row">
                                    <li>
                                        <label class="active">
                                            <p>Да</p>
                                            <input type="radio" name="buy-input">
                                        </label>
                                    </li>
                                    <li>
                                        <label>
                                            <p>Нет</p>
                                            <input type="radio" name="buy-input">
                                        </label>
                                    </li>
                                </ul>
                            </form>
                        </div>
                    </div>
                        <div>
                            <div class="careerum-registration-form">
                                <form action="">
                                    <div><input type="text" name="firstname" id="" required><span>Имя</span></div>
                                    <div><input type="text" name="lastname" id="" required><span>Фамилия</span></div>
                                    <div><input type="email" name="email" id="" required><span>Почта</span></div>
                                    <div><input type="tel" name="tel" id="" required><span>Номер телефона</span></div>                                
                                    <div>
                                        <label><input type="checkbox" name="agree" id=""></label>
                                        <p>Я принимаю условия <a href="#">Публичной оферты</a> и даю<br> согласие на обработку своих персональных данных в соответствии с <a href="#">Политикой конфиденциальности</a></p>
                                    </div>
                                    <button disabled>Забронировать место</button>
                                </form>
                            </div>
                        </div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-reserve-main-tablet', {
        label: 'Бронь места (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-reserve-main-tablet">
            <div>
                <div>
                    <a href="#">Назад</a>
                </div>
                <div>
                    <div>
                        <h2>Бронь места в клубе</h2>
                        <p>Сейчас клуб закрыт — оформить подписку<br> можно раз в 3-4 месяца. Заполните короткую<br> анкету, мы внесем вас в лист ожидания и раньше всех сообщим об открытии клуба </p>
                    </div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1661321465375.svg" alt="">
                </div>
                <div>
                    <div>
                        <div>
                            <p class="form-header">
                                Ваша ближайшая<br> карьерная цель
                            </p>
                            <form>
                                <ul>
                                    <li>
                                        <label class="active">
                                            <p>Найти новую работу</p>
                                            <input type="radio" name="goal-input">
                                        </label>
                                    </li>
                                    <li>
                                        <label>
                                            <p>Получить повышение в зарплате<br> и должности на текущей работе</p>
                                            <input type="radio" name="goal-input">
                                        </label>
                                    </li>
                                    <li>
                                        <label>
                                            <p>Понять, в какой сфере<br> мне развиваться</p>
                                            <input type="radio" name="goal-input">
                                        </label>
                                    </li>
                                    <li>
                                        <label>
                                            <p>Строить карьеру более быстро,<br> легко и осознанно</p>
                                            <input type="radio" name="goal-input">
                                        </label>
                                    </li>
                                </ul>
                            </form>
                        </div>
                        <div>
                            <p class="form-header">
                                Пользовались<br> ли вы платными<br>продуктами Careerum?
                            </p>
                            <form>
                                <ul class="ul-row">
                                    <li>
                                        <label class="active">
                                            <p>Да</p>
                                            <input type="radio" name="buy-input">
                                        </label>
                                    </li>
                                    <li>
                                        <label>
                                            <p>Нет</p>
                                            <input type="radio" name="buy-input">
                                        </label>
                                    </li>
                                </ul>
                            </form>
                        </div>
                    </div>
                        <div>
                            <div class="careerum-registration-form-tablet">
                                <form action="">
                                    <div><input type="text" name="firstname" id="" required><span>Имя</span></div>
                                    <div><input type="text" name="lastname" id="" required><span>Фамилия</span></div>
                                    <div><input type="email" name="email" id="" required><span>Почта</span></div>
                                    <div><input type="tel" name="tel" id="" required><span>Номер телефона</span></div>                                
                                    <div>
                                        <label><input type="checkbox" name="agree" id=""></label>
                                        <p>Я принимаю условия <a href="#">Публичной оферты</a> и даю<br> согласие на обработку своих персональных данных в соответствии с <a href="#">Политикой конфиденциальности</a></p>
                                    </div>
                                    <button disabled>Забронировать место</button>
                                </form>
                            </div>
                        </div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-reserve-main-mobile', {
        label: 'Бронь места (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-reserve-main-mobile">
            <div>
                <div>
                    <a href="#">Назад</a>
                </div>
                <div>
                    <div>
                        <h2>Бронь места<br> в клубе</h2>
                        <p>Сейчас клуб закрыт — оформить<br> подписку можно раз в 3-4 месяца. Заполните короткую анкету, мы внесем<br> вас в лист ожидания и раньше всех сообщим об открытии клуба </p>
                    </div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1661321504558.svg" alt="">
                </div>
                <div>
                    <div>
                        <div>
                            <p class="form-header">
                                Ваша ближайшая<br> карьерная цель
                            </p>
                            <form>
                                <ul>
                                    <li>
                                        <label class="active">
                                            <p>Найти новую работу</p>
                                            <input type="radio" name="goal-input">
                                        </label>
                                    </li>
                                    <li>
                                        <label>
                                            <p>Получить повышение в зарплате<br> и должности на текущей работе</p>
                                            <input type="radio" name="goal-input">
                                        </label>
                                    </li>
                                    <li>
                                        <label>
                                            <p>Понять, в какой сфере<br> мне развиваться</p>
                                            <input type="radio" name="goal-input">
                                        </label>
                                    </li>
                                    <li>
                                        <label>
                                            <p>Строить карьеру более быстро,<br> легко и осознанно</p>
                                            <input type="radio" name="goal-input">
                                        </label>
                                    </li>
                                </ul>
                            </form>
                        </div>
                        <div>
                            <p class="form-header">
                                Пользовались<br> ли вы платными<br>продуктами Careerum?
                            </p>
                            <form>
                                <ul class="ul-row">
                                    <li>
                                        <label class="active">
                                            <p>Да</p>
                                            <input type="radio" name="buy-input">
                                        </label>
                                    </li>
                                    <li>
                                        <label>
                                            <p>Нет</p>
                                            <input type="radio" name="buy-input">
                                        </label>
                                    </li>
                                </ul>
                            </form>
                        </div>
                    </div>
                        <div>
                            <div class="careerum-registration-form-mobile">
                                <form action="">
                                    <div><input type="text" name="firstname" id="" required><span>Имя</span></div>
                                    <div><input type="text" name="lastname" id="" required><span>Фамилия</span></div>
                                    <div><input type="email" name="email" id="" required><span>Почта</span></div>
                                    <div><input type="tel" name="tel" id="" required><span>Номер телефона</span></div>                                
                                    <div>
                                        <label><input type="checkbox" name="agree" id=""></label>
                                        <p>Я принимаю условия <a href="#">Публичной оферты</a><br> и даю согласие на обработку своих персональных данных в соответствии<br> с <a href="#">Политикой конфиденциальности</a></p>
                                    </div>
                                    <button disabled>Забронировать место</button>
                                </form>
                            </div>
                        </div>
                </div>
            </div>
        </div>`
	});
    
    blockManager.add('careerum-thanks-page1', {
        label: 'Страница Спасибо',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-thanks-page1">
            <div>
                <h2>Спасибо, что<br> заполнили анкету</h2>
                <p>Вы в списке самых решительных.<br>Письмо с приглашением в клуб придет<br> вам на почту раньше всех</p>
            </div>
        </div>`
	});

    blockManager.add('careerum-thanks-page1-tablet', {
        label: 'Страница Спасибо (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-thanks-page1-tablet">
            <div>
                <h2>Спасибо, что<br> заполнили анкету</h2>
                <p>Вы в списке самых решительных.<br>Письмо с приглашением в клуб придет вам<br> на почту раньше всех</p>
            </div>
        </div>`
	});

    blockManager.add('careerum-thanks-page1-mobile', {
        label: 'Страница Спасибо (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-thanks-page1-mobile">
            <div>
                <h2>Спасибо,<br> что заполнили анкету</h2>
                <p>Вы в списке самых решительных.<br>Письмо с приглашением в клуб придет вам на почту раньше всех</p>
            </div>
        </div>`
	});
    
    blockManager.add('careerum-thanks-page2', {
        label: 'Страница Поздравляем',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-thanks-page2">
            <div>
                <h2>Поздравляем!</h2>
                <div>
                    <div><p>Так как вы уже приобретали наши продукты, вы можете попасть в клуб прямо сейчас</p></div>
                    <div><p>Напишите нам на hello@careerum.ru адрес электронной почты, которую<br> вы указывали при оплате ранее</p></div>
                    <div><p>Наш менеджер свяжется<br> с вами для оформления подписки на клуб</p></div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-thanks-page2-tablet', {
        label: 'Страница Поздравляем (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-thanks-page2-tablet">
            <div>
                <h2>Поздравляем!</h2>
                <div>
                    <div><p>Так как вы уже приобретали наши продукты, вы можете попасть в клуб прямо сейчас</p></div>
                    <div><p>Напишите нам на hello@careerum.ru адрес электронной почты, которую<br> вы указывали при оплате ранее</p></div>
                    <div><p>Наш менеджер свяжется<br> с вами для оформления подписки на клуб</p></div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-thanks-page2-mobile', {
        label: 'Страница Поздравляем (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-thanks-page2-mobile">
            <div>
                <h2>Поздравляем!</h2>
                <div>
                    <div><p>Так как вы уже приобретали наши продукты, вы можете попасть в клуб<br> прямо сейчас</p></div>
                    <div><p>Напишите нам на hello@careerum.ru<br> адрес электронной почты, которую<br> вы указывали при оплате ранее</p></div>
                    <div><p>Наш менеджер свяжется с вами<br> для оформления подписки на клуб</p></div>
                </div>
            </div>
        </div>`
	});
    
    blockManager.add('careerum-faq2-block', {
        label: 'FAQ',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-faq2-block">
            <div>
                <div>
                    <h2>Часто задаваемые<br> вопросы</h2>
                </div>
                <div>
                    <div class="careerum-faq2-menu sticky">
                    </div>
                    <div class="careerum-faq2-tabs">
                        <div class="careerum-faq2-tab" data-tab-name="Популярное">
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Как понять, какая обучающая программа мне<br> нужна?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев,
                                        в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на
                                        1 месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с
                                        вашей карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Оплата не проходит, что делать?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев,
                                        в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1
                                        месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей
                                        карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Как продлить подписку на клуб?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев,
                                        в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1
                                        месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей
                                        карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Будет ли подписка на клуб продлеваться<br> автоматически?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев,
                                        в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1
                                        месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей
                                        карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                        </div>
                        <div class="careerum-faq2-tab" data-tab-name="Подписка">
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Что такое подписка на клуб, что она дает?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев,<br>
                                        в зависимости от выбранного вами варианта. Например, если вы выбрали<br> подписку на
                                        1 месяц (30 календарных дней), то для продления доступа<br> к клубу, на 31 день с
                                        вашей карты спишется сумма, равная стоимости<br> подписки.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Сколько стоит вступить в клуб?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Стоимость подписки на клуб зависит от выбранного тарифа. На любой<br> тариф можно оформить подписку на 1 месяц, которая действует 30<br> календарных дней. Также на все тарифы можно оформить подписку на 3, 6 и<br> 12 месяцев — чем дольше подписка, тем выгоднее стоимость. Узнать<br> подробнее о тарифах и стоимости можно на странице тарифов.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Будет ли подписка на клуб продлеваться<br> автоматически?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Как только вы оформляете подписку, по умолчанию подключается ее продление. Это значит, что сумма за следующий период (1,3, 6 или 12 месяцев) спишется автоматически с привязанной к личному кабинету карты.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>В какой день происходит автопродление<br> подписки?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Списание с карты произойдет за сутки до окончания вашей подписки, чтобы вы не потеряли доступ к клубу и могли беспрерывно продолжать обучение. Подписка будет продлена на тот же период, что и предыдущая. Если вы оформили подписку на 3 месяца, через 90 дней с вашей карты будет списана та же сумма, а подписка продлится на 3 месяца.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Как отключить автопродление подписки?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Вы можете отключить автоматическое продление подписки в любой момент. Для этого пройдите в настройки личного кабинета, снимите галочку «Продлевать автоматически» и обязательно нажмите кнопку «Сохранить». Если что-то не получается, напишите нам на почту hello@careerum.ru или менеджерам поддержки Татьяне Погребняк или Наталье Костенко на нетворкинговой платформе.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Можно ли купить отдельно курсы<br> и вебинары?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Отдельно можно приобрести три продукта из Careerum.Class. Другие продукты доступны по подписке на Careerum.Club</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Как продлить подписку на клуб?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Продлить подписку можно в личном кабинете,в разделе «Мои покупки», нажав на «Careerum.Club базовое членство». В открывшемся окне, в разделе «Продления» выбрать тариф и нажать «Продлить сейчас» и далее следовать подсказкам системы. Если вы захотите перейти на помесячную оплату или, наоборот, оформить подписку на несколько месяцев сразу, напишите на почту hello@careerum.ru или менеджерам поддержки Татьяне Погребняк или Наталье Костенко. Сделайте это минимум за двое суток до окончания вашей текущей подписки, чтобы уже в следующем месяце учиться на новых условиях.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>У меня был перерыв в клубе, как возобновить<br> подписку?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Вы можете вернуться в клуб в любой момент. Для этого напишите нам на почту hello@careerum.ru</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Как узнать, до какой даты у меня доступ<br> к клубу?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>В личном кабинете, в разделе «Мои покупки», найдите строчку «Careerum.Club базовое членство» — в этой строчке указана дата до которой действует ваша подписка.</p>
                                </div>
                            </div>
                        </div>
                        <div class="careerum-faq2-tab" data-tab-name="Тарифы">
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Как понять, какой тариф мне подойдет?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев, в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1 месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Чем отличаются тарифы с коучем<br> от самостоятельного?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев, в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1 месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Как перейти на другой тариф?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев, в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1 месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                        </div>
                        <div class="careerum-faq2-tab" data-tab-name="Технические вопросы">
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Как оплатить подписку, если я не в России?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев, в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1 месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Оплата не проходит, что делать?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев, в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1 месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Оплата прошла, но доступа к клубу нет,<br> что делать?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев, в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1 месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Я в клубе, но у меня возникли проблемы<br> с доступом, что делать?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев, в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1 месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Если я передумаю, могу ли я вернуть деньги<br> за подписку на клуб?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев, в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1 месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>                        
                        </div>
                        <div class="careerum-faq2-tab" data-tab-name="Обучение">
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Сколько времени мне понадобится, чтобы<br> изучить все материалы клуба?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев, в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1 месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Будет ли у меня расписание и дедлайны?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев, в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1 месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Как понять, какая обучающая программа<br> мне нужна?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев, в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1 месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Что такое фокус-кэмп?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев, в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1 месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Как быть, если я не буду успевать выполнять<br> задания на фокус-кэмпе?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев, в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1 месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Будет ли проверка заданий?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев, в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1 месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Что делать, если я не смогу сориентироваться<br> на образовательной платформе?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев, в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1 месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Сколько времени в день оптимально уделять<br> обучению, чтобы был результат?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев, в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1 месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                        </div>
                        <div class="careerum-faq2-tab" data-tab-name="Коучинг и консультации">
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Что такое коучинг?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев, в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1 месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Как коучинг поможет мне в карьере?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев, в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1 месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Чем коуч отличается от консультанта<br> или учителя?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев, в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1 месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Как работает коучинг в Careerum?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев, в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1 месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Как мы будем взаимодействовать с коучем?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев, в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1 месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Как часто я могу обращаться к коучу<br> с запросами?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев, в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1 месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Что можно спрашивать у коуча?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев, в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1 месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Есть ли гарантия, что на тарифе с коучем<br> я быстрее достигну целей?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев, в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1 месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Может ли коуч дать мне совет или высказать<br> свое мнение по рабочей ситуации?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев, в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1 месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Почему коуч, вместо ответов, задает<br> мне вопросы?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев, в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1 месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Могу ли я поработать с несколькими коучами<br> одновременно?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев, в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1 месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Что такое коучинговая видеосессия<br> в Careerum?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев, в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1 месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Как я могу назначить коучинговую<br> видеосессию?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев, в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1 месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Как получить консультацию CV-эксперта<br> по моему резюме?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев, в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1 месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Как попасть на личный коучинг к Ольге<br> Лермонтовой?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев, в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1 месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                        </div>
                        <div class="careerum-faq2-tab" data-tab-name="Главное о Careerum.Club">
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Как устроен Careerum.Club?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев, в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1 месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>У меня пока нет четкой карьерной цели —<br> подойдет ли мне клуб?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев, в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1 месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Какие активности есть в клубе?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев, в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1 месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Если я не смогу сориентироваться в клубе,<br> к кому мне обратиться?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев, в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1 месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Что такое образовательная платформа?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев, в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1 месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Доступ к обучающим материалам<br> открывается сразу или постепенно?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев, в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1 месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Что такое нетворкинговая платформа?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев, в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1 месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-faq2-block-tablet', {
        label: 'FAQ (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-faq2-block-tablet">
            <div>
                <div>
                    <h2>Часто задаваемые<br> вопросы</h2>
                </div>
                <div>
                    <div class="careerum-faq2-menu sticky">
                    </div>
                    <div class="careerum-faq2-tabs">
                        <div class="careerum-faq2-tab" data-tab-name="Популярное">
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Как понять, какая обучающая<br> программа мне нужна?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев,
                                        в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на
                                        1 месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с
                                        вашей карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Оплата не проходит, что делать?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев,
                                        в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1
                                        месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей
                                        карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Как продлить подписку на клуб?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев,
                                        в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1
                                        месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей
                                        карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Будет ли подписка на клуб<br> продлеваться автоматически?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев,
                                        в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1
                                        месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей
                                        карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                        </div>
                        <div class="careerum-faq2-tab" data-tab-name="Подписка">
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Что такое подписка на клуб, что она дает?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев,
                                        в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на
                                        1 месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с
                                        вашей карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Сколько стоит вступить в клуб?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Стоимость подписки на клуб зависит от выбранного тарифа. На любой<br> тариф можно оформить подписку на 1 месяц, которая действует 30<br> календарных дней. Также на все тарифы можно оформить подписку на 3, 6 и<br> 12 месяцев — чем дольше подписка, тем выгоднее стоимость. Узнать<br> подробнее о тарифах и стоимости можно на странице тарифов.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Будет ли подписка на клуб продлеваться<br> автоматически?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Как только вы оформляете подписку, по умолчанию подключается ее продление. Это значит, что сумма за следующий период (1,3, 6 или 12 месяцев) спишется автоматически с привязанной к личному кабинету карты.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>В какой день происходит автопродление<br> подписки?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Списание с карты произойдет за сутки до окончания вашей подписки, чтобы вы не потеряли доступ к клубу и могли беспрерывно продолжать обучение. Подписка будет продлена на тот же период, что и предыдущая. Если вы оформили подписку на 3 месяца, через 90 дней с вашей карты будет списана та же сумма, а подписка продлится на 3 месяца.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Как отключить автопродление подписки?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Вы можете отключить автоматическое продление подписки в любой момент. Для этого пройдите в настройки личного кабинета, снимите галочку «Продлевать автоматически» и обязательно нажмите кнопку «Сохранить». Если что-то не получается, напишите нам на почту hello@careerum.ru или менеджерам поддержки Татьяне Погребняк или Наталье Костенко на нетворкинговой платформе.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Можно ли купить отдельно курсы<br> и вебинары?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Отдельно можно приобрести три продукта из Careerum.Class. Другие продукты доступны по подписке на Careerum.Club</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Как продлить подписку на клуб?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Продлить подписку можно в личном кабинете,в разделе «Мои покупки», нажав на «Careerum.Club базовое членство». В открывшемся окне, в разделе «Продления» выбрать тариф и нажать «Продлить сейчас» и далее следовать подсказкам системы. Если вы захотите перейти на помесячную оплату или, наоборот, оформить подписку на несколько месяцев сразу, напишите на почту hello@careerum.ru или менеджерам поддержки Татьяне Погребняк или Наталье Костенко. Сделайте это минимум за двое суток до окончания вашей текущей подписки, чтобы уже в следующем месяце учиться на новых условиях.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>У меня был перерыв в клубе, как возобновить<br> подписку?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Вы можете вернуться в клуб в любой момент. Для этого напишите нам на почту hello@careerum.ru</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Как узнать, до какой даты у меня доступ<br> к клубу?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>В личном кабинете, в разделе «Мои покупки», найдите строчку «Careerum.Club базовое членство» — в этой строчке указана дата до которой действует ваша подписка.</p>
                                </div>
                            </div>
                        </div>
                        <div class="careerum-faq2-tab" data-tab-name="Тарифы">
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Как понять, какой тариф мне подойдет?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев, в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1 месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Чем отличаются тарифы с коучем<br> от самостоятельного?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев, в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1 месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Как перейти на другой тариф?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев, в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1 месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                        </div>
                        <div class="careerum-faq2-tab" data-tab-name="Технические вопросы">
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Как оплатить подписку, если я не в России?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев, в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1 месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Оплата не проходит, что делать?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев, в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1 месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Оплата прошла, но доступа к клубу нет,<br> что делать?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев, в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1 месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Я в клубе, но у меня возникли проблемы<br> с доступом, что делать?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев, в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1 месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Если я передумаю, могу ли я вернуть деньги<br> за подписку на клуб?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев, в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1 месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>                        
                        </div>
                        <div class="careerum-faq2-tab" data-tab-name="Обучение">
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Сколько времени мне понадобится, чтобы<br> изучить все материалы клуба?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев, в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1 месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Будет ли у меня расписание и дедлайны?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев, в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1 месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Как понять, какая обучающая программа<br> мне нужна?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев, в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1 месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Что такое фокус-кэмп?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев, в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1 месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Как быть, если я не буду успевать выполнять<br> задания на фокус-кэмпе?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев, в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1 месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Будет ли проверка заданий?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев, в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1 месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Что делать, если я не смогу сориентироваться<br> на образовательной платформе?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев, в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1 месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Сколько времени в день оптимально уделять<br> обучению, чтобы был результат?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев, в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1 месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                        </div>
                        <div class="careerum-faq2-tab" data-tab-name="Коучинг и консультации">
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Что такое коучинг?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев, в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1 месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Как коучинг поможет мне в карьере?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев, в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1 месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Чем коуч отличается от консультанта<br> или учителя?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев, в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1 месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Как работает коучинг в Careerum?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев, в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1 месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Как мы будем взаимодействовать с коучем?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев, в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1 месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Как часто я могу обращаться к коучу<br> с запросами?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев, в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1 месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Что можно спрашивать у коуча?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев, в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1 месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Есть ли гарантия, что на тарифе с коучем<br> я быстрее достигну целей?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев, в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1 месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Может ли коуч дать мне совет или высказать<br> свое мнение по рабочей ситуации?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев, в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1 месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Почему коуч, вместо ответов, задает<br> мне вопросы?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев, в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1 месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Могу ли я поработать с несколькими коучами<br> одновременно?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев, в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1 месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Что такое коучинговая видеосессия<br> в Careerum?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев, в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1 месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Как я могу назначить коучинговую<br> видеосессию?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев, в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1 месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Как получить консультацию CV-эксперта<br> по моему резюме?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев, в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1 месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Как попасть на личный коучинг к Ольге<br> Лермонтовой?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев, в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1 месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                        </div>
                        <div class="careerum-faq2-tab" data-tab-name="Главное о Careerum.Club">
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Как устроен Careerum.Club?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев, в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1 месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>У меня пока нет четкой карьерной цели —<br> подойдет ли мне клуб?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев, в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1 месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Какие активности есть в клубе?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев, в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1 месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Если я не смогу сориентироваться в клубе,<br> к кому мне обратиться?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев, в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1 месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Что такое образовательная платформа?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев, в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1 месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Доступ к обучающим материалам<br> открывается сразу или постепенно?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев, в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1 месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Что такое нетворкинговая платформа?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев, в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1 месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-faq2-block-mobile', {
        label: 'FAQ (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-faq2-block-mobile">
            <div>
                <div>
                    <h2>Часто задаваемые<br> вопросы</h2>
                </div>
                <div>
                    <div class="careerum-faq2-menu">
                    </div>
                    <div class="careerum-faq2-tabs">
                        <div class="careerum-faq2-tab" data-tab-name="Популярное">
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Как понять, какая обучающая<br> программа мне нужна?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев,
                                        в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на
                                        1 месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с
                                        вашей карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Оплата не проходит,<br> что делать?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев,
                                        в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1
                                        месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей
                                        карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Как продлить подписку<br> на клуб?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев,
                                        в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1
                                        месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей
                                        карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Будет ли подписка на клуб<br> продлеваться автоматически?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев,
                                        в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1
                                        месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей
                                        карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                        </div>
                        <div class="careerum-faq2-tab" data-tab-name="Подписка">
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Что такое подписка на клуб,<br> что она дает?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев,
                                        в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на
                                        1 месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с
                                        вашей карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Сколько стоит вступить в клуб?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Стоимость подписки на клуб зависит от выбранного тарифа. На любой<br> тариф можно оформить подписку на 1 месяц, которая действует 30<br> календарных дней. Также на все тарифы можно оформить подписку на 3, 6 и<br> 12 месяцев — чем дольше подписка, тем выгоднее стоимость. Узнать<br> подробнее о тарифах и стоимости можно на странице тарифов.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Будет ли подписка на клуб продлеваться автоматически?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Как только вы оформляете подписку, по умолчанию подключается ее продление. Это значит, что сумма за следующий период (1,3, 6 или 12 месяцев) спишется автоматически с привязанной к личному кабинету карты.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>В какой день происходит автопродление подписки?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Списание с карты произойдет за сутки до окончания вашей подписки, чтобы вы не потеряли доступ к клубу и могли беспрерывно продолжать обучение. Подписка будет продлена на тот же период, что и предыдущая. Если вы оформили подписку на 3 месяца, через 90 дней с вашей карты будет списана та же сумма, а подписка продлится на 3 месяца.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Как отключить автопродление подписки?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Вы можете отключить автоматическое продление подписки в любой момент. Для этого пройдите в настройки личного кабинета, снимите галочку «Продлевать автоматически» и обязательно нажмите кнопку «Сохранить». Если что-то не получается, напишите нам на почту hello@careerum.ru или менеджерам поддержки Татьяне Погребняк или Наталье Костенко на нетворкинговой платформе.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Можно ли купить отдельно курсы<br> и вебинары?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Отдельно можно приобрести три продукта из Careerum.Class. Другие продукты доступны по подписке на Careerum.Club</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Как продлить подписку на клуб?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Продлить подписку можно в личном кабинете,в разделе «Мои покупки», нажав на «Careerum.Club базовое членство». В открывшемся окне, в разделе «Продления» выбрать тариф и нажать «Продлить сейчас» и далее следовать подсказкам системы. Если вы захотите перейти на помесячную оплату или, наоборот, оформить подписку на несколько месяцев сразу, напишите на почту hello@careerum.ru или менеджерам поддержки Татьяне Погребняк или Наталье Костенко. Сделайте это минимум за двое суток до окончания вашей текущей подписки, чтобы уже в следующем месяце учиться на новых условиях.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>У меня был перерыв в клубе, как возобновить подписку?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Вы можете вернуться в клуб в любой момент. Для этого напишите нам на почту hello@careerum.ru</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Как узнать, до какой даты у меня доступ к клубу?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>В личном кабинете, в разделе «Мои покупки», найдите строчку «Careerum.Club базовое членство» — в этой строчке указана дата до которой действует ваша подписка.</p>
                                </div>
                            </div>
                        </div>
                        <div class="careerum-faq2-tab" data-tab-name="Обучение">
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Сколько времени мне<br> понадобится, чтобы изучить все материалы клуба?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев, в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1 месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Будет ли у меня расписание и дедлайны?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев, в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1 месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Как понять, какая обучающая программа мне нужна?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев, в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1 месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Что такое фокус-кэмп?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев, в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1 месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Как быть, если я не буду успевать выполнять задания<br> на фокус-кэмпе?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев, в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1 месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Будет ли проверка заданий?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев, в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1 месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Что делать, если я не смогу сориентироваться<br> на образовательной платформе?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев, в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1 месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Сколько времени в день<br> оптимально уделять обучению, чтобы был результат?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев, в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1 месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                        </div>
                        <div class="careerum-faq2-tab" data-tab-name="Тарифы">
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Как понять, какой тариф мне подойдет?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев, в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1 месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Чем отличаются тарифы с коучем<br> от самостоятельного?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев, в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1 месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Как перейти на другой тариф?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев, в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1 месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                        </div>
                        <div class="careerum-faq2-tab" data-tab-name="Технические вопросы">
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Как оплатить подписку,<br> если я не в России?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев, в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1 месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Оплата не проходит, что делать?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев, в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1 месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Оплата прошла, но доступа<br> к клубу нет, что делать?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев, в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1 месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Я в клубе, но у меня возникли проблемы с доступом, что делать?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев, в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1 месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Если я передумаю,<br> могу ли я вернуть деньги<br> за подписку на клуб?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев, в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1 месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>                        
                        </div>
                        <div class="careerum-faq2-tab" data-tab-name="Коучинг и консультации">
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Что такое коучинг?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев, в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1 месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Как коучинг поможет мне<br> в карьере?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев, в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1 месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Чем коуч отличается<br> от консультанта или учителя?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев, в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1 месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Как работает коучинг в Careerum?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев, в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1 месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Как мы будем взаимодействовать<br> с коучем?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев, в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1 месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Как часто я могу обращаться<br> к коучу с запросами?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев, в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1 месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Что можно спрашивать у коуча?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев, в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1 месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Есть ли гарантия, что на тарифе с коучем я быстрее достигну целей?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев, в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1 месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Может ли коуч дать мне совет <br>или высказать свое мнение<br> по рабочей ситуации?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев, в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1 месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Почему коуч, вместо ответов,<br> задает мне вопросы?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев, в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1 месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Могу ли я поработать <br>с несколькими коучами<br> одновременно?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев, в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1 месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Что такое коучинговая<br> видеосессия в Careerum?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев, в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1 месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Как я могу назначить<br> коучинговую видеосессию?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев, в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1 месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Как получить консультацию<br> CV-эксперта по моему резюме?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев, в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1 месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Как попасть на личный коучинг <br>к Ольге Лермонтовой?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев, в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1 месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                        </div>
                        <div class="careerum-faq2-tab" data-tab-name="Главное о Careerum.Club">
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Как устроен Careerum.Club?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев, в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1 месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>У меня пока нет четкой карьерной цели — подойдет ли мне клуб?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев, в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1 месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Какие активности есть в клубе?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев, в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1 месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Если я не смогу сориентироваться в клубе, к кому мне обратиться?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев, в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1 месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Что такое образовательная платформа?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев, в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1 месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Доступ к обучающим материалам<br> открывается сразу или постепенно?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев, в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1 месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-faq2-header">
                                    <p>Что такое нетворкинговая платформа?</p>
                                </div>
                                <div class="careerum-faq2-content">
                                    <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев, в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1 месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей карты спишется сумма, равная стоимости подписки.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
	});
    
    blockManager.add('careerum-results-tabs-block', {
        label: 'Страница результатов',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-results-tabs-block">
            <div>
                <div class="careerum-results-tabs-block-header">
                    <h2>Результаты участников</h2>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1662500061922.svg" alt="">
                </div>
                <div>
                    <div class="careerum-results-menu sticky">
                    </div>
                    <div class="careerum-results-tabs">
                        <div class="careerum-results-tab" data-tab-name="Посмотреть все">
                            <div>
                                <a class="careerum-results-tab-item-sm-left" href="#">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1662500084230.png" alt="">
                                    <p class="careerum-results-tab-item-sm-header">Как найти работу<br> с повышением зарплаты на
                                        40%</p>
                                    <p class="careerum-results-tab-item-sm-descr">Лизавета Жданович,<br> Product Manager,<br> Лондон</p>
                                </a>
                                <a class="careerum-results-tab-item-md" href="#">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1662500142355.svg" alt="">
                                    <p class="careerum-results-tab-item-md-header">Миссия выполнима: найти работу в Лондоне в
                                        2022 году</p>
                                    <p class="careerum-results-tab-item-md-subheader">
                                        В феврале 2022 Лизавета уволилась<br> из компании в Беларуси<br> и планировала
                                        устроиться на работу<br> в Москве. После событий 24 февраля<br> 2022 план изменился на
                                        «что угодно,<br> лишь бы за границей».
                                    </p>
                                </a>
                                <a class="careerum-results-tab-item-md-3t" href="#">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1662500152760.png"
                                        alt="">
                                    <p class="careerum-results-tab-item-md-header">Работа по любви: как<br> попасть в компанию,<br> близкую по ценностям</p>
                                    <p class="careerum-results-tab-item-md-subheader">
                                        Через месяц после начала поисков, Виктория<br> получила офферы от двух международных<br> компаний
                                    </p>
                                    <p class="careerum-results-tab-item-md-descr">Виктория Сагина, работала<br> Planning Specialist, Россия</p>
                                </a>
                                <a class="careerum-results-tab-item-sm-right" href="#">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1662500166136.svg" alt="">
                                    <p class="careerum-results-tab-item-sm-header">Как найти работу<br> с повышением зарплаты на
                                        40%</p>
                                    <p class="careerum-results-tab-item-sm-descr">Лизавета Жданович,<br> Product Manager,<br>
                                        Лондон</p>
                                </a>
                                <a class="careerum-results-tab-item-lg" href="#">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1662500195703.svg" alt="">
                                    <p class="careerum-results-tab-item-lg-header">Всё и сразу: сменить сферу,<br> должность и увеличить доход<br> в 2022 году</p>
                                    <p class="careerum-results-tab-item-lg-subheader">
                                        «Я проделала огромную внутреннюю работу, опираясь на материалы<br> в курсе «Звёздный кандидат» и Real me. Уверенность в себе и своих<br> силах, которую я приобрела в клубе, дорогого стоит»
                                    </p>
                                    <p class="careerum-results-tab-item-lg-descr">Виктория Крюкова, Руководитель<br> отдела обучения, Россия
                                    </p>
                                </a>
                                <a class="careerum-results-tab-item-sm-right" href="#">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1662500208609.svg" alt="">
                                    <p class="careerum-results-tab-item-sm-header">Как найти работу<br> с повышением зарплаты на
                                        40%</p>
                                    <p class="careerum-results-tab-item-sm-descr">Лизавета Жданович,<br> Product Manager,<br>
                                        Лондон</p>
                                </a>
                                <a class="careerum-results-tab-item-sm-right" href="#">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1662500220538.svg" alt="" style="left: 171px; top: 214px; ">
                                    <p class="careerum-results-tab-item-sm-header">Как найти работу<br> с повышением<br> зарплаты на 40%,<br> а потом работу<br> с повышением<br> зарплаты на 60%</p>
                                    <p class="careerum-results-tab-item-sm-descr">Лизавета Жданович,<br> Product Manager,<br>
                                        Лондон</p>
                                </a>
                                <a class="careerum-results-tab-item-sm-right" href="#">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1662500232402.svg" alt="" style="left: 102px; top: 131px; ">
                                    <p class="careerum-results-tab-item-sm-header">Как найти работу</p>
                                    <p class="careerum-results-tab-item-sm-descr">Лизавета Жданович,<br> Product Manager,<br>
                                        Лондон</p>
                                </a>
                                <a class="careerum-results-tab-item-sm-left" href="#">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1662500245146.png" alt="">
                                    <p class="careerum-results-tab-item-sm-header">Как найти работу<br> с повышением зарплаты на
                                        40%</p>
                                    <p class="careerum-results-tab-item-sm-descr">Лизавета Жданович,<br> Product Manager,<br> Лондон</p>
                                </a>
                                <a class="careerum-results-tab-item-md-3t" href="#">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1662500254718.png"
                                        alt="">
                                    <p class="careerum-results-tab-item-md-header">Из «джуна»<br> в специалиста, которого<br>
                                        надо поискать</p>
                                    <p class="careerum-results-tab-item-md-subheader">
                                        Благодаря клубу у Лизаветы изменилось<br> отношение к своему опыту и появилась<br>
                                        уверенность, что 2-3 года в IT — это супер<br> классный опыт.
                                    </p>
                                    <p class="careerum-results-tab-item-md-descr">Лизавета Жданович,<br> Product Manager,<br>
                                        Лондон</p>
                                </a>
                            </div>
                        </div>
                        <div class="careerum-results-tab" data-tab-name="Сменить сферу">
                            <div>
                                <div class="careerum-results-tab-empty">
                                    <p>Скоро здесь появятся новые кейсы</p>
                                </div>
                            </div>
                        </div>
                        <div class="careerum-results-tab" data-tab-name="Получить повышение">
                            <div>
                                <div class="careerum-results-tab-empty">
                                    <p>Скоро здесь появятся новые кейсы</p>
                                </div>
                            </div>
                        </div>
                        <div class="careerum-results-tab" data-tab-name="Переехать по работе">
                            <div>
                                <div class="careerum-results-tab-empty">
                                    <p>Скоро здесь появятся новые кейсы</p>
                                </div>
                            </div>
                        </div>
                        <div class="careerum-results-tab" data-tab-name="Выйти из декрета">
                            <div>
                                <div class="careerum-results-tab-empty">
                                    <p>Скоро здесь появятся новые кейсы</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-results-tabs-block-tablet', {
        label: 'Страница результатов (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-results-tabs-block-tablet">
            <div>
                <div class="careerum-results-tabs-block-header">
                    <h2>Результаты участников</h2>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1662500430312.svg" alt="">
                </div>
                <div>
                    <div class="careerum-results-menu sticky">
                    </div>
                    <div class="careerum-results-tabs">
                        <div class="careerum-results-tab" data-tab-name="Посмотреть все">
                            <div>
                                <a class="careerum-results-tab-item-sm-left-tablet" href="#">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1662500444771.png" alt="">
                                    <p class="careerum-results-tab-item-sm-header">Как найти работу<br> с повышением зарплаты на
                                        40%</p>
                                    <p class="careerum-results-tab-item-sm-descr">Лизавета<br> Жданович, Product<br> Manager, Лондон</p>
                                </a>
                                <a class="careerum-results-tab-item-md-tablet" href="#">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1662500455921.svg" alt="">
                                    <p class="careerum-results-tab-item-md-header">Как получить<br> работу в IT и пере-<br>ехать в Словению</p>
                                    <p class="careerum-results-tab-item-md-subheader">
                                        Алена пришла в клуб в мае, <br>а желанный оффер с рело-<br>кацией получила в последних числах августа. Это была именно та должность и та страна, о которой она мечтала, — Словения. 
                                    </p>
                                    <p class="careerum-results-tab-item-md-descr">Лизавета<br> Жданович, Product<br> Manager, Лондон</p>
                                </a>
                                <a class="careerum-results-tab-item-lg-tablet" href="#">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1662500528531.svg" alt="">
                                    <p class="careerum-results-tab-item-lg-header">Всё и сразу: сменить сферу, должность<br> и увеличить доход в 2022 году</p>
                                    <p class="careerum-results-tab-item-lg-subheader">
                                        «Я проделала огромную внутреннюю работу, опираясь<br> на материалы в курсе «Звёздный кандидат» и Real me.<br> Уверенность в себе и своих силах, которую я приобрела<br> в клубе, дорогого стоит» 
                                    </p>
                                    <p class="careerum-results-tab-item-lg-descr">Виктория Крюкова,<br> Руководитель отдела обучения,<br> Россия
                                    </p>
                                </a>
                                <a class="careerum-results-tab-item-sm-right-tablet" href="#">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1662500542480.svg" alt="">
                                    <p class="careerum-results-tab-item-sm-header">Как найти работу<br> с повышением зарплаты на
                                        40%</p>
                                    <p class="careerum-results-tab-item-sm-descr">Лизавета<br> Жданович, Product<br> Manager,
                                        Лондон</p>
                                </a>
                                <a class="careerum-results-tab-item-sm-right-tablet" href="#">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1662500552638.svg" alt="" style="left: 143px; top: 213px;">
                                    <p class="careerum-results-tab-item-sm-header">Как найти работу<br> с повышением<br> зарплаты на 40%,<br> а потом работу<br> с повышением<br> зарплаты на 60%</p>
                                    <p class="careerum-results-tab-item-sm-descr">Лизавета<br> Жданович, Product<br> Manager,
                                        Лондон</p>
                                </a>
                                <a class="careerum-results-tab-item-lg-tablet" href="#">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1662500563860.svg" alt="">
                                    <p class="careerum-results-tab-item-lg-header">«Вместо мысли “я никому не нужна”<br> появилась
                                        другая гениальная мысль:<br> “Вообще-то я крутой спец”»</p>
                                    <p class="careerum-results-tab-item-lg-descr">Лизавета Жданович, Product<br> Manager, Лондон
                                    </p>
                                </a>
                                <a class="careerum-results-tab-item-sm-right-tablet" href="#">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1662500580568.svg" alt="">
                                    <p class="careerum-results-tab-item-sm-header">Как найти работу<br> с повышением зарплаты на
                                        40%</p>
                                    <p class="careerum-results-tab-item-sm-descr">Лизавета<br> Жданович, Product<br> Manager,
                                        Лондон</p>
                                </a>
                                <a class="careerum-results-tab-item-sm-right-tablet" href="#">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1662500606854.svg" alt="" style="left: 143px; top: 213px;">
                                    <p class="careerum-results-tab-item-sm-header">Как найти работу<br> с повышением<br> зарплаты на 40%,<br> а потом работу<br> с повышением<br> зарплаты на 60%</p>
                                    <p class="careerum-results-tab-item-sm-descr">Лизавета<br> Жданович, Product<br> Manager,
                                        Лондон</p>
                                </a>
                                <a class="careerum-results-tab-item-sm-left-tablet" href="#">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1662500617651.png" alt="">
                                    <p class="careerum-results-tab-item-sm-header">Как найти работу<br> с повышением зарплаты на
                                        40%</p>
                                    <p class="careerum-results-tab-item-sm-descr">Лизавета<br> Жданович, Product<br> Manager, Лондон</p>
                                </a>
                                <a class="careerum-results-tab-item-sm-right-tablet" href="#">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1662500580568.svg" alt="">
                                    <p class="careerum-results-tab-item-sm-header">Как найти работу<br> с повышением<br> зарплаты на 40%,<br> а потом работу<br> с повышением<br> зарплаты на 60%</p>
                                    <p class="careerum-results-tab-item-sm-descr">Лизавета<br> Жданович, Product<br> Manager,
                                        Лондон</p>
                                </a>
                            </div>
                        </div>
                        <div class="careerum-results-tab" data-tab-name="Сменить сферу">
                            <div>
                                <div class="careerum-results-tab-empty-tablet">
                                    <p>Скоро здесь появятся новые кейсы</p>
                                </div>
                            </div>
                        </div>
                        <div class="careerum-results-tab" data-tab-name="Получить повышение">
                            <div>
                                <div class="careerum-results-tab-empty-tablet">
                                    <p>Скоро здесь появятся новые кейсы</p>
                                </div>
                            </div>
                        </div>
                        <div class="careerum-results-tab" data-tab-name="Переехать по работе">
                            <div>
                                <div class="careerum-results-tab-empty-tablet">
                                    <p>Скоро здесь появятся новые кейсы</p>
                                </div>
                            </div>
                        </div>
                        <div class="careerum-results-tab" data-tab-name="Выйти из&nbsp;декрета">
                            <div>
                                <div class="careerum-results-tab-empty-tablet">
                                    <p>Скоро здесь появятся новые кейсы</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-results-tabs-block-mobile', {
        label: 'Страница результатов (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-results-tabs-block-mobile">
            <div>
                <div class="careerum-results-tabs-block-header">
                    <h2>Результаты участников</h2>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1662500703672.svg" alt="">
                </div>
                <div>
                    <div class="careerum-results-menu sticky">
                        <div></div>
                    </div>
                    <div class="careerum-results-tabs">
                        <div class="careerum-results-tab" data-tab-name="Посмотреть все">
                            <div>
                                <a class="careerum-results-tab-item-sm-right-mobile" href="#">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1662500774998.svg" alt="">
                                    <p class="careerum-results-tab-item-sm-header">Как найти работу<br> с повышением зарплаты на
                                        40%</p>
                                    <p class="careerum-results-tab-item-sm-descr">Лизавета Жданович,<br> Product Manager,<br>
                                        Лондон</p>
                                </a>
                                <a class="careerum-results-tab-item-lg-mobile" href="#">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1662500789163.png" alt="">
                                    <p class="careerum-results-tab-item-lg-header">Всё и сразу: сменить сферу, должность и увеличить доход<br> в 2022 году</p>
                                    <p class="careerum-results-tab-item-lg-subheader">
                                        «Я проделала огромную внутреннюю работу, опираясь на материалы в курсе «Звёздный кандидат» и Real me. Уверенность в себе и своих силах, которую я приобрела в клубе, дорогого стоит»
                                    </p>
                                    <p class="careerum-results-tab-item-lg-descr">Виктория Крюкова,<br> Руководитель отдела обучения,<br> Россия
                                    </p>
                                </a>
                                <a class="careerum-results-tab-item-md-mobile" href="#">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1662500801206.svg" alt="">
                                    <p class="careerum-results-tab-item-md-header">Курс на Европу: как<br> получить работу в IT и<br> переехать в Словению</p>
                                    <p class="careerum-results-tab-item-md-subheader">
                                        Алёна пришла в клуб в мае, а желанный оффер с релокацией получила в последних числах августа. Это была именно та должность и та страна, о которой она мечтала, — Словения. 
                                    </p>
                                    <p class="careerum-results-tab-item-md-descr">Алёна Деревщикова,<br> QA Engineer,<br> Словения</p>
                                </a>
                                <a class="careerum-results-tab-item-sm-right-mobile" href="#">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1662500815545.png" alt="" style="bottom:0;right:0;top:unset; left:unset;">
                                    <p class="careerum-results-tab-item-sm-header">Как найти работу<br> с повышением зарплаты на
                                        40%</p>
                                    <p class="careerum-results-tab-item-sm-descr">Лизавета Жданович,<br> Product Manager,<br>
                                        Лондон</p>
                                </a>
                                <a class="careerum-results-tab-item-md-mobile" href="#">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1662500828995.svg" alt="">
                                    <p class="careerum-results-tab-item-md-header">Миссия выполнима: найти работу<br> в Лондоне в
                                        2022<br> году</p>
                                    <p class="careerum-results-tab-item-md-subheader">
                                        В феврале 2022 Лизавета уволилась из компании в Беларуси и планировала
                                        устроиться на работу в Москве. После событий 24 февраля 2022 план изменился на
                                        «что угодно, лишь бы за границей».
                                    </p>
                                </a>
                                <a class="careerum-results-tab-item-sm-left-mobile" href="#">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1662500852598.svg" alt="" style="left: 235px; top: 151px;">
                                    <p class="careerum-results-tab-item-sm-header">Как найти работу <br>с повышением зарплаты на 40%, а потом работу <br>с повышением зарплаты на 60%</p>
                                    <p class="careerum-results-tab-item-sm-descr">Лизавета Жданович,<br> Product Manager,<br>
                                        Лондон</p>
                                </a>
                                <a class="careerum-results-tab-item-md-mobile" href="#">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1662500864240.svg" alt="" style="left: 245px; top: 47px;">
                                    <p class="careerum-results-tab-item-md-header">Миссия выполнима: найти работу<br> в Лондоне в
                                        2022<br> году и перехать</p>
                                    <p class="careerum-results-tab-item-md-subheader">
                                        В феврале 2022 Лизавета уволилась из компании в Беларуси и планировала
                                        устроиться на работу в Москве. После событий 24 февраля 2022 план изменился на
                                        «что угодно, лишь бы за границей».
                                    </p>
                                </a>
                                <a class="careerum-results-tab-item-md-mobile" href="#">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1662500876215.svg" alt="" style="left: 11px; top: 207px;">
                                    <p class="careerum-results-tab-item-md-header">Миссия выполнима: найти работу<br> в Лондоне в 2022 году<br> и переехать. Получить много денег и<br> интересных задач </p>
                                    <p class="careerum-results-tab-item-md-subheader">
                                        В феврале 2022 Лизавета уволилась<br> из компании в Беларуси и планировала устроиться на работу в Москве.
                                    </p>
                                </a>
                            </div>
                        </div>
                        <div class="careerum-results-tab" data-tab-name="Сменить сферу">
                            <div>
                                <div class="careerum-results-tab-empty-mobile">
                                    <p>Скоро здесь появятся новые кейсы</p>
                                </div>
                            </div>
                        </div>
                        <div class="careerum-results-tab" data-tab-name="Получить повышение">
                            <div>
                                <div class="careerum-results-tab-empty-mobile">
                                    <p>Скоро здесь появятся новые кейсы</p>
                                </div>
                            </div>
                        </div>
                        <div class="careerum-results-tab" data-tab-name="Переехать по работе">
                            <div>
                                <div class="careerum-results-tab-empty-mobile">
                                    <p>Скоро здесь появятся новые кейсы</p>
                                </div>
                            </div>
                        </div>
                        <div class="careerum-results-tab" data-tab-name="Выйти из декрета">
                            <div>
                                <div class="careerum-results-tab-empty-mobile">
                                    <p>Скоро здесь появятся новые кейсы</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
	});
    
    blockManager.add('careerum-case-main', {
        label: 'Кейс',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-case-main">
            <div>
                <div class="careerum-case-main-top">
                    <div>
                        <div>
                            <h2>Как найти работу в<br> кризис с повышением<br> зарплаты на 40%</h2>
                        </div>
                        <div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1662502344534.png" alt="" class="careerum-case-main-header-avatar">
                                <a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1662502358011.svg" alt="" class="careerum-case-main-header-in"></a>
                            </div>
                            <div>
                                <p class="careerum-case-main-header-descr">Лизавета Жданович,<br> Product Manager, Лондон</p>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div>
                            <p class="careerum-case-main-tale-header">До Careerum</p>
                            <ul class="careerum-case-main-tale-list">
                                <li class="careerum-case-main-tale-list-item-yes">Мечта о работе с релокацией</li>
                                <li class="careerum-case-main-tale-list-item-no">Неуверенность в себе</li>
                                <li class="careerum-case-main-tale-list-item-no">Отсутствие плана</li>
                            </ul>
                        </div>
                        <div>
                            <p class="careerum-case-main-tale-header">В клубе</p>
                            <ul class="careerum-case-main-tale-list">
                                <li class="careerum-case-main-tale-list-item-yes">Составила продающее резюме</li>
                                <li class="careerum-case-main-tale-list-item-yes">Создала «воронку поиска» работы</li>
                                <li class="careerum-case-main-tale-list-item-yes">Научилась проходить интервью</li>
                        </div>
                        <div>
                            <p class="careerum-case-main-tale-header">Достигнутый результат</p>
                            <ul class="careerum-case-main-tale-list">
                                <li class="careerum-case-main-tale-list-item-yes">Новый взгляд на свой опыт</li>
                                <li class="careerum-case-main-tale-list-item-yes">Оффер с + 40% к зарплате</li>
                                <li class="careerum-case-main-tale-list-item-yes">Переезд в Лондон</li>
                        </div>
                    </div>
                    <div>
                        <a href="#" class="btn-color-main-bright-orange">Присоединиться к клубу</a>
                    </div>
                </div>
                <div class="careerum-case-text">
                    
                        <div>
                            <p class="careerum-case-text-subheader">
                                До Careerum
                            </p>
                            <p class="careerum-case-text-header">
                                «Что угодно, лишь бы за границей»
                            </p>
                        </div>
                        <div>
                            <p class="careerum-case-text-content">
                                В феврале 2022 Лизавета уволилась из компании в Беларуси и планировала устроиться на работу в Москве. После событий 24 февраля 2022 план изменился на «что угодно, лишь бы за границей». <br><br>
                                Появилась мечта — найти работу по специальности Product Manager в Европе (Великобритания или Нидерланды), но ей мешала неуверенность в себе: у Лизаветы было всего 2-3 года опыта, причем абсолютно разного: UX Designer, Data Engineer и всего 6 месяцев — Product Manager. 
                            </p>
                        </div>
                    
                </div>
                <div class="careerum-case-quote">
                    <div>
                        <p>«Курс “Умная стратегия поиска работы” очень помог принять реальность. И не летать в иллюзиях, что я через неделю найду работу в Лондоне, а четко понимать, какие действия мне нужно будет предпринять, чтобы получить работу в реальные сроки».</p>
                    </div>
                </div>
                <div class="careerum-case-text">
                    
                        <div>
                            <p class="careerum-case-text-subheader">
                                До Careerum
                            </p>
                            <p class="careerum-case-text-header">
                                «Что угодно, лишь бы за границей»
                            </p>
                        </div>
                        <div>
                            <p class="careerum-case-text-content">
                                В феврале 2022 Лизавета уволилась из компании в Беларуси и планировала устроиться на работу в Москве. После событий 24 февраля 2022 план изменился на «что угодно, лишь бы за границей». <br><br>
                                Появилась мечта — найти работу по специальности Product Manager в Европе (Великобритания или Нидерланды), но ей мешала неуверенность в себе: у Лизаветы было всего 2-3 года опыта, причем абсолютно разного: UX Designer, Data Engineer и всего 6 месяцев — Product Manager. 
                            </p>
                        </div>
                    
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-case-main-tablet', {
        label: 'Кейс (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-case-main-tablet">
            <div>
                <div class="careerum-case-main-top">
                    <div>
                        <div>
                            <h2>Как найти работу<br> с повышением зарплаты на 40%</h2>
                        </div>
                        <div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1662502436432.png" alt="" class="careerum-case-main-header-avatar">
                                <a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1662502447398.svg" alt="" class="careerum-case-main-header-in"></a>
                            </div>
                            <div>
                                <p class="careerum-case-main-header-descr">Лизавета Жданович,<br> Product Manager, Лондон</p>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div>
                            <p class="careerum-case-main-tale-header">До Careerum</p>
                            <ul class="careerum-case-main-tale-list">
                                <li class="careerum-case-main-tale-list-item-yes">Мечта о работе<br> с релокацией</li>
                                <li class="careerum-case-main-tale-list-item-no">Неуверенность<br> в себе</li>
                                <li class="careerum-case-main-tale-list-item-no">Отсутствие плана</li>
                            </ul>
                        </div>
                        <div>
                            <p class="careerum-case-main-tale-header">В клубе</p>
                            <ul class="careerum-case-main-tale-list">
                                <li class="careerum-case-main-tale-list-item-yes">Составила продающее резюме</li>
                                <li class="careerum-case-main-tale-list-item-yes">Создала «воронку поиска» работы</li>
                                <li class="careerum-case-main-tale-list-item-yes">Научилась проходить интервью</li>
                        </div>
                        <div>
                            <p class="careerum-case-main-tale-header">Достигнутый результат</p>
                            <ul class="careerum-case-main-tale-list">
                                <li class="careerum-case-main-tale-list-item-yes">Новый взгляд<br> на свой опыт</li>
                                <li class="careerum-case-main-tale-list-item-yes">Оффер с + 40%<br> к зарплате</li>
                                <li class="careerum-case-main-tale-list-item-yes">Переезд в Лондон</li>
                        </div>
                    </div>
                    <div>
                        <a href="#" class="btn-color-main-bright-orange">Присоединиться к клубу</a>
                    </div>
                </div>
                <div class="careerum-case-text">
                    
                        <div>
                            <p class="careerum-case-text-subheader">
                                До Careerum
                            </p>
                            <p class="careerum-case-text-header">
                                «Что угодно, лишь бы за границей»
                            </p>
                        </div>
                        <div class="careerum-case-text-content">
                            <p>
                                В феврале 2022 Лизавета уволилась из компании в Беларуси и планировала устроиться на работу в Москве. После событий 24 февраля 2022 план изменился на «что угодно, лишь бы за границей».
                                </p>
                                <p>
                                Появилась мечта — найти работу по специальности Product Manager в Европе (Великобритания или Нидерланды), но ей мешала неуверенность в себе: у Лизаветы было всего 2-3 года опыта, причем абсолютно разного: UX Designer, Data Engineer и всего 6 месяцев — Product Manager. 
                            </p>
                        </div>
                    
                </div>
                <div class="careerum-case-quote">
                    <div>
                        <p>«Курс “Умная стратегия поиска работы” очень помог принять реальность. И не летать в иллюзиях, что я через неделю найду работу в Лондоне, а четко понимать, какие действия мне нужно будет предпринять, чтобы получить работу в реальные сроки».</p>
                    </div>
                </div>
                <div class="careerum-case-text">
                    
                        <div>
                            <p class="careerum-case-text-subheader">
                                До Careerum
                            </p>
                            <p class="careerum-case-text-header">
                                «Что угодно, лишь бы за границей»
                            </p>
                        </div>
                        <div>
                            <p class="careerum-case-text-content">
                                В феврале 2022 Лизавета уволилась из компании в Беларуси и планировала устроиться на работу в Москве. После событий 24 февраля 2022 план изменился на «что угодно, лишь бы за границей». <br><br>
                                Появилась мечта — найти работу по специальности Product Manager в Европе (Великобритания или Нидерланды), но ей мешала неуверенность в себе: у Лизаветы было всего 2-3 года опыта, причем абсолютно разного: UX Designer, Data Engineer и всего 6 месяцев — Product Manager. 
                            </p>
                        </div>
                    
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-case-main-mobile', {
        label: 'Кейс (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-case-main-mobile">
            <div>
                <div class="careerum-case-main-top">
                    <div>
                        <div>
                            <h2>Как найти работу<br> с повышением зарплаты на 40%</h2>
                        </div>
                        <div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1662502510489.png" alt="" class="careerum-case-main-header-avatar">
                                <a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1662502519831.svg" alt="" class="careerum-case-main-header-in"></a>
                            </div>
                            <div>
                                <p class="careerum-case-main-header-descr">Лизавета Жданович,<br> Product Manager, Лондон</p>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div>
                            <p class="careerum-case-main-tale-header">До Careerum</p>
                            <ul class="careerum-case-main-tale-list">
                                <li class="careerum-case-main-tale-list-item-yes">Мечта о работе с релокацией</li>
                                <li class="careerum-case-main-tale-list-item-no">Неуверенность в себе</li>
                                <li class="careerum-case-main-tale-list-item-no">Отсутствие плана</li>
                            </ul>
                        </div>
                        <div>
                            <p class="careerum-case-main-tale-header">В клубе</p>
                            <ul class="careerum-case-main-tale-list">
                                <li class="careerum-case-main-tale-list-item-yes">Составила продающее резюме</li>
                                <li class="careerum-case-main-tale-list-item-yes">Создала «воронку поиска» работы</li>
                                <li class="careerum-case-main-tale-list-item-yes">Научилась проходить интервью</li>
                        </div>
                        <div>
                            <p class="careerum-case-main-tale-header">Достигнутый результат</p>
                            <ul class="careerum-case-main-tale-list">
                                <li class="careerum-case-main-tale-list-item-yes">Новый взгляд на свой опыт</li>
                                <li class="careerum-case-main-tale-list-item-yes">Оффер с + 40% к зарплате</li>
                                <li class="careerum-case-main-tale-list-item-yes">Переезд в Лондон</li>
                        </div>
                    </div>
                </div>
                <div class="careerum-case-button">
                    <a href="#" class="btn-color-main-bright-orange">Присоединиться к клубу</a>
                </div>
                <div class="careerum-case-button-fix">
                </div>
                <div class="careerum-case-text">
                    
                        <div>
                            <p class="careerum-case-text-subheader">
                                До Careerum
                            </p>
                            <p class="careerum-case-text-header">
                                «Что угодно,<br> лишь бы<br> за границей»
                            </p>
                        </div>
                        <div class="careerum-case-text-content">
                            <p>
                                В феврале 2022 Лизавета уволилась из компании в Беларуси и планировала устроиться на работу в Москве. После событий 24 февраля 2022 план изменился на «что угодно, лишь бы за границей».
                                </p>
                                <p>
                                Появилась мечта — найти работу<br> по специальности Product Manager в Европе (Великобритания или Нидерланды), но ей мешала неуверенность в себе: у Лизаветы было всего 2-3 года опыта, причем абсолютно разного: UX Designer, Data Engineer и всего 6 месяцев — Product Manager. 
                            </p>
                        </div>
                    
                </div>
                <div class="careerum-case-quote">
                    <div>
                        <p>«Курс “Умная стратегия поиска работы” очень помог принять реальность. И не летать в иллюзиях, что я через неделю найду работу в Лондоне, а четко понимать, какие действия мне нужно будет предпринять, чтобы получить работу в реальные сроки».</p>
                    </div>
                </div>
                <div class="careerum-case-text">
                    
                        <div>
                            <p class="careerum-case-text-subheader">
                                До Careerum
                            </p>
                            <p class="careerum-case-text-header">
                                «Что угодно, лишь бы за границей»
                            </p>
                        </div>
                        <div class="careerum-case-text-content">
                            <p>
                                В феврале 2022 Лизавета уволилась из компании в Беларуси и планировала устроиться на работу в Москве. После событий 24 февраля 2022 план изменился на «что угодно, лишь бы за границей». </p>
                                <p>Появилась мечта — найти работу по специальности Product Manager в Европе (Великобритания или Нидерланды), но ей мешала неуверенность в себе: у Лизаветы было всего 2-3 года опыта, причем абсолютно разного: UX Designer, Data Engineer и всего 6 месяцев — Product Manager. 
                            </p>
                        </div>
                    
                </div>
            </div>
        </div>`
	});
    
    blockManager.add('careerum-lead-form-row', {
        label: 'Лид форма блок',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-lead-form-row">
            <div>
                <div class="careerum-getcourse-email-form-lead">
                    <div class="careerum-form-lead">
                        <div>
                            <h2>Поиск работы может приносить <span>удовольствие</spa></h2>
                            <p>Чтобы убедиться в этом, посмотрите бесплатный урок курса <br>«Умная стратегия поиска работы»</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1668598134770.svg" alt="">
                        </div>
                        <div>
                            <form class="deva-form getcourse-email-signup" name="devaRegistrationForm" data-gjs-type="deva-registration-form">
                                <div>
                                    <div class="careerum-form-lead-name">
                                        <input type="text" name="name" value="" placeholder=" " required>
                                        <span>Имя</span>
                                    </div>
                                    <div class="careerum-form-lead-email">
                                        <input type="email" name="email" value="" placeholder=" " required>
                                        <span>Почта</span>
                                    </div>
                                    <div class="careerum-form-lead-tel">
                                        <input type="tel" name="tel" value="" placeholder=" " required>
                                        <span>Номер телефона</span>
                                    </div>
                                </div>
                                <div class="careerum-form-lead-agree">
                                    <label data-toggle-checkbox="true">
                                        <input type="checkbox" name="agree">
                                    </label>
                                    <p>Я даю согласие на обработку своих <br>персональных данных в соответствии <br>с <a href="/ru-ru/legal/privacy" target="_blank">Политикой конфиденциальности</a>
                                </div>
                                <a href="#" disabled class="submit-btn">Получить демоурок</a>
                            </form>
                        </div>
                    </div>
                    <div class="careerum-form-success-lead">
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1668598146404.svg" alt="" class="careerum-form-success-lead-heart">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1668598155559.svg" alt="" class="careerum-form-success-lead-highlight">
                            <h2>Спасибо! Скоро вам на почту придет письмо <span>с демоуроком</spa></h2>
                        </div>                    
                    </div>                    
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-lead-form-row-tablet', {
        label: 'Лид форма блок (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-lead-form-row-tablet">
            <div>
                <div class="careerum-getcourse-email-form-lead">
                    <div class="careerum-form-lead">
                        <div>
                            <h2>Поиск работы может<br> приносить <span>удовольствие</spa></h2>
                            <p>Чтобы убедиться в этом, посмотрите бесплатный <br>урок курса «Умная стратегия поиска работы»</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1668598181401.svg" alt="">
                        </div>
                        <div>
                            <form class="deva-form getcourse-email-signup" name="devaRegistrationForm" data-gjs-type="deva-registration-form">
                                <div>
                                    <div class="careerum-form-lead-name">
                                        <input type="text" name="name" value="" placeholder=" " required>
                                        <span>Имя</span>
                                    </div>
                                    <div class="careerum-form-lead-email">
                                        <input type="email" name="email" value=""  placeholder=" " required>
                                        <span>Почта</span>
                                    </div>
                                    <div class="careerum-form-lead-tel">
                                        <input type="tel" name="tel" value="" placeholder=" "  required>
                                        <span>Номер телефона</span>
                                    </div>
                                </div>
                                <div class="careerum-form-lead-agree">
                                    <label data-toggle-checkbox="true">
                                        <input type="checkbox" name="agree">
                                    </label>
                                    <p>Я даю согласие на обработку своих <br>персональных данных в соответствии <br>с <a href="/ru-ru/legal/privacy" target="_blank">Политикой конфиденциальности</a>
                                </div>
                                <a href="#" disabled class="submit-btn">Получить демоурок</a>
                            </form>
                        </div>
                    </div>
                    <div class="careerum-form-success-lead">
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1668598191411.svg" alt="" class="careerum-form-success-lead-heart">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1668598202783.svg" alt="" class="careerum-form-success-lead-highlight">
                            <h2>Спасибо! Скоро вам на почту придет письмо <span>с демоуроком</spa></h2>
                        </div>                    
                    </div>                    
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-lead-form-row-mobile', {
        label: 'Лид форма блок (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-lead-form-row-mobile">
            <div>
                <div class="careerum-getcourse-email-form-lead">
                    <div class="careerum-form-lead">
                        <div>
                            <h2>Поиск работы может приносить <span>удовольствие</span></h2>
                            <p>Чтобы убедиться в этом,<br> посмотрите бесплатный урок курса <br>«Умная стратегия поиска работы»</p>
                        </div>
                        <div>
                            <form class="deva-form getcourse-email-signup" name="devaRegistrationForm" data-gjs-type="deva-registration-form">
                                <div>
                                    <div class="careerum-form-lead-name">
                                        <input type="text" name="name" value="" placeholder=" " required>
                                        <span>Имя</span>
                                    </div>
                                    <div class="careerum-form-lead-email">
                                        <input type="email" name="email" value=""  placeholder=" " required>
                                        <span>Почта</span>
                                    </div>
                                    <div class="careerum-form-lead-tel">
                                        <input type="tel" name="tel" value="" placeholder=" "  required>
                                        <span>Номер телефона</span>
                                    </div>
                                </div>
                                <div class="careerum-form-lead-agree">
                                    <label data-toggle-checkbox="true">
                                        <input type="checkbox" name="agree">
                                    </label>
                                    <p>Я даю согласие на обработку своих <br>персональных данных в соответствии <br>с <a href="/ru-ru/legal/privacy" target="_blank">Политикой конфиденциальности</a>
                                </div>
                                <a href="#" disabled class="submit-btn">Получить демоурок</a>
                            </form>
                        </div>
                    </div>
                    <div class="careerum-form-success-lead" >
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1668598233783.svg" alt="" class="careerum-form-success-lead-heart">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1668598243347.svg" alt="" class="careerum-form-success-lead-highlight">
                            <h2>Спасибо! Скоро вам на почту придет письмо <br><span>с демоуроком</spa></h2>
                        </div>                    
                    </div>                    
                </div>
            </div>
        </div>`
	});
    
    blockManager.add('careerum-advent-calendar', {
        label: 'Адвент календарь',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-advent-calendar">
            <div>
                <div class="careerum-advent-calendar-main-form">
                    <div class="careerum-advent-calendar-logo">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1670921479832.svg" alt="">
                    </div>
                    <div class="careerum-advent-calendar-form">
                        <div class="careerum-lead-form-row form-advent-calendar">
                            <div>
                                <div class="careerum-getcourse-email-form-lead">
                                    <div class="careerum-form-lead advent-form-lead">
                                        <div>
                                            <h2>Как сделать 2023 год<br> успешным для своей<br> карьеры – советы
                                                экспертов<br>
                                                Careerum</h2>
                                        </div>
                                        <div>
                                            <form class="deva-form getcourse-email-signup" name="devaRegistrationForm"
                                                data-gjs-type="deva-registration-form">
                                                <div>
                                                    <div class="careerum-form-lead-name">
                                                        <input type="text" name="name" value="" placeholder=" " required>
                                                        <span>Имя</span>
                                                    </div>
                                                    <div class="careerum-form-lead-email">
                                                        <input type="email" name="email" value="" placeholder=" " required>
                                                        <span>Почта</span>
                                                    </div>
                                                    <div class="careerum-form-lead-tel">
                                                        <input type="tel" name="tel" value="" placeholder=" " required>
                                                        <span>Телефон</span>
                                                    </div>
                                                    <a href="#" class="submit-btn">Получать&nbsp;письма</a>
                                                </div>
                                                <div class="careerum-form-lead-agree">
                                                    <label data-toggle-checkbox="true" class="">
                                                        <input type="checkbox" name="agree">
                                                    </label>
                                                    <p>Я принимаю условия <a href="#">Публичной оферты</a> и даю согласие на
                                                        обработку своих персональных данных в соответствии с <a
                                                            href="#">Политикой конфиденциальности</a></p>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div>
                            <div>
                                <div>
                                    <p>Заполните форму<br> и бесплатно получите<br> 7 писем, в том числе одно секретное,
                                        которые
                                        помогут вам отлично провести новый карьерный год. </p>
                                    <p>1 день – 1 письмо</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="careerum-advent-calendar-letters">
                        <div>
                            <div>
                                <div class="careerum-advent-calendar-letters-item letters-item-1">
                                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1670921522170.svg" alt=""></div>
                                    <div>
                                        <div>
                                            <div>
                                                <p><span>1</span> письмо</p>
                                            </div>
                                            <div>
                                                <p>Подкаст о том, как подвести итоги 2022 года</p>
                                            </div>
                                            <div>
                                                <p>Расскажем, почему важно подвести итоги этого года,<br> как собраться с
                                                    силами
                                                    и сделать это</p>
                                            </div>
                                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1670921535690.svg" alt="">
                                        </div>
                                    </div>
                                </div>
                                <a href="#">Хочу получить мотивацию!</a>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1670921582901.svg" alt="">
                            </div>
                            <div>
                                <div>
                                    <div class="careerum-advent-calendar-letters-item letters-item-2">
                                        <div>
                                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1670921592411.svg" alt="">
                                        </div>
                                        <div>
                                            <div>
                                                <div>
                                                    <p><span>2</span> письмо</p>
                                                </div>
                                                <div>
                                                    <p>Видео про резюме<br>от CV-эксперта<br>Careerum</p>
                                                </div>
                                                <div>
                                                    <p>СV-эксперт Cофия<br>Бессонова расскажет, как<br>замотивировать себя
                                                        своим<br>собственным резюме</p>
                                                </div>
                                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1670921605556.png" alt="">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div class="careerum-advent-calendar-letters-item letters-item-3">
                                        <div>
                                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1670921615945.svg" alt="">
                                        </div>
                                        <div>
                                            <div>
                                                <div>
                                                    <p><span>3</span> письмо</p>
                                                </div>
                                                <div>
                                                    <p>Письмо<br>Careerum. Tips<br>о том, как<br>поставить цели<br>на 2023
                                                        год
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="careerum-advent-calendar-letters-item letters-item-4">
                                        <div>
                                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1670921627904.svg" alt="">
                                        </div>
                                        <div>
                                            <div>
                                                <div>
                                                    <p><span>4</span> письмо</p>
                                                </div>
                                                <div>
                                                    <p>Итоги 2022 года<br>от участников<br><ins>Careerum.Club</ins>
                                                        —<br>расскажем о самых<br>интересных результатах<br>клубовцев</p>
                                                </div>
                                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1670921641000.svg" alt="">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div class="careerum-advent-calendar-letters-item letters-item-5">
                                        <div>
                                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1670921651532.svg" alt="">
                                        </div>
                                        <div>
                                            <div>
                                                <div>
                                                    <p><span>5</span> письмо</p>
                                                </div>
                                                <div>
                                                    <p>Новогоднее видео<br>от Ольги Лермонтовой</p>
                                                </div>
                                                <div>
                                                    <p>Для успешного карьерного 2023 года в найме</p>
                                                </div>
                                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1670921683589.png" alt="">
                                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1670921696229.svg" alt="">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div>
                            <div>
                                <div class="careerum-advent-calendar-letters-item letters-item-6">
                                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1670921707243.svg" alt=""></div>
                                    <div>
                                        <div>
                                            <div>
                                                <p><span>6</span> письмо</p>
                                            </div>
                                            <div>
                                                <p>Список фильмов, которые<br>помогут создать настроение,<br> побыть наедине
                                                    с собой и<br> набраться сил на предстоящий<br> год</p>
                                            </div>
                                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1670921716640.svg" alt="">
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1670921728593.svg" alt="">
                        </div>
                    </div>
                    <div class="careerum-advent-calendar-form form-last">
                        <div class="careerum-lead-form-row form-advent-calendar">
                            <div>
                                <div class="careerum-getcourse-email-form-lead">
                                    <div class="careerum-form-lead advent-form-lead">
                                        <div>
                                            <h2>Подпишитесь на новогоднюю<br> рассылку Careerum и узнайте, что<br> поможет
                                                развитию вашей карьеры<br> в 2023 году</h2>
                                        </div>
                                        <div>
                                            <form class="deva-form getcourse-email-signup" name="devaRegistrationForm"
                                                data-gjs-type="deva-registration-form">
                                                <div>
                                                    <div class="careerum-form-lead-name">
                                                        <input type="text" name="name" value="" placeholder=" " required>
                                                        <span>Имя</span>
                                                    </div>
                                                    <div class="careerum-form-lead-email">
                                                        <input type="email" name="email" value="" placeholder=" " required>
                                                        <span>Почта</span>
                                                    </div>
                                                    <div class="careerum-form-lead-tel">
                                                        <input type="tel" name="tel" value="" placeholder=" " required>
                                                        <span>Телефон</span>
                                                    </div>
                                                    <a href="#" class="submit-btn">Получать&nbsp;письма</a>
                                                </div>
                                                <div class="careerum-form-lead-agree">
                                                    <label data-toggle-checkbox="true" class="">
                                                        <input type="checkbox" name="agree">
                                                    </label>
                                                    <p>Я принимаю условия <a href="#">Публичной оферты</a> и даю согласие на
                                                        обработку своих персональных данных в соответствии с <a
                                                            href="#">Политикой конфиденциальности</a></p>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="careerum-advent-calendar-form-footer">
                        <div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1670921754870.svg" alt="">
                            </div>
                            <div>
                                <p>
                                    © Careerum 2022<br>Все права защищены
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="careerum-advent-calendar-success">
                    <div class="careerum-advent-calendar-logo">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1670921479832.svg" alt="">
                    </div>
                    <div class="careerum-advent-calendar-thanks">
                        <h2><span>Подарки уже упакованы, ждите<br> первое письмо на почте 19 декабря.</span><br> Если вы хотите получать письма<br> адвента в Telegram, напишите слово<br> «Адвент» нашему боту <a href="#">Райану</a></h2>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1670921771575.svg" alt="">
                        <div class="careerum-advent-calendar-form-footer">
                            <div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1670921754870.svg" alt="">
                                </div>
                                <div>
                                    <p>
                                        © Careerum 2022<br>Все права защищены
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-advent-calendar-tablet', {
        label: 'Адвент календарь (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-advent-calendar-tablet">
            <div>
                <div class="careerum-advent-calendar-main-form">
                    <div class="careerum-advent-calendar-logo">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1670921875848.svg" alt="">
                    </div>
                    <div class="careerum-advent-calendar-form">
                        <div class="careerum-lead-form-row-tablet form-advent-calendar">
                            <div>
                                <div class="careerum-getcourse-email-form-lead">
                                    <div class="careerum-form-lead advent-form-lead">
                                        <div>
                                            <h2>Как сделать 2023 год успешным<br> для своей карьеры –<br> советы
                                                экспертов
                                                Careerum</h2>
                                        </div>
                                        <div>
                                            <form class="deva-form getcourse-email-signup" name="devaRegistrationForm"
                                                data-gjs-type="deva-registration-form">
                                                <div>
                                                    <div class="careerum-form-lead-name">
                                                        <input type="text" name="name" value="" placeholder=" " required>
                                                        <span>Имя</span>
                                                    </div>
                                                    <div class="careerum-form-lead-email">
                                                        <input type="email" name="email" value="" placeholder=" " required>
                                                        <span>Почта</span>
                                                    </div>
                                                    <div class="careerum-form-lead-tel">
                                                        <input type="tel" name="tel" value="" placeholder=" " required>
                                                        <span>Номер телефона</span>
                                                    </div>
                                                </div>
                                                <div class="careerum-form-lead-agree">
                                                    <label data-toggle-checkbox="true" class="">
                                                        <input type="checkbox" name="agree">
                                                    </label>
                                                    <p>Я принимаю условия <a href="#">Публичной оферты</a> и даю согласие на
                                                        обработку своих персональных данных в соответствии<br> с <a
                                                            href="#">Политикой конфиденциальности</a></p>
                                                </div>
                                                <a href="#" class="submit-btn">Получать&nbsp;письма</a>
                                            </form>
                                            <div>
                                                <div>
                                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1670921905505.svg" alt="">
                                                    <p>Заполните форму и<br> бесплатно получите 7 писем,<br> в том числе
                                                        одно секретное,<br>
                                                        которые
                                                        помогут вам <br>отлично провести новый<br> карьерный год. 1 день
                                                        –<br> 1 письмо</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="careerum-advent-calendar-letters">
                        <div>
                            <div>
                                <div class="careerum-advent-calendar-letters-item letters-item-1">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1670921922603.svg" alt="">
                                    <div>
                                        <div>
                                            <p><span>1</span> письмо</p>
                                        </div>
                                        <div>
                                            <p>Подкаст о том,<br> как подвести<br> итоги 2022<br> года</p>
                                        </div>
                                        <div>
                                            <p>Расскажем, почему <br>важно подвести итоги<br> этого года, как<br> собраться
                                                с
                                                силами<br>
                                                и сделать это</p>
                                        </div>
                                    </div>
                                </div>
                                <a href="#">Хочу получить мотивацию!</a>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1670921934220.svg" alt="">
                                <div class="careerum-advent-calendar-letters-item letters-item-5">
                                    <div>
                                            <div>
                                                <p><span>5</span> письмо</p>
                                            </div>
                                            <div>
                                                <p>Новогоднее видео от Ольги Лермонтовой</p>
                                            </div>
                                            <div>
                                                <p>Для успешного карьерного 2023 года в найме</p>
                                            </div>
                                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1670921950155.png" alt="">
                                        </div>
                                </div>
                            </div>
                            <div>
                                    <div class="careerum-advent-calendar-letters-item letters-item-2">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1670921962815.svg" alt="">
                                        <div>
                                                <div>
                                                    <p><span>2</span> письмо</p>
                                                </div>
                                                <div>
                                                    <p>Видео про<br> резюме от CV-<br>эксперта<br> Careerum</p>
                                                </div>
                                                <div>
                                                    <p>СV-эксперт Cофия Бессонова<br> расскажет, как замотивировать<br> себя
                                                        своим собственным<br> резюме</p>
                                                </div>
                                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1670921973603.png" alt="">
                                            </div>
                                    </div>
                                    <div class="careerum-advent-calendar-letters-item letters-item-3">
                                        <div>
                                                <div>
                                                    <p>3 </p>
                                                    <p>письмо</p>
                                                </div>
                                                <div>
                                                    <p>Письмо Careerum. Tips<br>о том, как поставить<br> цели на 2023
                                                        год
                                                    </p>
                                                </div>
                                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1670921985822.svg" alt="">
                                        </div>
                                    </div>
                                    <div class="careerum-advent-calendar-letters-item letters-item-4">
                                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1670921998467.svg" alt="">
                                        <div>
                                                <div>
                                                    <p><span>4</span> письмо</p>
                                                </div>
                                                <div>
                                                    <p>Итоги 2022 года<br>от участников<br><span>Careerum.Club</span>
                                                        —<br>расскажем о самых<br>интересных результатах<br>клубовцев</p>
                                                </div>
                                        </div>
                                    </div>
                                    <div class="careerum-advent-calendar-letters-item letters-item-6">
                                        <div>
                                                <div>
                                                    <p><span>6</span> письмо</p>
                                                </div>
                                                <div>
                                                    <p>Список фильмов, которые помогут<br> создать настроение, побыть наедине<br> с собой и набраться сил<br> на предстоящий год
                                                    </p>
                                                </div>
                                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1670922009168.svg" alt="">
                                        </div>
                                    </div>
                            </div>
                        </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1670922021190.svg" alt="">
                        </div>
                    </div>
                    <div class="careerum-advent-calendar-form form-last">
                        <div class="careerum-lead-form-row-tablet form-advent-calendar">
                            <div>
                                <div class="careerum-getcourse-email-form-lead">
                                    <div class="careerum-form-lead advent-form-lead">
                                        <div>
                                            <h2>Подпишитесь<br> на новогоднюю<br> рассылку Careerum<br> и узнайте, что<br> поможет
                                                развитию<br> вашей карьеры<br> в 2023 году</h2>
                                        </div>
                                        <div>
                                            <form class="deva-form getcourse-email-signup" name="devaRegistrationForm"
                                                data-gjs-type="deva-registration-form">
                                                <div>
                                                    <div class="careerum-form-lead-name">
                                                        <input type="text" name="name" value="" placeholder=" " required>
                                                        <span>Имя</span>
                                                    </div>
                                                    <div class="careerum-form-lead-email">
                                                        <input type="email" name="email" value="" placeholder=" " required>
                                                        <span>Почта</span>
                                                    </div>
                                                    <div class="careerum-form-lead-tel">
                                                        <input type="tel" name="tel" value="" placeholder=" " required>
                                                        <span>Телефон</span>
                                                    </div>
                                                </div>
                                                <div class="careerum-form-lead-agree">
                                                    <label data-toggle-checkbox="true" class="">
                                                        <input type="checkbox" name="agree">
                                                    </label>
                                                    <p>Я принимаю условия <a href="#">Публичной оферты</a> и даю согласие на
                                                        обработку своих персональных данных в соответствии
                                                        <br> с <a
                                                            href="#">Политикой конфиденциальности</a></p>
                                                </div>
                                                <a href="#" class="submit-btn">Получать&nbsp;письма</a>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="careerum-advent-calendar-form-footer">
                        <div>
                            <div>
                                <p>
                                    © Careerum 2022<br>Все права защищены
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="careerum-advent-calendar-success">
                    <div class="careerum-advent-calendar-logo">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1670921875848.svg" alt="">
                    </div>
                    <div class="careerum-advent-calendar-thanks">
                        <h2><span>Подарки уже упакованы, ждите<br> первое письмо на почте 19 декабря.</span><br> Если вы
                            хотите получать письма<br> адвента в Telegram, напишите слово<br> «Адвент» нашему боту <a
                                href="#">Райану</a></h2>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1670922057204.svg" alt="">
                        <div class="careerum-advent-calendar-form-footer">
                            <div>
                                <div>
                                    <p>
                                        © Careerum 2022<br>Все права защищены
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-advent-calendar-mobile', {
        label: 'Адвент календарь (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-advent-calendar-mobile">
            <div>
                <div class="careerum-advent-calendar-main-form">
                    <div class="careerum-advent-calendar-logo">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1670922120461.svg" alt="">
                    </div>
                    <div class="careerum-advent-calendar-form">
                        <div class="careerum-lead-form-row-mobile form-advent-calendar">
                            <div>
                                <div class="careerum-getcourse-email-form-lead">
                                    <div class="careerum-form-lead advent-form-lead">
                                        <div>
                                            <h2>Как сделать 2023 год успешным для своей карьеры – советы
                                                экспертов
                                                Careerum</h2>
                                        </div>
                                        <div>
                                            <div>
                                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1670922157298.svg" alt="">
                                                <p>Заполните форму и бесплатно<br> получите 7 писем, в том числе
                                                    одно<br> секретное,
                                                    которые
                                                    помогут вам <br>отлично провести новый карьерный<br> год. 1 день
                                                    – 1 письмо</p>
                                            </div>
                                        </div>
                                        <div>
                                            <form class="deva-form getcourse-email-signup" name="devaRegistrationForm"
                                                data-gjs-type="deva-registration-form">
                                                <div>
                                                    <div class="careerum-form-lead-name">
                                                        <input type="text" name="name" value="" placeholder=" " required>
                                                        <span>Имя</span>
                                                    </div>
                                                    <div class="careerum-form-lead-email">
                                                        <input type="email" name="email" value="" placeholder=" " required>
                                                        <span>Почта</span>
                                                    </div>
                                                    <div class="careerum-form-lead-tel">
                                                        <input type="tel" name="tel" value="" placeholder=" " required>
                                                        <span>Номер телефона</span>
                                                    </div>
                                                </div>
                                                <div class="careerum-form-lead-agree">
                                                    <label data-toggle-checkbox="true" class="">
                                                        <input type="checkbox" name="agree">
                                                    </label>
                                                    <p>Я принимаю условия <a href="#">Публичной оферты</a> и даю согласие на
                                                        обработку своих персональных данных<br> в соответствии с <a
                                                            href="#">Политикой конфиденциальности</a></p>
                                                </div>
                                                <a href="#" class="submit-btn">Получать&nbsp;письма</a>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="careerum-advent-calendar-letters">
                                <div class="careerum-advent-calendar-letters-item letters-item-1">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1670922171090.svg" alt="">
                                    <div>
                                        <div>
                                            <p><span>1</span> письмо</p>
                                        </div>
                                        <div>
                                            <p>Подкаст о том,<br> как подвести<br> итоги 2022<br> года</p>
                                        </div>
                                        <div>
                                            <p>Расскажем, почему важно<br> подвести итоги этого года,<br> как собраться
                                                с
                                                силами<br>
                                                и сделать это</p>
                                        </div>
                                    </div>
                                </div>
                                    <div class="careerum-advent-calendar-letters-item letters-item-2">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1670922180356.svg" alt="">
                                        <div>
                                                <div>
                                                    <p><span>2</span> письмо</p>
                                                </div>
                                                <div>
                                                    <p>Видео про<br> резюме от<br> CV-эксперта<br> Careerum</p>
                                                </div>
                                                <div>
                                                    <p>СV-эксперт Cофия<br> Бессонова расскажет,<br> как замотивировать себя<br>
                                                        своим собственным<br> резюме</p>
                                                </div>
                                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1670922192715.png" alt="">
                                            </div>
                                    </div>
                                    <div class="careerum-advent-calendar-letters-item letters-item-3">
                                        <div>
                                                <div>
                                                    <p><span>3</span> письмо</p>
                                                </div>
                                                <div>
                                                    <p>Письмо<br> Careerum. Tips о том, как поставить цели<br> на 2023
                                                        год
                                                    </p>
                                                </div>
                                        </div>
                                    </div>
                                    <div class="careerum-advent-calendar-letters-item letters-item-4">
                                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1670922203108.svg" alt="">
                                        <div>
                                                <div>
                                                    <p><span>4</span> письмо</p>
                                                </div>
                                                <div>
                                                    <p>Итоги 2022 года<br>от участников<br><span>Careerum.Club</span>
                                                        —<br>расскажем о самых<br>интересных результатах<br>клубовцев</p>
                                                </div>
                                        </div>
                                    </div>
                                    <div class="careerum-advent-calendar-letters-item letters-item-5">
                                        <div>
                                                <div>
                                                    <p><span>5</span> письмо</p>
                                                </div>
                                                <div>
                                                    <p>Новогоднее видео от Ольги Лермонтовой</p>
                                                </div>
                                                <div>
                                                    <p>Для успешного<br> карьерного<br> 2023 года<br> в найме</p>
                                                </div>
                                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1670922213845.png" alt="">
                                            </div>
                                    </div>
                                    <div class="careerum-advent-calendar-letters-item letters-item-6">
                                        <div>
                                                <div>
                                                    <p><span>6</span> письмо</p>
                                                </div>
                                                <div>
                                                    <p>Список фильмов, которые<br> помогут создать настроение,<br> побыть наедине с собой и<br> набраться сил на 2023 год
                                                    </p>
                                                </div>
                                        </div>
                                    </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1670922225871.svg" alt="">
                        </div>
                    </div>
                    <div class="careerum-advent-calendar-form form-last">
                        <div class="careerum-lead-form-row-mobile form-advent-calendar">
                            <div>
                                <div class="careerum-getcourse-email-form-lead">
                                    <div class="careerum-form-lead advent-form-lead">
                                        <div>
                                            <h2>Подпишитесь<br> на новогоднюю<br> рассылку Careerum и узнайте, что поможет
                                                развитию вашей карьеры в 2023 году</h2>
                                        </div>
                                        <div></div>
                                        <div>
                                            <form class="deva-form getcourse-email-signup" name="devaRegistrationForm"
                                                data-gjs-type="deva-registration-form">
                                                <div>
                                                    <div class="careerum-form-lead-name">
                                                        <input type="text" name="name" value="" placeholder=" " required>
                                                        <span>Имя</span>
                                                    </div>
                                                    <div class="careerum-form-lead-email">
                                                        <input type="email" name="email" value="" placeholder=" " required>
                                                        <span>Почта</span>
                                                    </div>
                                                    <div class="careerum-form-lead-tel">
                                                        <input type="tel" name="tel" value="" placeholder=" " required>
                                                        <span>Номер телефона</span>
                                                    </div>
                                                </div>
                                                <div class="careerum-form-lead-agree">
                                                    <label data-toggle-checkbox="true" class="">
                                                        <input type="checkbox" name="agree">
                                                    </label>
                                                    <p>Я принимаю условия <a href="#">Публичной оферты</a> и даю<br> согласие на
                                                        обработку своих персональных данных<br> в соответствии
                                                         с <a
                                                            href="#">Политикой конфиденциальности</a></p>
                                                </div>
                                                <a href="#" class="submit-btn">Получать&nbsp;письма</a>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="careerum-advent-calendar-form-footer">
                        <div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1670922240505.svg" alt="">
                            </div>
                            <div>
                                <p>
                                    © Careerum 2022<br>Все права защищены
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="careerum-advent-calendar-success">
                    <div class="careerum-advent-calendar-logo">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1670922120461.svg" alt="">
                    </div>
                    <div class="careerum-advent-calendar-thanks">
                        <h2><span>Подарки уже упакованы, ждите первое письмо<br> на почте 19 декабря.</span><br> Если вы
                            хотите получать письма адвента в<br> Telegram, напишите<br> слово «Адвент» нашему боту <a
                                href="#">Райану</a></h2>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1670922256361.svg" alt="">
                        <div class="careerum-advent-calendar-form-footer">
                            <div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1670922240505.svg" alt="">
                                </div>
                                <div>
                                    <p>
                                        © Careerum 2022<br>Все права защищены
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
	});

    
    blockManager.add('careerum-club-banner', {
        label: 'Баннер',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-club-banner">
            <div>
                <div>
                    <div>
                        <h2>Ждем всех участников 
                            клуба на фокус-кэмпе 
                            <span>
                                по самоопределению
                                — Real me
                            </span></h2>
                        <p>За 2,5 месяца вы пройдете путь от «не понимаю, какая работа мне подойдет» → «я знаю, в какой сфере и на какой позиции смогу реализоваться на 100% и получать удовольствие»</p>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1675062880528.svg" alt="">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1675062890882.svg" alt="">
                            <p>23 февраля — 30 апреля</p>
                            <p>9 эфиров</p>
                        </div>
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1675064355411.svg" alt="">
                        <p>Фокус-кэмп — это интерактивный формат обучения, где с помощью вебинаров, групповой работы и заданий вы быстрее достигаете целей</p>
                    </div>
                </div>
                <div>
                    <div>
                        <p>Спикеры фокус-кэмпа помогут вам:</p>
                    </div>
                    <div>
                        <div><p>проработать карьерные установки, которые мешают самореализации;</p></div>
                        <div><p>понять, что в работе мотивирует и демотивирует вас;</p></div>
                        <div><p>научиться опираться на свои таланты в работе;</p></div>
                        <div><p>достичь баланса в работе и в жизни.</p></div>
                        <div><p>определить ценности в работе, которые важны именно вам;</p></div>
                    </div>
                </div>
                <div>
                    <div>
                        <p>На фокус-кэмпе вы узнаете, как:</p>
                    </div>
                    <div>
                        <div><p>проанализировать рынок и выбрать компании и отрасли, которые<br> подходят именно вам;</p></div>
                        <div><p>исследовать рынок и понять, какие опции развития карьеры у вас есть;</p></div>
                        <div><p>выбрать направление в отрасли, согласно вашим желаниям;</p></div>
                        <div><p>проверить гипотезы и выбрать наиболее подходящую вам<br> карьерную опцию.</p></div>
                    </div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-club-banner-tablet', {
        label: 'Баннер (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-club-banner-tablet">
            <div>
                <div>
                    <div>
                        <h2>Ждем всех участников 
                            клуба на фокус-кэмпе 
                            <span>
                                по самоопределению
                                — Real me
                            </span></h2>
                        <p>За 2,5 месяца вы пройдете путь от «не понимаю, какая работа мне подойдет» → «я знаю, в какой сфере и на какой позиции смогу реализоваться на 100% и получать удовольствие»</p>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1675062968848.svg" alt="">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1675062978071.svg" alt="">
                            <p>23 февраля — 30 апреля</p>
                            <p>9 эфиров</p>
                        </div>
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1675064375660.svg" alt="">
                        <p>Фокус-кэмп — это интерактивный формат обучения, где с помощью вебинаров, групповой работы и заданий вы быстрее достигаете целей</p>
                    </div>
                </div>
                <div>
                    <div>
                        <p>Спикеры фокус-кэмпа помогут вам:</p>
                    </div>
                    <div>
                        <div><p>проработать карьерные установки, которые мешают самореализации;</p></div>
                        <div><p>понять, что в работе мотивирует и демотивирует вас;</p></div>
                        <div><p>научиться опираться на свои таланты в работе;</p></div>
                        <div><p>достичь баланса в работе и в жизни.</p></div>
                        <div><p>определить ценности в работе, которые важны именно вам;</p></div>
                    </div>
                </div>
                <div>
                    <div>
                        <p>На фокус-кэмпе вы узнаете, как:</p>
                    </div>
                    <div>
                        <div><p>проанализировать рынок и выбрать компании и отрасли, которые<br> подходят именно вам;</p></div>
                        <div><p>исследовать рынок и понять, какие опции развития карьеры у вас есть;</p></div>
                        <div><p>выбрать направление в отрасли, согласно вашим желаниям;</p></div>
                        <div><p>проверить гипотезы и выбрать наиболее подходящую вам<br> карьерную опцию.</p></div>
                    </div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-club-banner-mobile', {
        label: 'Баннер (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-club-banner-mobile">
            <div>
                <div>
                    <div>
                        <h2>Ждем всех участников<br> 
                            клуба на фокус-кэмпе 
                            <span>
                                по само-определению<br>
                                — Real me
                            </span></h2>
                        <p>За 2,5 месяца вы пройдете путь<br> от «не понимаю, какая работа мне подойдет» → «я знаю, в какой сфере и на какой позиции смогу реализоваться на 100% и получать удовольствие»</p>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1675063052574.svg" alt="">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1675063061937.svg" alt="">
                            <p>23 февраля — 30 апреля</p>
                            <p>9 эфиров</p>
                        </div>
                    </div>
                </div>
                <div class="careerum-club-banner-mobile-horizontal-slider">
                    <div>
                        <p>Спикеры фокус-кэмпа помогут вам:</p>
                    </div>
                    <div>
                        <div>
                            <div><p>проработать карьерные<br> установки, которые мешают<br> самореализации;</p></div>
                            <div><p>научиться опираться на свои<br> таланты в работе;</p></div>
                            <div><p>определить ценности в работе,<br> которые важны именно вам;</p></div>
                            <div><p>понять, что в работе мотивирует<br> и демотивирует вас;</p></div>
                            <div><p>достичь баланса в работе и в жизни.</p></div>
                        </div>
                    </div>
                </div>
                <div class="careerum-club-banner-mobile-horizontal-slider">
                    <div>
                        <p>На фокус-кэмпе вы узнаете, как:</p>
                    </div>
                    <div>
                        <div>
                            <div><p>проанализировать рынок<br> и выбрать компании и отрасли,<br> которые подходят именно вам;</p></div>
                            <div><p>выбрать направление в отрасли,<br> согласно вашим желаниям;</p></div>
                            <div><p>исследовать рынок и понять, какие<br> опции развития карьеры у вас есть;</p></div>
                            <div><p>проверить гипотезы и выбрать<br> наиболее подходящую вам<br> карьерную опцию.</p></div>
                        </div>
                    </div>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1675064389909.svg" alt="">
                    <p>Фокус-кэмп — это интерактивный формат обучения, где с помощью вебинаров, групповой работы и заданий вы быстрее достигаете целей</p>
                </div>
            </div>
        </div>`
	});
    
    blockManager.add('careerum-club-small-banner', {
        label: 'Баннер мини',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-club-small-banner">
            <div>
                <div>
                    <p>Первыми попасть в клуб на особых условиях смогут<br> только участники вебинара Ольги Лермонтовой</p>
                    <h3>«Строим карьеру<br> в 2023 году: как найти опору в работе и в жизни»</h3>
                    <a href="/ru-ru/promo/webinar/career-20230212" class="btn-color-main-bright-orange">Узнать подробнее</a>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1675094071335.svg" alt="">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1675094086092.png" alt="">
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-club-small-banner-tablet', {
        label: 'Баннер мини (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-club-small-banner-tablet">
            <div>
                <div>
                    <p>Первыми попасть в клуб на особых условиях смогут<br> только участники вебинара Ольги Лермонтовой</p>
                    <h3>«Строим карьеру<br> в 2023 году: как найти<br> опору в работе и в жизни»</h3>
                    <a href="/ru-ru/promo/webinar/career-20230212" class="btn-color-main-bright-orange">Узнать подробнее</a>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1675094166493.svg" alt="">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1675094174547.png" alt="">
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-club-small-banner-mobile', {
        label: 'Баннер мини (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-club-small-banner-mobile">
            <div>
                <div>
                    <p>Первыми попасть в клуб на особых условиях смогут только участники вебинара Ольги Лермонтовой</p>
                    <h3>«Строим карьеру<br> в 2023 году: как<br> найти опору в работе<br> и в жизни»</h3>
    
                    <a href="/ru-ru/promo/webinar/career-20230212" class="btn-color-main-bright-orange">Узнать подробнее</a>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1675094236683.svg" alt="">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1675094226285.png" alt="">
                </div>
            </div>
        </div>`
	});
    
    blockManager.add('careerum-cons-main', {
        label: 'Консультации главный',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-cons-main">
            <div>
                <h2>Индивидуальные<br> консультации<br>Ольги Лермонтовой</h2>
                <p>Персональная поддержка вашего карьерного развития<br> от основательницы и CEO Careerum</p>
                <a href="#" class="btn-color-main-dark-orange">Записаться</a>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676878948619.svg" alt="">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676878984054.svg" alt="">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676878994327.png" alt="">
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-cons-main-tablet', {
        label: 'Консультации главный (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-cons-main-tablet">
            <div>
                <h2>Индивидуальные<br> консультации<br>Ольги<br> Лермонтовой</h2>
                <p>Персональная поддержка вашего карьерного<br> развития от основательницы и CEO Careerum</p>
                <a href="#ancor" class="btn-color-main-dark-orange">Записаться</a>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676879025046.svg" alt="">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676879035611.png" alt="">
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-cons-main-mobile', {
        label: 'Консультации главный (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-cons-main-mobile">
            <div>
                <div>
                    <h2>Индивидуальные<br> консультации Ольги Лермонтовой</h2>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676879052288.svg" alt="">
                </div>
                <p>Персональная поддержка вашего карьерного развития от основательницы и CEO Careerum</p>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676879081396.png" alt="">
                <a href="#ancor" class="btn-color-main-dark-orange">Записаться</a>
            </div>
        </div>`
	});
    
    blockManager.add('careerum-cons-tales', {
        label: 'Консультации преимущества',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-cons-tales">
            <div>
                <div>
                    <p>15 лет<br> карьеры<br> в 5 странах</p>
                    <p>Россия, Италия, Ирландия,<br> Сингапур, Таиланд</p>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676879229574.svg" alt="">
                </div>
                <div>
                    <p>Должности<br> в топовых<br>IT-компаниях</p>
                    <p>Adobe Systems, McAfee,<br> Microsoft, Google</p>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676879250533.svg" alt="">
                </div>
                <div>
                    <p>Блог о карьере<br> с аудиторией<br>в 200 000+<br> читателей</p>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676879259001.svg" alt="">
                </div>
                <div>
                    <p>Работа на<br>25 рынках</p>
                    <p>Западная и Восточная<br> Европа, а также Африка</p>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676879272031.svg" alt="">
                </div>
                <div>
                    <p>Степень<br> MBA</p>
                    <p>В топовой школе INSEAD</p>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676879286342.svg" alt="">
                </div>
                <div>
                    <p>Аккредитация<br> ICF</p>
                    <p>Сертифицированный<br> карьерный коуч</p>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676879298808.svg" alt="">
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-cons-tales-tablet', {
        label: 'Консультации преимущества (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-cons-tales-tablet">
            <div>
                <div>
                    <p>15 лет<br> карьеры<br> в 5 странах</p>
                    <p>Россия, Италия,<br> Ирландия, Сингапур,<br> Таиланд</p>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676879325806.svg" alt="">
                </div>
                <div>
                    <p>Должности<br> в топовых IT-<br>компаниях</p>
                    <p>Adobe Systems, McAfee,<br> Microsoft, Google</p>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676879341617.svg" alt="">
                </div>
                <div>
                    <p>Блог о карьере<br> с аудиторией<br>в 200 000+<br> читателей</p>
                    
                </div>
                <div>
                    <p>Работа на<br>25 рынках</p>
                    <p>Западная и Восточная<br> Европа, а также Африка</p>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676879355305.svg" alt="">
                </div>
                <div>
                    <p>Степень<br> MBA</p>
                    <p>В топовой школе INSEAD</p>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676879371843.svg" alt="">
                </div>
                <div>
                    <p>Аккредитация<br> ICF</p>
                    <p>Сертифицированный<br> карьерный коуч</p>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676879382678.svg" alt="">
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-cons-tales-mobile', {
        label: 'Консультации преимущества (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-cons-tales-mobile">
            <div>
                <div>
                    <p>15 лет карьеры<br> в 5 странах</p>
                    <p>Россия, Италия, Ирландия, <br>Сингапур, Таиланд</p>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676879812008.svg" alt="">
                </div>
                <div>
                    <p>Должности в топовых<br> IT-компаниях</p>
                    <p>Adobe Systems, McAfee,<br> Microsoft, Google</p>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676879822530.svg" alt="">
                </div>
                <div>
                    <p>Работа на 25 рынках</p>
                    <p>Западная и Восточная<br> Европа, а также Африка</p>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676879839300.svg" alt="">
                </div>
                <div>
                    <p>Степень MBA</p>
                    <p>В топовой школе INSEAD</p>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676879853612.svg" alt="">
                </div>
                <div>
                    <p>Аккредитация ICF</p>
                    <p>Сертифицированный<br> карьерный коуч</p>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676879865523.svg" alt="">
                </div>
                <div>
                    <p>Блог о карьере<br> с аудиторией<br>в 200 000+ читателей</p>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676879874252.svg" alt="">                
                </div>
            </div>
        </div>`
	});
    
    blockManager.add('careerum-cons-about', {
        label: 'Консультации about',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-cons-about">
            <div>
                <div>
                    <h2>Как проходят консультации</h2>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676880078370.svg" alt="">
                </div>
                <div>
                    <div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676880088930.svg" alt="">
                            <p>Консультации проходят онлайн один раз<br> в неделю в удобное <br>для вас время.</p>
                            <p>Каждая консультация длится 50 минут</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676880108108.svg" alt="">
                        </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676880120659.svg" alt="">
                            <p>Консультации в формате коучинга помогут глубоко проработать ваш карьерный запрос</p>
                        </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676880133008.svg" alt="">
                            <p>Вы получите не просто готовые рекомендации, а вместе с Ольгой найдете разные пути решений
                                и выберете самое лучшее именно для вас</p>
                        </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676880150313.svg" alt="">
                            <p>Вы будете строить карьеру мечты через интерес и удовольствие, не через напряжение</p>
                        </div>
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676880159873.png" alt="">
                    </div>
                </div>
                <div>
                    <div>
                        <p>Перед началом консультации вас ждет вводная сессия с Ольгой</p>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676880172838.svg" alt="">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676880184384.svg" alt="">
                        </div>
                    </div>
                    <div>
                        <p>Вводная сессия — как разминка перед серьезным марафоном. Она поможет понять, насколько вам
                            подходит такой формат коучинга.</p>
                        <p>Если после нее придет понимание, что ваш запрос нужно решать как-то иначе, мы вернем стоимость
                            оплаченных консультаций.</p>
                    </div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-cons-about-tablet', {
        label: 'Консультации about (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-cons-about-tablet">
            <div>
                <div>
                    <h2>Как проходят консультации</h2>
                </div>
                <div>
                    <div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676880209876.svg" alt="">
                            <p>Консультации проходят онлайн один раз<br> в неделю в удобное<br> для вас время.</p>
                                <p>Каждая консультация длится 50 минут</p>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676880222156.svg" alt="">
                        </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676880237680.svg" alt="">
                            <p>Консультации<br> в формате коучинга помогут глубоко проработать ваш карьерный запрос</p>
                        </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676880252552.svg" alt="">
                            <p>Вы получите не<br> просто готовые рекомендации,<br> а вместе с Ольгой найдете разные пути решений и выберете самое лучшее<br> именно для вас</p>
                        </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676880261300.svg" alt="">
                            <p>Вы будете строить карьеру мечты через интерес<br> и удовольствие, <br>не через<br> напряжение</p>
                        </div>
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676880269854.png" alt="">
                    </div>
                </div>
                <div>
                    <div>
                        <p>Перед началом консультации вас ждет вводная сессия с Ольгой</p>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676880284298.svg" alt="">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676880299116.svg" alt="">
                        </div>
                    </div>
                    <div>
                        <p>Вводная сессия — как разминка перед<br> серьезным марафоном. Она поможет понять,<br> насколько вам подходит такой формат коучинга.</p>
                            <p>Если после нее придет понимание, что ваш<br> запрос нужно решать как-то иначе, мы вернем <br>стоимость оплаченных консультаций.</p>
                    </div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-cons-about-mobile', {
        label: 'Консультации about (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-cons-about-mobile">
            <div>
                <div>
                    <h2>Как проходят консультации</h2>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676880339956.svg" alt="">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676880349682.svg" alt="">
                    </div>
                </div>
                <div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676880357871.png" alt="">
                    </div>
                    <div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676880367515.svg" alt="">
                            <p>Консультации проходят онлайн один раз в неделю в удобное <br>для вас время.</p>
                            <p><span>Каждая консультация длится<br> 50 минут</span></p>
                        </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676880383945.svg" alt="">
                            <p>Консультации в формате коучинга помогут глубоко проработать ваш карьерный запрос</p>
                        </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676880394296.svg" alt="">
                            <p>Вы получите не просто готовые рекомендации, а вместе<br> с Ольгой найдете все<br> возможные пути решений и выберете самое лучшее именно для вас</p>
                        </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676880403694.svg" alt="">
                            <p>Вы будете строить карьеру<br> мечты через интерес и удовольствие,<br> не через напряжение</p>
                        </div>
                    </div>
                </div>
                <div>
                    <div>
                        <p>Перед началом консультации вас ждет вводная сессия с Ольгой</p>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676880419961.svg" alt="">
                        </div>
                    </div>
                    <div>
                        <p>Вводная сессия — как разминка<br> перед серьезным марафоном. Она поможет понять, насколько вам<br> подходит такой формат коучинга.</p>
                            <p>Если после нее придет<br> понимание, что ваш запрос нужно решать как-то иначе, мы вернем стоимость оплаченных<br> консультаций.</p>
                    </div>
                </div>
            </div>
        </div>`
	});
    
    blockManager.add('careerum-cons-tariff-block', {
        label: 'Консультации витрина',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-cons-tariff-block">
            <div>
                <div class="careerum-cons-tariff-header">
                    <h2>Выберите ваш запрос</h2>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676880575146.svg" alt="">
                </div>
                <div>
                    <div class="careerum-consult-tariff-menu">
                    </div>
                    <div class="careerum-consult-tariff-tabs">
                        <div class="careerum-cons-currency-switcher">
                            <div>
                                <p class="careerum-cons-currency-header">RUB</p>
                                <div class="careerum-cons-currency-dropdown">
                                    <p data-cons-currency="EUR" class="careerum-cons-currency-dropdown-item">EUR</p>
                                    <p data-cons-currency="RUB" class="careerum-cons-currency-dropdown-item">RUB</p>
                                </div>
                            </div>
                        </div>
                        <div class="careerum-consult-tariff-tab" data-tab-name="Понять, куда двигаться">
                            <div>
                                <div class="careerum-consult-tariff-tab-item-header">
                                    <div>
                                        <p class="careerum-cons-tariff-item-header-1">Избавитесь от установок, которые
                                            блокируют ваше<br> продвижение. Найдете свои таланты и построите<br> карьерную
                                            стратегию</p>
                                    </div>
                                </div>
                                <div class="careerum-cons-tariff-switcher-items2">
                                    <div class="careerum-cons-tariff-item2 active careerum-cons-tariff-item"
                                        data-EUR-amount="3 325 €" data-RUB-amount="199 500 ₽" data-link="#1">
                                        <p class="careerum-cons-tariff-item-header-2">5 консультаций</p>
                                        <p>Работа с ограничивающими<br> установками и создание стратегии для решения одного
                                            карьерного запроса</p>
                                        <div>
                                            <p class="careerum-cons-tariff-item-amount">
                                                199 500 ₽
                                            </p>
                                            <p>
    
                                            </p>
                                        </div>
                                    </div>
                                    <div class="careerum-cons-tariff-item2 careerum-cons-tariff-item"
                                        data-EUR-amount="5 990 €" data-RUB-amount="359 500 ₽" data-link="#2">
                                        <p class="careerum-cons-tariff-item-header-2">10 консультаций</p>
                                        <p>Глубокая проработка актуальных карьерных запросов и создание четкого плана
                                            достижения целей</p>
                                        <div>
                                            <p class="careerum-cons-tariff-item-amount">
                                                359 500 ₽
                                            </p>
                                            <p>
    
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div class="careerum-cons-tariff-links">
                                    <a href="#" class="btn-color-main-dark-orange">Купить</a>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-consult-tariff-tab-dropdown-link">
                                    <p>Что произойдет после оплаты?</p>
                                    <div>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676880597683.svg" alt="">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676880662948.svg" alt="">
                                    </div>
                                </div>
                                <div>
                                    <div>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676880714623.svg" alt="">
                                        <p>Мы пришлем календарь записи, чтобы вы могли выбрать время<br> и забронировать
                                            сессию.</p>
                                    </div>
                                    <div>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676880770344.svg" alt="">
                                        <p>Заполните анкету, которая придет в том же письме. Она поможет Ольге лучше понять
                                            вашу ситуацию.</p>
                                    </div>
                                    <div>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676880774640.svg" alt="">
                                        <p>Мы напомним о времени записи по электронной<br> почте: за 24 часа и за 1 час<br>
                                            до начала сессии.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="careerum-consult-tariff-tab" data-tab-name="Расти на рабочем месте">
                            <div>
                                <div class="careerum-consult-tariff-tab-item-header">
                                    <div>
                                        <p class="careerum-cons-tariff-item-header-1">Построите эффективную карьерную
                                            стратегию, которая<br> приведет вас к повышению в должности и в доходе</p>
                                    </div>
                                </div>
                                <div class="careerum-cons-tariff-switcher-items2">
                                    <div class="careerum-cons-tariff-item2 active careerum-cons-tariff-item"
                                        data-EUR-amount="3 325 €" data-RUB-amount="199 500 ₽" data-link="#1">
                                        <p class="careerum-cons-tariff-item-header-2">5 консультаций</p>
                                        <p>Работа с ограничивающими<br> установками и создание стратегии для решения одного
                                            карьерного запроса</p>
                                        <div>
                                            <p class="careerum-cons-tariff-item-amount">
                                                199 500 ₽
                                            </p>
                                            <p>
    
                                            </p>
                                        </div>
                                    </div>
                                    <div class="careerum-cons-tariff-item2 careerum-cons-tariff-item"
                                        data-EUR-amount="5 990 €" data-RUB-amount="359 500 ₽" data-link="#2">
                                        <p class="careerum-cons-tariff-item-header-2">10 консультаций</p>
                                        <p>Глубокая проработка актуальных карьерных запросов и создание четкого плана
                                            достижения целей</p>
                                        <div>
                                            <p class="careerum-cons-tariff-item-amount">
                                                359 500 ₽
                                            </p>
                                            <p>
    
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div class="careerum-cons-tariff-links">
                                    <a href="#" class="btn-color-main-dark-orange">Купить</a>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-consult-tariff-tab-dropdown-link">
                                    <p>Что произойдет после оплаты?</p>
                                    <div>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676880597683.svg" alt="">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676880662948.svg" alt="">
                                    </div>
                                </div>
                                <div>
                                    <div>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676880714623.svg" alt="">
                                        <p>Мы пришлем календарь записи, чтобы вы могли выбрать время<br> и забронировать
                                            сессию.</p>
                                    </div>
                                    <div>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676880770344.svg" alt="">
                                        <p>Заполните анкету, которая придет в том же письме. Она поможет Ольге лучше понять
                                            вашу ситуацию.</p>
                                    </div>
                                    <div>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676880774640.svg" alt="">
                                        <p>Мы напомним о времени записи по электронной<br> почте: за 24 часа и за 1 час<br>
                                            до начала сессии.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="careerum-consult-tariff-tab" data-tab-name="Повысить доход">
                            <div>
                                <div class="careerum-consult-tariff-tab-item-header">
                                    <div>
                                        <p class="careerum-cons-tariff-item-header-1">Узнаете, как двигаться в карьере и
                                            какие проекты<br> выбирать, чтобы повышать свой доход</p>
                                    </div>
                                </div>
                                <div class="careerum-cons-tariff-switcher-items2">
                                    <div class="careerum-cons-tariff-item2 active careerum-cons-tariff-item"
                                        data-EUR-amount="3 325 €" data-RUB-amount="199 500 ₽" data-link="#1">
                                        <p class="careerum-cons-tariff-item-header-2">5 консультаций</p>
                                        <p>Работа с ограничивающими<br> установками и создание стратегии для решения одного
                                            карьерного запроса</p>
                                        <div>
                                            <p class="careerum-cons-tariff-item-amount">
                                                199 500 ₽
                                            </p>
                                            <p>
    
                                            </p>
                                        </div>
                                    </div>
                                    <div class="careerum-cons-tariff-item2 careerum-cons-tariff-item"
                                        data-EUR-amount="5 990 €" data-RUB-amount="359 500 ₽" data-link="#2">
                                        <p class="careerum-cons-tariff-item-header-2">10 консультаций</p>
                                        <p>Глубокая проработка актуальных карьерных запросов и создание четкого плана
                                            достижения целей</p>
                                        <div>
                                            <p class="careerum-cons-tariff-item-amount">
                                                359 500 ₽
                                            </p>
                                            <p>
    
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div class="careerum-cons-tariff-links">
                                    <a href="#" class="btn-color-main-dark-orange">Купить</a>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-consult-tariff-tab-dropdown-link">
                                    <p>Что произойдет после оплаты?</p>
                                    <div>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676880597683.svg" alt="">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676880662948.svg" alt="">
                                    </div>
                                </div>
                                <div>
                                    <div>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676880714623.svg" alt="">
                                        <p>Мы пришлем календарь записи, чтобы вы могли выбрать время<br> и забронировать
                                            сессию.</p>
                                    </div>
                                    <div>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676880770344.svg" alt="">
                                        <p>Заполните анкету, которая придет в том же письме. Она поможет Ольге лучше понять
                                            вашу ситуацию.</p>
                                    </div>
                                    <div>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676880774640.svg" alt="">
                                        <p>Мы напомним о времени записи по электронной<br> почте: за 24 часа и за 1 час<br>
                                            до начала сессии.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="careerum-consult-tariff-tab" data-tab-name="Найти work-life balance">
                            <div>
                                <div class="careerum-consult-tariff-tab-item-header">
                                    <div>
                                        <p class="careerum-cons-tariff-item-header-1">Освоите инструменты, которые помогут
                                            «не только<br> работать, но и жить» без ущерба личной жизни</p>
                                    </div>
                                </div>
                                <div class="careerum-cons-tariff-switcher-items2">
                                    <div class="careerum-cons-tariff-item2 active careerum-cons-tariff-item"
                                        data-EUR-amount="3 325 €" data-RUB-amount="199 500 ₽" data-link="#1">
                                        <p class="careerum-cons-tariff-item-header-2">5 консультаций</p>
                                        <p>Работа с ограничивающими<br> установками и создание стратегии для решения одного
                                            карьерного запроса</p>
                                        <div>
                                            <p class="careerum-cons-tariff-item-amount">
                                                199 500 ₽
                                            </p>
                                            <p>
    
                                            </p>
                                        </div>
                                    </div>
                                    <div class="careerum-cons-tariff-item2 careerum-cons-tariff-item"
                                        data-EUR-amount="5 990 €" data-RUB-amount="359 500 ₽" data-link="#2">
                                        <p class="careerum-cons-tariff-item-header-2">10 консультаций</p>
                                        <p>Глубокая проработка актуальных карьерных запросов и создание четкого плана
                                            достижения целей</p>
                                        <div>
                                            <p class="careerum-cons-tariff-item-amount">
                                                359 500 ₽
                                            </p>
                                            <p>
    
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div class="careerum-cons-tariff-links">
                                    <a href="#" class="btn-color-main-dark-orange">Купить</a>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-consult-tariff-tab-dropdown-link">
                                    <p>Что произойдет после оплаты?</p>
                                    <div>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676880597683.svg" alt="">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676880662948.svg" alt="">
                                    </div>
                                </div>
                                <div>
                                    <div>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676880714623.svg" alt="">
                                        <p>Мы пришлем календарь записи, чтобы вы могли выбрать время<br> и забронировать
                                            сессию.</p>
                                    </div>
                                    <div>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676880770344.svg" alt="">
                                        <p>Заполните анкету, которая придет в том же письме. Она поможет Ольге лучше понять
                                            вашу ситуацию.</p>
                                    </div>
                                    <div>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676880774640.svg" alt="">
                                        <p>Мы напомним о времени записи по электронной<br> почте: за 24 часа и за 1 час<br>
                                            до начала сессии.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="careerum-consult-tariff-tab" data-tab-name="Подготовиться к интервью">
                            <div>
                                <div class="careerum-consult-tariff-tab-item-header">
                                    <div>
                                    </div>
                                </div>
                                <div class="careerum-cons-tariff-switcher-items1">
                                    <div class="careerum-cons-tariff-item1 careerum-cons-tariff-item"
                                        data-EUR-amount="499 €" data-RUB-amount="29 900 ₽" data-link="#1">
                                        <p class="careerum-cons-tariff-item-header-1">Курс + консультация</p>
                                        <p>Научитесь мастерски проходить интервью и отвечать даже на самые сложные вопросы.
                                        </p>
                                        <div>
                                            <p class="careerum-cons-tariff-item-amount">
    
                                            </p>
                                            <p>
    
                                            </p>
                                        </div>
                                        <a href="#" class="btn-color-main-dark-orange">Купить</a>
                                    </div>
                                    <div class="careerum-course-tab-item">
                                        <div>
                                            <p>Курс</p>
                                            <p>2 часа 16 мин.</p>
                                        </div>
                                        <h3>Эффективное интервью</h3>
                                        <p>Поймете, как выгодно подать себя на интервью, и научитесь отвечать даже на самые
                                            сложные вопросы рекрутера</p>
                                    </div>
                                    <div class="careerum-course-tab-item">
                                        <div>
                                            <p>Консультация</p>
                                            <p>50 мин.</p>
                                        </div>
                                        <h3>Консультация</h3>
                                        <p>Ольга даст вам точные рекомендации и поможет найти более эффективные способы
                                            прохождения интервью</p>
                                    </div>
                                </div>
                                <div class="careerum-cons-tariff-links">
                                </div>
                            </div>
                            <div>
                                <div class="careerum-consult-tariff-tab-dropdown-link">
                                    <p>Что произойдет после оплаты?</p>
                                    <div>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676880597683.svg" alt="">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676880662948.svg" alt="">
                                    </div>
                                </div>
                                <div>
                                    <div>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676880714623.svg" alt="">
                                        <p>Мы пришлем календарь записи, чтобы вы могли выбрать время<br> и забронировать
                                            сессию.</p>
                                    </div>
                                    <div>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676880770344.svg" alt="">
                                        <p>Заполните анкету, которая придет в том же письме. Она поможет Ольге лучше понять
                                            вашу ситуацию.</p>
                                    </div>
                                    <div>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676880774640.svg" alt="">
                                        <p>Мы напомним о времени записи по электронной<br> почте: за 24 часа и за 1 час<br>
                                            до начала сессии.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="careerum-consult-tariff-tab" data-tab-name="Стать сильным лидером">
                            <div>
                                <div class="careerum-consult-tariff-tab-item-header">
                                    <div>
                                        <p class="careerum-cons-tariff-item-header-1">Построите гармоничную стратегию
                                            управления, с учетом<br> именно ваших лидерских качеств</p>
                                    </div>
                                </div>
                                <div class="careerum-cons-tariff-switcher-items2">
                                    <div class="careerum-cons-tariff-item2 active careerum-cons-tariff-item"
                                        data-EUR-amount="3 325 €" data-RUB-amount="199 500 ₽" data-link="#1">
                                        <p class="careerum-cons-tariff-item-header-2">5 консультаций</p>
                                        <p>Работа с ограничивающими<br> установками и создание стратегии для решения одного
                                            карьерного запроса</p>
                                        <div>
                                            <p class="careerum-cons-tariff-item-amount">
                                                199 500 ₽
                                            </p>
                                            <p>
    
                                            </p>
                                        </div>
                                    </div>
                                    <div class="careerum-cons-tariff-item2 careerum-cons-tariff-item"
                                        data-EUR-amount="5 990 €" data-RUB-amount="359 500 ₽" data-link="#2">
                                        <p class="careerum-cons-tariff-item-header-2">10 консультаций</p>
                                        <p>Глубокая проработка актуальных карьерных запросов и создание четкого плана
                                            достижения целей</p>
                                        <div>
                                            <p class="careerum-cons-tariff-item-amount">
                                                359 500 ₽
                                            </p>
                                            <p>
    
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div class="careerum-cons-tariff-links">
                                    <a href="#" class="btn-color-main-dark-orange">Купить</a>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-consult-tariff-tab-dropdown-link">
                                    <p>Что произойдет после оплаты?</p>
                                    <div>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676880597683.svg" alt="">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676880662948.svg" alt="">
                                    </div>
                                </div>
                                <div>
                                    <div>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676880714623.svg" alt="">
                                        <p>Мы пришлем календарь записи, чтобы вы могли выбрать время<br> и забронировать
                                            сессию.</p>
                                    </div>
                                    <div>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676880770344.svg" alt="">
                                        <p>Заполните анкету, которая придет в том же письме. Она поможет Ольге лучше понять
                                            вашу ситуацию.</p>
                                    </div>
                                    <div>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676880774640.svg" alt="">
                                        <p>Мы напомним о времени записи по электронной<br> почте: за 24 часа и за 1 час<br>
                                            до начала сессии.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="careerum-consult-tariff-tab" data-tab-name="Начать и вести свой бизнес">
                            <div>
                                <div class="careerum-consult-tariff-tab-item-header">
                                    <div>
                                        <p class="careerum-cons-tariff-item-header-1">Разберетесь со страхами и найдете
                                            опоры, которые<br> помогут поэтапно построить крепкий бизнес<br> и развивать его
                                        </p>
                                    </div>
                                </div>
                                <div class="careerum-cons-tariff-switcher-items2">
                                    <div class="careerum-cons-tariff-item2 active careerum-cons-tariff-item"
                                        data-EUR-amount="3 325 €" data-RUB-amount="199 500 ₽" data-link="#1">
                                        <p class="careerum-cons-tariff-item-header-2">5 консультаций</p>
                                        <p>Работа с ограничивающими<br> установками и создание стратегии для решения одного
                                            карьерного запроса</p>
                                        <div>
                                            <p class="careerum-cons-tariff-item-amount">
                                                199 500 ₽
                                            </p>
                                            <p>
    
                                            </p>
                                        </div>
                                    </div>
                                    <div class="careerum-cons-tariff-item2 careerum-cons-tariff-item"
                                        data-EUR-amount="5 990 €" data-RUB-amount="359 500 ₽" data-link="#2">
                                        <p class="careerum-cons-tariff-item-header-2">10 консультаций</p>
                                        <p>Глубокая проработка актуальных карьерных запросов и создание четкого плана
                                            достижения целей</p>
                                        <div>
                                            <p class="careerum-cons-tariff-item-amount">
                                                359 500 ₽
                                            </p>
                                            <p>
    
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div class="careerum-cons-tariff-links">
                                    <a href="#" class="btn-color-main-dark-orange">Купить</a>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-consult-tariff-tab-dropdown-link">
                                    <p>Что произойдет после оплаты?</p>
                                    <div>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676880597683.svg" alt="">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676880662948.svg" alt="">
                                    </div>
                                </div>
                                <div>
                                    <div>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676880714623.svg" alt="">
                                        <p>Мы пришлем календарь записи, чтобы вы могли выбрать время<br> и забронировать
                                            сессию.</p>
                                    </div>
                                    <div>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676880770344.svg" alt="">
                                        <p>Заполните анкету, которая придет в том же письме. Она поможет Ольге лучше понять
                                            вашу ситуацию.</p>
                                    </div>
                                    <div>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676880774640.svg" alt="">
                                        <p>Мы напомним о времени записи по электронной<br> почте: за 24 часа и за 1 час<br>
                                            до начала сессии.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="careerum-consult-tariff-tab" data-tab-name="Поступить на программу MBA">
                            <div>
                                <div class="careerum-consult-tariff-tab-item-header">
                                    <div>
                                        <p class="careerum-cons-tariff-item-header-1">Получите пошаговый план подготовки
                                            к поступлению<br> на MBA, узнаете о подводных камнях и выработаете<br> пошаговую
                                            стратегию </p>
                                    </div>
                                </div>
                                <div class="careerum-cons-tariff-switcher-items2">
                                    <div class="careerum-cons-tariff-item2 active careerum-cons-tariff-item careerum-cons-tariff-item3"
                                        data-EUR-amount="3 330 €" data-RUB-amount="200 000 ₽" data-link="#1">
                                        <p class="careerum-cons-tariff-item-header-2">Разбор школы</p>
    
                                        <div>
                                            <p class="careerum-cons-tariff-item-amount">
                                                199 500 ₽
                                            </p>
                                            <p>
    
                                            </p>
                                        </div>
                                    </div>
                                    <div class="careerum-cons-tariff-item2 careerum-cons-tariff-item careerum-cons-tariff-item3"
                                        data-EUR-amount="6 515 €" data-RUB-amount="390 900 ₽" data-link="#2">
                                        <p class="careerum-cons-tariff-item-header-2">Разбор 2–3 школ</p>
    
                                        <div>
                                            <p class="careerum-cons-tariff-item-amount">
                                                359 500 ₽
                                            </p>
                                            <p>
    
                                            </p>
                                        </div>
                                    </div>
                                    <div class="careerum-cons-tariff-item2 careerum-cons-tariff-item careerum-cons-tariff-item3"
                                        data-EUR-amount="499 €" data-RUB-amount="29 900 ₽" data-link="#3">
                                        <p class="careerum-cons-tariff-item-header-2">Оценка профиля</p>
    
                                        <p>Последовательный поиск решения в любой ситуации</p>
                                        <div>
                                            <p class="careerum-cons-tariff-item-amount">
                                                359 500 ₽
                                            </p>
                                            <p>
    
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div class="careerum-cons-tariff-links">
                                    <a href="#" class="btn-color-main-dark-orange">Купить</a>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-consult-tariff-tab-dropdown-link">
                                    <p>Что произойдет после оплаты?</p>
                                    <div>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676880597683.svg" alt="">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676880662948.svg" alt="">
                                    </div>
                                </div>
                                <div>
                                    <div>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676880714623.svg" alt="">
                                        <p>Мы пришлем календарь записи, чтобы вы могли выбрать время<br> и забронировать
                                            сессию.</p>
                                    </div>
                                    <div>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676880770344.svg" alt="">
                                        <p>Заполните анкету, которая придет в том же письме. Она поможет Ольге лучше понять
                                            вашу ситуацию.</p>
                                    </div>
                                    <div>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676880774640.svg" alt="">
                                        <p>Мы напомним о времени записи по электронной<br> почте: за 24 часа и за 1 час<br>
                                            до начала сессии.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div></div>
            </div>
        </div>`
	});

    blockManager.add('careerum-cons-tariff-block-tablet', {
        label: 'Консультации витрина (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-cons-tariff-block-tablet">
            <div>
                <div class="careerum-cons-tariff-header">
                    <h2>Выберите ваш запрос</h2>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676880909808.svg" alt="">
                </div>
                <div>
                    <div class="careerum-consult-tariff-menu">
                    </div>
                    <div class="careerum-consult-tariff-tabs">
                        <div class="careerum-cons-currency-switcher">
                            <div>
                                <p class="careerum-cons-currency-header">RUB</p>
                                <div class="careerum-cons-currency-dropdown">
                                    <p data-cons-currency="EUR" class="careerum-cons-currency-dropdown-item">EUR</p>
                                    <p data-cons-currency="RUB" class="careerum-cons-currency-dropdown-item">RUB</p>
                                </div>
                            </div>
                        </div>
                        <div class="careerum-consult-tariff-tab" data-tab-name="Понять, куда двигаться">
                            <div>
                                <div class="careerum-cons-tariff-switcher-curr">
                                    <div>
                                        <p class="careerum-cons-tariff-item-header-1">Избавитесь от установок, которые блокируют ваше продвижение. Найдете свои таланты и построите карьерную<br> стратегию</p>
                                    </div>
                                </div>
                                <div class="careerum-cons-tariff-switcher-items2">
                                    <div class="careerum-cons-tariff-item2 active careerum-cons-tariff-item"
                                    data-EUR-amount="3 325 €" data-RUB-amount="199 600 ₽" data-link="#1">
                                        <p class="careerum-cons-tariff-item-header-2">5 консультаций</p>
                                        <p>Работа с ограничивающими установками<br> и создание стратегии для решения<br> одного карьерного запроса</p>
                                        <div>
                                            <p class="careerum-cons-tariff-item-amount">
                                                199 500 ₽ 
                                            </p>
                                        </div>
                                    </div>
                                    <div class="careerum-cons-tariff-item2 careerum-cons-tariff-item" data-EUR-amount="5 990 €" data-RUB-amount="359 500 ₽" data-link="#2">
                                        <p class="careerum-cons-tariff-item-header-2">10 консультаций</p>
                                        <p>Глубокая проработка актуальных карьерных запросов и создание четкого плана достижения целей</p>
                                        <div>
                                            <p class="careerum-cons-tariff-item-amount">
                                                359 500 ₽
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div class="careerum-cons-tariff-links">
                                    <p class="careerum-cons-tariff-item-amount-total">199 500 ₽</p>
                                    <a href="#" class="btn-color-main-dark-orange">Купить</a>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-consult-tariff-tab-dropdown-link">
                                    <p>Что произойдет после оплаты?</p>
                                    <div>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676880934846.svg" alt="">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676880976840.svg" alt="">
                                    </div>
                                </div>
                                <div>
                                    <div>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676880984647.svg" alt="">
                                        <p>Мы пришлем календарь записи, чтобы вы могли выбрать время и забронировать сессию.</p>
                                    </div>
                                    <div>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676880986449.svg" alt="">
                                        <p>Заполните анкету, которая придет в том же письме. Она поможет Ольге лучше понять вашу ситуацию.</p>
                                    </div>
                                    <div>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676880988664.svg" alt="">
                                        <p>Мы напомним о времени записи <br>по электронной почте: за 24 часа и за 1 час<br> до начала сессии.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="careerum-consult-tariff-tab" data-tab-name="Расти на рабочем месте">
                            <div>
                                <div class="careerum-cons-tariff-switcher-curr">
                                    <div>
                                        <p class="careerum-cons-tariff-item-header-1">Построите эффективную карьерную стратегию, которая приведет вас к повышению в должности и в доходе</p>
                                    </div>
                                </div>
                                <div class="careerum-cons-tariff-switcher-items2">
                                    <div class="careerum-cons-tariff-item2 active careerum-cons-tariff-item"
                                    data-EUR-amount="3 325 €" data-RUB-amount="199 500 ₽" data-link="#3">
                                        <p class="careerum-cons-tariff-item-header-2">5 консультаций</p>
                                        <p>Работа с ограничивающими<br> установками и создание стратегии для решения одного карьерного запроса</p>
                                        <div>
                                            <p class="careerum-cons-tariff-item-amount">
                                                199 500 ₽ 
                                            </p>
                                            <p>
                                                
                                            </p>
                                        </div>
                                    </div>
                                    <div class="careerum-cons-tariff-item2 careerum-cons-tariff-item" data-EUR-amount="5 990 €" data-RUB-amount="359 500 ₽" data-link="#4">
                                        <p class="careerum-cons-tariff-item-header-2">10 консультаций</p>
                                        <p>Глубокая проработка актуальных карьерных запросов и создание четкого плана достижения целей</p>
                                        <div>
                                            <p class="careerum-cons-tariff-item-amount">
                                                359 500 ₽
                                            </p>
                                            <p>
                                                
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div class="careerum-cons-tariff-links">
                                    <p class="careerum-cons-tariff-item-amount-total">199 500 ₽</p>
                                    <a href="#" class="btn-color-main-dark-orange">Купить</a>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-consult-tariff-tab-dropdown-link">
                                    <p>Что произойдет после оплаты?</p>
                                    <div>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676880934846.svg" alt="">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676880976840.svg" alt="">
                                    </div>
                                </div>
                                <div>
                                    <div>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676880984647.svg" alt="">
                                        <p>Мы пришлем календарь записи, чтобы вы могли выбрать время<br> и забронировать сессию.</p>
                                    </div>
                                    <div>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676880986449.svg" alt="">
                                        <p>Заполните анкету, которая придет в том же письме. Она поможет Ольге лучше понять вашу ситуацию.</p>
                                    </div>
                                    <div>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676880988664.svg" alt="">
                                        <p>Мы напомним о времени записи по электронной<br> почте: за 24 часа и за 1 час<br> до начала сессии.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="careerum-consult-tariff-tab" data-tab-name="Повысить доход">
                            <div>
                                <div class="careerum-cons-tariff-switcher-curr">
                                    <div>
                                        <p class="careerum-cons-tariff-item-header-1">Узнаете, как двигаться в карьере и какие проекты выбирать, чтобы повышать<br> свой доход</p>
                                    </div>
                                </div>
                                <div class="careerum-cons-tariff-switcher-items2">
                                    <div class="careerum-cons-tariff-item2 active careerum-cons-tariff-item"
                                    data-EUR-amount="3 325 €" data-RUB-amount="199 500 ₽" data-link="#1">
                                        <p class="careerum-cons-tariff-item-header-2">5 консультаций</p>
                                        <p>Работа с ограничивающими<br> установками и создание стратегии для решения одного карьерного запроса</p>
                                        <div>
                                            <p class="careerum-cons-tariff-item-amount">
                                                199 500 ₽ 
                                            </p>
                                            <p>
                                                
                                            </p>
                                        </div>
                                    </div>
                                    <div class="careerum-cons-tariff-item2 careerum-cons-tariff-item" data-EUR-amount="5 990 €" data-RUB-amount="359 500 ₽" data-link="#2">
                                        <p class="careerum-cons-tariff-item-header-2">10 консультаций</p>
                                        <p>Глубокая проработка актуальных карьерных запросов и создание четкого плана достижения целей</p>
                                        <div>
                                            <p class="careerum-cons-tariff-item-amount">
                                                359 500 ₽
                                            </p>
                                            <p>
                                                
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div class="careerum-cons-tariff-links">
                                    <p class="careerum-cons-tariff-item-amount-total">199 500 ₽</p>
                                    <a href="#" class="btn-color-main-dark-orange">Купить</a>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-consult-tariff-tab-dropdown-link">
                                    <p>Что произойдет после оплаты?</p>
                                    <div>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676880934846.svg" alt="">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676880976840.svg" alt="">
                                    </div>
                                </div>
                                <div>
                                    <div>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676880984647.svg" alt="">
                                        <p>Мы пришлем календарь записи, чтобы вы могли выбрать время<br> и забронировать сессию.</p>
                                    </div>
                                    <div>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676880986449.svg" alt="">
                                        <p>Заполните анкету, которая придет в том же письме. Она поможет Ольге лучше понять вашу ситуацию.</p>
                                    </div>
                                    <div>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676880988664.svg" alt="">
                                        <p>Мы напомним о времени записи по электронной<br> почте: за 24 часа и за 1 час<br> до начала сессии.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="careerum-consult-tariff-tab" data-tab-name="Найти work-life balance">
                            <div>
                                <div class="careerum-cons-tariff-switcher-curr">
                                    <div>
                                        <p class="careerum-cons-tariff-item-header-1">Освоите инструменты, которые помогут<br> «не только работать, но и жить» без ущерба личной жизни</p>
                                    </div>
                                </div>
                                <div class="careerum-cons-tariff-switcher-items2">
                                    <div class="careerum-cons-tariff-item2 active careerum-cons-tariff-item"
                                    data-EUR-amount="3 325 €" data-RUB-amount="199 500 ₽" data-link="#1">
                                        <p class="careerum-cons-tariff-item-header-2">5 консультаций</p>
                                        <p>Работа с ограничивающими<br> установками и создание стратегии для решения одного карьерного запроса</p>
                                        <div>
                                            <p class="careerum-cons-tariff-item-amount">
                                                199 500 ₽ 
                                            </p>
                                            <p>
                                                
                                            </p>
                                        </div>
                                    </div>
                                    <div class="careerum-cons-tariff-item2 careerum-cons-tariff-item" data-EUR-amount="5 990 €" data-RUB-amount="359 500 ₽" data-link="#2">
                                        <p class="careerum-cons-tariff-item-header-2">10 консультаций</p>
                                        <p>Глубокая проработка актуальных карьерных запросов и создание четкого плана достижения целей</p>
                                        <div>
                                            <p class="careerum-cons-tariff-item-amount">
                                                359 500 ₽
                                            </p>
                                            <p>
                                                
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div class="careerum-cons-tariff-links">
                                    <p class="careerum-cons-tariff-item-amount-total">199 500 ₽</p>
                                    <a href="#" class="btn-color-main-dark-orange">Купить</a>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-consult-tariff-tab-dropdown-link">
                                    <p>Что произойдет после оплаты?</p>
                                    <div>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676880934846.svg" alt="">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676880976840.svg" alt="">
                                    </div>
                                </div>
                                <div>
                                    <div>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676880984647.svg" alt="">
                                        <p>Мы пришлем календарь записи, чтобы вы могли выбрать время<br> и забронировать сессию.</p>
                                    </div>
                                    <div>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676880986449.svg" alt="">
                                        <p>Заполните анкету, которая придет в том же письме. Она поможет Ольге лучше понять вашу ситуацию.</p>
                                    </div>
                                    <div>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676880988664.svg" alt="">
                                        <p>Мы напомним о времени записи по электронной<br> почте: за 24 часа и за 1 час<br> до начала сессии.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="careerum-consult-tariff-tab" data-tab-name="Подготовиться к интервью">
                            <div>
                                <div class="careerum-cons-tariff-switcher-curr">
                                    <div>
                                    </div>
                                </div>
                                <div class="careerum-cons-tariff-switcher-items1">
                                    <div class="careerum-cons-tariff-item1 careerum-cons-tariff-item"
                                    data-EUR-amount="499 €" data-RUB-amount="29 900 ₽" data-link="#1">
                                        <p class="careerum-cons-tariff-item-header-1">Курс + консультация</p>
                                        <p>Научитесь мастерски проходить<br> интервью и отвечать даже на самые <br>сложные вопросы.</p>
                                        <div>
                                            <div>
                                                <div class="careerum-course-tab-item-tablet">
                                                    <div>  
                                                        <p>Курс</p>
                                                        <p>2 часа 16 мин.</p>
                                                    </div>  
                                                    <h3>Эффективное интервью</h3>
                                                    <p>Поймете, как выгодно подать себя на интервью, и научитесь отвечать даже на самые сложные вопросы рекрутера</p>
                                                </div>
                                                <div class="careerum-course-tab-item-tablet">
                                                    <div>  
                                                        <p>Консультация</p>
                                                        <p>50 мин.</p>
                                                    </div>  
                                                    <h3>Консультация</h3>
                                                    <p>Ольга даст вам точные рекомендации и поможет найти более эффективные способы прохождения интервью</p>
                                                </div>
                                            </div>
                                            <p>
                                                
                                            </p>
                                        </div>
                                        <p class="careerum-cons-tariff-item-amount">
                                             
                                        </p>
                                        <a href="#" class="btn-color-main-dark-orange">Купить</a>
                                    </div>
                                    
                                </div>
                                <div class="careerum-cons-tariff-links">
                                </div>
                            </div>
                            <div>
                                <div class="careerum-consult-tariff-tab-dropdown-link">
                                    <p>Что произойдет после оплаты?</p>
                                    <div>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676880934846.svg" alt="">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676880976840.svg" alt="">
                                    </div>
                                </div>
                                <div>
                                    <div>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676880984647.svg" alt="">
                                        <p>Мы пришлем календарь записи, чтобы вы могли выбрать время<br> и забронировать сессию.</p>
                                    </div>
                                    <div>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676880986449.svg" alt="">
                                        <p>Заполните анкету, которая придет в том же письме. Она поможет Ольге лучше понять вашу ситуацию.</p>
                                    </div>
                                    <div>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676880988664.svg" alt="">
                                        <p>Мы напомним о времени записи по электронной<br> почте: за 24 часа и за 1 час<br> до начала сессии.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="careerum-consult-tariff-tab" data-tab-name="Стать сильным лидером">
                            <div>
                                <div class="careerum-cons-tariff-switcher-curr">
                                    <div>
                                        <p class="careerum-cons-tariff-item-header-1">Построите гармоничную стратегию<br> управления, с учетом именно ваших<br> лидерских качеств</p>
                                    </div>
                                </div>
                                <div class="careerum-cons-tariff-switcher-items2">
                                    <div class="careerum-cons-tariff-item2 active careerum-cons-tariff-item"
                                    data-EUR-amount="3 325 €" data-RUB-amount="199 500 ₽" data-link="#1">
                                        <p class="careerum-cons-tariff-item-header-2">5 консультаций</p>
                                        <p>Работа с ограничивающими<br> установками и создание стратегии для решения одного карьерного запроса</p>
                                        <div>
                                            <p class="careerum-cons-tariff-item-amount">
                                                199 500 ₽ 
                                            </p>
                                            <p>
                                                
                                            </p>
                                        </div>
                                    </div>
                                    <div class="careerum-cons-tariff-item2 careerum-cons-tariff-item" data-EUR-amount="5 990 €" data-RUB-amount="359 500 ₽" data-link="#2">
                                        <p class="careerum-cons-tariff-item-header-2">10 консультаций</p>
                                        <p>Глубокая проработка актуальных карьерных запросов и создание четкого плана достижения целей</p>
                                        <div>
                                            <p class="careerum-cons-tariff-item-amount">
                                                359 500 ₽
                                            </p>
                                            <p>
                                                
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div class="careerum-cons-tariff-links">
                                    <p class="careerum-cons-tariff-item-amount-total">199 500 ₽</p>
                                    <a href="#" class="btn-color-main-dark-orange">Купить</a>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-consult-tariff-tab-dropdown-link">
                                    <p>Что произойдет после оплаты?</p>
                                    <div>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676880934846.svg" alt="">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676880976840.svg" alt="">
                                    </div>
                                </div>
                                <div>
                                    <div>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676880984647.svg" alt="">
                                        <p>Мы пришлем календарь записи, чтобы вы могли выбрать время<br> и забронировать сессию.</p>
                                    </div>
                                    <div>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676880986449.svg" alt="">
                                        <p>Заполните анкету, которая придет в том же письме. Она поможет Ольге лучше понять вашу ситуацию.</p>
                                    </div>
                                    <div>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676880988664.svg" alt="">
                                        <p>Мы напомним о времени записи по электронной<br> почте: за 24 часа и за 1 час<br> до начала сессии.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="careerum-consult-tariff-tab" data-tab-name="Начать и вести свой бизнес">
                            <div>
                                <div class="careerum-cons-tariff-switcher-curr">
                                    <div>
                                        <p class="careerum-cons-tariff-item-header-1">Разберетесь со страхами и найдете<br> опоры, которые помогут поэтапно построить крепкий бизнес <br>и развивать его</p>
                                    </div>
                                </div>
                                <div class="careerum-cons-tariff-switcher-items2">
                                    <div class="careerum-cons-tariff-item2 active careerum-cons-tariff-item"
                                    data-EUR-amount="3 325 €" data-RUB-amount="199 500 ₽" data-link="#1">
                                        <p class="careerum-cons-tariff-item-header-2">5 консультаций</p>
                                        <p>Работа с ограничивающими<br> установками и создание стратегии для решения одного карьерного запроса</p>
                                        <div>
                                            <p class="careerum-cons-tariff-item-amount">
                                                199 500 ₽ 
                                            </p>
                                            <p>
                                                
                                            </p>
                                        </div>
                                    </div>
                                    <div class="careerum-cons-tariff-item2 careerum-cons-tariff-item" data-EUR-amount="5 990 €" data-RUB-amount="359 500 ₽" data-link="#2">
                                        <p class="careerum-cons-tariff-item-header-2">10 консультаций</p>
                                        <p>Глубокая проработка актуальных карьерных запросов и создание четкого плана достижения целей</p>
                                        <div>
                                            <p class="careerum-cons-tariff-item-amount">
                                                359 500 ₽
                                            </p>
                                            <p>
                                                
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div class="careerum-cons-tariff-links">
                                    <p class="careerum-cons-tariff-item-amount-total">199 500 ₽</p>
                                    <a href="#" class="btn-color-main-dark-orange">Купить</a>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-consult-tariff-tab-dropdown-link">
                                    <p>Что произойдет после оплаты?</p>
                                    <div>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676880934846.svg" alt="">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676880976840.svg" alt="">
                                    </div>
                                </div>
                                <div>
                                    <div>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676880984647.svg" alt="">
                                        <p>Мы пришлем календарь записи, чтобы вы могли выбрать время<br> и забронировать сессию.</p>
                                    </div>
                                    <div>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676880986449.svg" alt="">
                                        <p>Заполните анкету, которая придет в том же письме. Она поможет Ольге лучше понять вашу ситуацию.</p>
                                    </div>
                                    <div>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676880988664.svg" alt="">
                                        <p>Мы напомним о времени записи по электронной<br> почте: за 24 часа и за 1 час<br> до начала сессии.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="careerum-consult-tariff-tab" data-tab-name="Поступить на программу MBA">
                            <div>
                                <div class="careerum-cons-tariff-switcher-curr">
                                    <div>
                                        <p class="careerum-cons-tariff-item-header-1">Получите пошаговый план подготовки к поступлению на MBA, узнаете<br> о подводных камнях и выработаете пошаговую стратегию </p>
                                    </div>
                                </div>
                                <div class="careerum-cons-tariff-switcher-items2">
                                    <div class="careerum-cons-tariff-item2 active careerum-cons-tariff-item careerum-cons-tariff-item3"
                                    data-EUR-amount="3 330 €" data-RUB-amount="200 000 ₽" data-link="#1">
                                        <p class="careerum-cons-tariff-item-header-2">Разбор школы</p>
                                        
                                        <div>
                                            <p class="careerum-cons-tariff-item-amount">
                                                199 500 ₽ 
                                            </p>
                                            <p>
                                                
                                            </p>
                                        </div>
                                    </div>
                                    <div class="careerum-cons-tariff-item2 careerum-cons-tariff-item careerum-cons-tariff-item3" data-EUR-amount="6 515 €" data-RUB-amount="390 900 ₽" data-link="#2">
                                        <p class="careerum-cons-tariff-item-header-2">Разбор 2–3 школ</p>
                                        
                                        <div>
                                            <p class="careerum-cons-tariff-item-amount">
                                                359 500 ₽
                                            </p>
                                            <p>
                                                
                                            </p>
                                        </div>
                                    </div>
                                    <div class="careerum-cons-tariff-item2 careerum-cons-tariff-item careerum-cons-tariff-item3" data-EUR-amount="499 €" data-RUB-amount="29 900 ₽" data-link="#3">
                                        <p class="careerum-cons-tariff-item-header-2">Оценка профиля</p>
                                        
                                        <p>Последовательный поиск решения<br> в любой ситуации</p>
                                        <div>
                                            <p class="careerum-cons-tariff-item-amount">
                                                359 500 ₽
                                            </p>
                                            <p>
                                                
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div class="careerum-cons-tariff-links">
                                    <p class="careerum-cons-tariff-item-amount-total">199 500 ₽</p>
                                    <a href="#" class="btn-color-main-dark-orange">Купить</a>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-consult-tariff-tab-dropdown-link">
                                    <p>Что произойдет после оплаты?</p>
                                    <div>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676880934846.svg" alt="">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676880976840.svg" alt="">
                                    </div>
                                </div>
                                <div>
                                    <div>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676880984647.svg" alt="">
                                        <p>Мы пришлем календарь записи, чтобы вы могли выбрать время<br> и забронировать сессию.</p>
                                    </div>
                                    <div>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676880986449.svg" alt="">
                                        <p>Заполните анкету, которая придет в том же письме. Она поможет Ольге лучше понять вашу ситуацию.</p>
                                    </div>
                                    <div>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676880988664.svg" alt="">
                                        <p>Мы напомним о времени записи по электронной<br> почте: за 24 часа и за 1 час<br> до начала сессии.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div></div>
            </div>
        </div>  `
	});

    blockManager.add('careerum-cons-tariff-block-mobile', {
        label: 'Консультации витрина (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-cons-tariff-block-mobile">
            <div>
                <div class="careerum-cons-tariff-header">
                    <h2>Выберите<br> ваш запрос</h2>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676881171249.svg" alt="">
                </div>
                <div>
                    <div class="careerum-consult-tariff-menu">
                        <div></div>
                    </div>
                    <div class="careerum-consult-tariff-tabs">
                        <div class="careerum-cons-currency-switcher">
                            <div>
                                <p class="careerum-cons-currency-header">RUB</p>
                                <div class="careerum-cons-currency-dropdown">
                                    <p data-cons-currency="EUR" class="careerum-cons-currency-dropdown-item">EUR</p>
                                    <p data-cons-currency="RUB" class="careerum-cons-currency-dropdown-item">RUB</p>
                                </div>
                            </div>
                        </div>
                        <div class="careerum-consult-tariff-tab" data-tab-name="Понять, куда двигаться">
                            <div>
                                <div class="careerum-cons-tariff-switcher-curr">
                                    <div>
                                        <p class="careerum-cons-tariff-item-header-1">Избавитесь от установок, которые блокируют ваше продвижение. Найдете свои таланты и построите карьерную стратегию</p>
                                    </div>
                                </div>
                                <div class="careerum-cons-tariff-switcher-items2">
                                    <div class="careerum-cons-tariff-item2 active careerum-cons-tariff-item"
                                    data-EUR-amount="3 325 €" data-RUB-amount="199 600 ₽" data-link="#1">
                                        <p class="careerum-cons-tariff-item-header-2">5 консультаций</p>
                                        <p>Работа с ограничивающими<br> установками и создание стратегии для решения одного карьерного запроса</p>
                                        <div>
                                            <p class="careerum-cons-tariff-item-amount">
                                                199 500 ₽ 
                                            </p>
                                        </div>
                                    </div>
                                    <div class="careerum-cons-tariff-item2 careerum-cons-tariff-item" data-EUR-amount="5 990 €" data-RUB-amount="359 500 ₽" data-link="#2">
                                        <p class="careerum-cons-tariff-item-header-2">10 консультаций</p>
                                        <p>Глубокая проработка актуальных карьерных запросов и создание четкого плана достижения целей</p>
                                        <div>
                                            <p class="careerum-cons-tariff-item-amount">
                                                359 500 ₽
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div class="careerum-cons-tariff-links">
                                    <p class="careerum-cons-tariff-item-amount-total">199 500 ₽</p>
                                    <a href="#" class="btn-color-main-dark-orange">Купить</a>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-consult-tariff-tab-dropdown-link">
                                    <p>Что произойдет после оплаты?</p>
                                    <div>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676881198179.svg" alt="">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676881280628.svg" alt="">
                                    </div>
                                </div>
                                <div>
                                    <div>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676881327686.svg" alt="">
                                        <p>Мы пришлем календарь записи,<br> чтобы вы могли выбрать время<br> и забронировать сессию.</p>
                                    </div>
                                    <div>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676881329629.svg" alt="">
                                        <p>Заполните анкету, которая придет<br> в том же письме. Она поможет Ольге<br> лучше понять вашу ситуацию.</p>
                                    </div>
                                    <div>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676881332211.svg" alt="">
                                        <p>Мы напомним о времени<br> записи по электронной почте:<br> за 24 часа и за 1 час до начала<br> сессии.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="careerum-consult-tariff-tab" data-tab-name="Расти на рабочем месте">
                            <div>
                                <div class="careerum-cons-tariff-switcher-curr">
                                    <div>
                                        <p class="careerum-cons-tariff-item-header-1">Построите эффективную карьерную стратегию, которая приведет вас к повышению в должности и в доходе</p>
                                    </div>
                                </div>
                                <div class="careerum-cons-tariff-switcher-items2">
                                    <div class="careerum-cons-tariff-item2 active careerum-cons-tariff-item"
                                    data-EUR-amount="3 325 €" data-RUB-amount="199 500 ₽" data-link="#3">
                                        <p class="careerum-cons-tariff-item-header-2">5 консультаций</p>
                                        <p>Работа с ограничивающими<br> установками и создание стратегии для решения одного карьерного запроса</p>
                                        <div>
                                            <p class="careerum-cons-tariff-item-amount">
                                                199 500 ₽ 
                                            </p>
                                            <p>
                                                
                                            </p>
                                        </div>
                                    </div>
                                    <div class="careerum-cons-tariff-item2 careerum-cons-tariff-item" data-EUR-amount="5 990 €" data-RUB-amount="359 500 ₽" data-link="#4">
                                        <p class="careerum-cons-tariff-item-header-2">10 консультаций</p>
                                        <p>Глубокая проработка актуальных карьерных запросов и создание четкого плана достижения целей</p>
                                        <div>
                                            <p class="careerum-cons-tariff-item-amount">
                                                359 500 ₽
                                            </p>
                                            <p>
                                                
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div class="careerum-cons-tariff-links">
                                    <p class="careerum-cons-tariff-item-amount-total">199 500 ₽</p>
                                    <a href="#" class="btn-color-main-dark-orange">Купить</a>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-consult-tariff-tab-dropdown-link">
                                    <p>Что произойдет после оплаты?</p>
                                    <div>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676881198179.svg" alt="">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676881280628.svg" alt="">
                                    </div>
                                </div>
                                <div>
                                    <div>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676881327686.svg" alt="">
                                        <p>Мы пришлем календарь записи, чтобы вы могли выбрать время<br> и забронировать сессию.</p>
                                    </div>
                                    <div>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676881329629.svg" alt="">
                                        <p>Заполните анкету, которая придет в том же письме. Она поможет Ольге лучше понять вашу ситуацию.</p>
                                    </div>
                                    <div>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676881332211.svg" alt="">
                                        <p>Мы напомним о времени записи по электронной<br> почте: за 24 часа и за 1 час<br> до начала сессии.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="careerum-consult-tariff-tab" data-tab-name="Повысить доход">
                            <div>
                                <div class="careerum-cons-tariff-switcher-curr">
                                    <div>
                                        <p class="careerum-cons-tariff-item-header-1">Узнаете, как двигаться в карьере<br> и какие проекты выбирать, чтобы повышать свой доход</p>
                                    </div>
                                </div>
                                <div class="careerum-cons-tariff-switcher-items2">
                                    <div class="careerum-cons-tariff-item2 active careerum-cons-tariff-item"
                                    data-EUR-amount="3 325 €" data-RUB-amount="199 500 ₽" data-link="#1">
                                        <p class="careerum-cons-tariff-item-header-2">5 консультаций</p>
                                        <p>Работа с ограничивающими<br> установками и создание стратегии для решения одного карьерного запроса</p>
                                        <div>
                                            <p class="careerum-cons-tariff-item-amount">
                                                199 500 ₽ 
                                            </p>
                                            <p>
                                                
                                            </p>
                                        </div>
                                    </div>
                                    <div class="careerum-cons-tariff-item2 careerum-cons-tariff-item" data-EUR-amount="5 990 €" data-RUB-amount="359 500 ₽" data-link="#2">
                                        <p class="careerum-cons-tariff-item-header-2">10 консультаций</p>
                                        <p>Глубокая проработка актуальных карьерных запросов и создание четкого плана достижения целей</p>
                                        <div>
                                            <p class="careerum-cons-tariff-item-amount">
                                                359 500 ₽
                                            </p>
                                            <p>
                                                
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div class="careerum-cons-tariff-links">
                                    <p class="careerum-cons-tariff-item-amount-total">199 500 ₽</p>
                                    <a href="#" class="btn-color-main-dark-orange">Купить</a>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-consult-tariff-tab-dropdown-link">
                                    <p>Что произойдет после оплаты?</p>
                                    <div>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676881198179.svg" alt="">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676881280628.svg" alt="">
                                    </div>
                                </div>
                                <div>
                                    <div>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676881327686.svg" alt="">
                                        <p>Мы пришлем календарь записи, чтобы вы могли выбрать время<br> и забронировать сессию.</p>
                                    </div>
                                    <div>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676881329629.svg" alt="">
                                        <p>Заполните анкету, которая придет в том же письме. Она поможет Ольге лучше понять вашу ситуацию.</p>
                                    </div>
                                    <div>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676881332211.svg" alt="">
                                        <p>Мы напомним о времени записи по электронной<br> почте: за 24 часа и за 1 час<br> до начала сессии.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="careerum-consult-tariff-tab" data-tab-name="Найти work-life balance">
                            <div>
                                <div class="careerum-cons-tariff-switcher-curr">
                                    <div>
                                        <p class="careerum-cons-tariff-item-header-1">Освоите инструменты, которые помогут «не только работать, но<br> и жить» без ущерба личной жизни</p>
                                    </div>
                                </div>
                                <div class="careerum-cons-tariff-switcher-items2">
                                    <div class="careerum-cons-tariff-item2 active careerum-cons-tariff-item"
                                    data-EUR-amount="3 325 €" data-RUB-amount="199 500 ₽" data-link="#1">
                                        <p class="careerum-cons-tariff-item-header-2">5 консультаций</p>
                                        <p>Работа с ограничивающими<br> установками и создание стратегии для решения одного карьерного запроса</p>
                                        <div>
                                            <p class="careerum-cons-tariff-item-amount">
                                                199 500 ₽ 
                                            </p>
                                            <p>
                                                
                                            </p>
                                        </div>
                                    </div>
                                    <div class="careerum-cons-tariff-item2 careerum-cons-tariff-item" data-EUR-amount="5 990 €" data-RUB-amount="359 500 ₽" data-link="#2">
                                        <p class="careerum-cons-tariff-item-header-2">10 консультаций</p>
                                        <p>Глубокая проработка актуальных карьерных запросов и создание четкого плана достижения целей</p>
                                        <div>
                                            <p class="careerum-cons-tariff-item-amount">
                                                359 500 ₽
                                            </p>
                                            <p>
                                                
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div class="careerum-cons-tariff-links">
                                    <p class="careerum-cons-tariff-item-amount-total">199 500 ₽</p>
                                    <a href="#" class="btn-color-main-dark-orange">Купить</a>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-consult-tariff-tab-dropdown-link">
                                    <p>Что произойдет после оплаты?</p>
                                    <div>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676881198179.svg" alt="">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676881280628.svg" alt="">
                                    </div>
                                </div>
                                <div>
                                    <div>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676881327686.svg" alt="">
                                        <p>Мы пришлем календарь записи, чтобы вы могли выбрать время<br> и забронировать сессию.</p>
                                    </div>
                                    <div>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676881329629.svg" alt="">
                                        <p>Заполните анкету, которая придет в том же письме. Она поможет Ольге лучше понять вашу ситуацию.</p>
                                    </div>
                                    <div>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676881332211.svg" alt="">
                                        <p>Мы напомним о времени записи по электронной<br> почте: за 24 часа и за 1 час<br> до начала сессии.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="careerum-consult-tariff-tab" data-tab-name="Подготовиться к интервью">
                            <div>
                                <div class="careerum-cons-tariff-switcher-curr">
                                    <div>
                                    </div>
                                </div>
                                <div class="careerum-cons-tariff-switcher-items1">
                                    <div class="careerum-cons-tariff-item1 careerum-cons-tariff-item"
                                    data-EUR-amount="499 €" data-RUB-amount="29 900 ₽" data-link="#1">
                                        <p class="careerum-cons-tariff-item-header-1">Курс + консультация</p>
                                        <p>Научитесь мастерски проходить<br> интервью и отвечать даже<br> на самые сложные вопросы.</p>
                                        <div>
                                            <div>
                                                <div class="careerum-course-tab-item-mobile">
                                                    <div>  
                                                        <p>Курс</p>
                                                        <p>2 часа 16 мин.</p>
                                                    </div>  
                                                    <h3>Эффективное интервью</h3>
                                                    <p>Поймете, как выгодно подать себя <br>на интервью, и научитесь отвечать даже<br> на самые сложные вопросы рекрутера</p>
                                                </div>
                                                <div class="careerum-course-tab-item-mobile">
                                                    <div>  
                                                        <p>Консультация</p>
                                                        <p>50 мин.</p>
                                                    </div>  
                                                    <h3>Консультация</h3>
                                                    <p>Ольга даст вам точные рекомендации и поможет найти более эффективные способы прохождения интервью</p>
                                                </div>
                                            </div>
                                            <p>
                                                
                                            </p>
                                        </div>
                                        <p class="careerum-cons-tariff-item-amount">
                                             
                                        </p>
                                        <a href="#" class="btn-color-main-dark-orange">Купить</a>
                                    </div>
                                    
                                </div>
                                <div class="careerum-cons-tariff-links">
                                </div>
                            </div>
                            <div>
                                <div class="careerum-consult-tariff-tab-dropdown-link">
                                    <p>Что произойдет после оплаты?</p>
                                    <div>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676881198179.svg" alt="">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676881280628.svg" alt="">
                                    </div>
                                </div>
                                <div>
                                    <div>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676881327686.svg" alt="">
                                        <p>Мы пришлем календарь записи, чтобы вы могли выбрать время<br> и забронировать сессию.</p>
                                    </div>
                                    <div>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676881329629.svg" alt="">
                                        <p>Заполните анкету, которая придет в том же письме. Она поможет Ольге лучше понять вашу ситуацию.</p>
                                    </div>
                                    <div>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676881332211.svg" alt="">
                                        <p>Мы напомним о времени записи по электронной<br> почте: за 24 часа и за 1 час<br> до начала сессии.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="careerum-consult-tariff-tab" data-tab-name="Стать сильным лидером">
                            <div>
                                <div class="careerum-cons-tariff-switcher-curr">
                                    <div>
                                        <p class="careerum-cons-tariff-item-header-1">Построите гармоничную стратегию<br> управления, с учетом именно ваших<br> лидерских качеств</p>
                                    </div>
                                </div>
                                <div class="careerum-cons-tariff-switcher-items2">
                                    <div class="careerum-cons-tariff-item2 active careerum-cons-tariff-item"
                                    data-EUR-amount="3 325 €" data-RUB-amount="199 500 ₽" data-link="#1">
                                        <p class="careerum-cons-tariff-item-header-2">5 консультаций</p>
                                        <p>Работа с ограничивающими<br> установками и создание стратегии для решения одного карьерного запроса</p>
                                        <div>
                                            <p class="careerum-cons-tariff-item-amount">
                                                199 500 ₽ 
                                            </p>
                                            <p>
                                                
                                            </p>
                                        </div>
                                    </div>
                                    <div class="careerum-cons-tariff-item2 careerum-cons-tariff-item" data-EUR-amount="5 990 €" data-RUB-amount="359 500 ₽" data-link="#2">
                                        <p class="careerum-cons-tariff-item-header-2">10 консультаций</p>
                                        <p>Глубокая проработка актуальных карьерных запросов и создание четкого плана достижения целей</p>
                                        <div>
                                            <p class="careerum-cons-tariff-item-amount">
                                                359 500 ₽
                                            </p>
                                            <p>
                                                
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div class="careerum-cons-tariff-links">
                                    <p class="careerum-cons-tariff-item-amount-total">199 500 ₽</p>
                                    <a href="#" class="btn-color-main-dark-orange">Купить</a>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-consult-tariff-tab-dropdown-link">
                                    <p>Что произойдет после оплаты?</p>
                                    <div>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676881198179.svg" alt="">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676881280628.svg" alt="">
                                    </div>
                                </div>
                                <div>
                                    <div>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676881327686.svg" alt="">
                                        <p>Мы пришлем календарь записи, чтобы вы могли выбрать время<br> и забронировать сессию.</p>
                                    </div>
                                    <div>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676881329629.svg" alt="">
                                        <p>Заполните анкету, которая придет в том же письме. Она поможет Ольге лучше понять вашу ситуацию.</p>
                                    </div>
                                    <div>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676881332211.svg" alt="">
                                        <p>Мы напомним о времени записи по электронной<br> почте: за 24 часа и за 1 час<br> до начала сессии.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="careerum-consult-tariff-tab" data-tab-name="Начать и вести свой бизнес">
                            <div>
                                <div class="careerum-cons-tariff-switcher-curr">
                                    <div>
                                        <p class="careerum-cons-tariff-item-header-1">Разберетесь со страхами и найдете<br> опоры, которые помогут поэтапно построить крепкий бизнес <br>и развивать его</p>
                                    </div>
                                </div>
                                <div class="careerum-cons-tariff-switcher-items2">
                                    <div class="careerum-cons-tariff-item2 active careerum-cons-tariff-item"
                                    data-EUR-amount="3 325 €" data-RUB-amount="199 500 ₽" data-link="#1">
                                        <p class="careerum-cons-tariff-item-header-2">5 консультаций</p>
                                        <p>Работа с ограничивающими<br> установками и создание стратегии для решения одного карьерного запроса</p>
                                        <div>
                                            <p class="careerum-cons-tariff-item-amount">
                                                199 500 ₽ 
                                            </p>
                                            <p>
                                                
                                            </p>
                                        </div>
                                    </div>
                                    <div class="careerum-cons-tariff-item2 careerum-cons-tariff-item" data-EUR-amount="5 990 €" data-RUB-amount="359 500 ₽" data-link="#2">
                                        <p class="careerum-cons-tariff-item-header-2">10 консультаций</p>
                                        <p>Глубокая проработка актуальных карьерных запросов и создание четкого плана достижения целей</p>
                                        <div>
                                            <p class="careerum-cons-tariff-item-amount">
                                                359 500 ₽
                                            </p>
                                            <p>
                                                
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div class="careerum-cons-tariff-links">
                                    <p class="careerum-cons-tariff-item-amount-total">199 500 ₽</p>
                                    <a href="#" class="btn-color-main-dark-orange">Купить</a>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-consult-tariff-tab-dropdown-link">
                                    <p>Что произойдет после оплаты?</p>
                                    <div>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676881198179.svg" alt="">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676881280628.svg" alt="">
                                    </div>
                                </div>
                                <div>
                                    <div>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676881327686.svg" alt="">
                                        <p>Мы пришлем календарь записи, чтобы вы могли выбрать время<br> и забронировать сессию.</p>
                                    </div>
                                    <div>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676881329629.svg" alt="">
                                        <p>Заполните анкету, которая придет в том же письме. Она поможет Ольге лучше понять вашу ситуацию.</p>
                                    </div>
                                    <div>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676881332211.svg" alt="">
                                        <p>Мы напомним о времени записи по электронной<br> почте: за 24 часа и за 1 час<br> до начала сессии.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="careerum-consult-tariff-tab" data-tab-name="Поступить на программу MBA">
                            <div>
                                <div class="careerum-cons-tariff-switcher-curr">
                                    <div>
                                        <p class="careerum-cons-tariff-item-header-1">Получите пошаговый план подготовки к поступлению на MBA, узнаете о подводных камнях и выработаете пошаговую стратегию </p>
                                    </div>
                                </div>
                                <div class="careerum-cons-tariff-switcher-items2">
                                    <div class="careerum-cons-tariff-item2 active careerum-cons-tariff-item careerum-cons-tariff-item3"
                                    data-EUR-amount="3 330 €" data-RUB-amount="200 000 ₽" data-link="#1">
                                        <p class="careerum-cons-tariff-item-header-2">Разбор школы</p>
                                        
                                        <div>
                                            <p class="careerum-cons-tariff-item-amount">
                                                199 500 ₽ 
                                            </p>
                                            <p>
                                                
                                            </p>
                                        </div>
                                    </div>
                                    <div class="careerum-cons-tariff-item2 careerum-cons-tariff-item careerum-cons-tariff-item3" data-EUR-amount="6 515 €" data-RUB-amount="390 900 ₽" data-link="#2">
                                        <p class="careerum-cons-tariff-item-header-2">Разбор 2–3 школ</p>
                                        
                                        <div>
                                            <p class="careerum-cons-tariff-item-amount">
                                                359 500 ₽
                                            </p>
                                            <p>
                                                
                                            </p>
                                        </div>
                                    </div>
                                    <div class="careerum-cons-tariff-item2 careerum-cons-tariff-item careerum-cons-tariff-item3" data-EUR-amount="499 €" data-RUB-amount="29 900 ₽" data-link="#3">
                                        <p class="careerum-cons-tariff-item-header-2">Оценка профиля</p>
                                        
                                        <p>Последовательный поиск решения<br> в любой ситуации</p>
                                        <div>
                                            <p class="careerum-cons-tariff-item-amount">
                                                359 500 ₽
                                            </p>
                                            <p>
                                                
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div class="careerum-cons-tariff-links">
                                    <p class="careerum-cons-tariff-item-amount-total">199 500 ₽</p>
                                    <a href="#" class="btn-color-main-dark-orange">Купить</a>
                                </div>
                            </div>
                            <div>
                                <div class="careerum-consult-tariff-tab-dropdown-link">
                                    <p>Что произойдет после оплаты?</p>
                                    <div>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676881198179.svg" alt="">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676881280628.svg" alt="">
                                    </div>
                                </div>
                                <div>
                                    <div>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676881327686.svg" alt="">
                                        <p>Мы пришлем календарь записи, чтобы вы могли выбрать время<br> и забронировать сессию.</p>
                                    </div>
                                    <div>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676881329629.svg" alt="">
                                        <p>Заполните анкету, которая придет в том же письме. Она поможет Ольге лучше понять вашу ситуацию.</p>
                                    </div>
                                    <div>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1676881332211.svg" alt="">
                                        <p>Мы напомним о времени записи по электронной<br> почте: за 24 часа и за 1 час<br> до начала сессии.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>  `
	});
    
    blockManager.add('careerum-cons-faq-block', {
        label: 'Консультации FAQ',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-cons-faq-block">
            <div>
                <div>
                    <p>Популярные вопросы</p>
                </div>
                <div>
                    <div class="careerum-cons-faq-item">
                        <div class="careerum-cons-faq-item-header">
                            <p>Как проходит консультация?</p>
                        </div>
                        <div class="careerum-cons-faq-item-content">
                            <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев,<br> в зависимости
                                от выбранного вами варианта. Например, если вы выбрали<br> подписку на 1 месяц (30
                                календарных дней), то для продления доступа<br> к клубу, на 31 день с вашей карты спишется
                                сумма, равная стоимости<br> подписки.</p>
                        </div>
                    </div>
                    <div class="careerum-cons-faq-item">
                        <div class="careerum-cons-faq-item-header">
                            <p>Как можно попасть на консультацию с Ольгой?</p>
                        </div>
                        <div class="careerum-cons-faq-item-content">
                            <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Quas ullam delectus pariatur
                                eveniet eum aliquid. Laborum fugit nobis ut aliquid sapiente officia animi? Odio totam
                                corrupti hic maiores fugit aliquid.</p>
                        </div>
                    </div>
                    <div class="careerum-cons-faq-item">
                        <div class="careerum-cons-faq-item-header">
                            <p>Почему я не могу купить одну<br> консультацию, а только 5 или 10?</p>
                        </div>
                        <div class="careerum-cons-faq-item-content">
                            <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Quas ullam delectus pariatur
                                eveniet eum aliquid. Laborum fugit nobis ut aliquid sapiente officia animi? Odio totam
                                corrupti hic maiores fugit aliquid.</p>
                        </div>
                    </div>
                    <div class="careerum-cons-faq-item">
                        <div class="careerum-cons-faq-item-header">
                            <p>Как часто я могу обращаться к Ольге с запросами?</p>
                        </div>
                        <div class="careerum-cons-faq-item-content">
                            <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Quas ullam delectus pariatur
                                eveniet eum aliquid. Laborum fugit nobis ut aliquid sapiente officia animi? Odio totam
                                corrupti hic maiores fugit aliquid.</p>
                        </div>
                    </div>
                    <div class="careerum-cons-faq-item">
                        <div class="careerum-cons-faq-item-header">
                            <p>Можно ли приобрести консультации<br> отдельно, если я не в клубе?</p>
                        </div>
                        <div class="careerum-cons-faq-item-content">
                            <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев, в зависимости
                                от выбранного вами варианта. Например, если вы выбрали подписку на 1 месяц (30 календарных
                                дней), то для продления доступа к клубу, на 31 день с вашей карты спишется сумма, равная
                                стоимости подписки.</p>
                        </div>
                    </div>
                    <div class="careerum-cons-faq-item">
                        <div class="careerum-cons-faq-item-header">
                            <p>Есть ли гарантия, что при помощи<br> консультаций я быстрее достигну целей?</p>
                        </div>
                        <div class="careerum-cons-faq-item-content">
                            <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Quas ullam delectus pariatur
                                eveniet eum aliquid. Laborum fugit nobis ut aliquid sapiente officia animi? Odio totam
                                corrupti hic maiores fugit aliquid.</p>
                        </div>
                    </div>
                    <div class="careerum-cons-faq-item">
                        <div class="careerum-cons-faq-item-header">
                            <p>Может ли Ольга дать мне совет или<br> высказать свое мнение по рабочей<br> ситуации?</p>
                        </div>
                        <div class="careerum-cons-faq-item-content">
                            <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Quas ullam delectus pariatur
                                eveniet eum aliquid. Laborum fugit nobis ut aliquid sapiente officia animi? Odio totam
                                corrupti hic maiores fugit aliquid.</p>
                        </div>
                    </div>
                    <div class="careerum-cons-faq-item">
                        <div class="careerum-cons-faq-item-header">
                            <p>Могу ли я задавать вопросы Ольге между<br> консультациями?</p>
                        </div>
                        <div class="careerum-cons-faq-item-content">
                            <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Quas ullam delectus pariatur
                                eveniet eum aliquid. Laborum fugit nobis ut aliquid sapiente officia animi? Odio totam
                                corrupti hic maiores fugit aliquid.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-cons-faq-block-tablet', {
        label: 'Консультации FAQ (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-cons-faq-block-tablet">
            <div>
                <div><p>Популярные вопросы</p></div>
                <div>
                    <div class="careerum-cons-faq-item">
                        <div class="careerum-cons-faq-item-header">
                            <p>Как проходит консультация?</p>
                        </div>
                        <div class="careerum-cons-faq-item-content">
                            <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев, в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1 месяц (30<br> календарных дней), то для продления доступа к клубу, на 31 день<br> с вашей карты спишется сумма, равная стоимости подписки.</p>
                        </div>
                    </div>
                    <div class="careerum-cons-faq-item">
                        <div class="careerum-cons-faq-item-header">
                            <p>Как можно попасть на консультацию<br> с Ольгой?</p>
                        </div>
                        <div class="careerum-cons-faq-item-content">
                            <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Quas ullam delectus pariatur eveniet eum aliquid. Laborum fugit nobis ut aliquid sapiente officia animi? Odio totam corrupti hic maiores fugit aliquid.</p>
                        </div>
                    </div>
                    <div class="careerum-cons-faq-item">
                        <div class="careerum-cons-faq-item-header">
                            <p>Почему я не могу купить одну<br> консультацию, а только 5 или 10?</p>
                        </div>
                        <div class="careerum-cons-faq-item-content">
                            <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Quas ullam delectus pariatur eveniet eum aliquid. Laborum fugit nobis ut aliquid sapiente officia animi? Odio totam corrupti hic maiores fugit aliquid.</p>
                        </div>
                    </div>
                    <div class="careerum-cons-faq-item">
                        <div class="careerum-cons-faq-item-header">
                            <p>Как часто я могу обращаться<br> к Ольге с запросами?</p>
                        </div>
                        <div class="careerum-cons-faq-item-content">
                            <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Quas ullam delectus pariatur eveniet eum aliquid. Laborum fugit nobis ut aliquid sapiente officia animi? Odio totam corrupti hic maiores fugit aliquid.</p>
                        </div>
                    </div>
                    <div class="careerum-cons-faq-item">
                        <div class="careerum-cons-faq-item-header">
                            <p>Можно ли приобрести консультации<br> отдельно, если я не в клубе?</p>
                        </div>
                        <div class="careerum-cons-faq-item-content">
                            <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев, в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1 месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей карты спишется сумма, равная стоимости подписки.</p>
                        </div>
                    </div>
                    <div class="careerum-cons-faq-item">
                        <div class="careerum-cons-faq-item-header">
                            <p>Есть ли гарантия, что при<br> помощи консультаций я быстрее<br> достигну целей?</p>
                        </div>
                        <div class="careerum-cons-faq-item-content">
                            <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Quas ullam delectus pariatur eveniet eum aliquid. Laborum fugit nobis ut aliquid sapiente officia animi? Odio totam corrupti hic maiores fugit aliquid.</p>
                        </div>
                    </div>
                    <div class="careerum-cons-faq-item">
                        <div class="careerum-cons-faq-item-header">
                            <p>Может ли Ольга дать мне совет<br> или высказать свое мнение<br> по рабочей ситуации?</p>
                        </div>
                        <div class="careerum-cons-faq-item-content">
                            <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Quas ullam delectus pariatur eveniet eum aliquid. Laborum fugit nobis ut aliquid sapiente officia animi? Odio totam corrupti hic maiores fugit aliquid.</p>
                        </div>
                    </div>
                    <div class="careerum-cons-faq-item">
                        <div class="careerum-cons-faq-item-header">
                            <p>Могу ли я задавать вопросы<br> Ольге между консультациями?</p>
                        </div>
                        <div class="careerum-cons-faq-item-content">
                            <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Quas ullam delectus pariatur eveniet eum aliquid. Laborum fugit nobis ut aliquid sapiente officia animi? Odio totam corrupti hic maiores fugit aliquid.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-cons-faq-block-mobile', {
        label: 'Консультации FAQ (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-cons-faq-block-mobile">
            <div>
                <div><p>Популярные<br> вопросы</p></div>
                <div>
                    <div class="careerum-cons-faq-item">
                        <div class="careerum-cons-faq-item-header">
                            <p>Как проходит консультация?</p>
                        </div>
                        <div class="careerum-cons-faq-item-content">
                            <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев, в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1 месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей карты спишется сумма, равная стоимости подписки.</p>
                        </div>
                    </div>
                    <div class="careerum-cons-faq-item">
                        <div class="careerum-cons-faq-item-header">
                            <p>Как можно попасть на консультацию с Ольгой?</p>
                        </div>
                        <div class="careerum-cons-faq-item-content">
                            <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Quas ullam delectus pariatur eveniet eum aliquid. Laborum fugit nobis ut aliquid sapiente officia animi? Odio totam corrupti hic maiores fugit aliquid.</p>
                        </div>
                    </div>
                    <div class="careerum-cons-faq-item">
                        <div class="careerum-cons-faq-item-header">
                            <p>Почему я не могу купить<br> одну консультацию, а только<br> 5 или 10?</p>
                        </div>
                        <div class="careerum-cons-faq-item-content">
                            <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Quas ullam delectus pariatur eveniet eum aliquid. Laborum fugit nobis ut aliquid sapiente officia animi? Odio totam corrupti hic maiores fugit aliquid.</p>
                        </div>
                    </div>
                    <div class="careerum-cons-faq-item">
                        <div class="careerum-cons-faq-item-header">
                            <p>Как часто я могу обращаться<br> к Ольге с запросами?</p>
                        </div>
                        <div class="careerum-cons-faq-item-content">
                            <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Quas ullam delectus pariatur eveniet eum aliquid. Laborum fugit nobis ut aliquid sapiente officia animi? Odio totam corrupti hic maiores fugit aliquid.</p>
                        </div>
                    </div>
                    <div class="careerum-cons-faq-item">
                        <div class="careerum-cons-faq-item-header">
                            <p>Можно ли приобрести консультации отдельно,<br> если я не в клубе?</p>
                        </div>
                        <div class="careerum-cons-faq-item-content">
                            <p>Careerum.Club работает по подписке, которая длится 1, 3, 6 или 12 месяцев, в зависимости от выбранного вами варианта. Например, если вы выбрали подписку на 1 месяц (30 календарных дней), то для продления доступа к клубу, на 31 день с вашей карты спишется сумма, равная стоимости подписки.</p>
                        </div>
                    </div>
                    <div class="careerum-cons-faq-item">
                        <div class="careerum-cons-faq-item-header">
                            <p>Есть ли гарантия, что при<br> помощи консультаций я<br> быстрее достигну целей?</p>
                        </div>
                        <div class="careerum-cons-faq-item-content">
                            <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Quas ullam delectus pariatur eveniet eum aliquid. Laborum fugit nobis ut aliquid sapiente officia animi? Odio totam corrupti hic maiores fugit aliquid.</p>
                        </div>
                    </div>
                    <div class="careerum-cons-faq-item">
                        <div class="careerum-cons-faq-item-header">
                            <p>Может ли Ольга дать мне<br> совет или высказать свое<br> мнение по рабочей<br> ситуации?</p>
                        </div>
                        <div class="careerum-cons-faq-item-content">
                            <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Quas ullam delectus pariatur eveniet eum aliquid. Laborum fugit nobis ut aliquid sapiente officia animi? Odio totam corrupti hic maiores fugit aliquid.</p>
                        </div>
                    </div>
                    <div class="careerum-cons-faq-item">
                        <div class="careerum-cons-faq-item-header">
                            <p>Могу ли я задавать вопросы<br> Ольге между консультациями?</p>
                        </div>
                        <div class="careerum-cons-faq-item-content">
                            <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Quas ullam delectus pariatur eveniet eum aliquid. Laborum fugit nobis ut aliquid sapiente officia animi? Odio totam corrupti hic maiores fugit aliquid.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div> `
	});

    blockManager.add('careerum-popup', {
        label: 'Popup',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-popup" id="123" data-timeout="30" data-exit="yes">
            <div class="popup__close-button-wrapper">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1677062419516.svg" alt="" class="close-switch">
            </div>
    
            <div class="careerum-form-lead ">
                <div class="popup__header-lg">
                    <p>Вступите<br> в клуб <span>первыми</span></p>
                </div>
                <div class="popup__header-sm">
                    <p>Вебинар «Строим карьеру в 2023 году: как найти опору в работе и в жизни»</p>
                </div>
                <div class="popup__image-wrapper">
                    <div class="popup__image-text-top">
                        <p>12 февраля, 13:00 (GMT+3)</p>
                    </div>
                    <div class="popup__image-text-bottom">
                        <p>Спикер: Ольга Лермонтова</p>
                    </div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1677062464337.png" alt="" class="popup__image-desctop">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1677062474169.png" alt="" class="popup__image-mobile">
                </div>
                <div>
                    <form class="deva-form getcourse-email-signup" name="devaRegistrationForm"
                        data-gjs-type="deva-registration-form">
                        <div>
                            <div class="careerum-form-lead-name">
                                <input type="text" name="name" value="" placeholder=" " required>
                                <span>Имя</span>
                            </div>
                            <div class="careerum-form-lead-email">
                                <input type="email" name="email" value="" placeholder=" " required>
                                <span>Почта</span>
                            </div>
                            <div class="careerum-form-lead-tel">
                                <input type="tel" name="tel" value="" placeholder=" " required>
                                <span>Номер телефона</span>
                            </div>
                        </div>
                        <div class="careerum-form-lead-agree">
                            <label data-toggle-checkbox="true">
                                <input type="checkbox" name="agree">
                            </label>
                            <p>Я даю согласие на обработку своих персональных данных в&nbsp;соответствии с&nbsp;<a
                                    href="#">Политикой конфиденциальности</a>
                        </div>
                        <a href="#" disabled class="submit-btn btn-desc">Записаться на вебинар</a>
                        <a href="#" disabled class="submit-btn btn-mob">Зарегистрироваться</a>
                    </form>
                </div>
            </div>
    
            <div class="careerum-form-success-lead">
                <div class="popup__header-md">
                    <p><span>Спасибо!</span><br> Данные успешно отправлены</p>
                </div>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1677062485067.svg" alt="">
            </div>
        </div>`
	});
    
    blockManager.add('careerum-vorkr-form', {
        label: 'Воронка главная',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-vorkr-form">
            <div>
                <div>
                    <h2>Получите бесплатный гайд «Как найти работу в кризис»</h2>
                    <p>Узнайте, как пережить времена турбулентности в карьере</p>
                </div>
                <div>
                    <div class="careerum-registration-form">
                        <form class="deva-form getcourse-email-signup" name="devaRegistrationForm">
                            <div><input type="text" name="name" id="" required placeholder="Имя"><span>Имя</span></div>
                            <div><input type="email" name="email" id="" required placeholder="Почта"><span>Почта</span></div>
                            <div><input type="tel" name="tel" id="" required placeholder="Телефон"><span>Телефон</span></div>      
                            <div></div>                          
                            <div>
                                <label><input type="checkbox" name="agree" id=""></label>
                                <p>Я даю согласие на обработку своих персональных данных<br> в соответствии с <a href="#">Политикой конфиденциальности</a></p>
                            </div>
                            <a href="#" disabled class="submit-btn">Получить гайд</a>
                        </form>
                    </div>
                </div>
            </div>
        </div>`
    });
    
    blockManager.add('careerum-vorkr-form-tablet', {
        label: 'Воронка главная (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-vorkr-form-tablet">
            <div>
                <div>
                    <h2>Получите бесплатный гайд «Как найти работу в кризис»</h2>
                    <p>Узнайте, как пережить времена турбулентности в карьере</p>
                </div>
                <div>
                    <div class="careerum-registration-form-tablet">
                        <form class="deva-form getcourse-email-signup" name="devaRegistrationForm">
                            <div><input type="text" name="name" id="" required placeholder="Имя"><span>Имя</span></div>
                            <div><input type="email" name="email" id="" required placeholder="Почта"><span>Почта</span></div>
                            <div><input type="tel" name="phone" id="" required placeholder="Телефон"><span>Телефон</span></div>      
                            <div></div>                          
                            <div>
                                <label><input type="checkbox" name="agree" id=""></label>
                                <p>Я даю согласие на обработку своих персональных данных в соответствии<br> с <a href="#">Политикой конфиденциальности</a></p>
                            </div>
                            <a href="#" disabled class="submit-btn">Получить гайд</a>
                        </form>
                    </div>
                </div>
            </div>
        </div>`
    });
    
    blockManager.add('careerum-vorkr-form-mobile', {
        label: 'Воронка главная (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-vorkr-form-mobile">
            <div>
                <div>
                    <h2>Получите бесплатный гайд «Как найти работу в кризис»</h2>
                    <p>Узнайте, как пережить времена турбулентности в карьере</p>
                </div>
                <div>
                    <div class="careerum-registration-form-mobile">
                        <form class="deva-form getcourse-email-signup" name="devaRegistrationForm">
                            <div><input type="text" name="name" id="" required placeholder="Имя"><span>Имя</span></div>
                            <div><input type="email" name="email" id="" required placeholder="Почта"><span>Почта</span></div>
                            <div><input type="tel" name="phone" id="" required placeholder="Телефон"><span>Телефон</span></div>      
                            <div></div>                          
                            <div>
                                <label><input type="checkbox" name="agree" id=""></label>
                                <p>Я даю согласие на обработку своих персональных данных в соответствии<br> с <a href="#">Политикой конфиденциальности</a></p>
                            </div>
                            <a href="#" disabled class="submit-btn">Получить гайд</a>
                        </form>
                    </div>
                </div>
            </div>
        </div>`
    });

    blockManager.add('careerum-vorkr-tabs-col', {
        label: 'Воронка табы папки',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-vorkr-tabs-col">
            <div>
                <div>
                    <h2>Из гайда вы узнаете</h2>
                </div>
                <div>
                    <div>
                        <div class="careerum-vorkr-tabs-col-item-light-blue">
                            <p>Как анализировать свои навыки и соотносить их с потребностями рынка</p>
                        </div>
                        <div class="careerum-vorkr-tabs-col-item-very-light-blue">
                            <p>Как составить продающее резюме и сопроводительное письмо</p>
                        </div>
                        <div class="careerum-vorkr-tabs-col-item-dark-blue">
                            <p>Как анализировать свои навыки и соотносить их с потребностями рынка</p>
                        </div>
                    </div>
                    <div>
                        <div class="careerum-vorkr-tabs-col-item-light-orange">
                            <p>Как удачно подсветить свои сильные стороны во время интервью</p>
                        </div>
                        <div class="careerum-vorkr-tabs-col-item-medium-yellow">
                            <p>Какие нетривиальные способы помогут остаться на плаву в кризис</p>
                        </div>
                        <div class="careerum-vorkr-tabs-col-item-dark-orange">
                            <p>Как удачно подсветить свои сильные стороны во время интервью</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
    });
    
    blockManager.add('careerum-vorkr-tabs-col-tablet', {
        label: 'Воронка табы папки (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-vorkr-tabs-col-tablet">
            <div>
                <div>
                    <h2>Из гайда вы узнаете</h2>
                </div>
                <div>
                    <div>
                        <div class="careerum-vorkr-tabs-col-item-light-blue">
                            <p>Как анализировать свои навыки и соотносить их с потребностями рынка</p>
                        </div>
                        <div class="careerum-vorkr-tabs-col-item-very-light-blue">
                            <p>Как составить продающее резюме и сопроводительное письмо</p>
                        </div>
                        <div class="careerum-vorkr-tabs-col-item-dark-blue">
                            <p>Как анализировать свои навыки и соотносить их с потребностями рынка</p>
                        </div>
                    </div>
                    <div>
                        <div class="careerum-vorkr-tabs-col-item-light-orange">
                            <p>Как удачно подсветить свои сильные стороны во время интервью</p>
                        </div>
                        <div class="careerum-vorkr-tabs-col-item-medium-yellow">
                            <p>Какие нетривиальные способы помогут остаться на плаву в кризис</p>
                        </div>
                        <div class="careerum-vorkr-tabs-col-item-dark-orange">
                            <p>Как удачно подсветить свои сильные стороны во время интервью</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
    });
    
    blockManager.add('careerum-vorkr-tabs-col-mobile', {
        label: 'Воронка табы папки (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-vorkr-tabs-col-mobile">
            <div>
                <div>
                    <h2>Из гайда вы узнаете</h2>
                </div>
                <div>
                    <div>
                        <div class="careerum-vorkr-tabs-col-item-light-blue">
                            <p>Как анализировать свои навыки и соотносить их с потребностями рынка</p>
                        </div>
                        <div class="careerum-vorkr-tabs-col-item-very-light-blue">
                            <p>Как составить продающее резюме и сопроводительное письмо</p>
                        </div>
                        <div class="careerum-vorkr-tabs-col-item-dark-blue">
                            <p>Как анализировать свои навыки и соотносить их с потребностями рынка</p>
                        </div>
                        <div class="careerum-vorkr-tabs-col-item-light-orange">
                            <p>Как удачно подсветить свои сильные стороны во время интервью</p>
                        </div>
                        <div class="careerum-vorkr-tabs-col-item-medium-yellow">
                            <p>Какие нетривиальные способы помогут остаться на плаву в кризис</p>
                        </div>
                        <div class="careerum-vorkr-tabs-col-item-dark-orange">
                            <p>Как удачно подсветить свои сильные стороны во время интервью</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
    });

    blockManager.add('careerum-vorkr-tabs-row', {
        label: 'Воронка табы плитки',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-vorkr-tabs-row">
            <div>
                <div>
                    <h2>Вы получите 4 подсказки</h2>
                </div>
                <div>
                    <div>
                        <p>Что сейчас ищут работодатели</p>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1678813857547.svg" alt="">
                    </div>
                    <div>
                        <p>Как быстро и эффективно начать нетворкинг</p>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1678813860691.svg" alt="">
                    </div>
                    <div>
                        <p>Какие сферы устойчивее переносят экономический кризис</p>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1678813864646.svg" alt="">
                    </div>
                    <div>
                        <p>Почему для эффективного поиска нужно знать свои<br> «Хочу – Могу – Надо»</p>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1678813871342.svg" alt="">
                    </div>
                </div>
            </div>
        </div>`
    });
    
    blockManager.add('careerum-vorkr-tabs-row-tablet', {
        label: 'Воронка табы плитки (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-vorkr-tabs-row-tablet">
            <div>
                <div>
                    <h2>Вы получите 4 подсказки</h2>
                </div>
                <div>
                    <div>
                        <p>Что сейчас ищут работодатели</p>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1678813917275.svg" alt="">
                    </div>
                    <div>
                        <p>Как быстро<br> и эффективно начать нетворкинг</p>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1678813919383.svg" alt="">
                    </div>
                    <div>
                        <p>Какие сферы<br> устойчивее переносят экономический кризис</p>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1678813923121.svg" alt="">
                    </div>
                    <div>
                        <p>Почему для эффективного поиска нужно знать свои «Хочу – Могу – Надо»</p>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1678813926480.svg" alt="">
                    </div>
                </div>
            </div>
        </div>`
    });
    
    blockManager.add('careerum-vorkr-tabs-row-mobile', {
        label: 'Воронка табы плитки (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-vorkr-tabs-row-mobile">
            <div>
                <div>
                    <h2>Вы получите<br> 4 подсказки</h2>
                </div>
                <div>
                    <div>
                        <p>Что сейчас ищут работодатели</p>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1678813975303.svg" alt="">
                    </div>
                    <div>
                        <p>Как быстро и эффективно начать нетворкинг</p>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1678813977149.svg" alt="">
                    </div>
                    <div>
                        <p>Какие сферы устойчивее переносят экономи-ческий кризис</p>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1678813979691.svg" alt="">
                    </div>
                    <div>
                        <p>Почему для эффектив-ного поиска нужно знать свои «Хочу – Могу – <br>Надо»</p>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1678813982245.svg" alt="">
                    </div>
                </div>
            </div>
        </div>`
    });
    
    blockManager.add('careerum-vorkr-tabs-accord-block', {
        label: 'Воронка плашки курсы',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-vorkr-tabs-accord-block">
            <div>
                <div>
                    <h2>
                        Узнайте больше благодаря курсам<br> программы <span>«Международная карьера<br> и релокация»</span>
                    </h2>
                </div>
                <div class="careerum-vorkr-tabs-accord-items-wrapper">
                    <div class="vorkr-row">
                        <div class="vorkr-col">
                            <div class="vorkr-row">
                                <div class="careerum-course-tab-item">
                                    <div>
                                        <p>Курс</p>
                                        <p>2 часа 16 мин.</p>
                                    </div>
                                    <h3>Умная стратегия поиска<br> работы</h3>
                                    <p>Создадите пошаговый план поиска работы, который приведет вас к офферу мечты</p>
                                </div>
                                <div class="careerum-course-tab-item">
                                    <div>
                                        <p>Курс</p>
                                        <p>1 час 35 мин.</p>
                                    </div>
                                    <h3>Работа<br> без границ</h3>
                                    <p>Изучите техники усиления резюме, откликов на вакансии и прохождения интервью, чтобы не допускать частых ошибок</p>
                                </div>
                            </div>
                        </div>
                        <div class="vorkr-col">
                            <div class="careerum-vebinar-tab-item">
                                <div>
                                    <p>Вебинар</p>
                                    <p>1 час 37 мин.</p>
                                </div>
                                <h3>The other side: recruiter’s view on a job search</h3>
                            </div>
                            <div class="careerum-vebinar-tab-item careerum-bg-very-light-blue">
                                <div>
                                    <p>Эфир</p>
                                    <p>1 час 2 мин.</p>
                                </div>
                                <h3>Мультикультурная карьера</h3>
                            </div>
                        </div>
                    </div>
                    <div class="vorkr-row">
                        <div class="careerum-course-tab-item">
                            <div>
                                <p>Курс</p>
                                <p>2 часа 16 мин.</p>
                            </div>
                            <h3>Продающее резюме</h3>
                            <p>Научитесь грамотно формулировать свои достижения и создадите сильное резюме на двух языках, которое точно рассмотрят</p>
                        </div>
                        <div class="careerum-course-tab-item">
                            <div>
                                <p>Курс</p>
                                <p>2 часа 33 мин.</p>
                            </div>
                            <h3>Эффективное интервью</h3>
                            <p>Поймете, как выгодно подать себя на интервью, и научитесь отвечать даже на самые сложные вопросы рекрутера</p>
                        </div>
                        <div class="careerum-course-tab-item">
                            <div>
                                <p>Курс</p>
                                <p>2 часа 25 мин.</p>
                            </div>
                            <h3>Language of a Job Interview</h3>
                            <p>Learn job interview lifehacks and become confident with<br> a small-talk and common questions</p>
                        </div>
                    </div>
                    <div class="vorkr-row">
                        <div class="careerum-master-tab-item">
                            <div>
                                <p>Мастер-класс</p>
                                <p>46 мин.</p>
                            </div>
                            <div>
                                <h3>Hooked: как написать цепляющее сопрово-дительное письмо</h3>
                                <p>Научитесь писать сопроводительное письмо, которое поможет выделиться среди других
                                    соискателей<br> и получить оффер</p>
                            </div>
                        </div>
                        <div class="careerum-vebinar-tab-item">
                            <div>
                                <p>Вебинар</p>
                                <p>1 часа 41 мин.</p>
                            </div>
                            <h3>Communication with English-speaking colleagues</h3>
                        </div>
                    </div>
                </div>
                <div class="careerum-vorkr-tabs-accord-items-switcher">
                    <p>Посмотреть все материалы</p><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680626218030.svg" alt="">
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-vorkr-tabs-accord-block-tablet', {
        label: 'Воронка плашки курсы (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-vorkr-tabs-accord-block-tablet">
            <div>
                <div>
                    <h2>
                        Узнайте больше благодаря курсам<br> программы <span>«Международная<br> карьера и релокация»</span>
                    </h2>
                </div>
                <div class="careerum-vorkr-tabs-accord-items-wrapper">
                    <div class="vorkr-col">
                        <div class="vorkr-row">
                                <div class="careerum-course-tab-item-tablet">
                                    <div>
                                        <p>Курс</p>
                                        <p>2 часа 16 мин.</p>
                                    </div>
                                    <h3>Умная стратегия поиска работы</h3>
                                    <p>Создадите пошаговый план поиска работы, который приведет вас к офферу<br> мечты</p>
                                </div>
                                <div class="careerum-course-tab-item-tablet">
                                    <div>
                                        <p>Курс</p>
                                        <p>1 час 35 мин.</p>
                                    </div>
                                    <h3>Работа без границ</h3>
                                    <p>Составите пошаговый план поиска работы на международном рынке </p>
                                </div>
                        </div>
                        <div class="vorkr-row">
                            <div class="careerum-master-tab-item-tablet">
                                <div>
                                    <p>Мастер-класс</p>
                                    <p>46 мин.</p>
                                </div>
                                <div>
                                    <h3>Как написать цепляющее сопроводительное письмо</h3>
                                    <p>Научитесь писать сопроводительное письмо, которое выделит вас среди других соискателей</p>
                                </div>
                            </div>
                        </div>
                        <div class="vorkr-row">
                            <div class="vorkr-col">
                                <div class="careerum-vebinar-tab-item-tablet">
                                    <div>
                                        <p>Вебинар</p>
                                        <p>1 час 37 мин.</p>
                                    </div>
                                    <h3>The other side: recruiter’s view on a job search</h3>
                                </div>
                                <div class="careerum-vebinar-tab-item-tablet careerum-bg-very-light-blue">
                                    <div>
                                        <p>Эфир</p>
                                        <p>1 час 2 мин.</p>
                                    </div>
                                    <h3>Мультикультурная карьера</h3>
                                </div>
                            </div>
                            <div class="vorkr-col">
                                <div class="careerum-course-tab-item-tablet">
                                    <div>
                                        <p>Курс</p>
                                        <p>2 часа 16 мин.</p>
                                    </div>
                                    <h3>Продающее резюме</h3>
                                    <p>Научитесь грамотно формулировать свои достижения и создадите сильное резюме на двух языках, которое точно рассмотрят</p>
                                </div>
                            </div>
                        </div>
                        <div class="vorkr-row">
                            <div class="careerum-course-tab-item-tablet">
                                <div>
                                    <p>Курс</p>
                                    <p>2 часа 33 мин.</p>
                                </div>
                                <h3>Эффективное интервью</h3>
                                <p>Поймете, как выгодно подать себя на интервью, и научитесь отвечать даже на самые сложные вопросы рекрутера</p>
                            </div>
                            <div class="careerum-course-tab-item-tablet">
                                <div>
                                    <p>Курс</p>
                                    <p>2 часа 25 мин.</p>
                                </div>
                                <h3>Language of a Job Interview</h3>
                                <p>Learn job interview lifehacks and become confident with<br> a small-talk and common questions</p>
                            </div>
                        </div>
                        <div class="vorkr-row">
                            <div class="careerum-vebinar-tab-item-tablet">
                                <div>
                                    <p>Вебинар</p>
                                    <p>1 часа 41 мин.</p>
                                </div>
                                <h3>Communication with English-speaking colleagues</h3>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="careerum-vorkr-tabs-accord-items-switcher">
                    <p>Посмотреть все материалы</p><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680626218030.svg" alt="">
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-vorkr-tabs-accord-block-mobile', {
        label: 'Воронка плашки курсы (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-vorkr-tabs-accord-block-mobile">
            <div>
                <div>
                    <h2>
                        Узнайте больше благодаря курсам<br> программы <span>«Международная<br> карьера и релокация»</span>
                    </h2>
                </div>
                <div class="careerum-vorkr-tabs-accord-items-wrapper">
                    <div class="careerum-course-tab-item-mobile">
                        <div>
                            <p>Курс</p>
                            <p>2 часа 16 мин.</p>
                        </div>
                        <h3>Умная стратегия поиска работы</h3>
                        <p>Создадите пошаговый план поиска работы, который приведет вас к офферу<br> мечты</p>
                    </div>
                    <div class="careerum-vebinar-tab-item-mobile careerum-bg-very-light-blue">
                        <div>
                            <p>Эфир</p>
                            <p>1 час 2 мин.</p>
                        </div>
                        <h3>Мультикуль-турная карьера</h3>
                    </div>
                    <div class="careerum-course-tab-item-mobile">
                        <div>
                            <p>Курс</p>
                            <p>1 час 35 мин.</p>
                        </div>
                        <h3>Работа без границ</h3>
                        <p>Составите пошаговый план поиска работы на международном рынке </p>
                    </div>
                    <div class="careerum-vebinar-tab-item-mobile">
                        <div>
                            <p>Вебинар</p>
                            <p>1 час 37 мин.</p>
                        </div>
                        <h3>The other side: recruiter’s view<br> on a job search</h3>
                    </div>
                    <div class="careerum-master-tab-item-mobile">
                        <div>
                            <p>Мастер-класс</p>
                            <p>46 мин.</p>
                        </div>
                        <div>
                            <h3>Hooked: как напи-сать цепляющее сопроводительное письмо</h3>
                            <p>Научитесь писать письмо, которое поможет выделиться</p>
                        </div>
                    </div>
                    <div class="careerum-course-tab-item-mobile">
                        <div>
                            <p>Курс</p>
                            <p>2 часа 16 мин.</p>
                        </div>
                        <h3>Продающее резюме</h3>
                        <p>Научитесь грамотно формулировать достижения и создадите сильное резюме, которое точно рассмотрят</p>
                    </div>
                    <div class="careerum-course-tab-item-mobile">
                        <div>
                            <p>Курс</p>
                            <p>2 часа 33 мин.</p>
                        </div>
                        <h3>Эффективное интервью</h3>
                        <p>Поймете, как выгодно подать себя на интервью и научитесь отвечать даже на самые сложные вопросы рекрутера</p>
                    </div>
                    <div class="careerum-vebinar-tab-item-mobile">
                        <div>
                            <p>Вебинар</p>
                            <p>1 часа 41 мин.</p>
                        </div>
                        <h3>Communication with English-speaking colleagues</h3>
                    </div>
                    <div class="careerum-course-tab-item-mobile">
                        <div>
                            <p>Курс</p>
                            <p>2 часа 25 мин.</p>
                        </div>
                        <h3>Language of a Job Interview</h3>
                        <p>Learn job interview lifehacks and become confident with a small-talk and common questions</p>
                    </div>
                </div>
                <div class="careerum-vorkr-tabs-accord-slider-switcher">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680510798194.svg" alt="">
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-vorkr-tabs-row-button', {
        label: 'Воронка табы плитки с кнопкой',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-vorkr-tabs-row-button">
            <div>
                <div>
                    <h2><span>Демоурок задаст вектор развития. </span><br>
                    А построить международную карьеру<br> вы сможете в Careerum.Club</h2>
                </div>
                <div>
                    <div>
                        <p>Что сейчас ищут работодатели</p>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1678813857547.svg" alt="">
                    </div>
                    <div>
                        <p>Как быстро и эффективно начать нетворкинг</p>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1678813860691.svg" alt="">
                    </div>
                    <div>
                        <p>Какие сферы устойчивее переносят экономический кризис</p>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1678813864646.svg" alt="">
                    </div>
                    <div>
                        <p>Почему для эффективного поиска нужно знать свои<br> «Хочу – Могу – Надо»</p>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1678813871342.svg" alt="">
                    </div>
                </div>
                <div>
                    <a href="#" class="btn-color-main-dark-orange">Хочу в Careerum.Club!</a>
                </div>
            </div>
        </div>`
    });
    
    blockManager.add('careerum-vorkr-tabs-row-button-tablet', {
        label: 'Воронка табы плитки с кнопкой (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-vorkr-tabs-row-button-tablet">
            <div>
                <div>
                    <h2>Сделать международную карьеру реальнее, чем вы думаете. <span>В Careerum.Club вас ждет</span></h2>
                </div>
                <div>
                    <div>
                        <p>Что сейчас ищут работодатели</p>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1678813917275.svg" alt="">
                    </div>
                    <div>
                        <p>Как быстро<br> и эффективно начать нетворкинг</p>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1678813919383.svg" alt="">
                    </div>
                    <div>
                        <p>Какие сферы<br> устойчивее переносят экономический кризис</p>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1678813923121.svg" alt="">
                    </div>
                    <div>
                        <p>Почему для эффективного поиска нужно знать свои «Хочу – Могу – Надо»</p>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1678813926480.svg" alt="">
                    </div>
                </div>
                <div>
                    <a href="#" class="btn-color-main-dark-orange">Хочу в Careerum.Club!</a>
                </div>
            </div>
        </div>`
    });
    
    blockManager.add('careerum-vorkr-tabs-row-button-mobile', {
        label: 'Воронка табы плитки с кнопкой (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-vorkr-tabs-row-button-mobile">
            <div>
                <div>
                    <h2>Сделать международную карьеру реальнее, чем вы думаете. <span>В Careerum.Club вас ждет</span></h2>
                </div>
                <div>
                    <div>
                        <p>Что сейчас ищут работодатели</p>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1678813975303.svg" alt="">
                    </div>
                    <div>
                        <p>Как быстро и эффективно начать нетворкинг</p>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1678813977149.svg" alt="">
                    </div>
                    <div>
                        <p>Какие сферы устойчивее переносят экономи-ческий кризис</p>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1678813979691.svg" alt="">
                    </div>
                    <div>
                        <p>Почему для эффектив-ного поиска нужно знать свои «Хочу – Могу – <br>Надо»</p>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1678813982245.svg" alt="">
                    </div>
                </div>
                <div>
                    <a href="#" class="btn-color-main-dark-orange">Хочу в Careerum.Club!</a>
                </div>
            </div>
        </div>`
    });

    blockManager.add('careerum-vorkr-results', {
        label: 'Воронка результаты',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-vorkr-results">
            <div>
                <div>
                    <h2>
                        Мы поможем вам достичь своей цели.<br>
                        Даже самой масштабной!
                    </h2>
                </div>
                <div>
                    <div>
                        <div>
                            <p>450%</p>
                            <p>рекорд повышения<br> зарплаты в Careerum</p>
                        </div>
                        <div>
                            <p>на 82%</p>
                            <p>в среднем увеличился<br> доход участников клуба</p>
                        </div>
                    </div>
                    <div>
                        <div>
                            <p>9 из 10</p>
                            <p>рекомендуют курсы<br> Careerum знакомым</p>
                        </div>
                        <div>
                            <p>9,3/10</p>
                            <p>средняя оценка клубовцев после работы с коучами</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
    });
    
    blockManager.add('careerum-vorkr-results-tablet', {
        label: 'Воронка результаты (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-vorkr-results-tablet">
            <div>
                <div>
                    <h2>
                        Мы поможем вам достичь<br> своей цели.<br>
                        Даже самой масштабной!
                    </h2>
                </div>
                <div>
                    <div>
                        <div>
                            <p>450%</p>
                            <p>рекорд повышения<br> зарплаты в Careerum</p>
                        </div>
                        <div>
                            <p>на 82%</p>
                            <p>в среднем увеличился<br> доход участников клуба</p>
                        </div>
                    </div>
                    <div>
                        <div>
                            <p>9 из 10</p>
                            <p>рекомендуют курсы<br> Careerum знакомым</p>
                        </div>
                        <div>
                            <p>9,3/10</p>
                            <p>средняя оценка клубовцев после работы с коучами</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
    });
    
    blockManager.add('careerum-vorkr-results-mobile', {
        label: 'Воронка результаты (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-vorkr-results-mobile">
            <div>
                <div>
                    <h2>
                        Мы поможем вам достичь своей цели.<br>
                        Даже самой масштабной!
                    </h2>
                </div>
                <div>
                    <div>
                        <div>
                            <p>450%</p>
                            <p>рекорд повышения<br> зарплаты в Careerum</p>
                        </div>
                        <div>
                            <p>на 82%</p>
                            <p>в среднем увеличился<br> доход участников клуба</p>
                        </div>
                    </div>
                    <div>
                        <div>
                            <p>9 из 10</p>
                            <p>рекомендуют курсы<br> Careerum знакомым</p>
                        </div>
                        <div>
                            <p>9,3/10</p>
                            <p>средняя оценка<br> клубовцев после<br> работы с коучами</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
    });

    blockManager.add('careerum-vorkr-thanks', {
        label: 'Воронка спасибо',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-vorkr-thanks">
            <div>
                <h2>Спасибо! Скоро вам<br> на почту придет<br> <span>письмо <i>с гайдом</i></span></h2>
            </div>
        </div>`
    });
    
    blockManager.add('careerum-vorkr-thanks-tablet', {
        label: 'Воронка спасибо (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-vorkr-thanks-tablet">
            <div>
                <h2>Спасибо! Скоро вам<br> на почту придет<br> <span>письмо <i>с гайдом</i></span></h2>
            </div>
        </div>`
    });
    
    blockManager.add('careerum-vorkr-thanks-mobile', {
        label: 'Воронка спасибо (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-vorkr-thanks-mobile">
            <div>
                <h2>Спасибо! Скоро вам на почту придет <span>письмо<br> <i>с гайдом</i></span></h2>
            </div>
        </div>`
    });
    
    blockManager.add('careerum-lead-form-sheets-row', {
        label: 'Лид форма Sheets',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-lead-form-sheets-row">
            <div>
                <div class="careerum-getcourse-email-form-lead">
                    <div class="careerum-form-lead">
                        <div>
                            <h2>Квест в день рождения<br> Careerum!</h2>
                            <p><span>5 букв</span> с нетерпением хотят сложиться в слово. Соберите его и получите шанс забрать секретный приз от Ольги Лермонтовой! </p>
                            <p>Всего будет <span>4 победителя</span>. Первый — тот, <br>кто нашел слово раньше всех. А троих мы выберем рандомно.</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1678995262226.svg" alt="">
                        </div>
                        <div>
                            <form class="deva-form getcourse-email-signup" name="devaRegistrationForm" data-gjs-type="deva-registration-form">
                                <div class="careerum-form-lead-word hidden">
                                    <div>
                                        <p>
                                            Готовы вписать кодовое слово? Let’s go!
                                        </p>
                                    </div>
                                    <div>
                                        <input type="text" name="word" value="" placeholder=" " required>
                                        <span>Слово</span>
                                    </div>
                                </div>
                                <div class="careerum-form-lead-notification hidden">
                                    <p>Оставьте данные, чтобы мы с вами связались в случае победы:</p>
                                </div>
                                <div class="careerum-form-lead-flex">
                                    <div>
                                        <div class="careerum-form-lead-name">
                                            <input type="text" name="name" value="" placeholder=" " required>
                                            <span>Имя</span>
                                        </div>
                                        <div class="careerum-form-lead-email">
                                            <input type="email" name="email" value="" placeholder=" " required>
                                            <span>Почта</span>
                                        </div>
                                        <div class="careerum-form-lead-tel">
                                            <input type="tel" name="tel" value="" placeholder=" " required>
                                            <span>Номер телефона</span>
                                        </div>
                                    </div>
                                    <div class="careerum-form-lead-agree">
                                        <label data-toggle-checkbox="true">
                                            <input type="checkbox" name="agree">
                                        </label>
                                        <p>Я даю согласие на обработку своих <br>персональных данных в соответствии <br>с <a href="#">Политикой конфиденциальности</a>
                                    </div>
                                    <a href="#" disabled class="submit-btn">Получить демоурок</a>
                                </div>
                                <div class="careerum-form-lead-contact">
                                    <div>
                                        <p>Хочу получить карьерную консультацию по телефону:</p>
                                    </div>
                                    <div>
                                        <div>
                                            <input type="radio" value="yes" checked>
                                            <p>Да</p>
                                        </div>
                                        <div>
                                            <input type="radio" value="no">
                                            <p>Нет</p>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                    <div class="careerum-form-success-lead">
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1668598146404.svg" alt="" class="careerum-form-success-lead-heart">
                            <h2>Спасибо! В случае победы мы обязательно с вами свяжемся</h2>
                        </div>                    
                    </div>                    
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-lead-form-sheets-row-tablet', {
        label: 'Лид форма Sheets (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-lead-form-sheets-row-tablet">
            <div>
                <div class="careerum-getcourse-email-form-lead">
                    <div class="careerum-form-lead">
                        <div>
                            <h2>Квест в день рождения<br> Careerum!</h2>
                            <p><span>5 букв</span> с нетерпением хотят сложиться в слово. Соберите его и получите шанс забрать секретный приз от Ольги Лермонтовой! </p>
                            <p>Всего будет <span>4 победителя</span>. Первый — тот, <br>кто нашел слово раньше всех. А троих мы выберем рандомно.</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1678995262226.svg" alt="">
                        </div>
                        <div>
                            <form class="deva-form getcourse-email-signup" name="devaRegistrationForm" data-gjs-type="deva-registration-form">
                                <div class="careerum-form-lead-word">
                                    <div>
                                        <p>
                                            Готовы вписать кодовое слово?<br> Let’s go!
                                        </p>
                                    </div>
                                    <div>
                                        <input type="text" name="word" value="" placeholder=" " required>
                                        <span>Слово</span>
                                    </div>
                                </div>
                                <div class="careerum-form-lead-notification">
                                    <p>Оставьте данные, чтобы мы с вами <br>связались в случае победы:</p>
                                </div>
                                <div class="careerum-form-lead-flex">
                                    <div>
                                        <div class="careerum-form-lead-name">
                                            <input type="text" name="name" value="" placeholder=" " required>
                                            <span>Имя</span>
                                        </div>
                                        <div class="careerum-form-lead-email">
                                            <input type="email" name="email" value="" placeholder=" " required>
                                            <span>Почта</span>
                                        </div>
                                        <div class="careerum-form-lead-tel">
                                            <input type="tel" name="tel" value="" placeholder=" " required>
                                            <span>Номер телефона</span>
                                        </div>
                                    </div>
                                    <div class="careerum-form-lead-contact">
                                        <div>
                                            <p>Хочу получить карьерную консультацию по телефону:</p>
                                        </div>
                                        <div>
                                            <div>
                                                <input type="radio" value="yes" checked>
                                                <p>Да</p>
                                            </div>
                                            <div>
                                                <input type="radio" value="no">
                                                <p>Нет</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="careerum-form-lead-agree">
                                        <label data-toggle-checkbox="true">
                                            <input type="checkbox" name="agree">
                                        </label>
                                        <p>Я даю согласие на обработку своих <br>персональных данных в соответствии <br>с <a href="#">Политикой конфиденциальности</a>
                                    </div>
                                    <a href="#" disabled class="submit-btn">Участвовать в квесте</a>
                                </div>
                            </form>
                        </div>
                    </div>
                    <div class="careerum-form-success-lead">
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1668598191411.svg" alt="" class="careerum-form-success-lead-heart">
                            <h2>Спасибо! В случае победы мы обязательно с вами свяжемся</h2>
                        </div>                    
                    </div>                    
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-lead-form-sheets-row-mobile', {
        label: 'Лид форма Sheets (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-lead-form-sheets-row-mobile">
            <div>
                <div class="careerum-getcourse-email-form-lead">
                    <div class="careerum-form-lead">
                        <div>
                            <h2>Квест в день рождения<br> Careerum!</h2>
                            <p><span>5 букв</span> с нетерпением хотят сложиться <br>в слово. Соберите его и получите шанс забрать секретный приз от Ольги Лермонтовой! </p>
                            <p>Всего будет <span>4 победителя</span>. Первый — <br>тот, кто нашел слово раньше всех. <br>А троих мы выберем рандомно.</p>
                        </div>
                        <div>
                            <form class="deva-form getcourse-email-signup" name="devaRegistrationForm" data-gjs-type="deva-registration-form">
                                <div class="careerum-form-lead-word">
                                    <div>
                                        <p>
                                            Готовы вписать кодовое слово?<br> Let’s go!
                                        </p>
                                    </div>
                                    <div>
                                        <input type="text" name="word" value="" placeholder=" " required>
                                        <span>Слово</span>
                                    </div>
                                </div>
                                <div class="careerum-form-lead-notification">
                                    <p>Оставьте данные, чтобы мы с вами <br>связались в случае победы:</p>
                                </div>
                                <div class="careerum-form-lead-flex">
                                    <div>
                                        <div class="careerum-form-lead-name">
                                            <input type="text" name="name" value="" placeholder=" " required>
                                            <span>Имя</span>
                                        </div>
                                        <div class="careerum-form-lead-email">
                                            <input type="email" name="email" value="" placeholder=" " required>
                                            <span>Почта</span>
                                        </div>
                                        <div class="careerum-form-lead-tel">
                                            <input type="tel" name="tel" value="" placeholder=" " required>
                                            <span>Номер телефона</span>
                                        </div>
                                    </div>
                                    <div class="careerum-form-lead-contact">
                                        <div>
                                            <p>Хочу получить карьерную консультацию по телефону:</p>
                                        </div>
                                        <div>
                                            <div>
                                                <input type="radio" value="yes" checked>
                                                <p>Да</p>
                                            </div>
                                            <div>
                                                <input type="radio" value="no">
                                                <p>Нет</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="careerum-form-lead-agree">
                                        <label data-toggle-checkbox="true">
                                            <input type="checkbox" name="agree">
                                        </label>
                                        <p>Я даю согласие на обработку своих <br>персональных данных в соответствии <br>с <a href="#">Политикой конфиденциальности</a>
                                    </div>
                                    <a href="#" disabled class="submit-btn">Участвовать в квесте</a>
                                </div>
                            </form>
                        </div>
                    </div>
                    <div class="careerum-form-success-lead">
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1668598233783.svg" alt="" class="careerum-form-success-lead-heart">
                            <h2>Спасибо! В случае победы мы обязательно <br>с вами свяжемся</h2>
                        </div>                    
                    </div>                    
                </div>
            </div>
        </div>`
	});
    
    blockManager.add('careerum-club2-main', {
        label: 'Страница Клуб 2 первый экран',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-club2-main">
            <div>
                <div>
                    <h1>Careerum.Club <br>
                        Платформа для старта<br> и развития карьеры</h1>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680509917476.svg" alt="">
                </div>
                <div>
                    <div>
                        <p>С нами<br> у вас<br> получится</p>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680509929962.svg" alt="">
                    </div>
                    <div>
                        <div>
                            <p>Вырасти <br>в зарплате <br>и в должности</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680509947018.svg" alt="">
                        </div>
                        <div>
                            <p>Начать<br> успешную<br> карьеру на<br> международном<br> рынке</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680509959727.svg" alt="">
                        </div>
                        <div>
                            <p>Найти работу<br> в новой сфере</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680509977158.svg" alt="">
                        </div>
                        <div>
                            <p>Укрепить<br> самооценку<br> и выбрать<br> карьерный<br> вектор</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680509985566.svg" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-club2-main-tablet', {
        label: 'Страница Клуб 2 первый экран (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-club2-main-tablet">
            <div>
                <div>
                    <h2>Careerum.Club <br>
                        Платформа для старта<br> и развития карьеры</h2>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680510069409.svg" alt="">
                </div>
                <div>
                    <div>
                        <p>С нами у вас получится</p>
                    </div>
                    <div>
                        <div>
                            <p>Вырасти <br>в зарплате <br>и в должности</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680509947018.svg" alt="">
                        </div>
                        <div>
                            <p>Начать успешную<br> карьеру на<br> международном<br> рынке</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680509959727.svg" alt="">
                        </div>
                        <div>
                            <p>Найти работу<br> в новой сфере</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680509977158.svg" alt="">
                        </div>
                        <div>
                            <p>Укрепить<br> самооценку<br> и выбрать<br> карьерный<br> вектор</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680509985566.svg" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-club2-main-mobile', {
        label: 'Страница Клуб 2 первый экран (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-club2-main-mobile">
            <div>
                <div>
                    <h2>Careerum.Club <br>
                        Платформа для старта<br> и развития карьеры</h2>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680510093789.svg" alt="">
                </div>
                <div>
                    <div>
                        <p>С нами у вас получится</p>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680510105470.svg" alt="">
                    </div>
                    <div>
                        <div>
                            <p>Вырасти в зарплате<br>и в должности</p>
                        </div>
                        <div>
                            <p>Начать успешную карьеру<br> на международном рынке</p>
                        </div>
                        <div>
                            <p>Найти работу в новой сфере</p>
                        </div>
                        <div>
                            <p>Укрепить самооценку и выбрать<br> карьерный вектор</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
	});
    
    blockManager.add('careerum-club2-results', {
        label: 'Страница Клуб 2 кейсы',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-club2-results">
            <div>
                <div>
                    <h2>10 000+ человек<br>
                        уже перезапустили свою карьеру</h2>
                </div>
                <div class="club2-results-slider">
                    <div class="results-slider-item1">
                        <div>
                            <div>
                                <p class="results-slider-item1__header">на 82%</p>
                                <p class="results-slider-item1__text">в среднем растет зарплата участников клуба</p>
                                <p class="results-slider-item1__header">450%</p>
                                <p class="results-slider-item1__text">рекорд повышения зарплаты в Careerum</p>
                                <p class="results-slider-item1__header">9 из 10</p>
                                <p class="results-slider-item1__text">участников рекомендуют клуб друзьям</p>
                            </div>
                        </div>
                    </div>
                    <div class="results-slider-item2">
                        <div class="results-slider-item2__top">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680510295861.png" alt=""  class="results-slider-item2__top-avatar">
                                <div  class="results-slider-item2__top-ln">
                                    <a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680510310279.svg" alt=""></a>
                                </div>
                            </div>
                            <div>
                                <p class="results-slider-item2__top-header">Сергей Михайлов</p>
                                <p class="results-slider-item2__top-text">Technical transfer lead, Австрия</p>
                            </div>
                        </div>
                        <div class="results-slider-item2__bottom">
                            <ul>
                                <li>Хотел найти работу проджет-менеджера в международной компании и переехать в Западную Европу</li>
                                <li>Прошел Real Me, «Звёздного кандидата», проработал резюме<br> и составил стратегию</li>
                                <li>Получил оффер c релокацией в Австрию весной 2022 года,<br> увеличил доход в 3 раза</li>
                            </ul>
                        </div>
                    </div>
                    <div class="results-slider-item2">
                        <div class="results-slider-item2__top">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680510356975.png" alt=""  class="results-slider-item2__top-avatar">
                                <div  class="results-slider-item2__top-ln">
                                    <a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680510310279.svg" alt=""></a>
                                </div>
                            </div>
                            <div>
                                <p class="results-slider-item2__top-header">Александра Пинчукова</p>
                                <p class="results-slider-item2__top-text">менеджер бизнес-процессов, Германия</p>
                            </div>
                        </div>
                        <div class="results-slider-item2__bottom">
                            <ul>
                                <li>Работала главным бухгалтером. Хотела найти работу в Германии и переехать</li>
                                <li>Прошла «Звёздного кандидата», курсы по LinkedIn и самооценку, работала с коучем и CV-специалистом</li>
                                <li>Получила оффер в штаб-квартиру Puma в начале 2023 года – после 3 месяцев поиска</li>
                            </ul>
                        </div>
                    </div>
                    <div class="results-slider-item2">
                        <div class="results-slider-item2__top">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680510370489.png" alt=""  class="results-slider-item2__top-avatar">
                                <div  class="results-slider-item2__top-ln">
                                    <a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680510310279.svg" alt=""></a>
                                </div>
                            </div>
                            <div>
                                <p class="results-slider-item2__top-header">Сергей Бухаров</p>
                                <p class="results-slider-item2__top-text">Supply Chain Forecast Analyst, Нидерланды</p>
                            </div>
                        </div>
                        <div class="results-slider-item2__bottom">
                            <ul>
                                <li>Уволился из Mars весной 2022 года, так как не смог договориться о релокации, переехал из России в Грузию</li>
                                <li>Прошел курс Real Me, персонально работал с экспертом клуба, составил стратегию</li>
                                <li>Получил оффер от Mars с релокацией в<br> Нидерланды в середине 2022 года</li>
                            </ul>
                        </div>
                    </div>
                    <div class="results-slider-item2">
                        <div class="results-slider-item2__top">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680510383207.png" alt=""  class="results-slider-item2__top-avatar">
                                <div  class="results-slider-item2__top-ln">
                                    <a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680510310279.svg" alt=""></a>
                                </div>
                            </div>
                            <div>
                                <p class="results-slider-item2__top-header">Карина Пысина</p>
                                <p class="results-slider-item2__top-text">бизнес-аналитик, Россия</p>
                            </div>
                        </div>
                        <div class="results-slider-item2__bottom">
                            <ul>
                                <li>Пыталась перейти в бизнес-анализ из клиентского отдела, но не смогла и уволилась вникуда</li>
                                <li>Прошла Real Me, «Звёздного кандидата», работала с коучем, составила продающее резюме</li>
                                <li>Получила оффер бизнес-аналитика, зарплату на 100% выше в 2022 году</li>
                            </ul>
                        </div>
                    </div>
                    <div class="results-slider-item2">
                        <div class="results-slider-item2__top">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680510392778.png" alt=""  class="results-slider-item2__top-avatar">
                                <div  class="results-slider-item2__top-ln">
                                    <a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680510310279.svg" alt=""></a>
                                </div>
                            </div>
                            <div>
                                <p class="results-slider-item2__top-header">Тая Штоль</p>
                                <p class="results-slider-item2__top-text">UX/UI-дизайнер, Испания</p>
                            </div>
                        </div>
                        <div class="results-slider-item2__bottom">
                            <ul>
                                <li>Потеряла всех клиентов из России в феврале 2022 года. Хотела в найм, но опыт был только во фрилансе</li>
                                <li>Прошла программы «Звёздный кандидат» и «Выход из декрета», работала с коучем</li>
                                <li>Получила оффер в немецкую компанию. Увеличила доход в 6 раз, получила соцпакет</li>
                            </ul>
                        </div>
                    </div>
                    <div class="results-slider-item2">
                        <div class="results-slider-item2__top">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680510407061.png" alt=""  class="results-slider-item2__top-avatar">
                                <div  class="results-slider-item2__top-ln">
                                    <a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680510310279.svg" alt=""></a>
                                </div>
                            </div>
                            <div>
                                <p class="results-slider-item2__top-header">Евгения Вольхина</p>
                                <p class="results-slider-item2__top-text">Project Manager, Германия</p>
                            </div>
                        </div>
                        <div class="results-slider-item2__bottom">
                            <ul>
                                <li>Работала консультантом-методологом в Екатеринбурге. Хотела стать project manager в Германии</li>
                                <li>Прошла «Звёздного кандидата», прокачала CV, выстроила нетворк</li>
                                <li>Получила оффер в Big4 в Москве и зарплату в 3,5 раза больше, потом – оффер в Германию с ростом ещё на 40%</li>
                            </ul>
                        </div>
                    </div>
                    <div class="results-slider-item2">
                        <div class="results-slider-item2__top">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680510418438.png" alt=""  class="results-slider-item2__top-avatar">
                                <div  class="results-slider-item2__top-ln">
                                    <a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680510310279.svg" alt=""></a>
                                </div>
                            </div>
                            <div>
                                <p class="results-slider-item2__top-header">Олег Федоткин</p>
                                <p class="results-slider-item2__top-text">Head of Department, Германия</p>
                            </div>
                        </div>
                        <div class="results-slider-item2__bottom">
                            <ul>
                                <li>Не мог найти работу в Германии, не хотел возвращаться в Москву после окончания контракта Henkel</li>
                                <li>Прошел Real Me, составил стратегию, прорабатывал запрос в паре с участником клуба</li>
                                <li>Получил оффер на head-позицию с ростом зарплаты на 30% в начале 2022 года</li>
                            </ul>
                        </div>
                    </div>
                    <div class="results-slider-item2">
                        <div class="results-slider-item2__top">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680510428678.png" alt=""  class="results-slider-item2__top-avatar">
                                <div  class="results-slider-item2__top-ln">
                                    <a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680510310279.svg" alt=""></a>
                                </div>
                            </div>
                            <div>
                                <p class="results-slider-item2__top-header">Людмила Киселёва</p>
                                <p class="results-slider-item2__top-text">Recruiter ll, США</p>
                            </div>
                        </div>
                        <div class="results-slider-item2__bottom">
                            <ul>
                                <li>Приехала в США как турист, осталась там, работала ассистентом. Хотела начать карьеру<br> в корпорации</li>
                                <li>Прошла курсы<br> «Продающее резюме» и «Эффективное<br> интервью».</li>
                                <li>Получила оффер ассистента в Microsoft, через год стала рекрутером в Transocean</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div>
                    <a href="#" class="btn-color-main-dark-orange">Хочу такой результат</a>
                    <div>
                        <div class="club2-results-slider__arrow-left">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680510826990.svg" alt="">
                        </div>
                        <div class="club2-results-slider__arrow-right">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680510798194.svg" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-club2-results-tablet', {
        label: 'Страница Клуб 2 кейсы (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-club2-results-tablet">
            <div>
                <div>
                    <h2>10 000+ человек
                        уже перезапустили<br> свою карьеру</h2>
                </div>
                <div class="club2-results-slider">
                    <div class="results-slider-item1">
                        <div>
                            <div>
                                <p class="results-slider-item1__header">на 82%</p>
                                <p class="results-slider-item1__text">в среднем растет зарплата участников клуба</p>
                                <p class="results-slider-item1__header">450%</p>
                                <p class="results-slider-item1__text">рекорд повышения зарплаты в Careerum</p>
                                <p class="results-slider-item1__header">9 из 10</p>
                                <p class="results-slider-item1__text">участников рекомендуют клуб друзьям</p>
                            </div>
                        </div>
                    </div>
                    <div class="results-slider-item2">
                        <div class="results-slider-item2__top">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680510295861.png" alt=""  class="results-slider-item2__top-avatar">
                                <div  class="results-slider-item2__top-ln">
                                    <a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680510310279.svg" alt=""></a>
                                </div>
                            </div>
                            <div>
                                <p class="results-slider-item2__top-header">Сергей Михайлов</p>
                                <p class="results-slider-item2__top-text">Technical transfer lead, Австрия</p>
                            </div>
                        </div>
                        <div class="results-slider-item2__bottom">
                            <ul>
                                <li>Хотел найти работу проджет-менеджера<br> в международной компании и переехать<br> в Западную Европу</li>
                                <li>Прошел Real Me, «Звёздного кандидата», проработал резюме<br> и составил стратегию</li>
                                <li>Получил оффер<br> c релокацией в Австрию весной 2022 года,<br> увеличил доход в 3 раза</li>
                            </ul>
                        </div>
                    </div>
                    <div class="results-slider-item2">
                        <div class="results-slider-item2__top">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680510356975.png" alt=""  class="results-slider-item2__top-avatar">
                                <div  class="results-slider-item2__top-ln">
                                    <a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680510310279.svg" alt=""></a>
                                </div>
                            </div>
                            <div>
                                <p class="results-slider-item2__top-header">Александра Пинчукова</p>
                                <p class="results-slider-item2__top-text">менеджер процессов, Германия</p>
                            </div>
                        </div>
                        <div class="results-slider-item2__bottom">
                            <ul>
                                <li>Работала главным бухгалтером. Хотела<br> найти работу в Германии<br> и переехать</li>
                                <li>Прошла «Звёздного кандидата», курсы по LinkedIn и самооценку, работала с коучем и CV-специалистом</li>
                                <li>Получила оффер в штаб-квартиру Puma в начале 2023 года – после 3 месяцев поиска</li>
                            </ul>
                        </div>
                    </div>
                    <div class="results-slider-item2">
                        <div class="results-slider-item2__top">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680510370489.png" alt=""  class="results-slider-item2__top-avatar">
                                <div  class="results-slider-item2__top-ln">
                                    <a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680510310279.svg" alt=""></a>
                                </div>
                            </div>
                            <div>
                                <p class="results-slider-item2__top-header">Сергей Бухаров</p>
                                <p class="results-slider-item2__top-text">Supply Chain Forecast Analyst, Нидерланды</p>
                            </div>
                        </div>
                        <div class="results-slider-item2__bottom">
                            <ul>
                                <li>Уволился из Mars весной 2022 года, так как не смог договориться о<br> релокации, переехал из России в Грузию</li>
                                <li>Прошел курс Real Me, персонально работал с экспертом клуба, составил стратегию</li>
                                <li>Получил оффер<br> от Mars с релокацией<br> в Нидерланды в<br> середине 2022 года</li>
                            </ul>
                        </div>
                    </div>
                    <div class="results-slider-item2">
                        <div class="results-slider-item2__top">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680510383207.png" alt=""  class="results-slider-item2__top-avatar">
                                <div  class="results-slider-item2__top-ln">
                                    <a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680510310279.svg" alt=""></a>
                                </div>
                            </div>
                            <div>
                                <p class="results-slider-item2__top-header">Карина Пысина</p>
                                <p class="results-slider-item2__top-text">бизнес-аналитик, Россия</p>
                            </div>
                        </div>
                        <div class="results-slider-item2__bottom">
                            <ul>
                                <li>Пыталась перейти в бизнес-анализ из клиентского отдела,<br> но не смогла и<br> уволилась вникуда</li>
                                <li>Прошла Real Me,<br> «Звёздного кандидата»,<br> работала с коучем,<br> составила продающее резюме</li>
                                <li>Получила оффер бизнес-аналитика, зарплату на 100% выше в 2022 году</li>
                            </ul>
                        </div>
                    </div>
                    <div class="results-slider-item2">
                        <div class="results-slider-item2__top">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680510392778.png" alt=""  class="results-slider-item2__top-avatar">
                                <div  class="results-slider-item2__top-ln">
                                    <a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680510310279.svg" alt=""></a>
                                </div>
                            </div>
                            <div>
                                <p class="results-slider-item2__top-header">Тая Штоль</p>
                                <p class="results-slider-item2__top-text">UX/UI-дизайнер,<br> Испания</p>
                            </div>
                        </div>
                        <div class="results-slider-item2__bottom">
                            <ul>
                                <li>Потеряла всех клиентов<br> из России в феврале 2022 года. Хотела в найм,<br> но опыт был только во фрилансе</li>
                                <li>Прошла программы «Звёздный кандидат»<br> и «Выход из декрета», работала с коучем</li>
                                <li>Получила оффер в<br> немецкую компанию. Увеличила доход в 6 раз, получила соцпакет</li>
                            </ul>
                        </div>
                    </div>
                    <div class="results-slider-item2">
                        <div class="results-slider-item2__top">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680510407061.png" alt=""  class="results-slider-item2__top-avatar">
                                <div  class="results-slider-item2__top-ln">
                                    <a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680510310279.svg" alt=""></a>
                                </div>
                            </div>
                            <div>
                                <p class="results-slider-item2__top-header">Евгения Вольхина</p>
                                <p class="results-slider-item2__top-text">Project Manager, Германия</p>
                            </div>
                        </div>
                        <div class="results-slider-item2__bottom">
                            <ul>
                                <li>Работала консультантом-<br>методологом в<br> Екатеринбурге. Хотела стать project manager<br> в Германии</li>
                                <li>Прошла «Звёздного<br> кандидата», прокачала<br> CV, выстроила нетворк</li>
                                <li>Получила оффер в Big4<br> в Москве и зарплату<br> в 3,5 раза больше, потом<br> – оффер в Германию<br> с ростом ещё на 40%</li>
                            </ul>
                        </div>
                    </div>
                    <div class="results-slider-item2">
                        <div class="results-slider-item2__top">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680510418438.png" alt=""  class="results-slider-item2__top-avatar">
                                <div  class="results-slider-item2__top-ln">
                                    <a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680510310279.svg" alt=""></a>
                                </div>
                            </div>
                            <div>
                                <p class="results-slider-item2__top-header">Олег Федоткин</p>
                                <p class="results-slider-item2__top-text">Head of Department, Германия</p>
                            </div>
                        </div>
                        <div class="results-slider-item2__bottom">
                            <ul>
                                <li>Не мог найти работу<br> в Германии, не хотел возвращаться в Москву после окончания контракта Henkel</li>
                                <li>Прошел Real Me, составил стратегию, прорабатывал запрос в паре с участником клуба</li>
                                <li>Получил оффер<br> на head-позицию с ростом зарплаты на 30%<br> в начале 2022 года</li>
                            </ul>
                        </div>
                    </div>
                    <div class="results-slider-item2">
                        <div class="results-slider-item2__top">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680510428678.png" alt=""  class="results-slider-item2__top-avatar">
                                <div  class="results-slider-item2__top-ln">
                                    <a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680510310279.svg" alt=""></a>
                                </div>
                            </div>
                            <div>
                                <p class="results-slider-item2__top-header">Людмила Киселёва</p>
                                <p class="results-slider-item2__top-text">Recruiter ll, США</p>
                            </div>
                        </div>
                        <div class="results-slider-item2__bottom">
                            <ul>
                                <li>Приехала в США как<br> турист, осталась там, работала ассистентом. Хотела начать карьеру<br> в корпорации</li>
                                <li>Прошла курсы<br> «Продающее резюме»<br> и «Эффективное интервью».</li>
                                <li>Получила оффер ассистента в Microsoft,<br> через год стала<br> рекрутером в Transocean</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div>
                    <a href="#" class="btn-color-main-dark-orange">Хочу такой результат</a>
                        <div class="club2-results-slider__arrow-right">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680510798194.svg" alt="">
                        </div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-club2-results-mobile', {
        label: 'Страница Клуб 2 кейсы (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-club2-results-mobile">
            <div>
                <div>
                    <h2>10 000+ человек
                        уже<br> перезапустили карьеру</h2>
                </div>
                <div class="club2-results-slider">
                    <div class="results-slider-item1">
                        <div>
                            <div>
                                <p class="results-slider-item1__header">на 82%</p>
                                <p class="results-slider-item1__text">в среднем растет зарплата участников клуба</p>
                                <p class="results-slider-item1__header">450%</p>
                                <p class="results-slider-item1__text">рекорд повышения зарплаты в Careerum</p>
                                <p class="results-slider-item1__header">9 из 10</p>
                                <p class="results-slider-item1__text">участников рекомендуют Careerum друзьям</p>
                            </div>
                        </div>
                    </div>
                    <div class="results-slider-item2">
                        <div class="results-slider-item2__top">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680510295861.png" alt=""  class="results-slider-item2__top-avatar">
                                <div  class="results-slider-item2__top-ln">
                                    <a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680510310279.svg" alt=""></a>
                                </div>
                            </div>
                            <div>
                                <p class="results-slider-item2__top-header">Сергей Михайлов</p>
                                <p class="results-slider-item2__top-text">Technical transfer lead, Австрия</p>
                            </div>
                        </div>
                        <div class="results-slider-item2__bottom">
                            <ul>
                                <li>Хотел найти работу проджет-менеджера<br> в международной компании и переехать<br> в Западную Европу</li>
                                <li>Прошел Real Me, «Звёздного кандидата», проработал резюме<br> и составил стратегию</li>
                                <li>Получил оффер<br> c релокацией в Австрию весной 2022 года,<br> увеличил доход в 3 раза</li>
                            </ul>
                        </div>
                    </div>
                    <div class="results-slider-item2">
                        <div class="results-slider-item2__top">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680510356975.png" alt=""  class="results-slider-item2__top-avatar">
                                <div  class="results-slider-item2__top-ln">
                                    <a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680510310279.svg" alt=""></a>
                                </div>
                            </div>
                            <div>
                                <p class="results-slider-item2__top-header">Александра Пинчукова</p>
                                <p class="results-slider-item2__top-text">менеджер процессов, Германия</p>
                            </div>
                        </div>
                        <div class="results-slider-item2__bottom">
                            <ul>
                                <li>Работала главным бухгалтером. Хотела<br> найти работу в Германии<br> и переехать</li>
                                <li>Прошла «Звёздного кандидата», курсы по LinkedIn и самооценку, работала с коучем и CV-специалистом</li>
                                <li>Получила оффер в штаб-квартиру Puma в начале 2023 года – после 3 месяцев поиска</li>
                            </ul>
                        </div>
                    </div>
                    <div class="results-slider-item2">
                        <div class="results-slider-item2__top">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680510370489.png" alt=""  class="results-slider-item2__top-avatar">
                                <div  class="results-slider-item2__top-ln">
                                    <a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680510310279.svg" alt=""></a>
                                </div>
                            </div>
                            <div>
                                <p class="results-slider-item2__top-header">Сергей Бухаров</p>
                                <p class="results-slider-item2__top-text">Supply Chain Forecast Analyst, Нидерланды</p>
                            </div>
                        </div>
                        <div class="results-slider-item2__bottom">
                            <ul>
                                <li>Уволился из Mars весной 2022 года, так как не смог договориться о<br> релокации, переехал<br> из России в Грузию</li>
                                <li>Прошел курс Real Me, персонально работал<br> с экспертом клуба,<br> составил стратегию</li>
                                <li>Получил оффер<br> от Mars с релокацией<br> в Нидерланды в<br> середине 2022 года</li>
                            </ul>
                        </div>
                    </div>
                    <div class="results-slider-item2">
                        <div class="results-slider-item2__top">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680510383207.png" alt=""  class="results-slider-item2__top-avatar">
                                <div  class="results-slider-item2__top-ln">
                                    <a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680510310279.svg" alt=""></a>
                                </div>
                            </div>
                            <div>
                                <p class="results-slider-item2__top-header">Карина Пысина</p>
                                <p class="results-slider-item2__top-text">бизнес-аналитик, Россия</p>
                            </div>
                        </div>
                        <div class="results-slider-item2__bottom">
                            <ul>
                                <li>Пыталась перейти<br> в бизнес-анализ из<br> клиентского отдела,<br> но не смогла и<br> уволилась вникуда</li>
                                <li>Прошла Real Me,<br> «Звёздного кандидата», работала с коучем, составила продающее резюме</li>
                                <li>Получила оффер бизнес-аналитика, зарплату на 100% выше в 2022 году</li>
                            </ul>
                        </div>
                    </div>
                    <div class="results-slider-item2">
                        <div class="results-slider-item2__top">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680510392778.png" alt=""  class="results-slider-item2__top-avatar">
                                <div  class="results-slider-item2__top-ln">
                                    <a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680510310279.svg" alt=""></a>
                                </div>
                            </div>
                            <div>
                                <p class="results-slider-item2__top-header">Тая Штоль</p>
                                <p class="results-slider-item2__top-text">UX/UI-дизайнер, Испания</p>
                            </div>
                        </div>
                        <div class="results-slider-item2__bottom">
                            <ul>
                                <li>Потеряла всех клиентов <br>из России в феврале<br> 2022 года. Хотела в найм,<br> но опыт был только во<br> фрилансе</li>
                                <li>Прошла программы <br>«Звёздный кандидат»<br> и «Выход из декрета», работала с коучем</li>
                                <li>Получила оффер в немецкую компанию. Увеличила доход в 6 раз, получила соцпакет</li>
                            </ul>
                        </div>
                    </div>
                    <div class="results-slider-item2">
                        <div class="results-slider-item2__top">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680510407061.png" alt=""  class="results-slider-item2__top-avatar">
                                <div  class="results-slider-item2__top-ln">
                                    <a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680510310279.svg" alt=""></a>
                                </div>
                            </div>
                            <div>
                                <p class="results-slider-item2__top-header">Евгения Вольхина</p>
                                <p class="results-slider-item2__top-text">Project Manager, Германия</p>
                            </div>
                        </div>
                        <div class="results-slider-item2__bottom">
                            <ul>
                                <li>Работала консультантом-методологом в Екатеринбурге. Хотела стать project manager<br> в Германии</li>
                                <li>Прошла «Звёздного кандидата», прокачала<br> CV, выстроила нетворк</li>
                                <li>Получила оффер в Big4<br> в Москве и зарплату<br> в 3,5 раза больше, потом<br> – оффер в Германию<br> с ростом ещё на 40%</li>
                            </ul>
                        </div>
                    </div>
                    <div class="results-slider-item2">
                        <div class="results-slider-item2__top">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680510418438.png" alt=""  class="results-slider-item2__top-avatar">
                                <div  class="results-slider-item2__top-ln">
                                    <a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680510310279.svg" alt=""></a>
                                </div>
                            </div>
                            <div>
                                <p class="results-slider-item2__top-header">Олег Федоткин</p>
                                <p class="results-slider-item2__top-text">Head of Department, Германия</p>
                            </div>
                        </div>
                        <div class="results-slider-item2__bottom">
                            <ul>
                                <li>Не мог найти работу<br> в Германии, не хотел возвращаться в Москву после окончания контракта Henkel</li>
                                <li>Прошел Real Me,<br> составил стратегию, прорабатывал запрос в паре с участником клуба</li>
                                <li>Получил оффер<br> на head-позицию с ростом зарплаты на 30%<br> в начале 2022 года</li>
                            </ul>
                        </div>
                    </div>
                    <div class="results-slider-item2">
                        <div class="results-slider-item2__top">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680510428678.png" alt=""  class="results-slider-item2__top-avatar">
                                <div  class="results-slider-item2__top-ln">
                                    <a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680510310279.svg" alt=""></a>
                                </div>
                            </div>
                            <div>
                                <p class="results-slider-item2__top-header">Людмила Киселёва</p>
                                <p class="results-slider-item2__top-text">Recruiter ll, США</p>
                            </div>
                        </div>
                        <div class="results-slider-item2__bottom">
                            <ul>
                                <li>Приехала в США как турист, осталась там, работала ассистентом. Хотела начать карьеру<br> в корпорации</li>
                                <li>Прошла курсы «Продающее резюме»<br> и «Эффективное<br> интервью».</li>
                                <li>Получила оффер ассистента в Microsoft, через год стала рекрутером в Transocean</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div>
                    <a href="#" class="btn-color-main-dark-orange">Хочу такой результат</a>
                        <div class="club2-results-slider__arrow-right">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680510798194.svg" alt="">
                        </div>
                </div>
            </div>
        </div>`
	});
    
    blockManager.add('careerum-club2-goals', {
        label: 'Страница Клуб 2 цели',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-club2-goals">
            <div>
                <div>
                    <h2>Как участники клуба достигают своих целей?<br> Рассказываем на примере Даши</h2>
                </div>
                <div>
                    <div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680510994792.svg" alt="">
                            <p class="careerum-club2-goals__header">Она оказалась в карьерном тупике</p>
                            <p class="careerum-club2-goals__text">Даша не понимала,<br> что делать с работой, особенно в кризис</p>
                        </div>
                        <div class="careerum-club2-goals__items-left">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680511007158.svg" alt="">
                            <div>
                                <div class="items-left__mg">нет драйва</div>
                                <div class="items-left__mg">кризис</div>
                                <div class="items-left__g">усталость</div>
                                <div class="items-left__g">страх</div>
                                <div class="items-left__mg">напряжение</div>
                                <div class="items-left__g">нет развития</div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680511024367.svg" alt="">
                            <p class="careerum-club2-goals__header">Даше нужно<br> было понять,<br> чего она хочет</p>
                            <p class="careerum-club2-goals__text">А еще найти<br> классную работу со<br> смыслом и драйвом</p>
                        </div>
                        <div class="careerum-club2-goals__items-right">
                            <div>
                                <div class="items-left__or">высокая зарплата</div>
                                <div class="items-left__db">польза</div>
                                <div class="items-left__lb">стабильность</div>
                                <div class="items-left__or">развитие</div>
                                <div class="items-left__db">рост</div>
                                <div class="items-left__lb">здоровая самооценка</div>
                                <div class="items-left__db">уверенность</div>
                            </div>                        
                        </div>
                    </div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-club2-goals-tablet', {
        label: 'Страница Клуб 2 цели (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-club2-goals-tablet">
            <div>
                <div>
                    <h2>Как участники клуба достигают своих целей?<br> Рассказываем на примере Даши</h2>
                </div>
                <div>
                    <div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680510994792.svg" alt="">
                            <div>
                                <p class="careerum-club2-goals__header">Она оказалась<br> в карьерном<br> тупике</p>
                                <p class="careerum-club2-goals__text">Даша не понимала,<br> что делать с работой, особенно в кризис</p>
                            </div>
                        </div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680511088180.svg" alt="">
                        <div class="careerum-club2-goals__items-left">
                            <div>
                                <div class="items-left__mg">нет драйва</div>
                                <div class="items-left__mg">кризис</div>
                                <div class="items-left__g">усталость</div>
                                <div class="items-left__g">страх</div>
                                <div class="items-left__mg">напряжение</div>
                                <div class="items-left__g">нет развития</div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680511024367.svg" alt="">
                            <div>
                                <p class="careerum-club2-goals__header">Даше нужно было понять, чего<br> она хочет</p>
                                <p class="careerum-club2-goals__text">А еще найти классную<br> работу со смыслом<br> и драйвом</p>
                            </div>
                        </div>
                        <div class="careerum-club2-goals__items-right">
                            <div>
                                <div class="items-left__or">высокая зарплата</div>
                                <div class="items-left__db">смысл</div>
                                <div class="items-left__db">стабильность</div>
                                <div class="items-left__or">развитие</div>
                                <div class="items-left__db">рост</div>
                                <div class="items-left__lb">здоровая самооценка</div>
                                <div class="items-left__lb">уверенность</div>
                            </div>                        
                        </div>
                    </div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-club2-goals-mobile', {
        label: 'Страница Клуб 2 цели (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-club2-goals-mobile">
            <div>
                <div>
                    <h2>Как участники клуба достигают своих целей? Рассказываем на примере Даши</h2>
                </div>
                <div>
                    <div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680510994792.svg" alt="">
                            <div>
                                <p class="careerum-club2-goals__header">Она оказалась в карьерном тупике и не понимала, что делать<br> с работой в кризис</p>
                            </div>
                        </div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680511121170.svg" alt="">
                        <div class="careerum-club2-goals__items-left">
                            <div>
                                <div class="items-left__mg">нет драйва</div>
                                <div class="items-left__mg">кризис</div>
                                <div class="items-left__g">усталость</div>
                                <div class="items-left__g">страх</div>
                                <div class="items-left__mg">напряжение</div>
                                <div class="items-left__g">нет развития</div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div>
                            <div>
                                <p class="careerum-club2-goals__header">Даша хотела понять, чего<br> она хочет, и найти классную<br> работу со смыслом и драйвом</p>
                            </div>
                        </div>
                        <div class="careerum-club2-goals__items-right">
                            <div>
                                <div class="items-left__or">высокая зарплата</div>
                                <div class="items-left__db">смысл</div>
                                <div class="items-left__db">стабильность</div>
                                <div class="items-left__or">развитие</div>
                                <div class="items-left__db">рост</div>
                                <div class="items-left__lb">здоровая самооценка</div>
                                <div class="items-left__lb">уверенность</div>
                            </div>                        
                        </div>
                    </div>
                </div>
            </div>
        </div>`
	});
    
    blockManager.add('careerum-club2-subscribe', {
        label: 'Страница Клуб 2 подписка описание',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-club2-subscribe">
            <div>
                <div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680511495269.svg" alt="">
                        <p class="careerum-club2-subscribe__header">Даша оформила<br> подписку на<br> Careerum.Club</p>
                        <p class="careerum-club2-subscribe__text">Сразу после этого<br> она получила доступ<br> к платформе и начала<br> проходить обучающие<br> программы</p>
                        <a href="#" class="btn-color-main-dark-orange">Начать обучение</a>
                    </div>
                    <div class="club2-subscribe-slider">
                        <div class="subscribe-slider-item">
                            <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680512305855.svg" alt=""></div>
                            <p>15 учебных программ<br> под любой запрос:<br> от релокации до выхода<br> из декрета</p>
                        </div>
                        <div class="subscribe-slider-item">
                            <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680512292130.png" alt=""></div>
                            <p>Доступ 24/7:<br> смотрите видео-курсы<br> без ограничений где<br> и когда удобно</p>
                        </div>
                        <div class="subscribe-slider-item">
                            <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680512275231.png" alt=""></div>
                            <p>Практические задания:<br> прокачивайте свои навыки<br> последовательно и<br> системно </p>
                        </div>
                    </div>  
                </div>
                <div>
                    <div>
                        <div class="club2-subscribe-slider__arrow-left hidden">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680510826990.svg" alt="">
                        </div>
                        <div class="club2-subscribe-slider__arrow-right hidden">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680510798194.svg" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-club2-subscribe-tablet', {
        label: 'Страница Клуб 2 подписка описание (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-club2-subscribe-tablet">
            <div>
                <div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680511495269.svg" alt="">
                        <p class="careerum-club2-subscribe__header">Даша оформила подписку<br> Careerum.Club и начала проходить<br> обучающие программы</p>
                    </div>
                    <div class="club2-subscribe-slider">
                        <div class="subscribe-slider-item item1">
                            <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680512242864.svg" alt=""></div>
                            <p>15 учебных программ<br> под любой запрос:<br> от релокации до выхода<br> из декрета</p>
                        </div>
                        <div class="subscribe-slider-item item2">
                            <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680512231471.png" alt=""></div>
                            <p>Доступ 24/7:<br> смотрите видео-курсы<br> без ограничений где<br> и когда удобно</p>
                        </div>
                        <div class="subscribe-slider-item item3">
                            <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680512218628.png" alt=""></div>
                            <p>Практические задания:<br> прокачивайте свои навыки<br> последовательно и<br> системно </p>
                        </div>
                    </div>  
                </div>
                <div>
                    <a href="#" class="btn-color-main-dark-orange">Вступить в клуб</a>
                        <div class="club2-subscribe-slider__arrow-right hidden">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680510798194.svg" alt="">
                        </div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-club2-subscribe-mobile', {
        label: 'Страница Клуб 2 подписка описание (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-club2-subscribe-mobile">
            <div>
                <div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680511495269.svg" alt="">
                        <p class="careerum-club2-subscribe__header">Даша оформила<br> подписку Careerum.Club<br> и начала проходить<br> обучающие программы</p>
                    </div>
                    <div class="club2-subscribe-slider">
                        <div class="subscribe-slider-item item1">
                            <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680511471529.svg" alt=""></div>
                            <p>15 учебных программ<br> под любой запрос:<br> от релокации до выхода<br> из декрета</p>
                        </div>
                        <div class="subscribe-slider-item item2">
                            <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680511461152.png" alt=""></div>
                            <p>Доступ 24/7:<br> смотрите видео-курсы<br> без ограничений где<br> и когда удобно</p>
                        </div>
                        <div class="subscribe-slider-item item3">
                            <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680511450775.png" alt=""></div>
                            <p>Практические задания:<br> прокачивайте свои навыки<br> последовательно и<br> системно </p>
                        </div>
                    </div>  
                </div>
                <div>
                    <a href="#" class="btn-color-main-dark-orange">Начать обучение</a>
                        <div class="club2-subscribe-slider__arrow-right">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680510798194.svg" alt="">
                        </div>
                </div>
            </div>
        </div>`
	});
    
    blockManager.add('careerum-club2-network', {
        label: 'Страница Клуб 2 нетворк описание',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-club2-network">
            <div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680512622786.svg" alt="">
                    <p class="careerum-club2-network__header">Даша хотела<br> пообщаться с<br> теми, кто тоже<br> ищет работу</p>
                    <p class="careerum-club2-network__text">Она написала пост<br> на платформе для<br> нетворкинга</p>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680512643004.svg" alt="" class="careerum-club2-network__img">
                </div>
                <div>
                    <div class="club2-network__item-border">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680512665917.svg" alt="">
                        <p>Всем привет!<br> Я Даша! Хочу найти<br> работу по любви</p>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680512679734.svg" alt="">
                            <p>23 нравится</p>
                        </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680512691827.svg" alt="">
                            <p>16 комментариев</p>
                        </div>
                    </div>
                    <div class="club2-network__item-yellow">
                        <p>Нашла поддержкку единомышленников, укрепив веру в себя<br> и самооценку</p>
                    </div>
                    <div class="club2-network__item-blue">
                        <p>Познакомилась<br> с людьми из нужных сфер и узнала, кто сейчас нужен рынку</p>
                    </div>
                    <div class="club2-network__item-black">
                        <div>
                            <p class="club2-network__item-black__header">30+ стран</p>
                            <p class="club2-network__item-black__text">география участников клуба</p>
                            <p class="club2-network__item-black__header">7 ивентов</p>
                            <p class="club2-network__item-black__text">проходит в<br> коммьюнити каждый месяц </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-club2-network-tablet', {
        label: 'Страница Клуб 2 нетворк описание (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-club2-network-tablet">
            <div>
                <div>
                    <p class="careerum-club2-network__header">Даша захотела пообщаться<br> с теми, кто тоже ищет работу</p>
                    <p class="careerum-club2-network__text">Она написала пост на платформе<br> для нетворкинга</p>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680512734301.svg" alt="" class="careerum-club2-network__img">
                </div>
                <div>
                    <div class="club2-network__item-border">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680512751611.svg" alt="">
                        <p>Всем привет!<br> Я Даша! Хочу найти<br> работу по любви</p>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680512679734.svg" alt="">
                            <p>23 нравится</p>
                        </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680512691827.svg" alt="">
                            <p>16 комментариев</p>
                        </div>
                    </div>
                    <div class="club2-network__item-yellow">
                        <p>Нашла поддержкку единомышленников, укрепив веру в себя<br> и самооценку</p>
                    </div>
                    <div class="club2-network__item-blue">
                        <p>Познакомилась<br> с людьми из нужных сфер и узнала, кто сейчас нужен рынку</p>
                    </div>
                    <div class="club2-network__item-black">
                        <div>
                            <p class="club2-network__item-black__header">30+ стран</p>
                            <p class="club2-network__item-black__text">география участников клуба</p>
                            <p class="club2-network__item-black__header">7 ивентов</p>
                            <p class="club2-network__item-black__text">проходит<br> в коммьюнити каждый месяц </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-club2-network-mobile', {
        label: 'Страница Клуб 2 нетворк описание (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-club2-network-mobile">
            <div>
                <div>
                    <p class="careerum-club2-network__header">Даша хотела пообщаться<br> с теми, кто тоже ищет работу.<br> Она написала пост на платформе<br> для нетворкинга</p>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680512770819.svg" alt="" class="careerum-club2-network__img">
                </div>
                <div>
                    <div class="club2-network__item-border">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680512780710.svg" alt="">
                        <div>
                            <p>Всем привет!<br> Я Даша! Хочу найти<br> работу по любви</p>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680512679734.svg" alt="">
                                <p>23 нравится</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680512691827.svg" alt="">
                                <p>16 комментариев</p>
                            </div>
                        </div>
                    </div>
                    <div class="club2-network__item-yellow">
                        <p>Нашла поддержкку единомышленников, укрепив веру в себя<br> и самооценку</p>
                    </div>
                    <div class="club2-network__item-blue">
                        <p>Познакомилась с людьми из нужных сфер и узнала, кто сейчас нужен рынку</p>
                    </div>
                    <div class="club2-network__item-black">
                        <div>
                            <p class="club2-network__item-black__header">30+ стран</p>
                            <p class="club2-network__item-black__text">география участников клуба</p>
                            <p class="club2-network__item-black__header">7 ивентов</p>
                            <p class="club2-network__item-black__text">проходит в коммьюнити каждый месяц </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
	});
    
    blockManager.add('careerum-club2-coaches', {
        label: 'Страница Клуб 2 коучи',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-club2-coaches">
            <div>
                <div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513007568.svg" alt="">
                        <p class="careerum-club2-coaches__header">Даша решила обратиться<br> к коучу и CV-специалисту</p>
                        <p class="careerum-club2-coaches__text">В коммьюнити<br> ей посоветовали индивидуальную поддержку специалиста, чтобы лучше<br> проработать запрос </p>
                    </div>
                    <div class="club2-coaches-slider">
                        <div class="coaches-slider-item1">
                            <div>
                                <div>
                                    <p class="coaches-slider-item1__header">9,3/10</p>
                                    <p class="coaches-slider-item1__text">средняя оценка<br> коучей от участников клуба</p>
                                    <p class="coaches-slider-item1__header">9,5/10</p>
                                    <p class="coaches-slider-item1__text">средняя оценка<br> CV-специалистов</p>
                                    <p class="coaches-slider-item1__header">Все коучи</p>
                                    <p class="coaches-slider-item1__text">имеют международную сертификацию<br> ICF и ACF</p>
                                </div>
                            </div>
                        </div>
                        <div class="coaches-slider-item2">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513044873.png" alt="">
                            <p class="coaches-slider-item2__header">Елена Добринская</p>
                            <p class="coaches-slider-item2__text">Коуч ICF</p>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513075681.svg" alt="">
                                <p>6+ лет опыта</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513108788.svg" alt="">
                                <p>Помогла 1700+ клиентам обрести уверенность и подготовиться к собеседованиям </p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513122799.svg" alt="">
                                <p>Работала с<br> сотрудниками Sony,<br>  MTC, «Газпромнефть» </p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513142334.svg" alt="">
                                <p>ОАЭ</p>
                            </div>
                        </div>
                        <div class="coaches-slider-item2">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513163934.png" alt="">
                            <p class="coaches-slider-item2__header">Ирина Феокистова</p>
                            <p class="coaches-slider-item2__text">Коуч ICF</p>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513075681.svg" alt="">
                                <p>3+ года опыта </p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513108788.svg" alt="">
                                <p>Помогла 700+ клиентам получить офферы с релокацией и повышение</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513122799.svg" alt="">
                                <p>Работала с<br> сотрудниками PepsiCo и<br> «Аэрофлота»</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513142334.svg" alt="">
                                <p>Россия</p>
                            </div>
                        </div>
                        <div class="coaches-slider-item2">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513178026.png" alt="">
                            <p class="coaches-slider-item2__header">Яна Хмельницкая</p>
                            <p class="coaches-slider-item2__text">Коуч ICF</p>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513075681.svg" alt="">
                                <p>10+ лет опыта</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513108788.svg" alt="">
                                <p>Помогла 250+ клиентам с релокацией и поиском работы на международном рынке</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513122799.svg" alt="">
                                <p>Работала с<br> сотрудниками Ford, Leroy Merlin, Toyota</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513142334.svg" alt="">
                                <p>Турция</p>
                            </div>
                        </div>
                        <div class="coaches-slider-item2">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513207695.png" alt="">
                            <p class="coaches-slider-item2__header">Елена Эльзенбах</p>
                            <p class="coaches-slider-item2__text">Коуч ICF</p>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513075681.svg" alt="">
                                <p>3+ года опыта </p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513108788.svg" alt="">
                                <p>Помогла 700+ клиентам из России и Европы найти работу в ЕС, США<br> и Канаде</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513122799.svg" alt="">
                                <p>Работала с<br> сотрудниками InDriver<br> и Promwad</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513142334.svg" alt="">
                                <p>Россия</p>
                            </div>
                        </div>
                        <div class="coaches-slider-item2">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513229972.png" alt="">
                            <p class="coaches-slider-item2__header">Софи Бессон</p>
                            <p class="coaches-slider-item2__text">CV-специалист</p>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513075681.svg" alt="">
                                <p>8+ лет опыта</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513108788.svg" alt="">
                                <p>Помогла 300+ клиентам составить резюме и найти работу в Европе, США и Канаде</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513122799.svg" alt="">
                                <p>Работала с<br> сотрудниками Disney, Intel, Microsoft</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513142334.svg" alt="">
                                <p>Израиль</p>
                            </div>
                        </div>
                        <div class="coaches-slider-item2">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513254543.png" alt="">
                            <p class="coaches-slider-item2__header">Надежда Община</p>
                            <p class="coaches-slider-item2__text">CV-специалист</p>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513075681.svg" alt="">
                                <p>2+ лет опыта</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513108788.svg" alt="">
                                <p>Помогла 250+ клиентам<br> в самопрезентации и поиске работы</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513122799.svg" alt="">
                                <p>Работала с<br> сотрудниками Airbus, Hubspot, DAWESoft, Weatherford</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513142334.svg" alt="">
                                <p>Португалия</p>
                            </div>
                        </div>
                        <div class="coaches-slider-item2">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513271340.png" alt="">
                            <p class="coaches-slider-item2__header">Астра Висаева</p>
                            <p class="coaches-slider-item2__text">Коуч ICF</p>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513075681.svg" alt="">
                                <p>4+ года опыта</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513108788.svg" alt="">
                                <p>Помогла 2000+ клиентам сделать карьерную стратегию и найти работу в ЕС и США</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513122799.svg" alt="">
                                <p>Работала с<br> сотрудниками EPAM,<br> OZON</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513142334.svg" alt="">
                                <p>Россия</p>
                            </div>
                        </div>
                        <div class="coaches-slider-item2">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513287747.png" alt="">
                            <p class="coaches-slider-item2__header">Марина Веденичева</p>
                            <p class="coaches-slider-item2__text">Коуч ICF PCC</p>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513075681.svg" alt="">
                                <p>15+ лет опыта</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513108788.svg" alt="">
                                <p>Помогла 1000+ клиентам усилить лидерские качества и получить повышение</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513122799.svg" alt="">
                                <p>Работала с<br> сотрудниками Mars, Shell, Ernst & Young</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513142334.svg" alt="">
                                <p>Великобритания</p>
                            </div>
                        </div>
                        <div class="coaches-slider-item2">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513303406.png" alt="">
                            <p class="coaches-slider-item2__header">Светлана Баран</p>
                            <p class="coaches-slider-item2__text">Коуч ICF</p>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513075681.svg" alt="">
                                <p>4+ года опыта</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513108788.svg" alt="">
                                <p>Помогла 3300+ клиентам с релокацией и поиске работы на международном рынке</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513122799.svg" alt="">
                                <p>Работала с<br> сотрудниками Tesla,<br> Google, Phillips</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513142334.svg" alt="">
                                <p>Италия</p>
                            </div>
                        </div>
                    </div>  
                </div>
                <div>
                    <div>
                        <div class="club2-coaches-slider__arrow-left">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680510826990.svg" alt="">
                        </div>
                        <div class="club2-coaches-slider__arrow-right">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680510798194.svg" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-club2-coaches-tablet', {
        label: 'Страница Клуб 2 коучи (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-club2-coaches-tablet">
            <div>
                <div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513407007.svg" alt="">
                        <div>
                            <p class="careerum-club2-coaches__header">Даша решила обратиться к коучу</p>
                            <p class="careerum-club2-coaches__text">В коммьюнити ей посоветовали воспользоваться<br> индивидуальной поддержкой, чтобы лучше<br> проработать запрос </p>
                        </div>
                    </div>
                    <div class="club2-coaches-slider">
                        <div class="coaches-slider-item1">
                            <div>
                                <div>
                                    <p class="coaches-slider-item1__header">9,3/10</p>
                                    <p class="coaches-slider-item1__text">средняя оценка<br> коучей от участников клуба</p>
                                    <p class="coaches-slider-item1__header">9,5/10</p>
                                    <p class="coaches-slider-item1__text">средняя оценка CV-<br> специалистов</p>
                                    <p class="coaches-slider-item1__header">Все коучи</p>
                                    <p class="coaches-slider-item1__text">имеют международную сертификацию<br> ICF и ACF</p>
                                </div>
                            </div>
                        </div>
                        <div class="coaches-slider-item2">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513044873.png" alt="">
                            <p class="coaches-slider-item2__header">Елена Добринская</p>
                            <p class="coaches-slider-item2__text">Коуч ICF</p>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513075681.svg" alt="">
                                <p>6+ лет опыта</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513108788.svg" alt="">
                                <p>Помогла 1700+ клиентам обрести уверенность и подготовиться к собеседованиям </p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513122799.svg" alt="">
                                <p>Работала с<br> сотрудниками Sony,<br>  MTC, «Газпромнефть» </p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513142334.svg" alt="">
                                <p>ОАЭ</p>
                            </div>
                        </div>
                        <div class="coaches-slider-item2">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513163934.png" alt="">
                            <p class="coaches-slider-item2__header">Ирина Феокистова</p>
                            <p class="coaches-slider-item2__text">Коуч ICF</p>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513075681.svg" alt="">
                                <p>3+ года опыта </p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513108788.svg" alt="">
                                <p>Помогла 700+ клиентам получить офферы с релокацией и повышение</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513122799.svg" alt="">
                                <p>Работала с<br> сотрудниками PepsiCo<br> и «Аэрофлота»</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513142334.svg" alt="">
                                <p>Россия</p>
                            </div>
                        </div>
                        <div class="coaches-slider-item2">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513178026.png" alt="">
                            <p class="coaches-slider-item2__header">Яна Хмельницкая</p>
                            <p class="coaches-slider-item2__text">Коуч ICF</p>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513075681.svg" alt="">
                                <p>10+ лет опыта</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513108788.svg" alt="">
                                <p>Помогла 250+ клиентам <br>с релокацией и поиском работы на международном рынке</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513122799.svg" alt="">
                                <p>Работала с<br> сотрудниками Ford, Leroy Merlin, Toyota</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513142334.svg" alt="">
                                <p>Турция</p>
                            </div>
                        </div>
                        <div class="coaches-slider-item2">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513207695.png" alt="">
                            <p class="coaches-slider-item2__header">Елена Эльзенбах</p>
                            <p class="coaches-slider-item2__text">Коуч ICF</p>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513075681.svg" alt="">
                                <p>3+ года опыта </p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513108788.svg" alt="">
                                <p>Помогла 700+ клиентам из России и Европы найти работу в ЕС, США<br> и Канаде</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513122799.svg" alt="">
                                <p>Работала с<br> сотрудниками InDriver<br> и Promwad</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513142334.svg" alt="">
                                <p>Россия</p>
                            </div>
                        </div>
                        <div class="coaches-slider-item2">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513229972.png" alt="">
                            <p class="coaches-slider-item2__header">Софи Бессон</p>
                            <p class="coaches-slider-item2__text">CV-специалист</p>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513075681.svg" alt="">
                                <p>8+ лет опыта</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513108788.svg" alt="">
                                <p>Помогла 300+ клиентам составить резюме и найти работу в Европе, США и Канаде</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513122799.svg" alt="">
                                <p>Работала с<br> сотрудниками Disney, Intel, Microsoft</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513142334.svg" alt="">
                                <p>Израиль</p>
                            </div>
                        </div>
                        <div class="coaches-slider-item2">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513254543.png" alt="">
                            <p class="coaches-slider-item2__header">Надежда Община</p>
                            <p class="coaches-slider-item2__text">CV-специалист</p>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513075681.svg" alt="">
                                <p>2+ лет опыта</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513108788.svg" alt="">
                                <p>Помогла 250+ клиентам<br> в самопрезентации и поиске работы</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513122799.svg" alt="">
                                <p>Работала с<br> сотрудниками Airbus, Hubspot, DAWESoft, Weatherford</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513142334.svg" alt="">
                                <p>Португалия</p>
                            </div>
                        </div>
                        <div class="coaches-slider-item2">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513271340.png" alt="">
                            <p class="coaches-slider-item2__header">Астра Висаева</p>
                            <p class="coaches-slider-item2__text">Коуч ICF</p>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513075681.svg" alt="">
                                <p>4+ года опыта</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513108788.svg" alt="">
                                <p>Помогла 2000+ клиентам сделать карьерную стратегию и найти<br> работу в ЕС и США</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513122799.svg" alt="">
                                <p>Работала с<br> сотрудниками EPAM,<br> OZON</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513142334.svg" alt="">
                                <p>Россия</p>
                            </div>
                        </div>
                        <div class="coaches-slider-item2">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513287747.png" alt="">
                            <p class="coaches-slider-item2__header">Марина Веденичева</p>
                            <p class="coaches-slider-item2__text">Коуч ICF PCC</p>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513075681.svg" alt="">
                                <p>15+ лет опыта</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513108788.svg" alt="">
                                <p>Помогла 1000+ клиентам усилить лидерские качества и получить повышение</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513122799.svg" alt="">
                                <p>Работала с<br> сотрудниками Mars, Shell, Ernst & Young</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513142334.svg" alt="">
                                <p>Великобритания</p>
                            </div>
                        </div>
                        <div class="coaches-slider-item2">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513303406.png" alt="">
                            <p class="coaches-slider-item2__header">Светлана Баран</p>
                            <p class="coaches-slider-item2__text">Коуч ICF</p>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513075681.svg" alt="">
                                <p>4+ года опыта</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513108788.svg" alt="">
                                <p>Помогла 3300+ клиентам с релокацией и поиске работы на международном рынке</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513122799.svg" alt="">
                                <p>Работала с<br> сотрудниками Tesla,<br> Google, Phillips</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513142334.svg" alt="">
                                <p>Италия</p>
                            </div>
                        </div>
                    </div>  
                </div>
                <div>
                    <div>
                        <div class="club2-coaches-slider__arrow-right">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680510798194.svg" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-club2-coaches-mobile', {
        label: 'Страница Клуб 2 коучи (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-club2-coaches-mobile">
            <div>
                <div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513438306.svg" alt="">
                        <div>
                            <p class="careerum-club2-coaches__header">Даша обратилась<br> к коучу и CV-специалисту, чтобы детально проработать запрос и резюме</p>
                        </div>
                    </div>
                    <div class="club2-coaches-slider">
                        <div class="coaches-slider-item1">
                            <div>
                                <div>
                                    <p class="coaches-slider-item1__header">9,3/10</p>
                                    <p class="coaches-slider-item1__text">средняя оценка<br> коучей от участников клуба</p>
                                    <p class="coaches-slider-item1__header">9,5/10</p>
                                    <p class="coaches-slider-item1__text">средняя оценка CV-<br> специалистов</p>
                                    <p class="coaches-slider-item1__header">Все коучи</p>
                                    <p class="coaches-slider-item1__text">имеют международную сертификацию<br> ICF и ACF</p>
                                </div>
                            </div>
                        </div>
                        <div class="coaches-slider-item2">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513044873.png" alt="">
                            <p class="coaches-slider-item2__header">Елена Добринская</p>
                            <p class="coaches-slider-item2__text">Коуч ICF</p>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513075681.svg" alt="">
                                <p>6+ лет опыта</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513108788.svg" alt="">
                                <p>Помогла 1700+ клиентам обрести уверенность и подготовиться к собеседованиям </p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513122799.svg" alt="">
                                <p>Работала с<br> сотрудниками Sony,<br>  MTC, «Газпромнефть» </p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513142334.svg" alt="">
                                <p>ОАЭ</p>
                            </div>
                        </div>
                        <div class="coaches-slider-item2">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513163934.png" alt="">
                            <p class="coaches-slider-item2__header">Ирина Феокистова</p>
                            <p class="coaches-slider-item2__text">Коуч ICF</p>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513075681.svg" alt="">
                                <p>3+ года опыта </p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513108788.svg" alt="">
                                <p>Помогла 700+ клиентам получить офферы с релокацией и повышение</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513122799.svg" alt="">
                                <p>Работала с<br> сотрудниками PepsiCo<br> и «Аэрофлота»</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513142334.svg" alt="">
                                <p>Россия</p>
                            </div>
                        </div>
                        <div class="coaches-slider-item2">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513178026.png" alt="">
                            <p class="coaches-slider-item2__header">Яна Хмельницкая</p>
                            <p class="coaches-slider-item2__text">Коуч ICF</p>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513075681.svg" alt="">
                                <p>10+ лет опыта</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513108788.svg" alt="">
                                <p>Помогла 250+ клиентам<br> с релокацией и поиском работы на международном рынке</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513122799.svg" alt="">
                                <p>Работала с<br> сотрудниками Ford, Leroy Merlin, Toyota</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513142334.svg" alt="">
                                <p>Турция</p>
                            </div>
                        </div>
                        <div class="coaches-slider-item2">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513207695.png" alt="">
                            <p class="coaches-slider-item2__header">Елена Эльзенбах</p>
                            <p class="coaches-slider-item2__text">Коуч ICF</p>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513075681.svg" alt="">
                                <p>3+ года опыта </p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513108788.svg" alt="">
                                <p>Помогла 700+ клиентам из России и Европы<br> найти работу в ЕС, США<br> и Канаде</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513122799.svg" alt="">
                                <p>Работала с<br> сотрудниками InDriver<br> и Promwad</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513142334.svg" alt="">
                                <p>Россия</p>
                            </div>
                        </div>
                        <div class="coaches-slider-item2">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513229972.png" alt="">
                            <p class="coaches-slider-item2__header">Софи Бессон</p>
                            <p class="coaches-slider-item2__text">CV-специалист</p>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513075681.svg" alt="">
                                <p>8+ лет опыта</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513108788.svg" alt="">
                                <p>Помогла 300+ клиентам составить резюме и найти работу в Европе,<br> США и Канаде</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513122799.svg" alt="">
                                <p>Работала с<br> сотрудниками Disney, Intel, Microsoft</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513142334.svg" alt="">
                                <p>Израиль</p>
                            </div>
                        </div>
                        <div class="coaches-slider-item2">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513254543.png" alt="">
                            <p class="coaches-slider-item2__header">Надежда Община</p>
                            <p class="coaches-slider-item2__text">CV-специалист</p>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513075681.svg" alt="">
                                <p>2+ лет опыта</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513108788.svg" alt="">
                                <p>Помогла 250+ клиентам<br> в самопрезентации и поиске работы</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513122799.svg" alt="">
                                <p>Работала с<br> сотрудниками Airbus, Hubspot, DAWESoft, Weatherford</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513142334.svg" alt="">
                                <p>Португалия</p>
                            </div>
                        </div>
                        <div class="coaches-slider-item2">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513271340.png" alt="">
                            <p class="coaches-slider-item2__header">Астра Висаева</p>
                            <p class="coaches-slider-item2__text">Коуч ICF</p>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513075681.svg" alt="">
                                <p>4+ года опыта</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513108788.svg" alt="">
                                <p>Помогла 2000+ клиентам сделать карьерную стратегию и найти<br> работу в ЕС и США</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513122799.svg" alt="">
                                <p>Работала с<br> сотрудниками EPAM,<br> OZON</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513142334.svg" alt="">
                                <p>Россия</p>
                            </div>
                        </div>
                        <div class="coaches-slider-item2">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513287747.png" alt="">
                            <p class="coaches-slider-item2__header">Марина Веденичева</p>
                            <p class="coaches-slider-item2__text">Коуч ICF PCC</p>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513075681.svg" alt="">
                                <p>15+ лет опыта</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513108788.svg" alt="">
                                <p>Помогла 1000+ клиентам усилить лидерские качества и получить повышение</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513122799.svg" alt="">
                                <p>Работала с<br> сотрудниками Mars, Shell, Ernst & Young</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513142334.svg" alt="">
                                <p>Великобритания</p>
                            </div>
                        </div>
                        <div class="coaches-slider-item2">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513303406.png" alt="">
                            <p class="coaches-slider-item2__header">Светлана Баран</p>
                            <p class="coaches-slider-item2__text">Коуч ICF</p>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513075681.svg" alt="">
                                <p>4+ года опыта</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513108788.svg" alt="">
                                <p>Помогла 3300+ клиентам<br> с релокацией и поиске работы на международном рынке</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513122799.svg" alt="">
                                <p>Работала с<br> сотрудниками Tesla,<br> Google, Phillips</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513142334.svg" alt="">
                                <p>Италия</p>
                            </div>
                        </div>
                    </div>  
                </div>
                <div>
                    <div>
                        <div class="club2-coaches-slider__arrow-right">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680510798194.svg" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </div>`
	});
    
    blockManager.add('careerum-club2-resgoals', {
        label: 'Страница Клуб 2 результаты',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-club2-resgoals">
            <div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513596133.svg" alt="">
                    <p class="careerum-club2-resgoals__header">В результате работы в клубе Даша достигла своих целей</p>
                    <a href="#" class="btn-color-main-dark-orange">Хочу в клуб!</a>
                </div>
                <div>
                    <div class="club2-resgoals-items-lb">
                        <p>Нашла работу<br> с повышением зарплаты</p>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513619022.svg" alt="">
                    </div>
                    <div class="club2-resgoals-items-db">
                        <p>Захотела строить карьеру на междуна-родном рынке</p>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513645057.svg" alt="">
                    </div>
                    <div class="club2-resgoals-items-lb">
                        <p>Укрепила самооценку<br> и составила карьерный<br> план на 10 лет</p>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513657647.svg" alt="">
                    </div>
                    <div class="club2-resgoals-items-db">
                        <p>Определила ценности и присвоила<br> себе свои достижения</p>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513683620.svg" alt="">
                    </div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513696796.png" alt="">
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-club2-resgoals-tablet', {
        label: 'Страница Клуб 2 результаты (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-club2-resgoals-tablet">
            <div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513712258.svg" alt="">
                    <p class="careerum-club2-resgoals__header">В результате работы<br> в клубе Даша<br> достигла своих целей</p>
                </div>
                <div>
                    <div class="club2-resgoals-items-lb">
                        <p>Захотела<br> строить карьеру<br>на между-народном рынке</p>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513645057.svg" alt="">
                    </div>
                    <div class="club2-resgoals-items-db">
                        <p>Нашла работу<br> с повышением зарплаты </p>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513619022.svg" alt="">
                    </div>
                    <div class="club2-resgoals-items-lb">
                        <p>Составила карьерный план на 10 лет</p>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513657647.svg" alt="">
                    </div>
                    <div class="club2-resgoals-items-db">
                        <p>Определила ценности и присвоила себе свои достижения </p>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513725255.svg" alt="">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513737680.svg" alt="" class="club2-resgoals-items__img-bottom">
                    </div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513746851.png" alt="">
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-club2-resgoals-mobile', {
        label: 'Страница Клуб 2 результаты (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-club2-resgoals-mobile">
            <div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513769290.svg" alt="">
                    <p class="careerum-club2-resgoals__header">В результате Даша</p>
                </div>
                <div>
                    <div class="club2-resgoals-items-lb">
                        <p>Захотела строить карьеру<br>на международном рынке</p>
                    </div>
                    <div class="club2-resgoals-items-db">
                        <p>Нашла работу<br> с повышением зарплаты </p>
                    </div>
                    <div class="club2-resgoals-items-lb">
                        <p>Укрепила самооценку</p>
                    </div>
                    <div class="club2-resgoals-items-db">
                        <p>Составила карьерный план на 10 лет</p>
                    </div>
                    <div class="club2-resgoals-items-lb">
                        <p>Определила ценности<br> и присвоила себе свои<br> достижения </p>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513778055.svg" alt="" class="club2-resgoals-items__img-bottom">
                    </div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513786889.png" alt="">
                </div>
            </div>
        </div>`
	});
    
    blockManager.add('careerum-club2-tariffs', {
        label: 'Страница Клуб 2 витрина',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-club2-tariffs">
            <div>
                <div>
                    <h2>Развивайте свою карьеру<br> в Careerum.Club</h2>
                    <div class="club2-tariffs__swicher-block">
                        <div class="club2-tariffs__swicher-top">
                            <p class="club2-tariffs__swicher-header">Посмотреть цены в <span>RUB<span></p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680514062680.svg" alt="" class="club2-tariffs__swicher-arrow">
                        </div>
                        <div class="club2-tariffs__swicher-bottom">
                            <ul>
                                <li data-currency="RUB">
                                    RUB
                                </li>
                                <li class="active" data-currency="EUR">
                                    EUR
                                </li>
                            </ul>
                            <p>
                                Обратите внимание,<br> что оплата в российских рублях возможна только<br> с карты российского банка. Оплата в евро — с карты зарубежного банка
                            </p>
                        </div>
                    </div>
                </div>
                <div class="club2-tariffs-wrapper">
                    <div class="club2-tariffs-item" data-price-eur="от 100 €" data-price-rub="от 8 075 ₽" data-link-rub="#rub" data-link-eur="#eur">
                        <p class="club2-tariffs-item__header">Тариф «Самостоятельный»</p>
                        <div class="club2-tariffs-item__content">
                            <ul>
                                <li class="active">Обучение</li>
                                <li class="active">Нетворкинг</li>
                                <li class="active">Поддержка сообщества</li>
                                <li>Поддержка коуча</li>
                                <li>Помощь CV-эксперта</li>
                                <li>2 личные сессии с коучем</li>
                            </ul>
                            <div class="club2-tariffs-item__price">
                                <p class="club2-tariffs-item__price-text">от 100 €</p>
                                <p>в месяц</p>
                            </div>
                        </div>
                        <a href="#125" class="btn-color-main-dark-orange">Оформить подписку</a>
                    </div>
                    <div class="club2-tariffs-item" data-price-eur="от 200 €" data-price-rub="от 9 991 ₽" data-link-rub="#rub" data-link-eur="#eur">
                        <p class="club2-tariffs-item__header">Тариф<br> «С поддержкой»</p>
                        <p class="club2-tariffs-item__places">Осталось 30 мест</p>
                        <div class="club2-tariffs-item__label">
                            <p>популярный</p>
                        </div>
                        <div class="club2-tariffs-item__content">
                            <ul>
                                <li class="active">Обучение</li>
                                <li class="active">Нетворкинг</li>
                                <li class="active">Поддержка сообщества</li>
                                <li class="active">Поддержка коуча</li>
                                <li class="active">Помощь CV-эксперта</li>
                                <li>2 личные сессии с коучем</li>
                            </ul>
                            <div class="club2-tariffs-item__price">
                                <p class="club2-tariffs-item__price-text">от 200 €</p>
                                <p>в месяц</p>
                            </div>
                        </div>
                        <a href="#124" class="btn-color-main-dark-orange">Оформить подписку</a>
                    </div>
                    <div class="club2-tariffs-item" data-price-eur="от 300 €" data-price-rub="от 19 633 ₽" data-link-rub="#rub" data-link-eur="#eur">
                        <p class="club2-tariffs-item__header">Тариф «Полное<br> сопровождение»</p>
                        <p class="club2-tariffs-item__places">Осталось 10 мест</p>
                        <div class="club2-tariffs-item__content">
                            <ul>
                                <li class="active">Обучение</li>
                                <li class="active">Нетворкинг</li>
                                <li class="active">Поддержка сообщества</li>
                                <li class="active">Поддержка коуча</li>
                                <li class="active">Помощь CV-эксперта</li>
                                <li class="active">2 личные сессии с коучем</li>
                            </ul>
                            <div class="club2-tariffs-item__price">
                                <p class="club2-tariffs-item__price-text">от 300 €</p>
                                <p>в месяц</p>
                            </div>
                        </div>
                        <a href="#123" class="btn-color-main-dark-orange">Оформить подписку</a>
                    </div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-club2-tariffs-tablet', {
        label: 'Страница Клуб 2 витрина (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-club2-tariffs-tablet">
            <div>
                <div>
                    <h2>Развивайте свою карьеру<br> в Careerum.Club</h2>
                    <div class="club2-tariffs__swicher-block">
                        <div class="club2-tariffs__swicher-top">
                            <p class="club2-tariffs__swicher-header">Посмотреть цены в <span>RUB<span></p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680514062680.svg" alt="" class="club2-tariffs__swicher-arrow">
                        </div>
                        <div class="club2-tariffs__swicher-bottom">
                            <ul>
                                <li data-currency="RUB">
                                    RUB
                                </li>
                                <li class="active" data-currency="EUR">
                                    EUR
                                </li>
                            </ul>
                            <p>
                                Обратите внимание,<br> что оплата в российских рублях возможна только<br> с карты российского банка. Оплата в евро — с карты зарубежного банка
                            </p>
                        </div>
                    </div>
                </div>
                <div class="club2-tariffs-wrapper">
                    <div class="club2-tariffs-item" data-price-eur="от 100 €" data-price-rub="от 8 075 ₽" data-link-rub="#rub" data-link-eur="#eur">
                        <p class="club2-tariffs-item__header">Тариф «Самостоятельный»</p>
                        <div class="club2-tariffs-item__content">
                            <ul>
                                <li class="active">Обучение</li>
                                <li class="active">Нетворкинг</li>
                                <li class="active">Поддержка сообщества</li>
                                <li>Поддержка коуча</li>
                                <li>Помощь CV-эксперта</li>
                                <li>2 личные сессии с коучем</li>
                            </ul>
                            <div class="club2-tariffs-item__price">
                                <p class="club2-tariffs-item__price-text">от 100 €</p>
                                <p>в месяц</p>
                            </div>
                        </div>
                        <a href="#125" class="btn-color-main-dark-orange">Оформить подписку</a>
                    </div>
                    <div class="club2-tariffs-item" data-price-eur="от 200 €" data-price-rub="от 9 991 ₽" data-link-rub="#rub" data-link-eur="#eur">
                        <p class="club2-tariffs-item__header">Тариф<br> «С поддержкой»</p>
                        <p class="club2-tariffs-item__places">Осталось 30 мест</p>
                        <div class="club2-tariffs-item__label">
                            <p>популярный</p>
                        </div>
                        <div class="club2-tariffs-item__content">
                            <ul>
                                <li class="active">Обучение</li>
                                <li class="active">Нетворкинг</li>
                                <li class="active">Поддержка сообщества</li>
                                <li class="active">Поддержка коуча</li>
                                <li class="active">Помощь CV-эксперта</li>
                                <li>2 личные сессии с коучем</li>
                            </ul>
                            <div class="club2-tariffs-item__price">
                                <p class="club2-tariffs-item__price-text">от 200 €</p>
                                <p>в месяц</p>
                            </div>
                        </div>
                        <a href="#124" class="btn-color-main-dark-orange">Оформить подписку</a>
                    </div>
                    <div class="club2-tariffs-item" data-price-eur="от 300 €" data-price-rub="от 19 633 ₽" data-link-rub="#rub" data-link-eur="#eur">
                        <p class="club2-tariffs-item__header">Тариф «Полное<br> сопровождение»</p>
                        <p class="club2-tariffs-item__places">Осталось 10 мест</p>
                        <div class="club2-tariffs-item__content">
                            <ul>
                                <li class="active">Обучение</li>
                                <li class="active">Нетворкинг</li>
                                <li class="active">Поддержка сообщества</li>
                                <li class="active">Поддержка коуча</li>
                                <li class="active">Помощь CV-эксперта</li>
                                <li class="active">2 личные сессии с коучем</li>
                            </ul>
                            <div class="club2-tariffs-item__price">
                                <p class="club2-tariffs-item__price-text">от 300 €</p>
                                <p>в месяц</p>
                            </div>
                        </div>
                        <a href="#123" class="btn-color-main-dark-orange">Оформить подписку</a>
                    </div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-club2-tariffs-mobile', {
        label: 'Страница Клуб 2 витрина (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-club2-tariffs-mobile">
            <div>
                <div>
                    <h2>Развивайте<br> свою карьеру<br> в Careerum.Club</h2>
                    <div class="club2-tariffs__swicher-block">
                        <div class="club2-tariffs__swicher-top">
                            <p class="club2-tariffs__swicher-header">Посмотреть цены в <span>RUB<span></p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680514062680.svg" alt="" class="club2-tariffs__swicher-arrow">
                        </div>
                        <div class="club2-tariffs__swicher-bottom">
                            <ul>
                                <li data-currency="RUB">
                                    RUB
                                </li>
                                <li class="active" data-currency="EUR">
                                    EUR
                                </li>
                            </ul>
                            <p>
                                Обратите внимание,<br> что оплата в российских рублях возможна только<br> с карты российского банка. Оплата в евро — с карты зарубежного банка
                            </p>
                        </div>
                    </div>
                </div>
                <div class="club2-tariffs-wrapper">
                    <div class="club2-tariffs-item" data-price-eur="от 100 €" data-price-rub="от 8 075 ₽" data-link-rub="#rub" data-link-eur="#eur">
                        <p class="club2-tariffs-item__header">Тариф «Самостоятельный»</p>
                        <div class="club2-tariffs-item__content">
                            <ul>
                                <li class="active">Обучение</li>
                                <li class="active">Нетворкинг</li>
                                <li class="active">Поддержка сообщества</li>
                                <li>Поддержка коуча</li>
                                <li>Помощь CV-эксперта</li>
                                <li>2 личные сессии с коучем</li>
                            </ul>
                            <div class="club2-tariffs-item__price">
                                <p class="club2-tariffs-item__price-text">от 100 €</p>
                                <p>в месяц</p>
                            </div>
                        </div>
                        <a href="#123" class="btn-color-main-dark-orange">Оформить подписку</a>
                    </div>
                    <div class="club2-tariffs-item" data-price-eur="от 200 €" data-price-rub="от 9 991 ₽" data-link-rub="#rub" data-link-eur="#eur">
                        <p class="club2-tariffs-item__header">Тариф<br> «С поддержкой»</p>
                        <p class="club2-tariffs-item__places">Осталось 30 мест</p>
                        <div class="club2-tariffs-item__label">
                            <p>популярный</p>
                        </div>
                        <div class="club2-tariffs-item__content">
                            <ul>
                                <li class="active">Обучение</li>
                                <li class="active">Нетворкинг</li>
                                <li class="active">Поддержка сообщества</li>
                                <li class="active">Поддержка коуча</li>
                                <li class="active">Помощь CV-эксперта</li>
                                <li>2 личные сессии с коучем</li>
                            </ul>
                            <div class="club2-tariffs-item__price">
                                <p class="club2-tariffs-item__price-text">от 200 €</p>
                                <p>в месяц</p>
                            </div>
                        </div>
                        <a href="#124" class="btn-color-main-dark-orange">Оформить подписку</a>
                    </div>
                    <div class="club2-tariffs-item" data-price-eur="от 300 €" data-price-rub="от 19 633 ₽" data-link-rub="#rub" data-link-eur="#eur">
                        <p class="club2-tariffs-item__header">Тариф «Полное<br> сопровождение»</p>
                        <p class="club2-tariffs-item__places">Осталось 10 мест</p>
                        <div class="club2-tariffs-item__content">
                            <ul>
                                <li class="active">Обучение</li>
                                <li class="active">Нетворкинг</li>
                                <li class="active">Поддержка сообщества</li>
                                <li class="active">Поддержка коуча</li>
                                <li class="active">Помощь CV-эксперта</li>
                                <li class="active">2 личные сессии с коучем</li>
                            </ul>
                            <div class="club2-tariffs-item__price">
                                <p class="club2-tariffs-item__price-text">от 300 €</p>
                                <p>в месяц</p>
                            </div>
                        </div>
                        <a href="#125" class="btn-color-main-dark-orange">Оформить подписку</a>
                    </div>
                </div>
            </div>
        </div>`
	});
    
    blockManager.add('careerum-club2-tariffs-rassr', {
        label: 'Страница Клуб 2 витрина с рассрочкой',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-club2-tariffs-rassr">
            <div>
                <div>
                    <h2>Развивайте свою карьеру<br> в Careerum.Club</h2>
                    <div class="club2-tariffs__swicher-block">
                        <div class="club2-tariffs__swicher-top">
                            <p class="club2-tariffs__swicher-header">Посмотреть цены в <span>RUB<span></p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680514062680.svg" alt="" class="club2-tariffs__swicher-arrow">
                        </div>
                        <div class="club2-tariffs__swicher-bottom">
                            <ul>
                                <li class="active" data-currency="RUB">
                                    RUB
                                </li>
                                <li data-currency="EUR">
                                    EUR
                                </li>
                            </ul>
                            <p>
                                Обратите внимание,<br> что оплата в российских рублях возможна только<br> с карты
                                российского банка. Оплата в евро — с карты зарубежного банка
                            </p>
                        </div>
                    </div>
                </div>
                <div class="club2-tariffs-wrapper">
                    <div class="club2-tariffs-item" data-price-EUR="от 100 €" data-price-RUB="от 8 075 ₽"
                        data-link-RUB="#125" data-link-EUR="#125">
                        <p class="club2-tariffs-item__header">Тариф «Самостоятельный»</p>
                        <div class="club2-tariffs-item__content">
                            <ul>
                                <li class="active">Все программы, курсы и уроки</li>
                                <li class="active">Поддержка сообщества</li>
                                <li>Групповой чат с коучами</li>
                                <li>Фидбэк по вашему <br>резюме от CV-эксперта</li>
                                <li>2 личные сессии с коучем</li>
                            </ul>
                            <div class="club2-tariffs-item__price">
                                <p class="club2-tariffs-item__price-rassr">
                                    Доступно в рассрочку
                                </p>
                                <div>
                                    <p class="club2-tariffs-item__price-text">от 100 €</p>
                                    <p>в месяц</p>
                                </div>
                            </div>
                        </div>
                        <a href="#125" class="btn-color-main-dark-orange">Оформить подписку</a>
                    </div>
                    <div class="club2-tariffs-item" data-price-EUR="от 200 €" data-price-RUB="от 9 991 ₽"
                        data-link-RUB="#124" data-link-EUR="#124">
                        <p class="club2-tariffs-item__header">Тариф<br> «С поддержкой»</p>
                        <p class="club2-tariffs-item__places">Осталось 30 мест</p>
                        <div class="club2-tariffs-item__label">
                            <p>популярный</p>
                        </div>
                        <div class="club2-tariffs-item__content">
                            <ul>
                                <li class="active">Все программы, курсы и уроки</li>
                                <li class="active">Поддержка сообщества</li>
                                <li class="active">Групповой чат с коучами</li>
                                <li class="active">Фидбэк по вашему <br>резюме от CV-эксперта</li>
                                <li>2 личные сессии с коучем</li>
                            </ul>
                            <div class="club2-tariffs-item__price">
                                <p class="club2-tariffs-item__price-rassr">
                                    Доступно в рассрочку
                                </p>
                                <div>
                                    <p class="club2-tariffs-item__price-text">от 200 €</p>
                                    <p>в месяц</p>
    
                                </div>
                            </div>
                        </div>
                        <a href="#124" class="btn-color-main-dark-orange">Оформить подписку</a>
                    </div>
                    <div class="club2-tariffs-item" data-price-eur="от 300 €" data-price-rub="от 19 633 ₽"
                        data-link-rub="#123" data-link-eur="#123">
                        <p class="club2-tariffs-item__header">Тариф «Полное<br> сопровождение»</p>
                        <p class="club2-tariffs-item__places">Осталось 10 мест</p>
                        <div class="club2-tariffs-item__content">
                            <ul>
                                <li class="active">Все программы, курсы и уроки</li>
                                <li class="active">Поддержка сообщества</li>
                                <li class="active">Личный чат с коучами</li>
                                <li class="active">Фидбэк по вашему <br>резюме от CV-эксперта</li>
                                <li class="active">2 личные сессии с коучем</li>
                            </ul>
                            <div class="club2-tariffs-item__price">
                                <p class="club2-tariffs-item__price-rassr">
                                    Доступно в рассрочку
                                </p>
                                <div>
                                    <p class="club2-tariffs-item__price-text">от 300 €</p>
                                    <p>в месяц</p>
                                </div>
                            </div>
                        </div>
                        <a href="#123" class="btn-color-main-dark-orange">Оформить подписку</a>
                    </div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-club2-tariffs-rassr-tablet', {
        label: 'Страница Клуб 2 витрина с рассрочкой (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-club2-tariffs-rassr-tablet">
            <div>
                <div>
                    <h2>Развивайте свою карьеру<br> в Careerum.Club</h2>
                    <div class="club2-tariffs__swicher-block">
                        <div class="club2-tariffs__swicher-top">
                            <p class="club2-tariffs__swicher-header">Посмотреть цены в <span>RUB<span></p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680514062680.svg" alt="" class="club2-tariffs__swicher-arrow">
                        </div>
                        <div class="club2-tariffs__swicher-bottom">
                            <ul>
                                <li data-currency="RUB">
                                    RUB
                                </li>
                                <li class="active" data-currency="EUR">
                                    EUR
                                </li>
                            </ul>
                            <p>
                                Обратите внимание,<br> что оплата в российских рублях возможна только<br> с карты российского банка. Оплата в евро — с карты зарубежного банка
                            </p>
                        </div>
                    </div>
                </div>
                <div class="club2-tariffs-wrapper">
                    <div class="club2-tariffs-item" data-price-EUR="от 100 €" data-price-RUB="от 8 075 ₽">
                        <p class="club2-tariffs-item__header">Тариф «Самостоятельный»</p>
                        <div class="club2-tariffs-item__content">
                            <ul>
                                <li class="active">Все программы, курсы и уроки</li>
                                <li class="active">Поддержка сообщества</li>
                                <li>Групповой чат с коучами</li>
                                <li>Фидбэк по вашему <br>резюме от CV-эксперта</li>
                                <li>2 личные сессии с коучем</li>
                            </ul>
                            <div class="club2-tariffs-item__price">
                                <p class="club2-tariffs-item__price-rassr">
                                    Доступно в рассрочку
                                </p>
                                <div>
                                    <p class="club2-tariffs-item__price-text">от 100 €</p>
                                    <p>в месяц</p>
                                </div>
                            </div>
                        </div>
                        <a href="#125" class="btn-color-main-dark-orange">Оформить подписку</a>
                    </div>
                    <div class="club2-tariffs-item" data-price-EUR="от 200 €" data-price-RUB="от 9 991 ₽">
                        <p class="club2-tariffs-item__header">Тариф<br> «С поддержкой»</p>
                        <p class="club2-tariffs-item__places">Осталось 30 мест</p>
                        <div class="club2-tariffs-item__label">
                            <p>популярный</p>
                        </div>
                        <div class="club2-tariffs-item__content">
                            <ul>
                                <li class="active">Все программы, курсы и уроки</li>
                                <li class="active">Поддержка сообщества</li>
                                <li class="active">Групповой чат с коучами</li>
                                <li class="active">Фидбэк по вашему <br>резюме от CV-эксперта</li>
                                <li>2 личные сессии с коучем</li>
                            </ul>
                            <div class="club2-tariffs-item__price">
                                <p class="club2-tariffs-item__price-rassr">
                                    Доступно в рассрочку
                                </p>
                                <div>
                                    <p class="club2-tariffs-item__price-text">от 100 €</p>
                                    <p>в месяц</p>
                                </div>
                            </div>
                        </div>
                        <a href="#124" class="btn-color-main-dark-orange">Оформить подписку</a>
                    </div>
                    <div class="club2-tariffs-item" data-price-EUR="от 300 €" data-price-RUB="от 19 633 ₽">
                        <p class="club2-tariffs-item__header">Тариф «Полное<br> сопровождение»</p>
                        <p class="club2-tariffs-item__places">Осталось 10 мест</p>
                        <div class="club2-tariffs-item__content">
                            <ul>
                                <li class="active">Все программы, курсы и уроки</li>
                                <li class="active">Поддержка сообщества</li>
                                <li class="active">Личный чат с коучами</li>
                                <li class="active">Фидбэк по вашему <br>резюме от CV-эксперта</li>
                                <li class="active">2 личные сессии с коучем</li>
                            </ul>
                            <div class="club2-tariffs-item__price">
                                <p class="club2-tariffs-item__price-rassr">
                                    Доступно в рассрочку
                                </p>
                                <div>
                                    <p class="club2-tariffs-item__price-text">от 100 €</p>
                                    <p>в месяц</p>
                                </div>
                            </div>
                        </div>
                        <a href="#123" class="btn-color-main-dark-orange">Оформить подписку</a>
                    </div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-club2-tariffs-rassr-mobile', {
        label: 'Страница Клуб 2 витрина с рассрочкой (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-club2-tariffs-rassr-mobile">
            <div>
                <div>
                    <h2>Развивайте<br> свою карьеру<br> в Careerum.Club</h2>
                    <div class="club2-tariffs__swicher-block">
                        <div class="club2-tariffs__swicher-top">
                            <p class="club2-tariffs__swicher-header">Посмотреть цены в <span>RUB<span></p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680514062680.svg" alt="" class="club2-tariffs__swicher-arrow">
                        </div>
                        <div class="club2-tariffs__swicher-bottom">
                            <ul>
                                <li data-currency="RUB">
                                    RUB
                                </li>
                                <li class="active" data-currency="EUR">
                                    EUR
                                </li>
                            </ul>
                            <p>
                                Обратите внимание,<br> что оплата в российских рублях возможна только<br> с карты российского банка. Оплата в евро — с карты зарубежного банка
                            </p>
                        </div>
                    </div>
                </div>
                <div class="club2-tariffs-wrapper">
                    <div class="club2-tariffs-item" data-price-EUR="от 100 €" data-price-RUB="от 8 075 ₽">
                        <p class="club2-tariffs-item__header">Тариф «Самостоятельный»</p>
                        <div class="club2-tariffs-item__content">
                            <ul>
                                <li class="active">Все программы, курсы и уроки</li>
                                <li class="active">Поддержка сообщества</li>
                                <li>Групповой чат с коучами</li>
                                <li>Фидбэк по вашему <br>резюме от CV-эксперта</li>
                                <li>2 личные сессии с коучем</li>
                            </ul>
                            <div class="club2-tariffs-item__price">
                                <p class="club2-tariffs-item__price-rassr">
                                    Доступно в рассрочку
                                </p>
                                <div>
                                    <p class="club2-tariffs-item__price-text">от 100 €</p>
                                    <p>в месяц</p>
                                </div>
                            </div>
                        </div>
                        <a href="#123" class="btn-color-main-dark-orange">Оформить подписку</a>
                    </div>
                    <div class="club2-tariffs-item" data-price-EUR="от 200 €" data-price-RUB="от 9 991 ₽">
                        <p class="club2-tariffs-item__header">Тариф<br> «С поддержкой»</p>
                        <p class="club2-tariffs-item__places">Осталось 30 мест</p>
                        <div class="club2-tariffs-item__label">
                            <p>популярный</p>
                        </div>
                        <div class="club2-tariffs-item__content">
                            <ul>
                                <li class="active">Все программы, курсы и уроки</li>
                                <li class="active">Поддержка сообщества</li>
                                <li class="active">Групповой чат с коучами</li>
                                <li class="active">Фидбэк по вашему <br>резюме от CV-эксперта</li>
                                <li>2 личные сессии с коучем</li>
                            </ul>
                            <div class="club2-tariffs-item__price">
                                <p class="club2-tariffs-item__price-rassr">
                                    Доступно в рассрочку
                                </p>
                                <div>
                                    <p class="club2-tariffs-item__price-text">от 100 €</p>
                                    <p>в месяц</p>
                                </div>
                            </div>
                        </div>
                        <a href="#124" class="btn-color-main-dark-orange">Оформить подписку</a>
                    </div>
                    <div class="club2-tariffs-item" data-price-EUR="от 300 €" data-price-RUB="от 19 633 ₽">
                        <p class="club2-tariffs-item__header">Тариф «Полное<br> сопровождение»</p>
                        <p class="club2-tariffs-item__places">Осталось 10 мест</p>
                        <div class="club2-tariffs-item__content">
                            <ul>
                                <li class="active">Все программы, курсы и уроки</li>
                                <li class="active">Поддержка сообщества</li>
                                <li class="active">Групповой чат с коучами</li>
                                <li class="active">Фидбэк по вашему <br>резюме от CV-эксперта</li>
                                <li class="active">2 личные сессии с коучем</li>
                            </ul>
                            <div class="club2-tariffs-item__price">
                                <p class="club2-tariffs-item__price-rassr">
                                    Доступно в рассрочку
                                </p>
                                <div>
                                    <p class="club2-tariffs-item__price-text">от 100 €</p>
                                    <p>в месяц</p>
                                </div>
                            </div>
                        </div>
                        <a href="#125" class="btn-color-main-dark-orange">Оформить подписку</a>
                    </div>
                </div>
            </div>
        </div>`
	});
    
    blockManager.add('careerum-club2-popup-block-pay', {
        label: 'Страница Клуб 2 попап оплата',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-popup careerum-club2-popup-block-pay" id="">
            <div class="popup__close-button-wrapper">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680514187058.svg" alt="" class="close-switch">
            </div>
            <div class="careerum-club2-popup-wrapper">
                <div class="club2-popup-block-pay-desc">
                    <div class="careerum-club2-popup-notif-tariff">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680514201045.svg" alt="">
                        <p>Тариф «Самостоятельный» </p>
                    </div>
                    <div class="careerum-club2-popup-notif-discount">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680514211658.svg" alt="">
                        <p>Скидка до 10% на покупку от 3 месяцев </p>
                    </div>
                </div>
                <div class="careerum-club2-popup-step1">
                    <p class="club2-popup-block-pay-desc">Шаг 1. Выберите количество месяцев в&nbsp;клубе</p>
                    <p class="club2-popup-block-pay-mob">Выберите количество месяцев в клубе</p>
                    <p class="club2-popup-block-pay-mob">Тариф «Самостоятельный»</p>
                    <p class="club2-popup-block-pay-mob">Скидка до 10% на покупку<br> от 3 месяцев</p>
                    <div>
                        <div class="careerum-club2-popup__period-switcher" data-period-offer-id="11">
                            <div class="careerum-club2-popup__label">
                                <p>выгодный</p>
                            </div>
                            <p class="careerum-club2-popup__period-switcher-mounth">12 месяцев</p>
                            <p class="careerum-club2-popup__period-switcher-goal">Закрыть все долгосрочные цели</p>
                            <div class="careerum-club2-popup__period-switcher-line"></div>
                            <p class="careerum-club2-popup__period-switcher-old-price">8 150 ₽</p>
                            <p class="careerum-club2-popup__period-switcher-per-mounth">8 075 ₽ в месяц</p>
                            <p class="careerum-club2-popup__period-switcher-total">= 96 900 ₽</p>
                            <button class="btn-color-main-dark-orange active">Выбрать</button>
                            <button class="btn-color-main-dark-orange inactive" disabled>Выбрано</button>
                        </div>
                        <div class="careerum-club2-popup__period-switcher" data-period-offer-id="12">
                            <p class="careerum-club2-popup__period-switcher-mounth">6 месяцев</p>
                            <p class="careerum-club2-popup__period-switcher-goal">Получить оффер, добиться повышения</p>
                            <div class="careerum-club2-popup__period-switcher-line"></div>
                            <p class="careerum-club2-popup__period-switcher-old-price">8 300 ₽</p>
                            <p class="careerum-club2-popup__period-switcher-per-mounth">8 150 ₽ в месяц</p>
                            <p class="careerum-club2-popup__period-switcher-total">= 48 900 ₽</p>
                            <button class="btn-color-main-dark-orange active">Выбрать</button>
                            <button class="btn-color-main-dark-orange inactive" disabled>Выбрано</button>
                        </div>
                        <div class="careerum-club2-popup__period-switcher" data-period-offer-id="13">
                            <div class="careerum-club2-popup__label">
                                <p>популярный</p>
                            </div>
                            <p class="careerum-club2-popup__period-switcher-mounth">3 месяца</p>
                            <p class="careerum-club2-popup__period-switcher-goal">Получить первые результаты и ответы на отклики</p>
                            <div class="careerum-club2-popup__period-switcher-line"></div>
                            <p class="careerum-club2-popup__period-switcher-old-price">8 900 ₽</p>
                            <p class="careerum-club2-popup__period-switcher-per-mounth">8 300 ₽ в месяц</p>
                            <p class="careerum-club2-popup__period-switcher-total">= 24 900 ₽</p>
                            <button class="btn-color-main-dark-orange active">Выбрать</button>
                            <button class="btn-color-main-dark-orange inactive" disabled>Выбрано</button>
                        </div>
                        <div class="careerum-club2-popup__period-switcher" data-period-offer-id="14">
                            <p class="careerum-club2-popup__period-switcher-mounth">1 месяц</p>
                            <p class="careerum-club2-popup__period-switcher-goal">Определить цели<br> и составить план</p>
                            <div class="careerum-club2-popup__period-switcher-line"></div>
                            <p class="careerum-club2-popup__period-switcher-old-price">&nbsp;</p>
                            <p class="careerum-club2-popup__period-switcher-per-mounth">&nbsp;</p>
                            <p class="careerum-club2-popup__period-switcher-total">= 8 900 ₽</p>
                            <button class="btn-color-main-dark-orange active">Выбрать</button>
                            <button class="btn-color-main-dark-orange inactive" disabled>Выбрано</button>
                        </div>
                    </div>
                </div>
                <div class="careerum-club2-popup-step2">
                    <div>
                        <p class="form-p-desctop">Шаг 2.<br> Укажите свои данные</p>
                        <p class="form-p-tablet">Шаг 2. Укажите свои данные</p>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680514237548.svg" alt="" class="form-img-desctop">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680514248995.svg" alt="" class="form-img-tablet">
                    </div>
                    <div>
                        <div class="careerum-registration-form">
                            <form class="deva-form" name="devaRegistrationForm">
                                <div><input type="text" name="firstname" id="" required placeholder="Имя"><span>Имя</span></div>
                                <div><input type="text" name="lastname" id="" required placeholder="Фамилия"><span>Фамилия</span></div>
                                <div><input type="email" name="email" id="" required placeholder="Почта"><span>Почта</span></div>
                                <div><input type="tel" name="phone" id="" required placeholder="Номер телефона"><span>Номер телефона</span></div>                                
                                <div>
                                    <label><input type="checkbox" name="agree" id=""></label>
                                    <p>Я принимаю условия <a href="">Публичной оферты</a> и&nbsp;даю&nbsp;согласие на обработку своих персональных данных в соответствии с&nbsp;<a href="">Политикой конфиденциальности</a>. Подписка будет автоматически продлеваться по такой же цене и на такой же период времени в&nbsp;последний день оплаченного периода</p>
                                </div>
                                <a href="#" disabled class="submit-btn">Перейти к оплате</a>
                                <input type="hidden" name="offerID" required>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
	});
    
    blockManager.add('careerum-club2-popup-block-pay-rassr', {
        label: 'Страница Клуб 2 попап оплата рассрочка',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-popup careerum-club2-popup-block-pay-rassr" id="">
            <div class="popup__close-button-wrapper">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680514187058.svg" alt="" class="close-switch">
            </div>
            <div class="careerum-club2-popup-wrapper">
                <div class="club2-popup-block-pay-desc">
                    <div class="careerum-club2-popup-notif-tariff">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680514201045.svg" alt="">
                        <p>Тариф «Самостоятельный» </p>
                    </div>
                    <div class="careerum-club2-popup-notif-rassr">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1683717359889.svg" alt="">
                        <p>Рассрочка без<br> переплаты на пакеты<br> 6 и 12 месяцев</p>
                    </div>
                    <div class="careerum-club2-popup-notif-discount">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680514211658.svg" alt="">
                        <p>Скидка до 10% на покупку от 3 месяцев </p>
                    </div>
                </div>
                <div class="careerum-club2-popup-step1">
                    <p class="club2-popup-block-pay-desc">Шаг 1. Выберите количество месяцев в&nbsp;клубе</p>
                    <p class="club2-popup-block-pay-mob">Выберите количество месяцев в клубе</p>
                    <p class="club2-popup-block-pay-mob">Тариф «Самостоятельный»</p>
                    <p class="club2-popup-block-pay-mob">Рассрочка без переплаты на пакеты 6 и 12 месяцев</p>
                    <p class="club2-popup-block-pay-mob">При оплате в рассрочку первый платеж через 30 дней</p>
                    <div>
                        <div class="careerum-club2-popup__period-switcher" data-period-offer-id="11">
                            <div class="careerum-club2-popup__label">
                                <p>выгодный</p>
                            </div>
                            <p class="careerum-club2-popup__period-switcher-mounth">12 месяцев</p>
                            <p class="careerum-club2-popup__period-switcher-goal">Закрыть все долгосрочные цели</p>
                            <div class="careerum-club2-popup__period-switcher-line"></div>
                            <div class="careerum-club2-popup__period-switcher-price-line"><p class="careerum-club2-popup__period-switcher-price">8 075 ₽</p>
                            <p class="careerum-club2-popup__period-switcher-per-mounth">/месяц</p></div>
                            <p class="careerum-club2-popup__period-switcher-total">к оплате 96 900 ₽</p>
                            <button class="btn-color-main-dark-orange active">Выбрать</button>
                            <button class="btn-color-main-dark-orange inactive" disabled>Выбрано</button>
                        </div>
                        <div class="careerum-club2-popup__period-switcher" data-period-offer-id="12">
                            <p class="careerum-club2-popup__period-switcher-mounth">6 месяцев</p>
                            <p class="careerum-club2-popup__period-switcher-goal">Получить оффер, добиться повышения</p>
                            <div class="careerum-club2-popup__period-switcher-line"></div>
                            <div class="careerum-club2-popup__period-switcher-price-line"><p class="careerum-club2-popup__period-switcher-price">8 150 ₽</p>
                            <p class="careerum-club2-popup__period-switcher-per-mounth">/месяц</p></div>
                            <p class="careerum-club2-popup__period-switcher-total">к оплате 48 900 ₽</p>
                            <button class="btn-color-main-dark-orange active">Выбрать</button>
                            <button class="btn-color-main-dark-orange inactive" disabled>Выбрано</button>
                        </div>
                        <div class="careerum-club2-popup__period-switcher" data-period-offer-id="13">
                            <div class="careerum-club2-popup__label">
                                <p>популярный</p>
                            </div>
                            <p class="careerum-club2-popup__period-switcher-mounth">3 месяца</p>
                            <p class="careerum-club2-popup__period-switcher-goal">Получить первые результаты и ответы на
                                отклики</p>
                            <div class="careerum-club2-popup__period-switcher-line"></div>
                            <div class="careerum-club2-popup__period-switcher-price-line">
                                <p class="careerum-club2-popup__period-switcher-price">8 300 ₽</p>
                                <p class="careerum-club2-popup__period-switcher-per-mounth">/месяц</p>
                            </div>
                            <p class="careerum-club2-popup__period-switcher-total">к оплате 24 900 ₽</p>
                            <button class="btn-color-main-dark-orange active">Выбрать</button>
                            <button class="btn-color-main-dark-orange inactive" disabled>Выбрано</button>
                        </div>
                        <div class="careerum-club2-popup__period-switcher" data-period-offer-id="14">
                            <p class="careerum-club2-popup__period-switcher-mounth">1 месяц</p>
                            <p class="careerum-club2-popup__period-switcher-goal">Определить цели<br> и составить план</p>
                            <div class="careerum-club2-popup__period-switcher-line"></div>
                            <div class="careerum-club2-popup__period-switcher-price-line"><p class="careerum-club2-popup__period-switcher-price">8 900 ₽</p>
                            <p class="careerum-club2-popup__period-switcher-per-mounth">&nbsp;</p></div>
                            <p class="careerum-club2-popup__period-switcher-total">&nbsp;</p>
                            <button class="btn-color-main-dark-orange active">Выбрать</button>
                            <button class="btn-color-main-dark-orange inactive" disabled>Выбрано</button>
                        </div>
                    </div>
                </div>
                <div class="careerum-club2-popup-step2">
                    <div>
                        <p class="form-p-desctop">Шаг 2.<br> Укажите свои данные</p>
                        <p class="form-p-tablet">Шаг 2. Укажите свои данные</p>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680514237548.svg" alt="" class="form-img-desctop">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680514248995.svg" alt="" class="form-img-tablet">
                    </div>
                    <div>
                        <div class="careerum-registration-form">
                            <form class="deva-form" name="devaRegistrationForm">
                                <div><input type="text" name="firstname" id="" required placeholder="Имя"><span>Имя</span></div>
                                <div><input type="text" name="lastname" id="" required placeholder="Фамилия"><span>Фамилия</span></div>
                                <div><input type="email" name="email" id="" required placeholder="Почта"><span>Почта</span></div>
                                <div><input type="tel" name="phone" id="" required placeholder="Номер телефона"><span>Номер телефона</span></div>                                
                                <div>
                                    <label><input type="checkbox" name="agree" id=""></label>
                                    <p>Я принимаю условия <a href="">Публичной оферты</a> и&nbsp;даю&nbsp;согласие на обработку своих персональных данных в соответствии с&nbsp;<a href="">Политикой конфиденциальности</a>. Подписка будет автоматически продлеваться по такой же цене и на такой же период времени в&nbsp;последний день оплаченного периода</p>
                                </div>
                                <a href="#" disabled class="submit-btn">Перейти к оплате</a>
                                <input type="hidden" name="offerID" required>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
	});
    
    blockManager.add('careerum-club2-popup-block-subscribe', {
        label: 'Страница Клуб 2 попап подписка',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-popup careerum-club2-popup-block-subscribe" id="">
            <div class="popup__close-button-wrapper">
            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680514187058.svg" alt="" class="close-switch">
            </div>
            <div class="careerum-club2-popup-wrapper">
                <div class="careerum-form-lead">
                    <div>
                        <p class="popup-block-subscribe__header">Бронь места<br> в клубе</p>
                        <p class="popup-block-subscribe__text">Сейчас Сareerum.Club закрыт.  <br>Заполните заявку, чтобы записаться в&nbsp;лист&nbsp;ожидания.
                            Укажите, пожалуйста, ваш e-mail и&nbsp;номер телефона (в полном формате начиная с "+" и кодом страны), и&nbsp;мы&nbsp;раньше всех сообщим вам о&nbsp;возможности вступить в клуб!</p>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680514448022.svg" alt="">
                    </div>
                    <div>
                        <form class="deva-form getcourse-email-signup" name="devaRegistrationForm"
                            data-gjs-type="deva-registration-form">
                            <div>
                                <div class="careerum-form-lead-fname">
                                    <input type="text" name="firstname" value="" placeholder="Имя " required>
                                    <span>Имя</span>
                                </div>
                                <div class="careerum-form-lead-lname">
                                    <input type="text" name="lastname" value="" placeholder="Фамилия " required>
                                    <span>Имя</span>
                                </div>
                                <div class="careerum-form-lead-email">
                                    <input type="email" name="email" value="" placeholder="Почта " required>
                                    <span>Почта</span>
                                </div>
                                <div class="careerum-form-lead-tel">
                                    <input type="tel" name="tel" value="" placeholder="Номер телефона " required>
                                    <span>Номер телефона</span>
                                </div>
                            </div>
                            <div class="careerum-form-lead-agree">
                                <label data-toggle-checkbox="true">
                                    <input type="checkbox" name="agree">
                                </label>
                                <p>Я принимаю условия <a href="">Публичной оферты</a> и&nbsp;даю&nbsp;согласие на обработку своих персональных данных в соответствии с&nbsp;<a href="">Политикой конфиденциальности</a>
                            </div>
                            <a href="#" disabled class="submit-btn btn-desc">Забронировать место</a>
                        </form>
                    </div>
                </div>
        
                <div class="careerum-form-success-lead">
                <div>
                    <p>Спасибо, что оставили заявку!</p>
                    <p>Письмо с приглашением оформить подписку и вступить в клуб придет вам раньше всех</p>
                    <button class="btn-color-main-dark-orange close-switch">Вернуться на страницу клуба</button>
                </div>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680514424714.svg" alt="" class="form-img-desctop">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680514408273.svg" alt="" class="form-img-tablet">
            </div>
            </div>
        </div>`
	});
    
    blockManager.add('no-cabinet', {
        label: 'Страница Клуб 2 попап ЛК нет',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div getcourse-group="" getcourse-redirect-url="" js-hide-script="" hide-by-geo="unset" id="thanks-no" class="careerum-popup careerum-club2-popup-block-subscribe no-cabinet">
            <div class="popup__close-button-wrapper">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680514187058.svg" alt="" class="close-switch">
            </div>
            <div class="careerum-club2-popup-wrapper">
                <div class="careerum-form-lead form-sent"></div>
                <div class="careerum-form-success-lead">
                    <div>
                        <p>Теперь у вас есть личный кабинет!</p>
                        <p>Чтобы попасть туда, нужно всего лишь подтвердить свой email.<br><br>Для этого нажмите кнопку ниже и следуйте нашим инструкциям.</p>
                        <a onclick="" class="close-switch btn-color-main-dark-orange cabinet-activate">Перейти в личный кабинет</a>
                    </div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680514424714.svg" alt="" class="form-img-desctop">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680514408273.svg" alt="" class="form-img-tablet">
                </div>
            </div>
        </div>`
	});
    
    blockManager.add('has-cabinet', {
        label: 'Страница Клуб 2 попап ЛК есть',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div getcourse-group="" getcourse-redirect-url="" js-hide-script="" hide-by-geo="unset" id="thanks-has" class="careerum-popup careerum-club2-popup-block-subscribe has-cabinet">
            <div class="popup__close-button-wrapper"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680514187058.svg" alt="" class="close-switch"></div>
            <div class="careerum-club2-popup-wrapper">
                <div class="careerum-form-lead form-sent"></div>
                <div class="careerum-form-success-lead">
                    <div>
                        <p>Welcome back! Рады видеть вас снова</p>
                        <p>Вы уже зарегистрированы в Careerum.<br><br>Чтобы войти в личный кабинет, нажмите на кнопку ниже.</p>
                        <a onclick="" class="close-switch btn-color-main-dark-orange">Войти в личный кабинет</a>
                    </div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1703771156804.svg" alt="" class="form-img-tablet">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1703771156804.svg" alt="" class="form-img-desctop">
                </div>
            </div>
        </div>`
	});
    
    blockManager.add('careerum-thanks-page', {
        label: 'Спасибо 2.0',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-thanks-page">
            <div>
                <h2>Поздравляем!<br> Вы успешно<br> оформили<br> подписку</h2>
                <div class="thanks-tab-light-blue">
                    <p>Впереди 90 дней обучения и развития в Careerum.Club на тарифе «Полное сопровождение»</p>
                </div>
                <div class="thanks-tab-medium-yellow">
                    <p>Проверьте почту<br> — мы уже отправили<br> вам письмо<br> с доступами!</p>
                </div>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1681114565333.svg" alt="">
            </div>
        </div>`
	});

    blockManager.add('careerum-thanks-page-tablet', {
        label: 'Спасибо 2.0 (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-thanks-page-tablet">
            <div>
                <h2>Поздравляем!<br> Вы успешно<br> оформили подписку</h2>
                <div class="thanks-tab-medium-yellow">
                    <p>Впереди 90 дней обучения и развития в Careerum.Club<br> на тарифе «Полное сопровождение»</p>
                </div>
                <div class="thanks-tab-light-blue">
                    <p>Проверьте почту<br> — мы уже отправили<br> вам письмо<br> с доступами!</p>
                </div>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1681114571352.svg" alt="">
            </div>
        </div>`
	});

    blockManager.add('careerum-thanks-page-mobile', {
        label: 'Спасибо 2.0 (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-thanks-page-mobile">
            <div>
                <h2>Поздравляем! Вы<br> успешно оформили<br> подписку</h2>
                <div class="thanks-tab-light-blue">
                    <p>Впереди 90 дней обучения и развития в Careerum.Club<br> на тарифе «Полное сопровождение»</p>
                </div>
                <div class="thanks-tab-medium-yellow">
                    <p>Проверьте почту<br> — мы уже отправили вам письмо с доступами!</p>
                </div>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1681114573847.svg" alt="">
            </div>
        </div>`
	});
    
    blockManager.add('careerum-club2-banner', {
        label: 'Страница Клуб 2 баннер',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-club2-banner">
            <div>
                <div>
                    <div>
                        <h2><span>Вырасти в доходе<br> за 9 эфиров?</span> Сделаем это вместе на фокус-кэмпе</h2>
                        <p>8 июня — 13 августа</p>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1683871720619.svg" alt="">
                        <ul>
                            <li>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1683871735072.svg" alt=""><p>Доступен только для участников Careerum.Club</p>
                            </li>
                            <li>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1683871754436.svg" alt=""><p>Рекомендуем приобрести<br> подписку на клуб от 3 месяцев</p>
                            </li>
                        </ul>
                    </div>
                    <div>
                        <div>
                            <div class="careerum-club2-banner-item-light-blue"><p>Получите пошаговые<br> инструкции и записи<br> вебинаров о том, как<br> расти в зарплате</p></div>
                            <div class="careerum-club2-banner-item-very-light-blue"><p>Узнаете, можно ли<br> попробовать себя<br> в новой сфере<br> и не потерять<br> в доходе</p></div>
                            <div class="careerum-club2-banner-item-dark-blue"><p>В группах из 2–4 человек<br> проработаете<br> психологические<br> установки, которые<br> мешают повысить доход</p></div>
                        </div>
                        <div>
                            <div class="careerum-club2-banner-item-light-orange"><p>Составите карьерный<br> план, чтобы достигать<br> финансовых<br> целей пошагово</p></div>
                            <div class="careerum-club2-banner-item-medium-yellow"><p>Научитесь презентовать<br> свои навыки и<br> достижения,
                                чтобы<br> правильно обсуждать<br> финансовое<br> вознаграждение</p></div>
                            <div class="careerum-club2-banner-item-image"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1683871771123.svg" alt=""><p>Фокус-кэмп, что это?<br> 
                                <span>Форма онлайн-обучения, в которой каждую неделю вы получаете теоретические материалы и участвуете в практикумах для проработки теории в мини-группе.</span></p></div>
                        </div>
                    </div>
                </div>
                <div>
                    <a href="#" class="btn-color-main-dark-orange">Хочу на фокус-кэмп</a>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-club2-banner-tablet', {
        label: 'Страница Клуб 2 баннер (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-club2-banner-tablet">
            <div>
                <div>
                    <div>
                        <h2><span>Вырасти в доходе<br> за 9 эфиров?</span> Сделаем это вместе<br> на фокус-кэмпе</h2>
                        <div>
                            <div>
                                <p>8 июня — 13 августа</p>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1683871844656.svg" alt="">
                            </div>
                            <ul>
                                <li>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1683871735072.svg" alt=""><p>Доступен только<br> для участников<br> Careerum.Club</p>
                                </li>
                                <li>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1683871754436.svg" alt=""><p>Рекомендуем<br> приобрести подписку<br> на клуб от 3 месяцев</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div>
                        <div>
                            <div class="careerum-club2-banner-item-light-blue"><p>Получите пошаговые<br> инструкции и записи<br> вебинаров о том, как<br> расти в зарплате</p></div>
                            <div class="careerum-club2-banner-item-medium-yellow"><p>Узнаете, можно ли<br> попробовать себя<br> в новой сфере<br> и не потерять<br> в доходе</p></div>
                            <div class="careerum-club2-banner-item-very-light-blue"><p>В группах из 2–4 человек<br> проработаете<br> психологические<br> установки, которые<br> мешают повысить доход</p></div>
                        </div>
                        <div>
                            <div class="careerum-club2-banner-item-light-orange"><p>Составите карьерный<br> план, чтобы достигать<br> финансовых<br> целей пошагово</p></div>
                            <div class="careerum-club2-banner-item-light-blue"><p>Научитесь презентовать<br> свои навыки и<br> достижения,
                                чтобы<br> правильно обсуждать<br> финансовое<br> вознаграждение</p></div>
                            <div class="careerum-club2-banner-item-image"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1683871859339.svg" alt=""><p>Фокус-кэмп, что это?<br> 
                                <span>Форма онлайн-обучения, в которой каждую неделю<br> вы получаете теоретические материалы и участвуете<br> в практикумах<br> для проработки теории <br>в мини-группе.</span></p></div>
                        </div>
                    </div>
                </div>
                <div>
                    <a href="#" class="btn-color-main-dark-orange">Хочу на фокус-кэмп</a>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-club2-banner-mobile', {
        label: 'Страница Клуб 2 баннер (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-club2-banner-mobile">
            <div>
                <div>
                    <div>
                        <h2><span>Вырасти в доходе<br> за 9 эфиров?</span> Сделаем это<br> вместе на фокус-кэмпе</h2>
                        <div>
                            <div>
                                <p>8 июня — 13 августа</p>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1683871844656.svg" alt="">
                            </div>
                            <ul>
                                <li>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1683871735072.svg" alt=""><p>Доступен только для<br> участников Careerum.Club</p>
                                </li>
                                <li>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1683871754436.svg" alt=""><p>Рекомендуем приобрести<br> подписку на клуб от 3 месяцев</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div>
                        <div>
                            <div class="careerum-club2-banner-item-light-blue"><p>Получите пошаговые<br> инструкции и записи вебинаров о том, как расти в зарплате</p></div>
                            <div class="careerum-club2-banner-item-medium-yellow"><p>Узнаете, можно ли попробовать себя в новой сфере и не потерять<br> в доходе</p></div>
                            <div class="careerum-club2-banner-item-very-light-blue"><p>В группах из 2–4 человек<br> проработаете психологические<br> установки, которые мешают повысить доход</p></div>
                            <div class="careerum-club2-banner-item-light-orange"><p>Составите карьерный план, чтобы достигать финансовых<br> целей пошагово</p></div>
                            <div class="careerum-club2-banner-item-light-blue"><p>Научитесь презентовать свои навыки и достижения,
                                чтобы<br> правильно обсуждать<br> финансовое вознаграждение</p></div>
                            <div class="careerum-club2-banner-item-image"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1683871883490.svg" alt=""><p>Фокус-кэмп, что это?<br> 
                                <span>Форма онлайн-обучения,<br> в которой каждую неделю вы получаете теоретические<br> материалы и участвуете<br> в практикумах для проработки<br> теории в мини-группе.</span></p></div>
                        </div>
                    </div>
                </div>
                <div>
                    <a href="#" class="btn-color-main-dark-orange">Хочу на фокус-кэмп</a>
                </div>
            </div>
        </div>`
	});
    
    blockManager.add('careerum-club21-main', {
        label: 'Клуб 2.1 первый блок',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-club21-main">
            <div>
                <div class="careerum-club21-main__top">
                    <h1>Постройте карьеру<br> по своим правилам</h1>
                    <p>Careerum — это образовательная платформа, с помощью<br> которой специалисты могут поставить карьерную цель и достичь ее</p>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1691831957878.svg" alt="">
                </div>
                <div class="careerum-club21-main__bottom">
                    <div>
                        <div>
                            <p class="main-block-header">в 1,5 раза</p>
                            <p>средний рост зарплаты участников Careerum</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1691831937175.svg" alt="">
                        </div>
                        <div>
                            <p class="main-block-header">4 000 +</p>
                            <p>офферов получили участники по всему миру</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1691831973998.svg" alt="">
                        </div>
                        <div>
                            <p class="main-block-header">9 из 10</p>
                            <p>участников<br> рекомендуют Careerum друзьям</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1691831988562.svg" alt="">
                        </div>
                    </div>
                </div>
                <div class="careerum-club21-main__button">
                    <a href="#" class="btn-color-main-dark-orange">Оставить заявку</a>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-club21-main-tablet', {
        label: 'Клуб 2.1 первый блок (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-club21-main-tablet">
            <div>
                <div class="careerum-club21-main__top">
                    <h1>Постройте карьеру<br> по своим правилам</h1>
                    <p>Careerum — это образовательная платформа, с помощью<br> которой специалисты могут поставить карьерную цель и достичь ее</p>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1691831957878.svg" alt="">
                </div>
                <div class="careerum-club21-main__bottom">
                    <div>
                        <div>
                            <p class="main-block-header">в 1,5 раза</p>
                            <p>средний рост зарплаты участников Careerum</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1691832041525.svg" alt="">
                        </div>
                        <div>
                            <p class="main-block-header">4 000 +</p>
                            <p>офферов получили участники по всему миру</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1691832052771.svg" alt="">
                        </div>
                        <div>
                            <p class="main-block-header">9 из 10</p>
                            <p>участников<br> рекомендуют Careerum друзьям</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1691832064011.svg" alt="">
                        </div>
                    </div>
                </div>
                <div class="careerum-club21-main__button">
                    <a href="#" class="btn-color-main-dark-orange">Оставить заявку</a>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-club21-main-mobile', {
        label: 'Клуб 2.1 первый блок (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-club21-main-mobile">
            <div>
                <div>
                    <h1>Постройте карьеру<br> по своим правилам</h1>
                    <p>Careerum — это образовательная платформа, с помощью<br> которой специалисты могут поставить карьерную цель и достичь ее</p>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1691832108885.svg" alt="">
                </div>
                <div>
                    <div>
                        <div>
                            <p class="main-block-header">в 1,5 раза</p>
                            <p>средний рост зарплаты участников Careerum</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1691832125913.svg" alt="">
                        </div>
                        <div>
                            <p class="main-block-header">4 000 +</p>
                            <p>офферов получили участники<br> по всему миру</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1691832137513.svg" alt="">
                        </div>
                        <div>
                            <p class="main-block-header">9 из 10</p>
                            <p>участников рекомендуют<br> Careerum друзьям</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1691832152718.svg" alt="">
                        </div>
                    </div>
                </div>
                <div>
                    <a href="#" class="btn-color-main-dark-orange">Оставить заявку</a>
                </div>
            </div>
        </div>`
	});
    
    blockManager.add('careerum-club21-tools', {
        label: 'Клуб 2.1 инструменты',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-club21-tools">
            <div>
                <div>
                    <h2>Вырасти в зарплате<br> или релоцироваться?</h2>
                    <p>Инструменты Careerum<br> помогут решить именно вашу задачу</p>
                </div>
                <div class="careerum-club21-tools__goals">
                    <div>
                        <div>Найти дело по душе</div>
                        <div>Получить оффер мечты</div>
                        <div>Вырасти в ЗП или должности</div>
                    </div>
                    <div>
                        <div>Выйти из карьерного тупика</div>
                        <div>Построить международную карьеру</div>
                    </div>
                    <div>
                        <div>Достичь другую цель</div>
                    </div>
                </div>
                <div class="careerum-club21-tools__tiles">
                    <div>
                        <div>
                            <p>Обучающий контент</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1691832305776.svg" alt="">
                            <p>Вебинары и эфиры международных экспертов: от поиска работы до роста в&nbsp;доходе</p>
                            <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1691832334562.png" alt=""></div>
                            <a href="#126">Подробнее</a>
                        </div>
                        <div>
                            <svg xmlns="http://www.w3.org/2000/svg" width="117" height="117" viewBox="0 0 117 117" fill="none">
                                <path d="M56.1397 24.5456C18.0588 19.4716 14.3424 82.2674 47.8529 86.7324C60.0395 88.3561 71.9434 86.0392 83.3541 76.2728C97.431 64.2244 99.6193 24.0097 50.876 17.5151" stroke="black" stroke-width="1.90045" stroke-linecap="round"/>
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M62.2965 39.514C62.3896 38.8155 61.8988 38.1738 61.2002 38.0807C60.5017 37.9876 59.86 38.4784 59.7669 39.1769C59.4583 41.4933 59.0727 43.8678 58.6813 46.2784L58.6813 46.2786C58.237 49.015 57.7851 51.798 57.4295 54.5955L57.3737 54.5881L57.3172 54.5806L57.2607 54.5731L57.2042 54.5655L57.1477 54.558L57.0912 54.5505L57.0347 54.5429L56.9782 54.5354L56.9217 54.5279L56.8652 54.5204L56.8087 54.5128L56.7523 54.5053L56.6958 54.4978L56.6393 54.4903L56.5828 54.4827L56.5263 54.4752L56.4698 54.4677L56.4133 54.4601L56.3568 54.4526L56.3003 54.4451L56.2438 54.4376L56.1873 54.43L56.1308 54.4225L56.0743 54.415L56.0178 54.4074L55.9613 54.3999L55.9048 54.3924L55.8483 54.3849L55.7918 54.3773L55.7353 54.3698L55.6788 54.3623L55.6223 54.3548L55.5658 54.3472L55.5093 54.3397L55.4528 54.3322L55.3963 54.3246L55.3398 54.3171L55.2833 54.3096L55.2268 54.3021L55.1703 54.2945L55.1138 54.287L55.0573 54.2795L55.0008 54.2719L54.9443 54.2644L54.8878 54.2569L54.8313 54.2494L54.7748 54.2418L54.7183 54.2343L54.6618 54.2268L54.6053 54.2193L54.5488 54.2117L54.4923 54.2042L54.4358 54.1967L54.3793 54.1891L54.3228 54.1816L54.2663 54.1741L54.2098 54.1666L54.1533 54.159L54.0968 54.1515L54.0403 54.144L53.9838 54.1364L53.9274 54.1289L53.8709 54.1214L53.8144 54.1139L53.7579 54.1063L53.7014 54.0988L53.6449 54.0913L53.5884 54.0838L53.5319 54.0762L53.4754 54.0687L53.4189 54.0612L53.3624 54.0536L53.3059 54.0461L53.2494 54.0386L53.1929 54.0311L53.1364 54.0235L53.0799 54.016L53.0234 54.0085L52.9669 54.0009L52.9104 53.9934L52.8539 53.9859L52.7974 53.9784L52.7409 53.9708L52.6844 53.9633L52.6279 53.9558L52.5714 53.9482L52.5149 53.9407L52.4584 53.9332L52.4019 53.9257L52.3454 53.9181L52.2889 53.9106L52.2324 53.9031L52.1759 53.8956L52.1194 53.888L52.0629 53.8805L52.0064 53.873L51.9499 53.8654L51.8934 53.8579L51.8369 53.8504L51.7804 53.8429L51.7239 53.8353L51.6674 53.8278L51.6109 53.8203L51.5544 53.8127L51.4979 53.8052L51.4414 53.7977L51.3849 53.7902L51.3284 53.7826L51.2719 53.7751L51.2154 53.7676L51.1589 53.7601L51.1025 53.7525L51.046 53.745L50.9895 53.7375L50.933 53.7299L50.8765 53.7224L50.82 53.7149L50.7635 53.7074L50.707 53.6998L50.6505 53.6923L50.594 53.6848L50.5375 53.6772L50.481 53.6697L50.4245 53.6622L50.368 53.6547L50.3115 53.6471L50.255 53.6396L50.1985 53.6321L50.142 53.6246L50.0855 53.617L50.029 53.6095L49.9725 53.602L49.916 53.5944L49.8595 53.5869L49.803 53.5794L49.7465 53.5719L49.69 53.5643L49.6335 53.5568L49.577 53.5493L49.5205 53.5417L49.464 53.5342L49.4075 53.5267L49.351 53.5192L49.2945 53.5116L49.238 53.5041L49.1815 53.4966L49.125 53.4891L49.0685 53.4815L49.012 53.474L48.9555 53.4665L48.899 53.4589L48.8425 53.4514L48.786 53.4439L48.7295 53.4364L48.673 53.4288L48.6165 53.4213L48.56 53.4138L48.5035 53.4062L48.447 53.3987L48.3905 53.3912L48.334 53.3837L48.2776 53.3761L48.2211 53.3686L48.1646 53.3611L48.1081 53.3535L48.0516 53.346L47.9951 53.3385L47.9386 53.331L47.8821 53.3234L47.8256 53.3159L47.7691 53.3084L47.7126 53.3009L47.6561 53.2933L47.5996 53.2858L47.5431 53.2783L47.4866 53.2707L47.4301 53.2632L47.3736 53.2557L47.3171 53.2482L47.2606 53.2406L47.2041 53.2331L47.1476 53.2256L47.0911 53.218L47.0346 53.2105L46.9781 53.203L46.9216 53.1955L46.8651 53.1879L46.8086 53.1804L46.7521 53.1729L46.6956 53.1654L46.6391 53.1578L46.5826 53.1503L46.5261 53.1428L46.4696 53.1352L46.4131 53.1277L46.3566 53.1202L46.3001 53.1127L46.2436 53.1051L46.1871 53.0976L46.1306 53.0901L46.0741 53.0825L46.0176 53.075L45.9611 53.0675L45.9046 53.06L45.8481 53.0524L45.7916 53.0449L45.7351 53.0374L45.6786 53.0299L45.6221 53.0223L45.5656 53.0148L45.5091 53.0073L45.4527 52.9997L45.3962 52.9922L45.3397 52.9847L45.2832 52.9772L45.2267 52.9696L45.1702 52.9621L45.1137 52.9546L45.0572 52.947L45.0007 52.9395L44.9442 52.932L44.8877 52.9245L44.8312 52.9169L44.7747 52.9094L44.7182 52.9019L44.6617 52.8944L44.6052 52.8868L44.5487 52.8793L44.4922 52.8718L44.4357 52.8642L44.3792 52.8567L44.3227 52.8492L44.2662 52.8417L44.2097 52.8341L44.1532 52.8266L44.0967 52.8191L44.0402 52.8115L43.9837 52.804L43.9272 52.7965L43.8707 52.789L43.8142 52.7814L43.7577 52.7739L43.7012 52.7664L43.6447 52.7588L43.5882 52.7513L43.5317 52.7438L43.4752 52.7363L43.4187 52.7287L43.3622 52.7212L43.3057 52.7137L43.2492 52.7062L43.1927 52.6986L43.1362 52.6911L43.0797 52.6836L43.0232 52.676L42.9667 52.6685L42.9102 52.661L42.8537 52.6535L42.7972 52.6459L42.7407 52.6384L42.6842 52.6309L42.6278 52.6233L42.5713 52.6158L42.5148 52.6083L42.4583 52.6008L42.4018 52.5932L42.3453 52.5857L42.2888 52.5782L42.2323 52.5707L42.1758 52.5631L42.1193 52.5556L42.0628 52.5481L42.0063 52.5405L41.9498 52.533L41.8933 52.5255L41.8368 52.518L41.7803 52.5104L41.7238 52.5029L41.6673 52.4954L41.6108 52.4878L41.5543 52.4803L41.4978 52.4728L41.4413 52.4653L41.3848 52.4577L41.3283 52.4502L41.2718 52.4427L41.2153 52.4352L41.1588 52.4276L41.1023 52.4201L41.0458 52.4126L40.9893 52.405L40.9328 52.3975L40.8763 52.39L40.8198 52.3825L40.7633 52.3749L40.7068 52.3674L40.6503 52.3599L40.5938 52.3523L40.5373 52.3448L40.4808 52.3373L40.4243 52.3298L40.3678 52.3222L40.3113 52.3147L40.2548 52.3072L40.1983 52.2997L40.1418 52.2921L40.0853 52.2846L40.0288 52.2771L39.9723 52.2695L39.9158 52.262C39.2173 52.1689 38.5756 52.6598 38.4825 53.3583C38.3895 54.0568 38.8803 54.6985 39.5788 54.7916L39.6353 54.7991L39.6918 54.8066L39.7483 54.8142L39.8048 54.8217L39.8613 54.8292L39.9178 54.8368L39.9743 54.8443L40.0308 54.8518L40.0873 54.8593L40.1438 54.8669L40.2003 54.8744L40.2568 54.8819L40.3133 54.8894L40.3698 54.897L40.4263 54.9045L40.4828 54.912L40.5393 54.9196L40.5958 54.9271L40.6523 54.9346L40.7088 54.9421L40.7653 54.9497L40.8218 54.9572L40.8783 54.9647L40.9348 54.9723L40.9913 54.9798L41.0478 54.9873L41.1042 54.9948L41.1607 55.0024L41.2172 55.0099L41.2737 55.0174L41.3302 55.025L41.3867 55.0325L41.4432 55.04L41.4997 55.0475L41.5562 55.0551L41.6127 55.0626L41.6692 55.0701L41.7257 55.0776L41.7822 55.0852L41.8387 55.0927L41.8952 55.1002L41.9517 55.1078L42.0082 55.1153L42.0647 55.1228L42.1212 55.1303L42.1777 55.1379L42.2342 55.1454L42.2907 55.1529L42.3472 55.1605L42.4037 55.168L42.4602 55.1755L42.5167 55.183L42.5732 55.1906L42.6297 55.1981L42.6862 55.2056L42.7427 55.2131L42.7992 55.2207L42.8557 55.2282L42.9122 55.2357L42.9687 55.2433L43.0252 55.2508L43.0817 55.2583L43.1382 55.2658L43.1947 55.2734L43.2512 55.2809L43.3077 55.2884L43.3642 55.296L43.4207 55.3035L43.4772 55.311L43.5337 55.3185L43.5902 55.3261L43.6467 55.3336L43.7032 55.3411L43.7597 55.3486L43.8162 55.3562L43.8727 55.3637L43.9291 55.3712L43.9856 55.3788L44.0421 55.3863L44.0986 55.3938L44.1551 55.4013L44.2116 55.4089L44.2681 55.4164L44.3246 55.4239L44.3811 55.4315L44.4376 55.439L44.4941 55.4465L44.5506 55.454L44.6071 55.4616L44.6636 55.4691L44.7201 55.4766L44.7766 55.4841L44.8331 55.4917L44.8896 55.4992L44.9461 55.5067L45.0026 55.5143L45.0591 55.5218L45.1156 55.5293L45.1721 55.5368L45.2286 55.5444L45.2851 55.5519L45.3416 55.5594L45.3981 55.567L45.4546 55.5745L45.5111 55.582L45.5676 55.5895L45.6241 55.5971L45.6806 55.6046L45.7371 55.6121L45.7936 55.6197L45.8501 55.6272L45.9066 55.6347L45.9631 55.6422L46.0196 55.6498L46.0761 55.6573L46.1326 55.6648L46.1891 55.6723L46.2456 55.6799L46.3021 55.6874L46.3586 55.6949L46.4151 55.7025L46.4716 55.71L46.5281 55.7175L46.5846 55.725L46.6411 55.7326L46.6976 55.7401L46.754 55.7476L46.8105 55.7552L46.867 55.7627L46.9235 55.7702L46.98 55.7777L47.0365 55.7853L47.093 55.7928L47.1495 55.8003L47.206 55.8078L47.2625 55.8154L47.319 55.8229L47.3755 55.8304L47.432 55.838L47.4885 55.8455L47.545 55.853L47.6015 55.8605L47.658 55.8681L47.7145 55.8756L47.771 55.8831L47.8275 55.8907L47.884 55.8982L47.9405 55.9057L47.997 55.9132L48.0535 55.9208L48.11 55.9283L48.1665 55.9358L48.223 55.9433L48.2795 55.9509L48.336 55.9584L48.3925 55.9659L48.449 55.9735L48.5055 55.981L48.562 55.9885L48.6185 55.996L48.675 56.0036L48.7315 56.0111L48.788 56.0186L48.8445 56.0262L48.901 56.0337L48.9575 56.0412L49.014 56.0487L49.0705 56.0563L49.127 56.0638L49.1835 56.0713L49.24 56.0788L49.2965 56.0864L49.353 56.0939L49.4095 56.1014L49.466 56.109L49.5225 56.1165L49.579 56.124L49.6354 56.1315L49.6919 56.1391L49.7484 56.1466L49.8049 56.1541L49.8614 56.1617L49.9179 56.1692L49.9744 56.1767L50.0309 56.1842L50.0874 56.1918L50.1439 56.1993L50.2004 56.2068L50.2569 56.2144L50.3134 56.2219L50.3699 56.2294L50.4264 56.2369L50.4829 56.2445L50.5394 56.252L50.5959 56.2595L50.6524 56.267L50.7089 56.2746L50.7654 56.2821L50.8219 56.2896L50.8784 56.2972L50.9349 56.3047L50.9914 56.3122L51.0479 56.3197L51.1044 56.3273L51.1609 56.3348L51.2174 56.3423L51.2739 56.3499L51.3304 56.3574L51.3869 56.3649L51.4434 56.3724L51.4999 56.38L51.5564 56.3875L51.6129 56.395L51.6694 56.4025L51.7259 56.4101L51.7824 56.4176L51.8389 56.4251L51.8954 56.4327L51.9519 56.4402L52.0084 56.4477L52.0649 56.4552L52.1214 56.4628L52.1779 56.4703L52.2344 56.4778L52.2909 56.4854L52.3474 56.4929L52.4038 56.5004L52.4603 56.5079L52.5168 56.5155L52.5733 56.523L52.6298 56.5305L52.6863 56.538L52.7428 56.5456L52.7993 56.5531L52.8558 56.5606L52.9123 56.5682L52.9688 56.5757L53.0253 56.5832L53.0818 56.5907L53.1383 56.5983L53.1948 56.6058L53.2513 56.6133L53.3078 56.6209L53.3643 56.6284L53.4208 56.6359L53.4773 56.6434L53.5338 56.651L53.5903 56.6585L53.6468 56.666L53.7033 56.6735L53.7598 56.6811L53.8163 56.6886L53.8728 56.6961L53.9293 56.7037L53.9858 56.7112L54.0423 56.7187L54.0988 56.7262L54.1553 56.7338L54.2118 56.7413L54.2683 56.7488L54.3248 56.7564L54.3813 56.7639L54.4378 56.7714L54.4943 56.7789L54.5508 56.7865L54.6073 56.794L54.6638 56.8015L54.7203 56.8091L54.7768 56.8166L54.8333 56.8241L54.8898 56.8316L54.9463 56.8392L55.0028 56.8467L55.0593 56.8542L55.1158 56.8617L55.1723 56.8693L55.2287 56.8768L55.2852 56.8843L55.3417 56.8919L55.3982 56.8994L55.4547 56.9069L55.5112 56.9144L55.5677 56.922L55.6242 56.9295L55.6807 56.937L55.7372 56.9446L55.7937 56.9521L55.8502 56.9596L55.9067 56.9671L55.9632 56.9747L56.0197 56.9822L56.0762 56.9897L56.1327 56.9972L56.1892 57.0048L56.2457 57.0123L56.3022 57.0198L56.3587 57.0274L56.4152 57.0349L56.4717 57.0424L56.5282 57.0499L56.5847 57.0575L56.6412 57.065L56.6977 57.0725L56.7542 57.0801L56.8107 57.0876L56.8672 57.0951L56.9237 57.1026L56.9802 57.1102L57.0367 57.1177L57.0932 57.1252L57.1368 57.131C56.7846 60.5605 56.6234 63.9974 56.8435 67.3829C56.8893 68.0861 57.4964 68.6191 58.1996 68.5734C58.9028 68.5276 59.4358 67.9205 59.3901 67.2173C59.1802 63.9897 59.3291 60.7376 59.664 57.4678L59.6921 57.4715L59.7486 57.479L59.8051 57.4866L59.8616 57.4941L59.9181 57.5016L59.9746 57.5091L60.0311 57.5167L60.0876 57.5242L60.1441 57.5317L60.2006 57.5393L60.2571 57.5468L60.3136 57.5543L60.3701 57.5618L60.4266 57.5694L60.4831 57.5769L60.5396 57.5844L60.5961 57.5919L60.6526 57.5995L60.7091 57.607L60.7656 57.6145L60.8221 57.6221L60.8785 57.6296L60.935 57.6371L60.9915 57.6446L61.048 57.6522L61.1045 57.6597L61.161 57.6672L61.2175 57.6748L61.274 57.6823L61.3305 57.6898L61.387 57.6973L61.4435 57.7049L61.5 57.7124L61.5565 57.7199L61.613 57.7274L61.6695 57.735L61.726 57.7425L61.7825 57.75L61.839 57.7576L61.8955 57.7651L61.952 57.7726L62.0085 57.7801L62.065 57.7877L62.1215 57.7952L62.178 57.8027L62.2345 57.8103L62.291 57.8178L62.3475 57.8253L62.404 57.8328L62.4605 57.8404L62.517 57.8479L62.5735 57.8554L62.63 57.8629L62.6865 57.8705L62.743 57.878L62.7995 57.8855L62.856 57.8931L62.9125 57.9006L62.969 57.9081L63.0255 57.9156L63.082 57.9232L63.1385 57.9307L63.195 57.9382L63.2515 57.9458L63.308 57.9533L63.3645 57.9608L63.421 57.9683L63.4775 57.9759L63.534 57.9834L63.5905 57.9909L63.647 57.9985L63.7034 58.006L63.7599 58.0135L63.8164 58.021L63.8729 58.0286L63.9294 58.0361L63.9859 58.0436L64.0424 58.0511L64.0989 58.0587L64.1554 58.0662L64.2119 58.0737L64.2684 58.0813L64.3249 58.0888L64.3814 58.0963L64.4379 58.1038L64.4944 58.1114L64.5509 58.1189L64.6074 58.1264L64.6639 58.134L64.7204 58.1415L64.7769 58.149L64.8334 58.1565L64.8899 58.1641L64.9464 58.1716L65.0029 58.1791L65.0594 58.1866L65.1159 58.1942L65.1724 58.2017L65.2289 58.2092L65.2854 58.2168L65.3419 58.2243L65.3984 58.2318L65.4549 58.2393L65.5114 58.2469L65.5679 58.2544L65.6244 58.2619L65.6809 58.2695L65.7374 58.277L65.7939 58.2845L65.8504 58.292L65.9069 58.2996L65.9634 58.3071L66.0199 58.3146L66.0764 58.3221L66.1329 58.3297L66.1894 58.3372L66.2459 58.3447L66.3024 58.3523L66.3589 58.3598L66.4154 58.3673L66.4719 58.3748L66.5283 58.3824L66.5848 58.3899L66.6413 58.3974L66.6978 58.405L66.7543 58.4125L66.8108 58.42L66.8673 58.4275L66.9238 58.4351L66.9803 58.4426L67.0368 58.4501L67.0933 58.4576L67.1498 58.4652L67.2063 58.4727L67.2628 58.4802L67.3193 58.4878L67.3758 58.4953L67.4323 58.5028L67.4888 58.5103L67.5453 58.5179L67.6018 58.5254L67.6583 58.5329L67.7148 58.5405L67.7713 58.548L67.8278 58.5555L67.8843 58.563L67.9408 58.5706L67.9973 58.5781L68.0538 58.5856L68.1103 58.5932L68.1668 58.6007L68.2233 58.6082L68.2798 58.6157L68.3363 58.6233L68.3928 58.6308L68.4493 58.6383L68.5058 58.6458C69.0167 58.7139 69.6815 58.7533 70.3536 58.7931L70.3536 58.7931L70.5103 58.8024C71.2612 58.8471 72.0552 58.8972 72.8214 58.9869C73.5935 59.0772 74.2855 59.2024 74.8365 59.3803C75.4143 59.5669 75.6765 59.7614 75.7711 59.8793C76.212 60.429 77.0151 60.5171 77.5648 60.0762C78.1145 59.6353 78.2027 58.8322 77.7617 58.2825C77.2041 57.5873 76.3749 57.1955 75.6208 56.9519C74.84 56.6997 73.9598 56.5507 73.1181 56.4522C72.2705 56.353 71.4092 56.2995 70.662 56.255L70.5542 56.2486L70.554 56.2485C69.8314 56.2056 69.2566 56.1714 68.8428 56.1163L68.7863 56.1087L68.7298 56.1012L68.6733 56.0937L68.6168 56.0862L68.5603 56.0786L68.5038 56.0711L68.4473 56.0636L68.3908 56.056L68.3343 56.0485L68.2778 56.041L68.2213 56.0335L68.1648 56.0259L68.1083 56.0184L68.0519 56.0109L67.9954 56.0034L67.9389 55.9958L67.8824 55.9883L67.8259 55.9808L67.7694 55.9732L67.7129 55.9657L67.6564 55.9582L67.5999 55.9507L67.5434 55.9431L67.4869 55.9356L67.4304 55.9281L67.3739 55.9205L67.3174 55.913L67.2609 55.9055L67.2044 55.898L67.1479 55.8904L67.0914 55.8829L67.0349 55.8754L66.9784 55.8678L66.9219 55.8603L66.8654 55.8528L66.8089 55.8453L66.7524 55.8377L66.6959 55.8302L66.6394 55.8227L66.5829 55.8152L66.5264 55.8076L66.4699 55.8001L66.4134 55.7926L66.3569 55.785L66.3004 55.7775L66.2439 55.77L66.1874 55.7625L66.1309 55.7549L66.0744 55.7474L66.0179 55.7399L65.9614 55.7323L65.9049 55.7248L65.8484 55.7173L65.7919 55.7098L65.7354 55.7022L65.6789 55.6947L65.6224 55.6872L65.5659 55.6797L65.5094 55.6721L65.4529 55.6646L65.3964 55.6571L65.3399 55.6495L65.2834 55.642L65.227 55.6345L65.1705 55.627L65.114 55.6194L65.0575 55.6119L65.001 55.6044L64.9445 55.5968L64.888 55.5893L64.8315 55.5818L64.775 55.5743L64.7185 55.5667L64.662 55.5592L64.6055 55.5517L64.549 55.5442L64.4925 55.5366L64.436 55.5291L64.3795 55.5216L64.323 55.514L64.2665 55.5065L64.21 55.499L64.1535 55.4915L64.097 55.4839L64.0405 55.4764L63.984 55.4689L63.9275 55.4613L63.871 55.4538L63.8145 55.4463L63.758 55.4388L63.7015 55.4312L63.645 55.4237L63.5885 55.4162L63.532 55.4087L63.4755 55.4011L63.419 55.3936L63.3625 55.3861L63.306 55.3785L63.2495 55.371L63.193 55.3635L63.1365 55.356L63.08 55.3484L63.0235 55.3409L62.967 55.3334L62.9105 55.3258L62.854 55.3183L62.7975 55.3108L62.741 55.3033L62.6845 55.2957L62.628 55.2882L62.5715 55.2807L62.515 55.2731L62.4585 55.2656L62.4021 55.2581L62.3456 55.2506L62.2891 55.243L62.2326 55.2355L62.1761 55.228L62.1196 55.2205L62.0631 55.2129L62.0066 55.2054L61.9501 55.1979L61.8936 55.1903L61.8371 55.1828L61.7806 55.1753L61.7241 55.1678L61.6676 55.1602L61.6111 55.1527L61.5546 55.1452L61.4981 55.1376L61.4416 55.1301L61.3851 55.1226L61.3286 55.1151L61.2721 55.1075L61.2156 55.1L61.1591 55.0925L61.1026 55.085L61.0461 55.0774L60.9896 55.0699L60.9331 55.0624L60.8766 55.0548L60.8201 55.0473L60.7636 55.0398L60.7071 55.0323L60.6506 55.0247L60.5941 55.0172L60.5376 55.0097L60.4811 55.0021L60.4246 54.9946L60.3681 54.9871L60.3116 54.9796L60.2551 54.972L60.1986 54.9645L60.1421 54.957L60.0856 54.9495L60.0291 54.9419L59.9726 54.9344L59.9576 54.9324C60.2973 52.2776 60.7298 49.6124 61.1634 46.9402C61.5643 44.4698 61.9661 41.9934 62.2965 39.514Z" fill="black"/>
                              </svg>
                        </div>
                        <div>
                            <p>Сообщество</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1691832355548.svg" alt="">
                            <p>Открытые к общению участники, которые готовы делиться своим личным опытом</p>
                            <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1691832378753.png" alt=""></div>
                            <a href="#127">Подробнее</a>
                        </div>
                        <div>
                            <svg xmlns="http://www.w3.org/2000/svg" width="98" height="98" viewBox="0 0 98 98" fill="none">
                                <path d="M42.8672 17.7275C6.52636 17.7275 10.8871 77.0728 42.8663 77.0728C54.4961 77.0728 65.3684 73.4131 74.8476 62.83C86.5417 49.774 83.5693 11.793 37.0533 11.793" stroke="black" stroke-width="1.79772" stroke-linecap="round"/>
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M50.511 30.9961C50.511 30.3295 49.9706 29.7891 49.304 29.7891C48.6374 29.7891 48.097 30.3295 48.097 30.9961C48.097 33.2066 48.0322 35.4813 47.9663 37.7906V37.7906C47.8916 40.4119 47.8155 43.0777 47.8316 45.7452H47.7783H47.7244H47.6705H47.6165H47.5626H47.5087H47.4548H47.4009H47.347H47.293H47.2391H47.1852H47.1313H47.0774H47.0235H46.9695H46.9156H46.8617H46.8078H46.7539H46.7H46.646H46.5921H46.5382H46.4843H46.4304H46.3765H46.3225H46.2686H46.2147H46.1608H46.1069H46.053H45.999H45.9451H45.8912H45.8373H45.7834H45.7295H45.6755H45.6216H45.5677H45.5138H45.4599H45.406H45.352H45.2981H45.2442H45.1903H45.1364H45.0825H45.0286H44.9746H44.9207H44.8668H44.8129H44.759H44.7051H44.6511H44.5972H44.5433H44.4894H44.4355H44.3816H44.3276H44.2737H44.2198H44.1659H44.112H44.0581H44.0041H43.9502H43.8963H43.8424H43.7885H43.7346H43.6806H43.6267H43.5728H43.5189H43.465H43.4111H43.3571H43.3032H43.2493H43.1954H43.1415H43.0876H43.0336H42.9797H42.9258H42.8719H42.818H42.7641H42.7101H42.6562H42.6023H42.5484H42.4945H42.4406H42.3866H42.3327H42.2788H42.2249H42.171H42.1171H42.0632H42.0092H41.9553H41.9014H41.8475H41.7936H41.7397H41.6857H41.6318H41.5779H41.524H41.4701H41.4162H41.3622H41.3083H41.2544H41.2005H41.1466H41.0927H41.0387H40.9848H40.9309H40.877H40.8231H40.7692H40.7152H40.6613H40.6074H40.5535H40.4996H40.4457H40.3917H40.3378H40.2839H40.23H40.1761H40.1222H40.0682H40.0143H39.9604H39.9065H39.8526H39.7987H39.7447H39.6908H39.6369H39.583H39.5291H39.4752H39.4212H39.3673H39.3134H39.2595H39.2056H39.1517H39.0978H39.0438H38.9899H38.936H38.8821H38.8282H38.7743H38.7203H38.6664H38.6125H38.5586H38.5047H38.4508H38.3968H38.3429H38.289H38.2351H38.1812H38.1273H38.0733H38.0194H37.9655H37.9116H37.8577H37.8038H37.7498H37.6959H37.642H37.5881H37.5342H37.4803H37.4263H37.3724H37.3185H37.2646H37.2107H37.1568H37.1028H37.0489H36.995H36.9411H36.8872H36.8333H36.7793H36.7254H36.6715H36.6176H36.5637H36.5098H36.4558H36.4019H36.348H36.2941H36.2402H36.1863H36.1324H36.0784H36.0245H35.9706H35.9167H35.8628H35.8089H35.7549H35.701H35.6471H35.5932H35.5393H35.4854H35.4314H35.3775H35.3236H35.2697H35.2158H35.1619H35.1079H35.054H35.0001H34.9462H34.8923H34.8384H34.7844H34.7305H34.6766H34.6227H34.5688H34.5149H34.4609H34.407H34.3531H34.2992H34.2453H34.1914H34.1374H34.0835H34.0296H33.9757H33.9218H33.8679H33.8139H33.76H33.7061H33.6522H33.5983H33.5444H33.4904H33.4365H33.3826H33.3287H33.2748H33.2209H33.1669H33.113H33.0591H33.0052H32.9513H32.8974H32.8435H32.7895H32.7356H32.6817H32.6278H32.5739H32.52H32.466H32.4121H32.3582H32.3043H32.2504H32.1965H32.1425H32.0886H32.0347H31.9808H31.9269H31.873H31.819H31.7651H31.7112H31.6573H31.6034H31.5495H31.4955H31.4416H31.3877H31.3338H31.2799H31.226H31.172H31.1181C30.4515 45.7452 29.9111 46.2856 29.9111 46.9522C29.9111 47.6188 30.4515 48.1592 31.1181 48.1592H31.172H31.226H31.2799H31.3338H31.3877H31.4416H31.4955H31.5495H31.6034H31.6573H31.7112H31.7651H31.819H31.873H31.9269H31.9808H32.0347H32.0886H32.1425H32.1965H32.2504H32.3043H32.3582H32.4121H32.466H32.52H32.5739H32.6278H32.6817H32.7356H32.7895H32.8435H32.8974H32.9513H33.0052H33.0591H33.113H33.1669H33.2209H33.2748H33.3287H33.3826H33.4365H33.4904H33.5444H33.5983H33.6522H33.7061H33.76H33.8139H33.8679H33.9218H33.9757H34.0296H34.0835H34.1374H34.1914H34.2453H34.2992H34.3531H34.407H34.4609H34.5149H34.5688H34.6227H34.6766H34.7305H34.7844H34.8384H34.8923H34.9462H35.0001H35.054H35.1079H35.1619H35.2158H35.2697H35.3236H35.3775H35.4314H35.4854H35.5393H35.5932H35.6471H35.701H35.7549H35.8089H35.8628H35.9167H35.9706H36.0245H36.0784H36.1324H36.1863H36.2402H36.2941H36.348H36.4019H36.4558H36.5098H36.5637H36.6176H36.6715H36.7254H36.7793H36.8333H36.8872H36.9411H36.995H37.0489H37.1028H37.1568H37.2107H37.2646H37.3185H37.3724H37.4263H37.4803H37.5342H37.5881H37.642H37.6959H37.7498H37.8038H37.8577H37.9116H37.9655H38.0194H38.0733H38.1273H38.1812H38.2351H38.289H38.3429H38.3968H38.4508H38.5047H38.5586H38.6125H38.6664H38.7203H38.7743H38.8282H38.8821H38.936H38.9899H39.0438H39.0978H39.1517H39.2056H39.2595H39.3134H39.3673H39.4212H39.4752H39.5291H39.583H39.6369H39.6908H39.7447H39.7987H39.8526H39.9065H39.9604H40.0143H40.0682H40.1222H40.1761H40.23H40.2839H40.3378H40.3917H40.4457H40.4996H40.5535H40.6074H40.6613H40.7152H40.7692H40.8231H40.877H40.9309H40.9848H41.0387H41.0927H41.1466H41.2005H41.2544H41.3083H41.3622H41.4162H41.4701H41.524H41.5779H41.6318H41.6857H41.7397H41.7936H41.8475H41.9014H41.9553H42.0092H42.0632H42.1171H42.171H42.2249H42.2788H42.3327H42.3866H42.4406H42.4945H42.5484H42.6023H42.6562H42.7101H42.7641H42.818H42.8719H42.9258H42.9797H43.0336H43.0876H43.1415H43.1954H43.2493H43.3032H43.3571H43.4111H43.465H43.5189H43.5728H43.6267H43.6806H43.7346H43.7885H43.8424H43.8963H43.9502H44.0041H44.0581H44.112H44.1659H44.2198H44.2737H44.3276H44.3816H44.4355H44.4894H44.5433H44.5972H44.6511H44.7051H44.759H44.8129H44.8668H44.9207H44.9746H45.0286H45.0825H45.1364H45.1903H45.2442H45.2981H45.352H45.406H45.4599H45.5138H45.5677H45.6216H45.6755H45.7295H45.7834H45.8373H45.8912H45.9451H45.999H46.053H46.1069H46.1608H46.2147H46.2686H46.3225H46.3765H46.4304H46.4843H46.5382H46.5921H46.646H46.7H46.7539H46.8078H46.8617H46.9156H46.9695H47.0235H47.0774H47.1313H47.1852H47.2391H47.293H47.347H47.4009H47.4548H47.5087H47.5626H47.6165H47.6705H47.7244H47.7783H47.8322H47.874C47.9721 51.419 48.2504 54.6618 48.8798 57.8088C49.0105 58.4625 49.6464 58.8864 50.3001 58.7557C50.9537 58.625 51.3776 57.9891 51.2469 57.3354C50.6468 54.3352 50.3801 51.2671 50.2857 48.1592H50.3124H50.3663H50.4202H50.4741H50.528H50.5819H50.6359H50.6898H50.7437H50.7976H50.8515H50.9054H50.9594H51.0133H51.0672H51.1211H51.175H51.2289H51.2829H51.3368H51.3907H51.4446H51.4985H51.5524H51.6064H51.6603H51.7142H51.7681H51.822H51.8759H51.9298H51.9838H52.0377H52.0916H52.1455H52.1994H52.2533H52.3073H52.3612H52.4151H52.469H52.5229H52.5768H52.6308H52.6847H52.7386H52.7925H52.8464H52.9003H52.9543H53.0082H53.0621H53.116H53.1699H53.2238H53.2778H53.3317H53.3856H53.4395H53.4934H53.5473H53.6013H53.6552H53.7091H53.763H53.8169H53.8708H53.9248H53.9787H54.0326H54.0865H54.1404H54.1943H54.2483H54.3022H54.3561H54.41H54.4639H54.5178H54.5718H54.6257H54.6796H54.7335H54.7874H54.8413H54.8953H54.9492H55.0031H55.057H55.1109H55.1648H55.2187H55.2727H55.3266H55.3805H55.4344H55.4883H55.5422H55.5962H55.6501H55.704H55.7579H55.8118H55.8657H55.9197H55.9736H56.0275H56.0814H56.1353H56.1892H56.2432H56.2971H56.351H56.4049H56.4588H56.5127H56.5667H56.6206H56.6745H56.7284H56.7823H56.8362H56.8902H56.9441H56.998H57.0519H57.1058H57.1597H57.2137H57.2676H57.3215H57.3754H57.4293H57.4832H57.5372H57.5911H57.645H57.6989H57.7528H57.8067H57.8607H57.9146H57.9685H58.0224H58.0763H58.1302H58.1841H58.2381H58.292H58.3459H58.3998H58.4537H58.5076H58.5616H58.6155H58.6694H58.7233C59.2109 48.1592 59.8392 48.1131 60.4744 48.0664L60.6224 48.0556C61.3321 48.0037 62.0828 47.9514 62.8125 47.9398C63.5478 47.9281 64.2123 47.959 64.7511 48.057C65.3162 48.1598 65.5864 48.3093 65.6898 48.4081C66.1719 48.8684 66.9359 48.8508 67.3963 48.3686C67.8566 47.8865 67.839 47.1225 67.3568 46.6621C66.7471 46.0799 65.9206 45.8161 65.1832 45.682C64.4195 45.543 63.5755 45.5133 62.774 45.5261C61.9669 45.539 61.1526 45.5964 60.4464 45.648L60.3445 45.6555L60.3444 45.6555C59.6615 45.7055 59.1182 45.7452 58.7233 45.7452H58.6694H58.6155H58.5616H58.5076H58.4537H58.3998H58.3459H58.292H58.2381H58.1841H58.1302H58.0763H58.0224H57.9685H57.9146H57.8607H57.8067H57.7528H57.6989H57.645H57.5911H57.5372H57.4832H57.4293H57.3754H57.3215H57.2676H57.2137H57.1597H57.1058H57.0519H56.998H56.9441H56.8902H56.8362H56.7823H56.7284H56.6745H56.6206H56.5667H56.5127H56.4588H56.4049H56.351H56.2971H56.2432H56.1892H56.1353H56.0814H56.0275H55.9736H55.9197H55.8657H55.8118H55.7579H55.704H55.6501H55.5962H55.5422H55.4883H55.4344H55.3805H55.3266H55.2727H55.2187H55.1648H55.1109H55.057H55.0031H54.9492H54.8953H54.8413H54.7874H54.7335H54.6796H54.6257H54.5718H54.5178H54.4639H54.41H54.3561H54.3022H54.2483H54.1943H54.1404H54.0865H54.0326H53.9787H53.9248H53.8708H53.8169H53.763H53.7091H53.6552H53.6013H53.5473H53.4934H53.4395H53.3856H53.3317H53.2778H53.2238H53.1699H53.116H53.0621H53.0082H52.9543H52.9003H52.8464H52.7925H52.7386H52.6847H52.6308H52.5768H52.5229H52.469H52.4151H52.3612H52.3073H52.2533H52.1994H52.1455H52.0916H52.0377H51.9838H51.9298H51.8759H51.822H51.7681H51.7142H51.6603H51.6064H51.5524H51.4985H51.4446H51.3907H51.3368H51.2829H51.2289H51.175H51.1211H51.0672H51.0133H50.9594H50.9054H50.8515H50.7976H50.7437H50.6898H50.6359H50.5819H50.528H50.4741H50.4202H50.3663H50.3124H50.2584H50.2442C50.2311 43.2136 50.3036 40.6606 50.3764 38.1009C50.4436 35.7344 50.511 33.3622 50.511 30.9961Z" fill="black"/>
                              </svg>
                        </div>
                        <div>
                            <p>Эксперты</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1691832410535.svg" alt="">
                            <p>Быстрое достижение целей с поддержкой практиков, которые знают потребности рынка</p>
                            <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1691832427315.png" alt=""></div>
                            <a href="#128">Подробнее</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-club21-tools-tablet', {
        label: 'Клуб 2.1 инструменты (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-club21-tools-tablet">
            <div>
                <div>
                    <h2>Вырасти в зарплате<br> или релоцироваться?</h2>
                    <p>Инструменты Careerum помогут решить<br> именно вашу задачу</p>
                </div>
                <div class="careerum-club21-tools__goals-tablet">
                    <div>
                        <div>Найти дело по душе</div>
                        <div>Получить оффер мечты</div>
                        <div>Вырасти в ЗП или должности</div>
                    </div>
                    <div>
                        <div>Выйти из карьерного тупика</div>
                        <div>Построить международную карьеру</div>
                    </div>
                    <div>
                        <div>Достичь другую цель</div>
                    </div>
                </div>
                <div class="careerum-club21-tools__tiles-tablet">
                    <div>
                        <div>
                            <p>Обучающий контент</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1691832538298.svg" alt="">
                            <p>Вебинары и эфиры международных экспертов: от поиска работы до роста в&nbsp;доходе</p>
                            <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1691832559268.png" alt=""></div>
                            <a href="#126">Подробнее</a>
                        </div>
                        <div>
                            <p>Сообщество</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1691832573542.svg" alt="">
                            <p>Открытые к общению участники, которые готовы делиться своим личным опытом</p>
                            <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1691832589345.png" alt=""></div>
                            <a href="#127">Подробнее</a>
                        </div>
                        <div>
                            <p>Эксперты</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1691832601258.svg" alt="">
                            <p>Быстрое достижение целей с поддержкой практиков, которые знают потребности рынка</p>
                            <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1691832613975.png" alt=""></div>
                            <a href="#128">Подробнее</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-club21-tools-mobile', {
        label: 'Клуб 2.1 инструменты (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-club21-tools-mobile">
            <div>
                <div>
                    <h2>Вырасти в зарплате<br> или релоцироваться?</h2>
                    <p>Инструменты Careerum<br> помогут решить именно вашу<br> задачу</p>
                </div>
                <div>
                    <div>
                        <div>
                            <p>Образование</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1691832717868.svg" alt="">
                            <p>Проходите учебные программы — от поиска работы до эффективного лидерства</p>
                            <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1691832755569.png" alt=""></div>
                            <a href="#126">Подробнее</a>
                        </div>
                        <div>
                            <p>Комьюнити</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1691832721068.svg" alt="">
                            <p>Обсуждайте идеи<br> в сообществе<br> специалистов, обменивайтесь опытом и заводите знакомства</p>
                            <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1691832757481.png" alt=""></div>
                            <a href="#127">Подробнее</a>
                        </div>
                        <div>
                            <p>Коучи и CV-специалисты</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1691832723299.svg" alt="">
                            <p>Получайте поддержку сертифицированных специалистов</p>
                            <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1691832759316.png" alt=""></div>
                            <a href="#128">Подробнее</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
	});
    
    blockManager.add('careerum-getcourse-email-form-4-fields', {
        label: 'Клуб 2.1 форма',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-getcourse-email-form-4-fields single-block" custom-link-anchor="form">
            <div class="careerum-form-tab-item-4-fields-block">
                <div>
                    <div>
                        <h3>Забронируйте свое<br> место в Careerum</h3>
                        <p>Сейчас в Careerum максимальное количество<br> участников. Оставьте заявку и мы пригласим<br> вас, как только появится место</p>
                    </div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1691832945954.png" alt="">
                    <div class="careerum-registration-form">
                        <form class="deva-form getcourse-email-signup" name="devaRegistrationForm" data-gjs-type="deva-registration-form">
                            <div>
                                <div class="careerum-form-tab-item-4-fields-field-name">
                                    <input type="text" name="firstname" value="" required placeholder="Имя">
                                </div>
                                <div class="careerum-form-tab-item-4-fields-field-name">
                                    <input type="text" name="lastname" value="" required placeholder="Фамилия">
                                </div>
                                <div class="careerum-form-tab-item-4-fields-field-email">
                                    <input type="text" name="email" value="" required placeholder="Почта">
                                </div>
                                <div class="careerum-form-tab-item-4-fields-field-tel">
                                    <input type="tel" value="" name="tel" required class="itl-input">
                                </div>
                            </div>
                            <div class="careerum-form-tab-item-4-fields-field-agree">
                                <input type="checkbox" name="">
                                <label data-toggle-checkbox="true">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
                                        <path d="M1 2.84615L3.14168 6.70118C3.21595 6.83487 3.40669 6.83912 3.48685 6.70887L7 1" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
                                      </svg>
                                </label>
                                <p>Я даю согласие на обработку своих персональных данных в соответствии с <a href="#">Политикой конфиденциальности</a></p>
                            </div>
                            <a href="#" disabled class="submit-btn btn-color-main-bright-orange">Оставить заявку</a>
                            <a href="#" class="submit-btn btn-color-main-bright-orange" disabled>
                                <p class="submit-btn-text">Оставить заявку</p>
                                <p class="submit-btn-sending-text">Бронируем место</p>
                                <p class="submit-btn-success-text">Место забронировано</p>
                                <p class="flare"></p>
                            </a>
                        </form>
                    </div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-getcourse-email-form-4-fields-tablet', {
        label: 'Клуб 2.1 форма (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-getcourse-email-form-4-fields-tablet single-block" custom-link-anchor="form">
            <div class="careerum-form-tab-item-4-fields-block">
                <div>
                    <div>
                        <h3>Забронируйте свое место<br> в Careerum</h3>
                        <p>Сейчас в Careerum<br> максимальное количество<br> участников. Оставьте заявку<br> и мы пригласим вас, как<br> только появится место</p>
                    </div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1691832968403.png" alt="">
                    <div class="careerum-registration-form-tablet">
                        <form class="deva-form getcourse-email-signup" name="devaRegistrationForm" data-gjs-type="deva-registration-form">
                            <div>
                                <div class="careerum-form-tab-item-4-fields-field-name">
                                    <input type="text" name="firstname" value="" required placeholder="Имя">
                                </div>
                                <div class="careerum-form-tab-item-4-fields-field-name">
                                    <input type="text" name="lastname" value="" required placeholder="Фамилия">
                                </div>
                                <div class="careerum-form-tab-item-4-fields-field-email">
                                    <input type="text" name="email" value="" required placeholder="Почта">
                                </div>
                                <div class="careerum-form-tab-item-4-fields-field-tel">
                                    <input type="tel" value="" name="tel" required class="itl-input">
                                </div>
                            </div>
                            <div class="careerum-form-tab-item-4-fields-field-agree">
                                <input type="checkbox" name="">
                                <label data-toggle-checkbox="true">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
                                        <path d="M1 2.84615L3.14168 6.70118C3.21595 6.83487 3.40669 6.83912 3.48685 6.70887L7 1" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
                                      </svg>
                                </label>
                                <p>Я даю согласие на обработку своих персональных данных в соответствии с <a href="#">Политикой конфиденциальности</a></p>
                            </div>
                            <a href="#" disabled class="submit-btn btn-color-main-bright-orange">Оставить заявку</a>
                            <a href="#" class="submit-btn btn-color-main-bright-orange" disabled>
                                <p class="submit-btn-text">Оставить заявку</p>
                                <p class="submit-btn-sending-text">Бронируем место</p>
                                <p class="submit-btn-success-text">Место забронировано</p>
                                <p class="flare"></p>
                            </a>
                        </form>
                    </div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-getcourse-email-form-4-fields-mobile', {
        label: 'Клуб 2.1 форма (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-getcourse-email-form-4-fields-mobile single-block" custom-link-anchor="form" success-popup="#128">
            <div class="careerum-form-tab-item-4-fields-block">
                <div>
                    <div>
                        <h3>Забронируйте свое место в Careerum</h3>
                        <p>Сейчас в Careerum максимальное количество участников. Оставьте заявку и мы пригласим вас, как только появится место</p>
                    </div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1691832984537.png" alt="">
                    <div class="careerum-registration-form-mobile">
                        <form class="deva-form getcourse-email-signup" name="devaRegistrationForm" data-gjs-type="deva-registration-form">
                            <div>
                                <div class="careerum-form-tab-item-4-fields-field-name">
                                    <input type="text" name="firstname" value="" required placeholder="Имя">
                                </div>
                                <div class="careerum-form-tab-item-4-fields-field-name">
                                    <input type="text" name="lastname" value="" required placeholder="Фамилия">
                                </div>
                                <div class="careerum-form-tab-item-4-fields-field-email">
                                    <input type="text" name="email" value="" required placeholder="Почта">
                                </div>
                                <div class="careerum-form-tab-item-4-fields-field-tel">
                                    <input type="tel" value="" name="tel" required class="itl-input">
                                </div>
                            </div>
                            <div class="careerum-form-tab-item-4-fields-field-agree">
                                <input type="checkbox" name="">
                                <label data-toggle-checkbox="true">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
                                        <path d="M1 2.84615L3.14168 6.70118C3.21595 6.83487 3.40669 6.83912 3.48685 6.70887L7 1" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
                                      </svg>
                                </label>
                                <p>Я даю согласие на обработку своих персональных данных в соответствии с <a href="#1">Политикой конфиденциальности</a></p>
                            </div>
                            <a href="#" disabled class="submit-btn btn-color-main-bright-orange">Оставить заявку</a>
                            <a href="#" class="submit-btn btn-color-main-bright-orange" disabled>
                                <p class="submit-btn-text">Оставить заявку</p>
                                <p class="submit-btn-sending-text">Бронируем место</p>
                                <p class="submit-btn-success-text">Место забронировано</p>
                                <p class="flare"></p>
                            </a>
                        </form>
                    </div>
                </div>
            </div>
        </div>`
	});
    
    blockManager.add('careerum-club21-programs', {
        label: 'Клуб 2.1 программы',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-club21-programs">
            <div>
                <div>
                    <h2>Топ-программы Careerum<br> под самые востребованные цели</h2>
                    <svg xmlns="http://www.w3.org/2000/svg" width="185" height="62" viewBox="0 0 185 62" fill="none">
                        <path d="M2.32681 24.742C55.1859 -20.7399 158.21 6.97299 180.981 59.4931M179.209 26.8605C178.696 38.0772 177.543 44.4536 181.344 54.7957C184.881 64.4193 177.688 58.638 172.809 54.2903C164.098 48.972 159.463 49.2397 149.441 49.4275" stroke="black" stroke-width="3.4867" stroke-linecap="round"/>
                      </svg>
                </div>
                <div>
                    <ul class="club21-programs-nav">
                    </ul>
                </div>
                <div class="club21-programs-items-wrapper">
                    <div class="club21-programs-items">
                        <div class="club21-programs-item active" data-name="Найти работу по душе">
                            <div>
                                <div class="club21-programs-item-description">
                                    <p>
                                        Программа «Real Me: как найти<br> себя в работе и жизни»
                                    </p>
                                    <ul>
                                        <li>Раскроете свои сильные стороны и глубинную мотивацию
                                        </li>
                                        <li>Соотнесете свои таланты и ценности с запросами рынка
                                        </li>
                                        <li>Поймете в какой сфере вам комфортно</li>
                                        <li>Научитесь исследовать отрасли, компании и профессии, чтобы<br> выбирать работу осознанно, а не брать, «что дают»</li>
                                    </ul>
                                </div>
                                <div class="club21-programs-item-experts">
                                    <p>
                                        Эксперты программы
                                    </p>
                                    <div>
                                        <div>
                                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1691833200721.png" alt="">
                                            <div>
                                                <p><span>Ольга Лермонтова,</span><br> основательница<br> Careerum</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="club21-programs-item-components">
                                    <p>
                                        Что входит в программу
                                    </p>
                                    <div class="club21-programs-components-wrapper">
                                        <div class="club21-programs-components">
                                            <div class="club21-programs-component">
                                                <div>
                                                    <p>Курс</p>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="19" viewBox="0 0 9 19" fill="none">
                                                        <circle cx="4.5" cy="9.5" r="2.5" fill="white"/>
                                                      </svg>
                                                    <p>5 часов 42 мин.</p>
                                                </div>
                                                <p>Хочу–Могу</p>
                                                <p>Выявите свои таланты и истинные ценности, чтобы опираться на них при построении карьеры.</p>
                                            </div>
                                            <div class="club21-programs-component">
                                                <div>
                                                    <p>Курс</p>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="19" viewBox="0 0 9 19" fill="none">
                                                        <circle cx="4.5" cy="9.5" r="2.5" fill="white"/>
                                                      </svg>
                                                    <p>2 часа 16 мин.</p>
                                                </div>
                                                <p>Надо</p>
                                                <p>Узнаете, как анализировать компании и сферы на предмет соответствия вашим талантам и интересам.</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="club21-programs-components-arrows">
                                        <div class="club21-programs-components-slider__arrow-left">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 18 16" fill="none">
                                                <path d="M2.19055 7.99935L15.8105 7.99935" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M8.46289 14.2453L2.18956 7.99862L8.46289 1.75195" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                        </div>
                                        <div class="club21-programs-components-slider__arrow-right">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 18 16" fill="none">
                                                <path d="M15.8095 8.00065L2.18945 8.00065" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M9.53711 1.75471L15.8104 8.00138L9.53711 14.248" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                        </div>
    
                                    </div>
                                </div>
                                <div class="careerum-getcourse-email-form-4-fields">
                                    <div class="careerum-form-tab-item-4-fields-block">
                                        <div>
                                            <div>
                                                <h3>Оставить заявку на программу</h3>
                                                <p>Эта программа дсотупна для всех участнкиов Careerum.</p>
                                                <p>Оставьте свои данные, чтобы получить приглашение оформить подписку.</p>
                                            </div>
                                            <div class="careerum-registration-form">
                                                <form class="deva-form getcourse-email-signup" name="devaRegistrationForm" data-gjs-type="deva-registration-form">
                                                    <div>
                                                        <div class="careerum-form-tab-item-4-fields-field-name">
                                                            <input type="text" name="firstname" value="" required placeholder="Имя">
                                                        </div>
                                                        <div class="careerum-form-tab-item-4-fields-field-name">
                                                            <input type="text" name="lastname" value="" required placeholder="Фамилия">
                                                        </div>
                                                        <div class="careerum-form-tab-item-4-fields-field-email">
                                                            <input type="text" name="email" value="" required placeholder="Почта">
                                                        </div>
                                                        <div class="careerum-form-tab-item-4-fields-field-tel">
                                                            <input type="tel" value="" name="tel" required class="itl-input">
                                                        </div>
                                                    </div>
                                                    <div class="careerum-form-tab-item-4-fields-field-agree">
                                                        <input type="checkbox" name="">
                                                        <label data-toggle-checkbox="true">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
                                                                <path d="M1 2.84615L3.14168 6.70118C3.21595 6.83487 3.40669 6.83912 3.48685 6.70887L7 1" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
                                                              </svg>
                                                        </label>
                                                        <p>Я даю согласие на обработку своих персональных данных в соответствии с <a href="#">Политикой конфиденциальности</a></p>
                                                    </div>
                                                    <a href="#" disabled class="submit-btn btn-color-main-bright-orange">Хочу пройти программу</a>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="club21-programs-item-button">
                                    <a href="#buy" class="btn-color-main-dark-orange">Вступить в Careerum</a>
                                </div>
                            </div>
                            <div>
                                <div>
                                    <p>4,8 / 5</p>
                                    <p>оценка программы<br> участниками Careerum</p>
                                </div>
                                <div>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M8.50008 0.978516C12.6531 0.978516 16.0209 4.34559 16.0209 8.49935C16.0209 12.6531 12.6531 16.0202 8.50008 16.0202C4.34633 16.0202 0.979248 12.6531 0.979248 8.49935C0.979248 4.34559 4.34633 0.978516 8.50008 0.978516Z" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M10.8751 8.49616C10.8751 7.85401 7.58375 5.79972 7.21039 6.16909C6.83702 6.53847 6.80112 10.419 7.21039 10.8232C7.61965 11.2288 10.8751 9.1383 10.8751 8.49616Z" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                      </svg>
                                      <p>Видео уроки от 5<br> до 30 мин</p>
                                </div>
                                <div>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                                        <path d="M8.098 1.20898H5.13795C2.70358 1.20898 1.17725 2.93244 1.17725 5.37236V11.9543C1.17725 14.3942 2.69645 16.1177 5.13795 16.1177H12.1236C14.5659 16.1177 16.0851 14.3942 16.0851 11.9543V8.76544" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M5.9885 7.64605L11.9046 1.72992C12.6417 0.993672 13.8363 0.993672 14.5733 1.72992L15.5368 2.69338C16.2738 3.43042 16.2738 4.62584 15.5368 5.36209L9.59217 11.3067C9.26996 11.6289 8.83296 11.8102 8.37696 11.8102H5.41138L5.48579 8.81771C5.49688 8.37755 5.67659 7.95796 5.9885 7.64605Z" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M11.0056 2.64453L14.6204 6.25928" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                      </svg>
                                      <p>Есть домашние задания</p>
                                </div>
                                <div>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="17" viewBox="0 0 15 17" fill="none">
                                        <path d="M11.0018 6.48035V4.78064C11.0018 2.79119 9.38838 1.17777 7.39892 1.17777C5.40946 1.16906 3.78971 2.77456 3.78101 4.76481V4.78064V6.48035" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M10.4159 15.8233H4.36675C2.709 15.8233 1.36475 14.4798 1.36475 12.8213V9.42583C1.36475 7.76729 2.709 6.42383 4.36675 6.42383H10.4159C12.0736 6.42383 13.4179 7.76729 13.4179 9.42583V12.8213C13.4179 14.4798 12.0736 15.8233 10.4159 15.8233Z" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M7.39144 10.2441V12.0024" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                      </svg>
                                      <p>Доступно только участникам Careerum</p>
                                </div>
                            </div>
                        </div>
                        <div class="club21-programs-item" data-name="Получить оффер мечты">
                            <div>
                                <div class="club21-programs-item-description">
                                    <p>
                                        Программа «Звездный<br> кандидат»
                                    </p>
                                    <ul>
                                        <li>Научитесь составлять продающие резюме и сопроводительные письма
                                        </li>
                                        <li>Сможете презентовать себя так, чтобы договариваться о своих условиях<br> оффера
                                        </li>
                                        <li>Перестанете откликаться на «все подряд», начали искать вакансии системно</li>
                                        <li>Выработаете менталитет продавца</li>
                                        <li>Поймете, как стать востребованным специалистом</li>
                                    </ul>
                                </div>
                                <div class="club21-programs-item-experts">
                                    <p>
                                        Эксперты программы
                                    </p>
                                    <div>
                                        <div>
                                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1691833200721.png" alt="">
                                            <div>
                                                <p><span>Ольга Лермонтова,</span><br> основательница<br> Careerum</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="club21-programs-item-components">
                                    <p>
                                        Что входит в программу
                                    </p>
                                    <div class="club21-programs-components-wrapper">
                                        <div class="club21-programs-components">
                                            <div class="club21-programs-component">
                                                <div>
                                                    <p>Вебинар</p>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="19" viewBox="0 0 9 19" fill="none">
                                                        <circle cx="4.5" cy="9.5" r="2.5" fill="white"/>
                                                      </svg>
                                                    <p>26 мин.</p>
                                                </div>
                                                <p>Менталитет продавца</p>
                                                <p>Поймете, как негативные психологические установки мешают построить карьеру.</p>
                                            </div>
                                            <div class="club21-programs-component">
                                                <div>
                                                    <p>Курс</p>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="19" viewBox="0 0 9 19" fill="none">
                                                        <circle cx="4.5" cy="9.5" r="2.5" fill="white"/>
                                                      </svg>
                                                    <p>2 часа 16 мин.</p>
                                                </div>
                                                <p>Умная стратегия поиска работы</p>
                                                <p>Построите воронку поиска, которая поможет системно двигаться к желаемому офферу.</p>
                                            </div>
                                            <div class="club21-programs-component">
                                                <div>
                                                    <p>Курс</p>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="19" viewBox="0 0 9 19" fill="none">
                                                        <circle cx="4.5" cy="9.5" r="2.5" fill="white"/>
                                                      </svg>
                                                    <p>5 часов 42 мин.</p>
                                                </div>
                                                <p>Продающее резюме</p>
                                                <p>Вы изучите главные принципы составления резюме, научитесь искать и грамотно формулировать свои достижения, опыт работы и образование.</p>
                                            </div>
                                            <div class="club21-programs-component">
                                                <div>
                                                    <p>Вебинар</p>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="19" viewBox="0 0 9 19" fill="none">
                                                        <circle cx="4.5" cy="9.5" r="2.5" fill="white"/>
                                                      </svg>
                                                    <p>51 мин.</p>
                                                </div>
                                                <p>Hooked: цепляющее сопроводительное письмо</p>
                                            </div>
                                            <div class="club21-programs-component">
                                                <div>
                                                    <p>Курс</p>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="19" viewBox="0 0 9 19" fill="none">
                                                        <circle cx="4.5" cy="9.5" r="2.5" fill="white"/>
                                                      </svg>
                                                    <p>2 часа 48 мин.</p>
                                                </div>
                                                <p>Эффективное интервью</p>
                                                <p>Вы научитесь грамотно и без стресса проходить любые собеседования.</p>
                                            </div>
                                            <div class="club21-programs-component">
                                                <div>
                                                    <p>Курс</p>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="19" viewBox="0 0 9 19" fill="none">
                                                        <circle cx="4.5" cy="9.5" r="2.5" fill="white"/>
                                                      </svg>
                                                    <p>2 часа 47 мин.</p>
                                                </div>
                                                <p>Great Deal: получить оффер мечты</p>
                                                <p>Вы научитесь и сразу попрактикуетесь грамотно вести переговоры об оффере.</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="club21-programs-components-arrows">
                                        <div class="club21-programs-components-slider__arrow-left">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 18 16" fill="none">
                                                <path d="M2.19055 7.99935L15.8105 7.99935" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M8.46289 14.2453L2.18956 7.99862L8.46289 1.75195" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                        </div>
                                        <div class="club21-programs-components-slider__arrow-right">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 18 16" fill="none">
                                                <path d="M15.8095 8.00065L2.18945 8.00065" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M9.53711 1.75471L15.8104 8.00138L9.53711 14.248" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                        </div>
    
                                    </div>
                                </div>
                                <div class="careerum-getcourse-email-form-4-fields">
                                    <div class="careerum-form-tab-item-4-fields-block">
                                        <div>
                                            <div>
                                                <h3>Оставить заявку на программу</h3>
                                                <p>Эта программа дсотупна для всех участнкиов Careerum.</p>
                                                <p>Оставьте свои данные, чтобы получить приглашение оформить подписку.</p>
                                            </div>
                                            <div class="careerum-registration-form">
                                                <form class="deva-form getcourse-email-signup" name="devaRegistrationForm" data-gjs-type="deva-registration-form">
                                                    <div>
                                                        <div class="careerum-form-tab-item-4-fields-field-name">
                                                            <input type="text" name="firstname" value="" required placeholder="Имя">
                                                        </div>
                                                        <div class="careerum-form-tab-item-4-fields-field-name">
                                                            <input type="text" name="lastname" value="" required placeholder="Фамилия">
                                                        </div>
                                                        <div class="careerum-form-tab-item-4-fields-field-email">
                                                            <input type="text" name="email" value="" required placeholder="Почта">
                                                        </div>
                                                        <div class="careerum-form-tab-item-4-fields-field-tel">
                                                            <input type="tel" value="" name="tel" required class="itl-input">
                                                        </div>
                                                    </div>
                                                    <div class="careerum-form-tab-item-4-fields-field-agree">
                                                        <input type="checkbox" name="">
                                                        <label data-toggle-checkbox="true">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
                                                                <path d="M1 2.84615L3.14168 6.70118C3.21595 6.83487 3.40669 6.83912 3.48685 6.70887L7 1" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
                                                              </svg>
                                                        </label>
                                                        <p>Я даю согласие на обработку своих персональных данных в соответствии с <a href="#">Политикой конфиденциальности</a></p>
                                                    </div>
                                                    <a href="#" disabled class="submit-btn btn-color-main-bright-orange">Хочу пройти программу</a>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="club21-programs-item-button">
                                    <a href="#buy" class="btn-color-main-dark-orange">Вступить в Careerum</a>
                                </div>
                            </div>
                            <div>
                                <div>
                                    <p>4,8 / 5</p>
                                    <p>оценка программы<br> участниками Careerum</p>
                                </div>
                                <div>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M8.50008 0.978516C12.6531 0.978516 16.0209 4.34559 16.0209 8.49935C16.0209 12.6531 12.6531 16.0202 8.50008 16.0202C4.34633 16.0202 0.979248 12.6531 0.979248 8.49935C0.979248 4.34559 4.34633 0.978516 8.50008 0.978516Z" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M10.8751 8.49616C10.8751 7.85401 7.58375 5.79972 7.21039 6.16909C6.83702 6.53847 6.80112 10.419 7.21039 10.8232C7.61965 11.2288 10.8751 9.1383 10.8751 8.49616Z" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                      </svg>
                                      <p>Видео уроки от 5<br> до 30 мин</p>
                                </div>
                                <div>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                                        <path d="M8.098 1.20898H5.13795C2.70358 1.20898 1.17725 2.93244 1.17725 5.37236V11.9543C1.17725 14.3942 2.69645 16.1177 5.13795 16.1177H12.1236C14.5659 16.1177 16.0851 14.3942 16.0851 11.9543V8.76544" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M5.9885 7.64605L11.9046 1.72992C12.6417 0.993672 13.8363 0.993672 14.5733 1.72992L15.5368 2.69338C16.2738 3.43042 16.2738 4.62584 15.5368 5.36209L9.59217 11.3067C9.26996 11.6289 8.83296 11.8102 8.37696 11.8102H5.41138L5.48579 8.81771C5.49688 8.37755 5.67659 7.95796 5.9885 7.64605Z" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M11.0056 2.64453L14.6204 6.25928" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                      </svg>
                                      <p>Есть домашние задания</p>
                                </div>
                                <div>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="17" viewBox="0 0 15 17" fill="none">
                                        <path d="M11.0018 6.48035V4.78064C11.0018 2.79119 9.38838 1.17777 7.39892 1.17777C5.40946 1.16906 3.78971 2.77456 3.78101 4.76481V4.78064V6.48035" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M10.4159 15.8233H4.36675C2.709 15.8233 1.36475 14.4798 1.36475 12.8213V9.42583C1.36475 7.76729 2.709 6.42383 4.36675 6.42383H10.4159C12.0736 6.42383 13.4179 7.76729 13.4179 9.42583V12.8213C13.4179 14.4798 12.0736 15.8233 10.4159 15.8233Z" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M7.39144 10.2441V12.0024" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                      </svg>
                                      <p>Доступно только участникам Careerum</p>
                                </div>
                            </div>
                        </div>
                        <div class="club21-programs-item" data-name="Вырасти в доходе или должности">
                            <div>
                                <div class="club21-programs-item-description">
                                    <p>
                                        Карьерная ракета
                                    </p>
                                    <ul>
                                        <li>Поймете, как расти в зарплате / должности именно вам
                                        </li>
                                        <li>Научитесь ставить карьерные цели и добиваться их
                                        </li>
                                        <li>Узнаете, какие навыки нужны именно вам, именно для ваших задач</li>
                                        <li>Сможете составить долгосрочную карьерную стратегию и понять,<br> как начать ее реализовывать шаг за шагом.</li>
                                    </ul>
                                </div>
                                <div class="club21-programs-item-experts">
                                    <p>
                                        Эксперты программы
                                    </p>
                                    <div>
                                        <div>
                                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1691833200721.png" alt="">
                                            <div>
                                                <p><span>Ольга Лермонтова,</span><br> основательница<br> Careerum</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="club21-programs-item-components">
                                    <p>
                                        Что входит в программу
                                    </p>
                                    <div class="club21-programs-components-wrapper">
                                        <div class="club21-programs-components">
                                            <div class="club21-programs-component">
                                                <div>
                                                    <p>Курс</p>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="19" viewBox="0 0 9 19" fill="none">
                                                        <circle cx="4.5" cy="9.5" r="2.5" fill="white"/>
                                                      </svg>
                                                    <p>2 часа 43 мин.</p>
                                                </div>
                                                <p>Карьера как проект</p>
                                                <p>Вы освоите базу карьерного мышления и сможете осознанно спланировать своё долгосрочное карьерное развитие.</p>
                                            </div>
                                            <div class="club21-programs-component">
                                                <div>
                                                    <p>Курс</p>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="19" viewBox="0 0 9 19" fill="none">
                                                        <circle cx="4.5" cy="9.5" r="2.5" fill="white"/>
                                                      </svg>
                                                    <p>1 час 10 мин.</p>
                                                </div>
                                                <p>Цели как в Google. Результаты как в Forbes</p>
                                                <p>Вы научитесь планировать свои задачи и узнаете, как сделать руководителя и коллег своими союзниками в достижении целей.</p>
                                            </div>
                                            <div class="club21-programs-component">
                                                <div>
                                                    <p>Курс</p>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="19" viewBox="0 0 9 19" fill="none">
                                                        <circle cx="4.5" cy="9.5" r="2.5" fill="white"/>
                                                      </svg>
                                                    <p>1 час 10 мин.</p>
                                                </div>
                                                <p>Пробей зарплатный потолок</p>
                                                <p>Вы узнаете, как запрограммировать свое повышение и системно расти в должности и зарплате.</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="club21-programs-components-arrows">
                                        <div class="club21-programs-components-slider__arrow-left">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 18 16" fill="none">
                                                <path d="M2.19055 7.99935L15.8105 7.99935" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M8.46289 14.2453L2.18956 7.99862L8.46289 1.75195" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                        </div>
                                        <div class="club21-programs-components-slider__arrow-right">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 18 16" fill="none">
                                                <path d="M15.8095 8.00065L2.18945 8.00065" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M9.53711 1.75471L15.8104 8.00138L9.53711 14.248" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                        </div>
    
                                    </div>
                                </div>
                                <div class="careerum-getcourse-email-form-4-fields">
                                    <div class="careerum-form-tab-item-4-fields-block">
                                        <div>
                                            <div>
                                                <h3>Оставить заявку на программу</h3>
                                                <p>Эта программа дсотупна для всех участнкиов Careerum.</p>
                                                <p>Оставьте свои данные, чтобы получить приглашение оформить подписку.</p>
                                            </div>
                                            <div class="careerum-registration-form">
                                                <form class="deva-form getcourse-email-signup" name="devaRegistrationForm" data-gjs-type="deva-registration-form">
                                                    <div>
                                                        <div class="careerum-form-tab-item-4-fields-field-name">
                                                            <input type="text" name="firstname" value="" required placeholder="Имя">
                                                        </div>
                                                        <div class="careerum-form-tab-item-4-fields-field-name">
                                                            <input type="text" name="lastname" value="" required placeholder="Фамилия">
                                                        </div>
                                                        <div class="careerum-form-tab-item-4-fields-field-email">
                                                            <input type="text" name="email" value="" required placeholder="Почта">
                                                        </div>
                                                        <div class="careerum-form-tab-item-4-fields-field-tel">
                                                            <input type="tel" value="" name="tel" required class="itl-input">
                                                        </div>
                                                    </div>
                                                    <div class="careerum-form-tab-item-4-fields-field-agree">
                                                        <input type="checkbox" name="">
                                                        <label data-toggle-checkbox="true">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
                                                                <path d="M1 2.84615L3.14168 6.70118C3.21595 6.83487 3.40669 6.83912 3.48685 6.70887L7 1" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
                                                              </svg>
                                                        </label>
                                                        <p>Я даю согласие на обработку своих персональных данных в соответствии с <a href="#">Политикой конфиденциальности</a></p>
                                                    </div>
                                                    <a href="#" disabled class="submit-btn btn-color-main-bright-orange">Хочу пройти программу</a>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="club21-programs-item-button">
                                    <a href="#buy" class="btn-color-main-dark-orange">Вступить в Careerum</a>
                                </div>
                            </div>
                            <div>
                                <div>
                                    <p>4,8 / 5</p>
                                    <p>оценка программы<br> участниками Careerum</p>
                                </div>
                                <div>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M8.50008 0.978516C12.6531 0.978516 16.0209 4.34559 16.0209 8.49935C16.0209 12.6531 12.6531 16.0202 8.50008 16.0202C4.34633 16.0202 0.979248 12.6531 0.979248 8.49935C0.979248 4.34559 4.34633 0.978516 8.50008 0.978516Z" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M10.8751 8.49616C10.8751 7.85401 7.58375 5.79972 7.21039 6.16909C6.83702 6.53847 6.80112 10.419 7.21039 10.8232C7.61965 11.2288 10.8751 9.1383 10.8751 8.49616Z" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                      </svg>
                                      <p>Видео уроки от 5<br> до 30 мин</p>
                                </div>
                                <div>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                                        <path d="M8.098 1.20898H5.13795C2.70358 1.20898 1.17725 2.93244 1.17725 5.37236V11.9543C1.17725 14.3942 2.69645 16.1177 5.13795 16.1177H12.1236C14.5659 16.1177 16.0851 14.3942 16.0851 11.9543V8.76544" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M5.9885 7.64605L11.9046 1.72992C12.6417 0.993672 13.8363 0.993672 14.5733 1.72992L15.5368 2.69338C16.2738 3.43042 16.2738 4.62584 15.5368 5.36209L9.59217 11.3067C9.26996 11.6289 8.83296 11.8102 8.37696 11.8102H5.41138L5.48579 8.81771C5.49688 8.37755 5.67659 7.95796 5.9885 7.64605Z" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M11.0056 2.64453L14.6204 6.25928" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                      </svg>
                                      <p>Есть домашние задания</p>
                                </div>
                                <div>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="17" viewBox="0 0 15 17" fill="none">
                                        <path d="M11.0018 6.48035V4.78064C11.0018 2.79119 9.38838 1.17777 7.39892 1.17777C5.40946 1.16906 3.78971 2.77456 3.78101 4.76481V4.78064V6.48035" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M10.4159 15.8233H4.36675C2.709 15.8233 1.36475 14.4798 1.36475 12.8213V9.42583C1.36475 7.76729 2.709 6.42383 4.36675 6.42383H10.4159C12.0736 6.42383 13.4179 7.76729 13.4179 9.42583V12.8213C13.4179 14.4798 12.0736 15.8233 10.4159 15.8233Z" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M7.39144 10.2441V12.0024" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                      </svg>
                                      <p>Доступно только участникам Careerum</p>
                                </div>
                            </div>
                        </div>
                        <div class="club21-programs-item" data-name="Переехать по работе">
                            <div>
                                <div class="club21-programs-item-description">
                                    <p>
                                        Международная карьера<br> и релокация
                                    </p>
                                    <ul>
                                        <li>Поймете, как устроен процесс найма за рубежом
                                        </li>
                                        <li>Узнаите, где искать вакансии иностранных компаний
                                        </li>
                                        <li>Овладеете навыками ведения переговоров с зарубежными рекрутерами
                                        </li>
                                        <li>Выработаете менталитет продавца</li>
                                        <li>Сумеете адаптироваться к незнакомой культурной среде</li>
                                    </ul>
                                </div>
                                <div class="club21-programs-item-experts">
                                    <p>
                                        Эксперты программы
                                    </p>
                                    <div>
                                        <div>
                                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1691833200721.png" alt="">
                                            <div>
                                                <p><span>Ольга Лермонтова,</span><br> основательница<br> Careerum</p>
                                            </div>
                                        </div>
                                        <div>
                                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1691833224105.png" alt="">
                                            <div>
                                                <p><span>Montse Lorente,</span><br> международный<br> карьерный<br> консультант</p>
                                            </div>
                                        </div>
                                        <div>
                                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1691833243676.png" alt="">
                                            <div>
                                                <p><span>Sophie Vurpillot,</span><br>международный<br> рекрутер и коуч,<br> 10+ лет опыта</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="club21-programs-item-components">
                                    <p>
                                        Что входит в программу
                                    </p>
                                    <div class="club21-programs-components-wrapper">
                                        <div class="club21-programs-components">
                                            <div class="club21-programs-component">
                                                <div>
                                                    <p>Курс</p>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="19" viewBox="0 0 9 19" fill="none">
                                                        <circle cx="4.5" cy="9.5" r="2.5" fill="white"/>
                                                      </svg>
                                                    <p>1 час 34 мин.</p>
                                                </div>
                                                <p>Работа без границ</p>
                                                <p>Вы изучите алгоритм поиска работы за границей, построите свою стратегию для получения оффера в новой географии.</p>
                                            </div>
                                            <div class="club21-programs-component">
                                                <div>
                                                    <p>Курс</p>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="19" viewBox="0 0 9 19" fill="none">
                                                        <circle cx="4.5" cy="9.5" r="2.5" fill="white"/>
                                                      </svg>
                                                    <p>1 час 10 мин.</p>
                                                </div>
                                                <p>Your Dream job, Abroad</p>
                                                <p>You will learn how to find a job in the global market, gaining practical recommendations on building your action plan.</p>
                                            </div>
                                            <div class="club21-programs-component">
                                                <div>
                                                    <p>Курс</p>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="19" viewBox="0 0 9 19" fill="none">
                                                        <circle cx="4.5" cy="9.5" r="2.5" fill="white"/>
                                                      </svg>
                                                    <p>6 часов 30 мин.</p>
                                                </div>
                                                <p>LinkedIn для развития карьеры</p>
                                                
                                            </div>
                                            <div class="club21-programs-component">
                                                <div>
                                                    <p>Вебинар</p>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="19" viewBox="0 0 9 19" fill="none">
                                                        <circle cx="4.5" cy="9.5" r="2.5" fill="white"/>
                                                      </svg>
                                                    <p>1 час 37 мин.</p>
                                                </div>
                                                <p>The other side: recruiter’s view on the job search</p>
                                            </div>
                                            <div class="club21-programs-component">
                                                <div>
                                                    <p>Вебинар</p>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="19" viewBox="0 0 9 19" fill="none">
                                                        <circle cx="4.5" cy="9.5" r="2.5" fill="white"/>
                                                      </svg>
                                                    <p>1 час 31 мин.</p>
                                                </div>
                                                <p>Communication with English-speaking colleagues</p>
                                            </div>
                                            <div class="club21-programs-component">
                                                <div>
                                                    <p>Курс</p>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="19" viewBox="0 0 9 19" fill="none">
                                                        <circle cx="4.5" cy="9.5" r="2.5" fill="white"/>
                                                      </svg>
                                                    <p>2 часа 47 мин.</p>
                                                </div>
                                                <p>Language of a Job Interview</p>
                                            </div>
                                            <div class="club21-programs-component">
                                                <div>
                                                    <p>Курс</p>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="19" viewBox="0 0 9 19" fill="none">
                                                        <circle cx="4.5" cy="9.5" r="2.5" fill="white"/>
                                                      </svg>
                                                    <p>1 час 18 мин.</p>
                                                </div>
                                                <p>Professional and cultural adaptation in Corporate America</p>
                                            </div>
                                            <div class="club21-programs-component">
                                                <div>
                                                    <p>Курс</p>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="19" viewBox="0 0 9 19" fill="none">
                                                        <circle cx="4.5" cy="9.5" r="2.5" fill="white"/>
                                                      </svg>
                                                    <p>1 час 37 мин.</p>
                                                </div>
                                                <p>Пути профессиональной иммиграции в США и навигация по американскому рынку труда</p>
                                            </div>
                                            <div class="club21-programs-component">
                                                <div>
                                                    <p>Курс</p>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="19" viewBox="0 0 9 19" fill="none">
                                                        <circle cx="4.5" cy="9.5" r="2.5" fill="white"/>
                                                      </svg>
                                                    <p>1 час 5 мин.</p>
                                                </div>
                                                <p>Межкультурная адаптация и коммуникация</p>
                                            </div>
                                            <div class="club21-programs-component">
                                                <div>
                                                    <p>Курс</p>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="19" viewBox="0 0 9 19" fill="none">
                                                        <circle cx="4.5" cy="9.5" r="2.5" fill="white"/>
                                                      </svg>
                                                    <p>2 часа 9 мин.</p>
                                                </div>
                                                <p>Intercultural Communications</p>
                                                <p>This course is about cross-cultural communication and team communication in English, particularly when relocating.</p>
                                            </div>
                                            <div class="club21-programs-component">
                                                <div>
                                                    <p>Вебинар</p>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="19" viewBox="0 0 9 19" fill="none">
                                                        <circle cx="4.5" cy="9.5" r="2.5" fill="white"/>
                                                      </svg>
                                                    <p>2 часа 21 мин.</p>
                                                </div>
                                                <p>Как попасть в Google: секреты и подводные камни</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="club21-programs-components-arrows">
                                        <div class="club21-programs-components-slider__arrow-left">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 18 16" fill="none">
                                                <path d="M2.19055 7.99935L15.8105 7.99935" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M8.46289 14.2453L2.18956 7.99862L8.46289 1.75195" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                        </div>
                                        <div class="club21-programs-components-slider__arrow-right">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 18 16" fill="none">
                                                <path d="M15.8095 8.00065L2.18945 8.00065" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M9.53711 1.75471L15.8104 8.00138L9.53711 14.248" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                        </div>
    
                                    </div>
                                </div>
                                <div class="careerum-getcourse-email-form-4-fields">
                                    <div class="careerum-form-tab-item-4-fields-block">
                                        <div>
                                            <div>
                                                <h3>Оставить заявку на программу</h3>
                                                <p>Эта программа дсотупна для всех участнкиов Careerum.</p>
                                                <p>Оставьте свои данные, чтобы получить приглашение оформить подписку.</p>
                                            </div>
                                            <div class="careerum-registration-form">
                                                <form class="deva-form getcourse-email-signup" name="devaRegistrationForm" data-gjs-type="deva-registration-form">
                                                    <div>
                                                        <div class="careerum-form-tab-item-4-fields-field-name">
                                                            <input type="text" name="firstname" value="" required placeholder="Имя">
                                                        </div>
                                                        <div class="careerum-form-tab-item-4-fields-field-name">
                                                            <input type="text" name="lastname" value="" required placeholder="Фамилия">
                                                        </div>
                                                        <div class="careerum-form-tab-item-4-fields-field-email">
                                                            <input type="text" name="email" value="" required placeholder="Почта">
                                                        </div>
                                                        <div class="careerum-form-tab-item-4-fields-field-tel">
                                                            <input type="tel" value="" name="tel" required class="itl-input">
                                                        </div>
                                                    </div>
                                                    <div class="careerum-form-tab-item-4-fields-field-agree">
                                                        <input type="checkbox" name="">
                                                        <label data-toggle-checkbox="true">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
                                                                <path d="M1 2.84615L3.14168 6.70118C3.21595 6.83487 3.40669 6.83912 3.48685 6.70887L7 1" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
                                                              </svg>
                                                        </label>
                                                        <p>Я даю согласие на обработку своих персональных данных в соответствии с <a href="#">Политикой конфиденциальности</a></p>
                                                    </div>
                                                    <a href="#" disabled class="submit-btn btn-color-main-bright-orange">Хочу пройти программу</a>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="club21-programs-item-button">
                                    <a href="#buy" class="btn-color-main-dark-orange">Вступить в Careerum</a>
                                </div>
                            </div>
                            <div>
                                <div>
                                    <p>4,8 / 5</p>
                                    <p>оценка программы<br> участниками Careerum</p>
                                </div>
                                <div>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M8.50008 0.978516C12.6531 0.978516 16.0209 4.34559 16.0209 8.49935C16.0209 12.6531 12.6531 16.0202 8.50008 16.0202C4.34633 16.0202 0.979248 12.6531 0.979248 8.49935C0.979248 4.34559 4.34633 0.978516 8.50008 0.978516Z" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M10.8751 8.49616C10.8751 7.85401 7.58375 5.79972 7.21039 6.16909C6.83702 6.53847 6.80112 10.419 7.21039 10.8232C7.61965 11.2288 10.8751 9.1383 10.8751 8.49616Z" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                      </svg>
                                      <p>Видео уроки от 5<br> до 30 мин</p>
                                </div>
                                <div>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                                        <path d="M8.098 1.20898H5.13795C2.70358 1.20898 1.17725 2.93244 1.17725 5.37236V11.9543C1.17725 14.3942 2.69645 16.1177 5.13795 16.1177H12.1236C14.5659 16.1177 16.0851 14.3942 16.0851 11.9543V8.76544" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M5.9885 7.64605L11.9046 1.72992C12.6417 0.993672 13.8363 0.993672 14.5733 1.72992L15.5368 2.69338C16.2738 3.43042 16.2738 4.62584 15.5368 5.36209L9.59217 11.3067C9.26996 11.6289 8.83296 11.8102 8.37696 11.8102H5.41138L5.48579 8.81771C5.49688 8.37755 5.67659 7.95796 5.9885 7.64605Z" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M11.0056 2.64453L14.6204 6.25928" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                      </svg>
                                      <p>Есть домашние задания</p>
                                </div>
                                <div>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="17" viewBox="0 0 15 17" fill="none">
                                        <path d="M11.0018 6.48035V4.78064C11.0018 2.79119 9.38838 1.17777 7.39892 1.17777C5.40946 1.16906 3.78971 2.77456 3.78101 4.76481V4.78064V6.48035" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M10.4159 15.8233H4.36675C2.709 15.8233 1.36475 14.4798 1.36475 12.8213V9.42583C1.36475 7.76729 2.709 6.42383 4.36675 6.42383H10.4159C12.0736 6.42383 13.4179 7.76729 13.4179 9.42583V12.8213C13.4179 14.4798 12.0736 15.8233 10.4159 15.8233Z" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M7.39144 10.2441V12.0024" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                      </svg>
                                      <p>Программу можно<br> купить отдельно</p>
                                </div>
                            </div>
                        </div>
                        <div class="club21-programs-item" data-name="Пройти испытательный срок">
                            <div>
                                <div class="club21-programs-item-description">
                                    <p>
                                        Жизнь после оффера
                                    </p>
                                    <ul>
                                        <li>Поймете, как сразу взять успешный страт на новом месте
                                        </li>
                                        <li>Разберете пошагово свою первую неделю и дальнейшую стратегию
                                        </li>
                                        <li>Узнаете, как быть на хорошем счету у руководства и коллег</li>
                                    </ul>
                                </div>
                                <div class="club21-programs-item-experts">
                                    <p>
                                        Эксперты программы
                                    </p>
                                    <div>
                                        <div>
                                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1691833200721.png" alt="">
                                            <div>
                                                <p><span>Ольга Лермонтова,</span><br> основательница<br> Careerum</p>
                                            </div>
                                        </div>
                                        <div>
                                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1691833262781.png" alt="">
                                            <div>
                                                <p><span>Мария Батти,</span><br> карьерный стратег</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="club21-programs-item-components">
                                    <p>
                                        Что входит в программу
                                    </p>
                                    <div class="club21-programs-components-wrapper">
                                        <div class="club21-programs-components">
                                            <div class="club21-programs-component">
                                                <div>
                                                    <p>Курс</p>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="19" viewBox="0 0 9 19" fill="none">
                                                        <circle cx="4.5" cy="9.5" r="2.5" fill="white"/>
                                                      </svg>
                                                    <p>6 часов 44 мин.</p>
                                                </div>
                                                <p>Первые месяцы на новой работе</p>
                                                <p>Вы получите и научитесь применять инструменты, которые помогут взять успешный старт в новой компании.</p>
                                            </div>
                                            <div class="club21-programs-component">
                                                <div>
                                                    <p>Курс</p>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="19" viewBox="0 0 9 19" fill="none">
                                                        <circle cx="4.5" cy="9.5" r="2.5" fill="white"/>
                                                      </svg>
                                                    <p>1 часа 24 мин.</p>
                                                </div>
                                                <p>Как грамотно выстраивать общение на работе</p>
                                                <p>Вы научитесь строить конструктивные отношения с руководителем и коллегами.</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="club21-programs-components-arrows">
                                        <div class="club21-programs-components-slider__arrow-left">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 18 16" fill="none">
                                                <path d="M2.19055 7.99935L15.8105 7.99935" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M8.46289 14.2453L2.18956 7.99862L8.46289 1.75195" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                        </div>
                                        <div class="club21-programs-components-slider__arrow-right">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 18 16" fill="none">
                                                <path d="M15.8095 8.00065L2.18945 8.00065" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M9.53711 1.75471L15.8104 8.00138L9.53711 14.248" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                        </div>
    
                                    </div>
                                </div>
                                <div class="careerum-getcourse-email-form-4-fields">
                                    <div class="careerum-form-tab-item-4-fields-block">
                                        <div>
                                            <div>
                                                <h3>Оставить заявку на программу</h3>
                                                <p>Эта программа дсотупна для всех участнкиов Careerum.</p>
                                                <p>Оставьте свои данные, чтобы получить приглашение оформить подписку.</p>
                                            </div>
                                            <div class="careerum-registration-form">
                                                <form class="deva-form getcourse-email-signup" name="devaRegistrationForm" data-gjs-type="deva-registration-form">
                                                    <div>
                                                        <div class="careerum-form-tab-item-4-fields-field-name">
                                                            <input type="text" name="firstname" value="" required placeholder="Имя">
                                                        </div>
                                                        <div class="careerum-form-tab-item-4-fields-field-name">
                                                            <input type="text" name="lastname" value="" required placeholder="Фамилия">
                                                        </div>
                                                        <div class="careerum-form-tab-item-4-fields-field-email">
                                                            <input type="text" name="email" value="" required placeholder="Почта">
                                                        </div>
                                                        <div class="careerum-form-tab-item-4-fields-field-tel">
                                                            <input type="tel" value="" name="tel" required class="itl-input">
                                                        </div>
                                                    </div>
                                                    <div class="careerum-form-tab-item-4-fields-field-agree">
                                                        <input type="checkbox" name="">
                                                        <label data-toggle-checkbox="true">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
                                                                <path d="M1 2.84615L3.14168 6.70118C3.21595 6.83487 3.40669 6.83912 3.48685 6.70887L7 1" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
                                                              </svg>
                                                        </label>
                                                        <p>Я даю согласие на обработку своих персональных данных в соответствии с <a href="#">Политикой конфиденциальности</a></p>
                                                    </div>
                                                    <a href="#" disabled class="submit-btn btn-color-main-bright-orange">Хочу пройти программу</a>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="club21-programs-item-button">
                                    <a href="#buy" class="btn-color-main-dark-orange">Вступить в Careerum</a>
                                </div>
                            </div>
                            <div>
                                <div>
                                    <p>4,8 / 5</p>
                                    <p>оценка программы<br> участниками Careerum</p>
                                </div>
                                <div>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M8.50008 0.978516C12.6531 0.978516 16.0209 4.34559 16.0209 8.49935C16.0209 12.6531 12.6531 16.0202 8.50008 16.0202C4.34633 16.0202 0.979248 12.6531 0.979248 8.49935C0.979248 4.34559 4.34633 0.978516 8.50008 0.978516Z" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M10.8751 8.49616C10.8751 7.85401 7.58375 5.79972 7.21039 6.16909C6.83702 6.53847 6.80112 10.419 7.21039 10.8232C7.61965 11.2288 10.8751 9.1383 10.8751 8.49616Z" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                      </svg>
                                      <p>Видео уроки от 5<br> до 30 мин</p>
                                </div>
                                <div>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                                        <path d="M8.098 1.20898H5.13795C2.70358 1.20898 1.17725 2.93244 1.17725 5.37236V11.9543C1.17725 14.3942 2.69645 16.1177 5.13795 16.1177H12.1236C14.5659 16.1177 16.0851 14.3942 16.0851 11.9543V8.76544" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M5.9885 7.64605L11.9046 1.72992C12.6417 0.993672 13.8363 0.993672 14.5733 1.72992L15.5368 2.69338C16.2738 3.43042 16.2738 4.62584 15.5368 5.36209L9.59217 11.3067C9.26996 11.6289 8.83296 11.8102 8.37696 11.8102H5.41138L5.48579 8.81771C5.49688 8.37755 5.67659 7.95796 5.9885 7.64605Z" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M11.0056 2.64453L14.6204 6.25928" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                      </svg>
                                      <p>Есть домашние задания</p>
                                </div>
                                <div>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="17" viewBox="0 0 15 17" fill="none">
                                        <path d="M11.0018 6.48035V4.78064C11.0018 2.79119 9.38838 1.17777 7.39892 1.17777C5.40946 1.16906 3.78971 2.77456 3.78101 4.76481V4.78064V6.48035" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M10.4159 15.8233H4.36675C2.709 15.8233 1.36475 14.4798 1.36475 12.8213V9.42583C1.36475 7.76729 2.709 6.42383 4.36675 6.42383H10.4159C12.0736 6.42383 13.4179 7.76729 13.4179 9.42583V12.8213C13.4179 14.4798 12.0736 15.8233 10.4159 15.8233Z" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M7.39144 10.2441V12.0024" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                      </svg>
                                      <p>Доступно только участникам Careerum</p>
                                </div>
                            </div>
                        </div>
                        <div class="club21-programs-item" data-name="Расти в кризис">
                            <div>
                                <div class="club21-programs-item-description">
                                    <p>
                                        Антикризис
                                    </p>
                                    <ul>
                                        <li>Узнаете, как расти в должности / получать офферы вопреки кризисам
                                        </li>
                                        <li>Научитесь адаптировать свои навыки к меняющимся реалиям рынка
                                        </li>
                                        <li>Сформируете мышление, которое позволит принимать взвешенные решения</li>
                                    </ul>
                                </div>
                                <div class="club21-programs-item-experts">
                                    <p>
                                        Эксперты программы
                                    </p>
                                    <div>
                                        <div>
                                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1691833200721.png" alt="">
                                            <div>
                                                <p><span>Ольга Лермонтова,</span><br> основательница<br> Careerum</p>
                                            </div>
                                        </div>
                                        <div>
                                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1691833281537.png" alt="">
                                            <div>
                                                <p><span>Елена Федорова,</span><br> юрист с 15-летним<br> опытом</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="club21-programs-item-components">
                                    <p>
                                        Что входит в программу
                                    </p>
                                    <div class="club21-programs-components-wrapper">
                                        <div class="club21-programs-components">
                                            <div class="club21-programs-component">
                                                <div>
                                                    <p>Курс</p>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="19" viewBox="0 0 9 19" fill="none">
                                                        <circle cx="4.5" cy="9.5" r="2.5" fill="white"/>
                                                      </svg>
                                                    <p>4 часов 39 мин.</p>
                                                </div>
                                                <p>Карьера в кризис: как найти и не потерять работу</p>
                                                <p>Этот курс — база антикризисного мышления. С ним вы научитесь извлекать силу из кризисов.</p>
                                            </div>
                                            <div class="club21-programs-component">
                                                <div>
                                                    <p>Курс</p>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="19" viewBox="0 0 9 19" fill="none">
                                                        <circle cx="4.5" cy="9.5" r="2.5" fill="white"/>
                                                      </svg>
                                                    <p>1 час 15 мин.</p>
                                                </div>
                                                <p>Как продолжать идти к своим целям в режиме турбулентности</p>
                                                <p>Вы узнаете, как выйти из режима «выживание» и начать жить.</p>
                                            </div>
                                            <div class="club21-programs-component">
                                                <div>
                                                    <p>Курс</p>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="19" viewBox="0 0 9 19" fill="none">
                                                        <circle cx="4.5" cy="9.5" r="2.5" fill="white"/>
                                                      </svg>
                                                    <p>1 час 7 мин.</p>
                                                </div>
                                                <p>Как себя вести в условиях кризиса</p>
                                                <p>Как защититься от манипуляций работодателя и на что обратить внимание при устройстве на работу.</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="club21-programs-components-arrows">
                                        <div class="club21-programs-components-slider__arrow-left">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 18 16" fill="none">
                                                <path d="M2.19055 7.99935L15.8105 7.99935" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M8.46289 14.2453L2.18956 7.99862L8.46289 1.75195" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                        </div>
                                        <div class="club21-programs-components-slider__arrow-right">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 18 16" fill="none">
                                                <path d="M15.8095 8.00065L2.18945 8.00065" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M9.53711 1.75471L15.8104 8.00138L9.53711 14.248" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                        </div>
    
                                    </div>
                                </div>
                                <div class="careerum-getcourse-email-form-4-fields">
                                    <div class="careerum-form-tab-item-4-fields-block">
                                        <div>
                                            <div>
                                                <h3>Оставить заявку на программу</h3>
                                                <p>Эта программа дсотупна для всех участнкиов Careerum.</p>
                                                <p>Оставьте свои данные, чтобы получить приглашение оформить подписку.</p>
                                            </div>
                                            <div class="careerum-registration-form">
                                                <form class="deva-form getcourse-email-signup" name="devaRegistrationForm" data-gjs-type="deva-registration-form">
                                                    <div>
                                                        <div class="careerum-form-tab-item-4-fields-field-name">
                                                            <input type="text" name="firstname" value="" required placeholder="Имя">
                                                        </div>
                                                        <div class="careerum-form-tab-item-4-fields-field-name">
                                                            <input type="text" name="lastname" value="" required placeholder="Фамилия">
                                                        </div>
                                                        <div class="careerum-form-tab-item-4-fields-field-email">
                                                            <input type="text" name="email" value="" required placeholder="Почта">
                                                        </div>
                                                        <div class="careerum-form-tab-item-4-fields-field-tel">
                                                            <input type="tel" value="" name="tel" required class="itl-input">
                                                        </div>
                                                    </div>
                                                    <div class="careerum-form-tab-item-4-fields-field-agree">
                                                        <input type="checkbox" name="">
                                                        <label data-toggle-checkbox="true">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
                                                                <path d="M1 2.84615L3.14168 6.70118C3.21595 6.83487 3.40669 6.83912 3.48685 6.70887L7 1" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
                                                              </svg>
                                                        </label>
                                                        <p>Я даю согласие на обработку своих персональных данных в соответствии с <a href="#">Политикой конфиденциальности</a></p>
                                                    </div>
                                                    <a href="#" disabled class="submit-btn btn-color-main-bright-orange">Хочу пройти программу</a>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="club21-programs-item-button">
                                    <a href="#buy" class="btn-color-main-dark-orange">Вступить в Careerum</a>
                                </div>
                            </div>
                            <div>
                                <div>
                                    <p>4,8 / 5</p>
                                    <p>оценка программы<br> участниками Careerum</p>
                                </div>
                                <div>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M8.50008 0.978516C12.6531 0.978516 16.0209 4.34559 16.0209 8.49935C16.0209 12.6531 12.6531 16.0202 8.50008 16.0202C4.34633 16.0202 0.979248 12.6531 0.979248 8.49935C0.979248 4.34559 4.34633 0.978516 8.50008 0.978516Z" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M10.8751 8.49616C10.8751 7.85401 7.58375 5.79972 7.21039 6.16909C6.83702 6.53847 6.80112 10.419 7.21039 10.8232C7.61965 11.2288 10.8751 9.1383 10.8751 8.49616Z" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                      </svg>
                                      <p>Видео уроки от 5<br> до 30 мин</p>
                                </div>
                                <div>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                                        <path d="M8.098 1.20898H5.13795C2.70358 1.20898 1.17725 2.93244 1.17725 5.37236V11.9543C1.17725 14.3942 2.69645 16.1177 5.13795 16.1177H12.1236C14.5659 16.1177 16.0851 14.3942 16.0851 11.9543V8.76544" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M5.9885 7.64605L11.9046 1.72992C12.6417 0.993672 13.8363 0.993672 14.5733 1.72992L15.5368 2.69338C16.2738 3.43042 16.2738 4.62584 15.5368 5.36209L9.59217 11.3067C9.26996 11.6289 8.83296 11.8102 8.37696 11.8102H5.41138L5.48579 8.81771C5.49688 8.37755 5.67659 7.95796 5.9885 7.64605Z" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M11.0056 2.64453L14.6204 6.25928" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                      </svg>
                                      <p>Есть домашние задания</p>
                                </div>
                                <div>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="17" viewBox="0 0 15 17" fill="none">
                                        <path d="M11.0018 6.48035V4.78064C11.0018 2.79119 9.38838 1.17777 7.39892 1.17777C5.40946 1.16906 3.78971 2.77456 3.78101 4.76481V4.78064V6.48035" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M10.4159 15.8233H4.36675C2.709 15.8233 1.36475 14.4798 1.36475 12.8213V9.42583C1.36475 7.76729 2.709 6.42383 4.36675 6.42383H10.4159C12.0736 6.42383 13.4179 7.76729 13.4179 9.42583V12.8213C13.4179 14.4798 12.0736 15.8233 10.4159 15.8233Z" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M7.39144 10.2441V12.0024" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                      </svg>
                                      <p>Доступно только участникам Careerum</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-club21-programs-tablet', {
        label: 'Клуб 2.1 программы (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-club21-programs-tablet">
            <div>
                <div>
                    <h2>Топ-программы Careerum<br> под самые востребованные цели</h2>
                </div>
                <div>
                    <ul class="club21-programs-nav">
                    </ul>
                </div>
                <div class="club21-programs-items-wrapper">
                    <div class="club21-programs-items">
                        <div class="club21-programs-item active" data-name="Найти работу по душе">
                            <div>
                                <div>
                                    <p>4,8 / 5</p>
                                    <p>оценка программы<br> участниками Careerum</p>
                                </div>
                            </div>
                            <div>
                                <div class="club21-programs-item-description">
                                    <p>
                                        Программа «Real Me: как найти себя<br> в работе и жизни»
                                    </p>
                                    <ul>
                                        <li>Раскроете свои сильные стороны и глубинную мотивацию
                                        </li>
                                        <li>Соотнесете свои таланты и ценности с запросами рынка
                                        </li>
                                        <li>Поймете в какой сфере вам комфортно</li>
                                        <li>Научитесь исследовать отрасли, компании и профессии, чтобы<br> выбирать работу осознанно, а не брать, «что дают»</li>
                                    </ul>                                
                                    <div>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M8.50008 0.978516C12.6531 0.978516 16.0209 4.34559 16.0209 8.49935C16.0209 12.6531 12.6531 16.0202 8.50008 16.0202C4.34633 16.0202 0.979248 12.6531 0.979248 8.49935C0.979248 4.34559 4.34633 0.978516 8.50008 0.978516Z" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M10.8751 8.49616C10.8751 7.85401 7.58375 5.79972 7.21039 6.16909C6.83702 6.53847 6.80112 10.419 7.21039 10.8232C7.61965 11.2288 10.8751 9.1383 10.8751 8.49616Z" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                        <p>Видео уроки от 5 до 30 мин</p>
                                    </div>
                                    <div>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                                            <path d="M8.098 1.20898H5.13795C2.70358 1.20898 1.17725 2.93244 1.17725 5.37236V11.9543C1.17725 14.3942 2.69645 16.1177 5.13795 16.1177H12.1236C14.5659 16.1177 16.0851 14.3942 16.0851 11.9543V8.76544" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M5.9885 7.64605L11.9046 1.72992C12.6417 0.993672 13.8363 0.993672 14.5733 1.72992L15.5368 2.69338C16.2738 3.43042 16.2738 4.62584 15.5368 5.36209L9.59217 11.3067C9.26996 11.6289 8.83296 11.8102 8.37696 11.8102H5.41138L5.48579 8.81771C5.49688 8.37755 5.67659 7.95796 5.9885 7.64605Z" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M11.0056 2.64453L14.6204 6.25928" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                        <p>Есть домашние задания</p>
                                    </div>
                                    <div>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="17" viewBox="0 0 15 17" fill="none">
                                            <path d="M11.0018 6.48035V4.78064C11.0018 2.79119 9.38838 1.17777 7.39892 1.17777C5.40946 1.16906 3.78971 2.77456 3.78101 4.76481V4.78064V6.48035" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M10.4159 15.8233H4.36675C2.709 15.8233 1.36475 14.4798 1.36475 12.8213V9.42583C1.36475 7.76729 2.709 6.42383 4.36675 6.42383H10.4159C12.0736 6.42383 13.4179 7.76729 13.4179 9.42583V12.8213C13.4179 14.4798 12.0736 15.8233 10.4159 15.8233Z" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M7.39144 10.2441V12.0024" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                        <p>Доступно только участникам<br> Careerum</p>
                                    </div>
                                </div>
                                <div class="club21-programs-item-experts">
                                    <p>
                                        Эксперты программы
                                    </p>
                                    <div>
                                        <div>
                                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1691833200721.png" alt="">
                                            <div>
                                                <p><span>Ольга<br> Лермонтова,</span><br> основательница<br> Careerum</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="club21-programs-item-components">
                                    <p>
                                        Что входит в программу
                                    </p>
                                    <div class="club21-programs-components-wrapper">
                                        <div class="club21-programs-components">
                                            <div class="club21-programs-component">
                                                <div>
                                                    <p>Курс</p>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="19" viewBox="0 0 9 19" fill="none">
                                                        <circle cx="4.5" cy="9.5" r="2.5" fill="white"/>
                                                      </svg>
                                                    <p>5 часов 42 мин.</p>
                                                </div>
                                                <p>Хочу–Могу</p>
                                                <p>Выявите свои таланты и истинные ценности, чтобы опираться на них при построении карьеры.</p>
                                            </div>
                                            <div class="club21-programs-component">
                                                <div>
                                                    <p>Курс</p>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="19" viewBox="0 0 9 19" fill="none">
                                                        <circle cx="4.5" cy="9.5" r="2.5" fill="white"/>
                                                      </svg>
                                                    <p>2 часа 16 мин.</p>
                                                </div>
                                                <p>Надо</p>
                                                <p>Узнаете, как анализировать компании и сферы на предмет соответствия вашим талантам и интересам.</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="club21-programs-components-arrows">
                                        <div class="club21-programs-components-slider__arrow-left">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 18 16" fill="none">
                                                <path d="M2.19055 7.99935L15.8105 7.99935" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M8.46289 14.2453L2.18956 7.99862L8.46289 1.75195" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                        </div>
                                        <div class="club21-programs-components-slider__arrow-right">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 18 16" fill="none">
                                                <path d="M15.8095 8.00065L2.18945 8.00065" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M9.53711 1.75471L15.8104 8.00138L9.53711 14.248" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                        </div>
    
                                    </div>
                                </div>
                                <div class="careerum-getcourse-email-form-4-fields-tablet">
                                    <div class="careerum-form-tab-item-4-fields-block">
                                        <div>
                                            <div>
                                                <h3>Оставить заявку на программу</h3>
                                                <p>Эта программа дсотупна для всех участнкиов Careerum.</p>
                                                <p>Оставьте свои данные, чтобы получить приглашение оформить подписку.</p>
                                            </div>
                                            <div class="careerum-registration-form-tablet">
                                                <form class="deva-form getcourse-email-signup" name="devaRegistrationForm" data-gjs-type="deva-registration-form">
                                                    <div>
                                                        <div class="careerum-form-tab-item-4-fields-field-name">
                                                            <input type="text" name="firstname" value="" required placeholder="Имя">
                                                        </div>
                                                        <div class="careerum-form-tab-item-4-fields-field-name">
                                                            <input type="text" name="lastname" value="" required placeholder="Фамилия">
                                                        </div>
                                                        <div class="careerum-form-tab-item-4-fields-field-email">
                                                            <input type="text" name="email" value="" required placeholder="Почта">
                                                        </div>
                                                        <div class="careerum-form-tab-item-4-fields-field-tel">
                                                            <input type="tel" value="" name="tel" required class="itl-input">
                                                        </div>
                                                    </div>
                                                    <div class="careerum-form-tab-item-4-fields-field-agree">
                                                        <input type="checkbox" name="">
                                                        <label data-toggle-checkbox="true">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
                                                                <path d="M1 2.84615L3.14168 6.70118C3.21595 6.83487 3.40669 6.83912 3.48685 6.70887L7 1" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
                                                              </svg>
                                                        </label>
                                                        <p>Я даю согласие на обработку своих персональных данных в соответствии с <a href="#">Политикой конфиденциальности</a></p>
                                                    </div>
                                                    <a href="#" disabled class="submit-btn btn-color-main-bright-orange">Хочу пройти программу</a>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="club21-programs-item-button">
                                    <a href="#buy" class="btn-color-main-dark-orange">Вступить в Careerum</a>
                                </div>
                            </div>
                        </div>
                        <div class="club21-programs-item" data-name="Получить оффер мечты">
                            <div>
                                <div>
                                    <p>4,8 / 5</p>
                                    <p>оценка программы<br> участниками Careerum</p>
                                </div>
                            </div>
                            <div>
                                <div class="club21-programs-item-description">
                                    <p>
                                        Программа «Звездный<br> кандидат»
                                    </p>
                                    <ul>
                                        <li>Научитесь составлять продающие резюме и сопроводительные письма
                                        </li>
                                        <li>Сможете презентовать себя так, чтобы договариваться о своих условиях<br> оффера
                                        </li>
                                        <li>Перестанете откликаться на «все подряд», начали искать вакансии системно</li>
                                        <li>Выработаете менталитет продавца</li>
                                        <li>Поймете, как стать востребованным специалистом</li>
                                    </ul>
                                    <div>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M8.50008 0.978516C12.6531 0.978516 16.0209 4.34559 16.0209 8.49935C16.0209 12.6531 12.6531 16.0202 8.50008 16.0202C4.34633 16.0202 0.979248 12.6531 0.979248 8.49935C0.979248 4.34559 4.34633 0.978516 8.50008 0.978516Z" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M10.8751 8.49616C10.8751 7.85401 7.58375 5.79972 7.21039 6.16909C6.83702 6.53847 6.80112 10.419 7.21039 10.8232C7.61965 11.2288 10.8751 9.1383 10.8751 8.49616Z" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                          </svg>
                                          <p>Видео уроки от 5 до 30 мин</p>
                                    </div>
                                    <div>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                                            <path d="M8.098 1.20898H5.13795C2.70358 1.20898 1.17725 2.93244 1.17725 5.37236V11.9543C1.17725 14.3942 2.69645 16.1177 5.13795 16.1177H12.1236C14.5659 16.1177 16.0851 14.3942 16.0851 11.9543V8.76544" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M5.9885 7.64605L11.9046 1.72992C12.6417 0.993672 13.8363 0.993672 14.5733 1.72992L15.5368 2.69338C16.2738 3.43042 16.2738 4.62584 15.5368 5.36209L9.59217 11.3067C9.26996 11.6289 8.83296 11.8102 8.37696 11.8102H5.41138L5.48579 8.81771C5.49688 8.37755 5.67659 7.95796 5.9885 7.64605Z" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M11.0056 2.64453L14.6204 6.25928" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                          </svg>
                                          <p>Есть домашние задания</p>
                                    </div>
                                    <div>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="17" viewBox="0 0 15 17" fill="none">
                                            <path d="M11.0018 6.48035V4.78064C11.0018 2.79119 9.38838 1.17777 7.39892 1.17777C5.40946 1.16906 3.78971 2.77456 3.78101 4.76481V4.78064V6.48035" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M10.4159 15.8233H4.36675C2.709 15.8233 1.36475 14.4798 1.36475 12.8213V9.42583C1.36475 7.76729 2.709 6.42383 4.36675 6.42383H10.4159C12.0736 6.42383 13.4179 7.76729 13.4179 9.42583V12.8213C13.4179 14.4798 12.0736 15.8233 10.4159 15.8233Z" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M7.39144 10.2441V12.0024" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                          </svg>
                                          <p>Доступно только участникам<br> Careerum</p>
                                    </div>
                                </div>
                                <div class="club21-programs-item-experts">
                                    <p>
                                        Эксперты программы
                                    </p>
                                    <div>
                                        <div>
                                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1691833200721.png" alt="">
                                            <div>
                                                <p><span>Ольга Лермонтова,</span><br> основательница<br> Careerum</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="club21-programs-item-components">
                                    <p>
                                        Что входит в программу
                                    </p>
                                    <div class="club21-programs-components-wrapper">
                                        <div class="club21-programs-components">
                                            <div class="club21-programs-component">
                                                <div>
                                                    <p>Вебинар</p>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="19" viewBox="0 0 9 19" fill="none">
                                                        <circle cx="4.5" cy="9.5" r="2.5" fill="white"/>
                                                      </svg>
                                                    <p>26 мин.</p>
                                                </div>
                                                <p>Менталитет продавца</p>
                                                <p>Поймете, как негативные психологические установки мешают построить карьеру.</p>
                                            </div>
                                            <div class="club21-programs-component">
                                                <div>
                                                    <p>Курс</p>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="19" viewBox="0 0 9 19" fill="none">
                                                        <circle cx="4.5" cy="9.5" r="2.5" fill="white"/>
                                                      </svg>
                                                    <p>2 часа 16 мин.</p>
                                                </div>
                                                <p>Умная стратегия поиска работы</p>
                                                <p>Построите воронку поиска, которая поможет системно двигаться к желаемому офферу.</p>
                                            </div>
                                            <div class="club21-programs-component">
                                                <div>
                                                    <p>Курс</p>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="19" viewBox="0 0 9 19" fill="none">
                                                        <circle cx="4.5" cy="9.5" r="2.5" fill="white"/>
                                                      </svg>
                                                    <p>5 часов 42 мин.</p>
                                                </div>
                                                <p>Продающее резюме</p>
                                                <p>Вы изучите главные принципы составления резюме, научитесь искать и грамотно формулировать свои достижения, опыт работы и образование.</p>
                                            </div>
                                            <div class="club21-programs-component">
                                                <div>
                                                    <p>Вебинар</p>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="19" viewBox="0 0 9 19" fill="none">
                                                        <circle cx="4.5" cy="9.5" r="2.5" fill="white"/>
                                                      </svg>
                                                    <p>51 мин.</p>
                                                </div>
                                                <p>Hooked: цепляющее сопроводительное письмо</p>
                                            </div>
                                            <div class="club21-programs-component">
                                                <div>
                                                    <p>Курс</p>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="19" viewBox="0 0 9 19" fill="none">
                                                        <circle cx="4.5" cy="9.5" r="2.5" fill="white"/>
                                                      </svg>
                                                    <p>2 часа 48 мин.</p>
                                                </div>
                                                <p>Эффективное интервью</p>
                                                <p>Вы научитесь грамотно и без стресса проходить любые собеседования.</p>
                                            </div>
                                            <div class="club21-programs-component">
                                                <div>
                                                    <p>Курс</p>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="19" viewBox="0 0 9 19" fill="none">
                                                        <circle cx="4.5" cy="9.5" r="2.5" fill="white"/>
                                                      </svg>
                                                    <p>2 часа 47 мин.</p>
                                                </div>
                                                <p>Great Deal: получить оффер мечты</p>
                                                <p>Вы научитесь и сразу попрактикуетесь грамотно вести переговоры об оффере.</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="club21-programs-components-arrows">
                                        <div class="club21-programs-components-slider__arrow-left">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 18 16" fill="none">
                                                <path d="M2.19055 7.99935L15.8105 7.99935" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M8.46289 14.2453L2.18956 7.99862L8.46289 1.75195" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                        </div>
                                        <div class="club21-programs-components-slider__arrow-right">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 18 16" fill="none">
                                                <path d="M15.8095 8.00065L2.18945 8.00065" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M9.53711 1.75471L15.8104 8.00138L9.53711 14.248" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                        </div>
    
                                    </div>
                                </div>
                                <div class="careerum-getcourse-email-form-4-fields-tablet">
                                    <div class="careerum-form-tab-item-4-fields-block">
                                        <div>
                                            <div>
                                                <h3>Оставить заявку на программу</h3>
                                                <p>Эта программа дсотупна для всех участнкиов Careerum.</p>
                                                <p>Оставьте свои данные, чтобы получить приглашение оформить подписку.</p>
                                            </div>
                                            <div class="careerum-registration-form-tablet">
                                                <form class="deva-form getcourse-email-signup" name="devaRegistrationForm" data-gjs-type="deva-registration-form">
                                                    <div>
                                                        <div class="careerum-form-tab-item-4-fields-field-name">
                                                            <input type="text" name="firstname" value="" required placeholder="Имя">
                                                        </div>
                                                        <div class="careerum-form-tab-item-4-fields-field-name">
                                                            <input type="text" name="lastname" value="" required placeholder="Фамилия">
                                                        </div>
                                                        <div class="careerum-form-tab-item-4-fields-field-email">
                                                            <input type="text" name="email" value="" required placeholder="Почта">
                                                        </div>
                                                        <div class="careerum-form-tab-item-4-fields-field-tel">
                                                            <input type="tel" value="" name="tel" required class="itl-input">
                                                        </div>
                                                    </div>
                                                    <div class="careerum-form-tab-item-4-fields-field-agree">
                                                        <input type="checkbox" name="">
                                                        <label data-toggle-checkbox="true">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
                                                                <path d="M1 2.84615L3.14168 6.70118C3.21595 6.83487 3.40669 6.83912 3.48685 6.70887L7 1" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
                                                              </svg>
                                                        </label>
                                                        <p>Я даю согласие на обработку своих персональных данных в соответствии с <a href="#">Политикой конфиденциальности</a></p>
                                                    </div>
                                                    <a href="#" disabled class="submit-btn btn-color-main-bright-orange">Хочу пройти программу</a>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="club21-programs-item-button">
                                    <a href="#buy" class="btn-color-main-dark-orange">Вступить в Careerum</a>
                                </div>
                            </div>
                        </div>
                        <div class="club21-programs-item" data-name="Вырасти в доходе или должности">
                            <div>
                                <div>
                                    <p>4,8 / 5</p>
                                    <p>оценка программы<br> участниками Careerum</p>
                                </div>
                            </div>
                            <div>
                                <div class="club21-programs-item-description">
                                    <p>
                                        Карьерная ракета
                                    </p>
                                    <ul>
                                        <li>Поймете, как расти в зарплате / должности именно вам
                                        </li>
                                        <li>Научитесь ставить карьерные цели и добиваться их
                                        </li>
                                        <li>Узнаете, какие навыки нужны именно вам, именно для ваших задач</li>
                                        <li>Сможете составить долгосрочную карьерную стратегию и понять,<br> как начать ее реализовывать шаг за шагом.</li>
                                    </ul>
                                    <div>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M8.50008 0.978516C12.6531 0.978516 16.0209 4.34559 16.0209 8.49935C16.0209 12.6531 12.6531 16.0202 8.50008 16.0202C4.34633 16.0202 0.979248 12.6531 0.979248 8.49935C0.979248 4.34559 4.34633 0.978516 8.50008 0.978516Z" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M10.8751 8.49616C10.8751 7.85401 7.58375 5.79972 7.21039 6.16909C6.83702 6.53847 6.80112 10.419 7.21039 10.8232C7.61965 11.2288 10.8751 9.1383 10.8751 8.49616Z" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                          </svg>
                                          <p>Видео уроки от 5 до 30 мин</p>
                                    </div>
                                    <div>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                                            <path d="M8.098 1.20898H5.13795C2.70358 1.20898 1.17725 2.93244 1.17725 5.37236V11.9543C1.17725 14.3942 2.69645 16.1177 5.13795 16.1177H12.1236C14.5659 16.1177 16.0851 14.3942 16.0851 11.9543V8.76544" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M5.9885 7.64605L11.9046 1.72992C12.6417 0.993672 13.8363 0.993672 14.5733 1.72992L15.5368 2.69338C16.2738 3.43042 16.2738 4.62584 15.5368 5.36209L9.59217 11.3067C9.26996 11.6289 8.83296 11.8102 8.37696 11.8102H5.41138L5.48579 8.81771C5.49688 8.37755 5.67659 7.95796 5.9885 7.64605Z" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M11.0056 2.64453L14.6204 6.25928" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                          </svg>
                                          <p>Есть домашние задания</p>
                                    </div>
                                    <div>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="17" viewBox="0 0 15 17" fill="none">
                                            <path d="M11.0018 6.48035V4.78064C11.0018 2.79119 9.38838 1.17777 7.39892 1.17777C5.40946 1.16906 3.78971 2.77456 3.78101 4.76481V4.78064V6.48035" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M10.4159 15.8233H4.36675C2.709 15.8233 1.36475 14.4798 1.36475 12.8213V9.42583C1.36475 7.76729 2.709 6.42383 4.36675 6.42383H10.4159C12.0736 6.42383 13.4179 7.76729 13.4179 9.42583V12.8213C13.4179 14.4798 12.0736 15.8233 10.4159 15.8233Z" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M7.39144 10.2441V12.0024" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                          </svg>
                                          <p>Доступно только участникам<br> Careerum</p>
                                    </div>
                                </div>
                                <div class="club21-programs-item-experts">
                                    <p>
                                        Эксперты программы
                                    </p>
                                    <div>
                                        <div>
                                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1691833200721.png" alt="">
                                            <div>
                                                <p><span>Ольга Лермонтова,</span><br> основательница<br> Careerum</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="club21-programs-item-components">
                                    <p>
                                        Что входит в программу
                                    </p>
                                    <div class="club21-programs-components-wrapper">
                                        <div class="club21-programs-components">
                                            <div class="club21-programs-component">
                                                <div>
                                                    <p>Курс</p>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="19" viewBox="0 0 9 19" fill="none">
                                                        <circle cx="4.5" cy="9.5" r="2.5" fill="white"/>
                                                      </svg>
                                                    <p>2 часа 43 мин.</p>
                                                </div>
                                                <p>Карьера как проект</p>
                                                <p>Вы освоите базу карьерного мышления и сможете осознанно спланировать своё долгосрочное карьерное развитие.</p>
                                            </div>
                                            <div class="club21-programs-component">
                                                <div>
                                                    <p>Курс</p>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="19" viewBox="0 0 9 19" fill="none">
                                                        <circle cx="4.5" cy="9.5" r="2.5" fill="white"/>
                                                      </svg>
                                                    <p>1 час 10 мин.</p>
                                                </div>
                                                <p>Цели как в Google. Результаты как в Forbes</p>
                                                <p>Вы научитесь планировать свои задачи и узнаете, как сделать руководителя и коллег своими союзниками в достижении целей.</p>
                                            </div>
                                            <div class="club21-programs-component">
                                                <div>
                                                    <p>Курс</p>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="19" viewBox="0 0 9 19" fill="none">
                                                        <circle cx="4.5" cy="9.5" r="2.5" fill="white"/>
                                                      </svg>
                                                    <p>1 час 10 мин.</p>
                                                </div>
                                                <p>Пробей зарплатный потолок</p>
                                                <p>Вы узнаете, как запрограммировать свое повышение и системно расти в должности и зарплате.</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="club21-programs-components-arrows">
                                        <div class="club21-programs-components-slider__arrow-left">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 18 16" fill="none">
                                                <path d="M2.19055 7.99935L15.8105 7.99935" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M8.46289 14.2453L2.18956 7.99862L8.46289 1.75195" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                        </div>
                                        <div class="club21-programs-components-slider__arrow-right">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 18 16" fill="none">
                                                <path d="M15.8095 8.00065L2.18945 8.00065" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M9.53711 1.75471L15.8104 8.00138L9.53711 14.248" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                        </div>
    
                                    </div>
                                </div>
                                <div class="careerum-getcourse-email-form-4-fields-tablet">
                                    <div class="careerum-form-tab-item-4-fields-block">
                                        <div>
                                            <div>
                                                <h3>Оставить заявку на программу</h3>
                                                <p>Эта программа дсотупна для всех участнкиов Careerum.</p>
                                                <p>Оставьте свои данные, чтобы получить приглашение оформить подписку.</p>
                                            </div>
                                            <div class="careerum-registration-form-tablet">
                                                <form class="deva-form getcourse-email-signup" name="devaRegistrationForm" data-gjs-type="deva-registration-form">
                                                    <div>
                                                        <div class="careerum-form-tab-item-4-fields-field-name">
                                                            <input type="text" name="firstname" value="" required placeholder="Имя">
                                                        </div>
                                                        <div class="careerum-form-tab-item-4-fields-field-name">
                                                            <input type="text" name="lastname" value="" required placeholder="Фамилия">
                                                        </div>
                                                        <div class="careerum-form-tab-item-4-fields-field-email">
                                                            <input type="text" name="email" value="" required placeholder="Почта">
                                                        </div>
                                                        <div class="careerum-form-tab-item-4-fields-field-tel">
                                                            <input type="tel" value="" name="tel" required class="itl-input">
                                                        </div>
                                                    </div>
                                                    <div class="careerum-form-tab-item-4-fields-field-agree">
                                                        <input type="checkbox" name="">
                                                        <label data-toggle-checkbox="true">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
                                                                <path d="M1 2.84615L3.14168 6.70118C3.21595 6.83487 3.40669 6.83912 3.48685 6.70887L7 1" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
                                                              </svg>
                                                        </label>
                                                        <p>Я даю согласие на обработку своих персональных данных в соответствии с <a href="#">Политикой конфиденциальности</a></p>
                                                    </div>
                                                    <a href="#" disabled class="submit-btn btn-color-main-bright-orange">Хочу пройти программу</a>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="club21-programs-item-button">
                                    <a href="#buy" class="btn-color-main-dark-orange">Вступить в Careerum</a>
                                </div>
                            </div>
                        </div>
                        <div class="club21-programs-item" data-name="Переехать по работе">
                            <div>
                                <div>
                                    <p>4,8 / 5</p>
                                    <p>оценка программы<br> участниками Careerum</p>
                                </div>
                            </div>
                            <div>
                                <div class="club21-programs-item-description">
                                    <p>
                                        Международная карьера<br> и релокация
                                    </p>
                                    <ul>
                                        <li>Поймете, как устроен процесс найма за рубежом
                                        </li>
                                        <li>Узнаите, где искать вакансии иностранных компаний
                                        </li>
                                        <li>Овладеете навыками ведения переговоров с зарубежными рекрутерами
                                        </li>
                                        <li>Выработаете менталитет продавца</li>
                                        <li>Сумеете адаптироваться к незнакомой культурной среде</li>
                                    </ul>
                                    <div>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M8.50008 0.978516C12.6531 0.978516 16.0209 4.34559 16.0209 8.49935C16.0209 12.6531 12.6531 16.0202 8.50008 16.0202C4.34633 16.0202 0.979248 12.6531 0.979248 8.49935C0.979248 4.34559 4.34633 0.978516 8.50008 0.978516Z" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M10.8751 8.49616C10.8751 7.85401 7.58375 5.79972 7.21039 6.16909C6.83702 6.53847 6.80112 10.419 7.21039 10.8232C7.61965 11.2288 10.8751 9.1383 10.8751 8.49616Z" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                          </svg>
                                          <p>Видео уроки от 5 до 30 мин</p>
                                    </div>
                                    <div>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                                            <path d="M8.098 1.20898H5.13795C2.70358 1.20898 1.17725 2.93244 1.17725 5.37236V11.9543C1.17725 14.3942 2.69645 16.1177 5.13795 16.1177H12.1236C14.5659 16.1177 16.0851 14.3942 16.0851 11.9543V8.76544" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M5.9885 7.64605L11.9046 1.72992C12.6417 0.993672 13.8363 0.993672 14.5733 1.72992L15.5368 2.69338C16.2738 3.43042 16.2738 4.62584 15.5368 5.36209L9.59217 11.3067C9.26996 11.6289 8.83296 11.8102 8.37696 11.8102H5.41138L5.48579 8.81771C5.49688 8.37755 5.67659 7.95796 5.9885 7.64605Z" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M11.0056 2.64453L14.6204 6.25928" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                          </svg>
                                          <p>Есть домашние задания</p>
                                    </div>
                                    <div>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="17" viewBox="0 0 15 17" fill="none">
                                            <path d="M11.0018 6.48035V4.78064C11.0018 2.79119 9.38838 1.17777 7.39892 1.17777C5.40946 1.16906 3.78971 2.77456 3.78101 4.76481V4.78064V6.48035" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M10.4159 15.8233H4.36675C2.709 15.8233 1.36475 14.4798 1.36475 12.8213V9.42583C1.36475 7.76729 2.709 6.42383 4.36675 6.42383H10.4159C12.0736 6.42383 13.4179 7.76729 13.4179 9.42583V12.8213C13.4179 14.4798 12.0736 15.8233 10.4159 15.8233Z" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M7.39144 10.2441V12.0024" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                          </svg>
                                          <p>Программу можно<br> купить отдельно</p>
                                    </div>
                                </div>
                                <div class="club21-programs-item-experts">
                                    <p>
                                        Эксперты программы
                                    </p>
                                    <div>
                                        <div>
                                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1691833200721.png" alt="">
                                            <div>
                                                <p><span>Ольга Лермонтова,</span><br> основательница<br> Careerum</p>
                                            </div>
                                        </div>
                                        <div>
                                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1691833224105.png" alt="">
                                            <div>
                                                <p><span>Montse Lorente,</span><br> международный<br> карьерный<br> консультант</p>
                                            </div>
                                        </div>
                                        <div>
                                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1691833243676.png" alt="">
                                            <div>
                                                <p><span>Sophie Vurpillot,</span><br>международный<br> рекрутер и коуч,<br> 10+ лет опыта</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="club21-programs-item-components">
                                    <p>
                                        Что входит в программу
                                    </p>
                                    <div class="club21-programs-components-wrapper">
                                        <div class="club21-programs-components">
                                            <div class="club21-programs-component">
                                                <div>
                                                    <p>Курс</p>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="19" viewBox="0 0 9 19" fill="none">
                                                        <circle cx="4.5" cy="9.5" r="2.5" fill="white"/>
                                                      </svg>
                                                    <p>1 час 34 мин.</p>
                                                </div>
                                                <p>Работа без границ</p>
                                                <p>Вы изучите алгоритм поиска работы за границей, построите свою стратегию для получения оффера в новой географии.</p>
                                            </div>
                                            <div class="club21-programs-component">
                                                <div>
                                                    <p>Курс</p>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="19" viewBox="0 0 9 19" fill="none">
                                                        <circle cx="4.5" cy="9.5" r="2.5" fill="white"/>
                                                      </svg>
                                                    <p>1 час 10 мин.</p>
                                                </div>
                                                <p>Your Dream job, Abroad</p>
                                                <p>You will learn how to find a job in the global market, gaining practical recommendations on building your action plan.</p>
                                            </div>
                                            <div class="club21-programs-component">
                                                <div>
                                                    <p>Курс</p>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="19" viewBox="0 0 9 19" fill="none">
                                                        <circle cx="4.5" cy="9.5" r="2.5" fill="white"/>
                                                      </svg>
                                                    <p>6 часов 30 мин.</p>
                                                </div>
                                                <p>LinkedIn для развития карьеры</p>
                                                
                                            </div>
                                            <div class="club21-programs-component">
                                                <div>
                                                    <p>Вебинар</p>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="19" viewBox="0 0 9 19" fill="none">
                                                        <circle cx="4.5" cy="9.5" r="2.5" fill="white"/>
                                                      </svg>
                                                    <p>1 час 37 мин.</p>
                                                </div>
                                                <p>The other side: recruiter’s view on the job search</p>
                                            </div>
                                            <div class="club21-programs-component">
                                                <div>
                                                    <p>Вебинар</p>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="19" viewBox="0 0 9 19" fill="none">
                                                        <circle cx="4.5" cy="9.5" r="2.5" fill="white"/>
                                                      </svg>
                                                    <p>1 час 31 мин.</p>
                                                </div>
                                                <p>Communication with English-speaking colleagues</p>
                                            </div>
                                            <div class="club21-programs-component">
                                                <div>
                                                    <p>Курс</p>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="19" viewBox="0 0 9 19" fill="none">
                                                        <circle cx="4.5" cy="9.5" r="2.5" fill="white"/>
                                                      </svg>
                                                    <p>2 часа 47 мин.</p>
                                                </div>
                                                <p>Language of a Job Interview</p>
                                            </div>
                                            <div class="club21-programs-component">
                                                <div>
                                                    <p>Курс</p>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="19" viewBox="0 0 9 19" fill="none">
                                                        <circle cx="4.5" cy="9.5" r="2.5" fill="white"/>
                                                      </svg>
                                                    <p>1 час 18 мин.</p>
                                                </div>
                                                <p>Professional and cultural adaptation in Corporate America</p>
                                            </div>
                                            <div class="club21-programs-component">
                                                <div>
                                                    <p>Курс</p>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="19" viewBox="0 0 9 19" fill="none">
                                                        <circle cx="4.5" cy="9.5" r="2.5" fill="white"/>
                                                      </svg>
                                                    <p>1 час 37 мин.</p>
                                                </div>
                                                <p>Пути профессиональной иммиграции в США и навигация по американскому рынку труда</p>
                                            </div>
                                            <div class="club21-programs-component">
                                                <div>
                                                    <p>Курс</p>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="19" viewBox="0 0 9 19" fill="none">
                                                        <circle cx="4.5" cy="9.5" r="2.5" fill="white"/>
                                                      </svg>
                                                    <p>1 час 5 мин.</p>
                                                </div>
                                                <p>Межкультурная адаптация и коммуникация</p>
                                            </div>
                                            <div class="club21-programs-component">
                                                <div>
                                                    <p>Курс</p>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="19" viewBox="0 0 9 19" fill="none">
                                                        <circle cx="4.5" cy="9.5" r="2.5" fill="white"/>
                                                      </svg>
                                                    <p>2 часа 9 мин.</p>
                                                </div>
                                                <p>Intercultural Communications</p>
                                                <p>This course is about cross-cultural communication and team communication in English, particularly when relocating.</p>
                                            </div>
                                            <div class="club21-programs-component">
                                                <div>
                                                    <p>Вебинар</p>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="19" viewBox="0 0 9 19" fill="none">
                                                        <circle cx="4.5" cy="9.5" r="2.5" fill="white"/>
                                                      </svg>
                                                    <p>2 часа 21 мин.</p>
                                                </div>
                                                <p>Как попасть в Google: секреты и подводные камни</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="club21-programs-components-arrows">
                                        <div class="club21-programs-components-slider__arrow-left">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 18 16" fill="none">
                                                <path d="M2.19055 7.99935L15.8105 7.99935" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M8.46289 14.2453L2.18956 7.99862L8.46289 1.75195" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                        </div>
                                        <div class="club21-programs-components-slider__arrow-right">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 18 16" fill="none">
                                                <path d="M15.8095 8.00065L2.18945 8.00065" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M9.53711 1.75471L15.8104 8.00138L9.53711 14.248" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                        </div>
    
                                    </div>
                                </div>
                                <div class="careerum-getcourse-email-form-4-fields-tablet">
                                    <div class="careerum-form-tab-item-4-fields-block">
                                        <div>
                                            <div>
                                                <h3>Оставить заявку на программу</h3>
                                                <p>Эта программа дсотупна для всех участнкиов Careerum.</p>
                                                <p>Оставьте свои данные, чтобы получить приглашение оформить подписку.</p>
                                            </div>
                                            <div class="careerum-registration-form-tablet">
                                                <form class="deva-form getcourse-email-signup" name="devaRegistrationForm" data-gjs-type="deva-registration-form">
                                                    <div>
                                                        <div class="careerum-form-tab-item-4-fields-field-name">
                                                            <input type="text" name="firstname" value="" required placeholder="Имя">
                                                        </div>
                                                        <div class="careerum-form-tab-item-4-fields-field-name">
                                                            <input type="text" name="lastname" value="" required placeholder="Фамилия">
                                                        </div>
                                                        <div class="careerum-form-tab-item-4-fields-field-email">
                                                            <input type="text" name="email" value="" required placeholder="Почта">
                                                        </div>
                                                        <div class="careerum-form-tab-item-4-fields-field-tel">
                                                            <input type="tel" value="" name="tel" required class="itl-input">
                                                        </div>
                                                    </div>
                                                    <div class="careerum-form-tab-item-4-fields-field-agree">
                                                        <input type="checkbox" name="">
                                                        <label data-toggle-checkbox="true">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
                                                                <path d="M1 2.84615L3.14168 6.70118C3.21595 6.83487 3.40669 6.83912 3.48685 6.70887L7 1" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
                                                              </svg>
                                                        </label>
                                                        <p>Я даю согласие на обработку своих персональных данных в соответствии с <a href="#">Политикой конфиденциальности</a></p>
                                                    </div>
                                                    <a href="#" disabled class="submit-btn btn-color-main-bright-orange">Хочу пройти программу</a>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="club21-programs-item-button">
                                    <a href="#buy" class="btn-color-main-dark-orange">Вступить в Careerum</a>
                                </div>
                            </div>
                        </div>
                        <div class="club21-programs-item" data-name="Пройти испытательный срок">
                            <div>
                                <div>
                                    <p>4,8 / 5</p>
                                    <p>оценка программы<br> участниками Careerum</p>
                                </div>
                            </div>
                            <div>
                                <div class="club21-programs-item-description">
                                    <p>
                                        Жизнь после оффера
                                    </p>
                                    <ul>
                                        <li>Поймете, как сразу взять успешный страт на новом месте
                                        </li>
                                        <li>Разберете пошагово свою первую неделю и дальнейшую стратегию
                                        </li>
                                        <li>Узнаете, как быть на хорошем счету у руководства и коллег</li>
                                    </ul>
                                    <div>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M8.50008 0.978516C12.6531 0.978516 16.0209 4.34559 16.0209 8.49935C16.0209 12.6531 12.6531 16.0202 8.50008 16.0202C4.34633 16.0202 0.979248 12.6531 0.979248 8.49935C0.979248 4.34559 4.34633 0.978516 8.50008 0.978516Z" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M10.8751 8.49616C10.8751 7.85401 7.58375 5.79972 7.21039 6.16909C6.83702 6.53847 6.80112 10.419 7.21039 10.8232C7.61965 11.2288 10.8751 9.1383 10.8751 8.49616Z" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                          </svg>
                                          <p>Видео уроки от 5 до 30 мин</p>
                                    </div>
                                    <div>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                                            <path d="M8.098 1.20898H5.13795C2.70358 1.20898 1.17725 2.93244 1.17725 5.37236V11.9543C1.17725 14.3942 2.69645 16.1177 5.13795 16.1177H12.1236C14.5659 16.1177 16.0851 14.3942 16.0851 11.9543V8.76544" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M5.9885 7.64605L11.9046 1.72992C12.6417 0.993672 13.8363 0.993672 14.5733 1.72992L15.5368 2.69338C16.2738 3.43042 16.2738 4.62584 15.5368 5.36209L9.59217 11.3067C9.26996 11.6289 8.83296 11.8102 8.37696 11.8102H5.41138L5.48579 8.81771C5.49688 8.37755 5.67659 7.95796 5.9885 7.64605Z" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M11.0056 2.64453L14.6204 6.25928" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                          </svg>
                                          <p>Есть домашние задания</p>
                                    </div>
                                    <div>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="17" viewBox="0 0 15 17" fill="none">
                                            <path d="M11.0018 6.48035V4.78064C11.0018 2.79119 9.38838 1.17777 7.39892 1.17777C5.40946 1.16906 3.78971 2.77456 3.78101 4.76481V4.78064V6.48035" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M10.4159 15.8233H4.36675C2.709 15.8233 1.36475 14.4798 1.36475 12.8213V9.42583C1.36475 7.76729 2.709 6.42383 4.36675 6.42383H10.4159C12.0736 6.42383 13.4179 7.76729 13.4179 9.42583V12.8213C13.4179 14.4798 12.0736 15.8233 10.4159 15.8233Z" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M7.39144 10.2441V12.0024" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                          </svg>
                                          <p>Доступно только участникам<br> Careerum</p>
                                    </div>
                                </div>
                                <div class="club21-programs-item-experts">
                                    <p>
                                        Эксперты программы
                                    </p>
                                    <div>
                                        <div>
                                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1691833200721.png" alt="">
                                            <div>
                                                <p><span>Ольга<br> Лермонтова,</span><br> основательница<br> Careerum</p>
                                            </div>
                                        </div>
                                        <div>
                                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1691833262781.png" alt="">
                                            <div>
                                                <p><span>Мария Батти,</span><br> карьерный стратег</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="club21-programs-item-components">
                                    <p>
                                        Что входит в программу
                                    </p>
                                    <div class="club21-programs-components-wrapper">
                                        <div class="club21-programs-components">
                                            <div class="club21-programs-component">
                                                <div>
                                                    <p>Курс</p>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="19" viewBox="0 0 9 19" fill="none">
                                                        <circle cx="4.5" cy="9.5" r="2.5" fill="white"/>
                                                      </svg>
                                                    <p>6 часов 44 мин.</p>
                                                </div>
                                                <p>Первые месяцы на новой работе</p>
                                                <p>Вы получите и научитесь применять инструменты, которые помогут взять успешный старт в новой компании.</p>
                                            </div>
                                            <div class="club21-programs-component">
                                                <div>
                                                    <p>Курс</p>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="19" viewBox="0 0 9 19" fill="none">
                                                        <circle cx="4.5" cy="9.5" r="2.5" fill="white"/>
                                                      </svg>
                                                    <p>1 часа 24 мин.</p>
                                                </div>
                                                <p>Как грамотно выстраивать общение на работе</p>
                                                <p>Вы научитесь строить конструктивные отношения с руководителем и коллегами.</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="club21-programs-components-arrows">
                                        <div class="club21-programs-components-slider__arrow-left">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 18 16" fill="none">
                                                <path d="M2.19055 7.99935L15.8105 7.99935" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M8.46289 14.2453L2.18956 7.99862L8.46289 1.75195" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                        </div>
                                        <div class="club21-programs-components-slider__arrow-right">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 18 16" fill="none">
                                                <path d="M15.8095 8.00065L2.18945 8.00065" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M9.53711 1.75471L15.8104 8.00138L9.53711 14.248" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                        </div>
    
                                    </div>
                                </div>
                                <div class="careerum-getcourse-email-form-4-fields-tablet">
                                    <div class="careerum-form-tab-item-4-fields-block">
                                        <div>
                                            <div>
                                                <h3>Оставить заявку на программу</h3>
                                                <p>Эта программа дсотупна для всех участнкиов Careerum.</p>
                                                <p>Оставьте свои данные, чтобы получить приглашение оформить подписку.</p>
                                            </div>
                                            <div class="careerum-registration-form-tablet">
                                                <form class="deva-form getcourse-email-signup" name="devaRegistrationForm" data-gjs-type="deva-registration-form">
                                                    <div>
                                                        <div class="careerum-form-tab-item-4-fields-field-name">
                                                            <input type="text" name="firstname" value="" required placeholder="Имя">
                                                        </div>
                                                        <div class="careerum-form-tab-item-4-fields-field-name">
                                                            <input type="text" name="lastname" value="" required placeholder="Фамилия">
                                                        </div>
                                                        <div class="careerum-form-tab-item-4-fields-field-email">
                                                            <input type="text" name="email" value="" required placeholder="Почта">
                                                        </div>
                                                        <div class="careerum-form-tab-item-4-fields-field-tel">
                                                            <input type="tel" value="" name="tel" required class="itl-input">
                                                        </div>
                                                    </div>
                                                    <div class="careerum-form-tab-item-4-fields-field-agree">
                                                        <input type="checkbox" name="">
                                                        <label data-toggle-checkbox="true">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
                                                                <path d="M1 2.84615L3.14168 6.70118C3.21595 6.83487 3.40669 6.83912 3.48685 6.70887L7 1" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
                                                              </svg>
                                                        </label>
                                                        <p>Я даю согласие на обработку своих персональных данных в соответствии с <a href="#">Политикой конфиденциальности</a></p>
                                                    </div>
                                                    <a href="#" disabled class="submit-btn btn-color-main-bright-orange">Хочу пройти программу</a>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="club21-programs-item-button">
                                    <a href="#buy" class="btn-color-main-dark-orange">Вступить в Careerum</a>
                                </div>
                            </div>
                        </div>
                        <div class="club21-programs-item" data-name="Расти в кризис">
                            <div>
                                <div>
                                    <p>4,8 / 5</p>
                                    <p>оценка программы<br> участниками Careerum</p>
                                </div>
                            </div>
                            <div>
                                <div class="club21-programs-item-description">
                                    <p>
                                        Антикризис
                                    </p>
                                    <ul>
                                        <li>Узнаете, как расти в должности / получать офферы вопреки кризисам
                                        </li>
                                        <li>Научитесь адаптировать свои навыки к меняющимся реалиям рынка
                                        </li>
                                        <li>Сформируете мышление, которое позволит принимать взвешенные решения</li>
                                    </ul>
                                    <div>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M8.50008 0.978516C12.6531 0.978516 16.0209 4.34559 16.0209 8.49935C16.0209 12.6531 12.6531 16.0202 8.50008 16.0202C4.34633 16.0202 0.979248 12.6531 0.979248 8.49935C0.979248 4.34559 4.34633 0.978516 8.50008 0.978516Z" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M10.8751 8.49616C10.8751 7.85401 7.58375 5.79972 7.21039 6.16909C6.83702 6.53847 6.80112 10.419 7.21039 10.8232C7.61965 11.2288 10.8751 9.1383 10.8751 8.49616Z" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                          </svg>
                                          <p>Видео уроки от 5 до 30 мин</p>
                                    </div>
                                    <div>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                                            <path d="M8.098 1.20898H5.13795C2.70358 1.20898 1.17725 2.93244 1.17725 5.37236V11.9543C1.17725 14.3942 2.69645 16.1177 5.13795 16.1177H12.1236C14.5659 16.1177 16.0851 14.3942 16.0851 11.9543V8.76544" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M5.9885 7.64605L11.9046 1.72992C12.6417 0.993672 13.8363 0.993672 14.5733 1.72992L15.5368 2.69338C16.2738 3.43042 16.2738 4.62584 15.5368 5.36209L9.59217 11.3067C9.26996 11.6289 8.83296 11.8102 8.37696 11.8102H5.41138L5.48579 8.81771C5.49688 8.37755 5.67659 7.95796 5.9885 7.64605Z" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M11.0056 2.64453L14.6204 6.25928" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                          </svg>
                                          <p>Есть домашние задания</p>
                                    </div>
                                    <div>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="17" viewBox="0 0 15 17" fill="none">
                                            <path d="M11.0018 6.48035V4.78064C11.0018 2.79119 9.38838 1.17777 7.39892 1.17777C5.40946 1.16906 3.78971 2.77456 3.78101 4.76481V4.78064V6.48035" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M10.4159 15.8233H4.36675C2.709 15.8233 1.36475 14.4798 1.36475 12.8213V9.42583C1.36475 7.76729 2.709 6.42383 4.36675 6.42383H10.4159C12.0736 6.42383 13.4179 7.76729 13.4179 9.42583V12.8213C13.4179 14.4798 12.0736 15.8233 10.4159 15.8233Z" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M7.39144 10.2441V12.0024" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                          </svg>
                                          <p>Доступно только участникам<br> Careerum</p>
                                    </div>
                                </div>
                                <div class="club21-programs-item-experts">
                                    <p>
                                        Эксперты программы
                                    </p>
                                    <div>
                                        <div>
                                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1691833200721.png" alt="">
                                            <div>
                                                <p><span>Ольга Лермонтова,</span><br> основательница<br> Careerum</p>
                                            </div>
                                        </div>
                                        <div>
                                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1691833281537.png" alt="">
                                            <div>
                                                <p><span>Елена Федорова,</span><br> юрист с 15-летним<br> опытом</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="club21-programs-item-components">
                                    <p>
                                        Что входит в программу
                                    </p>
                                    <div class="club21-programs-components-wrapper">
                                        <div class="club21-programs-components">
                                            <div class="club21-programs-component">
                                                <div>
                                                    <p>Курс</p>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="19" viewBox="0 0 9 19" fill="none">
                                                        <circle cx="4.5" cy="9.5" r="2.5" fill="white"/>
                                                      </svg>
                                                    <p>4 часов 39 мин.</p>
                                                </div>
                                                <p>Карьера в кризис: как найти и не потерять работу</p>
                                                <p>Этот курс — база антикризисного мышления. С ним вы научитесь извлекать силу из кризисов.</p>
                                            </div>
                                            <div class="club21-programs-component">
                                                <div>
                                                    <p>Курс</p>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="19" viewBox="0 0 9 19" fill="none">
                                                        <circle cx="4.5" cy="9.5" r="2.5" fill="white"/>
                                                      </svg>
                                                    <p>1 час 15 мин.</p>
                                                </div>
                                                <p>Как продолжать идти к своим целям в режиме турбулентности</p>
                                                <p>Вы узнаете, как выйти из режима «выживание» и начать жить.</p>
                                            </div>
                                            <div class="club21-programs-component">
                                                <div>
                                                    <p>Курс</p>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="19" viewBox="0 0 9 19" fill="none">
                                                        <circle cx="4.5" cy="9.5" r="2.5" fill="white"/>
                                                      </svg>
                                                    <p>1 час 7 мин.</p>
                                                </div>
                                                <p>Как себя вести в условиях кризиса</p>
                                                <p>Как защититься от манипуляций работодателя и на что обратить внимание при устройстве на работу.</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="club21-programs-components-arrows">
                                        <div class="club21-programs-components-slider__arrow-left">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 18 16" fill="none">
                                                <path d="M2.19055 7.99935L15.8105 7.99935" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M8.46289 14.2453L2.18956 7.99862L8.46289 1.75195" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                        </div>
                                        <div class="club21-programs-components-slider__arrow-right">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 18 16" fill="none">
                                                <path d="M15.8095 8.00065L2.18945 8.00065" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M9.53711 1.75471L15.8104 8.00138L9.53711 14.248" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                        </div>
    
                                    </div>
                                </div>
                                <div class="careerum-getcourse-email-form-4-fields-tablet">
                                    <div class="careerum-form-tab-item-4-fields-block">
                                        <div>
                                            <div>
                                                <h3>Оставить заявку на программу</h3>
                                                <p>Эта программа дсотупна для всех участнкиов Careerum.</p>
                                                <p>Оставьте свои данные, чтобы получить приглашение оформить подписку.</p>
                                            </div>
                                            <div class="careerum-registration-form-tablet">
                                                <form class="deva-form getcourse-email-signup" name="devaRegistrationForm" data-gjs-type="deva-registration-form">
                                                    <div>
                                                        <div class="careerum-form-tab-item-4-fields-field-name">
                                                            <input type="text" name="firstname" value="" required placeholder="Имя">
                                                        </div>
                                                        <div class="careerum-form-tab-item-4-fields-field-name">
                                                            <input type="text" name="lastname" value="" required placeholder="Фамилия">
                                                        </div>
                                                        <div class="careerum-form-tab-item-4-fields-field-email">
                                                            <input type="text" name="email" value="" required placeholder="Почта">
                                                        </div>
                                                        <div class="careerum-form-tab-item-4-fields-field-tel">
                                                            <input type="tel" value="" name="tel" required class="itl-input">
                                                        </div>
                                                    </div>
                                                    <div class="careerum-form-tab-item-4-fields-field-agree">
                                                        <input type="checkbox" name="">
                                                        <label data-toggle-checkbox="true">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
                                                                <path d="M1 2.84615L3.14168 6.70118C3.21595 6.83487 3.40669 6.83912 3.48685 6.70887L7 1" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
                                                              </svg>
                                                        </label>
                                                        <p>Я даю согласие на обработку своих персональных данных в соответствии с <a href="#">Политикой конфиденциальности</a></p>
                                                    </div>
                                                    <a href="#" disabled class="submit-btn btn-color-main-bright-orange">Хочу пройти программу</a>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="club21-programs-item-button">
                                    <a href="#buy" class="btn-color-main-dark-orange">Вступить в Careerum</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-club21-programs-mobile', {
        label: 'Клуб 2.1 программы (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-club21-programs-mobile">
            <div>
                <div>
                    <h2>Топ-программы Careerum под самые<br> востребованные цели</h2>
                </div>
                <div>
                    <ul class="club21-programs-nav">
                    </ul>
                </div>
                <div class="club21-programs-items-wrapper">
                    <div class="club21-programs-items">
                        <div class="club21-programs-item active" data-name="Найти работу по душе">
                            <div>
                                <div>
                                    <p>4,8 / 5</p>
                                    <p>оценка программы<br> участниками Careerum</p>
                                </div>
                            </div>
                            <div>
                                <div class="club21-programs-item-description">
                                    <p>
                                        Программа «Real Me:<br> как найти себя<br> в работе и жизни»
                                    </p>
                                    <ul>
                                        <li>Раскроете свои сильные стороны и глубинную мотивацию
                                        </li>
                                        <li>Соотнесете свои таланты и ценности с запросами рынка
                                        </li>
                                        <li>Поймете в какой сфере вам комфортно</li>
                                        <li>Научитесь исследовать отрасли, компании и профессии, чтобы<br> выбирать работу осознанно, а не брать, «что дают»</li>
                                    </ul>                                
                                    <div>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M8.50008 0.978516C12.6531 0.978516 16.0209 4.34559 16.0209 8.49935C16.0209 12.6531 12.6531 16.0202 8.50008 16.0202C4.34633 16.0202 0.979248 12.6531 0.979248 8.49935C0.979248 4.34559 4.34633 0.978516 8.50008 0.978516Z" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M10.8751 8.49616C10.8751 7.85401 7.58375 5.79972 7.21039 6.16909C6.83702 6.53847 6.80112 10.419 7.21039 10.8232C7.61965 11.2288 10.8751 9.1383 10.8751 8.49616Z" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                        <p>Видео уроки от 5 до 30 мин</p>
                                    </div>
                                    <div>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                                            <path d="M8.098 1.20898H5.13795C2.70358 1.20898 1.17725 2.93244 1.17725 5.37236V11.9543C1.17725 14.3942 2.69645 16.1177 5.13795 16.1177H12.1236C14.5659 16.1177 16.0851 14.3942 16.0851 11.9543V8.76544" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M5.9885 7.64605L11.9046 1.72992C12.6417 0.993672 13.8363 0.993672 14.5733 1.72992L15.5368 2.69338C16.2738 3.43042 16.2738 4.62584 15.5368 5.36209L9.59217 11.3067C9.26996 11.6289 8.83296 11.8102 8.37696 11.8102H5.41138L5.48579 8.81771C5.49688 8.37755 5.67659 7.95796 5.9885 7.64605Z" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M11.0056 2.64453L14.6204 6.25928" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                        <p>Есть домашние задания</p>
                                    </div>
                                    <div>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="17" viewBox="0 0 15 17" fill="none">
                                            <path d="M11.0018 6.48035V4.78064C11.0018 2.79119 9.38838 1.17777 7.39892 1.17777C5.40946 1.16906 3.78971 2.77456 3.78101 4.76481V4.78064V6.48035" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M10.4159 15.8233H4.36675C2.709 15.8233 1.36475 14.4798 1.36475 12.8213V9.42583C1.36475 7.76729 2.709 6.42383 4.36675 6.42383H10.4159C12.0736 6.42383 13.4179 7.76729 13.4179 9.42583V12.8213C13.4179 14.4798 12.0736 15.8233 10.4159 15.8233Z" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M7.39144 10.2441V12.0024" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                        <p>Доступно только участникам<br> Careerum</p>
                                    </div>
                                </div>
                                <div class="club21-programs-item-experts">
                                    <p>
                                        Эксперты программы
                                    </p>
                                    <div>
                                        <div>
                                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1691833200721.png" alt="">
                                            <div>
                                                <p><span>Ольга Лермонтова,</span><br> основательница<br> Careerum</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="club21-programs-item-components">
                                    <p>
                                        Что входит в программу
                                    </p>
                                    <div class="club21-programs-components-wrapper">
                                        <div class="club21-programs-components">
                                            <div class="club21-programs-component">
                                                <div>
                                                    <p>Курс</p>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="19" viewBox="0 0 9 19" fill="none">
                                                        <circle cx="4.5" cy="9.5" r="2.5" fill="white"/>
                                                      </svg>
                                                    <p>5 часов 42 мин.</p>
                                                </div>
                                                <p>Хочу–Могу</p>
                                                <p>Выявите свои таланты и истинные ценности, чтобы опираться на них при построении карьеры.</p>
                                            </div>
                                            <div class="club21-programs-component">
                                                <div>
                                                    <p>Курс</p>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="19" viewBox="0 0 9 19" fill="none">
                                                        <circle cx="4.5" cy="9.5" r="2.5" fill="white"/>
                                                      </svg>
                                                    <p>2 часа 16 мин.</p>
                                                </div>
                                                <p>Надо</p>
                                                <p>Узнаете, как анализировать компании и сферы на предмет соответствия вашим талантам и интересам.</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="club21-programs-components-arrows">
                                        <div class="club21-programs-components-slider__arrow-left">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 18 16" fill="none">
                                                <path d="M2.19055 7.99935L15.8105 7.99935" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M8.46289 14.2453L2.18956 7.99862L8.46289 1.75195" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                        </div>
                                        <div class="club21-programs-components-slider__arrow-right">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 18 16" fill="none">
                                                <path d="M15.8095 8.00065L2.18945 8.00065" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M9.53711 1.75471L15.8104 8.00138L9.53711 14.248" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                        </div>
    
                                    </div>
                                </div>
                                <div class="careerum-getcourse-email-form-4-fields-mobile">
                                    <div class="careerum-form-tab-item-4-fields-block">
                                        <div>
                                            <div>
                                                <h3>Оставить заявку на программу</h3>
                                                <p>Чтобы пройти эту и другие программы, вступите в Careerum. </p>
                                                    <p>Вы получите доступ к видеоурокам, вебинарам и эфирам по 20+ актуальным карьерным темам.</p> 
                                                    <p>Для вступления оставьте заявку.</p>
                                            </div>
                                            <div class="careerum-registration-form-mobile">
                                                <form class="deva-form getcourse-email-signup" name="devaRegistrationForm" data-gjs-type="deva-registration-form">
                                                    <div>
                                                        <div class="careerum-form-tab-item-4-fields-field-name">
                                                            <input type="text" name="firstname" value="" required placeholder="Имя">
                                                        </div>
                                                        <div class="careerum-form-tab-item-4-fields-field-name">
                                                            <input type="text" name="lastname" value="" required placeholder="Фамилия">
                                                        </div>
                                                        <div class="careerum-form-tab-item-4-fields-field-email">
                                                            <input type="text" name="email" value="" required placeholder="Почта">
                                                        </div>
                                                        <div class="careerum-form-tab-item-4-fields-field-tel">
                                                            <input type="tel" value="" name="tel" required class="itl-input">
                                                        </div>
                                                    </div>
                                                    <div class="careerum-form-tab-item-4-fields-field-agree">
                                                        <input type="checkbox" name="">
                                                        <label data-toggle-checkbox="true">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
                                                                <path d="M1 2.84615L3.14168 6.70118C3.21595 6.83487 3.40669 6.83912 3.48685 6.70887L7 1" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
                                                              </svg>
                                                        </label>
                                                        <p>Я даю согласие на обработку своих персональных данных в соответствии с <a href="#">Политикой конфиденциальности</a></p>
                                                    </div>
                                                    <a href="#" disabled class="submit-btn btn-color-main-bright-orange">Хочу пройти программу</a>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="club21-programs-item-button">
                                    <a href="#buy" class="btn-color-main-dark-orange">Вступить в Careerum</a>
                                </div>
                            </div>
                        </div>
                        <div class="club21-programs-item" data-name="Получить оффер мечты">
                            <div>
                                <div>
                                    <p>4,8 / 5</p>
                                    <p>оценка программы<br> участниками Careerum</p>
                                </div>
                            </div>
                            <div>
                                <div class="club21-programs-item-description">
                                    <p>
                                        Программа «Звездный<br> кандидат»
                                    </p>
                                    <ul>
                                        <li>Научитесь составлять продающие резюме и сопроводительные письма
                                        </li>
                                        <li>Сможете презентовать себя так, чтобы договариваться о своих условиях<br> оффера
                                        </li>
                                        <li>Перестанете откликаться на «все подряд», начали искать вакансии системно</li>
                                        <li>Выработаете менталитет продавца</li>
                                        <li>Поймете, как стать востребованным специалистом</li>
                                    </ul>
                                    <div>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M8.50008 0.978516C12.6531 0.978516 16.0209 4.34559 16.0209 8.49935C16.0209 12.6531 12.6531 16.0202 8.50008 16.0202C4.34633 16.0202 0.979248 12.6531 0.979248 8.49935C0.979248 4.34559 4.34633 0.978516 8.50008 0.978516Z" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M10.8751 8.49616C10.8751 7.85401 7.58375 5.79972 7.21039 6.16909C6.83702 6.53847 6.80112 10.419 7.21039 10.8232C7.61965 11.2288 10.8751 9.1383 10.8751 8.49616Z" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                          </svg>
                                          <p>Видео уроки от 5 до 30 мин</p>
                                    </div>
                                    <div>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                                            <path d="M8.098 1.20898H5.13795C2.70358 1.20898 1.17725 2.93244 1.17725 5.37236V11.9543C1.17725 14.3942 2.69645 16.1177 5.13795 16.1177H12.1236C14.5659 16.1177 16.0851 14.3942 16.0851 11.9543V8.76544" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M5.9885 7.64605L11.9046 1.72992C12.6417 0.993672 13.8363 0.993672 14.5733 1.72992L15.5368 2.69338C16.2738 3.43042 16.2738 4.62584 15.5368 5.36209L9.59217 11.3067C9.26996 11.6289 8.83296 11.8102 8.37696 11.8102H5.41138L5.48579 8.81771C5.49688 8.37755 5.67659 7.95796 5.9885 7.64605Z" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M11.0056 2.64453L14.6204 6.25928" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                          </svg>
                                          <p>Есть домашние задания</p>
                                    </div>
                                    <div>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="17" viewBox="0 0 15 17" fill="none">
                                            <path d="M11.0018 6.48035V4.78064C11.0018 2.79119 9.38838 1.17777 7.39892 1.17777C5.40946 1.16906 3.78971 2.77456 3.78101 4.76481V4.78064V6.48035" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M10.4159 15.8233H4.36675C2.709 15.8233 1.36475 14.4798 1.36475 12.8213V9.42583C1.36475 7.76729 2.709 6.42383 4.36675 6.42383H10.4159C12.0736 6.42383 13.4179 7.76729 13.4179 9.42583V12.8213C13.4179 14.4798 12.0736 15.8233 10.4159 15.8233Z" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M7.39144 10.2441V12.0024" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                          </svg>
                                          <p>Доступно только участникам<br> Careerum</p>
                                    </div>
                                </div>
                                <div class="club21-programs-item-experts">
                                    <p>
                                        Эксперты программы
                                    </p>
                                    <div>
                                        <div>
                                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1691833200721.png" alt="">
                                            <div>
                                                <p><span>Ольга Лермонтова,</span><br> основательница<br> Careerum</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="club21-programs-item-components">
                                    <p>
                                        Что входит в программу
                                    </p>
                                    <div class="club21-programs-components-wrapper">
                                        <div class="club21-programs-components">
                                            <div class="club21-programs-component">
                                                <div>
                                                    <p>Вебинар</p>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="19" viewBox="0 0 9 19" fill="none">
                                                        <circle cx="4.5" cy="9.5" r="2.5" fill="white"/>
                                                      </svg>
                                                    <p>26 мин.</p>
                                                </div>
                                                <p>Менталитет продавца</p>
                                                <p>Поймете, как негативные психологические установки мешают построить карьеру.</p>
                                            </div>
                                            <div class="club21-programs-component">
                                                <div>
                                                    <p>Курс</p>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="19" viewBox="0 0 9 19" fill="none">
                                                        <circle cx="4.5" cy="9.5" r="2.5" fill="white"/>
                                                      </svg>
                                                    <p>2 часа 16 мин.</p>
                                                </div>
                                                <p>Умная стратегия поиска работы</p>
                                                <p>Построите воронку поиска, которая поможет системно двигаться к желаемому офферу.</p>
                                            </div>
                                            <div class="club21-programs-component">
                                                <div>
                                                    <p>Курс</p>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="19" viewBox="0 0 9 19" fill="none">
                                                        <circle cx="4.5" cy="9.5" r="2.5" fill="white"/>
                                                      </svg>
                                                    <p>5 часов 42 мин.</p>
                                                </div>
                                                <p>Продающее резюме</p>
                                                <p>Вы изучите главные принципы составления резюме, научитесь искать и грамотно формулировать свои достижения, опыт работы и образование.</p>
                                            </div>
                                            <div class="club21-programs-component">
                                                <div>
                                                    <p>Вебинар</p>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="19" viewBox="0 0 9 19" fill="none">
                                                        <circle cx="4.5" cy="9.5" r="2.5" fill="white"/>
                                                      </svg>
                                                    <p>51 мин.</p>
                                                </div>
                                                <p>Hooked: цепляющее сопроводительное письмо</p>
                                            </div>
                                            <div class="club21-programs-component">
                                                <div>
                                                    <p>Курс</p>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="19" viewBox="0 0 9 19" fill="none">
                                                        <circle cx="4.5" cy="9.5" r="2.5" fill="white"/>
                                                      </svg>
                                                    <p>2 часа 48 мин.</p>
                                                </div>
                                                <p>Эффективное интервью</p>
                                                <p>Вы научитесь грамотно и без стресса проходить любые собеседования.</p>
                                            </div>
                                            <div class="club21-programs-component">
                                                <div>
                                                    <p>Курс</p>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="19" viewBox="0 0 9 19" fill="none">
                                                        <circle cx="4.5" cy="9.5" r="2.5" fill="white"/>
                                                      </svg>
                                                    <p>2 часа 47 мин.</p>
                                                </div>
                                                <p>Great Deal: получить оффер мечты</p>
                                                <p>Вы научитесь и сразу попрактикуетесь грамотно вести переговоры об оффере.</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="club21-programs-components-arrows">
                                        <div class="club21-programs-components-slider__arrow-left">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 18 16" fill="none">
                                                <path d="M2.19055 7.99935L15.8105 7.99935" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M8.46289 14.2453L2.18956 7.99862L8.46289 1.75195" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                        </div>
                                        <div class="club21-programs-components-slider__arrow-right">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 18 16" fill="none">
                                                <path d="M15.8095 8.00065L2.18945 8.00065" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M9.53711 1.75471L15.8104 8.00138L9.53711 14.248" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                        </div>
    
                                    </div>
                                </div>
                                <div class="careerum-getcourse-email-form-4-fields-mobile">
                                    <div class="careerum-form-tab-item-4-fields-block">
                                        <div>
                                            <div>
                                                <h3>Оставить заявку на программу</h3>
                                                <p>Чтобы пройти эту и другие программы, вступите в Careerum. </p>
                                                    <p>Вы получите доступ к видеоурокам, вебинарам и эфирам по 20+ актуальным карьерным темам.</p> 
                                                    <p>Для вступления оставьте заявку.</p>
                                            </div>
                                            <div class="careerum-registration-form-mobile">
                                                <form class="deva-form getcourse-email-signup" name="devaRegistrationForm" data-gjs-type="deva-registration-form">
                                                    <div>
                                                        <div class="careerum-form-tab-item-4-fields-field-name">
                                                            <input type="text" name="firstname" value="" required placeholder="Имя">
                                                        </div>
                                                        <div class="careerum-form-tab-item-4-fields-field-name">
                                                            <input type="text" name="lastname" value="" required placeholder="Фамилия">
                                                        </div>
                                                        <div class="careerum-form-tab-item-4-fields-field-email">
                                                            <input type="text" name="email" value="" required placeholder="Почта">
                                                        </div>
                                                        <div class="careerum-form-tab-item-4-fields-field-tel">
                                                            <input type="tel" value="" name="tel" required class="itl-input">
                                                        </div>
                                                    </div>
                                                    <div class="careerum-form-tab-item-4-fields-field-agree">
                                                        <input type="checkbox" name="">
                                                        <label data-toggle-checkbox="true">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
                                                                <path d="M1 2.84615L3.14168 6.70118C3.21595 6.83487 3.40669 6.83912 3.48685 6.70887L7 1" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
                                                              </svg>
                                                        </label>
                                                        <p>Я даю согласие на обработку своих персональных данных в соответствии с <a href="#">Политикой конфиденциальности</a></p>
                                                    </div>
                                                    <a href="#" disabled class="submit-btn btn-color-main-bright-orange">Хочу пройти программу</a>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="club21-programs-item-button">
                                    <a href="#buy" class="btn-color-main-dark-orange">Вступить в Careerum</a>
                                </div>
                            </div>
                        </div>
                        <div class="club21-programs-item" data-name="Вырасти в доходе или должности">
                            <div>
                                <div>
                                    <p>4,8 / 5</p>
                                    <p>оценка программы<br> участниками Careerum</p>
                                </div>
                            </div>
                            <div>
                                <div class="club21-programs-item-description">
                                    <p>
                                        Карьерная ракета
                                    </p>
                                    <ul>
                                        <li>Поймете, как расти в зарплате / должности именно вам
                                        </li>
                                        <li>Научитесь ставить карьерные цели и добиваться их
                                        </li>
                                        <li>Узнаете, какие навыки нужны именно вам, именно для ваших задач</li>
                                        <li>Сможете составить долгосрочную карьерную стратегию и понять,<br> как начать ее реализовывать шаг за шагом.</li>
                                    </ul>
                                    <div>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M8.50008 0.978516C12.6531 0.978516 16.0209 4.34559 16.0209 8.49935C16.0209 12.6531 12.6531 16.0202 8.50008 16.0202C4.34633 16.0202 0.979248 12.6531 0.979248 8.49935C0.979248 4.34559 4.34633 0.978516 8.50008 0.978516Z" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M10.8751 8.49616C10.8751 7.85401 7.58375 5.79972 7.21039 6.16909C6.83702 6.53847 6.80112 10.419 7.21039 10.8232C7.61965 11.2288 10.8751 9.1383 10.8751 8.49616Z" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                          </svg>
                                          <p>Видео уроки от 5 до 30 мин</p>
                                    </div>
                                    <div>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                                            <path d="M8.098 1.20898H5.13795C2.70358 1.20898 1.17725 2.93244 1.17725 5.37236V11.9543C1.17725 14.3942 2.69645 16.1177 5.13795 16.1177H12.1236C14.5659 16.1177 16.0851 14.3942 16.0851 11.9543V8.76544" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M5.9885 7.64605L11.9046 1.72992C12.6417 0.993672 13.8363 0.993672 14.5733 1.72992L15.5368 2.69338C16.2738 3.43042 16.2738 4.62584 15.5368 5.36209L9.59217 11.3067C9.26996 11.6289 8.83296 11.8102 8.37696 11.8102H5.41138L5.48579 8.81771C5.49688 8.37755 5.67659 7.95796 5.9885 7.64605Z" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M11.0056 2.64453L14.6204 6.25928" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                          </svg>
                                          <p>Есть домашние задания</p>
                                    </div>
                                    <div>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="17" viewBox="0 0 15 17" fill="none">
                                            <path d="M11.0018 6.48035V4.78064C11.0018 2.79119 9.38838 1.17777 7.39892 1.17777C5.40946 1.16906 3.78971 2.77456 3.78101 4.76481V4.78064V6.48035" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M10.4159 15.8233H4.36675C2.709 15.8233 1.36475 14.4798 1.36475 12.8213V9.42583C1.36475 7.76729 2.709 6.42383 4.36675 6.42383H10.4159C12.0736 6.42383 13.4179 7.76729 13.4179 9.42583V12.8213C13.4179 14.4798 12.0736 15.8233 10.4159 15.8233Z" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M7.39144 10.2441V12.0024" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                          </svg>
                                          <p>Доступно только участникам<br> Careerum</p>
                                    </div>
                                </div>
                                <div class="club21-programs-item-experts">
                                    <p>
                                        Эксперты программы
                                    </p>
                                    <div>
                                        <div>
                                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1691833200721.png" alt="">
                                            <div>
                                                <p><span>Ольга Лермонтова,</span><br> основательница<br> Careerum</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="club21-programs-item-components">
                                    <p>
                                        Что входит в программу
                                    </p>
                                    <div class="club21-programs-components-wrapper">
                                        <div class="club21-programs-components">
                                            <div class="club21-programs-component">
                                                <div>
                                                    <p>Курс</p>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="19" viewBox="0 0 9 19" fill="none">
                                                        <circle cx="4.5" cy="9.5" r="2.5" fill="white"/>
                                                      </svg>
                                                    <p>2 часа 43 мин.</p>
                                                </div>
                                                <p>Карьера как проект</p>
                                                <p>Вы освоите базу карьерного мышления и сможете осознанно спланировать своё долгосрочное карьерное развитие.</p>
                                            </div>
                                            <div class="club21-programs-component">
                                                <div>
                                                    <p>Курс</p>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="19" viewBox="0 0 9 19" fill="none">
                                                        <circle cx="4.5" cy="9.5" r="2.5" fill="white"/>
                                                      </svg>
                                                    <p>1 час 10 мин.</p>
                                                </div>
                                                <p>Цели как в Google. Результаты как в Forbes</p>
                                                <p>Вы научитесь планировать свои задачи и узнаете, как сделать руководителя и коллег своими союзниками в достижении целей.</p>
                                            </div>
                                            <div class="club21-programs-component">
                                                <div>
                                                    <p>Курс</p>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="19" viewBox="0 0 9 19" fill="none">
                                                        <circle cx="4.5" cy="9.5" r="2.5" fill="white"/>
                                                      </svg>
                                                    <p>1 час 10 мин.</p>
                                                </div>
                                                <p>Пробей зарплатный потолок</p>
                                                <p>Вы узнаете, как запрограммировать свое повышение и системно расти в должности и зарплате.</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="club21-programs-components-arrows">
                                        <div class="club21-programs-components-slider__arrow-left">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 18 16" fill="none">
                                                <path d="M2.19055 7.99935L15.8105 7.99935" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M8.46289 14.2453L2.18956 7.99862L8.46289 1.75195" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                        </div>
                                        <div class="club21-programs-components-slider__arrow-right">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 18 16" fill="none">
                                                <path d="M15.8095 8.00065L2.18945 8.00065" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M9.53711 1.75471L15.8104 8.00138L9.53711 14.248" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                        </div>
    
                                    </div>
                                </div>
                                <div class="careerum-getcourse-email-form-4-fields-mobile">
                                    <div class="careerum-form-tab-item-4-fields-block">
                                        <div>
                                            <div>
                                                <h3>Оставить заявку на программу</h3>
                                                <p>Эта программа дсотупна для всех участнкиов Careerum.</p>
                                                <p>Оставьте свои данные, чтобы получить приглашение оформить подписку.</p>
                                            </div>
                                            <div class="careerum-registration-form-mobile">
                                                <form class="deva-form getcourse-email-signup" name="devaRegistrationForm" data-gjs-type="deva-registration-form">
                                                    <div>
                                                        <div class="careerum-form-tab-item-4-fields-field-name">
                                                            <input type="text" name="firstname" value="" required placeholder="Имя">
                                                        </div>
                                                        <div class="careerum-form-tab-item-4-fields-field-name">
                                                            <input type="text" name="lastname" value="" required placeholder="Фамилия">
                                                        </div>
                                                        <div class="careerum-form-tab-item-4-fields-field-email">
                                                            <input type="text" name="email" value="" required placeholder="Почта">
                                                        </div>
                                                        <div class="careerum-form-tab-item-4-fields-field-tel">
                                                            <input type="tel" value="" name="tel" required class="itl-input">
                                                        </div>
                                                    </div>
                                                    <div class="careerum-form-tab-item-4-fields-field-agree">
                                                        <input type="checkbox" name="">
                                                        <label data-toggle-checkbox="true">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
                                                                <path d="M1 2.84615L3.14168 6.70118C3.21595 6.83487 3.40669 6.83912 3.48685 6.70887L7 1" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
                                                              </svg>
                                                        </label>
                                                        <p>Я даю согласие на обработку своих персональных данных в соответствии с <a href="#">Политикой конфиденциальности</a></p>
                                                    </div>
                                                    <a href="#" disabled class="submit-btn btn-color-main-bright-orange">Хочу пройти программу</a>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="club21-programs-item-button">
                                    <a href="#buy" class="btn-color-main-dark-orange">Вступить в Careerum</a>
                                </div>
                            </div>
                        </div>
                        <div class="club21-programs-item" data-name="Переехать по работе">
                            <div>
                                <div>
                                    <p>4,8 / 5</p>
                                    <p>оценка программы<br> участниками Careerum</p>
                                </div>
                            </div>
                            <div>
                                <div class="club21-programs-item-description">
                                    <p>
                                        Международная карьера<br> и релокация
                                    </p>
                                    <ul>
                                        <li>Поймете, как устроен процесс найма за рубежом
                                        </li>
                                        <li>Узнаите, где искать вакансии иностранных компаний
                                        </li>
                                        <li>Овладеете навыками ведения переговоров с зарубежными рекрутерами
                                        </li>
                                        <li>Выработаете менталитет продавца</li>
                                        <li>Сумеете адаптироваться к незнакомой культурной среде</li>
                                    </ul>
                                    <div>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M8.50008 0.978516C12.6531 0.978516 16.0209 4.34559 16.0209 8.49935C16.0209 12.6531 12.6531 16.0202 8.50008 16.0202C4.34633 16.0202 0.979248 12.6531 0.979248 8.49935C0.979248 4.34559 4.34633 0.978516 8.50008 0.978516Z" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M10.8751 8.49616C10.8751 7.85401 7.58375 5.79972 7.21039 6.16909C6.83702 6.53847 6.80112 10.419 7.21039 10.8232C7.61965 11.2288 10.8751 9.1383 10.8751 8.49616Z" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                          </svg>
                                          <p>Видео уроки от 5 до 30 мин</p>
                                    </div>
                                    <div>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                                            <path d="M8.098 1.20898H5.13795C2.70358 1.20898 1.17725 2.93244 1.17725 5.37236V11.9543C1.17725 14.3942 2.69645 16.1177 5.13795 16.1177H12.1236C14.5659 16.1177 16.0851 14.3942 16.0851 11.9543V8.76544" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M5.9885 7.64605L11.9046 1.72992C12.6417 0.993672 13.8363 0.993672 14.5733 1.72992L15.5368 2.69338C16.2738 3.43042 16.2738 4.62584 15.5368 5.36209L9.59217 11.3067C9.26996 11.6289 8.83296 11.8102 8.37696 11.8102H5.41138L5.48579 8.81771C5.49688 8.37755 5.67659 7.95796 5.9885 7.64605Z" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M11.0056 2.64453L14.6204 6.25928" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                          </svg>
                                          <p>Есть домашние задания</p>
                                    </div>
                                    <div>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="17" viewBox="0 0 15 17" fill="none">
                                            <path d="M11.0018 6.48035V4.78064C11.0018 2.79119 9.38838 1.17777 7.39892 1.17777C5.40946 1.16906 3.78971 2.77456 3.78101 4.76481V4.78064V6.48035" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M10.4159 15.8233H4.36675C2.709 15.8233 1.36475 14.4798 1.36475 12.8213V9.42583C1.36475 7.76729 2.709 6.42383 4.36675 6.42383H10.4159C12.0736 6.42383 13.4179 7.76729 13.4179 9.42583V12.8213C13.4179 14.4798 12.0736 15.8233 10.4159 15.8233Z" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M7.39144 10.2441V12.0024" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                          </svg>
                                          <p>Программу можно<br> купить отдельно</p>
                                    </div>
                                </div>
                                <div class="club21-programs-item-experts">
                                    <p>
                                        Эксперты программы
                                    </p>
                                    <div>
                                        <div>
                                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1691833200721.png" alt="">
                                            <div>
                                                <p><span>Ольга Лермонтова,</span><br> основательница<br> Careerum</p>
                                            </div>
                                        </div>
                                        <div>
                                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1691833224105.png" alt="">
                                            <div>
                                                <p><span>Montse Lorente,</span><br> международный<br> карьерный<br> консультант</p>
                                            </div>
                                        </div>
                                        <div>
                                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1691833243676.png" alt="">
                                            <div>
                                                <p><span>Sophie Vurpillot,</span><br>международный<br> рекрутер и коуч,<br> 10+ лет опыта</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="club21-programs-item-components">
                                    <p>
                                        Что входит в программу
                                    </p>
                                    <div class="club21-programs-components-wrapper">
                                        <div class="club21-programs-components">
                                            <div class="club21-programs-component">
                                                <div>
                                                    <p>Курс</p>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="19" viewBox="0 0 9 19" fill="none">
                                                        <circle cx="4.5" cy="9.5" r="2.5" fill="white"/>
                                                      </svg>
                                                    <p>1 час 34 мин.</p>
                                                </div>
                                                <p>Работа без границ</p>
                                                <p>Вы изучите алгоритм поиска работы за границей, построите свою стратегию для получения оффера в новой географии.</p>
                                            </div>
                                            <div class="club21-programs-component">
                                                <div>
                                                    <p>Курс</p>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="19" viewBox="0 0 9 19" fill="none">
                                                        <circle cx="4.5" cy="9.5" r="2.5" fill="white"/>
                                                      </svg>
                                                    <p>1 час 10 мин.</p>
                                                </div>
                                                <p>Your Dream job, Abroad</p>
                                                <p>You will learn how to find a job in the global market, gaining practical recommendations on building your action plan.</p>
                                            </div>
                                            <div class="club21-programs-component">
                                                <div>
                                                    <p>Курс</p>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="19" viewBox="0 0 9 19" fill="none">
                                                        <circle cx="4.5" cy="9.5" r="2.5" fill="white"/>
                                                      </svg>
                                                    <p>6 часов 30 мин.</p>
                                                </div>
                                                <p>LinkedIn для развития карьеры</p>
                                                
                                            </div>
                                            <div class="club21-programs-component">
                                                <div>
                                                    <p>Вебинар</p>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="19" viewBox="0 0 9 19" fill="none">
                                                        <circle cx="4.5" cy="9.5" r="2.5" fill="white"/>
                                                      </svg>
                                                    <p>1 час 37 мин.</p>
                                                </div>
                                                <p>The other side: recruiter’s view on the job search</p>
                                            </div>
                                            <div class="club21-programs-component">
                                                <div>
                                                    <p>Вебинар</p>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="19" viewBox="0 0 9 19" fill="none">
                                                        <circle cx="4.5" cy="9.5" r="2.5" fill="white"/>
                                                      </svg>
                                                    <p>1 час 31 мин.</p>
                                                </div>
                                                <p>Communication with English-speaking colleagues</p>
                                            </div>
                                            <div class="club21-programs-component">
                                                <div>
                                                    <p>Курс</p>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="19" viewBox="0 0 9 19" fill="none">
                                                        <circle cx="4.5" cy="9.5" r="2.5" fill="white"/>
                                                      </svg>
                                                    <p>2 часа 47 мин.</p>
                                                </div>
                                                <p>Language of a Job Interview</p>
                                            </div>
                                            <div class="club21-programs-component">
                                                <div>
                                                    <p>Курс</p>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="19" viewBox="0 0 9 19" fill="none">
                                                        <circle cx="4.5" cy="9.5" r="2.5" fill="white"/>
                                                      </svg>
                                                    <p>1 час 18 мин.</p>
                                                </div>
                                                <p>Professional and cultural adaptation in Corporate America</p>
                                            </div>
                                            <div class="club21-programs-component">
                                                <div>
                                                    <p>Курс</p>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="19" viewBox="0 0 9 19" fill="none">
                                                        <circle cx="4.5" cy="9.5" r="2.5" fill="white"/>
                                                      </svg>
                                                    <p>1 час 37 мин.</p>
                                                </div>
                                                <p>Пути профессиональной иммиграции в США и навигация по американскому рынку труда</p>
                                            </div>
                                            <div class="club21-programs-component">
                                                <div>
                                                    <p>Курс</p>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="19" viewBox="0 0 9 19" fill="none">
                                                        <circle cx="4.5" cy="9.5" r="2.5" fill="white"/>
                                                      </svg>
                                                    <p>1 час 5 мин.</p>
                                                </div>
                                                <p>Межкультурная адаптация и коммуникация</p>
                                            </div>
                                            <div class="club21-programs-component">
                                                <div>
                                                    <p>Курс</p>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="19" viewBox="0 0 9 19" fill="none">
                                                        <circle cx="4.5" cy="9.5" r="2.5" fill="white"/>
                                                      </svg>
                                                    <p>2 часа 9 мин.</p>
                                                </div>
                                                <p>Intercultural Communications</p>
                                                <p>This course is about cross-cultural communication and team communication in English, particularly when relocating.</p>
                                            </div>
                                            <div class="club21-programs-component">
                                                <div>
                                                    <p>Вебинар</p>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="19" viewBox="0 0 9 19" fill="none">
                                                        <circle cx="4.5" cy="9.5" r="2.5" fill="white"/>
                                                      </svg>
                                                    <p>2 часа 21 мин.</p>
                                                </div>
                                                <p>Как попасть в Google: секреты и подводные камни</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="club21-programs-components-arrows">
                                        <div class="club21-programs-components-slider__arrow-left">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 18 16" fill="none">
                                                <path d="M2.19055 7.99935L15.8105 7.99935" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M8.46289 14.2453L2.18956 7.99862L8.46289 1.75195" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                        </div>
                                        <div class="club21-programs-components-slider__arrow-right">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 18 16" fill="none">
                                                <path d="M15.8095 8.00065L2.18945 8.00065" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M9.53711 1.75471L15.8104 8.00138L9.53711 14.248" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                        </div>
    
                                    </div>
                                </div>
                                <div class="careerum-getcourse-email-form-4-fields-mobile">
                                    <div class="careerum-form-tab-item-4-fields-block">
                                        <div>
                                            <div>
                                                <h3>Оставить заявку на программу</h3>
                                                <p>Эта программа дсотупна для всех участнкиов Careerum.</p>
                                                <p>Оставьте свои данные, чтобы получить приглашение оформить подписку.</p>
                                            </div>
                                            <div class="careerum-registration-form-mobile">
                                                <form class="deva-form getcourse-email-signup" name="devaRegistrationForm" data-gjs-type="deva-registration-form">
                                                    <div>
                                                        <div class="careerum-form-tab-item-4-fields-field-name">
                                                            <input type="text" name="firstname" value="" required placeholder="Имя">
                                                        </div>
                                                        <div class="careerum-form-tab-item-4-fields-field-name">
                                                            <input type="text" name="lastname" value="" required placeholder="Фамилия">
                                                        </div>
                                                        <div class="careerum-form-tab-item-4-fields-field-email">
                                                            <input type="text" name="email" value="" required placeholder="Почта">
                                                        </div>
                                                        <div class="careerum-form-tab-item-4-fields-field-tel">
                                                            <input type="tel" value="" name="tel" required class="itl-input">
                                                        </div>
                                                    </div>
                                                    <div class="careerum-form-tab-item-4-fields-field-agree">
                                                        <input type="checkbox" name="">
                                                        <label data-toggle-checkbox="true">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
                                                                <path d="M1 2.84615L3.14168 6.70118C3.21595 6.83487 3.40669 6.83912 3.48685 6.70887L7 1" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
                                                              </svg>
                                                        </label>
                                                        <p>Я даю согласие на обработку своих персональных данных в соответствии с <a href="#">Политикой конфиденциальности</a></p>
                                                    </div>
                                                    <a href="#" disabled class="submit-btn btn-color-main-bright-orange">Хочу пройти программу</a>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="club21-programs-item-button">
                                    <a href="#buy" class="btn-color-main-dark-orange">Вступить в Careerum</a>
                                </div>
                            </div>
                        </div>
                        <div class="club21-programs-item" data-name="Пройти испытательный срок">
                            <div>
                                <div>
                                    <p>4,8 / 5</p>
                                    <p>оценка программы<br> участниками Careerum</p>
                                </div>
                            </div>
                            <div>
                                <div class="club21-programs-item-description">
                                    <p>
                                        Жизнь после оффера
                                    </p>
                                    <ul>
                                        <li>Поймете, как сразу взять успешный страт на новом месте
                                        </li>
                                        <li>Разберете пошагово свою первую неделю и дальнейшую стратегию
                                        </li>
                                        <li>Узнаете, как быть на хорошем счету у руководства и коллег</li>
                                    </ul>
                                    <div>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M8.50008 0.978516C12.6531 0.978516 16.0209 4.34559 16.0209 8.49935C16.0209 12.6531 12.6531 16.0202 8.50008 16.0202C4.34633 16.0202 0.979248 12.6531 0.979248 8.49935C0.979248 4.34559 4.34633 0.978516 8.50008 0.978516Z" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M10.8751 8.49616C10.8751 7.85401 7.58375 5.79972 7.21039 6.16909C6.83702 6.53847 6.80112 10.419 7.21039 10.8232C7.61965 11.2288 10.8751 9.1383 10.8751 8.49616Z" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                          </svg>
                                          <p>Видео уроки от 5 до 30 мин</p>
                                    </div>
                                    <div>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                                            <path d="M8.098 1.20898H5.13795C2.70358 1.20898 1.17725 2.93244 1.17725 5.37236V11.9543C1.17725 14.3942 2.69645 16.1177 5.13795 16.1177H12.1236C14.5659 16.1177 16.0851 14.3942 16.0851 11.9543V8.76544" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M5.9885 7.64605L11.9046 1.72992C12.6417 0.993672 13.8363 0.993672 14.5733 1.72992L15.5368 2.69338C16.2738 3.43042 16.2738 4.62584 15.5368 5.36209L9.59217 11.3067C9.26996 11.6289 8.83296 11.8102 8.37696 11.8102H5.41138L5.48579 8.81771C5.49688 8.37755 5.67659 7.95796 5.9885 7.64605Z" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M11.0056 2.64453L14.6204 6.25928" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                          </svg>
                                          <p>Есть домашние задания</p>
                                    </div>
                                    <div>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="17" viewBox="0 0 15 17" fill="none">
                                            <path d="M11.0018 6.48035V4.78064C11.0018 2.79119 9.38838 1.17777 7.39892 1.17777C5.40946 1.16906 3.78971 2.77456 3.78101 4.76481V4.78064V6.48035" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M10.4159 15.8233H4.36675C2.709 15.8233 1.36475 14.4798 1.36475 12.8213V9.42583C1.36475 7.76729 2.709 6.42383 4.36675 6.42383H10.4159C12.0736 6.42383 13.4179 7.76729 13.4179 9.42583V12.8213C13.4179 14.4798 12.0736 15.8233 10.4159 15.8233Z" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M7.39144 10.2441V12.0024" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                          </svg>
                                          <p>Доступно только участникам<br> Careerum</p>
                                    </div>
                                </div>
                                <div class="club21-programs-item-experts">
                                    <p>
                                        Эксперты программы
                                    </p>
                                    <div>
                                        <div>
                                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1691833200721.png" alt="">
                                            <div>
                                                <p><span>Ольга<br> Лермонтова,</span><br> основательница<br> Careerum</p>
                                            </div>
                                        </div>
                                        <div>
                                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1691833262781.png" alt="">
                                            <div>
                                                <p><span>Мария Батти,</span><br> карьерный стратег</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="club21-programs-item-components">
                                    <p>
                                        Что входит в программу
                                    </p>
                                    <div class="club21-programs-components-wrapper">
                                        <div class="club21-programs-components">
                                            <div class="club21-programs-component">
                                                <div>
                                                    <p>Курс</p>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="19" viewBox="0 0 9 19" fill="none">
                                                        <circle cx="4.5" cy="9.5" r="2.5" fill="white"/>
                                                      </svg>
                                                    <p>6 часов 44 мин.</p>
                                                </div>
                                                <p>Первые месяцы на новой работе</p>
                                                <p>Вы получите и научитесь применять инструменты, которые помогут взять успешный старт в новой компании.</p>
                                            </div>
                                            <div class="club21-programs-component">
                                                <div>
                                                    <p>Курс</p>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="19" viewBox="0 0 9 19" fill="none">
                                                        <circle cx="4.5" cy="9.5" r="2.5" fill="white"/>
                                                      </svg>
                                                    <p>1 часа 24 мин.</p>
                                                </div>
                                                <p>Как грамотно выстраивать общение на работе</p>
                                                <p>Вы научитесь строить конструктивные отношения с руководителем и коллегами.</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="club21-programs-components-arrows">
                                        <div class="club21-programs-components-slider__arrow-left">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 18 16" fill="none">
                                                <path d="M2.19055 7.99935L15.8105 7.99935" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M8.46289 14.2453L2.18956 7.99862L8.46289 1.75195" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                        </div>
                                        <div class="club21-programs-components-slider__arrow-right">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 18 16" fill="none">
                                                <path d="M15.8095 8.00065L2.18945 8.00065" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M9.53711 1.75471L15.8104 8.00138L9.53711 14.248" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                        </div>
    
                                    </div>
                                </div>
                                <div class="careerum-getcourse-email-form-4-fields-mobile">
                                    <div class="careerum-form-tab-item-4-fields-block">
                                        <div>
                                            <div>
                                                <h3>Оставить заявку на программу</h3>
                                                <p>Эта программа дсотупна для всех участнкиов Careerum.</p>
                                                <p>Оставьте свои данные, чтобы получить приглашение оформить подписку.</p>
                                            </div>
                                            <div class="careerum-registration-form-mobile">
                                                <form class="deva-form getcourse-email-signup" name="devaRegistrationForm" data-gjs-type="deva-registration-form">
                                                    <div>
                                                        <div class="careerum-form-tab-item-4-fields-field-name">
                                                            <input type="text" name="firstname" value="" required placeholder="Имя">
                                                        </div>
                                                        <div class="careerum-form-tab-item-4-fields-field-name">
                                                            <input type="text" name="lastname" value="" required placeholder="Фамилия">
                                                        </div>
                                                        <div class="careerum-form-tab-item-4-fields-field-email">
                                                            <input type="text" name="email" value="" required placeholder="Почта">
                                                        </div>
                                                        <div class="careerum-form-tab-item-4-fields-field-tel">
                                                            <input type="tel" value="" name="tel" required class="itl-input">
                                                        </div>
                                                    </div>
                                                    <div class="careerum-form-tab-item-4-fields-field-agree">
                                                        <input type="checkbox" name="">
                                                        <label data-toggle-checkbox="true">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
                                                                <path d="M1 2.84615L3.14168 6.70118C3.21595 6.83487 3.40669 6.83912 3.48685 6.70887L7 1" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
                                                              </svg>
                                                        </label>
                                                        <p>Я даю согласие на обработку своих персональных данных в соответствии с <a href="#">Политикой конфиденциальности</a></p>
                                                    </div>
                                                    <a href="#" disabled class="submit-btn btn-color-main-bright-orange">Хочу пройти программу</a>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="club21-programs-item-button">
                                    <a href="#buy" class="btn-color-main-dark-orange">Вступить в Careerum</a>
                                </div>
                            </div>
                        </div>
                        <div class="club21-programs-item" data-name="Расти в кризис">
                            <div>
                                <div>
                                    <p>4,8 / 5</p>
                                    <p>оценка программы<br> участниками Careerum</p>
                                </div>
                            </div>
                            <div>
                                <div class="club21-programs-item-description">
                                    <p>
                                        Антикризис
                                    </p>
                                    <ul>
                                        <li>Узнаете, как расти в должности / получать офферы вопреки кризисам
                                        </li>
                                        <li>Научитесь адаптировать свои навыки к меняющимся реалиям рынка
                                        </li>
                                        <li>Сформируете мышление, которое позволит принимать взвешенные решения</li>
                                    </ul>
                                    <div>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M8.50008 0.978516C12.6531 0.978516 16.0209 4.34559 16.0209 8.49935C16.0209 12.6531 12.6531 16.0202 8.50008 16.0202C4.34633 16.0202 0.979248 12.6531 0.979248 8.49935C0.979248 4.34559 4.34633 0.978516 8.50008 0.978516Z" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M10.8751 8.49616C10.8751 7.85401 7.58375 5.79972 7.21039 6.16909C6.83702 6.53847 6.80112 10.419 7.21039 10.8232C7.61965 11.2288 10.8751 9.1383 10.8751 8.49616Z" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                          </svg>
                                          <p>Видео уроки от 5 до 30 мин</p>
                                    </div>
                                    <div>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                                            <path d="M8.098 1.20898H5.13795C2.70358 1.20898 1.17725 2.93244 1.17725 5.37236V11.9543C1.17725 14.3942 2.69645 16.1177 5.13795 16.1177H12.1236C14.5659 16.1177 16.0851 14.3942 16.0851 11.9543V8.76544" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M5.9885 7.64605L11.9046 1.72992C12.6417 0.993672 13.8363 0.993672 14.5733 1.72992L15.5368 2.69338C16.2738 3.43042 16.2738 4.62584 15.5368 5.36209L9.59217 11.3067C9.26996 11.6289 8.83296 11.8102 8.37696 11.8102H5.41138L5.48579 8.81771C5.49688 8.37755 5.67659 7.95796 5.9885 7.64605Z" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M11.0056 2.64453L14.6204 6.25928" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                          </svg>
                                          <p>Есть домашние задания</p>
                                    </div>
                                    <div>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="17" viewBox="0 0 15 17" fill="none">
                                            <path d="M11.0018 6.48035V4.78064C11.0018 2.79119 9.38838 1.17777 7.39892 1.17777C5.40946 1.16906 3.78971 2.77456 3.78101 4.76481V4.78064V6.48035" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M10.4159 15.8233H4.36675C2.709 15.8233 1.36475 14.4798 1.36475 12.8213V9.42583C1.36475 7.76729 2.709 6.42383 4.36675 6.42383H10.4159C12.0736 6.42383 13.4179 7.76729 13.4179 9.42583V12.8213C13.4179 14.4798 12.0736 15.8233 10.4159 15.8233Z" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M7.39144 10.2441V12.0024" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                          </svg>
                                          <p>Доступно только участникам<br> Careerum</p>
                                    </div>
                                </div>
                                <div class="club21-programs-item-experts">
                                    <p>
                                        Эксперты программы
                                    </p>
                                    <div>
                                        <div>
                                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1691833200721.png" alt="">
                                            <div>
                                                <p><span>Ольга Лермонтова,</span><br> основательница<br> Careerum</p>
                                            </div>
                                        </div>
                                        <div>
                                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1691833281537.png" alt="">
                                            <div>
                                                <p><span>Елена Федорова,</span><br> юрист с 15-летним<br> опытом</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="club21-programs-item-components">
                                    <p>
                                        Что входит в программу
                                    </p>
                                    <div class="club21-programs-components-wrapper">
                                        <div class="club21-programs-components">
                                            <div class="club21-programs-component">
                                                <div>
                                                    <p>Курс</p>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="19" viewBox="0 0 9 19" fill="none">
                                                        <circle cx="4.5" cy="9.5" r="2.5" fill="white"/>
                                                      </svg>
                                                    <p>4 часов 39 мин.</p>
                                                </div>
                                                <p>Карьера в кризис: как найти и не потерять работу</p>
                                                <p>Этот курс — база антикризисного мышления. С ним вы научитесь извлекать силу из кризисов.</p>
                                            </div>
                                            <div class="club21-programs-component">
                                                <div>
                                                    <p>Курс</p>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="19" viewBox="0 0 9 19" fill="none">
                                                        <circle cx="4.5" cy="9.5" r="2.5" fill="white"/>
                                                      </svg>
                                                    <p>1 час 15 мин.</p>
                                                </div>
                                                <p>Как продолжать идти к своим целям в режиме турбулентности</p>
                                                <p>Вы узнаете, как выйти из режима «выживание» и начать жить.</p>
                                            </div>
                                            <div class="club21-programs-component">
                                                <div>
                                                    <p>Курс</p>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="19" viewBox="0 0 9 19" fill="none">
                                                        <circle cx="4.5" cy="9.5" r="2.5" fill="white"/>
                                                      </svg>
                                                    <p>1 час 7 мин.</p>
                                                </div>
                                                <p>Как себя вести в условиях кризиса</p>
                                                <p>Как защититься от манипуляций работодателя и на что обратить внимание при устройстве на работу.</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="club21-programs-components-arrows">
                                        <div class="club21-programs-components-slider__arrow-left">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 18 16" fill="none">
                                                <path d="M2.19055 7.99935L15.8105 7.99935" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M8.46289 14.2453L2.18956 7.99862L8.46289 1.75195" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                        </div>
                                        <div class="club21-programs-components-slider__arrow-right">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 18 16" fill="none">
                                                <path d="M15.8095 8.00065L2.18945 8.00065" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M9.53711 1.75471L15.8104 8.00138L9.53711 14.248" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                        </div>
    
                                    </div>
                                </div>
                                <div class="careerum-getcourse-email-form-4-fields-mobile">
                                    <div class="careerum-form-tab-item-4-fields-block">
                                        <div>
                                            <div>
                                                <h3>Оставить заявку на программу</h3>
                                                <p>Эта программа дсотупна для всех участнкиов Careerum.</p>
                                                <p>Оставьте свои данные, чтобы получить приглашение оформить подписку.</p>
                                            </div>
                                            <div class="careerum-registration-form-mobile">
                                                <form class="deva-form getcourse-email-signup" name="devaRegistrationForm" data-gjs-type="deva-registration-form">
                                                    <div>
                                                        <div class="careerum-form-tab-item-4-fields-field-name">
                                                            <input type="text" name="firstname" value="" required placeholder="Имя">
                                                        </div>
                                                        <div class="careerum-form-tab-item-4-fields-field-name">
                                                            <input type="text" name="lastname" value="" required placeholder="Фамилия">
                                                        </div>
                                                        <div class="careerum-form-tab-item-4-fields-field-email">
                                                            <input type="text" name="email" value="" required placeholder="Почта">
                                                        </div>
                                                        <div class="careerum-form-tab-item-4-fields-field-tel">
                                                            <input type="tel" value="" name="tel" required class="itl-input">
                                                        </div>
                                                    </div>
                                                    <div class="careerum-form-tab-item-4-fields-field-agree">
                                                        <input type="checkbox" name="">
                                                        <label data-toggle-checkbox="true">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
                                                                <path d="M1 2.84615L3.14168 6.70118C3.21595 6.83487 3.40669 6.83912 3.48685 6.70887L7 1" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
                                                              </svg>
                                                        </label>
                                                        <p>Я даю согласие на обработку своих персональных данных в соответствии с <a href="#">Политикой конфиденциальности</a></p>
                                                    </div>
                                                    <a href="#" disabled class="submit-btn btn-color-main-bright-orange">Хочу пройти программу</a>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="club21-programs-item-button">
                                    <a href="#buy" class="btn-color-main-dark-orange">Вступить в Careerum</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
	});
    
    blockManager.add('careerum-club21-authors', {
        label: 'Клуб 2.1 авторы',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-club21-authors">
            <div>
                <div>
                    <h2>Авторы программ и курсов — эксперты Careerum</h2>
                </div>
                <div class="club21-authors-wrapper">
                    <div class="club21-authors">
                        <div class="club21-author">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1691833456575.png" alt="">
                            <p class="club21-author-name">Ольга Лермонтова</p>
                            <div class="club21-author-country">
                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="18" viewBox="0 0 14 18" fill="none">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.08341 7.74977C9.08341 6.59871 8.15072 5.66602 7.0005 5.66602C5.84944 5.66602 4.91675 6.59871 4.91675 7.74977C4.91675 8.89999 5.84944 9.83268 7.0005 9.83268C8.15072 9.83268 9.08341 8.89999 9.08341 7.74977Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.99959 16.5C6.00086 16.5 0.75 12.2486 0.75 7.80274C0.75 4.3222 3.54758 1.5 6.99959 1.5C10.4516 1.5 13.25 4.3222 13.25 7.80274C13.25 12.2486 7.99832 16.5 6.99959 16.5Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                                <p>Италия</p>
                            </div>
                            <p class="club21-author-about">Занимала руководящие роли в Google и Microsoft. Получила MBA в сингапурской бизнес-школе INSEAD и основала Careerum — крупнейшую в России и СНГ платформу карьерного развития.</p>
                            <div class="club21-author-achievements">
                                <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                                    <path d="M9.49224 0.789062H5.75324C2.67824 0.789062 0.750244 2.96606 0.750244 6.04806V14.3621C0.750244 17.4441 2.66924 19.6211 5.75324 19.6211H14.5772C17.6622 19.6211 19.5812 17.4441 19.5812 14.3621V10.3341" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.82763 8.9205L14.3006 1.4475C15.2316 0.5175 16.7406 0.5175 17.6716 1.4475L18.8886 2.6645C19.8196 3.5955 19.8196 5.1055 18.8886 6.0355L11.3796 13.5445C10.9726 13.9515 10.4206 14.1805 9.84463 14.1805H6.09863L6.19263 10.4005C6.20663 9.8445 6.43363 9.3145 6.82763 8.9205Z" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M13.165 2.60156L17.731 7.16756" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                  </svg>
                                  <p>
                                    <span>Автор программ и курсов:</span> «Real Me: как найти себя в работе и жизни»; «Карьера в кризис»; «Цели как в Google. Результаты как в Forbes» и др.
                                  </p>
                            </div>
                        </div>
                        <div class="club21-author">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1691833487598.png" alt="">
                            <p class="club21-author-name">Санжар Ибрагимов</p>
                            <div class="club21-author-country">
                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="18" viewBox="0 0 14 18" fill="none">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.08341 7.74977C9.08341 6.59871 8.15072 5.66602 7.0005 5.66602C5.84944 5.66602 4.91675 6.59871 4.91675 7.74977C4.91675 8.89999 5.84944 9.83268 7.0005 9.83268C8.15072 9.83268 9.08341 8.89999 9.08341 7.74977Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.99959 16.5C6.00086 16.5 0.75 12.2486 0.75 7.80274C0.75 4.3222 3.54758 1.5 6.99959 1.5C10.4516 1.5 13.25 4.3222 13.25 7.80274C13.25 12.2486 7.99832 16.5 6.99959 16.5Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                  </svg>
                                  <p>Финляндия</p>
                                </div>
                            <p class="club21-author-about">Работал в консалтинге в 5 странах — McKinsey & Company, PwC, World Bank Group. Получил MBA в швейцарской бизнес-школе IMD. Ментор в IMD International и Aalto Business School.</p>
                            <div class="club21-author-achievements">
                                <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                                    <path d="M9.49224 0.789062H5.75324C2.67824 0.789062 0.750244 2.96606 0.750244 6.04806V14.3621C0.750244 17.4441 2.66924 19.6211 5.75324 19.6211H14.5772C17.6622 19.6211 19.5812 17.4441 19.5812 14.3621V10.3341" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.82763 8.9205L14.3006 1.4475C15.2316 0.5175 16.7406 0.5175 17.6716 1.4475L18.8886 2.6645C19.8196 3.5955 19.8196 5.1055 18.8886 6.0355L11.3796 13.5445C10.9726 13.9515 10.4206 14.1805 9.84463 14.1805H6.09863L6.19263 10.4005C6.20663 9.8445 6.43363 9.3145 6.82763 8.9205Z" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M13.165 2.60156L17.731 7.16756" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                  </svg>
                                  <p>
                                    <span>Автор программ и курсов:</span> «Высокий старт: как попасть в консалтинг»; «Dream Team: как вывести командную работу на новый уровень»
                                  </p>
                            </div>
                        </div>
                        <div class="club21-author">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1691833490717.png" alt="">
                            <p class="club21-author-name">Ольга Сильверман</p>
                            <div class="club21-author-country">
                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="18" viewBox="0 0 14 18" fill="none">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.08341 7.74977C9.08341 6.59871 8.15072 5.66602 7.0005 5.66602C5.84944 5.66602 4.91675 6.59871 4.91675 7.74977C4.91675 8.89999 5.84944 9.83268 7.0005 9.83268C8.15072 9.83268 9.08341 8.89999 9.08341 7.74977Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.99959 16.5C6.00086 16.5 0.75 12.2486 0.75 7.80274C0.75 4.3222 3.54758 1.5 6.99959 1.5C10.4516 1.5 13.25 4.3222 13.25 7.80274C13.25 12.2486 7.99832 16.5 6.99959 16.5Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                  </svg>
                                  <p>Великобритания</p>
                                </div>
                            <p class="club21-author-about">Карьерный консультант с 20-летним опытом. Основательница агентства по сопровождению бизнеса в LinkedIn, которое помогло уже 400 бизнесам в 30 странах.</p>
                            <div class="club21-author-achievements">
                                <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                                    <path d="M9.49224 0.789062H5.75324C2.67824 0.789062 0.750244 2.96606 0.750244 6.04806V14.3621C0.750244 17.4441 2.66924 19.6211 5.75324 19.6211H14.5772C17.6622 19.6211 19.5812 17.4441 19.5812 14.3621V10.3341" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.82763 8.9205L14.3006 1.4475C15.2316 0.5175 16.7406 0.5175 17.6716 1.4475L18.8886 2.6645C19.8196 3.5955 19.8196 5.1055 18.8886 6.0355L11.3796 13.5445C10.9726 13.9515 10.4206 14.1805 9.84463 14.1805H6.09863L6.19263 10.4005C6.20663 9.8445 6.43363 9.3145 6.82763 8.9205Z" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M13.165 2.60156L17.731 7.16756" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                  </svg>
                                  <p>
                                    <span>Автор курса:</span> «LinkedIn для развития карьеры: выжми из него максимум»
                                  </p>
                            </div>
                        </div>
                        <div class="club21-author">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1691833494757.png" alt="">
                            <p class="club21-author-name">Наталья Токарь</p>
                            <div class="club21-author-country">
                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="18" viewBox="0 0 14 18" fill="none">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.08341 7.74977C9.08341 6.59871 8.15072 5.66602 7.0005 5.66602C5.84944 5.66602 4.91675 6.59871 4.91675 7.74977C4.91675 8.89999 5.84944 9.83268 7.0005 9.83268C8.15072 9.83268 9.08341 8.89999 9.08341 7.74977Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.99959 16.5C6.00086 16.5 0.75 12.2486 0.75 7.80274C0.75 4.3222 3.54758 1.5 6.99959 1.5C10.4516 1.5 13.25 4.3222 13.25 7.80274C13.25 12.2486 7.99832 16.5 6.99959 16.5Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                  </svg>
                                  <p>США</p>
                                </div>
                            <p class="club21-author-about">Эксперт по коммуникации. CEO проекта по обучению команд маркетинга, продаж, проджект-менеджеров и руководителей. Ментор в бизнес-акселераторе Чикаго.</p>
                            <div class="club21-author-achievements">
                                <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                                    <path d="M9.49224 0.789062H5.75324C2.67824 0.789062 0.750244 2.96606 0.750244 6.04806V14.3621C0.750244 17.4441 2.66924 19.6211 5.75324 19.6211H14.5772C17.6622 19.6211 19.5812 17.4441 19.5812 14.3621V10.3341" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.82763 8.9205L14.3006 1.4475C15.2316 0.5175 16.7406 0.5175 17.6716 1.4475L18.8886 2.6645C19.8196 3.5955 19.8196 5.1055 18.8886 6.0355L11.3796 13.5445C10.9726 13.9515 10.4206 14.1805 9.84463 14.1805H6.09863L6.19263 10.4005C6.20663 9.8445 6.43363 9.3145 6.82763 8.9205Z" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M13.165 2.60156L17.731 7.16756" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                  </svg>
                                  <p>
                                    <span>Автор вебинара:</span> «Коммуникация с англоязычными коллегами»
                                  </p>
                            </div>
                        </div>
                        <div class="club21-author">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1691833533225.png" alt="">
                            <p class="club21-author-name">Никита Сергеев</p>
                            <div class="club21-author-country">
                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="18" viewBox="0 0 14 18" fill="none">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.08341 7.74977C9.08341 6.59871 8.15072 5.66602 7.0005 5.66602C5.84944 5.66602 4.91675 6.59871 4.91675 7.74977C4.91675 8.89999 5.84944 9.83268 7.0005 9.83268C8.15072 9.83268 9.08341 8.89999 9.08341 7.74977Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.99959 16.5C6.00086 16.5 0.75 12.2486 0.75 7.80274C0.75 4.3222 3.54758 1.5 6.99959 1.5C10.4516 1.5 13.25 4.3222 13.25 7.80274C13.25 12.2486 7.99832 16.5 6.99959 16.5Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                  </svg>
                                  <p>Россия</p>
                                </div>
                            <p class="club21-author-about">Коуч и бизнес-тренер с 12-летним опытом тренингов. Ведет курс по переговорам в академии PWC. Работал с такими, компаниями, как МТС, Росатом, Академия PwC, Шлюмберже, Eli Lilly и др.</p>
                            <div class="club21-author-achievements">
                                <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                                    <path d="M9.49224 0.789062H5.75324C2.67824 0.789062 0.750244 2.96606 0.750244 6.04806V14.3621C0.750244 17.4441 2.66924 19.6211 5.75324 19.6211H14.5772C17.6622 19.6211 19.5812 17.4441 19.5812 14.3621V10.3341" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.82763 8.9205L14.3006 1.4475C15.2316 0.5175 16.7406 0.5175 17.6716 1.4475L18.8886 2.6645C19.8196 3.5955 19.8196 5.1055 18.8886 6.0355L11.3796 13.5445C10.9726 13.9515 10.4206 14.1805 9.84463 14.1805H6.09863L6.19263 10.4005C6.20663 9.8445 6.43363 9.3145 6.82763 8.9205Z" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M13.165 2.60156L17.731 7.16756" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                  </svg>
                                  <p>
                                    <span>Автор курса:</span> «Big Boss: быть, а не казаться»
                                  </p>
                            </div>
                        </div>
                        <div class="club21-author">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1691833536771.png" alt="">
                            <p class="club21-author-name">Sophie Vurpillot</p>
                            <div class="club21-author-country">
                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="18" viewBox="0 0 14 18" fill="none">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.08341 7.74977C9.08341 6.59871 8.15072 5.66602 7.0005 5.66602C5.84944 5.66602 4.91675 6.59871 4.91675 7.74977C4.91675 8.89999 5.84944 9.83268 7.0005 9.83268C8.15072 9.83268 9.08341 8.89999 9.08341 7.74977Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.99959 16.5C6.00086 16.5 0.75 12.2486 0.75 7.80274C0.75 4.3222 3.54758 1.5 6.99959 1.5C10.4516 1.5 13.25 4.3222 13.25 7.80274C13.25 12.2486 7.99832 16.5 6.99959 16.5Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                  </svg>
                                  <p>Испания</p>
                                </div>
                            <p class="club21-author-about">Международный рекрутер и коуч, 10+ лет опыта. Помогла специалистам из 20+ стран раскрыть потенциал. Сотрудничала с университетами Европы, США и Латинской Америки.</p>
                            <div class="club21-author-achievements">
                                <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                                    <path d="M9.49224 0.789062H5.75324C2.67824 0.789062 0.750244 2.96606 0.750244 6.04806V14.3621C0.750244 17.4441 2.66924 19.6211 5.75324 19.6211H14.5772C17.6622 19.6211 19.5812 17.4441 19.5812 14.3621V10.3341" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.82763 8.9205L14.3006 1.4475C15.2316 0.5175 16.7406 0.5175 17.6716 1.4475L18.8886 2.6645C19.8196 3.5955 19.8196 5.1055 18.8886 6.0355L11.3796 13.5445C10.9726 13.9515 10.4206 14.1805 9.84463 14.1805H6.09863L6.19263 10.4005C6.20663 9.8445 6.43363 9.3145 6.82763 8.9205Z" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M13.165 2.60156L17.731 7.16756" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                  </svg>
                                  <p>
                                    <span>Автор вебинара:</span> «The Other Side: Recuirter's View»
                                  </p>
                            </div>
                        </div>
                        <div class="club21-author">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1691833543032.png" alt="">
                            <p class="club21-author-name">Montse Lorente</p>
                            <div class="club21-author-country">
                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="18" viewBox="0 0 14 18" fill="none">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.08341 7.74977C9.08341 6.59871 8.15072 5.66602 7.0005 5.66602C5.84944 5.66602 4.91675 6.59871 4.91675 7.74977C4.91675 8.89999 5.84944 9.83268 7.0005 9.83268C8.15072 9.83268 9.08341 8.89999 9.08341 7.74977Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.99959 16.5C6.00086 16.5 0.75 12.2486 0.75 7.80274C0.75 4.3222 3.54758 1.5 6.99959 1.5C10.4516 1.5 13.25 4.3222 13.25 7.80274C13.25 12.2486 7.99832 16.5 6.99959 16.5Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                  </svg>
                                  <p>Перу</p>
                                </div>
                            <p class="club21-author-about">Международный рекрутер и коуч, 10+ лет опыта. Помогла специалистам из 20+ стран раскрыть потенциал. Сотрудничала с университетами Европы, США и Латинской Америки.</p>
                            <div class="club21-author-achievements">
                                <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                                    <path d="M9.49224 0.789062H5.75324C2.67824 0.789062 0.750244 2.96606 0.750244 6.04806V14.3621C0.750244 17.4441 2.66924 19.6211 5.75324 19.6211H14.5772C17.6622 19.6211 19.5812 17.4441 19.5812 14.3621V10.3341" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.82763 8.9205L14.3006 1.4475C15.2316 0.5175 16.7406 0.5175 17.6716 1.4475L18.8886 2.6645C19.8196 3.5955 19.8196 5.1055 18.8886 6.0355L11.3796 13.5445C10.9726 13.9515 10.4206 14.1805 9.84463 14.1805H6.09863L6.19263 10.4005C6.20663 9.8445 6.43363 9.3145 6.82763 8.9205Z" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M13.165 2.60156L17.731 7.16756" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                  </svg>
                                  <p>
                                    <span>Автор вебинара:</span> «The Other Side: Recuirter's View»
                                  </p>
                            </div>
                        </div>
                        <div class="club21-author">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1691833588400.png" alt="">
                            <p class="club21-author-name">Анна Бабич</p>
                            <div class="club21-author-country">
                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="18" viewBox="0 0 14 18" fill="none">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.08341 7.74977C9.08341 6.59871 8.15072 5.66602 7.0005 5.66602C5.84944 5.66602 4.91675 6.59871 4.91675 7.74977C4.91675 8.89999 5.84944 9.83268 7.0005 9.83268C8.15072 9.83268 9.08341 8.89999 9.08341 7.74977Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.99959 16.5C6.00086 16.5 0.75 12.2486 0.75 7.80274C0.75 4.3222 3.54758 1.5 6.99959 1.5C10.4516 1.5 13.25 4.3222 13.25 7.80274C13.25 12.2486 7.99832 16.5 6.99959 16.5Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                  </svg>
                                  <p>Россия</p>
                                </div>
                            <p class="club21-author-about">Дипломированный психолог с 8-летним опытом в своей нише. Помогает специалистам проработать внутренние блокеры и понять свои сильные стороны.</p>
                            <div class="club21-author-achievements">
                                <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                                    <path d="M9.49224 0.789062H5.75324C2.67824 0.789062 0.750244 2.96606 0.750244 6.04806V14.3621C0.750244 17.4441 2.66924 19.6211 5.75324 19.6211H14.5772C17.6622 19.6211 19.5812 17.4441 19.5812 14.3621V10.3341" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.82763 8.9205L14.3006 1.4475C15.2316 0.5175 16.7406 0.5175 17.6716 1.4475L18.8886 2.6645C19.8196 3.5955 19.8196 5.1055 18.8886 6.0355L11.3796 13.5445C10.9726 13.9515 10.4206 14.1805 9.84463 14.1805H6.09863L6.19263 10.4005C6.20663 9.8445 6.43363 9.3145 6.82763 8.9205Z" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M13.165 2.60156L17.731 7.16756" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                  </svg>
                                  <p>
                                    <span>Автор курса:</span> «Сколько я стою»
                                  </p>
                            </div>
                        </div>
                        <div class="club21-author">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1691833591108.png" alt="">
                            <p class="club21-author-name">Елена Резанова</p>
                            <div class="club21-author-country">
                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="18" viewBox="0 0 14 18" fill="none">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.08341 7.74977C9.08341 6.59871 8.15072 5.66602 7.0005 5.66602C5.84944 5.66602 4.91675 6.59871 4.91675 7.74977C4.91675 8.89999 5.84944 9.83268 7.0005 9.83268C8.15072 9.83268 9.08341 8.89999 9.08341 7.74977Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.99959 16.5C6.00086 16.5 0.75 12.2486 0.75 7.80274C0.75 4.3222 3.54758 1.5 6.99959 1.5C10.4516 1.5 13.25 4.3222 13.25 7.80274C13.25 12.2486 7.99832 16.5 6.99959 16.5Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                  </svg>
                                  <p>Монако</p>
                                </div>
                            <p class="club21-author-about">Карьерный стратег, за плечами которого 9+ лет опыта. Помогает посмотреть на карьеру целостно и соотнести ее с целями бизнеса.</p>
                            <div class="club21-author-achievements">
                                <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                                    <path d="M9.49224 0.789062H5.75324C2.67824 0.789062 0.750244 2.96606 0.750244 6.04806V14.3621C0.750244 17.4441 2.66924 19.6211 5.75324 19.6211H14.5772C17.6622 19.6211 19.5812 17.4441 19.5812 14.3621V10.3341" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.82763 8.9205L14.3006 1.4475C15.2316 0.5175 16.7406 0.5175 17.6716 1.4475L18.8886 2.6645C19.8196 3.5955 19.8196 5.1055 18.8886 6.0355L11.3796 13.5445C10.9726 13.9515 10.4206 14.1805 9.84463 14.1805H6.09863L6.19263 10.4005C6.20663 9.8445 6.43363 9.3145 6.82763 8.9205Z" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M13.165 2.60156L17.731 7.16756" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                  </svg>
                                  <p>
                                    <span>Автор курса:</span> «Самоопределение: профессионал в точке выбора»
                                  </p>
                            </div>
                        </div>
                    </div>
                    <div>
                        <button class="club21-authors-closed">Остальные эксперты</button>
                        <button class="club21-authors-opened">Показать меньше</button>
                    </div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-club21-authors-tablet', {
        label: 'Клуб 2.1 авторы (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-club21-authors-tablet">
            <div>
                <div>
                    <h2>Авторы программ и курсов — <br>эксперты Careerum</h2>
                </div>
                <div class="club21-authors-wrapper">
                    <div class="club21-authors">
                        <div class="club21-author">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1691833663944.png" alt="">
                            <p class="club21-author-name">Ольга Лермонтова</p>
                            <div class="club21-author-country">
                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="18" viewBox="0 0 14 18" fill="none">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.08341 7.74977C9.08341 6.59871 8.15072 5.66602 7.0005 5.66602C5.84944 5.66602 4.91675 6.59871 4.91675 7.74977C4.91675 8.89999 5.84944 9.83268 7.0005 9.83268C8.15072 9.83268 9.08341 8.89999 9.08341 7.74977Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.99959 16.5C6.00086 16.5 0.75 12.2486 0.75 7.80274C0.75 4.3222 3.54758 1.5 6.99959 1.5C10.4516 1.5 13.25 4.3222 13.25 7.80274C13.25 12.2486 7.99832 16.5 6.99959 16.5Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                                <p>Италия</p>
                            </div>
                            <p class="club21-author-about">Занимала руководящие роли в Google и Microsoft. Получила MBA в сингапурской бизнес-школе INSEAD и основала Careerum — крупнейшую в России и СНГ платформу карьерного развития.</p>
                            <div class="club21-author-achievements">
                                <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                                    <path d="M9.49224 0.789062H5.75324C2.67824 0.789062 0.750244 2.96606 0.750244 6.04806V14.3621C0.750244 17.4441 2.66924 19.6211 5.75324 19.6211H14.5772C17.6622 19.6211 19.5812 17.4441 19.5812 14.3621V10.3341" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.82763 8.9205L14.3006 1.4475C15.2316 0.5175 16.7406 0.5175 17.6716 1.4475L18.8886 2.6645C19.8196 3.5955 19.8196 5.1055 18.8886 6.0355L11.3796 13.5445C10.9726 13.9515 10.4206 14.1805 9.84463 14.1805H6.09863L6.19263 10.4005C6.20663 9.8445 6.43363 9.3145 6.82763 8.9205Z" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M13.165 2.60156L17.731 7.16756" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                  </svg>
                                  <p>
                                    <span>Автор программ и курсов:</span> «Real Me: как найти себя в работе и жизни»; «Карьера в кризис»; «Цели как в Google. Результаты как в Forbes» и др.
                                  </p>
                            </div>
                        </div>
                        <div class="club21-author">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1691833666454.png" alt="">
                            <p class="club21-author-name">Санжар Ибрагимов</p>
                            <div class="club21-author-country">
                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="18" viewBox="0 0 14 18" fill="none">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.08341 7.74977C9.08341 6.59871 8.15072 5.66602 7.0005 5.66602C5.84944 5.66602 4.91675 6.59871 4.91675 7.74977C4.91675 8.89999 5.84944 9.83268 7.0005 9.83268C8.15072 9.83268 9.08341 8.89999 9.08341 7.74977Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.99959 16.5C6.00086 16.5 0.75 12.2486 0.75 7.80274C0.75 4.3222 3.54758 1.5 6.99959 1.5C10.4516 1.5 13.25 4.3222 13.25 7.80274C13.25 12.2486 7.99832 16.5 6.99959 16.5Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                  </svg>
                                  <p>Финляндия</p>
                                </div>
                            <p class="club21-author-about">Работал в консалтинге в 5 странах — McKinsey & Company, PwC, World Bank Group. Получил MBA в швейцарской бизнес-школе IMD. Ментор в IMD International и Aalto Business School.</p>
                            <div class="club21-author-achievements">
                                <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                                    <path d="M9.49224 0.789062H5.75324C2.67824 0.789062 0.750244 2.96606 0.750244 6.04806V14.3621C0.750244 17.4441 2.66924 19.6211 5.75324 19.6211H14.5772C17.6622 19.6211 19.5812 17.4441 19.5812 14.3621V10.3341" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.82763 8.9205L14.3006 1.4475C15.2316 0.5175 16.7406 0.5175 17.6716 1.4475L18.8886 2.6645C19.8196 3.5955 19.8196 5.1055 18.8886 6.0355L11.3796 13.5445C10.9726 13.9515 10.4206 14.1805 9.84463 14.1805H6.09863L6.19263 10.4005C6.20663 9.8445 6.43363 9.3145 6.82763 8.9205Z" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M13.165 2.60156L17.731 7.16756" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                  </svg>
                                  <p>
                                    <span>Автор программ и курсов:</span> «Высокий старт: как попасть в консалтинг»; «Dream Team: как вывести командную работу на новый уровень»
                                  </p>
                            </div>
                        </div>
                        <div class="club21-author">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1691833668407.png" alt="">
                            <p class="club21-author-name">Ольга Сильверман</p>
                            <div class="club21-author-country">
                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="18" viewBox="0 0 14 18" fill="none">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.08341 7.74977C9.08341 6.59871 8.15072 5.66602 7.0005 5.66602C5.84944 5.66602 4.91675 6.59871 4.91675 7.74977C4.91675 8.89999 5.84944 9.83268 7.0005 9.83268C8.15072 9.83268 9.08341 8.89999 9.08341 7.74977Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.99959 16.5C6.00086 16.5 0.75 12.2486 0.75 7.80274C0.75 4.3222 3.54758 1.5 6.99959 1.5C10.4516 1.5 13.25 4.3222 13.25 7.80274C13.25 12.2486 7.99832 16.5 6.99959 16.5Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                  </svg>
                                  <p>Великобритания</p>
                                </div>
                            <p class="club21-author-about">Карьерный консультант с 20-летним опытом. Основательница агентства по сопровождению бизнеса в LinkedIn, которое помогло уже 400 бизнесам в 30 странах.</p>
                            <div class="club21-author-achievements">
                                <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                                    <path d="M9.49224 0.789062H5.75324C2.67824 0.789062 0.750244 2.96606 0.750244 6.04806V14.3621C0.750244 17.4441 2.66924 19.6211 5.75324 19.6211H14.5772C17.6622 19.6211 19.5812 17.4441 19.5812 14.3621V10.3341" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.82763 8.9205L14.3006 1.4475C15.2316 0.5175 16.7406 0.5175 17.6716 1.4475L18.8886 2.6645C19.8196 3.5955 19.8196 5.1055 18.8886 6.0355L11.3796 13.5445C10.9726 13.9515 10.4206 14.1805 9.84463 14.1805H6.09863L6.19263 10.4005C6.20663 9.8445 6.43363 9.3145 6.82763 8.9205Z" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M13.165 2.60156L17.731 7.16756" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                  </svg>
                                  <p>
                                    <span>Автор курса:</span> «LinkedIn для развития карьеры: выжми из него максимум»
                                  </p>
                            </div>
                        </div>
                        <div class="club21-author">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1691833723041.png" alt="">
                            <p class="club21-author-name">Наталья Токарь</p>
                            <div class="club21-author-country">
                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="18" viewBox="0 0 14 18" fill="none">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.08341 7.74977C9.08341 6.59871 8.15072 5.66602 7.0005 5.66602C5.84944 5.66602 4.91675 6.59871 4.91675 7.74977C4.91675 8.89999 5.84944 9.83268 7.0005 9.83268C8.15072 9.83268 9.08341 8.89999 9.08341 7.74977Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.99959 16.5C6.00086 16.5 0.75 12.2486 0.75 7.80274C0.75 4.3222 3.54758 1.5 6.99959 1.5C10.4516 1.5 13.25 4.3222 13.25 7.80274C13.25 12.2486 7.99832 16.5 6.99959 16.5Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                  </svg>
                                  <p>США</p>
                                </div>
                            <p class="club21-author-about">Эксперт по коммуникации. CEO проекта по обучению команд маркетинга, продаж, проджект-менеджеров и руководителей. Ментор в бизнес-акселераторе Чикаго.</p>
                            <div class="club21-author-achievements">
                                <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                                    <path d="M9.49224 0.789062H5.75324C2.67824 0.789062 0.750244 2.96606 0.750244 6.04806V14.3621C0.750244 17.4441 2.66924 19.6211 5.75324 19.6211H14.5772C17.6622 19.6211 19.5812 17.4441 19.5812 14.3621V10.3341" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.82763 8.9205L14.3006 1.4475C15.2316 0.5175 16.7406 0.5175 17.6716 1.4475L18.8886 2.6645C19.8196 3.5955 19.8196 5.1055 18.8886 6.0355L11.3796 13.5445C10.9726 13.9515 10.4206 14.1805 9.84463 14.1805H6.09863L6.19263 10.4005C6.20663 9.8445 6.43363 9.3145 6.82763 8.9205Z" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M13.165 2.60156L17.731 7.16756" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                  </svg>
                                  <p>
                                    <span>Автор вебинара:</span> «Коммуникация с англоязычными коллегами»
                                  </p>
                            </div>
                        </div>
                        <div class="club21-author">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1691833725127.png" alt="">
                            <p class="club21-author-name">Никита Сергеев</p>
                            <div class="club21-author-country">
                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="18" viewBox="0 0 14 18" fill="none">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.08341 7.74977C9.08341 6.59871 8.15072 5.66602 7.0005 5.66602C5.84944 5.66602 4.91675 6.59871 4.91675 7.74977C4.91675 8.89999 5.84944 9.83268 7.0005 9.83268C8.15072 9.83268 9.08341 8.89999 9.08341 7.74977Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.99959 16.5C6.00086 16.5 0.75 12.2486 0.75 7.80274C0.75 4.3222 3.54758 1.5 6.99959 1.5C10.4516 1.5 13.25 4.3222 13.25 7.80274C13.25 12.2486 7.99832 16.5 6.99959 16.5Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                  </svg>
                                  <p>Россия</p>
                                </div>
                            <p class="club21-author-about">Коуч и бизнес-тренер с 12-летним опытом тренингов. Ведет курс по переговорам в академии PWC. Работал с такими, компаниями, как МТС, Росатом, Академия PwC, Шлюмберже, Eli Lilly и др.</p>
                            <div class="club21-author-achievements">
                                <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                                    <path d="M9.49224 0.789062H5.75324C2.67824 0.789062 0.750244 2.96606 0.750244 6.04806V14.3621C0.750244 17.4441 2.66924 19.6211 5.75324 19.6211H14.5772C17.6622 19.6211 19.5812 17.4441 19.5812 14.3621V10.3341" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.82763 8.9205L14.3006 1.4475C15.2316 0.5175 16.7406 0.5175 17.6716 1.4475L18.8886 2.6645C19.8196 3.5955 19.8196 5.1055 18.8886 6.0355L11.3796 13.5445C10.9726 13.9515 10.4206 14.1805 9.84463 14.1805H6.09863L6.19263 10.4005C6.20663 9.8445 6.43363 9.3145 6.82763 8.9205Z" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M13.165 2.60156L17.731 7.16756" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                  </svg>
                                  <p>
                                    <span>Автор курса:</span> «Big Boss: быть, а не казаться»
                                  </p>
                            </div>
                        </div>
                        <div class="club21-author">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1691833727245.png" alt="">
                            <p class="club21-author-name">Sophie Vurpillot</p>
                            <div class="club21-author-country">
                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="18" viewBox="0 0 14 18" fill="none">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.08341 7.74977C9.08341 6.59871 8.15072 5.66602 7.0005 5.66602C5.84944 5.66602 4.91675 6.59871 4.91675 7.74977C4.91675 8.89999 5.84944 9.83268 7.0005 9.83268C8.15072 9.83268 9.08341 8.89999 9.08341 7.74977Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.99959 16.5C6.00086 16.5 0.75 12.2486 0.75 7.80274C0.75 4.3222 3.54758 1.5 6.99959 1.5C10.4516 1.5 13.25 4.3222 13.25 7.80274C13.25 12.2486 7.99832 16.5 6.99959 16.5Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                  </svg>
                                  <p>Испания</p>
                                </div>
                            <p class="club21-author-about">Международный рекрутер и коуч, 10+ лет опыта. Помогла специалистам из 20+ стран раскрыть потенциал. Сотрудничала с университетами Европы, США и Латинской Америки.</p>
                            <div class="club21-author-achievements">
                                <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                                    <path d="M9.49224 0.789062H5.75324C2.67824 0.789062 0.750244 2.96606 0.750244 6.04806V14.3621C0.750244 17.4441 2.66924 19.6211 5.75324 19.6211H14.5772C17.6622 19.6211 19.5812 17.4441 19.5812 14.3621V10.3341" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.82763 8.9205L14.3006 1.4475C15.2316 0.5175 16.7406 0.5175 17.6716 1.4475L18.8886 2.6645C19.8196 3.5955 19.8196 5.1055 18.8886 6.0355L11.3796 13.5445C10.9726 13.9515 10.4206 14.1805 9.84463 14.1805H6.09863L6.19263 10.4005C6.20663 9.8445 6.43363 9.3145 6.82763 8.9205Z" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M13.165 2.60156L17.731 7.16756" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                  </svg>
                                  <p>
                                    <span>Автор вебинара:</span> «The Other Side: Recuirter's View»
                                  </p>
                            </div>
                        </div>
                        <div class="club21-author">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1691833771372.png" alt="">
                            <p class="club21-author-name">Montse Lorente</p>
                            <div class="club21-author-country">
                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="18" viewBox="0 0 14 18" fill="none">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.08341 7.74977C9.08341 6.59871 8.15072 5.66602 7.0005 5.66602C5.84944 5.66602 4.91675 6.59871 4.91675 7.74977C4.91675 8.89999 5.84944 9.83268 7.0005 9.83268C8.15072 9.83268 9.08341 8.89999 9.08341 7.74977Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.99959 16.5C6.00086 16.5 0.75 12.2486 0.75 7.80274C0.75 4.3222 3.54758 1.5 6.99959 1.5C10.4516 1.5 13.25 4.3222 13.25 7.80274C13.25 12.2486 7.99832 16.5 6.99959 16.5Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                  </svg>
                                  <p>Перу</p>
                                </div>
                            <p class="club21-author-about">Международный рекрутер и коуч, 10+ лет опыта. Помогла специалистам из 20+ стран раскрыть потенциал. Сотрудничала с университетами Европы, США и Латинской Америки.</p>
                            <div class="club21-author-achievements">
                                <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                                    <path d="M9.49224 0.789062H5.75324C2.67824 0.789062 0.750244 2.96606 0.750244 6.04806V14.3621C0.750244 17.4441 2.66924 19.6211 5.75324 19.6211H14.5772C17.6622 19.6211 19.5812 17.4441 19.5812 14.3621V10.3341" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.82763 8.9205L14.3006 1.4475C15.2316 0.5175 16.7406 0.5175 17.6716 1.4475L18.8886 2.6645C19.8196 3.5955 19.8196 5.1055 18.8886 6.0355L11.3796 13.5445C10.9726 13.9515 10.4206 14.1805 9.84463 14.1805H6.09863L6.19263 10.4005C6.20663 9.8445 6.43363 9.3145 6.82763 8.9205Z" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M13.165 2.60156L17.731 7.16756" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                  </svg>
                                  <p>
                                    <span>Автор вебинара:</span> «The Other Side: Recuirter's View»
                                  </p>
                            </div>
                        </div>
                        <div class="club21-author">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1691833773297.png" alt="">
                            <p class="club21-author-name">Анна Бабич</p>
                            <div class="club21-author-country">
                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="18" viewBox="0 0 14 18" fill="none">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.08341 7.74977C9.08341 6.59871 8.15072 5.66602 7.0005 5.66602C5.84944 5.66602 4.91675 6.59871 4.91675 7.74977C4.91675 8.89999 5.84944 9.83268 7.0005 9.83268C8.15072 9.83268 9.08341 8.89999 9.08341 7.74977Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.99959 16.5C6.00086 16.5 0.75 12.2486 0.75 7.80274C0.75 4.3222 3.54758 1.5 6.99959 1.5C10.4516 1.5 13.25 4.3222 13.25 7.80274C13.25 12.2486 7.99832 16.5 6.99959 16.5Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                  </svg>
                                  <p>Россия</p>
                                </div>
                            <p class="club21-author-about">Дипломированный психолог с 8-летним опытом в своей нише. Помогает специалистам проработать внутренние блокеры и понять свои сильные стороны.</p>
                            <div class="club21-author-achievements">
                                <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                                    <path d="M9.49224 0.789062H5.75324C2.67824 0.789062 0.750244 2.96606 0.750244 6.04806V14.3621C0.750244 17.4441 2.66924 19.6211 5.75324 19.6211H14.5772C17.6622 19.6211 19.5812 17.4441 19.5812 14.3621V10.3341" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.82763 8.9205L14.3006 1.4475C15.2316 0.5175 16.7406 0.5175 17.6716 1.4475L18.8886 2.6645C19.8196 3.5955 19.8196 5.1055 18.8886 6.0355L11.3796 13.5445C10.9726 13.9515 10.4206 14.1805 9.84463 14.1805H6.09863L6.19263 10.4005C6.20663 9.8445 6.43363 9.3145 6.82763 8.9205Z" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M13.165 2.60156L17.731 7.16756" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                  </svg>
                                  <p>
                                    <span>Автор курса:</span> «Сколько я стою»
                                  </p>
                            </div>
                        </div>
                        <div class="club21-author">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1691833775838.png" alt="">
                            <p class="club21-author-name">Елена Резанова</p>
                            <div class="club21-author-country">
                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="18" viewBox="0 0 14 18" fill="none">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.08341 7.74977C9.08341 6.59871 8.15072 5.66602 7.0005 5.66602C5.84944 5.66602 4.91675 6.59871 4.91675 7.74977C4.91675 8.89999 5.84944 9.83268 7.0005 9.83268C8.15072 9.83268 9.08341 8.89999 9.08341 7.74977Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.99959 16.5C6.00086 16.5 0.75 12.2486 0.75 7.80274C0.75 4.3222 3.54758 1.5 6.99959 1.5C10.4516 1.5 13.25 4.3222 13.25 7.80274C13.25 12.2486 7.99832 16.5 6.99959 16.5Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                  </svg>
                                  <p>Монако</p>
                                </div>
                            <p class="club21-author-about">Карьерный стратег, за плечами которого 9+ лет опыта. Помогает посмотреть на карьеру целостно и соотнести ее с целями бизнеса.</p>
                            <div class="club21-author-achievements">
                                <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                                    <path d="M9.49224 0.789062H5.75324C2.67824 0.789062 0.750244 2.96606 0.750244 6.04806V14.3621C0.750244 17.4441 2.66924 19.6211 5.75324 19.6211H14.5772C17.6622 19.6211 19.5812 17.4441 19.5812 14.3621V10.3341" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.82763 8.9205L14.3006 1.4475C15.2316 0.5175 16.7406 0.5175 17.6716 1.4475L18.8886 2.6645C19.8196 3.5955 19.8196 5.1055 18.8886 6.0355L11.3796 13.5445C10.9726 13.9515 10.4206 14.1805 9.84463 14.1805H6.09863L6.19263 10.4005C6.20663 9.8445 6.43363 9.3145 6.82763 8.9205Z" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M13.165 2.60156L17.731 7.16756" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                  </svg>
                                  <p>
                                    <span>Автор курса:</span> «Самоопределение: профессионал в точке выбора»
                                  </p>
                            </div>
                        </div>
                    </div>
                    <div class="club21-authors-arrows">
                        <div>
                            <div class="club21-authors-slider__arrow-left">
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 18 16" fill="none">
                                    <path d="M2.19055 7.99935L15.8105 7.99935" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M8.46289 14.2453L2.18956 7.99862L8.46289 1.75195" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                            </div>
                            <div class="club21-authors-slider__arrow-right">
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 18 16" fill="none">
                                    <path d="M15.8095 8.00065L2.18945 8.00065" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M9.53711 1.75471L15.8104 8.00138L9.53711 14.248" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-club21-authors-mobile', {
        label: 'Клуб 2.1 авторы (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-club21-authors-mobile">
            <div>
                <div>
                    <h2>Авторы программ и курсов<br> — эксперты Careerum</h2>
                </div>
                <div class="club21-authors-wrapper">
                    <div class="club21-authors">
                        <div class="club21-author">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1691833663944.png" alt="">
                            <p class="club21-author-name">Ольга Лермонтова</p>
                            <div class="club21-author-country">
                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="18" viewBox="0 0 14 18" fill="none">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.08341 7.74977C9.08341 6.59871 8.15072 5.66602 7.0005 5.66602C5.84944 5.66602 4.91675 6.59871 4.91675 7.74977C4.91675 8.89999 5.84944 9.83268 7.0005 9.83268C8.15072 9.83268 9.08341 8.89999 9.08341 7.74977Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.99959 16.5C6.00086 16.5 0.75 12.2486 0.75 7.80274C0.75 4.3222 3.54758 1.5 6.99959 1.5C10.4516 1.5 13.25 4.3222 13.25 7.80274C13.25 12.2486 7.99832 16.5 6.99959 16.5Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                                <p>Италия</p>
                            </div>
                            <p class="club21-author-about">Занимала руководящие роли в Google и Microsoft. Получила MBA в сингапурской бизнес-школе INSEAD и основала Careerum — крупнейшую в России и СНГ платформу карьерного развития.</p>
                            <div class="club21-author-achievements">
                                <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                                    <path d="M9.49224 0.789062H5.75324C2.67824 0.789062 0.750244 2.96606 0.750244 6.04806V14.3621C0.750244 17.4441 2.66924 19.6211 5.75324 19.6211H14.5772C17.6622 19.6211 19.5812 17.4441 19.5812 14.3621V10.3341" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.82763 8.9205L14.3006 1.4475C15.2316 0.5175 16.7406 0.5175 17.6716 1.4475L18.8886 2.6645C19.8196 3.5955 19.8196 5.1055 18.8886 6.0355L11.3796 13.5445C10.9726 13.9515 10.4206 14.1805 9.84463 14.1805H6.09863L6.19263 10.4005C6.20663 9.8445 6.43363 9.3145 6.82763 8.9205Z" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M13.165 2.60156L17.731 7.16756" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                  </svg>
                                  <p>
                                    <span>Автор программ и курсов:</span> «Real Me: как найти себя в работе и жизни»; «Карьера в кризис»; «Цели как в Google. Результаты как в Forbes» и др.
                                  </p>
                            </div>
                        </div>
                        <div class="club21-author">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1691833666454.png" alt="">
                            <p class="club21-author-name">Санжар Ибрагимов</p>
                            <div class="club21-author-country">
                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="18" viewBox="0 0 14 18" fill="none">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.08341 7.74977C9.08341 6.59871 8.15072 5.66602 7.0005 5.66602C5.84944 5.66602 4.91675 6.59871 4.91675 7.74977C4.91675 8.89999 5.84944 9.83268 7.0005 9.83268C8.15072 9.83268 9.08341 8.89999 9.08341 7.74977Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.99959 16.5C6.00086 16.5 0.75 12.2486 0.75 7.80274C0.75 4.3222 3.54758 1.5 6.99959 1.5C10.4516 1.5 13.25 4.3222 13.25 7.80274C13.25 12.2486 7.99832 16.5 6.99959 16.5Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                  </svg>
                                  <p>Финляндия</p>
                                </div>
                            <p class="club21-author-about">Работал в консалтинге в 5 странах — McKinsey & Company, PwC, World Bank Group. Получил MBA в швейцарской бизнес-школе IMD. Ментор в IMD International и Aalto Business School.</p>
                            <div class="club21-author-achievements">
                                <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                                    <path d="M9.49224 0.789062H5.75324C2.67824 0.789062 0.750244 2.96606 0.750244 6.04806V14.3621C0.750244 17.4441 2.66924 19.6211 5.75324 19.6211H14.5772C17.6622 19.6211 19.5812 17.4441 19.5812 14.3621V10.3341" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.82763 8.9205L14.3006 1.4475C15.2316 0.5175 16.7406 0.5175 17.6716 1.4475L18.8886 2.6645C19.8196 3.5955 19.8196 5.1055 18.8886 6.0355L11.3796 13.5445C10.9726 13.9515 10.4206 14.1805 9.84463 14.1805H6.09863L6.19263 10.4005C6.20663 9.8445 6.43363 9.3145 6.82763 8.9205Z" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M13.165 2.60156L17.731 7.16756" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                  </svg>
                                  <p>
                                    <span>Автор программ и курсов:</span> «Высокий старт: как попасть в консалтинг»; «Dream Team: как вывести командную работу на новый уровень»
                                  </p>
                            </div>
                        </div>
                        <div class="club21-author">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1691833668407.png" alt="">
                            <p class="club21-author-name">Ольга Сильверман</p>
                            <div class="club21-author-country">
                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="18" viewBox="0 0 14 18" fill="none">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.08341 7.74977C9.08341 6.59871 8.15072 5.66602 7.0005 5.66602C5.84944 5.66602 4.91675 6.59871 4.91675 7.74977C4.91675 8.89999 5.84944 9.83268 7.0005 9.83268C8.15072 9.83268 9.08341 8.89999 9.08341 7.74977Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.99959 16.5C6.00086 16.5 0.75 12.2486 0.75 7.80274C0.75 4.3222 3.54758 1.5 6.99959 1.5C10.4516 1.5 13.25 4.3222 13.25 7.80274C13.25 12.2486 7.99832 16.5 6.99959 16.5Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                  </svg>
                                  <p>Великобритания</p>
                                </div>
                            <p class="club21-author-about">Карьерный консультант с 20-летним опытом. Основательница агентства по сопровождению бизнеса в LinkedIn, которое помогло уже 400 бизнесам в 30 странах.</p>
                            <div class="club21-author-achievements">
                                <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                                    <path d="M9.49224 0.789062H5.75324C2.67824 0.789062 0.750244 2.96606 0.750244 6.04806V14.3621C0.750244 17.4441 2.66924 19.6211 5.75324 19.6211H14.5772C17.6622 19.6211 19.5812 17.4441 19.5812 14.3621V10.3341" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.82763 8.9205L14.3006 1.4475C15.2316 0.5175 16.7406 0.5175 17.6716 1.4475L18.8886 2.6645C19.8196 3.5955 19.8196 5.1055 18.8886 6.0355L11.3796 13.5445C10.9726 13.9515 10.4206 14.1805 9.84463 14.1805H6.09863L6.19263 10.4005C6.20663 9.8445 6.43363 9.3145 6.82763 8.9205Z" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M13.165 2.60156L17.731 7.16756" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                  </svg>
                                  <p>
                                    <span>Автор курса:</span> «LinkedIn для развития карьеры: выжми из него максимум»
                                  </p>
                            </div>
                        </div>
                        <div class="club21-author">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1691833723041.png" alt="">
                            <p class="club21-author-name">Наталья Токарь</p>
                            <div class="club21-author-country">
                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="18" viewBox="0 0 14 18" fill="none">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.08341 7.74977C9.08341 6.59871 8.15072 5.66602 7.0005 5.66602C5.84944 5.66602 4.91675 6.59871 4.91675 7.74977C4.91675 8.89999 5.84944 9.83268 7.0005 9.83268C8.15072 9.83268 9.08341 8.89999 9.08341 7.74977Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.99959 16.5C6.00086 16.5 0.75 12.2486 0.75 7.80274C0.75 4.3222 3.54758 1.5 6.99959 1.5C10.4516 1.5 13.25 4.3222 13.25 7.80274C13.25 12.2486 7.99832 16.5 6.99959 16.5Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                  </svg>
                                  <p>США</p>
                                </div>
                            <p class="club21-author-about">Эксперт по коммуникации. CEO проекта по обучению команд маркетинга, продаж, проджект-менеджеров и руководителей. Ментор в бизнес-акселераторе Чикаго.</p>
                            <div class="club21-author-achievements">
                                <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                                    <path d="M9.49224 0.789062H5.75324C2.67824 0.789062 0.750244 2.96606 0.750244 6.04806V14.3621C0.750244 17.4441 2.66924 19.6211 5.75324 19.6211H14.5772C17.6622 19.6211 19.5812 17.4441 19.5812 14.3621V10.3341" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.82763 8.9205L14.3006 1.4475C15.2316 0.5175 16.7406 0.5175 17.6716 1.4475L18.8886 2.6645C19.8196 3.5955 19.8196 5.1055 18.8886 6.0355L11.3796 13.5445C10.9726 13.9515 10.4206 14.1805 9.84463 14.1805H6.09863L6.19263 10.4005C6.20663 9.8445 6.43363 9.3145 6.82763 8.9205Z" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M13.165 2.60156L17.731 7.16756" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                  </svg>
                                  <p>
                                    <span>Автор вебинара:</span> «Коммуникация с англоязычными коллегами»
                                  </p>
                            </div>
                        </div>
                        <div class="club21-author">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1691833725127.png" alt="">
                            <p class="club21-author-name">Никита Сергеев</p>
                            <div class="club21-author-country">
                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="18" viewBox="0 0 14 18" fill="none">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.08341 7.74977C9.08341 6.59871 8.15072 5.66602 7.0005 5.66602C5.84944 5.66602 4.91675 6.59871 4.91675 7.74977C4.91675 8.89999 5.84944 9.83268 7.0005 9.83268C8.15072 9.83268 9.08341 8.89999 9.08341 7.74977Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.99959 16.5C6.00086 16.5 0.75 12.2486 0.75 7.80274C0.75 4.3222 3.54758 1.5 6.99959 1.5C10.4516 1.5 13.25 4.3222 13.25 7.80274C13.25 12.2486 7.99832 16.5 6.99959 16.5Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                  </svg>
                                  <p>Россия</p>
                                </div>
                            <p class="club21-author-about">Коуч и бизнес-тренер с 12-летним опытом тренингов. Ведет курс по переговорам в академии PWC. Работал с такими, компаниями, как МТС, Росатом, Академия PwC, Шлюмберже, Eli Lilly и др.</p>
                            <div class="club21-author-achievements">
                                <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                                    <path d="M9.49224 0.789062H5.75324C2.67824 0.789062 0.750244 2.96606 0.750244 6.04806V14.3621C0.750244 17.4441 2.66924 19.6211 5.75324 19.6211H14.5772C17.6622 19.6211 19.5812 17.4441 19.5812 14.3621V10.3341" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.82763 8.9205L14.3006 1.4475C15.2316 0.5175 16.7406 0.5175 17.6716 1.4475L18.8886 2.6645C19.8196 3.5955 19.8196 5.1055 18.8886 6.0355L11.3796 13.5445C10.9726 13.9515 10.4206 14.1805 9.84463 14.1805H6.09863L6.19263 10.4005C6.20663 9.8445 6.43363 9.3145 6.82763 8.9205Z" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M13.165 2.60156L17.731 7.16756" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                  </svg>
                                  <p>
                                    <span>Автор курса:</span> «Big Boss: быть, а не казаться»
                                  </p>
                            </div>
                        </div>
                        <div class="club21-author">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1691833727245.png" alt="">
                            <p class="club21-author-name">Sophie Vurpillot</p>
                            <div class="club21-author-country">
                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="18" viewBox="0 0 14 18" fill="none">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.08341 7.74977C9.08341 6.59871 8.15072 5.66602 7.0005 5.66602C5.84944 5.66602 4.91675 6.59871 4.91675 7.74977C4.91675 8.89999 5.84944 9.83268 7.0005 9.83268C8.15072 9.83268 9.08341 8.89999 9.08341 7.74977Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.99959 16.5C6.00086 16.5 0.75 12.2486 0.75 7.80274C0.75 4.3222 3.54758 1.5 6.99959 1.5C10.4516 1.5 13.25 4.3222 13.25 7.80274C13.25 12.2486 7.99832 16.5 6.99959 16.5Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                  </svg>
                                  <p>Испания</p>
                                </div>
                            <p class="club21-author-about">Международный рекрутер и коуч, 10+ лет опыта. Помогла специалистам из 20+ стран раскрыть потенциал. Сотрудничала с университетами Европы, США и Латинской Америки.</p>
                            <div class="club21-author-achievements">
                                <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                                    <path d="M9.49224 0.789062H5.75324C2.67824 0.789062 0.750244 2.96606 0.750244 6.04806V14.3621C0.750244 17.4441 2.66924 19.6211 5.75324 19.6211H14.5772C17.6622 19.6211 19.5812 17.4441 19.5812 14.3621V10.3341" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.82763 8.9205L14.3006 1.4475C15.2316 0.5175 16.7406 0.5175 17.6716 1.4475L18.8886 2.6645C19.8196 3.5955 19.8196 5.1055 18.8886 6.0355L11.3796 13.5445C10.9726 13.9515 10.4206 14.1805 9.84463 14.1805H6.09863L6.19263 10.4005C6.20663 9.8445 6.43363 9.3145 6.82763 8.9205Z" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M13.165 2.60156L17.731 7.16756" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                  </svg>
                                  <p>
                                    <span>Автор вебинара:</span> «The Other Side: Recuirter's View»
                                  </p>
                            </div>
                        </div>
                        <div class="club21-author">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1691833771372.png" alt="">
                            <p class="club21-author-name">Montse Lorente</p>
                            <div class="club21-author-country">
                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="18" viewBox="0 0 14 18" fill="none">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.08341 7.74977C9.08341 6.59871 8.15072 5.66602 7.0005 5.66602C5.84944 5.66602 4.91675 6.59871 4.91675 7.74977C4.91675 8.89999 5.84944 9.83268 7.0005 9.83268C8.15072 9.83268 9.08341 8.89999 9.08341 7.74977Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.99959 16.5C6.00086 16.5 0.75 12.2486 0.75 7.80274C0.75 4.3222 3.54758 1.5 6.99959 1.5C10.4516 1.5 13.25 4.3222 13.25 7.80274C13.25 12.2486 7.99832 16.5 6.99959 16.5Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                  </svg>
                                  <p>Перу</p>
                                </div>
                            <p class="club21-author-about">Международный рекрутер и коуч, 10+ лет опыта. Помогла специалистам из 20+ стран раскрыть потенциал. Сотрудничала с университетами Европы, США и Латинской Америки.</p>
                            <div class="club21-author-achievements">
                                <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                                    <path d="M9.49224 0.789062H5.75324C2.67824 0.789062 0.750244 2.96606 0.750244 6.04806V14.3621C0.750244 17.4441 2.66924 19.6211 5.75324 19.6211H14.5772C17.6622 19.6211 19.5812 17.4441 19.5812 14.3621V10.3341" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.82763 8.9205L14.3006 1.4475C15.2316 0.5175 16.7406 0.5175 17.6716 1.4475L18.8886 2.6645C19.8196 3.5955 19.8196 5.1055 18.8886 6.0355L11.3796 13.5445C10.9726 13.9515 10.4206 14.1805 9.84463 14.1805H6.09863L6.19263 10.4005C6.20663 9.8445 6.43363 9.3145 6.82763 8.9205Z" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M13.165 2.60156L17.731 7.16756" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                  </svg>
                                  <p>
                                    <span>Автор вебинара:</span> «The Other Side: Recuirter's View»
                                  </p>
                            </div>
                        </div>
                        <div class="club21-author">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1691833773297.png" alt="">
                            <p class="club21-author-name">Анна Бабич</p>
                            <div class="club21-author-country">
                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="18" viewBox="0 0 14 18" fill="none">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.08341 7.74977C9.08341 6.59871 8.15072 5.66602 7.0005 5.66602C5.84944 5.66602 4.91675 6.59871 4.91675 7.74977C4.91675 8.89999 5.84944 9.83268 7.0005 9.83268C8.15072 9.83268 9.08341 8.89999 9.08341 7.74977Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.99959 16.5C6.00086 16.5 0.75 12.2486 0.75 7.80274C0.75 4.3222 3.54758 1.5 6.99959 1.5C10.4516 1.5 13.25 4.3222 13.25 7.80274C13.25 12.2486 7.99832 16.5 6.99959 16.5Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                  </svg>
                                  <p>Россия</p>
                                </div>
                            <p class="club21-author-about">Дипломированный психолог с 8-летним опытом в своей нише. Помогает специалистам проработать внутренние блокеры и понять свои сильные стороны.</p>
                            <div class="club21-author-achievements">
                                <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                                    <path d="M9.49224 0.789062H5.75324C2.67824 0.789062 0.750244 2.96606 0.750244 6.04806V14.3621C0.750244 17.4441 2.66924 19.6211 5.75324 19.6211H14.5772C17.6622 19.6211 19.5812 17.4441 19.5812 14.3621V10.3341" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.82763 8.9205L14.3006 1.4475C15.2316 0.5175 16.7406 0.5175 17.6716 1.4475L18.8886 2.6645C19.8196 3.5955 19.8196 5.1055 18.8886 6.0355L11.3796 13.5445C10.9726 13.9515 10.4206 14.1805 9.84463 14.1805H6.09863L6.19263 10.4005C6.20663 9.8445 6.43363 9.3145 6.82763 8.9205Z" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M13.165 2.60156L17.731 7.16756" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                  </svg>
                                  <p>
                                    <span>Автор курса:</span> «Сколько я стою»
                                  </p>
                            </div>
                        </div>
                        <div class="club21-author">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1691833775838.png" alt="">
                            <p class="club21-author-name">Елена Резанова</p>
                            <div class="club21-author-country">
                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="18" viewBox="0 0 14 18" fill="none">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.08341 7.74977C9.08341 6.59871 8.15072 5.66602 7.0005 5.66602C5.84944 5.66602 4.91675 6.59871 4.91675 7.74977C4.91675 8.89999 5.84944 9.83268 7.0005 9.83268C8.15072 9.83268 9.08341 8.89999 9.08341 7.74977Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.99959 16.5C6.00086 16.5 0.75 12.2486 0.75 7.80274C0.75 4.3222 3.54758 1.5 6.99959 1.5C10.4516 1.5 13.25 4.3222 13.25 7.80274C13.25 12.2486 7.99832 16.5 6.99959 16.5Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                  </svg>
                                  <p>Монако</p>
                                </div>
                            <p class="club21-author-about">Карьерный стратег, за плечами которого 9+ лет опыта. Помогает посмотреть на карьеру целостно и соотнести ее с целями бизнеса.</p>
                            <div class="club21-author-achievements">
                                <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                                    <path d="M9.49224 0.789062H5.75324C2.67824 0.789062 0.750244 2.96606 0.750244 6.04806V14.3621C0.750244 17.4441 2.66924 19.6211 5.75324 19.6211H14.5772C17.6622 19.6211 19.5812 17.4441 19.5812 14.3621V10.3341" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.82763 8.9205L14.3006 1.4475C15.2316 0.5175 16.7406 0.5175 17.6716 1.4475L18.8886 2.6645C19.8196 3.5955 19.8196 5.1055 18.8886 6.0355L11.3796 13.5445C10.9726 13.9515 10.4206 14.1805 9.84463 14.1805H6.09863L6.19263 10.4005C6.20663 9.8445 6.43363 9.3145 6.82763 8.9205Z" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M13.165 2.60156L17.731 7.16756" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                  </svg>
                                  <p>
                                    <span>Автор курса:</span> «Самоопределение: профессионал в точке выбора»
                                  </p>
                            </div>
                        </div>
                    </div>
                    <div class="club21-authors-arrows">
                        <div>
                            <div class="club21-authors-slider__arrow-left">
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 18 16" fill="none">
                                    <path d="M2.19055 7.99935L15.8105 7.99935" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M8.46289 14.2453L2.18956 7.99862L8.46289 1.75195" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                            </div>
                            <div class="club21-authors-slider__arrow-right">
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 18 16" fill="none">
                                    <path d="M15.8095 8.00065L2.18945 8.00065" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M9.53711 1.75471L15.8104 8.00138L9.53711 14.248" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
	});
    
    blockManager.add('careerum-club21-calendar', {
        label: 'Клуб 2.1 календарь',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-club21-calendar">
            <div>
                <div>
                    <h2>Сообщество Careerum — это 10 000+<br> русскоговорящих специалистов из 30+ стран</h2>
                    <p>Здесь можно получить опыт, завести знакомства и участвовать в онлайн<br> или офлайн-мероприятиях</p>
                </div>
                <div class="calendar-load" style="display: none;">
                    <div class="elfsight-app-6772dc83-89c5-403a-8b5e-9ddee3d11d61"></div>
                </div>
                <div class="calendar-wrapper">
    
                </div>
                <div>
                    <div>
                        <div class="club21-calendar-slider__arrow-left">
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 18 16" fill="none">
                                <path d="M2.19055 7.99935L15.8105 7.99935" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M8.46289 14.2453L2.18956 7.99862L8.46289 1.75195" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                        </div>
                        <div class="club21-calendar-slider__arrow-right">
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 18 16" fill="none">
                                <path d="M15.8095 8.00065L2.18945 8.00065" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M9.53711 1.75471L15.8104 8.00138L9.53711 14.248" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
	});
    
    blockManager.add('careerum-club21-coaches', {
        label: 'Клуб 2.1 коучи',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-club21-coaches">
            <div>
                <div>
                    <div>
                        <p class="careerum-club21-coaches__header">Коучи Careerum — специалисты<br> с международной сертификацией</p>
                        <p class="careerum-club21-coaches__text">Помогут прийти к цели быстрее и проработать задачи, которые сложно<br> решить самостоятельно</p>
                    </div>
                    <div class="club21-coaches-slider">
                        <div class="coaches-slider-item1">
                            <div>
                                <div>
                                    <p class="coaches-slider-item1__header">9,3/10</p>
                                    <p class="coaches-slider-item1__text">средняя оценка<br> коучей от участников клуба</p>
                                    <p class="coaches-slider-item1__header">9,5/10</p>
                                    <p class="coaches-slider-item1__text">средняя оценка<br> CV-специалистов</p>
                                    <p class="coaches-slider-item1__header">Доступно</p>
                                    <p class="coaches-slider-item1__text">на тарифах <br>«С поддержкой»<br> и «Полное сопровождение»</p>
                                </div>
                            </div>
                        </div>
                        <div class="coaches-slider-item2">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513044873.png" alt="">
                            <p class="coaches-slider-item2__header">Елена Добринская</p>
                            <p class="coaches-slider-item2__text">Коуч ICF</p>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513075681.svg" alt="">
                                <p>6+ лет опыта</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513108788.svg" alt="">
                                <p>Помогла 1700+ клиентам обрести уверенность и подготовиться к собеседованиям </p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513122799.svg" alt="">
                                <p>Работала с<br> сотрудниками Sony,<br>  MTC, «Газпромнефть» </p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513142334.svg" alt="">
                                <p>ОАЭ</p>
                            </div>
                        </div>
                        <div class="coaches-slider-item2">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513163934.png" alt="">
                            <p class="coaches-slider-item2__header">Ирина Феокистова</p>
                            <p class="coaches-slider-item2__text">Коуч ICF</p>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513075681.svg" alt="">
                                <p>3+ года опыта </p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513108788.svg" alt="">
                                <p>Помогла 700+ клиентам получить офферы с релокацией и повышение</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513122799.svg" alt="">
                                <p>Работала с<br> сотрудниками PepsiCo и<br> «Аэрофлота»</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513142334.svg" alt="">
                                <p>Россия</p>
                            </div>
                        </div>
                        <div class="coaches-slider-item2">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513178026.png" alt="">
                            <p class="coaches-slider-item2__header">Яна Хмельницкая</p>
                            <p class="coaches-slider-item2__text">Коуч ICF</p>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513075681.svg" alt="">
                                <p>10+ лет опыта</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513108788.svg" alt="">
                                <p>Помогла 250+ клиентам с релокацией и поиском работы на международном рынке</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513122799.svg" alt="">
                                <p>Работала с<br> сотрудниками Ford, Leroy Merlin, Toyota</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513142334.svg" alt="">
                                <p>Турция</p>
                            </div>
                        </div>
                        <div class="coaches-slider-item2">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513207695.png" alt="">
                            <p class="coaches-slider-item2__header">Елена Эльзенбах</p>
                            <p class="coaches-slider-item2__text">Коуч ICF</p>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513075681.svg" alt="">
                                <p>3+ года опыта </p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513108788.svg" alt="">
                                <p>Помогла 700+ клиентам из России и Европы найти работу в ЕС, США<br> и Канаде</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513122799.svg" alt="">
                                <p>Работала с<br> сотрудниками InDriver<br> и Promwad</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513142334.svg" alt="">
                                <p>Россия</p>
                            </div>
                        </div>
                        <div class="coaches-slider-item2">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513229972.png" alt="">
                            <p class="coaches-slider-item2__header">Софи Бессон</p>
                            <p class="coaches-slider-item2__text">CV-специалист</p>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513075681.svg" alt="">
                                <p>8+ лет опыта</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513108788.svg" alt="">
                                <p>Помогла 300+ клиентам составить резюме и найти работу в Европе, США и Канаде</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513122799.svg" alt="">
                                <p>Работала с<br> сотрудниками Disney, Intel, Microsoft</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513142334.svg" alt="">
                                <p>Израиль</p>
                            </div>
                        </div>
                        <div class="coaches-slider-item2">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513254543.png" alt="">
                            <p class="coaches-slider-item2__header">Надежда Община</p>
                            <p class="coaches-slider-item2__text">CV-специалист</p>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513075681.svg" alt="">
                                <p>2+ лет опыта</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513108788.svg" alt="">
                                <p>Помогла 250+ клиентам<br> в самопрезентации и поиске работы</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513122799.svg" alt="">
                                <p>Работала с<br> сотрудниками Airbus, Hubspot, DAWESoft, Weatherford</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513142334.svg" alt="">
                                <p>Португалия</p>
                            </div>
                        </div>
                        <div class="coaches-slider-item2">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513271340.png" alt="">
                            <p class="coaches-slider-item2__header">Астра Висаева</p>
                            <p class="coaches-slider-item2__text">Коуч ICF</p>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513075681.svg" alt="">
                                <p>4+ года опыта</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513108788.svg" alt="">
                                <p>Помогла 2000+ клиентам сделать карьерную стратегию и найти работу в ЕС и США</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513122799.svg" alt="">
                                <p>Работала с<br> сотрудниками EPAM,<br> OZON</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513142334.svg" alt="">
                                <p>Россия</p>
                            </div>
                        </div>
                        <div class="coaches-slider-item2">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513287747.png" alt="">
                            <p class="coaches-slider-item2__header">Марина Веденичева</p>
                            <p class="coaches-slider-item2__text">Коуч ICF PCC</p>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513075681.svg" alt="">
                                <p>15+ лет опыта</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513108788.svg" alt="">
                                <p>Помогла 1000+ клиентам усилить лидерские качества и получить повышение</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513122799.svg" alt="">
                                <p>Работала с<br> сотрудниками Mars, Shell, Ernst & Young</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513142334.svg" alt="">
                                <p>Великобритания</p>
                            </div>
                        </div>
                        <div class="coaches-slider-item2">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513303406.png" alt="">
                            <p class="coaches-slider-item2__header">Светлана Баран</p>
                            <p class="coaches-slider-item2__text">Коуч ICF</p>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513075681.svg" alt="">
                                <p>4+ года опыта</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513108788.svg" alt="">
                                <p>Помогла 3300+ клиентам с релокацией и поиске работы на международном рынке</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513122799.svg" alt="">
                                <p>Работала с<br> сотрудниками Tesla,<br> Google, Phillips</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513142334.svg" alt="">
                                <p>Италия</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <div>
                        <div class="club21-coaches-slider__arrow-left">
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 18 16" fill="none">
                                <path d="M2.19055 7.99935L15.8105 7.99935" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M8.46289 14.2453L2.18956 7.99862L8.46289 1.75195" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                        </div>
                        <div class="club21-coaches-slider__arrow-right">
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 18 16" fill="none">
                                <path d="M15.8095 8.00065L2.18945 8.00065" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M9.53711 1.75471L15.8104 8.00138L9.53711 14.248" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-club21-coaches-tablet', {
        label: 'Клуб 2.1 коучи (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-club21-coaches-tablet">
            <div>
                <div>
                    <div>
                        <p class="careerum-club21-coaches__header">Коучи Careerum — специалисты<br> с международной сертификацией</p>
                        <p class="careerum-club21-coaches__text">Помогут прийти к цели быстрее и проработать задачи, которые сложно<br> решить самостоятельно</p>
                    </div>
                    <div class="club21-coaches-slider">
                        <div class="coaches-slider-item1">
                            <div>
                                <div>
                                    <p class="coaches-slider-item1__header">9,3/10</p>
                                    <p class="coaches-slider-item1__text">средняя оценка<br> коучей от участников клуба</p>
                                    <p class="coaches-slider-item1__header">9,5/10</p>
                                    <p class="coaches-slider-item1__text">средняя оценка<br> CV-специалистов</p>
                                    <p class="coaches-slider-item1__header">Доступно</p>
                                    <p class="coaches-slider-item1__text">на тарифах <br>«С поддержкой»<br> и «Полное сопровождение»</p>
                                </div>
                            </div>
                        </div>
                        <div class="coaches-slider-item2">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513044873.png" alt="">
                            <p class="coaches-slider-item2__header">Елена Добринская</p>
                            <p class="coaches-slider-item2__text">Коуч ICF</p>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513075681.svg" alt="">
                                <p>6+ лет опыта</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513108788.svg" alt="">
                                <p>Помогла 1700+ клиентам обрести уверенность и подготовиться к собеседованиям </p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513122799.svg" alt="">
                                <p>Работала с<br> сотрудниками Sony,<br>  MTC, «Газпромнефть» </p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513142334.svg" alt="">
                                <p>ОАЭ</p>
                            </div>
                        </div>
                        <div class="coaches-slider-item2">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513163934.png" alt="">
                            <p class="coaches-slider-item2__header">Ирина Феокистова</p>
                            <p class="coaches-slider-item2__text">Коуч ICF</p>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513075681.svg" alt="">
                                <p>3+ года опыта </p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513108788.svg" alt="">
                                <p>Помогла 700+ клиентам получить офферы с релокацией и повышение</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513122799.svg" alt="">
                                <p>Работала с<br> сотрудниками PepsiCo и<br> «Аэрофлота»</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513142334.svg" alt="">
                                <p>Россия</p>
                            </div>
                        </div>
                        <div class="coaches-slider-item2">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513178026.png" alt="">
                            <p class="coaches-slider-item2__header">Яна Хмельницкая</p>
                            <p class="coaches-slider-item2__text">Коуч ICF</p>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513075681.svg" alt="">
                                <p>10+ лет опыта</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513108788.svg" alt="">
                                <p>Помогла 250+ клиентам с релокацией и поиском работы на международном рынке</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513122799.svg" alt="">
                                <p>Работала с<br> сотрудниками Ford, Leroy Merlin, Toyota</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513142334.svg" alt="">
                                <p>Турция</p>
                            </div>
                        </div>
                        <div class="coaches-slider-item2">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513207695.png" alt="">
                            <p class="coaches-slider-item2__header">Елена Эльзенбах</p>
                            <p class="coaches-slider-item2__text">Коуч ICF</p>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513075681.svg" alt="">
                                <p>3+ года опыта </p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513108788.svg" alt="">
                                <p>Помогла 700+ клиентам из России и Европы найти работу в ЕС, США<br> и Канаде</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513122799.svg" alt="">
                                <p>Работала с<br> сотрудниками InDriver<br> и Promwad</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513142334.svg" alt="">
                                <p>Россия</p>
                            </div>
                        </div>
                        <div class="coaches-slider-item2">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513229972.png" alt="">
                            <p class="coaches-slider-item2__header">Софи Бессон</p>
                            <p class="coaches-slider-item2__text">CV-специалист</p>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513075681.svg" alt="">
                                <p>8+ лет опыта</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513108788.svg" alt="">
                                <p>Помогла 300+ клиентам составить резюме и найти работу в Европе, США и Канаде</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513122799.svg" alt="">
                                <p>Работала с<br> сотрудниками Disney, Intel, Microsoft</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513142334.svg" alt="">
                                <p>Израиль</p>
                            </div>
                        </div>
                        <div class="coaches-slider-item2">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513254543.png" alt="">
                            <p class="coaches-slider-item2__header">Надежда Община</p>
                            <p class="coaches-slider-item2__text">CV-специалист</p>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513075681.svg" alt="">
                                <p>2+ лет опыта</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513108788.svg" alt="">
                                <p>Помогла 250+ клиентам<br> в самопрезентации и поиске работы</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513122799.svg" alt="">
                                <p>Работала с<br> сотрудниками Airbus, Hubspot, DAWESoft, Weatherford</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513142334.svg" alt="">
                                <p>Португалия</p>
                            </div>
                        </div>
                        <div class="coaches-slider-item2">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513271340.png" alt="">
                            <p class="coaches-slider-item2__header">Астра Висаева</p>
                            <p class="coaches-slider-item2__text">Коуч ICF</p>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513075681.svg" alt="">
                                <p>4+ года опыта</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513108788.svg" alt="">
                                <p>Помогла 2000+ клиентам сделать карьерную стратегию и найти работу в ЕС и США</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513122799.svg" alt="">
                                <p>Работала с<br> сотрудниками EPAM,<br> OZON</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513142334.svg" alt="">
                                <p>Россия</p>
                            </div>
                        </div>
                        <div class="coaches-slider-item2">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513287747.png" alt="">
                            <p class="coaches-slider-item2__header">Марина Веденичева</p>
                            <p class="coaches-slider-item2__text">Коуч ICF PCC</p>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513075681.svg" alt="">
                                <p>15+ лет опыта</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513108788.svg" alt="">
                                <p>Помогла 1000+ клиентам усилить лидерские качества и получить повышение</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513122799.svg" alt="">
                                <p>Работала с<br> сотрудниками Mars, Shell, Ernst & Young</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513142334.svg" alt="">
                                <p>Великобритания</p>
                            </div>
                        </div>
                        <div class="coaches-slider-item2">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513303406.png" alt="">
                            <p class="coaches-slider-item2__header">Светлана Баран</p>
                            <p class="coaches-slider-item2__text">Коуч ICF</p>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513075681.svg" alt="">
                                <p>4+ года опыта</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513108788.svg" alt="">
                                <p>Помогла 3300+ клиентам с релокацией и поиске работы на международном рынке</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513122799.svg" alt="">
                                <p>Работала с<br> сотрудниками Tesla,<br> Google, Phillips</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513142334.svg" alt="">
                                <p>Италия</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <div>
                        <div class="club21-coaches-slider__arrow-left">
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 18 16" fill="none">
                                <path d="M2.19055 7.99935L15.8105 7.99935" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M8.46289 14.2453L2.18956 7.99862L8.46289 1.75195" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                        </div>
                        <div class="club21-coaches-slider__arrow-right">
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 18 16" fill="none">
                                <path d="M15.8095 8.00065L2.18945 8.00065" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M9.53711 1.75471L15.8104 8.00138L9.53711 14.248" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-club21-coaches-mobile', {
        label: 'Клуб 2.1 коучи (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-club21-coaches-mobile">
            <div>
                <div>
                    <div>
                        <p class="careerum-club21-coaches__header">Коучи Careerum — специалисты<br> с международной сертификацией</p>
                        <p class="careerum-club21-coaches__text">Помогут прийти к цели быстрее<br> и проработать задачи, которые <br>сложно решить самостоятельно</p>
                    </div>
                    <div class="club21-coaches-slider">
                        <div class="coaches-slider-item1">
                            <div>
                                <div>
                                    <p class="coaches-slider-item1__header">9,3/10</p>
                                    <p class="coaches-slider-item1__text">средняя оценка<br> коучей от участников клуба</p>
                                    <p class="coaches-slider-item1__header">9,5/10</p>
                                    <p class="coaches-slider-item1__text">средняя оценка<br> CV-специалистов</p>
                                    <p class="coaches-slider-item1__header">Доступно</p>
                                    <p class="coaches-slider-item1__text">на тарифах <br>«С поддержкой»<br> и «Полное сопровождение»</p>
                                </div>
                            </div>
                        </div>
                        <div class="coaches-slider-item2">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513044873.png" alt="">
                            <p class="coaches-slider-item2__header">Елена Добринская</p>
                            <p class="coaches-slider-item2__text">Коуч ICF</p>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513075681.svg" alt="">
                                <p>6+ лет опыта</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513108788.svg" alt="">
                                <p>Помогла 1700+ клиентам обрести уверенность и подготовиться к собеседованиям </p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513122799.svg" alt="">
                                <p>Работала с<br> сотрудниками Sony,<br>  MTC, «Газпромнефть» </p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513142334.svg" alt="">
                                <p>ОАЭ</p>
                            </div>
                        </div>
                        <div class="coaches-slider-item2">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513163934.png" alt="">
                            <p class="coaches-slider-item2__header">Ирина Феокистова</p>
                            <p class="coaches-slider-item2__text">Коуч ICF</p>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513075681.svg" alt="">
                                <p>3+ года опыта </p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513108788.svg" alt="">
                                <p>Помогла 700+ клиентам получить офферы с релокацией и повышение</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513122799.svg" alt="">
                                <p>Работала с<br> сотрудниками PepsiCo и<br> «Аэрофлота»</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513142334.svg" alt="">
                                <p>Россия</p>
                            </div>
                        </div>
                        <div class="coaches-slider-item2">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513178026.png" alt="">
                            <p class="coaches-slider-item2__header">Яна Хмельницкая</p>
                            <p class="coaches-slider-item2__text">Коуч ICF</p>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513075681.svg" alt="">
                                <p>10+ лет опыта</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513108788.svg" alt="">
                                <p>Помогла 250+ клиентам с релокацией и поиском работы на международном рынке</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513122799.svg" alt="">
                                <p>Работала с<br> сотрудниками Ford, Leroy Merlin, Toyota</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513142334.svg" alt="">
                                <p>Турция</p>
                            </div>
                        </div>
                        <div class="coaches-slider-item2">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513207695.png" alt="">
                            <p class="coaches-slider-item2__header">Елена Эльзенбах</p>
                            <p class="coaches-slider-item2__text">Коуч ICF</p>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513075681.svg" alt="">
                                <p>3+ года опыта </p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513108788.svg" alt="">
                                <p>Помогла 700+ клиентам из России и Европы найти работу в ЕС, США<br> и Канаде</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513122799.svg" alt="">
                                <p>Работала с<br> сотрудниками InDriver<br> и Promwad</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513142334.svg" alt="">
                                <p>Россия</p>
                            </div>
                        </div>
                        <div class="coaches-slider-item2">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513229972.png" alt="">
                            <p class="coaches-slider-item2__header">Софи Бессон</p>
                            <p class="coaches-slider-item2__text">CV-специалист</p>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513075681.svg" alt="">
                                <p>8+ лет опыта</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513108788.svg" alt="">
                                <p>Помогла 300+ клиентам составить резюме и найти работу в Европе, США и Канаде</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513122799.svg" alt="">
                                <p>Работала с<br> сотрудниками Disney, Intel, Microsoft</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513142334.svg" alt="">
                                <p>Израиль</p>
                            </div>
                        </div>
                        <div class="coaches-slider-item2">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513254543.png" alt="">
                            <p class="coaches-slider-item2__header">Надежда Община</p>
                            <p class="coaches-slider-item2__text">CV-специалист</p>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513075681.svg" alt="">
                                <p>2+ лет опыта</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513108788.svg" alt="">
                                <p>Помогла 250+ клиентам<br> в самопрезентации и поиске работы</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513122799.svg" alt="">
                                <p>Работала с<br> сотрудниками Airbus, Hubspot, DAWESoft, Weatherford</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513142334.svg" alt="">
                                <p>Португалия</p>
                            </div>
                        </div>
                        <div class="coaches-slider-item2">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513271340.png" alt="">
                            <p class="coaches-slider-item2__header">Астра Висаева</p>
                            <p class="coaches-slider-item2__text">Коуч ICF</p>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513075681.svg" alt="">
                                <p>4+ года опыта</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513108788.svg" alt="">
                                <p>Помогла 2000+ клиентам сделать карьерную стратегию и найти работу в ЕС и США</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513122799.svg" alt="">
                                <p>Работала с<br> сотрудниками EPAM,<br> OZON</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513142334.svg" alt="">
                                <p>Россия</p>
                            </div>
                        </div>
                        <div class="coaches-slider-item2">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513287747.png" alt="">
                            <p class="coaches-slider-item2__header">Марина Веденичева</p>
                            <p class="coaches-slider-item2__text">Коуч ICF PCC</p>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513075681.svg" alt="">
                                <p>15+ лет опыта</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513108788.svg" alt="">
                                <p>Помогла 1000+ клиентам усилить лидерские качества и получить повышение</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513122799.svg" alt="">
                                <p>Работала с<br> сотрудниками Mars, Shell, Ernst & Young</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513142334.svg" alt="">
                                <p>Великобритания</p>
                            </div>
                        </div>
                        <div class="coaches-slider-item2">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513303406.png" alt="">
                            <p class="coaches-slider-item2__header">Светлана Баран</p>
                            <p class="coaches-slider-item2__text">Коуч ICF</p>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513075681.svg" alt="">
                                <p>4+ года опыта</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513108788.svg" alt="">
                                <p>Помогла 3300+ клиентам с релокацией и поиске работы на международном рынке</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513122799.svg" alt="">
                                <p>Работала с<br> сотрудниками Tesla,<br> Google, Phillips</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680513142334.svg" alt="">
                                <p>Италия</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <div>
                        <div class="club21-coaches-slider__arrow-left">
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 18 16" fill="none">
                                <path d="M2.19055 7.99935L15.8105 7.99935" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M8.46289 14.2453L2.18956 7.99862L8.46289 1.75195" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                        </div>
                        <div class="club21-coaches-slider__arrow-right">
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 18 16" fill="none">
                                <path d="M15.8095 8.00065L2.18945 8.00065" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M9.53711 1.75471L15.8104 8.00138L9.53711 14.248" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
	});
    
    blockManager.add('careerum-club21-tariffs', {
        label: 'Клуб 2.1 витрина',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-club21-tariffs">
            <div>
                <div>
                    <h2>Доступные тарифы</h2>
                    <div class="club21-tariffs__swicher-block">
                        <div class="club21-tariffs__swicher-top">
                            <p class="club21-tariffs__swicher-header">Посмотреть цены в <span>RUB<span></p>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" class="club21-tariffs__swicher-arrow">
                                    <path d="M7 9.5L12 14.5L17 9.5H7Z" fill="black"/>
                            </svg>
                        </div>
                        <div class="club21-tariffs__swicher-bottom">
                            <ul>
                                <li class="active" data-currency="RUB">
                                    RUB
                                </li>
                                <li data-currency="EUR">
                                    EUR
                                </li>
                            </ul>
                            <p>
                                Обратите внимание,<br> что оплата в российских рублях возможна только<br> с карты
                                российского банка. Оплата в евро — с карты зарубежного банка
                            </p>
                        </div>
                    </div>
                </div>
                <div class="club21-tariffs-wrapper">
                    <div class="club21-tariffs-item" data-price-EUR="от 100 €" data-price-RUB="от 8 075 ₽"
                        data-link-RUB="#rub" data-link-EUR="#eur">
                        <p class="club21-tariffs-item__header">Тариф «Самостоятельный»</p>
                        <div class="club21-tariffs-item__content">
                            <ul>
                                <li>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                        <path d="M4 9.2L6.66667 12L12 4" stroke="black" stroke-width="1.5" stroke-linecap="round"/>
                                      </svg>
                                    <p>Все программы, курсы и уроки</p>
                                </li>
                                <li>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                        <path d="M4 9.2L6.66667 12L12 4" stroke="black" stroke-width="1.5" stroke-linecap="round"/>
                                      </svg>
                                    <p>Доступ в комьюнити</p></li>
                            </ul>
                        </div>
                        <div class="club21-tariffs-item__rassr">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M2 12C2 6.47784 6.47673 2 12 2C17.5222 2 22 6.47779 22 12C22 17.5222 17.5222 22 12 22C6.47673 22 2 17.5222 2 12ZM16.0898 10.1573C16.3827 9.86439 16.3827 9.38952 16.0898 9.09662C15.7969 8.80373 15.322 8.80373 15.0291 9.09662L10.8133 13.3124L8.96967 11.4695C8.67672 11.1767 8.20184 11.1768 7.90901 11.4697C7.61618 11.7627 7.61628 12.2376 7.90924 12.5304L10.2832 14.9034C10.5761 15.1962 11.0509 15.1961 11.3438 14.9033L16.0898 10.1573Z" fill="#0B70FE"/>
                              </svg>
                            <p class="club21-tariffs-item__rassr-text">Доступно в рассрочку</p>
                        </div>
                        <div class="club21-tariffs-item__price">
                            <p class="club21-tariffs-item__price-text">до 9 900 €</p>
                            <p>в месяц</p>
                        </div>
                        <a href="#125" class="btn-color-main-dark-orange">Оформить подписку</a>
                    </div>
                    <div class="club21-tariffs-item" data-price-EUR="от 200 €" data-price-RUB="от 9 991 ₽"
                        data-link-RUB="#rub" data-link-EUR="#eur">
                        <p class="club21-tariffs-item__header">Тариф<br> «С поддержкой»</p>
                        <div class="club21-tariffs-item__label">
                            <p>популярный</p>
                        </div>
                        <div class="club21-tariffs-item__content">
                            <ul>
                                <li>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                        <path d="M4 9.2L6.66667 12L12 4" stroke="black" stroke-width="1.5" stroke-linecap="round"/>
                                      </svg>
                                    <p>Все программы, курсы и уроки</p>
                                </li>
                                <li>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                        <path d="M4 9.2L6.66667 12L12 4" stroke="black" stroke-width="1.5" stroke-linecap="round"/>
                                      </svg>
                                    <p>Доступ в комьюнити</p>
                                    </li>
                                <li>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                        <path d="M8 15C11.3137 15 14 12.3137 14 9C14 5.68629 11.3137 3 8 3C4.68629 3 2 5.68629 2 9C2 12.3137 4.68629 15 8 15Z" stroke="#FF5A00" stroke-width="1.3" stroke-miterlimit="10"/>
                                        <path d="M5.5 9H10.5" stroke="#FF5A00" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M8 6.5V11.5" stroke="#FF5A00" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
                                      </svg>
                                    <p>Поддержка коуча</p>
                                    </li>
                                <li>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                        <path d="M8 15C11.3137 15 14 12.3137 14 9C14 5.68629 11.3137 3 8 3C4.68629 3 2 5.68629 2 9C2 12.3137 4.68629 15 8 15Z" stroke="#FF5A00" stroke-width="1.3" stroke-miterlimit="10"/>
                                        <path d="M5.5 9H10.5" stroke="#FF5A00" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M8 6.5V11.5" stroke="#FF5A00" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
                                      </svg>
                                    <p>Фидбэк по вашему резюме от CV-эксперта</p>
                                    </li>
                            </ul>
                        </div>
                        <div class="club21-tariffs-item__rassr">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M2 12C2 6.47784 6.47673 2 12 2C17.5222 2 22 6.47779 22 12C22 17.5222 17.5222 22 12 22C6.47673 22 2 17.5222 2 12ZM16.0898 10.1573C16.3827 9.86439 16.3827 9.38952 16.0898 9.09662C15.7969 8.80373 15.322 8.80373 15.0291 9.09662L10.8133 13.3124L8.96967 11.4695C8.67672 11.1767 8.20184 11.1768 7.90901 11.4697C7.61618 11.7627 7.61628 12.2376 7.90924 12.5304L10.2832 14.9034C10.5761 15.1962 11.0509 15.1961 11.3438 14.9033L16.0898 10.1573Z" fill="#0B70FE"/>
                              </svg>
                            <p class="club21-tariffs-item__rassr-text">Доступно в рассрочку</p>
                        </div>
                        <div class="club21-tariffs-item__price">
                            <p class="club21-tariffs-item__price-text">от 200 €</p>
                            <p>в месяц</p>
                        </div>
                        <a href="#124" class="btn-color-main-dark-orange">Оформить подписку</a>
                    </div>
                    <div class="club21-tariffs-item" data-price-eur="от 300 €" data-price-rub="от 19 633 ₽"
                        data-link-rub="#rub" data-link-eur="#eur">
                        <p class="club21-tariffs-item__header">Тариф «Полное<br> сопровождение»</p>
                        <div class="club21-tariffs-item__content">
                            <ul>
                                <li>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                        <path d="M4 9.2L6.66667 12L12 4" stroke="black" stroke-width="1.5" stroke-linecap="round"/>
                                      </svg>
                                    <p>Все программы, курсы и уроки</p>
                                </li>
                                <li>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                        <path d="M4 9.2L6.66667 12L12 4" stroke="black" stroke-width="1.5" stroke-linecap="round"/>
                                      </svg>
                                    <p>Доступ в комьюнити</p>
                                    </li>
                                <li>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                        <path d="M4 9.2L6.66667 12L12 4" stroke="black" stroke-width="1.5" stroke-linecap="round"/>
                                      </svg>
                                    <p>Поддержка коуча</p>
                                    </li>
                                <li>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                        <path d="M4 9.2L6.66667 12L12 4" stroke="black" stroke-width="1.5" stroke-linecap="round"/>
                                      </svg>
                                    <p>Фидбэк по вашему резюме от CV-эксперта</p>
                                    </li>
                                    <li>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                            <path d="M8 15C11.3137 15 14 12.3137 14 9C14 5.68629 11.3137 3 8 3C4.68629 3 2 5.68629 2 9C2 12.3137 4.68629 15 8 15Z" stroke="#FF5A00" stroke-width="1.3" stroke-miterlimit="10"/>
                                            <path d="M5.5 9H10.5" stroke="#FF5A00" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M8 6.5V11.5" stroke="#FF5A00" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
                                          </svg>
                                        <p>2 личные сессии с коучем</p>
                                        </li>
                            </ul>
                        </div>
                        <div class="club21-tariffs-item__rassr">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M2 12C2 6.47784 6.47673 2 12 2C17.5222 2 22 6.47779 22 12C22 17.5222 17.5222 22 12 22C6.47673 22 2 17.5222 2 12ZM16.0898 10.1573C16.3827 9.86439 16.3827 9.38952 16.0898 9.09662C15.7969 8.80373 15.322 8.80373 15.0291 9.09662L10.8133 13.3124L8.96967 11.4695C8.67672 11.1767 8.20184 11.1768 7.90901 11.4697C7.61618 11.7627 7.61628 12.2376 7.90924 12.5304L10.2832 14.9034C10.5761 15.1962 11.0509 15.1961 11.3438 14.9033L16.0898 10.1573Z" fill="#0B70FE"/>
                              </svg>
                            <p class="club21-tariffs-item__rassr-text">Доступно в рассрочку</p>
                        </div>
                        <div class="club21-tariffs-item__price">
                            <p class="club21-tariffs-item__price-text">от 300 €</p>
                            <p>в месяц</p>
                        </div>
                        <a href="#123" class="btn-color-main-dark-orange">Оформить подписку</a>
                    </div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-club21-tariffs-tablet', {
        label: 'Клуб 2.1 витрина (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-club21-tariffs-tablet">
            <div>
                <div>
                    <h2>Доступные тарифы</h2>
                    <div class="club21-tariffs__swicher-block">
                        <div class="club21-tariffs__swicher-top">
                            <p class="club21-tariffs__swicher-header">Посмотреть цены в <span>RUB<span></p>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" class="club21-tariffs__swicher-arrow">
                                    <path d="M7 9.5L12 14.5L17 9.5H7Z" fill="black"/>
                            </svg>
                        </div>
                        <div class="club21-tariffs__swicher-bottom">
                            <ul>
                                <li class="active" data-currency="RUB">
                                    RUB
                                </li>
                                <li data-currency="EUR">
                                    EUR
                                </li>
                            </ul>
                            <p>
                                Обратите внимание,<br> что оплата в российских рублях возможна только<br> с карты
                                российского банка. Оплата в евро — с карты зарубежного банка
                            </p>
                        </div>
                    </div>
                </div>
                <div class="club21-tariffs-wrapper">
                    <div class="club21-tariffs-item" data-price-EUR="от 100 €" data-price-RUB="от 8 075 ₽"
                        data-link-RUB="#rub" data-link-EUR="#eur">
                        <p class="club21-tariffs-item__header">Тариф «Самостоятельный»</p>
                        <div class="club21-tariffs-item__content">
                            <ul>
                                <li>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                        <path d="M4 9.2L6.66667 12L12 4" stroke="black" stroke-width="1.5" stroke-linecap="round"/>
                                      </svg>
                                    <p>Все программы, курсы и уроки</p>
                                </li>
                                <li>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                        <path d="M4 9.2L6.66667 12L12 4" stroke="black" stroke-width="1.5" stroke-linecap="round"/>
                                      </svg>
                                    <p>Доступ в комьюнити</p></li>
                            </ul>
                        </div>
                        <div class="club21-tariffs-item__rassr">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M2 12C2 6.47784 6.47673 2 12 2C17.5222 2 22 6.47779 22 12C22 17.5222 17.5222 22 12 22C6.47673 22 2 17.5222 2 12ZM16.0898 10.1573C16.3827 9.86439 16.3827 9.38952 16.0898 9.09662C15.7969 8.80373 15.322 8.80373 15.0291 9.09662L10.8133 13.3124L8.96967 11.4695C8.67672 11.1767 8.20184 11.1768 7.90901 11.4697C7.61618 11.7627 7.61628 12.2376 7.90924 12.5304L10.2832 14.9034C10.5761 15.1962 11.0509 15.1961 11.3438 14.9033L16.0898 10.1573Z" fill="#0B70FE"/>
                              </svg>
                            <p class="club21-tariffs-item__rassr-text">Доступно в рассрочку</p>
                        </div>
                        <div class="club21-tariffs-item__price">
                            <p class="club21-tariffs-item__price-text">до 9 900 €</p>
                            <p>в месяц</p>
                        </div>
                        <a href="#125" class="btn-color-main-dark-orange">Оформить подписку</a>
                    </div>
                    <div class="club21-tariffs-item" data-price-EUR="от 200 €" data-price-RUB="от 9 991 ₽"
                        data-link-RUB="#rub" data-link-EUR="#eur">
                        <p class="club21-tariffs-item__header">Тариф<br> «С поддержкой»</p>
                        <div class="club21-tariffs-item__label">
                            <p>популярный</p>
                        </div>
                        <div class="club21-tariffs-item__content">
                            <ul>
                                <li>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                        <path d="M4 9.2L6.66667 12L12 4" stroke="black" stroke-width="1.5" stroke-linecap="round"/>
                                      </svg>
                                    <p>Все программы, курсы и уроки</p>
                                </li>
                                <li>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                        <path d="M4 9.2L6.66667 12L12 4" stroke="black" stroke-width="1.5" stroke-linecap="round"/>
                                      </svg>
                                    <p>Доступ в комьюнити</p>
                                    </li>
                                <li>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                        <path d="M8 15C11.3137 15 14 12.3137 14 9C14 5.68629 11.3137 3 8 3C4.68629 3 2 5.68629 2 9C2 12.3137 4.68629 15 8 15Z" stroke="#FF5A00" stroke-width="1.3" stroke-miterlimit="10"/>
                                        <path d="M5.5 9H10.5" stroke="#FF5A00" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M8 6.5V11.5" stroke="#FF5A00" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
                                      </svg>
                                    <p>Поддержка коуча</p>
                                    </li>
                                <li>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                        <path d="M8 15C11.3137 15 14 12.3137 14 9C14 5.68629 11.3137 3 8 3C4.68629 3 2 5.68629 2 9C2 12.3137 4.68629 15 8 15Z" stroke="#FF5A00" stroke-width="1.3" stroke-miterlimit="10"/>
                                        <path d="M5.5 9H10.5" stroke="#FF5A00" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M8 6.5V11.5" stroke="#FF5A00" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
                                      </svg>
                                    <p>Фидбэк по вашему резюме от CV-эксперта</p>
                                    </li>
                            </ul>
                        </div>
                        <div class="club21-tariffs-item__rassr">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M2 12C2 6.47784 6.47673 2 12 2C17.5222 2 22 6.47779 22 12C22 17.5222 17.5222 22 12 22C6.47673 22 2 17.5222 2 12ZM16.0898 10.1573C16.3827 9.86439 16.3827 9.38952 16.0898 9.09662C15.7969 8.80373 15.322 8.80373 15.0291 9.09662L10.8133 13.3124L8.96967 11.4695C8.67672 11.1767 8.20184 11.1768 7.90901 11.4697C7.61618 11.7627 7.61628 12.2376 7.90924 12.5304L10.2832 14.9034C10.5761 15.1962 11.0509 15.1961 11.3438 14.9033L16.0898 10.1573Z" fill="#0B70FE"/>
                              </svg>
                            <p class="club21-tariffs-item__rassr-text">Доступно в рассрочку</p>
                        </div>
                        <div class="club21-tariffs-item__price">
                            <p class="club21-tariffs-item__price-text">от 200 €</p>
                            <p>в месяц</p>
                        </div>
                        <a href="#124" class="btn-color-main-dark-orange">Оформить подписку</a>
                    </div>
                    <div class="club21-tariffs-item" data-price-eur="от 300 €" data-price-rub="от 19 633 ₽"
                        data-link-rub="#rub" data-link-eur="#eur">
                        <p class="club21-tariffs-item__header">Тариф «Полное<br> сопровождение»</p>
                        <div class="club21-tariffs-item__content">
                            <ul>
                                <li>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                        <path d="M4 9.2L6.66667 12L12 4" stroke="black" stroke-width="1.5" stroke-linecap="round"/>
                                      </svg>
                                    <p>Все программы, курсы и уроки</p>
                                </li>
                                <li>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                        <path d="M4 9.2L6.66667 12L12 4" stroke="black" stroke-width="1.5" stroke-linecap="round"/>
                                      </svg>
                                    <p>Доступ в комьюнити</p>
                                    </li>
                                <li>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                        <path d="M4 9.2L6.66667 12L12 4" stroke="black" stroke-width="1.5" stroke-linecap="round"/>
                                      </svg>
                                    <p>Поддержка коуча</p>
                                    </li>
                                <li>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                        <path d="M4 9.2L6.66667 12L12 4" stroke="black" stroke-width="1.5" stroke-linecap="round"/>
                                      </svg>
                                    <p>Фидбэк по вашему резюме от CV-эксперта</p>
                                    </li>
                                    <li>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                            <path d="M8 15C11.3137 15 14 12.3137 14 9C14 5.68629 11.3137 3 8 3C4.68629 3 2 5.68629 2 9C2 12.3137 4.68629 15 8 15Z" stroke="#FF5A00" stroke-width="1.3" stroke-miterlimit="10"/>
                                            <path d="M5.5 9H10.5" stroke="#FF5A00" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M8 6.5V11.5" stroke="#FF5A00" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
                                          </svg>
                                        <p>2 личные сессии с коучем</p>
                                        </li>
                            </ul>
                        </div>
                        <div class="club21-tariffs-item__rassr">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M2 12C2 6.47784 6.47673 2 12 2C17.5222 2 22 6.47779 22 12C22 17.5222 17.5222 22 12 22C6.47673 22 2 17.5222 2 12ZM16.0898 10.1573C16.3827 9.86439 16.3827 9.38952 16.0898 9.09662C15.7969 8.80373 15.322 8.80373 15.0291 9.09662L10.8133 13.3124L8.96967 11.4695C8.67672 11.1767 8.20184 11.1768 7.90901 11.4697C7.61618 11.7627 7.61628 12.2376 7.90924 12.5304L10.2832 14.9034C10.5761 15.1962 11.0509 15.1961 11.3438 14.9033L16.0898 10.1573Z" fill="#0B70FE"/>
                              </svg>
                            <p class="club21-tariffs-item__rassr-text">Доступно в рассрочку</p>
                        </div>
                        <div class="club21-tariffs-item__price">
                            <p class="club21-tariffs-item__price-text">от 300 €</p>
                            <p>в месяц</p>
                        </div>
                        <a href="#123" class="btn-color-main-dark-orange">Оформить подписку</a>
                    </div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-club21-tariffs-mobile', {
        label: 'Клуб 2.1 витрина (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-club21-tariffs-mobile">
            <div>
                <div>
                    <h2>Доступные<br> тарифы</h2>
                    <div class="club21-tariffs__swicher-block">
                        <div class="club21-tariffs__swicher-top">
                            <p class="club21-tariffs__swicher-header">Посмотреть цены в <span>RUB<span></p>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" class="club21-tariffs__swicher-arrow">
                                    <path d="M7 9.5L12 14.5L17 9.5H7Z" fill="black"/>
                            </svg>
                        </div>
                        <div class="club21-tariffs__swicher-bottom">
                            <ul>
                                <li class="active" data-currency="RUB">
                                    RUB
                                </li>
                                <li data-currency="EUR">
                                    EUR
                                </li>
                            </ul>
                            <p>
                                Обратите внимание,<br> что оплата в российских рублях возможна только<br> с карты
                                российского банка. Оплата в евро — с карты зарубежного банка
                            </p>
                        </div>
                    </div>
                </div>
                <div class="club21-tariffs-wrapper">
                    <div>
                        <div class="club21-tariffs-item" data-price-EUR="от 100 €" data-price-RUB="от 8 075 ₽"
                            data-link-RUB="#rub" data-link-EUR="#eur">
                            <p class="club21-tariffs-item__header">Тариф «Самостоятельный»</p>
                            <div class="club21-tariffs-item__content">
                                <ul>
                                    <li>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                            <path d="M4 9.2L6.66667 12L12 4" stroke="black" stroke-width="1.5" stroke-linecap="round"/>
                                          </svg>
                                        <p>Все программы, курсы и уроки</p>
                                    </li>
                                    <li>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                            <path d="M4 9.2L6.66667 12L12 4" stroke="black" stroke-width="1.5" stroke-linecap="round"/>
                                          </svg>
                                        <p>Доступ в комьюнити</p></li>
                                </ul>
                            </div>
                            <div class="club21-tariffs-item__rassr">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M2 12C2 6.47784 6.47673 2 12 2C17.5222 2 22 6.47779 22 12C22 17.5222 17.5222 22 12 22C6.47673 22 2 17.5222 2 12ZM16.0898 10.1573C16.3827 9.86439 16.3827 9.38952 16.0898 9.09662C15.7969 8.80373 15.322 8.80373 15.0291 9.09662L10.8133 13.3124L8.96967 11.4695C8.67672 11.1767 8.20184 11.1768 7.90901 11.4697C7.61618 11.7627 7.61628 12.2376 7.90924 12.5304L10.2832 14.9034C10.5761 15.1962 11.0509 15.1961 11.3438 14.9033L16.0898 10.1573Z" fill="#0B70FE"/>
                                  </svg>
                                <p class="club21-tariffs-item__rassr-text">Доступно в рассрочку</p>
                            </div>
                            <div class="club21-tariffs-item__price">
                                <p class="club21-tariffs-item__price-text">до 9 900 €</p>
                                <p>в месяц</p>
                            </div>
                            <a href="#125" class="btn-color-main-dark-orange">Оформить подписку</a>
                        </div>
                        <div class="club21-tariffs-item" data-price-EUR="от 200 €" data-price-RUB="от 9 991 ₽"
                            data-link-RUB="#rub" data-link-EUR="#eur">
                            <p class="club21-tariffs-item__header">Тариф<br> «С поддержкой»</p>
                            <div class="club21-tariffs-item__label">
                                <p>популярный</p>
                            </div>
                            <div class="club21-tariffs-item__content">
                                <ul>
                                    <li>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                            <path d="M4 9.2L6.66667 12L12 4" stroke="black" stroke-width="1.5" stroke-linecap="round"/>
                                          </svg>
                                        <p>Все программы, курсы и уроки</p>
                                    </li>
                                    <li>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                            <path d="M4 9.2L6.66667 12L12 4" stroke="black" stroke-width="1.5" stroke-linecap="round"/>
                                          </svg>
                                        <p>Доступ в комьюнити</p>
                                        </li>
                                    <li>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                            <path d="M8 15C11.3137 15 14 12.3137 14 9C14 5.68629 11.3137 3 8 3C4.68629 3 2 5.68629 2 9C2 12.3137 4.68629 15 8 15Z" stroke="#FF5A00" stroke-width="1.3" stroke-miterlimit="10"/>
                                            <path d="M5.5 9H10.5" stroke="#FF5A00" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M8 6.5V11.5" stroke="#FF5A00" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
                                          </svg>
                                        <p>Поддержка коуча</p>
                                        </li>
                                    <li>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                            <path d="M8 15C11.3137 15 14 12.3137 14 9C14 5.68629 11.3137 3 8 3C4.68629 3 2 5.68629 2 9C2 12.3137 4.68629 15 8 15Z" stroke="#FF5A00" stroke-width="1.3" stroke-miterlimit="10"/>
                                            <path d="M5.5 9H10.5" stroke="#FF5A00" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M8 6.5V11.5" stroke="#FF5A00" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
                                          </svg>
                                        <p>Фидбэк по вашему резюме от CV-эксперта</p>
                                        </li>
                                </ul>
                            </div>
                            <div class="club21-tariffs-item__rassr">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M2 12C2 6.47784 6.47673 2 12 2C17.5222 2 22 6.47779 22 12C22 17.5222 17.5222 22 12 22C6.47673 22 2 17.5222 2 12ZM16.0898 10.1573C16.3827 9.86439 16.3827 9.38952 16.0898 9.09662C15.7969 8.80373 15.322 8.80373 15.0291 9.09662L10.8133 13.3124L8.96967 11.4695C8.67672 11.1767 8.20184 11.1768 7.90901 11.4697C7.61618 11.7627 7.61628 12.2376 7.90924 12.5304L10.2832 14.9034C10.5761 15.1962 11.0509 15.1961 11.3438 14.9033L16.0898 10.1573Z" fill="#0B70FE"/>
                                  </svg>
                                <p class="club21-tariffs-item__rassr-text">Доступно в рассрочку</p>
                            </div>
                            <div class="club21-tariffs-item__price">
                                <p class="club21-tariffs-item__price-text">от 200 €</p>
                                <p>в месяц</p>
                            </div>
                            <a href="#124" class="btn-color-main-dark-orange">Оформить подписку</a>
                        </div>
                        <div class="club21-tariffs-item" data-price-eur="от 300 €" data-price-rub="от 19 633 ₽"
                            data-link-rub="#rub" data-link-eur="#eur">
                            <p class="club21-tariffs-item__header">Тариф «Полное<br> сопровождение»</p>
                            <div class="club21-tariffs-item__content">
                                <ul>
                                    <li>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                            <path d="M4 9.2L6.66667 12L12 4" stroke="black" stroke-width="1.5" stroke-linecap="round"/>
                                          </svg>
                                        <p>Все программы, курсы и уроки</p>
                                    </li>
                                    <li>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                            <path d="M4 9.2L6.66667 12L12 4" stroke="black" stroke-width="1.5" stroke-linecap="round"/>
                                          </svg>
                                        <p>Доступ в комьюнити</p>
                                        </li>
                                    <li>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                            <path d="M4 9.2L6.66667 12L12 4" stroke="black" stroke-width="1.5" stroke-linecap="round"/>
                                          </svg>
                                        <p>Поддержка коуча</p>
                                        </li>
                                    <li>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                            <path d="M4 9.2L6.66667 12L12 4" stroke="black" stroke-width="1.5" stroke-linecap="round"/>
                                          </svg>
                                        <p>Фидбэк по вашему резюме от CV-эксперта</p>
                                        </li>
                                        <li>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                <path d="M8 15C11.3137 15 14 12.3137 14 9C14 5.68629 11.3137 3 8 3C4.68629 3 2 5.68629 2 9C2 12.3137 4.68629 15 8 15Z" stroke="#FF5A00" stroke-width="1.3" stroke-miterlimit="10"/>
                                                <path d="M5.5 9H10.5" stroke="#FF5A00" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M8 6.5V11.5" stroke="#FF5A00" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
                                              </svg>
                                            <p>2 личные сессии с коучем</p>
                                            </li>
                                </ul>
                            </div>
                            <div class="club21-tariffs-item__rassr">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M2 12C2 6.47784 6.47673 2 12 2C17.5222 2 22 6.47779 22 12C22 17.5222 17.5222 22 12 22C6.47673 22 2 17.5222 2 12ZM16.0898 10.1573C16.3827 9.86439 16.3827 9.38952 16.0898 9.09662C15.7969 8.80373 15.322 8.80373 15.0291 9.09662L10.8133 13.3124L8.96967 11.4695C8.67672 11.1767 8.20184 11.1768 7.90901 11.4697C7.61618 11.7627 7.61628 12.2376 7.90924 12.5304L10.2832 14.9034C10.5761 15.1962 11.0509 15.1961 11.3438 14.9033L16.0898 10.1573Z" fill="#0B70FE"/>
                                  </svg>
                                <p class="club21-tariffs-item__rassr-text">Доступно в рассрочку</p>
                            </div>
                            <div class="club21-tariffs-item__price">
                                <p class="club21-tariffs-item__price-text">от 300 €</p>
                                <p>в месяц</p>
                            </div>
                            <a href="#123" class="btn-color-main-dark-orange">Оформить подписку</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
	});
    
    blockManager.add('careerum-club21-results', {
        label: 'Клуб 2.1 результаты',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-club21-results">
            <div>
                <div>
                    <h2>После Careerum наших клиентов наняли</h2>
                </div>
                <div class="careerum-result__companies">
                    <div class="companies__label">
                        <div><p>4 000+ офферов</p></div>
                    </div>
                    <div class="companies__list">
                        <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1698230119330.png" alt=""></div>
                        <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1698230122618.png" alt=""></div>
                        <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1698230124901.png" alt=""></div>
                        <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1698230128850.png" alt=""></div>
                        <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1698230136092.png" alt=""></div>
                        <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1698230197744.png" alt=""></div>
                        <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1698230200447.png" alt=""></div>
                        <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1698230202517.png" alt=""></div>
                        <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1698230204638.png" alt=""></div>
                        <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1698230206747.png" alt=""></div>
                        <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1698230208904.png" alt=""></div>
                        <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1698230211350.png" alt=""></div>
                        <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1698230213128.png" alt=""></div>
                        <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1698230215397.png" alt=""></div>
                        <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1698230217404.png" alt=""></div>
                        <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1698230219153.png" alt=""></div>
                    </div>
                </div>
                <div class="club21-results-slider">
                <div class="results-slider-item2">
                    <div class="results-slider-item2__top">
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680510295861.png" alt=""  class="results-slider-item2__top-avatar">
                            <div  class="results-slider-item2__top-ln">
                                <a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680510310279.svg" alt=""></a>
                            </div>
                        </div>
                        <div>
                            <p class="results-slider-item2__top-header">Сергей Михайлов</p>
                            <p class="results-slider-item2__top-text">Technical transfer lead, Австрия</p>
                        </div>
                    </div>
                    <div class="results-slider-item2__bottom">
                        <ul>
                            <li>Хотел найти работу проджет-менеджера в международной компании и переехать в Западную Европу</li>
                            <li>Прошел Real Me, «Звёздного кандидата», проработал резюме<br> и составил стратегию</li>
                            <li>Получил оффер c релокацией в Австрию весной 2022 года,<br> увеличил доход в 3 раза</li>
                        </ul>
                    </div>
                </div>
                <div class="results-slider-item2">
                    <div class="results-slider-item2__top">
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680510356975.png" alt=""  class="results-slider-item2__top-avatar">
                            <div  class="results-slider-item2__top-ln">
                                <a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680510310279.svg" alt=""></a>
                            </div>
                        </div>
                        <div>
                            <p class="results-slider-item2__top-header">Александра Пинчукова</p>
                            <p class="results-slider-item2__top-text">менеджер бизнес-процессов, Германия</p>
                        </div>
                    </div>
                    <div class="results-slider-item2__bottom">
                        <ul>
                            <li>Работала главным бухгалтером. Хотела найти работу в Германии и переехать</li>
                            <li>Прошла «Звёздного кандидата», курсы по LinkedIn и самооценку, работала с коучем и CV-специалистом</li>
                            <li>Получила оффер в штаб-квартиру Puma в начале 2023 года – после 3 месяцев поиска</li>
                        </ul>
                    </div>
                </div>
                <div class="results-slider-item2">
                    <div class="results-slider-item2__top">
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680510370489.png" alt=""  class="results-slider-item2__top-avatar">
                            <div  class="results-slider-item2__top-ln">
                                <a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680510310279.svg" alt=""></a>
                            </div>
                        </div>
                        <div>
                            <p class="results-slider-item2__top-header">Сергей Бухаров</p>
                            <p class="results-slider-item2__top-text">Supply Chain Forecast Analyst, Нидерланды</p>
                        </div>
                    </div>
                    <div class="results-slider-item2__bottom">
                        <ul>
                            <li>Уволился из Mars весной 2022 года, так как не смог договориться о релокации, переехал из России в Грузию</li>
                            <li>Прошел курс Real Me, персонально работал с экспертом клуба, составил стратегию</li>
                            <li>Получил оффер от Mars с релокацией в<br> Нидерланды в середине 2022 года</li>
                        </ul>
                    </div>
                </div>
                <div class="results-slider-item2">
                    <div class="results-slider-item2__top">
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680510383207.png" alt=""  class="results-slider-item2__top-avatar">
                            <div  class="results-slider-item2__top-ln">
                                <a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680510310279.svg" alt=""></a>
                            </div>
                        </div>
                        <div>
                            <p class="results-slider-item2__top-header">Карина Пысина</p>
                            <p class="results-slider-item2__top-text">бизнес-аналитик, Россия</p>
                        </div>
                    </div>
                    <div class="results-slider-item2__bottom">
                        <ul>
                            <li>Пыталась перейти в бизнес-анализ из клиентского отдела, но не смогла и уволилась вникуда</li>
                            <li>Прошла Real Me, «Звёздного кандидата», работала с коучем, составила продающее резюме</li>
                            <li>Получила оффер бизнес-аналитика, зарплату на 100% выше в 2022 году</li>
                        </ul>
                    </div>
                </div>
                <div class="results-slider-item2">
                    <div class="results-slider-item2__top">
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680510392778.png" alt=""  class="results-slider-item2__top-avatar">
                            <div  class="results-slider-item2__top-ln">
                                <a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680510310279.svg" alt=""></a>
                            </div>
                        </div>
                        <div>
                            <p class="results-slider-item2__top-header">Тая Штоль</p>
                            <p class="results-slider-item2__top-text">UX/UI-дизайнер, Испания</p>
                        </div>
                    </div>
                    <div class="results-slider-item2__bottom">
                        <ul>
                            <li>Потеряла всех клиентов из России в феврале 2022 года. Хотела в найм, но опыт был только во фрилансе</li>
                            <li>Прошла программы «Звёздный кандидат» и «Выход из декрета», работала с коучем</li>
                            <li>Получила оффер в немецкую компанию. Увеличила доход в 6 раз, получила соцпакет</li>
                        </ul>
                    </div>
                </div>
                <div class="results-slider-item2">
                    <div class="results-slider-item2__top">
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680510407061.png" alt=""  class="results-slider-item2__top-avatar">
                            <div  class="results-slider-item2__top-ln">
                                <a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680510310279.svg" alt=""></a>
                            </div>
                        </div>
                        <div>
                            <p class="results-slider-item2__top-header">Евгения Вольхина</p>
                            <p class="results-slider-item2__top-text">Project Manager, Германия</p>
                        </div>
                    </div>
                    <div class="results-slider-item2__bottom">
                        <ul>
                            <li>Работала консультантом-методологом в Екатеринбурге. Хотела стать project manager в Германии</li>
                            <li>Прошла «Звёздного кандидата», прокачала CV, выстроила нетворк</li>
                            <li>Получила оффер в Big4 в Москве и зарплату в 3,5 раза больше, потом – оффер в Германию с ростом ещё на 40%</li>
                        </ul>
                    </div>
                </div>
                <div class="results-slider-item2">
                    <div class="results-slider-item2__top">
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680510418438.png" alt=""  class="results-slider-item2__top-avatar">
                            <div  class="results-slider-item2__top-ln">
                                <a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680510310279.svg" alt=""></a>
                            </div>
                        </div>
                        <div>
                            <p class="results-slider-item2__top-header">Олег Федоткин</p>
                            <p class="results-slider-item2__top-text">Head of Department, Германия</p>
                        </div>
                    </div>
                    <div class="results-slider-item2__bottom">
                        <ul>
                            <li>Не мог найти работу в Германии, не хотел возвращаться в Москву после окончания контракта Henkel</li>
                            <li>Прошел Real Me, составил стратегию, прорабатывал запрос в паре с участником клуба</li>
                            <li>Получил оффер на head-позицию с ростом зарплаты на 30% в начале 2022 года</li>
                        </ul>
                    </div>
                </div>
                <div class="results-slider-item2">
                    <div class="results-slider-item2__top">
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680510428678.png" alt=""  class="results-slider-item2__top-avatar">
                            <div  class="results-slider-item2__top-ln">
                                <a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680510310279.svg" alt=""></a>
                            </div>
                        </div>
                        <div>
                            <p class="results-slider-item2__top-header">Людмила Киселёва</p>
                            <p class="results-slider-item2__top-text">Recruiter ll, США</p>
                        </div>
                    </div>
                    <div class="results-slider-item2__bottom">
                        <ul>
                            <li>Приехала в США как турист, осталась там, работала ассистентом. Хотела начать карьеру<br> в корпорации</li>
                            <li>Прошла курсы<br> «Продающее резюме» и «Эффективное<br> интервью».</li>
                            <li>Получила оффер ассистента в Microsoft, через год стала рекрутером в Transocean</li>
                        </ul>
                    </div>
                </div>
                </div>
                <div>
                    <div>
                        <div class="club21-results-slider__arrow-left">
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 18 16" fill="none">
                                <path d="M2.19055 7.99935L15.8105 7.99935" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M8.46289 14.2453L2.18956 7.99862L8.46289 1.75195" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                        </div>
                        <div class="club21-results-slider__arrow-right">
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 18 16" fill="none">
                                <path d="M15.8095 8.00065L2.18945 8.00065" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M9.53711 1.75471L15.8104 8.00138L9.53711 14.248" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-club21-results-tablet', {
        label: 'Клуб 2.1 результаты (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-club21-results-tablet">
            <div>
            <div>
                <h2>После Careerum наших клиентов наняли</h2>
            </div>
            <div class="careerum-result__companies">
                <div class="companies__label">
                    <div><p>4 000+ офферов</p></div>
                </div>
                <div class="companies__list">
                    <div></div>
                    <div></div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1698230119330.png" alt=""></div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1698230122618.png" alt=""></div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1698230124901.png" alt=""></div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1698230128850.png" alt=""></div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1698230136092.png" alt=""></div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1698230197744.png" alt=""></div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1698230200447.png" alt=""></div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1698230202517.png" alt=""></div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1698230204638.png" alt=""></div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1698230206747.png" alt=""></div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1698230208904.png" alt=""></div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1698230211350.png" alt=""></div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1698230213128.png" alt=""></div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1698230215397.png" alt=""></div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1698230217404.png" alt=""></div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1698230219153.png" alt=""></div>
                </div>
            </div>
                <div class="club21-results-slider">
                    <div class="results-slider-item2">
                        <div class="results-slider-item2__top">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680510295861.png" alt=""  class="results-slider-item2__top-avatar">
                                <div  class="results-slider-item2__top-ln">
                                    <a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680510310279.svg" alt=""></a>
                                </div>
                            </div>
                            <div>
                                <p class="results-slider-item2__top-header">Сергей Михайлов</p>
                                <p class="results-slider-item2__top-text">Technical transfer lead, Австрия</p>
                            </div>
                        </div>
                        <div class="results-slider-item2__bottom">
                            <ul>
                                <li>Хотел найти работу проджет-менеджера в международной компании и переехать в Западную Европу</li>
                                <li>Прошел Real Me, «Звёздного кандидата», проработал резюме<br> и составил стратегию</li>
                                <li>Получил оффер c релокацией в Австрию весной 2022 года,<br> увеличил доход в 3 раза</li>
                            </ul>
                        </div>
                    </div>
                    <div class="results-slider-item2">
                        <div class="results-slider-item2__top">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680510356975.png" alt=""  class="results-slider-item2__top-avatar">
                                <div  class="results-slider-item2__top-ln">
                                    <a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680510310279.svg" alt=""></a>
                                </div>
                            </div>
                            <div>
                                <p class="results-slider-item2__top-header">Александра Пинчукова</p>
                                <p class="results-slider-item2__top-text">менеджер бизнес-процессов, Германия</p>
                            </div>
                        </div>
                        <div class="results-slider-item2__bottom">
                            <ul>
                                <li>Работала главным бухгалтером. Хотела найти работу в Германии и переехать</li>
                                <li>Прошла «Звёздного кандидата», курсы по LinkedIn и самооценку, работала с коучем и CV-специалистом</li>
                                <li>Получила оффер в штаб-квартиру Puma в начале 2023 года – после 3 месяцев поиска</li>
                            </ul>
                        </div>
                    </div>
                    <div class="results-slider-item2">
                        <div class="results-slider-item2__top">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680510370489.png" alt=""  class="results-slider-item2__top-avatar">
                                <div  class="results-slider-item2__top-ln">
                                    <a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680510310279.svg" alt=""></a>
                                </div>
                            </div>
                            <div>
                                <p class="results-slider-item2__top-header">Сергей Бухаров</p>
                                <p class="results-slider-item2__top-text">Supply Chain Forecast Analyst, Нидерланды</p>
                            </div>
                        </div>
                        <div class="results-slider-item2__bottom">
                            <ul>
                                <li>Уволился из Mars весной 2022 года, так как не смог договориться о релокации, переехал из России в Грузию</li>
                                <li>Прошел курс Real Me, персонально работал с экспертом клуба, составил стратегию</li>
                                <li>Получил оффер от Mars с релокацией в<br> Нидерланды в середине 2022 года</li>
                            </ul>
                        </div>
                    </div>
                    <div class="results-slider-item2">
                        <div class="results-slider-item2__top">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680510383207.png" alt=""  class="results-slider-item2__top-avatar">
                                <div  class="results-slider-item2__top-ln">
                                    <a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680510310279.svg" alt=""></a>
                                </div>
                            </div>
                            <div>
                                <p class="results-slider-item2__top-header">Карина Пысина</p>
                                <p class="results-slider-item2__top-text">бизнес-аналитик, Россия</p>
                            </div>
                        </div>
                        <div class="results-slider-item2__bottom">
                            <ul>
                                <li>Пыталась перейти в бизнес-анализ из клиентского отдела, но не смогла и уволилась вникуда</li>
                                <li>Прошла Real Me, «Звёздного кандидата», работала с коучем, составила продающее резюме</li>
                                <li>Получила оффер бизнес-аналитика, зарплату на 100% выше в 2022 году</li>
                            </ul>
                        </div>
                    </div>
                    <div class="results-slider-item2">
                        <div class="results-slider-item2__top">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680510392778.png" alt=""  class="results-slider-item2__top-avatar">
                                <div  class="results-slider-item2__top-ln">
                                    <a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680510310279.svg" alt=""></a>
                                </div>
                            </div>
                            <div>
                                <p class="results-slider-item2__top-header">Тая Штоль</p>
                                <p class="results-slider-item2__top-text">UX/UI-дизайнер, Испания</p>
                            </div>
                        </div>
                        <div class="results-slider-item2__bottom">
                            <ul>
                                <li>Потеряла всех клиентов из России в феврале 2022 года. Хотела в найм, но опыт был только во фрилансе</li>
                                <li>Прошла программы «Звёздный кандидат» и «Выход из декрета», работала с коучем</li>
                                <li>Получила оффер в немецкую компанию. Увеличила доход в 6 раз, получила соцпакет</li>
                            </ul>
                        </div>
                    </div>
                    <div class="results-slider-item2">
                        <div class="results-slider-item2__top">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680510407061.png" alt=""  class="results-slider-item2__top-avatar">
                                <div  class="results-slider-item2__top-ln">
                                    <a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680510310279.svg" alt=""></a>
                                </div>
                            </div>
                            <div>
                                <p class="results-slider-item2__top-header">Евгения Вольхина</p>
                                <p class="results-slider-item2__top-text">Project Manager, Германия</p>
                            </div>
                        </div>
                        <div class="results-slider-item2__bottom">
                            <ul>
                                <li>Работала консультантом-методологом в Екатеринбурге. Хотела стать project manager в Германии</li>
                                <li>Прошла «Звёздного кандидата», прокачала CV, выстроила нетворк</li>
                                <li>Получила оффер в Big4 в Москве и зарплату в 3,5 раза больше, потом – оффер в Германию с ростом ещё на 40%</li>
                            </ul>
                        </div>
                    </div>
                    <div class="results-slider-item2">
                        <div class="results-slider-item2__top">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680510418438.png" alt=""  class="results-slider-item2__top-avatar">
                                <div  class="results-slider-item2__top-ln">
                                    <a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680510310279.svg" alt=""></a>
                                </div>
                            </div>
                            <div>
                                <p class="results-slider-item2__top-header">Олег Федоткин</p>
                                <p class="results-slider-item2__top-text">Head of Department, Германия</p>
                            </div>
                        </div>
                        <div class="results-slider-item2__bottom">
                            <ul>
                                <li>Не мог найти работу в Германии, не хотел возвращаться в Москву после окончания контракта Henkel</li>
                                <li>Прошел Real Me, составил стратегию, прорабатывал запрос в паре с участником клуба</li>
                                <li>Получил оффер на head-позицию с ростом зарплаты на 30% в начале 2022 года</li>
                            </ul>
                        </div>
                    </div>
                    <div class="results-slider-item2">
                        <div class="results-slider-item2__top">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680510428678.png" alt=""  class="results-slider-item2__top-avatar">
                                <div  class="results-slider-item2__top-ln">
                                    <a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680510310279.svg" alt=""></a>
                                </div>
                            </div>
                            <div>
                                <p class="results-slider-item2__top-header">Людмила Киселёва</p>
                                <p class="results-slider-item2__top-text">Recruiter ll, США</p>
                            </div>
                        </div>
                        <div class="results-slider-item2__bottom">
                            <ul>
                                <li>Приехала в США как турист, осталась там, работала ассистентом. Хотела начать карьеру<br> в корпорации</li>
                                <li>Прошла курсы<br> «Продающее резюме» и «Эффективное<br> интервью».</li>
                                <li>Получила оффер ассистента в Microsoft, через год стала рекрутером в Transocean</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div>
                    <div>
                        <div class="club21-results-slider__arrow-left">
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 18 16" fill="none">
                                <path d="M2.19055 7.99935L15.8105 7.99935" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M8.46289 14.2453L2.18956 7.99862L8.46289 1.75195" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                        </div>
                        <div class="club21-results-slider__arrow-right">
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 18 16" fill="none">
                                <path d="M15.8095 8.00065L2.18945 8.00065" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M9.53711 1.75471L15.8104 8.00138L9.53711 14.248" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-club21-results-mobile', {
        label: 'Клуб 2.1 результаты (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-club21-results-mobile">
            <div>
            <div>
                <h2>После Careerum наших клиентов наняли</h2>
            </div>
            <div class="careerum-result__companies">
                <div class="companies__label">
                    <div><p>4 000+ офферов</p></div>
                </div>
                <div class="companies__list">
                    <div></div>
                    <div></div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1698230119330.png" alt=""></div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1698230122618.png" alt=""></div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1698230124901.png" alt=""></div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1698230128850.png" alt=""></div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1698230136092.png" alt=""></div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1698230197744.png" alt=""></div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1698230200447.png" alt=""></div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1698230202517.png" alt=""></div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1698230204638.png" alt=""></div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1698230206747.png" alt=""></div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1698230208904.png" alt=""></div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1698230211350.png" alt=""></div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1698230213128.png" alt=""></div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1698230215397.png" alt=""></div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1698230217404.png" alt=""></div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1698230219153.png" alt=""></div>
                </div>
            </div>
                <div class="club21-results-slider">
                    <div class="results-slider-item2">
                        <div class="results-slider-item2__top">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680510295861.png" alt=""  class="results-slider-item2__top-avatar">
                                <div  class="results-slider-item2__top-ln">
                                    <a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680510310279.svg" alt=""></a>
                                </div>
                            </div>
                            <div>
                                <p class="results-slider-item2__top-header">Сергей Михайлов</p>
                                <p class="results-slider-item2__top-text">Technical transfer lead, Австрия</p>
                            </div>
                        </div>
                        <div class="results-slider-item2__bottom">
                            <ul>
                                <li>Хотел найти работу проджет-менеджера в международной компании и переехать в Западную Европу</li>
                                <li>Прошел Real Me, «Звёздного кандидата», проработал резюме<br> и составил стратегию</li>
                                <li>Получил оффер c релокацией в Австрию весной 2022 года,<br> увеличил доход в 3 раза</li>
                            </ul>
                        </div>
                    </div>
                    <div class="results-slider-item2">
                        <div class="results-slider-item2__top">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680510356975.png" alt=""  class="results-slider-item2__top-avatar">
                                <div  class="results-slider-item2__top-ln">
                                    <a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680510310279.svg" alt=""></a>
                                </div>
                            </div>
                            <div>
                                <p class="results-slider-item2__top-header">Александра Пинчукова</p>
                                <p class="results-slider-item2__top-text">менеджер бизнес-процессов, Германия</p>
                            </div>
                        </div>
                        <div class="results-slider-item2__bottom">
                            <ul>
                                <li>Работала главным бухгалтером. Хотела найти работу в Германии и переехать</li>
                                <li>Прошла «Звёздного кандидата», курсы по LinkedIn и самооценку, работала с коучем и CV-специалистом</li>
                                <li>Получила оффер в штаб-квартиру Puma в начале 2023 года – после 3 месяцев поиска</li>
                            </ul>
                        </div>
                    </div>
                    <div class="results-slider-item2">
                        <div class="results-slider-item2__top">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680510370489.png" alt=""  class="results-slider-item2__top-avatar">
                                <div  class="results-slider-item2__top-ln">
                                    <a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680510310279.svg" alt=""></a>
                                </div>
                            </div>
                            <div>
                                <p class="results-slider-item2__top-header">Сергей Бухаров</p>
                                <p class="results-slider-item2__top-text">Supply Chain Forecast Analyst, Нидерланды</p>
                            </div>
                        </div>
                        <div class="results-slider-item2__bottom">
                            <ul>
                                <li>Уволился из Mars весной 2022 года, так как не смог договориться о релокации, переехал из России в Грузию</li>
                                <li>Прошел курс Real Me, персонально работал с экспертом клуба, составил стратегию</li>
                                <li>Получил оффер от Mars с релокацией в<br> Нидерланды в середине 2022 года</li>
                            </ul>
                        </div>
                    </div>
                    <div class="results-slider-item2">
                        <div class="results-slider-item2__top">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680510383207.png" alt=""  class="results-slider-item2__top-avatar">
                                <div  class="results-slider-item2__top-ln">
                                    <a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680510310279.svg" alt=""></a>
                                </div>
                            </div>
                            <div>
                                <p class="results-slider-item2__top-header">Карина Пысина</p>
                                <p class="results-slider-item2__top-text">бизнес-аналитик, Россия</p>
                            </div>
                        </div>
                        <div class="results-slider-item2__bottom">
                            <ul>
                                <li>Пыталась перейти в бизнес-анализ из клиентского отдела, но не смогла и уволилась вникуда</li>
                                <li>Прошла Real Me, «Звёздного кандидата», работала с коучем, составила продающее резюме</li>
                                <li>Получила оффер бизнес-аналитика, зарплату на 100% выше в 2022 году</li>
                            </ul>
                        </div>
                    </div>
                    <div class="results-slider-item2">
                        <div class="results-slider-item2__top">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680510392778.png" alt=""  class="results-slider-item2__top-avatar">
                                <div  class="results-slider-item2__top-ln">
                                    <a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680510310279.svg" alt=""></a>
                                </div>
                            </div>
                            <div>
                                <p class="results-slider-item2__top-header">Тая Штоль</p>
                                <p class="results-slider-item2__top-text">UX/UI-дизайнер, Испания</p>
                            </div>
                        </div>
                        <div class="results-slider-item2__bottom">
                            <ul>
                                <li>Потеряла всех клиентов из России в феврале 2022 года. Хотела в найм, но опыт был только во фрилансе</li>
                                <li>Прошла программы «Звёздный кандидат» и «Выход из декрета», работала с коучем</li>
                                <li>Получила оффер в немецкую компанию. Увеличила доход в 6 раз, получила соцпакет</li>
                            </ul>
                        </div>
                    </div>
                    <div class="results-slider-item2">
                        <div class="results-slider-item2__top">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680510407061.png" alt=""  class="results-slider-item2__top-avatar">
                                <div  class="results-slider-item2__top-ln">
                                    <a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680510310279.svg" alt=""></a>
                                </div>
                            </div>
                            <div>
                                <p class="results-slider-item2__top-header">Евгения Вольхина</p>
                                <p class="results-slider-item2__top-text">Project Manager, Германия</p>
                            </div>
                        </div>
                        <div class="results-slider-item2__bottom">
                            <ul>
                                <li>Работала консультантом-методологом в Екатеринбурге. Хотела стать project manager в Германии</li>
                                <li>Прошла «Звёздного кандидата», прокачала CV, выстроила нетворк</li>
                                <li>Получила оффер в Big4 в Москве и зарплату в 3,5 раза больше, потом – оффер в Германию с ростом ещё на 40%</li>
                            </ul>
                        </div>
                    </div>
                    <div class="results-slider-item2">
                        <div class="results-slider-item2__top">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680510418438.png" alt=""  class="results-slider-item2__top-avatar">
                                <div  class="results-slider-item2__top-ln">
                                    <a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680510310279.svg" alt=""></a>
                                </div>
                            </div>
                            <div>
                                <p class="results-slider-item2__top-header">Олег Федоткин</p>
                                <p class="results-slider-item2__top-text">Head of Department, Германия</p>
                            </div>
                        </div>
                        <div class="results-slider-item2__bottom">
                            <ul>
                                <li>Не мог найти работу в Германии, не хотел возвращаться в Москву после окончания контракта Henkel</li>
                                <li>Прошел Real Me, составил стратегию, прорабатывал запрос в паре с участником клуба</li>
                                <li>Получил оффер на head-позицию с ростом зарплаты на 30% в начале 2022 года</li>
                            </ul>
                        </div>
                    </div>
                    <div class="results-slider-item2">
                        <div class="results-slider-item2__top">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680510428678.png" alt=""  class="results-slider-item2__top-avatar">
                                <div  class="results-slider-item2__top-ln">
                                    <a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680510310279.svg" alt=""></a>
                                </div>
                            </div>
                            <div>
                                <p class="results-slider-item2__top-header">Людмила Киселёва</p>
                                <p class="results-slider-item2__top-text">Recruiter ll, США</p>
                            </div>
                        </div>
                        <div class="results-slider-item2__bottom">
                            <ul>
                                <li>Приехала в США как турист, осталась там, работала ассистентом. Хотела начать карьеру<br> в корпорации</li>
                                <li>Прошла курсы<br> «Продающее резюме» и «Эффективное<br> интервью».</li>
                                <li>Получила оффер ассистента в Microsoft, через год стала рекрутером в Transocean</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div>
                    <div>
                        <div class="club21-results-slider__arrow-left">
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 18 16" fill="none">
                                <path d="M2.19055 7.99935L15.8105 7.99935" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M8.46289 14.2453L2.18956 7.99862L8.46289 1.75195" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                        </div>
                        <div class="club21-results-slider__arrow-right">
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 18 16" fill="none">
                                <path d="M15.8095 8.00065L2.18945 8.00065" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M9.53711 1.75471L15.8104 8.00138L9.53711 14.248" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
	});
    
    blockManager.add('careerum-club21-faq', {
        label: 'Клуб 2.1 FAQ',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-club21-faq">
            <div>
                <div>
                    <h2>Популярные<br> вопросы</h2>
                </div>
                <div>
                    <div>
                        <div class="club21-faq-header">
                            <p>Как устроен Careerum?</p> 
                            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="12" viewBox="0 0 22 12" fill="none">
                                <path d="M1 1L11 11L21 1" stroke="#827F7C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                              </svg>
                        </div>
                        <div class="club21-faq-content">
                            <p>
                                Careerum состоит из двух платформ — образовательной и нетворкинговой. Поэтому, став участником Careerum, вы будете решать карьерные вопросы системно: не только учиться, но и посещать мероприятия, чтобы выстраивать нетворк с русскоязычными профессионалами из больше чем 30 стран.
                            </p>
                        </div>
                    </div>
                    <div>
                        <div class="club21-faq-header">
                            <p>Что дает подписка на Careerum?</p> 
                            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="12" viewBox="0 0 22 12" fill="none">
                                <path d="M1 1L11 11L21 1" stroke="#827F7C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                              </svg>
                        </div>
                        <div class="club21-faq-content">
                            <p>
                                Оформив подписку, вы становитесь частью крупнейшего сообщества о карьере среди русскоязычных профессионалов и получаете доступ:</p>
                            <ul>
                                <li>ко всем обучающим материалам Careerum продолжительностью более 350 часов;</li>
                                <li>к собственной нетворкинговой платфоме, где участники из 28 стран общаются и строят нетворк;</li>
                                <li>ко всем онлайн- и офлайн-мероприятиям, которые регулярно проходят в клубе;</li>
                                <li>к тематическим фокус-кэмпам, где за несколько недель вы в интерактивном формате сможете прицельно прокачать определенный карьерный навык.</li>
                            </ul>  
                            <p>
                                Таким образом, вы не только пройдёте обучение, но и создадите сеть знакомств, которая поможет успешному развитию вашей карьеры.
                            </p>
                        </div>
                    </div>
                    <div>
                            <div class="club21-faq-header">
                                <p>Как понять, какой тариф мне подойдет?</p> 
                                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="12" viewBox="0 0 22 12" fill="none">
                                    <path d="M1 1L11 11L21 1" stroke="#827F7C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                  </svg>
                            </div>
                            <div class="club21-faq-content">
                                <p>
                                    При выборе тарифа мы советуем опираться на вашу карьерную ситуацию.</p>
                                <p>Если вы хотите глубоко и системно проработать ваш вопрос и прийти к цели с персональной поддержкой коуча, выбирайте тариф «Полное сопровождение». Кроме всех опций, которые есть на двух других тарифах, в него входит две 50-минутные видеосессии с коучем в месяц.</p>
                                <p>Если вы хотите получать прицельную и точечную поддержку в процессе обучения, вам подойдет тариф «С поддержкой». Помимо всего, что входит в тариф «Самостоятельный», вы получите возможность задавать вопросы коучу в чате, чтобы получить подробную текстовую рекомендацию.</p>
                                <p>Если у вас уже есть карьерная цель, но необходимы знания и поддержка сильного сообщества, вам подойдет тариф «Самостоятельный». На этом тарифе вы сможете неограниченно выбирать обучающие программы, строить нетворк и участвовать в мероприятиях клуба. Взаимодействие с коучем на тарифе «Самостоятельный» не предусмотрено.
                                </p>
                            </div>
                    </div>
                    <div>
                        <div class="club21-faq-header">
                            <p>Нужно ли отдельно покупать выбранные курсы, если у меня есть подписка?</p> 
                            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="12" viewBox="0 0 22 12" fill="none">
                                <path d="M1 1L11 11L21 1" stroke="#827F7C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                              </svg>
                        </div>
                        <div class="club21-faq-content">
                            <p>
                                Дополнительно платить за курсы не нужно. Оформив подписку на Careerum, вы сразу получаете доступ:
                            </p>
                            <ul>
                                <li>ко всем курсам и мастер-классам (350+ часов обучающих материалов);</li>
                                <li>к нетворк-платформе, где можно знакомиться, общаться и обмениваться опытом с другими клубовцами;</li>
                                <li>ко всем онлайн- и офлайн-мероприятиям, которые регулярно проходят в клубе;</li>
                                <li>к тематическим фокус-кэмпам – это интерактивный формат Careerum, где вы не просто изучаете теорию, но отрабатываете знания на практике, а также общаетесь в комфортной и безопасной среде с единомышленниками.</li>
                            </ul>
                        </div>
                    </div>
                    <div>
                        <div class="club21-faq-header">
                            <p>
                                Можно ли купить курсы отдельно от подписки на Careerum?
                            </p> 
                            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="12" viewBox="0 0 22 12" fill="none">
                                <path d="M1 1L11 11L21 1" stroke="#827F7C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                              </svg>
                        </div>
                        <div class="club21-faq-content">
                            <p>
                                Да, два курса и одну программу вы можете купить отдельно прямо сейчас, кликнув на название:
                            </p>
                            <ul>
                                <li>
                                    курс «Продающее резюме», благодаря которому, вы создадите сильное продающее CV на двух языках;</li>
                                <li>курс «Эффективное интервью», где вы узнаете, как отвечать даже на самые сложные вопросы рекрутеров;</li>
                                <li>программу «Международная карьера и релокация», где вы поймете,как выбрать страну и составите четкий план поиска работы на международном рынке.</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-club21-faq-tablet', {
        label: 'Клуб 2.1 FAQ (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-club21-faq-tablet">
            <div>
                <div>
                    <h2>Популярные<br> вопросы</h2>
                </div>
                <div>
                    <div>
                        <div class="club21-faq-header">
                            <p>Как устроен Careerum?</p> 
                            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="12" viewBox="0 0 22 12" fill="none">
                                <path d="M1 1L11 11L21 1" stroke="#827F7C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                              </svg>
                        </div>
                        <div class="club21-faq-content">
                            <p>
                                Careerum состоит из двух платформ — образовательной и нетворкинговой. Поэтому, став участником Careerum, вы будете решать карьерные вопросы системно: не только учиться, но и посещать мероприятия, чтобы выстраивать нетворк с русскоязычными профессионалами из больше чем 30 стран.
                            </p>
                        </div>
                    </div>
                    <div>
                        <div class="club21-faq-header">
                            <p>Что дает подписка на Careerum?</p> 
                            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="12" viewBox="0 0 22 12" fill="none">
                                <path d="M1 1L11 11L21 1" stroke="#827F7C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                              </svg>
                        </div>
                        <div class="club21-faq-content">
                            <p>
                                Оформив подписку, вы становитесь частью крупнейшего сообщества о карьере среди русскоязычных профессионалов и получаете доступ:</p>
                            <ul>
                                <li>ко всем обучающим материалам Careerum продолжительностью более 350 часов;</li>
                                <li>к собственной нетворкинговой платфоме, где участники из 28 стран общаются и строят нетворк;</li>
                                <li>ко всем онлайн- и офлайн-мероприятиям, которые регулярно проходят в клубе;</li>
                                <li>к тематическим фокус-кэмпам, где за несколько недель вы в интерактивном формате сможете прицельно прокачать определенный карьерный навык.</li>
                            </ul>  
                            <p>
                                Таким образом, вы не только пройдёте обучение, но и создадите сеть знакомств, которая поможет успешному развитию вашей карьеры.
                            </p>
                        </div>
                    </div>
                    <div>
                            <div class="club21-faq-header">
                                <p>Как понять, какой тариф мне подойдет?</p> 
                                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="12" viewBox="0 0 22 12" fill="none">
                                    <path d="M1 1L11 11L21 1" stroke="#827F7C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                  </svg>
                            </div>
                            <div class="club21-faq-content">
                                <p>
                                    При выборе тарифа мы советуем опираться на вашу карьерную ситуацию.</p>
                                <p>Если вы хотите глубоко и системно проработать ваш вопрос и прийти к цели с персональной поддержкой коуча, выбирайте тариф «Полное сопровождение». Кроме всех опций, которые есть на двух других тарифах, в него входит две 50-минутные видеосессии с коучем в месяц.</p>
                                <p>Если вы хотите получать прицельную и точечную поддержку в процессе обучения, вам подойдет тариф «С поддержкой». Помимо всего, что входит в тариф «Самостоятельный», вы получите возможность задавать вопросы коучу в чате, чтобы получить подробную текстовую рекомендацию.</p>
                                <p>Если у вас уже есть карьерная цель, но необходимы знания и поддержка сильного сообщества, вам подойдет тариф «Самостоятельный». На этом тарифе вы сможете неограниченно выбирать обучающие программы, строить нетворк и участвовать в мероприятиях клуба. Взаимодействие с коучем на тарифе «Самостоятельный» не предусмотрено.
                                </p>
                            </div>
                    </div>
                    <div>
                        <div class="club21-faq-header">
                            <p>Нужно ли отдельно покупать выбранные курсы, если у меня есть подписка?</p> 
                            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="12" viewBox="0 0 22 12" fill="none">
                                <path d="M1 1L11 11L21 1" stroke="#827F7C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                              </svg>
                        </div>
                        <div class="club21-faq-content">
                            <p>
                                Дополнительно платить за курсы не нужно. Оформив подписку на Careerum, вы сразу получаете доступ:
                            </p>
                            <ul>
                                <li>ко всем курсам и мастер-классам (350+ часов обучающих материалов);</li>
                                <li>к нетворк-платформе, где можно знакомиться, общаться и обмениваться опытом с другими клубовцами;</li>
                                <li>ко всем онлайн- и офлайн-мероприятиям, которые регулярно проходят в клубе;</li>
                                <li>к тематическим фокус-кэмпам – это интерактивный формат Careerum, где вы не просто изучаете теорию, но отрабатываете знания на практике, а также общаетесь в комфортной и безопасной среде с единомышленниками.</li>
                            </ul>
                        </div>
                    </div>
                    <div>
                        <div class="club21-faq-header">
                            <p>
                                Можно ли купить курсы отдельно от подписки на Careerum?
                            </p> 
                            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="12" viewBox="0 0 22 12" fill="none">
                                <path d="M1 1L11 11L21 1" stroke="#827F7C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                              </svg>
                        </div>
                        <div class="club21-faq-content">
                            <p>
                                Да, два курса и одну программу вы можете купить отдельно прямо сейчас, кликнув на название:
                            </p>
                            <ul>
                                <li>
                                    курс «Продающее резюме», благодаря которому, вы создадите сильное продающее CV на двух языках;</li>
                                <li>курс «Эффективное интервью», где вы узнаете, как отвечать даже на самые сложные вопросы рекрутеров;</li>
                                <li>программу «Международная карьера и релокация», где вы поймете,как выбрать страну и составите четкий план поиска работы на международном рынке.</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div> `
	});

    blockManager.add('careerum-club21-faq-mobile', {
        label: 'Клуб 2.1 FAQ (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-club21-faq-mobile">
            <div>
                <div>
                    <h2>Популярные вопросы</h2>
                </div>
                <div>
                    <div>
                        <div class="club21-faq-header">
                            <p>Как устроен Careerum?</p> 
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="10" viewBox="0 0 16 10" fill="none">
    <path d="M1 1.5L8 8.5L15 1.5" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
                        </div>
                        <div class="club21-faq-content">
                            <p>
                                Careerum состоит из двух платформ — образовательной и нетворкинговой. Поэтому, став участником Careerum, вы будете решать карьерные вопросы системно: не только учиться, но и посещать мероприятия, чтобы выстраивать нетворк с русскоязычными профессионалами из больше чем 30 стран.
                            </p>
                        </div>
                    </div>
                    <div>
                        <div class="club21-faq-header">
                            <p>Что дает подписка на Careerum?</p> 
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="10" viewBox="0 0 16 10" fill="none">
    <path d="M1 1.5L8 8.5L15 1.5" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
                        </div>
                        <div class="club21-faq-content">
                            <p>
                                Оформив подписку, вы становитесь частью крупнейшего сообщества о карьере среди русскоязычных профессионалов и получаете доступ:</p>
                            <ul>
                                <li>ко всем обучающим материалам Careerum продолжительностью более 350 часов;</li>
                                <li>к собственной нетворкинговой платфоме, где участники из 28 стран общаются и строят нетворк;</li>
                                <li>ко всем онлайн- и офлайн-мероприятиям, которые регулярно проходят в клубе;</li>
                                <li>к тематическим фокус-кэмпам, где за несколько недель вы в интерактивном формате сможете прицельно прокачать определенный карьерный навык.</li>
                            </ul>  
                            <p>
                                Таким образом, вы не только пройдёте обучение, но и создадите сеть знакомств, которая поможет успешному развитию вашей карьеры.
                            </p>
                        </div>
                    </div>
                    <div>
                            <div class="club21-faq-header">
                                <p>Как понять, какой тариф мне подойдет?</p> 
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="10" viewBox="0 0 16 10" fill="none">
                                    <path d="M1 1.5L8 8.5L15 1.5" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                            </div>
                            <div class="club21-faq-content">
                                <p>
                                    При выборе тарифа мы советуем опираться на вашу карьерную ситуацию.</p>
                                <p>Если вы хотите глубоко и системно проработать ваш вопрос и прийти к цели с персональной поддержкой коуча, выбирайте тариф «Полное сопровождение». Кроме всех опций, которые есть на двух других тарифах, в него входит две 50-минутные видеосессии с коучем в месяц.</p>
                                <p>Если вы хотите получать прицельную и точечную поддержку в процессе обучения, вам подойдет тариф «С поддержкой». Помимо всего, что входит в тариф «Самостоятельный», вы получите возможность задавать вопросы коучу в чате, чтобы получить подробную текстовую рекомендацию.</p>
                                <p>Если у вас уже есть карьерная цель, но необходимы знания и поддержка сильного сообщества, вам подойдет тариф «Самостоятельный». На этом тарифе вы сможете неограниченно выбирать обучающие программы, строить нетворк и участвовать в мероприятиях клуба. Взаимодействие с коучем на тарифе «Самостоятельный» не предусмотрено.
                                </p>
                            </div>
                    </div>
                    <div>
                        <div class="club21-faq-header">
                            <p>Нужно ли отдельно покупать выбранные курсы, если у меня есть подписка?</p> 
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="10" viewBox="0 0 16 10" fill="none">
    <path d="M1 1.5L8 8.5L15 1.5" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
                        </div>
                        <div class="club21-faq-content">
                            <p>
                                Дополнительно платить за курсы не нужно. Оформив подписку на Careerum, вы сразу получаете доступ:
                            </p>
                            <ul>
                                <li>ко всем курсам и мастер-классам (350+ часов обучающих материалов);</li>
                                <li>к нетворк-платформе, где можно знакомиться, общаться и обмениваться опытом с другими клубовцами;</li>
                                <li>ко всем онлайн- и офлайн-мероприятиям, которые регулярно проходят в клубе;</li>
                                <li>к тематическим фокус-кэмпам – это интерактивный формат Careerum, где вы не просто изучаете теорию, но отрабатываете знания на практике, а также общаетесь в комфортной и безопасной среде с единомышленниками.</li>
                            </ul>
                        </div>
                    </div>
                    <div>
                        <div class="club21-faq-header">
                            <p>
                                Можно ли купить курсы отдельно от подписки на Careerum?
                            </p> 
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="10" viewBox="0 0 16 10" fill="none">
    <path d="M1 1.5L8 8.5L15 1.5" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
                        </div>
                        <div class="club21-faq-content">
                            <p>
                                Да, два курса и одну программу вы можете купить отдельно прямо сейчас, кликнув на название:
                            </p>
                            <ul>
                                <li>
                                    курс «Продающее резюме», благодаря которому, вы создадите сильное продающее CV на двух языках;</li>
                                <li>курс «Эффективное интервью», где вы узнаете, как отвечать даже на самые сложные вопросы рекрутеров;</li>
                                <li>программу «Международная карьера и релокация», где вы поймете,как выбрать страну и составите четкий план поиска работы на международном рынке.</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div> `
	});
    
    blockManager.add('careerum-club21-popup-block-info', {
        label: 'Клуб 2.1 попап инфо',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-popup careerum-club21-popup-block-info" id="126">
            <div class="popup__close-button-wrapper">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680514187058.svg" alt="" class="close-switch">
            </div>
            <div class="careerum-club21-popup-wrapper">
                <div>
                    <div class="club21-popup-header">
                        <p class="club21-popup-header-text">Образование</p>
                        <p class="club21-popup-header-header">Актуальный<br> образовательный контент</p>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1691834899366.svg" alt="">
                    </div>
                    <div class="club21-popup-blocks">
                        <div>
                            <p class="club21-popup-block-header">Формат:</p>
                            <p class="club21-popup-block-text">вебинары, живые
                                эфиры и подкасты</p>
                            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="16" viewBox="0 0 22 16" fill="none">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M15.2969 11.5383C15.3778 13.3704 13.8992 14.9196 11.9946 14.9975C11.8543 15.0034 5.01531 14.9896 5.01531 14.9896C3.11996 15.1335 1.46115 13.7715 1.31165 11.9463C1.30039 11.8103 1.30346 4.47219 1.30346 4.47219C1.21949 2.63815 2.69604 1.08499 4.60163 1.00418C4.74396 0.997278 11.5738 1.01009 11.5738 1.01009C13.4783 0.868176 15.1423 2.24001 15.2897 4.07405C15.3 4.2061 15.2969 11.5383 15.2969 11.5383Z" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M15.3 5.97984L18.593 3.28484C19.409 2.61684 20.633 3.19884 20.632 4.25184L20.62 11.6008C20.619 12.6538 19.394 13.2308 18.58 12.5628L15.3 9.86784" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </div>
                        <div>
                            <p class="club21-popup-block-header">Авторы и ведущие: </p>
                            <p class="club21-popup-block-text">эксперты с опытом работы в Microsoft, Google, EY и др.</p>
                            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="18" viewBox="0 0 22 18" fill="none">
                                <path d="M16.8876 7.8977C18.2826 7.7017 19.3566 6.5057 19.3596 5.0567C19.3596 3.6287 18.3186 2.4447 16.9536 2.2207" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M18.7284 11.25C20.0794 11.452 21.0224 11.925 21.0224 12.9C21.0224 13.571 20.5784 14.007 19.8604 14.281" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M10.8867 11.6641C7.67273 11.6641 4.92773 12.1511 4.92773 14.0961C4.92773 16.0401 7.65573 16.5411 10.8867 16.5411C14.1007 16.5411 16.8447 16.0591 16.8447 14.1131C16.8447 12.1671 14.1177 11.6641 10.8867 11.6641Z" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M10.8867 8.888C12.9957 8.888 14.7057 7.179 14.7057 5.069C14.7057 2.96 12.9957 1.25 10.8867 1.25C8.77766 1.25 7.06766 2.96 7.06766 5.069C7.05966 7.171 8.75666 8.881 10.8587 8.888H10.8867Z" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M4.88496 7.8977C3.48896 7.7017 2.41596 6.5057 2.41296 5.0567C2.41296 3.6287 3.45396 2.4447 4.81896 2.2207" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M3.04388 11.25C1.69288 11.452 0.749878 11.925 0.749878 12.9C0.749878 13.571 1.19388 14.007 1.91188 14.281" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                              </svg>
                        </div>
                    </div>
                    <div class="club21-popup-text">
                        <p>Обучающая платформа с вебинарами, курсами и мастер-классами по актуальным запросам</p>
                        <p class="club21-poppup-text-header">Среди тем: </p>
                        <ul>
                            <li><svg xmlns="http://www.w3.org/2000/svg" width="12" height="14" viewBox="0 0 12 14" fill="none">
                                <path d="M2.23438 9.6809L5.07406 12.1656L10.7534 5.06641" stroke="black" stroke-width="1.5" stroke-linecap="round"/>
                              </svg><p>как найти себя в жизни и работе</p></li>
                            <li><svg xmlns="http://www.w3.org/2000/svg" width="12" height="14" viewBox="0 0 12 14" fill="none">
                                <path d="M2.23438 9.6809L5.07406 12.1656L10.7534 5.06641" stroke="black" stroke-width="1.5" stroke-linecap="round"/>
                              </svg><p>вырасти в зарплате и должности</p></li>
                            <li><svg xmlns="http://www.w3.org/2000/svg" width="12" height="14" viewBox="0 0 12 14" fill="none">
                                <path d="M2.23438 9.6809L5.07406 12.1656L10.7534 5.06641" stroke="black" stroke-width="1.5" stroke-linecap="round"/>
                              </svg><p>переехать и устроиться в солидную компанию</p></li>
                            <li><svg xmlns="http://www.w3.org/2000/svg" width="12" height="14" viewBox="0 0 12 14" fill="none">
                                <path d="M2.23438 9.6809L5.07406 12.1656L10.7534 5.06641" stroke="black" stroke-width="1.5" stroke-linecap="round"/>
                              </svg><p>а также многие другие</p></li>
                        </ul>
                    </div>
                    <div class="club21-popup-button">
                        <a href="#form" class="close-switch btn-color-main-dark-orange">Вступить в Careerum</a>
                    </div>
                </div>
            </div>
        </div>`
	});
    
    blockManager.add('careerum-club21-banner', {
        label: 'Клуб 2.1 баннер',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-club21-banner">
            <div>
                <div>
                    <h2><span>Фокус-кэмп сезона</span> Beyond Borders: поиск работы без границ</h2>
                    <p class="club21-banner__subheader">7 сентября — 29 октября</p>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1692178433965.svg" alt="">
                    <p>Узнайте, как запустить поиск<br> работы в любой точке мира<br> с экспертами Careerum</p>
                    <a href="#" class="btn-color-main-bright-orange">Хочу на фокус-кэмп</a>
                </div>
                <div>
                    <div>
                        <div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1692178482877.svg" alt="">
                                <p>Еженедельные эфиры с международными экспертами</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1692178487100.svg" alt="">
                                <p>Много практики: индивидуальной<br> и в группах</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1692178490581.svg" alt="">
                                <p>Короткие информативные видеолекции на русском и английском</p>
                            </div>
                        </div>
                        <div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1692178537447.svg" alt="">
                                <p>Прожарка резюме и профилей LinkedIn с действующими рекрутерами</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1692178540021.svg" alt="">
                                <p>Доступен только для участников Careerum<br><br>
                                </p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1692178537447.svg" alt="">
                                <p>Рекомендуем приобрести подписку от 3 месяцев</p>
                            </div>
                        </div>
                    </div>
                    <div>
                        <p>После фокус-кэмпа вы:</p>
                        <ul>
                            <li>составите план действий для поиска работы</li>
                            <li>составите резюме и сопроводительное под целевую страну</li>
                            <li>перейдете с LinkedIn на «ты»</li>
                            <li>научитесь отвечать даже на каверзные вопросы рекрутеров</li>
                            <li>оптимизируете процесс поиска с помощью нейросетей</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-club21-banner-tablet', {
        label: 'Клуб 2.1 баннер (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-club21-banner-tablet">
            <div>
                <div>
                    <h2><span>Фокус-кэмп сезона</span><br> Beyond Borders: поиск работы<br> без границ</h2>
                    <p class="club21-banner__subheader">7 сентября — 29 октября</p>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1692178436937.svg" alt="">
                    <p>Узнайте, как запустить поиск работы в любой точке<br> мира с экспертами Careerum</p>
                </div>
                <div>
                    <div>
                        <p>После фокус-кэмпа вы:</p>
                        <ul>
                            <li>составите план действий для поиска работы</li>
                            <li>составите резюме<br> и сопроводительное<br> под целевую страну</li>
                            <li>перейдете с LinkedIn на «ты»</li>
                            <li>научитесь отвечать даже на каверзные вопросы рекрутеров</li>
                            <li>оптимизируете процесс поиска с помощью нейросетей</li>
                        </ul>
                    </div>
                    <div>
                        <div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1692178482877.svg" alt="">
                                <p>Еженедельные эфиры с международными экспертами</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1692178487100.svg" alt="">
                                <p>Много практики: индивидуальной<br> и в группах</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1692178490581.svg" alt="">
                                <p>Короткие информативные видеолекции на русском<br> и английском</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1692178537447.svg" alt="">
                                <p>Прожарка резюме и профилей LinkedIn с действующими рекрутерами</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1692178540021.svg" alt="">
                                <p>Доступен только для<br> участников Careerum
                                </p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1692178537447.svg" alt="">
                                <p>Рекомендуем приобрести подписку от 3 месяцев</p>
                            </div>
                        </div>
                    </div>
                </div>
                <a href="#" class="btn-color-main-bright-orange">Хочу на фокус-кэмп</a>
            </div>
        </div>`
	});

    blockManager.add('careerum-club21-banner-mobile', {
        label: 'Клуб 2.1 баннер (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-club21-banner-mobile">
            <div>
                <div>
                    <h2><span>Фокус-кэмп сезона</span><br> Beyond Borders: поиск работы<br> без границ</h2>
                    <p class="club21-banner__subheader">7 сентября — 29 октября</p>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1692178439940.svg" alt="">
                    <p>Узнайте, как запустить поиск работы в любой точке мира<br> с экспертами Careerum</p>
                </div>
                <div>
                    <div>
                        <div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1692178482877.svg" alt="">
                                <p>Еженедельные эфиры с международными экспертами</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1692178487100.svg" alt="">
                                <p>Много практики: индивидуальной<br> и в группах</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1692178490581.svg" alt="">
                                <p>Короткие информативные видеолекции на русском<br> и английском</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1692178537447.svg" alt="">
                                <p>Прожарка резюме и профилей LinkedIn с действующими рекрутерами</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1692178540021.svg" alt="">
                                <p>Доступен только для участников<br> Careerum
                                </p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1692178537447.svg" alt="">
                                <p>Рекомендуем приобрести подписку от 3 месяцев</p>
                            </div>
                        </div>
                    </div>
                    <div>
                        <p>После фокус-кэмпа вы:</p>
                        <ul class="slider">
                            <li>составите план действий для<br> поиска работы</li>
                            <li>составите резюме<br> и сопроводительное<br> под целевую страну</li>
                            <li>перейдете с LinkedIn на «ты»</li>
                            <li>научитесь отвечать даже на каверзные вопросы рекрутеров</li>
                            <li>оптимизируете процесс поиска<br> с помощью нейросетей</li>
                        </ul>
                        <div class="club21-banner-arrows">
                            <div>
                                <div class="club21-banner-slider__arrow-right">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 18 16" fill="none">
                                        <path d="M15.8095 8.00065L2.18945 8.00065" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M9.53711 1.75471L15.8104 8.00138L9.53711 14.248" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <a href="#" class="btn-color-main-bright-orange">Хочу на фокус-кэмп</a>
            </div>
        </div>`
	});
    
    blockManager.add('careerum-club21-popup-block-tariffs', {
        label: 'Клуб 2.1 попап вейт',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-popup careerum-club2-popup-block-tariffs">
            <div class="popup__close-button-wrapper">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1680514187058.svg" alt="" class="close-switch">
            </div>
            <div class="careerum-club2-popup-wrapper">
                <div class="careerum-form-lead">
                    <div>
                        <p class="popup-block-tariffs__header">Место в клубе забронировано</p>
                        <div class="popup-block-tariffs__divider"></div>
                        <p class="popup-block-tariffs__text">Уже сейчас вы можете бесплатно решить, какой тариф вас интересует. А&nbsp;мы&nbsp;сообщим, когда именно там появится свободное место!</p>
                    </div>
                    <div>
                        <form class="deva-form getcourse-email-signup" name="devaRegistrationForm"
                        data-gjs-type="deva-registration-form">
                            <div class="popup-tariff__items-wrapper">
                                <div class="popup-tariff__item" gc-group="Вейтлист Т1">
                                    <div class="popup-tariff__item-header"><p>Самостоятельный</p></div>
                                    <div class="popup-tariff__item-subheader"></div>
                                    <ul>
                                        <li>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                            <path d="M4 9.2L6.66667 12L12 4" stroke="black" stroke-width="1.5" stroke-linecap="round"/>
                                            </svg>
                                            <p>Все программы, курсы и уроки</p>
                                        </li>
                                        <li>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                            <path d="M4 9.2L6.66667 12L12 4" stroke="black" stroke-width="1.5" stroke-linecap="round"/>
                                            </svg>
                                            <p>Онлайн и офлайн мероприятия</p>
                                        </li>
                                        <li>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                            <path d="M4 9.2L6.66667 12L12 4" stroke="black" stroke-width="1.5" stroke-linecap="round"/>
                                            </svg>
                                            <p>Доступ в комьюнити</p>
                                        </li>
                                    </ul>
                                </div>
                                <div class="popup-tariff__item" gc-group="Вейтлист Т2">
                                    <div class="popup-tariff__item-header"><p>С поддержкой</p></div>
                                    <div class="popup-tariff__item-subheader"><p>Все, что и на тарифе «Самостоятельный»</p></div>
                                    <ul>
                                        <li>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                <path d="M8 15C11.3137 15 14 12.3137 14 9C14 5.68629 11.3137 3 8 3C4.68629 3 2 5.68629 2 9C2 12.3137 4.68629 15 8 15Z" stroke="#FF5A00" stroke-width="1.3" stroke-miterlimit="10"/>
                                                <path d="M5.5 9H10.5" stroke="#FF5A00" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M8 6.5V11.5" stroke="#FF5A00" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
                                            </svg>
                                            <p>Поддержка коуча</p>
                                        </li>
                                        <li>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                            <path d="M8 15C11.3137 15 14 12.3137 14 9C14 5.68629 11.3137 3 8 3C4.68629 3 2 5.68629 2 9C2 12.3137 4.68629 15 8 15Z" stroke="#FF5A00" stroke-width="1.3" stroke-miterlimit="10"/>
                                            <path d="M5.5 9H10.5" stroke="#FF5A00" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M8 6.5V11.5" stroke="#FF5A00" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
                                          </svg>
                                          <p>Фидбэк вашему резюме от CV-эксперта</p>
                                        </li>
                                    </ul>
                                </div>
                                <div class="popup-tariff__item" gc-group="Вейтлист Т3">
                                    <div class="popup-tariff__item-header"><p>Полное сопровождение</p></div>
                                    <div class="popup-tariff__item-subheader"><p>Все, что и на предыдущих тарифах</p></div>
                                    <ul>
                                        <li>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                <path d="M8 15C11.3137 15 14 12.3137 14 9C14 5.68629 11.3137 3 8 3C4.68629 3 2 5.68629 2 9C2 12.3137 4.68629 15 8 15Z" stroke="#FF5A00" stroke-width="1.3" stroke-miterlimit="10"/>
                                                <path d="M5.5 9H10.5" stroke="#FF5A00" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M8 6.5V11.5" stroke="#FF5A00" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
                                            </svg>
                                            <p>2 личные сессии с коучем в месяц</p>
                                        </li>
                                    </ul>
                                </div>
                                <div class="popup-tariff__item" gc-group="Карьерный клуб: вейтлист">
                                    <div class="popup-tariff__item-header"><p>Все тарифы</p></div>
                                    <div class="popup-tariff__item-subheader"><p>Хочу узнавать про свободные места на каждом тарифе</p></div>
                                </div>
                            </div>
                            <a href="#" disabled class="submit-btn btn-desc">Выбрать</a>
                            <input hidden type="text" name="firstname">
                            <input hidden type="text" name="lastname">
                            <input hidden type="text" name="email">
                            <input hidden type="text" name="tel">
                        </form>
                    </div>
                </div>
    
                <div class="careerum-form-success-lead">
                    <div>
                        <p>Первый шаг<br>к карьере мечты сделан</p>
                        <p>Вы получите письмо с приглашением на интересующий тариф раньше всех!</p>
                        <button class="btn-color-main-dark-orange close-switch">Вернуться на страницу клуба</button>
                    </div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1695123998982.svg" alt="" class="form-img-desctop">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1695124074996.svg" alt="" class="form-img-tablet">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1695124168894.svg" alt="" class="form-img-mobile">
                    <button class="btn-color-main-dark-orange close-switch button-adaptive">Вернуться на страницу клуба</button>
                </div>
            </div>
        </div>`
	});
    
    blockManager.add('careerum-veb20-main', {
        label: 'Веб 2.0 main',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-veb20-main">
            <div>
                <div class="veb20-main__top">
                    <div>Бесплатный вебинар</div>
                    <div class="veb20-main__top-block">Подарок участникам: карта-маршрут для самоопределения</div>
                </div>
                <div class="veb20-main__header">
                    <h1>На своем месте:<br>
                        из точки А в точку Б<br> к карьере в удовольствие</h1>
                </div>
                <div class="veb20-main__date-author">
                    <div><span>Дата:</span> 18 ноября в 13:00 МСК</div>
                    <div><span>Автор и ведущая:</span> Ольга Лермонтова</div>
                </div>
                <div class="veb20-main__button">
                    <a href="#" class="btn-color-main-dark-orange">Зарегистрироваться на вебинар</a>
                </div>
                <div class="veb20-main__bottom">
                    <div>
                        <div>Точно ли я занимаюсь своим делом?</div>
                    </div>
                    <div>
                        <div>Стоит ли менять компанию?</div>
                        <div>Зачем мне все это?</div>
                    </div>
                    <div>
                        <div>Как зарабатывать больше?</div>
                        <div>Как быть востребованным?</div>
                    </div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-veb20-main-tablet', {
        label: 'Веб 2.0 main (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-veb20-main-tablet">
            <div>
                <div class="veb20-main__top">
                    <div>Бесплатный вебинар</div>
                    <div class="veb20-main__top-block">Подарок участникам: карта-маршрут для самоопределения</div>
                </div>
                <div class="veb20-main__header">
                    <h1>На своем месте:<br>
                        из точки А в точку Б<br> к карьере<br> в удовольствие</h1>
                </div>
                <div class="veb20-main__date-author">
                    <div><span>Дата:</span> 18 ноября в 13:00 МСК</div>
                    <div><span>Автор и ведущая:</span> Ольга Лермонтова</div>
                </div>
                <div class="veb20-main__button">
                    <a href="#" class="btn-color-main-dark-orange">Зарегистрироваться на вебинар</a>
                </div>
                <div class="veb20-main__bottom">
                    <div>
                        <div>Зачем мне все это?</div>
                    </div>
                    <div>
                        <div>Стоит ли менять компанию?</div>
                        <div>Точно ли я занимаюсь своим делом?</div>
                    </div>
                    <div>
                        <div>Как быть востребованным?</div>
                        <div>Как зарабатывать больше?</div>
                    </div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-veb20-main-mobile', {
        label: 'Веб 2.0 main (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-veb20-main-mobile">
            <div>
                <div class="veb20-main__top">
                    <div>Бесплатный вебинар</div>
                </div>
                <div class="veb20-main__header">
                    <h1>На своем месте:<br>
                        из точки А в точку Б<br> к карьере<br> в удовольствие</h1>
                </div>
                <div class="veb20-main__date-author">
                    <div><span>Дата:</span> 18 ноября в 13:00 МСК</div>
                    <div><span>Автор и ведущая:</span> Ольга Лермонтова</div>
                </div>
                <div class="veb20-main__top-block">Подарок участникам: карта-маршрут для самоопределения</div>
                <div class="veb20-main__button">
                    <a href="#" class="btn-color-main-dark-orange">Зарегистрироваться на вебинар</a>
                </div>
                <div class="veb20-main__bottom">
                    <div>
                        <div>Зачем мне все это?</div>
                    </div>
                    <div>
                        <div>Точно ли я занимаюсь своим делом?</div>
                        <div>Стоит ли менять компанию?</div>
                    </div>
                    <div>
                        <div>Как зарабатывать больше?</div>
                        <div>Как быть востребованным?</div>
                    </div>
                </div>
            </div>
        </div>`
	});
    
    blockManager.add('careerum-veb20-about', {
        label: 'Веб 2.0 about',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-veb20-about">
            <div>
                <div class="veb20-about__top">
                    <div>
                        <div class="veb20-about__header">
                            Вебинар для вас, если вы
                        </div>
                        <ul>
                            <li>
                                <svg xmlns="http://www.w3.org/2000/svg" width="40" height="48" viewBox="0 0 40 48" fill="none">
                                    <path d="M14.7616 38.8545C12.7438 38.9873 10.9739 38.9873 9.25703 38.6333C5.73485 37.9032 3.20829 35.7483 1.5357 32.6465C0.664004 31.027 0.243661 29.2349 0.11534 27.3587C-0.203248 22.81 0.106491 18.3144 1.44279 13.9692C2.19502 11.5178 3.39414 9.16379 5.08886 7.18146C6.26587 5.80091 7.93847 5.10624 9.7438 5.04871C11.6111 4.98676 13.1111 4.38941 14.3456 2.94691C18.4917 -1.88944 25.1467 -0.150504 28.6954 3.69468C31.5937 6.83632 33.2131 10.624 34.2751 14.6904C34.514 15.6019 35.045 16.2745 35.5672 17.04C37.1601 19.3454 38.5716 21.8144 38.5849 24.7393C38.5938 26.8057 37.4079 28.4783 36.0273 29.7747C31.0848 34.412 25.421 37.7704 18.5669 38.7306C17.8766 38.828 17.1687 38.8324 16.4695 38.8501C15.8147 38.8678 15.1554 38.8501 14.7616 38.8501V38.8545ZM29.8591 10.478C28.8547 7.66823 27.4564 5.53987 25.0758 4.15931C23.7794 3.40709 22.4033 3.07523 20.9165 3.49559C20.5802 3.58851 20.1731 3.68144 20.1731 4.11508C20.1731 4.52659 20.5537 4.70358 20.8944 4.7788C23.6909 5.41156 25.7927 7.1859 27.9078 8.96026C28.452 9.42044 28.7175 10.2169 29.8591 10.4824V10.478ZM19.297 23.7746C20.4342 21.3719 21.1776 18.7878 23.2041 16.5665C20.9607 17.071 18.7793 21.2879 19.297 23.7746ZM7.61986 27.0888C7.53579 27.111 7.45617 27.1331 7.37209 27.1552C7.37209 27.8809 7.34993 28.6066 7.38533 29.3278C7.3986 29.6022 7.43404 30.0093 7.86767 29.9385C8.19069 29.8854 8.1774 29.5402 8.12873 29.3012C7.97828 28.5623 7.79243 27.8278 7.61986 27.0933V27.0888ZM35.5274 25.8587C36.0274 25.5268 36.2309 25.1508 36.045 24.6286C36.0229 24.5711 35.7707 24.5092 35.7176 24.5578C35.3238 24.903 35.1955 25.31 35.5274 25.8587Z" fill="black"/>
                                    </svg>
                                <p><span>Находитесь в состоянии постоянного напряжения,</span> испытываете усталость при малейших задачах</p>
                            </li>
                            <li>
                                <svg xmlns="http://www.w3.org/2000/svg" width="40" height="48" viewBox="0 0 40 48" fill="none">
                                    <path d="M0.0508162 11.2227C-0.174971 7.60557 0.371439 4.80581 1.29717 2.08282C1.60875 1.17064 2.06035 0.0417045 3.12607 0.00106275C4.20985 -0.039579 4.66138 1.09385 5.11747 1.95636C5.57356 2.82339 5.70908 3.77622 5.28009 4.67485C3.50088 8.40034 3.67699 12.311 4.14211 16.2442C4.2821 17.4454 4.50789 18.6421 5.22138 19.6626C5.49233 20.0465 5.74067 20.611 6.33224 20.4574C6.83349 20.3265 6.84703 19.7845 6.94637 19.351C7.51536 16.8674 8.01212 14.3611 8.67142 11.9046C9.42555 9.08223 10.7938 6.59855 13.2323 4.83741C13.3768 4.73355 13.5123 4.58457 13.6794 4.54393C16.4791 3.7898 18.9808 2.30407 21.6632 1.279C24.8107 0.0732948 27.4027 1.79833 29.0916 4.12394C30.8753 6.58051 32.4333 9.19967 33.1558 12.2252C33.4629 13.5122 34.1447 14.5689 35.2917 15.3591C36.5832 16.2487 37.3329 17.6125 37.8296 19.0665C38.385 20.6922 37.4909 21.9295 36.4703 23.0359C34.3931 25.2847 31.8146 26.9195 29.3941 28.7483C26.7615 30.7443 23.8579 31.7242 20.5117 31.3223C19.008 31.1417 17.6442 30.6223 16.3572 29.9043C15.6618 29.516 14.9844 29.2857 14.1987 29.3534C11.9363 29.5521 10.0171 28.8206 8.6443 27.0143C7.37989 25.357 5.56007 24.3365 4.15567 22.8327C3.05383 21.6541 2.22293 20.3761 1.7262 18.8769C0.823047 16.1584 -0.134325 13.4489 0.0553364 11.2227H0.0508162ZM13.86 20.2362C13.9639 20.8729 13.6613 21.7354 14.4515 22.1192C15.0521 22.4127 15.6799 22.1102 16.1676 21.6676C16.5559 21.3064 16.5695 20.787 16.6191 20.2993C16.7772 18.7685 17.2152 17.3325 17.9874 15.9913C18.1996 15.6256 18.6738 15.2237 18.2809 14.8037C17.888 14.3792 17.3416 14.6366 16.9216 14.8895C14.9212 16.0816 13.9323 17.8744 13.8555 20.2316L13.86 20.2362ZM21.3697 8.5042C20.322 8.44549 19.4686 8.48166 18.8228 9.16353C18.3712 9.6422 18.4164 10.0847 19.1118 10.2247C19.8976 10.3828 20.7013 10.5318 21.4961 10.5273C22.2773 10.5273 22.9592 10.008 23.0044 9.25835C23.0631 8.31907 22.1238 8.65774 21.5864 8.50872C21.4645 8.47259 21.32 8.5042 21.3697 8.5042ZM25.5784 5.47415C25.5467 5.46512 25.5106 5.45611 25.479 5.44708C25.4745 5.47869 25.4519 5.52383 25.4655 5.54189C25.4835 5.56447 25.5287 5.56445 25.5603 5.57348C25.5648 5.54187 25.5738 5.50576 25.5784 5.47415Z" fill="black"/>
                                    </svg>
                                <p><span>Застряли на месте:</span> не верите, что заслуживаете большего в карьере<br> и жизни</p>
                            </li>
                            <li>
                                <svg xmlns="http://www.w3.org/2000/svg" width="40" height="50" viewBox="0 0 40 50" fill="none">
                                    <path d="M22.908 10.3334C22.6422 11.5514 23.0482 12.9047 24.6045 14.2387C27.0646 16.346 29.0704 18.9462 31.1196 21.4788C35.1844 26.5054 34.6431 33.1608 31.3903 38.081C28.1037 43.0495 23.459 46.4909 17.8525 48.458C14.8558 49.5116 11.8447 49.5503 8.9351 47.6073C5.43101 45.2729 2.25559 42.7451 0.97962 38.5547C-0.214188 34.6398 -0.286705 30.6572 0.597776 26.6408C1.1826 23.9728 2.22662 21.5514 3.90375 19.4054C5.55672 17.2933 5.62919 14.5722 6.71666 12.2377C8.59196 8.21645 10.8829 4.50937 14.1792 1.48376C14.9429 0.787776 15.837 0.32864 16.8278 0.115978C18.2971 -0.203016 19.5441 0.106283 20.4914 1.41609C22.2893 3.91004 23.3527 6.59735 22.9128 10.3286L22.908 10.3334ZM7.41268 41.3821L7.44649 41.3483C7.52382 41.7929 7.47064 42.3246 8.09412 42.4309C8.29229 42.4647 8.50981 42.3487 8.48081 42.1409C8.40347 41.6286 7.90079 41.6093 7.54313 41.4208C7.50446 41.4014 7.45617 41.3869 7.40784 41.3773L7.41268 41.3821ZM20.3222 8.97527C20.2207 8.11979 20.1144 6.88249 19.9163 5.65968C19.8099 4.98303 19.8776 4.12756 19.0124 3.85689C18.1521 3.58623 17.5383 4.18073 17.0115 4.71239C14.8607 6.89217 13.0095 9.31362 11.4774 11.9622C11.1197 12.5761 10.4479 13.4073 10.9748 14.0357C11.4291 14.577 12.3232 14.0598 13.0047 13.9197C15.2425 13.4653 17.1758 12.0106 19.5538 11.9767C20.0999 11.9671 20.3222 11.4741 20.3271 10.9376C20.3271 10.4108 20.3271 9.88876 20.3271 8.98011L20.3222 8.97527ZM24.2082 22.5808C23.9278 22.6098 23.3043 22.5277 23.111 22.9916C22.8258 23.6635 23.633 23.6151 23.9375 23.9051C24.1453 24.1033 24.3725 24.2773 24.5899 24.461C24.8461 24.6785 25.1023 24.9346 25.4696 24.693C25.7355 24.519 25.7693 24.2193 25.7838 23.9342C25.837 22.9627 25.3633 22.518 24.213 22.5808H24.2082ZM22.3473 27.7669C22.6325 27.7041 22.9467 27.6268 22.9419 27.2594C22.937 26.9018 22.6808 26.7664 22.3473 26.8341C22.038 26.9018 21.8205 27.1241 21.8157 27.4334C21.8157 27.7379 22.0912 27.7765 22.3473 27.7669ZM15.1507 35.0651C15.0637 34.9394 15.0008 34.7751 14.9235 34.7654C14.8268 34.7557 14.6673 34.8524 14.6238 34.9491C14.5465 35.1231 14.5949 35.3164 14.8317 35.3067C14.9283 35.3067 15.0202 35.1665 15.1459 35.0651H15.1507Z" fill="black"/>
                                    </svg>
                                <p><span>Не отделяете работу от личной жизни,</span> даже за ужином<br> обсуждаете вопросы в чатах</p>
                            </li>
                            <li>
                                <svg xmlns="http://www.w3.org/2000/svg" width="40" height="48" viewBox="0 0 40 48" fill="none">
                                    <path d="M15.6652 0.273912C16.4738 0.209051 17.2911 0.18312 18.0953 0.0706945C20.6422 -0.283877 22.5966 0.714939 24.1836 2.62617C24.8365 3.41747 25.4722 4.2261 26.164 4.98713C27.0029 5.90815 28.0017 6.56108 29.3249 6.28001C30.0729 6.12002 30.5615 6.42702 30.9853 6.96752C31.3269 7.40425 31.595 7.93611 32.0231 8.26473C35.0974 10.6257 36.386 13.9897 37.3805 17.5441C38.3232 20.9082 37.5319 23.7751 35.0715 26.2441C30.8296 30.4947 26.1251 34.1874 21.3427 37.7936C19.3839 39.2681 17.611 40.9026 16.1884 42.9263C15.155 44.3965 14.4285 44.3272 13.3 42.9003C12.7335 42.1825 12.3011 41.4085 12.0417 40.5351C11.5228 38.8055 9.74557 37.9925 8.02028 38.6887C7.78246 38.7838 7.56195 38.9179 7.33277 39.039C5.80639 39.8389 5.56859 39.7265 5.30482 38.0574C5.20537 37.4347 4.90698 36.9591 4.40972 36.557C0.665095 33.5561 -0.511045 29.552 0.193774 24.9772C0.544022 22.7027 0.729979 20.5018 0.27163 18.2317C-0.398596 14.9151 0.513754 11.8451 2.13959 8.99553C4.63457 4.61527 8.07652 1.37656 13.2351 0.399326C13.6545 0.321493 14.0826 0.269607 14.5063 0.239339C14.8912 0.213394 15.276 0.23501 15.6609 0.23501C15.6609 0.247982 15.6609 0.26094 15.6609 0.273912H15.6652ZM11.713 15.0708C13.2437 14.3616 14.1302 12.9693 15.2977 11.8753C13.4816 12.1261 12.4698 13.0904 11.739 15.1097C11.2936 15.6286 10.6925 16.061 10.779 16.8696C11.2806 16.368 11.8298 15.8923 11.713 15.0708ZM20.8627 20.0434C18.7223 21.3796 17.3992 23.2259 15.6869 24.6312C15.1593 25.0636 14.9993 25.7987 14.9128 26.4906C14.8047 27.3554 15.2458 27.7013 15.9506 27.2473C18.5191 25.5955 20.3092 23.3643 20.8627 20.0391V20.0434ZM3.12549 16.2859C3.48871 16.4026 3.64436 16.2945 3.70922 16.1431C4.47458 14.4222 5.59021 12.9088 6.55015 11.3045C6.76203 10.9543 6.81823 10.5046 6.91335 10.0938C6.96092 9.89489 6.98685 9.6268 6.73605 9.55329C6.61066 9.51437 6.38147 9.60085 6.28634 9.70895C4.58266 11.5986 3.34601 13.7087 3.12549 16.2902V16.2859ZM6.7274 27.5889C6.76199 26.443 6.35986 25.4571 5.92313 24.4799C5.79773 24.1988 5.76746 23.6886 5.32641 23.7751C4.86806 23.8616 4.88971 24.3545 4.87242 24.7264C4.82918 25.7598 4.99781 26.7673 5.30049 27.7489C5.46913 28.298 5.60315 29.1239 6.29932 28.9986C6.9436 28.8818 6.62794 28.0559 6.72307 27.5846L6.7274 27.5889ZM17.5635 10.6992C18.5537 11.071 19.2109 11.3608 19.8941 11.564C20.7762 11.8234 21.4811 11.4689 21.9999 10.7554C22.1729 10.5176 22.2983 10.2063 22.1383 9.91222C21.974 9.60954 21.654 9.57493 21.3513 9.63115C20.1536 9.86032 18.9731 10.1543 17.5635 10.6948V10.6992ZM34.3148 17.3236C34.2932 16.4415 33.9645 15.914 33.3722 15.568C33.0997 15.4081 32.7755 15.4297 32.5376 15.6588C32.0231 16.1518 32.1528 16.7485 32.343 17.3279C32.4511 17.6522 32.5939 17.9636 32.7582 18.2619C32.8922 18.5127 32.9398 18.8975 33.303 18.9019C33.7051 18.9105 33.8608 18.5344 33.9992 18.2317C34.1592 17.8901 34.2456 17.5182 34.3148 17.3193V17.3236ZM7.57062 34.1052C7.58791 34.2912 7.68734 34.4166 7.86462 34.4555C8.04623 34.4944 8.21488 34.4382 8.24947 34.2436C8.29271 33.9971 8.14135 33.8544 7.90785 33.8285C7.72624 33.8112 7.60521 33.9193 7.57062 34.1052ZM12.2016 22.8497C12.4351 22.707 12.5519 22.6638 12.6254 22.5816C12.7421 22.4433 12.98 22.1925 12.6989 22.1233C12.4092 22.0498 12.2449 22.3698 12.2016 22.8497Z" fill="black"/>
                                    </svg>
                                <p><span>Перестали получать удовольствие от работы,</span> а чего хочется на самом деле — непонятно</p>
                            </li>
                        </ul>
                    </div>
                    <div><svg width="530" height="388" viewBox="0 0 530 388" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M410.852 221.171C346.906 262.502 123.517 289.287 117.511 242.228C112.28 201.241 304.324 158.989 361.994 146.229C380.957 142.033 501.812 116.25 506.338 151.72C508.997 172.555 455.454 190.612 388.334 199.178C346.321 204.54 274.145 206.038 270.268 163.335C267.771 135.824 350.3 106.29 410.16 100.741C429.612 98.9385 443.406 106.093 444.378 113.711" stroke="black" stroke-width="2.3" stroke-linecap="round"/>
                            <path d="M233.33 132.383C245.18 51.0793 520.608 114.374 514.967 161.408C510.054 202.372 313.377 196.481 254.298 194.782C234.872 194.223 111.299 189.736 115.551 154.285C118.048 133.462 174.414 129.025 241.641 137.089C283.722 142.136 354.133 158.277 347.487 200.573C343.206 227.822 255.912 236.307 196.466 227.091C177.148 224.096 163.946 216.293 164.86 208.679C165.836 200.541 182.845 200.832 193.951 202.165C205.057 203.497 293.732 216.398 294.571 257.762" stroke="black" stroke-width="2.3" stroke-linecap="round"/>
                            <path d="M222.301 72.5111C234.151 -8.79282 509.579 54.5021 503.938 101.536C499.024 142.5 302.348 136.609 243.269 134.91C223.843 134.351 100.269 129.864 104.521 94.4129C107.019 73.5897 163.384 69.1534 230.612 77.2169C272.693 82.2642 343.104 98.4049 336.458 140.701C332.177 167.95 244.883 176.435 185.437 167.219C166.119 164.224 152.917 156.421 153.83 148.807C154.807 140.669 171.816 140.96 182.922 142.292C194.028 143.625 282.702 156.526 283.542 197.89" stroke="black" stroke-width="2.3" stroke-linecap="round"/>
                            <path d="M326.513 280.597C250.886 271.602 94.5265 155.019 119.866 114.996C141.936 80.1364 316.919 170.122 369.511 197.089C386.805 205.956 496.409 263.204 477.31 293.371C466.092 311.091 413.307 290.83 356.099 254.611C320.29 231.94 263.686 187.059 287.892 151.744C303.487 128.993 385.931 158.913 435.619 192.823C451.766 203.843 460.323 216.569 456.221 223.048C451.836 229.973 436.609 222.388 427.158 216.404C417.708 210.421 344.102 159.298 361.151 121.601C366.04 110.792 381.805 116.476 387.583 125.872" stroke="black" stroke-width="2.3" stroke-linecap="round"/>
                            <path d="M260.076 300.738C184.449 291.742 28.089 175.16 53.4286 135.136C75.4984 100.277 250.481 190.262 303.074 217.229C320.367 226.097 429.972 283.345 410.873 313.512C399.654 331.231 346.869 310.97 289.662 274.751C253.853 252.08 197.248 207.2 221.455 171.885C237.05 149.134 319.493 179.054 369.182 212.964C385.328 223.983 393.885 236.709 389.783 243.189C385.399 250.114 370.172 242.528 360.721 236.545C351.27 230.562 277.664 179.439 294.714 141.742C299.603 130.932 315.367 136.616 321.146 146.012" stroke="black" stroke-width="2.3" stroke-linecap="round"/>
                            <path d="M304.731 255.715C299.69 236.946 239.522 79.6288 274.701 73.5254C295.365 69.9404 315.795 122.66 327.369 189.373C334.613 231.131 339.364 303.213 296.941 308.988C269.61 312.709 236.423 231.525 228.187 171.935C225.511 152.57 229.195 137.684 236.751 136.373C244.827 134.972 249.43 151.349 251.342 162.37C253.254 173.391 263.216 276.204 225.413 274.941C208.555 274.378 223.494 204.178 226.577 193.588" stroke="black" stroke-width="2.3" stroke-linecap="round"/>
                            <path d="M434.659 191.489C461.031 195.83 500.521 220.096 528.137 203.454" stroke="black" stroke-width="2.3" stroke-linecap="round"/>
                            <path d="M1.9999 186.759C56.8749 184.137 131.415 174.511 228.631 179.199" stroke="black" stroke-width="2.3" stroke-linecap="round"/>
                            </svg>
                    </div>
                </div>
                <div class="veb20-about__bottom">
                    <div>
                        <svg width="510" height="523" viewBox="0 0 510 523" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M420.123 234.092C307.552 88.5297 337.112 26.7204 361.869 21.5249C385.647 16.535 398.139 67.4661 400.127 97.0043C400.156 97.4315 400.837 97.4655 400.912 97.0439C406.836 63.9823 425.807 6.72315 459.693 17.3258C488.59 26.3674 469.771 116.135 376.704 200.907" stroke="black" stroke-width="2.3" stroke-linecap="round"/>
                        <path d="M420.42 234.5C435.92 257 373.931 316.397 263.203 297.758C124.794 274.46 440.987 218.918 417.265 292.084C393.542 365.25 157.534 305.214 113.148 366.258C68.7612 427.301 349.51 420.939 251.621 473.069C153.732 525.2 30.2501 470.899 1.99926 495.642" stroke="black" stroke-width="2.3" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>                    
                    </div>
                    <div>
                        <div class="veb20-about__header">
                            По итогам вебинара вы
                        </div>
                        <ul>
                            <li>
                                <svg xmlns="http://www.w3.org/2000/svg" width="50" height="60" viewBox="0 0 50 60" fill="none">
                                    <path d="M0 34.437C0.0817259 32.6659 0.122589 30.8948 0.255394 29.1339C0.296257 28.5401 0.531209 27.9566 0.704876 27.373C0.837681 26.9226 1.07263 26.4926 1.15436 26.0319C1.28716 25.2743 1.60383 24.6191 2.05332 24.0049C2.53346 23.3394 2.89104 22.6126 2.99319 21.7731C3.05449 21.3124 3.19751 20.821 3.4529 20.4422C5.17936 17.9135 6.63002 15.2006 8.6323 12.8561C8.93878 12.4978 9.10219 12.0269 9.35758 11.6379C9.54146 11.3615 9.71514 11.0339 9.98075 10.8598C11.411 9.95891 12.3508 8.62804 13.1272 7.18454C13.5154 6.46791 14.0773 6.03793 14.7822 5.75128C15.3032 5.53629 15.7322 5.31106 15.957 4.71728C16.2226 4.02112 16.9377 3.8266 17.5506 3.52971C18.5824 3.03831 19.5836 2.56739 20.4621 1.72791C21.4326 0.796291 22.6892 0.171784 24.1602 0.253685C24.4974 0.27416 24.8447 0.21274 25.1716 0.130839C26.2136 -0.135338 27.2045 0.0284584 28.175 0.407249C28.9412 0.704138 29.7176 0.960098 30.4327 1.34913C31.015 1.66649 31.6075 2.07599 32.0059 2.5981C32.6189 3.39663 33.3135 3.99041 34.2942 4.18493C36.7766 4.66609 38.5848 6.17102 40.0559 8.10592C40.9651 9.29348 41.8028 10.5425 42.6303 11.7812C43.3147 12.7947 43.8868 13.8901 44.6019 14.8832C45.3272 15.8865 45.9504 16.9102 46.2977 18.1182C46.5735 19.1011 46.9924 20.0429 47.3295 21.0053C47.4419 21.3226 47.5951 21.6502 47.6258 21.9778C47.7688 23.5339 47.9016 25.0901 47.9935 26.6564C48.014 27.0557 47.9935 27.5061 47.8199 27.8644C47.3908 28.7551 47.3295 29.697 47.2274 30.6491C47.1661 31.2633 47.0435 31.8571 46.5429 32.3075C46.3488 32.4816 46.1751 32.7273 46.1036 32.973C45.4703 35.0922 44.1013 36.5971 42.3238 37.8563C41.2205 38.6343 40.2296 39.5865 39.1978 40.4771C38.3703 41.1938 37.4816 41.7773 36.46 42.2175C35.4793 42.6475 34.5599 43.272 33.712 43.9374C31.8425 45.3809 29.738 46.2716 27.4804 46.8551C25.3044 47.4182 23.2102 48.186 21.2487 49.3019C20.4519 49.7524 19.5631 49.7728 18.6744 49.7626C18.0716 49.7524 17.4485 49.8343 16.856 49.7523C15.5586 49.5783 14.2918 49.9161 13.0148 49.9059C11.0228 49.8957 9.092 49.4452 7.29403 48.5853C6.6913 48.2986 6.13962 47.8687 5.62883 47.4387C3.89216 45.9747 2.52326 44.1831 1.39953 42.2277C0.541405 40.733 0.132795 39.0746 0.0919317 37.3342C0.0715002 36.3821 0.0919317 35.4198 0.0919317 34.4677C0.0510687 34.4472 0.0306472 34.4472 0 34.437ZM24.1704 4.88109C22.4235 4.90156 20.9116 5.46463 19.5222 6.36554C17.6425 7.59405 15.9468 9.02731 14.2816 10.5629C10.4711 14.0949 7.7231 18.3537 5.31219 22.8787C4.74011 23.9537 4.23952 25.09 3.87176 26.2571C3.3814 27.803 2.79907 29.4001 2.71735 30.9869C2.60497 33.0754 2.58458 35.174 2.91149 37.2932C3.35076 40.2109 4.75029 42.4325 7.12034 43.9886C9.56191 45.5857 12.4223 46.1283 15.2827 46.2102C17.1011 46.2614 18.9297 45.8826 20.7584 45.6778C21.1568 45.6369 21.5654 45.5345 21.9536 45.4014C25.6415 44.1933 29.0638 42.4222 32.4043 40.4873C33.6813 39.7502 34.7437 38.6446 36.1841 38.143C36.5519 38.0099 36.8482 37.6823 37.1546 37.4058C37.8187 36.8223 38.4929 36.249 39.1161 35.6245C40.1785 34.57 41.2409 33.5156 42.2319 32.3997C42.6712 31.898 43.0389 31.2838 43.2637 30.6593C43.7336 29.3796 44.0299 28.0487 44.4896 26.769C45.0004 25.3562 44.939 23.9332 44.6326 22.5307C43.897 19.2239 42.2523 16.3369 40.2704 13.624C40.107 13.409 39.9027 13.2247 39.7188 13.02C37.7369 10.9827 35.3362 9.61084 32.6802 8.63827C31.3215 8.13663 29.881 7.94212 28.4815 7.92164C27.2249 7.90117 25.9377 8.2902 24.6914 8.58708C23.8231 8.79184 22.9752 9.0273 22.0864 8.84302C21.8514 8.79184 21.5143 8.58708 21.4735 8.4028C21.4224 8.11615 21.5143 7.72712 21.688 7.48142C21.8719 7.21524 22.1988 7.05145 22.4848 6.87742C22.9445 6.59076 23.4451 6.36552 23.8946 6.06863C24.2419 5.86388 24.5177 5.54653 24.1704 4.88109ZM22.7709 1.58457C22.7198 1.49243 22.6891 1.43102 22.6483 1.3696C22.6278 1.41055 22.587 1.47197 22.6074 1.49244C22.6279 1.53339 22.6892 1.54362 22.7709 1.58457Z" fill="black"/>
                                    <path d="M22.7708 1.58445C22.6891 1.5435 22.6278 1.53327 22.6074 1.49232C22.5971 1.47185 22.638 1.41043 22.6482 1.36948C22.6789 1.4309 22.7197 1.49231 22.7708 1.58445Z" fill="black"/>
                                    <path d="M31.352 32.2358C30.4428 35.6859 28.0217 37.6822 24.7629 38.7469C23.0875 39.2997 21.3508 39.525 19.5426 39.2178C17.2645 38.839 15.9466 37.3546 14.9864 35.5016C14.3734 34.3038 14.2611 32.9217 14.2304 31.4066C14.639 31.5089 14.9353 31.5089 15.109 31.6523C15.5278 31.9901 15.8956 32.3996 16.2633 32.7886C16.6413 33.1777 16.9886 33.6077 17.3666 33.9864C18.807 35.3992 20.462 36.0442 22.546 35.7882C24.63 35.5323 26.52 34.9385 28.134 33.5667C28.7572 33.0343 29.3803 32.5122 30.0546 32.0515C30.4428 31.7956 30.9229 31.6625 31.352 32.2358Z" fill="black"/>
                                    <path d="M20.9013 13.9823C21.0852 14.2177 21.3201 14.4532 21.4734 14.7296C22.3417 16.2346 22.6788 17.893 22.8525 19.5925C23.0262 21.2817 23.1488 22.9709 23.2714 24.6703C23.2918 24.9979 23.2407 25.3562 23.1181 25.6531C23.0262 25.8681 22.781 26.1241 22.5665 26.1548C22.3622 26.1855 22.0046 25.991 21.9331 25.8067C21.6675 25.1924 21.4631 24.5372 21.2997 23.882C20.9626 22.5716 20.7481 21.2203 20.3394 19.9303C19.7163 17.9442 20.1862 16.0605 20.6255 14.1563C20.6357 14.1154 20.7378 14.0847 20.9013 13.9823Z" fill="black"/>
                                    <path d="M26.2085 27.4755C26.0451 27.3833 25.7386 27.3117 25.6364 27.1274C25.4832 26.851 25.3811 26.4824 25.4117 26.1651C25.5241 24.5475 25.6671 22.9198 25.851 21.3125C25.9531 20.4423 26.1268 19.5721 26.3005 18.7121C26.3617 18.3947 26.5252 18.0979 26.6274 17.801C27.7511 18.1286 28.3538 18.6405 28.1904 19.3776C27.5979 22.0086 27.5877 24.7728 26.4741 27.2912C26.4537 27.3424 26.3618 27.3629 26.2085 27.4755Z" fill="black"/>
                                    </svg>
                                <p>Поймете, как пошагово прийти к карьере, <span>которая будет приносить радость и доход</span></p>
                            </li>
                            <li>
                                <svg xmlns="http://www.w3.org/2000/svg" width="50" height="60" viewBox="0 0 50 60" fill="none">
                                    <path d="M13.6084 54.7297C13.7031 54.6892 13.7708 54.5946 13.8249 54.5C17.6134 48.8378 20.1572 42.3378 21.1855 35.5946C21.3343 34.6486 22.5385 34.3514 23.4992 34.2838C25.4747 34.1351 27.4501 33.9865 29.4121 33.8514C31.6175 33.6892 34.1477 33.3513 35.352 31.5C32.5647 28.5 29.7774 25.5 27.0036 22.5135C26.8007 22.2973 26.5977 22.0676 26.5436 21.7838C26.4895 21.4595 26.6248 21.1486 26.7601 20.8514L30.6298 12.5811C29.9803 12.5 29.3444 12.4324 28.6949 12.3513C27.8831 11.0946 27.0577 9.85135 26.2459 8.59459C24.5411 10.3108 22.8362 12.0405 21.1314 13.7703C20.9014 14 20.6307 14.2568 20.306 14.2297C19.9677 14.2162 19.7242 13.8919 19.5212 13.6081L15.9086 8.39189C15.7598 8.16216 15.4756 8.51351 15.3268 8.74324C15.1779 8.97297 14.7044 8.64865 14.975 8.62162C15.5974 7.95946 14.9073 6.91892 14.2579 6.28378C14.0684 6.10811 13.8384 5.91892 13.5813 5.97297C13.4866 6 13.419 6.09459 13.4055 6.18919C11.863 3.81081 9.90103 1.71622 7.64143 0C6.23426 1.16216 6.50488 3.35135 6.8702 5.13514C7.99324 10.4865 8.8592 15.8919 9.49513 21.3108C9.67103 22.7973 9.68454 24.6081 8.43973 25.4459C5.97717 27.1216 3.64994 28.973 1.45799 30.9865C0.794995 31.6081 0.0913976 32.3243 0.0102144 33.2297C-0.125091 34.527 1.10619 35.6351 2.37806 35.9054C3.66346 36.1622 4.97591 35.8243 6.26131 35.5676C7.73614 35.2703 9.22451 35.0946 10.7129 35.027C11.2541 40.5135 11.2541 46.0541 10.7129 51.5405C10.564 53.0541 10.3881 54.6892 11.1594 56C11.8088 55.9324 12.4583 55.8784 13.1213 55.8108C12.3501 55.027 12.4448 53.5811 13.2972 52.9054C13.419 53.2568 13.1754 53.6216 13.0807 53.9865C12.986 54.3513 13.2701 54.8784 13.6084 54.7162V54.7297ZM31.4281 28.5541C31.5769 28.5676 31.5769 28.8378 31.4281 28.8514C31.2793 28.8514 31.2793 28.5676 31.4281 28.5541ZM28.1808 14.6892C28.2214 14.8514 28.1131 15.0135 27.9914 15.1487C27.829 15.0405 27.7613 14.8108 27.829 14.6351H27.8019C27.829 14.4595 28.1267 14.5135 28.1672 14.6892H28.1808ZM26.3271 18.2838C26.5301 18.7027 26.5165 19.2162 26.3 19.6351V19.6892C26.3 19.6892 26.2594 19.6892 26.2459 19.6892C25.9618 19.6892 25.7453 19.3378 25.7994 19.0405C25.8535 18.7297 26.0971 18.4865 26.3271 18.2703V18.2838ZM20.6037 34.8784C20.4548 35.1081 20.0625 35.0946 19.9136 34.8784C20.0625 34.6486 20.4548 34.6486 20.6037 34.8784ZM16.8693 46.7432C16.7475 46.1487 16.7881 45.5135 16.991 44.9324C17.2211 45.5405 17.397 46.3514 16.8693 46.7432ZM19.2506 37.2568C19.3048 37.0946 19.6024 37.1892 19.5618 37.3378C19.4536 37.3378 19.3454 37.3513 19.2371 37.3649L19.2642 37.2568H19.2506ZM19.2236 38.9865H19.1695C19.1559 39.0946 19.0612 39.1486 18.953 39.1486C18.7771 39.1486 18.5741 39.027 18.5606 38.8378C18.5471 38.527 18.8312 38.2973 19.1018 38.1351C19.2506 38.3784 19.3048 38.7027 19.2371 38.9865H19.2236ZM18.7094 21.6892L18.8177 21.6622C18.8177 21.9459 18.6147 22.2162 18.3576 22.3243C18.0329 22.1351 18.3712 21.5135 18.7094 21.6892ZM18.52 40.0811L18.0464 40.2432L17.9382 40.2162C17.8164 39.8919 18.4794 39.7432 18.52 40.0811ZM18.1141 41.6487C18.2764 41.8108 18.2358 42.1216 18.0329 42.2432C17.857 42.0811 17.6946 41.9054 17.5187 41.7432C17.627 41.5405 17.9517 41.5 18.1141 41.6622V41.6487ZM17.1399 25.973C16.8963 26.2432 16.5986 26.4459 16.2874 26.6486C16.1386 26.7432 15.9627 26.8243 15.8003 26.8243C15.7056 26.8243 15.6109 26.7973 15.5433 26.7162C15.3538 26.4865 15.5703 26.1486 15.7868 25.9459C16.4363 25.3243 17.0858 24.6892 17.7352 24.0676C17.8299 24.7568 17.5999 25.473 17.1399 25.973ZM16.328 20.3108C16.4633 20.3108 16.4769 20.5946 16.328 20.6081C16.1792 20.6081 16.1792 20.3243 16.328 20.3108ZM12.9589 11.2838C14.1902 13.027 15.408 14.7838 16.6392 16.527C16.761 16.6892 16.8828 16.8784 16.8828 17.0811C16.8828 17.3108 16.761 17.5135 16.6392 17.7027C16.0574 18.5405 15.3809 19.2838 14.5961 19.9324C14.2037 19.7568 14.1226 19.2432 14.082 18.8108C13.9061 16.8514 13.5137 14.9054 12.9184 13.027C12.7289 12.4459 12.553 11.7432 12.9589 11.2973V11.2838ZM10.9564 10.0811C10.9835 9.75676 11.1188 9.43243 10.9835 9.13513H10.997C11.0376 8.85135 10.8617 8.55405 10.6046 8.44595C10.8076 8.10811 11.3488 8.44595 11.4841 8.81081C11.6194 9.18919 11.6735 9.67568 12.0524 9.81081C11.7006 9.86487 11.8224 10.5135 11.4976 10.6757C11.4571 10.7027 11.4165 10.7027 11.3759 10.7027C11.1323 10.7027 10.9429 10.3649 10.9564 10.0946V10.0811ZM12.8913 51.8243C12.7425 51.8243 12.7425 51.5405 12.8913 51.527C13.0401 51.527 13.0401 51.8108 12.8913 51.8243ZM12.8642 21.2838C12.5801 20.7027 12.6477 19.9865 13.0131 19.4459C12.5801 19 12.4448 18.3514 12.3365 17.7432C12.1606 16.7568 11.9847 15.7838 11.8088 14.7973C11.6735 14.0676 11.5518 13.3378 11.4165 12.6081C11.3759 12.3514 11.4435 11.9459 11.7141 12C11.8765 12.027 11.9306 12.2297 11.9577 12.3919C12.2824 14.2973 12.6207 16.1892 12.9454 18.0811C12.9995 18.4189 13.3513 18.6216 13.5678 18.8919C13.7843 19.1622 13.7572 19.7162 13.4055 19.7027C13.7167 19.8514 13.7708 20.2973 13.6084 20.5946C13.446 20.8919 13.1484 21.0811 12.8642 21.2703V21.2838Z" fill="black"/>
                                  </svg>
                                <p>Узнаете, какие инструменты необходимы, чтобы <span>достичь личной «идеальной» карьеры</span></p>
                            </li>
                            <li>
                                <svg xmlns="http://www.w3.org/2000/svg" width="52" height="62" viewBox="0 0 52 62" fill="none">
                                    <path d="M24.0299 55C43.3688 15.1104 33.341 2 27.2469 2C21.394 2 20.9685 14.6263 21.9615 21.689C21.9758 21.7911 21.817 21.8328 21.7783 21.7372C18.7458 14.2352 11.4397 1.67376 3.97489 5.85023C-2.39092 9.41183 6.4878 29.6453 32.625 45.0276" stroke="black" stroke-width="3" stroke-linecap="round"/>
                                  </svg>
                                <p>Проработаете внутренние установки, которые мешают <span>получать от карьеры максимум</span></p>
                            </li>
                            <li>
                                <svg xmlns="http://www.w3.org/2000/svg" width="51" height="60" viewBox="0 0 51 60" fill="none">
                                    <path d="M11.2614 30.3154C9.70095 27.6948 8.13399 25.0808 6.57353 22.4602C6.78809 23.1495 6.99615 23.8323 7.20421 24.5216L3.91425 18.9032C4.62296 19.7746 5.33816 20.6525 6.04687 21.5303C5.91683 21.914 6.15091 22.3887 6.54752 22.5122C6.44999 22.1481 6.28094 21.8034 6.05988 21.4978L6.04687 21.5303C5.00657 19.599 3.52413 17.9083 1.75562 16.6143C1.54105 16.4582 1.31349 16.3022 1.04691 16.2892C0.29269 16.2437 -0.00639833 17.2516 0.000103574 18.0059C0.0196093 20.8671 0.754324 23.6697 1.43702 26.4463C3.25106 33.7943 4.7595 41.2204 5.95585 48.6985C6.05337 49.2837 6.15091 49.8884 6.4825 50.3761C6.8206 50.8638 7.46429 51.189 8.01045 50.9679C7.65935 51.4036 7.30174 51.8588 7.1717 52.3985C7.04167 52.9447 7.19771 53.6015 7.69185 53.8681C8.1795 54.1347 8.77767 53.9461 9.29782 53.751C16.2028 51.189 23.3159 49.2057 30.5461 47.8271C27.8933 46.7347 25.0389 46.1884 22.1716 46.1624C22.1846 46.1689 22.1911 46.1754 22.2041 46.1819V46.1949C22.0611 46.312 21.8335 46.3055 21.697 46.1884C21.71 46.1754 21.723 46.1689 21.736 46.1624C16.9636 46.2079 12.1912 47.697 8.33555 50.5127C8.59562 47.5475 8.12748 44.5693 7.62684 41.6366C6.4695 34.8868 5.1301 28.163 3.60866 21.4848C5.15611 23.6632 6.53452 25.9716 7.71786 28.3711C8.23801 29.4311 8.73867 30.5235 9.5254 31.4079C10.3121 32.2922 11.4565 32.9425 12.6333 32.819C14.5579 32.6174 15.6697 30.595 16.4369 28.8263C18.5825 23.9038 20.6632 18.9488 22.6787 13.9677C22.1651 13.9417 21.6905 14.4294 21.7295 14.9366C21.3654 14.0197 21.853 12.8493 22.7633 12.4591C22.5747 12.9078 22.3862 13.363 22.1976 13.8117C23.4265 12.6932 24.2587 11.1521 24.5188 9.50689C24.1287 9.74099 23.8491 10.1637 23.7841 10.6123L23.0364 10.0466C23.589 9.95558 24.0702 9.50689 24.1937 8.95417C24.4538 9.0257 24.6813 9.21428 24.7919 9.46788C25.364 8.14134 26.1378 6.90583 27.087 5.80688C26.5344 11.5162 26.1963 17.2451 26.0727 22.9804C26.0402 24.489 26.0337 26.0367 26.5994 27.4347C27.1651 28.8328 28.4459 30.0488 29.9544 30.0618C31.4888 30.0748 32.7502 28.9109 33.836 27.8249C37.5941 24.0599 41.3522 20.2883 45.1038 16.5233C42.1325 22.7528 39.2391 29.0214 36.4238 35.329C34.2326 40.2385 32.0545 45.3561 32.0675 50.7338C32.3211 50.3306 32.5746 49.9275 32.8282 49.5243C32.8412 49.5828 32.8737 49.6348 32.9388 49.6479C33.0818 49.6739 33.2118 49.5568 33.3094 49.4463C36.1182 46.2795 38.0297 42.4364 39.9088 38.6453C43.5239 31.3559 47.1454 24.0469 49.9998 16.4192C50.6044 14.8001 49.8762 12.8493 48.4653 11.8544C41.4432 15.4373 36.4888 22.0961 29.8699 26.3748C29.9804 18.6041 30.0909 10.8334 30.1949 3.06275C30.2015 2.41249 29.8959 1.48911 29.2652 1.67118C28.6085 1.85976 28.6345 0.643763 28.1338 0.182074C27.9973 0.0585232 27.8413 0 27.6787 0C27.1846 0 26.6319 0.487698 26.3068 0.95589C20.6762 9.0387 17.8023 18.6561 13.6736 27.5973C13.147 28.7288 12.4708 29.9708 11.2679 30.3024L11.2614 30.3154ZM25.7216 47.9572C25.7672 47.9181 25.8322 47.9116 25.8972 47.9051C26.0207 47.8921 26.1573 47.8921 26.2548 47.9637C26.3523 48.0352 26.3653 48.2238 26.2483 48.2628L26.2288 48.2238C26.1378 48.2563 26.0402 48.2953 25.9427 48.2953C25.9037 48.2953 25.8712 48.2953 25.8322 48.2758C25.7086 48.2303 25.6306 48.0482 25.7281 47.9637L25.7216 47.9572ZM2.43832 20.4574C2.42531 20.4054 2.41231 20.3468 2.43181 20.3013C2.47083 20.1843 2.65288 20.1778 2.74391 20.2688C2.83493 20.3533 2.85444 20.4899 2.87394 20.6134L3.069 22.1091C3.08201 22.1936 3.10151 22.2911 3.17303 22.3367C3.30307 22.4082 3.56965 22.3236 3.54364 22.4732C3.34208 22.4732 3.13402 22.5317 2.97147 22.6553C2.78942 21.927 2.61387 21.1987 2.43181 20.4704L2.43832 20.4574ZM7.69185 48.3473C7.69185 48.4709 7.73087 48.5879 7.76988 48.7115C7.90642 49.1666 7.89992 49.6609 7.75037 50.1095C7.67235 49.4983 7.59433 48.887 7.5098 48.2693C7.47079 47.9637 7.47729 47.567 7.76338 47.4499C8.01045 47.6515 7.70486 48.0287 7.69185 48.3473ZM7.45779 44.6213C7.63984 45.4991 7.71136 46.3965 7.66585 47.2939C7.35376 47.1703 7.33425 46.7477 7.34076 46.4095C7.35376 45.7202 7.25623 45.0244 7.06117 44.3612C7.10669 44.2701 7.25623 44.2701 7.33425 44.3417C7.41227 44.4132 7.43828 44.5238 7.45779 44.6213ZM6.67756 37.93L6.69056 37.9821C6.63855 37.9821 6.58653 37.9756 6.53452 37.9691C6.51501 37.891 6.65805 37.852 6.68406 37.93H6.67756ZM6.01437 34.1325V34.1845C5.97535 34.1845 5.92334 34.1845 5.86482 34.178C5.84531 34.1 5.98836 34.061 6.01437 34.139V34.1325ZM5.25364 33.2546C5.42269 33.8399 5.59174 34.4186 5.76729 35.0038C5.81931 35.1859 5.87132 35.394 5.7803 35.5566C5.70227 35.6996 5.75429 35.8752 5.80631 36.0313C5.96885 36.4865 6.1314 36.9481 6.29395 37.4033C6.16391 38.1121 6.35897 38.8794 6.8206 39.4322C6.53452 39.8548 6.69056 40.4206 6.8271 40.9148C7.06767 41.7861 7.23022 42.677 7.30174 43.5744C7.30824 43.6719 7.24973 43.815 7.1717 43.815C7.1587 43.815 7.13919 43.815 7.12619 43.7954C7.10018 43.7759 7.09368 43.7369 7.08718 43.7044C6.87912 42.638 6.67105 41.565 6.46299 40.4986C6.30695 39.6858 6.15091 38.8729 5.98836 38.0666L5.13661 33.6578C5.1106 33.5082 5.1106 33.3132 5.24714 33.2676L5.25364 33.2546ZM5.02607 32.923C5.02607 32.923 4.99357 32.923 4.97406 32.91C4.92855 32.8905 4.90254 32.845 4.88303 32.8059C4.80501 32.6564 4.72049 32.5003 4.71398 32.3313C4.71398 32.1622 4.80501 31.9736 4.96756 31.9346C5.02608 32.1362 5.09109 32.3378 5.14961 32.5393C5.19512 32.6889 5.14961 32.923 5.02607 32.923ZM4.51242 29.5806C4.62946 30.1399 4.7465 30.7056 4.97406 31.2323C5.01958 31.3428 5.07159 31.4664 5.04558 31.5834C5.02607 31.668 4.93505 31.7395 4.85703 31.7395C4.82452 31.7395 4.79201 31.7265 4.7725 31.707C4.73999 31.6745 4.72699 31.6225 4.71398 31.5769C4.55144 30.8682 4.39539 30.1529 4.23284 29.4441C4.0963 28.8068 3.95326 28.1695 3.81672 27.5323C3.7452 27.2006 3.68018 26.8235 3.88824 26.5504L4.51893 29.5871L4.51242 29.5806ZM3.84923 25.8806C3.77771 26.0237 3.71269 26.1602 3.64117 26.3033C3.56315 25.9912 3.47862 25.6725 3.4006 25.3539C3.23805 24.7231 3.12102 24.0794 3.056 23.4291C3.04299 23.3251 3.056 23.1885 3.16003 23.1625C3.21205 23.1495 3.25755 23.1755 3.30307 23.2015C3.49812 23.3381 3.56314 23.6177 3.46562 23.8323C3.35508 24.0599 3.4201 24.3265 3.49162 24.5671C3.61516 25.0027 3.7322 25.4384 3.85573 25.8741L3.84923 25.8806ZM8.34855 26.2513C8.32904 26.1732 8.47209 26.1342 8.49809 26.2122C8.49809 26.2318 8.49809 26.2448 8.50459 26.2643C8.45258 26.2643 8.40056 26.2578 8.34855 26.2513ZM9.56441 28.4817C9.44087 28.2736 9.31733 28.059 9.1938 27.8509C9.18729 27.7534 9.33684 27.8639 9.33034 27.955C9.57091 27.955 9.72695 28.2996 9.56441 28.4817ZM39.4602 37.6894C39.3821 37.6374 39.3496 37.5334 39.3821 37.4423C39.2976 37.2863 39.5772 37.1107 39.6747 37.2603C39.6032 37.4033 39.5252 37.5464 39.4537 37.6894H39.4602ZM39.8698 36.7791C39.8698 36.7791 39.8373 36.8246 39.8048 36.8246C39.7593 36.8246 39.7007 36.7856 39.6942 36.7336C39.6812 36.649 39.7462 36.5775 39.8048 36.5125C39.8308 36.597 39.8633 36.6815 39.8958 36.7661L39.8763 36.7791H39.8698ZM40.9426 34.0415C40.8711 34.0415 40.8711 33.9049 40.9426 33.8984C41.0141 33.8984 41.0141 34.035 40.9426 34.0415ZM42.2625 31.2453C42.152 31.1738 42.152 30.9852 42.2625 30.9202L42.2755 30.8877C42.3535 30.9202 42.438 30.9592 42.5161 30.9917C42.4315 31.0762 42.347 31.1608 42.269 31.2453H42.2625ZM43.0882 29.9253C42.9777 29.8537 42.9777 29.6652 43.0882 29.6001C43.1988 29.6717 43.1988 29.8602 43.0882 29.9253ZM49.5316 14.0913C49.6031 14.2343 49.6747 14.3969 49.6291 14.553C49.5966 14.657 49.4861 14.7285 49.3821 14.7285C49.3301 14.7285 49.2845 14.709 49.252 14.6635L49.2845 14.6505C49.2195 14.4359 49.3301 14.1888 49.5316 14.0848V14.0913ZM49.3691 15.0667C49.5381 15.3333 49.4536 15.7234 49.187 15.899C49.018 15.6324 49.1025 15.2357 49.3691 15.0667ZM48.6409 16.6858C48.7189 16.3997 48.9204 16.0551 49.213 16.1136C49.2845 16.2502 49.3561 16.3867 49.4406 16.5168C49.2195 16.4843 48.979 16.5753 48.8424 16.7574C48.9464 17.167 48.7839 17.6352 48.4393 17.8823C48.4718 17.4792 48.5368 17.076 48.6409 16.6793V16.6858ZM45.3834 24.9702C45.3119 24.8467 45.2859 24.6971 45.3184 24.5606L45.3314 24.4825C45.5134 24.5606 45.5394 24.8532 45.3769 24.9702H45.3834ZM45.3964 15.7299C45.4939 15.782 45.5134 15.938 45.4354 16.0161C45.3574 16.0941 45.2078 16.0746 45.1493 15.977C45.2339 15.899 45.3119 15.8145 45.3964 15.7299ZM43.8229 17.05C43.901 17.1865 43.7644 17.3426 43.6409 17.4467C43.4458 17.6027 43.2508 17.7523 43.0557 17.9083C42.9842 17.9669 42.8737 18.0254 42.7826 18.0254C42.7306 18.0254 42.6851 18.0059 42.6591 17.9604C43.0037 17.6092 43.3938 17.3036 43.8164 17.05H43.8229ZM41.6903 18.8967L41.6773 18.9553C41.7358 19.0723 41.5993 19.1829 41.4823 19.1829C41.4367 19.1829 41.3912 19.1634 41.3652 19.1178C41.4172 18.9878 41.5473 18.8967 41.6838 18.8967H41.6903ZM40.5395 20.4444C40.2924 20.5289 40.0713 20.6785 39.9088 20.8801L39.8633 20.854C39.8698 20.8996 39.8763 20.9516 39.8438 20.9841C39.8373 20.9906 39.8243 20.9971 39.8113 20.9971C39.7788 20.9971 39.7463 20.9711 39.7593 20.9451C39.8178 20.763 39.8828 20.5744 40.0258 20.4509C40.1689 20.3273 40.4224 20.3013 40.5395 20.4509V20.4444ZM39.7918 18.8772C39.8633 18.8837 39.8633 19.0138 39.7918 19.0203C39.7267 19.0138 39.7267 18.8837 39.7918 18.8772ZM39.1286 21.3417C39.2261 21.3938 39.2456 21.5433 39.1676 21.6279C39.0896 21.7059 38.94 21.6864 38.8815 21.5888C38.966 21.5108 39.044 21.4263 39.1286 21.3483V21.3417ZM38.81 22.0115C38.9075 22.018 38.81 22.1806 38.7124 22.1611L38.732 22.2001C38.6084 22.2521 38.5889 22.4212 38.5304 22.5447C38.4979 22.6163 38.4069 22.6618 38.3353 22.6618C38.2833 22.6618 38.2378 22.6358 38.2378 22.5773C38.4264 22.3887 38.6214 22.2001 38.8165 22.018L38.81 22.0115ZM37.035 23.8778C37.126 23.7868 37.295 23.9493 37.23 24.0599C37.1975 24.1119 37.139 24.1379 37.074 24.1379C37.0089 24.1379 36.9374 24.1119 36.8984 24.0599C36.9569 24.0013 37.0089 23.9493 37.0675 23.8908L37.035 23.8778ZM29.0896 26.5569C29.0051 26.7455 28.9401 26.9405 28.8751 27.1421C28.7645 26.5244 28.7645 25.8871 28.8816 25.2694C28.9466 25.588 29.0181 25.9066 29.0831 26.2253C29.1091 26.3358 29.1286 26.4528 29.0831 26.5569H29.0896ZM28.9076 23.1495C28.9791 23.273 29.0051 23.4226 28.9726 23.5592L28.9596 23.6372C28.7775 23.5592 28.7515 23.2665 28.9141 23.1495H28.9076ZM29.1026 22.4277L28.9011 22.8244C28.8231 22.7723 28.7905 22.6618 28.823 22.5773H28.8165C28.7645 22.5187 28.7125 22.4667 28.667 22.4147C28.7255 22.3171 28.7905 22.2196 28.8946 22.1806C28.9986 22.1416 29.1416 22.1936 29.1481 22.3041C29.1481 22.3497 29.1286 22.3952 29.1091 22.4342L29.1026 22.4277ZM29.1221 19.6901C29.1221 19.6901 29.0896 19.6901 29.0701 19.6771C29.0311 19.6511 29.0116 19.6055 28.9921 19.56C28.8491 19.1569 28.732 18.6301 29.0701 18.37C29.1286 18.7017 29.1937 19.0333 29.2522 19.3649C29.2782 19.495 29.2197 19.6901 29.1156 19.6901H29.1221ZM28.8296 17.089C28.9856 17.063 29.1286 16.985 29.2392 16.8679C29.3432 17.076 29.3432 17.3361 29.2392 17.5442L29.1937 17.5832C29.0181 17.4727 28.8881 17.2906 28.8361 17.089H28.8296ZM29.3822 25.4709C29.2522 25.2629 29.2587 24.9832 29.3887 24.7752C29.4212 24.8597 29.4602 24.9442 29.4927 25.0288L29.4602 25.0418C29.4993 25.1848 29.4732 25.3474 29.3822 25.4644V25.4709ZM29.5513 19.5145C29.4407 19.443 29.4407 19.2544 29.5513 19.1894C29.6618 19.2609 29.6618 19.4495 29.5513 19.5145ZM29.3107 2.75062C29.2717 2.65959 29.3172 2.54254 29.4017 2.50353C29.5122 2.77664 29.5057 3.09527 29.3822 3.35537C29.2847 3.1733 29.2587 2.95871 29.3107 2.75713V2.75062ZM29.2587 5.8524C29.2912 5.71584 29.3432 5.57929 29.4082 5.44923C29.5058 5.94994 29.5057 6.47015 29.4147 6.97736C29.1937 6.65873 29.1611 6.22955 29.2587 5.8524ZM29.2912 8.19986C29.2912 8.27139 29.1546 8.27139 29.1481 8.19986C29.1481 8.13483 29.2847 8.12833 29.2912 8.19986ZM29.2197 4.48684C29.3302 4.55837 29.3302 4.74695 29.2197 4.81197C29.1091 4.74044 29.1091 4.55187 29.2197 4.48684ZM29.1416 8.85013C29.2522 8.72007 29.4797 8.85663 29.5057 9.0257C29.5383 9.19477 29.4602 9.36384 29.4667 9.5329C29.4667 9.70197 29.6293 9.89706 29.7853 9.82553C29.6683 9.91656 29.5448 10.0076 29.5057 10.1507C29.4667 10.2872 29.5578 10.4758 29.7008 10.4693C29.8504 10.4628 29.7983 10.7164 29.6618 10.7749C29.5253 10.8334 29.3367 10.8725 29.3172 11.0155L29.4732 11.1781C29.3887 11.2626 29.3107 11.3406 29.2327 11.4187C28.8556 10.9115 29.5318 10.0856 29.1416 9.58493C28.9791 9.37684 28.9856 9.05821 29.1416 8.85663V8.85013ZM29.0636 12.5371C29.1156 12.264 29.1676 11.9909 29.2197 11.7113C29.5253 12.082 29.5838 12.6282 29.3692 13.0574C29.2717 13.2394 29.3562 13.4605 29.3952 13.6621C29.4342 13.8637 29.3952 14.1303 29.2002 14.1953C29.0896 13.7987 28.9726 13.3955 28.9986 12.9793C29.0116 12.8298 29.0376 12.6802 29.0636 12.5371ZM29.0116 15.2227L29.2977 15.4698C29.2392 15.5219 29.1872 15.5804 29.1351 15.6324C29.4602 15.9315 29.3107 16.5753 28.8816 16.6923C28.8035 16.6143 28.7255 16.5428 28.6475 16.4647C28.9011 16.1071 29.0311 15.6584 29.0051 15.2227H29.0116ZM28.693 19.8721C28.8035 19.7681 28.9921 19.8331 29.0766 19.9567C29.1611 20.0802 29.1676 20.2428 29.1676 20.3924C29.1676 20.8475 29.1677 21.3287 28.9076 21.6994C28.6605 21.3547 28.9076 20.8606 28.7645 20.4639C28.693 20.2623 28.537 20.0217 28.6865 19.8721H28.693ZM27.1 3.6675C27.1716 3.84958 27.1846 4.05116 27.1521 4.24624L27.1326 4.23324C27.0545 4.3828 26.9765 4.52585 26.892 4.67541C26.7554 4.33727 26.84 3.92111 27.1 3.6675ZM25.5656 6.63922C25.6956 6.69124 25.7932 6.8213 25.8062 6.96435H25.7216C25.6891 7.15943 25.5786 7.34151 25.4226 7.45856C25.338 7.37402 25.2535 7.28949 25.1755 7.21145C25.3705 7.0749 25.5071 6.86681 25.5721 6.63922H25.5656ZM24.1872 8.5575C24.2587 8.41445 24.4928 8.45346 24.5968 8.33642C24.7073 8.21287 24.6228 8.02429 24.5708 7.86822C24.5188 7.71216 24.5968 7.46506 24.7529 7.51058C25.0389 7.95276 24.7594 8.64204 24.2522 8.75909C24.1807 8.72658 24.1547 8.62904 24.1872 8.56401V8.5575ZM23.1014 10.931C23.2054 10.931 23.1209 11.1261 23.0233 11.087L23.0103 11.1C23.0494 11.1586 22.9713 11.2106 22.9128 11.2106C22.8868 11.2106 22.8608 11.1976 22.8543 11.1651C22.9583 11.1131 23.0494 11.0285 23.0949 10.9245L23.1014 10.931ZM23.0364 12.0299C23.0559 12.108 23.0038 12.186 22.9453 12.251C22.8673 12.199 22.8348 12.0885 22.8673 12.0039H22.8608C22.8738 11.9194 23.0168 11.9454 23.0364 12.0299ZM21.7945 10.6123C21.8595 10.6189 21.8595 10.7489 21.7945 10.7554C21.723 10.7554 21.723 10.6189 21.7945 10.6123ZM21.3264 15.0732C21.4499 14.9821 21.5604 15.2032 21.5604 15.3593C21.5604 15.4893 21.5604 15.6194 21.5604 15.7495C21.5604 15.8795 21.5279 16.0421 21.4044 16.0681C21.3914 16.0681 21.3849 16.0681 21.3719 16.0681C21.2938 16.0681 21.2223 16.0031 21.1768 15.9315C21.0013 15.6584 21.0728 15.2553 21.3394 15.0667L21.3264 15.0732ZM20.8127 16.1916C20.8452 16.2762 20.8842 16.3607 20.9167 16.4452L20.8842 16.4582C20.9232 16.6013 20.8972 16.7639 20.8062 16.8809C20.6762 16.6728 20.6827 16.3867 20.8127 16.1851V16.1916ZM20.13 17.3426C20.182 17.2581 20.26 17.1735 20.3576 17.18C20.5721 17.18 20.5591 17.5247 20.4096 17.6807C20.26 17.8303 20.0325 17.9604 20.039 18.1749C20.039 18.279 20.1105 18.383 20.208 18.4221C20.13 18.5651 20.0585 18.7147 19.9805 18.8577C19.7789 18.37 19.8374 17.7783 20.13 17.3426ZM19.6554 19.6771C19.7074 19.7421 19.7594 19.8201 19.7464 19.8982C19.7334 19.9437 19.6814 19.9697 19.6359 19.9697C19.6034 19.9697 19.5708 19.9567 19.5708 19.9177H19.5838C19.5513 19.8331 19.5838 19.7226 19.6619 19.6706L19.6554 19.6771ZM18.7776 20.9646C18.8361 20.8085 18.9011 20.659 18.9727 20.5029C19.0247 20.3859 19.0832 20.2688 19.1872 20.1973C19.2913 20.1257 19.4603 20.1322 19.5253 20.2428C19.3758 20.5419 19.2262 20.841 19.0832 21.1337C19.0377 21.2182 18.9727 21.3222 18.8751 21.3222C18.8686 21.3222 18.8556 21.3222 18.8491 21.3222C18.7126 21.2897 18.7321 21.0946 18.7841 20.9646H18.7776ZM18.8231 21.6539H18.8361C18.9532 21.7969 18.9467 22.0245 18.8296 22.1611C18.7126 22.018 18.7126 21.7969 18.8296 21.6539H18.8231ZM18.498 22.1546C18.5956 22.2066 18.6151 22.3627 18.537 22.4407C18.459 22.5187 18.3095 22.4992 18.251 22.4017C18.3355 22.3236 18.4135 22.2391 18.498 22.1546ZM18.1989 22.9674C18.2965 22.9414 18.4005 23.0259 18.4005 23.1235C18.4005 23.1755 18.381 23.2275 18.355 23.273C18.29 23.3966 18.2314 23.5266 18.1664 23.6502C18.0754 23.5331 18.0494 23.3706 18.0884 23.2275L18.1014 23.208C18.0559 23.1235 18.1014 22.9999 18.1989 22.9739V22.9674ZM17.5032 24.6321C17.6138 24.7036 17.6138 24.8922 17.5032 24.9572C17.3927 24.8857 17.3927 24.6971 17.5032 24.6321ZM17.1846 25.4644C17.3017 25.562 17.2432 25.8156 17.0871 25.7896L17.0741 25.8026C17.1391 25.9196 17.0741 26.0887 16.9506 26.1342C16.9506 25.8936 17.0286 25.6595 17.1781 25.4709L17.1846 25.4644ZM15.2731 29.8342C15.2341 29.8862 15.1755 29.9123 15.1105 29.9123C15.0455 29.9123 14.9805 29.8862 14.948 29.8277C15.0195 29.7172 15.2081 29.7172 15.2731 29.8277V29.8342ZM13.8687 31.746C13.9402 31.746 13.9402 31.8826 13.8687 31.8891C13.8036 31.8826 13.8036 31.7525 13.8687 31.746Z" fill="black"/>
                                    </svg>
                                <p>Увидите, что талант — это <span>приобретаемый навык, а не благословение свыше</span></p>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-veb20-about-tablet', {
        label: 'Веб 2.0 about (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-veb20-about-tablet">
            <div>
                <div class="veb20-about__top">
                    <div>
                        <div class="veb20-about__header">
                            Вебинар для вас, если вы
                        </div>
                        <ul>
                            <li>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="32" viewBox="0 0 24 32" fill="none">
                                    <path d="M9.18175 24.1677C7.92672 24.2502 6.82579 24.2502 5.75791 24.0301C3.5671 23.5759 1.99557 22.2356 0.95521 20.3062C0.413013 19.2989 0.151558 18.1842 0.0717422 17.0172C-0.126421 14.1879 0.0662376 11.3916 0.897424 8.68887C1.36531 7.16412 2.11117 5.69992 3.16529 4.4669C3.8974 3.60819 4.93776 3.1761 6.06069 3.14032C7.22215 3.10179 8.15514 2.73023 8.92302 1.83299C11.5019 -1.17524 15.6413 -0.093614 17.8487 2.29811C19.6514 4.25222 20.6587 6.60816 21.3193 9.1375C21.4679 9.70446 21.7982 10.1228 22.1229 10.599C23.1138 12.0329 23.9917 13.5687 24 15.3879C24.0055 16.6732 23.2679 17.7136 22.4091 18.52C19.3349 21.4044 15.812 23.4934 11.5487 24.0906C11.1193 24.1512 10.679 24.1539 10.2441 24.1649C9.83679 24.1759 9.4267 24.1649 9.18175 24.1649V24.1677ZM18.5725 6.51736C17.9477 4.76967 17.078 3.44582 15.5973 2.58711C14.7909 2.11923 13.9349 1.9128 13.0102 2.17427C12.801 2.23207 12.5478 2.28987 12.5478 2.55959C12.5478 2.81556 12.7845 2.92565 12.9964 2.97244C14.7358 3.36601 16.0432 4.46966 17.3587 5.57332C17.6973 5.85955 17.8624 6.35495 18.5725 6.52008V6.51736ZM12.0028 14.7879C12.7102 13.2934 13.1725 11.6861 14.4331 10.3045C13.0377 10.6182 11.6808 13.2411 12.0028 14.7879ZM4.73958 16.8494C4.68729 16.8631 4.63777 16.8769 4.58547 16.8907C4.58547 17.342 4.57169 17.7934 4.59371 18.242C4.60196 18.4127 4.624 18.6659 4.89373 18.6218C5.09464 18.5888 5.08638 18.3741 5.0561 18.2255C4.96252 17.7659 4.84692 17.309 4.73958 16.8521V16.8494ZM22.0982 16.0842C22.4092 15.8778 22.5358 15.6439 22.4202 15.3191C22.4064 15.2833 22.2495 15.2448 22.2165 15.2751C21.9716 15.4897 21.8918 15.7429 22.0982 16.0842Z" fill="black"/>
                                  </svg>
                                <p><span>Находитесь в состоянии постоянного напряжения,</span> испытываете усталость<br> при малейших задачах</p>
                            </li>
                            <li>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="32" viewBox="0 0 24 32" fill="none">
                                    <path d="M0.0320945 7.08801C-0.110508 4.80352 0.234593 3.03525 0.819264 1.31546C1.01605 0.739348 1.30127 0.0263397 1.97436 0.000671213C2.65885 -0.0249973 2.94403 0.690855 3.23209 1.2356C3.52014 1.78319 3.60574 2.38498 3.33479 2.95254C2.21108 5.30548 2.32231 7.77536 2.61607 10.2595C2.70448 11.0181 2.84709 11.774 3.29771 12.4185C3.46884 12.6609 3.62569 13.0174 3.99931 12.9205C4.31589 12.8378 4.32444 12.4955 4.38718 12.2217C4.74654 10.6531 5.06029 9.07019 5.47669 7.51867C5.95298 5.73614 6.81714 4.16751 8.35725 3.05521C8.44852 2.98961 8.53408 2.89552 8.6396 2.86985C10.4079 2.39356 11.9879 1.4552 13.682 0.807789C15.6699 0.0462915 17.307 1.13579 18.3737 2.6046C19.5002 4.15611 20.4842 5.81032 20.9405 7.72119C21.1344 8.53403 21.5651 9.20139 22.2895 9.7005C23.1052 10.2624 23.5786 11.1237 23.8924 12.042C24.2432 13.0688 23.6785 13.8502 23.0339 14.549C21.722 15.9693 20.0934 17.0018 18.5647 18.1568C16.902 19.4174 15.0681 20.0363 12.9548 19.7825C12.005 19.6684 11.1437 19.3404 10.3308 18.8869C9.89163 18.6417 9.46385 18.4962 8.96759 18.539C7.53872 18.6645 6.32658 18.2025 5.45956 17.0617C4.66098 16.015 3.51162 15.3704 2.62463 14.4207C1.92873 13.6763 1.40395 12.8691 1.09023 11.9223C0.519819 10.2053 -0.0848369 8.49407 0.0349493 7.08801H0.0320945ZM8.75369 12.7807C8.81929 13.1829 8.62818 13.7276 9.12729 13.97C9.50661 14.1554 9.90306 13.9643 10.2111 13.6848C10.4564 13.4566 10.4649 13.1287 10.4963 12.8206C10.5961 11.8538 10.8727 10.9469 11.3604 10.0998C11.4945 9.86878 11.794 9.61495 11.5458 9.3497C11.2977 9.08161 10.9526 9.24416 10.6874 9.40388C9.4239 10.1568 8.79932 11.2891 8.75084 12.7779L8.75369 12.7807ZM13.4967 5.37107C12.835 5.334 12.2959 5.35684 11.8881 5.7875C11.6029 6.08981 11.6314 6.36931 12.0706 6.45772C12.5669 6.55754 13.0745 6.65167 13.5765 6.64882C14.0699 6.64882 14.5006 6.32082 14.5291 5.84738C14.5662 5.25415 13.9729 5.46804 13.6335 5.37393C13.5565 5.35111 13.4653 5.37107 13.4967 5.37107ZM16.1547 3.45736C16.1348 3.45165 16.112 3.44597 16.092 3.44026C16.0892 3.46023 16.0749 3.48874 16.0834 3.50014C16.0949 3.5144 16.1234 3.51439 16.1433 3.52009C16.1462 3.50013 16.1519 3.47732 16.1547 3.45736Z" fill="black"/>
                                  </svg>
                                <p><span>Застряли на месте:</span><br> не верите, что<br> заслуживаете большего<br> в карьере и жизни</p>
                            </li>
                            <li>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="36" viewBox="0 0 24 36" fill="none">
                                    <path d="M15.838 7.14429C15.6542 7.98637 15.9349 8.92199 17.0109 9.84427C18.7118 11.3012 20.0985 13.099 21.5154 14.8499C24.3256 18.3252 23.9514 22.9265 21.7025 26.3283C19.4302 29.7634 16.219 32.1426 12.3428 33.5027C10.271 34.2311 8.18914 34.2579 6.17751 32.9145C3.75487 31.3006 1.55946 29.5529 0.677286 26.6558C-0.148084 23.9491 -0.198221 21.1956 0.413288 18.4188C0.817619 16.5742 1.53943 14.9001 2.69896 13.4164C3.84178 11.9562 3.89188 10.0748 4.64374 8.46085C5.94027 5.68066 7.5242 3.11767 9.80316 1.02584C10.3311 0.544649 10.9493 0.227214 11.6343 0.0801842C12.6502 -0.14036 13.5123 0.0734814 14.1672 0.979049C15.4103 2.7033 16.1455 4.56124 15.8414 7.14094L15.838 7.14429ZM5.12495 28.6106L5.14832 28.5872C5.20179 28.8946 5.16502 29.2622 5.59608 29.3357C5.73309 29.3591 5.88347 29.2789 5.86342 29.1352C5.80996 28.781 5.46241 28.7676 5.21514 28.6373C5.1884 28.6239 5.15502 28.6139 5.1216 28.6072L5.12495 28.6106ZM14.0503 6.20528C13.9801 5.61382 13.9066 4.75839 13.7696 3.91297C13.6961 3.44514 13.7429 2.85369 13.1447 2.66656C12.5499 2.47943 12.1256 2.89046 11.7613 3.25803C10.2743 4.76508 8.99447 6.43921 7.93519 8.2704C7.68791 8.69478 7.22346 9.2695 7.58769 9.70391C7.9018 10.0782 8.51997 9.72062 8.99114 9.62371C10.5383 9.3096 11.8749 8.30382 13.519 8.28043C13.8966 8.27375 14.0503 7.9329 14.0536 7.56199C14.0536 7.19775 14.0536 6.83685 14.0536 6.20863L14.0503 6.20528ZM16.7369 15.6118C16.5431 15.6319 16.1121 15.5751 15.9784 15.8959C15.7812 16.3603 16.3393 16.3269 16.5498 16.5274C16.6935 16.6644 16.8505 16.7847 17.0009 16.9117C17.178 17.0621 17.3551 17.2392 17.6091 17.0721C17.7929 16.9518 17.8163 16.7446 17.8263 16.5475C17.8631 15.8758 17.5356 15.5684 16.7403 15.6118H16.7369ZM15.4504 19.1973C15.6475 19.1539 15.8648 19.1005 15.8614 18.8465C15.8581 18.5992 15.681 18.5057 15.4504 18.5524C15.2365 18.5992 15.0862 18.7529 15.0828 18.9668C15.0828 19.1773 15.2733 19.204 15.4504 19.1973ZM10.4748 24.2431C10.4147 24.1562 10.3712 24.0426 10.3177 24.0359C10.2509 24.0293 10.1406 24.0961 10.1106 24.1629C10.0571 24.2832 10.0905 24.4169 10.2543 24.4102C10.3211 24.4102 10.3846 24.3133 10.4715 24.2431H10.4748Z" fill="black"/>
                                  </svg>
                                <p><span>Не отделяете работу<br> от личной жизни,</span> даже<br> за ужином обсуждаете вопросы в чатах</p>
                            </li>
                            <li>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="36" viewBox="0 0 24 36" fill="none">
                                    <path d="M9.61274 0.168082C10.1089 0.128281 10.6104 0.112369 11.1039 0.0433807C12.6668 -0.174197 13.8661 0.438712 14.8399 1.61151C15.2406 2.09708 15.6306 2.59329 16.0552 3.06028C16.5699 3.62546 17.1829 4.02611 17.9948 3.85364C18.4538 3.75547 18.7537 3.94385 19.0137 4.27552C19.2233 4.54352 19.3878 4.86988 19.6505 5.07154C21.5371 6.52029 22.3278 8.58462 22.9381 10.7657C23.5165 12.83 23.0309 14.5893 21.5212 16.1044C18.9182 18.7126 16.0313 20.9786 13.0966 23.1916C11.8947 24.0964 10.8068 25.0993 9.93379 26.3411C9.29963 27.2433 8.85388 27.2008 8.16135 26.3252C7.81375 25.8847 7.54841 25.4098 7.3892 24.8738C7.0708 23.8124 5.98024 23.3136 4.92154 23.7408C4.7756 23.7992 4.64029 23.8814 4.49966 23.9557C3.56301 24.4466 3.41709 24.3776 3.25523 23.3534C3.1942 22.9713 3.0111 22.6795 2.70596 22.4327C0.408127 20.5912 -0.313596 18.1342 0.118907 15.3269C0.333832 13.9312 0.447942 12.5806 0.166682 11.1876C-0.244593 9.15247 0.315258 7.26857 1.31293 5.51998C2.84394 2.8321 4.95605 0.844707 8.12154 0.245041C8.37892 0.19728 8.64159 0.165441 8.90162 0.146867C9.13777 0.130947 9.37394 0.144211 9.61009 0.144211C9.61009 0.152171 9.61009 0.160122 9.61009 0.168082H9.61274ZM7.18754 9.24797C8.12684 8.81282 8.6708 7.95842 9.38721 7.28712C8.27279 7.44101 7.6519 8.03275 7.20348 9.27188C6.93018 9.59029 6.56133 9.85561 6.6144 10.3518C6.92219 10.044 7.25918 9.75212 7.18754 9.24797ZM12.8021 12.2994C11.4887 13.1193 10.6768 14.2523 9.62602 15.1146C9.30231 15.38 9.20413 15.831 9.15106 16.2556C9.08472 16.7863 9.35537 16.9985 9.78788 16.7199C11.364 15.7063 12.4625 14.3372 12.8021 12.2967V12.2994ZM1.91791 9.99359C2.1408 10.0652 2.23631 9.99888 2.27611 9.90601C2.74576 8.84996 3.43036 7.92129 4.01941 6.93688C4.14943 6.72196 4.18391 6.44599 4.24229 6.19392C4.27147 6.07186 4.28738 5.90735 4.13349 5.86225C4.05654 5.83837 3.9159 5.89143 3.85752 5.95776C2.81209 7.1173 2.05324 8.41217 1.91791 9.99625V9.99359ZM4.12818 16.9296C4.1494 16.2264 3.90264 15.6214 3.63465 15.0218C3.5577 14.8493 3.53913 14.5362 3.26848 14.5892C2.98722 14.6423 3.00051 14.9448 2.98989 15.173C2.96336 15.8072 3.06684 16.4254 3.25258 17.0277C3.35606 17.3647 3.4383 17.8715 3.86549 17.7946C4.26085 17.7229 4.06715 17.2161 4.12552 16.9269L4.12818 16.9296ZM10.7776 6.5654C11.3852 6.79359 11.7885 6.97137 12.2078 7.09608C12.7491 7.25528 13.1816 7.03771 13.5 6.5999C13.6061 6.45396 13.683 6.26293 13.5849 6.0825C13.484 5.89676 13.2877 5.87553 13.102 5.91002C12.367 6.05065 11.6426 6.23107 10.7776 6.56275V6.5654ZM21.0568 10.6304C21.0436 10.0891 20.8419 9.76539 20.4784 9.55312C20.3112 9.45495 20.1122 9.4682 19.9663 9.60883C19.6505 9.91132 19.7301 10.2775 19.8469 10.633C19.9132 10.832 20.0008 11.0231 20.1016 11.2062C20.1839 11.3601 20.213 11.5962 20.4359 11.5989C20.6827 11.6042 20.7782 11.3734 20.8631 11.1876C20.9613 10.978 21.0144 10.7498 21.0568 10.6278V10.6304ZM4.64561 20.9282C4.65622 21.0423 4.71723 21.1193 4.82602 21.1431C4.93746 21.167 5.04095 21.1325 5.06217 21.0131C5.08871 20.8619 4.99583 20.7743 4.85255 20.7584C4.7411 20.7478 4.66683 20.8141 4.64561 20.9282ZM7.48738 14.0214C7.63066 13.9339 7.7023 13.9073 7.7474 13.8569C7.81905 13.772 7.96499 13.6181 7.79252 13.5757C7.61475 13.5306 7.51391 13.7269 7.48738 14.0214Z" fill="black"/>
                                  </svg>
                                <p><span>Перестали получать удовольствие от работы,</span><br> а чего хочется на самом<br> деле — непонятно</p>
                            </li>
                        </ul>
                    </div>
                    <div><svg width="305" height="324" viewBox="0 0 305 324" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M198.469 114.737C165.295 136.178 49.4079 150.074 46.2922 125.661C43.5786 104.398 143.205 82.479 173.123 75.8595C182.96 73.6829 245.656 60.3073 248.004 78.7081C249.384 89.5165 221.607 98.8842 186.787 103.328C164.992 106.11 127.549 106.887 125.538 84.7337C124.243 70.4618 167.056 55.1401 198.11 52.2619C208.201 51.3266 215.357 55.038 215.861 58.9902" stroke="black" stroke-width="1.19317" stroke-linecap="round"/>
                        <path d="M106.376 68.6767C112.524 26.4986 255.408 59.3342 252.481 83.7338C249.932 104.985 147.902 101.929 117.254 101.047C107.176 100.757 43.07 98.4295 45.2758 80.0387C46.5715 69.2363 75.8122 66.9348 110.688 71.1179C132.518 73.7364 169.046 82.1096 165.598 104.051C163.377 118.187 118.091 122.589 87.2523 117.808C77.2309 116.254 70.3821 112.207 70.8559 108.257C71.3623 104.035 80.1862 104.186 85.9476 104.877C91.7091 105.568 137.711 112.261 138.146 133.72" stroke="black" stroke-width="1.19317" stroke-linecap="round"/>
                        <path d="M100.654 37.6168C106.801 -4.56125 249.685 28.2743 246.759 52.6739C244.21 73.9252 142.18 70.8692 111.531 69.9875C101.454 69.6976 37.3473 67.3696 39.5532 48.9789C40.8489 38.1764 70.0896 35.875 104.965 40.0581C126.795 42.6765 163.323 51.0498 159.875 72.9916C157.654 87.1276 112.369 91.5296 81.5297 86.7483C71.5083 85.1946 64.6595 81.147 65.1333 77.1968C65.6396 72.975 74.4635 73.1263 80.225 73.8174C85.9864 74.5084 131.988 81.2011 132.424 102.66" stroke="black" stroke-width="1.19317" stroke-linecap="round"/>
                        <path d="M154.717 145.566C115.484 140.899 34.369 80.4196 47.5144 59.6565C58.9636 41.5726 149.74 88.2542 177.023 102.244C185.994 106.844 242.854 136.543 232.946 152.192C227.126 161.385 199.743 150.874 170.065 132.085C151.489 120.324 122.124 97.0411 134.682 78.7208C142.772 66.918 185.541 82.4397 211.318 100.031C219.694 105.748 224.133 112.35 222.005 115.711C219.731 119.304 211.831 115.368 206.929 112.264C202.026 109.16 163.841 82.6395 172.686 63.0834C175.222 57.4756 183.401 60.4244 186.398 65.2987" stroke="black" stroke-width="1.19317" stroke-linecap="round"/>
                        <path d="M120.25 156.014C81.017 151.347 -0.0978017 90.868 13.0476 70.1049C24.4968 52.021 115.273 98.7026 142.556 112.692C151.528 117.292 208.387 146.991 198.479 162.641C192.659 171.833 165.276 161.323 135.598 142.533C117.022 130.772 87.657 107.489 100.215 89.1691C108.305 77.3663 151.074 92.8881 176.851 110.48C185.227 116.196 189.667 122.798 187.538 126.159C185.264 129.752 177.365 125.817 172.462 122.713C167.559 119.609 129.375 93.0879 138.219 73.5318C140.756 67.924 148.934 70.8727 151.931 75.747" stroke="black" stroke-width="1.19317" stroke-linecap="round"/>
                        <path d="M143.417 132.658C140.802 122.921 109.588 41.3092 127.838 38.143C138.558 36.2832 149.156 63.6326 155.161 98.2412C158.919 119.904 161.384 157.298 139.376 160.294C125.197 162.224 107.981 120.109 103.708 89.1949C102.32 79.1493 104.231 71.4268 108.151 70.7468C112.34 70.0199 114.728 78.5158 115.72 84.2332C116.712 89.9505 121.88 143.286 102.269 142.632C93.5233 142.34 101.274 105.922 102.873 100.428" stroke="black" stroke-width="1.19317" stroke-linecap="round"/>
                        <path d="M63.6565 137.097C54.9155 151.575 90.6238 190.315 153.781 178.813C232.727 164.435 51.8295 126.912 65.7484 174.368C79.6672 221.823 214.179 184.167 239.841 223.884C265.503 263.601 105.1 258.073 161.278 292.292C217.457 326.511 287.72 292.001 303.982 308.151" stroke="black" stroke-width="1.48879" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        
                    </div>
                </div>
                <div class="veb20-about__bottom">
                    <div>
                        <svg width="286" height="339" viewBox="0 0 286 339" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M227.816 152.181C154.635 57.5522 173.852 17.3706 189.946 13.9931C205.403 10.7492 213.525 43.859 214.817 63.0614C214.836 63.3392 215.278 63.3612 215.327 63.0872C219.178 41.5942 231.511 4.37064 253.54 11.2633C272.326 17.1412 260.092 75.4978 199.59 130.608" stroke="black" stroke-width="1.49521" stroke-linecap="round"/>
                            <path d="M228.01 152.446C238.086 167.073 197.788 205.686 125.805 193.569C35.8263 178.423 241.38 142.316 225.958 189.881C210.536 237.445 57.1104 198.416 28.2552 238.1" stroke="black" stroke-width="1.49521" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                                              
                    </div>
                    <div>
                        <div class="veb20-about__header">
                            По итогам вебинара вы
                        </div>
                        <ul>
                            <li>
                                <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                                    <path d="M0 21.5231C0.0510787 20.4162 0.0766181 19.3092 0.159621 18.2087C0.18516 17.8376 0.332005 17.4729 0.440548 17.1081C0.523551 16.8266 0.670396 16.5579 0.721474 16.2699C0.804477 15.7964 1.00239 15.3869 1.28333 15.003C1.58342 14.5871 1.8069 14.1329 1.87075 13.6082C1.90905 13.3202 1.99844 13.0131 2.15806 12.7764C3.2371 11.1959 4.14376 9.50034 5.39519 8.03509C5.58673 7.81114 5.68887 7.51682 5.84849 7.27368C5.96342 7.10092 6.07196 6.89616 6.23797 6.78739C7.13185 6.22432 7.71927 5.39252 8.20452 4.49034C8.44714 4.04244 8.79829 3.77371 9.23884 3.59455C9.56447 3.46018 9.83263 3.31941 9.9731 2.9483C10.1391 2.5132 10.5861 2.39162 10.9691 2.20607C11.614 1.89894 12.2397 1.60462 12.7888 1.07994C13.3954 0.497682 14.1807 0.107365 15.1001 0.158553C15.3108 0.17135 15.5279 0.132962 15.7322 0.0817745C16.3835 -0.0845861 17.0028 0.0177865 17.6094 0.25453C18.0882 0.440086 18.5735 0.600061 19.0204 0.843203C19.3844 1.04156 19.7547 1.29749 20.0037 1.62381C20.3868 2.1229 20.8209 2.49401 21.4339 2.61558C22.9854 2.91631 24.1155 3.85689 25.0349 5.0662C25.6032 5.80843 26.1268 6.58903 26.6439 7.36325C27.0717 7.9967 27.4292 8.68134 27.8762 9.30199C28.3295 9.92905 28.719 10.5689 28.9361 11.3239C29.1085 11.9382 29.3703 12.5268 29.5809 13.1283C29.6512 13.3266 29.747 13.5314 29.7661 13.7361C29.8555 14.7087 29.9385 15.6813 29.996 16.6602C30.0087 16.9098 29.996 17.1913 29.8874 17.4153C29.6192 17.9719 29.5809 18.5606 29.5171 19.1557C29.4788 19.5396 29.4022 19.9107 29.0893 20.1922C28.968 20.301 28.8595 20.4545 28.8148 20.6081C28.4189 21.9326 27.5633 22.8732 26.4524 23.6602C25.7628 24.1465 25.1435 24.7415 24.4986 25.2982C23.9814 25.7461 23.426 26.1108 22.7875 26.3859C22.1745 26.6547 21.5999 27.045 21.07 27.4609C19.9015 28.3631 18.5863 28.9197 17.1752 29.2845C15.8152 29.6364 14.5064 30.1163 13.2805 30.8137C12.7824 31.0952 12.227 31.108 11.6715 31.1016C11.2948 31.0952 10.9053 31.1464 10.535 31.0952C9.72411 30.9864 8.93238 31.1976 8.13428 31.1912C6.88924 31.1848 5.6825 30.9033 4.55877 30.3658C4.18206 30.1866 3.83726 29.9179 3.51802 29.6492C2.4326 28.7342 1.57704 27.6144 0.874704 26.3923C0.338378 25.4582 0.0829967 24.4216 0.0574573 23.3339C0.0446876 22.7388 0.0574573 22.1374 0.0574573 21.5423C0.031918 21.5295 0.0191545 21.5295 0 21.5231ZM15.1065 3.05068C14.0147 3.06348 13.0697 3.41539 12.2014 3.97846C11.0266 4.74628 9.96672 5.64207 8.92599 6.60184C6.54445 8.80931 4.82694 11.4711 3.32012 14.2992C2.96257 14.971 2.6497 15.6813 2.41985 16.4107C2.11338 17.3769 1.74942 18.375 1.69834 19.3668C1.62811 20.6721 1.61536 21.9838 1.81968 23.3083C2.09423 25.1318 2.96893 26.5203 4.45021 27.4929C5.97619 28.491 7.76394 28.8302 9.5517 28.8813C10.6882 28.9133 11.8311 28.6766 12.974 28.5486C13.223 28.523 13.4784 28.459 13.721 28.3759C16.0259 27.6208 18.1649 26.5139 20.2527 25.3046C21.0508 24.8439 21.7148 24.1529 22.6151 23.8393C22.8449 23.7562 23.0301 23.5514 23.2216 23.3787C23.6367 23.0139 24.0581 22.6556 24.4475 22.2653C25.1116 21.6063 25.7756 20.9472 26.3949 20.2498C26.6695 19.9363 26.8993 19.5524 27.0398 19.162C27.3335 18.3622 27.5187 17.5304 27.806 16.7306C28.1252 15.8476 28.0869 14.9583 27.8954 14.0817C27.4356 12.0149 26.4077 10.2106 25.169 8.51498C25.0669 8.38061 24.9392 8.26544 24.8242 8.13747C23.5856 6.86418 22.0852 6.00678 20.4251 5.39892C19.5759 5.08539 18.6756 4.96382 17.8009 4.95103C17.0156 4.93823 16.2111 5.18137 15.4321 5.36693C14.8894 5.4949 14.3595 5.64206 13.804 5.52689C13.6572 5.4949 13.4465 5.36692 13.4209 5.25175C13.389 5.07259 13.4465 4.82945 13.555 4.67589C13.6699 4.50953 13.8742 4.40716 14.053 4.29838C14.3403 4.11923 14.6532 3.97845 14.9341 3.79289C15.1512 3.66492 15.3236 3.46658 15.1065 3.05068ZM14.2318 0.990356C14.1999 0.93277 14.1807 0.894388 14.1552 0.855997C14.1424 0.881591 14.1169 0.919979 14.1296 0.932776C14.1424 0.95837 14.1807 0.964762 14.2318 0.990356Z" fill="black"/>
                                    <path d="M14.2318 0.990281C14.1807 0.964687 14.1424 0.958295 14.1296 0.932701C14.1232 0.919904 14.1487 0.881516 14.1551 0.855922C14.1743 0.894313 14.1998 0.932694 14.2318 0.990281Z" fill="black"/>
                                    <path d="M19.595 20.1474C19.0268 22.3037 17.5135 23.5514 15.4768 24.2168C14.4297 24.5623 13.3442 24.7031 12.2141 24.5111C10.7903 24.2744 9.96665 23.3466 9.36648 22.1885C8.98339 21.4399 8.91316 20.5761 8.89401 19.6291C9.1494 19.6931 9.33457 19.6931 9.44311 19.7827C9.70489 19.9938 9.93473 20.2497 10.1646 20.4929C10.4008 20.736 10.6179 21.0048 10.8541 21.2415C11.7544 22.1245 12.7888 22.5276 14.0913 22.3676C15.3938 22.2077 16.575 21.8366 17.5838 20.9792C17.9733 20.6465 18.3627 20.3201 18.7841 20.0322C19.0267 19.8722 19.3268 19.7891 19.595 20.1474Z" fill="black"/>
                                    <path d="M13.0633 8.73893C13.1782 8.88609 13.3251 9.03326 13.4209 9.20602C13.9636 10.1466 14.1743 11.1832 14.2828 12.2453C14.3914 13.301 14.468 14.3568 14.5446 15.419C14.5574 15.6237 14.5254 15.8476 14.4488 16.0332C14.3914 16.1676 14.2381 16.3275 14.1041 16.3467C13.9764 16.3659 13.7529 16.2443 13.7082 16.1292C13.5422 15.7453 13.4145 15.3358 13.3123 14.9263C13.1016 14.1073 12.9675 13.2627 12.7121 12.4565C12.3227 11.2151 12.6164 10.0378 12.8909 8.8477C12.8973 8.8221 12.9611 8.80291 13.0633 8.73893Z" fill="black"/>
                                    <path d="M16.3803 17.1722C16.2782 17.1146 16.0866 17.0698 16.0228 16.9546C15.927 16.7819 15.8632 16.5515 15.8823 16.3532C15.9526 15.3422 16.0419 14.3249 16.1569 13.3203C16.2207 12.7764 16.3292 12.2325 16.4378 11.6951C16.4761 11.4967 16.5783 11.3112 16.6421 11.1256C17.3444 11.3304 17.7211 11.6503 17.619 12.111C17.2487 13.7554 17.2423 15.483 16.5463 17.057C16.5336 17.089 16.4761 17.1018 16.3803 17.1722Z" fill="black"/>
                                  </svg>
                                <p>Поймете, как пошагово прийти к карьере, <span>которая будет приносить радость и доход</span></p>
                            </li>
                            <li>
                                <svg xmlns="http://www.w3.org/2000/svg" width="40" height="51" viewBox="0 0 40 51" fill="none">
                                    <path d="M11.5482 46.4442C11.6286 46.4098 11.686 46.3295 11.7319 46.2492C14.9469 41.4442 17.1056 35.9283 17.9782 30.2059C18.1045 29.4032 19.1264 29.1509 19.9417 29.0935C21.618 28.9674 23.2944 28.8412 24.9593 28.7266C26.8309 28.589 28.9781 28.3023 30 26.7312C27.6347 24.1854 25.2694 21.6395 22.9155 19.1052C22.7433 18.9217 22.5711 18.7267 22.5251 18.4859C22.4792 18.2107 22.594 17.9469 22.7089 17.6947L25.9927 10.6764C25.4416 10.6076 24.9019 10.5503 24.3508 10.4815C23.6619 9.41498 22.9615 8.35995 22.2725 7.29345C20.8258 8.74985 19.379 10.2177 17.9323 11.6856C17.7371 11.8805 17.5074 12.0984 17.2319 12.0755C16.9448 12.064 16.7381 11.7888 16.5659 11.548L13.5002 7.12144C13.3739 6.92649 13.1328 7.22465 13.0065 7.4196C12.8802 7.61455 12.4783 7.33932 12.7079 7.31639C13.2361 6.75447 12.6505 5.87146 12.0994 5.33248C11.9386 5.1834 11.7434 5.02285 11.5252 5.06872C11.4449 5.09166 11.3875 5.17193 11.376 5.2522C10.067 3.23389 8.40211 1.4564 6.48459 0C5.29045 0.986222 5.5201 2.84399 5.83012 4.35772C6.78314 8.89893 7.518 13.486 8.05766 18.0846C8.20692 19.346 8.21839 20.8827 7.16203 21.5937C5.07229 23.0157 3.09737 24.5867 1.23726 26.2954C0.67464 26.8229 0.0775608 27.4307 0.00866803 28.1991C-0.106153 29.3 0.938721 30.2403 2.01804 30.4697C3.10884 30.6875 4.22261 30.4009 5.31341 30.183C6.56496 29.9307 7.82801 29.7816 9.09104 29.7243C9.55033 34.3801 9.55033 39.0819 9.09104 43.7378C8.96474 45.0222 8.81547 46.4098 9.46995 47.5221C10.0211 47.4648 10.5722 47.4189 11.1349 47.3616C10.4804 46.6965 10.5608 45.4694 11.2841 44.896C11.3875 45.1942 11.1808 45.5038 11.1004 45.8134C11.02 46.1231 11.2612 46.5703 11.5482 46.4327V46.4442ZM26.6702 24.2312C26.7965 24.2427 26.7965 24.4721 26.6702 24.4835C26.5439 24.4835 26.5439 24.2427 26.6702 24.2312ZM23.9145 12.4654C23.9489 12.603 23.8571 12.7406 23.7537 12.8553C23.6159 12.7635 23.5585 12.5686 23.6159 12.4195H23.593C23.6159 12.2704 23.8685 12.3163 23.903 12.4654H23.9145ZM22.3414 15.5158C22.5136 15.8713 22.5022 16.3071 22.3185 16.6626V16.7084C22.3185 16.7084 22.284 16.7084 22.2725 16.7084C22.0314 16.7084 21.8477 16.4103 21.8936 16.158C21.9395 15.8942 22.1462 15.6878 22.3414 15.5043V15.5158ZM17.4845 29.5981C17.3582 29.7931 17.0252 29.7816 16.8989 29.5981C17.0252 29.4032 17.3582 29.4032 17.4845 29.5981ZM14.3154 39.6668C14.2121 39.1622 14.2465 38.6232 14.4188 38.1301C14.6139 38.6461 14.7632 39.3342 14.3154 39.6668ZM16.3363 31.6164C16.3822 31.4788 16.6348 31.5591 16.6004 31.6852C16.5085 31.6852 16.4166 31.6967 16.3248 31.7082L16.3477 31.6164H16.3363ZM16.3133 33.0843H16.2674C16.2559 33.176 16.1755 33.2219 16.0837 33.2219C15.9344 33.2219 15.7622 33.1187 15.7507 32.9581C15.7392 32.6944 15.9803 32.4994 16.21 32.3618C16.3363 32.5682 16.3822 32.8435 16.3248 33.0843H16.3133ZM15.877 18.4056L15.9688 18.3827C15.9688 18.6235 15.7966 18.8529 15.5784 18.9446C15.3029 18.7841 15.5899 18.2566 15.877 18.4056ZM15.7162 34.0132L15.3144 34.1508L15.2225 34.1279C15.1192 33.8526 15.6818 33.7265 15.7162 34.0132ZM15.3718 35.3434C15.5096 35.481 15.4751 35.7448 15.3029 35.848C15.1536 35.7104 15.0158 35.5613 14.8666 35.4237C14.9584 35.2517 15.234 35.2173 15.3718 35.3549V35.3434ZM14.5451 22.0409C14.3384 22.2703 14.0858 22.4423 13.8217 22.6143C13.6954 22.6946 13.5461 22.7634 13.4083 22.7634C13.3279 22.7634 13.2476 22.7404 13.1902 22.6716C13.0294 22.4767 13.2131 22.19 13.3968 22.018C13.948 21.4905 14.4991 20.9515 15.0503 20.424C15.1306 21.0088 14.9354 21.6166 14.5451 22.0409ZM13.8561 17.2359C13.9709 17.2359 13.9824 17.4768 13.8561 17.4882C13.7298 17.4882 13.7298 17.2474 13.8561 17.2359ZM10.9971 9.57552C12.042 11.0549 13.0753 12.5457 14.1202 14.025C14.2236 14.1626 14.3269 14.3231 14.3269 14.4952C14.3269 14.6901 14.2236 14.8621 14.1202 15.0227C13.6265 15.7337 13.0524 16.3644 12.3864 16.9148C12.0534 16.7658 11.9845 16.33 11.9501 15.963C11.8008 14.3002 11.4678 12.6489 10.9626 11.0549C10.8019 10.5617 10.6526 9.96543 10.9971 9.58699V9.57552ZM9.29771 8.5549C9.32068 8.27967 9.4355 8.00445 9.32068 7.75216H9.33216C9.3666 7.51134 9.21734 7.25905 8.99918 7.16731C9.17141 6.88062 9.63069 7.16731 9.74551 7.47694C9.86034 7.79803 9.90628 8.21087 10.2278 8.32555C9.92924 8.37142 10.0326 8.92187 9.75701 9.05948C9.72256 9.08241 9.68812 9.08241 9.65367 9.08241C9.44699 9.08241 9.28623 8.79572 9.29771 8.56637V8.5549ZM10.9397 43.9786C10.8134 43.9786 10.8134 43.7378 10.9397 43.7263C11.066 43.7263 11.066 43.9671 10.9397 43.9786ZM10.9167 18.0616C10.6756 17.5685 10.733 16.9607 11.043 16.502C10.6756 16.1236 10.5608 15.5731 10.4689 15.0571C10.3196 14.2199 10.1704 13.3943 10.0211 12.5571C9.90627 11.9379 9.80294 11.3186 9.68812 10.6994C9.65367 10.4815 9.71108 10.1374 9.94073 10.1833C10.0785 10.2062 10.1244 10.3783 10.1474 10.5159C10.423 12.1328 10.71 13.7383 10.9856 15.3438C11.0315 15.6305 11.3301 15.8025 11.5138 16.0318C11.6975 16.2612 11.6745 16.7314 11.376 16.7199C11.6401 16.846 11.686 17.2245 11.5482 17.4768C11.4104 17.7291 11.1578 17.8896 10.9167 18.0501V18.0616Z" fill="black"/>
                                  </svg>
                                <p>Узнаете, какие инструменты необходимы, чтобы <span>достичь личной «идеальной» карьеры</span></p>
                            </li>
                            <li>
                                <svg xmlns="http://www.w3.org/2000/svg" width="40" height="60" viewBox="0 0 40 60" fill="none">
                                    <path d="M22.5366 49C39.6862 13.6262 30.7936 2 25.3894 2C20.1991 2 19.8218 13.1969 20.7023 19.46C20.7151 19.5506 20.5742 19.5876 20.5399 19.5028C17.8507 12.8501 11.3717 1.71069 4.75198 5.41436C-0.893169 8.57276 6.98041 26.5157 30.1587 40.1565" stroke="black" stroke-width="2.66038" stroke-linecap="round"/>
                                  </svg>
                                <p>Проработаете внутренние установки, которые мешают <span>получать от карьеры максимум</span></p>
                            </li>
                            <li>
                                <svg xmlns="http://www.w3.org/2000/svg" width="40" height="60" viewBox="0 0 40 60" fill="none">
                                    <path d="M7.40088 19.923C6.37536 18.2008 5.34557 16.4828 4.32006 14.7606C4.46107 15.2136 4.5978 15.6623 4.73454 16.1153L2.5724 12.423C3.03816 12.9957 3.50819 13.5726 3.97394 14.1495C3.88848 14.4016 4.04231 14.7136 4.30297 14.7948C4.23887 14.5555 4.12777 14.329 3.98249 14.1281L3.97394 14.1495C3.29027 12.8803 2.31603 11.7692 1.15377 10.9188C1.01276 10.8162 0.863212 10.7136 0.688019 10.7051C0.192353 10.6752 -0.00420492 11.3376 6.8068e-05 11.8333C0.012887 13.7136 0.495734 15.5555 0.944398 17.3803C2.13656 22.2093 3.12789 27.0896 3.91412 32.0041C3.97822 32.3888 4.04231 32.7862 4.26024 33.1067C4.48243 33.4272 4.90546 33.6409 5.26439 33.4956C5.03365 33.7819 4.79863 34.0811 4.71317 34.4358C4.62771 34.7947 4.73026 35.2263 5.05501 35.4016C5.37548 35.5768 5.7686 35.4528 6.11044 35.3246C10.6483 33.6409 15.323 32.3375 20.0746 31.4315C18.3312 30.7135 16.4553 30.3546 14.571 30.3375C14.5795 30.3418 14.5838 30.346 14.5923 30.3503V30.3588C14.4983 30.4358 14.3488 30.4315 14.259 30.3546C14.2676 30.346 14.2761 30.3418 14.2847 30.3375C11.1483 30.3674 8.01192 31.346 5.47804 33.1964C5.64896 31.2477 5.3413 29.2905 5.01228 27.3631C4.25169 22.9273 3.37145 18.5085 2.37157 14.1196C3.38854 15.5512 4.29442 17.0683 5.0721 18.6452C5.41394 19.3418 5.74296 20.0597 6.25999 20.6409C6.77703 21.2221 7.52907 21.6495 8.30248 21.5683C9.56729 21.4358 10.298 20.1068 10.8022 18.9444C12.2123 15.7093 13.5796 12.4529 14.9042 9.17945C14.5667 9.16235 14.2547 9.48287 14.2804 9.8162C14.0411 9.21364 14.3616 8.44441 14.9598 8.188C14.8359 8.48287 14.712 8.78201 14.588 9.07688C15.3956 8.34184 15.9426 7.32903 16.1135 6.24784C15.8571 6.40168 15.6734 6.67946 15.6307 6.97433L15.1393 6.60254C15.5025 6.54271 15.8187 6.24784 15.8999 5.88459C16.0708 5.9316 16.2203 6.05553 16.293 6.2222C16.669 5.3504 17.1775 4.53844 17.8013 3.81622C17.4381 7.56834 17.2159 11.3333 17.1347 15.1025C17.1134 16.0939 17.1091 17.111 17.4809 18.0298C17.8526 18.9486 18.6944 19.7478 19.6857 19.7563C20.6941 19.7649 21.5231 18.9999 22.2367 18.2862C24.7065 15.8119 27.1763 13.3333 29.6418 10.8589C27.689 14.9529 25.7875 19.0726 23.9373 23.2179C22.4973 26.4443 21.0659 29.8076 21.0744 33.3417C21.2411 33.0768 21.4077 32.8118 21.5744 32.5469C21.5829 32.5853 21.6043 32.6195 21.647 32.6281C21.741 32.6452 21.8265 32.5682 21.8906 32.4956C23.7365 30.4144 24.9928 27.8888 26.2277 25.3973C28.6034 20.6068 30.9835 15.8034 32.8593 10.7906C33.2567 9.72645 32.7782 8.44441 31.8509 7.79056C27.2361 10.1453 23.9801 14.5213 19.6302 17.3333C19.7028 12.2264 19.7754 7.11963 19.8438 2.01281C19.8481 1.58546 19.6473 0.978628 19.2328 1.09829C18.8012 1.22222 18.8183 0.423075 18.4893 0.119657C18.3995 0.0384609 18.297 0 18.1902 0C17.8654 0 17.5022 0.32051 17.2886 0.628201C13.5882 5.94015 11.6995 12.2606 8.98616 18.1367C8.64004 18.8803 8.19565 19.6965 7.40515 19.9144L7.40088 19.923ZM16.904 31.517C16.9339 31.4913 16.9766 31.4871 17.0194 31.4828C17.1006 31.4742 17.1903 31.4742 17.2544 31.5212C17.3185 31.5682 17.327 31.6922 17.2501 31.7178L17.2373 31.6922C17.1775 31.7135 17.1134 31.7392 17.0493 31.7392C17.0236 31.7392 17.0023 31.7392 16.9766 31.7264C16.8955 31.6964 16.8442 31.5768 16.9083 31.5212L16.904 31.517ZM1.60244 13.4444C1.59389 13.4102 1.58535 13.3717 1.59816 13.3418C1.6238 13.2649 1.74345 13.2606 1.80327 13.3205C1.86309 13.376 1.87591 13.4658 1.88873 13.547L2.01692 14.5299C2.02546 14.5854 2.03828 14.6495 2.08528 14.6794C2.17074 14.7264 2.34594 14.6709 2.32884 14.7692C2.19638 14.7692 2.05965 14.8076 1.95282 14.8888C1.83318 14.4102 1.71781 13.9316 1.59816 13.4529L1.60244 13.4444ZM5.05501 31.7734C5.05501 31.8546 5.08065 31.9315 5.10629 32.0127C5.19602 32.3118 5.19175 32.6366 5.09347 32.9315C5.04219 32.5298 4.99091 32.1281 4.93537 31.7221C4.90973 31.5212 4.914 31.2606 5.10201 31.1836C5.26439 31.3161 5.06356 31.564 5.05501 31.7734ZM4.90118 29.3247C5.02083 29.9016 5.06783 30.4913 5.03792 31.0811C4.83282 30.9999 4.82 30.7221 4.82427 30.4999C4.83282 30.0469 4.76872 29.5896 4.64053 29.1537C4.67044 29.0939 4.76872 29.0939 4.82 29.1409C4.87127 29.1879 4.88837 29.2606 4.90118 29.3247ZM4.38842 24.9272L4.39697 24.9614C4.36279 24.9614 4.3286 24.9572 4.29442 24.9529C4.2816 24.9016 4.37561 24.876 4.3927 24.9272H4.38842ZM3.95258 22.4315V22.4657C3.92694 22.4657 3.89276 22.4657 3.8543 22.4614C3.84148 22.4102 3.93549 22.3845 3.95258 22.4358V22.4315ZM3.45264 21.8546C3.56374 22.2392 3.67483 22.6196 3.79021 23.0042C3.82439 23.1238 3.85858 23.2606 3.79875 23.3674C3.74748 23.4614 3.78166 23.5768 3.81585 23.6794C3.92267 23.9785 4.02949 24.2819 4.13632 24.5811C4.05086 25.0469 4.17905 25.5512 4.48243 25.9144C4.29442 26.1922 4.39697 26.564 4.4867 26.8888C4.6448 27.4614 4.75163 28.0469 4.79863 28.6366C4.8029 28.7007 4.76445 28.7948 4.71317 28.7948C4.70463 28.7948 4.69181 28.7948 4.68326 28.7819C4.66617 28.7691 4.6619 28.7435 4.65762 28.7221C4.52089 28.0212 4.38415 27.3161 4.24742 26.6153C4.14486 26.0811 4.04231 25.5469 3.93549 25.017L3.37573 22.1196C3.35864 22.0213 3.35864 21.8931 3.44837 21.8632L3.45264 21.8546ZM3.30309 21.6367C3.30309 21.6367 3.28172 21.6367 3.2689 21.6281C3.23899 21.6153 3.2219 21.5854 3.20908 21.5597C3.1578 21.4614 3.10226 21.3589 3.09798 21.2478C3.09798 21.1367 3.15781 21.0127 3.26463 20.9871C3.30309 21.1196 3.34582 21.252 3.38427 21.3845C3.41418 21.4828 3.38427 21.6367 3.30309 21.6367ZM2.96552 19.4401C3.04243 19.8076 3.11935 20.1794 3.2689 20.5256C3.29881 20.5982 3.333 20.6794 3.3159 20.7563C3.30308 20.8119 3.24327 20.8589 3.19199 20.8589C3.17062 20.8589 3.14926 20.8503 3.13644 20.8375C3.11507 20.8162 3.10653 20.782 3.09798 20.752C2.99116 20.2862 2.8886 19.8162 2.78178 19.3503C2.69205 18.9315 2.59804 18.5127 2.50831 18.0939C2.46131 17.876 2.41858 17.6281 2.55531 17.4486L2.96979 19.4444L2.96552 19.4401ZM2.52968 17.0085C2.48267 17.1025 2.43994 17.1922 2.39294 17.2863C2.34166 17.0811 2.28611 16.8717 2.23484 16.6623C2.12801 16.2478 2.0511 15.8247 2.00837 15.3974C1.99982 15.329 2.00837 15.2393 2.07674 15.2222C2.11092 15.2136 2.14083 15.2307 2.17074 15.2478C2.29893 15.3375 2.34166 15.5213 2.27757 15.6623C2.20493 15.8119 2.24766 15.9871 2.29466 16.1452C2.37585 16.4316 2.45276 16.7179 2.53395 17.0042L2.52968 17.0085ZM5.48658 17.2521C5.47376 17.2008 5.56777 17.1751 5.58486 17.2264C5.58486 17.2392 5.58486 17.2478 5.58913 17.2606C5.55495 17.2606 5.52077 17.2563 5.48658 17.2521ZM6.28563 18.7179C6.20444 18.5811 6.12326 18.4401 6.04207 18.3033C6.0378 18.2392 6.13608 18.3119 6.1318 18.3717C6.2899 18.3717 6.39246 18.5982 6.28563 18.7179ZM25.9328 24.7691C25.8815 24.7349 25.8602 24.6666 25.8815 24.6067C25.826 24.5042 26.0097 24.3888 26.0738 24.4871C26.0268 24.5811 25.9756 24.6751 25.9286 24.7691H25.9328ZM26.202 24.1708C26.202 24.1708 26.1807 24.2008 26.1593 24.2008C26.1294 24.2008 26.0909 24.1751 26.0867 24.1409C26.0781 24.0854 26.1208 24.0384 26.1593 23.9956C26.1764 24.0512 26.1977 24.1067 26.2191 24.1623L26.2063 24.1708H26.202ZM26.9071 22.3717C26.8601 22.3717 26.8601 22.282 26.9071 22.2777C26.9541 22.2777 26.9541 22.3674 26.9071 22.3717ZM27.7745 20.5341C27.7018 20.4871 27.7018 20.3632 27.7745 20.3204L27.783 20.2991C27.8343 20.3204 27.8899 20.3461 27.9411 20.3674C27.8856 20.423 27.83 20.4785 27.7788 20.5341H27.7745ZM28.3172 19.6666C28.2445 19.6196 28.2445 19.4956 28.3172 19.4529C28.3898 19.4999 28.3898 19.6238 28.3172 19.6666ZM32.5517 9.26064C32.5987 9.35466 32.6457 9.4615 32.6158 9.56406C32.5944 9.63244 32.5218 9.67945 32.4534 9.67945C32.4192 9.67945 32.3893 9.66662 32.3679 9.63671L32.3893 9.62816C32.3466 9.48714 32.4192 9.32475 32.5517 9.25637V9.26064ZM32.4449 9.90167C32.556 10.0769 32.5004 10.3333 32.3252 10.4487C32.2141 10.2735 32.2697 10.0128 32.4449 9.90167ZM31.9663 10.9658C32.0176 10.7777 32.15 10.5512 32.3423 10.5897C32.3893 10.6794 32.4363 10.7692 32.4919 10.8547C32.3466 10.8333 32.1885 10.8931 32.0987 11.0128C32.1671 11.282 32.0603 11.5897 31.8338 11.7521C31.8552 11.4871 31.8979 11.2222 31.9663 10.9615V10.9658ZM29.8255 16.4102C29.7785 16.329 29.7614 16.2307 29.7828 16.141L29.7913 16.0897C29.911 16.141 29.9281 16.3333 29.8212 16.4102H29.8255ZM29.8341 10.3376C29.8982 10.3717 29.911 10.4743 29.8597 10.5256C29.8084 10.5769 29.7101 10.5641 29.6717 10.5C29.7272 10.4487 29.7785 10.3931 29.8341 10.3376ZM28.8 11.2051C28.8513 11.2948 28.7615 11.3974 28.6804 11.4658C28.5522 11.5683 28.424 11.6666 28.2958 11.7692C28.2488 11.8076 28.1761 11.8461 28.1163 11.8461C28.0821 11.8461 28.0522 11.8333 28.0351 11.8034C28.2616 11.5726 28.518 11.3717 28.7957 11.2051H28.8ZM27.3985 12.4188L27.3899 12.4572C27.4284 12.5341 27.3386 12.6068 27.2617 12.6068C27.2318 12.6068 27.2019 12.594 27.1848 12.5641C27.219 12.4786 27.3045 12.4188 27.3942 12.4188H27.3985ZM26.6421 13.4358C26.4798 13.4914 26.3345 13.5897 26.2277 13.7222L26.1978 13.7051C26.202 13.735 26.2063 13.7692 26.1849 13.7905C26.1807 13.7948 26.1721 13.7991 26.1636 13.7991C26.1422 13.7991 26.1208 13.782 26.1294 13.7649C26.1678 13.6452 26.2106 13.5213 26.3046 13.4401C26.3986 13.3589 26.5652 13.3418 26.6421 13.4401V13.4358ZM26.1508 12.4059C26.1978 12.4102 26.1978 12.4957 26.1508 12.4999C26.108 12.4957 26.108 12.4102 26.1508 12.4059ZM25.7149 14.0256C25.779 14.0598 25.7918 14.1581 25.7405 14.2136C25.6893 14.2649 25.591 14.2521 25.5525 14.188C25.6081 14.1367 25.6594 14.0811 25.7149 14.0299V14.0256ZM25.5055 14.4658C25.5696 14.47 25.5055 14.5769 25.4414 14.564L25.4543 14.5897C25.3731 14.6239 25.3602 14.735 25.3218 14.8162C25.3004 14.8632 25.2406 14.8931 25.1936 14.8931C25.1594 14.8931 25.1295 14.876 25.1295 14.8375C25.2534 14.7136 25.3816 14.5897 25.5098 14.47L25.5055 14.4658ZM24.339 15.6922C24.3988 15.6324 24.5099 15.7393 24.4672 15.8119C24.4458 15.8461 24.4074 15.8632 24.3646 15.8632C24.3219 15.8632 24.2749 15.8461 24.2493 15.8119C24.2877 15.7734 24.3219 15.7392 24.3604 15.7008L24.339 15.6922ZM19.1174 17.4529C19.0619 17.5768 19.0191 17.7051 18.9764 17.8375C18.9038 17.4316 18.9038 17.0128 18.9807 16.6068C19.0234 16.8162 19.0704 17.0256 19.1131 17.235C19.1302 17.3076 19.1431 17.3845 19.1131 17.4529H19.1174ZM18.9978 15.2136C19.0448 15.2948 19.0619 15.3931 19.0405 15.4828L19.032 15.5341C18.9123 15.4828 18.8952 15.2905 19.002 15.2136H18.9978ZM19.126 14.7393L18.9935 14.9999C18.9422 14.9657 18.9209 14.8931 18.9422 14.8375H18.9379C18.9038 14.7991 18.8696 14.7649 18.8397 14.7307C18.8781 14.6666 18.9209 14.6025 18.9892 14.5769C19.0576 14.5512 19.1516 14.5854 19.1559 14.6581C19.1559 14.688 19.143 14.7179 19.1302 14.7435L19.126 14.7393ZM19.1388 12.9401C19.1388 12.9401 19.1174 12.9401 19.1046 12.9316C19.079 12.9145 19.0661 12.8846 19.0533 12.8546C18.9593 12.5897 18.8824 12.2435 19.1046 12.0726C19.143 12.2905 19.1858 12.5085 19.2242 12.7264C19.2413 12.8119 19.2029 12.9401 19.1345 12.9401H19.1388ZM18.9465 11.2307C19.049 11.2136 19.143 11.1623 19.2157 11.0854C19.2841 11.2222 19.2841 11.3931 19.2157 11.5299L19.1858 11.5555C19.0704 11.4829 18.9849 11.3632 18.9508 11.2307H18.9465ZM19.3097 16.7392C19.2242 16.6025 19.2285 16.4187 19.314 16.282C19.3353 16.3375 19.361 16.3931 19.3823 16.4486L19.361 16.4572C19.3866 16.5512 19.3695 16.658 19.3097 16.735V16.7392ZM19.4208 12.8247C19.3482 12.7777 19.3482 12.6538 19.4208 12.6111C19.4934 12.6581 19.4934 12.782 19.4208 12.8247ZM19.2627 1.80768C19.2371 1.74785 19.267 1.67093 19.3225 1.64529C19.3952 1.82478 19.3909 2.03418 19.3097 2.20512C19.2456 2.08546 19.2285 1.94444 19.2627 1.81196V1.80768ZM19.2285 3.84614C19.2499 3.75639 19.2841 3.66665 19.3268 3.58118C19.3909 3.91024 19.3909 4.25212 19.3311 4.58545C19.1858 4.37605 19.1644 4.094 19.2285 3.84614ZM19.2499 5.38887C19.2499 5.43587 19.1601 5.43587 19.1559 5.38887C19.1559 5.34613 19.2456 5.34186 19.2499 5.38887ZM19.2029 2.94871C19.2755 2.99571 19.2755 3.11965 19.2029 3.16238C19.1302 3.11537 19.1302 2.99144 19.2029 2.94871ZM19.1516 5.81622C19.2242 5.73075 19.3738 5.82049 19.3909 5.9316C19.4122 6.04271 19.361 6.15382 19.3652 6.26493C19.3652 6.37604 19.4721 6.50425 19.5746 6.45724C19.4977 6.51707 19.4165 6.5769 19.3909 6.67091C19.3652 6.76066 19.4251 6.88459 19.5191 6.88031C19.6174 6.87604 19.5832 7.04271 19.4934 7.08117C19.4037 7.11963 19.2798 7.14527 19.267 7.23928L19.3695 7.34612C19.314 7.40168 19.2627 7.45296 19.2114 7.50424C18.9636 7.17091 19.408 6.62818 19.1516 6.29912C19.0448 6.16237 19.049 5.95296 19.1516 5.82049V5.81622ZM19.1003 8.23928C19.1345 8.05979 19.1687 7.88031 19.2029 7.69655C19.4037 7.94014 19.4422 8.29911 19.3011 8.58116C19.2371 8.70082 19.2926 8.84612 19.3182 8.9786C19.3439 9.11107 19.3182 9.28629 19.1901 9.32902C19.1174 9.06834 19.0405 8.80338 19.0576 8.52988C19.0661 8.43159 19.0832 8.3333 19.1003 8.23928ZM19.0661 10.0042L19.2542 10.1666C19.2157 10.2008 19.1815 10.2393 19.1473 10.2735C19.361 10.47 19.2627 10.8931 18.9807 10.97C18.9294 10.9188 18.8781 10.8717 18.8269 10.8205C18.9935 10.5854 19.079 10.2906 19.0619 10.0042H19.0661ZM18.8568 13.0598C18.9294 12.9914 19.0533 13.0341 19.1089 13.1153C19.1644 13.1965 19.1687 13.3034 19.1687 13.4017C19.1687 13.7008 19.1687 14.017 18.9978 14.2606C18.8354 14.0341 18.9978 13.7093 18.9038 13.4487C18.8568 13.3162 18.7542 13.1581 18.8525 13.0598H18.8568ZM17.8099 2.41025C17.8569 2.5299 17.8654 2.66238 17.8441 2.79059L17.8312 2.78204C17.78 2.88033 17.7287 2.97434 17.6731 3.07263C17.5834 2.85041 17.639 2.57691 17.8099 2.41025ZM16.8015 4.36323C16.8869 4.39742 16.951 4.48289 16.9596 4.5769H16.904C16.8826 4.70511 16.81 4.82477 16.7074 4.90169C16.6519 4.84613 16.5963 4.79058 16.5451 4.7393C16.6733 4.64955 16.763 4.5128 16.8057 4.36323H16.8015ZM15.8956 5.62391C15.9426 5.52989 16.0964 5.55553 16.1648 5.47861C16.2374 5.39741 16.1819 5.27348 16.1477 5.17092C16.1135 5.06835 16.1648 4.90596 16.2673 4.93587C16.4553 5.22647 16.2716 5.67946 15.9383 5.75639C15.8913 5.73502 15.8742 5.67092 15.8956 5.62818V5.62391ZM15.182 7.18373C15.2504 7.18373 15.1948 7.31193 15.1307 7.28629L15.1222 7.29484C15.1478 7.3333 15.0965 7.36749 15.0581 7.36749C15.041 7.36749 15.0239 7.35894 15.0196 7.33758C15.088 7.30339 15.1478 7.24783 15.1777 7.17946L15.182 7.18373ZM15.1393 7.90595C15.1521 7.95723 15.1179 8.00851 15.0794 8.05125C15.0282 8.01706 15.0068 7.94441 15.0282 7.88886H15.0239C15.0324 7.8333 15.1264 7.85039 15.1393 7.90595ZM14.3231 6.97433C14.3658 6.9786 14.3658 7.06407 14.3231 7.06835C14.2761 7.06835 14.2761 6.9786 14.3231 6.97433ZM14.0155 9.90594C14.0967 9.84611 14.1693 9.99141 14.1693 10.094C14.1693 10.1794 14.1693 10.2649 14.1693 10.3504C14.1693 10.4359 14.1479 10.5427 14.0667 10.5598C14.0582 10.5598 14.0539 10.5598 14.0454 10.5598C13.9941 10.5598 13.9471 10.517 13.9172 10.47C13.8018 10.2906 13.8488 10.0256 14.024 9.90167L14.0155 9.90594ZM13.6779 10.641C13.6993 10.6965 13.7249 10.7521 13.7463 10.8076L13.7249 10.8162C13.7505 10.9102 13.7334 11.017 13.6736 11.094C13.5882 10.9572 13.5924 10.7692 13.6779 10.6367V10.641ZM13.2292 11.3974C13.2634 11.3418 13.3147 11.2863 13.3788 11.2906C13.5198 11.2906 13.5112 11.517 13.413 11.6196C13.3147 11.7179 13.1651 11.8034 13.1694 11.9444C13.1694 12.0128 13.2164 12.0811 13.2805 12.1068C13.2292 12.2008 13.1822 12.2991 13.131 12.3931C12.9985 12.0726 13.037 11.6837 13.2292 11.3974ZM12.9173 12.9316C12.9515 12.9743 12.9857 13.0256 12.9771 13.0769C12.9686 13.1068 12.9344 13.1239 12.9045 13.1239C12.8831 13.1239 12.8618 13.1153 12.8618 13.0897H12.8703C12.8489 13.0341 12.8703 12.9615 12.9216 12.9273L12.9173 12.9316ZM12.3405 13.7777C12.3789 13.6752 12.4216 13.5769 12.4686 13.4743C12.5028 13.3974 12.5413 13.3205 12.6097 13.2734C12.678 13.2264 12.7891 13.2307 12.8318 13.3034C12.7336 13.4999 12.6353 13.6965 12.5413 13.8888C12.5114 13.9444 12.4686 14.0128 12.4045 14.0128C12.4003 14.0128 12.3917 14.0128 12.3875 14.0128C12.2977 13.9914 12.3105 13.8632 12.3447 13.7777H12.3405ZM12.3704 14.2307H12.3789C12.4558 14.3247 12.4516 14.4743 12.3746 14.564C12.2977 14.47 12.2977 14.3247 12.3746 14.2307H12.3704ZM12.1567 14.5598C12.2208 14.594 12.2336 14.6965 12.1824 14.7478C12.1311 14.7991 12.0328 14.7863 11.9943 14.7222C12.0499 14.6709 12.1012 14.6153 12.1567 14.5598ZM11.9602 15.094C12.0243 15.0769 12.0926 15.1324 12.0926 15.1965C12.0926 15.2307 12.0798 15.2649 12.0627 15.2948C12.02 15.376 11.9815 15.4615 11.9388 15.5427C11.879 15.4657 11.8619 15.3589 11.8875 15.2649L11.8961 15.2521C11.8662 15.1965 11.8961 15.1153 11.9602 15.0982V15.094ZM11.5029 16.188C11.5756 16.235 11.5756 16.3589 11.5029 16.4016C11.4303 16.3546 11.4303 16.2307 11.5029 16.188ZM11.2936 16.735C11.3705 16.7991 11.332 16.9657 11.2295 16.9486L11.2209 16.9572C11.2637 17.0341 11.2209 17.1452 11.1397 17.1751C11.1397 17.017 11.191 16.8632 11.2893 16.7392L11.2936 16.735ZM10.0373 19.6068C10.0117 19.6409 9.97322 19.658 9.93049 19.658C9.88776 19.658 9.84503 19.6409 9.82366 19.6025C9.87067 19.5298 9.99458 19.5298 10.0373 19.6025V19.6068ZM9.11435 20.8632C9.16135 20.8632 9.16135 20.9529 9.11435 20.9572C9.07162 20.9529 9.07162 20.8674 9.11435 20.8632Z" fill="black"/>
                                  </svg>
                                <p>Увидите, что талант — это <span>приобретаемый навык, а не благословение свыше</span></p>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-veb20-about-mobile', {
        label: 'Веб 2.0 about (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-veb20-about-mobile">
            <div>
                <div class="veb20-about__top">
                    <div>
                        <div class="veb20-about__header">
                            Вебинар для вас, если вы
                        </div>
                        <ul>
                            <li>
                                <svg xmlns="http://www.w3.org/2000/svg" width="23" height="20" viewBox="0 0 23 20" fill="none">
                                    <path d="M7.26889 19.1327C6.27532 19.1981 5.40375 19.1981 4.55835 19.0238C2.82396 18.6643 1.57983 17.6032 0.756208 16.0758C0.326969 15.2783 0.119983 14.3958 0.0567959 13.472C-0.100084 11.2321 0.0524381 9.01835 0.71046 6.87869C1.08087 5.67159 1.67134 4.51243 2.50586 3.5363C3.08544 2.85649 3.90906 2.51441 4.79804 2.48609C5.71753 2.45558 6.45615 2.16143 7.06406 1.45112C9.10567 -0.930399 12.3827 -0.0741111 14.1302 1.81934C15.5573 3.36634 16.3548 5.23146 16.8777 7.23385C16.9954 7.6827 17.2569 8.0139 17.514 8.39085C18.2984 9.52605 18.9934 10.7419 19 12.1821C19.0043 13.1996 18.4204 14.0233 17.7406 14.6617C15.3068 16.9451 12.5178 18.5989 9.14272 19.0717C8.80281 19.1197 8.4542 19.1218 8.10993 19.1306C7.78746 19.1393 7.46281 19.1306 7.26889 19.1306V19.1327ZM14.7032 5.15958C14.2086 3.77599 13.5201 2.72794 12.3478 2.04813C11.7094 1.67772 11.0318 1.5143 10.2997 1.7213C10.1341 1.76705 9.93365 1.81282 9.93365 2.02635C9.93365 2.22898 10.121 2.31614 10.2888 2.35318C11.6659 2.66476 12.7008 3.53848 13.7423 4.41221C14.0103 4.63881 14.1411 5.031 14.7032 5.16173V5.15958ZM9.50224 11.7071C10.0622 10.524 10.4283 9.25149 11.4262 8.15769C10.3215 8.40609 9.24731 10.4826 9.50224 11.7071ZM3.75217 13.3391C3.71077 13.35 3.67157 13.3609 3.63017 13.3718C3.63017 13.7291 3.61925 14.0864 3.63668 14.4416C3.64322 14.5767 3.66067 14.7772 3.8742 14.7423C4.03326 14.7161 4.02671 14.5462 4.00275 14.4285C3.92866 14.0646 3.83715 13.703 3.75217 13.3413V13.3391ZM17.4944 12.7333C17.7406 12.5699 17.8408 12.3847 17.7493 12.1276C17.7384 12.0993 17.6142 12.0688 17.5881 12.0928C17.3941 12.2627 17.331 12.4632 17.4944 12.7333Z" fill="black"/>
                                  </svg>
                                <p><span>Находитесь в состоянии постоянного напряжения,</span> испытываете усталость при малейших задачах</p>
                            </li>
                            <li>
                                <svg xmlns="http://www.w3.org/2000/svg" width="23" height="17" viewBox="0 0 23 17" fill="none">
                                    <path d="M0.0275022 6.07383C-0.0946961 4.11621 0.201026 2.60095 0.702039 1.12724C0.870673 0.633559 1.11508 0.0225709 1.69186 0.000575173C2.27841 -0.0214205 2.52278 0.592004 2.76963 1.0588C3.01647 1.52804 3.08981 2.04373 2.85763 2.53007C1.89471 4.54635 1.99002 6.66282 2.24175 8.79152C2.31751 9.44161 2.43972 10.0893 2.82586 10.6416C2.9725 10.8494 3.10691 11.1549 3.42707 11.0718C3.69835 11.0009 3.70568 10.7076 3.75944 10.473C4.06738 9.12878 4.33624 7.77239 4.69306 6.44287C5.1012 4.91539 5.84171 3.5712 7.16146 2.61805C7.23966 2.56184 7.31298 2.48122 7.40341 2.45922C8.91867 2.05108 10.2726 1.24699 11.7243 0.692207C13.4278 0.0396679 14.8306 0.973275 15.7447 2.23192C16.71 3.56144 17.5532 4.97895 17.9442 6.61641C18.1104 7.31294 18.4795 7.88481 19.1002 8.31251C19.7992 8.79397 20.2049 9.53204 20.4737 10.319C20.7743 11.1988 20.2904 11.8685 19.7381 12.4673C18.6139 13.6843 17.2184 14.5691 15.9084 15.5589C14.4836 16.6391 12.9121 17.1694 11.1011 16.9519C10.2873 16.8542 9.54919 16.5731 8.85266 16.1845C8.47629 15.9743 8.10972 15.8497 7.68447 15.8864C6.46004 15.9939 5.42134 15.598 4.67838 14.6204C3.99407 13.7235 3.00916 13.1711 2.24909 12.3573C1.65276 11.7194 1.20307 11.0278 0.934234 10.2164C0.445441 8.7451 -0.072698 7.2787 0.0299486 6.07383H0.0275022ZM7.50117 10.952C7.55738 11.2966 7.39362 11.7634 7.82132 11.9711C8.14636 12.13 8.48609 11.9662 8.75003 11.7267C8.96022 11.5312 8.96755 11.2501 8.99443 10.9862C9.07997 10.1577 9.31701 9.38053 9.73493 8.65467C9.8498 8.45671 10.1064 8.23919 9.89379 8.0119C9.68117 7.78217 9.38545 7.92146 9.15816 8.05833C8.07548 8.70353 7.54027 9.67381 7.49873 10.9496L7.50117 10.952ZM11.5655 4.60255C10.9985 4.57078 10.5366 4.59035 10.1871 4.95939C9.94269 5.21845 9.96713 5.45796 10.3435 5.53372C10.7688 5.61926 11.2038 5.69992 11.6339 5.69748C12.0567 5.69748 12.4258 5.41641 12.4502 5.01071C12.482 4.50236 11.9736 4.68565 11.6828 4.605C11.6168 4.58545 11.5386 4.60255 11.5655 4.60255ZM13.8433 2.96266C13.8261 2.95777 13.8066 2.9529 13.7895 2.94801C13.787 2.96512 13.7748 2.98955 13.7822 2.99933C13.7919 3.01155 13.8164 3.01153 13.8335 3.01642C13.8359 2.99931 13.8408 2.97977 13.8433 2.96266Z" fill="black"/>
                                  </svg>
                                <p><span>Застряли на месте:</span> не верите, что заслуживаете большего<br> в карьере и жизни</p>
                            </li>
                            <li>
                                <svg xmlns="http://www.w3.org/2000/svg" width="23" height="31" viewBox="0 0 23 31" fill="none">
                                    <path d="M14.4406 6.51391C14.273 7.28169 14.5289 8.13476 15.51 8.97566C17.0607 10.304 18.3251 11.9432 19.617 13.5397C22.1793 16.7083 21.838 20.9036 19.7876 24.0052C17.7158 27.1372 14.7879 29.3065 11.2537 30.5465C9.36471 31.2107 7.46657 31.2351 5.63244 30.0103C3.42356 28.5387 1.42186 26.9453 0.617525 24.3038C-0.135018 21.8359 -0.180731 19.3254 0.376821 16.7936C0.745476 15.1118 1.4036 13.5854 2.46081 12.2326C3.5028 10.9012 3.54848 9.18588 4.234 7.7143C5.41613 5.17942 6.8603 2.84258 8.93817 0.935321C9.41956 0.496592 9.9832 0.207165 10.6078 0.0731092C11.534 -0.127975 12.32 0.0669978 12.9172 0.892663C14.0506 2.46478 14.7209 4.15878 14.4436 6.51086L14.4406 6.51391ZM4.67275 26.0861L4.69406 26.0648C4.7428 26.3451 4.70928 26.6802 5.10231 26.7472C5.22722 26.7686 5.36434 26.6955 5.34606 26.5644C5.29731 26.2415 4.98043 26.2293 4.75498 26.1105C4.7306 26.0983 4.70016 26.0892 4.6697 26.0831L4.67275 26.0861ZM12.8106 5.65776C12.7466 5.11849 12.6796 4.33853 12.5546 3.5677C12.4876 3.14116 12.5303 2.6019 11.9849 2.43128C11.4426 2.26066 11.0556 2.63542 10.7236 2.97056C9.36776 4.34463 8.20084 5.87105 7.23502 7.54066C7.00956 7.92759 6.58609 8.45161 6.91819 8.84768C7.20458 9.18892 7.76821 8.86292 8.1978 8.77456C9.60844 8.48817 10.8271 7.57113 12.3261 7.54981C12.6704 7.54371 12.8106 7.23294 12.8136 6.89475C12.8136 6.56266 12.8136 6.2336 12.8136 5.66081L12.8106 5.65776ZM15.2601 14.2343C15.0834 14.2526 14.6904 14.2008 14.5685 14.4933C14.3888 14.9168 14.8976 14.8863 15.0895 15.0691C15.2205 15.194 15.3637 15.3037 15.5008 15.4195C15.6623 15.5566 15.8238 15.7181 16.0553 15.5657C16.2229 15.4561 16.2442 15.2672 16.2534 15.0874C16.2869 14.475 15.9883 14.1947 15.2632 14.2343H15.2601ZM14.0871 17.5035C14.2669 17.4639 14.4649 17.4151 14.4619 17.1836C14.4589 16.9581 14.2973 16.8728 14.0871 16.9155C13.8921 16.9581 13.755 17.0983 13.752 17.2933C13.752 17.4852 13.9256 17.5096 14.0871 17.5035ZM9.55057 22.104C9.49573 22.0248 9.45609 21.9212 9.40734 21.9151C9.34641 21.909 9.24587 21.97 9.21845 22.0309C9.1697 22.1406 9.20018 22.2625 9.34947 22.2564C9.41041 22.2564 9.4683 22.168 9.54752 22.104H9.55057Z" fill="black"/>
                                  </svg>
                                <p><span>Не отделяете работу от личной жизни,</span> даже за ужином обсуждаете вопросы в чатах</p>
                            </li>
                            <li>
                                <svg xmlns="http://www.w3.org/2000/svg" width="23" height="27" viewBox="0 0 23 27" fill="none">
                                    <path d="M9.54027 0.166815C10.0327 0.127314 10.5304 0.111522 11.0202 0.0430537C12.5713 -0.172884 13.7616 0.435405 14.728 1.59936C15.1257 2.08127 15.5128 2.57374 15.9341 3.03721C16.445 3.59812 17.0533 3.99576 17.8591 3.82459C18.3147 3.72716 18.6123 3.91412 18.8703 4.24329C19.0784 4.50926 19.2417 4.83317 19.5024 5.03331C21.3747 6.47114 22.1595 8.5199 22.7651 10.6845C23.3392 12.7333 22.8573 14.4793 21.3589 15.9829C18.7756 18.5716 15.9104 20.8205 12.9979 23.0167C11.805 23.9147 10.7253 24.9101 9.8589 26.1425C9.22952 27.0379 8.78713 26.9957 8.09982 26.1267C7.75485 25.6896 7.4915 25.2182 7.33349 24.6863C7.01749 23.6329 5.93515 23.1378 4.88443 23.5618C4.7396 23.6197 4.6053 23.7014 4.46573 23.7751C3.53615 24.2623 3.39133 24.1938 3.23069 23.1773C3.17012 22.7981 2.9884 22.5085 2.68556 22.2636C0.40505 20.436 -0.311231 17.9975 0.118011 15.2113C0.331315 13.8262 0.444565 12.4858 0.165426 11.1033C-0.242749 9.08347 0.312881 7.21377 1.30303 5.47837C2.8225 2.81075 4.91868 0.838339 8.06031 0.243194C8.31575 0.195793 8.57644 0.164193 8.83451 0.14576C9.06888 0.129959 9.30327 0.143124 9.53764 0.143124C9.53764 0.151024 9.53764 0.158915 9.53764 0.166815H9.54027ZM7.13335 9.17825C8.06557 8.74638 8.60543 7.89842 9.31644 7.23218C8.21042 7.38491 7.59421 7.97219 7.14917 9.20198C6.87793 9.51798 6.51187 9.78131 6.56453 10.2738C6.87001 9.96828 7.20446 9.6786 7.13335 9.17825ZM12.7056 12.2066C11.4021 13.0204 10.5963 14.1448 9.55345 15.0007C9.23218 15.264 9.13473 15.7117 9.08207 16.133C9.01623 16.6597 9.28484 16.8704 9.71409 16.5939C11.2783 15.5879 12.3685 14.2291 12.7056 12.204V12.2066ZM1.90345 9.91825C2.12466 9.98935 2.21945 9.9235 2.25895 9.83133C2.72506 8.78324 3.4045 7.86157 3.98911 6.88458C4.11814 6.67128 4.15237 6.3974 4.2103 6.14722C4.23927 6.02609 4.25506 5.86282 4.10232 5.81805C4.02596 5.79435 3.88638 5.84701 3.82844 5.91285C2.79089 7.06364 2.03776 8.34875 1.90345 9.92089V9.91825ZM4.09705 16.8019C4.11812 16.1041 3.87322 15.5036 3.60725 14.9085C3.53088 14.7373 3.51244 14.4266 3.24384 14.4793C2.9647 14.5319 2.97789 14.8322 2.96735 15.0586C2.94102 15.688 3.04372 16.3016 3.22805 16.8994C3.33076 17.2338 3.41238 17.7368 3.83635 17.6604C4.22872 17.5893 4.03648 17.0863 4.09442 16.7993L4.09705 16.8019ZM10.6963 6.5159C11.2994 6.74238 11.6997 6.91881 12.1157 7.04258C12.6529 7.20058 13.0822 6.98465 13.3982 6.55014C13.5035 6.4053 13.5799 6.21571 13.4824 6.03664C13.3824 5.8523 13.1875 5.83123 13.0032 5.86547C12.2737 6.00503 11.5548 6.18409 10.6963 6.51327V6.5159ZM20.8981 10.5503C20.8849 10.0131 20.6847 9.69177 20.324 9.4811C20.1581 9.38366 19.9606 9.39682 19.8158 9.53639C19.5024 9.8366 19.5814 10.2 19.6972 10.5529C19.7631 10.7504 19.85 10.94 19.9501 11.1217C20.0317 11.2744 20.0607 11.5088 20.2819 11.5114C20.5268 11.5167 20.6216 11.2876 20.7058 11.1033C20.8033 10.8952 20.8559 10.6688 20.8981 10.5476V10.5503ZM4.61058 20.7704C4.62112 20.8837 4.68167 20.96 4.78963 20.9837C4.90024 21.0074 5.00294 20.9732 5.02401 20.8547C5.05034 20.7046 4.95816 20.6177 4.81596 20.6019C4.70536 20.5913 4.63165 20.6572 4.61058 20.7704ZM7.43093 13.9157C7.57313 13.8288 7.64423 13.8025 7.68899 13.7524C7.7601 13.6682 7.90494 13.5155 7.73377 13.4733C7.55734 13.4286 7.45726 13.6234 7.43093 13.9157Z" fill="black"/>
                                  </svg>
                                <p><span>Перестали получать удовольствие от работы,</span><br> а чего хочется на самом<br> деле — непонятно</p>
                            </li>
                        </ul>
                    </div>
                    <div><svg xmlns="http://www.w3.org/2000/svg" width="206" height="151" viewBox="0 0 206 151" fill="none">
                        <path d="M157.564 91.0899C131.228 108.112 39.2252 119.143 36.7516 99.762C34.5972 82.8814 113.691 65.48 137.442 60.2249C145.252 58.4969 195.026 47.8779 196.891 62.4863C197.986 71.0671 175.934 78.5042 148.291 82.0321C130.987 84.2404 101.262 84.8572 99.6649 67.2701C98.6363 55.9397 132.626 43.7757 157.28 41.4907C165.291 40.7482 170.972 43.6946 171.372 46.8324" stroke="black" stroke-width="1.2" stroke-linecap="round"/>
                        <path d="M84.4519 54.5223C89.3321 21.0372 202.768 47.1053 200.444 66.4761C198.421 83.3475 117.419 80.9213 93.0875 80.2213C85.0868 79.9912 34.1929 78.143 35.9441 63.5426C36.9728 54.9665 60.1869 53.1394 87.8747 56.4604C105.206 58.5391 134.205 65.1867 131.468 82.6063C129.704 93.8288 93.7523 97.3236 69.2692 93.5277C61.3132 92.2942 55.876 89.0808 56.2521 85.9448C56.6542 82.5931 63.6594 82.7132 68.2334 83.2619C72.8074 83.8105 109.328 89.1238 109.674 106.16" stroke="black" stroke-width="1.2" stroke-linecap="round"/>
                        <path d="M79.9089 29.864C84.7892 -3.62117 198.225 22.4469 195.901 41.8178C193.878 58.6891 112.876 56.263 88.5445 55.563C80.5439 55.3329 29.6499 53.4847 31.4012 38.8843C32.4298 30.3082 55.644 28.4811 83.3317 31.8021C100.663 33.8808 129.662 40.5284 126.925 57.948C125.161 69.1705 89.2094 72.6653 64.7263 68.8694C56.7703 67.6359 51.333 64.4225 51.7092 61.2865C52.1112 57.9348 59.1165 58.0549 63.6905 58.6035C68.2645 59.1522 104.785 64.4654 105.131 81.5016" stroke="black" stroke-width="1.2" stroke-linecap="round"/>
                        <path d="M122.829 115.565C91.6817 111.86 27.2847 63.845 37.7208 47.3613C46.8104 33.0045 118.877 70.065 140.538 81.1714C147.66 84.8234 192.801 108.401 184.935 120.825C180.314 128.123 158.575 119.779 135.014 104.862C120.266 95.5248 96.9532 77.0408 106.923 62.4963C113.346 53.1261 147.3 65.4488 167.764 79.4147C174.414 83.9531 177.938 89.1942 176.249 91.8628C174.443 94.715 168.172 91.5908 164.28 89.1266C160.387 86.6623 130.073 65.6074 137.095 50.0819C139.108 45.6298 145.601 47.9708 147.981 51.8405" stroke="black" stroke-width="1.2" stroke-linecap="round"/>
                        <path d="M95.4674 123.86C64.3203 120.155 -0.0766172 72.14 10.3595 55.6562C19.449 41.2994 91.516 78.3599 113.176 89.4664C120.299 93.1183 165.439 116.696 157.573 129.12C152.953 136.418 131.214 128.074 107.652 113.157C92.9045 103.82 69.5918 85.3358 79.5614 70.7913C85.9842 61.4211 119.939 73.7437 140.403 87.7097C147.053 92.2481 150.577 97.4892 148.888 100.158C147.082 103.01 140.811 99.8858 136.918 97.4215C133.026 94.9573 102.711 73.9024 109.733 58.3768C111.747 53.9248 118.239 56.2658 120.619 60.1355" stroke="black" stroke-width="1.2" stroke-linecap="round"/>
                        <path d="M113.86 105.317C111.784 97.5867 87.0034 32.7954 101.492 30.2817C110.002 28.8052 118.416 50.5179 123.183 77.9936C126.167 95.1919 128.124 124.879 110.652 127.257C99.3952 128.79 85.7271 95.3541 82.3351 70.8118C81.2329 62.8365 82.7502 56.7057 85.8622 56.1658C89.1883 55.5887 91.0841 62.3337 91.8716 66.8726C92.6591 71.4116 96.7618 113.755 81.1925 113.235C74.2496 113.003 80.4024 84.0913 81.672 79.7295" stroke="black" stroke-width="1.2" stroke-linecap="round"/>
                      </svg>
                        
                    </div>
                </div>
                <div class="veb20-about__bottom">
                    <div>
                        <div class="veb20-about__header">
                            По итогам вебинара вы
                        </div>
                        <ul>
                            <li>
                                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="49" viewBox="0 0 32 49" fill="none">
                                    <path d="M0 20.701C0.0491278 19.6364 0.0736917 18.5717 0.153524 17.5132C0.178088 17.1563 0.319325 16.8055 0.423721 16.4547C0.503554 16.1839 0.64479 15.9254 0.693918 15.6485C0.773751 15.1931 0.964109 14.7992 1.23431 14.43C1.52294 14.03 1.73788 13.5931 1.79929 13.0884C1.83614 12.8115 1.92211 12.5161 2.07564 12.2884C3.11346 10.7683 3.98549 9.13748 5.18912 7.7282C5.37335 7.5128 5.47158 7.22972 5.62511 6.99586C5.73565 6.8297 5.84005 6.63277 5.99971 6.52815C6.85945 5.98659 7.42444 5.18656 7.89115 4.31883C8.12451 3.88805 8.46224 3.62957 8.88597 3.45726C9.19916 3.32802 9.45708 3.19263 9.59218 2.83569C9.75185 2.41721 10.1817 2.30028 10.5502 2.12181C11.1704 1.82641 11.7722 1.54333 12.3004 1.0387C12.8838 0.478673 13.6391 0.103265 14.5234 0.152497C14.7261 0.164805 14.9348 0.127884 15.1314 0.0786511C15.7577 -0.0813554 16.3534 0.0171072 16.9368 0.244809C17.3974 0.423278 17.8641 0.577142 18.294 0.810998C18.644 1.00177 19.0002 1.24794 19.2397 1.56179C19.6081 2.04181 20.0257 2.39875 20.6152 2.51568C22.1075 2.80492 23.1944 3.70958 24.0787 4.8727C24.6253 5.58658 25.1289 6.33737 25.6263 7.08202C26.0377 7.69127 26.3816 8.34976 26.8115 8.94671C27.2475 9.54981 27.6221 10.1652 27.8309 10.8914C27.9967 11.4822 28.2485 12.0484 28.4511 12.6269C28.5187 12.8176 28.6108 13.0146 28.6292 13.2115C28.7152 14.1469 28.795 15.0823 28.8503 16.0239C28.8626 16.2639 28.8503 16.5347 28.7459 16.7501C28.488 17.2855 28.4511 17.8517 28.3897 18.424C28.3529 18.7933 28.2792 19.1502 27.9783 19.421C27.8616 19.5256 27.7572 19.6733 27.7142 19.821C27.3335 21.0949 26.5106 21.9995 25.442 22.7565C24.7788 23.2242 24.1831 23.7965 23.5629 24.3319C23.0655 24.7627 22.5312 25.1135 21.9171 25.3781C21.3276 25.6366 20.7749 26.012 20.2652 26.412C19.1414 27.2798 17.8764 27.8152 16.5192 28.166C15.2112 28.5044 13.9523 28.966 12.7732 29.6368C12.2942 29.9076 11.76 29.9199 11.2257 29.9137C10.8634 29.9076 10.4888 29.9568 10.1326 29.9076C9.3527 29.8029 8.59122 30.006 7.8236 29.9999C6.62611 29.9937 5.46546 29.7229 4.38465 29.206C4.02233 29.0337 3.6907 28.7752 3.38365 28.5167C2.33969 27.6367 1.5168 26.5597 0.841295 25.3843C0.325454 24.4858 0.0798267 23.4888 0.0552628 22.4426C0.0429808 21.8703 0.0552628 21.2918 0.0552628 20.7195C0.0306989 20.7072 0.0184229 20.7072 0 20.701ZM14.5295 2.93416C13.4794 2.94647 12.5705 3.28494 11.7354 3.8265C10.6054 4.565 9.58605 5.42657 8.58507 6.34968C6.29449 8.47285 4.64258 11.0329 3.19331 13.753C2.84941 14.3992 2.5485 15.0823 2.32742 15.7839C2.03266 16.7132 1.6826 17.6732 1.63348 18.6271C1.56592 19.8825 1.55367 21.1441 1.75018 22.418C2.01424 24.1719 2.85554 25.5074 4.28024 26.4428C5.74793 27.4028 7.4674 27.729 9.18687 27.7782C10.28 27.809 11.3792 27.5813 12.4784 27.4582C12.7179 27.4336 12.9636 27.3721 13.1969 27.2921C15.4138 26.5659 17.4711 25.5012 19.4792 24.3381C20.2468 23.895 20.8854 23.2304 21.7513 22.9288C21.9724 22.8488 22.1505 22.6519 22.3347 22.4857C22.7339 22.1349 23.1392 21.7903 23.5138 21.4149C24.1524 20.781 24.7911 20.1472 25.3868 19.4764C25.6508 19.1748 25.8719 18.8056 26.007 18.4302C26.2895 17.6609 26.4676 16.8609 26.7439 16.0916C27.051 15.2423 27.0141 14.3869 26.8299 13.5438C26.3878 11.556 25.3991 9.82059 24.2077 8.18975C24.1094 8.06052 23.9866 7.94975 23.8761 7.82667C22.6847 6.602 21.2416 5.77735 19.645 5.19271C18.8282 4.89116 17.9623 4.77423 17.121 4.76192C16.3657 4.74962 15.5919 4.98347 14.8427 5.16194C14.3207 5.28502 13.811 5.42657 13.2768 5.31579C13.1355 5.28502 12.9329 5.16194 12.9083 5.05116C12.8776 4.87885 12.9329 4.64499 13.0373 4.4973C13.1478 4.33729 13.3443 4.23883 13.5163 4.13421C13.7926 3.96189 14.0935 3.8265 14.3637 3.64803C14.5725 3.52495 14.7383 3.33418 14.5295 2.93416ZM13.6882 0.95253C13.6575 0.897143 13.6391 0.860227 13.6145 0.823303C13.6022 0.847919 13.5777 0.884841 13.59 0.897149C13.6022 0.921765 13.6391 0.927913 13.6882 0.95253Z" fill="black"/>
                                    <path d="M13.6882 0.952458C13.6391 0.927841 13.6022 0.921693 13.5899 0.897077C13.5838 0.884768 13.6083 0.847847 13.6145 0.823231C13.6329 0.860155 13.6575 0.897071 13.6882 0.952458Z" fill="black"/>
                                    <path d="M18.8466 19.3779C18.3 21.4518 16.8446 22.6518 14.8857 23.2919C13.8785 23.6242 12.8346 23.7596 11.7476 23.575C10.3782 23.3472 9.58598 22.4549 9.00873 21.341C8.64027 20.621 8.57273 19.7902 8.55431 18.8794C8.79994 18.9409 8.97804 18.9409 9.08243 19.0271C9.33422 19.2302 9.55528 19.4763 9.77635 19.7102C10.0036 19.944 10.2123 20.2025 10.4396 20.4302C11.3054 21.2795 12.3003 21.6672 13.5531 21.5133C14.8058 21.3595 15.9419 21.0025 16.9122 20.1779C17.2868 19.8579 17.6614 19.544 18.0667 19.2671C18.3 19.1132 18.5887 19.0332 18.8466 19.3779Z" fill="black"/>
                                    <path d="M12.5644 8.40515C12.6749 8.54669 12.8161 8.68824 12.9083 8.8544C13.4302 9.75905 13.6329 10.756 13.7373 11.7776C13.8417 12.793 13.9154 13.8085 13.9891 14.83C14.0014 15.027 13.9707 15.2423 13.897 15.4208C13.8417 15.5501 13.6943 15.7039 13.5654 15.7224C13.4425 15.7408 13.2276 15.6239 13.1846 15.5131C13.0249 15.1439 12.9021 14.75 12.8039 14.3562C12.6012 13.5684 12.4722 12.7561 12.2266 11.9807C11.852 10.7868 12.1345 9.65443 12.3986 8.50977C12.4047 8.48515 12.4661 8.46669 12.5644 8.40515Z" fill="black"/>
                                    <path d="M15.7547 16.5163C15.6564 16.4609 15.4722 16.4178 15.4108 16.307C15.3187 16.1409 15.2573 15.9193 15.2757 15.7286C15.3433 14.7562 15.4292 13.7777 15.5398 12.8115C15.6012 12.2884 15.7056 11.7653 15.8099 11.2484C15.8468 11.0576 15.9451 10.8791 16.0065 10.7007C16.682 10.8976 17.0443 11.2053 16.946 11.6484C16.5899 13.23 16.5837 14.8916 15.9144 16.4055C15.9021 16.4363 15.8468 16.4486 15.7547 16.5163Z" fill="black"/>
                                  </svg>
                                <p>Поймете, как пошагово<br> прийти к карьере,<br> <span>которая будет приносить радость и доход</span></p>
                            </li>
                            <li>
                                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="49" viewBox="0 0 32 49" fill="none">
                                    <path d="M10.9353 43.9792C11.0114 43.9467 11.0658 43.8707 11.1093 43.7946C14.1537 39.2447 16.1977 34.0215 17.0241 28.6028C17.1437 27.8427 18.1113 27.6038 18.8833 27.5495C20.4707 27.43 22.0581 27.3106 23.6347 27.202C25.4069 27.0717 27.4401 26.8002 28.4078 25.3125C26.168 22.9018 23.9283 20.4911 21.6993 18.0912C21.5362 17.9175 21.3732 17.7329 21.3297 17.5048C21.2862 17.2442 21.3949 16.9944 21.5036 16.7556L24.6132 10.1098C24.0914 10.0446 23.5803 9.99035 23.0584 9.92519C22.4061 8.9153 21.7428 7.91626 21.0905 6.90637C19.7205 8.28547 18.3505 9.67543 16.9806 11.0654C16.7957 11.25 16.5783 11.4563 16.3173 11.4346C16.0455 11.4237 15.8498 11.1631 15.6867 10.9351L12.7837 6.74348C12.6641 6.55888 12.4358 6.84122 12.3162 7.02582C12.1966 7.21042 11.816 6.94981 12.0335 6.92809C12.5336 6.39599 11.9791 5.55985 11.4572 5.04947C11.305 4.9083 11.1202 4.75627 10.9136 4.79971C10.8375 4.82143 10.7831 4.89744 10.7722 4.97346C9.53275 3.06226 7.95619 1.3791 6.14044 0C5.00967 0.93388 5.22714 2.69305 5.5207 4.12645C6.42314 8.42664 7.119 12.7703 7.63002 17.1248C7.77136 18.3193 7.78222 19.7744 6.78193 20.4476C4.80309 21.7942 2.93299 23.2819 1.1716 24.8999C0.638835 25.3994 0.0734445 25.9749 0.00820799 26.7025C-0.100519 27.7449 0.888901 28.6354 1.91094 28.8526C2.94385 29.0589 3.9985 28.7874 5.03141 28.5811C6.21654 28.3422 7.41255 28.201 8.60856 28.1467C9.04347 32.5555 9.04347 37.0077 8.60856 41.4165C8.48896 42.6327 8.34761 43.9467 8.96736 45C9.48925 44.9457 10.0111 44.9023 10.5439 44.848C9.92416 44.2182 10.0003 43.0562 10.6853 42.5133C10.7831 42.7956 10.5874 43.0888 10.5113 43.382C10.4352 43.6752 10.6635 44.0987 10.9353 43.9684V43.9792ZM25.2547 22.9452C25.3743 22.9561 25.3743 23.1733 25.2547 23.1841C25.1351 23.1841 25.1351 22.9561 25.2547 22.9452ZM22.6453 11.8038C22.6779 11.9341 22.5909 12.0644 22.4931 12.173C22.3626 12.0861 22.3082 11.9015 22.3626 11.7604H22.3408C22.3626 11.6192 22.6018 11.6626 22.6344 11.8038H22.6453ZM21.1557 14.6923C21.3188 15.029 21.3079 15.4416 21.134 15.7782V15.8217C21.134 15.8217 21.1013 15.8217 21.0905 15.8217C20.8621 15.8217 20.6882 15.5393 20.7317 15.3004C20.7752 15.0507 20.9709 14.8552 21.1557 14.6815V14.6923ZM16.5565 28.0273C16.4369 28.2119 16.1216 28.201 16.002 28.0273C16.1216 27.8427 16.4369 27.8427 16.5565 28.0273ZM13.5557 37.5615C13.4578 37.0837 13.4904 36.5734 13.6535 36.1064C13.8383 36.5951 13.9797 37.2466 13.5557 37.5615ZM15.4693 29.9385C15.5127 29.8082 15.7519 29.8842 15.7193 30.0036C15.6323 30.0036 15.5454 30.0145 15.4584 30.0253L15.4801 29.9385H15.4693ZM15.4475 31.3284H15.404C15.3932 31.4153 15.317 31.4587 15.2301 31.4587C15.0887 31.4587 14.9256 31.361 14.9148 31.209C14.9039 30.9592 15.1322 30.7746 15.3497 30.6443C15.4693 30.8398 15.5128 31.1004 15.4584 31.3284H15.4475ZM15.0344 17.4288L15.1213 17.4071C15.1213 17.6351 14.9582 17.8523 14.7517 17.9392C14.4907 17.7872 14.7625 17.2876 15.0344 17.4288ZM14.8821 32.208L14.5016 32.3383L14.4146 32.3166C14.3167 32.056 14.8495 31.9365 14.8821 32.208ZM14.556 33.4677C14.6864 33.598 14.6538 33.8477 14.4907 33.9455C14.3494 33.8152 14.2189 33.674 14.0775 33.5437C14.1645 33.3808 14.4255 33.3482 14.556 33.4785V33.4677ZM13.7731 20.8711C13.5774 21.0883 13.3382 21.2512 13.0881 21.4141C12.9685 21.4901 12.8272 21.5553 12.6967 21.5553C12.6206 21.5553 12.5445 21.5335 12.4901 21.4684C12.3379 21.2838 12.5119 21.0123 12.6858 20.8494C13.2077 20.3499 13.7296 19.8395 14.2515 19.34C14.3276 19.8938 14.1428 20.4694 13.7731 20.8711ZM13.1207 16.3212C13.2295 16.3212 13.2403 16.5492 13.1207 16.5601C13.0011 16.5601 13.0011 16.332 13.1207 16.3212ZM10.4134 9.06733C11.4029 10.4681 12.3814 11.8798 13.3708 13.2806C13.4687 13.411 13.5665 13.563 13.5665 13.7259C13.5665 13.9105 13.4687 14.0734 13.3708 14.2254C12.9033 14.8986 12.3596 15.4959 11.729 16.0171C11.4137 15.876 11.3485 15.4633 11.3159 15.1158C11.1745 13.5413 10.8592 11.9776 10.3808 10.4681C10.2286 10.0012 10.0873 9.43653 10.4134 9.07819V9.06733ZM8.80426 8.10087C8.826 7.84025 8.93474 7.57963 8.82601 7.34073H8.83687C8.86949 7.11269 8.72815 6.87379 8.52157 6.78692C8.68466 6.51544 9.11957 6.78692 9.22829 7.08012C9.33702 7.38417 9.38053 7.7751 9.68496 7.88369C9.40227 7.92712 9.50012 8.44836 9.23918 8.57867C9.20656 8.60039 9.17394 8.60039 9.14133 8.60039C8.94562 8.60039 8.79338 8.32891 8.80426 8.11173V8.10087ZM10.3591 41.6445C10.2395 41.6445 10.2395 41.4165 10.3591 41.4056C10.4787 41.4056 10.4787 41.6337 10.3591 41.6445ZM10.3373 17.103C10.109 16.6361 10.1634 16.0606 10.4569 15.6262C10.109 15.2679 10.0003 14.7466 9.91328 14.258C9.77194 13.4653 9.63059 12.6834 9.48925 11.8907C9.38052 11.3043 9.28267 10.7179 9.17394 10.1315C9.14132 9.92519 9.19569 9.59942 9.41315 9.64286C9.54362 9.66458 9.5871 9.82746 9.60885 9.95777C9.86979 11.4889 10.1416 13.0092 10.4026 14.5294C10.446 14.8009 10.7287 14.9638 10.9027 15.181C11.0767 15.3982 11.0549 15.8434 10.7722 15.8325C11.0223 15.952 11.0658 16.3103 10.9353 16.5492C10.8048 16.7881 10.5656 16.9402 10.3373 17.0922V17.103Z" fill="black"/>
                                  </svg>
                                <p>Узнаете, какие<br> инструменты необходимы, чтобы <span>достичь личной «идеальной» карьеры</span></p>
                            </li>
                            <li>
                                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="49" viewBox="0 0 32 49" fill="none">
                                    <g clip-path="url(#clip0_239_9328)">
                                      <path d="M20.7035 47C37.1234 13.1314 28.6092 2 23.435 2C18.4655 2 18.1043 12.7205 18.9473 18.7171C18.9595 18.8038 18.8246 18.8392 18.7918 18.758C16.2171 12.3884 10.0138 1.723 3.67573 5.26906C-1.7292 8.29307 5.80933 25.4725 28.0013 38.5329" stroke="black" stroke-width="2.54717" stroke-linecap="round"/>
                                    </g>
                                    <defs>
                                      <clipPath id="clip0_239_9328">
                                        <rect width="32" height="49" fill="white"/>
                                      </clipPath>
                                    </defs>
                                  </svg>
                                <p>Проработаете внутренние установки, которые мешают <span>получать от карьеры<br> максимум</span></p>
                            </li>
                            <li>
                                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="49" viewBox="0 0 32 49" fill="none">
                                    <path d="M7.17661 19.3193C6.18217 17.6492 5.18359 15.9834 4.18915 14.3133C4.32588 14.7526 4.45847 15.1877 4.59106 15.627L2.49445 12.0466C2.94609 12.6019 3.40188 13.1613 3.85352 13.7207C3.77065 13.9652 3.91982 14.2677 4.17257 14.3465C4.11042 14.1144 4.00269 13.8948 3.86181 13.7L3.85352 13.7207C3.19056 12.49 2.24584 11.4125 1.11881 10.5879C0.982075 10.4884 0.837054 10.389 0.66717 10.3807C0.186524 10.3517 -0.0040775 10.994 6.60053e-05 11.4747C0.0124965 13.2981 0.480712 15.0841 0.91578 16.8536C2.07182 21.5363 3.03311 26.2687 3.79551 31.0343C3.85767 31.4073 3.91982 31.7927 4.13114 32.1035C4.3466 32.4143 4.75681 32.6215 5.10486 32.4806C4.88111 32.7582 4.65322 33.0483 4.57035 33.3922C4.48748 33.7403 4.58692 34.1589 4.90183 34.3288C5.21259 34.4987 5.59379 34.3785 5.92527 34.2542C10.3257 32.6215 14.8587 31.3575 19.4662 30.479C17.7757 29.7828 15.9567 29.4347 14.1294 29.4182C14.1377 29.4223 14.1418 29.4265 14.1501 29.4306V29.4389C14.059 29.5135 13.9139 29.5093 13.8269 29.4347C13.8352 29.4264 13.8435 29.4223 13.8518 29.4182C10.8105 29.4472 7.76913 30.3961 5.31204 32.1905C5.47778 30.3008 5.17944 28.4029 4.86039 26.5339C4.12285 22.2325 3.26929 17.9476 2.29971 13.6917C3.28586 15.08 4.16428 16.5511 4.9184 18.0802C5.24988 18.7557 5.56893 19.4519 6.0703 20.0155C6.57166 20.579 7.30092 20.9934 8.05089 20.9147C9.27737 20.7862 9.9859 19.4975 10.4748 18.3703C11.8422 15.2333 13.1681 12.0756 14.4526 8.90128C14.1253 8.88471 13.8228 9.19551 13.8476 9.51874C13.6156 8.93444 13.9264 8.18852 14.5065 7.93988C14.3863 8.22581 14.2661 8.51589 14.146 8.80183C14.9291 8.08906 15.4595 7.10694 15.6252 6.05851C15.3766 6.20769 15.1984 6.47705 15.157 6.76299L14.6805 6.40246C15.0327 6.34444 15.3393 6.05851 15.418 5.70627C15.5838 5.75185 15.7288 5.87203 15.7992 6.03364C16.1639 5.18827 16.6569 4.40091 17.2619 3.70058C16.9097 7.339 16.6942 10.9899 16.6155 14.6448C16.5948 15.6063 16.5906 16.5925 16.9511 17.4835C17.3116 18.3744 18.1279 19.1494 19.0892 19.1576C20.067 19.1659 20.8709 18.4242 21.5629 17.7321C23.9578 15.3328 26.3527 12.9292 28.7435 10.5299C26.85 14.4998 25.0061 18.4946 23.212 22.5143C21.8156 25.643 20.4275 28.9043 20.4358 32.3314C20.5974 32.0745 20.759 31.8175 20.9206 31.5606C20.9289 31.5979 20.9496 31.6311 20.991 31.6393C21.0822 31.6559 21.1651 31.5813 21.2272 31.5109C23.0172 29.4928 24.2354 27.0437 25.4329 24.6277C27.7367 19.9823 30.0446 15.3245 31.8636 10.4636C32.2489 9.43171 31.7849 8.18852 30.8857 7.55449C26.4108 9.83782 23.2534 14.0813 19.0353 16.808C19.1058 11.8559 19.1762 6.90388 19.2425 1.95182C19.2466 1.53742 19.0519 0.948973 18.65 1.065C18.2315 1.18518 18.2481 0.410254 17.929 0.116031C17.842 0.0372954 17.7425 0 17.639 0C17.3241 0 16.9719 0.310798 16.7647 0.609165C13.1764 5.76014 11.345 11.8891 8.71385 17.5871C8.37823 18.3081 7.9473 19.0996 7.18075 19.311L7.17661 19.3193ZM16.3918 30.5619C16.4208 30.537 16.4622 30.5329 16.5036 30.5288C16.5824 30.5205 16.6694 30.5205 16.7315 30.566C16.7937 30.6116 16.802 30.7318 16.7274 30.7567L16.715 30.7318C16.6569 30.7525 16.5948 30.7774 16.5326 30.7774C16.5078 30.7774 16.4871 30.7774 16.4622 30.765C16.3835 30.736 16.3338 30.6199 16.3959 30.566L16.3918 30.5619ZM1.55388 13.037C1.54559 13.0038 1.5373 12.9665 1.54974 12.9375C1.5746 12.8629 1.69062 12.8588 1.74862 12.9168C1.80663 12.9707 1.81906 13.0577 1.83149 13.1364L1.9558 14.0896C1.96409 14.1434 1.97652 14.2056 2.02209 14.2346C2.10496 14.2802 2.27485 14.2263 2.25827 14.3216C2.12983 14.3216 1.99723 14.3589 1.89365 14.4376C1.77763 13.9735 1.66575 13.5094 1.54974 13.0453L1.55388 13.037ZM4.90183 30.8105C4.90183 30.8893 4.92669 30.9639 4.95155 31.0426C5.03856 31.3327 5.03442 31.6476 4.93912 31.9336C4.8894 31.544 4.83968 31.1545 4.78581 30.7608C4.76095 30.566 4.76509 30.3133 4.94741 30.2387C5.10486 30.3671 4.91011 30.6075 4.90183 30.8105ZM4.75266 28.436C4.86868 28.9955 4.91426 29.5673 4.88526 30.1392C4.68637 30.0605 4.67394 29.7911 4.67808 29.5756C4.68637 29.1364 4.62422 28.693 4.49991 28.2703C4.52891 28.2123 4.62421 28.2123 4.67394 28.2578C4.72366 28.3034 4.74023 28.3739 4.75266 28.436ZM4.25544 24.1719L4.26373 24.205C4.23058 24.205 4.19743 24.2009 4.16428 24.1967C4.15185 24.147 4.24301 24.1221 4.25959 24.1719H4.25544ZM3.83281 21.7518V21.7849C3.80795 21.7849 3.7748 21.7849 3.7375 21.7808C3.72507 21.7311 3.81623 21.7062 3.83281 21.7559V21.7518ZM3.34801 21.1923C3.45574 21.5653 3.56348 21.9341 3.67535 22.3071C3.7085 22.4231 3.74165 22.5557 3.68364 22.6593C3.63392 22.7505 3.66707 22.8624 3.70021 22.9618C3.8038 23.2519 3.90739 23.5461 4.01098 23.8362C3.92811 24.2879 4.05241 24.7769 4.3466 25.1291C4.16429 25.3985 4.26373 25.759 4.35074 26.074C4.50405 26.6293 4.60764 27.197 4.65322 27.7689C4.65736 27.831 4.62007 27.9222 4.57035 27.9222C4.56206 27.9222 4.54963 27.9222 4.54134 27.9098C4.52477 27.8973 4.52063 27.8725 4.51648 27.8517C4.38389 27.1721 4.2513 26.4884 4.11871 25.8088C4.01926 25.2908 3.91982 24.7728 3.81623 24.2589L3.27343 21.4493C3.25686 21.354 3.25686 21.2296 3.34387 21.2006L3.34801 21.1923ZM3.20299 20.981C3.20299 20.981 3.18228 20.981 3.16985 20.9727C3.14084 20.9603 3.12426 20.9313 3.11183 20.9064C3.06211 20.8111 3.00825 20.7116 3.00411 20.6039C3.00411 20.4962 3.06211 20.376 3.1657 20.3511C3.20299 20.4796 3.24443 20.608 3.28172 20.7365C3.31072 20.8318 3.28172 20.981 3.20299 20.981ZM2.87565 18.851C2.95024 19.2074 3.02482 19.5679 3.16985 19.9036C3.19885 19.974 3.232 20.0528 3.21542 20.1273C3.20299 20.1812 3.14498 20.2268 3.09526 20.2268C3.07455 20.2268 3.05383 20.2185 3.0414 20.2061C3.02068 20.1854 3.01239 20.1522 3.00411 20.1232C2.90052 19.6715 2.80107 19.2157 2.69748 18.764C2.61047 18.3579 2.51931 17.9517 2.4323 17.5456C2.38672 17.3343 2.34529 17.0939 2.47788 16.9199L2.8798 18.8551L2.87565 18.851ZM2.45302 16.4931C2.40744 16.5842 2.36601 16.6713 2.32043 16.7624C2.2707 16.5635 2.21684 16.3605 2.16712 16.1574C2.06353 15.7554 1.98895 15.3452 1.94751 14.9308C1.93922 14.8645 1.94751 14.7775 2.01381 14.7609C2.04696 14.7526 2.07596 14.7692 2.10496 14.7857C2.22927 14.8728 2.2707 15.051 2.20855 15.1877C2.13811 15.3328 2.17955 15.5027 2.22512 15.656C2.30385 15.9336 2.37844 16.2113 2.45716 16.4889L2.45302 16.4931ZM5.32032 16.7293C5.30789 16.6795 5.39905 16.6547 5.41562 16.7044C5.41562 16.7168 5.41562 16.7251 5.41976 16.7376C5.38662 16.7376 5.35347 16.7334 5.32032 16.7293ZM6.09516 18.1507C6.01643 18.0181 5.93771 17.8813 5.85898 17.7487C5.85484 17.6865 5.95014 17.757 5.94599 17.815C6.0993 17.815 6.19875 18.0346 6.09516 18.1507ZM25.147 24.0185C25.0973 23.9854 25.0765 23.9191 25.0973 23.8611C25.0434 23.7616 25.2216 23.6497 25.2837 23.745C25.2381 23.8362 25.1884 23.9274 25.1428 24.0185H25.147ZM25.408 23.4384C25.408 23.4384 25.3873 23.4674 25.3666 23.4674C25.3376 23.4674 25.3003 23.4425 25.2961 23.4094C25.2879 23.3555 25.3293 23.3099 25.3666 23.2685C25.3832 23.3224 25.4039 23.3762 25.4246 23.4301L25.4122 23.4384H25.408ZM26.0917 21.6938C26.0461 21.6938 26.0461 21.6067 26.0917 21.6026C26.1373 21.6026 26.1373 21.6896 26.0917 21.6938ZM26.9328 19.9119C26.8624 19.8663 26.8624 19.7461 26.9328 19.7047L26.9411 19.6839C26.9908 19.7047 27.0447 19.7295 27.0944 19.7502C27.0406 19.8041 26.9867 19.858 26.937 19.9119H26.9328ZM27.4591 19.0706C27.3886 19.025 27.3886 18.9049 27.4591 18.8634C27.5295 18.909 27.5295 19.0292 27.4591 19.0706ZM31.5653 8.98002C31.6108 9.07119 31.6564 9.17479 31.6274 9.27424C31.6067 9.34055 31.5363 9.38613 31.47 9.38613C31.4368 9.38613 31.4078 9.3737 31.3871 9.34469L31.4078 9.3364C31.3664 9.19965 31.4368 9.04218 31.5653 8.97587V8.98002ZM31.4617 9.60162C31.5694 9.77152 31.5155 10.0202 31.3457 10.132C31.2379 9.96214 31.2918 9.70936 31.4617 9.60162ZM30.9976 10.6335C31.0473 10.4511 31.1758 10.2315 31.3622 10.2688C31.4078 10.3558 31.4534 10.4428 31.5073 10.5257C31.3664 10.505 31.2131 10.563 31.1261 10.6791C31.1924 10.9401 31.0888 11.2385 30.8692 11.396C30.8899 11.139 30.9313 10.8821 30.9976 10.6293V10.6335ZM28.9217 15.9129C28.8761 15.8342 28.8596 15.7389 28.8803 15.6518L28.8886 15.6021C29.0046 15.6518 29.0212 15.8383 28.9176 15.9129H28.9217ZM28.93 10.0243C28.9922 10.0575 29.0046 10.1569 28.9549 10.2066C28.9051 10.2564 28.8098 10.2439 28.7725 10.1818C28.8264 10.132 28.8761 10.0782 28.93 10.0243ZM27.9273 10.8655C27.977 10.9526 27.89 11.052 27.8113 11.1183C27.687 11.2178 27.5626 11.3131 27.4383 11.4125C27.3928 11.4498 27.3223 11.4871 27.2643 11.4871C27.2312 11.4871 27.2022 11.4747 27.1856 11.4457C27.4052 11.2219 27.6538 11.0272 27.9231 10.8655H27.9273ZM26.5682 12.0424L26.5599 12.0797C26.5972 12.1543 26.5102 12.2248 26.4356 12.2248C26.4066 12.2248 26.3776 12.2123 26.361 12.1833C26.3942 12.1004 26.477 12.0424 26.5641 12.0424H26.5682ZM25.8348 13.0287C25.6774 13.0826 25.5365 13.1779 25.4329 13.3063L25.4039 13.2898C25.408 13.3188 25.4122 13.3519 25.3914 13.3726C25.3873 13.3768 25.379 13.3809 25.3707 13.3809C25.35 13.3809 25.3293 13.3644 25.3376 13.3478C25.3749 13.2318 25.4163 13.1116 25.5075 13.0328C25.5986 12.9541 25.7602 12.9375 25.8348 13.0328V13.0287ZM25.3583 12.03C25.4039 12.0341 25.4039 12.117 25.3583 12.1212C25.3169 12.117 25.3169 12.0341 25.3583 12.03ZM24.9357 13.6006C24.9978 13.6337 25.0102 13.729 24.9605 13.7829C24.9108 13.8326 24.8155 13.8202 24.7782 13.758C24.8321 13.7083 24.8818 13.6544 24.9357 13.6047V13.6006ZM24.7326 14.0274C24.7948 14.0315 24.7326 14.1351 24.6705 14.1227L24.6829 14.1476C24.6042 14.1807 24.5918 14.2885 24.5545 14.3672C24.5337 14.4128 24.4757 14.4418 24.4302 14.4418C24.397 14.4418 24.368 14.4252 24.368 14.3879C24.4882 14.2677 24.6125 14.1476 24.7368 14.0315L24.7326 14.0274ZM23.6015 15.2167C23.6595 15.1587 23.7672 15.2623 23.7258 15.3328C23.705 15.3659 23.6678 15.3825 23.6263 15.3825C23.5849 15.3825 23.5393 15.3659 23.5144 15.3328C23.5517 15.2955 23.5849 15.2623 23.6222 15.225L23.6015 15.2167ZM18.5381 16.924C18.4842 17.0442 18.4428 17.1685 18.4014 17.297C18.3309 16.9033 18.3309 16.4972 18.4055 16.1035C18.4469 16.3066 18.4925 16.5096 18.534 16.7127C18.5505 16.7831 18.563 16.8577 18.534 16.924H18.5381ZM18.4221 14.7526C18.4677 14.8313 18.4842 14.9266 18.4635 15.0137L18.4552 15.0634C18.3392 15.0137 18.3226 14.8272 18.4262 14.7526H18.4221ZM18.5464 14.2926L18.4179 14.5454C18.3682 14.5122 18.3475 14.4418 18.3682 14.3879H18.3641C18.3309 14.3506 18.2978 14.3175 18.2688 14.2843C18.3061 14.2222 18.3475 14.16 18.4138 14.1351C18.4801 14.1103 18.5712 14.1434 18.5754 14.2139C18.5754 14.2429 18.563 14.2719 18.5505 14.2968L18.5464 14.2926ZM18.5588 12.548C18.5588 12.548 18.5381 12.548 18.5257 12.5397C18.5008 12.5231 18.4884 12.4941 18.4759 12.4651C18.3848 12.2082 18.3102 11.8725 18.5257 11.7068C18.563 11.9181 18.6044 12.1294 18.6417 12.3408C18.6583 12.4237 18.621 12.548 18.5547 12.548H18.5588ZM18.3724 10.8904C18.4718 10.8738 18.563 10.8241 18.6334 10.7495C18.6997 10.8821 18.6997 11.0479 18.6334 11.1805L18.6044 11.2053C18.4925 11.1349 18.4096 11.0189 18.3765 10.8904H18.3724ZM18.7246 16.232C18.6417 16.0994 18.6458 15.9212 18.7287 15.7886C18.7494 15.8425 18.7743 15.8963 18.795 15.9502L18.7743 15.9585C18.7991 16.0497 18.7826 16.1533 18.7246 16.2279V16.232ZM18.8323 12.4361C18.7618 12.3905 18.7618 12.2703 18.8323 12.2289C18.9027 12.2745 18.9027 12.3947 18.8323 12.4361ZM18.679 1.7529C18.6541 1.69489 18.6831 1.6203 18.737 1.59543C18.8074 1.76948 18.8033 1.97254 18.7246 2.1383C18.6624 2.02226 18.6458 1.88551 18.679 1.75705V1.7529ZM18.6458 3.72959C18.6665 3.64256 18.6997 3.55554 18.7411 3.47266C18.8033 3.79175 18.8033 4.12327 18.7453 4.4465C18.6044 4.24344 18.5837 3.96994 18.6458 3.72959ZM18.6665 5.22557C18.6665 5.27115 18.5795 5.27115 18.5754 5.22557C18.5754 5.18413 18.6624 5.17998 18.6665 5.22557ZM18.621 2.85935C18.6914 2.90494 18.6914 3.02511 18.621 3.06655C18.5505 3.02097 18.5505 2.90079 18.621 2.85935ZM18.5712 5.63997C18.6417 5.55709 18.7867 5.64411 18.8033 5.75185C18.824 5.8596 18.7743 5.96734 18.7784 6.07508C18.7784 6.18283 18.882 6.30715 18.9815 6.26156C18.9069 6.31958 18.8281 6.3776 18.8033 6.46876C18.7784 6.55579 18.8364 6.67596 18.9276 6.67182C19.0229 6.66767 18.9897 6.82929 18.9027 6.86659C18.8157 6.90388 18.6956 6.92874 18.6831 7.01991L18.7826 7.12351C18.7287 7.17738 18.679 7.22711 18.6293 7.27684C18.3889 6.95361 18.8199 6.42732 18.5712 6.10824C18.4677 5.97563 18.4718 5.77257 18.5712 5.64411V5.63997ZM18.5215 7.98961C18.5547 7.81556 18.5878 7.64151 18.621 7.46332C18.8157 7.69953 18.853 8.04762 18.7163 8.32113C18.6541 8.43716 18.708 8.57805 18.7328 8.70652C18.7577 8.83498 18.7328 9.00488 18.6085 9.04632C18.5381 8.79354 18.4635 8.53661 18.4801 8.2714C18.4884 8.17609 18.505 8.08077 18.5215 7.98961ZM18.4884 9.70107L18.6707 9.85855C18.6334 9.8917 18.6003 9.92899 18.5671 9.96214C18.7743 10.1528 18.679 10.563 18.4055 10.6376C18.3558 10.5879 18.3061 10.5423 18.2563 10.4926C18.4179 10.2647 18.5008 9.97872 18.4842 9.70107H18.4884ZM18.2853 12.664C18.3558 12.5977 18.4759 12.6392 18.5298 12.7179C18.5837 12.7966 18.5878 12.9002 18.5878 12.9955C18.5878 13.2856 18.5878 13.5923 18.4221 13.8285C18.2646 13.6089 18.4221 13.2939 18.3309 13.0411C18.2853 12.9127 18.1859 12.7593 18.2812 12.664H18.2853ZM17.2702 2.33721C17.3158 2.45324 17.3241 2.5817 17.3033 2.70602L17.2909 2.69774C17.2412 2.79305 17.1915 2.88421 17.1376 2.97952C17.0506 2.76404 17.1044 2.49882 17.2702 2.33721ZM16.2923 4.23101C16.3752 4.26416 16.4373 4.34704 16.4456 4.43821H16.3918C16.371 4.56253 16.3006 4.67856 16.2012 4.75315C16.1473 4.69928 16.0934 4.64541 16.0437 4.59568C16.168 4.50866 16.255 4.37605 16.2965 4.23101H16.2923ZM15.4139 5.45349C15.4595 5.36232 15.6086 5.38718 15.6749 5.31259C15.7454 5.23386 15.6915 5.11368 15.6584 5.01422C15.6252 4.91477 15.6749 4.7573 15.7744 4.7863C15.9567 5.06809 15.7785 5.50736 15.4553 5.58195C15.4098 5.56123 15.3932 5.49907 15.4139 5.45763V5.45349ZM14.7219 6.96604C14.7882 6.96604 14.7344 7.09036 14.6722 7.0655L14.6639 7.07379C14.6888 7.11108 14.6391 7.14423 14.6018 7.14423C14.5852 7.14423 14.5686 7.13594 14.5645 7.11522C14.6308 7.08207 14.6888 7.0282 14.7178 6.9619L14.7219 6.96604ZM14.6805 7.66638C14.6929 7.7161 14.6598 7.76583 14.6225 7.80727C14.5728 7.77412 14.552 7.70367 14.5728 7.6498H14.5686C14.5769 7.59593 14.6681 7.6125 14.6805 7.66638ZM13.8891 6.76299C13.9305 6.76713 13.9305 6.85001 13.8891 6.85416C13.8435 6.85416 13.8435 6.76713 13.8891 6.76299ZM13.5908 9.60576C13.6695 9.54775 13.7399 9.68864 13.7399 9.7881C13.7399 9.87097 13.7399 9.95386 13.7399 10.0367C13.7399 10.1196 13.7192 10.2232 13.6405 10.2398C13.6322 10.2398 13.628 10.2398 13.6198 10.2398C13.57 10.2398 13.5245 10.1984 13.4955 10.1528C13.3836 9.97872 13.4292 9.72179 13.599 9.60162L13.5908 9.60576ZM13.2634 10.3185C13.2841 10.3724 13.309 10.4263 13.3297 10.4801L13.309 10.4884C13.3339 10.5796 13.3173 10.6832 13.2593 10.7578C13.1764 10.6252 13.1805 10.4428 13.2634 10.3144V10.3185ZM12.8284 11.052C12.8615 10.9981 12.9112 10.9443 12.9734 10.9484C13.1101 10.9484 13.1018 11.168 13.0065 11.2675C12.9112 11.3628 12.7662 11.4457 12.7703 11.5824C12.7703 11.6487 12.8159 11.7151 12.8781 11.7399C12.8283 11.8311 12.7828 11.9264 12.7331 12.0176C12.6046 11.7068 12.6419 11.3297 12.8284 11.052ZM12.5259 12.5397C12.559 12.5811 12.5922 12.6309 12.5839 12.6806C12.5756 12.7096 12.5425 12.7262 12.5134 12.7262C12.4927 12.7262 12.472 12.7179 12.472 12.693H12.4803C12.4596 12.6392 12.4803 12.5687 12.53 12.5356L12.5259 12.5397ZM11.9665 13.3602C12.0038 13.2608 12.0452 13.1654 12.0908 13.066C12.124 12.9914 12.1612 12.9168 12.2275 12.8712C12.2938 12.8256 12.4016 12.8298 12.443 12.9002C12.3477 13.0909 12.2524 13.2815 12.1612 13.468C12.1322 13.5218 12.0908 13.5881 12.0287 13.5881C12.0245 13.5881 12.0162 13.5881 12.0121 13.5881C11.9251 13.5674 11.9375 13.4431 11.9706 13.3602H11.9665ZM11.9955 13.7995H12.0038C12.0784 13.8906 12.0742 14.0357 11.9997 14.1227C11.9251 14.0315 11.9251 13.8906 11.9997 13.7995H11.9955ZM11.7883 14.1186C11.8505 14.1517 11.8629 14.2512 11.8132 14.3009C11.7635 14.3506 11.6682 14.3382 11.6309 14.276C11.6847 14.2263 11.7345 14.1724 11.7883 14.1186ZM11.5977 14.6366C11.6599 14.62 11.7262 14.6739 11.7262 14.736C11.7262 14.7692 11.7137 14.8023 11.6972 14.8313C11.6557 14.9101 11.6184 14.9929 11.577 15.0717C11.519 14.9971 11.5024 14.8935 11.5273 14.8023L11.5356 14.7899C11.5066 14.736 11.5356 14.6573 11.5977 14.6407V14.6366ZM11.1544 15.6974C11.2248 15.743 11.2248 15.8632 11.1544 15.9046C11.0839 15.859 11.0839 15.7389 11.1544 15.6974ZM10.9513 16.2279C11.0259 16.29 10.9886 16.4516 10.8892 16.4351L10.8809 16.4433C10.9223 16.5179 10.8809 16.6257 10.8022 16.6547C10.8022 16.5014 10.8519 16.3522 10.9472 16.232L10.9513 16.2279ZM9.73315 19.0126C9.70829 19.0458 9.671 19.0623 9.62957 19.0623C9.58813 19.0623 9.5467 19.0458 9.52598 19.0085C9.57156 18.938 9.69172 18.938 9.73315 19.0085V19.0126ZM8.83815 20.2309C8.88373 20.2309 8.88373 20.318 8.83815 20.3221C8.79672 20.318 8.79672 20.2351 8.83815 20.2309Z" fill="black"/>
                                  </svg>
                                <p>Увидите, что талант — это <span>приобретаемый навык, а не благословение<br> свыше</span></p>
                            </li>
                        </ul>
                    </div>
                    <div>
                        <svg xmlns="http://www.w3.org/2000/svg" width="239" height="182" viewBox="0 0 239 182" fill="none">
                            <path d="M196.964 110.274C143.936 41.7036 157.861 12.5872 169.523 10.1397C180.724 7.78912 186.609 31.7812 187.545 45.6957C187.558 45.897 187.879 45.913 187.915 45.7144C190.705 30.1401 199.642 3.16707 215.605 8.16163C229.217 12.4209 220.352 54.7074 176.511 94.6413" stroke="black" stroke-width="1.2" stroke-linecap="round"/>
                            <path d="M196.7 109.95C207.2 121.95 175.207 149.045 123.046 140.265C57.8456 129.289 206.795 103.126 195.62 137.592C184.444 172.058 73.2685 143.777 52.3594 172.533" stroke="black" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                          </svg>          
                    </div>
                </div>
            </div>
        </div>`
	});
    
    blockManager.add('careerum-veb20-author', {
        label: 'Веб 2.0 author',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-veb20-author">
            <div>
                <div class="veb20-author__header">
                    Автор и ведущая — Ольга Лермонтова, <span>основательница Careerum</span>
                </div>
                <div class="veb20-author__info">
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1699104665885.png" alt="Author"></div>
                    <div>14+ лет успешной карьеры в 5 странах в компаниях Google, Microsoft</div>
                    <div>Степень MBA от топовой бизнес-школы INSEAD</div>
                    <div>Помогла 11 000+ человек полюбить свою работу</div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-veb20-author-tablet', {
        label: 'Веб 2.0 author (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-veb20-author-tablet">
            <div>
                <div class="veb20-author__header">
                    Автор и ведущая — Ольга Лермонтова, основательница Careerum
                </div>
                <div class="veb20-author__info">
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1699104746182.png" alt="Author"></div>
                    <div>
                        <div>14+ лет успешной карьеры в 5 странах в компаниях Google, Microsoft</div>
                        <div>Степень MBA от топовой бизнес-школы INSEAD</div>
                        <div>Помогла 11 000+ человек полюбить<br> свою работу</div>
                    </div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-veb20-author-mobile', {
        label: 'Веб 2.0 author (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-veb20-author-mobile">
            <div>
                <div class="veb20-author__header">
                    Автор и ведущая —<br> Ольга Лермонтова, основательница<br> Careerum
                </div>
                <div class="veb20-author__info">
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1699104760095.png" alt="Author"></div>
                    <div>
                        <div>14+ лет успешной карьеры в 5 странах в компаниях Google, Microsoft</div>
                        <div>Степень MBA от топовой бизнес-<br>школы INSEAD</div>
                        <div>Помогла 11 000+ человек полюбить<br> свою работу</div>
                    </div>
                </div>
            </div>
        </div>`
	});
    
    blockManager.add('careerum-club21-banner20', {
        label: 'Баннер 2.0',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-club21-banner20">
            <div>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1699356916750.png" alt="">
                <div class="banner20__top">
                    <div class="banner20__top-date">27 ноября — 29 февраля</div>
                    <div class="banner20__top-header"><span>The New Old Me:</span> 3-месячная программа профессионального возрождения</div>
                </div>
                <div class="banner20__header">
                    <p>Из карьерного пепла<br> к работе по любви </p>
                </div>
                <div class="banner20__tiles">
                    <div>
                        <p class="banner20__tiles-header">Стадия 1:</p>
                        <p>Подведение итогов</p>
                        <ul>
                            <li>Сможете подвести итоги года<br>без самокритики и сказать:  «Вообще-то я хорошо справляюсь»</li>
                            <li>Укротите внутренних<br> критиков</li>
                            <li>Присвоите себе свои достижения</li>
                        </ul>
                    </div>
                    <div>
                        <p class="banner20__tiles-header">Стадия 2:</p>
                        <p>Восстановление сил</p>
                        <ul>
                            <li>Проведете аудит баланса<br> и избавитесь от «пожирателей энергии»</li>
                            <li>Научитесь бережно планировать ресурсы и избегать выгорания</li>
                            <li>Прокачаете устойчивость<br> к турбулентности и тревоге</li>
                        </ul>
                    </div>
                    <div>
                        <p class="banner20__tiles-header">Стадия 3: </p>
                        <p>Самоопределение</p>
                        <ul>
                            <li>Поймете, что для вас на самом деле важно в карьере</li>
                            <li>Определите свои суперсилы</li>
                            <li>Узнаете, как на этом зарабатывать</li>
                        </ul>
                    </div>
                </div>
                <div class="banner20__bottom">
                    <div>
                        <div>
                            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M27.1611 22.8972C27.2959 25.9507 24.8316 28.5327 21.6573 28.6625C21.4235 28.6723 10.0251 28.6493 10.0251 28.6493C6.8662 28.8891 4.10151 26.6192 3.85235 23.5772C3.83357 23.3506 3.83869 11.1204 3.83869 11.1204C3.69875 8.06363 6.15967 5.47502 9.33564 5.34033C9.57286 5.32884 20.9559 5.35019 20.9559 5.35019C24.1301 5.11367 26.9034 7.40005 27.1491 10.4568C27.1662 10.6769 27.1611 22.8972 27.1611 22.8972Z" stroke="#130F26" stroke-width="2.47059" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M27.166 13.6331L32.6543 9.14148C34.0143 8.02814 36.0543 8.99814 36.0527 10.7531L36.0327 23.0015C36.031 24.7565 33.9893 25.7181 32.6327 24.6048L27.166 20.1131" stroke="#130F26" stroke-width="2.47059" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                        </div>
                        <div>
                            <p class="banner20__bottom-header">Поучаствуете в вебинарах и эфирах:</p>
                            <p>с Ольгой Лермонтовой, карьерным стратегом Еленой<br> Резановой и другими экспертами в построении карьеры</p>
                        </div>
                    </div>
                    <div>
                        <div>
                            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g id="Iconly/Light/2 User">
                                <g id="2 User">
                                <path id="Stroke 1" fill-rule="evenodd" clip-rule="evenodd" d="M15.9859 25.3446C22.1342 25.3446 27.3892 26.2763 27.3892 29.9979C27.3892 33.7196 22.1692 34.6779 15.9859 34.6779C9.83585 34.6779 4.58252 33.7546 4.58252 30.0313C4.58252 26.3079 9.80085 25.3446 15.9859 25.3446Z" stroke="#130F26" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
                                <path id="Stroke 3" fill-rule="evenodd" clip-rule="evenodd" d="M15.9858 20.0329C11.9491 20.0329 8.67578 16.7613 8.67578 12.7246C8.67578 8.68793 11.9491 5.41626 15.9858 5.41626C20.0208 5.41626 23.2941 8.68793 23.2941 12.7246C23.3091 16.7463 20.0591 20.0179 16.0374 20.0329H15.9858Z" stroke="#130F26" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
                                <path id="Stroke 5" d="M27.4717 18.1359C30.14 17.7609 32.195 15.4709 32.2 12.6993C32.2 9.96758 30.2083 7.70092 27.5967 7.27258" stroke="#130F26" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
                                <path id="Stroke 7" d="M30.9922 24.5536C33.5772 24.9386 35.3822 25.8453 35.3822 27.7119C35.3822 28.9969 34.5322 29.8303 33.1589 30.3519" stroke="#130F26" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
                                </g>
                                </g>
                                </svg>
                                
                        </div>
                        <div>
                            <p class="banner20__bottom-header">Посетите ресурсные встречи,</p>
                            <p>расширите профессиональный нетворк с участниками<br> Careerum, выполните практические задания<br> для формирования карьерных навыков</p>
                        </div>
                    </div>
                    <div>
                        <div>
                            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g id="Iconly/Light/Edit Square">
                                <g id="Edit Square">
                                <path id="Stroke 1" d="M19.154 4.64844H12.9223C7.79732 4.64844 4.58398 8.27677 4.58398 13.4134V27.2701C4.58398 32.4068 7.78232 36.0351 12.9223 36.0351H27.629C32.7706 36.0351 35.969 32.4068 35.969 27.2701V20.5568" stroke="#130F26" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
                                <path id="Stroke 3" fill-rule="evenodd" clip-rule="evenodd" d="M14.7135 18.2017L27.1685 5.74673C28.7202 4.19673 31.2352 4.19673 32.7869 5.74673L34.8152 7.77506C36.3669 9.32673 36.3669 11.8434 34.8152 13.3934L22.3002 25.9084C21.6219 26.5867 20.7019 26.9684 19.7419 26.9684H13.4985L13.6552 20.6684C13.6785 19.7417 14.0569 18.8584 14.7135 18.2017Z" stroke="#130F26" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
                                <path id="Stroke 5" d="M25.2759 7.6709L32.8859 15.2809" stroke="#130F26" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
                                </g>
                                </g>
                                </svg>
                                
                        </div>
                        <div>
                            <p class="banner20__bottom-header">Примете участие в обновленной программе </p>
                            <p>«Real Me: как найти себя в работе и жизни», чтобы обрести работу<br> по любви</p>
                        </div>
                    </div>
                </div>
                <div class="banner20__button">
                    <a href="" class="btn-color-main-bright-orange">Участвовать</a>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-club21-banner20-tablet', {
        label: 'Баннер 2.0 (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-club21-banner20-tablet">
            <div>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1699356901667.png" alt="">
                <div class="banner20__top">
                    <div class="banner20__top-date">27 ноября — 29 февраля</div>
                    <div class="banner20__top-header"><span>The New Old Me:</span> 3-месячная программа профессионального возрождения</div>
                </div>
                <div class="banner20__header">
                    <p>Из карьерного пепла<br> к работе по любви </p>
                </div>
                <div class="banner20__tiles">
                    <div>
                        <p class="banner20__tiles-header">Стадия 1:</p>
                        <p>Подведение итогов</p>
                        <ul>
                            <li>Сможете подвести итоги года без самокритики и<br> сказать: «Вообще-то я хорошо справляюсь»</li>
                            <li>Укротите внутренних<br> критиков</li>
                            <li>Присвоите себе свои достижения</li>
                        </ul>
                    </div>
                    <div>
                        <p class="banner20__tiles-header">Стадия 2:</p>
                        <p>Восстановление сил</p>
                        <ul>
                            <li>Проведете аудит баланса и избавитесь от «пожирателей энергии»</li>
                            <li>Научитесь бережно планировать ресурсы<br> и избегать выгорания</li>
                            <li>Прокачаете устойчивость<br> к турбулентности<br> и тревоге</li>
                        </ul>
                    </div>
                    <div>
                        <p class="banner20__tiles-header">Стадия 3: </p>
                        <p>Самоопределение</p>
                        <ul>
                            <li>Поймете, что для вас<br> на самом деле важно<br> в карьере</li>
                            <li>Определите свои суперсилы</li>
                            <li>Узнаете, как на этом зарабатывать</li>
                        </ul>
                    </div>
                </div>
                <div class="banner20__bottom">
                    <div>
                        <div>
                            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M27.1611 22.8972C27.2959 25.9507 24.8316 28.5327 21.6573 28.6625C21.4235 28.6723 10.0251 28.6493 10.0251 28.6493C6.8662 28.8891 4.10151 26.6192 3.85235 23.5772C3.83357 23.3506 3.83869 11.1204 3.83869 11.1204C3.69875 8.06363 6.15967 5.47502 9.33564 5.34033C9.57286 5.32884 20.9559 5.35019 20.9559 5.35019C24.1301 5.11367 26.9034 7.40005 27.1491 10.4568C27.1662 10.6769 27.1611 22.8972 27.1611 22.8972Z" stroke="#130F26" stroke-width="2.47059" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M27.166 13.6331L32.6543 9.14148C34.0143 8.02814 36.0543 8.99814 36.0527 10.7531L36.0327 23.0015C36.031 24.7565 33.9893 25.7181 32.6327 24.6048L27.166 20.1131" stroke="#130F26" stroke-width="2.47059" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                        </div>
                        <div>
                            <p class="banner20__bottom-header">Поучаствуете в вебинарах и эфирах:</p>
                            <p>с Ольгой Лермонтовой, карьерным стратегом Еленой<br> Резановой и другими экспертами в построении карьеры</p>
                        </div>
                    </div>
                    <div>
                        <div>
                            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g id="Iconly/Light/2 User">
                                <g id="2 User">
                                <path id="Stroke 1" fill-rule="evenodd" clip-rule="evenodd" d="M15.9859 25.3446C22.1342 25.3446 27.3892 26.2763 27.3892 29.9979C27.3892 33.7196 22.1692 34.6779 15.9859 34.6779C9.83585 34.6779 4.58252 33.7546 4.58252 30.0313C4.58252 26.3079 9.80085 25.3446 15.9859 25.3446Z" stroke="#130F26" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
                                <path id="Stroke 3" fill-rule="evenodd" clip-rule="evenodd" d="M15.9858 20.0329C11.9491 20.0329 8.67578 16.7613 8.67578 12.7246C8.67578 8.68793 11.9491 5.41626 15.9858 5.41626C20.0208 5.41626 23.2941 8.68793 23.2941 12.7246C23.3091 16.7463 20.0591 20.0179 16.0374 20.0329H15.9858Z" stroke="#130F26" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
                                <path id="Stroke 5" d="M27.4717 18.1359C30.14 17.7609 32.195 15.4709 32.2 12.6993C32.2 9.96758 30.2083 7.70092 27.5967 7.27258" stroke="#130F26" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
                                <path id="Stroke 7" d="M30.9922 24.5536C33.5772 24.9386 35.3822 25.8453 35.3822 27.7119C35.3822 28.9969 34.5322 29.8303 33.1589 30.3519" stroke="#130F26" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
                                </g>
                                </g>
                                </svg>
                                
                        </div>
                        <div>
                            <p class="banner20__bottom-header">Посетите ресурсные встречи,</p>
                            <p>расширите профессиональный нетворк с участниками<br> Careerum, выполните практические задания для формирования <br>карьерных навыков</p>
                        </div>
                    </div>
                    <div>
                        <div>
                            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g id="Iconly/Light/Edit Square">
                                <g id="Edit Square">
                                <path id="Stroke 1" d="M19.154 4.64844H12.9223C7.79732 4.64844 4.58398 8.27677 4.58398 13.4134V27.2701C4.58398 32.4068 7.78232 36.0351 12.9223 36.0351H27.629C32.7706 36.0351 35.969 32.4068 35.969 27.2701V20.5568" stroke="#130F26" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
                                <path id="Stroke 3" fill-rule="evenodd" clip-rule="evenodd" d="M14.7135 18.2017L27.1685 5.74673C28.7202 4.19673 31.2352 4.19673 32.7869 5.74673L34.8152 7.77506C36.3669 9.32673 36.3669 11.8434 34.8152 13.3934L22.3002 25.9084C21.6219 26.5867 20.7019 26.9684 19.7419 26.9684H13.4985L13.6552 20.6684C13.6785 19.7417 14.0569 18.8584 14.7135 18.2017Z" stroke="#130F26" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
                                <path id="Stroke 5" d="M25.2759 7.6709L32.8859 15.2809" stroke="#130F26" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
                                </g>
                                </g>
                                </svg>
                                
                        </div>
                        <div>
                            <p class="banner20__bottom-header">Примете участие в обновленной программе </p>
                            <p>«Real Me: как найти себя в работе и жизни», чтобы обрести<br> работу по любви</p>
                        </div>
                    </div>
                </div>
                <div class="banner20__button">
                    <a href="" class="btn-color-main-bright-orange">Участвовать</a>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-club21-banner20-mobile', {
        label: 'Баннер 2.0 (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-club21-banner20-mobile">
            <div>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1699356908368.png" alt="">
                <div class="banner20__top">
                    <div class="banner20__top-date">27 ноября — 29 февраля</div>
                    <div class="banner20__top-header"><span>The New Old Me:</span><br> 3-месячная программа профессионального возрождения</div>
                </div>
                <div class="banner20__header">
                    <p>Из карьерного<br> пепла к работе<br> по любви </p>
                </div>
                <div class="banner20__tiles">
                    <div class="banner20__tiles-item">
                        <p class="banner20__tiles-header">Стадия 1:</p>
                        <p>Подведение итогов</p>
                        <ul>
                            <li>Сможете подвести итоги года без самокритики<br> и сказать: «Вообще-то я хорошо справляюсь»</li>
                            <li>Укротите внутренних<br> критиков</li>
                            <li>Присвоите себе свои достижения</li>
                        </ul>
                    </div>
                    <div class="banner20__tiles-item">
                        <p class="banner20__tiles-header">Стадия 2:</p>
                        <p>Восстановление сил</p>
                        <ul>
                            <li>Проведете аудит баланса и избавитесь от «пожирателей энергии»</li>
                            <li>Научитесь бережно планировать ресурсы<br> и избегать выгорания</li>
                            <li>Прокачаете устойчивость<br> к турбулентности<br> и тревоге</li>
                        </ul>
                    </div>
                    <div class="banner20__tiles-item">
                        <p class="banner20__tiles-header">Стадия 3: </p>
                        <p>Самоопределение</p>
                        <ul>
                            <li>Поймете, что для вас<br> на самом деле важно<br> в карьере</li>
                            <li>Определите свои суперсилы</li>
                            <li>Узнаете, как на этом зарабатывать</li>
                        </ul>
                    </div>
                </div>
                <div class="club21-banner20-arrows">
                    <div>
                        <div class="club21-banner20-slider__arrow-left"  style="display: block;">
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 18 16" fill="none"><path d="M2.19055 7.99935L15.8105 7.99935" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"></path><path d="M8.46289 14.2453L2.18956 7.99862L8.46289 1.75195" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"></path>
                            </svg>
                        </div>
                        <div class="club21-banner20-slider__arrow-right" >
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 18 16" fill="none"><path d="M15.8095 8.00065L2.18945 8.00065" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"></path><path d="M9.53711 1.75471L15.8104 8.00138L9.53711 14.248" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"></path>
                            </svg>
                        </div>
                    </div>
                </div>
                <div class="banner20__bottom">
                    <div>
                        <div>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M16.2966 13.5383C16.3775 15.3704 14.8989 16.9196 12.9944 16.9975C12.8541 17.0034 6.01507 16.9896 6.01507 16.9896C4.11972 17.1335 2.46091 15.7715 2.31141 13.9463C2.30014 13.8103 2.30322 6.47219 2.30322 6.47219C2.21925 4.63815 3.6958 3.08499 5.60139 3.00418C5.74372 2.99728 12.5735 3.01009 12.5735 3.01009C14.4781 2.86818 16.142 4.24001 16.2895 6.07404C16.2997 6.2061 16.2966 13.5383 16.2966 13.5383Z" stroke="#130F26" stroke-width="1.48235" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M16.2998 7.97984L19.5928 5.28484C20.4088 4.61684 21.6328 5.19884 21.6318 6.25184L21.6198 13.6008C21.6188 14.6538 20.3938 15.2308 19.5798 14.5628L16.2998 11.8678" stroke="#130F26" stroke-width="1.48235" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>                            
                        </div>
                        <div>
                            <p class="banner20__bottom-header">Поучаствуете в<br> вебинарах и эфирах:</p>
                            <p>с Ольгой Лермонтовой,<br> карьерным стратегом Еленой<br> Резановой и другими экспертами<br> в построении карьеры</p>
                        </div>
                    </div>
                    <div>
                        <div>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M9.59151 15.2068C13.2805 15.2068 16.4335 15.7658 16.4335 17.9988C16.4335 20.2318 13.3015 20.8068 9.59151 20.8068C5.90151 20.8068 2.74951 20.2528 2.74951 18.0188C2.74951 15.7848 5.88051 15.2068 9.59151 15.2068Z" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M9.59157 12.0198C7.16957 12.0198 5.20557 10.0568 5.20557 7.63476C5.20557 5.21276 7.16957 3.24976 9.59157 3.24976C12.0126 3.24976 13.9766 5.21276 13.9766 7.63476C13.9856 10.0478 12.0356 12.0108 9.62257 12.0198H9.59157Z" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M16.4829 10.8815C18.0839 10.6565 19.3169 9.28253 19.3199 7.61953C19.3199 5.98053 18.1249 4.62053 16.5579 4.36353" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M18.5952 14.7322C20.1462 14.9632 21.2292 15.5072 21.2292 16.6272C21.2292 17.3982 20.7192 17.8982 19.8952 18.2112" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>                            
                        </div>
                        <div>
                            <p class="banner20__bottom-header">Посетите ресурсные встречи,</p>
                            <p>расширите профессиональный нетворк с участниками Careerum,<br> выполните практические<br> задания для формирования <br>карьерных навыков</p>
                        </div>
                    </div>
                    <div>
                        <div>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M11.4925 2.78906H7.75349C4.67849 2.78906 2.75049 4.96606 2.75049 8.04806V16.3621C2.75049 19.4441 4.66949 21.6211 7.75349 21.6211H16.5775C19.6625 21.6211 21.5815 19.4441 21.5815 16.3621V12.3341" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M8.82812 10.921L16.3011 3.44799C17.2321 2.51799 18.7411 2.51799 19.6721 3.44799L20.8891 4.66499C21.8201 5.59599 21.8201 7.10599 20.8891 8.03599L13.3801 15.545C12.9731 15.952 12.4211 16.181 11.8451 16.181H8.09912L8.19312 12.401C8.20712 11.845 8.43412 11.315 8.82812 10.921Z" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M15.1655 4.60254L19.7315 9.16854" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                                
                                
                        </div>
                        <div>
                            <p class="banner20__bottom-header">Примете участие в обновленной программе </p>
                            <p>«Real Me: как найти себя в работе<br> и жизни», чтобы обрести работу<br> по любви</p>
                        </div>
                    </div>
                </div>
                <div class="banner20__button">
                    <a href="" class="btn-color-main-bright-orange">Участвовать</a>
                </div>
            </div>
        </div>`
	});
    
    blockManager.add('careerum-club21-banner21', {
        label: 'Баннер 2.1',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-club21-banner21">
            <div>
                <div class="banner21__header">
                    <p>А так можно было? Построить карьеру<br> по своим правилам и <span>со скидкой 15%</span></p>
                    <svg width="342" height="59" viewBox="0 0 342 59" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect width="341" height="54" transform="translate(0 4.23145) rotate(-0.710964)" fill="#FF5A00"/>
                    </svg>                    
                </div>
                <div class="banner21__subheader">
                    <p>Успейте активировать промокод NOVEMBER15 </p>
                </div>
                <div class="banner21__text">
                    <p>Действует на первую покупку только 19 ноября, для первых<br> 100 человек</p>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-club21-banner21-tablet', {
        label: 'Баннер 2.1 (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-club21-banner21-tablet">
            <div>
                <div class="banner21__header">
                    <p>А так можно было? Построить<br> карьеру по своим правилам и <br><span>со скидкой 15%</span></p>
                    <svg width="245" height="45" viewBox="0 0 245 45" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect width="244" height="40" transform="translate(0 5) rotate(-1)" fill="#FF5A00"/>
                        </svg>                                   
                </div>
                <div class="banner21__subheader">
                    <p>Успейте активировать промокод NOVEMBER15 </p>
                </div>
                <div class="banner21__text">
                    <p>Действует на первую покупку только 19 ноября,<br> для первых 100 человек</p>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-club21-banner21-mobile', {
        label: 'Баннер 2.1 (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-club21-banner21-mobile">
            <div>
                <div class="banner21__header">
                    <p>А так можно было? Построить карьеру<br> по своим правилам и <br><span>со скидкой 15%</span></p>
                    <svg width="164" height="32" viewBox="0 0 164 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect width="163" height="29" transform="translate(0 3) rotate(-1)" fill="#FF5A00"/>
                        </svg>
                                                         
                </div>
                <div class="banner21__subheader">
                    <p>Успейте активировать<br> промокод NOVEMBER15 </p>
                </div>
                <div class="banner21__text">
                    <p>Действует на первую покупку только 19 ноября, для первых<br> 100 человек</p>
                </div>
            </div>
        </div>`
	});
    
    blockManager.add('careerum-club21-banner22', {
        label: 'Баннер 2.2',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-club21-banner22">
            <div>
                <div class="club21-banner22-top">
                    <p>Главный предновогодний розыгрыш</p>
                </div>
                <div class="club21-banner22-header">
                    <p>The New Old Friday</p>
                </div>
                <div class="club21-banner22-subheader">
                    <p>Вступите в Careerum </p>
                </div>
                <div class="club21-banner22-subheader2">
                    <p>и выиграйте вдвойне</p>
                </div>
                <div class="club21-banner22-row">
                    <div class="club21-banner22-card-hw orange">
                        <div class="club21-banner22-card-header">
                            <p>Гарантированный подарок на выбор</p>
                        </div>
                        <div class="club21-banner22-card-text">
                            <p>Годовой доступ к платной рассылке Careerum.Tips или электронная версии книги Ольги Лермонтовой «Работа по любви»</p>
                        </div>
                    </div>
                    <div class="club21-banner22-card-hw">
                        <div class="club21-banner22-card-header">
                            <p>Продление подписки на любой тариф х2</p>
                        </div>
                        <div class="club21-banner22-card-text">
                            <p>Например, оплачиваете 3 месяца — а мы вам столько же добавляем бесплатно</p>
                        </div>
                        <div class="club21-banner22-card-label">
                            <p>5 мест</p>
                        </div>
                    </div>
                </div>
                <div class="club21-banner22-card-fw">
                    <div class="club21-banner22-card-header">
                        <p>Индивидуальное сопровождение Ольги Лермонтовой, основательницы Careerum</p>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1700759411321.png" alt="">
                    </div>
                    <div>
                        <div class="club21-banner22-card-text"><p>Годовое сопровождение Ольги Лермонтовой для тарифа на 12 месяцев и полугодовое для тарифа на 6 месяцев:</p></div>
                        <div class="club21-banner22-card-ul">
                            <ul>
                                <li>3 встречи при подписке на 6 месяцев</li>
                                <li>6 встреч при подписке на 12 месяцев</li>
                            </ul>
                        </div>
                        <div class="club21-banner22-card-label">
                            <p>2 места</p>
                        </div>
                    </div>
                </div>
                <div class="club21-banner22-card-fw card-bottom">
                    <div class="club21-banner22-card-header">
                        <p>Персональное сопровождение Вероники Зданович, СЕО Careerum</p>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1700759560822.png" alt="">
                    </div>
                    <div>
                        <div class="club21-banner22-card-text"><p>Бизнес-сопровождение Вероники<br> Зданович, CEO Careerum для тарифов<br> на 3, 6, 12 месяцев:</p></div>
                        <div class="club21-banner22-card-ul">
                            <ul>
                                <li>1 встреча при подписке на 3 месяца</li>
                                <li>3 встречи при подписке на 6 месяцев</li>
                                <li>6 встреч при подписки на год</li>
                            </ul>
                        </div>
                        <div class="club21-banner22-card-label">
                            <p>2 места</p>
                        </div>
                    </div>
                </div>
                <div class="club21-banner22-link">
                    <a href="#buy" class="btn-color-main-dark-orange">Выбрать тариф и участвовать в розыгрыше</a>
                </div>
                <div class="club21-banner22-bottom">
                    <p>В розыгрыше участвуют все, кто вступил в Careerum, начиная с 16 ноября. Победители будут выбраны случайным<br> образом. Результаты объявим 2 декабря в Instagram-аккаунте Ольги Лермонтовой</p>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-club21-banner22-tablet', {
        label: 'Баннер 2.2 (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-club21-banner22-tablet">
            <div>
                <div class="club21-banner22-top">
                    <p>Главный предновогодний розыгрыш</p>
                </div>
                <div class="club21-banner22-header">
                    <p>The New Old Friday</p>
                </div>
                <div class="club21-banner22-subheader">
                    <p>Вступите в Careerum </p>
                </div>
                <div class="club21-banner22-subheader2">
                    <p>и выиграйте вдвойне</p>
                </div>
                <div class="club21-banner22-row">
                    <div class="club21-banner22-card-hw orange">
                        <div class="club21-banner22-card-header">
                            <p>Гарантированный<br>подарок на выбор</p>
                        </div>
                        <div class="club21-banner22-card-text">
                            <p>Годовой доступ к платной рассылке Careerum.Tips или электронная версии книги Ольги Лермонтовой «Работа по любви»</p>
                        </div>
                    </div>
                    <div class="club21-banner22-card-hw">
                        <div class="club21-banner22-card-header">
                            <p>Продление подписки на любой тариф х2</p>
                        </div>
                        <div class="club21-banner22-card-text">
                            <p>Например, оплачиваете 3 месяца — а мы вам столько же добавляем бесплатно</p>
                        </div>
                        <div class="club21-banner22-card-label">
                            <p>5 мест</p>
                        </div>
                    </div>
                </div>
                <div class="club21-banner22-card-fw">
                    <div class="club21-banner22-card-header">
                        <p>Индивидуальное сопровождение Ольги Лермонтовой, основательницы Careerum</p>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1700759575117.png" alt="">
                    </div>
                    <div>
                        <div class="club21-banner22-card-text"><p>Годовое сопровождение Ольги Лермонтовой для тарифа на 12 месяцев и полугодовое для тарифа на 6 месяцев:</p></div>
                        <div class="club21-banner22-card-ul">
                            <ul>
                                <li>3 встречи при подписке на 6 месяцев</li>
                                <li>6 встреч при подписке на 12 месяцев</li>
                            </ul>
                        </div>
                        <div class="club21-banner22-card-label">
                            <p>2 места</p>
                        </div>
                    </div>
                </div>
                <div class="club21-banner22-card-fw card-bottom">
                    <div class="club21-banner22-card-header">
                        <p>Персональное сопровождение Вероники Зданович, СЕО Careerum</p>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1700759589497.png" alt="">
                    </div>
                    <div>
                        <div class="club21-banner22-card-text"><p>Бизнес-сопровождение Вероники<br> Зданович, CEO Careerum для тарифов<br> на 3, 6, 12 месяцев:</p></div>
                        <div class="club21-banner22-card-ul">
                            <ul>
                                <li>1 встреча при подписке на 3 месяца</li>
                                <li>3 встречи при подписке на 6 месяцев</li>
                                <li>6 встреч при подписки на год</li>
                            </ul>
                        </div>
                        <div class="club21-banner22-card-label">
                            <p>2 места</p>
                        </div>
                    </div>
                </div>
                <div class="club21-banner22-link">
                    <a href="#buy" class="btn-color-main-dark-orange">Выбрать тариф и участвовать в розыгрыше</a>
                </div>
                <div class="club21-banner22-bottom">
                    <p>В розыгрыше участвуют все, кто вступил в Careerum, начиная с 16 ноября. Победители<br> будут выбраны случайным образом. Результаты объявим 2 декабря в аккаунтах Ольги<br> Лермонтовой в Instagram и Telegram</p>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-club21-banner22-mobile', {
        label: 'Баннер 2.2 (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-club21-banner22-mobile">
            <div>
                <div class="club21-banner22-top">
                    <p>Главный предновогодний розыгрыш</p>
                </div>
                <div class="club21-banner22-header">
                    <p>The New Old Friday</p>
                </div>
                <div class="club21-banner22-subheader">
                    <p>Вступите в Careerum </p>
                </div>
                <div class="club21-banner22-subheader2">
                    <p>и выиграйте вдвойне</p>
                </div>
                <div class="club21-banner22-row">
                    <div class="club21-banner22-card-hw orange">
                        <div class="club21-banner22-card-header">
                            <p>Гарантированный<br>подарок на выбор</p>
                        </div>
                        <div class="club21-banner22-card-text">
                            <p>Годовой доступ к платной рассылке Careerum.Tips или электронная версии книги Ольги Лермонтовой «Работа<br> по любви»</p>
                        </div>
                    </div>
                    <div class="club21-banner22-card-hw">
                        <div class="club21-banner22-card-header">
                            <p>Продление<br> подписки на любой тариф х2</p>
                        </div>
                        <div class="club21-banner22-card-text">
                            <p>Например, оплачиваете 3 месяца — а мы вам столько же добавляем бесплатно</p>
                        </div>
                        <div class="club21-banner22-card-label">
                            <p>5 мест</p>
                        </div>
                    </div>
                </div>
                <div class="club21-banner22-card-fw">
                    <div class="club21-banner22-card-header">
                        <p>Индивидуальное сопровождение основательницы Careerum Ольги Лермонтовой</p>
                    </div>
                    <div class="club21-banner22-card-row">
                        <div>                        
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1700759575117.png" alt="">
                        </div>
                        <div class="club21-banner22-card-label">
                            <p>2 места</p>
                        </div>
                    </div>
                    <div class="club21-banner22-card-collapse">
                        <div class="club21-banner22-card-text"><p>Годовое сопровождение Ольги Лермонтовой для тарифа на 12 месяцев и полугодовое для тарифа на 6 месяцев:</p></div>
                        <div class="club21-banner22-card-ul">
                            <ul>
                                <li>3 встречи при подписке на 6 месяцев</li>
                                <li>6 встреч при подписке на 12 месяцев</li>
                            </ul>
                        </div>
                    </div>
                    <div class="club21-banner22-card-button">
                        <p>Подробнее</p>
                        <p>Свернуть</p>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M2.79199 10.7054C2.79199 14.9621 6.24283 18.4137 10.5003 18.4137C14.757 18.4137 18.2087 14.9621 18.2087 10.7054C18.2087 6.44874 14.757 2.99707 10.5003 2.99707C6.24283 2.99707 2.79199 6.44874 2.79199 10.7054Z" stroke="white" stroke-width="1.28125" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M7.60742 9.50342L10.4999 12.4084L13.3924 9.50342" stroke="white" stroke-width="1.28125" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                            
                    </div>
                </div>
                <div class="club21-banner22-card-fw card-bottom">
                    <div class="club21-banner22-card-header">
                        <p>Персональное сопровождение Вероники Зданович, СЕО Careerum</p>
                    </div>
                    <div class="club21-banner22-card-row">
                        <div>                        
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1700759589497.png" alt="">
                        </div>
                        <div class="club21-banner22-card-label">
                            <p>2 места</p>
                        </div>
                    </div>
                    <div class="club21-banner22-card-collapse">
                        <div class="club21-banner22-card-text"><p>Бизнес-сопровождение Вероники<br> Зданович, CEO Careerum для тарифов<br> на 3, 6, 12 месяцев:</p></div>
                        <div class="club21-banner22-card-ul">
                            <ul>
                                <li>1 встреча при подписке на 3 месяца</li>
                                <li>3 встречи при подписке на 6 месяцев</li>
                                <li>6 встреч при подписки на год</li>
                            </ul>
                        </div>
                    </div>
                    <div class="club21-banner22-card-button">
                        <p>Подробнее</p>
                        <p>Свернуть</p>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M2.79199 10.7054C2.79199 14.9621 6.24283 18.4137 10.5003 18.4137C14.757 18.4137 18.2087 14.9621 18.2087 10.7054C18.2087 6.44874 14.757 2.99707 10.5003 2.99707C6.24283 2.99707 2.79199 6.44874 2.79199 10.7054Z" stroke="white" stroke-width="1.28125" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M7.60742 9.50342L10.4999 12.4084L13.3924 9.50342" stroke="white" stroke-width="1.28125" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                            
                    </div>
                </div>
                <div class="club21-banner22-link">
                    <a href="#buy" class="btn-color-main-dark-orange">Выбрать тариф</a>
                </div>
                <div class="club21-banner22-bottom">
                    <p>В розыгрыше участвуют все, кто вступил в Careerum, начиная с 16 ноября. Победители будут выбраны случайным образом. Результаты объявим 2 декабря в аккаунтах Ольги Лермонтовой в Instagram и Telegram</p>
                </div>
            </div>
        </div>`
	});
    
    
    blockManager.add('careerum-sert-main', {
        label: 'Сертификаты главный',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-sert-main">
            <div>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1701259869373.svg" alt="">
                <h1>Подарочные<br> сертификаты Careerum</h1>
                <p>Лучший подарок для любимых, друзей и близких, который поможет<br> построить карьеру по своим правилам и начать работать в удовольствие</p>
                <a href="#buy" class="btn-color-black">Выбрать сертификат</a>
            </div>
        </div>`
	});

    blockManager.add('careerum-sert-main-tablet', {
        label: 'Сертификаты главный (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-sert-main-tablet">
            <div>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1701259982597.svg" alt="">
                <h2>Подарочные<br> сертификаты Careerum</h2>
                <p>Лучший подарок для любимых, друзей и близких, который поможет<br> построить карьеру по своим правилам и
                    начать работать<br> в удовольствие</p>
                <a href="#buy" class="btn-color-black">Выбрать сертификат</a>
            </div>
        </div>`
	});

    blockManager.add('careerum-sert-main-mobile', {
        label: 'Сертификаты главный (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-sert-main-mobile">
            <div>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1701260059310.svg" alt="">
                <h2>Подарочные<br> сертификаты Careerum</h2>
                <p>Лучший подарок для любимых,<br> друзей и близких, который<br> поможет построить карьеру<br> по своим
                    правилам и
                    начать<br> работать в удовольствие</p>
                <a href="#buy" class="btn-color-black">Выбрать сертификат</a>
            </div>
        </div>`
	});
    
    blockManager.add('careerum-round-separator', {
        label: 'Разделитель полукруг',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-round-separator">
            <div>
                <svg id="bigHalfCircle" xmlns="http://www.w3.org/2000/svg" version="1.1" width="100%" height="170" viewBox="0 0 100 100" preserveAspectRatio="none">
                    <path d="M0 100 C40 0 60 0 100 100 Z"></path>
                </svg>
            </div>
        </div>`
	});

    blockManager.add('careerum-round-separator-tablet', {
        label: 'Разделитель полукруг (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-round-separator-tablet">
            <div>
                <svg id="bigHalfCircle" xmlns="http://www.w3.org/2000/svg" version="1.1" width="100%" height="140"
                    viewBox="0 0 100 100" preserveAspectRatio="none">
                    <path d="M0 100 C40 0 60 0 100 100 Z"></path>
                </svg>
            </div>
        </div>`
	});

    blockManager.add('careerum-round-separator-mobile', {
        label: 'Разделитель полукруг (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-round-separator-mobile">
            <div>
                <svg id="bigHalfCircle" xmlns="http://www.w3.org/2000/svg" version="1.1" width="100%" height="65"
                    viewBox="0 0 100 100" preserveAspectRatio="none">
                    <path d="M0 100 C40 0 60 0 100 100 Z"></path>
                </svg>
            </div>
        </div>`
	});
    
    blockManager.add('careerum-sert-how', {
        label: 'Сертификаты как это',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-sert-how">
            <div>
                <div class="sert-how__header"><p>Как это работает?</p></div>
                <div class="sert-how__tiles">
                    <div class="sert-how__tile">
                        <p>Выбираете подписку, которую хотите подарить</p>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1701259934059.svg" alt="">
                    </div>
                    <div class="sert-how__tile">
                        <p>Оформляете заказ<br> и оплачиваете</p>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1701259940017.svg" alt="">
                    </div>
                    <div class="sert-how__tile">
                        <p>Мы присылаем письмо<br> с подарочным кодом</p>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1701259942339.svg" alt="">
                    </div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-sert-how-tablet', {
        label: 'Сертификаты как это (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-sert-how-tablet">
            <div>
                <div class="sert-how__header">
                    <p>Как это работает?</p>
                </div>
                <div class="sert-how__tiles">
                    <div class="sert-how__tile">
                        <p>Выбираете подписку, которую хотите подарить</p>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1701259994738.svg" alt="">
                    </div>
                    <div class="sert-how__tile">
                        <p>Оформляете заказ<br> и оплачиваете</p>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1701259996883.svg" alt="">
                    </div>
                    <div class="sert-how__tile">
                        <p>Мы присылаем письмо<br> с подарочным кодом</p>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1701259998950.svg" alt="">
                    </div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-sert-how-mobile', {
        label: 'Сертификаты как это (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-sert-how-mobile">
            <div>
                <div class="sert-how__header">
                    <p>Как это работает?</p>
                </div>
                <div class="sert-how__tiles">
                    <div class="sert-how__tile">
                        <p>Выбираете подписку,<br> которую хотите подарить</p>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1701259994738.svg" alt="">
                    </div>
                    <div class="sert-how__tile">
                        <p>Оформляете заказ<br> и оплачиваете</p>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1701259996883.svg" alt="">
                    </div>
                    <div class="sert-how__tile">
                        <p>Мы присылаем письмо<br> с подарочным кодом</p>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1701259998950.svg" alt="">
                    </div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-sert-single', {
        label: 'Сертификаты один курс (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-sert-single main-wrapper">
            <div class="careerum-container-responsive careerum-flex-sbc">
                <h2 class="hidden-desc-tablet">Сертификат на любой курс</h2>
                <div class="sert-single-left position-relative">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1734506477476-uCz0X-ÑÐµ.png" alt="" class="position-absolute sert-single-left-bg z-10 hidden-tablet-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1734507928806-zDfwj-ÑÐµ.png" alt="" class="position-absolute sert-single-left-bg z-10 hidden-desc">
                    <div class="position-relative z-20">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1734506477709-kbY3l-logo.svg" alt="">
                        <p class="sert-single-left-header">Подарочный сертификат</p>
                        <p class="sert-single-left-text">от платформы карьерного развития</p>
                    </div>
                </div>
                <div class="sert-single-right">
                    <p class="sert-single-right-header hidden-mobile">Сертификат на любой курс</p>
                    <p class="sert-single-right-text">Вы покупаете сертификат на любой курс из списка ниже. Предъявитель сертификата может открыть любой курс на 3 месяца</p>
                    <ul class="hidden-tablet-mobile">
                        <li class="position-relative"><span>«Продающее резюме»,</span> чтобы составлять их как боженька </li>
                        <li class="position-relative"><span>«Международная карьера и релокация»,</span> чтобы найти работу на глобальном рынке даже в 2025 году</li>
                        <li class="position-relative"><span>«Карьера в кризис: как найти и не потерять работу»,</span> чтобы быть устойчивым в любые мировые потрясения</li>
                        <li class="position-relative"><span>«Great Deal: как получить оффер мечты»,</span> чтобы устроиться в компанию мечты</li>
                        <li class="position-relative"><span>«Пробейте карьерный потолок»,</span> чтобы вырасти кратно в доходе и роли</li>
                        <li class="position-relative"><span>«Нетворкинг для карьеры и жизни»,</span> чтобы растить полезное и нетоксичное окружение</li>
                    </ul>
                    <ul class="hidden-desc">
                        <li class="position-relative"><span>«Продающее резюме»</span></li>
                        <li class="position-relative"><span>«Международная карьера и релокация»</span></li>
                        <li class="position-relative"><span>«Карьера в кризис: как найти и не потерять работу»</span></li>
                        <li class="position-relative"><span>«Great Deal: как получить оффер мечты»</span></li>
                        <li class="position-relative"><span>«Пробейте карьерный потолок»</span></li>
                        <li class="position-relative"><span>«Нетворкинг для карьеры и жизни»</span></li>
                    </ul>
                    <div class="careerum-flex-fsc">
                        <p class="sert-single-right-price">14 900 ₽</p>
                        <div class="careerum-flex-fsc">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1734506477829-4lRJG-Lock.svg" alt="" class="hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1734508324144-nYhBZ-Lock.svg" alt="" class="hidden-desc">
                            <p class="sert-single-right-price-dscr">Доступ на 90 дней</p>
                        </div>
                    </div>
                    <a href="#buy" class="btn-color-main-dark-orange">Купить</a>
                </div>
            </div>  
        </div>`
	});
    
    blockManager.add('careerum-consultations-main', {
        label: 'Страница консультаций главный',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-consultations-main">
            <div>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1701770933315.svg" alt="">
                <div class="careerum-consultations-main-header">
                    <h1>Индивидуальные консультации </h1>
                    <p>Поможем с любым карьерным вопросом</p>
                    <a href="#club2-solo-eur" class="btn-color-main-dark-orange">Купить консультацию</a>
                </div>
                <div class="careerum-consultations-main-descr">
                    <div class="careerum-consultations-main-about">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1701765889724.png" alt="">
                        <div><p>Виктория, коуч Careerum</p></div>
                    </div>
                    <div class="careerum-consultations-main-about-bottom">
                        <div>
                            <p>Получите персональную поддержку специалиста, который обладает экспертизой именно в вашей теме
                            </p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1701766044421.svg" alt="">
                        </div>
                        <div>
                            <p>Освоите инструменты и алгоритмы достижения цели и научитесь пользоваться ими в любой
                                карьерной ситуации</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1701766022873.svg" alt="">
                        </div>
                        <div>
                            <p>Совместно со специалистом составите стратегию достижения результата, опираясь на ваши желания
                                и сильные стороны</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1701766028434.svg" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-consultations-main-tablet', {
        label: 'Страница консультаций главный (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-consultations-main-tablet">
            <div>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1701806130354.png" alt="">
                <div class="careerum-consultations-main-top">
                    <div class="careerum-consultations-main-header">
                        <h1>Индивидуальные консультации </h1>
                        <p>Поможем с любым<br> карьерным вопросом</p>
                    </div>
                    <div class="careerum-consultations-main-descr">
                        <div class="careerum-consultations-main-about">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1701765889724.png" alt="">
                            <div><p>Виктория, коуч Careerum</p></div>
                        </div>
                    </div>
                </div>
                <div class="careerum-consultations-main-bottom">
                    <div>
                        <p>Освоите инструменты и алгоритмы достижения цели и научитесь пользоваться ими в любой
                            карьерной ситуации</p>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1701766022873.svg" alt="">
                    </div>
                    <div>
                        <p>Получите персональную поддержку специалиста, который обладает экспертизой именно в вашей теме
                        </p>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1701766044421.svg" alt="">
                    </div>
                    <div>
                        <p>Совместно<br> со специалистом составите стратегию достижения результата, опираясь на ваши желания
                            и сильные стороны</p>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1701766028434.svg" alt="">
                    </div>
                </div>
                <div class="careerum-consultations-main-link">
                    <a href="#club2-solo-eur" class="btn-color-main-dark-orange">Купить консультацию</a>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-consultations-main-mobile', {
        label: 'Страница консультаций главный (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-consultations-main-mobile">
            <div>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1701791890641.png" alt="">
                <div class="careerum-consultations-main-top">
                    <div class="careerum-consultations-main-header">
                        <h1>Индивидуальные консультации </h1>
                        <p>Поможем с любым<br> карьерным вопросом</p>
                    </div>
                    <div class="careerum-consultations-main-descr">
                        <div class="careerum-consultations-main-about">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1701765889724.png" alt="">
                            <div><p>Виктория, коуч Careerum</p></div>
                        </div>
                    </div>
                </div>
                <div class="careerum-consultations-main-bottom">
                    <div>
                        <p>Освоите инструменты и алгоритмы достижения цели и научитесь пользоваться ими в любой
                            карьерной ситуации</p>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1701766022873.svg" alt="">
                    </div>
                    <div>
                        <p>Получите персональную поддержку специалиста, который обладает экспертизой именно в вашей теме
                        </p>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1701766044421.svg" alt="">
                    </div>
                    <div>
                        <p>Совместно со специалистом составите стратегию достижения результата, опираясь на ваши желания
                            и сильные стороны</p>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1701766028434.svg" alt="">
                    </div>
                </div>
                <div class="careerum-consultations-main-link">
                    <a href="#club2-solo-eur" class="btn-color-main-dark-orange">Купить консультацию</a>
                </div>
            </div>
        </div>`
	});
    
    blockManager.add('careerum-consultations-goals', {
        label: 'Страница консультаций табы (3 экрана)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-consultations-goals">
            <div>
                <div class="careerum-consultations-goals-header">
                    <p>Выберите свою карьерную цель</p>
                </div>
                <div class="careerum-consultations-goals-tabs-nav">
                    <ul>
                        <li>Понять, куда двигаться</li>
                        <li class="active">Найти работу</li>
                        <li>Улучшить резюме</li>
                        <li>Усилить сопроводительное письмо</li>
                        <li>Усовершенствовать профиль LinkedIn</li>
                        <li>Подготовиться к интервью</li>
                        <li>Поставить карьерную цель</li>
                        <li>Расти на рабочем месте</li>
                        <li>Повысить доход</li>
                        <li>Адаптироваться на новой работе</li>
                        <li>Найти внутренние ресурсы</li>
                        <li>Найти life-work balance</li>
                    </ul>
                </div>
                <div class="careerum-consultations-goals-tabs-wrapper">
                    <div class="careerum-consultations-goals-tab active" data-name="Понять, куда двигаться">
                        <div class="careerum-consultations-goals-tab-name">
                            <p>Найти работу</p>
                        </div>
                        <div class="careerum-consultations-goals-tab-header">
                            <p>На сессии с коучем вы сможете проработать один запрос, связанный с поиском работы.
                                Например:</p>
                        </div>
                        <div class="careerum-consultations-goals-tab-content">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1701766022874.svg" alt="">
                                <p>определить, что мешает вам найти работу</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1701773091316.svg" alt="">
                                <p>построить стратегию поиска работы</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1701773100161.svg" alt="">
                                <p>сформулировать личные критерии по выбору страны для&nbsp;релокации</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1701773106359.svg" alt="">
                                <p>составить план действий для&nbsp;улучшения поиска</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1701773110491.svg" alt="">
                                <p>проанализировать эффективность процесса поиска работы на всех этапах</p>
                            </div>
                        </div>
                    </div>
                    <div class="careerum-consultations-goals-tab" data-name="Понять, куда двигаться">
                        <div class="careerum-consultations-goals-tab-name">
                            <p>Найти работу</p>
                        </div>
                        <div class="careerum-consultations-goals-tab-header">
                            <p>На сессии с коучем вы сможете проработать один<br> запрос, связанный с поиском работы.
                                Например:</p>
                        </div>
                        <div class="careerum-consultations-goals-tab-content">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1701766022874.svg" alt="">
                                <p>определить, что мешает вам найти работу</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1701773091316.svg" alt="">
                                <p>построить стратегию поиска работы</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1701773100161.svg" alt="">
                                <p>сформулировать личные критерии по выбору страны для&nbsp;релокации</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1701773106359.svg" alt="">
                                <p>составить план действий для&nbsp;улучшения поиска</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1701773110491.svg" alt="">
                                <p>проанализировать эффективность процесса поиска работы на всех этапах</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="careerum-consultations-goals-tabs-bottom">
                    <p>На одной сессии вы сможете разобрать один запрос, на 3 — три на 5 — пять</p>
                </div>
                <div class="careerum-consultations-goals-tabs-link">
                    <a href="#" class="btn-color-main-dark-orange">Купить консультацию</a>
                </div>
            </div>
        </div>`
	});
    
    blockManager.add('careerum-consultations-about', {
        label: 'Страница консультаций about',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-consultations-about">
            <div>
                <div class="careerum-consultations-about-header">
                    <p>Как работают консультации</p>
                </div>
                <div class="careerum-consultations-about-content">
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1701775637829.svg" alt="">
                        <p>Консультации проходят онлайн в удобное для вас время. </p>
                        <p>Каждая консультация длится 50 минут</p>
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1701775637828.svg" alt="">
                        <p>Консультации помогут глубоко проработать ваш карьерный запрос</p>
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1701775637822.svg" alt="">
                        <p>Вы получите не просто готовые рекомендации, а вместе с экспертом найдете разные пути решений
                            и выберете самое лучшее именно для вас</p>
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1701775637821.svg" alt="">
                        <p>Вы будете строить карьеру мечты через интерес и удовольствие, не через напряжение</p>
                    </div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-consultations-about-tablet', {
        label: 'Страница консультаций about (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-consultations-about-tablet">
            <div>
                <div class="careerum-consultations-about-header">
                    <p>Как работают консультации</p>
                </div>
                <div class="careerum-consultations-about-content">
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1701775637829.svg" alt="">
                        <p>Консультации проходят онлайн в удобное для вас время. </p>
                        <p>Каждая консультация длится 50 минут</p>
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1701775637828.svg" alt="">
                        <p>Консультации помогут глубоко проработать ваш карьерный запрос</p>
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1701775637822.svg" alt="">
                        <p>Вы получите не просто готовые рекомендации, а вместе с экспертом найдете разные пути решений
                            и выберете самое лучшее именно для вас</p>
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1701775637821.svg" alt="">
                        <p>Вы будете строить карьеру мечты через интерес и удовольствие, не через напряжение</p>
                    </div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-consultations-about-mobile', {
        label: 'Страница консультаций about (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-consultations-about-mobile">
            <div>
                <div class="careerum-consultations-about-header">
                    <p>Как работают консультации</p>
                </div>
                <div class="careerum-consultations-about-content careerum-consultations-slider">
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1701775637829.svg" alt="">
                        <p>Консультации проходят онлайн в удобное для вас время. </p>
                        <p>Каждая консультация длится 50 минут</p>
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1701775637828.svg" alt="">
                        <p>Консультации помогут глубоко проработать ваш карьерный запрос</p>
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1701775637822.svg" alt="">
                        <p>Вы получите не просто готовые рекомендации, а вместе с экспертом найдете разные пути решений
                            и выберете самое лучшее именно для вас</p>
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1701775637821.svg" alt="">
                        <p>Вы будете строить карьеру мечты через интерес и удовольствие, не через напряжение</p>
                    </div>
                </div>
                <div class="consultations-about-slider__arrow-right">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 18 16" fill="none">
                        <path d="M15.8095 8.00065L2.18945 8.00065" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M9.53711 1.75471L15.8104 8.00138L9.53711 14.248" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                </div>
            </div>
        </div>`
	});
    
    blockManager.add('careerum-header30', {
        label: 'Клуб 3,0 хэдер',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <header class="careerum-header30 header-promo">
            <div class="careerum-header30-main">
                <div class="careerum-header30-main-logo">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1702397727291.svg" alt="">
                </div>
                <nav>
                    <a href="#">Club</a>
                    <a href="#">Cертификаты</a>
                    <a href="#">Консультации</a>
                    <a href="#">Результаты</a>
                    <a href="#">О нас</a>
                </nav>
                <div class="careerum-header30-main-button">
                    <a href="#" class="btn-color-new-light-blue">Войти</a>
                </div>
                <div class="careerum-header30-main-mobile-button">
                    <span>
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="10" viewBox="0 0 16 10" fill="none">
                            <path d="M1 1.03052L8.00003 1.02778L15.0001 1.03052" stroke="#B2B2B2" stroke-width="1.25"
                                stroke-linecap="round" />
                            <path d="M1 5.03052L8.00003 5.02778L15.0001 5.03052" stroke="#B2B2B2" stroke-width="1.25"
                                stroke-linecap="round" />
                            <path d="M1 9.03052L8.00003 9.02778L15.0001 9.03052" stroke="#B2B2B2" stroke-width="1.25"
                                stroke-linecap="round" />
                        </svg>
                    </span>
                    <span>
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <path d="M5.05127 14.9507L9.9991 9.99898L14.9508 5.05115" stroke="#B2B2B2" stroke-width="1.25"
                                stroke-linecap="round" />
                            <path d="M5.04944 5.05103L10.0011 9.99886L14.949 14.9506" stroke="#B2B2B2" stroke-width="1.25"
                                stroke-linecap="round" />
                        </svg>
                    </span>
                </div>
                <div class="careerum-header30-main-mobile-block">
                    <nav>
                        <a href="#">Careerum.Club</a>
                        <a href="#">Подарочные сертификаты</a>
                        <a href="#">Консультации</a>
                        <a href="#">Результаты участников</a>
                        <a href="#">О нас</a>
                    </nav>
                    <div class="careerum-header30-main-button">
                        <a href="#" class="btn-color-new-light-blue">Войти</a>
                    </div>
                </div>
            </div>
            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1702479388922.png" alt="" class="careerum-header30-promo-img-desctop">
            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1702479450990.png" alt="" class="careerum-header30-promo-img-mobile">
            <div class="careerum-header30-promo">
                <div>
                    <a href="#buy">
                        <p>Cкидка 15% для первых 100 человек! Успейте&nbsp;активировать промокод <span>NOVEMBER15</span></p>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1702398337783.svg" alt="">
                    </a>
                </div>
            </div>
        </header>`
	});
    
    blockManager.add('careerum-club30-main', {
        label: 'Клуб 3,0 главный',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <section class="careerum-club30-main">
            <div class="careerum-club30-main-left">
                <div class="careerum-club30-main-header">
                    <p>Постройте карьеру по своим правилам</p>
                </div>
                <div class="careerum-club30-block-text">
                    <p>с помощью образовательной платформы специалисты помогут достичь
                        ваших целей</p>
                </div>
                <a href="#" class="btn-color-main-black">Вступить в клуб</a>
            </div>
            <div class="careerum-club30-main-slider">
                <div class="careerum-club30-main-slider-wrapper">
                    <div class="careerum-club30-main-slider-item">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1702479492533.png" alt="" class="careerum-club30-main-slider-desctop">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1702479521213.png" alt="" class="careerum-club30-main-slider-tablet">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1702479563733.png" alt="" class="careerum-club30-main-slider-mobile">
                    </div>
                    <div class="careerum-club30-main-slider-item">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1702479492533.png" alt="" class="careerum-club30-main-slider-desctop">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1702479521213.png" alt="" class="careerum-club30-main-slider-tablet">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1702479563733.png" alt="" class="careerum-club30-main-slider-mobile">
                    </div>
                    <div class="careerum-club30-main-slider-item">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1702479492533.png" alt="" class="careerum-club30-main-slider-desctop">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1702479521213.png" alt="" class="careerum-club30-main-slider-tablet">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1702479563733.png" alt="" class="careerum-club30-main-slider-mobile">
                    </div>
                </div>
            </div>
            <div class="careerum-club30-main-bottom">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1702927948835.png" alt="">
            </div>
        </section>`
	});
    
    blockManager.add('careerum-club30-reasons', {
        label: 'Клуб 3,0 поможем',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <section class="careerum-club30-reasons">
            <div class="careerum-club30-block-header">
                <p>Поможем, если у вас</p>
            </div>
            <div class="careerum-club30-reasons-content">
                <div class="careerum-club30-reasons-accordeon">
                    <div class="careerum-club30-reasons-accordeon-item active" data-image="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1702479592487.png">
                        <div class="careerum-club30-reasons-accordeon-item-header">
                            <p>Выгорание</p>
                        </div>
                        <div class="careerum-club30-reasons-accordeon-item-content">
                            <ul>
                                <li>Кажется, что в последнее время карьеру стало строить сложнее, а&nbsp;кризисы выбивают из
                                    сил</li>
                                <li>Регулярно выгораете, уходите в&nbsp;другое место/творческий отпуск</li>
                                <li>Берете на себя кучу проектов и&nbsp;ждете, что коллеги сами заметят и оценят результаты
                                </li>
                            </ul>
                            <a href="">Смотреть программу</a>
                        </div>
                    </div>
                    <div class="careerum-club30-reasons-accordeon-item" data-image="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1702479592487.png">
                        <div class="careerum-club30-reasons-accordeon-item-header">
                            <p>Эмиграция</p>
                        </div>
                        <div class="careerum-club30-reasons-accordeon-item-content">
                            <ul>
                                <li>Впервые ищете работу
                                    или выходите на первую рольв чужой стране</li>
                                <li>Классно справляетесь
                                    с задачами, но повышают обычно не вас</li>
                                <li>Более 3 месяцев ищете работу, а откликов мало, да и вакансии не радуют</li>
                            </ul>
                            <a href="">Смотреть программу</a>
                        </div>
                    </div>
                    <div class="careerum-club30-reasons-accordeon-item" data-image="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1702479592487.png">
                        <div class="careerum-club30-reasons-accordeon-item-header">
                            <p>Сомнения</p>
                        </div>
                        <div class="careerum-club30-reasons-accordeon-item-content">
                            <ul>
                                <li>Кажется, что в последнее время карьеру стало строить сложнее, а кризисы выбивают из сил
                                </li>
                                <li>Регулярно выгораете, уходите в другое место/творческий отпуск</li>
                                <li>Берте на себя кучу проектов и ждете, что коллеги сами заметят и оценят результаты</li>
                            </ul>
                            <a href="">Смотреть программу</a>
                        </div>
                    </div>
                </div>
                <div class="careerum-club30-reasons-image-container">
                    <div class="careerum-club30-reasons-image"></div>
                </div>
            </div>
        </section>`
	});
    
    blockManager.add('careerum-club30-goals', {
        label: 'Клуб 3,0 цели',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <section class="careerum-club30-goals">
            <div class="careerum-club30-block-header">
                <p>Лучшие программы под ваши цели</p>
            </div>
            <div class="careerum-club30-goals-content">
                <div class="careerum-club30-goals-nav">
                    <ul>
                    </ul>
                    <div class="careerum-club30-goals-tab-score">
                        <p class="careerum-club30-goals-tab-score-top">4,8/5</p>
                        <p class="careerum-club30-goals-tab-score-bottom">оценка<br>участников</p>
                    </div>
                </div>
                <div class="careerum-club30-goals-tabs">
                    <div class="careerum-club30-goals-tab" data-name="Найти работу по душе" data-val="4,6/5">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1702479649117.png" alt="" class="careerum-club30-goals-tab-img-desctop">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1702479675626.png" alt="" class="careerum-club30-goals-tab-img-tablet">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1702479768753.png" alt="" class="careerum-club30-goals-tab-img-mobile">
                        <div class="careerum-club30-goals-tab-meta">
                            <p>Домашние задания</p>
                            <p>Уроки 5–30 мин</p>
                        </div>
                        <div class="careerum-club30-goals-tab-header">
                            <p>Real Me: как найти себя<br> в работе и жизни</p>
                        </div>
                        <ul>
                            <li>Раскроете свои сильные стороны и мотивацию</li>
                            <li>Поймете в какой сфере вам комфортно</li>
                            <li>Соотнесете ваши ценности с запросами рынка</li>
                        </ul>
                        <a href="#" class="btn-color-main-black">Вступить в клуб</a>
                    </div>
                    <div class="careerum-club30-goals-tab" data-name="Получить оффер мечты" data-val="4,8/5">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1702479649117.png" alt="" class="careerum-club30-goals-tab-img-desctop">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1702479675626.png" alt="" class="careerum-club30-goals-tab-img-tablet">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1702479768753.png" alt="" class="careerum-club30-goals-tab-img-mobile">
                        <div class="careerum-club30-goals-tab-meta">
                            <p>Домашние задания</p>
                            <p>Уроки 5–30 мин</p>
                        </div>
                        <div class="careerum-club30-goals-tab-header">
                            <p>Real Me: как найти себя<br> в работе и жизни</p>
                        </div>
                        <ul>
                            <li>Раскроете свои сильные стороны и мотивацию</li>
                            <li>Поймете в какой сфере вам комфортно</li>
                            <li>Соотнесете ваши ценности с запросами рынка</li>
                        </ul>
                        <a href="#" class="btn-color-main-black">Вступить в клуб</a>
                    </div>
                    <div class="careerum-club30-goals-tab" data-name="Пройти испытательный срок" data-val="4,8/5">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1702479649117.png" alt="" class="careerum-club30-goals-tab-img-desctop">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1702479675626.png" alt="" class="careerum-club30-goals-tab-img-tablet">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1702479768753.png" alt="" class="careerum-club30-goals-tab-img-mobile">
                        <div class="careerum-club30-goals-tab-meta">
                            <p>Домашние задания</p>
                            <p>Уроки 5–30 мин</p>
                        </div>
                        <div class="careerum-club30-goals-tab-header">
                            <p>Real Me: как найти себя<br> в работе и жизни</p>
                        </div>
                        <ul>
                            <li>Раскроете свои сильные стороны и мотивацию</li>
                            <li>Поймете в какой сфере вам комфортно</li>
                            <li>Соотнесете ваши ценности с запросами рынка</li>
                        </ul>
                        <a href="#" class="btn-color-main-black">Вступить в клуб</a>
                    </div>
                    <div class="careerum-club30-goals-tab" data-name="Вырасти в доходе или должности" data-val="4,8/5">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1702479649117.png" alt="" class="careerum-club30-goals-tab-img-desctop">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1702479675626.png" alt="" class="careerum-club30-goals-tab-img-tablet">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1702479768753.png" alt="" class="careerum-club30-goals-tab-img-mobile">
                        <div class="careerum-club30-goals-tab-meta">
                            <p>Домашние задания</p>
                            <p>Уроки 5–30 мин</p>
                        </div>
                        <div class="careerum-club30-goals-tab-header">
                            <p>Real Me: как найти себя<br> в работе и жизни</p>
                        </div>
                        <ul>
                            <li>Раскроете свои сильные стороны и мотивацию</li>
                            <li>Поймете в какой сфере вам комфортно</li>
                            <li>Соотнесете ваши ценности с запросами рынка</li>
                        </ul>
                        <a href="#" class="btn-color-main-black">Вступить в клуб</a>
                    </div>
                    <div class="careerum-club30-goals-tab" data-name="Переехать по работе" data-val="4,8/5">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1702479649117.png" alt="" class="careerum-club30-goals-tab-img-desctop">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1702479675626.png" alt="" class="careerum-club30-goals-tab-img-tablet">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1702479768753.png" alt="" class="careerum-club30-goals-tab-img-mobile">
                        <div class="careerum-club30-goals-tab-meta">
                            <p>Домашние задания</p>
                            <p>Уроки 5–30 мин</p>
                        </div>
                        <div class="careerum-club30-goals-tab-header">
                            <p>Real Me: как найти себя<br> в работе и жизни</p>
                        </div>
                        <ul>
                            <li>Раскроете свои сильные стороны и мотивацию</li>
                            <li>Поймете в какой сфере вам комфортно</li>
                            <li>Соотнесете ваши ценности с запросами рынка</li>
                        </ul>
                        <a href="#" class="btn-color-main-black">Вступить в клуб</a>
                    </div>
                    <div class="careerum-club30-goals-tab" data-name="Расти в кризис" data-val="4,8/5">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1702479649117.png" alt="" class="careerum-club30-goals-tab-img-desctop">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1702479675626.png" alt="" class="careerum-club30-goals-tab-img-tablet">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1702479768753.png" alt="" class="careerum-club30-goals-tab-img-mobile">
                        <div class="careerum-club30-goals-tab-meta">
                            <p>Домашние задания</p>
                            <p>Уроки 5–30 мин</p>
                        </div>
                        <div class="careerum-club30-goals-tab-header">
                            <p>Real Me: как найти себя<br> в работе и жизни</p>
                        </div>
                        <ul>
                            <li>Раскроете свои сильные стороны и мотивацию</li>
                            <li>Поймете в какой сфере вам комфортно</li>
                            <li>Соотнесете ваши ценности с запросами рынка</li>
                        </ul>
                        <a href="#" class="btn-color-main-black">Вступить в клуб</a>
                    </div>
                </div>
            </div>
        </section>`
	});
    
    blockManager.add('careerum-club30-tools', {
        label: 'Клуб 3,0 инструменты',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <section class="careerum-club30-tools">
            <div class="careerum-club30-block-header">
                <p>Результат за счет 3-х инструментов</p>
            </div>
            <div class="careerum-club30-tools-content">
                <div class="careerum-club30-tools-item">
                    <div class="careerum-club30-tools-item-header">
                        <p>Программа</p>
                    </div>
                    <div class="careerum-club30-block-text">
                        <p>покрывающая карьерный запрос</p>
                    </div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1702479809252.png" alt="" class="careerum-club30-tools-item-img-desctop">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1702479837630.png" alt="" class="careerum-club30-tools-item-img-tablet">
                </div>
                <div class="careerum-club30-tools-item">
                    <div class="careerum-club30-tools-item-header">
                        <p>Сообщество</p>
                    </div>
                    <div class="careerum-club30-block-text">
                        <p>1000 специалистов из 30+ стран</p>
                    </div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1702479863257.png" alt="" class="careerum-club30-tools-item-img-desctop">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1702479875678.png" alt="" class="careerum-club30-tools-item-img-tablet">
                </div>
                <div class="careerum-club30-tools-item">
                    <div class="careerum-club30-tools-item-header">
                        <p>Поддержка</p>
                    </div>
                    <div class="careerum-club30-block-text">
                        <p>опытных коучей и консультантов</p>
                    </div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1702479891829.png" alt="" class="careerum-club30-tools-item-img-desctop">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1702479904855.png" alt="" class="careerum-club30-tools-item-img-tablet">
                </div>
            </div>
            <div class="careerum-club30-tools-content-mobile">
                <div class="careerum-club30-tools-item">
                    <div class="careerum-club30-tools-item-header">
                        <p>Программа</p>
                    </div>
                    <div class="careerum-club30-block-text">
                        <p>покрывающая карьерный запрос</p>
                    </div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1702479809252.png" alt="" class="careerum-club30-tools-item-img-desctop">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1702479837630.png" alt="" class="careerum-club30-tools-item-img-tablet">
                </div>
                <div class="careerum-club30-tools-item">
                    <div class="careerum-club30-tools-item-header">
                        <p>Сообщество</p>
                    </div>
                    <div class="careerum-club30-block-text">
                        <p>1000 специалистов из 30+ стран</p>
                    </div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1702479863257.png" alt="" class="careerum-club30-tools-item-img-desctop">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1702479875678.png" alt="" class="careerum-club30-tools-item-img-tablet">
                </div>
                <div class="careerum-club30-tools-item">
                    <div class="careerum-club30-tools-item-header">
                        <p>Поддержка</p>
                    </div>
                    <div class="careerum-club30-block-text">
                        <p>опытных коучей и консультантов</p>
                    </div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1702479891829.png" alt="" class="careerum-club30-tools-item-img-desctop">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1702479904855.png" alt="" class="careerum-club30-tools-item-img-tablet">
                </div>
            </div>
        </section>`
	});
    
    blockManager.add('careerum-club30-authors', {
        label: 'Клуб 3,0 авторы',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <section class="careerum-club30-authors">
            <div class="careerum-club30-block-header">
                <p>30+ авторов — экспертов международного рынка</p>
                <div class="careerum-club30-authors-arrow-right">
                    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                        <path opacity="0.32"
                            d="M40 20C40 31.0452 31.0452 40 20 40C8.95481 40 0 31.0452 0 20C0 8.95481 8.95481 0 20 0C31.0452 0 40 8.95481 40 20ZM18.4615 12.299L24.575 18.4615H10.1923V21.5385H24.575L18.4615 27.701L20.6442 29.8683L30.4365 20L20.6442 10.1317L18.4615 12.299Z"
                            fill="black" />
                    </svg>
                </div>
            </div>
            <div class="careerum-club30-authors-content">
                <div class="careerum-club30-authors-content-wrapper">
                    <div class="careerum-club30-authors-content-item">
                        <div class="careerum-club30-authors-content-item-top">
                            <div>
                                <div class="careerum-club30-authors-content-item-name">
                                    <p>Sophie<br>Vurpillot</p>
                                </div>
                                <div class="careerum-club30-authors-content-item-position">
                                    <p>Рекрутер</p>
                                </div>
                                <div class="careerum-club30-authors-content-item-country">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"
                                        fill="none">
                                        <path
                                            d="M9 15.7501C12.7279 15.7501 15.75 12.728 15.75 9.00006C15.75 5.27214 12.7279 2.25006 9 2.25006C5.27208 2.25006 2.25 5.27214 2.25 9.00006C2.25 12.728 5.27208 15.7501 9 15.7501Z"
                                            stroke="#B2B2B2" stroke-width="1.25" stroke-linecap="round"
                                            stroke-linejoin="round" />
                                        <path d="M2.69995 6.75006H15.3" stroke="#B2B2B2" stroke-width="1.25"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M2.69995 11.2501H15.3" stroke="#B2B2B2" stroke-width="1.25"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                        <path
                                            d="M8.625 2.25006C7.3615 4.27477 6.69165 6.61346 6.69165 9.00006C6.69165 11.3867 7.3615 13.7253 8.625 15.7501"
                                            stroke="#B2B2B2" stroke-width="1.25" stroke-linecap="round"
                                            stroke-linejoin="round" />
                                        <path
                                            d="M9.375 2.25006C10.6385 4.27477 11.3083 6.61346 11.3083 9.00006C11.3083 11.3867 10.6385 13.7253 9.375 15.7501"
                                            stroke="#B2B2B2" stroke-width="1.25" stroke-linecap="round"
                                            stroke-linejoin="round" />
                                    </svg>
                                    <p>Италия</p>
                                </div>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1702479951765.png" alt="">
                            </div>
                        </div>
                        <div class="careerum-club30-block-text ">
                            <p>Занимала директорские роли в Google и Microsoft. Получила MBA в сингапурской бизнес-школе
                                INSEAD и основала Карьерум — крупнейшую в России и СНГ платформу карьерного развития.</p>
                        </div>
                        <div class="careerum-club30-authors-content-item-bottom">
                            <p>Автор курсов «Цели как в Google. Результаты как в Forbes» и «Первые месяцы на новой работе».
                            </p>
                        </div>
                    </div>
                    <div class="careerum-club30-authors-content-item">
                        <div class="careerum-club30-authors-content-item-top">
                            <div>
                                <div class="careerum-club30-authors-content-item-name">
                                    <p>Ольга<br>Лермонтова</p>
                                </div>
                                <div class="careerum-club30-authors-content-item-position">
                                    <p>CEO Карьерум</p>
                                </div>
                                <div class="careerum-club30-authors-content-item-country">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"
                                        fill="none">
                                        <path
                                            d="M9 15.7501C12.7279 15.7501 15.75 12.728 15.75 9.00006C15.75 5.27214 12.7279 2.25006 9 2.25006C5.27208 2.25006 2.25 5.27214 2.25 9.00006C2.25 12.728 5.27208 15.7501 9 15.7501Z"
                                            stroke="#B2B2B2" stroke-width="1.25" stroke-linecap="round"
                                            stroke-linejoin="round" />
                                        <path d="M2.69995 6.75006H15.3" stroke="#B2B2B2" stroke-width="1.25"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M2.69995 11.2501H15.3" stroke="#B2B2B2" stroke-width="1.25"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                        <path
                                            d="M8.625 2.25006C7.3615 4.27477 6.69165 6.61346 6.69165 9.00006C6.69165 11.3867 7.3615 13.7253 8.625 15.7501"
                                            stroke="#B2B2B2" stroke-width="1.25" stroke-linecap="round"
                                            stroke-linejoin="round" />
                                        <path
                                            d="M9.375 2.25006C10.6385 4.27477 11.3083 6.61346 11.3083 9.00006C11.3083 11.3867 10.6385 13.7253 9.375 15.7501"
                                            stroke="#B2B2B2" stroke-width="1.25" stroke-linecap="round"
                                            stroke-linejoin="round" />
                                    </svg>
                                    <p>Италия</p>
                                </div>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1702479971174.png" alt="">
                            </div>
                        </div>
                        <div class="careerum-club30-block-text">
                            <p>Занимала директорские роли в Google и Microsoft. Получила MBA в сингапурской бизнес-школе
                                INSEAD и основала Карьерум — крупнейшую в России и СНГ платформу карьерного развития.</p>
                        </div>
                        <div class="careerum-club30-authors-content-item-bottom">
                            <p>Автор курсов «Цели как в Google. Результаты как в Forbes» и «Первые месяцы на новой работе».
                            </p>
                        </div>
                    </div>
                    <div class="careerum-club30-authors-content-item">
                        <div class="careerum-club30-authors-content-item-top">
                            <div>
                                <div class="careerum-club30-authors-content-item-name">
                                    <p>Елена<br>Резанова</p>
                                </div>
                                <div class="careerum-club30-authors-content-item-position">
                                    <p>Карьерный стратег</p>
                                </div>
                                <div class="careerum-club30-authors-content-item-country">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"
                                        fill="none">
                                        <path
                                            d="M9 15.7501C12.7279 15.7501 15.75 12.728 15.75 9.00006C15.75 5.27214 12.7279 2.25006 9 2.25006C5.27208 2.25006 2.25 5.27214 2.25 9.00006C2.25 12.728 5.27208 15.7501 9 15.7501Z"
                                            stroke="#B2B2B2" stroke-width="1.25" stroke-linecap="round"
                                            stroke-linejoin="round" />
                                        <path d="M2.69995 6.75006H15.3" stroke="#B2B2B2" stroke-width="1.25"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M2.69995 11.2501H15.3" stroke="#B2B2B2" stroke-width="1.25"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                        <path
                                            d="M8.625 2.25006C7.3615 4.27477 6.69165 6.61346 6.69165 9.00006C6.69165 11.3867 7.3615 13.7253 8.625 15.7501"
                                            stroke="#B2B2B2" stroke-width="1.25" stroke-linecap="round"
                                            stroke-linejoin="round" />
                                        <path
                                            d="M9.375 2.25006C10.6385 4.27477 11.3083 6.61346 11.3083 9.00006C11.3083 11.3867 10.6385 13.7253 9.375 15.7501"
                                            stroke="#B2B2B2" stroke-width="1.25" stroke-linecap="round"
                                            stroke-linejoin="round" />
                                    </svg>
                                    <p>Италия</p>
                                </div>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1702479991059.png" alt="">
                            </div>
                        </div>
                        <div class="careerum-club30-block-text">
                            <p>Занимала директорские роли в Google и Microsoft. Получила MBA в сингапурской бизнес-школе
                                INSEAD и основала Карьерум — крупнейшую в России и СНГ платформу карьерного развития.</p>
                        </div>
                        <div class="careerum-club30-authors-content-item-bottom">
                            <p>Автор курсов «Цели как в Google. Результаты как в Forbes» и «Первые месяцы на новой работе».
                            </p>
                        </div>
                    </div>
                    <div class="careerum-club30-authors-content-item">
                        <div class="careerum-club30-authors-content-item-top">
                            <div>
                                <div class="careerum-club30-authors-content-item-name">
                                    <p>Sophie<br>Vurpillot</p>
                                </div>
                                <div class="careerum-club30-authors-content-item-position">
                                    <p>Рекрутер</p>
                                </div>
                                <div class="careerum-club30-authors-content-item-country">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"
                                        fill="none">
                                        <path
                                            d="M9 15.7501C12.7279 15.7501 15.75 12.728 15.75 9.00006C15.75 5.27214 12.7279 2.25006 9 2.25006C5.27208 2.25006 2.25 5.27214 2.25 9.00006C2.25 12.728 5.27208 15.7501 9 15.7501Z"
                                            stroke="#B2B2B2" stroke-width="1.25" stroke-linecap="round"
                                            stroke-linejoin="round" />
                                        <path d="M2.69995 6.75006H15.3" stroke="#B2B2B2" stroke-width="1.25"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M2.69995 11.2501H15.3" stroke="#B2B2B2" stroke-width="1.25"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                        <path
                                            d="M8.625 2.25006C7.3615 4.27477 6.69165 6.61346 6.69165 9.00006C6.69165 11.3867 7.3615 13.7253 8.625 15.7501"
                                            stroke="#B2B2B2" stroke-width="1.25" stroke-linecap="round"
                                            stroke-linejoin="round" />
                                        <path
                                            d="M9.375 2.25006C10.6385 4.27477 11.3083 6.61346 11.3083 9.00006C11.3083 11.3867 10.6385 13.7253 9.375 15.7501"
                                            stroke="#B2B2B2" stroke-width="1.25" stroke-linecap="round"
                                            stroke-linejoin="round" />
                                    </svg>
                                    <p>Италия</p>
                                </div>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1702479951765.png" alt="">
                            </div>
                        </div>
                        <div class="careerum-club30-block-text ">
                            <p>Занимала директорские роли в Google и Microsoft. Получила MBA в сингапурской бизнес-школе
                                INSEAD и основала Карьерум — крупнейшую в России и СНГ платформу карьерного развития.</p>
                        </div>
                        <div class="careerum-club30-authors-content-item-bottom">
                            <p>Автор курсов «Цели как в Google. Результаты как в Forbes» и «Первые месяцы на новой работе».
                            </p>
                        </div>
                    </div>
                    <div class="careerum-club30-authors-content-item">
                        <div class="careerum-club30-authors-content-item-top">
                            <div>
                                <div class="careerum-club30-authors-content-item-name">
                                    <p>Ольга<br>Лермонтова</p>
                                </div>
                                <div class="careerum-club30-authors-content-item-position">
                                    <p>CEO Карьерум</p>
                                </div>
                                <div class="careerum-club30-authors-content-item-country">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"
                                        fill="none">
                                        <path
                                            d="M9 15.7501C12.7279 15.7501 15.75 12.728 15.75 9.00006C15.75 5.27214 12.7279 2.25006 9 2.25006C5.27208 2.25006 2.25 5.27214 2.25 9.00006C2.25 12.728 5.27208 15.7501 9 15.7501Z"
                                            stroke="#B2B2B2" stroke-width="1.25" stroke-linecap="round"
                                            stroke-linejoin="round" />
                                        <path d="M2.69995 6.75006H15.3" stroke="#B2B2B2" stroke-width="1.25"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M2.69995 11.2501H15.3" stroke="#B2B2B2" stroke-width="1.25"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                        <path
                                            d="M8.625 2.25006C7.3615 4.27477 6.69165 6.61346 6.69165 9.00006C6.69165 11.3867 7.3615 13.7253 8.625 15.7501"
                                            stroke="#B2B2B2" stroke-width="1.25" stroke-linecap="round"
                                            stroke-linejoin="round" />
                                        <path
                                            d="M9.375 2.25006C10.6385 4.27477 11.3083 6.61346 11.3083 9.00006C11.3083 11.3867 10.6385 13.7253 9.375 15.7501"
                                            stroke="#B2B2B2" stroke-width="1.25" stroke-linecap="round"
                                            stroke-linejoin="round" />
                                    </svg>
                                    <p>Италия</p>
                                </div>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1702479971174.png" alt="">
                            </div>
                        </div>
                        <div class="careerum-club30-block-text">
                            <p>Занимала директорские роли в Google и Microsoft. Получила MBA в сингапурской бизнес-школе
                                INSEAD и основала Карьерум — крупнейшую в России и СНГ платформу карьерного развития.</p>
                        </div>
                        <div class="careerum-club30-authors-content-item-bottom">
                            <p>Автор курсов «Цели как в Google. Результаты как в Forbes» и «Первые месяцы на новой работе».
                            </p>
                        </div>
                    </div>
                    <div class="careerum-club30-authors-content-item">
                        <div class="careerum-club30-authors-content-item-top">
                            <div>
                                <div class="careerum-club30-authors-content-item-name">
                                    <p>Елена<br>Резанова</p>
                                </div>
                                <div class="careerum-club30-authors-content-item-position">
                                    <p>Карьерный стратег</p>
                                </div>
                                <div class="careerum-club30-authors-content-item-country">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"
                                        fill="none">
                                        <path
                                            d="M9 15.7501C12.7279 15.7501 15.75 12.728 15.75 9.00006C15.75 5.27214 12.7279 2.25006 9 2.25006C5.27208 2.25006 2.25 5.27214 2.25 9.00006C2.25 12.728 5.27208 15.7501 9 15.7501Z"
                                            stroke="#B2B2B2" stroke-width="1.25" stroke-linecap="round"
                                            stroke-linejoin="round" />
                                        <path d="M2.69995 6.75006H15.3" stroke="#B2B2B2" stroke-width="1.25"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M2.69995 11.2501H15.3" stroke="#B2B2B2" stroke-width="1.25"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                        <path
                                            d="M8.625 2.25006C7.3615 4.27477 6.69165 6.61346 6.69165 9.00006C6.69165 11.3867 7.3615 13.7253 8.625 15.7501"
                                            stroke="#B2B2B2" stroke-width="1.25" stroke-linecap="round"
                                            stroke-linejoin="round" />
                                        <path
                                            d="M9.375 2.25006C10.6385 4.27477 11.3083 6.61346 11.3083 9.00006C11.3083 11.3867 10.6385 13.7253 9.375 15.7501"
                                            stroke="#B2B2B2" stroke-width="1.25" stroke-linecap="round"
                                            stroke-linejoin="round" />
                                    </svg>
                                    <p>Италия</p>
                                </div>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1702479991059.png" alt="">
                            </div>
                        </div>
                        <div class="careerum-club30-block-text">
                            <p>Занимала директорские роли в Google и Microsoft. Получила MBA в сингапурской бизнес-школе
                                INSEAD и основала Карьерум — крупнейшую в России и СНГ платформу карьерного развития.</p>
                        </div>
                        <div class="careerum-club30-authors-content-item-bottom">
                            <p>Автор курсов «Цели как в Google. Результаты как в Forbes» и «Первые месяцы на новой работе».
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>`
	});
    
    blockManager.add('careerum-club30-subscribe', {
        label: 'Клуб 3,0 форма',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-club30-subscribe">
            <div class="careerum-club30-subscribe-left">
                <div class="careerum-club30-block-header">
                    <p>С нами достигают<br>целей специалисты</p>
                </div>
                <div class="careerum-club30-block-text">
                    <p>из разных профессий, стран и индустрий</p>
                </div>
                <div class="careerum-club30-subscribe-left-words">
                    <div class="careerum-club30-subscribe-left-words-wrapper">
                        <p>Дизайнеры</p>
                        <p>Медицина</p>
                        <p>Образование</p>
                        <p>Продакты</p>
                        <p>Менеджеры</p>
                        <p>IT</p>
                        <p>Дизайнеры</p>
                        <p>Медицина</p>
                        <p>Образование</p>
                        <p>Продакты</p>
                        <p>Менеджеры</p>
                        <p>IT</p>
                        <p>Дизайнеры</p>
                        <p>Медицина</p>
                        <p>Образование</p>
                        <p>Продакты</p>
                        <p>IT</p>
                        <p>Продакты</p>
                        <p>Менеджеры</p>
                        <p>Медицина</p>
                        <p>Дизайнеры</p>
                        <p>IT</p>
                    </div>
                </div>
            </div>
            <div class="careerum-club30-subscribe-right careerum-form-lead">
                <div class="careerum-club30-subscribe-right-header">
                    <p>Забронируйте место</p>
                </div>
                <div class="careerum-club30-block-text">
                    <p>Пригласим вас, как только<br>откроется запись</p>
                </div>
                <div class="careerum-club30-subscribe-right-header block-element-thanks">
                    <p>Первый шаг к карьере<br />мечты сделан</p>
                </div>
                <div class="careerum-club30-block-text block-element-thanks">
                    <p>Вы получите письмо с приглашением<br />на интересующий тариф раньше всех!</p>
                </div>
                <div class="careerum-club30-subscribe-right-form">
                    <div class="careerum-registration-form">
                        <form class="deva-form getcourse-email-signup" name="devaRegistrationForm"
                            data-gjs-type="deva-registration-form">
                            <div>
                                <div class="careerum-club30-form-name">
                                    <input type="text" name="name" value="" placeholder="Имя Фамилия" required>
                                </div>
                                <div class="careerum-club30-form-email">
                                    <input type="email" name="email" value="" placeholder="Почта " required>
                                </div>
                                <div class="careerum-club30-form-tel">
                                    <input value="">
                                </div>
                            </div>
                            <a href="#" disabled class="submit-btn btn-desc btn-color-main-black">Забронировать</a>
                            <input type="hidden" name="firstname">
                            <input type="hidden" name="lastname">
                        </form>
                    </div>
                    <div class="careerum-club30-subscribe-right-form-agree">
                        <p>Нажимая на кнопку вы даете согласие на обработку своих персональных данных в соответствии с <a
                                href="">Политикой конфиденциальности</a></p>
                    </div>
                </div>
            </div>
        </div>`
	});
    
    blockManager.add('careerum-footer30', {
        label: 'Клуб 3,0 футер',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <footer class="careerum-footer30">
            <div class="careerum-footer30-main">
                <div>
                    <div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1702480019056.svg" alt="">
                        </div>
                        <div class="careerum-club30-footer-text">
                            <p>© Careerum 2023<br>Все права защищены</p>
                        </div>
                    </div>
                    <div>
                        <ul>
                            <li><a href="">Careerum.Club</a></li>
                            <li><a href="">Личные консультации</a></li>
                            <li><a href="">Careerum.Tips</a></li>
                            <li><a href="">Телеграм-бот</a></li>
                        </ul>
                    </div>
                    <div>
                        <ul>
                            <li><a href="">О нас</a></li>
                            <li><a href="">Вакансии</a></li>
                            <li><a href="">FAQ</a></li>
                        </ul>
                    </div>
                    <div class="careerum-footer30-social-block">
                        <div class="careerum-footer30-social-header">
                            <p>Мы в соцсетях</p>
                        </div>
                        <div class="careerum-footer30-social">
                            <a href=""><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1702412280517.svg"
                                    alt=""></a>
                            <a href=""><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1702412332524.svg"
                                    alt=""></a>
                            <a href=""><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1702412366173.svg"
                                    alt=""></a>
                            <a href=""><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1702412392583.svg"
                                    alt=""></a>
                        </div>
                    </div>
                    <div>
                        <div class="careerum-footer30-social-header">
                            <p>Связаться с нами</p>
                        </div>
                        <div class="careerum-footer30-social">
                            <a href=""><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1702412426235.svg"
                                    alt=""></a>
                            <a href=""><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1702412444791.svg"
                                    alt=""></a>
                            <a href=""><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1702412489665.svg"
                                    alt=""></a>
                            <a href=""><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1702412495905.svg"
                                    alt=""></a>
                            <a href=""><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1702412500773.svg"
                                    alt=""></a>
                        </div>
                    </div>
                </div>
                <div>
                    <div>
                        <div class="careerum-club30-footer-text">
                            <p>Careerum OÜ. Reg. No 14726350</p>
                        </div>
                        <div class="careerum-club30-footer-text">
                            <p>Адрес:<br>Vesivärava 50-201,<br>Tallinn 10152, Estonia.</p>
                        </div>
                    </div>
                    <div>
                        <ul>
                            <li><a href="">Публичная оферта</a></li>
                            <li><a href="">Политика конфиденциальности</a></li>
                            <li><a href="">Политика возвратов</a></li>
                            <li><a href="">Корпоративное предложение</a></li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="careerum-footer30-main-mobile">
                <div>
                    <div class="careerum-footer30-main-mobile-logo">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1702480019056.svg" alt="">
                    </div>
                    <div class="careerum-club30-footer-text">
                        <p>© Careerum 2023<br>Все права защищены</p>
                        <p>Careerum OÜ. Reg. No 14726350</p>
                        <p>Адрес:<br>Vesivärava 50-201,<br>Tallinn 10152, Estonia.</p>
                    </div>
                    <div>
                        <ul>
                            <li><a href="">Публичная оферта</a></li>
                            <li><a href="">Политика конфиденциальности</a></li>
                            <li><a href="">Политика возвратов</a></li>
                            <li><a href="">Корпоративное предложение</a></li>
                        </ul>
                    </div>
                </div>
                <div>
                    <div>
                        <div class="careerum-footer30-social-block">
                            <div class="careerum-footer30-social-header">
                                <p>Мы в соцсетях</p>
                            </div>
                            <div class="careerum-footer30-social">
                                <a href=""><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1702412280517.svg"
                                        alt=""></a>
                                <a href=""><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1702412332524.svg"
                                        alt=""></a>
                                <a href=""><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1702412366173.svg"
                                        alt=""></a>
                                <a href=""><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1702412392583.svg"
                                        alt=""></a>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div class="careerum-footer30-social-header">
                            <p>Связаться с нами</p>
                        </div>
                        <div class="careerum-footer30-social">
                            <a href=""><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1702412426235.svg"
                                    alt=""></a>
                            <a href=""><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1702412444791.svg"
                                    alt=""></a>
                            <a href=""><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1702412489665.svg"
                                    alt=""></a>
                            <a href=""><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1702412495905.svg"
                                    alt=""></a>
                            <a href=""><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1702412500773.svg"
                                    alt=""></a>
                        </div>
                    </div>
                    <div>
                        <ul>
                            <li><a href="">О нас</a></li>
                            <li><a href="">Вакансии</a></li>
                            <li><a href="">FAQ</a></li>
                        </ul>
                    </div>
                    <div>
                        <ul>
                            <li><a href="">Careerum.Club</a></li>
                            <li><a href="">Личные консультации</a></li>
                            <li><a href="">Careerum.Tips</a></li>
                            <li><a href="">Телеграм-бот</a></li>
                        </ul>
                    </div>
                </div>
            </div>
        </footer>`
	});
    
    blockManager.add('careerum-club30-main2', {
        label: 'Клуб 3,0 главный 2',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <section class="careerum-club30-main2">
            <div>
                <div>
                    <div class="careerum-club30-main2-header">
                        <p>Постройте карьеру по&nbsp;своим правилам</p>
                    </div>
                    <div class="careerum-club30-block-text">
                        <p>с помощью образовательной платформы специалисты помогут достичь
                            ваших целей</p>
                    </div>
                    <a href="#" class="btn-color-main-black">Вступить в клуб</a>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1702927353933.svg" alt="">
                </div>
            </div>
        </section>`
	});
    
    blockManager.add('careerum-club30-main3', {
        label: 'Клуб 3,0 главный 3',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <section class="careerum-club30-main3">
            <div>
                <div>
                    <div class="careerum-club30-main3-header">
                        <p>Постройте карьеру по&nbsp;своим правилам</p>
                    </div>
                    <div class="careerum-club30-block-text">
                        <p>с помощью образовательной платформы специалисты помогут достичь
                            ваших целей</p>
                    </div>
                    <a href="#" class="btn-color-main-black">Вступить в клуб</a>
                </div>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1702927504370.png" alt="" class="careerum-club30-main3-img-desctop">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1702927513612.png" alt="" class="careerum-club30-main3-img-tablet">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1702927521447.png" alt="" class="careerum-club30-main3-img-mobile">
            </div>
        </section>`
	});
    
    
    blockManager.add('careerum-new-year-decor', {
        label: 'Новогодние шары',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-new-year-decor">
            <div>
                <div class="careerum-new-year-decor-top">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1703179927087.svg" alt="">
                    <p class="careerum-new-year-decor-top-h">Только 2 дня<br> скидка 60%</p>
                    <p class="careerum-new-year-decor-top-b">Новогодняя распродажа<br> Сareerum</p>
                </div>
                <div class="careerum-new-year-decor-bottom">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1703179938359.svg" alt="">
                    <p class="careerum-new-year-decor-bottom-h">12 500 ₽</p>
                    <p class="careerum-new-year-decor-bottom-b">4 990 ₽ </p>
                </div>
            </div>
        </div>`
	});
    
    blockManager.add('careerum-new-year-decor-tablet', {
        label: 'Новогодние шары (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-new-year-decor-tablet">
            <div>
                <div class="careerum-new-year-decor-top">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1703179947324.svg" alt="">
                    <p class="careerum-new-year-decor-top-h">Только 2 дня<br> скидка на курс<br> 60%</p>
                    <p class="careerum-new-year-decor-top-b">Новогодняя<br> распродажа Сareerum</p>
                </div>
                <div class="careerum-new-year-decor-bottom">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1703179956401.svg" alt="">
                    <p class="careerum-new-year-decor-bottom-h">12 500 ₽</p>
                    <p class="careerum-new-year-decor-bottom-b">4 990 ₽ </p>
                </div>
            </div>
        </div>`
	});
    
    blockManager.add('careerum-new-year-decor-mobile', {
        label: 'Новогодние шары (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-new-year-decor-mobile">
            <div>
                <div class="careerum-new-year-decor-top">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1703179966954.svg" alt="">
                    <p class="careerum-new-year-decor-top-h">Только 2 дня<br> скидка на курс<br> 60%</p>
                    <p class="careerum-new-year-decor-top-b">Новогодняя<br> распродажа Сareerum</p>
                </div>
                <div class="careerum-new-year-decor-bottom">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1703179977932.svg" alt="">
                    <p class="careerum-new-year-decor-bottom-h">12 500 ₽</p>
                    <p class="careerum-new-year-decor-bottom-b">4 990 ₽ </p>
                </div>
            </div>
        </div>`
	});
    
    
    blockManager.add('careerum-realme-main', {
        label: 'RealMe главный',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-realme-main">
            <div>
                <h1><span>Real Me:</span> как найти себя<br> в работе <span>и жизни</span></h1>
                <p>Легендарная программа Careerum доступна и вам. Чтобы ваши «Хочу»,<br> «Могу» и «Надо» образовали карьеру по любви</p>
                <a href="#buy" class="btn-color-main-dark-orange">Получить доступ к программе</a>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1703512401161.svg" alt="">
            </div>
        </div>`
	});
    
    blockManager.add('careerum-realme-main-tablet', {
        label: 'RealMe главный (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-realme-main-tablet">
            <div>
                <h2><span>Real Me:</span> как найти себя<br> в работе <span>и жизни</span></h2>
                <p>Легендарная программа Careerum доступна и вам. Чтобы ваши «Хочу»,<br> «Могу» и «Надо» образовали карьеру по любви</p>
                <a href="#buy" class="btn-color-main-dark-orange">Получить доступ к программе</a>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1703585346952.svg" alt="">
            </div>
        </div>`
	});
    
    blockManager.add('careerum-realme-main-mobile', {
        label: 'RealMe главный (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-realme-main-mobile">
            <div>
                <h2><span>Real Me:</span> как найти себя в работе <span>и жизни</span></h2>
                <p>Легендарная программа Careerum доступна и вам. Чтобы ваши<br> «Хочу», «Могу» и «Надо»<br> образовали карьеру по любви</p>
                <a href="#buy" class="btn-color-main-dark-orange">Получить доступ к программе</a>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1703589361714.svg" alt="">
            </div>
        </div>`
	});
    
    
    blockManager.add('careerum-realme-pains', {
        label: 'RealMe боли',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-realme-pains">
            <div>
                <div class="careerum-realme-pains-items">
                    <div class="careerum-realme-pains-item">
                        <p>«Кажется, что я никакой специалист!»</p>
                    </div>
                    <div class="careerum-realme-pains-item">
                        <p>«Ой всё, работа — тлен, мне ничего не надо...»</p>
                    </div>
                    <div class="careerum-realme-pains-item">
                        <p>«Не понимаю себя как профессионала»</p>
                    </div>
                    <div class="careerum-realme-pains-item">
                        <p>«...похоже, это карьерный потолок»</p>
                    </div>
                    <div class="careerum-realme-pains-item">
                        <p>«А какая работа — моя?»</p>
                    </div>
                </div>
                <div class="careerum-realme-pains-imgs">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1703512873516.svg" alt="">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1703512883621.svg" alt="">
                </div>
            </div>
        </div>`
	});
    
    blockManager.add('careerum-realme-pains-tablet', {
        label: 'RealMe боли (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-realme-pains-tablet">
            <div>
                <div class="careerum-realme-pains-items">
                    <div class="careerum-realme-pains-item">
                        <p>«Кажется, что я никакой специалист!»</p>
                    </div>
                    <div class="careerum-realme-pains-item">
                        <p>«Не понимаю себя как профессионала»</p>
                    </div>
                    <div class="careerum-realme-pains-item">
                        <p>«Ой всё, работа — тлен, мне ничего не надо...»</p>
                    </div>
                    <div class="careerum-realme-pains-item">
                        <p>«...похоже, это карьерный потолок»</p>
                    </div>
                    <div class="careerum-realme-pains-item">
                        <p>«А какая работа — моя?»</p>
                    </div>
                </div>
                <div class="careerum-realme-pains-imgs">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1703512873516.svg" alt="">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1703512883621.svg" alt="">
                </div>
            </div>
        </div>`
	});
    
    blockManager.add('careerum-realme-pains-mobile', {
        label: 'RealMe боли (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-realme-pains-mobile">
            <div>
                <div class="careerum-realme-pains-items">
                    <div class="careerum-realme-pains-item">
                        <p>«Кажется, что я никакой специалист!»</p>
                    </div>
                    <div class="careerum-realme-pains-item">
                        <p>«Ой всё, работа — тлен,</p>
                    </div>
                    <div class="careerum-realme-pains-item">
                        <p>мне ничего не надо...»</p>
                    </div>
                    <div class="careerum-realme-pains-item">
                        <p>«Не понимаю себя</p>
                    </div>
                    <div class="careerum-realme-pains-item">
                        <p>как профессионала»</p>
                    </div>
                    <div class="careerum-realme-pains-item">
                        <p>«...похоже, это карьерный потолок»</p>
                    </div>
                    <div class="careerum-realme-pains-item">
                        <p>«А какая работа — моя?»</p>
                    </div>
                </div>
                <div class="careerum-realme-pains-imgs">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1703512873516.svg" alt="">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1703512883621.svg" alt="">
                </div>
            </div>
        </div>`
	});
    
    
    blockManager.add('careerum-realme-for-what', {
        label: 'RealMe для чего',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-realme-for-what">
            <div>
                <h2>Программа заботливо создана, чтобы <br>вы смогли:</h2>
                <div class="careerum-realme-for-what-slider">
                    <div class="careerum-realme-for-what-slider-item">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1703514164051.svg" alt="">
                        <p>Понять свои ценности и строить карьеру в соответствии с ними</p>
                    </div>
                    <div class="careerum-realme-for-what-slider-item">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1703514267964.svg" alt="">
                        <p>Определить именно свои ориентиры для принятия карьерных решений</p>
                    </div>
                    <div class="careerum-realme-for-what-slider-item">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1703514247756.svg" alt="">
                        <p>Справиться с профессиональным кризисом</p>
                    </div>
                    <div class="careerum-realme-for-what-slider-item">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1703514164048.svg" alt="">
                        <p>Найти свои сильные стороны и таланты, которые откроют новые двери</p>
                    </div>
                    <div class="careerum-realme-for-what-slider-item">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1703514164046.svg" alt="">
                        <p>Понять, что в работе приводит вас к выгоранию, и предотвратить его</p>
                    </div>
                    <div class="careerum-realme-for-what-slider-item">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1703514164052.svg" alt="">
                        <p>Вернуть себе мотивацию в работе</p>
                    </div>
                    <div class="careerum-realme-for-what-slider-item">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1703514325721.svg" alt="">
                        <p>Понять: на своем ли вы месте и каким оно должно быть на самом деле</p>
                    </div>
                    <div class="careerum-realme-for-what-slider-item">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1703514339315.svg" alt="">
                        <p>Провести самоаудит и адаптировать свой опыт к новой сфере или после перерыва</p>
                    </div>
                </div>
                <div>
                    <div class="careerum-realme-for-what-slider-prev">
                        <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M2.19055 7.99935L15.8105 7.99935" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M8.46289 14.2453L2.18956 7.99862L8.46289 1.75195" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                            
                    </div>
                    <div class="careerum-realme-for-what-slider-next">
                        <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M15.8095 8.00065L2.18945 8.00065" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M9.53711 1.75471L15.8104 8.00138L9.53711 14.248" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                            
                    </div>
                </div>
            </div>
        </div>`
	});
    
    blockManager.add('careerum-realme-for-what-tablet', {
        label: 'RealMe для чего (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-realme-for-what-tablet">
            <div>
                <h2>Программа заботливо создана, чтобы вы смогли:</h2>
                <div class="careerum-realme-for-what-slider">
                    <div class="careerum-realme-for-what-slider-item">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1703514164051.svg" alt="">
                        <p>Понять свои ценности<br> и строить карьеру<br> в соответствии с ними</p>
                    </div>
                    <div class="careerum-realme-for-what-slider-item">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1703514267964.svg" alt="">
                        <p>Определить именно свои ориентиры для принятия карьерных решений</p>
                    </div>
                    <div class="careerum-realme-for-what-slider-item">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1703514247756.svg" alt="">
                        <p>Справиться <br>с профессиональным кризисом</p>
                    </div>
                    <div class="careerum-realme-for-what-slider-item">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1703514164048.svg" alt="">
                        <p>Найти свои сильные стороны и таланты, которые откроют новые двери</p>
                    </div>
                    <div class="careerum-realme-for-what-slider-item">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1703514164046.svg" alt="">
                        <p>Понять, что в работе приводит вас к выгоранию, и предотвратить его</p>
                    </div>
                    <div class="careerum-realme-for-what-slider-item">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1703514164052.svg" alt="">
                        <p>Вернуть себе мотивацию в работе</p>
                    </div>
                    <div class="careerum-realme-for-what-slider-item">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1703514325721.svg" alt="">
                        <p>Понять: на своем ли вы месте и каким оно должно быть на самом деле</p>
                    </div>
                    <div class="careerum-realme-for-what-slider-item">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1703514339315.svg" alt="">
                        <p>Провести самоаудит и адаптировать свой опыт к новой сфере или после перерыва</p>
                    </div>
                </div>
                <div>
                    <div class="careerum-realme-for-what-slider-prev">
                        <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M2.19055 7.99935L15.8105 7.99935" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M8.46289 14.2453L2.18956 7.99862L8.46289 1.75195" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                            
                    </div>
                    <div class="careerum-realme-for-what-slider-next">
                        <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M15.8095 8.00065L2.18945 8.00065" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M9.53711 1.75471L15.8104 8.00138L9.53711 14.248" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                            
                    </div>
                </div>
            </div>
        </div>`
	});
    
    blockManager.add('careerum-realme-for-what-mobile', {
        label: 'RealMe для чего (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-realme-for-what-mobile">
            <div>
                <h2>Программа заботливо создана, чтобы вы <br>смогли:</h2>
                <div class="careerum-realme-for-what-slider">
                    <div class="careerum-realme-for-what-slider-item">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1703514164051.svg" alt="">
                        <p>Понять свои ценности<br> и строить карьеру<br> в соответствии с ними</p>
                    </div>
                    <div class="careerum-realme-for-what-slider-item">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1703514267964.svg" alt="">
                        <p>Определить именно свои ориентиры для принятия карьерных решений</p>
                    </div>
                    <div class="careerum-realme-for-what-slider-item">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1703514247756.svg" alt="">
                        <p>Справиться <br>с профессиональным кризисом</p>
                    </div>
                    <div class="careerum-realme-for-what-slider-item">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1703514164048.svg" alt="">
                        <p>Найти свои сильные стороны и таланты, которые откроют новые двери</p>
                    </div>
                    <div class="careerum-realme-for-what-slider-item">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1703514164046.svg" alt="">
                        <p>Понять, что в работе приводит вас к выгоранию, и предотвратить его</p>
                    </div>
                    <div class="careerum-realme-for-what-slider-item">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1703514164052.svg" alt="">
                        <p>Вернуть себе мотивацию в работе</p>
                    </div>
                    <div class="careerum-realme-for-what-slider-item">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1703514325721.svg" alt="">
                        <p>Понять: на своем ли вы месте и каким оно должно быть на самом деле</p>
                    </div>
                    <div class="careerum-realme-for-what-slider-item">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1703514339315.svg" alt="">
                        <p>Провести самоаудит и адаптировать свой опыт к новой сфере или после перерыва</p>
                    </div>
                </div>
                <div>
                    <div class="careerum-realme-for-what-slider-prev">
                        <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M2.19055 7.99935L15.8105 7.99935" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M8.46289 14.2453L2.18956 7.99862L8.46289 1.75195" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                            
                    </div>
                    <div class="careerum-realme-for-what-slider-next">
                        <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M15.8095 8.00065L2.18945 8.00065" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M9.53711 1.75471L15.8104 8.00138L9.53711 14.248" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                            
                    </div>
                </div>
            </div>
        </div>`
	});
    
    
    blockManager.add('careerum-realme-balance', {
        label: 'RealMe баланс',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-realme-balance">
            <div>
                <div>
                    <h2>Real Me сбалансирует<br><span>3 элемента карьеры по любви</span></h2>
                </div>
                <div class="careerum-realme-balance-center">
                    <div>
                        <div class="careerum-realme-balance-item">
                            <p class="careerum-realme-balance-item-header">Могу</p>
                            <p class="careerum-realme-balance-item-text">Ваши ценности и желания: <br>
                                то, что приносит удовольствие<br> и дает энергию</p>
                        </div>
                        <div class="careerum-realme-balance-item">
                            <p class="careerum-realme-balance-item-header">Хочу</p>
                            <p class="careerum-realme-balance-item-text">Ваши сильные стороны<br> и таланты: то, что вы умеете<br> лучше всех</p>
                        </div>
                        <div class="careerum-realme-balance-item">
                            <p class="careerum-realme-balance-item-header">Надо</p>
                            <p class="careerum-realme-balance-item-text">То, что нужно рынку<br> труда: навыки, за которые<br> готовы хорошо платить</p>
                        </div>
                    </div>
                    <div>
                        <p class="careerum-realme-balance-right-text">Хочу</p>
                        <p class="careerum-realme-balance-right-text">Могу</p>
                        <p class="careerum-realme-balance-right-text">Карьера<br> по любви</p>
                        <p class="careerum-realme-balance-right-text">Надо</p>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1703516852218.svg" alt="">
                    </div>
                </div>
                <div>
                    <a href="#buy" class="btn-color-main-dark-orange">Получить доступ к программе</a>
                </div>
            </div>
        </div>`
	});
    
    blockManager.add('careerum-realme-balance-tablet', {
        label: 'RealMe баланс (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-realme-balance-tablet">
            <div>
                <div>
                    <h2>Real Me сбалансирует<br>3 элемента карьеры по любви</h2>
                </div>
                <div class="careerum-realme-balance-center">
                    <div>
                        <div class="careerum-realme-balance-item">
                            <p class="careerum-realme-balance-item-header">Могу</p>
                            <p class="careerum-realme-balance-item-text">Ваши ценности и желания: <br>
                                то, что приносит удовольствие<br> и дает энергию</p>
                        </div>
                        <div class="careerum-realme-balance-item">
                            <p class="careerum-realme-balance-item-header">Хочу</p>
                            <p class="careerum-realme-balance-item-text">Ваши сильные стороны<br> и таланты: то, что вы умеете<br> лучше всех</p>
                        </div>
                        <div class="careerum-realme-balance-item">
                            <p class="careerum-realme-balance-item-header">Надо</p>
                            <p class="careerum-realme-balance-item-text">То, что нужно рынку<br> труда: навыки, за которые<br> готовы хорошо платить</p>
                        </div>
                    </div>
                    <div>
                        <p class="careerum-realme-balance-right-text">Хочу</p>
                        <p class="careerum-realme-balance-right-text">Могу</p>
                        <p class="careerum-realme-balance-right-text">Карьера<br> по любви</p>
                        <p class="careerum-realme-balance-right-text">Надо</p>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1703583281146.svg" alt="">
                    </div>
                </div>
                <div>
                    <a href="#buy" class="btn-color-main-dark-orange">Получить доступ к программе</a>
                </div>
            </div>
        </div>`
	});
    
    blockManager.add('careerum-realme-balance-mobile', {
        label: 'RealMe баланс (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-realme-balance-mobile">
            <div>
                <div>
                    <h2>Real Me<br> сбалансирует<br>3 элемента карьеры по любви</h2>
                </div>
                <div class="careerum-realme-balance-center">
                    <div>
                        <div class="careerum-realme-balance-item">
                            <p class="careerum-realme-balance-item-header">Могу</p>
                            <p class="careerum-realme-balance-item-text">Ваши ценности и желания: <br>
                                то, что приносит удовольствие<br> и дает энергию</p>
                        </div>
                        <div class="careerum-realme-balance-item">
                            <p class="careerum-realme-balance-item-header">Хочу</p>
                            <p class="careerum-realme-balance-item-text">Ваши сильные стороны<br> и таланты: то, что вы умеете<br> лучше всех</p>
                        </div>
                        <div class="careerum-realme-balance-item">
                            <p class="careerum-realme-balance-item-header">Надо</p>
                            <p class="careerum-realme-balance-item-text">То, что нужно рынку<br> труда: навыки, за которые<br> готовы хорошо платить</p>
                        </div>
                    </div>
                    <div>
                        <p class="careerum-realme-balance-right-text">Хочу</p>
                        <p class="careerum-realme-balance-right-text">Могу</p>
                        <p class="careerum-realme-balance-right-text">Карьера<br> по любви</p>
                        <p class="careerum-realme-balance-right-text">Надо</p>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1703586452314.svg" alt="">
                    </div>
                </div>
                <div>
                    <a href="#buy" class="btn-color-main-dark-orange">Получить доступ к программе</a>
                </div>
            </div>
        </div>`
	});
    
    
    blockManager.add('careerum-realme-skills', {
        label: 'RealMe навыки',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-realme-skills">
            <div>
                <div>
                    <h2>Как и какие навыки вы освоите</h2>
                </div>
                <div class="careerum-realme-skills-items">
                    <div class="careerum-realme-skills-item">
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1703517531814.svg" alt="">
                        </div>
                        <div>
                            <p>Шаг 1: определите свои личные «Могу»</p>
                            <ul>
                                <li>Выработаете профессиональную уверенность</li>
                                <li>Поймете себя как профессионала</li>
                                <li>Систематизируете свой опыт, знания, таланты</li>
                                <li>Осознаете сколько у вас суперсил</li>
                            </ul>
                        </div>
                    </div>
                    <div class="careerum-realme-skills-item">
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1703517551671.svg" alt="">
                        </div>
                        <div>
                            <p>Шаг 2: поймете<br> свои «Хочу»</p>
                            <ul>
                                <li>Осознаете, какие ценности и смыслы вы вкладываете в карьеру</li>
                                <li>Исследуете свои мотиваторы, интересы, а также — рабочую среду</li>
                                <li>Сформулируете, что в карьере важно именно для вас</li>
                                <li>Поймете, что в работае заряжает вас энергией, а что обесточивает</li>
                            </ul>
                        </div>
                    </div>
                    <div class="careerum-realme-skills-item">
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1703517571901.svg" alt="">
                        </div>
                        <div>
                            <p>Шаг 3: сможете определять «Надо»</p>
                            <ul>
                                <li>Поймете, как анализировать отрасли, профессии и компании, чтобы соотносить их с вашими «Хочу» и «Могу»</li>
                                <li>Научитесь «сканировать» рынок труда и находить там возможности для развития карьеры</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
	});
    
    blockManager.add('careerum-realme-skills-tablet', {
        label: 'RealMe навыки (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-realme-skills-tablet">
            <div>
                <div>
                    <h2>Как и какие навыки вы освоите</h2>
                </div>
                <div class="careerum-realme-skills-items">
                    <div class="careerum-realme-skills-item">
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1703583550497.svg" alt="">
                        </div>
                        <div>
                            <p>Шаг 1: определите <br>свои личные «Могу»</p>
                            <ul>
                                <li>Выработаете профессиональную уверенность</li>
                                <li>Поймете себя как профессионала</li>
                                <li>Систематизируете свой опыт, знания, таланты</li>
                                <li>Осознаете сколько у вас суперсил</li>
                            </ul>
                        </div>
                    </div>
                    <div class="careerum-realme-skills-item">
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1703583570290.svg" alt="">
                        </div>
                        <div>
                            <p>Шаг 2: поймете свои «Хочу»</p>
                            <ul>
                                <li>Осознаете, какие ценности и смыслы вы вкладываете в карьеру</li>
                                <li>Исследуете свои мотиваторы, интересы, а также — рабочую среду</li>
                                <li>Сформулируете, что в карьере важно именно для вас</li>
                                <li>Поймете, что в работае заряжает вас энергией, а что обесточивает</li>
                            </ul>
                        </div>
                    </div>
                    <div class="careerum-realme-skills-item">
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1703583589557.svg" alt="">
                        </div>
                        <div>
                            <p>Шаг 3: сможете определять «Надо»</p>
                            <ul>
                                <li>Поймете, как анализировать отрасли, профессии и компании, чтобы соотносить их с вашими «Хочу» и «Могу»</li>
                                <li>Научитесь «сканировать» рынок труда и находить там возможности для развития карьеры</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
	});
    
    blockManager.add('careerum-realme-skills-mobile', {
        label: 'RealMe навыки (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-realme-skills-mobile">
            <div>
                <div>
                    <h2>Как и какие навыки вы освоите</h2>
                </div>
                <div class="careerum-realme-skills-items slider">
                    <div class="careerum-realme-skills-item">
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1703583550497.svg" alt="">
                        </div>
                        <div>
                            <p>Шаг 1: определите свои<br> личные «Могу»</p>
                            <ul>
                                <li>Выработаете профессиональную<br> уверенность</li>
                                <li>Поймете себя как<br> профессионала</li>
                                <li>Систематизируете свой опыт,<br> знания, таланты</li>
                                <li>Осознаете сколько у вас<br> суперсил</li>
                            </ul>
                        </div>
                    </div>
                    <div class="careerum-realme-skills-item">
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1703583570290.svg" alt="">
                        </div>
                        <div>
                            <p>Шаг 2: поймете свои «Хочу»</p>
                            <ul>
                                <li>Осознаете, какие ценности<br> и смыслы вы вкладываете<br> в карьеру</li>
                                <li>Исследуете свои мотиваторы,<br> интересы, а также — рабочую среду</li>
                                <li>Сформулируете, что в карьере<br> важно именно для вас</li>
                                <li>Поймете, что в работае заряжает вас<br> энергией, а что обесточивает</li>
                            </ul>
                        </div>
                    </div>
                    <div class="careerum-realme-skills-item">
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1703583589557.svg" alt="">
                        </div>
                        <div>
                            <p>Шаг 3: сможете определять<br> «Надо»</p>
                            <ul>
                                <li>Поймете, как анализировать<br> отрасли, профессии и компании,<br> чтобы соотносить их с вашими<br> «Хочу» и «Могу»</li>
                                <li>Научитесь «сканировать» рынок<br> труда и находить там возможности<br> для развития карьеры</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div>
                    <div class="careerum-realme-skills-slider-prev">
                        <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M2.19055 7.99935L15.8105 7.99935" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M8.46289 14.2453L2.18956 7.99862L8.46289 1.75195" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                            
                    </div>
                    <div class="careerum-realme-skills-slider-next">
                        <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M15.8095 8.00065L2.18945 8.00065" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M9.53711 1.75471L15.8104 8.00138L9.53711 14.248" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                            
                    </div>
                </div>
            </div>
        </div>`
	});
    
    
    blockManager.add('careerum-realme-how-it', {
        label: 'RealMe как это',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-realme-how-it">
            <div>
                <div>
                    <h2>Как устроена<br> Real Me</h2>
                    <div>
                        <p class="careerum-realme-how-it-header">Можно учиться в тройках (но это не обязательно)
                        </p>
                        <p class="careerum-realme-how-it-text">Вы можете проходить программу с единомышленниками. В рабочей тетради вы найдете способы собрать вашу тройку и задания для командной работы.</p>
                        <p class="careerum-realme-how-it-text">Так каждый участник тройки получит полноценный взгляд на свою ситуацию, новые идеи и дополнительную поддержку</p>
                    </div>
                </div>
                <div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1703518281509.svg" alt="">
                        <p>Программа состоит из видеоуроков, которые можно смотреть в любое время, в любом месте. Хоть по 15 минут в такси или за обедом</p>
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1703518291591.svg" alt="">
                        <p>Материал разбит на 3 блока: «Могу», «Хочу», «Надо»
                        </p>
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1703518303657.svg" alt="">
                        <p>В начале каждого блока будет урок-антиблоекр: разбор карьерных установок, которые<br> мешают достигать целей</p>
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1703518315997.svg" alt="">
                        <p>После каждого урока вам предстоит выполнить задание в рабочей тетради: несложное и без проверок — просто, чтобы закрепить материал</p>
                    </div>
                </div>
            </div>
        </div>`
	});
    
    blockManager.add('careerum-realme-how-it-tablet', {
        label: 'RealMe как это (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-realme-how-it-tablet">
            <div>
                <div>
                    <h2>Как устроена Real Me</h2>
                </div>
                <div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1703518281509.svg" alt="">
                        <p>Программа состоит из видеоуроков, которые можно смотреть в любое время, в любом месте. Хоть по 15 минут в такси или за обедом</p>
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1703518291591.svg" alt="">
                        <p>Материал разбит на 3 блока: «Могу», «Хочу», «Надо»
                        </p>
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1703518303657.svg" alt="">
                        <p>В начале каждого блока будет урок-антиблоекр: разбор карьерных установок, которые<br> мешают достигать целей</p>
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1703518315997.svg" alt="">
                        <p>После каждого урока вам предстоит выполнить задание в рабочей тетради: несложное и без проверок — просто, чтобы закрепить материал</p>
                    </div>
                </div>
                
                <div>
                    <p class="careerum-realme-how-it-header">Можно учиться в тройках (но это не обязательно)
                    </p>
                    <p class="careerum-realme-how-it-text">Вы можете проходить программу с единомышленниками. В рабочей тетради вы найдете способы собрать вашу тройку и задания для командной работы.</p>
                    <p class="careerum-realme-how-it-text">Так каждый участник тройки получит полноценный взгляд на свою ситуацию, новые идеи и дополнительную поддержку</p>
                </div>
            </div>
        </div>`
	});
    
    blockManager.add('careerum-realme-how-it-mobile', {
        label: 'RealMe как это (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-realme-how-it-mobile">
            <div>
                <div>
                    <h2>Как устроена<br> Real Me</h2>
                </div>
                <div class="careerum-realme-how-it-slider">
                    <div class="careerum-realme-how-it-slider-item">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1703518281509.svg" alt="">
                        <p>Программа состоит<br> из видеоуроков, которые можно<br> смотреть в любое время, в любом<br> месте. Хоть по 15 минут в такси<br> или за обедом</p>
                    </div>
                    <div class="careerum-realme-how-it-slider-item">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1703518291591.svg" alt="">
                        <p>Материал разбит<br> на 3 блока: «Могу»,<br> «Хочу», «Надо»
                        </p>
                    </div>
                    <div class="careerum-realme-how-it-slider-item">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1703518303657.svg" alt="">
                        <p>В начале каждого блока будет<br> урок-антиблоекр: разбор<br> карьерных установок, которые<br> мешают достигать целей</p>
                    </div>
                    <div class="careerum-realme-how-it-slider-item">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1703518315997.svg" alt="">
                        <p>После каждого урока вам<br> предстоит выполнить задание<br> в рабочей тетради: несложное<br> и без проверок — просто, чтобы<br> закрепить материал</p>
                    </div>
                </div>  
                <div>
                    <div class="careerum-realme-how-it-slider-prev">
                        <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M2.19055 7.99935L15.8105 7.99935" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M8.46289 14.2453L2.18956 7.99862L8.46289 1.75195" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                            
                    </div>
                    <div class="careerum-realme-how-it-slider-next">
                        <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M15.8095 8.00065L2.18945 8.00065" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M9.53711 1.75471L15.8104 8.00138L9.53711 14.248" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                            
                    </div>
                </div>          
                <div>
                    <p class="careerum-realme-how-it-header">Можно учиться<br> в тройках (но это не обязательно)
                    </p>
                    <p class="careerum-realme-how-it-text">Вы можете проходить программу с единомышленниками.<br> В рабочей тетради вы найдете способы собрать вашу тройку и задания для командной работы.</p>
                    <p class="careerum-realme-how-it-text">Так каждый участник тройки получит полноценный взгляд на свою ситуацию, новые идеи и дополнительную поддержку</p>
                </div>
            </div>
        </div>`
	});
    
    
    blockManager.add('careerum-realme-author', {
        label: 'RealMe автор',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-realme-author">
            <div>
                <div>
                    <div>
                        <h2>Автор программы:</h2>
                        <p>Ольга Лермонтова, основательница карьерной платформы Careerum</p>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1703518961625.png" alt="">
                    </div>
                    <div>
                        <ul>
                            <li>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1703519152888.svg" alt="">
                                <p>Помогла 11 000+ клиентам из России, СНГ, Европы, Северной и Южной Америки построить карьеру по любви</p>
                            </li>
                            <li>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1703519194584.svg" alt="">
                                <p>Сертифицированный карьерный коуч International Coaching Federation</p>
                            </li>
                            <li>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1703519218688.svg" alt="">
                                <p>15+ лет успешной карьеры на руководящих позициях в 5 странах в tech-компаниях (Google, Microsoft, Intel)</p>
                            </li>
                            <li>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1703519194584.svg" alt="">
                                <p>Степень MBA от бизнес-школы INSEAD</p>
                            </li>
                            <li>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1703519240573.svg" alt="">
                                <p>Управляла бизнесом на 20+ рынках Африки, Западной и Восточной Европы</p>
                            </li>
                            <li>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1703519152888.svg" alt="">
                                <p>В качестве клиентов в Careerum приходят сотрудники «Яндекса», Puma, VK, Mars, InDrive, Microsoft и др.</p>
                            </li>
                            <li>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1703519268031.svg" alt="">
                                <p>Италия</p>
                            </li>
                        </ul>
                    </div>
                </div>
                <a href="#buy" class="btn-color-main-dark-orange">Получить доступ к программе</a>
            </div>
        </div>`
	});
    
    blockManager.add('careerum-realme-author-tablet', {
        label: 'RealMe автор (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-realme-author-tablet">
            <div>
                <div>
                    <div>
                        <h2>Автор программы:</h2>
                        <p>Ольга Лермонтова, основательница карьерной платформы Careerum</p>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1703584965372.png" alt="">
                    </div>
                    <div>
                        <ul>
                            <li>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1703519152888.svg" alt="">
                                <p>Помогла 11 000+ клиентам из России, СНГ, Европы, Северной и Южной Америки построить карьеру по любви</p>
                            </li>
                            <li>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1703519194584.svg" alt="">
                                <p>Сертифицированный карьерный коуч International Coaching Federation</p>
                            </li>
                            <li>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1703519218688.svg" alt="">
                                <p>15+ лет успешной карьеры на руководящих позициях в 5 странах в tech-компаниях (Google, Microsoft, Intel)</p>
                            </li>
                            <li>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1703519194584.svg" alt="">
                                <p>Степень MBA от бизнес-школы INSEAD</p>
                            </li>
                            <li>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1703519240573.svg" alt="">
                                <p>Управляла бизнесом на 20+ рынках Африки, Западной и Восточной Европы</p>
                            </li>
                            <li>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1703519152888.svg" alt="">
                                <p>В качестве клиентов в Careerum приходят сотрудники «Яндекса», Puma, VK, Mars, InDrive, Microsoft и др.</p>
                            </li>
                            <li>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1703519268031.svg" alt="">
                                <p>Италия</p>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>`
	});
    
    blockManager.add('careerum-realme-author-mobile', {
        label: 'RealMe автор (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-realme-author-mobile">
            <div>
                <div>
                    <div>
                        <h2>Автор программы:</h2>
                        <p>Ольга Лермонтова,<br> основательница карьерной<br> платформы Careerum</p>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1703588918574.png" alt="">
                    </div>
                    <div>
                        <ul>
                            <li>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1703519152888.svg" alt="">
                                <p>Помогла 11 000+ клиентам<br> из России, СНГ, Европы, Северной и Южной Америки построить карьеру по любви</p>
                            </li>
                            <li>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1703519194584.svg" alt="">
                                <p>Сертифицированный карьерный коуч International Coaching Federation</p>
                            </li>
                            <li>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1703519218688.svg" alt="">
                                <p>15+ лет успешной карьеры на руководящих позициях в 5 странах в tech-компаниях (Google,<br> Microsoft, Intel)</p>
                            </li>
                            <li>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1703519194584.svg" alt="">
                                <p>Степень MBA от бизнес-школы INSEAD</p>
                            </li>
                            <li>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1703519240573.svg" alt="">
                                <p>Управляла бизнесом на 20+ рынках Африки, Западной и Восточной Европы</p>
                            </li>
                            <li>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1703519152888.svg" alt="">
                                <p>В качестве клиентов в Careerum приходят сотрудники «Яндекса», Puma, VK, Mars, InDrive, Microsoft<br> и др.</p>
                            </li>
                            <li>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1703519268031.svg" alt="">
                                <p>Италия</p>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>`
	});
    
    blockManager.add('careerum-business-main', {
        label: 'Страница B2B главный',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-business-main">
            <div>
                <div class="business-main-top">
                    <div>
                        <div class="business-main-top-text">
                            <svg xmlns="http://www.w3.org/2000/svg" width="205" height="7" viewBox="0 0 205 7" fill="none">
                                <path d="M1.5 5.5C89.6207 -0.68749 118.5 2.00136 204 2.00091" stroke="black"
                                    stroke-width="2" stroke-linecap="round" />
                            </svg>
                            <h1>Careerum для бизнеса</h1>
                        </div>
                        <div class="business-main-top-header">
                            <svg xmlns="http://www.w3.org/2000/svg" width="516" height="68" viewBox="0 0 516 68"
                                fill="none">
                                <path
                                    d="M515 39.7939C497.249 64.4635 331.143 66.9938 247.619 66.9937C203.256 66.9937 11.3035 68.2588 1.31837 34.7335C-7.14344 6.32276 155.47 2.70643 202.94 1.57929C290.753 -0.505762 513.891 1.5793 508.343 32.8358"
                                    stroke="black" stroke-width="2" stroke-linecap="round" />
                            </svg>
                            <p>Помогаем<br> достигать личных<br> и корпоративных целей</p>
                        </div>
                        <div class="business-main-top-link">
                            <a href="#register" class="btn-color-main-black">Узнать больше</a>
                        </div>
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1705407474256.png" alt="">
                    </div>
                </div>
                <div class="business-main-bottom">
                    <div>
                        <p class="business-main-bottom-item-top">11 000+</p>
                        <p class="business-main-bottom-item-bottom">русскоговорящих<br> специалистов из 30+ стран</p>
                    </div>
                    <div>
                        <p class="business-main-bottom-item-top">3 800+</p>
                        <p class="business-main-bottom-item-bottom">часов проведенных коуч-<br>сессий</p>
                    </div>
                    <div>
                        <p class="business-main-bottom-item-top">9.3/10</p>
                        <p class="business-main-bottom-item-bottom">средняя оценка коучей клиентами Careerum</p>
                    </div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-business-main-tablet', {
        label: 'Страница B2B главный (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-business-main-tablet">
            <div>
                <div class="business-main-top">
                    <div>
                        <div class="business-main-top-text">
                            <svg xmlns="http://www.w3.org/2000/svg" width="109" height="4" viewBox="0 0 109 4" fill="none">
                                <path d="M1 3.14582C47.3449 -0.108342 62.5333 1.30579 107.5 1.30555" stroke="black"
                                    stroke-width="1.05185" stroke-linecap="round" />
                            </svg>
                            <h2>Careerum для бизнеса</h2>
                        </div>
                        <div class="business-main-top-header">
                            <p>Помогаем<br> достигать личных<br> и корпоративных целей</p>
                        </div>
                        <div class="business-main-top-link">
                            <a href="#register" class="btn-color-main-black">Узнать больше</a>
                        </div>
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1705565728501.jpg" alt="">
                    </div>
                </div>
                <div class="business-main-bottom">
                    <div>
                        <p class="business-main-bottom-item-top">11 000+</p>
                        <p class="business-main-bottom-item-bottom">русскоговорящих<br> специалистов из 30+ стран</p>
                    </div>
                    <div>
                        <p class="business-main-bottom-item-top">3 800+</p>
                        <p class="business-main-bottom-item-bottom">часов проведенных коуч-<br>сессий</p>
                    </div>
                    <div>
                        <p class="business-main-bottom-item-top">9.3/10</p>
                        <p class="business-main-bottom-item-bottom">средняя оценка коучей клиентами Careerum</p>
                    </div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-business-main-mobile', {
        label: 'Страница B2B главный (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-business-main-mobile">
            <div>
                <div class="business-main-top">
                    <div>
                        <div class="business-main-top-text">
                            <svg xmlns="http://www.w3.org/2000/svg" width="113" height="4" viewBox="0 0 113 4" fill="none">
                                <path d="M1 3.15836C49.3032 -0.233299 65.1333 1.24059 112 1.24034" stroke="black" stroke-linecap="round"/>
                            </svg>
                            <h2>Careerum для бизнеса</h2>
                        </div>
                        <div class="business-main-top-header">
                            <svg xmlns="http://www.w3.org/2000/svg" width="224" height="28" viewBox="0 0 224 28" fill="none">
                                <path d="M223 16.2824C215.299 26.0008 143.233 26.9975 106.996 26.9975C87.7492 26.9975 4.47021 27.4959 0.138123 14.2889C-3.53305 3.09685 67.0169 1.67223 87.612 1.2282C125.71 0.406822 222.519 1.22821 220.112 13.5414" stroke="black" stroke-linecap="round"/>
                              </svg>
                            <p>Помогаем достигать личных и корпоративных целей</p>
                        </div>
                        <div class="business-main-top-link">
                            <a href="#register" class="btn-color-main-black">Узнать больше</a>
                        </div>
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1705575348557.png" alt="">
                    </div>
                </div>
                <div class="business-main-bottom">
                    <div>
                        <p class="business-main-bottom-item-top">11 000+</p>
                        <p class="business-main-bottom-item-bottom">русскоговорящих<br> специалистов из 30+ стран</p>
                    </div>
                    <div>
                        <p class="business-main-bottom-item-top">3 800+</p>
                        <p class="business-main-bottom-item-bottom">часов проведенных коуч-<br>сессий</p>
                    </div>
                    <div>
                        <p class="business-main-bottom-item-top">9.3/10</p>
                        <p class="business-main-bottom-item-bottom">средняя оценка коучей<br> клиентами Careerum</p>
                    </div>
                </div>
            </div>
        </div>`
	});
    
    blockManager.add('careerum-business-companies', {
        label: 'Страница B2B компании',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-business-companies">
            <div>
                <div>
                    <h2>Нас выбирают сотрудники компаний:</h2>
                </div>
                <div class="business-companies-list">
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1705409273645.png" alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1705409282980.png" alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1705409291576.png" alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1705409305519.png" alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1705409318602.png" alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1705409334663.png" alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1705409348384.png" alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1705409365967.png" alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1705409379686.png" alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1705409398087.png" alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1705409409856.png" alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1705409419536.png" alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1705409431383.png" alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1705409443005.png" alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1705409454169.png" alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1705409465322.png" alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1705409474297.png" alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1705409482426.png" alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1705409502461.png" alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1705409512062.png" alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1705409524088.png" alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1705409536989.png" alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1705409546786.png" alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1705409556032.png" alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1705409571721.png" alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1705409583154.png" alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1705409591924.png" alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1705409603083.png" alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1705409613417.png" alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1705409623273.png" alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1705409631738.png" alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1705409641779.png" alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1705409650055.png" alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1705409658652.png" alt="">
                    </div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-business-companies-tablet', {
        label: 'Страница B2B компании (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-business-companies-tablet">
            <div>
                <div>
                    <h2>Нас выбирают сотрудники компаний:</h2>
                </div>
                <div class="business-companies-list">
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1705409273645.png" alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1705409282980.png" alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1705409291576.png" alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1705409305519.png" alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1705409318602.png" alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1705409334663.png" alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1705409348384.png" alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1705409365967.png" alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1705409379686.png" alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1705409398087.png" alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1705409409856.png" alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1705409419536.png" alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1705409431383.png" alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1705409443005.png" alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1705409454169.png" alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1705409465322.png" alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1705409474297.png" alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1705409482426.png" alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1705409502461.png" alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1705409512062.png" alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1705409524088.png" alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1705409536989.png" alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1705409546786.png" alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1705409556032.png" alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1705409571721.png" alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1705409583154.png" alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1705409591924.png" alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1705409603083.png" alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1705409613417.png" alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1705409623273.png" alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1705409631738.png" alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1705409641779.png" alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1705409650055.png" alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1705409658652.png" alt="">
                    </div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-business-companies-mobile', {
        label: 'Страница B2B компании (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-business-companies-mobile">
            <div>
                <div>
                    <h2>Нас выбирают<br> сотрудники компаний:</h2>
                </div>
                <div class="business-companies-list">
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1705585210304.png" alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1705585237322.png" alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1705585245839.png" alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1705585254196.png" alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1705585263097.png" alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1705585274385.png" alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1705585284673.png" alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1705585293266.png" alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1705585301219.png" alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1705585308378.png" alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1705585316756.png" alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1705585325801.png" alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1705585334909.png" alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1705585343105.png" alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1705585356159.png" alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1705585367185.png" alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1705585375326.png" alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1705585382450.png" alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1705585394674.png" alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1705585402603.png" alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1705585411322.png" alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1705585420065.png" alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1705585428384.png" alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1705585437650.png" alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1705585452118.png" alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1705585484694.png" alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1705585495149.png" alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1705585502884.png" alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1705585512234.png" alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1705585520656.png" alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1705585531238.png" alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1705585539983.png" alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1705585552231.png" alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1705585562441.png" alt="">
                    </div>
                </div>
            </div>
        </div>`
	});
    
    blockManager.add('careerum-business-advantages', {
        label: 'Страница B2B преимущество',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-business-advantages">
            <div>
                <div>
                    <h2>Наше преимущество — <br>возможность выбрать формат,<br> удобный для вас</h2>
                </div>
                <div class="business-advantages-top">
                    <div>
                        <svg xmlns="http://www.w3.org/2000/svg" width="572" height="166" viewBox="0 0 572 166" fill="none">
                            <path
                                d="M205.916 18.3542C310.34 -10.0669 607 2.49075 607 43.4702C607 79.1618 309.153 94.3641 219.697 98.9908C190.282 100.512 3 109.389 3 78.5011C3 60.3583 87.2512 50.741 190.155 50.741C254.568 50.741 363.739 57.3505 361.365 94.3641C359.836 118.21 229.648 134.492 138.277 132.7C108.585 132.117 87.2512 126.776 87.2512 120.141C87.2512 113.051 112.971 111.549 129.97 111.549C146.97 111.549 283.047 114.854 291.801 150.296C294.311 160.46 277.415 165.748 262.357 161.555"
                                stroke="#FFC76A" stroke-opacity="0.3" stroke-width="5.62308" stroke-linecap="round" />
                        </svg>
                        <div class="business-advantages-top-first">
                            <p class="business-advantages-top-header">Сессии с коучем</p>
                            <p class="business-advantages-top-type">Групповые<br> и индивидуальные</p>
                        </div>
                        <div>
                            <p class="business-advantages-top-descr">Глубокая проработка запроса.<br> Например, мотивация в
                                команде, командная коммуникация,
                                управление стрессом</p>
                        </div>
                    </div>
                    <div>
                        <svg xmlns="http://www.w3.org/2000/svg" width="421" height="300" viewBox="0 0 421 300" fill="none">
                            <path
                                d="M365.378 292.816C344.403 296.717 290.074 300.43 266.044 282.568C226.863 253.445 267.217 189.457 286.703 168.254C306.188 147.051 340.656 129.518 370.628 129.518C400.599 129.518 417.109 139.09 417.109 163.088C417.109 186.329 400.322 204.111 378.374 218.607C347.511 238.993 316.365 247.359 277.708 249.438C230.59 251.973 156.688 243.158 154.939 181.866C152.936 111.667 233.507 85.926 266.596 83.2692C290.439 81.3547 311.898 90.6698 310.815 102.279C303.069 151.716 39.1465 118.843 8.50031 54.9107C-22.1458 -9.02143 120.178 -23.5254 128.825 3.63271"
                                stroke="#FFC76A" stroke-opacity="0.3" stroke-width="6.81331" stroke-linecap="round" />
                        </svg>
                        <div class="business-advantages-top-first">
                            <p class="business-advantages-top-header">Образовательные<br>и нетворкинговые<br> мероприятия
                            </p>
                            <p class="business-advantages-top-type">Онлайн и офлайн</p>
                        </div>
                        <div>
                            <p class="business-advantages-top-descr">Пример тем: постановка целей, мотивация, эмоциональное
                                выгорание, коммуникация и экологичное
                                общение</p>
                        </div>
                    </div>
                </div>
                <div class="business-advantages-bottom">
                    <svg xmlns="http://www.w3.org/2000/svg" width="413" height="8" viewBox="0 0 413 8" fill="none">
                        <path d="M2 5.99999C179.982 -0.0660455 238.311 2.57002 411 2.56958" stroke="#FFC76A"
                            stroke-width="3" stroke-linecap="round" />
                    </svg>
                    <div class="business-advantages-bottom-left">
                        <p class="business-advantages-top-header-bottom">Корпоративная подписка</p>
                        <p class="business-advantages-top-type">Доступно 2 тарифа</p>
                    </div>
                    <div class="business-advantages-bottom-right">
                        <h4>Self study</h4>
                        <p class="business-advantages-top-descr">Доступ к сообществу с другими участниками Careerum и<br> к
                            образовательной платформе<br> для
                            самостоятельного изучения материалов</p>
                        <h4>VIP</h4>
                        <p class="business-advantages-top-descr">Доступ к сообществу, образовательной платформе, плюс,
                            проработатка запросов вместе с коучем на
                            сессиях</p>
                    </div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-business-advantages-tablet', {
        label: 'Страница B2B преимущество (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-business-advantages-tablet">
            <div>
                <div>
                    <h2>Наше преимущество — возможность выбрать формат, удобный для вас</h2>
                </div>
                <div class="business-advantages-top">
                    <div>
                        <svg xmlns="http://www.w3.org/2000/svg" width="332" height="138" viewBox="0 0 332 138" fill="none">
                            <path d="M168.916 17.3542C273.34 -11.0669 570 1.49075 570 42.4702C570 78.1618 272.153 93.3641 182.697 97.9908C153.282 99.5121 -34 108.389 -34 77.5011C-34 59.3583 50.2512 49.741 153.155 49.741C217.568 49.741 326.739 56.3505 324.365 93.3641C322.836 117.21 192.648 133.492 101.277 131.7C71.5848 131.117 50.2512 125.776 50.2512 119.141C50.2512 112.051 75.9706 110.549 92.9703 110.549C109.97 110.549 246.047 113.854 254.801 149.296C257.311 159.46 240.415 164.748 225.357 160.555" stroke="#FFC76A" stroke-opacity="0.3" stroke-width="3" stroke-linecap="round"/>
                          </svg>
                        <div class="business-advantages-top-first">
                            <p class="business-advantages-top-header">Сессии с коучем</p>
                            <p class="business-advantages-top-type">Групповые и индивидуальные</p>
                        </div>
                        <div>
                            <p class="business-advantages-top-descr">Глубокая проработка запроса.<br> Например, мотивация в
                                команде, командная коммуникация,
                                управление стрессом</p>
                        </div>
                    </div>
                    <div>
                        <svg xmlns="http://www.w3.org/2000/svg" width="246" height="173" viewBox="0 0 246 173" fill="none">
                            <path d="M300.573 136.543C295.11 148.417 277.122 174.131 257.454 170.116C225.384 163.569 201.975 96.1577 196.493 71.2565C191.011 46.3552 193.309 18.0664 204.462 5.49677C215.615 -7.07289 227.507 -6.44414 241.918 12.4903C255.875 30.8275 260.307 51.8986 260.845 72.5403C261.602 101.568 255.036 121.232 241.899 139.084C225.887 160.845 193.093 184.883 155.635 137.256C112.734 82.7081 127.258 28.6084 137.976 12.6351C145.699 1.12504 159.278 -0.524799 165.847 9.08946C192.652 51.3438 74.6992 136.092 24.9024 98.5012C-24.8944 60.9106 19.3577 -10.2217 38.8843 7.58022" stroke="#FFC76A" stroke-opacity="0.3" stroke-width="3" stroke-linecap="round"/>
                          </svg>
                        <div class="business-advantages-top-first">
                            <p class="business-advantages-top-header">Образовательные<br>и нетворкинговые<br> мероприятия
                            </p>
                            <p class="business-advantages-top-type">Онлайн и офлайн</p>
                        </div>
                        <div>
                            <p class="business-advantages-top-descr">Пример тем: постановка целей, мотивация, эмоциональное
                                выгорание, коммуникация и экологичное
                                общение</p>
                        </div>
                    </div>
                </div>
                <div class="business-advantages-bottom">
                    <svg xmlns="http://www.w3.org/2000/svg" width="253" height="6" viewBox="0 0 253 6" fill="none">
                        <path d="M1.99066 4.09439C182.511 1.97736 78.3247 1.21984 251.009 2.47609" stroke="#FFC76A" stroke-width="3" stroke-linecap="round"/>
                      </svg>
                    <div class="business-advantages-bottom-left">
                        <p class="business-advantages-top-header-bottom">Корпоративная подписка</p>
                        <p class="business-advantages-top-type">Доступно 2 тарифа</p>
                    </div>
                    <div class="business-advantages-bottom-right">
                        <h4>Self study</h4>
                        <p class="business-advantages-top-descr">Доступ к сообществу с другими участниками Careerum и к
                            образовательной платформе<br> для
                            самостоятельного изучения материалов</p>
                        <h4>VIP</h4>
                        <p class="business-advantages-top-descr">Доступ к сообществу, образовательной платформе, плюс,
                            проработатка запросов вместе с коучем на
                            сессиях</p>
                    </div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-business-advantages-mobile', {
        label: 'Страница B2B преимущество (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-business-advantages-mobile">
            <div>
                <div>
                    <h2>Наше преимущество — возможность выбрать формат, удобный для вас</h2>
                </div>
                <div class="business-advantages-top">
                    <div>
                        <svg xmlns="http://www.w3.org/2000/svg" width="300" height="120" viewBox="0 0 300 120" fill="none">
                            <path d="M190.916 -26.6458C295.34 -55.0669 592 -42.5093 592 -1.52982C592 34.1618 294.153 49.3641 204.697 53.9908C175.282 55.5121 -12 64.3885 -12 33.5011C-12 15.3583 72.2512 5.74095 175.155 5.74095C239.568 5.74095 348.739 12.3505 346.365 49.3641C344.836 73.2099 214.648 89.4916 123.277 87.6995C93.5848 87.1172 72.2512 81.7757 72.2512 75.1414C72.2512 68.0508 97.9706 66.5489 114.97 66.5489C131.97 66.5489 268.047 69.8537 276.801 105.296C279.311 115.46 262.415 120.748 247.357 116.555" stroke="#FFC76A" stroke-opacity="0.3" stroke-width="3" stroke-linecap="round"/>
                          </svg>
                        <div class="business-advantages-top-first">
                            <p class="business-advantages-top-header">Сессии с коучем</p>
                            <p class="business-advantages-top-type">Групповые и индивидуальные</p>
                        </div>
                        <div>
                            <p class="business-advantages-top-descr">Глубокая проработка запроса.<br> Например, мотивация в
                                команде, командная коммуникация,
                                управление стрессом</p>
                        </div>
                    </div>
                    <div>
                        <svg xmlns="http://www.w3.org/2000/svg" width="255" height="140" viewBox="0 0 255 140" fill="none">
                            <path d="M313.745 142.259C307.563 154.589 287.679 181.507 267.063 178.092C233.45 172.525 211.111 104.434 206.199 79.1711C201.288 53.908 204.705 24.9089 216.916 11.6682C229.127 -1.57252 241.655 -1.34701 256.199 17.5032C270.284 35.7589 274.221 57.1434 274.065 78.2257C273.845 107.873 266.226 128.205 251.737 146.915C234.076 169.722 198.625 195.446 160.766 148.073C117.406 93.8163 134.632 38.0029 146.502 21.2981C155.056 9.26089 169.445 7.09789 176.039 16.6957C202.844 58.95 75.3948 149.723 24.1627 113.043C-27.0693 76.3623 22.1259 2.09425 42.1079 19.6073" stroke="#FFC76A" stroke-opacity="0.3" stroke-width="3" stroke-linecap="round"/>
                          </svg>
                        <div class="business-advantages-top-first">
                            <p class="business-advantages-top-header">Образовательные<br>и нетворкинговые<br> мероприятия
                            </p>
                            <p class="business-advantages-top-type">Онлайн и офлайн</p>
                        </div>
                        <div>
                            <p class="business-advantages-top-descr">Пример тем: постановка целей, мотивация, эмоциональное
                                выгорание, коммуникация и экологичное
                                общение</p>
                        </div>
                    </div>
                </div>
                <div class="business-advantages-bottom">
                    <svg xmlns="http://www.w3.org/2000/svg" width="281" height="5" viewBox="0 0 281 5" fill="none">
                        <path d="M1 3.42536C126.5 -1.00829 162.2 1.99293 280 1.99171" stroke="#FFC76A" stroke-width="1.32029" stroke-linecap="round"/>
                    </svg>
                    <div class="business-advantages-bottom-left">
                        <p class="business-advantages-top-header-bottom">Корпоративная подписка</p>
                        <p class="business-advantages-top-type">Доступно 2 тарифа</p>
                    </div>
                    <div class="business-advantages-bottom-right">
                        <h4>Self study</h4>
                        <p class="business-advantages-top-descr">Доступ к сообществу с другими участниками Careerum и к
                            образовательной платформе<br> для
                            самостоятельного изучения материалов</p>
                        <h4>VIP</h4>
                        <p class="business-advantages-top-descr">Доступ к сообществу, образовательной платформе, плюс,
                            проработатка запросов вместе с коучем на
                            сессиях</p>
                    </div>
                </div>
            </div>
        </div>`
	});
    
    blockManager.add('careerum-business-about', {
        label: 'Страница B2B о нас',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-business-about">
            <div>
                <div class="business-about-top">
                    <svg xmlns="http://www.w3.org/2000/svg" width="554" height="70" viewBox="0 0 554 70" fill="none">
                        <path
                            d="M552 40.7939C533.005 65.4635 355.266 67.9938 265.892 67.9937C218.422 67.9937 13.0252 69.2588 2.34067 35.7335C-6.7138 7.32276 167.288 3.70643 218.084 2.57928C312.047 0.494237 550.813 2.5793 544.877 33.8358"
                            stroke="#FFC76A" stroke-width="3" stroke-linecap="round" />
                    </svg>
                    <h2>Проект под ключ</h2>
                </div>
                <div class="business-about-bottom">
                    <div>
                        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M15.324 3.71875H10.3386C6.23864 3.71875 3.66797 6.62142 3.66797 10.7307V21.8161C3.66797 25.9254 6.22664 28.8281 10.3386 28.8281H22.104C26.2173 28.8281 28.776 25.9254 28.776 21.8161V16.4454"
                                stroke="#130F26" stroke-width="1.96875" stroke-linecap="round" stroke-linejoin="round" />
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                d="M11.7728 14.5615L21.7368 4.59748C22.9781 3.35748 24.9901 3.35748 26.2314 4.59748L27.8541 6.22015C29.0954 7.46148 29.0954 9.47481 27.8541 10.7148L17.8421 20.7268C17.2994 21.2695 16.5634 21.5748 15.7954 21.5748H10.8008L10.9261 16.5348C10.9448 15.7935 11.2474 15.0868 11.7728 14.5615Z"
                                stroke="#130F26" stroke-width="1.96875" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M20.2227 6.13672L26.3107 12.2247" stroke="#130F26" stroke-width="1.96875"
                                stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
    
                        <p>Организуем ивент<br> в подходящем вам формате на актуальную тему </p>
                    </div>
                    <div>
                        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                d="M28.3307 16.0008C28.3307 22.8128 22.8094 28.3341 15.9974 28.3341C9.1854 28.3341 3.66406 22.8128 3.66406 16.0008C3.66406 9.18881 9.1854 3.66748 15.9974 3.66748C22.8094 3.66748 28.3307 9.18881 28.3307 16.0008Z"
                                stroke="#130F26" stroke-width="2.0625" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M20.5735 19.9237L15.5469 16.9251V10.4624" stroke="#130F26" stroke-width="2.0625"
                                stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
    
                        <p>Подберем оптимальную длительность и лучшее решение для вашей команды</p>
                    </div>
                    <div>
                        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                d="M17.4723 5.56918L19.9089 10.4368C20.1477 10.9147 20.6086 11.2461 21.1431 11.3227L26.5938 12.1073C27.9405 12.3018 28.4764 13.9339 27.5018 14.8691L23.5602 18.6564C23.1729 19.0289 22.9966 19.5642 23.0882 20.09L24.0184 25.4369C24.2475 26.7596 22.8397 27.7688 21.636 27.143L16.7643 24.6167C16.2867 24.3689 15.7147 24.3689 15.2357 24.6167L10.364 27.143C9.16031 27.7688 7.75253 26.7596 7.98299 25.4369L8.9118 20.09C9.00343 19.5642 8.82711 19.0289 8.43976 18.6564L4.49824 14.8691C3.52362 13.9339 4.05952 12.3018 5.40622 12.1073L10.8569 11.3227C11.3914 11.2461 11.8537 10.9147 12.0925 10.4368L14.5277 5.56918C15.1302 4.36561 16.8698 4.36561 17.4723 5.56918Z"
                                stroke="#130F26" stroke-width="2.0625" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
    
                        <p>Подготовим дополнительные материалы под ваш запрос</p>
                    </div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-business-about-tablet', {
        label: 'Страница B2B о нас (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-business-about-tablet">
            <div>
                <div class="business-about-top">
                    <svg xmlns="http://www.w3.org/2000/svg" width="364" height="47" viewBox="0 0 364 47" fill="none">
                        <path d="M362 27.3926C349.567 43.54 233.228 45.1961 174.729 45.1961C143.658 45.1961 9.21648 46.0242 2.22297 24.0803C-3.70359 5.48419 110.189 3.11713 143.436 2.37937C204.94 1.01461 361.223 2.37938 357.338 22.8382" stroke="#FFC76A" stroke-width="3" stroke-linecap="round"/>
                      </svg>
                    <h2>Проект под ключ</h2>
                </div>
                <div class="business-about-bottom">
                    <div>
                        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M15.324 3.71875H10.3386C6.23864 3.71875 3.66797 6.62142 3.66797 10.7307V21.8161C3.66797 25.9254 6.22664 28.8281 10.3386 28.8281H22.104C26.2173 28.8281 28.776 25.9254 28.776 21.8161V16.4454"
                                stroke="#130F26" stroke-width="1.96875" stroke-linecap="round" stroke-linejoin="round" />
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                d="M11.7728 14.5615L21.7368 4.59748C22.9781 3.35748 24.9901 3.35748 26.2314 4.59748L27.8541 6.22015C29.0954 7.46148 29.0954 9.47481 27.8541 10.7148L17.8421 20.7268C17.2994 21.2695 16.5634 21.5748 15.7954 21.5748H10.8008L10.9261 16.5348C10.9448 15.7935 11.2474 15.0868 11.7728 14.5615Z"
                                stroke="#130F26" stroke-width="1.96875" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M20.2227 6.13672L26.3107 12.2247" stroke="#130F26" stroke-width="1.96875"
                                stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
    
                        <p>Организуем ивент<br> в подходящем вам формате на актуальную тему </p>
                    </div>
                    <div>
                        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                d="M28.3307 16.0008C28.3307 22.8128 22.8094 28.3341 15.9974 28.3341C9.1854 28.3341 3.66406 22.8128 3.66406 16.0008C3.66406 9.18881 9.1854 3.66748 15.9974 3.66748C22.8094 3.66748 28.3307 9.18881 28.3307 16.0008Z"
                                stroke="#130F26" stroke-width="2.0625" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M20.5735 19.9237L15.5469 16.9251V10.4624" stroke="#130F26" stroke-width="2.0625"
                                stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
    
                        <p>Подберем оптимальную длительность и лучшее решение для вашей команды</p>
                    </div>
                    <div>
                        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                d="M17.4723 5.56918L19.9089 10.4368C20.1477 10.9147 20.6086 11.2461 21.1431 11.3227L26.5938 12.1073C27.9405 12.3018 28.4764 13.9339 27.5018 14.8691L23.5602 18.6564C23.1729 19.0289 22.9966 19.5642 23.0882 20.09L24.0184 25.4369C24.2475 26.7596 22.8397 27.7688 21.636 27.143L16.7643 24.6167C16.2867 24.3689 15.7147 24.3689 15.2357 24.6167L10.364 27.143C9.16031 27.7688 7.75253 26.7596 7.98299 25.4369L8.9118 20.09C9.00343 19.5642 8.82711 19.0289 8.43976 18.6564L4.49824 14.8691C3.52362 13.9339 4.05952 12.3018 5.40622 12.1073L10.8569 11.3227C11.3914 11.2461 11.8537 10.9147 12.0925 10.4368L14.5277 5.56918C15.1302 4.36561 16.8698 4.36561 17.4723 5.56918Z"
                                stroke="#130F26" stroke-width="2.0625" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
    
                        <p>Подготовим дополнительные материалы под ваш запрос</p>
                    </div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-business-about-mobile', {
        label: 'Страница B2B о нас (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-business-about-mobile">
            <div>
                <div class="business-about-top">
                    <svg xmlns="http://www.w3.org/2000/svg" width="211" height="34" viewBox="0 0 211 34" fill="none">
                        <path d="M210 19.8092C202.782 31.7702 135.241 32.997 101.279 32.997C83.2403 32.997 5.18958 33.6104 1.12946 17.3556C-2.31124 3.58073 63.8096 1.82736 83.1117 1.28086C118.818 0.269932 209.549 1.28087 207.293 16.4355" stroke="#FFC76A" stroke-width="1.4" stroke-linecap="round"/>
                      </svg>
                    <h2>Проект под ключ</h2>
                </div>
                <div class="business-about-bottom">
                    <div>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M11.492 2.78955H7.753C4.678 2.78955 2.75 4.96655 2.75 8.04855V16.3626C2.75 19.4446 4.669 21.6216 7.753 21.6216H16.577C19.662 21.6216 21.581 19.4446 21.581 16.3626V12.3346" stroke="#130F26" stroke-width="1.47656" stroke-linecap="round" stroke-linejoin="round"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M8.83056 10.9215L16.3036 3.44848C17.2346 2.51848 18.7436 2.51848 19.6746 3.44848L20.8916 4.66548C21.8226 5.59648 21.8226 7.10648 20.8916 8.03648L13.3826 15.5455C12.9756 15.9525 12.4236 16.1815 11.8476 16.1815H8.10156L8.19556 12.4015C8.20956 11.8455 8.43656 11.3155 8.83056 10.9215Z" stroke="#130F26" stroke-width="1.47656" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M15.1641 4.60303L19.7301 9.16903" stroke="#130F26" stroke-width="1.47656" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        <p>Организуем ивент<br> в подходящем вам формате на актуальную тему </p>
                    </div>
                    <div>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M21.25 12.0005C21.25 17.1095 17.109 21.2505 12 21.2505C6.891 21.2505 2.75 17.1095 2.75 12.0005C2.75 6.89149 6.891 2.75049 12 2.75049C17.109 2.75049 21.25 6.89149 21.25 12.0005Z" stroke="#130F26" stroke-width="1.54688" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M15.4341 14.9427L11.6641 12.6937V7.84668" stroke="#130F26" stroke-width="1.54688" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        <p>Подберем оптимальную длительность и лучшее решение для вашей команды</p>
                    </div>
                    <div>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M13.1043 4.17701L14.9317 7.82776C15.1108 8.18616 15.4565 8.43467 15.8574 8.49218L19.9453 9.08062C20.9554 9.22644 21.3573 10.4505 20.6263 11.1519L17.6702 13.9924C17.3797 14.2718 17.2474 14.6733 17.3162 15.0676L18.0138 19.0778C18.1856 20.0698 17.1298 20.8267 16.227 20.3574L12.5732 18.4627C12.215 18.2768 11.786 18.2768 11.4268 18.4627L7.77301 20.3574C6.87023 20.8267 5.81439 20.0698 5.98724 19.0778L6.68385 15.0676C6.75257 14.6733 6.62033 14.2718 6.32982 13.9924L3.37368 11.1519C2.64272 10.4505 3.04464 9.22644 4.05466 9.08062L8.14265 8.49218C8.54354 8.43467 8.89028 8.18616 9.06937 7.82776L10.8957 4.17701C11.3477 3.27433 12.6524 3.27433 13.1043 4.17701Z" stroke="#130F26" stroke-width="1.54688" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>    
                        <p>Подготовим дополнительные материалы под ваш запрос</p>
                    </div>
                </div>
            </div>
        </div>`
	});
    
    blockManager.add('careerum-business-form', {
        label: 'Страница B2B форма',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-business-form google-sheets-form-block">
            <div>
                <div class="business-form-left">
                    <h2>Оставьте заявку</h2>
                    <div class="careerum-registration-form">
                        <form class="deva-form getcourse-email-signup" name="devaRegistrationForm"
                            data-gjs-type="deva-registration-form">
                            <div class="business-form-label">
                                <p>Контактные данные</p>
                            </div>
                            <div class="business-form-name">
                                <input type="text" name="name" value="" placeholder="Имя и фамилия" required>
                            </div>
                            <div class="business-form-email">
                                <input type="email" name="email" value="" placeholder="Почта" required>
                            </div>
                            <div class="business-form-tel">
                                <input type="tel" value="" name="tl" required class="itl-input">
                            </div>
                            <div class="business-form-company">
                                <input type="text" name="company" value="" placeholder="Компания" required>
                            </div>
                            <div class="business-form-label">
                                <p>Ваш запрос</p>
                            </div>
                            <div class="business-form-question">
                                <textarea type="text" name="question" value="" placeholder="Краткое описание запроса"
                                    required></textarea>
                            </div>
                            <div class="business-form-label">
                                <p>Как с вами связаться</p>
                            </div>
                            <div class="business-form-connect no-select">
                                <input type="text" readonly placeholder="Выберите способ связи">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                        d="M2.75 12C2.75 17.108 6.891 21.25 12 21.25C17.108 21.25 21.25 17.108 21.25 12C21.25 6.892 17.108 2.75 12 2.75C6.891 2.75 2.75 6.892 2.75 12Z"
                                        stroke="#827F7C" stroke-width="1.5" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path d="M8.52734 10.5576L11.9983 14.0436L15.4693 10.5576" stroke="#827F7C"
                                        stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                <div class="business-form-connect-dropdown">
                                    <ul>
                                        <li>По электронной почте</li>
                                        <li>По номеру телефона</li>
                                        <li>В Telegram</li>
                                        <li>В WhatsApp</li>
                                    </ul>
                                </div>
                            </div>
                            <div class="business-form-agree no-select">
                                <label>
                                    <input type="checkbox" name="agree">
                                    <div>
                                        <svg width="8" height="8" viewBox="0 0 8 8" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M1 2.84615L3.14168 6.70118C3.21595 6.83487 3.40669 6.83912 3.48685 6.70887L7 1"
                                                stroke="black" stroke-width="1.5" stroke-linecap="round" />
                                        </svg>
                                    </div>
                                </label>
                                <p>Я даю согласие на обработку своих персональных данных в соответствии с <a
                                        href="#">Политикой конфиденциальности</a></p>
                            </div>
                            <a href="#" disabled class="submit-btn btn-color-main-dark-orange">
                                <p class="submit-btn-text">Оставить заявку</p>
                                <p class="submit-btn-sending-text">Отправляем заявку</p>
                                <p class="submit-btn-success-text">Заявка отправлена</p>
                                <p class="flare"></p>
                            </a>
                            <input type="hidden" name="firstname">
                            <input type="hidden" name="lastname">
                            <input type="hidden" name="tel">
                        </form>
                    </div>
                </div>
                <div class="business-form-right">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1705560776172.svg" alt=""
                        class="business-form-right-bg">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1705560791299.png" alt=""
                        class="business-form-right-hum">
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-business-form-tablet', {
        label: 'Страница B2B форма (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-business-form-tablet google-sheets-form-block">
            <div>
                <div class="business-form-left">
                    <h2>Оставьте заявку</h2>
                    <div class="careerum-registration-form-tablet">
                        <form class="deva-form getcourse-email-signup" name="devaRegistrationForm"
                            data-gjs-type="deva-registration-form">
                            <div class="business-form-label">
                                <p>Контактные данные</p>
                            </div>
                            <div class="business-form-name">
                                <input type="text" name="name" value="" placeholder="Имя и фамилия" required>
                            </div>
                            <div class="business-form-email">
                                <input type="email" name="email" value="" placeholder="Почта" required>
                            </div>
                            <div class="business-form-tel">
                                <input type="tel" value="" name="tl" required class="itl-input">
                            </div>
                            <div class="business-form-company">
                                <input type="text" name="company" value="" placeholder="Компания" required>
                            </div>
                            <div class="business-form-label">
                                <p>Ваш запрос</p>
                            </div>
                            <div class="business-form-question">
                                <textarea type="text" name="question" value="" placeholder="Краткое описание запроса"
                                    required></textarea>
                            </div>
                            <div class="business-form-label">
                                <p>Как с вами связаться</p>
                            </div>
                            <div class="business-form-connect no-select">
                                <input type="text" readonly placeholder="Выберите способ связи">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                        d="M2.75 12C2.75 17.108 6.891 21.25 12 21.25C17.108 21.25 21.25 17.108 21.25 12C21.25 6.892 17.108 2.75 12 2.75C6.891 2.75 2.75 6.892 2.75 12Z"
                                        stroke="#827F7C" stroke-width="1.5" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path d="M8.52734 10.5576L11.9983 14.0436L15.4693 10.5576" stroke="#827F7C"
                                        stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                <div class="business-form-connect-dropdown">
                                    <ul>
                                        <li>По электронной почте</li>
                                        <li>По номеру телефона</li>
                                        <li>В Telegram</li>
                                        <li>В WhatsApp</li>
                                    </ul>
                                </div>
                            </div>
                            <div class="business-form-agree no-select">
                                <label>
                                    <input type="checkbox" name="agree">
                                    <div>
                                        <svg width="8" height="8" viewBox="0 0 8 8" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M1 2.84615L3.14168 6.70118C3.21595 6.83487 3.40669 6.83912 3.48685 6.70887L7 1"
                                                stroke="black" stroke-width="1.5" stroke-linecap="round" />
                                        </svg>
                                    </div>
                                </label>
                                <p>Я даю согласие на обработку своих персональных данных в соответствии с <a
                                        href="#">Политикой конфиденциальности</a></p>
                            </div>
                            <a href="#" disabled class="submit-btn btn-color-main-dark-orange">
                                <p class="submit-btn-text">Оставить заявку</p>
                                <!-- <p class="submit-btn-sending-text">Отправляем заявку</p>
                                <p class="submit-btn-success-text">Заявка отправлена</p>
                                <p class="flare"></p> -->
                            </a>
                            <input type="hidden" name="firstname">
                            <input type="hidden" name="lastname">
                            <input type="hidden" name="tel">
                        </form>
                    </div>
                </div>
                <div class="business-form-right">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1705571321680.svg" alt=""
                        class="business-form-right-bg">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1705571249185.png" alt=""
                        class="business-form-right-hum">
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-business-form-mobile', {
        label: 'Страница B2B форма (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-business-form-mobile google-sheets-form-block">
            <div>
                <div class="business-form-left">
                    <h2>Оставьте заявку</h2>
                    <div class="careerum-registration-form-mobile">
                        <form class="deva-form getcourse-email-signup" name="devaRegistrationForm"
                            data-gjs-type="deva-registration-form">
                            <div class="business-form-label">
                                <p>Контактные данные</p>
                            </div>
                            <div class="business-form-name">
                                <input type="text" name="name" value="" placeholder="Имя и фамилия" required>
                            </div>
                            <div class="business-form-email">
                                <input type="email" name="email" value="" placeholder="Почта" required>
                            </div>
                            <div class="business-form-tel">
                                <input type="tel" value="" name="tl" required class="itl-input">
                            </div>
                            <div class="business-form-company">
                                <input type="text" name="company" value="" placeholder="Компания" required>
                            </div>
                            <div class="business-form-label">
                                <p>Ваш запрос</p>
                            </div>
                            <div class="business-form-question">
                                <textarea type="text" name="question" value="" placeholder="Краткое описание запроса"
                                    required></textarea>
                            </div>
                            <div class="business-form-label">
                                <p>Как с вами связаться</p>
                            </div>
                            <div class="business-form-connect no-select">
                                <input type="text" readonly placeholder="Выберите способ связи">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                        d="M2.75 12C2.75 17.108 6.891 21.25 12 21.25C17.108 21.25 21.25 17.108 21.25 12C21.25 6.892 17.108 2.75 12 2.75C6.891 2.75 2.75 6.892 2.75 12Z"
                                        stroke="#827F7C" stroke-width="1.5" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path d="M8.52734 10.5576L11.9983 14.0436L15.4693 10.5576" stroke="#827F7C"
                                        stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                <div class="business-form-connect-dropdown">
                                    <ul>
                                        <li>По электронной почте</li>
                                        <li>По номеру телефона</li>
                                        <li>В Telegram</li>
                                        <li>В WhatsApp</li>
                                    </ul>
                                </div>
                            </div>
                            <div class="business-form-agree no-select">
                                <label>
                                    <input type="checkbox" name="agree">
                                    <div>
                                        <svg width="8" height="8" viewBox="0 0 8 8" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M1 2.84615L3.14168 6.70118C3.21595 6.83487 3.40669 6.83912 3.48685 6.70887L7 1"
                                                stroke="black" stroke-width="1.5" stroke-linecap="round" />
                                        </svg>
                                    </div>
                                </label>
                                <p>Я даю согласие на обработку своих персональных данных в соответствии с <a
                                        href="#">Политикой конфиденциальности</a></p>
                            </div>
                            <a href="#" disabled class="submit-btn btn-color-main-dark-orange">
                                <p class="submit-btn-text">Оставить заявку</p>
                                <!-- <p class="submit-btn-sending-text">Отправляем заявку</p>
                                <p class="submit-btn-success-text">Заявка отправлена</p>
                                <p class="flare"></p> -->
                            </a>
                            <input type="hidden" name="firstname">
                            <input type="hidden" name="lastname">
                            <input type="hidden" name="tel">
                        </form>
                    </div>
                </div>
                <div class="business-form-right">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1705576750468.svg" alt=""
                        class="business-form-right-bg">
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-thanks-popup', {
        label: 'Страница B2B попап',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-popup careerum-thanks-popup" id="000">
            <div class="popup__close-button-wrapper">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1677062419516.svg" alt="" class="close-switch">
            </div>
    
            <div class="careerum-thanks-popup-content">
                <div>
                    <div class="careerum-thanks-popup-content-left">
                        <svg width="53" height="53" viewBox="0 0 53 53" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                d="M36.0683 6.07349H16.9243C10.2529 6.07349 6.07031 10.7971 6.07031 17.4817V35.5194C6.07031 42.204 10.233 46.9277 16.9243 46.9277H36.0661C42.7596 46.9277 46.9245 42.204 46.9245 35.5194V17.4817C46.9245 10.7971 42.7596 6.07349 36.0683 6.07349Z"
                                stroke="#FFC76A" stroke-width="3.3125" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M18.6406 26.5004L23.8832 31.7408L34.364 21.26" stroke="#FFC76A" stroke-width="3.3125"
                                stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </div>
                    <div class="careerum-thanks-popup-content-right">
                        <p class="careerum-thanks-popup-content-right-header">Спасибо, что оставили заявку!</p>
                        <p class="careerum-thanks-popup-content-right-text">Мы свяжемся с вами в&nbsp;ближайшее время</p>
                    </div>
                </div>
            </div>
        </div>`
	});
    
    blockManager.add('careerum-intens-main', {
        label: 'Интенсив главный',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-intens-main">
            <div>
                <div class="careerum-intens-main-left">
                    <div class="careerum-intens-main-left-top">
                        <div>
                            <p>С 5 по 20 февраля</p>
                        </div>
                        <div>
                            <p>Скорая помощь для резюме</p>
                        </div>
                    </div>
                    <div class="careerum-intens-main-left-bottom">
                        <h1>CV, в которое влюбятся рекрутеры</h1>
                        <p>Для тех, кто уже ищет работу, и для тех, кто хочет быть готов<br> к внезапным переменам</p>
                    </div>
                    <div class="careerum-intens-main-left-link">
                        <a href="#buy" class="btn-color-main-dark-orange">Записаться на интенсив</a>
                    </div>
                </div>
                <div class="careerum-intens-main-right">
                    <div>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path
                                d="M17.9189 14.32C17.6599 14.571 17.5409 14.934 17.5999 15.29L18.4889 20.21C18.5639 20.627 18.3879 21.049 18.0389 21.29C17.6969 21.54 17.2419 21.57 16.8689 21.37L12.4399 19.06C12.2859 18.978 12.1149 18.934 11.9399 18.929H11.6689C11.5749 18.943 11.4829 18.973 11.3989 19.019L6.96888 21.34C6.74988 21.45 6.50188 21.489 6.25888 21.45C5.66688 21.338 5.27188 20.774 5.36888 20.179L6.25888 15.259C6.31788 14.9 6.19888 14.535 5.93988 14.28L2.32888 10.78C2.02688 10.487 1.92188 10.047 2.05988 9.65C2.19388 9.254 2.53588 8.965 2.94888 8.9L7.91888 8.179C8.29688 8.14 8.62888 7.91 8.79888 7.57L10.9889 3.08C11.0409 2.98 11.1079 2.888 11.1889 2.81L11.2789 2.74C11.3259 2.688 11.3799 2.645 11.4399 2.61L11.5489 2.57L11.7189 2.5H12.1399C12.5159 2.539 12.8469 2.764 13.0199 3.1L15.2389 7.57C15.3989 7.897 15.7099 8.124 16.0689 8.179L21.0389 8.9C21.4589 8.96 21.8099 9.25 21.9489 9.65C22.0799 10.051 21.9669 10.491 21.6589 10.78L17.9189 14.32Z"
                                fill="black" />
                        </svg>
                        <p>Алгоритм усиления резюме: проверен 5 000+ соискателей</p>
                    </div>
                    <div>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path
                                d="M19.9898 18.9533C20.5469 18.9533 21 19.4123 21 19.9766C21 20.5421 20.5469 21 19.9898 21H14.2797C13.7226 21 13.2695 20.5421 13.2695 19.9766C13.2695 19.4123 13.7226 18.9533 14.2797 18.9533H19.9898ZM16.0299 3.69906L17.5049 4.87078C18.1097 5.34377 18.513 5.96726 18.6509 6.62299C18.8101 7.3443 18.6403 8.0527 18.1628 8.66544L9.3764 20.0279C8.97316 20.5439 8.37891 20.8341 7.74222 20.8449L4.24039 20.8879C4.04939 20.8879 3.89021 20.7589 3.84777 20.5761L3.0519 17.1255C2.91395 16.4912 3.0519 15.8355 3.45514 15.3303L9.68413 7.26797C9.79025 7.13898 9.98126 7.11855 10.1086 7.21422L12.7297 9.29967C12.8994 9.43942 13.1329 9.51467 13.377 9.48242C13.8969 9.41792 14.2471 8.94493 14.1941 8.43969C14.1622 8.1817 14.0349 7.96671 13.8651 7.80546C13.812 7.76246 11.3183 5.76301 11.3183 5.76301C11.1591 5.63401 11.1273 5.39752 11.2546 5.23735L12.2415 3.95706C13.1541 2.78534 14.7459 2.67784 16.0299 3.69906Z"
                                fill="black" />
                        </svg>
                        <p>Эффективный формат: фокус на резюме участников и рабочие инструменты</p>
                    </div>
                    <div>
                        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="20" viewBox="0 0 17 20" fill="none">
                            <path
                                d="M9.75247 0C10.0099 0 10.2079 0.21 10.2079 0.46V3.68C10.2079 5.51 11.703 7.01 13.5149 7.02C14.2673 7.02 14.8614 7.03 15.3168 7.03L15.4855 7.02926C15.7899 7.02694 16.1997 7.02 16.5545 7.02C16.802 7.02 17 7.22 17 7.47V15.51C17 17.99 15.0099 20 12.5545 20H4.67327C2.09901 20 0 17.89 0 15.29V4.51C0 2.03 2 0 4.46535 0H9.75247ZM10.8119 12.9H5.42574C5.0198 12.9 4.68317 13.23 4.68317 13.64C4.68317 14.05 5.0198 14.39 5.42574 14.39H10.8119C11.2178 14.39 11.5545 14.05 11.5545 13.64C11.5545 13.23 11.2178 12.9 10.8119 12.9ZM8.77228 7.9H5.42574C5.0198 7.9 4.68317 8.24 4.68317 8.65C4.68317 9.06 5.0198 9.39 5.42574 9.39H8.77228C9.17822 9.39 9.51485 9.06 9.51485 8.65C9.51485 8.24 9.17822 7.9 8.77228 7.9ZM11.6507 0.906C11.6507 0.475 12.1685 0.261 12.4646 0.572C13.5349 1.696 15.4051 3.661 16.4507 4.759C16.7398 5.062 16.5279 5.565 16.1111 5.566C15.2972 5.569 14.3378 5.566 13.6477 5.559C12.5527 5.559 11.6507 4.648 11.6507 3.542V0.906Z"
                                fill="black" />
                        </svg>
                        <p>Выжимка практических знаний: легко усвоить за полторы недели и применить к CV</p>
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1706173368563.png" alt="">
                        <p>Эксперт: специалист, работавшая с сотрудниками Microsoft, Disney, Mastercard и др. </p>
                    </div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-intens-main-tablet', {
        label: 'Интенсив главный (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-intens-main-tablet">
            <div>
                <div class="careerum-intens-main-left">
                    <div class="careerum-intens-main-left-top">
                        <div>
                            <p>С 5 по 20 февраля</p>
                        </div>
                        <div>
                            <p>Скорая помощь для резюме</p>
                        </div>
                    </div>
                    <div class="careerum-intens-main-left-bottom">
                        <h2>CV, в которое влюбятся рекрутеры</h2>
                        <p>Для тех, кто уже ищет работу, и для тех,<br> кто хочет быть готов к внезапным переменам</p>
                    </div>
                    <div class="careerum-intens-main-left-link">
                        <a href="#buy" class="btn-color-main-dark-orange">Оставить заявку</a>
                    </div>
                </div>
                <div class="careerum-intens-main-right">
                    <div>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path
                                d="M17.9189 14.32C17.6599 14.571 17.5409 14.934 17.5999 15.29L18.4889 20.21C18.5639 20.627 18.3879 21.049 18.0389 21.29C17.6969 21.54 17.2419 21.57 16.8689 21.37L12.4399 19.06C12.2859 18.978 12.1149 18.934 11.9399 18.929H11.6689C11.5749 18.943 11.4829 18.973 11.3989 19.019L6.96888 21.34C6.74988 21.45 6.50188 21.489 6.25888 21.45C5.66688 21.338 5.27188 20.774 5.36888 20.179L6.25888 15.259C6.31788 14.9 6.19888 14.535 5.93988 14.28L2.32888 10.78C2.02688 10.487 1.92188 10.047 2.05988 9.65C2.19388 9.254 2.53588 8.965 2.94888 8.9L7.91888 8.179C8.29688 8.14 8.62888 7.91 8.79888 7.57L10.9889 3.08C11.0409 2.98 11.1079 2.888 11.1889 2.81L11.2789 2.74C11.3259 2.688 11.3799 2.645 11.4399 2.61L11.5489 2.57L11.7189 2.5H12.1399C12.5159 2.539 12.8469 2.764 13.0199 3.1L15.2389 7.57C15.3989 7.897 15.7099 8.124 16.0689 8.179L21.0389 8.9C21.4589 8.96 21.8099 9.25 21.9489 9.65C22.0799 10.051 21.9669 10.491 21.6589 10.78L17.9189 14.32Z"
                                fill="black" />
                        </svg>
                        <p>Алгоритм усиления резюме: проверен 5 000+ соискателей</p>
                    </div>
                    <div>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path
                                d="M19.9898 18.9533C20.5469 18.9533 21 19.4123 21 19.9766C21 20.5421 20.5469 21 19.9898 21H14.2797C13.7226 21 13.2695 20.5421 13.2695 19.9766C13.2695 19.4123 13.7226 18.9533 14.2797 18.9533H19.9898ZM16.0299 3.69906L17.5049 4.87078C18.1097 5.34377 18.513 5.96726 18.6509 6.62299C18.8101 7.3443 18.6403 8.0527 18.1628 8.66544L9.3764 20.0279C8.97316 20.5439 8.37891 20.8341 7.74222 20.8449L4.24039 20.8879C4.04939 20.8879 3.89021 20.7589 3.84777 20.5761L3.0519 17.1255C2.91395 16.4912 3.0519 15.8355 3.45514 15.3303L9.68413 7.26797C9.79025 7.13898 9.98126 7.11855 10.1086 7.21422L12.7297 9.29967C12.8994 9.43942 13.1329 9.51467 13.377 9.48242C13.8969 9.41792 14.2471 8.94493 14.1941 8.43969C14.1622 8.1817 14.0349 7.96671 13.8651 7.80546C13.812 7.76246 11.3183 5.76301 11.3183 5.76301C11.1591 5.63401 11.1273 5.39752 11.2546 5.23735L12.2415 3.95706C13.1541 2.78534 14.7459 2.67784 16.0299 3.69906Z"
                                fill="black" />
                        </svg>
                        <p>Эффективный формат: фокус на резюме участников и рабочие инструменты</p>
                    </div>
                    <div>
                        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="20" viewBox="0 0 17 20" fill="none">
                            <path
                                d="M9.75247 0C10.0099 0 10.2079 0.21 10.2079 0.46V3.68C10.2079 5.51 11.703 7.01 13.5149 7.02C14.2673 7.02 14.8614 7.03 15.3168 7.03L15.4855 7.02926C15.7899 7.02694 16.1997 7.02 16.5545 7.02C16.802 7.02 17 7.22 17 7.47V15.51C17 17.99 15.0099 20 12.5545 20H4.67327C2.09901 20 0 17.89 0 15.29V4.51C0 2.03 2 0 4.46535 0H9.75247ZM10.8119 12.9H5.42574C5.0198 12.9 4.68317 13.23 4.68317 13.64C4.68317 14.05 5.0198 14.39 5.42574 14.39H10.8119C11.2178 14.39 11.5545 14.05 11.5545 13.64C11.5545 13.23 11.2178 12.9 10.8119 12.9ZM8.77228 7.9H5.42574C5.0198 7.9 4.68317 8.24 4.68317 8.65C4.68317 9.06 5.0198 9.39 5.42574 9.39H8.77228C9.17822 9.39 9.51485 9.06 9.51485 8.65C9.51485 8.24 9.17822 7.9 8.77228 7.9ZM11.6507 0.906C11.6507 0.475 12.1685 0.261 12.4646 0.572C13.5349 1.696 15.4051 3.661 16.4507 4.759C16.7398 5.062 16.5279 5.565 16.1111 5.566C15.2972 5.569 14.3378 5.566 13.6477 5.559C12.5527 5.559 11.6507 4.648 11.6507 3.542V0.906Z"
                                fill="black" />
                        </svg>
                        <p>Выжимка практических знаний: легко усвоить за полторы недели и применить к CV</p>
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1706193967248.png" alt="">
                        <p>Эксперт: специалист, работавшая с сотрудниками Microsoft, Disney, Mastercard и др. </p>
                    </div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-intens-main-mobile', {
        label: 'Интенсив главный (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-intens-main-mobile">
            <div>
                <div class="careerum-intens-main-left">
                    <div class="careerum-intens-main-left-top">
                        <div>
                            <p>С 5 по 20 февраля</p>
                        </div>
                        <div>
                            <p>Скорая помощь для резюме</p>
                        </div>
                    </div>
                    <div class="careerum-intens-main-left-bottom">
                        <h2>CV, в которое влюбятся рекрутеры</h2>
                        <p>Для тех, кто уже ищет работу,<br> и для тех, кто хочет быть готов<br> к внезапным переменам</p>
                    </div>
                    <div class="careerum-intens-main-left-link">
                        <a href="#buy" class="btn-color-main-dark-orange">Записаться на интенсив</a>
                    </div>
                </div>
                <div class="careerum-intens-main-right">
                    <div>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path
                                d="M17.9189 14.32C17.6599 14.571 17.5409 14.934 17.5999 15.29L18.4889 20.21C18.5639 20.627 18.3879 21.049 18.0389 21.29C17.6969 21.54 17.2419 21.57 16.8689 21.37L12.4399 19.06C12.2859 18.978 12.1149 18.934 11.9399 18.929H11.6689C11.5749 18.943 11.4829 18.973 11.3989 19.019L6.96888 21.34C6.74988 21.45 6.50188 21.489 6.25888 21.45C5.66688 21.338 5.27188 20.774 5.36888 20.179L6.25888 15.259C6.31788 14.9 6.19888 14.535 5.93988 14.28L2.32888 10.78C2.02688 10.487 1.92188 10.047 2.05988 9.65C2.19388 9.254 2.53588 8.965 2.94888 8.9L7.91888 8.179C8.29688 8.14 8.62888 7.91 8.79888 7.57L10.9889 3.08C11.0409 2.98 11.1079 2.888 11.1889 2.81L11.2789 2.74C11.3259 2.688 11.3799 2.645 11.4399 2.61L11.5489 2.57L11.7189 2.5H12.1399C12.5159 2.539 12.8469 2.764 13.0199 3.1L15.2389 7.57C15.3989 7.897 15.7099 8.124 16.0689 8.179L21.0389 8.9C21.4589 8.96 21.8099 9.25 21.9489 9.65C22.0799 10.051 21.9669 10.491 21.6589 10.78L17.9189 14.32Z"
                                fill="black" />
                        </svg>
                        <p>Алгоритм усиления резюме: проверен 5 000+ соискателей</p>
                    </div>
                    <div>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path
                                d="M19.9898 18.9533C20.5469 18.9533 21 19.4123 21 19.9766C21 20.5421 20.5469 21 19.9898 21H14.2797C13.7226 21 13.2695 20.5421 13.2695 19.9766C13.2695 19.4123 13.7226 18.9533 14.2797 18.9533H19.9898ZM16.0299 3.69906L17.5049 4.87078C18.1097 5.34377 18.513 5.96726 18.6509 6.62299C18.8101 7.3443 18.6403 8.0527 18.1628 8.66544L9.3764 20.0279C8.97316 20.5439 8.37891 20.8341 7.74222 20.8449L4.24039 20.8879C4.04939 20.8879 3.89021 20.7589 3.84777 20.5761L3.0519 17.1255C2.91395 16.4912 3.0519 15.8355 3.45514 15.3303L9.68413 7.26797C9.79025 7.13898 9.98126 7.11855 10.1086 7.21422L12.7297 9.29967C12.8994 9.43942 13.1329 9.51467 13.377 9.48242C13.8969 9.41792 14.2471 8.94493 14.1941 8.43969C14.1622 8.1817 14.0349 7.96671 13.8651 7.80546C13.812 7.76246 11.3183 5.76301 11.3183 5.76301C11.1591 5.63401 11.1273 5.39752 11.2546 5.23735L12.2415 3.95706C13.1541 2.78534 14.7459 2.67784 16.0299 3.69906Z"
                                fill="black" />
                        </svg>
                        <p>Эффективный формат: фокус на резюме участников<br> и рабочие инструменты</p>
                    </div>
                    <div>
                        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="20" viewBox="0 0 17 20" fill="none">
                            <path
                                d="M9.75247 0C10.0099 0 10.2079 0.21 10.2079 0.46V3.68C10.2079 5.51 11.703 7.01 13.5149 7.02C14.2673 7.02 14.8614 7.03 15.3168 7.03L15.4855 7.02926C15.7899 7.02694 16.1997 7.02 16.5545 7.02C16.802 7.02 17 7.22 17 7.47V15.51C17 17.99 15.0099 20 12.5545 20H4.67327C2.09901 20 0 17.89 0 15.29V4.51C0 2.03 2 0 4.46535 0H9.75247ZM10.8119 12.9H5.42574C5.0198 12.9 4.68317 13.23 4.68317 13.64C4.68317 14.05 5.0198 14.39 5.42574 14.39H10.8119C11.2178 14.39 11.5545 14.05 11.5545 13.64C11.5545 13.23 11.2178 12.9 10.8119 12.9ZM8.77228 7.9H5.42574C5.0198 7.9 4.68317 8.24 4.68317 8.65C4.68317 9.06 5.0198 9.39 5.42574 9.39H8.77228C9.17822 9.39 9.51485 9.06 9.51485 8.65C9.51485 8.24 9.17822 7.9 8.77228 7.9ZM11.6507 0.906C11.6507 0.475 12.1685 0.261 12.4646 0.572C13.5349 1.696 15.4051 3.661 16.4507 4.759C16.7398 5.062 16.5279 5.565 16.1111 5.566C15.2972 5.569 14.3378 5.566 13.6477 5.559C12.5527 5.559 11.6507 4.648 11.6507 3.542V0.906Z"
                                fill="black" />
                        </svg>
                        <p>Выжимка практических знаний: легко усвоить за полторы недели и применить к CV</p>
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1706193967248.png" alt="">
                        <p>Эксперт: специалист, работавшая с сотрудниками Microsoft, Disney, Mastercard и др. </p>
                    </div>
                </div>
            </div>
        </div>`
	});
    
    blockManager.add('careerum-intens-bonus', {
        label: 'Интенсив результат',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-intens-bonus">
            <div>
                <div>
                    <h2>В формате онлайн-встреч и прожарок научимся упаковывать опыт так, чтобы:</h2>
                </div>
                <div class="intens-bonus-wrapper">
                    <div>
                        <div>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path
                                    d="M8.28002 2.50015C8.91002 2.51931 9.52002 2.62931 10.111 2.83031H10.17C10.21 2.84931 10.24 2.87031 10.26 2.88931C10.481 2.96031 10.69 3.04031 10.89 3.15031L11.27 3.32031C11.42 3.40031 11.6 3.54931 11.7 3.61031C11.8 3.66931 11.91 3.73031 12 3.79931C13.111 2.95031 14.46 2.49031 15.85 2.50015C16.481 2.50015 17.111 2.58931 17.71 2.79031C21.401 3.99031 22.731 8.04031 21.62 11.5803C20.99 13.3893 19.96 15.0403 18.611 16.3893C16.68 18.2593 14.561 19.9193 12.28 21.3493L12.03 21.5003L11.77 21.3393C9.48102 19.9193 7.35002 18.2593 5.40102 16.3793C4.06102 15.0303 3.03002 13.3893 2.39002 11.5803C1.26002 8.04031 2.59002 3.99031 6.32102 2.76931C6.61102 2.66931 6.91002 2.59931 7.21002 2.56031H7.33002C7.61102 2.51931 7.89002 2.50015 8.17002 2.50015H8.28002ZM17.19 5.66031C16.78 5.51931 16.33 5.74031 16.18 6.16031C16.04 6.58031 16.26 7.04031 16.68 7.18931C17.321 7.42931 17.75 8.06031 17.75 8.75931V8.79031C17.731 9.01931 17.8 9.24031 17.94 9.41031C18.08 9.58031 18.29 9.67931 18.51 9.70031C18.92 9.68931 19.27 9.36031 19.3 8.93931V8.82031C19.33 7.41931 18.481 6.15031 17.19 5.66031Z"
                                    fill="black" />
                            </svg>
                            <p><span>У работодателя</span> разыгрался аппетит на ваши навыки</p>
                        </div>
                        <div>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path
                                    d="M16.34 2C19.73 2 22 4.38 22 7.92V16.091C22 19.62 19.73 22 16.34 22H7.67C4.28 22 2 19.62 2 16.091V7.92C2 4.38 4.28 2 7.67 2H16.34ZM16.18 9C15.84 8.66 15.28 8.66 14.94 9L10.81 13.13L9.06 11.38C8.72 11.04 8.16 11.04 7.82 11.38C7.48 11.72 7.48 12.27 7.82 12.62L10.2 14.99C10.37 15.16 10.59 15.24 10.81 15.24C11.04 15.24 11.26 15.16 11.43 14.99L16.18 10.24C16.52 9.9 16.52 9.35 16.18 9Z"
                                    fill="black" />
                            </svg>
                            <p><span>Сразу стало ясно:</span> вы — тот самый нужный кандидат</p>
                        </div>
                        <div>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path
                                    d="M12 4C14.0683 4 16.0293 4.71758 17.7366 6.04606C19.4439 7.36485 20.8976 9.29455 21.9415 11.7091C22.0195 11.8933 22.0195 12.1067 21.9415 12.2812C19.8537 17.1103 16.1366 20 12 20H11.9902C7.86341 20 4.14634 17.1103 2.05854 12.2812C1.98049 12.1067 1.98049 11.8933 2.05854 11.7091C4.14634 6.88 7.86341 4 11.9902 4H12ZM12 8.12121C9.8439 8.12121 8.09756 9.85697 8.09756 12C8.09756 14.1333 9.8439 15.8691 12 15.8691C14.1463 15.8691 15.8927 14.1333 15.8927 12C15.8927 9.85697 14.1463 8.12121 12 8.12121ZM12.0012 9.57362C13.3378 9.57362 14.4304 10.6597 14.4304 11.9979C14.4304 13.3264 13.3378 14.4124 12.0012 14.4124C10.6548 14.4124 9.56215 13.3264 9.56215 11.9979C9.56215 11.833 9.58166 11.6779 9.61093 11.5227H9.65971C10.7426 11.5227 11.6207 10.6694 11.6597 9.60272C11.767 9.58332 11.8841 9.57362 12.0012 9.57362Z"
                                    fill="black" />
                            </svg>
                            <p><span>Пробиться</span> сквозь профессиональную «слепоту» рекрутера</p>
                        </div>
                        <div>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path
                                    d="M19.9898 18.9533C20.5469 18.9533 21 19.4123 21 19.9766C21 20.5421 20.5469 21 19.9898 21H14.2797C13.7226 21 13.2695 20.5421 13.2695 19.9766C13.2695 19.4123 13.7226 18.9533 14.2797 18.9533H19.9898ZM16.0299 3.69906L17.5049 4.87078C18.1097 5.34377 18.513 5.96726 18.6509 6.62299C18.8101 7.3443 18.6403 8.0527 18.1628 8.66544L9.3764 20.0279C8.97316 20.5439 8.37891 20.8341 7.74222 20.8449L4.24039 20.8879C4.04939 20.8879 3.89021 20.7589 3.84777 20.5761L3.0519 17.1255C2.91395 16.4912 3.0519 15.8355 3.45514 15.3303L9.68413 7.26797C9.79025 7.13898 9.98126 7.11855 10.1086 7.21422L12.7297 9.29967C12.8994 9.43942 13.1329 9.51467 13.377 9.48242C13.8969 9.41792 14.2471 8.94493 14.1941 8.43969C14.1622 8.1817 14.0349 7.96671 13.8651 7.80546C13.812 7.76246 11.3183 5.76301 11.3183 5.76301C11.1591 5.63401 11.1273 5.39752 11.2546 5.23735L12.2415 3.95706C13.1541 2.78534 14.7459 2.67784 16.0299 3.69906Z"
                                    fill="black" />
                            </svg>
                            <p><span>Адаптировать</span> ваше CV под различные<br> вакансии</p>
                        </div>
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1706173478127.png" alt="">
                    </div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-intens-bonus-tablet', {
        label: 'Интенсив результат (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-intens-bonus-tablet">
            <div>
                <div>
                    <h2>В формате онлайн-встреч и прожарок научимся упаковывать опыт так, чтобы:</h2>
                </div>
                <div class="intens-bonus-wrapper">
                    <div>
                        <div>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path
                                    d="M8.28002 2.50015C8.91002 2.51931 9.52002 2.62931 10.111 2.83031H10.17C10.21 2.84931 10.24 2.87031 10.26 2.88931C10.481 2.96031 10.69 3.04031 10.89 3.15031L11.27 3.32031C11.42 3.40031 11.6 3.54931 11.7 3.61031C11.8 3.66931 11.91 3.73031 12 3.79931C13.111 2.95031 14.46 2.49031 15.85 2.50015C16.481 2.50015 17.111 2.58931 17.71 2.79031C21.401 3.99031 22.731 8.04031 21.62 11.5803C20.99 13.3893 19.96 15.0403 18.611 16.3893C16.68 18.2593 14.561 19.9193 12.28 21.3493L12.03 21.5003L11.77 21.3393C9.48102 19.9193 7.35002 18.2593 5.40102 16.3793C4.06102 15.0303 3.03002 13.3893 2.39002 11.5803C1.26002 8.04031 2.59002 3.99031 6.32102 2.76931C6.61102 2.66931 6.91002 2.59931 7.21002 2.56031H7.33002C7.61102 2.51931 7.89002 2.50015 8.17002 2.50015H8.28002ZM17.19 5.66031C16.78 5.51931 16.33 5.74031 16.18 6.16031C16.04 6.58031 16.26 7.04031 16.68 7.18931C17.321 7.42931 17.75 8.06031 17.75 8.75931V8.79031C17.731 9.01931 17.8 9.24031 17.94 9.41031C18.08 9.58031 18.29 9.67931 18.51 9.70031C18.92 9.68931 19.27 9.36031 19.3 8.93931V8.82031C19.33 7.41931 18.481 6.15031 17.19 5.66031Z"
                                    fill="black" />
                            </svg>
                            <p><span>У рекрутера</span> разыгрался аппетит на ваши навыки</p>
                        </div>
                        <div>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path
                                    d="M16.34 2C19.73 2 22 4.38 22 7.92V16.091C22 19.62 19.73 22 16.34 22H7.67C4.28 22 2 19.62 2 16.091V7.92C2 4.38 4.28 2 7.67 2H16.34ZM16.18 9C15.84 8.66 15.28 8.66 14.94 9L10.81 13.13L9.06 11.38C8.72 11.04 8.16 11.04 7.82 11.38C7.48 11.72 7.48 12.27 7.82 12.62L10.2 14.99C10.37 15.16 10.59 15.24 10.81 15.24C11.04 15.24 11.26 15.16 11.43 14.99L16.18 10.24C16.52 9.9 16.52 9.35 16.18 9Z"
                                    fill="black" />
                            </svg>
                            <p><span>Сразу стало ясно:</span> вы — тот самый нужный кандидат</p>
                        </div>
                        <div>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path
                                    d="M12 4C14.0683 4 16.0293 4.71758 17.7366 6.04606C19.4439 7.36485 20.8976 9.29455 21.9415 11.7091C22.0195 11.8933 22.0195 12.1067 21.9415 12.2812C19.8537 17.1103 16.1366 20 12 20H11.9902C7.86341 20 4.14634 17.1103 2.05854 12.2812C1.98049 12.1067 1.98049 11.8933 2.05854 11.7091C4.14634 6.88 7.86341 4 11.9902 4H12ZM12 8.12121C9.8439 8.12121 8.09756 9.85697 8.09756 12C8.09756 14.1333 9.8439 15.8691 12 15.8691C14.1463 15.8691 15.8927 14.1333 15.8927 12C15.8927 9.85697 14.1463 8.12121 12 8.12121ZM12.0012 9.57362C13.3378 9.57362 14.4304 10.6597 14.4304 11.9979C14.4304 13.3264 13.3378 14.4124 12.0012 14.4124C10.6548 14.4124 9.56215 13.3264 9.56215 11.9979C9.56215 11.833 9.58166 11.6779 9.61093 11.5227H9.65971C10.7426 11.5227 11.6207 10.6694 11.6597 9.60272C11.767 9.58332 11.8841 9.57362 12.0012 9.57362Z"
                                    fill="black" />
                            </svg>
                            <p><span>Пробиться</span> сквозь профессиональную «слепоту» рекрутера</p>
                        </div>
                        <div>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path
                                    d="M19.9898 18.9533C20.5469 18.9533 21 19.4123 21 19.9766C21 20.5421 20.5469 21 19.9898 21H14.2797C13.7226 21 13.2695 20.5421 13.2695 19.9766C13.2695 19.4123 13.7226 18.9533 14.2797 18.9533H19.9898ZM16.0299 3.69906L17.5049 4.87078C18.1097 5.34377 18.513 5.96726 18.6509 6.62299C18.8101 7.3443 18.6403 8.0527 18.1628 8.66544L9.3764 20.0279C8.97316 20.5439 8.37891 20.8341 7.74222 20.8449L4.24039 20.8879C4.04939 20.8879 3.89021 20.7589 3.84777 20.5761L3.0519 17.1255C2.91395 16.4912 3.0519 15.8355 3.45514 15.3303L9.68413 7.26797C9.79025 7.13898 9.98126 7.11855 10.1086 7.21422L12.7297 9.29967C12.8994 9.43942 13.1329 9.51467 13.377 9.48242C13.8969 9.41792 14.2471 8.94493 14.1941 8.43969C14.1622 8.1817 14.0349 7.96671 13.8651 7.80546C13.812 7.76246 11.3183 5.76301 11.3183 5.76301C11.1591 5.63401 11.1273 5.39752 11.2546 5.23735L12.2415 3.95706C13.1541 2.78534 14.7459 2.67784 16.0299 3.69906Z"
                                    fill="black" />
                            </svg>
                            <p><span>Адаптировать</span> ваше CV<br> под различные вакансии</p>
                        </div>
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1706194207334.png" alt="">
                    </div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-intens-bonus-mobile', {
        label: 'Интенсив результат (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-intens-bonus-mobile">
            <div>
                <div>
                    <h2>В формате онлайн-встреч<br> и прожарок научимся упаковывать опыт так, чтобы:</h2>
                </div>
                <div class="intens-bonus-wrapper">
                    <div>
                        <div>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path
                                    d="M8.28002 2.50015C8.91002 2.51931 9.52002 2.62931 10.111 2.83031H10.17C10.21 2.84931 10.24 2.87031 10.26 2.88931C10.481 2.96031 10.69 3.04031 10.89 3.15031L11.27 3.32031C11.42 3.40031 11.6 3.54931 11.7 3.61031C11.8 3.66931 11.91 3.73031 12 3.79931C13.111 2.95031 14.46 2.49031 15.85 2.50015C16.481 2.50015 17.111 2.58931 17.71 2.79031C21.401 3.99031 22.731 8.04031 21.62 11.5803C20.99 13.3893 19.96 15.0403 18.611 16.3893C16.68 18.2593 14.561 19.9193 12.28 21.3493L12.03 21.5003L11.77 21.3393C9.48102 19.9193 7.35002 18.2593 5.40102 16.3793C4.06102 15.0303 3.03002 13.3893 2.39002 11.5803C1.26002 8.04031 2.59002 3.99031 6.32102 2.76931C6.61102 2.66931 6.91002 2.59931 7.21002 2.56031H7.33002C7.61102 2.51931 7.89002 2.50015 8.17002 2.50015H8.28002ZM17.19 5.66031C16.78 5.51931 16.33 5.74031 16.18 6.16031C16.04 6.58031 16.26 7.04031 16.68 7.18931C17.321 7.42931 17.75 8.06031 17.75 8.75931V8.79031C17.731 9.01931 17.8 9.24031 17.94 9.41031C18.08 9.58031 18.29 9.67931 18.51 9.70031C18.92 9.68931 19.27 9.36031 19.3 8.93931V8.82031C19.33 7.41931 18.481 6.15031 17.19 5.66031Z"
                                    fill="black" />
                            </svg>
                            <p><span>У рекрутера</span> разыгрался аппетит на ваши навыки</p>
                        </div>
                        <div>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path
                                    d="M16.34 2C19.73 2 22 4.38 22 7.92V16.091C22 19.62 19.73 22 16.34 22H7.67C4.28 22 2 19.62 2 16.091V7.92C2 4.38 4.28 2 7.67 2H16.34ZM16.18 9C15.84 8.66 15.28 8.66 14.94 9L10.81 13.13L9.06 11.38C8.72 11.04 8.16 11.04 7.82 11.38C7.48 11.72 7.48 12.27 7.82 12.62L10.2 14.99C10.37 15.16 10.59 15.24 10.81 15.24C11.04 15.24 11.26 15.16 11.43 14.99L16.18 10.24C16.52 9.9 16.52 9.35 16.18 9Z"
                                    fill="black" />
                            </svg>
                            <p><span>Сразу стало ясно:</span> вы — тот самый нужный кандидат</p>
                        </div>
                        <div>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path
                                    d="M12 4C14.0683 4 16.0293 4.71758 17.7366 6.04606C19.4439 7.36485 20.8976 9.29455 21.9415 11.7091C22.0195 11.8933 22.0195 12.1067 21.9415 12.2812C19.8537 17.1103 16.1366 20 12 20H11.9902C7.86341 20 4.14634 17.1103 2.05854 12.2812C1.98049 12.1067 1.98049 11.8933 2.05854 11.7091C4.14634 6.88 7.86341 4 11.9902 4H12ZM12 8.12121C9.8439 8.12121 8.09756 9.85697 8.09756 12C8.09756 14.1333 9.8439 15.8691 12 15.8691C14.1463 15.8691 15.8927 14.1333 15.8927 12C15.8927 9.85697 14.1463 8.12121 12 8.12121ZM12.0012 9.57362C13.3378 9.57362 14.4304 10.6597 14.4304 11.9979C14.4304 13.3264 13.3378 14.4124 12.0012 14.4124C10.6548 14.4124 9.56215 13.3264 9.56215 11.9979C9.56215 11.833 9.58166 11.6779 9.61093 11.5227H9.65971C10.7426 11.5227 11.6207 10.6694 11.6597 9.60272C11.767 9.58332 11.8841 9.57362 12.0012 9.57362Z"
                                    fill="black" />
                            </svg>
                            <p><span>Пробиться</span> сквозь профессиональную «слепоту» рекрутера</p>
                        </div>
                        <div>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path
                                    d="M19.9898 18.9533C20.5469 18.9533 21 19.4123 21 19.9766C21 20.5421 20.5469 21 19.9898 21H14.2797C13.7226 21 13.2695 20.5421 13.2695 19.9766C13.2695 19.4123 13.7226 18.9533 14.2797 18.9533H19.9898ZM16.0299 3.69906L17.5049 4.87078C18.1097 5.34377 18.513 5.96726 18.6509 6.62299C18.8101 7.3443 18.6403 8.0527 18.1628 8.66544L9.3764 20.0279C8.97316 20.5439 8.37891 20.8341 7.74222 20.8449L4.24039 20.8879C4.04939 20.8879 3.89021 20.7589 3.84777 20.5761L3.0519 17.1255C2.91395 16.4912 3.0519 15.8355 3.45514 15.3303L9.68413 7.26797C9.79025 7.13898 9.98126 7.11855 10.1086 7.21422L12.7297 9.29967C12.8994 9.43942 13.1329 9.51467 13.377 9.48242C13.8969 9.41792 14.2471 8.94493 14.1941 8.43969C14.1622 8.1817 14.0349 7.96671 13.8651 7.80546C13.812 7.76246 11.3183 5.76301 11.3183 5.76301C11.1591 5.63401 11.1273 5.39752 11.2546 5.23735L12.2415 3.95706C13.1541 2.78534 14.7459 2.67784 16.0299 3.69906Z"
                                    fill="black" />
                            </svg>
                            <p><span>Адаптировать</span> ваше CV<br> под различные вакансии</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
	});
    
    blockManager.add('careerum-intens-how', {
        label: 'Интенсив бонусы',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-intens-how">
            <div>
                <div>
                    <h2>На десерт: карьерные бонусы<br> для участников</h2>
                </div>
                <div class="intens-how-img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1706173537006.png" alt="">
                </div>
                <div class="intens-how-bottom">
                    <div>
                        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="24" viewBox="0 0 28 24" fill="none">
                            <path
                                d="M21.8074 0C24.8527 0 27.3314 2.45602 27.3314 5.47352L27.3327 9.04327C27.3327 9.30486 27.2274 9.55852 27.0407 9.74348C26.8527 9.92976 26.5993 10.0341 26.3327 10.0341C25.238 10.0341 24.3473 10.9167 24.3473 12.0013C24.3473 13.086 25.238 13.9685 26.3327 13.9685C26.8847 13.9685 27.3327 14.4124 27.3327 14.9594V18.5278C27.3327 21.5453 24.8553 24 21.81 24H6.19002C3.14468 24 0.666016 21.5453 0.666016 18.5278V14.9594C0.666016 14.4124 1.11402 13.9685 1.66602 13.9685C2.76202 13.9685 3.65268 13.086 3.65268 12.0013C3.65268 10.9444 2.79802 10.1491 1.66602 10.1491C1.40068 10.1491 1.14735 10.0447 0.959349 9.85842C0.771349 9.67214 0.666016 9.4198 0.666016 9.15821L0.668682 5.47352C0.668682 2.45602 3.14602 0 6.19135 0H21.8074ZM14.002 6.8713C13.6233 6.8713 13.2847 7.08004 13.1153 7.41561L12.1433 9.36695L9.97535 9.68006C9.60068 9.73291 9.29402 9.98657 9.17535 10.3433C9.05802 10.7 9.15268 11.0858 9.42468 11.3474L10.9967 12.864L10.626 15.0083C10.562 15.3782 10.7127 15.7455 11.0193 15.9661C11.1927 16.089 11.394 16.1524 11.598 16.1524C11.754 16.1524 11.9113 16.1141 12.0553 16.0388L13.9993 15.0268L15.9393 16.0361C16.2753 16.2145 16.674 16.1867 16.9793 15.9648C17.2873 15.7455 17.438 15.3782 17.374 15.0083L17.002 12.864L18.574 11.3474C18.8473 11.0858 18.942 10.7 18.8233 10.3433C18.706 9.98657 18.3993 9.73291 18.0287 9.68138L15.8567 9.36695L14.8847 7.41693C14.718 7.08136 14.3793 6.87262 14.002 6.8713Z"
                                fill="black" />
                        </svg>
                        <h4>Разыграем:</h4>
                        <p>Грант на обучение в Careerum + видеоконстультации<br> CV-эксперта и письменное<br> ревью вашего
                            резюме</p>
                    </div>
                    <div>
                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                            <path
                                d="M17.6693 2.66797C18.0125 2.66797 18.2766 2.94797 18.2766 3.2813V7.57464C18.2766 10.0146 20.27 12.0146 22.6858 12.028C23.6891 12.028 24.4812 12.0413 25.0885 12.0413L25.3134 12.0403C25.7192 12.0372 26.2656 12.028 26.7386 12.028C27.0687 12.028 27.3327 12.2946 27.3327 12.628V23.348C27.3327 26.6546 24.6792 29.3346 21.4053 29.3346H10.897C7.4647 29.3346 4.66602 26.5213 4.66602 23.0546V8.6813C4.66602 5.37464 7.33268 2.66797 10.6198 2.66797H17.6693ZM19.0819 19.868H11.9003C11.3591 19.868 10.9102 20.308 10.9102 20.8546C10.9102 21.4013 11.3591 21.8546 11.9003 21.8546H19.0819C19.6231 21.8546 20.072 21.4013 20.072 20.8546C20.072 20.308 19.6231 19.868 19.0819 19.868ZM16.3624 13.2013H11.9003C11.3591 13.2013 10.9102 13.6546 10.9102 14.2013C10.9102 14.748 11.3591 15.188 11.9003 15.188H16.3624C16.9036 15.188 17.3525 14.748 17.3525 14.2013C17.3525 13.6546 16.9036 13.2013 16.3624 13.2013ZM20.2003 3.87597C20.2003 3.3013 20.8907 3.01597 21.2854 3.43064C22.7125 4.9293 25.2062 7.5493 26.6003 9.0133C26.9858 9.4173 26.7032 10.088 26.1475 10.0893C25.0623 10.0933 23.7831 10.0893 22.863 10.08C21.4029 10.08 20.2003 8.8653 20.2003 7.39064V3.87597Z"
                                fill="black" />
                        </svg>
                        <h4>Подарим:</h4>
                        <p>Шаблоны резюме и другие практические инструменты под различные сценарии<br> поиска работы</p>
                    </div>
                    <div>
                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                            <path
                                d="M12.4661 19.8103C17.7799 19.8103 22.2652 20.6548 22.2652 23.9205C22.2652 27.1836 17.7512 28 12.4661 28L12.1051 27.9987C6.95076 27.9604 2.66699 27.0813 2.66699 23.8898C2.66699 20.6267 7.18103 19.8103 12.4661 19.8103ZM20.7599 17.8443C22.7808 17.8059 24.9543 18.0781 25.7567 18.2697C27.4579 18.5955 28.576 19.2586 29.0391 20.2258C29.4318 21.0179 29.4318 21.9378 29.0391 22.73C28.3307 24.2274 26.045 24.709 25.1565 24.833C24.9726 24.8585 24.8252 24.7052 24.8447 24.5238C25.2987 20.374 21.6888 18.4064 20.7547 17.9542C20.7156 17.9324 20.7064 17.9018 20.7104 17.8813C20.713 17.8686 20.7299 17.8481 20.7599 17.8443ZM12.4661 4C16.0656 4 18.9501 6.82487 18.9501 10.3499C18.9501 13.8749 16.0656 16.6998 12.4661 16.6998C8.86792 16.6998 5.98207 13.8749 5.98207 10.3499C5.98207 6.82487 8.86792 4 12.4661 4ZM21.1122 5.06057C24.589 5.06057 27.3183 8.26234 26.3881 11.8282C25.7606 14.2315 23.4892 15.8273 20.9582 15.7621C20.7038 15.757 20.4546 15.7327 20.212 15.6931C20.0372 15.6624 19.9484 15.4695 20.0489 15.3264C21.0143 13.9351 21.5649 12.2601 21.5649 10.465C21.5649 8.58942 20.9648 6.84288 19.9197 5.40809C19.8858 5.36337 19.861 5.29566 19.895 5.24327C19.921 5.20239 19.9732 5.17939 20.0215 5.16917C20.3738 5.0989 20.7351 5.06057 21.1122 5.06057Z"
                                fill="black" />
                        </svg>
                        <h4>Откроем доступ:</h4>
                        <p>К закрытому чату участников, где можно задавать вопросы эксперту, совместно достигать целей и
                            обмениваться опытом</p>
                    </div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-intens-how-tablet', {
        label: 'Интенсив бонусы (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-intens-how-tablet">
            <div>
                <div>
                    <h2>На десерт: карьерные бонусы<br> для участников</h2>
                </div>
                <div class="intens-how-img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1706194510853.png" alt="">
                </div>
                <div class="intens-how-bottom">
                    <div>
                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                            <path
                                d="M23.8074 4C26.8527 4 29.3314 6.45602 29.3314 9.47352L29.3327 13.0433C29.3327 13.3049 29.2274 13.5585 29.0407 13.7435C28.8527 13.9298 28.5993 14.0341 28.3327 14.0341C27.238 14.0341 26.3473 14.9167 26.3473 16.0013C26.3473 17.086 27.238 17.9685 28.3327 17.9685C28.8847 17.9685 29.3327 18.4124 29.3327 18.9594V22.5278C29.3327 25.5453 26.8553 28 23.81 28H8.19002C5.14468 28 2.66602 25.5453 2.66602 22.5278V18.9594C2.66602 18.4124 3.11402 17.9685 3.66602 17.9685C4.76202 17.9685 5.65268 17.086 5.65268 16.0013C5.65268 14.9444 4.79802 14.1491 3.66602 14.1491C3.40068 14.1491 3.14735 14.0447 2.95935 13.8584C2.77135 13.6721 2.66602 13.4198 2.66602 13.1582L2.66868 9.47352C2.66868 6.45602 5.14602 4 8.19135 4H23.8074ZM16.002 10.8713C15.6233 10.8713 15.2847 11.08 15.1153 11.4156L14.1433 13.3669L11.9753 13.6801C11.6007 13.7329 11.294 13.9866 11.1753 14.3433C11.058 14.7 11.1527 15.0858 11.4247 15.3474L12.9967 16.864L12.626 19.0083C12.562 19.3782 12.7127 19.7455 13.0193 19.9661C13.1927 20.089 13.394 20.1524 13.598 20.1524C13.754 20.1524 13.9113 20.1141 14.0553 20.0388L15.9993 19.0268L17.9393 20.0361C18.2753 20.2145 18.674 20.1867 18.9793 19.9648C19.2873 19.7455 19.438 19.3782 19.374 19.0083L19.002 16.864L20.574 15.3474C20.8473 15.0858 20.942 14.7 20.8233 14.3433C20.706 13.9866 20.3993 13.7329 20.0287 13.6814L17.8567 13.3669L16.8847 11.4169C16.718 11.0814 16.3793 10.8726 16.002 10.8713Z"
                                fill="black" />
                        </svg>
                        <h4>Разыграем:</h4>
                        <p>Грант на обучение в Careerum + видеоконстультации<br> CV-эксперта и письменное ревью вашего
                            резюме</p>
                    </div>
                    <div>
                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                            <path
                                d="M17.6693 2.66797C18.0125 2.66797 18.2766 2.94797 18.2766 3.2813V7.57464C18.2766 10.0146 20.27 12.0146 22.6858 12.028C23.6891 12.028 24.4812 12.0413 25.0885 12.0413L25.3134 12.0403C25.7192 12.0372 26.2656 12.028 26.7386 12.028C27.0687 12.028 27.3327 12.2946 27.3327 12.628V23.348C27.3327 26.6546 24.6792 29.3346 21.4053 29.3346H10.897C7.4647 29.3346 4.66602 26.5213 4.66602 23.0546V8.6813C4.66602 5.37464 7.33268 2.66797 10.6198 2.66797H17.6693ZM19.0819 19.868H11.9003C11.3591 19.868 10.9102 20.308 10.9102 20.8546C10.9102 21.4013 11.3591 21.8546 11.9003 21.8546H19.0819C19.6231 21.8546 20.072 21.4013 20.072 20.8546C20.072 20.308 19.6231 19.868 19.0819 19.868ZM16.3624 13.2013H11.9003C11.3591 13.2013 10.9102 13.6546 10.9102 14.2013C10.9102 14.748 11.3591 15.188 11.9003 15.188H16.3624C16.9036 15.188 17.3525 14.748 17.3525 14.2013C17.3525 13.6546 16.9036 13.2013 16.3624 13.2013ZM20.2003 3.87597C20.2003 3.3013 20.8907 3.01597 21.2854 3.43064C22.7125 4.9293 25.2062 7.5493 26.6003 9.0133C26.9858 9.4173 26.7032 10.088 26.1475 10.0893C25.0623 10.0933 23.7831 10.0893 22.863 10.08C21.4029 10.08 20.2003 8.8653 20.2003 7.39064V3.87597Z"
                                fill="black" />
                        </svg>
                        <h4>Подарим:</h4>
                        <p>Шаблоны резюме и другие практические инструменты под различные сценарии<br> поиска работы</p>
                    </div>
                    <div>
                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                            <path
                                d="M12.4661 19.8103C17.7799 19.8103 22.2652 20.6548 22.2652 23.9205C22.2652 27.1836 17.7512 28 12.4661 28L12.1051 27.9987C6.95076 27.9604 2.66699 27.0813 2.66699 23.8898C2.66699 20.6267 7.18103 19.8103 12.4661 19.8103ZM20.7599 17.8443C22.7808 17.8059 24.9543 18.0781 25.7567 18.2697C27.4579 18.5955 28.576 19.2586 29.0391 20.2258C29.4318 21.0179 29.4318 21.9378 29.0391 22.73C28.3307 24.2274 26.045 24.709 25.1565 24.833C24.9726 24.8585 24.8252 24.7052 24.8447 24.5238C25.2987 20.374 21.6888 18.4064 20.7547 17.9542C20.7156 17.9324 20.7064 17.9018 20.7104 17.8813C20.713 17.8686 20.7299 17.8481 20.7599 17.8443ZM12.4661 4C16.0656 4 18.9501 6.82487 18.9501 10.3499C18.9501 13.8749 16.0656 16.6998 12.4661 16.6998C8.86792 16.6998 5.98207 13.8749 5.98207 10.3499C5.98207 6.82487 8.86792 4 12.4661 4ZM21.1122 5.06057C24.589 5.06057 27.3183 8.26234 26.3881 11.8282C25.7606 14.2315 23.4892 15.8273 20.9582 15.7621C20.7038 15.757 20.4546 15.7327 20.212 15.6931C20.0372 15.6624 19.9484 15.4695 20.0489 15.3264C21.0143 13.9351 21.5649 12.2601 21.5649 10.465C21.5649 8.58942 20.9648 6.84288 19.9197 5.40809C19.8858 5.36337 19.861 5.29566 19.895 5.24327C19.921 5.20239 19.9732 5.17939 20.0215 5.16917C20.3738 5.0989 20.7351 5.06057 21.1122 5.06057Z"
                                fill="black" />
                        </svg>
                        <h4>Откроем доступ:</h4>
                        <p>К закрытому чату участников, где можно задавать вопросы эксперту, совместно достигать целей и
                            обмениваться опытом</p>
                    </div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-intens-how-mobile', {
        label: 'Интенсив бонусы (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-intens-how-mobile">
            <div>
                <div>
                    <h2>На десерт: карьерные<br> бонусы для участников</h2>
                </div>
                <div class="intens-how-img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1706201930711.png" alt="">
                </div>
                <div class="intens-how-bottom">
                    <div>
                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                            <path
                                d="M23.8074 4C26.8527 4 29.3314 6.45602 29.3314 9.47352L29.3327 13.0433C29.3327 13.3049 29.2274 13.5585 29.0407 13.7435C28.8527 13.9298 28.5993 14.0341 28.3327 14.0341C27.238 14.0341 26.3473 14.9167 26.3473 16.0013C26.3473 17.086 27.238 17.9685 28.3327 17.9685C28.8847 17.9685 29.3327 18.4124 29.3327 18.9594V22.5278C29.3327 25.5453 26.8553 28 23.81 28H8.19002C5.14468 28 2.66602 25.5453 2.66602 22.5278V18.9594C2.66602 18.4124 3.11402 17.9685 3.66602 17.9685C4.76202 17.9685 5.65268 17.086 5.65268 16.0013C5.65268 14.9444 4.79802 14.1491 3.66602 14.1491C3.40068 14.1491 3.14735 14.0447 2.95935 13.8584C2.77135 13.6721 2.66602 13.4198 2.66602 13.1582L2.66868 9.47352C2.66868 6.45602 5.14602 4 8.19135 4H23.8074ZM16.002 10.8713C15.6233 10.8713 15.2847 11.08 15.1153 11.4156L14.1433 13.3669L11.9753 13.6801C11.6007 13.7329 11.294 13.9866 11.1753 14.3433C11.058 14.7 11.1527 15.0858 11.4247 15.3474L12.9967 16.864L12.626 19.0083C12.562 19.3782 12.7127 19.7455 13.0193 19.9661C13.1927 20.089 13.394 20.1524 13.598 20.1524C13.754 20.1524 13.9113 20.1141 14.0553 20.0388L15.9993 19.0268L17.9393 20.0361C18.2753 20.2145 18.674 20.1867 18.9793 19.9648C19.2873 19.7455 19.438 19.3782 19.374 19.0083L19.002 16.864L20.574 15.3474C20.8473 15.0858 20.942 14.7 20.8233 14.3433C20.706 13.9866 20.3993 13.7329 20.0287 13.6814L17.8567 13.3669L16.8847 11.4169C16.718 11.0814 16.3793 10.8726 16.002 10.8713Z"
                                fill="black" />
                        </svg>
    
                        <p><span>Разыграем:</span> грант на обучение в Careerum + видеоконстультации <br>CV-эксперта и
                            письменное ревью вашего резюме</p>
                    </div>
                    <div>
                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                            <path
                                d="M17.6693 2.66797C18.0125 2.66797 18.2766 2.94797 18.2766 3.2813V7.57464C18.2766 10.0146 20.27 12.0146 22.6858 12.028C23.6891 12.028 24.4812 12.0413 25.0885 12.0413L25.3134 12.0403C25.7192 12.0372 26.2656 12.028 26.7386 12.028C27.0687 12.028 27.3327 12.2946 27.3327 12.628V23.348C27.3327 26.6546 24.6792 29.3346 21.4053 29.3346H10.897C7.4647 29.3346 4.66602 26.5213 4.66602 23.0546V8.6813C4.66602 5.37464 7.33268 2.66797 10.6198 2.66797H17.6693ZM19.0819 19.868H11.9003C11.3591 19.868 10.9102 20.308 10.9102 20.8546C10.9102 21.4013 11.3591 21.8546 11.9003 21.8546H19.0819C19.6231 21.8546 20.072 21.4013 20.072 20.8546C20.072 20.308 19.6231 19.868 19.0819 19.868ZM16.3624 13.2013H11.9003C11.3591 13.2013 10.9102 13.6546 10.9102 14.2013C10.9102 14.748 11.3591 15.188 11.9003 15.188H16.3624C16.9036 15.188 17.3525 14.748 17.3525 14.2013C17.3525 13.6546 16.9036 13.2013 16.3624 13.2013ZM20.2003 3.87597C20.2003 3.3013 20.8907 3.01597 21.2854 3.43064C22.7125 4.9293 25.2062 7.5493 26.6003 9.0133C26.9858 9.4173 26.7032 10.088 26.1475 10.0893C25.0623 10.0933 23.7831 10.0893 22.863 10.08C21.4029 10.08 20.2003 8.8653 20.2003 7.39064V3.87597Z"
                                fill="black" />
                        </svg>
                        <p><span>Подарим:</span> шаблоны резюме <br>и другие практические инструменты под различные сценарии
                            поиска работы</p>
                    </div>
                    <div>
                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                            <path
                                d="M12.4661 19.8103C17.7799 19.8103 22.2652 20.6548 22.2652 23.9205C22.2652 27.1836 17.7512 28 12.4661 28L12.1051 27.9987C6.95076 27.9604 2.66699 27.0813 2.66699 23.8898C2.66699 20.6267 7.18103 19.8103 12.4661 19.8103ZM20.7599 17.8443C22.7808 17.8059 24.9543 18.0781 25.7567 18.2697C27.4579 18.5955 28.576 19.2586 29.0391 20.2258C29.4318 21.0179 29.4318 21.9378 29.0391 22.73C28.3307 24.2274 26.045 24.709 25.1565 24.833C24.9726 24.8585 24.8252 24.7052 24.8447 24.5238C25.2987 20.374 21.6888 18.4064 20.7547 17.9542C20.7156 17.9324 20.7064 17.9018 20.7104 17.8813C20.713 17.8686 20.7299 17.8481 20.7599 17.8443ZM12.4661 4C16.0656 4 18.9501 6.82487 18.9501 10.3499C18.9501 13.8749 16.0656 16.6998 12.4661 16.6998C8.86792 16.6998 5.98207 13.8749 5.98207 10.3499C5.98207 6.82487 8.86792 4 12.4661 4ZM21.1122 5.06057C24.589 5.06057 27.3183 8.26234 26.3881 11.8282C25.7606 14.2315 23.4892 15.8273 20.9582 15.7621C20.7038 15.757 20.4546 15.7327 20.212 15.6931C20.0372 15.6624 19.9484 15.4695 20.0489 15.3264C21.0143 13.9351 21.5649 12.2601 21.5649 10.465C21.5649 8.58942 20.9648 6.84288 19.9197 5.40809C19.8858 5.36337 19.861 5.29566 19.895 5.24327C19.921 5.20239 19.9732 5.17939 20.0215 5.16917C20.3738 5.0989 20.7351 5.06057 21.1122 5.06057Z"
                                fill="black" />
                        </svg>
                        <p><span>Откроем доступ:</span> к закрытому чату участников, где можно задавать вопросы эксперту,
                            совместно достигать целей <br>и обмениваться опытом</p>
                    </div>
                </div>
            </div>
        </div>`
	});
    
    blockManager.add('careerum-intens-resume', {
        label: 'Интенсив как понять',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-intens-resume">
            <div>
                <div>
                    <h2>Как понять, что вашему резюме<br> пора на интенсив</h2>
                </div>
                <div class="intens-resume-slider-wrapper">
                    <div class="intens-resume-slider-item">
                        <div class="intens-resume-slider-item-top">
                            <p class="intens-resume-slider-item-header">До интенсива</p>
                            <p>«Шлю-шлю резюме, а его как будто не замечают. Почти не получаю приглашений на собеседования!»
                            </p>
                        </div>
                        <div class="intens-resume-slider-item-bottom">
                            <p class="intens-resume-slider-item-header">После интенсива</p>
                            <p>Разберетесь, а действительно ли проблема в резюме. Если да: определите, что это за проблема
                                и как ее решать</p>
                        </div>
                    </div>
                    <div class="intens-resume-slider-item">
                        <div class="intens-resume-slider-item-top">
                            <p class="intens-resume-slider-item-header">До интенсива</p>
                            <p>«Ну нельзя уместить резюме в 2 страницы! Не хочется утомить работодателя, но как я могу
                                упустить детали?»</p>
                        </div>
                        <div class="intens-resume-slider-item-bottom">
                            <p class="intens-resume-slider-item-header">После интенсива</p>
                            <p>Сами увидите, что сильное резюме может быть кратким, но информативным.</p>
                            <p>Поймете, как отсекать лишнее, и почему рекрутеры игнорируют дли-и-инные резюме</p>
                        </div>
                    </div>
                    <div class="intens-resume-slider-item">
                        <div class="intens-resume-slider-item-top">
                            <p class="intens-resume-slider-item-header">До интенсива</p>
                            <p>«И как только выявить достижения?! Какие указывать...
                                Нельзя же «вывалить» навыки и опыт на работодателя»</p>
                        </div>
                        <div class="intens-resume-slider-item-bottom">
                            <p class="intens-resume-slider-item-header">После интенсива</p>
                            <p>Научитесь исследовать свой опыт и превращать его в достижения. Выявите те самые важные
                                аспекты в своих навыках, которые помогут заинтересовать работодателя.</p>
                            <p>Научитесь формулировать собственную ценность, опираясь на потребности компании</p>
                        </div>
                    </div>
                    <div class="intens-resume-slider-item">
                        <div class="intens-resume-slider-item-top">
                            <p class="intens-resume-slider-item-header">До интенсива</p>
                            <p>«Не знаю, как адаптировать резюме. Боюсь «спугнуть» свою вакансию и упустить шанс»</p>
                        </div>
                        <div class="intens-resume-slider-item-bottom">
                            <p class="intens-resume-slider-item-header">После интенсива</p>
                            <p>Узнаете, какие форматы резюме востребованы и какой подойдет в вашей ситуации.</p>
                            <p>Сможете определять, какого кандидата ищет компания и адаптировать резюме под запрос</p>
                        </div>
                    </div>
                    <div class="intens-resume-slider-item">
                        <div class="intens-resume-slider-item-top">
                            <p class="intens-resume-slider-item-header">До интенсива</p>
                            <p>«Есть пробелы в карьере: декрет / релокация / выгорание. С таким «багажом» никуда не примут!»
                            </p>
                        </div>
                        <div class="intens-resume-slider-item-bottom">
                            <p class="intens-resume-slider-item-header">После интенсива</p>
                            <p>Научитесь превращать карьерные перерывы и изменения в достоинства.</p>
                            <p>Поймете, что это необязательно становится препятствием для трудоустройства</p>
                        </div>
                    </div>
                    <div class="intens-resume-slider-item">
                        <div class="intens-resume-slider-item-top">
                            <p class="intens-resume-slider-item-header">До интенсива</p>
                            <p>«Никогда не писал резюме... Не понимаю, с чего начать и не наделать ошибок»</p>
                        </div>
                        <div class="intens-resume-slider-item-bottom">
                            <p class="intens-resume-slider-item-header">После интенсива</p>
                            <p>Получите поэтапный алгоритм из практических шагов, проверенный 5 000+ соискателей.</p>
                            <p>Начнете работать над резюме осознанно, используя его, как инструмент для достижения цели</p>
                        </div>
                    </div>
                </div>
                <div class="intens-resume-slider-nav">
                    <div class="intens-resume-slider__arrow-left">
                        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="41" viewBox="0 0 40 41" fill="none">
                            <g clip-path="url(#clip0_141_4353)">
                                <g filter="url(#filter0_b_141_4353)">
                                    <rect y="40.6113" width="40" height="40" transform="rotate(-90 0 40.6113)"
                                        fill="black" />
                                </g>
                                <path d="M13.1896 20.6107L26.8096 20.6107" stroke="white" stroke-width="2.64201"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M19.4629 26.8566L13.1896 20.6099L19.4629 14.3633" stroke="white"
                                    stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round" />
                            </g>
                            <defs>
                                <filter id="filter0_b_141_4353" x="-18.1166" y="-17.5053" width="76.2332" height="76.2332"
                                    filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feGaussianBlur in="BackgroundImageFix" stdDeviation="9.05831" />
                                    <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_141_4353" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_141_4353"
                                        result="shape" />
                                </filter>
                                <clipPath id="clip0_141_4353">
                                    <rect y="40.6113" width="40" height="40" rx="20" transform="rotate(-90 0 40.6113)"
                                        fill="white" />
                                </clipPath>
                            </defs>
                        </svg>
                    </div>
                    <div class="intens-resume-slider__arrow-right">
                        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="41" viewBox="0 0 40 41" fill="none">
                            <g clip-path="url(#clip0_141_4357)">
                                <g filter="url(#filter0_b_141_4357)">
                                    <rect x="40" y="0.611328" width="40" height="40" transform="rotate(90 40 0.611328)"
                                        fill="black" />
                                </g>
                                <path d="M26.8104 20.612L13.1904 20.612" stroke="white" stroke-width="2.64201"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M20.5371 14.366L26.8104 20.6127L20.5371 26.8594" stroke="white"
                                    stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round" />
                            </g>
                            <defs>
                                <filter id="filter0_b_141_4357" x="-18.1166" y="-17.5053" width="76.2332" height="76.2332"
                                    filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feGaussianBlur in="BackgroundImageFix" stdDeviation="9.05831" />
                                    <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_141_4357" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_141_4357"
                                        result="shape" />
                                </filter>
                                <clipPath id="clip0_141_4357">
                                    <rect x="40" y="0.611328" width="40" height="40" rx="20"
                                        transform="rotate(90 40 0.611328)" fill="white" />
                                </clipPath>
                            </defs>
                        </svg>
                    </div>
                </div>
                <div class="intens-resume-link">
                    <a href="#buy" class="btn-color-main-dark-orange">Супер, хочу оплатить участие</a>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-intens-resume-tablet', {
        label: 'Интенсив как понять (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-intens-resume-tablet">
            <div>
                <div>
                    <h2>Как понять, что вашему резюме<br> пора на интенсив</h2>
                </div>
                <div class="intens-resume-slider-wrapper">
                    <div class="intens-resume-slider-item">
                        <div class="intens-resume-slider-item-top">
                            <p class="intens-resume-slider-item-header">До интенсива</p>
                            <p>«Шлю-шлю резюме, а его как будто не замечают. Почти <br>не получаю приглашений
                                на собеседования!»
                            </p>
                        </div>
                        <div class="intens-resume-slider-item-bottom">
                            <p class="intens-resume-slider-item-header">После интенсива</p>
                            <p>Разберетесь, а действительно ли проблема в резюме. Если да: определите, что это за проблема
                                и как ее решать</p>
                        </div>
                    </div>
                    <div class="intens-resume-slider-item">
                        <div class="intens-resume-slider-item-top">
                            <p class="intens-resume-slider-item-header">До интенсива</p>
                            <p>«Ну нельзя уместить резюме в 2 страницы! Не хочется утомить работодателя, но как я могу
                                упустить детали?»</p>
                        </div>
                        <div class="intens-resume-slider-item-bottom">
                            <p class="intens-resume-slider-item-header">После интенсива</p>
                            <p>Сами увидите, что сильное резюме может быть кратким, но информативным.</p>
                            <p>Поймете, как отсекать лишнее, и почему рекрутеры игнорируют дли-и-инные резюме</p>
                        </div>
                    </div>
                    <div class="intens-resume-slider-item">
                        <div class="intens-resume-slider-item-top">
                            <p class="intens-resume-slider-item-header">До интенсива</p>
                            <p>«И как только выявить достижения?! Какие указывать...
                                Нельзя же «вывалить» навыки и опыт на работодателя»</p>
                        </div>
                        <div class="intens-resume-slider-item-bottom">
                            <p class="intens-resume-slider-item-header">После интенсива</p>
                            <p>Научитесь исследовать свой опыт и превращать его в достижения. Выявите те самые важные
                                аспекты в своих навыках, которые помогут заинтересовать работодателя.</p>
                        </div>
                    </div>
                    <div class="intens-resume-slider-item">
                        <div class="intens-resume-slider-item-top">
                            <p class="intens-resume-slider-item-header">До интенсива</p>
                            <p>«Не знаю, как адаптировать резюме. Боюсь «спугнуть» свою вакансию и упустить шанс»</p>
                        </div>
                        <div class="intens-resume-slider-item-bottom">
                            <p class="intens-resume-slider-item-header">После интенсива</p>
                            <p>Узнаете, какие форматы резюме востребованы и какой подойдет в вашей ситуации.</p>
                            <p>Сможете определять, какого кандидата ищет компания и адаптировать резюме под запрос</p>
                        </div>
                    </div>
                    <div class="intens-resume-slider-item">
                        <div class="intens-resume-slider-item-top">
                            <p class="intens-resume-slider-item-header">До интенсива</p>
                            <p>«Есть пробелы в карьере: декрет / релокация / выгорание. С таким «багажом» никуда не примут!»
                            </p>
                        </div>
                        <div class="intens-resume-slider-item-bottom">
                            <p class="intens-resume-slider-item-header">После интенсива</p>
                            <p>Научитесь превращать карьерные перерывы и изменения в достоинства.</p>
                            <p>Поймете, что это необязательно становится препятствием для трудоустройства</p>
                        </div>
                    </div>
                    <div class="intens-resume-slider-item">
                        <div class="intens-resume-slider-item-top">
                            <p class="intens-resume-slider-item-header">До интенсива</p>
                            <p>«Никогда не писал резюме... Не понимаю, с чего начать и не наделать ошибок»</p>
                        </div>
                        <div class="intens-resume-slider-item-bottom">
                            <p class="intens-resume-slider-item-header">После интенсива</p>
                            <p>Получите поэтапный алгоритм из практических шагов, проверенный 5 000+ соискателей.</p>
                            <p>Начнете работать над резюме осознанно, используя его, как инструмент для достижения цели</p>
                        </div>
                    </div>
                </div>
                <div class="intens-resume-slider-nav">
                    <div class="intens-resume-slider__arrow-left">
                        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="41" viewBox="0 0 40 41" fill="none">
                            <g clip-path="url(#clip0_141_4353)">
                                <g filter="url(#filter0_b_141_4353)">
                                    <rect y="40.6113" width="40" height="40" transform="rotate(-90 0 40.6113)"
                                        fill="black" />
                                </g>
                                <path d="M13.1896 20.6107L26.8096 20.6107" stroke="white" stroke-width="2.64201"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M19.4629 26.8566L13.1896 20.6099L19.4629 14.3633" stroke="white"
                                    stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round" />
                            </g>
                            <defs>
                                <filter id="filter0_b_141_4353" x="-18.1166" y="-17.5053" width="76.2332" height="76.2332"
                                    filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feGaussianBlur in="BackgroundImageFix" stdDeviation="9.05831" />
                                    <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_141_4353" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_141_4353"
                                        result="shape" />
                                </filter>
                                <clipPath id="clip0_141_4353">
                                    <rect y="40.6113" width="40" height="40" rx="20" transform="rotate(-90 0 40.6113)"
                                        fill="white" />
                                </clipPath>
                            </defs>
                        </svg>
                    </div>
                    <div class="intens-resume-slider__arrow-right">
                        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="41" viewBox="0 0 40 41" fill="none">
                            <g clip-path="url(#clip0_141_4357)">
                                <g filter="url(#filter0_b_141_4357)">
                                    <rect x="40" y="0.611328" width="40" height="40" transform="rotate(90 40 0.611328)"
                                        fill="black" />
                                </g>
                                <path d="M26.8104 20.612L13.1904 20.612" stroke="white" stroke-width="2.64201"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M20.5371 14.366L26.8104 20.6127L20.5371 26.8594" stroke="white"
                                    stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round" />
                            </g>
                            <defs>
                                <filter id="filter0_b_141_4357" x="-18.1166" y="-17.5053" width="76.2332" height="76.2332"
                                    filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feGaussianBlur in="BackgroundImageFix" stdDeviation="9.05831" />
                                    <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_141_4357" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_141_4357"
                                        result="shape" />
                                </filter>
                                <clipPath id="clip0_141_4357">
                                    <rect x="40" y="0.611328" width="40" height="40" rx="20"
                                        transform="rotate(90 40 0.611328)" fill="white" />
                                </clipPath>
                            </defs>
                        </svg>
                    </div>
                </div>
                <div class="intens-resume-link">
                    <a href="#buy" class="btn-color-main-dark-orange">Супер, хочу оплатить участие</a>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-intens-resume-mobile', {
        label: 'Интенсив как понять (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-intens-resume-mobile">
            <div>
                <div>
                    <h2>Как понять, что вашему резюме пора на интенсив</h2>
                </div>
                <div class="intens-resume-slider-wrapper">
                    <div class="intens-resume-slider-item">
                        <div class="intens-resume-slider-item-top">
                            <p class="intens-resume-slider-item-header">До интенсива</p>
                            <p>«Шлю-шлю резюме, а его как будто не замечают. Почти <br>не получаю приглашений
                                на собеседования!»
                            </p>
                        </div>
                        <div class="intens-resume-slider-item-bottom">
                            <p class="intens-resume-slider-item-header">После интенсива</p>
                            <p>Разберетесь, а действительно ли проблема в резюме. Если да: определите, что это за проблема
                                и как ее решать</p>
                        </div>
                    </div>
                    <div class="intens-resume-slider-item">
                        <div class="intens-resume-slider-item-top">
                            <p class="intens-resume-slider-item-header">До интенсива</p>
                            <p>«Ну нельзя уместить резюме в 2 страницы! Не хочется утомить работодателя, но как я могу
                                упустить детали?»</p>
                        </div>
                        <div class="intens-resume-slider-item-bottom">
                            <p class="intens-resume-slider-item-header">После интенсива</p>
                            <p>Сами увидите, что сильное резюме может быть кратким, но информативным.</p>
                            <p>Поймете, как отсекать лишнее, и почему рекрутеры игнорируют дли-и-инные резюме</p>
                        </div>
                    </div>
                    <div class="intens-resume-slider-item">
                        <div class="intens-resume-slider-item-top">
                            <p class="intens-resume-slider-item-header">До интенсива</p>
                            <p>«И как только выявить достижения?! Какие указывать...
                                Нельзя же «вывалить» навыки и опыт на работодателя»</p>
                        </div>
                        <div class="intens-resume-slider-item-bottom">
                            <p class="intens-resume-slider-item-header">После интенсива</p>
                            <p>Научитесь исследовать свой опыт и превращать его в достижения. Выявите те самые важные
                                аспекты в своих навыках, которые помогут заинтересовать работодателя.</p>
                        </div>
                    </div>
                    <div class="intens-resume-slider-item">
                        <div class="intens-resume-slider-item-top">
                            <p class="intens-resume-slider-item-header">До интенсива</p>
                            <p>«Не знаю, как адаптировать резюме. Боюсь «спугнуть» свою вакансию и упустить шанс»</p>
                        </div>
                        <div class="intens-resume-slider-item-bottom">
                            <p class="intens-resume-slider-item-header">После интенсива</p>
                            <p>Узнаете, какие форматы резюме востребованы и какой подойдет в вашей ситуации.</p>
                            <p>Сможете определять, какого кандидата ищет компания и адаптировать резюме под запрос</p>
                        </div>
                    </div>
                    <div class="intens-resume-slider-item">
                        <div class="intens-resume-slider-item-top">
                            <p class="intens-resume-slider-item-header">До интенсива</p>
                            <p>«Есть пробелы в карьере: декрет / релокация / выгорание. С таким «багажом» никуда не примут!»
                            </p>
                        </div>
                        <div class="intens-resume-slider-item-bottom">
                            <p class="intens-resume-slider-item-header">После интенсива</p>
                            <p>Научитесь превращать карьерные перерывы и изменения в достоинства.</p>
                            <p>Поймете, что это необязательно становится препятствием для трудоустройства</p>
                        </div>
                    </div>
                    <div class="intens-resume-slider-item">
                        <div class="intens-resume-slider-item-top">
                            <p class="intens-resume-slider-item-header">До интенсива</p>
                            <p>«Никогда не писал резюме... Не понимаю, с чего начать и не наделать ошибок»</p>
                        </div>
                        <div class="intens-resume-slider-item-bottom">
                            <p class="intens-resume-slider-item-header">После интенсива</p>
                            <p>Получите поэтапный алгоритм из практических шагов, проверенный 5 000+ соискателей.</p>
                            <p>Начнете работать над резюме осознанно, используя его, как инструмент для достижения цели</p>
                        </div>
                    </div>
                </div>
                <div class="intens-resume-slider-nav">
                    <div class="intens-resume-slider__arrow-left">
                        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="41" viewBox="0 0 40 41" fill="none">
                            <g clip-path="url(#clip0_141_4353)">
                                <g filter="url(#filter0_b_141_4353)">
                                    <rect y="40.6113" width="40" height="40" transform="rotate(-90 0 40.6113)"
                                        fill="black" />
                                </g>
                                <path d="M13.1896 20.6107L26.8096 20.6107" stroke="white" stroke-width="2.64201"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M19.4629 26.8566L13.1896 20.6099L19.4629 14.3633" stroke="white"
                                    stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round" />
                            </g>
                            <defs>
                                <filter id="filter0_b_141_4353" x="-18.1166" y="-17.5053" width="76.2332" height="76.2332"
                                    filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feGaussianBlur in="BackgroundImageFix" stdDeviation="9.05831" />
                                    <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_141_4353" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_141_4353"
                                        result="shape" />
                                </filter>
                                <clipPath id="clip0_141_4353">
                                    <rect y="40.6113" width="40" height="40" rx="20" transform="rotate(-90 0 40.6113)"
                                        fill="white" />
                                </clipPath>
                            </defs>
                        </svg>
                    </div>
                    <div class="intens-resume-slider__arrow-right">
                        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="41" viewBox="0 0 40 41" fill="none">
                            <g clip-path="url(#clip0_141_4357)">
                                <g filter="url(#filter0_b_141_4357)">
                                    <rect x="40" y="0.611328" width="40" height="40" transform="rotate(90 40 0.611328)"
                                        fill="black" />
                                </g>
                                <path d="M26.8104 20.612L13.1904 20.612" stroke="white" stroke-width="2.64201"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M20.5371 14.366L26.8104 20.6127L20.5371 26.8594" stroke="white"
                                    stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round" />
                            </g>
                            <defs>
                                <filter id="filter0_b_141_4357" x="-18.1166" y="-17.5053" width="76.2332" height="76.2332"
                                    filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feGaussianBlur in="BackgroundImageFix" stdDeviation="9.05831" />
                                    <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_141_4357" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_141_4357"
                                        result="shape" />
                                </filter>
                                <clipPath id="clip0_141_4357">
                                    <rect x="40" y="0.611328" width="40" height="40" rx="20"
                                        transform="rotate(90 40 0.611328)" fill="white" />
                                </clipPath>
                            </defs>
                        </svg>
                    </div>
                </div>
                <div class="intens-resume-link">
                    <a href="#buy" class="btn-color-main-dark-orange">Супер, хочу оплатить участие</a>
                </div>
            </div>
        </div>`
	});
    
    blockManager.add('careerum-intens-before', {
        label: 'Интенсив до',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-intens-before">
            <div>
                <div class="careerum-intens-before-left">
                    <h2>Резюме до интенсива: пресное, похожее на другие, без «огонька»</h2>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1706174162293.png" alt="">
                </div>
                <div class="careerum-intens-before-right">
                    <ul>
                        <li>
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                                <path
                                    d="M13.979 0.611328C17.0865 0.611328 19.1673 2.99133 19.1673 6.53133V14.7023C19.1673 18.2323 17.0865 20.6113 13.979 20.6113H6.03148C2.92398 20.6113 0.833984 18.2323 0.833984 14.7023V6.53133C0.833984 2.99133 2.92398 0.611328 6.03148 0.611328H13.979ZM12.7598 7.58233C12.4482 7.24133 11.944 7.24133 11.6232 7.58233L10.0007 9.36133L8.36898 7.58233C8.04815 7.24133 7.54398 7.24133 7.23232 7.58233C6.92065 7.92233 6.92065 8.48233 7.23232 8.82133L8.86399 10.6023L7.23232 12.3723C6.92065 12.7223 6.92065 13.2723 7.23232 13.6113C7.38815 13.7813 7.59898 13.8723 7.80065 13.8723C8.01148 13.8723 8.21315 13.7813 8.36898 13.6113L10.0007 11.8423L11.6323 13.6113C11.7882 13.7923 11.9898 13.8723 12.1915 13.8723C12.4023 13.8723 12.604 13.7813 12.7598 13.6113C13.0715 13.2723 13.0715 12.7223 12.7598 12.3823L11.1282 10.6023L12.7598 8.82133C13.0715 8.48233 13.0715 7.92233 12.7598 7.58233Z"
                                    fill="black" />
                            </svg>
                            <p>Много-много про опыт, мало про пользу</p>
                        </li>
                        <li>
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                                <path
                                    d="M13.979 0.611328C17.0865 0.611328 19.1673 2.99133 19.1673 6.53133V14.7023C19.1673 18.2323 17.0865 20.6113 13.979 20.6113H6.03148C2.92398 20.6113 0.833984 18.2323 0.833984 14.7023V6.53133C0.833984 2.99133 2.92398 0.611328 6.03148 0.611328H13.979ZM12.7598 7.58233C12.4482 7.24133 11.944 7.24133 11.6232 7.58233L10.0007 9.36133L8.36898 7.58233C8.04815 7.24133 7.54398 7.24133 7.23232 7.58233C6.92065 7.92233 6.92065 8.48233 7.23232 8.82133L8.86399 10.6023L7.23232 12.3723C6.92065 12.7223 6.92065 13.2723 7.23232 13.6113C7.38815 13.7813 7.59898 13.8723 7.80065 13.8723C8.01148 13.8723 8.21315 13.7813 8.36898 13.6113L10.0007 11.8423L11.6323 13.6113C11.7882 13.7923 11.9898 13.8723 12.1915 13.8723C12.4023 13.8723 12.604 13.7813 12.7598 13.6113C13.0715 13.2723 13.0715 12.7223 12.7598 12.3823L11.1282 10.6023L12.7598 8.82133C13.0715 8.48233 13.0715 7.92233 12.7598 7.58233Z"
                                    fill="black" />
                            </svg>
                            <p>Непонятно, почему нанять нужно именно вас<br> и чем вы поможете бизнесу </p>
                        </li>
                        <li>
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                                <path
                                    d="M13.979 0.611328C17.0865 0.611328 19.1673 2.99133 19.1673 6.53133V14.7023C19.1673 18.2323 17.0865 20.6113 13.979 20.6113H6.03148C2.92398 20.6113 0.833984 18.2323 0.833984 14.7023V6.53133C0.833984 2.99133 2.92398 0.611328 6.03148 0.611328H13.979ZM12.7598 7.58233C12.4482 7.24133 11.944 7.24133 11.6232 7.58233L10.0007 9.36133L8.36898 7.58233C8.04815 7.24133 7.54398 7.24133 7.23232 7.58233C6.92065 7.92233 6.92065 8.48233 7.23232 8.82133L8.86399 10.6023L7.23232 12.3723C6.92065 12.7223 6.92065 13.2723 7.23232 13.6113C7.38815 13.7813 7.59898 13.8723 7.80065 13.8723C8.01148 13.8723 8.21315 13.7813 8.36898 13.6113L10.0007 11.8423L11.6323 13.6113C11.7882 13.7923 11.9898 13.8723 12.1915 13.8723C12.4023 13.8723 12.604 13.7813 12.7598 13.6113C13.0715 13.2723 13.0715 12.7223 12.7598 12.3823L11.1282 10.6023L12.7598 8.82133C13.0715 8.48233 13.0715 7.92233 12.7598 7.58233Z"
                                    fill="black" />
                            </svg>
                            <p>Проблемы со структурой</p>
                        </li>
                        <li>
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                                <path
                                    d="M13.979 0.611328C17.0865 0.611328 19.1673 2.99133 19.1673 6.53133V14.7023C19.1673 18.2323 17.0865 20.6113 13.979 20.6113H6.03148C2.92398 20.6113 0.833984 18.2323 0.833984 14.7023V6.53133C0.833984 2.99133 2.92398 0.611328 6.03148 0.611328H13.979ZM12.7598 7.58233C12.4482 7.24133 11.944 7.24133 11.6232 7.58233L10.0007 9.36133L8.36898 7.58233C8.04815 7.24133 7.54398 7.24133 7.23232 7.58233C6.92065 7.92233 6.92065 8.48233 7.23232 8.82133L8.86399 10.6023L7.23232 12.3723C6.92065 12.7223 6.92065 13.2723 7.23232 13.6113C7.38815 13.7813 7.59898 13.8723 7.80065 13.8723C8.01148 13.8723 8.21315 13.7813 8.36898 13.6113L10.0007 11.8423L11.6323 13.6113C11.7882 13.7923 11.9898 13.8723 12.1915 13.8723C12.4023 13.8723 12.604 13.7813 12.7598 13.6113C13.0715 13.2723 13.0715 12.7223 12.7598 12.3823L11.1282 10.6023L12.7598 8.82133C13.0715 8.48233 13.0715 7.92233 12.7598 7.58233Z"
                                    fill="black" />
                            </svg>
                            <p>Есть красные флаги для рекрутера</p>
                        </li>
                        <li>
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                                <path
                                    d="M13.979 0.611328C17.0865 0.611328 19.1673 2.99133 19.1673 6.53133V14.7023C19.1673 18.2323 17.0865 20.6113 13.979 20.6113H6.03148C2.92398 20.6113 0.833984 18.2323 0.833984 14.7023V6.53133C0.833984 2.99133 2.92398 0.611328 6.03148 0.611328H13.979ZM12.7598 7.58233C12.4482 7.24133 11.944 7.24133 11.6232 7.58233L10.0007 9.36133L8.36898 7.58233C8.04815 7.24133 7.54398 7.24133 7.23232 7.58233C6.92065 7.92233 6.92065 8.48233 7.23232 8.82133L8.86399 10.6023L7.23232 12.3723C6.92065 12.7223 6.92065 13.2723 7.23232 13.6113C7.38815 13.7813 7.59898 13.8723 7.80065 13.8723C8.01148 13.8723 8.21315 13.7813 8.36898 13.6113L10.0007 11.8423L11.6323 13.6113C11.7882 13.7923 11.9898 13.8723 12.1915 13.8723C12.4023 13.8723 12.604 13.7813 12.7598 13.6113C13.0715 13.2723 13.0715 12.7223 12.7598 12.3823L11.1282 10.6023L12.7598 8.82133C13.0715 8.48233 13.0715 7.92233 12.7598 7.58233Z"
                                    fill="black" />
                            </svg>
                            <p>Используются формулировки, которые снижают вашу ценность</p>
                        </li>
                        <li>
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                                <path
                                    d="M13.979 0.611328C17.0865 0.611328 19.1673 2.99133 19.1673 6.53133V14.7023C19.1673 18.2323 17.0865 20.6113 13.979 20.6113H6.03148C2.92398 20.6113 0.833984 18.2323 0.833984 14.7023V6.53133C0.833984 2.99133 2.92398 0.611328 6.03148 0.611328H13.979ZM12.7598 7.58233C12.4482 7.24133 11.944 7.24133 11.6232 7.58233L10.0007 9.36133L8.36898 7.58233C8.04815 7.24133 7.54398 7.24133 7.23232 7.58233C6.92065 7.92233 6.92065 8.48233 7.23232 8.82133L8.86399 10.6023L7.23232 12.3723C6.92065 12.7223 6.92065 13.2723 7.23232 13.6113C7.38815 13.7813 7.59898 13.8723 7.80065 13.8723C8.01148 13.8723 8.21315 13.7813 8.36898 13.6113L10.0007 11.8423L11.6323 13.6113C11.7882 13.7923 11.9898 13.8723 12.1915 13.8723C12.4023 13.8723 12.604 13.7813 12.7598 13.6113C13.0715 13.2723 13.0715 12.7223 12.7598 12.3823L11.1282 10.6023L12.7598 8.82133C13.0715 8.48233 13.0715 7.92233 12.7598 7.58233Z"
                                    fill="black" />
                            </svg>
                            <p>Резюме не презентует весь ваш потенциал</p>
                        </li>
                    </ul>
                    <p>«В моем CV уже учтено все, о чем написано выше. Но меня все равно не нанимают! Памигити-и-и...»</p>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-intens-before-tablet', {
        label: 'Интенсив до (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-intens-before-tablet">
            <div>
                <div class="careerum-intens-before-left">
                    <h2>Резюме до интенсива: пресное, похожее на другие, без «огонька»</h2>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1706195474383.png" alt="">
                </div>
                <div class="careerum-intens-before-right">
                    <ul>
                        <li>
                            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="25" viewBox="0 0 22 25" fill="none">
                                <path
                                    d="M14.979 2.53516C18.0865 2.53516 20.1673 4.91516 20.1673 8.45516V16.6262C20.1673 20.1562 18.0865 22.5352 14.979 22.5352H7.03148C3.92398 22.5352 1.83398 20.1562 1.83398 16.6262V8.45516C1.83398 4.91516 3.92398 2.53516 7.03148 2.53516H14.979ZM13.7598 9.50616C13.4482 9.16516 12.944 9.16516 12.6232 9.50616L11.0007 11.2852L9.36898 9.50616C9.04815 9.16516 8.54398 9.16516 8.23232 9.50616C7.92065 9.84616 7.92065 10.4062 8.23232 10.7452L9.86399 12.5262L8.23232 14.2962C7.92065 14.6462 7.92065 15.1962 8.23232 15.5352C8.38815 15.7052 8.59898 15.7962 8.80065 15.7962C9.01148 15.7962 9.21315 15.7052 9.36898 15.5352L11.0007 13.7662L12.6323 15.5352C12.7882 15.7162 12.9898 15.7962 13.1915 15.7962C13.4023 15.7962 13.604 15.7052 13.7598 15.5352C14.0715 15.1962 14.0715 14.6462 13.7598 14.3062L12.1282 12.5262L13.7598 10.7452C14.0715 10.4062 14.0715 9.84616 13.7598 9.50616Z"
                                    fill="black" />
                            </svg>
                            <p>Много-много про опыт, мало про пользу</p>
                        </li>
                        <li>
                            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="25" viewBox="0 0 22 25" fill="none">
                                <path
                                    d="M14.979 2.53516C18.0865 2.53516 20.1673 4.91516 20.1673 8.45516V16.6262C20.1673 20.1562 18.0865 22.5352 14.979 22.5352H7.03148C3.92398 22.5352 1.83398 20.1562 1.83398 16.6262V8.45516C1.83398 4.91516 3.92398 2.53516 7.03148 2.53516H14.979ZM13.7598 9.50616C13.4482 9.16516 12.944 9.16516 12.6232 9.50616L11.0007 11.2852L9.36898 9.50616C9.04815 9.16516 8.54398 9.16516 8.23232 9.50616C7.92065 9.84616 7.92065 10.4062 8.23232 10.7452L9.86399 12.5262L8.23232 14.2962C7.92065 14.6462 7.92065 15.1962 8.23232 15.5352C8.38815 15.7052 8.59898 15.7962 8.80065 15.7962C9.01148 15.7962 9.21315 15.7052 9.36898 15.5352L11.0007 13.7662L12.6323 15.5352C12.7882 15.7162 12.9898 15.7962 13.1915 15.7962C13.4023 15.7962 13.604 15.7052 13.7598 15.5352C14.0715 15.1962 14.0715 14.6462 13.7598 14.3062L12.1282 12.5262L13.7598 10.7452C14.0715 10.4062 14.0715 9.84616 13.7598 9.50616Z"
                                    fill="black" />
                            </svg>
                            <p>Непонятно, почему нанять нужно именно вас<br> и чем вы поможете бизнесу </p>
                        </li>
                        <li>
                            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="25" viewBox="0 0 22 25" fill="none">
                                <path
                                    d="M14.979 2.53516C18.0865 2.53516 20.1673 4.91516 20.1673 8.45516V16.6262C20.1673 20.1562 18.0865 22.5352 14.979 22.5352H7.03148C3.92398 22.5352 1.83398 20.1562 1.83398 16.6262V8.45516C1.83398 4.91516 3.92398 2.53516 7.03148 2.53516H14.979ZM13.7598 9.50616C13.4482 9.16516 12.944 9.16516 12.6232 9.50616L11.0007 11.2852L9.36898 9.50616C9.04815 9.16516 8.54398 9.16516 8.23232 9.50616C7.92065 9.84616 7.92065 10.4062 8.23232 10.7452L9.86399 12.5262L8.23232 14.2962C7.92065 14.6462 7.92065 15.1962 8.23232 15.5352C8.38815 15.7052 8.59898 15.7962 8.80065 15.7962C9.01148 15.7962 9.21315 15.7052 9.36898 15.5352L11.0007 13.7662L12.6323 15.5352C12.7882 15.7162 12.9898 15.7962 13.1915 15.7962C13.4023 15.7962 13.604 15.7052 13.7598 15.5352C14.0715 15.1962 14.0715 14.6462 13.7598 14.3062L12.1282 12.5262L13.7598 10.7452C14.0715 10.4062 14.0715 9.84616 13.7598 9.50616Z"
                                    fill="black" />
                            </svg>
                            <p>Проблемы со структурой</p>
                        </li>
                        <li>
                            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="25" viewBox="0 0 22 25" fill="none">
                                <path
                                    d="M14.979 2.53516C18.0865 2.53516 20.1673 4.91516 20.1673 8.45516V16.6262C20.1673 20.1562 18.0865 22.5352 14.979 22.5352H7.03148C3.92398 22.5352 1.83398 20.1562 1.83398 16.6262V8.45516C1.83398 4.91516 3.92398 2.53516 7.03148 2.53516H14.979ZM13.7598 9.50616C13.4482 9.16516 12.944 9.16516 12.6232 9.50616L11.0007 11.2852L9.36898 9.50616C9.04815 9.16516 8.54398 9.16516 8.23232 9.50616C7.92065 9.84616 7.92065 10.4062 8.23232 10.7452L9.86399 12.5262L8.23232 14.2962C7.92065 14.6462 7.92065 15.1962 8.23232 15.5352C8.38815 15.7052 8.59898 15.7962 8.80065 15.7962C9.01148 15.7962 9.21315 15.7052 9.36898 15.5352L11.0007 13.7662L12.6323 15.5352C12.7882 15.7162 12.9898 15.7962 13.1915 15.7962C13.4023 15.7962 13.604 15.7052 13.7598 15.5352C14.0715 15.1962 14.0715 14.6462 13.7598 14.3062L12.1282 12.5262L13.7598 10.7452C14.0715 10.4062 14.0715 9.84616 13.7598 9.50616Z"
                                    fill="black" />
                            </svg>
                            <p>Есть красные флаги для рекрутера</p>
                        </li>
                        <li>
                            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="25" viewBox="0 0 22 25" fill="none">
                                <path
                                    d="M14.979 2.53516C18.0865 2.53516 20.1673 4.91516 20.1673 8.45516V16.6262C20.1673 20.1562 18.0865 22.5352 14.979 22.5352H7.03148C3.92398 22.5352 1.83398 20.1562 1.83398 16.6262V8.45516C1.83398 4.91516 3.92398 2.53516 7.03148 2.53516H14.979ZM13.7598 9.50616C13.4482 9.16516 12.944 9.16516 12.6232 9.50616L11.0007 11.2852L9.36898 9.50616C9.04815 9.16516 8.54398 9.16516 8.23232 9.50616C7.92065 9.84616 7.92065 10.4062 8.23232 10.7452L9.86399 12.5262L8.23232 14.2962C7.92065 14.6462 7.92065 15.1962 8.23232 15.5352C8.38815 15.7052 8.59898 15.7962 8.80065 15.7962C9.01148 15.7962 9.21315 15.7052 9.36898 15.5352L11.0007 13.7662L12.6323 15.5352C12.7882 15.7162 12.9898 15.7962 13.1915 15.7962C13.4023 15.7962 13.604 15.7052 13.7598 15.5352C14.0715 15.1962 14.0715 14.6462 13.7598 14.3062L12.1282 12.5262L13.7598 10.7452C14.0715 10.4062 14.0715 9.84616 13.7598 9.50616Z"
                                    fill="black" />
                            </svg>
                            <p>Используются формулировки, которые снижают вашу ценность</p>
                        </li>
                        <li>
                            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="25" viewBox="0 0 22 25" fill="none">
                                <path
                                    d="M14.979 2.53516C18.0865 2.53516 20.1673 4.91516 20.1673 8.45516V16.6262C20.1673 20.1562 18.0865 22.5352 14.979 22.5352H7.03148C3.92398 22.5352 1.83398 20.1562 1.83398 16.6262V8.45516C1.83398 4.91516 3.92398 2.53516 7.03148 2.53516H14.979ZM13.7598 9.50616C13.4482 9.16516 12.944 9.16516 12.6232 9.50616L11.0007 11.2852L9.36898 9.50616C9.04815 9.16516 8.54398 9.16516 8.23232 9.50616C7.92065 9.84616 7.92065 10.4062 8.23232 10.7452L9.86399 12.5262L8.23232 14.2962C7.92065 14.6462 7.92065 15.1962 8.23232 15.5352C8.38815 15.7052 8.59898 15.7962 8.80065 15.7962C9.01148 15.7962 9.21315 15.7052 9.36898 15.5352L11.0007 13.7662L12.6323 15.5352C12.7882 15.7162 12.9898 15.7962 13.1915 15.7962C13.4023 15.7962 13.604 15.7052 13.7598 15.5352C14.0715 15.1962 14.0715 14.6462 13.7598 14.3062L12.1282 12.5262L13.7598 10.7452C14.0715 10.4062 14.0715 9.84616 13.7598 9.50616Z"
                                    fill="black" />
                            </svg>
                            <p>Резюме не презентует весь ваш потенциал</p>
                        </li>
                    </ul>
                    <p>«В моем CV уже учтено все, о чем написано выше. Но меня все равно не нанимают! Памигити-и-и...»</p>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-intens-before-mobile', {
        label: 'Интенсив до (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-intens-before-mobile">
            <div>
                <div class="careerum-intens-before-left">
                    <h2>Резюме до интенсива: пресное, похожее на другие, без «огонька»</h2>
                </div>
                <div class="careerum-intens-before-right">
                    <ul>
                        <li>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path
                                    d="M16.34 2C19.73 2 22 4.38 22 7.92V16.091C22 19.621 19.73 22 16.34 22H7.67C4.28 22 2 19.621 2 16.091V7.92C2 4.38 4.28 2 7.67 2H16.34ZM15.01 8.971C14.67 8.63 14.12 8.63 13.77 8.971L12 10.75L10.22 8.971C9.87 8.63 9.32 8.63 8.98 8.971C8.64 9.311 8.64 9.871 8.98 10.21L10.76 11.991L8.98 13.761C8.64 14.111 8.64 14.661 8.98 15C9.15 15.17 9.38 15.261 9.6 15.261C9.83 15.261 10.05 15.17 10.22 15L12 13.231L13.78 15C13.95 15.181 14.17 15.261 14.39 15.261C14.62 15.261 14.84 15.17 15.01 15C15.35 14.661 15.35 14.111 15.01 13.771L13.23 11.991L15.01 10.21C15.35 9.871 15.35 9.311 15.01 8.971Z"
                                    fill="black" />
                            </svg>
                            <p>Много-много про опыт, мало<br> про пользу</p>
                        </li>
                        <li>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path
                                    d="M16.34 2C19.73 2 22 4.38 22 7.92V16.091C22 19.621 19.73 22 16.34 22H7.67C4.28 22 2 19.621 2 16.091V7.92C2 4.38 4.28 2 7.67 2H16.34ZM15.01 8.971C14.67 8.63 14.12 8.63 13.77 8.971L12 10.75L10.22 8.971C9.87 8.63 9.32 8.63 8.98 8.971C8.64 9.311 8.64 9.871 8.98 10.21L10.76 11.991L8.98 13.761C8.64 14.111 8.64 14.661 8.98 15C9.15 15.17 9.38 15.261 9.6 15.261C9.83 15.261 10.05 15.17 10.22 15L12 13.231L13.78 15C13.95 15.181 14.17 15.261 14.39 15.261C14.62 15.261 14.84 15.17 15.01 15C15.35 14.661 15.35 14.111 15.01 13.771L13.23 11.991L15.01 10.21C15.35 9.871 15.35 9.311 15.01 8.971Z"
                                    fill="black" />
                            </svg>
                            <p>Непонятно, почему нанять нужно именно ваc и чем вы поможете бизнесу </p>
                        </li>
                        <li>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path
                                    d="M16.34 2C19.73 2 22 4.38 22 7.92V16.091C22 19.621 19.73 22 16.34 22H7.67C4.28 22 2 19.621 2 16.091V7.92C2 4.38 4.28 2 7.67 2H16.34ZM15.01 8.971C14.67 8.63 14.12 8.63 13.77 8.971L12 10.75L10.22 8.971C9.87 8.63 9.32 8.63 8.98 8.971C8.64 9.311 8.64 9.871 8.98 10.21L10.76 11.991L8.98 13.761C8.64 14.111 8.64 14.661 8.98 15C9.15 15.17 9.38 15.261 9.6 15.261C9.83 15.261 10.05 15.17 10.22 15L12 13.231L13.78 15C13.95 15.181 14.17 15.261 14.39 15.261C14.62 15.261 14.84 15.17 15.01 15C15.35 14.661 15.35 14.111 15.01 13.771L13.23 11.991L15.01 10.21C15.35 9.871 15.35 9.311 15.01 8.971Z"
                                    fill="black" />
                            </svg>
                            <p>Проблемы со структурой</p>
                        </li>
                        <li>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path
                                    d="M16.34 2C19.73 2 22 4.38 22 7.92V16.091C22 19.621 19.73 22 16.34 22H7.67C4.28 22 2 19.621 2 16.091V7.92C2 4.38 4.28 2 7.67 2H16.34ZM15.01 8.971C14.67 8.63 14.12 8.63 13.77 8.971L12 10.75L10.22 8.971C9.87 8.63 9.32 8.63 8.98 8.971C8.64 9.311 8.64 9.871 8.98 10.21L10.76 11.991L8.98 13.761C8.64 14.111 8.64 14.661 8.98 15C9.15 15.17 9.38 15.261 9.6 15.261C9.83 15.261 10.05 15.17 10.22 15L12 13.231L13.78 15C13.95 15.181 14.17 15.261 14.39 15.261C14.62 15.261 14.84 15.17 15.01 15C15.35 14.661 15.35 14.111 15.01 13.771L13.23 11.991L15.01 10.21C15.35 9.871 15.35 9.311 15.01 8.971Z"
                                    fill="black" />
                            </svg>
                            <p>Есть красные флаги <br>для рекрутера</p>
                        </li>
                        <li>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path
                                    d="M16.34 2C19.73 2 22 4.38 22 7.92V16.091C22 19.621 19.73 22 16.34 22H7.67C4.28 22 2 19.621 2 16.091V7.92C2 4.38 4.28 2 7.67 2H16.34ZM15.01 8.971C14.67 8.63 14.12 8.63 13.77 8.971L12 10.75L10.22 8.971C9.87 8.63 9.32 8.63 8.98 8.971C8.64 9.311 8.64 9.871 8.98 10.21L10.76 11.991L8.98 13.761C8.64 14.111 8.64 14.661 8.98 15C9.15 15.17 9.38 15.261 9.6 15.261C9.83 15.261 10.05 15.17 10.22 15L12 13.231L13.78 15C13.95 15.181 14.17 15.261 14.39 15.261C14.62 15.261 14.84 15.17 15.01 15C15.35 14.661 15.35 14.111 15.01 13.771L13.23 11.991L15.01 10.21C15.35 9.871 15.35 9.311 15.01 8.971Z"
                                    fill="black" />
                            </svg>
                            <p>Используются формулировки, которые снижают вашу ценность</p>
                        </li>
                        <li>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path
                                    d="M16.34 2C19.73 2 22 4.38 22 7.92V16.091C22 19.621 19.73 22 16.34 22H7.67C4.28 22 2 19.621 2 16.091V7.92C2 4.38 4.28 2 7.67 2H16.34ZM15.01 8.971C14.67 8.63 14.12 8.63 13.77 8.971L12 10.75L10.22 8.971C9.87 8.63 9.32 8.63 8.98 8.971C8.64 9.311 8.64 9.871 8.98 10.21L10.76 11.991L8.98 13.761C8.64 14.111 8.64 14.661 8.98 15C9.15 15.17 9.38 15.261 9.6 15.261C9.83 15.261 10.05 15.17 10.22 15L12 13.231L13.78 15C13.95 15.181 14.17 15.261 14.39 15.261C14.62 15.261 14.84 15.17 15.01 15C15.35 14.661 15.35 14.111 15.01 13.771L13.23 11.991L15.01 10.21C15.35 9.871 15.35 9.311 15.01 8.971Z"
                                    fill="black" />
                            </svg>
                            <p>Резюме не презентует весь ваш потенциал</p>
                        </li>
                    </ul>
                    <p>«В моем CV уже учтено все, о чем написано выше. Но меня все равно не нанимают! Памигити-и-и...»</p>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1706202590131.png" alt="">
                </div>
            </div>
        </div>`
	});
    
    blockManager.add('careerum-intens-after', {
        label: 'Интенсив после',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-intens-after">
            <div>
                <div>
                    <h2>Ваше резюме после интенсива</h2>
                </div>
                <div class="intens-after-bottom">
                    <div class="intens-after-item">
                        <div class="intens-after-item-left">
                            <h4>После первого эфира</h4>
                            <div>
                                <p>Ого, почему я раньше этого не знал!</p>
                            </div>
                            <p>6 февраля, 19:00 МСК / 17:00 CET</p>
                        </div>
                        <div class="intens-after-item-right">
                            <ul>
                                <li>Определите тип резюме, который подходит именно к вашей ситуации</li>
                                <li>Освоите основы анализа рынка труда</li>
                                <li>Поймете, на что обращает внимание рекрутер</li>
                                <li>Уберете лишнюю информацию, из-за которой ваше резюме не работает</li>
                            </ul>
                        </div>
                    </div>
                    <div class="intens-after-item">
                        <div class="intens-after-item-left">
                            <h4>После второго эфира</h4>
                            <div>
                                <p>О Боги, я и не думал, </p>
                                <p>что мой опыт так хорош...</p>
                            </div>
                            <p>8 февраля, 19:00 МСК / 17:00 CET</p>
                        </div>
                        <div class="intens-after-item-right">
                            <ul>
                                <li>Узнаете, какие бывают типы достижений</li>
                                <li>Поймете, что является достижениями в вашем опыте</li>
                                <li>Научитесь демонстрировать навыки, необходимые для вакансии</li>
                                <li>Сможете искать достижения, даже когда кажется, что их нет</li>
                            </ul>
                        </div>
                    </div>
                    <div class="intens-after-item">
                        <div class="intens-after-item-left">
                            <h4>После третьего эфира</h4>
                            <div>
                                <p>Держите меня, я сейчас</p>
                                <p>сам себя найму</p>
                            </div>
                            <p>13 февраля, 19:00 МСК / 17:00 CET</p>
                        </div>
                        <div class="intens-after-item-right">
                            <ul>
                                <li>Узнаете, как оформить резюме так, чтобы оно легко читалось</li>
                                <li>Увидите разницу между слабым и сильным саммари</li>
                                <li>Уберете из CV лишние навыки и добавите нужные</li>
                                <li>Поймете, как адаптировать резюме под конкретную вакансию</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="intens-after-link">
                    <a href="#buy" class="btn-color-main-dark-orange">Прокачать резюме</a>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-intens-after-tablet', {
        label: 'Интенсив после (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-intens-after-tablet">
            <div>
                <div>
                    <h2>Ваше резюме после интенсива</h2>
                </div>
                <div class="intens-after-bottom">
                    <div class="intens-after-item">
                        <div class="intens-after-item-left">
                            <h4>После первого эфира</h4>
                            <div>
                                <p>Ого, почему я раньше</p> 
                                <p>этого не знал!</p>
                            </div>
                            <p>6 февраля, 19:00 МСК / 17:00 CET</p>
                        </div>
                        <div class="intens-after-item-right">
                            <ul>
                                <li>Определите тип резюме, который подходит именно к вашей ситуации</li>
                                <li>Освоите основы анализа рынка труда</li>
                                <li>Поймете, на что обращает внимание рекрутер</li>
                                <li>Уберете лишнюю информацию, из-за которой ваше резюме не работает</li>
                            </ul>
                        </div>
                    </div>
                    <div class="intens-after-item">
                        <div class="intens-after-item-left">
                            <h4>После второго эфира</h4>
                            <div>
                                <p>Ого, почему я раньше</p> 
                                <p>этого не знал!</p>
                            </div>
                            <p>8 февраля, 19:00 МСК / 17:00 CET</p>
                        </div>
                        <div class="intens-after-item-right">
                            <ul>
                                <li>Узнаете, какие бывают типы достижений</li>
                                <li>Поймете, что является достижениями в вашем опыте</li>
                                <li>Научитесь демонстрировать навыки, необходимые для вакансии</li>
                                <li>Сможете искать достижения, даже когда кажется, что их нет</li>
                            </ul>
                        </div>
                    </div>
                    <div class="intens-after-item">
                        <div class="intens-after-item-left">
                            <h4>После третьего эфира</h4>
                            <div>
                                <p>Держите меня, я сейчас</p>
                                <p>сам себя найму</p>
                            </div>
                            <p>13 февраля, 19:00 МСК / 17:00 CET</p>
                        </div>
                        <div class="intens-after-item-right">
                            <ul>
                                <li>Узнаете, как оформить резюме так, чтобы оно легко читалось</li>
                                <li>Увидите разницу между слабым и сильным саммари</li>
                                <li>Уберете из CV лишние навыки и добавите нужные</li>
                                <li>Поймете, как адаптировать резюме под конкретную вакансию</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="intens-after-link">
                    <a href="#buy" class="btn-color-main-dark-orange">Прокачать резюме</a>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-intens-after-mobile', {
        label: 'Интенсив после (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-intens-after-mobile">
            <div>
                <div>
                    <h2>Ваше резюме<br> после интенсива</h2>
                </div>
                <div class="intens-after-bottom">
                    <div class="intens-after-item">
                        <div class="intens-after-item-left">
                            <p>6 февраля, 19:00 МСК / 17:00 CET</p>
                            <h4>После первого эфира</h4>
                            <div>
                                <p>Ого, почему я раньше</p>
                                <p>этого не знал!</p>
                            </div>
                        </div>
                        <div class="intens-after-item-right">
                            <ul>
                                <li>Определите тип резюме, который подходит именно к вашей ситуации</li>
                                <li>Освоите основы анализа рынка труда</li>
                                <li>Поймете, на что обращает внимание рекрутер</li>
                                <li>Уберете лишнюю информацию, из-за которой ваше резюме не работает</li>
                            </ul>
                        </div>
                    </div>
                    <div class="intens-after-item">
                        <div class="intens-after-item-left">
                            <p>8 февраля, 19:00 МСК / 17:00 CET</p>
                            <h4>После второго эфира</h4>
                            <div>
                                <p>О Боги, я и не думал, </p>
                                <p>что мой опыт так хорош...</p>
                            </div>
                        </div>
                        <div class="intens-after-item-right">
                            <ul>
                                <li>Узнаете, какие бывают типы достижений</li>
                                <li>Поймете, что является достижениями в вашем опыте</li>
                                <li>Научитесь демонстрировать навыки, необходимые для вакансии</li>
                                <li>Сможете искать достижения, даже когда кажется, что их нет</li>
                            </ul>
                        </div>
                    </div>
                    <div class="intens-after-item">
                        <div class="intens-after-item-left">
                            <p>13 февраля, 19:00 МСК / 17:00 CET</p>
                            <h4>После третьего эфира</h4>
                            <div>
                                <p>Держите меня, я сейчас</p>
                                <p>сам себя найму</p>
                            </div>
                        </div>
                        <div class="intens-after-item-right">
                            <ul>
                                <li>Узнаете, как оформить резюме так, чтобы оно легко читалось</li>
                                <li>Увидите разницу между слабым и сильным саммари</li>
                                <li>Уберете из CV лишние навыки и добавите нужные</li>
                                <li>Поймете, как адаптировать резюме под конкретную вакансию</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="intens-after-link">
                    <a href="#buy" class="btn-color-main-dark-orange">Прокачать резюме</a>
                </div>
            </div>
        </div>`
	});
    
    blockManager.add('careerum-intens-author', {
        label: 'Интенсив ведущий',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-intens-author">
            <div>
                <div>
                    <h2>Ведущая интенсива — Софи Бессон,<br>CV-эксперт карьерной платформы Careerum</h2>
                </div>
                <div class="intens-author-bottom">
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1706174941202.png" alt="">
                    </div>
                    <div>
                        <div>
                            <div>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25"
                                    fill="none">
                                    <path
                                        d="M21.8099 13.4246C21.8819 13.4651 21.8963 13.551 21.8992 13.5837L21.9 13.5968L21.8199 18.7613C21.8199 20.8214 20.2237 22.5014 18.2138 22.6044L18.018 22.6094H5.97199C3.93659 22.6094 2.27678 20.9938 2.17503 18.9594L2.17009 18.7613L2.10005 13.5968C2.10005 13.5968 2.10005 13.4752 2.1901 13.4246C2.27014 13.374 2.37019 13.4347 2.38019 13.4449C4.4012 14.8018 6.83242 15.7031 9.38369 16.0778C9.74387 16.1284 10.1041 15.8955 10.2041 15.5309C10.4105 14.7525 11.0477 14.2232 11.8273 14.1601L11.985 14.1537H12.015C12.8654 14.1537 13.5758 14.7006 13.7959 15.5309C13.8959 15.8955 14.2561 16.1284 14.6163 16.0778C17.1676 15.7031 19.5988 14.8018 21.6198 13.4449C21.6198 13.4449 21.6398 13.4347 21.6598 13.4246C21.6999 13.4044 21.7599 13.3942 21.8099 13.4246ZM11.995 15.6018C11.619 15.6018 11.3018 15.8911 11.2516 16.2591L11.2446 16.3613V17.6676C11.2446 18.0929 11.5848 18.4271 11.995 18.4271C12.3802 18.4271 12.6897 18.1463 12.7386 17.7719L12.7454 17.6676V16.3613C12.7454 15.9461 12.4152 15.6018 11.995 15.6018ZM13.2856 2.60938C14.7864 2.60938 16.017 3.75367 16.2071 5.22202H18.1881C20.2891 5.22202 22 6.95366 22 9.08023C22 9.08023 21.94 9.98048 21.92 11.2341C21.918 11.3334 21.8699 11.4306 21.7909 11.4893C21.3097 11.8448 20.8694 12.1384 20.8294 12.1587C19.1686 13.2726 17.2386 14.0564 15.1826 14.4463C15.0485 14.4726 14.9165 14.4027 14.8484 14.2832C14.2721 13.2848 13.1956 12.6346 11.995 12.6346C10.8024 12.6346 9.71586 13.2777 9.12256 14.2772C9.05353 14.3946 8.92346 14.4625 8.7904 14.4372C6.75138 14.0463 4.82141 13.2635 3.17059 12.1688L2.21011 11.5005C2.13007 11.4498 2.08004 11.3587 2.08004 11.2574C2.05003 10.741 2 9.08023 2 9.08023C2 6.95366 3.71086 5.22202 5.81191 5.22202H7.78289C7.97299 3.75367 9.2036 2.60938 10.7044 2.60938H13.2856ZM13.2856 4.12835H10.7044C10.034 4.12835 9.46373 4.59417 9.30365 5.22202H14.6863C14.5263 4.59417 13.956 4.12835 13.2856 4.12835Z"
                                        fill="black" />
                                </svg>
                                <p>Карьерный консультант с международным опытом, специализирующийся на поиске работы</p>
                            </div>
                            <div>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25"
                                    fill="none">
                                    <path
                                        d="M16.191 2.61133C19.28 2.61133 21 4.39133 21 7.44133V17.7713C21 20.8713 19.28 22.6113 16.191 22.6113H7.81C4.77 22.6113 3 20.8713 3 17.7713V7.44133C3 4.39133 4.77 2.61133 7.81 2.61133H16.191ZM8.08 16.3513C7.78 16.3213 7.49 16.4613 7.33 16.7213C7.17 16.9713 7.17 17.3013 7.33 17.5613C7.49 17.8113 7.78 17.9613 8.08 17.9213H15.92C16.319 17.8813 16.62 17.5403 16.62 17.1413C16.62 16.7313 16.319 16.3913 15.92 16.3513H8.08ZM15.92 11.7903H8.08C7.649 11.7903 7.3 12.1413 7.3 12.5713C7.3 13.0013 7.649 13.3513 8.08 13.3513H15.92C16.35 13.3513 16.7 13.0013 16.7 12.5713C16.7 12.1413 16.35 11.7903 15.92 11.7903ZM11.069 7.26133H8.08V7.27133C7.649 7.27133 7.3 7.62133 7.3 8.05133C7.3 8.48133 7.649 8.83133 8.08 8.83133H11.069C11.5 8.83133 11.85 8.48133 11.85 8.04033C11.85 7.61133 11.5 7.26133 11.069 7.26133Z"
                                        fill="black" />
                                </svg>
                                <p>Магистр организационной психологии</p>
                            </div>
                        </div>
                        <div>
                            <div>
                                <h4>4,5 года</h4>
                                <p>в карьерном консалтинге. С 2015 года — в HR</p>
                            </div>
                            <div>
                                <h4>9,7 из 10</h4>
                                <p>средний балл оценки качества работы от клиентов</p>
                            </div>
                        </div>
                        <div>
                            <h4>600+ успешных клиентов</h4>
                            <p>из локальных и международных компаний: IBM, World Bank, Microsoft, Disney, Mastercard и др.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-intens-author-tablet', {
        label: 'Интенсив ведущий (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-intens-author-tablet">
            <div>
                <div>
                    <h2>Ведущая интенсива — Софи Бессон,<br>CV-эксперт карьерной платформы Careerum</h2>
                </div>
                <div class="intens-author-bottom">
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1706196708027.png" alt="">
                    </div>
                    <div>
                        <div>
                            <div>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25"
                                    fill="none">
                                    <path
                                        d="M21.8099 13.4246C21.8819 13.4651 21.8963 13.551 21.8992 13.5837L21.9 13.5968L21.8199 18.7613C21.8199 20.8214 20.2237 22.5014 18.2138 22.6044L18.018 22.6094H5.97199C3.93659 22.6094 2.27678 20.9938 2.17503 18.9594L2.17009 18.7613L2.10005 13.5968C2.10005 13.5968 2.10005 13.4752 2.1901 13.4246C2.27014 13.374 2.37019 13.4347 2.38019 13.4449C4.4012 14.8018 6.83242 15.7031 9.38369 16.0778C9.74387 16.1284 10.1041 15.8955 10.2041 15.5309C10.4105 14.7525 11.0477 14.2232 11.8273 14.1601L11.985 14.1537H12.015C12.8654 14.1537 13.5758 14.7006 13.7959 15.5309C13.8959 15.8955 14.2561 16.1284 14.6163 16.0778C17.1676 15.7031 19.5988 14.8018 21.6198 13.4449C21.6198 13.4449 21.6398 13.4347 21.6598 13.4246C21.6999 13.4044 21.7599 13.3942 21.8099 13.4246ZM11.995 15.6018C11.619 15.6018 11.3018 15.8911 11.2516 16.2591L11.2446 16.3613V17.6676C11.2446 18.0929 11.5848 18.4271 11.995 18.4271C12.3802 18.4271 12.6897 18.1463 12.7386 17.7719L12.7454 17.6676V16.3613C12.7454 15.9461 12.4152 15.6018 11.995 15.6018ZM13.2856 2.60938C14.7864 2.60938 16.017 3.75367 16.2071 5.22202H18.1881C20.2891 5.22202 22 6.95366 22 9.08023C22 9.08023 21.94 9.98048 21.92 11.2341C21.918 11.3334 21.8699 11.4306 21.7909 11.4893C21.3097 11.8448 20.8694 12.1384 20.8294 12.1587C19.1686 13.2726 17.2386 14.0564 15.1826 14.4463C15.0485 14.4726 14.9165 14.4027 14.8484 14.2832C14.2721 13.2848 13.1956 12.6346 11.995 12.6346C10.8024 12.6346 9.71586 13.2777 9.12256 14.2772C9.05353 14.3946 8.92346 14.4625 8.7904 14.4372C6.75138 14.0463 4.82141 13.2635 3.17059 12.1688L2.21011 11.5005C2.13007 11.4498 2.08004 11.3587 2.08004 11.2574C2.05003 10.741 2 9.08023 2 9.08023C2 6.95366 3.71086 5.22202 5.81191 5.22202H7.78289C7.97299 3.75367 9.2036 2.60938 10.7044 2.60938H13.2856ZM13.2856 4.12835H10.7044C10.034 4.12835 9.46373 4.59417 9.30365 5.22202H14.6863C14.5263 4.59417 13.956 4.12835 13.2856 4.12835Z"
                                        fill="black" />
                                </svg>
                                <p>Карьерный консультант с международным опытом, специализи-руется на поиске работы</p>
                            </div>
                            <div>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25"
                                    fill="none">
                                    <path
                                        d="M16.191 2.61133C19.28 2.61133 21 4.39133 21 7.44133V17.7713C21 20.8713 19.28 22.6113 16.191 22.6113H7.81C4.77 22.6113 3 20.8713 3 17.7713V7.44133C3 4.39133 4.77 2.61133 7.81 2.61133H16.191ZM8.08 16.3513C7.78 16.3213 7.49 16.4613 7.33 16.7213C7.17 16.9713 7.17 17.3013 7.33 17.5613C7.49 17.8113 7.78 17.9613 8.08 17.9213H15.92C16.319 17.8813 16.62 17.5403 16.62 17.1413C16.62 16.7313 16.319 16.3913 15.92 16.3513H8.08ZM15.92 11.7903H8.08C7.649 11.7903 7.3 12.1413 7.3 12.5713C7.3 13.0013 7.649 13.3513 8.08 13.3513H15.92C16.35 13.3513 16.7 13.0013 16.7 12.5713C16.7 12.1413 16.35 11.7903 15.92 11.7903ZM11.069 7.26133H8.08V7.27133C7.649 7.27133 7.3 7.62133 7.3 8.05133C7.3 8.48133 7.649 8.83133 8.08 8.83133H11.069C11.5 8.83133 11.85 8.48133 11.85 8.04033C11.85 7.61133 11.5 7.26133 11.069 7.26133Z"
                                        fill="black" />
                                </svg>
                                <p>Магистр организационной психологии</p>
                            </div>
                        </div>
                        <div>
                            <div>
                                <h4>4,5 года</h4>
                                <p>в карьерном консалтинге. С 2015 года — в HR</p>
                            </div>
                            <div>
                                <h4>9,7 из 10</h4>
                                <p>средний балл оценки качества работы от клиентов</p>
                            </div>
                        </div>
                        <div>
                            <h4>600+ успешных клиентов</h4>
                            <p>из локальных и международных компаний: IBM, World Bank, Microsoft, Disney, Mastercard и др.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-intens-author-mobile', {
        label: 'Интенсив ведущий (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-intens-author-mobile">
            <div>
                <div>
                    <h2>Ведущая интенсива — Софи Бессон, CV-эксперт<br> карьерной платформы Careerum</h2>
                </div>
                <div class="intens-author-bottom">
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1706203174067.png" alt="">
                    </div>
                    <div>
                        <div>
                            <div>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25"
                                    fill="none">
                                    <path
                                        d="M21.8099 13.4246C21.8819 13.4651 21.8963 13.551 21.8992 13.5837L21.9 13.5968L21.8199 18.7613C21.8199 20.8214 20.2237 22.5014 18.2138 22.6044L18.018 22.6094H5.97199C3.93659 22.6094 2.27678 20.9938 2.17503 18.9594L2.17009 18.7613L2.10005 13.5968C2.10005 13.5968 2.10005 13.4752 2.1901 13.4246C2.27014 13.374 2.37019 13.4347 2.38019 13.4449C4.4012 14.8018 6.83242 15.7031 9.38369 16.0778C9.74387 16.1284 10.1041 15.8955 10.2041 15.5309C10.4105 14.7525 11.0477 14.2232 11.8273 14.1601L11.985 14.1537H12.015C12.8654 14.1537 13.5758 14.7006 13.7959 15.5309C13.8959 15.8955 14.2561 16.1284 14.6163 16.0778C17.1676 15.7031 19.5988 14.8018 21.6198 13.4449C21.6198 13.4449 21.6398 13.4347 21.6598 13.4246C21.6999 13.4044 21.7599 13.3942 21.8099 13.4246ZM11.995 15.6018C11.619 15.6018 11.3018 15.8911 11.2516 16.2591L11.2446 16.3613V17.6676C11.2446 18.0929 11.5848 18.4271 11.995 18.4271C12.3802 18.4271 12.6897 18.1463 12.7386 17.7719L12.7454 17.6676V16.3613C12.7454 15.9461 12.4152 15.6018 11.995 15.6018ZM13.2856 2.60938C14.7864 2.60938 16.017 3.75367 16.2071 5.22202H18.1881C20.2891 5.22202 22 6.95366 22 9.08023C22 9.08023 21.94 9.98048 21.92 11.2341C21.918 11.3334 21.8699 11.4306 21.7909 11.4893C21.3097 11.8448 20.8694 12.1384 20.8294 12.1587C19.1686 13.2726 17.2386 14.0564 15.1826 14.4463C15.0485 14.4726 14.9165 14.4027 14.8484 14.2832C14.2721 13.2848 13.1956 12.6346 11.995 12.6346C10.8024 12.6346 9.71586 13.2777 9.12256 14.2772C9.05353 14.3946 8.92346 14.4625 8.7904 14.4372C6.75138 14.0463 4.82141 13.2635 3.17059 12.1688L2.21011 11.5005C2.13007 11.4498 2.08004 11.3587 2.08004 11.2574C2.05003 10.741 2 9.08023 2 9.08023C2 6.95366 3.71086 5.22202 5.81191 5.22202H7.78289C7.97299 3.75367 9.2036 2.60938 10.7044 2.60938H13.2856ZM13.2856 4.12835H10.7044C10.034 4.12835 9.46373 4.59417 9.30365 5.22202H14.6863C14.5263 4.59417 13.956 4.12835 13.2856 4.12835Z"
                                        fill="black" />
                                </svg>
                                <p>Карьерный консультант с международным опытом, специализируется на поиске работы</p>
                            </div>
                            <div>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25"
                                    fill="none">
                                    <path
                                        d="M16.191 2.61133C19.28 2.61133 21 4.39133 21 7.44133V17.7713C21 20.8713 19.28 22.6113 16.191 22.6113H7.81C4.77 22.6113 3 20.8713 3 17.7713V7.44133C3 4.39133 4.77 2.61133 7.81 2.61133H16.191ZM8.08 16.3513C7.78 16.3213 7.49 16.4613 7.33 16.7213C7.17 16.9713 7.17 17.3013 7.33 17.5613C7.49 17.8113 7.78 17.9613 8.08 17.9213H15.92C16.319 17.8813 16.62 17.5403 16.62 17.1413C16.62 16.7313 16.319 16.3913 15.92 16.3513H8.08ZM15.92 11.7903H8.08C7.649 11.7903 7.3 12.1413 7.3 12.5713C7.3 13.0013 7.649 13.3513 8.08 13.3513H15.92C16.35 13.3513 16.7 13.0013 16.7 12.5713C16.7 12.1413 16.35 11.7903 15.92 11.7903ZM11.069 7.26133H8.08V7.27133C7.649 7.27133 7.3 7.62133 7.3 8.05133C7.3 8.48133 7.649 8.83133 8.08 8.83133H11.069C11.5 8.83133 11.85 8.48133 11.85 8.04033C11.85 7.61133 11.5 7.26133 11.069 7.26133Z"
                                        fill="black" />
                                </svg>
                                <p>Магистр организационной психологии</p>
                            </div>
                        </div>
                        <div>
                            <div>
                                <h4>4,5 года</h4>
                                <p>в карьерном консалтинге. <br>С 2015 года — в HR</p>
                            </div>
                            <div>
                                <h4>9,7 из 10</h4>
                                <p>средний балл оценки качества работы<br> от клиентов</p>
                            </div>
                        </div>
                        <div>
                            <h4>600+ успешных клиентов</h4>
                            <p>из локальных и международных компаний: IBM, World Bank, Microsoft, Disney, Mastercard и др.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
	});
    
    blockManager.add('careerum-intens-product', {
        label: 'Интенсив продукт',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-intens-product">
            <div>
                <div class="intens-product-top">
                    <div>
                        <h2>Новый образовательный продукт от платформы карьерного развития Careerum</h2>
                    </div>
                    <div>
                        <p>Careerum — образовательная платформа, с помощью которой профессионалы могут получить иммерсивный
                            опыт для развития карьеры.</p>
                        <p>Экосистема Careerum позволяет выбрать определенную цель — усилить резюме, устроиться на работу,
                            вырасти в доходе или другую — и достичь ее самостоятельно или с поддержкой опытных
                            экспертов-практиков.</p>
                    </div>
                </div>
                <div class="intens-product-bottom">
                    <div>
                        <h4>11 000+</h4>
                        <p>русскоговорящих специалистов из 30+ стран</p>
                    </div>
                    <div>
                        <h4>3 800+</h4>
                        <p>часов проведенных коуч-сессий</p>
                    </div>
                    <div>
                        <h4>9.5/10</h4>
                        <p>средняя оценка коучей
                            клиентами Careerum</p>
                    </div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-intens-product-tablet', {
        label: 'Интенсив продукт (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-intens-product-tablet">
            <div>
                <div class="intens-product-top">
                    <div>
                        <h2>Новый образовательный продукт от платформы карьерного развития Careerum</h2>
                    </div>
                    <div>
                        <p>Careerum — образовательная платформа, с помощью которой профессионалы могут получить иммерсивный
                            опыт для развития карьеры.</p>
                        <p>Экосистема Careerum позволяет выбрать определенную цель — усилить резюме, устроиться на работу,
                            вырасти в доходе или другую — и достичь ее самостоятельно или с поддержкой опытных
                            экспертов-практиков.</p>
                    </div>
                </div>
                <div class="intens-product-bottom">
                    <div>
                        <h4>11 000+</h4>
                        <p>русскоговорящих специалистов из 30+ стран</p>
                    </div>
                    <div>
                        <h4>3 800+</h4>
                        <p>часов проведенных коуч-сессий</p>
                    </div>
                    <div>
                        <h4>9.5/10</h4>
                        <p>средняя оценка коучей
                            клиентами Careerum</p>
                    </div>
                </div>
            </div>
        </div>`
	});
    
    blockManager.add('careerum-intens-result', {
        label: 'Интенсив результат',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-intens-result">
            <div>
                <div class="intens-result-header">
                    <h2>Научитесь составлять резюме, которое<br> открывает двери в компании мечты</h2>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1706175782428.png" alt="">
                </div>
                <div class="intens-result-top">
                    <div>
                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="33" viewBox="0 0 32 33" fill="none">
                            <path
                                d="M26.653 25.8823C27.3958 25.8823 28 26.4943 28 27.2468C28 28.0007 27.3958 28.6113 26.653 28.6113H19.0396C18.2968 28.6113 17.6926 28.0007 17.6926 27.2468C17.6926 26.4943 18.2968 25.8823 19.0396 25.8823H26.653ZM21.3731 5.54341L23.3398 7.10571C24.1463 7.73636 24.684 8.56767 24.8679 9.44198C25.0801 10.4037 24.8537 11.3483 24.217 12.1652L12.5019 27.3152C11.9642 28.0032 11.1719 28.3902 10.323 28.4045L5.65386 28.4618C5.39918 28.4618 5.18695 28.2898 5.13036 28.0462L4.0692 23.4453C3.88526 22.5996 4.0692 21.7253 4.60685 21.0517L12.9122 10.302C13.0537 10.13 13.3083 10.1027 13.4781 10.2303L16.9729 13.0109C17.1993 13.1972 17.5105 13.2976 17.8359 13.2546C18.5292 13.1686 18.9961 12.5379 18.9254 11.8643C18.883 11.5203 18.7132 11.2336 18.4868 11.0186C18.416 10.9613 15.0911 8.29534 15.0911 8.29534C14.8789 8.12335 14.8364 7.80802 15.0062 7.59446L16.322 5.8874C17.5388 4.32511 19.6611 4.18178 21.3731 5.54341Z"
                                fill="black" />
                        </svg>
                        <p><span>3 вебинара:</span> теория, разборы-прожарки CV в прямом эфире, практические инструменты и техники</p>
                    </div>
                    <div>
                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="33" viewBox="0 0 32 33" fill="none">
                            <path
                                d="M16.0007 20.8426C21.7855 20.8426 26.6673 21.7826 26.6673 25.4093C26.6673 29.0373 21.7535 29.944 16.0007 29.944C10.2171 29.944 5.33398 29.004 5.33398 25.3773C5.33398 21.7493 10.2478 20.8426 16.0007 20.8426ZM16.0007 3.27734C19.9195 3.27734 23.0593 6.41604 23.0593 10.3321C23.0593 14.2481 19.9195 17.3882 16.0007 17.3882C12.0832 17.3882 8.942 14.2481 8.942 10.3321C8.942 6.41604 12.0832 3.27734 16.0007 3.27734Z"
                                fill="black" />
                        </svg>
                        <p><span>Работа с международным экспертом-практиком,</span> который знает, что на самом деле важно рекрутерам</p>
                    </div>
                    <div>
                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="33" viewBox="0 0 32 33" fill="none">
                            <path
                                d="M21.588 3.27832C25.7067 3.27832 28 5.65165 28 9.71832V23.4917C28 27.625 25.7067 29.945 21.588 29.945H10.4133C6.36 29.945 4 27.625 4 23.4917V9.71832C4 5.65165 6.36 3.27832 10.4133 3.27832H21.588ZM10.7733 21.5983C10.3733 21.5583 9.98667 21.745 9.77333 22.0917C9.56 22.425 9.56 22.865 9.77333 23.2117C9.98667 23.545 10.3733 23.745 10.7733 23.6917H21.2267C21.7587 23.6383 22.16 23.1837 22.16 22.6517C22.16 22.105 21.7587 21.6517 21.2267 21.5983H10.7733ZM21.2267 15.517H10.7733C10.1987 15.517 9.73333 15.985 9.73333 16.5583C9.73333 17.1317 10.1987 17.5983 10.7733 17.5983H21.2267C21.8 17.5983 22.2667 17.1317 22.2667 16.5583C22.2667 15.985 21.8 15.517 21.2267 15.517ZM14.7587 9.47832H10.7733V9.49165C10.1987 9.49165 9.73333 9.95832 9.73333 10.5317C9.73333 11.105 10.1987 11.5717 10.7733 11.5717H14.7587C15.3333 11.5717 15.8 11.105 15.8 10.517C15.8 9.94499 15.3333 9.47832 14.7587 9.47832Z"
                                fill="black" />
                        </svg>
                        <p><span>Шаблоны резюме</span> под разные кейсы + доступ в закрытый чат участников интенсива</p>
                    </div>
                </div>
                <div class="intens-result-bottom">
                    <div>
                        <h4>Бонусы для участников</h4>
                    </div>
                    <div>
                        <div>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                                <path
                                    d="M16.34 2.61133C19.73 2.61133 22 4.99133 22 8.53133V16.7023C22 20.2313 19.73 22.6113 16.34 22.6113H7.67C4.28 22.6113 2 20.2313 2 16.7023V8.53133C2 4.99133 4.28 2.61133 7.67 2.61133H16.34ZM16.18 9.61133C15.84 9.27133 15.28 9.27133 14.94 9.61133L10.81 13.7413L9.06 11.9913C8.72 11.6513 8.16 11.6513 7.82 11.9913C7.48 12.3313 7.48 12.8813 7.82 13.2313L10.2 15.6013C10.37 15.7713 10.59 15.8513 10.81 15.8513C11.04 15.8513 11.26 15.7713 11.43 15.6013L16.18 10.8513C16.52 10.5113 16.52 9.96133 16.18 9.61133Z"
                                    fill="black" />
                            </svg>
                            <p>Грант на обучение в Careerum</p>
                        </div>
                        <div>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                                <path
                                    d="M16.34 2.61133C19.73 2.61133 22 4.99133 22 8.53133V16.7023C22 20.2313 19.73 22.6113 16.34 22.6113H7.67C4.28 22.6113 2 20.2313 2 16.7023V8.53133C2 4.99133 4.28 2.61133 7.67 2.61133H16.34ZM16.18 9.61133C15.84 9.27133 15.28 9.27133 14.94 9.61133L10.81 13.7413L9.06 11.9913C8.72 11.6513 8.16 11.6513 7.82 11.9913C7.48 12.3313 7.48 12.8813 7.82 13.2313L10.2 15.6013C10.37 15.7713 10.59 15.8513 10.81 15.8513C11.04 15.8513 11.26 15.7713 11.43 15.6013L16.18 10.8513C16.52 10.5113 16.52 9.96133 16.18 9.61133Z"
                                    fill="black" />
                            </svg>
                            <p>Розыгрыш видеоконсультации CV-эксперта</p>
                        </div>
                        <div>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                                <path
                                    d="M16.34 2.61133C19.73 2.61133 22 4.99133 22 8.53133V16.7023C22 20.2313 19.73 22.6113 16.34 22.6113H7.67C4.28 22.6113 2 20.2313 2 16.7023V8.53133C2 4.99133 4.28 2.61133 7.67 2.61133H16.34ZM16.18 9.61133C15.84 9.27133 15.28 9.27133 14.94 9.61133L10.81 13.7413L9.06 11.9913C8.72 11.6513 8.16 11.6513 7.82 11.9913C7.48 12.3313 7.48 12.8813 7.82 13.2313L10.2 15.6013C10.37 15.7713 10.59 15.8513 10.81 15.8513C11.04 15.8513 11.26 15.7713 11.43 15.6013L16.18 10.8513C16.52 10.5113 16.52 9.96133 16.18 9.61133Z"
                                    fill="black" />
                            </svg>
                            <p>Розыгрыш письменного ревью вашего резюме</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-intens-result-tablet', {
        label: 'Интенсив результат (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-intens-result-tablet">
            <div>
                <div class="intens-result-header">
                    <h2>Научитесь составлять<br> резюме, которое открывает<br> двери в компании мечты</h2>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1706175782428.png" alt="">
                </div>
                <div class="intens-result-top">
                    <div>
                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="33" viewBox="0 0 32 33" fill="none">
                            <path
                                d="M26.653 25.8823C27.3958 25.8823 28 26.4943 28 27.2468C28 28.0007 27.3958 28.6113 26.653 28.6113H19.0396C18.2968 28.6113 17.6926 28.0007 17.6926 27.2468C17.6926 26.4943 18.2968 25.8823 19.0396 25.8823H26.653ZM21.3731 5.54341L23.3398 7.10571C24.1463 7.73636 24.684 8.56767 24.8679 9.44198C25.0801 10.4037 24.8537 11.3483 24.217 12.1652L12.5019 27.3152C11.9642 28.0032 11.1719 28.3902 10.323 28.4045L5.65386 28.4618C5.39918 28.4618 5.18695 28.2898 5.13036 28.0462L4.0692 23.4453C3.88526 22.5996 4.0692 21.7253 4.60685 21.0517L12.9122 10.302C13.0537 10.13 13.3083 10.1027 13.4781 10.2303L16.9729 13.0109C17.1993 13.1972 17.5105 13.2976 17.8359 13.2546C18.5292 13.1686 18.9961 12.5379 18.9254 11.8643C18.883 11.5203 18.7132 11.2336 18.4868 11.0186C18.416 10.9613 15.0911 8.29534 15.0911 8.29534C14.8789 8.12335 14.8364 7.80802 15.0062 7.59446L16.322 5.8874C17.5388 4.32511 19.6611 4.18178 21.3731 5.54341Z"
                                fill="black" />
                        </svg>
                        <p><span>3 вебинара:</span> теория, разборы-прожарки CV в прямом эфире, практические инструменты
                            и техники</p>
                    </div>
                    <div>
                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="33" viewBox="0 0 32 33" fill="none">
                            <path
                                d="M16.0007 20.8426C21.7855 20.8426 26.6673 21.7826 26.6673 25.4093C26.6673 29.0373 21.7535 29.944 16.0007 29.944C10.2171 29.944 5.33398 29.004 5.33398 25.3773C5.33398 21.7493 10.2478 20.8426 16.0007 20.8426ZM16.0007 3.27734C19.9195 3.27734 23.0593 6.41604 23.0593 10.3321C23.0593 14.2481 19.9195 17.3882 16.0007 17.3882C12.0832 17.3882 8.942 14.2481 8.942 10.3321C8.942 6.41604 12.0832 3.27734 16.0007 3.27734Z"
                                fill="black" />
                        </svg>
                        <p><span>Работа с международным экспертом-практиком,</span> который знает, что на самом деле важно
                            рекрутерам</p>
                    </div>
                    <div>
                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="33" viewBox="0 0 32 33" fill="none">
                            <path
                                d="M21.588 3.27832C25.7067 3.27832 28 5.65165 28 9.71832V23.4917C28 27.625 25.7067 29.945 21.588 29.945H10.4133C6.36 29.945 4 27.625 4 23.4917V9.71832C4 5.65165 6.36 3.27832 10.4133 3.27832H21.588ZM10.7733 21.5983C10.3733 21.5583 9.98667 21.745 9.77333 22.0917C9.56 22.425 9.56 22.865 9.77333 23.2117C9.98667 23.545 10.3733 23.745 10.7733 23.6917H21.2267C21.7587 23.6383 22.16 23.1837 22.16 22.6517C22.16 22.105 21.7587 21.6517 21.2267 21.5983H10.7733ZM21.2267 15.517H10.7733C10.1987 15.517 9.73333 15.985 9.73333 16.5583C9.73333 17.1317 10.1987 17.5983 10.7733 17.5983H21.2267C21.8 17.5983 22.2667 17.1317 22.2667 16.5583C22.2667 15.985 21.8 15.517 21.2267 15.517ZM14.7587 9.47832H10.7733V9.49165C10.1987 9.49165 9.73333 9.95832 9.73333 10.5317C9.73333 11.105 10.1987 11.5717 10.7733 11.5717H14.7587C15.3333 11.5717 15.8 11.105 15.8 10.517C15.8 9.94499 15.3333 9.47832 14.7587 9.47832Z"
                                fill="black" />
                        </svg>
                        <p><span>Шаблоны резюме под разные кейсы +</span> доступ в закрытый чат участников интенсива</p>
                    </div>
                </div>
                <div class="intens-result-bottom">
                    <div>
                        <h4>Бонусы для участников</h4>
                    </div>
                    <div>
                        <div>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                                <path
                                    d="M16.34 2.61133C19.73 2.61133 22 4.99133 22 8.53133V16.7023C22 20.2313 19.73 22.6113 16.34 22.6113H7.67C4.28 22.6113 2 20.2313 2 16.7023V8.53133C2 4.99133 4.28 2.61133 7.67 2.61133H16.34ZM16.18 9.61133C15.84 9.27133 15.28 9.27133 14.94 9.61133L10.81 13.7413L9.06 11.9913C8.72 11.6513 8.16 11.6513 7.82 11.9913C7.48 12.3313 7.48 12.8813 7.82 13.2313L10.2 15.6013C10.37 15.7713 10.59 15.8513 10.81 15.8513C11.04 15.8513 11.26 15.7713 11.43 15.6013L16.18 10.8513C16.52 10.5113 16.52 9.96133 16.18 9.61133Z"
                                    fill="black" />
                            </svg>
                            <p>Грант на обучение в Careerum</p>
                        </div>
                        <div>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                                <path
                                    d="M16.34 2.61133C19.73 2.61133 22 4.99133 22 8.53133V16.7023C22 20.2313 19.73 22.6113 16.34 22.6113H7.67C4.28 22.6113 2 20.2313 2 16.7023V8.53133C2 4.99133 4.28 2.61133 7.67 2.61133H16.34ZM16.18 9.61133C15.84 9.27133 15.28 9.27133 14.94 9.61133L10.81 13.7413L9.06 11.9913C8.72 11.6513 8.16 11.6513 7.82 11.9913C7.48 12.3313 7.48 12.8813 7.82 13.2313L10.2 15.6013C10.37 15.7713 10.59 15.8513 10.81 15.8513C11.04 15.8513 11.26 15.7713 11.43 15.6013L16.18 10.8513C16.52 10.5113 16.52 9.96133 16.18 9.61133Z"
                                    fill="black" />
                            </svg>
                            <p>Розыгрыш видеоконсультации CV-эксперта</p>
                        </div>
                        <div>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                                <path
                                    d="M16.34 2.61133C19.73 2.61133 22 4.99133 22 8.53133V16.7023C22 20.2313 19.73 22.6113 16.34 22.6113H7.67C4.28 22.6113 2 20.2313 2 16.7023V8.53133C2 4.99133 4.28 2.61133 7.67 2.61133H16.34ZM16.18 9.61133C15.84 9.27133 15.28 9.27133 14.94 9.61133L10.81 13.7413L9.06 11.9913C8.72 11.6513 8.16 11.6513 7.82 11.9913C7.48 12.3313 7.48 12.8813 7.82 13.2313L10.2 15.6013C10.37 15.7713 10.59 15.8513 10.81 15.8513C11.04 15.8513 11.26 15.7713 11.43 15.6013L16.18 10.8513C16.52 10.5113 16.52 9.96133 16.18 9.61133Z"
                                    fill="black" />
                            </svg>
                            <p>Розыгрыш письменного ревью вашего резюме</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-intens-result-mobile', {
        label: 'Интенсив результат (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-intens-result-mobile">
        <div>
            <div class="intens-result-header">
                <h2>Научитесь составлять<br> резюме, которое<br> открывает двери<br> в компании мечты</h2>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1706212440377.png" alt="">
            </div>
            <div class="intens-result-top">
                <div>
                    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="33" viewBox="0 0 32 33" fill="none">
                        <path
                            d="M26.653 25.8823C27.3958 25.8823 28 26.4943 28 27.2468C28 28.0007 27.3958 28.6113 26.653 28.6113H19.0396C18.2968 28.6113 17.6926 28.0007 17.6926 27.2468C17.6926 26.4943 18.2968 25.8823 19.0396 25.8823H26.653ZM21.3731 5.54341L23.3398 7.10571C24.1463 7.73636 24.684 8.56767 24.8679 9.44198C25.0801 10.4037 24.8537 11.3483 24.217 12.1652L12.5019 27.3152C11.9642 28.0032 11.1719 28.3902 10.323 28.4045L5.65386 28.4618C5.39918 28.4618 5.18695 28.2898 5.13036 28.0462L4.0692 23.4453C3.88526 22.5996 4.0692 21.7253 4.60685 21.0517L12.9122 10.302C13.0537 10.13 13.3083 10.1027 13.4781 10.2303L16.9729 13.0109C17.1993 13.1972 17.5105 13.2976 17.8359 13.2546C18.5292 13.1686 18.9961 12.5379 18.9254 11.8643C18.883 11.5203 18.7132 11.2336 18.4868 11.0186C18.416 10.9613 15.0911 8.29534 15.0911 8.29534C14.8789 8.12335 14.8364 7.80802 15.0062 7.59446L16.322 5.8874C17.5388 4.32511 19.6611 4.18178 21.3731 5.54341Z"
                            fill="black" />
                    </svg>
                    <p><span>3 вебинара:</span> теория, разборы-прожарки CV в прямом эфире, практические инструменты
                        и техники</p>
                </div>
                <div>
                    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="33" viewBox="0 0 32 33" fill="none">
                        <path
                            d="M16.0007 20.8426C21.7855 20.8426 26.6673 21.7826 26.6673 25.4093C26.6673 29.0373 21.7535 29.944 16.0007 29.944C10.2171 29.944 5.33398 29.004 5.33398 25.3773C5.33398 21.7493 10.2478 20.8426 16.0007 20.8426ZM16.0007 3.27734C19.9195 3.27734 23.0593 6.41604 23.0593 10.3321C23.0593 14.2481 19.9195 17.3882 16.0007 17.3882C12.0832 17.3882 8.942 14.2481 8.942 10.3321C8.942 6.41604 12.0832 3.27734 16.0007 3.27734Z"
                            fill="black" />
                    </svg>
                    <p><span>Работа с международным экспертом-практиком,</span> который знает, что на самом деле важно
                        рекрутерам</p>
                </div>
                <div>
                    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="33" viewBox="0 0 32 33" fill="none">
                        <path
                            d="M21.588 3.27832C25.7067 3.27832 28 5.65165 28 9.71832V23.4917C28 27.625 25.7067 29.945 21.588 29.945H10.4133C6.36 29.945 4 27.625 4 23.4917V9.71832C4 5.65165 6.36 3.27832 10.4133 3.27832H21.588ZM10.7733 21.5983C10.3733 21.5583 9.98667 21.745 9.77333 22.0917C9.56 22.425 9.56 22.865 9.77333 23.2117C9.98667 23.545 10.3733 23.745 10.7733 23.6917H21.2267C21.7587 23.6383 22.16 23.1837 22.16 22.6517C22.16 22.105 21.7587 21.6517 21.2267 21.5983H10.7733ZM21.2267 15.517H10.7733C10.1987 15.517 9.73333 15.985 9.73333 16.5583C9.73333 17.1317 10.1987 17.5983 10.7733 17.5983H21.2267C21.8 17.5983 22.2667 17.1317 22.2667 16.5583C22.2667 15.985 21.8 15.517 21.2267 15.517ZM14.7587 9.47832H10.7733V9.49165C10.1987 9.49165 9.73333 9.95832 9.73333 10.5317C9.73333 11.105 10.1987 11.5717 10.7733 11.5717H14.7587C15.3333 11.5717 15.8 11.105 15.8 10.517C15.8 9.94499 15.3333 9.47832 14.7587 9.47832Z"
                            fill="black" />
                    </svg>
                    <p><span>Шаблоны резюме под разные кейсы +</span> доступ в закрытый чат участников интенсива</p>
                </div>
            </div>
            <div class="intens-result-bottom">
                <div>
                    <h4>Бонусы для участников</h4>
                </div>
                <div>
                    <div>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path
                                d="M16.34 2C19.73 2 22 4.38 22 7.92V16.091C22 19.62 19.73 22 16.34 22H7.67C4.28 22 2 19.62 2 16.091V7.92C2 4.38 4.28 2 7.67 2H16.34ZM16.18 9C15.84 8.66 15.28 8.66 14.94 9L10.81 13.13L9.06 11.38C8.72 11.04 8.16 11.04 7.82 11.38C7.48 11.72 7.48 12.27 7.82 12.62L10.2 14.99C10.37 15.16 10.59 15.24 10.81 15.24C11.04 15.24 11.26 15.16 11.43 14.99L16.18 10.24C16.52 9.9 16.52 9.35 16.18 9Z"
                                fill="white" />
                        </svg>
                        <p>грант на обучение в Careerum</p>
                    </div>
                    <div>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path
                                d="M16.34 2C19.73 2 22 4.38 22 7.92V16.091C22 19.62 19.73 22 16.34 22H7.67C4.28 22 2 19.62 2 16.091V7.92C2 4.38 4.28 2 7.67 2H16.34ZM16.18 9C15.84 8.66 15.28 8.66 14.94 9L10.81 13.13L9.06 11.38C8.72 11.04 8.16 11.04 7.82 11.38C7.48 11.72 7.48 12.27 7.82 12.62L10.2 14.99C10.37 15.16 10.59 15.24 10.81 15.24C11.04 15.24 11.26 15.16 11.43 14.99L16.18 10.24C16.52 9.9 16.52 9.35 16.18 9Z"
                                fill="white" />
                        </svg>
                        <p>розыгрыш видеоконсультации CV-эксперта</p>
                    </div>
                    <div>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path
                                d="M16.34 2C19.73 2 22 4.38 22 7.92V16.091C22 19.62 19.73 22 16.34 22H7.67C4.28 22 2 19.62 2 16.091V7.92C2 4.38 4.28 2 7.67 2H16.34ZM16.18 9C15.84 8.66 15.28 8.66 14.94 9L10.81 13.13L9.06 11.38C8.72 11.04 8.16 11.04 7.82 11.38C7.48 11.72 7.48 12.27 7.82 12.62L10.2 14.99C10.37 15.16 10.59 15.24 10.81 15.24C11.04 15.24 11.26 15.16 11.43 14.99L16.18 10.24C16.52 9.9 16.52 9.35 16.18 9Z"
                                fill="white" />
                        </svg>
                        <p>розыгрыш письменного ревью вашего резюме</p>
                    </div>
                </div>
            </div>
        </div>
    </div>`
	});
    
    blockManager.add('careerum-intens-form', {
        label: 'Интенсив форма',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-intens-form" data-offer-rub="123" data-offer-eur="321" data-price-rub="5 000 ₽" data-price-eur="50 €">
            <div>
                <div class="intens-form-top">
                    <div class="intens-form__swicher-block">
                        <div class="intens-form__swicher-top">
                            <p class="intens-form__swicher-header">Посмотреть цены в <span>RUB<span></p>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                                class="intens-form__swicher-arrow">
                                <path d="M7 9.5L12 14.5L17 9.5H7Z" fill="black" />
                            </svg>
                        </div>
                        <div class="intens-form__swicher-bottom">
                            <ul>
                                <li data-currency="RUB">
                                    RUB
                                </li>
                                <li class="active" data-currency="EUR">
                                    EUR
                                </li>
                            </ul>
                            <p>
                                Обратите внимание,<br> что оплата в российских рублях возможна только<br> с карты
                                российского банка. Оплата в евро — с карты зарубежного банка
                            </p>
                        </div>
                    </div>
                </div>
                <div class="intens-form-bottom">
                    <div class="intens-form-bottom-left">
                        <div>
                            <p>Интенсив от экспертов Careerum</p>
                        </div>
                        <h2>CV, в которое влюбятся рекрутеры</h2>
                        <ul>
                            <li>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                                    <path d="M16.34 2.61133C19.73 2.61133 22 4.99033 22 8.53033V16.7003C22 20.2313 19.73 22.6113 16.34 22.6113H7.67C4.28 22.6113 2 20.2313 2 16.7003V8.53033C2 4.99033 4.28 2.61133 7.67 2.61133H16.34ZM11.65 7.53033C11.24 7.53033 10.9 7.87133 10.9 8.28033V13.3313C10.9 13.5913 11.04 13.8413 11.27 13.9713L15.19 16.3113C15.31 16.3913 15.45 16.4213 15.58 16.4213C15.83 16.4213 16.08 16.2913 16.22 16.0513C16.44 15.7003 16.32 15.2403 15.96 15.0213L12.4 12.9013V8.28033C12.4 7.87133 12.07 7.53033 11.65 7.53033Z" fill="white"/>
                                  </svg>
                                <p>Общая длительность: 5–20 февраля</p>
                            </li>
                            <li>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                                    <path d="M15.6497 2.61133C16.0742 2.61033 16.4099 2.94017 16.4109 3.37995L16.4119 4.12957C19.1665 4.34546 20.9862 6.22252 20.9891 9.10108L21 17.5269C21.0039 20.6653 19.0322 22.5963 15.8718 22.6013L8.15189 22.6113C5.0112 22.6153 3.01482 20.6383 3.01087 17.4909L3.00001 9.16405C2.99606 6.2665 4.75153 4.39444 7.50618 4.14157L7.50519 3.39194C7.5042 2.95216 7.83002 2.62133 8.26445 2.62133C8.69887 2.62033 9.02469 2.95016 9.02568 3.38994L9.02666 4.08959L14.8914 4.0816L14.8904 3.38195C14.8894 2.94217 15.2152 2.61233 15.6497 2.61133ZM16.0525 16.8032H16.0426C15.5884 16.8142 15.2241 17.195 15.234 17.6548C15.235 18.1146 15.6013 18.4934 16.0555 18.5034C16.5185 18.5024 16.8937 18.1216 16.8927 17.6518C16.8927 17.182 16.5165 16.8032 16.0525 16.8032ZM7.91691 16.8042C7.46274 16.8242 7.1073 17.205 7.10828 17.6648C7.12902 18.1246 7.5042 18.4844 7.95837 18.4634C8.40366 18.4434 8.75811 18.0626 8.73738 17.6028C8.7275 17.153 8.3612 16.8032 7.91691 16.8042ZM11.9847 16.7992C11.5305 16.8202 11.1761 17.2 11.1761 17.6598C11.1968 18.1196 11.572 18.4784 12.0262 18.4584C12.4705 18.4374 12.8259 18.0576 12.8052 17.5968C12.7953 17.1481 12.429 16.7982 11.9847 16.7992ZM7.91197 13.206C7.4578 13.226 7.10335 13.6068 7.10433 14.0666C7.12408 14.5264 7.50025 14.8862 7.95442 14.8652C8.39872 14.8452 8.75317 14.4644 8.73244 14.0046C8.72257 13.5549 8.35725 13.205 7.91197 13.206ZM11.9807 13.171C11.5266 13.191 11.1711 13.5718 11.1721 14.0316C11.1919 14.4914 11.568 14.8502 12.0222 14.8302C12.4665 14.8092 12.821 14.4294 12.8012 13.9696C12.7904 13.5199 12.425 13.17 11.9807 13.171ZM16.0485 13.176C15.5944 13.186 15.2389 13.5559 15.2399 14.0156V14.0266C15.2498 14.4864 15.625 14.8352 16.0801 14.8252C16.5244 14.8142 16.8789 14.4334 16.869 13.9736C16.8483 13.5339 16.4918 13.175 16.0485 13.176ZM14.8934 5.62083L9.02864 5.62882L9.02962 6.43742C9.02962 6.8682 8.70479 7.20803 8.27037 7.20803C7.83595 7.20903 7.50914 6.8702 7.50914 6.43942L7.50815 5.6698C5.58286 5.8627 4.51754 6.99414 4.52049 9.16205L4.52149 9.4729L19.4696 9.45291V9.10308C19.4272 6.95416 18.349 5.82672 16.4138 5.65881L16.4148 6.42842C16.4148 6.85821 16.0801 7.19904 15.6556 7.19904C15.2212 7.20003 14.8944 6.8602 14.8944 6.43042L14.8934 5.62083Z" fill="white"/>
                                  </svg>
                                <p>Даты эфиров: 6, 8, 13 февраля в 19:00 МСК / 17:00 CET</p>
                            </li>
                            <li>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                                    <path d="M12.02 2.61133C17.7 2.61133 22 7.26831 22 12.5963C22 18.7756 16.96 22.6113 12 22.6113C10.36 22.6113 8.54 22.1707 7.08 21.3094C6.57 20.9989 6.14 20.7686 5.59 20.9488L3.57 21.5497C3.06 21.71 2.6 21.3094 2.75 20.7686L3.42 18.5252C3.53 18.2147 3.51 17.8842 3.35 17.6238C2.49 16.0415 2 14.3089 2 12.6264C2 7.35845 6.21 2.61133 12.02 2.61133ZM16.59 11.3544C15.88 11.3544 15.31 11.9253 15.31 12.6364C15.31 13.3374 15.88 13.9183 16.59 13.9183C17.3 13.9183 17.87 13.3374 17.87 12.6364C17.87 11.9253 17.3 11.3544 16.59 11.3544ZM11.98 11.3544C11.28 11.3444 10.7 11.9253 10.7 12.6264C10.7 13.3374 11.27 13.9083 11.98 13.9183C12.69 13.9183 13.26 13.3374 13.26 12.6364C13.26 11.9253 12.69 11.3544 11.98 11.3544ZM7.37 11.3544C6.66 11.3544 6.09 11.9253 6.09 12.6364C6.09 13.3374 6.67 13.9183 7.37 13.9183C8.08 13.9083 8.65 13.3374 8.65 12.6364C8.65 11.9253 8.08 11.3544 7.37 11.3544Z" fill="white"/>
                                  </svg>
                                <p>Неделя для обсуждения вопросов в чате с экспертом. Доступ к самому чату<br> останется
                                    навсегда</p>
                            </li>
                            <li>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                                    <path d="M19.9898 19.5646C20.5469 19.5646 21 20.0236 21 20.588C21 21.1534 20.5469 21.6113 19.9898 21.6113H14.2797C13.7226 21.6113 13.2695 21.1534 13.2695 20.588C13.2695 20.0236 13.7226 19.5646 14.2797 19.5646H19.9898ZM16.0299 4.31039L17.5049 5.48211C18.1097 5.9551 18.513 6.57858 18.6509 7.23432C18.8101 7.95562 18.6403 8.66403 18.1628 9.27677L9.3764 20.6392C8.97316 21.1552 8.37891 21.4455 7.74221 21.4562L4.24039 21.4992C4.04939 21.4992 3.89021 21.3702 3.84777 21.1875L3.0519 17.7368C2.91395 17.1026 3.0519 16.4468 3.45514 15.9416L9.68413 7.8793C9.79025 7.7503 9.98126 7.72988 10.1086 7.82555L12.7297 9.911C12.8994 10.0507 13.1329 10.126 13.377 10.0937C13.8969 10.0292 14.2471 9.55626 14.1941 9.05102C14.1622 8.79303 14.0349 8.57803 13.8651 8.41679C13.812 8.37379 11.3183 6.37434 11.3183 6.37434C11.1591 6.24534 11.1273 6.00885 11.2546 5.84868L12.2415 4.56839C13.1541 3.39666 14.7459 3.28917 16.0299 4.31039Z" fill="white"/>
                                  </svg>
                                <p>Доступ к записям эфиров на месяц</p>
                            </li>
                        </ul>
                    </div>
                    <div class="intens-form-bottom-right">
                        <div>
                            <h4>Стоимость: <br><span>5 000 ₽</span></h4>
                        </div>
                        <div>
                            <div class="careerum-registration-form">
                                <form class="deva-form" name="devaRegistrationForm">
                                    <div class="intens-form-firstname">
                                        <input type="text" name="firstname" id="" required placeholder="Имя">
                                    </div>
                                    <div class="intens-form-lastname">
                                        <input type="text" name="lastname" id="" required placeholder="Фамилия">
                                    </div>
                                    <div class="intens-form-email">
                                        <input type="email" name="email" id="" required placeholder="Почта">
                                    </div>
                                    <div class="intens-form-phone">
                                        <input id="" required>
                                    </div>
                                    <div class="intens-form-agree">
                                        <label>
                                            <input type="checkbox" name="agree">
                                            <div>
                                                <svg width="8" height="8" viewBox="0 0 8 8" fill="none"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        d="M1 2.84615L3.14168 6.70118C3.21595 6.83487 3.40669 6.83912 3.48685 6.70887L7 1"
                                                        stroke="black" stroke-width="1.5" stroke-linecap="round" />
                                                </svg>
                                            </div>
                                        </label>
                                        <p>Я принимаю условия <a href="/ru-ru/legal/offer">Публичной оферты</a> и даю
                                            согласие <br>на обработку своих персональных данных в соответствии<br> с <a
                                                href="/ru-ru/legal/privacy">Политикой конфиденциальности</a></p>
                                    </div>
                                    <a href="#" disabled class="submit-btn">Записаться на интенсив</a>
                                    <input type="hidden" name="offerID" required>
                                    <input type="hidden" name="tel">
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-intens-form-tablet', {
        label: 'Интенсив форма (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-intens-form-tablet" data-offer-rub="123" data-offer-eur="321" data-price-rub="5 000 ₽" data-price-eur="50 €">
            <div>
                <div class="intens-form-top">
                    <div class="intens-form__swicher-block">
                        <div class="intens-form__swicher-top">
                            <p class="intens-form__swicher-header">Посмотреть цены в <span>RUB<span></p>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                                class="intens-form__swicher-arrow">
                                <path d="M7 9.5L12 14.5L17 9.5H7Z" fill="black" />
                            </svg>
                        </div>
                        <div class="intens-form__swicher-bottom">
                            <ul>
                                <li data-currency="RUB">
                                    RUB
                                </li>
                                <li class="active" data-currency="EUR">
                                    EUR
                                </li>
                            </ul>
                            <p>
                                Обратите внимание,<br> что оплата в российских рублях возможна только<br> с карты
                                российского банка. Оплата в евро — с карты зарубежного банка
                            </p>
                        </div>
                    </div>
                </div>
                <div class="intens-form-bottom">
                    <div class="intens-form-bottom-left">
                        <div>
                            <p>Интенсив от экспертов</p> 
                            <p>Careerum</p>
                        </div>
                        <h2>CV, в которое влюбятся рекрутеры</h2>
                        <ul>
                            <li>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25"
                                    fill="none">
                                    <path
                                        d="M16.34 2.61133C19.73 2.61133 22 4.99033 22 8.53033V16.7003C22 20.2313 19.73 22.6113 16.34 22.6113H7.67C4.28 22.6113 2 20.2313 2 16.7003V8.53033C2 4.99033 4.28 2.61133 7.67 2.61133H16.34ZM11.65 7.53033C11.24 7.53033 10.9 7.87133 10.9 8.28033V13.3313C10.9 13.5913 11.04 13.8413 11.27 13.9713L15.19 16.3113C15.31 16.3913 15.45 16.4213 15.58 16.4213C15.83 16.4213 16.08 16.2913 16.22 16.0513C16.44 15.7003 16.32 15.2403 15.96 15.0213L12.4 12.9013V8.28033C12.4 7.87133 12.07 7.53033 11.65 7.53033Z"
                                        fill="white" />
                                </svg>
                                <p>Общая длительность: 5–20 февраля</p>
                            </li>
                            <li>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25"
                                    fill="none">
                                    <path
                                        d="M15.6497 2.61133C16.0742 2.61033 16.4099 2.94017 16.4109 3.37995L16.4119 4.12957C19.1665 4.34546 20.9862 6.22252 20.9891 9.10108L21 17.5269C21.0039 20.6653 19.0322 22.5963 15.8718 22.6013L8.15189 22.6113C5.0112 22.6153 3.01482 20.6383 3.01087 17.4909L3.00001 9.16405C2.99606 6.2665 4.75153 4.39444 7.50618 4.14157L7.50519 3.39194C7.5042 2.95216 7.83002 2.62133 8.26445 2.62133C8.69887 2.62033 9.02469 2.95016 9.02568 3.38994L9.02666 4.08959L14.8914 4.0816L14.8904 3.38195C14.8894 2.94217 15.2152 2.61233 15.6497 2.61133ZM16.0525 16.8032H16.0426C15.5884 16.8142 15.2241 17.195 15.234 17.6548C15.235 18.1146 15.6013 18.4934 16.0555 18.5034C16.5185 18.5024 16.8937 18.1216 16.8927 17.6518C16.8927 17.182 16.5165 16.8032 16.0525 16.8032ZM7.91691 16.8042C7.46274 16.8242 7.1073 17.205 7.10828 17.6648C7.12902 18.1246 7.5042 18.4844 7.95837 18.4634C8.40366 18.4434 8.75811 18.0626 8.73738 17.6028C8.7275 17.153 8.3612 16.8032 7.91691 16.8042ZM11.9847 16.7992C11.5305 16.8202 11.1761 17.2 11.1761 17.6598C11.1968 18.1196 11.572 18.4784 12.0262 18.4584C12.4705 18.4374 12.8259 18.0576 12.8052 17.5968C12.7953 17.1481 12.429 16.7982 11.9847 16.7992ZM7.91197 13.206C7.4578 13.226 7.10335 13.6068 7.10433 14.0666C7.12408 14.5264 7.50025 14.8862 7.95442 14.8652C8.39872 14.8452 8.75317 14.4644 8.73244 14.0046C8.72257 13.5549 8.35725 13.205 7.91197 13.206ZM11.9807 13.171C11.5266 13.191 11.1711 13.5718 11.1721 14.0316C11.1919 14.4914 11.568 14.8502 12.0222 14.8302C12.4665 14.8092 12.821 14.4294 12.8012 13.9696C12.7904 13.5199 12.425 13.17 11.9807 13.171ZM16.0485 13.176C15.5944 13.186 15.2389 13.5559 15.2399 14.0156V14.0266C15.2498 14.4864 15.625 14.8352 16.0801 14.8252C16.5244 14.8142 16.8789 14.4334 16.869 13.9736C16.8483 13.5339 16.4918 13.175 16.0485 13.176ZM14.8934 5.62083L9.02864 5.62882L9.02962 6.43742C9.02962 6.8682 8.70479 7.20803 8.27037 7.20803C7.83595 7.20903 7.50914 6.8702 7.50914 6.43942L7.50815 5.6698C5.58286 5.8627 4.51754 6.99414 4.52049 9.16205L4.52149 9.4729L19.4696 9.45291V9.10308C19.4272 6.95416 18.349 5.82672 16.4138 5.65881L16.4148 6.42842C16.4148 6.85821 16.0801 7.19904 15.6556 7.19904C15.2212 7.20003 14.8944 6.8602 14.8944 6.43042L14.8934 5.62083Z"
                                        fill="white" />
                                </svg>
                                <p>Даты эфиров: 6, 8, 13 февраля <br>в 19:00 МСК / 17:00 CET</p>
                            </li>
                            <li>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25"
                                    fill="none">
                                    <path
                                        d="M12.02 2.61133C17.7 2.61133 22 7.26831 22 12.5963C22 18.7756 16.96 22.6113 12 22.6113C10.36 22.6113 8.54 22.1707 7.08 21.3094C6.57 20.9989 6.14 20.7686 5.59 20.9488L3.57 21.5497C3.06 21.71 2.6 21.3094 2.75 20.7686L3.42 18.5252C3.53 18.2147 3.51 17.8842 3.35 17.6238C2.49 16.0415 2 14.3089 2 12.6264C2 7.35845 6.21 2.61133 12.02 2.61133ZM16.59 11.3544C15.88 11.3544 15.31 11.9253 15.31 12.6364C15.31 13.3374 15.88 13.9183 16.59 13.9183C17.3 13.9183 17.87 13.3374 17.87 12.6364C17.87 11.9253 17.3 11.3544 16.59 11.3544ZM11.98 11.3544C11.28 11.3444 10.7 11.9253 10.7 12.6264C10.7 13.3374 11.27 13.9083 11.98 13.9183C12.69 13.9183 13.26 13.3374 13.26 12.6364C13.26 11.9253 12.69 11.3544 11.98 11.3544ZM7.37 11.3544C6.66 11.3544 6.09 11.9253 6.09 12.6364C6.09 13.3374 6.67 13.9183 7.37 13.9183C8.08 13.9083 8.65 13.3374 8.65 12.6364C8.65 11.9253 8.08 11.3544 7.37 11.3544Z"
                                        fill="white" />
                                </svg>
                                <p>Неделя для обсуждения <br>вопросов в чате</p>
                            </li>
                            <li>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25"
                                    fill="none">
                                    <path
                                        d="M19.9898 19.5646C20.5469 19.5646 21 20.0236 21 20.588C21 21.1534 20.5469 21.6113 19.9898 21.6113H14.2797C13.7226 21.6113 13.2695 21.1534 13.2695 20.588C13.2695 20.0236 13.7226 19.5646 14.2797 19.5646H19.9898ZM16.0299 4.31039L17.5049 5.48211C18.1097 5.9551 18.513 6.57858 18.6509 7.23432C18.8101 7.95562 18.6403 8.66403 18.1628 9.27677L9.3764 20.6392C8.97316 21.1552 8.37891 21.4455 7.74221 21.4562L4.24039 21.4992C4.04939 21.4992 3.89021 21.3702 3.84777 21.1875L3.0519 17.7368C2.91395 17.1026 3.0519 16.4468 3.45514 15.9416L9.68413 7.8793C9.79025 7.7503 9.98126 7.72988 10.1086 7.82555L12.7297 9.911C12.8994 10.0507 13.1329 10.126 13.377 10.0937C13.8969 10.0292 14.2471 9.55626 14.1941 9.05102C14.1622 8.79303 14.0349 8.57803 13.8651 8.41679C13.812 8.37379 11.3183 6.37434 11.3183 6.37434C11.1591 6.24534 11.1273 6.00885 11.2546 5.84868L12.2415 4.56839C13.1541 3.39666 14.7459 3.28917 16.0299 4.31039Z"
                                        fill="white" />
                                </svg>
                                <p>Доступ к записям эфиров <br>на месяц</p>
                            </li>
                        </ul>
                    </div>
                    <div class="intens-form-bottom-right">
                        <div>
                            <h4>Стоимость: <br><span>5 000 ₽</span></h4>
                        </div>
                        <div>
                            <div class="careerum-registration-form-tablet">
                                <form class="deva-form" name="devaRegistrationForm">
                                    <div class="intens-form-firstname">
                                        <input type="text" name="firstname" id="" required placeholder="Имя">
                                    </div>
                                    <div class="intens-form-lastname">
                                        <input type="text" name="lastname" id="" required placeholder="Фамилия">
                                    </div>
                                    <div class="intens-form-email">
                                        <input type="email" name="email" id="" required placeholder="Почта">
                                    </div>
                                    <div class="intens-form-phone">
                                        <input id="" required>
                                    </div>
                                    <div class="intens-form-agree">
                                        <label>
                                            <input type="checkbox" name="agree">
                                            <div>
                                                <svg width="8" height="8" viewBox="0 0 8 8" fill="none"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        d="M1 2.84615L3.14168 6.70118C3.21595 6.83487 3.40669 6.83912 3.48685 6.70887L7 1"
                                                        stroke="black" stroke-width="1.5" stroke-linecap="round" />
                                                </svg>
                                            </div>
                                        </label>
                                        <p>Я принимаю условия <a href="/ru-ru/legal/offer">Публичной оферты</a> и даю согласие на обработку своих персональных данных в соответствии<br> с <a href="/ru-ru/legal/privacy">Политикой конфиденциальности</a></p>
                                    </div>
                                    <a href="#" disabled class="submit-btn">Записаться на интенсив</a>
                                    <input type="hidden" name="offerID" required>
                                    <input type="hidden" name="tel">
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-intens-form-mobile', {
        label: 'Интенсив форма (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-intens-form-mobile" data-offer-rub="123" data-offer-eur="321" data-price-rub="5 000 ₽" data-price-eur="50 €">
            <div>
                <div class="intens-form-bottom">
                    <div class="intens-form-bottom-left">
                        <div>
                            <p>Интенсив от экспертов</p>
                            <p>Careerum</p>
                        </div>
                        <h2>CV, в которое влюбятся рекрутеры</h2>
                        <ul>
                            <li>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25"
                                    fill="none">
                                    <path
                                        d="M16.34 2.61133C19.73 2.61133 22 4.99033 22 8.53033V16.7003C22 20.2313 19.73 22.6113 16.34 22.6113H7.67C4.28 22.6113 2 20.2313 2 16.7003V8.53033C2 4.99033 4.28 2.61133 7.67 2.61133H16.34ZM11.65 7.53033C11.24 7.53033 10.9 7.87133 10.9 8.28033V13.3313C10.9 13.5913 11.04 13.8413 11.27 13.9713L15.19 16.3113C15.31 16.3913 15.45 16.4213 15.58 16.4213C15.83 16.4213 16.08 16.2913 16.22 16.0513C16.44 15.7003 16.32 15.2403 15.96 15.0213L12.4 12.9013V8.28033C12.4 7.87133 12.07 7.53033 11.65 7.53033Z"
                                        fill="white" />
                                </svg>
                                <p>Общая длительность: 5–20 февраля</p>
                            </li>
                            <li>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25"
                                    fill="none">
                                    <path
                                        d="M15.6497 2.61133C16.0742 2.61033 16.4099 2.94017 16.4109 3.37995L16.4119 4.12957C19.1665 4.34546 20.9862 6.22252 20.9891 9.10108L21 17.5269C21.0039 20.6653 19.0322 22.5963 15.8718 22.6013L8.15189 22.6113C5.0112 22.6153 3.01482 20.6383 3.01087 17.4909L3.00001 9.16405C2.99606 6.2665 4.75153 4.39444 7.50618 4.14157L7.50519 3.39194C7.5042 2.95216 7.83002 2.62133 8.26445 2.62133C8.69887 2.62033 9.02469 2.95016 9.02568 3.38994L9.02666 4.08959L14.8914 4.0816L14.8904 3.38195C14.8894 2.94217 15.2152 2.61233 15.6497 2.61133ZM16.0525 16.8032H16.0426C15.5884 16.8142 15.2241 17.195 15.234 17.6548C15.235 18.1146 15.6013 18.4934 16.0555 18.5034C16.5185 18.5024 16.8937 18.1216 16.8927 17.6518C16.8927 17.182 16.5165 16.8032 16.0525 16.8032ZM7.91691 16.8042C7.46274 16.8242 7.1073 17.205 7.10828 17.6648C7.12902 18.1246 7.5042 18.4844 7.95837 18.4634C8.40366 18.4434 8.75811 18.0626 8.73738 17.6028C8.7275 17.153 8.3612 16.8032 7.91691 16.8042ZM11.9847 16.7992C11.5305 16.8202 11.1761 17.2 11.1761 17.6598C11.1968 18.1196 11.572 18.4784 12.0262 18.4584C12.4705 18.4374 12.8259 18.0576 12.8052 17.5968C12.7953 17.1481 12.429 16.7982 11.9847 16.7992ZM7.91197 13.206C7.4578 13.226 7.10335 13.6068 7.10433 14.0666C7.12408 14.5264 7.50025 14.8862 7.95442 14.8652C8.39872 14.8452 8.75317 14.4644 8.73244 14.0046C8.72257 13.5549 8.35725 13.205 7.91197 13.206ZM11.9807 13.171C11.5266 13.191 11.1711 13.5718 11.1721 14.0316C11.1919 14.4914 11.568 14.8502 12.0222 14.8302C12.4665 14.8092 12.821 14.4294 12.8012 13.9696C12.7904 13.5199 12.425 13.17 11.9807 13.171ZM16.0485 13.176C15.5944 13.186 15.2389 13.5559 15.2399 14.0156V14.0266C15.2498 14.4864 15.625 14.8352 16.0801 14.8252C16.5244 14.8142 16.8789 14.4334 16.869 13.9736C16.8483 13.5339 16.4918 13.175 16.0485 13.176ZM14.8934 5.62083L9.02864 5.62882L9.02962 6.43742C9.02962 6.8682 8.70479 7.20803 8.27037 7.20803C7.83595 7.20903 7.50914 6.8702 7.50914 6.43942L7.50815 5.6698C5.58286 5.8627 4.51754 6.99414 4.52049 9.16205L4.52149 9.4729L19.4696 9.45291V9.10308C19.4272 6.95416 18.349 5.82672 16.4138 5.65881L16.4148 6.42842C16.4148 6.85821 16.0801 7.19904 15.6556 7.19904C15.2212 7.20003 14.8944 6.8602 14.8944 6.43042L14.8934 5.62083Z"
                                        fill="white" />
                                </svg>
                                <p>Даты эфиров: 6, 8, 13 февраля <br>в 19:00 МСК / 17:00 CET</p>
                            </li>
                            <li>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25"
                                    fill="none">
                                    <path
                                        d="M12.02 2.61133C17.7 2.61133 22 7.26831 22 12.5963C22 18.7756 16.96 22.6113 12 22.6113C10.36 22.6113 8.54 22.1707 7.08 21.3094C6.57 20.9989 6.14 20.7686 5.59 20.9488L3.57 21.5497C3.06 21.71 2.6 21.3094 2.75 20.7686L3.42 18.5252C3.53 18.2147 3.51 17.8842 3.35 17.6238C2.49 16.0415 2 14.3089 2 12.6264C2 7.35845 6.21 2.61133 12.02 2.61133ZM16.59 11.3544C15.88 11.3544 15.31 11.9253 15.31 12.6364C15.31 13.3374 15.88 13.9183 16.59 13.9183C17.3 13.9183 17.87 13.3374 17.87 12.6364C17.87 11.9253 17.3 11.3544 16.59 11.3544ZM11.98 11.3544C11.28 11.3444 10.7 11.9253 10.7 12.6264C10.7 13.3374 11.27 13.9083 11.98 13.9183C12.69 13.9183 13.26 13.3374 13.26 12.6364C13.26 11.9253 12.69 11.3544 11.98 11.3544ZM7.37 11.3544C6.66 11.3544 6.09 11.9253 6.09 12.6364C6.09 13.3374 6.67 13.9183 7.37 13.9183C8.08 13.9083 8.65 13.3374 8.65 12.6364C8.65 11.9253 8.08 11.3544 7.37 11.3544Z"
                                        fill="white" />
                                </svg>
                                <p>Неделя для обсуждения <br>вопросов в чате</p>
                            </li>
                            <li>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25"
                                    fill="none">
                                    <path
                                        d="M19.9898 19.5646C20.5469 19.5646 21 20.0236 21 20.588C21 21.1534 20.5469 21.6113 19.9898 21.6113H14.2797C13.7226 21.6113 13.2695 21.1534 13.2695 20.588C13.2695 20.0236 13.7226 19.5646 14.2797 19.5646H19.9898ZM16.0299 4.31039L17.5049 5.48211C18.1097 5.9551 18.513 6.57858 18.6509 7.23432C18.8101 7.95562 18.6403 8.66403 18.1628 9.27677L9.3764 20.6392C8.97316 21.1552 8.37891 21.4455 7.74221 21.4562L4.24039 21.4992C4.04939 21.4992 3.89021 21.3702 3.84777 21.1875L3.0519 17.7368C2.91395 17.1026 3.0519 16.4468 3.45514 15.9416L9.68413 7.8793C9.79025 7.7503 9.98126 7.72988 10.1086 7.82555L12.7297 9.911C12.8994 10.0507 13.1329 10.126 13.377 10.0937C13.8969 10.0292 14.2471 9.55626 14.1941 9.05102C14.1622 8.79303 14.0349 8.57803 13.8651 8.41679C13.812 8.37379 11.3183 6.37434 11.3183 6.37434C11.1591 6.24534 11.1273 6.00885 11.2546 5.84868L12.2415 4.56839C13.1541 3.39666 14.7459 3.28917 16.0299 4.31039Z"
                                        fill="white" />
                                </svg>
                                <p>Доступ к записям эфиров <br>на месяц</p>
                            </li>
                        </ul>
                    </div>
                    <div class="intens-form-bottom-right">
                        <div class="intens-form__swicher-block">
                            <div class="intens-form__swicher-top">
                                <p class="intens-form__swicher-header">Посмотреть цены в <span>RUB<span></p>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                                    class="intens-form__swicher-arrow">
                                    <path d="M7 9.5L12 14.5L17 9.5H7Z" fill="black" />
                                </svg>
                            </div>
                            <div class="intens-form__swicher-bottom">
                                <ul>
                                    <li data-currency="RUB">
                                        RUB
                                    </li>
                                    <li class="active" data-currency="EUR">
                                        EUR
                                    </li>
                                </ul>
                                <p>
                                    Обратите внимание,<br> что оплата в российских рублях возможна только<br> с карты
                                    российского банка. Оплата в евро — с карты зарубежного банка
                                </p>
                            </div>
                        </div>
                        <div>
                            <h4>Стоимость: <br><span>5 000 ₽</span></h4>
                        </div>
                        <div>
                            <div class="careerum-registration-form-mobile">
                                <form class="deva-form" name="devaRegistrationForm">
                                    <div class="intens-form-firstname">
                                        <input type="text" name="firstname" id="" required placeholder="Имя">
                                    </div>
                                    <div class="intens-form-lastname">
                                        <input type="text" name="lastname" id="" required placeholder="Фамилия">
                                    </div>
                                    <div class="intens-form-email">
                                        <input type="email" name="email" id="" required placeholder="Почта">
                                    </div>
                                    <div class="intens-form-phone">
                                        <input id="" required>
                                    </div>
                                    <div class="intens-form-agree">
                                        <label>
                                            <input type="checkbox" name="agree">
                                            <div>
                                                <svg width="8" height="8" viewBox="0 0 8 8" fill="none"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        d="M1 2.84615L3.14168 6.70118C3.21595 6.83487 3.40669 6.83912 3.48685 6.70887L7 1"
                                                        stroke="black" stroke-width="1.5" stroke-linecap="round" />
                                                </svg>
                                            </div>
                                        </label>
                                        <p>Я принимаю условия <a href="/ru-ru/legal/offer">Публичной оферты</a> и даю
                                            согласие на обработку своих персональных данных<br> в соответствии с <a
                                                href="/ru-ru/legal/privacy">Политикой конфиденциальности</a></p>
                                    </div>
                                    <a href="#" disabled class="submit-btn">Записаться на интенсив</a>
                                    <input type="hidden" name="offerID" required>
                                    <input type="hidden" name="tel">
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
	});
    
    blockManager.add('careerum-club21-banner23', {
        label: 'Баннер 2.3',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-club21-banner23">
            <div>
                <div class="club21-banner23-label">
                    <p>Фокус-кэмп</p>
                </div>
                <div class="club21-banner23-top">
                    <div>
                        <h2>Get Hired: как получить оффер мечты</h2>
                        <p class="club21-banner23-subheader">Хоть в Европе, хоть в РФ — <br>в любой стране мира</p>
                        <p class="club21-banner23-text">Научим искать работу без паники. Проведем через все этапы<br> поиска.
                            Дадим пошаговый алгоритм для получения оффера: от анализа рынка до переговоров с рекрутером. Эти
                            навыки <br>останутся с вами навсегда и будут актуальны при любых условиях рынка</p>
                    </div>
                    <div>
                        <div class="club21-banner23-top-label">
                            <p>26 февраля — 5 мая</p>
                        </div>
                        <div class="club21-banner23-top-label">
                            <p>Бесплатно для участников Careerum</p>
                        </div>
                        <ul>
                            <li>
                                Живые эфиры                       
                            </li>
                            <li>
                                Теория в записи
                            </li>
                            <li>
                                Работа в тройках
                            </li>
                            <li>
                                Нетворкинг
                            </li>
                            <li>
                                Фидбек карьерного эксперта
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="club21-banner23-slider">
                    <div class="club21-banner23-slider-item">
                        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1.25 15L20 5L38.75 15L20 25L1.25 15Z" stroke="black" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M29.375 37.5V20L20 15" stroke="black" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M34.375 17.3291V25.8604C34.3739 26.1258 34.2861 26.3837 34.125 26.5947C33.0781 28.001 28.6406 33.126 20 33.126C11.3594 33.126 6.92187 28.001 5.875 26.5947C5.7139 26.3837 5.62612 26.1258 5.625 25.8604V17.3291" stroke="black" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
                          </svg>
                        <p>Получите навыки, чтобы искать работу в любой ситуации и без помощи консультантов</p>
                    </div>
                    <div class="club21-banner23-slider-item">
                        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M20 35C28.2843 35 35 28.2843 35 20C35 11.7157 28.2843 5 20 5C11.7157 5 5 11.7157 5 20C5 28.2843 11.7157 35 20 35Z" stroke="black" stroke-width="2.5" stroke-miterlimit="10" />
                            <path d="M5.85938 15H34.1406" stroke="black" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M5.85938 25H34.1406" stroke="black" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M20 34.5928C23.4518 34.5928 26.25 28.0589 26.25 19.999C26.25 11.9391 23.4518 5.40527 20 5.40527C16.5482 5.40527 13.75 11.9391 13.75 19.999C13.75 28.0589 16.5482 34.5928 20 34.5928Z" stroke="black" stroke-width="2.5" stroke-miterlimit="10" />
                          </svg>
                        <p>Познакомитесь с особенностями найма в различных культурах</p>
                    </div>
                    <div class="club21-banner23-slider-item">
                        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M20 35C28.2843 35 35 28.2843 35 20C35 11.7157 28.2843 5 20 5C11.7157 5 5 11.7157 5 20C5 28.2843 11.7157 35 20 35Z" stroke="black" stroke-width="2.5" stroke-miterlimit="10" />
                            <path d="M14.375 18.75C15.4105 18.75 16.25 17.9105 16.25 16.875C16.25 15.8395 15.4105 15 14.375 15C13.3395 15 12.5 15.8395 12.5 16.875C12.5 17.9105 13.3395 18.75 14.375 18.75Z" fill="black" />
                            <path d="M25.625 18.75C26.6605 18.75 27.5 17.9105 27.5 16.875C27.5 15.8395 26.6605 15 25.625 15C24.5895 15 23.75 15.8395 23.75 16.875C23.75 17.9105 24.5895 18.75 25.625 18.75Z" fill="black" />
                            <path d="M14.375 18.75C15.4105 18.75 16.25 17.9105 16.25 16.875C16.25 15.8395 15.4105 15 14.375 15C13.3395 15 12.5 15.8395 12.5 16.875C12.5 17.9105 13.3395 18.75 14.375 18.75Z" fill="black" />
                            <path d="M25.625 18.75C26.6605 18.75 27.5 17.9105 27.5 16.875C27.5 15.8395 26.6605 15 25.625 15C24.5895 15 23.75 15.8395 23.75 16.875C23.75 17.9105 24.5895 18.75 25.625 18.75Z" fill="black" />
                            <path d="M26.5 27.5001C25.8392 26.3616 24.891 25.4167 23.7503 24.7599C22.6096 24.103 21.3163 23.7573 20 23.7573C18.6837 23.7573 17.3905 24.103 16.2497 24.7599C15.109 25.4167 14.1608 26.3616 13.5 27.5001" stroke="black" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
                          </svg>
                        <p>Проработаете негативные установки, связанные с поиском работы и узнаете, где искать вакансии</p>
                    </div>
                    <div class="club21-banner23-slider-item">
                        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M8.75 8.75V17.3594C8.75 23.5625 13.7188 28.7032 19.9219 28.7501C21.4058 28.7604 22.8772 28.477 24.2511 27.9162C25.6251 27.3555 26.8745 26.5284 27.9274 25.4828C28.9804 24.4371 29.8161 23.1934 30.3863 21.8234C30.9565 20.4533 31.2501 18.984 31.2501 17.5V8.75C31.2501 8.41848 31.1184 8.10054 30.8839 7.86612C30.6495 7.6317 30.3316 7.5 30.0001 7.5H10C9.66848 7.5 9.35054 7.6317 9.11612 7.86612C8.8817 8.10054 8.75 8.41848 8.75 8.75Z" stroke="black" stroke-width="2.50001" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M15 35H25" stroke="black" stroke-width="2.50001" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M20 28.75V35" stroke="black" stroke-width="2.50001" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M30.9688 20H32.5C33.8261 20 35.0979 19.4732 36.0355 18.5356C36.9732 17.5979 37.5 16.3261 37.5 15V12.5C37.5 12.1685 37.3683 11.8505 37.1339 11.6161C36.8995 11.3817 36.5815 11.25 36.25 11.25H31.25" stroke="black" stroke-width="2.50001" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M9.06252 20H7.48439C6.1583 20 4.88653 19.4732 3.94885 18.5356C3.01116 17.5979 2.48438 16.3261 2.48438 15V12.5C2.48438 12.1685 2.61607 11.8505 2.85049 11.6161C3.08491 11.3817 3.40286 11.25 3.73438 11.25H8.73439" stroke="black" stroke-width="2.50001" stroke-linecap="round" stroke-linejoin="round" />
                          </svg>
                        <p>Научитесь находить у себя достижения и выгодно их презентовать</p>
                    </div>
                    <div class="club21-banner23-slider-item">
                        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M26.25 35H8.75C8.41848 35 8.10054 34.8683 7.86612 34.6339C7.6317 34.3995 7.5 34.0815 7.5 33.75V11.25C7.5 10.9185 7.6317 10.6005 7.86612 10.3661C8.10054 10.1317 8.41848 10 8.75 10H21.25L27.5 16.25V33.75C27.5 34.0815 27.3683 34.3995 27.1339 34.6339C26.8995 34.8683 26.5815 35 26.25 35Z" stroke="black" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M12.5 10V6.25C12.5 5.91848 12.6317 5.60054 12.8661 5.36612C13.1005 5.1317 13.4185 5 13.75 5H26.25L32.5 11.25V28.75C32.5 29.0815 32.3683 29.3995 32.1339 29.6339C31.8995 29.8683 31.5815 30 31.25 30H27.5" stroke="black" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M13.75 23.75H21.25" stroke="black" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M13.75 28.75H21.25" stroke="black" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
                          </svg>
                        <p>Научитесь анализировать компании, чтобы не разочароавться в выборе</p>
                    </div>
                    <div class="club21-banner23-slider-item">
                        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M33.1251 5.625H6.875C6.18465 5.625 5.625 6.18465 5.625 6.875V33.1251C5.625 33.8154 6.18465 34.3751 6.875 34.3751H33.1251C33.8154 34.3751 34.3751 33.8154 34.3751 33.1251V6.875C34.3751 6.18465 33.8154 5.625 33.1251 5.625Z" stroke="black" stroke-width="2.50001" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M18.75 17.5V27.5" stroke="black" stroke-width="2.50001" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M13.75 17.5V27.5" stroke="black" stroke-width="2.50001" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M18.75 21.875C18.75 20.7147 19.2109 19.6019 20.0314 18.7814C20.8519 17.9609 21.9647 17.5 23.125 17.5C24.2853 17.5 25.3981 17.9609 26.2186 18.7814C27.0391 19.6019 27.5 20.7147 27.5 21.875V27.5" stroke="black" stroke-width="2.50001" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M13.75 14.375C14.7855 14.375 15.625 13.5355 15.625 12.5C15.625 11.4645 14.7855 10.625 13.75 10.625C12.7145 10.625 11.875 11.4645 11.875 12.5C11.875 13.5355 12.7145 14.375 13.75 14.375Z" fill="black" />
                          </svg>
                        <p>Прокачаете резюме, сопроводительное письмо и LinkedIn-профиль</p>
                    </div>
                    <div class="club21-banner23-slider-item">
                        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M11.1875 22.5L5 27.5001V7.5C5 7.16848 5.1317 6.85054 5.36612 6.61612C5.60054 6.3817 5.91848 6.25 6.25 6.25H26.2501C26.5816 6.25 26.8995 6.3817 27.1339 6.61612C27.3684 6.85054 27.5001 7.16848 27.5001 7.5V21.25C27.5001 21.5816 27.3684 21.8995 27.1339 22.1339C26.8995 22.3684 26.5816 22.5 26.2501 22.5H11.1875Z" stroke="black" stroke-width="2.50001" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M12.5 22.5V28.75C12.5 29.0816 12.6317 29.3995 12.8661 29.6339C13.1005 29.8684 13.4185 30 13.75 30H28.8125L35.0001 35.0001V15C35.0001 14.6685 34.8684 14.3505 34.6339 14.1161C34.3995 13.8817 34.0816 13.75 33.7501 13.75H27.5" stroke="black" stroke-width="2.50001" stroke-linecap="round" stroke-linejoin="round" />
                          </svg>
                        <p>Подготовитесь к вопросам рекрутеров. И даже к каверзным ;)</p>
                    </div>
                    <div class="club21-banner23-slider-item">
                        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M37.6094 19.0302L33.75 20.9521L28.75 11.3895L32.6563 9.43639C32.9466 9.28842 33.2836 9.26122 33.5939 9.36074C33.9041 9.46026 34.1625 9.67842 34.3125 9.96765L38.1563 17.3271C38.2343 17.4744 38.282 17.6358 38.2966 17.8018C38.3112 17.9679 38.2925 18.1351 38.2416 18.2938C38.1906 18.4525 38.1084 18.5994 37.9999 18.7259C37.8913 18.8523 37.7586 18.9558 37.6094 19.0302V19.0302Z" stroke="black" stroke-width="2.50002" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M6.24952 20.7982L2.39012 18.8606C2.24152 18.7878 2.10908 18.6858 2.00067 18.5608C1.89227 18.4358 1.81012 18.2902 1.7591 18.1328C1.70808 17.9753 1.68924 17.8093 1.70369 17.6444C1.71815 17.4795 1.7656 17.3193 1.84324 17.1731L5.68701 9.81371C5.83738 9.5247 6.09464 9.3058 6.404 9.20366C6.71336 9.10151 7.05038 9.12418 7.34328 9.26683L11.2495 11.22L6.24952 20.7982Z" stroke="black" stroke-width="2.50002" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M33.7499 20.9524L31.2499 23.8899L25.4999 29.6399C25.3432 29.7865 25.1533 29.8929 24.9465 29.95C24.7397 30.0072 24.5221 30.0134 24.3124 29.9681L15.2498 27.7024C15.0843 27.6563 14.93 27.5765 14.7967 27.4681L6.24976 20.7961" stroke="black" stroke-width="2.50002" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M31.25 23.8917L24.375 18.8917L22.3749 20.3917C21.5084 21.0384 20.4562 21.3878 19.3749 21.3878C18.2937 21.3878 17.2414 21.0384 16.3749 20.3917L15.5311 19.751C15.3885 19.6426 15.2705 19.505 15.1849 19.3475C15.0994 19.19 15.0483 19.0161 15.035 18.8374C15.0217 18.6587 15.0465 18.4791 15.1078 18.3107C15.1691 18.1423 15.2655 17.9888 15.3905 17.8604L21.5156 11.751C21.6306 11.6365 21.7671 11.5458 21.9173 11.4842C22.0674 11.4225 22.2283 11.391 22.3906 11.3916H28.75" stroke="black" stroke-width="2.50002" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M11.3438 11.2179L19.3594 8.87412C19.6442 8.79244 19.9488 8.81459 20.2188 8.93662L25.6251 11.3898" stroke="black" stroke-width="2.50002" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M17.4998 33.2659L12.7967 32.0784C12.605 32.0351 12.4275 31.9437 12.281 31.8128L8.74976 28.7502" stroke="black" stroke-width="2.50002" stroke-linecap="round" stroke-linejoin="round" />
                          </svg>
                        <p>Научитесь использовать нетворкинг для поиска работы</p>
                    </div>
                    <div class="club21-banner23-slider-item">
                        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M31.2502 8.75H8.75002C6.67894 8.75 5 10.4289 5 12.5V30.0001C5 32.0712 6.67894 33.7502 8.75002 33.7502H31.2502C33.3212 33.7502 35.0002 32.0712 35.0002 30.0001V12.5C35.0002 10.4289 33.3212 8.75 31.2502 8.75Z" stroke="black" stroke-width="2.50002" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M25.6251 22.5002H14.375C12.6491 22.5002 11.25 23.8994 11.25 25.6253C11.25 27.3512 12.6491 28.7503 14.375 28.7503H25.6251C27.351 28.7503 28.7501 27.3512 28.7501 25.6253C28.7501 23.8994 27.351 22.5002 25.6251 22.5002Z" stroke="black" stroke-width="2.50002" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M23.125 22.5002V28.7503" stroke="black" stroke-width="2.50002" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M16.875 22.5002V28.7503" stroke="black" stroke-width="2.50002" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M20 8.75004V2.5" stroke="black" stroke-width="2.50002" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M13.125 18.75C14.1606 18.75 15 17.9106 15 16.875C15 15.8395 14.1606 15 13.125 15C12.0895 15 11.25 15.8395 11.25 16.875C11.25 17.9106 12.0895 18.75 13.125 18.75Z" fill="black" />
                            <path d="M26.875 18.75C27.9106 18.75 28.75 17.9106 28.75 16.875C28.75 15.8395 27.9106 15 26.875 15C25.8395 15 25 15.8395 25 16.875C25 17.9106 25.8395 18.75 26.875 18.75Z" fill="black" />
                          </svg>
                        <p>Упростите поиск работы с помощью нейросетей</p>
                    </div>
                    <div class="club21-banner23-slider-item">
                        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M36.2502 10H3.75001C3.05965 10 2.5 10.5596 2.5 11.25V28.7501C2.5 29.4405 3.05965 30.0001 3.75001 30.0001H36.2502C36.9406 30.0001 37.5002 29.4405 37.5002 28.7501V11.25C37.5002 10.5596 36.9406 10 36.2502 10Z" stroke="black" stroke-width="2.50002" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M20 25.0001C22.7615 25.0001 25.0001 22.7615 25.0001 20C25.0001 17.2386 22.7615 15 20 15C17.2386 15 15 17.2386 15 20C15 22.7615 17.2386 25.0001 20 25.0001Z" stroke="black" stroke-width="2.50002" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M27.5 10L37.5001 18.7501" stroke="black" stroke-width="2.50002" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M27.5 30.0003L37.5001 21.2502" stroke="black" stroke-width="2.50002" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M12.5001 10L2.5 18.7501" stroke="black" stroke-width="2.50002" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M12.5001 30.0003L2.5 21.2502" stroke="black" stroke-width="2.50002" stroke-linecap="round" stroke-linejoin="round" />
                          </svg>
                        <p>Узнаете, как правильно обсуждать будущую зарплату</p>
                    </div>
                </div>
                <div class="club21-banner23-slider-nav">
                    <div class="club21-banner23-slider-nav-prev">
                        <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M2.19055 7.99935L15.8105 7.99935" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M8.46289 14.2453L2.18956 7.99862L8.46289 1.75195" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round" />
                          </svg>
                    </div>
                    <div class="club21-banner23-slider-nav-next">
                        <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M15.8095 8.00065L2.18945 8.00065" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M9.53711 1.75471L15.8104 8.00138L9.53711 14.248" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round" />
                          </svg>
                    </div>
                </div>
                <div class="club21-banner23-button">
                    <a href="#" class="btn-color-main-bright-orange">Участвовать</a>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-club21-banner23-tablet', {
        label: 'Баннер 2.3 (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-club21-banner23-tablet">
            <div>
                <div class="club21-banner23-label">
                    <p>Фокус-кэмп</p>
                </div>
                <div class="club21-banner23-top">
                    <div>
                        <h2>Get Hired: как получить оффер мечты</h2>
                        <p class="club21-banner23-subheader">Хоть в Европе, хоть в РФ — <br>в любой стране мира</p>
                        <p class="club21-banner23-text">Научим искать работу без паники. Проведем через все этапы поиска.
                            Дадим пошаговый алгоритм <br>для получения оффера: от анализа рынка<br> до переговоров с рекрутером. Эти
                            навыки останутся<br> с вами навсегда и будут актуальны при любых условиях рынка</p>
                    </div>
                    <div>
                        <div class="club21-banner23-top-label">
                            <p>26 февраля — 5 мая</p>
                        </div>
                        <div class="club21-banner23-top-label">
                            <p>Бесплатно для участников Careerum</p>
                        </div>
                        <ul>
                            <li>
                                Живые эфиры                       
                            </li>
                            <li>
                                Теория в записи
                            </li>
                            <li>
                                Работа в тройках
                            </li>
                            <li>
                                Нетворкинг
                            </li>
                            <li>
                                Фидбек карьерного эксперта
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="club21-banner23-slider">
                    <div class="club21-banner23-slider-item">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0.75 9L12 3L23.25 9L12 15L0.75 9Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M17.625 22.5V12L12 9" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M20.625 10.3975V15.5162C20.6243 15.6755 20.5717 15.8302 20.475 15.9568C19.8469 16.8006 17.1844 19.8756 12 19.8756C6.81563 19.8756 4.15312 16.8006 3.525 15.9568C3.42834 15.8302 3.37567 15.6755 3.375 15.5162V10.3975" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                          </svg>
                        <p>Получите навыки, чтобы искать работу в любой ситуации и без помощи консультантов</p>
                    </div>
                    <div class="club21-banner23-slider-item">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z" stroke="black" stroke-width="1.5" stroke-miterlimit="10" />
                            <path d="M3.51562 9H20.4844" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M3.51562 15H20.4844" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M12 20.7557C14.0711 20.7557 15.75 16.8354 15.75 11.9994C15.75 7.16347 14.0711 3.24316 12 3.24316C9.92893 3.24316 8.25 7.16347 8.25 11.9994C8.25 16.8354 9.92893 20.7557 12 20.7557Z" stroke="black" stroke-width="1.5" stroke-miterlimit="10" />
                          </svg>
                        <p>Познакомитесь с особенностями найма в различных культурах</p>
                    </div>
                    <div class="club21-banner23-slider-item">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z" stroke="black" stroke-width="1.5" stroke-miterlimit="10" />
                            <path d="M8.625 11.25C9.24632 11.25 9.75 10.7463 9.75 10.125C9.75 9.50368 9.24632 9 8.625 9C8.00368 9 7.5 9.50368 7.5 10.125C7.5 10.7463 8.00368 11.25 8.625 11.25Z" fill="black" />
                            <path d="M15.375 11.25C15.9963 11.25 16.5 10.7463 16.5 10.125C16.5 9.50368 15.9963 9 15.375 9C14.7537 9 14.25 9.50368 14.25 10.125C14.25 10.7463 14.7537 11.25 15.375 11.25Z" fill="black" />
                            <path d="M8.625 11.25C9.24632 11.25 9.75 10.7463 9.75 10.125C9.75 9.50368 9.24632 9 8.625 9C8.00368 9 7.5 9.50368 7.5 10.125C7.5 10.7463 8.00368 11.25 8.625 11.25Z" fill="black" />
                            <path d="M15.375 11.25C15.9963 11.25 16.5 10.7463 16.5 10.125C16.5 9.50368 15.9963 9 15.375 9C14.7537 9 14.25 9.50368 14.25 10.125C14.25 10.7463 14.7537 11.25 15.375 11.25Z" fill="black" />
                            <path d="M15.9001 16.5C15.5036 15.817 14.9347 15.25 14.2503 14.8559C13.5658 14.4618 12.7899 14.2544 12.0001 14.2544C11.2103 14.2544 10.4344 14.4618 9.74993 14.8559C9.0655 15.25 8.49658 15.817 8.1001 16.5" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                          </svg>
                        <p>Проработаете негативные установки, связанные с поиском работы и узнаете, где искать вакансии</p>
                    </div>
                    <div class="club21-banner23-slider-item">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M5.25 5.25V10.4156C5.25 14.1375 8.23125 17.2219 11.9531 17.25C12.8435 17.2562 13.7263 17.0862 14.5506 16.7497C15.375 16.4133 16.1247 15.917 16.7564 15.2896C17.3882 14.6622 17.8896 13.916 18.2317 13.094C18.5739 12.272 18.75 11.3904 18.75 10.5V5.25C18.75 5.05109 18.671 4.86032 18.5303 4.71967C18.3897 4.57902 18.1989 4.5 18 4.5H6C5.80109 4.5 5.61032 4.57902 5.46967 4.71967C5.32902 4.86032 5.25 5.05109 5.25 5.25Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M9 21H15" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M12 17.25V21" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M18.5811 12H19.4998C20.2955 12 21.0585 11.6839 21.6211 11.1213C22.1837 10.5587 22.4998 9.79565 22.4998 9V7.5C22.4998 7.30109 22.4208 7.11032 22.2801 6.96967C22.1395 6.82902 21.9487 6.75 21.7498 6.75H18.7498" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M5.43711 12H4.49023C3.69458 12 2.93152 11.6839 2.36891 11.1213C1.8063 10.5587 1.49023 9.79565 1.49023 9V7.5C1.49023 7.30109 1.56925 7.11032 1.7099 6.96967C1.85056 6.82902 2.04132 6.75 2.24023 6.75H5.24023" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                          </svg>
                        <p>Научитесь находить у себя достижения и выгодно их презентовать</p>
                    </div>
                    <div class="club21-banner23-slider-item">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M15.75 21H5.25C5.05109 21 4.86032 20.921 4.71967 20.7803C4.57902 20.6397 4.5 20.4489 4.5 20.25V6.75C4.5 6.55109 4.57902 6.36032 4.71967 6.21967C4.86032 6.07902 5.05109 6 5.25 6H12.75L16.5 9.75V20.25C16.5 20.4489 16.421 20.6397 16.2803 20.7803C16.1397 20.921 15.9489 21 15.75 21Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M7.5 6V3.75C7.5 3.55109 7.57902 3.36032 7.71967 3.21967C7.86032 3.07902 8.05109 3 8.25 3H15.75L19.5 6.75V17.25C19.5 17.4489 19.421 17.6397 19.2803 17.7803C19.1397 17.921 18.9489 18 18.75 18H16.5" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M8.25 14.25H12.75" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M8.25 17.25H12.75" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                          </svg>
                        <p>Научитесь анализировать компании, чтобы не разочароавться в выборе</p>
                    </div>
                    <div class="club21-banner23-slider-item">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M19.875 3.375H4.125C3.71079 3.375 3.375 3.71079 3.375 4.125V19.875C3.375 20.2892 3.71079 20.625 4.125 20.625H19.875C20.2892 20.625 20.625 20.2892 20.625 19.875V4.125C20.625 3.71079 20.2892 3.375 19.875 3.375Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M11.25 10.5V16.5" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M8.25 10.5V16.5" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M11.25 13.125C11.25 12.4288 11.5266 11.7611 12.0188 11.2688C12.5111 10.7766 13.1788 10.5 13.875 10.5C14.5712 10.5 15.2389 10.7766 15.7312 11.2688C16.2234 11.7611 16.5 12.4288 16.5 13.125V16.5" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M8.25 8.625C8.87132 8.625 9.375 8.12132 9.375 7.5C9.375 6.87868 8.87132 6.375 8.25 6.375C7.62868 6.375 7.125 6.87868 7.125 7.5C7.125 8.12132 7.62868 8.625 8.25 8.625Z" fill="black" />
                          </svg>
                        <p>Прокачаете резюме, сопроводительное письмо и LinkedIn-профиль</p>
                    </div>
                    <div class="club21-banner23-slider-item">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M6.7125 13.5L3 16.5V4.5C3 4.30109 3.07902 4.11032 3.21967 3.96967C3.36032 3.82902 3.55109 3.75 3.75 3.75H15.75C15.9489 3.75 16.1397 3.82902 16.2803 3.96967C16.421 4.11032 16.5 4.30109 16.5 4.5V12.75C16.5 12.9489 16.421 13.1397 16.2803 13.2803C16.1397 13.421 15.9489 13.5 15.75 13.5H6.7125Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M7.5 13.5V17.25C7.5 17.4489 7.57902 17.6397 7.71967 17.7803C7.86032 17.921 8.05109 18 8.25 18H17.2875L21 21V9C21 8.80109 20.921 8.61032 20.7803 8.46967C20.6397 8.32902 20.4489 8.25 20.25 8.25H16.5" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                          </svg>
                        <p>Подготовитесь к вопросам рекрутеров. И даже к каверзным ;)</p>
                    </div>
                    <div class="club21-banner23-slider-item">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M22.5656 11.4181L20.25 12.5712L17.25 6.83371L19.5938 5.66184C19.7679 5.57305 19.9701 5.55673 20.1563 5.61645C20.3425 5.67616 20.4975 5.80705 20.5875 5.98058L22.8938 10.3962C22.9405 10.4846 22.9691 10.5815 22.9779 10.6811C22.9867 10.7807 22.9755 10.881 22.9449 10.9763C22.9143 11.0715 22.865 11.1596 22.7999 11.2355C22.7348 11.3114 22.6551 11.3734 22.5656 11.4181V11.4181Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M3.74984 12.4789L1.43422 11.3164C1.34506 11.2727 1.26559 11.2115 1.20055 11.1364C1.13551 11.0614 1.08622 10.9741 1.05561 10.8796C1.02499 10.7852 1.01369 10.6855 1.02236 10.5866C1.03103 10.4877 1.05951 10.3915 1.10609 10.3039L3.41234 5.88822C3.50256 5.71482 3.65691 5.58348 3.84253 5.52219C4.02814 5.46091 4.23035 5.47451 4.40609 5.5601L6.74984 6.73198L3.74984 12.4789Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M20.25 12.5713L18.75 14.3338L15.3 17.7838C15.206 17.8717 15.092 17.9356 14.968 17.9698C14.8439 18.0041 14.7133 18.0078 14.5875 17.9807L9.15 16.6213C9.05067 16.5936 8.95812 16.5457 8.87813 16.4807L3.75 12.4775" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M18.7501 14.335L14.6251 11.335L13.4251 12.235C12.9052 12.623 12.2738 12.8326 11.6251 12.8326C10.9763 12.8326 10.345 12.623 9.82508 12.235L9.31883 11.8506C9.23323 11.7855 9.16242 11.703 9.1111 11.6085C9.05978 11.514 9.02911 11.4097 9.02113 11.3024C9.01316 11.1952 9.02805 11.0875 9.06483 10.9864C9.1016 10.8853 9.15942 10.7932 9.23446 10.7162L12.9095 7.05059C12.9785 6.9819 13.0604 6.92749 13.1505 6.89049C13.2406 6.85349 13.3371 6.83462 13.4345 6.83497H17.2501" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M6.80664 6.73072L11.616 5.32447C11.7869 5.27546 11.9696 5.28875 12.1316 5.36197L15.3754 6.83384" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M10.5 19.9594L7.67813 19.2469C7.56313 19.2209 7.45666 19.166 7.36875 19.0875L5.25 17.25" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                          </svg>
                        <p>Научитесь использовать нетворкинг для поиска работы</p>
                    </div>
                    <div class="club21-banner23-slider-item">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M18.75 5.25H5.25C4.00736 5.25 3 6.25736 3 7.5V18C3 19.2426 4.00736 20.25 5.25 20.25H18.75C19.9926 20.25 21 19.2426 21 18V7.5C21 6.25736 19.9926 5.25 18.75 5.25Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M15.375 13.5H8.625C7.58947 13.5 6.75 14.3395 6.75 15.375C6.75 16.4105 7.58947 17.25 8.625 17.25H15.375C16.4105 17.25 17.25 16.4105 17.25 15.375C17.25 14.3395 16.4105 13.5 15.375 13.5Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M13.875 13.5V17.25" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M10.125 13.5V17.25" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M12 5.25V1.5" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M7.875 11.25C8.49632 11.25 9 10.7463 9 10.125C9 9.50368 8.49632 9 7.875 9C7.25368 9 6.75 9.50368 6.75 10.125C6.75 10.7463 7.25368 11.25 7.875 11.25Z" fill="black" />
                            <path d="M16.125 11.25C16.7463 11.25 17.25 10.7463 17.25 10.125C17.25 9.50368 16.7463 9 16.125 9C15.5037 9 15 9.50368 15 10.125C15 10.7463 15.5037 11.25 16.125 11.25Z" fill="black" />
                          </svg>
                        <p>Упростите поиск работы с помощью нейросетей</p>
                    </div>
                    <div class="club21-banner23-slider-item">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M21.75 6H2.25C1.83579 6 1.5 6.33579 1.5 6.75V17.25C1.5 17.6642 1.83579 18 2.25 18H21.75C22.1642 18 22.5 17.6642 22.5 17.25V6.75C22.5 6.33579 22.1642 6 21.75 6Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M16.5 6L22.5 11.25" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M16.5 18L22.5 12.75" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M7.5 6L1.5 11.25" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M7.5 18L1.5 12.75" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                          </svg>
                        <p>Узнаете, как правильно обсуждать будущую зарплату</p>
                    </div>
                </div>
                <div class="club21-banner23-slider-nav">
                    <div class="club21-banner23-slider-nav-prev">
                        <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M2.19055 7.99935L15.8105 7.99935" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M8.46289 14.2453L2.18956 7.99862L8.46289 1.75195" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round" />
                          </svg>
                    </div>
                    <div class="club21-banner23-slider-nav-next">
                        <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M15.8095 8.00065L2.18945 8.00065" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M9.53711 1.75471L15.8104 8.00138L9.53711 14.248" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round" />
                          </svg>
                    </div>
                </div>
                <div class="club21-banner23-button">
                    <a href="#" class="btn-color-main-bright-orange">Участвовать</a>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-club21-banner23-mobile', {
        label: 'Баннер 2.3 (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-club21-banner23-mobile">
            <div>
                <div class="club21-banner23-label">
                    <p>Фокус-кэмп</p>
                </div>
                <div class="club21-banner23-top">
                    <div>
                        <h2>Get Hired: как получить оффер мечты</h2>
                        <p class="club21-banner23-subheader">Хоть в Европе, хоть в РФ — в любой<br> стране мира</p>
                        <p class="club21-banner23-text">Научим искать работу без паники. Проведем через все этапы поиска.
                            Дадим пошаговый алгоритм для получения оффера: от анализа рынка до переговоров с рекрутером. Эти
                            навыки останутся с вами<br> навсегда и будут актуальны при любых условиях рынка</p>
                    </div>
                    <div>
                        <div class="club21-banner23-top-label">
                            <p>26 февраля — 5 мая</p>
                        </div>
                        <div class="club21-banner23-top-label">
                            <p>Бесплатно для участников Careerum</p>
                        </div>
                        <ul>
                            <li>
                                Живые эфиры                       
                            </li>
                            <li>
                                Теория в записи
                            </li>
                            <li>
                                Работа в тройках
                            </li>
                            <li>
                                Нетворкинг
                            </li>
                            <li>
                                Фидбек карьерного эксперта
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="club21-banner23-slider">
                    <div class="club21-banner23-slider-item">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0.75 9L12 3L23.25 9L12 15L0.75 9Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M17.625 22.5V12L12 9" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M20.625 10.3975V15.5162C20.6243 15.6755 20.5717 15.8302 20.475 15.9568C19.8469 16.8006 17.1844 19.8756 12 19.8756C6.81563 19.8756 4.15312 16.8006 3.525 15.9568C3.42834 15.8302 3.37567 15.6755 3.375 15.5162V10.3975" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                          </svg>
                        <p>Получите навыки, чтобы искать работу в любой ситуации<br> и без помощи консультантов</p>
                    </div>
                    <div class="club21-banner23-slider-item">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z" stroke="black" stroke-width="1.5" stroke-miterlimit="10" />
                            <path d="M3.51562 9H20.4844" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M3.51562 15H20.4844" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M12 20.7557C14.0711 20.7557 15.75 16.8354 15.75 11.9994C15.75 7.16347 14.0711 3.24316 12 3.24316C9.92893 3.24316 8.25 7.16347 8.25 11.9994C8.25 16.8354 9.92893 20.7557 12 20.7557Z" stroke="black" stroke-width="1.5" stroke-miterlimit="10" />
                          </svg>
                        <p>Познакомитесь с особенностями найма в различных культурах</p>
                    </div>
                    <div class="club21-banner23-slider-item">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z" stroke="black" stroke-width="1.5" stroke-miterlimit="10" />
                            <path d="M8.625 11.25C9.24632 11.25 9.75 10.7463 9.75 10.125C9.75 9.50368 9.24632 9 8.625 9C8.00368 9 7.5 9.50368 7.5 10.125C7.5 10.7463 8.00368 11.25 8.625 11.25Z" fill="black" />
                            <path d="M15.375 11.25C15.9963 11.25 16.5 10.7463 16.5 10.125C16.5 9.50368 15.9963 9 15.375 9C14.7537 9 14.25 9.50368 14.25 10.125C14.25 10.7463 14.7537 11.25 15.375 11.25Z" fill="black" />
                            <path d="M8.625 11.25C9.24632 11.25 9.75 10.7463 9.75 10.125C9.75 9.50368 9.24632 9 8.625 9C8.00368 9 7.5 9.50368 7.5 10.125C7.5 10.7463 8.00368 11.25 8.625 11.25Z" fill="black" />
                            <path d="M15.375 11.25C15.9963 11.25 16.5 10.7463 16.5 10.125C16.5 9.50368 15.9963 9 15.375 9C14.7537 9 14.25 9.50368 14.25 10.125C14.25 10.7463 14.7537 11.25 15.375 11.25Z" fill="black" />
                            <path d="M15.9001 16.5C15.5036 15.817 14.9347 15.25 14.2503 14.8559C13.5658 14.4618 12.7899 14.2544 12.0001 14.2544C11.2103 14.2544 10.4344 14.4618 9.74993 14.8559C9.0655 15.25 8.49658 15.817 8.1001 16.5" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                          </svg>
                        <p>Проработаете негативные установки, связанные с поиском работы и узнаете, где искать вакансии</p>
                    </div>
                    <div class="club21-banner23-slider-item">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M5.25 5.25V10.4156C5.25 14.1375 8.23125 17.2219 11.9531 17.25C12.8435 17.2562 13.7263 17.0862 14.5506 16.7497C15.375 16.4133 16.1247 15.917 16.7564 15.2896C17.3882 14.6622 17.8896 13.916 18.2317 13.094C18.5739 12.272 18.75 11.3904 18.75 10.5V5.25C18.75 5.05109 18.671 4.86032 18.5303 4.71967C18.3897 4.57902 18.1989 4.5 18 4.5H6C5.80109 4.5 5.61032 4.57902 5.46967 4.71967C5.32902 4.86032 5.25 5.05109 5.25 5.25Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M9 21H15" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M12 17.25V21" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M18.5811 12H19.4998C20.2955 12 21.0585 11.6839 21.6211 11.1213C22.1837 10.5587 22.4998 9.79565 22.4998 9V7.5C22.4998 7.30109 22.4208 7.11032 22.2801 6.96967C22.1395 6.82902 21.9487 6.75 21.7498 6.75H18.7498" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M5.43711 12H4.49023C3.69458 12 2.93152 11.6839 2.36891 11.1213C1.8063 10.5587 1.49023 9.79565 1.49023 9V7.5C1.49023 7.30109 1.56925 7.11032 1.7099 6.96967C1.85056 6.82902 2.04132 6.75 2.24023 6.75H5.24023" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                          </svg>
                        <p>Научитесь находить у себя достижения и выгодно их презентовать</p>
                    </div>
                    <div class="club21-banner23-slider-item">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M15.75 21H5.25C5.05109 21 4.86032 20.921 4.71967 20.7803C4.57902 20.6397 4.5 20.4489 4.5 20.25V6.75C4.5 6.55109 4.57902 6.36032 4.71967 6.21967C4.86032 6.07902 5.05109 6 5.25 6H12.75L16.5 9.75V20.25C16.5 20.4489 16.421 20.6397 16.2803 20.7803C16.1397 20.921 15.9489 21 15.75 21Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M7.5 6V3.75C7.5 3.55109 7.57902 3.36032 7.71967 3.21967C7.86032 3.07902 8.05109 3 8.25 3H15.75L19.5 6.75V17.25C19.5 17.4489 19.421 17.6397 19.2803 17.7803C19.1397 17.921 18.9489 18 18.75 18H16.5" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M8.25 14.25H12.75" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M8.25 17.25H12.75" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                          </svg>
                        <p>Научитесь анализировать компании, чтобы не разочароавться в выборе</p>
                    </div>
                    <div class="club21-banner23-slider-item">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M19.875 3.375H4.125C3.71079 3.375 3.375 3.71079 3.375 4.125V19.875C3.375 20.2892 3.71079 20.625 4.125 20.625H19.875C20.2892 20.625 20.625 20.2892 20.625 19.875V4.125C20.625 3.71079 20.2892 3.375 19.875 3.375Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M11.25 10.5V16.5" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M8.25 10.5V16.5" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M11.25 13.125C11.25 12.4288 11.5266 11.7611 12.0188 11.2688C12.5111 10.7766 13.1788 10.5 13.875 10.5C14.5712 10.5 15.2389 10.7766 15.7312 11.2688C16.2234 11.7611 16.5 12.4288 16.5 13.125V16.5" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M8.25 8.625C8.87132 8.625 9.375 8.12132 9.375 7.5C9.375 6.87868 8.87132 6.375 8.25 6.375C7.62868 6.375 7.125 6.87868 7.125 7.5C7.125 8.12132 7.62868 8.625 8.25 8.625Z" fill="black" />
                          </svg>
                        <p>Прокачаете резюме, сопроводительное письмо и LinkedIn-профиль</p>
                    </div>
                    <div class="club21-banner23-slider-item">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M6.7125 13.5L3 16.5V4.5C3 4.30109 3.07902 4.11032 3.21967 3.96967C3.36032 3.82902 3.55109 3.75 3.75 3.75H15.75C15.9489 3.75 16.1397 3.82902 16.2803 3.96967C16.421 4.11032 16.5 4.30109 16.5 4.5V12.75C16.5 12.9489 16.421 13.1397 16.2803 13.2803C16.1397 13.421 15.9489 13.5 15.75 13.5H6.7125Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M7.5 13.5V17.25C7.5 17.4489 7.57902 17.6397 7.71967 17.7803C7.86032 17.921 8.05109 18 8.25 18H17.2875L21 21V9C21 8.80109 20.921 8.61032 20.7803 8.46967C20.6397 8.32902 20.4489 8.25 20.25 8.25H16.5" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                          </svg>
                        <p>Подготовитесь к вопросам рекрутеров. И даже к каверзным ;)</p>
                    </div>
                    <div class="club21-banner23-slider-item">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M22.5656 11.4181L20.25 12.5712L17.25 6.83371L19.5938 5.66184C19.7679 5.57305 19.9701 5.55673 20.1563 5.61645C20.3425 5.67616 20.4975 5.80705 20.5875 5.98058L22.8938 10.3962C22.9405 10.4846 22.9691 10.5815 22.9779 10.6811C22.9867 10.7807 22.9755 10.881 22.9449 10.9763C22.9143 11.0715 22.865 11.1596 22.7999 11.2355C22.7348 11.3114 22.6551 11.3734 22.5656 11.4181V11.4181Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M3.74984 12.4789L1.43422 11.3164C1.34506 11.2727 1.26559 11.2115 1.20055 11.1364C1.13551 11.0614 1.08622 10.9741 1.05561 10.8796C1.02499 10.7852 1.01369 10.6855 1.02236 10.5866C1.03103 10.4877 1.05951 10.3915 1.10609 10.3039L3.41234 5.88822C3.50256 5.71482 3.65691 5.58348 3.84253 5.52219C4.02814 5.46091 4.23035 5.47451 4.40609 5.5601L6.74984 6.73198L3.74984 12.4789Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M20.25 12.5713L18.75 14.3338L15.3 17.7838C15.206 17.8717 15.092 17.9356 14.968 17.9698C14.8439 18.0041 14.7133 18.0078 14.5875 17.9807L9.15 16.6213C9.05067 16.5936 8.95812 16.5457 8.87813 16.4807L3.75 12.4775" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M18.7501 14.335L14.6251 11.335L13.4251 12.235C12.9052 12.623 12.2738 12.8326 11.6251 12.8326C10.9763 12.8326 10.345 12.623 9.82508 12.235L9.31883 11.8506C9.23323 11.7855 9.16242 11.703 9.1111 11.6085C9.05978 11.514 9.02911 11.4097 9.02113 11.3024C9.01316 11.1952 9.02805 11.0875 9.06483 10.9864C9.1016 10.8853 9.15942 10.7932 9.23446 10.7162L12.9095 7.05059C12.9785 6.9819 13.0604 6.92749 13.1505 6.89049C13.2406 6.85349 13.3371 6.83462 13.4345 6.83497H17.2501" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M6.80664 6.73072L11.616 5.32447C11.7869 5.27546 11.9696 5.28875 12.1316 5.36197L15.3754 6.83384" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M10.5 19.9594L7.67813 19.2469C7.56313 19.2209 7.45666 19.166 7.36875 19.0875L5.25 17.25" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                          </svg>
                        <p>Научитесь использовать нетворкинг для поиска работы</p>
                    </div>
                    <div class="club21-banner23-slider-item">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M18.75 5.25H5.25C4.00736 5.25 3 6.25736 3 7.5V18C3 19.2426 4.00736 20.25 5.25 20.25H18.75C19.9926 20.25 21 19.2426 21 18V7.5C21 6.25736 19.9926 5.25 18.75 5.25Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M15.375 13.5H8.625C7.58947 13.5 6.75 14.3395 6.75 15.375C6.75 16.4105 7.58947 17.25 8.625 17.25H15.375C16.4105 17.25 17.25 16.4105 17.25 15.375C17.25 14.3395 16.4105 13.5 15.375 13.5Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M13.875 13.5V17.25" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M10.125 13.5V17.25" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M12 5.25V1.5" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M7.875 11.25C8.49632 11.25 9 10.7463 9 10.125C9 9.50368 8.49632 9 7.875 9C7.25368 9 6.75 9.50368 6.75 10.125C6.75 10.7463 7.25368 11.25 7.875 11.25Z" fill="black" />
                            <path d="M16.125 11.25C16.7463 11.25 17.25 10.7463 17.25 10.125C17.25 9.50368 16.7463 9 16.125 9C15.5037 9 15 9.50368 15 10.125C15 10.7463 15.5037 11.25 16.125 11.25Z" fill="black" />
                          </svg>
                        <p>Упростите поиск работы с помощью нейросетей</p>
                    </div>
                    <div class="club21-banner23-slider-item">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M21.75 6H2.25C1.83579 6 1.5 6.33579 1.5 6.75V17.25C1.5 17.6642 1.83579 18 2.25 18H21.75C22.1642 18 22.5 17.6642 22.5 17.25V6.75C22.5 6.33579 22.1642 6 21.75 6Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M16.5 6L22.5 11.25" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M16.5 18L22.5 12.75" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M7.5 6L1.5 11.25" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M7.5 18L1.5 12.75" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                          </svg>
                        <p>Узнаете, как правильно обсуждать будущую зарплату</p>
                    </div>
                </div>
                <div class="club21-banner23-slider-nav">
                    <div class="club21-banner23-slider-nav-prev">
                        <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M2.19055 7.99935L15.8105 7.99935" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M8.46289 14.2453L2.18956 7.99862L8.46289 1.75195" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round" />
                          </svg>
                    </div>
                    <div class="club21-banner23-slider-nav-next">
                        <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M15.8095 8.00065L2.18945 8.00065" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M9.53711 1.75471L15.8104 8.00138L9.53711 14.248" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round" />
                          </svg>
                    </div>
                </div>
                <div class="club21-banner23-button">
                    <a href="#" class="btn-color-main-bright-orange">Участвовать</a>
                </div>
            </div>
        </div>`
	});
    
    blockManager.add('careerum-club21-banner-top', {
        label: 'Баннер top',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-club21-banner-top" data-href="#buy">
            <div>
                <div class="club21-banner-top-left">
                    <p class="banner-top-header">Достигните самых смелых карьерных целей уже этим летом</p>
                    <p class="banner-top-sunheader">О ценах мы позаботились</p>
                </div>
                <div class="club21-banner-top-center">
                    <p class="banner-top-discount">–15%</p>
                    <p class="banner-top-promo">Промокод: MAY15</p>
                    <p class="banner-top-period">Активен до 29 мая</p>
                </div>
                <div class="club21-banner-top-right">
                    <a href="#buy" class="btn-color-black">Клик, и первый шаг сделан</a>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-club21-banner-top-tablet', {
        label: 'Баннер top (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-club21-banner-top-tablet" data-href="#buy">
            <div>
                <div class="club21-banner-top-left">
                    <p class="banner-top-header">Достигните самых смелых карьерных целей уже этим летом</p>
                    <p class="banner-top-sunheader">О ценах мы позаботились</p>
                </div>
                <div class="club21-banner-top-center">
                    <p class="banner-top-discount">–15%</p>
                    <p class="banner-top-promo">Промокод: MAY15</p>
                    <p class="banner-top-period">Активен до 29 мая</p>
                </div>
                <div class="club21-banner-top-right">
                    <a href="#buy" class="btn-color-black">Клик, и первый шаг сделан</a>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-club21-banner-top-mobile', {
        label: 'Баннер top (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-club21-banner-top-mobile" data-href="#buy">
            <div>
                <div class="club21-banner-top-left">
                    <p class="banner-top-header">Достигните самых смелых карьерных целей уже этим летом</p>
                </div>
                <div class="club21-banner-top-center">
                    <p class="banner-top-discount">–15%</p>
                    <p class="banner-top-promo">Промокод: MAY15</p>
                    <p class="banner-top-period">Активен до 29 мая</p>
                </div>
                <div class="club21-banner-top-right">
                    <a href="#buy" class="btn-color-black">Клик, и первый шаг сделан</a>
                </div>
            </div>
        </div>`
	});
    
    blockManager.add('careerum-club21-banner-top2', {
        label: 'Баннер top с таймером',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-club21-banner-top2" data-href="#buy" data-timer="no" data-redirect="no" data-url="" data-static="yes" data-offset=""
        data-timer-end="06/19/2024 22:05 GMT+0300">
            <div>
                <div class="club21-banner-top-left">
                    <p class="banner-top-sunheader">Работайте, где хочется</p>
                    <p class="banner-top-header">Бесплатный вебинар «Как найти<br> работу на международном рынке<br> в 2024»</p>
                </div>
                <div class="club21-banner-top-center">
                    <p class="banner-top-date">20 июня, 20:00 мск</p>
                    <div class="banner-top-timer">
                        <div>
                            <p class="banner-top-timer-header">До старта:</p>
                        </div>
                        <div>
                            <p class="timer-day-number">00</p>
                            <p class="timer-day-text"></p>
                        </div>
                        <div>
                            <p class="timer-hour-number">00</p>
                            <p class="timer-hour-text"></p>
                        </div>
                        <div>
                            <p class="timer-min-number">00</p>
                            <p class="timer-min-text"></p>
                        </div>
                    </div>
                </div>
                <div class="club21-banner-top-right">
                    <a href="#buy" class="btn-color-black">Успеть на эфир</a>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-club21-banner-top2-tablet', {
        label: 'Баннер top с таймером (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-club21-banner-top2-tablet" data-href="#buy" data-timer="no" data-redirect="no" data-url="" data-static="yes" data-offset=""
        data-timer-end="06/19/2024 22:05 GMT+0300">
            <div>
                <div class="club21-banner-top-left">
                    <p class="banner-top-sunheader">Работайте, где хочется</p>
                    <p class="banner-top-header">Бесплатный вебинар «Как найти работу на международном рынке в 2024»</p>
                </div>
                <div class="club21-banner-top-center">
                    <p class="banner-top-date">20 июня, 20:00 мск</p>
                    <div class="banner-top-timer">
                        <div>
                            <p class="banner-top-timer-header">До старта:</p>
                        </div>
                        <div>
                            <p class="timer-day-number">00</p>
                            <p class="timer-day-text"></p>
                        </div>
                        <div>
                            <p class="timer-hour-number">00</p>
                            <p class="timer-hour-text"></p>
                        </div>
                        <div>
                            <p class="timer-min-number">00</p>
                            <p class="timer-min-text"></p>
                        </div>
                    </div>
                </div>
                <div class="club21-banner-top-right">
                    <a href="#buy" class="btn-color-black">Успеть на эфир</a>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-club21-banner-top2-mobile', {
        label: 'Баннер top с таймером (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-club21-banner-top2-mobile" data-href="#buy" data-timer="no" data-redirect="no" data-url="" data-static="yes" data-offset=""
        data-timer-end="06/19/2024 22:05 GMT+0300">
            <div>
                <div class="club21-banner-top-left">
                    <p class="banner-top-date">20 июня, 20:00 мск</p>
                    <p class="banner-top-header">Бесплатный вебинар «Как найти работу на международном рынке в 2024»</p>
                </div>
                <div class="club21-banner-top-center">
                    <p class="banner-top-date">20 июня, 20:00 мск</p>
                    <div class="banner-top-timer">
                        <div>
                            <p class="banner-top-timer-header">До старта:</p>
                        </div>
                        <div>
                            <p class="timer-day-number">00</p>
                            <p class="timer-day-text"></p>
                        </div>
                        <div>
                            <p class="timer-hour-number">00</p>
                            <p class="timer-hour-text"></p>
                        </div>
                        <div>
                            <p class="timer-min-number">00</p>
                            <p class="timer-min-text"></p>
                        </div>
                    </div>
                </div>
                <div class="club21-banner-top-right">
                    <a href="#buy" class="btn-color-black">Успеть на эфир</a>
                </div>
            </div>
        </div>`
	});
    
    blockManager.add('careerum-club21-banner-top3', {
        label: 'Баннер top3 с таймером',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-club21-banner-top3" data-href="#buy" data-timer="no" data-redirect="no" data-url="" data-static="yes" data-offset=""
        data-timer-end="07/19/2024 22:05 GMT+0300" data-theme="dark">
            <div>
                <div class="club21-banner-top-left">
                    <p class="banner-top-sunheader">20 июня, 20:00 мск</p>
                    <p class="banner-top-header">Вебинар «Как найти работу на международном рынке в 2024»</p>
                </div>
                <div class="club21-banner-top-center">
                    <p class="banner-top-timer-header">До старта</p>
                    <div class="banner-top-timer">
                        <div>
                            <p class="timer-day-number">00</p>
                            <p class="timer-day-text"></p>
                        </div>
                        <div>
                            <p class="timer-hour-number">00</p>
                            <p class="timer-hour-text"></p>
                        </div>
                        <div>
                            <p class="timer-min-number">00</p>
                            <p class="timer-min-text"></p>
                        </div>
                    </div>
                </div>
                <div class="club21-banner-top-right">
                    <a href="#buy" class="btn-color-main-dark-orange">Участвовать бесплатно</a>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-club21-banner-top3-tablet', {
        label: 'Баннер top3 с таймером (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-club21-banner-top3-tablet" data-href="#buy" data-timer="no" data-redirect="no" data-url="" data-static="yes" data-offset=""
        data-timer-end="07/19/2024 22:05 GMT+0300" data-theme="dark">
            <div>
                <div class="club21-banner-top-left">
                    <p class="banner-top-sunheader">20 июня, 20:00 мск</p>
                    <p class="banner-top-header">Вебинар «Как найти работу на международном рынке<br> в 2024»</p>
                </div>
                <div class="club21-banner-top-center">
                    <p class="banner-top-timer-header">До старта</p>
                    <div class="banner-top-timer">
                        <div>
                            <p class="timer-day-number">24</p>
                            <p class="timer-day-text"></p>
                        </div>
                        <div>
                            <p class="timer-hour-number">24</p>
                            <p class="timer-hour-text"></p>
                        </div>
                        <div>
                            <p class="timer-min-number">24</p>
                            <p class="timer-min-text"></p>
                        </div>
                    </div>
                </div>
                <div class="club21-banner-top-right">
                    <a href="#buy" class="btn-color-main-dark-orange">Участвовать бесплатно</a>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-club21-banner-top3-mobile', {
        label: 'Баннер top3 с таймером (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-club21-banner-top3-mobile" data-href="#buy" data-timer="no" data-redirect="no" data-url="" data-static="yes" data-offset=""
        data-timer-end="07/19/2024 22:05 GMT+0300" data-theme="dark">
            <div>
                <div class="club21-banner-top-left">
                    <p class="banner-top-sunheader">20 июня, 20:00 мск</p>
                    <p class="banner-top-header">Вебинар «Как найти работу на международном рынке в 2024»</p>
                </div>
                <div class="club21-banner-top-center">
                    <p class="banner-top-timer-header">До старта</p>
                    <div class="banner-top-timer">
                        <div>
                            <p class="timer-day-number">24</p>
                            <p class="timer-day-text"></p>
                        </div>
                        <div>
                            <p class="timer-hour-number">24</p>
                            <p class="timer-hour-text"></p>
                        </div>
                        <div>
                            <p class="timer-min-number">24</p>
                            <p class="timer-min-text"></p>
                        </div>
                    </div>
                </div>
                <div class="club21-banner-top-right">
                    <a href="#buy" class="btn-color-main-dark-orange">Участвовать бесплатно</a>
                </div>
            </div>
        </div>`
	});
    
    blockManager.add('careerum-club21-banner24', {
        label: 'Баннер 2.4',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-club21-banner24">
            <div>
                <div class="club21-banner24-top">
                    <p class="club21-banner24-top-label1">Новая программа в Careerum</p>
                    <p class="club21-banner24-top-label2">От автора бестселлера «Внутренняя опора»</p>
                </div>
                <div class="club21-banner24-bottom">
                    <div class="club21-banner24-left">
                        <h2>Самооценка & деньги: <span>не мешайте себе зарабатывать</span></h2>
                        <p>Сформируйте карьерную уверенность в себе, чтобы: <span>больше зарабатывать,<br> расти в должности,
                                открывать новые карьерные перспективы.</span> </p>
                        <a href="#buy" class="btn-color-main-dark-orange">Участвовать</a>
                    </div>
                    <div class="club21-banner24-right">
                        <div class="club21-banner24-list">
                            <p class="club21-banner24-label">Во время обучения:</p>
                            <ul>
                                <li>
                                    <svg width="24" height="25" viewBox="0 0 24 25" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M16.34 2.68664C19.73 2.68664 22 5.06664 22 8.60664V16.7776C22 20.3066 19.73 22.6866 16.34 22.6866H7.67C4.28 22.6866 2 20.3066 2 16.7776V8.60664C2 5.06664 4.28 2.68664 7.67 2.68664H16.34ZM16.18 9.68664C15.84 9.34664 15.28 9.34664 14.94 9.68664L10.81 13.8166L9.06 12.0666C8.72 11.7266 8.16 11.7266 7.82 12.0666C7.48 12.4066 7.48 12.9566 7.82 13.3066L10.2 15.6766C10.37 15.8466 10.59 15.9266 10.81 15.9266C11.04 15.9266 11.26 15.8466 11.43 15.6766L16.18 10.9266C16.52 10.5866 16.52 10.0366 16.18 9.68664Z"
                                            fill="#00BAFF" />
                                    </svg>
                                    <p>Продиагностируете свою самооценку</p>
                                </li>
                                <li>
                                    <svg width="24" height="25" viewBox="0 0 24 25" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M16.34 2.68664C19.73 2.68664 22 5.06664 22 8.60664V16.7776C22 20.3066 19.73 22.6866 16.34 22.6866H7.67C4.28 22.6866 2 20.3066 2 16.7776V8.60664C2 5.06664 4.28 2.68664 7.67 2.68664H16.34ZM16.18 9.68664C15.84 9.34664 15.28 9.34664 14.94 9.68664L10.81 13.8166L9.06 12.0666C8.72 11.7266 8.16 11.7266 7.82 12.0666C7.48 12.4066 7.48 12.9566 7.82 13.3066L10.2 15.6766C10.37 15.8466 10.59 15.9266 10.81 15.9266C11.04 15.9266 11.26 15.8466 11.43 15.6766L16.18 10.9266C16.52 10.5866 16.52 10.0366 16.18 9.68664Z"
                                            fill="#00BAFF" />
                                    </svg>
                                    <p>Прекратите себя постоянно критиковать</p>
                                </li>
                                <li>
                                    <svg width="24" height="25" viewBox="0 0 24 25" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M16.34 2.68664C19.73 2.68664 22 5.06664 22 8.60664V16.7776C22 20.3066 19.73 22.6866 16.34 22.6866H7.67C4.28 22.6866 2 20.3066 2 16.7776V8.60664C2 5.06664 4.28 2.68664 7.67 2.68664H16.34ZM16.18 9.68664C15.84 9.34664 15.28 9.34664 14.94 9.68664L10.81 13.8166L9.06 12.0666C8.72 11.7266 8.16 11.7266 7.82 12.0666C7.48 12.4066 7.48 12.9566 7.82 13.3066L10.2 15.6766C10.37 15.8466 10.59 15.9266 10.81 15.9266C11.04 15.9266 11.26 15.8466 11.43 15.6766L16.18 10.9266C16.52 10.5866 16.52 10.0366 16.18 9.68664Z"
                                            fill="#00BAFF" />
                                    </svg>
                                    <p>Начнете конструктивно работать с отказами</p>
                                </li>
                                <li>
                                    <svg width="24" height="25" viewBox="0 0 24 25" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M16.34 2.68664C19.73 2.68664 22 5.06664 22 8.60664V16.7776C22 20.3066 19.73 22.6866 16.34 22.6866H7.67C4.28 22.6866 2 20.3066 2 16.7776V8.60664C2 5.06664 4.28 2.68664 7.67 2.68664H16.34ZM16.18 9.68664C15.84 9.34664 15.28 9.34664 14.94 9.68664L10.81 13.8166L9.06 12.0666C8.72 11.7266 8.16 11.7266 7.82 12.0666C7.48 12.4066 7.48 12.9566 7.82 13.3066L10.2 15.6766C10.37 15.8466 10.59 15.9266 10.81 15.9266C11.04 15.9266 11.26 15.8466 11.43 15.6766L16.18 10.9266C16.52 10.5866 16.52 10.0366 16.18 9.68664Z"
                                            fill="#00BAFF" />
                                    </svg>
                                    <p>Перестанете сравнивать себя с другими</p>
                                </li>
                                <li>
                                    <svg width="24" height="25" viewBox="0 0 24 25" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M16.34 2.68664C19.73 2.68664 22 5.06664 22 8.60664V16.7776C22 20.3066 19.73 22.6866 16.34 22.6866H7.67C4.28 22.6866 2 20.3066 2 16.7776V8.60664C2 5.06664 4.28 2.68664 7.67 2.68664H16.34ZM16.18 9.68664C15.84 9.34664 15.28 9.34664 14.94 9.68664L10.81 13.8166L9.06 12.0666C8.72 11.7266 8.16 11.7266 7.82 12.0666C7.48 12.4066 7.48 12.9566 7.82 13.3066L10.2 15.6766C10.37 15.8466 10.59 15.9266 10.81 15.9266C11.04 15.9266 11.26 15.8466 11.43 15.6766L16.18 10.9266C16.52 10.5866 16.52 10.0366 16.18 9.68664Z"
                                            fill="#00BAFF" />
                                    </svg>
                                    <p>Сможете сохранять здоровую самооценку, несмотря на внешние потрясения</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club21-banner24-rotate">
                            <p class="club21-banner24-label">Только с 30 мая по 14 июля</p>
                            <p>В дополнение к основной программе <span>Анна проведет +3 онлайн-практикума и ответит на ваши
                                вопросы в закрытой группе</span></p>
                        </div>
                        <div class="club21-banner24-img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1715345110233.png" alt="">
                            <p><span>Автор программы</span> —<br> эксперт по самооценке<br> Анна Бабич</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-club21-banner24-tablet', {
        label: 'Баннер 2.4 (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-club21-banner24-tablet">
            <div>
                <div class="club21-banner24-top">
                    <p class="club21-banner24-top-label1">Новая программа в Careerum</p>
                    <p class="club21-banner24-top-label2">От автора бестселлера «Внутренняя опора»</p>
                </div>
                <div class="club21-banner24-bottom">
                    <div class="club21-banner24-left">
                        <h2>Самооценка & деньги: <span>не мешайте себе зарабатывать</span></h2>
                        <p>Сформируйте карьерную уверенность в себе, чтобы: <span>больше зарабатывать,<br> расти
                                в должности,
                                открывать новые карьерные перспективы.</span> </p>
                        <div class="club21-banner24-img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1715345516473.png" alt="">
                            <p><span>Автор программы</span><br> — эксперт<br> по самооценке<br> Анна Бабич</p>
                        </div>
                        <a href="#buy" class="btn-color-main-dark-orange">Участвовать</a>
                    </div>
                    <div class="club21-banner24-right">
                        <div class="club21-banner24-list">
                            <p class="club21-banner24-label">Во время обучения:</p>
                            <ul>
                                <li>
                                    <svg width="24" height="25" viewBox="0 0 24 25" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M16.34 2.68664C19.73 2.68664 22 5.06664 22 8.60664V16.7776C22 20.3066 19.73 22.6866 16.34 22.6866H7.67C4.28 22.6866 2 20.3066 2 16.7776V8.60664C2 5.06664 4.28 2.68664 7.67 2.68664H16.34ZM16.18 9.68664C15.84 9.34664 15.28 9.34664 14.94 9.68664L10.81 13.8166L9.06 12.0666C8.72 11.7266 8.16 11.7266 7.82 12.0666C7.48 12.4066 7.48 12.9566 7.82 13.3066L10.2 15.6766C10.37 15.8466 10.59 15.9266 10.81 15.9266C11.04 15.9266 11.26 15.8466 11.43 15.6766L16.18 10.9266C16.52 10.5866 16.52 10.0366 16.18 9.68664Z"
                                            fill="#00BAFF" />
                                    </svg>
                                    <p>Продиагностируете свою самооценку</p>
                                </li>
                                <li>
                                    <svg width="24" height="25" viewBox="0 0 24 25" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M16.34 2.68664C19.73 2.68664 22 5.06664 22 8.60664V16.7776C22 20.3066 19.73 22.6866 16.34 22.6866H7.67C4.28 22.6866 2 20.3066 2 16.7776V8.60664C2 5.06664 4.28 2.68664 7.67 2.68664H16.34ZM16.18 9.68664C15.84 9.34664 15.28 9.34664 14.94 9.68664L10.81 13.8166L9.06 12.0666C8.72 11.7266 8.16 11.7266 7.82 12.0666C7.48 12.4066 7.48 12.9566 7.82 13.3066L10.2 15.6766C10.37 15.8466 10.59 15.9266 10.81 15.9266C11.04 15.9266 11.26 15.8466 11.43 15.6766L16.18 10.9266C16.52 10.5866 16.52 10.0366 16.18 9.68664Z"
                                            fill="#00BAFF" />
                                    </svg>
                                    <p>Прекратите себя постоянно критиковать</p>
                                </li>
                                <li>
                                    <svg width="24" height="25" viewBox="0 0 24 25" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M16.34 2.68664C19.73 2.68664 22 5.06664 22 8.60664V16.7776C22 20.3066 19.73 22.6866 16.34 22.6866H7.67C4.28 22.6866 2 20.3066 2 16.7776V8.60664C2 5.06664 4.28 2.68664 7.67 2.68664H16.34ZM16.18 9.68664C15.84 9.34664 15.28 9.34664 14.94 9.68664L10.81 13.8166L9.06 12.0666C8.72 11.7266 8.16 11.7266 7.82 12.0666C7.48 12.4066 7.48 12.9566 7.82 13.3066L10.2 15.6766C10.37 15.8466 10.59 15.9266 10.81 15.9266C11.04 15.9266 11.26 15.8466 11.43 15.6766L16.18 10.9266C16.52 10.5866 16.52 10.0366 16.18 9.68664Z"
                                            fill="#00BAFF" />
                                    </svg>
                                    <p>Начнете конструктивно работать с отказами</p>
                                </li>
                                <li>
                                    <svg width="24" height="25" viewBox="0 0 24 25" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M16.34 2.68664C19.73 2.68664 22 5.06664 22 8.60664V16.7776C22 20.3066 19.73 22.6866 16.34 22.6866H7.67C4.28 22.6866 2 20.3066 2 16.7776V8.60664C2 5.06664 4.28 2.68664 7.67 2.68664H16.34ZM16.18 9.68664C15.84 9.34664 15.28 9.34664 14.94 9.68664L10.81 13.8166L9.06 12.0666C8.72 11.7266 8.16 11.7266 7.82 12.0666C7.48 12.4066 7.48 12.9566 7.82 13.3066L10.2 15.6766C10.37 15.8466 10.59 15.9266 10.81 15.9266C11.04 15.9266 11.26 15.8466 11.43 15.6766L16.18 10.9266C16.52 10.5866 16.52 10.0366 16.18 9.68664Z"
                                            fill="#00BAFF" />
                                    </svg>
                                    <p>Перестанете сравнивать себя с другими</p>
                                </li>
                                <li>
                                    <svg width="24" height="25" viewBox="0 0 24 25" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M16.34 2.68664C19.73 2.68664 22 5.06664 22 8.60664V16.7776C22 20.3066 19.73 22.6866 16.34 22.6866H7.67C4.28 22.6866 2 20.3066 2 16.7776V8.60664C2 5.06664 4.28 2.68664 7.67 2.68664H16.34ZM16.18 9.68664C15.84 9.34664 15.28 9.34664 14.94 9.68664L10.81 13.8166L9.06 12.0666C8.72 11.7266 8.16 11.7266 7.82 12.0666C7.48 12.4066 7.48 12.9566 7.82 13.3066L10.2 15.6766C10.37 15.8466 10.59 15.9266 10.81 15.9266C11.04 15.9266 11.26 15.8466 11.43 15.6766L16.18 10.9266C16.52 10.5866 16.52 10.0366 16.18 9.68664Z"
                                            fill="#00BAFF" />
                                    </svg>
                                    <p>Сможете сохранять здоровую самооценку, несмотря <br>на внешние потрясения</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club21-banner24-rotate">
                            <p class="club21-banner24-label">Только с 30 мая по 14 июля</p>
                            <p>В дополнение к основной программе <span>Анна проведет +3 онлайн-практикума и ответит на ваши
                                    вопросы в закрытой группе</span></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-club21-banner24-mobile', {
        label: 'Баннер 2.4 (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-club21-banner24-mobile">
            <div>
                <div class="club21-banner24-top">
                    <p class="club21-banner24-top-label1">Новая программа в Careerum</p>
                    <p class="club21-banner24-top-label2">От автора бестселлера</p>
                    <p class="club21-banner24-top-label3">«Внутренняя опора»</p>
                </div>
                <div class="club21-banner24-bottom">
                    <div class="club21-banner24-left">
                        <h2>Самооценка <br>& деньги: <span>не мешайте себе зарабатывать</span></h2>
                        <p>Сформируйте карьерную уверенность в себе, чтобы: <span>больше зарабатывать, расти в должности, открывать новые карьерные перспективы.</span> </p>
                    </div>
                    <div class="club21-banner24-right">
                        <div class="club21-banner24-list">
                            <p class="club21-banner24-label">Во время обучения:</p>
                            <ul>
                                <li>
                                    <svg width="24" height="25" viewBox="0 0 24 25" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M16.34 2.68664C19.73 2.68664 22 5.06664 22 8.60664V16.7776C22 20.3066 19.73 22.6866 16.34 22.6866H7.67C4.28 22.6866 2 20.3066 2 16.7776V8.60664C2 5.06664 4.28 2.68664 7.67 2.68664H16.34ZM16.18 9.68664C15.84 9.34664 15.28 9.34664 14.94 9.68664L10.81 13.8166L9.06 12.0666C8.72 11.7266 8.16 11.7266 7.82 12.0666C7.48 12.4066 7.48 12.9566 7.82 13.3066L10.2 15.6766C10.37 15.8466 10.59 15.9266 10.81 15.9266C11.04 15.9266 11.26 15.8466 11.43 15.6766L16.18 10.9266C16.52 10.5866 16.52 10.0366 16.18 9.68664Z"
                                            fill="#00BAFF" />
                                    </svg>
                                    <p>Продиагностируете свою самооценку</p>
                                </li>
                                <li>
                                    <svg width="24" height="25" viewBox="0 0 24 25" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M16.34 2.68664C19.73 2.68664 22 5.06664 22 8.60664V16.7776C22 20.3066 19.73 22.6866 16.34 22.6866H7.67C4.28 22.6866 2 20.3066 2 16.7776V8.60664C2 5.06664 4.28 2.68664 7.67 2.68664H16.34ZM16.18 9.68664C15.84 9.34664 15.28 9.34664 14.94 9.68664L10.81 13.8166L9.06 12.0666C8.72 11.7266 8.16 11.7266 7.82 12.0666C7.48 12.4066 7.48 12.9566 7.82 13.3066L10.2 15.6766C10.37 15.8466 10.59 15.9266 10.81 15.9266C11.04 15.9266 11.26 15.8466 11.43 15.6766L16.18 10.9266C16.52 10.5866 16.52 10.0366 16.18 9.68664Z"
                                            fill="#00BAFF" />
                                    </svg>
                                    <p>Прекратите себя постоянно критиковать</p>
                                </li>
                                <li>
                                    <svg width="24" height="25" viewBox="0 0 24 25" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M16.34 2.68664C19.73 2.68664 22 5.06664 22 8.60664V16.7776C22 20.3066 19.73 22.6866 16.34 22.6866H7.67C4.28 22.6866 2 20.3066 2 16.7776V8.60664C2 5.06664 4.28 2.68664 7.67 2.68664H16.34ZM16.18 9.68664C15.84 9.34664 15.28 9.34664 14.94 9.68664L10.81 13.8166L9.06 12.0666C8.72 11.7266 8.16 11.7266 7.82 12.0666C7.48 12.4066 7.48 12.9566 7.82 13.3066L10.2 15.6766C10.37 15.8466 10.59 15.9266 10.81 15.9266C11.04 15.9266 11.26 15.8466 11.43 15.6766L16.18 10.9266C16.52 10.5866 16.52 10.0366 16.18 9.68664Z"
                                            fill="#00BAFF" />
                                    </svg>
                                    <p>Начнете конструктивно работать с отказами</p>
                                </li>
                                <li>
                                    <svg width="24" height="25" viewBox="0 0 24 25" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M16.34 2.68664C19.73 2.68664 22 5.06664 22 8.60664V16.7776C22 20.3066 19.73 22.6866 16.34 22.6866H7.67C4.28 22.6866 2 20.3066 2 16.7776V8.60664C2 5.06664 4.28 2.68664 7.67 2.68664H16.34ZM16.18 9.68664C15.84 9.34664 15.28 9.34664 14.94 9.68664L10.81 13.8166L9.06 12.0666C8.72 11.7266 8.16 11.7266 7.82 12.0666C7.48 12.4066 7.48 12.9566 7.82 13.3066L10.2 15.6766C10.37 15.8466 10.59 15.9266 10.81 15.9266C11.04 15.9266 11.26 15.8466 11.43 15.6766L16.18 10.9266C16.52 10.5866 16.52 10.0366 16.18 9.68664Z"
                                            fill="#00BAFF" />
                                    </svg>
                                    <p>Перестанете сравнивать себя с другими</p>
                                </li>
                                <li>
                                    <svg width="24" height="25" viewBox="0 0 24 25" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M16.34 2.68664C19.73 2.68664 22 5.06664 22 8.60664V16.7776C22 20.3066 19.73 22.6866 16.34 22.6866H7.67C4.28 22.6866 2 20.3066 2 16.7776V8.60664C2 5.06664 4.28 2.68664 7.67 2.68664H16.34ZM16.18 9.68664C15.84 9.34664 15.28 9.34664 14.94 9.68664L10.81 13.8166L9.06 12.0666C8.72 11.7266 8.16 11.7266 7.82 12.0666C7.48 12.4066 7.48 12.9566 7.82 13.3066L10.2 15.6766C10.37 15.8466 10.59 15.9266 10.81 15.9266C11.04 15.9266 11.26 15.8466 11.43 15.6766L16.18 10.9266C16.52 10.5866 16.52 10.0366 16.18 9.68664Z"
                                            fill="#00BAFF" />
                                    </svg>
                                    <p>Сможете сохранять здоровую самооценку, несмотря <br>на внешние потрясения</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club21-banner24-rotate">
                            <p class="club21-banner24-label">Только с 30 мая по 14 июля</p>
                            <p>В дополнение к основной программе <span>Анна проведет +3 онлайн-практикума и ответит на ваши
                                    вопросы в закрытой группе</span></p>
                        </div>
                        <div class="club21-banner24-img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1715345516473.png" alt="">
                            <p><span>Автор программы</span><br> — эксперт<br> по самооценке<br> Анна Бабич</p>
                        </div>
                        <a href="#buy" class="btn-color-main-dark-orange">Участвовать</a>
                    </div>
                </div>
            </div>
        </div>`
	});
    
    blockManager.add('careerum-case2-main', {
        label: 'Кейсы первый',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-case2-main">
            <div>
                <div class="careerum-case2-main-left">
                    <p class="careerum-case2-main-date">февраль, 2024</p>
                    <h1>Из стоматологии в IT: как найти первую работу в новой сфере за 3 месяца</h1>
                    <div class="careerum-case2-main-info">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1707302723377.png" alt="">
                        <a href="#">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1707302641679.svg" alt="">
                        </a>
                        <p>Арина Кунашко, frontend-разработчик, DIGINETICA, Испания</p>
                    </div>
                    <svg width="547" height="401" viewBox="0 0 547 401" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M479.139 402.793C451.908 407.857 381.375 412.678 350.179 389.489C299.312 351.679 351.702 268.608 376.999 241.081C402.296 213.555 447.043 190.793 485.953 190.793C524.864 190.793 546.297 203.22 546.298 234.375C546.298 264.547 524.503 287.633 496.011 306.452C455.942 332.917 415.507 343.779 365.322 346.478C304.151 349.769 208.208 338.325 205.938 258.753C203.338 167.618 307.938 134.2 350.896 130.751C381.85 128.266 409.709 140.359 408.303 155.431C398.247 219.611 55.6119 176.934 15.8259 93.9349C-23.9601 10.9358 160.81 -7.8939 172.035 27.3639" stroke="#FFC76A" stroke-opacity="0.2" stroke-width="20" stroke-linecap="round" />
                      </svg>
                </div>
                <div class="careerum-case2-main-right">
                    <div>
                        <div>
                            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M15 37.5L17.5 25L7.5 21.25L25 2.5L22.5 15L32.5 18.75L15 37.5Z" stroke="black" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
                              </svg>
                            <p>
                                До Careerum
                            </p>
                        </div>
                        <ul>
                            <li>Желание уйти из стоматологии и стать frontend-разработчиком</li>
                            <li>Отсутствие профильного образования и опыта </li>
                            <li>Неуверенность, что получится добиться цели</li>
                        </ul>
                    </div>
                    <div>
                        <div>
                            <svg width="40" height="41" viewBox="0 0 40 41" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1.25 15.6665L20 5.6665L38.75 15.6665L20 25.6665L1.25 15.6665Z" stroke="black" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M29.375 38.1665V20.6665L20 15.6665" stroke="black" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M34.375 17.9956V26.5269C34.3739 26.7923 34.2861 27.0502 34.125 27.2612C33.0781 28.6675 28.6406 33.7925 20 33.7925C11.3594 33.7925 6.92187 28.6675 5.875 27.2612C5.7139 27.0502 5.62612 26.7923 5.625 26.5269V17.9956" stroke="black" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
                              </svg>
                            <p>В клубе</p>
                        </div>
                        <ul>
                            <li>Поняла, как применить свои таланты и ценности к новой сфере</li>
                            <li>Составила продающее резюме</li>
                            <li>Поверила в свои силы и укрепила профессиональную самооценку</li>
                        </ul>
                    </div>
                    <div>
                        <div>
                            <svg width="40" height="41" viewBox="0 0 40 41" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M20.6877 30.1304L28.5627 35.1304C29.5784 35.771 30.8284 34.8179 30.5315 33.646L28.2502 24.6773C28.1886 24.4287 28.1984 24.1677 28.2785 23.9244C28.3587 23.6812 28.506 23.4655 28.7034 23.3023L35.7659 17.4117C36.6877 16.646 36.219 15.0992 35.0159 15.021L25.7971 14.4273C25.5456 14.4126 25.3038 14.3251 25.1012 14.1752C24.8986 14.0254 24.7441 13.8198 24.6565 13.5835L21.219 4.92728C21.128 4.67713 20.9622 4.46104 20.7442 4.30834C20.5262 4.15564 20.2664 4.07373 20.0002 4.07373C19.7341 4.07373 19.4743 4.15564 19.2563 4.30834C19.0382 4.46104 18.8725 4.67713 18.7815 4.92728L15.344 13.5835C15.2564 13.8198 15.1019 14.0254 14.8993 14.1752C14.6967 14.3251 14.4549 14.4126 14.2034 14.4273L4.98461 15.021C3.78149 15.0992 3.31274 16.646 4.23461 17.4117L11.2971 23.3023C11.4945 23.4655 11.6418 23.6812 11.7219 23.9244C11.8021 24.1677 11.8119 24.4287 11.7502 24.6773L9.64086 32.9898C9.28149 34.396 10.7815 35.5367 11.9846 34.771L19.3127 30.1304C19.5182 29.9997 19.7567 29.9303 20.0002 29.9303C20.2438 29.9303 20.4822 29.9997 20.6877 30.1304V30.1304Z" stroke="black" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
                              </svg>
                            <p>Результат</p>
                        </div>
                        <ul>
                            <li>Получила оффер в новой сфере</li>
                            <li>Смогла реализоваться в IT</li>
                            <li>Почувствовала стабильность и уверенность в себе</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-case2-main-tablet', {
        label: 'Кейсы первый (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-case2-main-tablet">
            <div>
                <div class="careerum-case2-main-left">
                    <p class="careerum-case2-main-date">февраль, 2024</p>
                    <h2>Из стоматологии<br> в IT: как найти первую работу<br> в новой сфере за <br>3 месяца</h2>
                    <div class="careerum-case2-main-info">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1707310049064.png" alt="">
                        <a href="#">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1707309963081.svg" alt="">
                        </a>
                        <p>Арина Кунашко, frontend-разработчик, DIGINETICA, Испания</p>
                    </div>
                    <svg width="370" height="307" viewBox="0 0 370 307" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M406.139 292.793C378.909 297.857 308.376 302.678 277.179 279.489C226.313 241.679 278.703 158.608 303.999 131.081C329.296 103.555 374.044 80.7931 412.954 80.7931C451.864 80.7931 473.298 93.2202 473.298 124.375C473.298 154.547 451.504 177.633 423.011 196.452C382.943 222.917 342.508 233.779 292.323 236.478C231.151 239.769 135.209 228.325 132.939 148.753C130.339 57.6176 234.939 24.2002 277.896 20.751C308.85 18.2656 336.709 30.3587 335.303 45.4308C325.247 109.611 -17.3876 66.934 -57.1736 -16.0651C-96.9596 -99.0642 87.8109 -117.894 99.0359 -82.6361" stroke="#FFC76A" stroke-opacity="0.2" stroke-width="20" stroke-linecap="round" />
                      </svg>
                </div>
                <div class="careerum-case2-main-right">
                    <div>
                        <div>
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M7.5 18.75L8.75 12.5L3.75 10.625L12.5 1.25L11.25 7.5L16.25 9.375L7.5 18.75Z" stroke="black" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
                              </svg>
                            <p>
                                До Careerum
                            </p>
                        </div>
                        <ul>
                            <li>Желание уйти из стоматологии и стать frontend-разработчиком</li>
                            <li>Отсутствие профильного образования и опыта </li>
                            <li>Неуверенность, что получится добиться цели</li>
                        </ul>
                    </div>
                    <div>
                        <div>
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M0.625 7.5L10 2.5L19.375 7.5L10 12.5L0.625 7.5Z" stroke="black" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M14.6875 18.75V10L10 7.5" stroke="black" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M17.1875 8.66455V12.9302C17.1869 13.0629 17.143 13.1918 17.0625 13.2974C16.5391 14.0005 14.3203 16.563 10 16.563C5.67969 16.563 3.46094 14.0005 2.9375 13.2974C2.85695 13.1918 2.81306 13.0629 2.8125 12.9302V8.66455" stroke="black" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
                              </svg>
                            <p>В клубе</p>
                        </div>
                        <ul>
                            <li>Поняла, как применить свои таланты и ценности к новой сфере</li>
                            <li>Составила продающее резюме</li>
                            <li>Поверила в свои силы и укрепила профессиональную самооценку</li>
                        </ul>
                    </div>
                    <div>
                        <div>
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M10.3434 14.8985L14.2809 17.3985C14.7887 17.7188 15.4137 17.2422 15.2653 16.6563L14.1246 12.1719C14.0938 12.0476 14.0987 11.9171 14.1388 11.7955C14.1789 11.6738 14.2525 11.566 14.3512 11.4844L17.8824 8.53908C18.3434 8.15627 18.109 7.38283 17.5074 7.34377L12.8981 7.04689C12.7723 7.03958 12.6514 6.99578 12.5501 6.92086C12.4488 6.84594 12.3716 6.74314 12.3278 6.62502L10.609 2.29689C10.5635 2.17182 10.4806 2.06377 10.3716 1.98742C10.2626 1.91107 10.1327 1.87012 9.99963 1.87012C9.86654 1.87012 9.73667 1.91107 9.62765 1.98742C9.51863 2.06377 9.43575 2.17182 9.39025 2.29689L7.6715 6.62502C7.6277 6.74314 7.55044 6.84594 7.44915 6.92086C7.34787 6.99578 7.22696 7.03958 7.10119 7.04689L2.49182 7.34377C1.89026 7.38283 1.65588 8.15627 2.11682 8.53908L5.64807 11.4844C5.74677 11.566 5.8204 11.6738 5.86048 11.7955C5.90057 11.9171 5.90547 12.0476 5.87463 12.1719L4.81994 16.3281C4.64026 17.0313 5.39026 17.6016 5.99182 17.2188L9.65588 14.8985C9.75863 14.8331 9.87787 14.7984 9.99963 14.7984C10.1214 14.7984 10.2406 14.8331 10.3434 14.8985V14.8985Z" stroke="black" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
                              </svg>
                            <p>Результат</p>
                        </div>
                        <ul>
                            <li>Получила оффер в новой сфере</li>
                            <li>Смогла реализоваться в IT</li>
                            <li>Почувствовала стабильность и уверенность в себе</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-case2-main-mobile', {
        label: 'Кейсы первый (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-case2-main-mobile">
            <div>
                <div class="careerum-case2-main-left">
                    <p class="careerum-case2-main-date">февраль, 2024</p>
                    <h2>Из стоматологии в IT: как найти первую работу в новой сфере за 3 месяца</h2>
                    <div class="careerum-case2-main-info">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1707310049064.png" alt="">
                        <a href="#">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1707309963081.svg" alt="">
                        </a>
                        <p>Арина Кунашко, frontend-разработчик, DIGINETICA, Испания</p>
                    </div>
                    <svg width="300" height="303" viewBox="0 0 300 303" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M389.139 366.793C361.909 371.857 291.376 376.678 260.179 353.489C209.313 315.679 261.703 232.608 286.999 205.081C312.296 177.555 357.044 154.793 395.954 154.793C434.864 154.793 456.298 167.22 456.298 198.375C456.298 228.547 434.504 251.633 406.011 270.452C365.943 296.917 325.508 307.779 275.323 310.478C214.151 313.769 118.209 302.325 115.939 222.753C113.339 131.618 217.939 98.2002 260.896 94.751C291.85 92.2656 319.709 104.359 318.303 119.431C308.247 183.611 -34.3876 140.934 -74.1736 57.9349C-113.96 -25.0642 70.8109 -43.8939 82.0359 -8.63613" stroke="#FFC76A" stroke-opacity="0.2" stroke-width="20" stroke-linecap="round" />
                      </svg>
                </div>
                <div class="careerum-case2-main-right">
                    <div>
                        <div>
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M7.5 18.75L8.75 12.5L3.75 10.625L12.5 1.25L11.25 7.5L16.25 9.375L7.5 18.75Z" stroke="black" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
                              </svg>
                            <p>
                                До Careerum
                            </p>
                        </div>
                        <ul>
                            <li>Желание уйти из стоматологии и стать frontend-разработчиком</li>
                            <li>Отсутствие профильного образования и опыта </li>
                            <li>Неуверенность, что получится добиться цели</li>
                        </ul>
                    </div>
                    <div>
                        <div>
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M0.625 7.5L10 2.5L19.375 7.5L10 12.5L0.625 7.5Z" stroke="black" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M14.6875 18.75V10L10 7.5" stroke="black" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M17.1875 8.66455V12.9302C17.1869 13.0629 17.143 13.1918 17.0625 13.2974C16.5391 14.0005 14.3203 16.563 10 16.563C5.67969 16.563 3.46094 14.0005 2.9375 13.2974C2.85695 13.1918 2.81306 13.0629 2.8125 12.9302V8.66455" stroke="black" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
                              </svg>
                            <p>В клубе</p>
                        </div>
                        <ul>
                            <li>Поняла, как применить свои таланты и ценности к новой сфере</li>
                            <li>Составила продающее резюме</li>
                            <li>Поверила в свои силы и укрепила профессиональную самооценку</li>
                        </ul>
                    </div>
                    <div>
                        <div>
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M10.3434 14.8985L14.2809 17.3985C14.7887 17.7188 15.4137 17.2422 15.2653 16.6563L14.1246 12.1719C14.0938 12.0476 14.0987 11.9171 14.1388 11.7955C14.1789 11.6738 14.2525 11.566 14.3512 11.4844L17.8824 8.53908C18.3434 8.15627 18.109 7.38283 17.5074 7.34377L12.8981 7.04689C12.7723 7.03958 12.6514 6.99578 12.5501 6.92086C12.4488 6.84594 12.3716 6.74314 12.3278 6.62502L10.609 2.29689C10.5635 2.17182 10.4806 2.06377 10.3716 1.98742C10.2626 1.91107 10.1327 1.87012 9.99963 1.87012C9.86654 1.87012 9.73667 1.91107 9.62765 1.98742C9.51863 2.06377 9.43575 2.17182 9.39025 2.29689L7.6715 6.62502C7.6277 6.74314 7.55044 6.84594 7.44915 6.92086C7.34787 6.99578 7.22696 7.03958 7.10119 7.04689L2.49182 7.34377C1.89026 7.38283 1.65588 8.15627 2.11682 8.53908L5.64807 11.4844C5.74677 11.566 5.8204 11.6738 5.86048 11.7955C5.90057 11.9171 5.90547 12.0476 5.87463 12.1719L4.81994 16.3281C4.64026 17.0313 5.39026 17.6016 5.99182 17.2188L9.65588 14.8985C9.75863 14.8331 9.87787 14.7984 9.99963 14.7984C10.1214 14.7984 10.2406 14.8331 10.3434 14.8985V14.8985Z" stroke="black" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
                              </svg>
                            <p>Результат</p>
                        </div>
                        <ul>
                            <li>Получила оффер в новой сфере</li>
                            <li>Смогла реализоваться в IT</li>
                            <li>Почувствовала стабильность и уверенность в себе</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>`
	});
    
    blockManager.add('careerum-case2-content-block', {
        label: 'Кейсы контент',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-case2-content-block">
            <div>
                <div class="careerum-case2-content-wrapper">
                    <div class="careerum-case2-content-label">
                        <p>До Careerum</p>
                    </div>
                    <div class="careerum-case2-content-header">
                        <p>Решение менять сферу и зайти в IT с нуля</p>
                    </div>
                    <div class="careerum-case2-content-text">
                        <p>Арина закончила СПбГУ по специальности «Стоматология» в 2021 году, тогда же поступила в ординатуру и работала врачом-стоматологом в Санкт-Петербурге.</p>
                        <p>Ей очень нравилась эта профессия, работа приносила удовольствие. Но после 24 февраля 2022 года всё изменилось. Арина решила, что для нее важно не привязываться к месту и работать удаленно. Вместе с мужем они задумались о переезде в европейскую страну.</p>
                        <p>Как выяснила Арина, чтобы подтвердить диплом врача-стоматолога в Европе, нужно очень много времени и ресурсов. Так в голову пришло решение поменять сферу деятельности. Арина в то время много общалась со знакомыми программистами, которые предложили ей попробовать себя во frontend-разработке. Ее заинтересовало и она с головой погрузилась в теорию. А в июне 2022 года Арина переехала с мужем в Испанию.</p>
                        <p>О Careerum.Club она узнала в декабре 2022 года благодаря сестре. Та видела, что Арина сталкивается с разными сложностями: неуверенность в правильности выбора, трудности в обучении программированию. К тому же Арина очень скучала по работе врачом-стоматологом. Сестра решила подарить ей сертификат в клуб на три месяца, чтобы помочь.</p>
                        <p>Арина хотела найти свою первую работу во frontend-разработке. Это была ее главная цель. </p>
                    </div>
                    <div class="careerum-case2-content-quote">
                        <p>«Мне казалось, что я, кандидат без профильного образования и опыта работы, не смогу получить оффер из-за большой конкуренции. Боялась кардинально менять сферу» </p>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1707304283713.png" alt="">
                    </div>
                    <div class="careerum-case2-content-text">
                        <p>Когда она начала проходить обучение в клубе, появились новые запросы: как определить правильность своего выбора, стоит ли возвращаться в стоматологию, как справиться с неуверенностью и сомнениями. Она хотела добиться всего и сразу за три месяца, пока активирован сертификат.</p>
                    </div>
                    <div class="careerum-case2-content-form">
                        <div>
                            <p class="careerum-case2-content-form-header">Пора действовать!</p>
                            <p class="careerum-case2-content-form-text">Если вы хотите высоких результатов в карьере, оставьте заявку на обучение. Мы свяжемся с вами и расскажем, чем Careerum будет полезен именно вам</p>
                            <svg width="386" height="193" viewBox="0 0 386 193" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M124.42 34.6595C187.431 -6.18332 378.308 -11.6038 383.52 36.9789C388.06 79.2927 199.958 117.705 143.47 129.314C124.896 133.131 6.53244 156.475 2.60362 119.857C0.295876 98.3476 52.8277 81.1784 118.484 74.134C159.581 69.7246 230.077 70.0872 233.271 114.131C235.328 142.505 154.335 170.72 95.8087 174.85C76.7902 176.193 62.4992 171.32 61.6553 163.455C60.7534 155.049 76.9722 151.508 87.8186 150.344C98.665 149.181 185.907 143.783 196 185.203C198.895 197.08 188.787 204.506 178.646 200.565" stroke="#FFC76A" stroke-width="4" stroke-linecap="round" />
                              </svg>
                        </div>
                        <div>
                            <div class="careerum-registration-form">
                                <form class="deva-form getcourse-email-signup" name="devaRegistrationForm">
                                    <div class="intens-form-firstname">
                                        <input type="text" name="firstname" id="" required placeholder="Имя">
                                    </div>
                                    <div class="intens-form-lastname">
                                        <input type="text" name="lastname" id="" required placeholder="Фамилия">
                                    </div>
                                    <div class="intens-form-email">
                                        <input type="email" name="email" id="" required placeholder="Почта">
                                    </div>
                                    <div class="intens-form-phone">
                                        <input id="" required>
                                    </div>
                                    <div class="intens-form-agree">
                                        <label>
                                            <input type="checkbox" name="agree">
                                            <div>
                                                <svg width="8" height="8" viewBox="0 0 8 8" fill="none"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        d="M1 2.84615L3.14168 6.70118C3.21595 6.83487 3.40669 6.83912 3.48685 6.70887L7 1"
                                                        stroke="black" stroke-width="1.5" stroke-linecap="round" />
                                                </svg>
                                            </div>
                                        </label>
                                        <p>Я даю согласие на обработку своих персональных данных в соответствии с <a href="/ru-ru/legal/privacy">Политикой конфиденциальности</a></p>
                                    </div>
                                    <a href="#" disabled class="submit-btn">Оставить заявку</a>
                                    <input type="hidden" name="tel">
                                </form>
                            </div>
                        </div>
                    </div>
                    <div class="careerum-case2-content-label">
                        <p>Во время обучения</p>
                    </div>
                    <div class="careerum-case2-content-header">
                        <p>Определила свои «хочу» и «могу», проработала резюме</p>
                    </div>
                    <div class="careerum-case2-content-text">
                        <p>Благодаря программе «Real Me: как найти себя в работе и жизни» Арина осознала, что профессия frontend-разработчика ей подходит по талантам и ценностям. Она поняла, что работе важно чувствовать свое «авторство», видеть результат работы сразу, без долгого ожидания, а еще развивать проект в команде, а не в одиночку. Эти ценности она одинаково могла реализовывать и в роли врача-стоматолога, и в роли frontend-разработчика.</p>
                        <p>После блоков «Хочу» и «Могу» Арина пришла к инсайту: нужно применять полученные знания на практике, чтобы не сомневаться в том, что эта работа ей подходит.</p>
                        <p>Также Арина проработала многие свои страхи и сомнения, которые по большей части были навязаны извне.</p>
                    </div>
                    <div class="careerum-case2-content-quote-line">
                        <div>
                            <p>«У меня возникало желание вернуться в стоматологию только потому, что я не представляла себя в другой роли. Мне много говорили, что я прирожденный стоматолог и это мое призвание. Внушали, что в IT у меня ничего не получится и я ничего не добьюсь» </p>
                        </div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1707304283713.png" alt="">
                    </div>
                    <div class="careerum-case2-content-text">
                        <p>Арина знала, что у нее есть талант к работе с детьми: ей легко находить с ними общий язык. При этом ей всегда было интересно попробовать себя в преподавании. Поэтому, пока искала вакансии, она решила устроиться преподавателем по программированию для школьников.</p>
                        <p>Знания, которые ранее доставались с большим трудом, сильно помогали в работе. Преподавание и даже поверхностное погружение в сферу помогло ощутить себя реализованной и нужной. Арина «окрылилась» этим чувством. Теперь даже бесконечная череда отказов по резюме перестала вгонять в тоску, а всё потому что Арина больше не чувствовала бесполезность своего труда.</p>
                        <p>После того, как Арина определила свои «хочу» и «могу», наступило время для «надо». Ей нужно было за короткий срок успеть овладеть всеми инструментами поиска вакансий и найти применение своим навыкам на рынке. Программа «Звездный кандидат» с этим помогла: Арина построила стратегию поиска работы, научилась составлять продающее резюме и правильно преподносить себя на интервью.</p>
                        <p>Раньше у Арины было ощущение, что найти работу в разработке невозможно, ведь «таких людей много и мы никому не нужны». Чтобы поверить в себя и свои возможности, Арина прошла программу «Самооценка 2.0». Это помогло понять, что даже без опыта и профильного образования у нее всё получится. Арина осознала: не нужно занижать свои результаты. То, что она изучила и сделала, заслуживает внимания. Этого достаточно, чтобы уверенно искать работу и добиться цели.</p>
                        <p>На нетворкинговой платформе Арина обращалась к боту Сoffee Вuddy, чтобы тот нашел ей собеседников.</p>
                    </div>
                    <div class="careerum-case2-content-quote">
                        <p>«Я познакомилась с интересными людьми, которые оказались в похожей ситуации — меняли профессию. Это помогло обрести ощущение, что я не одна»</p>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1707304283713.png" alt="">
                    </div>
                    <div class="careerum-case2-content-text">
                        <p>Она много работала с коучем Еленой Эльзенбах, благодаря которой научилась выявлять результат своей работы. С помощью наводящих вопросов Арине было легче определить собственные чувства и эмоции, а также подводить итоги любых своих действий. Коуч помогала ставить цели и прокладывать путь к их достижению, поддерживала и подбадривала на каждом шагу. </p>
                        <p>Вместе с CV-экспертом Софи Бессон Арина прорабатывала свое резюме. До рекомендаций Софи было около 160 откликов и ни одного приглашения на собеседование. Теперь рекрутеры стали проявлять активное внимание кандидатуре Арины: в среднем из 30 откликов в неделю приходило по одному приглашению. </p>
                        <p>Благодаря работе над CV получилось выгодно презентовать себя перед работодателями. Поэтому уже через две недели, после второго пройденного интервью Арина получила долгожданный оффер от российской компании DIGINETICA, который подошел ей по всем условиям.</p>
                    </div>
                    <div class="careerum-case2-content-img">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1707304626803.png" alt="">
                        <p>Подпись к фото</p>
                    </div>
                    <div class="careerum-case2-content-label">
                        <p>Достигнутый результат</p>
                    </div>
                    <div class="careerum-case2-content-header">
                        <p>Получила оффер в новой сфере</p>
                    </div>
                    <div class="careerum-case2-content-text">
                        <p>К концу третьего месяца в Careerum.Club Арина устроилась на удаленную работу в DIGINETICA в роли frontend-разработчика. Также она продолжает преподавать программирование для школьников. </p>
                    </div>
                    <div class="careerum-case2-content-quote">
                        <p>«С каждым днем всё больше ощущаю свою реализованность и радость от выбранного пути. Несмотря на испытательный срок, чувствую облегчение, стабильность и спокойствие»</p>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1707304283713.png" alt="">
                    </div>
                    <div class="careerum-case2-content-text">
                        <p>Арине понравилось в DIGINETICA всё: возможность удаленного формата работы, интересный продукт, корпоративная культура. Для новых сотрудников в компании есть своя обучающая платформа, где можно пройти курсы и влиться в рабочие процессы. Еще Арину вдохновляет ее команда: коллеги отзывчивые и внимательные, они всегда готовы помочь в решении каких-либо задач.</p>
                        <p>Арина уже поставила перед собой новые цели: прокачать навыки и повысить доход. Она планирует вернуться в клуб, чтобы повторно пройти программу «Звездный кандидат» и познакомиться с программой «Карьерная ракета», которая поможет добиться повышения должности. </p>
                        <p>Арина считает, что в ее жизни началась новая глава, которая будет интересной и насыщенной новыми вызовами, с которыми она обязательно справится. </p>
                    </div>
                    <div class="careerum-case2-content-form">
                        <div>
                            <p class="careerum-case2-content-form-header">Хотите достигнуть успеха в карьере?</p>
                            <p class="careerum-case2-content-form-text">Если вы мечтаете строить карьеру по своим правилам, оставьте заявку на обучение. Мы свяжемся с вами и расскажем, чем Careerum будет полезен именно вам</p>
                            <svg width="386" height="193" viewBox="0 0 386 193" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M124.42 34.6595C187.431 -6.18332 378.308 -11.6038 383.52 36.9789C388.06 79.2927 199.958 117.705 143.47 129.314C124.896 133.131 6.53244 156.475 2.60362 119.857C0.295876 98.3476 52.8277 81.1784 118.484 74.134C159.581 69.7246 230.077 70.0872 233.271 114.131C235.328 142.505 154.335 170.72 95.8087 174.85C76.7902 176.193 62.4992 171.32 61.6553 163.455C60.7534 155.049 76.9722 151.508 87.8186 150.344C98.665 149.181 185.907 143.783 196 185.203C198.895 197.08 188.787 204.506 178.646 200.565" stroke="#FFC76A" stroke-width="4" stroke-linecap="round" />
                              </svg>
                        </div>
                        <div>
                            <div class="careerum-registration-form">
                                <form class="deva-form getcourse-email-signup" name="devaRegistrationForm">
                                    <div class="intens-form-firstname">
                                        <input type="text" name="firstname" id="" required placeholder="Имя">
                                    </div>
                                    <div class="intens-form-lastname">
                                        <input type="text" name="lastname" id="" required placeholder="Фамилия">
                                    </div>
                                    <div class="intens-form-email">
                                        <input type="email" name="email" id="" required placeholder="Почта">
                                    </div>
                                    <div class="intens-form-phone">
                                        <input id="" required>
                                    </div>
                                    <div class="intens-form-agree">
                                        <label>
                                            <input type="checkbox" name="agree">
                                            <div>
                                                <svg width="8" height="8" viewBox="0 0 8 8" fill="none"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        d="M1 2.84615L3.14168 6.70118C3.21595 6.83487 3.40669 6.83912 3.48685 6.70887L7 1"
                                                        stroke="black" stroke-width="1.5" stroke-linecap="round" />
                                                </svg>
                                            </div>
                                        </label>
                                        <p>Я даю согласие на обработку своих персональных данных в соответствии с <a href="/ru-ru/legal/privacy">Политикой конфиденциальности</a></p>
                                    </div>
                                    <a href="#" disabled class="submit-btn">Оставить заявку</a>
                                    <input type="hidden" name="tel">
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-case2-content-block-tablet', {
        label: 'Кейсы контент (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-case2-content-block-tablet">
            <div>
                <div class="careerum-case2-content-wrapper">
                    <div class="careerum-case2-content-label">
                        <p>До Careerum</p>
                    </div>
                    <div class="careerum-case2-content-header">
                        <p>Решение менять сферу и зайти в IT с нуля</p>
                    </div>
                    <div class="careerum-case2-content-text">
                        <p>Арина закончила СПбГУ по специальности «Стоматология» в 2021 году, тогда же поступила в ординатуру и работала врачом-стоматологом в Санкт-Петербурге.</p>
                        <p>Ей очень нравилась эта профессия, работа приносила удовольствие. Но после 24 февраля 2022 года всё изменилось. Арина решила, что для нее важно не привязываться к месту и работать удаленно. Вместе с мужем они задумались о переезде в европейскую страну.</p>
                        <p>Как выяснила Арина, чтобы подтвердить диплом врача-стоматолога в Европе, нужно очень много времени и ресурсов. Так в голову пришло решение поменять сферу деятельности. Арина в то время много общалась со знакомыми программистами, которые предложили ей попробовать себя во frontend-разработке. Ее заинтересовало и она с головой погрузилась в теорию. А в июне 2022 года Арина переехала с мужем в Испанию.</p>
                        <p>О Careerum.Club она узнала в декабре 2022 года благодаря сестре. Та видела, что Арина сталкивается с разными сложностями: неуверенность в правильности выбора, трудности в обучении программированию. К тому же Арина очень скучала по работе врачом-стоматологом. Сестра решила подарить ей сертификат в клуб на три месяца, чтобы помочь.</p>
                        <p>Арина хотела найти свою первую работу во frontend-разработке. Это была ее главная цель. </p>
                    </div>
                    <div class="careerum-case2-content-quote">
                        <p>«Мне казалось, что я, кандидат без профильного образования и опыта работы, не смогу получить оффер из-за большой конкуренции. Боялась кардинально менять сферу» </p>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1707304283713.png" alt="">
                    </div>
                    <div class="careerum-case2-content-text">
                        <p>Когда она начала проходить обучение в клубе, появились новые запросы: как определить правильность своего выбора, стоит ли возвращаться в стоматологию, как справиться с неуверенностью и сомнениями. Она хотела добиться всего и сразу за три месяца, пока активирован сертификат.</p>
                    </div>
                    <div class="careerum-case2-content-form">
                        <div>
                            <p class="careerum-case2-content-form-header">Пора действовать!</p>
                            <p class="careerum-case2-content-form-text">Если вы хотите высоких результатов в карьере, оставьте заявку на обучение. Мы свяжемся с вами<br> и расскажем, чем Careerum будет полезен именно вам</p>
                        </div>
                        <div>
                            <div class="careerum-registration-form-tablet">
                                <form class="deva-form getcourse-email-signup" name="devaRegistrationForm">
                                    <div class="intens-form-firstname">
                                        <input type="text" name="firstname" id="" required placeholder="Имя">
                                    </div>
                                    <div class="intens-form-lastname">
                                        <input type="text" name="lastname" id="" required placeholder="Фамилия">
                                    </div>
                                    <div class="intens-form-email">
                                        <input type="email" name="email" id="" required placeholder="Почта">
                                    </div>
                                    <div class="intens-form-phone">
                                        <input id="" required>
                                    </div>
                                    <div class="intens-form-agree">
                                        <label>
                                            <input type="checkbox" name="agree">
                                            <div>
                                                <svg width="8" height="8" viewBox="0 0 8 8" fill="none"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        d="M1 2.84615L3.14168 6.70118C3.21595 6.83487 3.40669 6.83912 3.48685 6.70887L7 1"
                                                        stroke="black" stroke-width="1.5" stroke-linecap="round" />
                                                </svg>
                                            </div>
                                        </label>
                                        <p>Я даю согласие на обработку своих персональных данных в соответствии<br> с <a href="/ru-ru/legal/privacy">Политикой конфиденциальности</a></p>
                                    </div>
                                    <a href="#" disabled class="submit-btn">Оставить заявку</a>
                                    <input type="hidden" name="tel">
                                </form>
                            </div>
                        </div>
                        <svg width="326" height="178" viewBox="0 0 326 178" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M102.364 36.2053C154.218 -3.69958 316.868 -13.5649 323.604 31.8952C329.471 71.4893 170.743 112.245 123.08 124.553C107.407 128.6 7.48871 153.47 2.41127 119.205C-0.571144 99.0785 43.454 81.6516 99.1571 73.3973C134.024 68.2306 194.206 66.8059 199.006 108.057C202.098 134.633 134.302 163.137 84.5474 168.478C68.3792 170.214 55.953 166 54.8624 158.64C53.6968 150.774 67.3721 147.045 76.5742 145.682C85.7763 144.318 159.979 137.069 170.544 175.685C173.574 186.758 165.297 193.98 156.456 190.536" stroke="#FFC76A" stroke-opacity="0.55" stroke-width="3.20832" stroke-linecap="round" />
                          </svg>
                    </div>
                    <div class="careerum-case2-content-label">
                        <p>Во время обучения</p>
                    </div>
                    <div class="careerum-case2-content-header">
                        <p>Определила свои «хочу» и «могу», проработала резюме</p>
                    </div>
                    <div class="careerum-case2-content-text">
                        <p>Благодаря программе «Real Me: как найти себя в работе и жизни» Арина осознала, что профессия frontend-разработчика ей подходит по талантам и ценностям. Она поняла, что работе важно чувствовать свое «авторство», видеть результат работы сразу, без долгого ожидания, а еще развивать проект в команде, а не в одиночку. Эти ценности она одинаково могла реализовывать и в роли врача-стоматолога, и в роли frontend-разработчика.</p>
                        <p>После блоков «Хочу» и «Могу» Арина пришла к инсайту: нужно применять полученные знания на практике, чтобы не сомневаться в том, что эта работа ей подходит.</p>
                        <p>Также Арина проработала многие свои страхи и сомнения, которые по большей части были навязаны извне.</p>
                    </div>
                    <div class="careerum-case2-content-quote-line">
                        <div>
                            <p>«У меня возникало желание вернуться в стоматологию только потому, что я не представляла себя в другой роли. Мне много говорили, что я прирожденный стоматолог и это мое призвание. Внушали, что в IT у меня ничего не получится и я ничего не добьюсь» </p>
                        </div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1707304283713.png" alt="">
                    </div>
                    <div class="careerum-case2-content-text">
                        <p>Арина знала, что у нее есть талант к работе с детьми: ей легко находить с ними общий язык. При этом ей всегда было интересно попробовать себя в преподавании. Поэтому, пока искала вакансии, она решила устроиться преподавателем по программированию для школьников.</p>
                        <p>Знания, которые ранее доставались с большим трудом, сильно помогали в работе. Преподавание и даже поверхностное погружение в сферу помогло ощутить себя реализованной и нужной. Арина «окрылилась» этим чувством. Теперь даже бесконечная череда отказов по резюме перестала вгонять в тоску, а всё потому что Арина больше не чувствовала бесполезность своего труда.</p>
                        <p>После того, как Арина определила свои «хочу» и «могу», наступило время для «надо». Ей нужно было за короткий срок успеть овладеть всеми инструментами поиска вакансий и найти применение своим навыкам на рынке. Программа «Звездный кандидат» с этим помогла: Арина построила стратегию поиска работы, научилась составлять продающее резюме и правильно преподносить себя на интервью.</p>
                        <p>Раньше у Арины было ощущение, что найти работу в разработке невозможно, ведь «таких людей много и мы никому не нужны». Чтобы поверить в себя и свои возможности, Арина прошла программу «Самооценка 2.0». Это помогло понять, что даже без опыта и профильного образования у нее всё получится. Арина осознала: не нужно занижать свои результаты. То, что она изучила и сделала, заслуживает внимания. Этого достаточно, чтобы уверенно искать работу и добиться цели.</p>
                        <p>На нетворкинговой платформе Арина обращалась к боту Сoffee Вuddy, чтобы тот нашел ей собеседников.</p>
                    </div>
                    <div class="careerum-case2-content-quote">
                        <p>«Я познакомилась с интересными людьми, которые оказались в похожей ситуации — меняли профессию. Это помогло обрести ощущение, что я не одна»</p>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1707304283713.png" alt="">
                    </div>
                    <div class="careerum-case2-content-text">
                        <p>Она много работала с коучем Еленой Эльзенбах, благодаря которой научилась выявлять результат своей работы. С помощью наводящих вопросов Арине было легче определить собственные чувства и эмоции, а также подводить итоги любых своих действий. Коуч помогала ставить цели и прокладывать путь к их достижению, поддерживала и подбадривала на каждом шагу. </p>
                        <p>Вместе с CV-экспертом Софи Бессон Арина прорабатывала свое резюме. До рекомендаций Софи было около 160 откликов и ни одного приглашения на собеседование. Теперь рекрутеры стали проявлять активное внимание кандидатуре Арины: в среднем из 30 откликов в неделю приходило по одному приглашению. </p>
                        <p>Благодаря работе над CV получилось выгодно презентовать себя перед работодателями. Поэтому уже через две недели, после второго пройденного интервью Арина получила долгожданный оффер от российской компании DIGINETICA, который подошел ей по всем условиям.</p>
                    </div>
                    <div class="careerum-case2-content-img">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1707304626803.png" alt="">
                        <p>Подпись к фото</p>
                    </div>
                    <div class="careerum-case2-content-label">
                        <p>Достигнутый результат</p>
                    </div>
                    <div class="careerum-case2-content-header">
                        <p>Получила оффер в новой сфере</p>
                    </div>
                    <div class="careerum-case2-content-text">
                        <p>К концу третьего месяца в Careerum.Club Арина устроилась на удаленную работу в DIGINETICA в роли frontend-разработчика. Также она продолжает преподавать программирование для школьников. </p>
                    </div>
                    <div class="careerum-case2-content-quote">
                        <p>«С каждым днем всё больше ощущаю свою реализованность и радость от выбранного пути. Несмотря на испытательный срок, чувствую облегчение, стабильность и спокойствие»</p>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1707304283713.png" alt="">
                    </div>
                    <div class="careerum-case2-content-text">
                        <p>Арине понравилось в DIGINETICA всё: возможность удаленного формата работы, интересный продукт, корпоративная культура. Для новых сотрудников в компании есть своя обучающая платформа, где можно пройти курсы и влиться в рабочие процессы. Еще Арину вдохновляет ее команда: коллеги отзывчивые и внимательные, они всегда готовы помочь в решении каких-либо задач.</p>
                        <p>Арина уже поставила перед собой новые цели: прокачать навыки и повысить доход. Она планирует вернуться в клуб, чтобы повторно пройти программу «Звездный кандидат» и познакомиться с программой «Карьерная ракета», которая поможет добиться повышения должности. </p>
                        <p>Арина считает, что в ее жизни началась новая глава, которая будет интересной и насыщенной новыми вызовами, с которыми она обязательно справится. </p>
                    </div>
                    <div class="careerum-case2-content-form">
                        <div>
                            <p class="careerum-case2-content-form-header">Хотите достигнуть успеха в карьере?</p>
                            <p class="careerum-case2-content-form-text">Если вы мечтаете строить карьеру по своим правилам, оставьте заявку на обучение. Мы свяжемся с вами<br> и расскажем, чем Careerum будет полезен именно вам</p>
                        </div>
                        <div>
                            <div class="careerum-registration-form-tablet">
                                <form class="deva-form getcourse-email-signup" name="devaRegistrationForm">
                                    <div class="intens-form-firstname">
                                        <input type="text" name="firstname" id="" required placeholder="Имя">
                                    </div>
                                    <div class="intens-form-lastname">
                                        <input type="text" name="lastname" id="" required placeholder="Фамилия">
                                    </div>
                                    <div class="intens-form-email">
                                        <input type="email" name="email" id="" required placeholder="Почта">
                                    </div>
                                    <div class="intens-form-phone">
                                        <input id="" required>
                                    </div>
                                    <div class="intens-form-agree">
                                        <label>
                                            <input type="checkbox" name="agree">
                                            <div>
                                                <svg width="8" height="8" viewBox="0 0 8 8" fill="none"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        d="M1 2.84615L3.14168 6.70118C3.21595 6.83487 3.40669 6.83912 3.48685 6.70887L7 1"
                                                        stroke="black" stroke-width="1.5" stroke-linecap="round" />
                                                </svg>
                                            </div>
                                        </label>
                                        <p>Я даю согласие на обработку своих персональных данных в соответствии<br> с <a href="/ru-ru/legal/privacy">Политикой конфиденциальности</a></p>
                                    </div>
                                    <a href="#" disabled class="submit-btn">Оставить заявку</a>
                                    <input type="hidden" name="tel">
                                </form>
                            </div>
                        </div>
                        <svg width="326" height="178" viewBox="0 0 326 178" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M102.364 36.2053C154.218 -3.69958 316.868 -13.5649 323.604 31.8952C329.471 71.4893 170.743 112.245 123.08 124.553C107.407 128.6 7.48871 153.47 2.41127 119.205C-0.571144 99.0785 43.454 81.6516 99.1571 73.3973C134.024 68.2306 194.206 66.8059 199.006 108.057C202.098 134.633 134.302 163.137 84.5474 168.478C68.3792 170.214 55.953 166 54.8624 158.64C53.6968 150.774 67.3721 147.045 76.5742 145.682C85.7763 144.318 159.979 137.069 170.544 175.685C173.574 186.758 165.297 193.98 156.456 190.536" stroke="#FFC76A" stroke-opacity="0.55" stroke-width="3.20832" stroke-linecap="round" />
                          </svg>
                    </div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-case2-content-block-mobile', {
        label: 'Кейсы контент (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-case2-content-block-mobile">
            <div>
                <div class="careerum-case2-content-wrapper">
                    <div class="careerum-case2-content-label">
                        <p>До Careerum</p>
                    </div>
                    <div class="careerum-case2-content-header">
                        <p>Решение менять сферу<br> и зайти в IT с нуля</p>
                    </div>
                    <div class="careerum-case2-content-text">
                        <p>Арина закончила СПбГУ по специальности «Стоматология» в 2021 году, тогда же поступила в ординатуру и работала<br> врачом-стоматологом в Санкт-Петербурге.</p>
                        <p>Ей очень нравилась эта профессия, работа приносила удовольствие. Но после 24 февраля 2022 года всё изменилось. Арина решила, что для нее важно<br> не привязываться к месту и работать удаленно. Вместе с мужем они задумались о переезде в европейскую страну.</p>
                        <p>Как выяснила Арина, чтобы подтвердить диплом врача-стоматолога в Европе,<br> нужно очень много времени и ресурсов.<br> Так в голову пришло решение поменять сферу деятельности. Арина в то время<br> много общалась со знакомыми программистами, которые предложили ей попробовать себя во frontend-разработке.<br> Ее заинтересовало и она с головой погрузилась в теорию. А в июне 2022 года Арина переехала с мужем в Испанию.</p>
                        <p>О Careerum.Club она узнала в декабре 2022 года благодаря сестре. Та видела, что<br> Арина сталкивается с разными<br> сложностями: неуверенность<br> в правильности выбора, трудности<br> в обучении программированию. К тому же Арина очень скучала по работе врачом-стоматологом. Сестра решила подарить ей сертификат в клуб на три месяца, чтобы помочь.</p>
                        <p>Арина хотела найти свою первую работу<br> во frontend-разработке. Это была<br> ее главная цель. </p>
                    </div>
                    <div class="careerum-case2-content-quote">
                        <p>«Мне казалось, что я, кандидат без профильного образования<br> и опыта работы, не смогу получить оффер из-за большой конкуренции. Боялась кардинально менять сферу» </p>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1707304283713.png" alt="">
                    </div>
                    <div class="careerum-case2-content-text">
                        <p>Когда она начала проходить обучение<br> в клубе, появились новые запросы: как определить правильность своего выбора, стоит ли возвращаться в стоматологию, как справиться с неуверенностью и сомнениями. Она хотела добиться всего и сразу за три месяца, пока активирован сертификат.</p>
                    </div>
                    <div class="careerum-case2-content-form">
                        <div>
                            <p class="careerum-case2-content-form-header">Пора действовать!</p>
                            <p class="careerum-case2-content-form-text">Если вы хотите высоких результатов в карьере, оставьте заявку на обучение. Мы свяжемся с вами<br> и расскажем, чем Careerum будет полезен именно вам</p>
                        </div>
                        <div>
                            <div class="careerum-registration-form-mobile">
                                <form class="deva-form getcourse-email-signup" name="devaRegistrationForm">
                                    <div class="intens-form-firstname">
                                        <input type="text" name="firstname" id="" required placeholder="Имя">
                                    </div>
                                    <div class="intens-form-lastname">
                                        <input type="text" name="lastname" id="" required placeholder="Фамилия">
                                    </div>
                                    <div class="intens-form-email">
                                        <input type="email" name="email" id="" required placeholder="Почта">
                                    </div>
                                    <div class="intens-form-phone">
                                        <input id="" required>
                                    </div>
                                    <div class="intens-form-agree">
                                        <label>
                                            <input type="checkbox" name="agree">
                                            <div>
                                                <svg width="8" height="8" viewBox="0 0 8 8" fill="none"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        d="M1 2.84615L3.14168 6.70118C3.21595 6.83487 3.40669 6.83912 3.48685 6.70887L7 1"
                                                        stroke="black" stroke-width="1.5" stroke-linecap="round" />
                                                </svg>
                                            </div>
                                        </label>
                                        <p>Я даю согласие на обработку своих персональных данных в соответствии<br> с <a href="/ru-ru/legal/privacy">Политикой конфиденциальности</a></p>
                                    </div>
                                    <a href="#" disabled class="submit-btn">Оставить заявку</a>
                                    <input type="hidden" name="tel">
                                </form>
                            </div>
                        </div>
                        <svg width="300" height="429" viewBox="0 0 300 429" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M5.48441 173.924C30.6101 65.5583 242.981 -53.0331 304.908 30.0974C358.844 102.501 187.649 277.982 136.324 330.81C119.447 348.181 10.7707 457.137 -35.9053 394.479C-63.3222 357.674 -22.9318 297.25 44.152 247.277C86.1428 215.997 167.3 176.389 221.686 252.627C256.725 301.743 196.459 397.994 134.185 438.731C113.949 451.969 91.9693 451.494 81.9438 438.035C71.2288 423.651 85.7257 408.115 96.808 399.859C107.89 391.604 201.593 332.225 260.86 399.873C277.855 419.271 274.832 438.205 258.678 437.01" stroke="#FFC76A" stroke-opacity="0.55" stroke-width="4" stroke-linecap="round" />
                          </svg>
                    </div>
                    <div class="careerum-case2-content-label">
                        <p>Во время обучения</p>
                    </div>
                    <div class="careerum-case2-content-header">
                        <p>Определила свои «хочу» и «могу», проработала резюме</p>
                    </div>
                    <div class="careerum-case2-content-text">
                        <p>Благодаря программе «Real Me: как найти себя в работе и жизни» Арина осознала,<br> что профессия frontend-разработчика<br> ей подходит по талантам и ценностям. Она поняла, что работе важно чувствовать свое «авторство», видеть результат работы сразу, без долгого ожидания, а еще развивать проект в команде, а не в одиночку.<br> Эти ценности она одинаково могла реализовывать и в роли врача-стоматолога,<br> и в роли frontend-разработчика.</p>
                        <p>После блоков «Хочу» и «Могу» Арина пришла к инсайту: нужно применять полученные знания на практике, чтобы не сомневаться<br> в том, что эта работа ей подходит.</p>
                        <p>Также Арина проработала многие свои страхи и сомнения, которые по большей части были навязаны извне.</p>
                    </div>
                    <div class="careerum-case2-content-quote-line">
                        <div>
                            <p>«У меня возникало желание вернуться в стоматологию только потому, что<br> я не представляла себя<br> в другой роли. Мне много говорили, что я прирожденный стоматолог и это мое<br> призвание. Внушали, что в IT<br> у меня ничего не получится и я ничего не добьюсь» </p>
                        </div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1707304283713.png" alt="">
                    </div>
                    <div class="careerum-case2-content-text">
                        <p>Арина знала, что у нее есть талант к работе<br> с детьми: ей легко находить с ними общий язык. При этом ей всегда было интересно попробовать себя в преподавании. Поэтому, пока искала вакансии, она решила устроиться преподавателем по программированию<br> для школьников.</p>
                        <p>Знания, которые ранее доставались<br> с большим трудом, сильно помогали в работе. Преподавание и даже поверхностное погружение в сферу помогло ощутить себя реализованной и нужной. Арина «окрылилась» этим чувством. Теперь даже бесконечная череда отказов по резюме перестала вгонять в тоску, а всё потому<br> что Арина больше не чувствовала бесполезность своего труда.</p>
                        <p>После того, как Арина определила свои «хочу» и «могу», наступило время для «надо».<br> Ей нужно было за короткий срок успеть овладеть всеми инструментами поиска вакансий и найти применение своим навыкам на рынке. Программа «Звездный кандидат»<br> с этим помогла: Арина построила стратегию поиска работы, научилась составлять продающее резюме и правильно преподносить себя на интервью.</p>
                        <p>Раньше у Арины было ощущение, что найти работу в разработке невозможно, ведь «таких людей много и мы никому не нужны». Чтобы поверить в себя и свои возможности, Арина прошла программу «Самооценка 2.0». <br>Это помогло понять, что даже без опыта<br> и профильного образования у нее всё получится. Арина осознала: не нужно занижать свои результаты. То, что она изучила и сделала, заслуживает внимания. Этого достаточно, чтобы уверенно искать работу<br> и добиться цели.</p>
                        <p>На нетворкинговой платформе Арина обращалась к боту Сoffee Вuddy, чтобы тот нашел ей собеседников.</p>
                    </div>
                    <div class="careerum-case2-content-quote">
                        <p>«Я познакомилась с интересными людьми, которые оказались в похожей ситуации — меняли профессию. Это помогло обрести ощущение, что я<br> не одна»</p>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1707304283713.png" alt="">
                    </div>
                    <div class="careerum-case2-content-text">
                        <p>Она много работала с коучем Еленой Эльзенбах, благодаря которой научилась выявлять результат своей работы. С помощью наводящих вопросов Арине было легче определить собственные чувства и эмоции, а также подводить итоги любых своих действий. Коуч помогала ставить цели и прокладывать путь к их достижению, поддерживала и подбадривала на каждом шагу. </p>
                        <p>Вместе с CV-экспертом Софи Бессон Арина прорабатывала свое резюме. До рекомендаций Софи было около 160 откликов и ни одного приглашения на собеседование. Теперь рекрутеры стали проявлять активное внимание кандидатуре Арины: в среднем из 30 откликов в неделю приходило по одному приглашению. </p>
                        <p>Благодаря работе над CV получилось выгодно презентовать себя перед работодателями. Поэтому уже через две недели, после второго пройденного интервью Арина получила долгожданный оффер от российской компании DIGINETICA, который подошел ей по всем условиям.</p>
                    </div>
                    <div class="careerum-case2-content-img">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1707304626803.png" alt="">
                        <p>Подпись к фото</p>
                    </div>
                    <div class="careerum-case2-content-label">
                        <p>Достигнутый результат</p>
                    </div>
                    <div class="careerum-case2-content-header">
                        <p>Получила оффер в новой сфере</p>
                    </div>
                    <div class="careerum-case2-content-text">
                        <p>К концу третьего месяца в Careerum.Club Арина устроилась на удаленную работу в DIGINETICA в роли frontend-разработчика. Также она продолжает преподавать программирование для школьников. </p>
                    </div>
                    <div class="careerum-case2-content-quote">
                        <p>«С каждым днем всё больше ощущаю свою реализованность и радость от выбранного пути. Несмотря на испытательный срок, чувствую облегчение, стабильность и спокойствие»</p>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1707304283713.png" alt="">
                    </div>
                    <div class="careerum-case2-content-text">
                        <p>Арине понравилось в DIGINETICA всё: возможность удаленного формата работы, интересный продукт, корпоративная культура. Для новых сотрудников в компании есть своя обучающая платформа, где можно пройти курсы и влиться в рабочие процессы. Еще Арину вдохновляет ее команда: коллеги отзывчивые и внимательные, они всегда готовы помочь в решении каких-либо задач.</p>
                        <p>Арина уже поставила перед собой новые цели: прокачать навыки и повысить доход. Она планирует вернуться в клуб, чтобы повторно пройти программу «Звездный кандидат» и познакомиться с программой «Карьерная ракета», которая поможет добиться повышения должности. </p>
                        <p>Арина считает, что в ее жизни началась новая глава, которая будет интересной и насыщенной новыми вызовами, с которыми она обязательно справится. </p>
                    </div>
                    <div class="careerum-case2-content-form">
                        <div>
                            <p class="careerum-case2-content-form-header">Хотите достигнуть успеха в карьере?</p>
                            <p class="careerum-case2-content-form-text">Если вы мечтаете строить карьеру по своим правилам, оставьте заявку на обучение. Мы свяжемся с вами<br> и расскажем, чем Careerum будет полезен именно вам</p>
                        </div>
                        <div>
                            <div class="careerum-registration-form-mobile">
                                <form class="deva-form getcourse-email-signup" name="devaRegistrationForm">
                                    <div class="intens-form-firstname">
                                        <input type="text" name="firstname" id="" required placeholder="Имя">
                                    </div>
                                    <div class="intens-form-lastname">
                                        <input type="text" name="lastname" id="" required placeholder="Фамилия">
                                    </div>
                                    <div class="intens-form-email">
                                        <input type="email" name="email" id="" required placeholder="Почта">
                                    </div>
                                    <div class="intens-form-phone">
                                        <input id="" required>
                                    </div>
                                    <div class="intens-form-agree">
                                        <label>
                                            <input type="checkbox" name="agree">
                                            <div>
                                                <svg width="8" height="8" viewBox="0 0 8 8" fill="none"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        d="M1 2.84615L3.14168 6.70118C3.21595 6.83487 3.40669 6.83912 3.48685 6.70887L7 1"
                                                        stroke="black" stroke-width="1.5" stroke-linecap="round" />
                                                </svg>
                                            </div>
                                        </label>
                                        <p>Я даю согласие на обработку своих персональных данных в соответствии<br> с <a href="/ru-ru/legal/privacy">Политикой конфиденциальности</a></p>
                                    </div>
                                    <a href="#" disabled class="submit-btn">Оставить заявку</a>
                                    <input type="hidden" name="tel">
                                </form>
                            </div>
                        </div>
                        <svg width="300" height="429" viewBox="0 0 300 429" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M5.48441 173.924C30.6101 65.5583 242.981 -53.0331 304.908 30.0974C358.844 102.501 187.649 277.982 136.324 330.81C119.447 348.181 10.7707 457.137 -35.9053 394.479C-63.3222 357.674 -22.9318 297.25 44.152 247.277C86.1428 215.997 167.3 176.389 221.686 252.627C256.725 301.743 196.459 397.994 134.185 438.731C113.949 451.969 91.9693 451.494 81.9438 438.035C71.2288 423.651 85.7257 408.115 96.808 399.859C107.89 391.604 201.593 332.225 260.86 399.873C277.855 419.271 274.832 438.205 258.678 437.01" stroke="#FFC76A" stroke-opacity="0.55" stroke-width="4" stroke-linecap="round" />
                          </svg>
                    </div>
                </div>
            </div>
        </div>`
	});
    
    blockManager.add('careerum-business-tasks', {
        label: 'Интенсив боли',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-business-tasks">
            <div>
                <h2>С какими задачами приходят в Careerum</h2>
                <div class="careerum-business-tasks-item">
                    <div class="careerum-business-tasks-item-left">
                        <p>Личностное развитие</p>
                    </div>
                    <div class="careerum-business-tasks-item-right">
                        <div>
                            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M8.98828 8.17578C7.06328 11.0758 5.48828 14.4008 5.48828 17.5008C5.48828 20.2856 6.59453 22.9563 8.56366 24.9254C10.5328 26.8945 13.2035 28.0008 15.9883 28.0008C18.7731 28.0008 21.4438 26.8945 23.4129 24.9254C25.382 22.9563 26.4883 20.2856 26.4883 17.5008C26.4883 11.0008 21.9883 6.00078 18.3383 2.36328L13.9883 11.5008L8.98828 8.17578Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                              </svg>
                            <p>работа с выгоранием</p>
                        </div>
                        <div>
                            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M16 28C22.6274 28 28 22.6274 28 16C28 9.37258 22.6274 4 16 4C9.37258 4 4 9.37258 4 16C4 22.6274 9.37258 28 16 28Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M11.5 15C12.3284 15 13 14.3284 13 13.5C13 12.6716 12.3284 12 11.5 12C10.6716 12 10 12.6716 10 13.5C10 14.3284 10.6716 15 11.5 15Z" fill="black" />
                                <path d="M20.5 15C21.3284 15 22 14.3284 22 13.5C22 12.6716 21.3284 12 20.5 12C19.6716 12 19 12.6716 19 13.5C19 14.3284 19.6716 15 20.5 15Z" fill="black" />
                                <path d="M21.2008 19C20.6721 19.9107 19.9136 20.6667 19.001 21.1922C18.0884 21.7176 17.0538 21.9942 16.0008 21.9942C14.9477 21.9942 13.9131 21.7176 13.0006 21.1922C12.088 20.6667 11.3294 19.9107 10.8008 19" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                              </svg>
                            <p>эмоциональный интеллект</p>
                        </div>
                        <div>
                            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M17.338 21.938L14.938 28.4505C14.8669 28.6418 14.739 28.8069 14.5714 28.9234C14.4038 29.04 14.2046 29.1025 14.0005 29.1025C13.7963 29.1025 13.5971 29.04 13.4295 28.9234C13.2619 28.8069 13.134 28.6418 13.063 28.4505L10.663 21.938C10.6123 21.8005 10.5324 21.6757 10.4288 21.5721C10.3252 21.4685 10.2004 21.3886 10.063 21.338L3.55045 18.938C3.35908 18.8669 3.19402 18.739 3.07747 18.5714C2.96091 18.4038 2.89844 18.2046 2.89844 18.0005C2.89844 17.7963 2.96091 17.5971 3.07747 17.4295C3.19402 17.2619 3.35908 17.134 3.55045 17.063L10.063 14.663C10.2004 14.6123 10.3252 14.5324 10.4288 14.4288C10.5324 14.3252 10.6123 14.2004 10.663 14.063L13.063 7.55045C13.134 7.35908 13.2619 7.19402 13.4295 7.07747C13.5971 6.96091 13.7963 6.89844 14.0005 6.89844C14.2046 6.89844 14.4038 6.96091 14.5714 7.07747C14.739 7.19402 14.8669 7.35908 14.938 7.55045L17.338 14.063C17.3886 14.2004 17.4685 14.3252 17.5721 14.4288C17.6757 14.5324 17.8005 14.6123 17.938 14.663L24.4505 17.063C24.6418 17.134 24.8069 17.2619 24.9234 17.4295C25.04 17.5971 25.1025 17.7963 25.1025 18.0005C25.1025 18.2046 25.04 18.4038 24.9234 18.5714C24.8069 18.739 24.6418 18.8669 24.4505 18.938L17.938 21.338C17.8005 21.3886 17.6757 21.4685 17.5721 21.5721C17.4685 21.6757 17.3886 21.8005 17.338 21.938V21.938Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M22 2V8" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M25 5H19" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M28 9V13" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M30 11H26" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                              </svg>
                            <p>поиск мотивации и внутренних ресурсов</p>
                        </div>
                        <div>
                            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M4 13H10V26H4C3.73478 26 3.48043 25.8946 3.29289 25.7071C3.10536 25.5196 3 25.2652 3 25V14C3 13.7348 3.10536 13.4804 3.29289 13.2929C3.48043 13.1054 3.73478 13 4 13V13Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M10 13L15 3C16.0609 3 17.0783 3.42143 17.8284 4.17157C18.5786 4.92172 19 5.93913 19 7V10H26.7375C27.0211 9.9993 27.3015 10.0593 27.56 10.176C27.8185 10.2926 28.049 10.4632 28.2361 10.6764C28.4232 10.8895 28.5625 11.1402 28.6447 11.4116C28.7268 11.683 28.75 11.9689 28.7125 12.25L27.2125 24.25C27.1518 24.7317 26.918 25.1749 26.5546 25.4969C26.1912 25.8189 25.723 25.9977 25.2375 26H10" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                              </svg>
                            <p>работа над самооценкой и уверенностью в себе</p>
                        </div>
                        <div>
                            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M11 7H8C7.44772 7 7 7.44772 7 8V24C7 24.5523 7.44772 25 8 25H11C11.5523 25 12 24.5523 12 24V8C12 7.44772 11.5523 7 11 7Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M24 7H21C20.4477 7 20 7.44772 20 8V24C20 24.5523 20.4477 25 21 25H24C24.5523 25 25 24.5523 25 24V8C25 7.44772 24.5523 7 24 7Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M25 10H28C28.2652 10 28.5196 10.1054 28.7071 10.2929C28.8946 10.4804 29 10.7348 29 11V21C29 21.2652 28.8946 21.5196 28.7071 21.7071C28.5196 21.8946 28.2652 22 28 22H25" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M7 22H4C3.73478 22 3.48043 21.8946 3.29289 21.7071C3.10536 21.5196 3 21.2652 3 21V11C3 10.7348 3.10536 10.4804 3.29289 10.2929C3.48043 10.1054 3.73478 10 4 10H7" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M12 16H20" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M29 16H31" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M1 16H3" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                              </svg>
                            <p>поиск и развитие сильных сторон</p>
                        </div>
                    </div>
                </div>
                <div class="careerum-business-tasks-item">
                    <div class="careerum-business-tasks-item-left">
                        <p>Soft Skills</p>
                    </div>
                    <div class="careerum-business-tasks-item-right">
                        <div>
                            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M8.95 18L4 22V6C4 5.73478 4.10536 5.48043 4.29289 5.29289C4.48043 5.10536 4.73478 5 5 5H21C21.2652 5 21.5196 5.10536 21.7071 5.29289C21.8946 5.48043 22 5.73478 22 6V17C22 17.2652 21.8946 17.5196 21.7071 17.7071C21.5196 17.8946 21.2652 18 21 18H8.95Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M10 18V23C10 23.2652 10.1054 23.5196 10.2929 23.7071C10.4804 23.8946 10.7348 24 11 24H23.05L28 28V12C28 11.7348 27.8946 11.4804 27.7071 11.2929C27.5196 11.1054 27.2652 11 27 11H22" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                              </svg>
                            <p>коммуникация в коллективе</p>
                        </div>
                        <div>
                            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M7 7V13.8875C7 18.85 10.975 22.9625 15.9375 23C17.1246 23.0082 18.3017 22.7815 19.4008 22.3329C20.5 21.8843 21.4995 21.2227 22.3419 20.3862C23.1843 19.5496 23.8528 18.5547 24.309 17.4586C24.7652 16.3626 25 15.1872 25 14V7C25 6.73478 24.8946 6.48043 24.7071 6.29289C24.5196 6.10536 24.2652 6 24 6H8C7.73478 6 7.48043 6.10536 7.29289 6.29289C7.10536 6.48043 7 6.73478 7 7Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M12 28H20" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M16 23V28" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M24.7754 16H26.0004C27.0613 16 28.0787 15.5786 28.8288 14.8284C29.579 14.0783 30.0004 13.0609 30.0004 12V10C30.0004 9.73478 29.895 9.48043 29.7075 9.29289C29.52 9.10536 29.2656 9 29.0004 9H25.0004" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M7.25078 16H5.98828C4.92742 16 3.91 15.5786 3.15985 14.8284C2.40971 14.0783 1.98828 13.0609 1.98828 12V10C1.98828 9.73478 2.09364 9.48043 2.28117 9.29289C2.46871 9.10536 2.72306 9 2.98828 9H6.98828" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                              </svg>
                            <p>развитие лидерства</p>
                        </div>
                        <div>
                            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M16 28C22.6274 28 28 22.6274 28 16C28 9.37258 22.6274 4 16 4C9.37258 4 4 9.37258 4 16C4 22.6274 9.37258 28 16 28Z" stroke="black" stroke-width="2" stroke-miterlimit="10" />
                                <path d="M16 9V16H23" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                              </svg>
                            <p>тайм-менеджмент</p>
                        </div>
                        <div>
                            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 30L14 20L6 17L20 2L18 12L26 15L12 30Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                              </svg>
                            <p>личная эффективность</p>
                        </div>
                        <div>
                            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M13 11.5H19" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M28.7 19.2874L23.2375 6.8749C22.6735 6.31689 21.9121 6.00391 21.1187 6.00391C20.3254 6.00391 19.564 6.31689 19 6.8749V20.9999" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M13.0008 20.9999V6.8749C12.4368 6.31689 11.6754 6.00391 10.882 6.00391C10.0886 6.00391 9.32728 6.31689 8.76328 6.8749L3.30078 19.2874" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M8 26C10.7614 26 13 23.7614 13 21C13 18.2386 10.7614 16 8 16C5.23858 16 3 18.2386 3 21C3 23.7614 5.23858 26 8 26Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M24 26C26.7614 26 29 23.7614 29 21C29 18.2386 26.7614 16 24 16C21.2386 16 19 18.2386 19 21C19 23.7614 21.2386 26 24 26Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                              </svg>
                            <p>поиск и определение общих ценностей в команде</p>
                        </div>
                    </div>
                </div>
                <div class="careerum-business-tasks-item">
                    <div class="careerum-business-tasks-item-left">
                        <p>Карьерные навыки</p>
                    </div>
                    <div class="careerum-business-tasks-item-right">
                        <div>
                            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M27 9H5C4.44772 9 4 9.44772 4 10V26C4 26.5523 4.44772 27 5 27H27C27.5523 27 28 26.5523 28 26V10C28 9.44772 27.5523 9 27 9Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M21 9V7C21 6.46957 20.7893 5.96086 20.4142 5.58579C20.0391 5.21071 19.5304 5 19 5H13C12.4696 5 11.9609 5.21071 11.5858 5.58579C11.2107 5.96086 11 6.46957 11 7V9" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M28 15.7871C24.3529 17.8964 20.2132 19.0046 16 18.9996C11.7861 19.0106 7.64484 17.9019 4 15.7871" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M14.5 15H17.5" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                              </svg>
                            <p>карьерная стратегия</p>
                        </div>
                        <div>
                            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 23L4 25V7L12 5" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M20 27L12 23V5L20 9V27Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M20 9L28 7V25L20 27" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                              </svg>
                            <p>определение плана карьерного развития</p>
                        </div>
                        <div>
                            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M30.0875 15.2241L27 16.7616L23 9.11161L26.125 7.54911C26.3572 7.43073 26.6269 7.40898 26.8751 7.48859C27.1233 7.56821 27.3299 7.74274 27.45 7.97411L30.525 13.8616C30.5874 13.9795 30.6255 14.1086 30.6372 14.2414C30.6489 14.3742 30.634 14.5081 30.5932 14.635C30.5525 14.762 30.4867 14.8795 30.3999 14.9806C30.313 15.0818 30.2068 15.1646 30.0875 15.2241V15.2241Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M4.99979 16.6385L1.91229 15.0885C1.79341 15.0302 1.68746 14.9486 1.60073 14.8486C1.51401 14.7486 1.44829 14.6321 1.40747 14.5062C1.36666 14.3802 1.35159 14.2474 1.36315 14.1155C1.37471 13.9836 1.41268 13.8554 1.47479 13.7385L4.54979 7.85097C4.67008 7.61976 4.87588 7.44464 5.12337 7.36293C5.37086 7.28121 5.64047 7.29934 5.87479 7.41347L8.99979 8.97597L4.99979 16.6385Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M27 16.7617L25 19.1117L20.4 23.7117C20.2746 23.829 20.1227 23.9141 19.9573 23.9598C19.7918 24.0055 19.6178 24.0105 19.45 23.9742L12.2 22.1617C12.0676 22.1248 11.9442 22.061 11.8375 21.9742L5 16.6367" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M25.0001 19.1133L19.5001 15.1133L17.9001 16.3133C17.2069 16.8307 16.3651 17.1102 15.5001 17.1102C14.6351 17.1102 13.7933 16.8307 13.1001 16.3133L12.4251 15.8008C12.311 15.714 12.2166 15.604 12.1481 15.478C12.0797 15.352 12.0388 15.2129 12.0282 15.0699C12.0175 14.9269 12.0374 14.7833 12.0864 14.6485C12.1355 14.5138 12.2126 14.391 12.3126 14.2883L17.2126 9.40079C17.3047 9.3092 17.4139 9.23666 17.534 9.18732C17.6541 9.13799 17.7828 9.11283 17.9126 9.11329H23.0001" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M9.07422 8.97429L15.4867 7.09929C15.7146 7.03395 15.9582 7.05167 16.1742 7.14929L20.4992 9.11179" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M14 26.6125L10.2375 25.6625C10.0842 25.6279 9.94221 25.5547 9.825 25.45L7 23" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                              </svg>
                            <p>синхронизация целей сотрудника с целями компании</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-business-tasks-tablet', {
        label: 'Интенсив боли (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-business-tasks-tablet">
            <div>
                <h2>С какими задачами приходят<br> в Careerum</h2>
                <div class="careerum-business-tasks-item">
                    <div class="careerum-business-tasks-item-left">
                        <p>Личностное развитие</p>
                    </div>
                    <div class="careerum-business-tasks-item-right">
                        <div>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M6.74219 6.13184C5.29844 8.30684 4.11719 10.8006 4.11719 13.1256C4.11719 15.2142 4.94687 17.2172 6.42372 18.6941C7.90057 20.1709 9.90361 21.0006 11.9922 21.0006C14.0808 21.0006 16.0838 20.1709 17.5607 18.6941C19.0375 17.2172 19.8672 15.2142 19.8672 13.1256C19.8672 8.25059 16.4922 4.50059 13.7547 1.77246L10.4922 8.62559L6.74219 6.13184Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                              </svg>
                            <p>работа с выгоранием</p>
                        </div>
                        <div>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M8.625 11.25C9.24632 11.25 9.75 10.7463 9.75 10.125C9.75 9.50368 9.24632 9 8.625 9C8.00368 9 7.5 9.50368 7.5 10.125C7.5 10.7463 8.00368 11.25 8.625 11.25Z" fill="black" />
                                <path d="M15.375 11.25C15.9963 11.25 16.5 10.7463 16.5 10.125C16.5 9.50368 15.9963 9 15.375 9C14.7537 9 14.25 9.50368 14.25 10.125C14.25 10.7463 14.7537 11.25 15.375 11.25Z" fill="black" />
                                <path d="M15.9016 14.25C15.5051 14.9331 14.9362 15.5 14.2517 15.8941C13.5673 16.2882 12.7914 16.4956 12.0016 16.4956C11.2118 16.4956 10.4358 16.2882 9.7514 15.8941C9.06696 15.5 8.49804 14.9331 8.10156 14.25" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                              </svg>
                            <p>эмоциональный интеллект</p>
                        </div>
                        <div>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M13.0035 16.4535L11.2035 21.3378C11.1502 21.4814 11.0543 21.6052 10.9286 21.6926C10.8029 21.78 10.6534 21.8269 10.5003 21.8269C10.3472 21.8269 10.1978 21.78 10.0721 21.6926C9.94642 21.6052 9.85049 21.4814 9.79721 21.3378L7.99721 16.4535C7.95923 16.3504 7.89932 16.2567 7.82163 16.1791C7.74394 16.1014 7.65031 16.0415 7.54721 16.0035L2.66284 14.2035C2.51931 14.1502 2.39552 14.0543 2.3081 13.9286C2.22068 13.8029 2.17383 13.6534 2.17383 13.5003C2.17383 13.3472 2.22068 13.1978 2.3081 13.0721C2.39552 12.9464 2.51931 12.8505 2.66284 12.7972L7.54721 10.9972C7.65031 10.9592 7.74394 10.8993 7.82163 10.8216C7.89932 10.7439 7.95923 10.6503 7.99721 10.5472L9.79721 5.66284C9.85049 5.51931 9.94642 5.39552 10.0721 5.3081C10.1978 5.22068 10.3472 5.17383 10.5003 5.17383C10.6534 5.17383 10.8029 5.22068 10.9286 5.3081C11.0543 5.39552 11.1502 5.51931 11.2035 5.66284L13.0035 10.5472C13.0415 10.6503 13.1014 10.7439 13.1791 10.8216C13.2567 10.8993 13.3504 10.9592 13.4535 10.9972L18.3378 12.7972C18.4814 12.8505 18.6052 12.9464 18.6926 13.0721C18.78 13.1978 18.8269 13.3472 18.8269 13.5003C18.8269 13.6534 18.78 13.8029 18.6926 13.9286C18.6052 14.0543 18.4814 14.1502 18.3378 14.2035L13.4535 16.0035C13.3504 16.0415 13.2567 16.1014 13.1791 16.1791C13.1014 16.2567 13.0415 16.3504 13.0035 16.4535V16.4535Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M16.5 1.5V6" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M18.75 3.75H14.25" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M21 6.75V9.75" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M22.5 8.25H19.5" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                              </svg>
                            <p>поиск мотивации и внутренних ресурсов</p>
                        </div>
                        <div>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M3 9.75H7.5V19.5H3C2.80109 19.5 2.61032 19.421 2.46967 19.2803C2.32902 19.1397 2.25 18.9489 2.25 18.75V10.5C2.25 10.3011 2.32902 10.1103 2.46967 9.96967C2.61032 9.82902 2.80109 9.75 3 9.75V9.75Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M7.5 9.75L11.25 2.25C12.0456 2.25 12.8087 2.56607 13.3713 3.12868C13.9339 3.69129 14.25 4.45435 14.25 5.25V7.5H20.0531C20.2658 7.49947 20.4762 7.54447 20.67 7.63197C20.8639 7.71946 21.0368 7.84743 21.1771 8.00728C21.3174 8.16712 21.4219 8.35514 21.4835 8.55871C21.5451 8.76228 21.5625 8.97667 21.5344 9.1875L20.4094 18.1875C20.3639 18.5488 20.1885 18.8812 19.9159 19.1227C19.6434 19.3642 19.2923 19.4983 18.9281 19.5H7.5" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                              </svg>
                            <p>работа над самооценкой и уверенностью в себе</p>
                        </div>
                        <div>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M8.25 5.25H6C5.58579 5.25 5.25 5.58579 5.25 6V18C5.25 18.4142 5.58579 18.75 6 18.75H8.25C8.66421 18.75 9 18.4142 9 18V6C9 5.58579 8.66421 5.25 8.25 5.25Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M18 5.25H15.75C15.3358 5.25 15 5.58579 15 6V18C15 18.4142 15.3358 18.75 15.75 18.75H18C18.4142 18.75 18.75 18.4142 18.75 18V6C18.75 5.58579 18.4142 5.25 18 5.25Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M18.75 7.5H21C21.1989 7.5 21.3897 7.57902 21.5303 7.71967C21.671 7.86032 21.75 8.05109 21.75 8.25V15.75C21.75 15.9489 21.671 16.1397 21.5303 16.2803C21.3897 16.421 21.1989 16.5 21 16.5H18.75" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M5.25 16.5H3C2.80109 16.5 2.61032 16.421 2.46967 16.2803C2.32902 16.1397 2.25 15.9489 2.25 15.75V8.25C2.25 8.05109 2.32902 7.86032 2.46967 7.71967C2.61032 7.57902 2.80109 7.5 3 7.5H5.25" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M9 12H15" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M21.75 12H23.25" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M0.75 12H2.25" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                              </svg>
                            <p>поиск и развитие сильных сторон</p>
                        </div>
                    </div>
                </div>
                <div class="careerum-business-tasks-item">
                    <div class="careerum-business-tasks-item-left">
                        <p>Soft Skills</p>
                    </div>
                    <div class="careerum-business-tasks-item-right">
                        <div>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M5.25 5.25V10.4156C5.25 14.1375 8.23125 17.2219 11.9531 17.25C12.8435 17.2562 13.7263 17.0862 14.5506 16.7497C15.375 16.4133 16.1247 15.917 16.7564 15.2896C17.3882 14.6622 17.8896 13.916 18.2317 13.094C18.5739 12.272 18.75 11.3904 18.75 10.5V5.25C18.75 5.05109 18.671 4.86032 18.5303 4.71967C18.3897 4.57902 18.1989 4.5 18 4.5H6C5.80109 4.5 5.61032 4.57902 5.46967 4.71967C5.32902 4.86032 5.25 5.05109 5.25 5.25Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M9 21H15" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M12 17.25V21" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M18.582 12H19.5008C20.2964 12 21.0595 11.6839 21.6221 11.1213C22.1847 10.5587 22.5008 9.79565 22.5008 9V7.5C22.5008 7.30109 22.4218 7.11032 22.2811 6.96967C22.1405 6.82902 21.9497 6.75 21.7508 6.75H18.7508" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M5.43906 12H4.49219C3.69654 12 2.93348 11.6839 2.37087 11.1213C1.80826 10.5587 1.49219 9.79565 1.49219 9V7.5C1.49219 7.30109 1.57121 7.11032 1.71186 6.96967C1.85251 6.82902 2.04328 6.75 2.24219 6.75H5.24219" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                              </svg>
                            <p>развитие лидерства</p>
                        </div>
                        <div>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M6.7125 13.5L3 16.5V4.5C3 4.30109 3.07902 4.11032 3.21967 3.96967C3.36032 3.82902 3.55109 3.75 3.75 3.75H15.75C15.9489 3.75 16.1397 3.82902 16.2803 3.96967C16.421 4.11032 16.5 4.30109 16.5 4.5V12.75C16.5 12.9489 16.421 13.1397 16.2803 13.2803C16.1397 13.421 15.9489 13.5 15.75 13.5H6.7125Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M7.5 13.5V17.25C7.5 17.4489 7.57902 17.6397 7.71967 17.7803C7.86032 17.921 8.05109 18 8.25 18H17.2875L21 21V9C21 8.80109 20.921 8.61032 20.7803 8.46967C20.6397 8.32902 20.4489 8.25 20.25 8.25H16.5" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                              </svg>
                            <p>коммуникация в коллективе</p>
                        </div>
                        <div>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M9 22.5L10.5 15L4.5 12.75L15 1.5L13.5 9L19.5 11.25L9 22.5Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                              </svg>
                            <p>личная эффективность</p>
                        </div>
                        <div>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z" stroke="black" stroke-width="1.5" stroke-miterlimit="10" />
                                <path d="M12 6.75V12H17.25" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                              </svg>
                            <p>тайм-менеджмент</p>
                        </div>
                        <div>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M9.75 8.625H14.25" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M21.525 14.4655L17.4281 5.15617C17.0051 4.73767 16.4341 4.50293 15.8391 4.50293C15.244 4.50293 14.673 4.73767 14.25 5.15617V15.7499" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M9.75156 15.7499V5.15617C9.32856 4.73767 8.75754 4.50293 8.1625 4.50293C7.56746 4.50293 6.99644 4.73767 6.57344 5.15617L2.47656 14.4655" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M6 19.5C8.07107 19.5 9.75 17.8211 9.75 15.75C9.75 13.6789 8.07107 12 6 12C3.92893 12 2.25 13.6789 2.25 15.75C2.25 17.8211 3.92893 19.5 6 19.5Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M18 19.5C20.0711 19.5 21.75 17.8211 21.75 15.75C21.75 13.6789 20.0711 12 18 12C15.9289 12 14.25 13.6789 14.25 15.75C14.25 17.8211 15.9289 19.5 18 19.5Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                              </svg>
                            <p>поиск и определение общих ценностей в команде</p>
                        </div>
                    </div>
                </div>
                <div class="careerum-business-tasks-item">
                    <div class="careerum-business-tasks-item-left">
                        <p>Карьерные навыки</p>
                    </div>
                    <div class="careerum-business-tasks-item-right">
                        <div>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M20.25 6.75H3.75C3.33579 6.75 3 7.08579 3 7.5V19.5C3 19.9142 3.33579 20.25 3.75 20.25H20.25C20.6642 20.25 21 19.9142 21 19.5V7.5C21 7.08579 20.6642 6.75 20.25 6.75Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M15.75 6.75V5.25C15.75 4.85218 15.592 4.47064 15.3107 4.18934C15.0294 3.90804 14.6478 3.75 14.25 3.75H9.75C9.35218 3.75 8.97064 3.90804 8.68934 4.18934C8.40804 4.47064 8.25 4.85218 8.25 5.25V6.75" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M21 11.8403C18.2646 13.4223 15.1599 14.2535 12 14.2497C8.83955 14.2579 5.73363 13.4265 3 11.8403" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M10.875 11.25H13.125" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                              </svg>
                            <p>карьерная стратегия</p>
                        </div>
                        <div>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M9 17.25L3 18.75V5.25L9 3.75" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M15 20.25L9 17.25V3.75L15 6.75V20.25Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M15 6.75L21 5.25V18.75L15 20.25" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                              </svg>
                            <p>определение плана карьерного развития</p>
                        </div>
                        <div class="careerum-business-tasks-item-right-full-width">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M22.5656 11.4181L20.25 12.5712L17.25 6.83371L19.5938 5.66183C19.7679 5.57305 19.9701 5.55673 20.1563 5.61645C20.3425 5.67616 20.4975 5.80705 20.5875 5.98058L22.8937 10.3962C22.9405 10.4846 22.9691 10.5815 22.9779 10.6811C22.9867 10.7807 22.9755 10.881 22.9449 10.9763C22.9143 11.0715 22.865 11.1596 22.7999 11.2355C22.7348 11.3114 22.6551 11.3734 22.5656 11.4181V11.4181Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M3.74984 12.4789L1.43422 11.3163C1.34506 11.2727 1.26559 11.2115 1.20055 11.1364C1.13551 11.0614 1.08622 10.9741 1.05561 10.8796C1.02499 10.7852 1.01369 10.6855 1.02236 10.5866C1.03103 10.4877 1.05951 10.3915 1.10609 10.3039L3.41234 5.88822C3.50256 5.71482 3.65691 5.58348 3.84253 5.52219C4.02814 5.46091 4.23035 5.47451 4.40609 5.5601L6.74984 6.73198L3.74984 12.4789Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M20.25 12.5713L18.75 14.3338L15.3 17.7838C15.206 17.8717 15.092 17.9356 14.968 17.9698C14.8439 18.0041 14.7133 18.0078 14.5875 17.9807L9.15 16.6213C9.05067 16.5936 8.95812 16.5457 8.87812 16.4807L3.75 12.4775" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M18.7506 14.335L14.6256 11.335L13.4256 12.235C12.9057 12.623 12.2743 12.8326 11.6256 12.8326C10.9768 12.8326 10.3455 12.623 9.82557 12.235L9.31932 11.8506C9.23371 11.7855 9.16291 11.703 9.11158 11.6085C9.06026 11.514 9.0296 11.4097 9.02162 11.3024C9.01365 11.1952 9.02854 11.0875 9.06531 10.9864C9.10209 10.8853 9.15991 10.7932 9.23495 10.7162L12.9099 7.05059C12.979 6.9819 13.0609 6.92749 13.151 6.89049C13.2411 6.85349 13.3376 6.83462 13.4349 6.83497H17.2506" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M6.80469 6.73072L11.6141 5.32447C11.785 5.27546 11.9677 5.28875 12.1297 5.36197L15.3734 6.83384" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M10.5 19.9594L7.67813 19.2469C7.56313 19.2209 7.45666 19.166 7.36875 19.0875L5.25 17.25" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                              </svg>
                            <p>синхронизация целей сотрудника<br> с целями компании</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-business-tasks-mobile', {
        label: 'Интенсив боли (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-business-tasks-mobile">
            <div>
                <h2>С какими задачами приходят в Careerum</h2>
                <div class="careerum-business-tasks-item">
                    <div class="careerum-business-tasks-item-left">
                        <p>Личностное развитие</p>
                    </div>
                    <div class="careerum-business-tasks-item-right">
                        <div>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M6.74219 6.13184C5.29844 8.30684 4.11719 10.8006 4.11719 13.1256C4.11719 15.2142 4.94687 17.2172 6.42372 18.6941C7.90057 20.1709 9.90361 21.0006 11.9922 21.0006C14.0808 21.0006 16.0838 20.1709 17.5607 18.6941C19.0375 17.2172 19.8672 15.2142 19.8672 13.1256C19.8672 8.25059 16.4922 4.50059 13.7547 1.77246L10.4922 8.62559L6.74219 6.13184Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                              </svg>
                            <p>работа с выгоранием</p>
                        </div>
                        <div>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M8.625 11.25C9.24632 11.25 9.75 10.7463 9.75 10.125C9.75 9.50368 9.24632 9 8.625 9C8.00368 9 7.5 9.50368 7.5 10.125C7.5 10.7463 8.00368 11.25 8.625 11.25Z" fill="black" />
                                <path d="M15.375 11.25C15.9963 11.25 16.5 10.7463 16.5 10.125C16.5 9.50368 15.9963 9 15.375 9C14.7537 9 14.25 9.50368 14.25 10.125C14.25 10.7463 14.7537 11.25 15.375 11.25Z" fill="black" />
                                <path d="M15.9016 14.25C15.5051 14.9331 14.9362 15.5 14.2517 15.8941C13.5673 16.2882 12.7914 16.4956 12.0016 16.4956C11.2118 16.4956 10.4358 16.2882 9.7514 15.8941C9.06696 15.5 8.49804 14.9331 8.10156 14.25" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                              </svg>
                            <p>эмоциональный интеллект</p>
                        </div>
                        <div>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M13.0035 16.4535L11.2035 21.3378C11.1502 21.4814 11.0543 21.6052 10.9286 21.6926C10.8029 21.78 10.6534 21.8269 10.5003 21.8269C10.3472 21.8269 10.1978 21.78 10.0721 21.6926C9.94642 21.6052 9.85049 21.4814 9.79721 21.3378L7.99721 16.4535C7.95923 16.3504 7.89932 16.2567 7.82163 16.1791C7.74394 16.1014 7.65031 16.0415 7.54721 16.0035L2.66284 14.2035C2.51931 14.1502 2.39552 14.0543 2.3081 13.9286C2.22068 13.8029 2.17383 13.6534 2.17383 13.5003C2.17383 13.3472 2.22068 13.1978 2.3081 13.0721C2.39552 12.9464 2.51931 12.8505 2.66284 12.7972L7.54721 10.9972C7.65031 10.9592 7.74394 10.8993 7.82163 10.8216C7.89932 10.7439 7.95923 10.6503 7.99721 10.5472L9.79721 5.66284C9.85049 5.51931 9.94642 5.39552 10.0721 5.3081C10.1978 5.22068 10.3472 5.17383 10.5003 5.17383C10.6534 5.17383 10.8029 5.22068 10.9286 5.3081C11.0543 5.39552 11.1502 5.51931 11.2035 5.66284L13.0035 10.5472C13.0415 10.6503 13.1014 10.7439 13.1791 10.8216C13.2567 10.8993 13.3504 10.9592 13.4535 10.9972L18.3378 12.7972C18.4814 12.8505 18.6052 12.9464 18.6926 13.0721C18.78 13.1978 18.8269 13.3472 18.8269 13.5003C18.8269 13.6534 18.78 13.8029 18.6926 13.9286C18.6052 14.0543 18.4814 14.1502 18.3378 14.2035L13.4535 16.0035C13.3504 16.0415 13.2567 16.1014 13.1791 16.1791C13.1014 16.2567 13.0415 16.3504 13.0035 16.4535V16.4535Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M16.5 1.5V6" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M18.75 3.75H14.25" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M21 6.75V9.75" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M22.5 8.25H19.5" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                              </svg>
                            <p>поиск мотивации<br> и внутренних ресурсов</p>
                        </div>
                        <div class="careerum-business-tasks-item-right-full-width">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M3 9.75H7.5V19.5H3C2.80109 19.5 2.61032 19.421 2.46967 19.2803C2.32902 19.1397 2.25 18.9489 2.25 18.75V10.5C2.25 10.3011 2.32902 10.1103 2.46967 9.96967C2.61032 9.82902 2.80109 9.75 3 9.75V9.75Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M7.5 9.75L11.25 2.25C12.0456 2.25 12.8087 2.56607 13.3713 3.12868C13.9339 3.69129 14.25 4.45435 14.25 5.25V7.5H20.0531C20.2658 7.49947 20.4762 7.54447 20.67 7.63197C20.8639 7.71946 21.0368 7.84743 21.1771 8.00728C21.3174 8.16712 21.4219 8.35514 21.4835 8.55871C21.5451 8.76228 21.5625 8.97667 21.5344 9.1875L20.4094 18.1875C20.3639 18.5488 20.1885 18.8812 19.9159 19.1227C19.6434 19.3642 19.2923 19.4983 18.9281 19.5H7.5" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                              </svg>
                            <p>работа над самооценкой<br> и уверенностью в себе</p>
                        </div>
                        <div>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M8.25 5.25H6C5.58579 5.25 5.25 5.58579 5.25 6V18C5.25 18.4142 5.58579 18.75 6 18.75H8.25C8.66421 18.75 9 18.4142 9 18V6C9 5.58579 8.66421 5.25 8.25 5.25Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M18 5.25H15.75C15.3358 5.25 15 5.58579 15 6V18C15 18.4142 15.3358 18.75 15.75 18.75H18C18.4142 18.75 18.75 18.4142 18.75 18V6C18.75 5.58579 18.4142 5.25 18 5.25Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M18.75 7.5H21C21.1989 7.5 21.3897 7.57902 21.5303 7.71967C21.671 7.86032 21.75 8.05109 21.75 8.25V15.75C21.75 15.9489 21.671 16.1397 21.5303 16.2803C21.3897 16.421 21.1989 16.5 21 16.5H18.75" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M5.25 16.5H3C2.80109 16.5 2.61032 16.421 2.46967 16.2803C2.32902 16.1397 2.25 15.9489 2.25 15.75V8.25C2.25 8.05109 2.32902 7.86032 2.46967 7.71967C2.61032 7.57902 2.80109 7.5 3 7.5H5.25" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M9 12H15" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M21.75 12H23.25" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M0.75 12H2.25" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                              </svg>
                            <p>поиск и развитие сильных сторон</p>
                        </div>
                    </div>
                </div>
                <div class="careerum-business-tasks-item">
                    <div class="careerum-business-tasks-item-left">
                        <p>Soft Skills</p>
                    </div>
                    <div class="careerum-business-tasks-item-right">
                        <div>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M6.7125 13.5L3 16.5V4.5C3 4.30109 3.07902 4.11032 3.21967 3.96967C3.36032 3.82902 3.55109 3.75 3.75 3.75H15.75C15.9489 3.75 16.1397 3.82902 16.2803 3.96967C16.421 4.11032 16.5 4.30109 16.5 4.5V12.75C16.5 12.9489 16.421 13.1397 16.2803 13.2803C16.1397 13.421 15.9489 13.5 15.75 13.5H6.7125Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M7.5 13.5V17.25C7.5 17.4489 7.57902 17.6397 7.71967 17.7803C7.86032 17.921 8.05109 18 8.25 18H17.2875L21 21V9C21 8.80109 20.921 8.61032 20.7803 8.46967C20.6397 8.32902 20.4489 8.25 20.25 8.25H16.5" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                              </svg>
                            <p>коммуникация в коллективе</p>
                        </div>
                        <div>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M5.25 5.25V10.4156C5.25 14.1375 8.23125 17.2219 11.9531 17.25C12.8435 17.2562 13.7263 17.0862 14.5506 16.7497C15.375 16.4133 16.1247 15.917 16.7564 15.2896C17.3882 14.6622 17.8896 13.916 18.2317 13.094C18.5739 12.272 18.75 11.3904 18.75 10.5V5.25C18.75 5.05109 18.671 4.86032 18.5303 4.71967C18.3897 4.57902 18.1989 4.5 18 4.5H6C5.80109 4.5 5.61032 4.57902 5.46967 4.71967C5.32902 4.86032 5.25 5.05109 5.25 5.25Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M9 21H15" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M12 17.25V21" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M18.582 12H19.5008C20.2964 12 21.0595 11.6839 21.6221 11.1213C22.1847 10.5587 22.5008 9.79565 22.5008 9V7.5C22.5008 7.30109 22.4218 7.11032 22.2811 6.96967C22.1405 6.82902 21.9497 6.75 21.7508 6.75H18.7508" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M5.43906 12H4.49219C3.69654 12 2.93348 11.6839 2.37087 11.1213C1.80826 10.5587 1.49219 9.79565 1.49219 9V7.5C1.49219 7.30109 1.57121 7.11032 1.71186 6.96967C1.85251 6.82902 2.04328 6.75 2.24219 6.75H5.24219" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                              </svg>
                            <p>развитие лидерства</p>
                        </div>
                        <div>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z" stroke="black" stroke-width="1.5" stroke-miterlimit="10" />
                                <path d="M12 6.75V12H17.25" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                              </svg>
                            <p>тайм-менеджмент</p>
                        </div>
                        <div>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M9 22.5L10.5 15L4.5 12.75L15 1.5L13.5 9L19.5 11.25L9 22.5Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                              </svg>
                            <p>личная эффективность</p>
                        </div>
                        <div class="careerum-business-tasks-item-right-full-width">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M9.75 8.625H14.25" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M21.525 14.4655L17.4281 5.15617C17.0051 4.73767 16.4341 4.50293 15.8391 4.50293C15.244 4.50293 14.673 4.73767 14.25 5.15617V15.7499" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M9.75156 15.7499V5.15617C9.32856 4.73767 8.75754 4.50293 8.1625 4.50293C7.56746 4.50293 6.99644 4.73767 6.57344 5.15617L2.47656 14.4655" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M6 19.5C8.07107 19.5 9.75 17.8211 9.75 15.75C9.75 13.6789 8.07107 12 6 12C3.92893 12 2.25 13.6789 2.25 15.75C2.25 17.8211 3.92893 19.5 6 19.5Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M18 19.5C20.0711 19.5 21.75 17.8211 21.75 15.75C21.75 13.6789 20.0711 12 18 12C15.9289 12 14.25 13.6789 14.25 15.75C14.25 17.8211 15.9289 19.5 18 19.5Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                              </svg>
                            <p>поиск и определение общих<br> ценностей в команде</p>
                        </div>
                    </div>
                </div>
                <div class="careerum-business-tasks-item">
                    <div class="careerum-business-tasks-item-left">
                        <p>Карьерные навыки</p>
                    </div>
                    <div class="careerum-business-tasks-item-right">
                        <div>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M20.25 6.75H3.75C3.33579 6.75 3 7.08579 3 7.5V19.5C3 19.9142 3.33579 20.25 3.75 20.25H20.25C20.6642 20.25 21 19.9142 21 19.5V7.5C21 7.08579 20.6642 6.75 20.25 6.75Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M15.75 6.75V5.25C15.75 4.85218 15.592 4.47064 15.3107 4.18934C15.0294 3.90804 14.6478 3.75 14.25 3.75H9.75C9.35218 3.75 8.97064 3.90804 8.68934 4.18934C8.40804 4.47064 8.25 4.85218 8.25 5.25V6.75" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M21 11.8403C18.2646 13.4223 15.1599 14.2535 12 14.2497C8.83955 14.2579 5.73363 13.4265 3 11.8403" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M10.875 11.25H13.125" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                              </svg>
                            <p>карьерная стратегия</p>
                        </div>
                        <div class="careerum-business-tasks-item-right-full-width">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M9 17.25L3 18.75V5.25L9 3.75" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M15 20.25L9 17.25V3.75L15 6.75V20.25Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M15 6.75L21 5.25V18.75L15 20.25" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                              </svg>
                            <p>определение плана карьерного<br> развития</p>
                        </div>
                        <div class="careerum-business-tasks-item-right-full-width">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M22.5656 11.4181L20.25 12.5712L17.25 6.83371L19.5938 5.66183C19.7679 5.57305 19.9701 5.55673 20.1563 5.61645C20.3425 5.67616 20.4975 5.80705 20.5875 5.98058L22.8937 10.3962C22.9405 10.4846 22.9691 10.5815 22.9779 10.6811C22.9867 10.7807 22.9755 10.881 22.9449 10.9763C22.9143 11.0715 22.865 11.1596 22.7999 11.2355C22.7348 11.3114 22.6551 11.3734 22.5656 11.4181V11.4181Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M3.74984 12.4789L1.43422 11.3163C1.34506 11.2727 1.26559 11.2115 1.20055 11.1364C1.13551 11.0614 1.08622 10.9741 1.05561 10.8796C1.02499 10.7852 1.01369 10.6855 1.02236 10.5866C1.03103 10.4877 1.05951 10.3915 1.10609 10.3039L3.41234 5.88822C3.50256 5.71482 3.65691 5.58348 3.84253 5.52219C4.02814 5.46091 4.23035 5.47451 4.40609 5.5601L6.74984 6.73198L3.74984 12.4789Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M20.25 12.5713L18.75 14.3338L15.3 17.7838C15.206 17.8717 15.092 17.9356 14.968 17.9698C14.8439 18.0041 14.7133 18.0078 14.5875 17.9807L9.15 16.6213C9.05067 16.5936 8.95812 16.5457 8.87812 16.4807L3.75 12.4775" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M18.7506 14.335L14.6256 11.335L13.4256 12.235C12.9057 12.623 12.2743 12.8326 11.6256 12.8326C10.9768 12.8326 10.3455 12.623 9.82557 12.235L9.31932 11.8506C9.23371 11.7855 9.16291 11.703 9.11158 11.6085C9.06026 11.514 9.0296 11.4097 9.02162 11.3024C9.01365 11.1952 9.02854 11.0875 9.06531 10.9864C9.10209 10.8853 9.15991 10.7932 9.23495 10.7162L12.9099 7.05059C12.979 6.9819 13.0609 6.92749 13.151 6.89049C13.2411 6.85349 13.3376 6.83462 13.4349 6.83497H17.2506" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M6.80469 6.73072L11.6141 5.32447C11.785 5.27546 11.9677 5.28875 12.1297 5.36197L15.3734 6.83384" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M10.5 19.9594L7.67813 19.2469C7.56313 19.2209 7.45666 19.166 7.36875 19.0875L5.25 17.25" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                              </svg>
                            <p>синхронизация целей<br> сотрудника с целями компании</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
	});
    
    blockManager.add('careerum-veb21-main', {
        label: 'Веб 2 главный',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-veb21-main">
            <div>
                <div>
                    <div class="veb21-main-top-labels">
                        <p>21 марта в 18:00 МСК</p>
                        <p>Бесплатный вебинар</p>
                    </div>
                    <h1>Прожарка CV,<br>
                        или 5 ошибок, которые вредят вашему резюме</h1>
                    <div class="veb21-main-top-descr">
                        <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M13.191 0C16.28 0 18 1.78 18 4.83V15.16C18 18.26 16.28 20 13.191 20H4.81C1.77 20 0 18.26 0 15.16V4.83C0 1.78 1.77 0 4.81 0H13.191ZM5.08 13.74C4.78 13.71 4.49 13.85 4.33 14.11C4.17 14.36 4.17 14.69 4.33 14.95C4.49 15.2 4.78 15.35 5.08 15.31H12.92C13.319 15.27 13.62 14.929 13.62 14.53C13.62 14.12 13.319 13.78 12.92 13.74H5.08ZM12.92 9.179H5.08C4.649 9.179 4.3 9.53 4.3 9.96C4.3 10.39 4.649 10.74 5.08 10.74H12.92C13.35 10.74 13.7 10.39 13.7 9.96C13.7 9.53 13.35 9.179 12.92 9.179ZM8.069 4.65H5.08V4.66C4.649 4.66 4.3 5.01 4.3 5.44C4.3 5.87 4.649 6.22 5.08 6.22H8.069C8.5 6.22 8.85 5.87 8.85 5.429C8.85 5 8.5 4.65 8.069 4.65Z"
                                fill="white" />
                        </svg>
                        <p>Разберем теорию</p>
                    </div>
                    <div class="veb21-main-top-descr">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M17.9184 14.32C17.6594 14.571 17.5404 14.934 17.5994 15.29L18.4884 20.21C18.5634 20.627 18.3874 21.049 18.0384 21.29C17.6964 21.54 17.2414 21.57 16.8684 21.37L12.4394 19.06C12.2854 18.978 12.1144 18.934 11.9394 18.929H11.6684C11.5744 18.943 11.4824 18.973 11.3984 19.019L6.96839 21.34C6.74939 21.45 6.50139 21.489 6.25839 21.45C5.66639 21.338 5.27139 20.774 5.36839 20.179L6.25839 15.259C6.31739 14.9 6.19839 14.535 5.93939 14.28L2.32839 10.78C2.02639 10.487 1.92139 10.047 2.05939 9.65C2.19339 9.254 2.53539 8.965 2.94839 8.9L7.91839 8.179C8.29639 8.14 8.62839 7.91 8.79839 7.57L10.9884 3.08C11.0404 2.98 11.1074 2.888 11.1884 2.81L11.2784 2.74C11.3254 2.688 11.3794 2.645 11.4394 2.61L11.5484 2.57L11.7184 2.5H12.1394C12.5154 2.539 12.8464 2.764 13.0194 3.1L15.2384 7.57C15.3984 7.897 15.7094 8.124 16.0684 8.179L21.0384 8.9C21.4584 8.96 21.8094 9.25 21.9484 9.65C22.0794 10.051 21.9664 10.491 21.6584 10.78L17.9184 14.32Z"
                                fill="white" />
                        </svg>
                        <p>Бонус: «прожарим» 3 CV в прямом эфире</p>
                    </div>
                    <div class="veb21-main-top-descr-white">
                        <svg width="18" height="21" viewBox="0 0 18 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M13.191 0.5C16.28 0.5 18 2.28 18 5.33V15.66C18 18.76 16.28 20.5 13.191 20.5H4.81C1.77 20.5 0 18.76 0 15.66V5.33C0 2.28 1.77 0.5 4.81 0.5H13.191ZM5.08 14.24C4.78 14.21 4.49 14.35 4.33 14.61C4.17 14.86 4.17 15.19 4.33 15.45C4.49 15.7 4.78 15.85 5.08 15.81H12.92C13.319 15.77 13.62 15.429 13.62 15.03C13.62 14.62 13.319 14.28 12.92 14.24H5.08ZM12.92 9.679H5.08C4.649 9.679 4.3 10.03 4.3 10.46C4.3 10.89 4.649 11.24 5.08 11.24H12.92C13.35 11.24 13.7 10.89 13.7 10.46C13.7 10.03 13.35 9.679 12.92 9.679ZM8.069 5.15H5.08V5.16C4.649 5.16 4.3 5.51 4.3 5.94C4.3 6.37 4.649 6.72 5.08 6.72H8.069C8.5 6.72 8.85 6.37 8.85 5.929C8.85 5.5 8.5 5.15 8.069 5.15Z"
                                fill="black" />
                        </svg>
                        <p>Разберем теорию</p>
                    </div>
                    <div class="veb21-main-top-descr-white">
                        <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M17.9184 14.8201C17.6594 15.0711 17.5404 15.4341 17.5994 15.7901L18.4884 20.7101C18.5634 21.1271 18.3874 21.5491 18.0384 21.7901C17.6964 22.0401 17.2414 22.0701 16.8684 21.8701L12.4394 19.5601C12.2854 19.4781 12.1144 19.4341 11.9394 19.4291H11.6684C11.5744 19.4431 11.4824 19.4731 11.3984 19.5191L6.96839 21.8401C6.74939 21.9501 6.50139 21.9891 6.25839 21.9501C5.66639 21.8381 5.27139 21.2741 5.36839 20.6791L6.25839 15.7591C6.31739 15.4001 6.19839 15.0351 5.93939 14.7801L2.32839 11.2801C2.02639 10.9871 1.92139 10.5471 2.05939 10.1501C2.19339 9.75412 2.53539 9.46512 2.94839 9.40012L7.91839 8.67912C8.29639 8.64012 8.62839 8.41012 8.79839 8.07012L10.9884 3.58012C11.0404 3.48012 11.1074 3.38812 11.1884 3.31012L11.2784 3.24012C11.3254 3.18812 11.3794 3.14512 11.4394 3.11012L11.5484 3.07012L11.7184 3.00012H12.1394C12.5154 3.03912 12.8464 3.26412 13.0194 3.60012L15.2384 8.07012C15.3984 8.39712 15.7094 8.62412 16.0684 8.67912L21.0384 9.40012C21.4584 9.46012 21.8094 9.75012 21.9484 10.1501C22.0794 10.5511 21.9664 10.9911 21.6584 11.2801L17.9184 14.8201Z" fill="black" />
                          </svg>
                        <p>Бонус: «прожарим» 3 CV в прямом эфире</p>
                    </div>
                    <ul>
                        <li>Заранее подготовьте свое резюме в Google-доке</li>
                        <li>Отправьте ссылку в чат во время вебинара</li>
                        <li>CV-специалист выберет три резюме случайным образом<br>
                            и проанализирует их онлайн</li>
                    </ul>
                </div>
                <div>
                    <svg width="562" height="458" viewBox="0 0 562 458" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M148.513 129.975C224.174 25.3468 520.402 -48.2209 556.103 50.0213C587.197 135.587 314.013 276.119 232.016 318.473C205.054 332.4 32.6848 419.129 5.77593 345.081C-10.03 301.586 62.613 249.087 161.572 213.125C223.516 190.615 334.26 168.309 364.223 257.873C383.527 315.574 272.514 400.104 183.084 427.739C154.023 436.719 128.854 431.369 123.074 415.464C116.897 398.465 140.322 385.877 156.67 379.936C173.018 373.995 306.757 334.364 346.053 416.273C357.321 439.761 345.68 458.344 327.546 453.553"
                            stroke="#FFC76A" stroke-width="6" stroke-linecap="round" />
                    </svg>
                    <div class="careerum-registration-form">
                        <form class="deva-form" name="devaRegistrationForm">
                            <div class="veb21-form-firstname">
                                <input type="text" name="firstname" id="" required placeholder="Имя">
                            </div>
                            <div class="veb21-form-lastname">
                                <input type="text" name="lastname" id="" required placeholder="Фамилия">
                            </div>
                            <div class="veb21-form-email">
                                <input type="email" name="email" id="" required placeholder="Почта">
                            </div>
                            <div class="veb21-form-phone">
                                <input id="" required class="itl-input">
                            </div>
                            <div class="veb21-form-agree">
                                <label>
                                    <input type="checkbox" name="agree">
                                    <div>
                                        <svg width="8" height="8" viewBox="0 0 8 8" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M1 2.84615L3.14168 6.70118C3.21595 6.83487 3.40669 6.83912 3.48685 6.70887L7 1"
                                                stroke="black" stroke-width="1.5" stroke-linecap="round" />
                                        </svg>
                                    </div>
                                </label>
                                <p>Я даю согласие на обработку своих персональных данных<br> в соответствии с <a
                                        href="/ru-ru/legal/privacy">Политикой конфиденциальности</a></p>
                            </div>
                            <a href="#" disabled class="submit-btn">Зарегистрироваться бесплатно</a>
                            <input type="hidden" name="tel">
                        </form>
                    </div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-veb21-main-tablet', {
        label: 'Веб 2 главный (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-veb21-main-tablet">
            <div>
                <div>
                    <div class="veb21-main-top-labels">
                        <p>21 марта в 18:00 МСК</p>
                        <p>Бесплатный вебинар</p>
                    </div>
                    <h2>Прожарка CV,
                        или 5 ошибок, которые вредят вашему резюме</h2>
                    <div class="veb21-main-top-descr">
                        <svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M10.2597 0C12.6622 0 14 1.38444 14 3.75667V11.7911C14 14.2022 12.6622 15.5556 10.2597 15.5556H3.74111C1.37667 15.5556 0 14.2022 0 11.7911V3.75667C0 1.38444 1.37667 0 3.74111 0H10.2597ZM3.95111 10.6867C3.71778 10.6633 3.49222 10.7722 3.36778 10.9744C3.24333 11.1689 3.24333 11.4256 3.36778 11.6278C3.49222 11.8222 3.71778 11.9389 3.95111 11.9078H10.0489C10.3592 11.8767 10.5933 11.6114 10.5933 11.3011C10.5933 10.9822 10.3592 10.7178 10.0489 10.6867H3.95111ZM10.0489 7.13922H3.95111C3.61589 7.13922 3.34444 7.41222 3.34444 7.74667C3.34444 8.08111 3.61589 8.35333 3.95111 8.35333H10.0489C10.3833 8.35333 10.6556 8.08111 10.6556 7.74667C10.6556 7.41222 10.3833 7.13922 10.0489 7.13922ZM6.27589 3.61667H3.95111V3.62444C3.61589 3.62444 3.34444 3.89667 3.34444 4.23111C3.34444 4.56556 3.61589 4.83778 3.95111 4.83778H6.27589C6.61111 4.83778 6.88333 4.56556 6.88333 4.22256C6.88333 3.88889 6.61111 3.61667 6.27589 3.61667Z"
                                fill="white" />
                        </svg>
                        <p>Разберем теорию</p>
                    </div>
                    <div class="veb21-main-top-descr">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M11.9466 9.54675C11.7739 9.71408 11.6946 9.95608 11.7339 10.1934L12.3266 13.4734C12.3766 13.7514 12.2592 14.0327 12.0266 14.1934C11.7986 14.3601 11.4952 14.3801 11.2466 14.2467L8.2939 12.7067C8.19124 12.6521 8.07723 12.6227 7.96057 12.6194H7.7799C7.71724 12.6287 7.6559 12.6487 7.5999 12.6794L4.64657 14.2267C4.50057 14.3001 4.33524 14.3261 4.17323 14.3001C3.77857 14.2254 3.51523 13.8494 3.5799 13.4527L4.17323 10.1727C4.21257 9.93341 4.13323 9.69008 3.96057 9.52008L1.55323 7.18675C1.3519 6.99141 1.2819 6.69808 1.3739 6.43341C1.46323 6.16941 1.69123 5.97675 1.96657 5.93341L5.2799 5.45275C5.5319 5.42675 5.75323 5.27341 5.86657 5.04675L7.32657 2.05341C7.36123 1.98675 7.4059 1.92541 7.4599 1.87341L7.5199 1.82675C7.55123 1.79208 7.58723 1.76341 7.62723 1.74008L7.6999 1.71341L7.81324 1.66675H8.0939C8.34457 1.69275 8.56524 1.84275 8.68057 2.06675L10.1599 5.04675C10.2666 5.26475 10.4739 5.41608 10.7132 5.45275L14.0266 5.93341C14.3066 5.97341 14.5406 6.16675 14.6332 6.43341C14.7206 6.70075 14.6452 6.99408 14.4399 7.18675L11.9466 9.54675Z"
                                fill="white" />
                        </svg>
                        <p>Бонус: «прожарим» 3 CV в прямом эфире</p>
                    </div>
                    <ul>
                        <li>Заранее подготовьте свое резюме в Google-доке</li>
                        <li>Отправьте ссылку в чат во время вебинара</li>
                        <li>CV-специалист выберет три резюме случайным образом
                            и проанализирует их онлайн</li>
                    </ul>
                </div>
                <div>
                    <svg width="336" height="276" viewBox="0 0 336 276" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M187.948 37.8871C272.622 55.2867 399.01 215.855 348.867 264.67C305.195 307.185 144.273 179.102 95.8665 140.705C79.9496 128.08 -20.4007 46.7294 17.3931 9.93651C39.5927 -11.6751 91.6184 18.2218 140.789 68.7304C171.568 100.346 215.645 161.804 169.222 204.729C139.313 232.384 57.1829 187.878 15.7154 140.895C2.24021 125.628 -1.41775 108.794 6.69996 100.891C15.376 92.445 29.5032 103.28 37.6262 111.624C45.7492 119.968 106.727 190.695 67.5425 237.211C56.306 250.549 41.7614 248.556 39.6975 236.17"
                            stroke="#FFC76A" stroke-width="4.01689" stroke-linecap="round" />
                    </svg>
                    <div class="careerum-registration-form-tablet">
                        <form class="deva-form" name="devaRegistrationForm">
                            <div class="veb21-form-firstname">
                                <input type="text" name="firstname" id="" required placeholder="Имя">
                            </div>
                            <div class="veb21-form-lastname">
                                <input type="text" name="lastname" id="" required placeholder="Фамилия">
                            </div>
                            <div class="veb21-form-email">
                                <input type="email" name="email" id="" required placeholder="Почта">
                            </div>
                            <div class="veb21-form-phone">
                                <input id="" required class="itl-input">
                            </div>
                            <div class="veb21-form-agree">
                                <label>
                                    <input type="checkbox" name="agree">
                                    <div>
                                        <svg width="8" height="8" viewBox="0 0 8 8" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M1 2.84615L3.14168 6.70118C3.21595 6.83487 3.40669 6.83912 3.48685 6.70887L7 1"
                                                stroke="black" stroke-width="1.5" stroke-linecap="round" />
                                        </svg>
                                    </div>
                                </label>
                                <p>Я даю согласие на обработку своих персональных данных в соответствии<br> с <a
                                        href="/ru-ru/legal/privacy">Политикой конфиденциальности</a></p>
                            </div>
                            <a href="#" disabled class="submit-btn">Зарегистрироваться бесплатно</a>
                            <input type="hidden" name="tel">
                        </form>
                    </div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-veb21-main-mobile', {
        label: 'Веб 2 главный (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-veb21-main-mobile">
            <div>
                <div>
                    <div class="veb21-main-top-labels">
                        <p>21 марта в 18:00 МСК</p>
                        <p>Бесплатный вебинар</p>
                    </div>
                    <h2>Прожарка CV,<br>
                        или 5 ошибок, которые вредят вашему резюме</h2>
                    <div class="veb21-main-top-descr">
                        <svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M10.2597 0C12.6622 0 14 1.38444 14 3.75667V11.7911C14 14.2022 12.6622 15.5556 10.2597 15.5556H3.74111C1.37667 15.5556 0 14.2022 0 11.7911V3.75667C0 1.38444 1.37667 0 3.74111 0H10.2597ZM3.95111 10.6867C3.71778 10.6633 3.49222 10.7722 3.36778 10.9744C3.24333 11.1689 3.24333 11.4256 3.36778 11.6278C3.49222 11.8222 3.71778 11.9389 3.95111 11.9078H10.0489C10.3592 11.8767 10.5933 11.6114 10.5933 11.3011C10.5933 10.9822 10.3592 10.7178 10.0489 10.6867H3.95111ZM10.0489 7.13922H3.95111C3.61589 7.13922 3.34444 7.41222 3.34444 7.74667C3.34444 8.08111 3.61589 8.35333 3.95111 8.35333H10.0489C10.3833 8.35333 10.6556 8.08111 10.6556 7.74667C10.6556 7.41222 10.3833 7.13922 10.0489 7.13922ZM6.27589 3.61667H3.95111V3.62444C3.61589 3.62444 3.34444 3.89667 3.34444 4.23111C3.34444 4.56556 3.61589 4.83778 3.95111 4.83778H6.27589C6.61111 4.83778 6.88333 4.56556 6.88333 4.22256C6.88333 3.88889 6.61111 3.61667 6.27589 3.61667Z"
                                fill="white" />
                        </svg>
                        <p>Разберем теорию</p>
                    </div>
                    <div class="veb21-main-top-descr">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M11.9466 9.54675C11.7739 9.71408 11.6946 9.95608 11.7339 10.1934L12.3266 13.4734C12.3766 13.7514 12.2592 14.0327 12.0266 14.1934C11.7986 14.3601 11.4952 14.3801 11.2466 14.2467L8.2939 12.7067C8.19124 12.6521 8.07723 12.6227 7.96057 12.6194H7.7799C7.71724 12.6287 7.6559 12.6487 7.5999 12.6794L4.64657 14.2267C4.50057 14.3001 4.33524 14.3261 4.17323 14.3001C3.77857 14.2254 3.51523 13.8494 3.5799 13.4527L4.17323 10.1727C4.21257 9.93341 4.13323 9.69008 3.96057 9.52008L1.55323 7.18675C1.3519 6.99141 1.2819 6.69808 1.3739 6.43341C1.46323 6.16941 1.69123 5.97675 1.96657 5.93341L5.2799 5.45275C5.5319 5.42675 5.75323 5.27341 5.86657 5.04675L7.32657 2.05341C7.36123 1.98675 7.4059 1.92541 7.4599 1.87341L7.5199 1.82675C7.55123 1.79208 7.58723 1.76341 7.62723 1.74008L7.6999 1.71341L7.81324 1.66675H8.0939C8.34457 1.69275 8.56524 1.84275 8.68057 2.06675L10.1599 5.04675C10.2666 5.26475 10.4739 5.41608 10.7132 5.45275L14.0266 5.93341C14.3066 5.97341 14.5406 6.16675 14.6332 6.43341C14.7206 6.70075 14.6452 6.99408 14.4399 7.18675L11.9466 9.54675Z"
                                fill="white" />
                        </svg>
                        <p>Бонус: «прожарим» 3 CV<br> в прямом эфире</p>
                    </div>
                    <ul>
                        <li>Заранее подготовьте свое резюме <br>в Google-доке</li>
                        <li>Отправьте ссылку в чат во время вебинара</li>
                        <li>CV-специалист выберет три резюме случайным образом
                            и проанализирует их онлайн</li>
                    </ul>
                </div>
                <div>
                    <svg width="300" height="387" viewBox="0 0 300 387" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M5.48441 127.924C30.6101 19.5583 242.981 -99.0331 304.908 -15.9026C358.844 56.5011 187.649 231.982 136.324 284.81C119.447 302.181 10.7707 411.137 -35.9053 348.479C-63.3222 311.674 -22.9318 251.25 44.152 201.277C86.1428 169.997 167.3 130.389 221.686 206.627C256.725 255.743 196.459 351.994 134.185 392.731C113.949 405.969 91.9693 405.494 81.9438 392.035C71.2288 377.651 85.7257 362.115 96.808 353.859C107.89 345.604 201.593 286.225 260.86 353.873C277.855 373.271 274.832 392.205 258.678 391.01"
                            stroke="#FFC76A" stroke-opacity="0.55" stroke-width="4" stroke-linecap="round" />
                    </svg>
                    <div class="careerum-registration-form-mobile">
                        <form class="deva-form" name="devaRegistrationForm">
                            <div class="veb21-form-firstname">
                                <input type="text" name="firstname" id="" required placeholder="Имя">
                            </div>
                            <div class="veb21-form-lastname">
                                <input type="text" name="lastname" id="" required placeholder="Фамилия">
                            </div>
                            <div class="veb21-form-email">
                                <input type="email" name="email" id="" required placeholder="Почта">
                            </div>
                            <div class="veb21-form-phone">
                                <input id="" required class="itl-input">
                            </div>
                            <div class="veb21-form-agree">
                                <label>
                                    <input type="checkbox" name="agree">
                                    <div>
                                        <svg width="8" height="8" viewBox="0 0 8 8" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M1 2.84615L3.14168 6.70118C3.21595 6.83487 3.40669 6.83912 3.48685 6.70887L7 1"
                                                stroke="black" stroke-width="1.5" stroke-linecap="round" />
                                        </svg>
                                    </div>
                                </label>
                                <p>Я даю согласие на обработку своих персональных данных в соответствии<br> с <a
                                        href="/ru-ru/legal/privacy">Политикой конфиденциальности</a></p>
                            </div>
                            <a href="#" disabled class="submit-btn">Зарегистрироваться бесплатно</a>
                            <input type="hidden" name="tel">
                        </form>
                    </div>
                </div>
            </div>
        </div>`
	});
    
    blockManager.add('careerum-veb21-tales', {
        label: 'Веб 2 слайдер',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-veb21-tales">
            <div>
                <div>
                    <h2>Вебинар для вас, если вы</h2>
                </div>
                <div class="veb21-tales-slider">
                    <div class="veb21-tales-slider-item">
                        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M20 35C28.2843 35 35 28.2843 35 20C35 11.7157 28.2843 5 20 5C11.7157 5 5 11.7157 5 20C5 28.2843 11.7157 35 20 35Z"
                                stroke="black" stroke-width="2.5" stroke-miterlimit="10" />
                            <path d="M25 15L15 25" stroke="black" stroke-width="2.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path d="M25 25L15 15" stroke="black" stroke-width="2.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>
                        <p>Отправляете резюме пачками, а в ответ — тишина или отказы</p>
                    </div>
                    <div class="veb21-tales-slider-item">
                        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M21.6719 27.4224L18.672 35.5631C18.5832 35.8023 18.4233 36.0086 18.2138 36.1543C18.0043 36.3 17.7552 36.3781 17.5001 36.3781C17.2449 36.3781 16.9958 36.3 16.7864 36.1543C16.5769 36.0086 16.417 35.8023 16.3282 35.5631L13.3282 27.4224C13.2649 27.2506 13.165 27.0946 13.0356 26.9651C12.9061 26.8356 12.75 26.7357 12.5782 26.6724L4.43758 23.6724C4.19836 23.5836 3.99204 23.4238 3.84635 23.2143C3.70065 23.0048 3.62256 22.7557 3.62256 22.5006C3.62256 22.2454 3.70065 21.9963 3.84635 21.7869C3.99204 21.5774 4.19836 21.4175 4.43758 21.3287L12.5782 18.3287C12.75 18.2654 12.9061 18.1655 13.0356 18.036C13.165 17.9066 13.2649 17.7505 13.3282 17.5787L16.3282 9.43807C16.417 9.19884 16.5769 8.99253 16.7864 8.84683C16.9958 8.70114 17.2449 8.62305 17.5001 8.62305C17.7552 8.62305 18.0043 8.70114 18.2138 8.84683C18.4233 8.99253 18.5832 9.19884 18.672 9.43807L21.6719 17.5787C21.7353 17.7505 21.8351 17.9066 21.9646 18.036C22.0941 18.1655 22.2501 18.2654 22.4219 18.3287L30.5626 21.3287C30.8018 21.4175 31.0081 21.5774 31.1538 21.7869C31.2995 21.9963 31.3776 22.2454 31.3776 22.5006C31.3776 22.7557 31.2995 23.0048 31.1538 23.2143C31.0081 23.4238 30.8018 23.5836 30.5626 23.6724L22.4219 26.6724C22.2501 26.7357 22.0941 26.8356 21.9646 26.9651C21.8351 27.0946 21.7353 27.2506 21.6719 27.4224V27.4224Z"
                                stroke="black" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M27.5 2.5V10" stroke="black" stroke-width="2.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path d="M31.25 6.25H23.75" stroke="black" stroke-width="2.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path d="M35 11.25V16.25" stroke="black" stroke-width="2.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path d="M37.5 13.75H32.5" stroke="black" stroke-width="2.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>
                        <p>Не знаете, как выгодно презентовать собственный уникальный опыт</p>
                    </div>
                    <div class="veb21-tales-slider-item">
                        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M20 35C28.2843 35 35 28.2843 35 20C35 11.7157 28.2843 5 20 5C11.7157 5 5 11.7157 5 20C5 28.2843 11.7157 35 20 35Z"
                                stroke="black" stroke-width="2.5" stroke-miterlimit="10" />
                            <path
                                d="M14.375 18.75C15.4105 18.75 16.25 17.9105 16.25 16.875C16.25 15.8395 15.4105 15 14.375 15C13.3395 15 12.5 15.8395 12.5 16.875C12.5 17.9105 13.3395 18.75 14.375 18.75Z"
                                fill="black" />
                            <path
                                d="M25.625 18.75C26.6605 18.75 27.5 17.9105 27.5 16.875C27.5 15.8395 26.6605 15 25.625 15C24.5895 15 23.75 15.8395 23.75 16.875C23.75 17.9105 24.5895 18.75 25.625 18.75Z"
                                fill="black" />
                            <path
                                d="M14.375 18.75C15.4105 18.75 16.25 17.9105 16.25 16.875C16.25 15.8395 15.4105 15 14.375 15C13.3395 15 12.5 15.8395 12.5 16.875C12.5 17.9105 13.3395 18.75 14.375 18.75Z"
                                fill="black" />
                            <path
                                d="M25.625 18.75C26.6605 18.75 27.5 17.9105 27.5 16.875C27.5 15.8395 26.6605 15 25.625 15C24.5895 15 23.75 15.8395 23.75 16.875C23.75 17.9105 24.5895 18.75 25.625 18.75Z"
                                fill="black" />
                            <path
                                d="M26.5 27.5001C25.8392 26.3616 24.891 25.4167 23.7503 24.7599C22.6096 24.103 21.3163 23.7573 20 23.7573C18.6837 23.7573 17.3905 24.103 16.2497 24.7599C15.109 25.4167 14.1608 26.3616 13.5 27.5001"
                                stroke="black" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                        <p>Не понимаете, почему специалистов с похожим опытом приглашают на интервью, а вас — нет </p>
                    </div>
                    <div class="veb21-tales-slider-item">
                        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M8.75 8.75V17.3594C8.75 23.5625 13.7188 28.7032 19.9219 28.7501C21.4058 28.7604 22.8772 28.477 24.2511 27.9162C25.6251 27.3555 26.8745 26.5284 27.9274 25.4828C28.9804 24.4371 29.8161 23.1934 30.3863 21.8234C30.9565 20.4533 31.2501 18.984 31.2501 17.5V8.75C31.2501 8.41848 31.1184 8.10054 30.8839 7.86612C30.6495 7.6317 30.3316 7.5 30.0001 7.5H10C9.66848 7.5 9.35054 7.6317 9.11612 7.86612C8.8817 8.10054 8.75 8.41848 8.75 8.75Z"
                                stroke="black" stroke-width="2.50001" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M15 35.0001H25" stroke="black" stroke-width="2.50001" stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path d="M20 28.7501V35.0001" stroke="black" stroke-width="2.50001" stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path
                                d="M30.9688 20H32.5C33.8261 20 35.0979 19.4732 36.0355 18.5356C36.9732 17.5979 37.5 16.3261 37.5 15V12.5C37.5 12.1685 37.3683 11.8505 37.1339 11.6161C36.8995 11.3817 36.5815 11.25 36.25 11.25H31.25"
                                stroke="black" stroke-width="2.50001" stroke-linecap="round" stroke-linejoin="round" />
                            <path
                                d="M9.06252 20H7.48439C6.1583 20 4.88653 19.4732 3.94885 18.5356C3.01116 17.5979 2.48438 16.3261 2.48438 15V12.5C2.48438 12.1685 2.61607 11.8505 2.85049 11.6161C3.08491 11.3817 3.40286 11.25 3.73438 11.25H8.73439"
                                stroke="black" stroke-width="2.50001" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                        <p>Хотите научиться составлять продающее резюме</p>
                    </div>
                    <div class="veb21-tales-slider-item">
                        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M26.25 35H8.75C8.41848 35 8.10054 34.8683 7.86612 34.6339C7.6317 34.3995 7.5 34.0815 7.5 33.75V11.25C7.5 10.9185 7.6317 10.6005 7.86612 10.3661C8.10054 10.1317 8.41848 10 8.75 10H21.25L27.5 16.25V33.75C27.5 34.0815 27.3683 34.3995 27.1339 34.6339C26.8995 34.8683 26.5815 35 26.25 35Z"
                                stroke="black" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path
                                d="M12.5 10V6.25C12.5 5.91848 12.6317 5.60054 12.8661 5.36612C13.1005 5.1317 13.4185 5 13.75 5H26.25L32.5 11.25V28.75C32.5 29.0815 32.3683 29.3995 32.1339 29.6339C31.8995 29.8683 31.5815 30 31.25 30H27.5"
                                stroke="black" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M13.75 23.75H21.25" stroke="black" stroke-width="2.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path d="M13.75 28.75H21.25" stroke="black" stroke-width="2.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>
                        <p>Испытываете стресс или тревогу при подготовке CV</p>
                    </div>
                    <div class="veb21-tales-slider-item">
                        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M31.25 8.75H8.75C6.67893 8.75 5 10.4289 5 12.5V30C5 32.0711 6.67893 33.75 8.75 33.75H31.25C33.3211 33.75 35 32.0711 35 30V12.5C35 10.4289 33.3211 8.75 31.25 8.75Z"
                                stroke="black" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path
                                d="M25.625 22.5H14.375C12.6491 22.5 11.25 23.8991 11.25 25.625C11.25 27.3509 12.6491 28.75 14.375 28.75H25.625C27.3509 28.75 28.75 27.3509 28.75 25.625C28.75 23.8991 27.3509 22.5 25.625 22.5Z"
                                stroke="black" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M23.125 22.5V28.75" stroke="black" stroke-width="2.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path d="M16.875 22.5V28.75" stroke="black" stroke-width="2.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path d="M20 8.75V2.5" stroke="black" stroke-width="2.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path
                                d="M13.125 18.75C14.1605 18.75 15 17.9105 15 16.875C15 15.8395 14.1605 15 13.125 15C12.0895 15 11.25 15.8395 11.25 16.875C11.25 17.9105 12.0895 18.75 13.125 18.75Z"
                                fill="black" />
                            <path
                                d="M26.875 18.75C27.9105 18.75 28.75 17.9105 28.75 16.875C28.75 15.8395 27.9105 15 26.875 15C25.8395 15 25 15.8395 25 16.875C25 17.9105 25.8395 18.75 26.875 18.75Z"
                                fill="black" />
                        </svg>
                        <p>Хотите использовать ChatGPT без вреда для резюме</p>
                    </div>
                </div>
                <div class="veb21-tales-slider-nav">
                    <div class="veb21-tales-slider-prev">
                        <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M2.19055 7.99935L15.8105 7.99935" stroke="white" stroke-width="2.64201"
                                stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M8.46289 14.2453L2.18956 7.99862L8.46289 1.75195" stroke="white" stroke-width="2.64201"
                                stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </div>
                    <div class="veb21-tales-slider-next">
                        <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M15.8095 8.00065L2.18945 8.00065" stroke="white" stroke-width="2.64201"
                                stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M9.53711 1.75471L15.8104 8.00138L9.53711 14.248" stroke="white" stroke-width="2.64201"
                                stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-veb21-tales-tablet', {
        label: 'Веб 2 слайдер (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-veb21-tales-tablet">
            <div>
                <div>
                    <h2>Вебинар для вас, если вы</h2>
                </div>
                <div class="veb21-tales-slider">
                    <div class="veb21-tales-slider-item">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
                                stroke="black" stroke-width="1.5" stroke-miterlimit="10" />
                            <path d="M15 9L9 15" stroke="black" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path d="M15 15L9 9" stroke="black" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>
                        <p>Отправляете резюме пачками,<br> а в ответ — тишина или отказы</p>
                    </div>
                    <div class="veb21-tales-slider-item">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M13.0035 16.4535L11.2035 21.3378C11.1502 21.4814 11.0543 21.6052 10.9286 21.6926C10.8029 21.78 10.6534 21.8269 10.5003 21.8269C10.3472 21.8269 10.1978 21.78 10.0721 21.6926C9.94642 21.6052 9.85049 21.4814 9.79721 21.3378L7.99721 16.4535C7.95923 16.3504 7.89932 16.2567 7.82163 16.1791C7.74394 16.1014 7.65031 16.0415 7.54721 16.0035L2.66284 14.2035C2.51931 14.1502 2.39552 14.0543 2.3081 13.9286C2.22068 13.8029 2.17383 13.6534 2.17383 13.5003C2.17383 13.3472 2.22068 13.1978 2.3081 13.0721C2.39552 12.9464 2.51931 12.8505 2.66284 12.7972L7.54721 10.9972C7.65031 10.9592 7.74394 10.8993 7.82163 10.8216C7.89932 10.7439 7.95923 10.6503 7.99721 10.5472L9.79721 5.66284C9.85049 5.51931 9.94642 5.39552 10.0721 5.3081C10.1978 5.22068 10.3472 5.17383 10.5003 5.17383C10.6534 5.17383 10.8029 5.22068 10.9286 5.3081C11.0543 5.39552 11.1502 5.51931 11.2035 5.66284L13.0035 10.5472C13.0415 10.6503 13.1014 10.7439 13.1791 10.8216C13.2567 10.8993 13.3504 10.9592 13.4535 10.9972L18.3378 12.7972C18.4814 12.8505 18.6052 12.9464 18.6926 13.0721C18.78 13.1978 18.8269 13.3472 18.8269 13.5003C18.8269 13.6534 18.78 13.8029 18.6926 13.9286C18.6052 14.0543 18.4814 14.1502 18.3378 14.2035L13.4535 16.0035C13.3504 16.0415 13.2567 16.1014 13.1791 16.1791C13.1014 16.2567 13.0415 16.3504 13.0035 16.4535V16.4535Z"
                                stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M16.5 1.5V6" stroke="black" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path d="M18.75 3.75H14.25" stroke="black" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path d="M21 6.75V9.75" stroke="black" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path d="M22.5 8.25H19.5" stroke="black" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>
                        <p>Не знаете, как выгодно презентовать собственный уникальный опыт</p>
                    </div>
                    <div class="veb21-tales-slider-item">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
                                stroke="black" stroke-width="1.5" stroke-miterlimit="10" />
                            <path
                                d="M8.625 11.25C9.24632 11.25 9.75 10.7463 9.75 10.125C9.75 9.50368 9.24632 9 8.625 9C8.00368 9 7.5 9.50368 7.5 10.125C7.5 10.7463 8.00368 11.25 8.625 11.25Z"
                                fill="black" />
                            <path
                                d="M15.375 11.25C15.9963 11.25 16.5 10.7463 16.5 10.125C16.5 9.50368 15.9963 9 15.375 9C14.7537 9 14.25 9.50368 14.25 10.125C14.25 10.7463 14.7537 11.25 15.375 11.25Z"
                                fill="black" />
                            <path
                                d="M8.625 11.25C9.24632 11.25 9.75 10.7463 9.75 10.125C9.75 9.50368 9.24632 9 8.625 9C8.00368 9 7.5 9.50368 7.5 10.125C7.5 10.7463 8.00368 11.25 8.625 11.25Z"
                                fill="black" />
                            <path
                                d="M15.375 11.25C15.9963 11.25 16.5 10.7463 16.5 10.125C16.5 9.50368 15.9963 9 15.375 9C14.7537 9 14.25 9.50368 14.25 10.125C14.25 10.7463 14.7537 11.25 15.375 11.25Z"
                                fill="black" />
                            <path
                                d="M15.8996 16.5C15.5031 15.817 14.9342 15.25 14.2498 14.8559C13.5653 14.4618 12.7894 14.2544 11.9996 14.2544C11.2098 14.2544 10.4339 14.4618 9.74945 14.8559C9.06501 15.25 8.49609 15.817 8.09961 16.5"
                                stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                        <p>Не понимаете, почему специалистов с похожим опытом приглашают на интервью, а вас — нет </p>
                    </div>
                    <div class="veb21-tales-slider-item">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M5.25 5.25V10.4156C5.25 14.1375 8.23125 17.2219 11.9531 17.25C12.8435 17.2562 13.7263 17.0862 14.5506 16.7497C15.375 16.4133 16.1247 15.917 16.7564 15.2896C17.3882 14.6622 17.8896 13.916 18.2317 13.094C18.5739 12.272 18.75 11.3904 18.75 10.5V5.25C18.75 5.05109 18.671 4.86032 18.5303 4.71967C18.3897 4.57902 18.1989 4.5 18 4.5H6C5.80109 4.5 5.61032 4.57902 5.46967 4.71967C5.32902 4.86032 5.25 5.05109 5.25 5.25Z"
                                stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M9 21H15" stroke="black" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path d="M12 17.25V21" stroke="black" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path
                                d="M18.582 12H19.5008C20.2964 12 21.0595 11.6839 21.6221 11.1213C22.1847 10.5587 22.5008 9.79565 22.5008 9V7.5C22.5008 7.30109 22.4218 7.11032 22.2811 6.96967C22.1405 6.82902 21.9497 6.75 21.7508 6.75H18.7508"
                                stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path
                                d="M5.43711 12H4.49023C3.69458 12 2.93152 11.6839 2.36891 11.1213C1.8063 10.5587 1.49023 9.79565 1.49023 9V7.5C1.49023 7.30109 1.56925 7.11032 1.7099 6.96967C1.85056 6.82902 2.04132 6.75 2.24023 6.75H5.24023"
                                stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                        <p>Хотите научиться составлять продающее резюме</p>
                    </div>
                    <div class="veb21-tales-slider-item">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M15.75 21H5.25C5.05109 21 4.86032 20.921 4.71967 20.7803C4.57902 20.6397 4.5 20.4489 4.5 20.25V6.75C4.5 6.55109 4.57902 6.36032 4.71967 6.21967C4.86032 6.07902 5.05109 6 5.25 6H12.75L16.5 9.75V20.25C16.5 20.4489 16.421 20.6397 16.2803 20.7803C16.1397 20.921 15.9489 21 15.75 21Z"
                                stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path
                                d="M7.5 6V3.75C7.5 3.55109 7.57902 3.36032 7.71967 3.21967C7.86032 3.07902 8.05109 3 8.25 3H15.75L19.5 6.75V17.25C19.5 17.4489 19.421 17.6397 19.2803 17.7803C19.1397 17.921 18.9489 18 18.75 18H16.5"
                                stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M8.25 14.25H12.75" stroke="black" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path d="M8.25 17.25H12.75" stroke="black" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>
                        <p>Испытываете стресс или тревогу при подготовке CV</p>
                    </div>
                    <div class="veb21-tales-slider-item">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M18.75 5.25H5.25C4.00736 5.25 3 6.25736 3 7.5V18C3 19.2426 4.00736 20.25 5.25 20.25H18.75C19.9926 20.25 21 19.2426 21 18V7.5C21 6.25736 19.9926 5.25 18.75 5.25Z"
                                stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path
                                d="M15.375 13.5H8.625C7.58947 13.5 6.75 14.3395 6.75 15.375C6.75 16.4105 7.58947 17.25 8.625 17.25H15.375C16.4105 17.25 17.25 16.4105 17.25 15.375C17.25 14.3395 16.4105 13.5 15.375 13.5Z"
                                stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M13.875 13.5V17.25" stroke="black" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path d="M10.125 13.5V17.25" stroke="black" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path d="M12 5.25V1.5" stroke="black" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path
                                d="M7.875 11.25C8.49632 11.25 9 10.7463 9 10.125C9 9.50368 8.49632 9 7.875 9C7.25368 9 6.75 9.50368 6.75 10.125C6.75 10.7463 7.25368 11.25 7.875 11.25Z"
                                fill="black" />
                            <path
                                d="M16.125 11.25C16.7463 11.25 17.25 10.7463 17.25 10.125C17.25 9.50368 16.7463 9 16.125 9C15.5037 9 15 9.50368 15 10.125C15 10.7463 15.5037 11.25 16.125 11.25Z"
                                fill="black" />
                        </svg>
                        <p>Хотите использовать ChatGPT без вреда для резюме</p>
                    </div>
                </div>
                <div class="veb21-tales-slider-nav">
                    <div class="veb21-tales-slider-next">
                        <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M15.8095 8.00065L2.18945 8.00065" stroke="white" stroke-width="2.64201"
                                stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M9.53711 1.75471L15.8104 8.00138L9.53711 14.248" stroke="white" stroke-width="2.64201"
                                stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-veb21-tales-mobile', {
        label: 'Веб 2 слайдер (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-veb21-tales-mobile">
            <div>
                <div>
                    <h2>Вебинар для вас, если вы</h2>
                </div>
                <div class="veb21-tales-slider">
                    <div class="veb21-tales-slider-item">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
                                stroke="black" stroke-width="1.5" stroke-miterlimit="10" />
                            <path d="M15 9L9 15" stroke="black" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path d="M15 15L9 9" stroke="black" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>
                        <p>Отправляете резюме пачками,<br> а в ответ — тишина или отказы</p>
                    </div>
                    <div class="veb21-tales-slider-item">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M13.0035 16.4535L11.2035 21.3378C11.1502 21.4814 11.0543 21.6052 10.9286 21.6926C10.8029 21.78 10.6534 21.8269 10.5003 21.8269C10.3472 21.8269 10.1978 21.78 10.0721 21.6926C9.94642 21.6052 9.85049 21.4814 9.79721 21.3378L7.99721 16.4535C7.95923 16.3504 7.89932 16.2567 7.82163 16.1791C7.74394 16.1014 7.65031 16.0415 7.54721 16.0035L2.66284 14.2035C2.51931 14.1502 2.39552 14.0543 2.3081 13.9286C2.22068 13.8029 2.17383 13.6534 2.17383 13.5003C2.17383 13.3472 2.22068 13.1978 2.3081 13.0721C2.39552 12.9464 2.51931 12.8505 2.66284 12.7972L7.54721 10.9972C7.65031 10.9592 7.74394 10.8993 7.82163 10.8216C7.89932 10.7439 7.95923 10.6503 7.99721 10.5472L9.79721 5.66284C9.85049 5.51931 9.94642 5.39552 10.0721 5.3081C10.1978 5.22068 10.3472 5.17383 10.5003 5.17383C10.6534 5.17383 10.8029 5.22068 10.9286 5.3081C11.0543 5.39552 11.1502 5.51931 11.2035 5.66284L13.0035 10.5472C13.0415 10.6503 13.1014 10.7439 13.1791 10.8216C13.2567 10.8993 13.3504 10.9592 13.4535 10.9972L18.3378 12.7972C18.4814 12.8505 18.6052 12.9464 18.6926 13.0721C18.78 13.1978 18.8269 13.3472 18.8269 13.5003C18.8269 13.6534 18.78 13.8029 18.6926 13.9286C18.6052 14.0543 18.4814 14.1502 18.3378 14.2035L13.4535 16.0035C13.3504 16.0415 13.2567 16.1014 13.1791 16.1791C13.1014 16.2567 13.0415 16.3504 13.0035 16.4535V16.4535Z"
                                stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M16.5 1.5V6" stroke="black" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path d="M18.75 3.75H14.25" stroke="black" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path d="M21 6.75V9.75" stroke="black" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path d="M22.5 8.25H19.5" stroke="black" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>
                        <p>Не знаете, как выгодно презентовать собственный уникальный опыт</p>
                    </div>
                    <div class="veb21-tales-slider-item">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
                                stroke="black" stroke-width="1.5" stroke-miterlimit="10" />
                            <path
                                d="M8.625 11.25C9.24632 11.25 9.75 10.7463 9.75 10.125C9.75 9.50368 9.24632 9 8.625 9C8.00368 9 7.5 9.50368 7.5 10.125C7.5 10.7463 8.00368 11.25 8.625 11.25Z"
                                fill="black" />
                            <path
                                d="M15.375 11.25C15.9963 11.25 16.5 10.7463 16.5 10.125C16.5 9.50368 15.9963 9 15.375 9C14.7537 9 14.25 9.50368 14.25 10.125C14.25 10.7463 14.7537 11.25 15.375 11.25Z"
                                fill="black" />
                            <path
                                d="M8.625 11.25C9.24632 11.25 9.75 10.7463 9.75 10.125C9.75 9.50368 9.24632 9 8.625 9C8.00368 9 7.5 9.50368 7.5 10.125C7.5 10.7463 8.00368 11.25 8.625 11.25Z"
                                fill="black" />
                            <path
                                d="M15.375 11.25C15.9963 11.25 16.5 10.7463 16.5 10.125C16.5 9.50368 15.9963 9 15.375 9C14.7537 9 14.25 9.50368 14.25 10.125C14.25 10.7463 14.7537 11.25 15.375 11.25Z"
                                fill="black" />
                            <path
                                d="M15.8996 16.5C15.5031 15.817 14.9342 15.25 14.2498 14.8559C13.5653 14.4618 12.7894 14.2544 11.9996 14.2544C11.2098 14.2544 10.4339 14.4618 9.74945 14.8559C9.06501 15.25 8.49609 15.817 8.09961 16.5"
                                stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                        <p>Не понимаете, почему специалистов с похожим опытом приглашают на интервью, а вас — нет </p>
                    </div>
                    <div class="veb21-tales-slider-item">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M5.25 5.25V10.4156C5.25 14.1375 8.23125 17.2219 11.9531 17.25C12.8435 17.2562 13.7263 17.0862 14.5506 16.7497C15.375 16.4133 16.1247 15.917 16.7564 15.2896C17.3882 14.6622 17.8896 13.916 18.2317 13.094C18.5739 12.272 18.75 11.3904 18.75 10.5V5.25C18.75 5.05109 18.671 4.86032 18.5303 4.71967C18.3897 4.57902 18.1989 4.5 18 4.5H6C5.80109 4.5 5.61032 4.57902 5.46967 4.71967C5.32902 4.86032 5.25 5.05109 5.25 5.25Z"
                                stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M9 21H15" stroke="black" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path d="M12 17.25V21" stroke="black" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path
                                d="M18.582 12H19.5008C20.2964 12 21.0595 11.6839 21.6221 11.1213C22.1847 10.5587 22.5008 9.79565 22.5008 9V7.5C22.5008 7.30109 22.4218 7.11032 22.2811 6.96967C22.1405 6.82902 21.9497 6.75 21.7508 6.75H18.7508"
                                stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path
                                d="M5.43711 12H4.49023C3.69458 12 2.93152 11.6839 2.36891 11.1213C1.8063 10.5587 1.49023 9.79565 1.49023 9V7.5C1.49023 7.30109 1.56925 7.11032 1.7099 6.96967C1.85056 6.82902 2.04132 6.75 2.24023 6.75H5.24023"
                                stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                        <p>Хотите научиться составлять продающее резюме</p>
                    </div>
                    <div class="veb21-tales-slider-item">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M15.75 21H5.25C5.05109 21 4.86032 20.921 4.71967 20.7803C4.57902 20.6397 4.5 20.4489 4.5 20.25V6.75C4.5 6.55109 4.57902 6.36032 4.71967 6.21967C4.86032 6.07902 5.05109 6 5.25 6H12.75L16.5 9.75V20.25C16.5 20.4489 16.421 20.6397 16.2803 20.7803C16.1397 20.921 15.9489 21 15.75 21Z"
                                stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path
                                d="M7.5 6V3.75C7.5 3.55109 7.57902 3.36032 7.71967 3.21967C7.86032 3.07902 8.05109 3 8.25 3H15.75L19.5 6.75V17.25C19.5 17.4489 19.421 17.6397 19.2803 17.7803C19.1397 17.921 18.9489 18 18.75 18H16.5"
                                stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M8.25 14.25H12.75" stroke="black" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path d="M8.25 17.25H12.75" stroke="black" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>
                        <p>Испытываете стресс или тревогу при подготовке CV</p>
                    </div>
                    <div class="veb21-tales-slider-item">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M18.75 5.25H5.25C4.00736 5.25 3 6.25736 3 7.5V18C3 19.2426 4.00736 20.25 5.25 20.25H18.75C19.9926 20.25 21 19.2426 21 18V7.5C21 6.25736 19.9926 5.25 18.75 5.25Z"
                                stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path
                                d="M15.375 13.5H8.625C7.58947 13.5 6.75 14.3395 6.75 15.375C6.75 16.4105 7.58947 17.25 8.625 17.25H15.375C16.4105 17.25 17.25 16.4105 17.25 15.375C17.25 14.3395 16.4105 13.5 15.375 13.5Z"
                                stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M13.875 13.5V17.25" stroke="black" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path d="M10.125 13.5V17.25" stroke="black" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path d="M12 5.25V1.5" stroke="black" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path
                                d="M7.875 11.25C8.49632 11.25 9 10.7463 9 10.125C9 9.50368 8.49632 9 7.875 9C7.25368 9 6.75 9.50368 6.75 10.125C6.75 10.7463 7.25368 11.25 7.875 11.25Z"
                                fill="black" />
                            <path
                                d="M16.125 11.25C16.7463 11.25 17.25 10.7463 17.25 10.125C17.25 9.50368 16.7463 9 16.125 9C15.5037 9 15 9.50368 15 10.125C15 10.7463 15.5037 11.25 16.125 11.25Z"
                                fill="black" />
                        </svg>
                        <p>Хотите использовать ChatGPT без вреда для резюме</p>
                    </div>
                </div>
                <div class="veb21-tales-slider-nav">
                    <div class="veb21-tales-slider-next">
                        <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M15.8095 8.00065L2.18945 8.00065" stroke="white" stroke-width="2.64201"
                                stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M9.53711 1.75471L15.8104 8.00138L9.53711 14.248" stroke="white" stroke-width="2.64201"
                                stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-veb21-3tales', {
        label: 'Веб 2 плитки',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-veb21-3tales">
            <div>
                <h2>Здоровая самооценка = <span>возможности,<br> доход и психологический комфорт</span></h2>
                <div>
                    <div>
                        <svg width="197" height="42" viewBox="0 0 197 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M2 4C60.5 0.500033 91 3.99997 157 4.00001" stroke="#43CCFF" stroke-width="3" stroke-linecap="round" />
                            <path d="M2 40C74.8419 35.5 112.819 40 195 40" stroke="#43CCFF" stroke-width="3" stroke-linecap="round" />
                          </svg>
                        <h4>Перестаете соглашаться на то, что предлагают</h4>
                        <p>Начинаете уверенно обсуждать условия работы, которые будут комфортны именно вам</p>
                    </div>
                    <div>
                        <svg width="226" height="41" viewBox="0 0 226 41" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M2 4C60.5 0.500033 91 3.99997 157 4.00001" stroke="#43CCFF" stroke-width="3" stroke-linecap="round" />
                            <path d="M2 39C85.7871 34.5 129.471 39 224 39" stroke="#43CCFF" stroke-width="3" stroke-linecap="round" />
                          </svg>
                        <h4>Получаете новые карьерные перспективы</h4>
                        <p>Активнее берете инициативу, включаетесь в новые проекты, как результат — становитесь более ценным специалистом</p>
                    </div>
                    <div>
                        <svg width="350" height="44" viewBox="0 0 350 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M2 5.99999C132.587 -2.99997 200.671 5.9999 348 6" stroke="#43CCFF" stroke-width="3" stroke-linecap="round" />
                            <path d="M2 42C88.429 35.25 133.49 37.9999 231 38" stroke="#43CCFF" stroke-width="3" stroke-linecap="round" />
                          </svg>
                        <h4>Работаете без ощущения паники и тревожности</h4>
                        <p>Правильно оцениваете свои ресурсы, понимаете собственные сильные стороны и начинаете достигать более высоких результатов без выгорания</p>
                    </div>
                </div>
            </div>
        </div>`
    });
    
    blockManager.add('careerum-veb21-3tales-tablet', {
        label: 'Веб 2 плитки (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-veb21-3tales-tablet">
            <div>
                <h2>Здоровая самооценка = <span>возможности, доход<br> и психологический комфорт</span></h2>
                <div>
                    <div>
                        <svg width="110" height="5" viewBox="0 0 110 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M2 3C42.0065 0.750007 62.8645 2.99998 108 3" stroke="#43CCFF" stroke-width="3" stroke-linecap="round" />
                          </svg>
                        <h4>Перестаете соглашаться на то, что предлагают</h4>
                        <p>Начинаете уверенно обсуждать условия работы, которые будут комфортны именно вам</p>
                    </div>
                    <div>
                        <svg width="143" height="29" viewBox="0 0 143 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M2 3C45.4032 0.750007 68.0323 2.99998 117 3" stroke="#43CCFF" stroke-width="3" stroke-linecap="round" />
                            <path d="M2 27C54.4613 24.75 81.8129 27 141 27" stroke="#43CCFF" stroke-width="3" stroke-linecap="round" />
                          </svg>
                        <h4>Получаете новые карьерные перспективы</h4>
                        <p>Активнее берете инициативу, включаетесь в новые проекты, как результат — становитесь более ценным специалистом</p>
                    </div>
                    <div>
                        <svg width="160" height="29" viewBox="0 0 160 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M2 2.17215C39.8074 3.17346 52.529 3.56448 90 2" stroke="#43CCFF" stroke-width="3" stroke-linecap="round" />
                            <path d="M2 26.1722C39.8074 27.1735 121.029 26.0645 158.5 24.5" stroke="#43CCFF" stroke-width="3" stroke-linecap="round" />
                          </svg>
                        <h4>Работаете без ощущения паники и тревожности</h4>
                        <p>Правильно оцениваете свои ресурсы, понимаете собственные сильные стороны и начинаете достигать более высоких результатов без выгорания</p>
                    </div>
                </div>
            </div>
        </div>`
    });
    
    blockManager.add('careerum-veb21-3tales-mobile', {
        label: 'Веб 2 плитки (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-veb21-3tales-mobile">
            <div>
                <h2>Здоровая самооценка = <span>возможности, доход и психологический комфорт</span></h2>
                <div>
                    <div>
                        <svg width="159" height="6" viewBox="0 0 159 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M2 4C60.5 0.500033 91 3.99997 157 4.00001" stroke="#43CCFF" stroke-width="3" stroke-linecap="round" />
                          </svg>
                        <h4>Перестаете соглашаться на то, что предлагают</h4>
                        <p>Начинаете уверенно обсуждать условия работы, которые будут комфортны именно вам</p>
                    </div>
                    <div>
                        <svg width="259" height="7" viewBox="0 0 259 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M2 4.99999C98.2419 -1.74998 148.419 4.99993 257 5" stroke="#43CCFF" stroke-width="3" stroke-linecap="round" />
                          </svg>
                        <h4>Получаете новые карьерные перспективы</h4>
                        <p>Активнее берете инициативу, включаетесь в новые проекты, как результат — становитесь более ценным специалистом</p>
                    </div>
                    <div>
                        <svg width="259" height="7" viewBox="0 0 259 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M2 4.99999C98.2419 -1.74998 148.419 4.99993 257 5" stroke="#43CCFF" stroke-width="3" stroke-linecap="round" />
                          </svg>
                        <h4>Работаете без ощущения паники и тревожности</h4>
                        <p>Правильно оцениваете свои ресурсы, понимаете собственные сильные стороны и начинаете достигать более высоких результатов без выгорания</p>
                    </div>
                </div>
            </div>
        </div>`
    });
    
    blockManager.add('careerum-veb21-author', {
        label: 'Веб 2 автор',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-veb21-author">
            <div>
                <div>
                    <div>
                        <h2>Ведущая вебинара — Софи Бессон,<br> CV-специалист Careerum с международной<br> экспертизой</h2>
                    </div>
                    <div class="veb21-author-top">
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1709629857968.png" alt="author">
                        </div>
                        <div>
                            <div>
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M20.25 6.75H3.75C3.33579 6.75 3 7.08579 3 7.5V19.5C3 19.9142 3.33579 20.25 3.75 20.25H20.25C20.6642 20.25 21 19.9142 21 19.5V7.5C21 7.08579 20.6642 6.75 20.25 6.75Z"
                                        stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path
                                        d="M15.75 6.75V5.25C15.75 4.85218 15.592 4.47064 15.3107 4.18934C15.0294 3.90804 14.6478 3.75 14.25 3.75H9.75C9.35218 3.75 8.97064 3.90804 8.68934 4.18934C8.40804 4.47064 8.25 4.85218 8.25 5.25V6.75"
                                        stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path
                                        d="M21 11.8403C18.2646 13.4223 15.1599 14.2535 12 14.2497C8.83955 14.2579 5.73363 13.4265 3 11.8403"
                                        stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M10.875 11.25H13.125" stroke="black" stroke-width="1.5" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                </svg>
                                <p>4,5 года в карьерном консалтинге, с 2015 года в HR</p>
                            </div>
                            <div>
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M8.25 15C10.9424 15 13.125 12.8174 13.125 10.125C13.125 7.43261 10.9424 5.25 8.25 5.25C5.55761 5.25 3.375 7.43261 3.375 10.125C3.375 12.8174 5.55761 15 8.25 15Z"
                                        stroke="black" stroke-width="1.5" stroke-miterlimit="10" />
                                    <path
                                        d="M14.5684 5.42813C14.9993 5.31124 15.4437 5.25136 15.8902 5.25C17.1832 5.25 18.4231 5.76361 19.3374 6.67785C20.2516 7.59209 20.7652 8.83207 20.7652 10.125C20.7652 11.4179 20.2516 12.6579 19.3374 13.5721C18.4231 14.4864 17.1832 15 15.8902 15"
                                        stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path
                                        d="M1.5 18.5066C2.2612 17.4234 3.27191 16.5393 4.44676 15.9289C5.6216 15.3186 6.92608 15 8.25 15C9.57392 15 10.8784 15.3186 12.0532 15.9289C13.2281 16.5393 14.2388 17.4234 15 18.5066"
                                        stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path
                                        d="M15.8906 15C17.2147 14.9992 18.5194 15.3174 19.6944 15.9277C20.8693 16.5381 21.8799 17.4225 22.6406 18.5063"
                                        stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                <p>600+ клиентов из локальных и крупных компаний: IBM, World Bank, Microsoft, Disney,
                                    Mastercard
                                    и др.</p>
                            </div>
                            <div>
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M12 5.25C4.5 5.25 1.5 12 1.5 12C1.5 12 4.5 18.75 12 18.75C19.5 18.75 22.5 12 22.5 12C22.5 12 19.5 5.25 12 5.25Z"
                                        stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path
                                        d="M12 15.75C14.0711 15.75 15.75 14.0711 15.75 12C15.75 9.92893 14.0711 8.25 12 8.25C9.92893 8.25 8.25 9.92893 8.25 12C8.25 14.0711 9.92893 15.75 12 15.75Z"
                                        stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                <p>Помогает обнаружить проблемы, которые<br> тормозят поиск работы на международном рынке и
                                    в СНГ
                                </p>
                            </div>
                            <div>
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12 15H9V12L18 3L21 6L12 15Z" stroke="black" stroke-width="1.5"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M15.75 5.25L18.75 8.25" stroke="black" stroke-width="1.5"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                    <path
                                        d="M20.25 11.25V19.5C20.25 19.6989 20.171 19.8897 20.0303 20.0303C19.8897 20.171 19.6989 20.25 19.5 20.25H4.5C4.30109 20.25 4.11032 20.171 3.96967 20.0303C3.82902 19.8897 3.75 19.6989 3.75 19.5V4.5C3.75 4.30109 3.82902 4.11032 3.96967 3.96967C4.11032 3.82902 4.30109 3.75 4.5 3.75H12.75"
                                        stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                <p>Бакалавр и магистр психологии</p>
                            </div>
                            <div>
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M12.4123 17.8781L17.1373 20.8781C17.7466 21.2625 18.4966 20.6906 18.3185 19.9875L16.9498 14.6063C16.9127 14.4571 16.9186 14.3005 16.9667 14.1546C17.0148 14.0086 17.1032 13.8792 17.2216 13.7813L21.4591 10.2469C22.0123 9.78752 21.731 8.8594 21.0091 8.81252L15.4779 8.45627C15.327 8.44749 15.1819 8.39494 15.0603 8.30503C14.9388 8.21513 14.8461 8.09177 14.7935 7.95002L12.731 2.75627C12.6764 2.60618 12.5769 2.47653 12.4461 2.38491C12.3153 2.29329 12.1595 2.24414 11.9998 2.24414C11.84 2.24414 11.6842 2.29329 11.5534 2.38491C11.4226 2.47653 11.3231 2.60618 11.2685 2.75627L9.206 7.95002C9.15344 8.09177 9.06072 8.21513 8.93918 8.30503C8.81764 8.39494 8.67255 8.44749 8.52163 8.45627L2.99038 8.81252C2.2685 8.8594 1.98725 9.78752 2.54038 10.2469L6.77788 13.7813C6.89632 13.8792 6.98468 14.0086 7.03278 14.1546C7.08088 14.3005 7.08676 14.4571 7.04975 14.6063L5.78413 19.5938C5.5685 20.4375 6.4685 21.1219 7.19038 20.6625L11.5873 17.8781C11.7105 17.7997 11.8536 17.7581 11.9998 17.7581C12.1459 17.7581 12.289 17.7997 12.4123 17.8781V17.8781Z"
                                        stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                <p>9,7 из 10: средний балл оценки работы<br> от клиентов</p>
                            </div>
                            <div>
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M3 9.75H7.5V19.5H3C2.80109 19.5 2.61032 19.421 2.46967 19.2803C2.32902 19.1397 2.25 18.9489 2.25 18.75V10.5C2.25 10.3011 2.32902 10.1103 2.46967 9.96967C2.61032 9.82902 2.80109 9.75 3 9.75V9.75Z"
                                        stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path
                                        d="M7.5 9.75L11.25 2.25C12.0456 2.25 12.8087 2.56607 13.3713 3.12868C13.9339 3.69129 14.25 4.45435 14.25 5.25V7.5H20.0531C20.2658 7.49947 20.4762 7.54447 20.67 7.63197C20.8639 7.71946 21.0368 7.84743 21.1771 8.00728C21.3174 8.16712 21.4219 8.35514 21.4835 8.55871C21.5451 8.76228 21.5625 8.97667 21.5344 9.1875L20.4094 18.1875C20.3639 18.5488 20.1885 18.8812 19.9159 19.1227C19.6434 19.3642 19.2923 19.4983 18.9281 19.5H7.5"
                                        stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                <p>97% клиентов Софи отмечают:<br> индивидуальный подход, отзывчивость,<br> глубину
                                    рекомендаций и
                                    искреннюю<br> поддержку</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="veb21-author-link">
                    <a href="#buy" class="btn-color-main-dark-orange">Зарегистрироваться бесплатно</a>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-veb21-author-tablet', {
        label: 'Веб 2 автор (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-veb21-author-tablet">
            <div>
                <div>
                    <div>
                        <h2>Ведущая вебинара — Софи Бессон, CV-специалист<br> Careerum с международной экспертизой</h2>
                    </div>
                    <div class="veb21-author-top">
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1709650055101.png" alt="author">
                        </div>
                        <div>
                            <div class="single-line-svg">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M20.25 6.75H3.75C3.33579 6.75 3 7.08579 3 7.5V19.5C3 19.9142 3.33579 20.25 3.75 20.25H20.25C20.6642 20.25 21 19.9142 21 19.5V7.5C21 7.08579 20.6642 6.75 20.25 6.75Z"
                                        stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path
                                        d="M15.75 6.75V5.25C15.75 4.85218 15.592 4.47064 15.3107 4.18934C15.0294 3.90804 14.6478 3.75 14.25 3.75H9.75C9.35218 3.75 8.97064 3.90804 8.68934 4.18934C8.40804 4.47064 8.25 4.85218 8.25 5.25V6.75"
                                        stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path
                                        d="M21 11.8403C18.2646 13.4223 15.1599 14.2535 12 14.2497C8.83955 14.2579 5.73363 13.4265 3 11.8403"
                                        stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M10.875 11.25H13.125" stroke="black" stroke-width="1.5" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                </svg>
                                <p>4,5 года в карьерном консалтинге, с 2015 года в HR</p>
                            </div>
                            <div>
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M8.25 15C10.9424 15 13.125 12.8174 13.125 10.125C13.125 7.43261 10.9424 5.25 8.25 5.25C5.55761 5.25 3.375 7.43261 3.375 10.125C3.375 12.8174 5.55761 15 8.25 15Z"
                                        stroke="black" stroke-width="1.5" stroke-miterlimit="10" />
                                    <path
                                        d="M14.5684 5.42813C14.9993 5.31124 15.4437 5.25136 15.8902 5.25C17.1832 5.25 18.4231 5.76361 19.3374 6.67785C20.2516 7.59209 20.7652 8.83207 20.7652 10.125C20.7652 11.4179 20.2516 12.6579 19.3374 13.5721C18.4231 14.4864 17.1832 15 15.8902 15"
                                        stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path
                                        d="M1.5 18.5066C2.2612 17.4234 3.27191 16.5393 4.44676 15.9289C5.6216 15.3186 6.92608 15 8.25 15C9.57392 15 10.8784 15.3186 12.0532 15.9289C13.2281 16.5393 14.2388 17.4234 15 18.5066"
                                        stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path
                                        d="M15.8906 15C17.2147 14.9992 18.5194 15.3174 19.6944 15.9277C20.8693 16.5381 21.8799 17.4225 22.6406 18.5063"
                                        stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                <p>600+ клиентов из локальных и крупных компаний: IBM, World Bank, Microsoft, Disney,
                                    Mastercard
                                    и др.</p>
                            </div>
                            <div>
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M12 5.25C4.5 5.25 1.5 12 1.5 12C1.5 12 4.5 18.75 12 18.75C19.5 18.75 22.5 12 22.5 12C22.5 12 19.5 5.25 12 5.25Z"
                                        stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path
                                        d="M12 15.75C14.0711 15.75 15.75 14.0711 15.75 12C15.75 9.92893 14.0711 8.25 12 8.25C9.92893 8.25 8.25 9.92893 8.25 12C8.25 14.0711 9.92893 15.75 12 15.75Z"
                                        stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                <p>Помогает обнаружить проблемы, которые тормозят поиск работы на международном рынке и
                                    в СНГ
                                </p>
                            </div>
                            <div class="single-line-svg">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12 15H9V12L18 3L21 6L12 15Z" stroke="black" stroke-width="1.5"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M15.75 5.25L18.75 8.25" stroke="black" stroke-width="1.5"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                    <path
                                        d="M20.25 11.25V19.5C20.25 19.6989 20.171 19.8897 20.0303 20.0303C19.8897 20.171 19.6989 20.25 19.5 20.25H4.5C4.30109 20.25 4.11032 20.171 3.96967 20.0303C3.82902 19.8897 3.75 19.6989 3.75 19.5V4.5C3.75 4.30109 3.82902 4.11032 3.96967 3.96967C4.11032 3.82902 4.30109 3.75 4.5 3.75H12.75"
                                        stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                <p>Бакалавр и магистр психологии</p>
                            </div>
                            <div class="single-line-svg">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M12.4123 17.8781L17.1373 20.8781C17.7466 21.2625 18.4966 20.6906 18.3185 19.9875L16.9498 14.6063C16.9127 14.4571 16.9186 14.3005 16.9667 14.1546C17.0148 14.0086 17.1032 13.8792 17.2216 13.7813L21.4591 10.2469C22.0123 9.78752 21.731 8.8594 21.0091 8.81252L15.4779 8.45627C15.327 8.44749 15.1819 8.39494 15.0603 8.30503C14.9388 8.21513 14.8461 8.09177 14.7935 7.95002L12.731 2.75627C12.6764 2.60618 12.5769 2.47653 12.4461 2.38491C12.3153 2.29329 12.1595 2.24414 11.9998 2.24414C11.84 2.24414 11.6842 2.29329 11.5534 2.38491C11.4226 2.47653 11.3231 2.60618 11.2685 2.75627L9.206 7.95002C9.15344 8.09177 9.06072 8.21513 8.93918 8.30503C8.81764 8.39494 8.67255 8.44749 8.52163 8.45627L2.99038 8.81252C2.2685 8.8594 1.98725 9.78752 2.54038 10.2469L6.77788 13.7813C6.89632 13.8792 6.98468 14.0086 7.03278 14.1546C7.08088 14.3005 7.08676 14.4571 7.04975 14.6063L5.78413 19.5938C5.5685 20.4375 6.4685 21.1219 7.19038 20.6625L11.5873 17.8781C11.7105 17.7997 11.8536 17.7581 11.9998 17.7581C12.1459 17.7581 12.289 17.7997 12.4123 17.8781V17.8781Z"
                                        stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                <p>9,7 из 10: средний балл оценки работы от клиентов</p>
                            </div>
                            <div>
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M3 9.75H7.5V19.5H3C2.80109 19.5 2.61032 19.421 2.46967 19.2803C2.32902 19.1397 2.25 18.9489 2.25 18.75V10.5C2.25 10.3011 2.32902 10.1103 2.46967 9.96967C2.61032 9.82902 2.80109 9.75 3 9.75V9.75Z"
                                        stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path
                                        d="M7.5 9.75L11.25 2.25C12.0456 2.25 12.8087 2.56607 13.3713 3.12868C13.9339 3.69129 14.25 4.45435 14.25 5.25V7.5H20.0531C20.2658 7.49947 20.4762 7.54447 20.67 7.63197C20.8639 7.71946 21.0368 7.84743 21.1771 8.00728C21.3174 8.16712 21.4219 8.35514 21.4835 8.55871C21.5451 8.76228 21.5625 8.97667 21.5344 9.1875L20.4094 18.1875C20.3639 18.5488 20.1885 18.8812 19.9159 19.1227C19.6434 19.3642 19.2923 19.4983 18.9281 19.5H7.5"
                                        stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                <p>97% клиентов Софи отмечают: индивидуальный подход, отзывчивость, глубину
                                    рекомендаций<br> и
                                    искреннюю поддержку</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="veb21-author-link">
                    <a href="#buy" class="btn-color-main-dark-orange">Зарегистрироваться бесплатно</a>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-veb21-author-mobile', {
        label: 'Веб 2 автор (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-veb21-author-mobile">
            <div>
                <div>
                    <div>
                        <h2>Ведущая вебинара — Софи Бессон, CV-специалист<br> Careerum с международной экспертизой</h2>
                    </div>
                    <div class="veb21-author-top">
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1709652450659.png" alt="author">
                        </div>
                        <div>
                            <div>
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M20.25 6.75H3.75C3.33579 6.75 3 7.08579 3 7.5V19.5C3 19.9142 3.33579 20.25 3.75 20.25H20.25C20.6642 20.25 21 19.9142 21 19.5V7.5C21 7.08579 20.6642 6.75 20.25 6.75Z"
                                        stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path
                                        d="M15.75 6.75V5.25C15.75 4.85218 15.592 4.47064 15.3107 4.18934C15.0294 3.90804 14.6478 3.75 14.25 3.75H9.75C9.35218 3.75 8.97064 3.90804 8.68934 4.18934C8.40804 4.47064 8.25 4.85218 8.25 5.25V6.75"
                                        stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path
                                        d="M21 11.8403C18.2646 13.4223 15.1599 14.2535 12 14.2497C8.83955 14.2579 5.73363 13.4265 3 11.8403"
                                        stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M10.875 11.25H13.125" stroke="black" stroke-width="1.5" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                </svg>
                                <p>4,5 года в карьерном консалтинге, <br>с 2015 года в HR</p>
                            </div>
                            <div>
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M8.25 15C10.9424 15 13.125 12.8174 13.125 10.125C13.125 7.43261 10.9424 5.25 8.25 5.25C5.55761 5.25 3.375 7.43261 3.375 10.125C3.375 12.8174 5.55761 15 8.25 15Z"
                                        stroke="black" stroke-width="1.5" stroke-miterlimit="10" />
                                    <path
                                        d="M14.5684 5.42813C14.9993 5.31124 15.4437 5.25136 15.8902 5.25C17.1832 5.25 18.4231 5.76361 19.3374 6.67785C20.2516 7.59209 20.7652 8.83207 20.7652 10.125C20.7652 11.4179 20.2516 12.6579 19.3374 13.5721C18.4231 14.4864 17.1832 15 15.8902 15"
                                        stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path
                                        d="M1.5 18.5066C2.2612 17.4234 3.27191 16.5393 4.44676 15.9289C5.6216 15.3186 6.92608 15 8.25 15C9.57392 15 10.8784 15.3186 12.0532 15.9289C13.2281 16.5393 14.2388 17.4234 15 18.5066"
                                        stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path
                                        d="M15.8906 15C17.2147 14.9992 18.5194 15.3174 19.6944 15.9277C20.8693 16.5381 21.8799 17.4225 22.6406 18.5063"
                                        stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                <p>600+ клиентов из локальных и крупных компаний: IBM, World Bank, Microsoft, Disney,
                                    Mastercard
                                    и др.</p>
                            </div>
                            <div>
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M12 5.25C4.5 5.25 1.5 12 1.5 12C1.5 12 4.5 18.75 12 18.75C19.5 18.75 22.5 12 22.5 12C22.5 12 19.5 5.25 12 5.25Z"
                                        stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path
                                        d="M12 15.75C14.0711 15.75 15.75 14.0711 15.75 12C15.75 9.92893 14.0711 8.25 12 8.25C9.92893 8.25 8.25 9.92893 8.25 12C8.25 14.0711 9.92893 15.75 12 15.75Z"
                                        stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                <p>Помогает обнаружить проблемы, которые тормозят поиск работы на международном рынке и
                                    в СНГ
                                </p>
                            </div>
                            <div class="single-line-svg">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12 15H9V12L18 3L21 6L12 15Z" stroke="black" stroke-width="1.5"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M15.75 5.25L18.75 8.25" stroke="black" stroke-width="1.5"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                    <path
                                        d="M20.25 11.25V19.5C20.25 19.6989 20.171 19.8897 20.0303 20.0303C19.8897 20.171 19.6989 20.25 19.5 20.25H4.5C4.30109 20.25 4.11032 20.171 3.96967 20.0303C3.82902 19.8897 3.75 19.6989 3.75 19.5V4.5C3.75 4.30109 3.82902 4.11032 3.96967 3.96967C4.11032 3.82902 4.30109 3.75 4.5 3.75H12.75"
                                        stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                <p>Бакалавр и магистр психологии</p>
                            </div>
                            <div>
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M12.4123 17.8781L17.1373 20.8781C17.7466 21.2625 18.4966 20.6906 18.3185 19.9875L16.9498 14.6063C16.9127 14.4571 16.9186 14.3005 16.9667 14.1546C17.0148 14.0086 17.1032 13.8792 17.2216 13.7813L21.4591 10.2469C22.0123 9.78752 21.731 8.8594 21.0091 8.81252L15.4779 8.45627C15.327 8.44749 15.1819 8.39494 15.0603 8.30503C14.9388 8.21513 14.8461 8.09177 14.7935 7.95002L12.731 2.75627C12.6764 2.60618 12.5769 2.47653 12.4461 2.38491C12.3153 2.29329 12.1595 2.24414 11.9998 2.24414C11.84 2.24414 11.6842 2.29329 11.5534 2.38491C11.4226 2.47653 11.3231 2.60618 11.2685 2.75627L9.206 7.95002C9.15344 8.09177 9.06072 8.21513 8.93918 8.30503C8.81764 8.39494 8.67255 8.44749 8.52163 8.45627L2.99038 8.81252C2.2685 8.8594 1.98725 9.78752 2.54038 10.2469L6.77788 13.7813C6.89632 13.8792 6.98468 14.0086 7.03278 14.1546C7.08088 14.3005 7.08676 14.4571 7.04975 14.6063L5.78413 19.5938C5.5685 20.4375 6.4685 21.1219 7.19038 20.6625L11.5873 17.8781C11.7105 17.7997 11.8536 17.7581 11.9998 17.7581C12.1459 17.7581 12.289 17.7997 12.4123 17.8781V17.8781Z"
                                        stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                <p>9,7 из 10: средний балл оценки работы от клиентов</p>
                            </div>
                            <div>
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M3 9.75H7.5V19.5H3C2.80109 19.5 2.61032 19.421 2.46967 19.2803C2.32902 19.1397 2.25 18.9489 2.25 18.75V10.5C2.25 10.3011 2.32902 10.1103 2.46967 9.96967C2.61032 9.82902 2.80109 9.75 3 9.75V9.75Z"
                                        stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path
                                        d="M7.5 9.75L11.25 2.25C12.0456 2.25 12.8087 2.56607 13.3713 3.12868C13.9339 3.69129 14.25 4.45435 14.25 5.25V7.5H20.0531C20.2658 7.49947 20.4762 7.54447 20.67 7.63197C20.8639 7.71946 21.0368 7.84743 21.1771 8.00728C21.3174 8.16712 21.4219 8.35514 21.4835 8.55871C21.5451 8.76228 21.5625 8.97667 21.5344 9.1875L20.4094 18.1875C20.3639 18.5488 20.1885 18.8812 19.9159 19.1227C19.6434 19.3642 19.2923 19.4983 18.9281 19.5H7.5"
                                        stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                <p>97% клиентов Софи отмечают: индивидуальный подход, отзывчивость, глубину
                                    рекомендаций и
                                    искреннюю поддержку</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="veb21-author-link">
                    <a href="#buy" class="btn-color-main-dark-orange">Зарегистрироваться бесплатно</a>
                </div>
            </div>
        </div>`
	});
    
    blockManager.add('careerum-veb21-reviews', {
        label: 'Веб 2 отзывы',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-veb21-reviews">
            <div>
                <div class="veb21-reviews-top">
                    <h2>Отзывы о работе с Софи</h2>
                    <div>
                        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M29.2551 23.7881C28.8323 24.1979 28.638 24.7906 28.7343 25.3718L30.1858 33.4046C30.3082 34.0854 30.0209 34.7744 29.4511 35.1679C28.8927 35.5761 28.1498 35.625 27.5408 35.2985L20.3097 31.527C20.0582 31.3931 19.779 31.3213 19.4933 31.3131H19.0509C18.8974 31.336 18.7472 31.385 18.61 31.4601L11.3772 35.2495C11.0197 35.4291 10.6148 35.4928 10.218 35.4291C9.2515 35.2463 8.60659 34.3254 8.76496 33.354L10.218 25.3212C10.3144 24.735 10.1201 24.1391 9.69722 23.7228L3.8016 18.0084C3.30853 17.53 3.1371 16.8116 3.36241 16.1635C3.58119 15.5169 4.13956 15.0451 4.81386 14.9389L12.9283 13.7618C13.5455 13.6981 14.0875 13.3226 14.3651 12.7675L17.9406 5.43673C18.0255 5.27346 18.1349 5.12326 18.2672 4.99591L18.4141 4.88162C18.4908 4.79672 18.579 4.72652 18.677 4.66937L18.8549 4.60406L19.1325 4.48978H19.8199C20.4337 4.55345 20.9742 4.92081 21.2566 5.46939L24.8795 12.7675C25.1408 13.3014 25.6485 13.672 26.2347 13.7618L34.3491 14.9389C35.0348 15.0369 35.6079 15.5104 35.8348 16.1635C36.0487 16.8182 35.8642 17.5365 35.3614 18.0084L29.2551 23.7881Z"
                                fill="#FFC76A" />
                        </svg>
                        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M29.2551 23.7881C28.8323 24.1979 28.638 24.7906 28.7343 25.3718L30.1858 33.4046C30.3082 34.0854 30.0209 34.7744 29.4511 35.1679C28.8927 35.5761 28.1498 35.625 27.5408 35.2985L20.3097 31.527C20.0582 31.3931 19.779 31.3213 19.4933 31.3131H19.0509C18.8974 31.336 18.7472 31.385 18.61 31.4601L11.3772 35.2495C11.0197 35.4291 10.6148 35.4928 10.218 35.4291C9.2515 35.2463 8.60659 34.3254 8.76496 33.354L10.218 25.3212C10.3144 24.735 10.1201 24.1391 9.69722 23.7228L3.8016 18.0084C3.30853 17.53 3.1371 16.8116 3.36241 16.1635C3.58119 15.5169 4.13956 15.0451 4.81386 14.9389L12.9283 13.7618C13.5455 13.6981 14.0875 13.3226 14.3651 12.7675L17.9406 5.43673C18.0255 5.27346 18.1349 5.12326 18.2672 4.99591L18.4141 4.88162C18.4908 4.79672 18.579 4.72652 18.677 4.66937L18.8549 4.60406L19.1325 4.48978H19.8199C20.4337 4.55345 20.9742 4.92081 21.2566 5.46939L24.8795 12.7675C25.1408 13.3014 25.6485 13.672 26.2347 13.7618L34.3491 14.9389C35.0348 15.0369 35.6079 15.5104 35.8348 16.1635C36.0487 16.8182 35.8642 17.5365 35.3614 18.0084L29.2551 23.7881Z"
                                fill="#FFC76A" />
                        </svg>
                        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M29.2551 23.7881C28.8323 24.1979 28.638 24.7906 28.7343 25.3718L30.1858 33.4046C30.3082 34.0854 30.0209 34.7744 29.4511 35.1679C28.8927 35.5761 28.1498 35.625 27.5408 35.2985L20.3097 31.527C20.0582 31.3931 19.779 31.3213 19.4933 31.3131H19.0509C18.8974 31.336 18.7472 31.385 18.61 31.4601L11.3772 35.2495C11.0197 35.4291 10.6148 35.4928 10.218 35.4291C9.2515 35.2463 8.60659 34.3254 8.76496 33.354L10.218 25.3212C10.3144 24.735 10.1201 24.1391 9.69722 23.7228L3.8016 18.0084C3.30853 17.53 3.1371 16.8116 3.36241 16.1635C3.58119 15.5169 4.13956 15.0451 4.81386 14.9389L12.9283 13.7618C13.5455 13.6981 14.0875 13.3226 14.3651 12.7675L17.9406 5.43673C18.0255 5.27346 18.1349 5.12326 18.2672 4.99591L18.4141 4.88162C18.4908 4.79672 18.579 4.72652 18.677 4.66937L18.8549 4.60406L19.1325 4.48978H19.8199C20.4337 4.55345 20.9742 4.92081 21.2566 5.46939L24.8795 12.7675C25.1408 13.3014 25.6485 13.672 26.2347 13.7618L34.3491 14.9389C35.0348 15.0369 35.6079 15.5104 35.8348 16.1635C36.0487 16.8182 35.8642 17.5365 35.3614 18.0084L29.2551 23.7881Z"
                                fill="#FFC76A" />
                        </svg>
                        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M29.2551 23.7881C28.8323 24.1979 28.638 24.7906 28.7343 25.3718L30.1858 33.4046C30.3082 34.0854 30.0209 34.7744 29.4511 35.1679C28.8927 35.5761 28.1498 35.625 27.5408 35.2985L20.3097 31.527C20.0582 31.3931 19.779 31.3213 19.4933 31.3131H19.0509C18.8974 31.336 18.7472 31.385 18.61 31.4601L11.3772 35.2495C11.0197 35.4291 10.6148 35.4928 10.218 35.4291C9.2515 35.2463 8.60659 34.3254 8.76496 33.354L10.218 25.3212C10.3144 24.735 10.1201 24.1391 9.69722 23.7228L3.8016 18.0084C3.30853 17.53 3.1371 16.8116 3.36241 16.1635C3.58119 15.5169 4.13956 15.0451 4.81386 14.9389L12.9283 13.7618C13.5455 13.6981 14.0875 13.3226 14.3651 12.7675L17.9406 5.43673C18.0255 5.27346 18.1349 5.12326 18.2672 4.99591L18.4141 4.88162C18.4908 4.79672 18.579 4.72652 18.677 4.66937L18.8549 4.60406L19.1325 4.48978H19.8199C20.4337 4.55345 20.9742 4.92081 21.2566 5.46939L24.8795 12.7675C25.1408 13.3014 25.6485 13.672 26.2347 13.7618L34.3491 14.9389C35.0348 15.0369 35.6079 15.5104 35.8348 16.1635C36.0487 16.8182 35.8642 17.5365 35.3614 18.0084L29.2551 23.7881Z"
                                fill="#FFC76A" />
                        </svg>
                        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M29.2551 23.7881C28.8323 24.1979 28.638 24.7906 28.7343 25.3718L30.1858 33.4046C30.3082 34.0854 30.0209 34.7744 29.4511 35.1679C28.8927 35.5761 28.1498 35.625 27.5408 35.2985L20.3097 31.527C20.0582 31.3931 19.779 31.3213 19.4933 31.3131H19.0509C18.8974 31.336 18.7472 31.385 18.61 31.4601L11.3772 35.2495C11.0197 35.4291 10.6148 35.4928 10.218 35.4291C9.2515 35.2463 8.60659 34.3254 8.76496 33.354L10.218 25.3212C10.3144 24.735 10.1201 24.1391 9.69722 23.7228L3.8016 18.0084C3.30853 17.53 3.1371 16.8116 3.36241 16.1635C3.58119 15.5169 4.13956 15.0451 4.81386 14.9389L12.9283 13.7618C13.5455 13.6981 14.0875 13.3226 14.3651 12.7675L17.9406 5.43673C18.0255 5.27346 18.1349 5.12326 18.2672 4.99591L18.4141 4.88162C18.4908 4.79672 18.579 4.72652 18.677 4.66937L18.8549 4.60406L19.1325 4.48978H19.8199C20.4337 4.55345 20.9742 4.92081 21.2566 5.46939L24.8795 12.7675C25.1408 13.3014 25.6485 13.672 26.2347 13.7618L34.3491 14.9389C35.0348 15.0369 35.6079 15.5104 35.8348 16.1635C36.0487 16.8182 35.8642 17.5365 35.3614 18.0084L29.2551 23.7881Z"
                                fill="#FFC76A" />
                        </svg>
                    </div>
                </div>
                <div class="veb21-reviews-bottom">
                    <div class="veb21-reviews-item">
                        <h4>Сабина Мурашева </h4>
                        <p>«Софи, хотела еще раз поблагодарить вас за проделанную работу и поддержку на протяжении всего
                            периода 😊. После пересмотра резюме и профиля Li, поняла, как действительно показывать свои
                            достижения (обязанность-описание и результат). Появилась уверенность в себе, как в сотруднике,
                            т.к. раньше казалось, что я ничего такого и не делала, а все результаты — заслуга команды.
                            Дополнительно, проработав раздел о себе на LinkedIn, в голове сложилась самопрезентация для
                            интервью.</p>
                        <p>Все о чем вы говорили, оказалось ценными знаниями. Забираю их с собой в будущее!»</p>
                    </div>
                    <div class="veb21-reviews-item">
                        <h4>Сабина Мурашева </h4>
                        <p>«Софи, хотела еще раз поблагодарить вас за проделанную работу и поддержку на протяжении всего
                            периода 😊. После пересмотра резюме и профиля Li, поняла, как действительно показывать свои
                            достижения (обязанность-описание и результат). Появилась уверенность в себе, как в сотруднике,
                            т.к. раньше казалось, что я ничего такого и не делала, а все результаты — заслуга команды.
                            Дополнительно, проработав раздел о себе на LinkedIn, в голове сложилась самопрезентация для
                            интервью.</p>
                        <p>Все о чем вы говорили, оказалось ценными знаниями. Забираю их с собой в будущее!»</p>
                    </div>
                    <div class="veb21-reviews-item">
                        <h4>Сабина Мурашева </h4>
                        <p>«Софи, хотела еще раз поблагодарить вас за проделанную работу и поддержку на протяжении всего
                            периода 😊. После пересмотра резюме и профиля Li, поняла, как действительно показывать свои
                            достижения (обязанность-описание и результат). Появилась уверенность в себе, как в сотруднике,
                            т.к. раньше казалось, что я ничего такого и не делала, а все результаты — заслуга команды.
                            Дополнительно, проработав раздел о себе на LinkedIn, в голове сложилась самопрезентация для
                            интервью.</p>
                        <p>Все о чем вы говорили, оказалось ценными знаниями. Забираю их с собой в будущее!»</p>
                    </div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-veb21-reviews-tablet', {
        label: 'Веб 2 отзывы (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-veb21-reviews-tablet">
            <div>
                <div class="veb21-reviews-top">
                    <h2>Отзывы о работе с Софи</h2>
                    <div>
                        <svg width="28" height="29" viewBox="0 0 28 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M20.3854 17.1397C20.0908 17.4253 19.9554 17.8383 20.0225 18.2433L21.0339 23.8408C21.1192 24.3152 20.919 24.7953 20.522 25.0695C20.1329 25.354 19.6152 25.3881 19.1908 25.1605L14.1519 22.5324C13.9767 22.4391 13.7822 22.3891 13.5831 22.3834H13.2748C13.1678 22.3993 13.0631 22.4335 12.9676 22.4858L7.92754 25.1264C7.67838 25.2516 7.39623 25.2959 7.11977 25.2516C6.44624 25.1241 5.99685 24.4825 6.10721 23.8055L7.11977 18.208C7.18689 17.7996 7.0515 17.3843 6.75684 17.0942L2.64858 13.1122C2.30499 12.7789 2.18553 12.2783 2.34254 11.8266C2.49499 11.3761 2.88408 11.0473 3.35396 10.9733L9.00836 10.1531C9.43841 10.1087 9.81613 9.84701 10.0095 9.46019L12.5011 4.35189C12.5603 4.23812 12.6365 4.13345 12.7287 4.04471L12.8311 3.96507C12.8845 3.90591 12.946 3.85698 13.0142 3.81716L13.1382 3.77166L13.3316 3.69202H13.8106C14.2384 3.73639 14.615 3.99237 14.8118 4.37464L17.3364 9.46019C17.5184 9.83222 17.8722 10.0905 18.2807 10.1531L23.9351 10.9733C24.4129 11.0416 24.8122 11.3715 24.9704 11.8266C25.1194 12.2828 24.9909 12.7834 24.6405 13.1122L20.3854 17.1397Z"
                                fill="#FFC76A" />
                        </svg>
                        <svg width="28" height="29" viewBox="0 0 28 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M20.3854 17.1397C20.0908 17.4253 19.9554 17.8383 20.0225 18.2433L21.0339 23.8408C21.1192 24.3152 20.919 24.7953 20.522 25.0695C20.1329 25.354 19.6152 25.3881 19.1908 25.1605L14.1519 22.5324C13.9767 22.4391 13.7822 22.3891 13.5831 22.3834H13.2748C13.1678 22.3993 13.0631 22.4335 12.9676 22.4858L7.92754 25.1264C7.67838 25.2516 7.39623 25.2959 7.11977 25.2516C6.44624 25.1241 5.99685 24.4825 6.10721 23.8055L7.11977 18.208C7.18689 17.7996 7.0515 17.3843 6.75684 17.0942L2.64858 13.1122C2.30499 12.7789 2.18553 12.2783 2.34254 11.8266C2.49499 11.3761 2.88408 11.0473 3.35396 10.9733L9.00836 10.1531C9.43841 10.1087 9.81613 9.84701 10.0095 9.46019L12.5011 4.35189C12.5603 4.23812 12.6365 4.13345 12.7287 4.04471L12.8311 3.96507C12.8845 3.90591 12.946 3.85698 13.0142 3.81716L13.1382 3.77166L13.3316 3.69202H13.8106C14.2384 3.73639 14.615 3.99237 14.8118 4.37464L17.3364 9.46019C17.5184 9.83222 17.8722 10.0905 18.2807 10.1531L23.9351 10.9733C24.4129 11.0416 24.8122 11.3715 24.9704 11.8266C25.1194 12.2828 24.9909 12.7834 24.6405 13.1122L20.3854 17.1397Z"
                                fill="#FFC76A" />
                        </svg>
                        <svg width="28" height="29" viewBox="0 0 28 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M20.3854 17.1397C20.0908 17.4253 19.9554 17.8383 20.0225 18.2433L21.0339 23.8408C21.1192 24.3152 20.919 24.7953 20.522 25.0695C20.1329 25.354 19.6152 25.3881 19.1908 25.1605L14.1519 22.5324C13.9767 22.4391 13.7822 22.3891 13.5831 22.3834H13.2748C13.1678 22.3993 13.0631 22.4335 12.9676 22.4858L7.92754 25.1264C7.67838 25.2516 7.39623 25.2959 7.11977 25.2516C6.44624 25.1241 5.99685 24.4825 6.10721 23.8055L7.11977 18.208C7.18689 17.7996 7.0515 17.3843 6.75684 17.0942L2.64858 13.1122C2.30499 12.7789 2.18553 12.2783 2.34254 11.8266C2.49499 11.3761 2.88408 11.0473 3.35396 10.9733L9.00836 10.1531C9.43841 10.1087 9.81613 9.84701 10.0095 9.46019L12.5011 4.35189C12.5603 4.23812 12.6365 4.13345 12.7287 4.04471L12.8311 3.96507C12.8845 3.90591 12.946 3.85698 13.0142 3.81716L13.1382 3.77166L13.3316 3.69202H13.8106C14.2384 3.73639 14.615 3.99237 14.8118 4.37464L17.3364 9.46019C17.5184 9.83222 17.8722 10.0905 18.2807 10.1531L23.9351 10.9733C24.4129 11.0416 24.8122 11.3715 24.9704 11.8266C25.1194 12.2828 24.9909 12.7834 24.6405 13.1122L20.3854 17.1397Z"
                                fill="#FFC76A" />
                        </svg>
                        <svg width="28" height="29" viewBox="0 0 28 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M20.3854 17.1397C20.0908 17.4253 19.9554 17.8383 20.0225 18.2433L21.0339 23.8408C21.1192 24.3152 20.919 24.7953 20.522 25.0695C20.1329 25.354 19.6152 25.3881 19.1908 25.1605L14.1519 22.5324C13.9767 22.4391 13.7822 22.3891 13.5831 22.3834H13.2748C13.1678 22.3993 13.0631 22.4335 12.9676 22.4858L7.92754 25.1264C7.67838 25.2516 7.39623 25.2959 7.11977 25.2516C6.44624 25.1241 5.99685 24.4825 6.10721 23.8055L7.11977 18.208C7.18689 17.7996 7.0515 17.3843 6.75684 17.0942L2.64858 13.1122C2.30499 12.7789 2.18553 12.2783 2.34254 11.8266C2.49499 11.3761 2.88408 11.0473 3.35396 10.9733L9.00836 10.1531C9.43841 10.1087 9.81613 9.84701 10.0095 9.46019L12.5011 4.35189C12.5603 4.23812 12.6365 4.13345 12.7287 4.04471L12.8311 3.96507C12.8845 3.90591 12.946 3.85698 13.0142 3.81716L13.1382 3.77166L13.3316 3.69202H13.8106C14.2384 3.73639 14.615 3.99237 14.8118 4.37464L17.3364 9.46019C17.5184 9.83222 17.8722 10.0905 18.2807 10.1531L23.9351 10.9733C24.4129 11.0416 24.8122 11.3715 24.9704 11.8266C25.1194 12.2828 24.9909 12.7834 24.6405 13.1122L20.3854 17.1397Z"
                                fill="#FFC76A" />
                        </svg>
                        <svg width="28" height="29" viewBox="0 0 28 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M20.3854 17.1397C20.0908 17.4253 19.9554 17.8383 20.0225 18.2433L21.0339 23.8408C21.1192 24.3152 20.919 24.7953 20.522 25.0695C20.1329 25.354 19.6152 25.3881 19.1908 25.1605L14.1519 22.5324C13.9767 22.4391 13.7822 22.3891 13.5831 22.3834H13.2748C13.1678 22.3993 13.0631 22.4335 12.9676 22.4858L7.92754 25.1264C7.67838 25.2516 7.39623 25.2959 7.11977 25.2516C6.44624 25.1241 5.99685 24.4825 6.10721 23.8055L7.11977 18.208C7.18689 17.7996 7.0515 17.3843 6.75684 17.0942L2.64858 13.1122C2.30499 12.7789 2.18553 12.2783 2.34254 11.8266C2.49499 11.3761 2.88408 11.0473 3.35396 10.9733L9.00836 10.1531C9.43841 10.1087 9.81613 9.84701 10.0095 9.46019L12.5011 4.35189C12.5603 4.23812 12.6365 4.13345 12.7287 4.04471L12.8311 3.96507C12.8845 3.90591 12.946 3.85698 13.0142 3.81716L13.1382 3.77166L13.3316 3.69202H13.8106C14.2384 3.73639 14.615 3.99237 14.8118 4.37464L17.3364 9.46019C17.5184 9.83222 17.8722 10.0905 18.2807 10.1531L23.9351 10.9733C24.4129 11.0416 24.8122 11.3715 24.9704 11.8266C25.1194 12.2828 24.9909 12.7834 24.6405 13.1122L20.3854 17.1397Z"
                                fill="#FFC76A" />
                        </svg>
                    </div>
                </div>
                <div class="veb21-reviews-slider">
                    <div class="veb21-reviews-item">
                        <h4>Сабина Мурашева </h4>
                        <p>«Софи, хотела еще раз поблагодарить вас за проделанную работу и поддержку на протяжении всего
                            периода 😊. После пересмотра резюме и профиля Li, поняла, как действительно показывать свои
                            достижения (обязанность-описание и результат). Появилась уверенность в себе, как в сотруднике,
                            т.к. раньше казалось, что я ничего такого и не делала, а все результаты — заслуга команды.
                            Дополнительно, проработав раздел о себе на LinkedIn, в голове сложилась самопрезентация для
                            интервью.</p>
                        <p>Все о чем вы говорили, оказалось ценными знаниями. Забираю их с собой в будущее!»</p>
                    </div>
                    <div class="veb21-reviews-item">
                        <h4>Сабина Мурашева </h4>
                        <p>«Софи, хотела еще раз поблагодарить вас за проделанную работу и поддержку на протяжении всего
                            периода 😊. После пересмотра резюме и профиля Li, поняла, как действительно показывать свои
                            достижения (обязанность-описание и результат). Появилась уверенность в себе, как в сотруднике,
                            т.к. раньше казалось, что я ничего такого и не делала, а все результаты — заслуга команды.
                            Дополнительно, проработав раздел о себе на LinkedIn, в голове сложилась самопрезентация для
                            интервью.</p>
                        <p>Все о чем вы говорили, оказалось ценными знаниями. Забираю их с собой в будущее!»</p>
                    </div>
                    <div class="veb21-reviews-item">
                        <h4>Сабина Мурашева </h4>
                        <p>«Софи, хотела еще раз поблагодарить вас за проделанную работу и поддержку на протяжении всего
                            периода 😊. После пересмотра резюме и профиля Li, поняла, как действительно показывать свои
                            достижения (обязанность-описание и результат). Появилась уверенность в себе, как в сотруднике,
                            т.к. раньше казалось, что я ничего такого и не делала, а все результаты — заслуга команды.
                            Дополнительно, проработав раздел о себе на LinkedIn, в голове сложилась самопрезентация для
                            интервью.</p>
                        <p>Все о чем вы говорили, оказалось ценными знаниями. Забираю их с собой в будущее!»</p>
                    </div>
                </div>
                <div class="veb21-reviews-slider-nav">
                    <div class="veb21-reviews-slider-next">
                        <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M15.8095 8.00065L2.18945 8.00065" stroke="white" stroke-width="2.64201"
                                stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M9.53711 1.75471L15.8104 8.00138L9.53711 14.248" stroke="white" stroke-width="2.64201"
                                stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-veb21-reviews-mobile', {
        label: 'Веб 2 отзывы (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-veb21-reviews-mobile">
            <div>
                <div class="veb21-reviews-top">
                    <h2>Отзывы о работе с Софи</h2>
                    <div>
                        <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M19.3274 15.4458C19.0481 15.7165 18.9197 16.108 18.9833 16.492L19.9422 21.7988C20.0231 22.2485 19.8333 22.7037 19.4568 22.9636C19.088 23.2333 18.5972 23.2657 18.1949 23.0499L13.4177 20.5584C13.2516 20.4699 13.0672 20.4225 12.8784 20.4171H12.5861C12.4847 20.4322 12.3855 20.4645 12.2949 20.5141L7.51668 23.0176C7.28047 23.1362 7.01297 23.1783 6.75087 23.1362C6.11234 23.0154 5.68629 22.4071 5.79091 21.7653L6.75087 16.4586C6.81451 16.0714 6.68616 15.6777 6.4068 15.4026L2.51195 11.6275C2.18621 11.3115 2.07296 10.8369 2.22181 10.4087C2.36634 9.98155 2.73523 9.66984 3.18069 9.59973L8.54136 8.82205C8.94907 8.77999 9.30717 8.53191 9.49053 8.16518L11.8527 3.32225C11.9088 3.21439 11.981 3.11515 12.0684 3.03102L12.1655 2.95552C12.2162 2.89943 12.2744 2.85305 12.3391 2.8153L12.4567 2.77216L12.6401 2.69666H13.0941C13.4997 2.73872 13.8567 2.98141 14.0433 3.34382L16.4367 8.16518C16.6093 8.51789 16.9448 8.76273 17.332 8.82205L22.6927 9.59973C23.1457 9.66444 23.5243 9.97724 23.6742 10.4087C23.8155 10.8412 23.6936 11.3158 23.3614 11.6275L19.3274 15.4458Z"
                                fill="#FFC76A" />
                        </svg>
                        <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M19.3274 15.4458C19.0481 15.7165 18.9197 16.108 18.9833 16.492L19.9422 21.7988C20.0231 22.2485 19.8333 22.7037 19.4568 22.9636C19.088 23.2333 18.5972 23.2657 18.1949 23.0499L13.4177 20.5584C13.2516 20.4699 13.0672 20.4225 12.8784 20.4171H12.5861C12.4847 20.4322 12.3855 20.4645 12.2949 20.5141L7.51668 23.0176C7.28047 23.1362 7.01297 23.1783 6.75087 23.1362C6.11234 23.0154 5.68629 22.4071 5.79091 21.7653L6.75087 16.4586C6.81451 16.0714 6.68616 15.6777 6.4068 15.4026L2.51195 11.6275C2.18621 11.3115 2.07296 10.8369 2.22181 10.4087C2.36634 9.98155 2.73523 9.66984 3.18069 9.59973L8.54136 8.82205C8.94907 8.77999 9.30717 8.53191 9.49053 8.16518L11.8527 3.32225C11.9088 3.21439 11.981 3.11515 12.0684 3.03102L12.1655 2.95552C12.2162 2.89943 12.2744 2.85305 12.3391 2.8153L12.4567 2.77216L12.6401 2.69666H13.0941C13.4997 2.73872 13.8567 2.98141 14.0433 3.34382L16.4367 8.16518C16.6093 8.51789 16.9448 8.76273 17.332 8.82205L22.6927 9.59973C23.1457 9.66444 23.5243 9.97724 23.6742 10.4087C23.8155 10.8412 23.6936 11.3158 23.3614 11.6275L19.3274 15.4458Z"
                                fill="#FFC76A" />
                        </svg>
                        <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M19.3274 15.4458C19.0481 15.7165 18.9197 16.108 18.9833 16.492L19.9422 21.7988C20.0231 22.2485 19.8333 22.7037 19.4568 22.9636C19.088 23.2333 18.5972 23.2657 18.1949 23.0499L13.4177 20.5584C13.2516 20.4699 13.0672 20.4225 12.8784 20.4171H12.5861C12.4847 20.4322 12.3855 20.4645 12.2949 20.5141L7.51668 23.0176C7.28047 23.1362 7.01297 23.1783 6.75087 23.1362C6.11234 23.0154 5.68629 22.4071 5.79091 21.7653L6.75087 16.4586C6.81451 16.0714 6.68616 15.6777 6.4068 15.4026L2.51195 11.6275C2.18621 11.3115 2.07296 10.8369 2.22181 10.4087C2.36634 9.98155 2.73523 9.66984 3.18069 9.59973L8.54136 8.82205C8.94907 8.77999 9.30717 8.53191 9.49053 8.16518L11.8527 3.32225C11.9088 3.21439 11.981 3.11515 12.0684 3.03102L12.1655 2.95552C12.2162 2.89943 12.2744 2.85305 12.3391 2.8153L12.4567 2.77216L12.6401 2.69666H13.0941C13.4997 2.73872 13.8567 2.98141 14.0433 3.34382L16.4367 8.16518C16.6093 8.51789 16.9448 8.76273 17.332 8.82205L22.6927 9.59973C23.1457 9.66444 23.5243 9.97724 23.6742 10.4087C23.8155 10.8412 23.6936 11.3158 23.3614 11.6275L19.3274 15.4458Z"
                                fill="#FFC76A" />
                        </svg>
                        <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M19.3274 15.4458C19.0481 15.7165 18.9197 16.108 18.9833 16.492L19.9422 21.7988C20.0231 22.2485 19.8333 22.7037 19.4568 22.9636C19.088 23.2333 18.5972 23.2657 18.1949 23.0499L13.4177 20.5584C13.2516 20.4699 13.0672 20.4225 12.8784 20.4171H12.5861C12.4847 20.4322 12.3855 20.4645 12.2949 20.5141L7.51668 23.0176C7.28047 23.1362 7.01297 23.1783 6.75087 23.1362C6.11234 23.0154 5.68629 22.4071 5.79091 21.7653L6.75087 16.4586C6.81451 16.0714 6.68616 15.6777 6.4068 15.4026L2.51195 11.6275C2.18621 11.3115 2.07296 10.8369 2.22181 10.4087C2.36634 9.98155 2.73523 9.66984 3.18069 9.59973L8.54136 8.82205C8.94907 8.77999 9.30717 8.53191 9.49053 8.16518L11.8527 3.32225C11.9088 3.21439 11.981 3.11515 12.0684 3.03102L12.1655 2.95552C12.2162 2.89943 12.2744 2.85305 12.3391 2.8153L12.4567 2.77216L12.6401 2.69666H13.0941C13.4997 2.73872 13.8567 2.98141 14.0433 3.34382L16.4367 8.16518C16.6093 8.51789 16.9448 8.76273 17.332 8.82205L22.6927 9.59973C23.1457 9.66444 23.5243 9.97724 23.6742 10.4087C23.8155 10.8412 23.6936 11.3158 23.3614 11.6275L19.3274 15.4458Z"
                                fill="#FFC76A" />
                        </svg>
                        <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M19.3274 15.4458C19.0481 15.7165 18.9197 16.108 18.9833 16.492L19.9422 21.7988C20.0231 22.2485 19.8333 22.7037 19.4568 22.9636C19.088 23.2333 18.5972 23.2657 18.1949 23.0499L13.4177 20.5584C13.2516 20.4699 13.0672 20.4225 12.8784 20.4171H12.5861C12.4847 20.4322 12.3855 20.4645 12.2949 20.5141L7.51668 23.0176C7.28047 23.1362 7.01297 23.1783 6.75087 23.1362C6.11234 23.0154 5.68629 22.4071 5.79091 21.7653L6.75087 16.4586C6.81451 16.0714 6.68616 15.6777 6.4068 15.4026L2.51195 11.6275C2.18621 11.3115 2.07296 10.8369 2.22181 10.4087C2.36634 9.98155 2.73523 9.66984 3.18069 9.59973L8.54136 8.82205C8.94907 8.77999 9.30717 8.53191 9.49053 8.16518L11.8527 3.32225C11.9088 3.21439 11.981 3.11515 12.0684 3.03102L12.1655 2.95552C12.2162 2.89943 12.2744 2.85305 12.3391 2.8153L12.4567 2.77216L12.6401 2.69666H13.0941C13.4997 2.73872 13.8567 2.98141 14.0433 3.34382L16.4367 8.16518C16.6093 8.51789 16.9448 8.76273 17.332 8.82205L22.6927 9.59973C23.1457 9.66444 23.5243 9.97724 23.6742 10.4087C23.8155 10.8412 23.6936 11.3158 23.3614 11.6275L19.3274 15.4458Z"
                                fill="#FFC76A" />
                        </svg>
                    </div>
                </div>
                <div class="veb21-reviews-slider">
                    <div class="veb21-reviews-item">
                        <h4>Сабина Мурашева </h4>
                        <p>«Софи, хотела еще раз поблагодарить вас за проделанную работу и поддержку на протяжении всего
                            периода 😊. После пересмотра резюме и профиля Li, поняла, как действительно показывать свои
                            достижения (обязанность-описание и результат). Появилась уверенность в себе, как в сотруднике,
                            т.к. раньше казалось, что я ничего такого и не делала, а все результаты — заслуга команды.
                            Дополнительно, проработав раздел о себе на LinkedIn, в голове сложилась самопрезентация для
                            интервью.</p>
                        <p>Все о чем вы говорили, оказалось ценными знаниями. Забираю их с собой в будущее!»</p>
                    </div>
                    <div class="veb21-reviews-item">
                        <h4>Сабина Мурашева </h4>
                        <p>«Софи, хотела еще раз поблагодарить вас за проделанную работу и поддержку на протяжении всего
                            периода 😊. После пересмотра резюме и профиля Li, поняла, как действительно показывать свои
                            достижения (обязанность-описание и результат). Появилась уверенность в себе, как в сотруднике,
                            т.к. раньше казалось, что я ничего такого и не делала, а все результаты — заслуга команды.
                            Дополнительно, проработав раздел о себе на LinkedIn, в голове сложилась самопрезентация для
                            интервью.</p>
                        <p>Все о чем вы говорили, оказалось ценными знаниями. Забираю их с собой в будущее!»</p>
                    </div>
                    <div class="veb21-reviews-item">
                        <h4>Сабина Мурашева </h4>
                        <p>«Софи, хотела еще раз поблагодарить вас за проделанную работу и поддержку на протяжении всего
                            периода 😊. После пересмотра резюме и профиля Li, поняла, как действительно показывать свои
                            достижения (обязанность-описание и результат). Появилась уверенность в себе, как в сотруднике,
                            т.к. раньше казалось, что я ничего такого и не делала, а все результаты — заслуга команды.
                            Дополнительно, проработав раздел о себе на LinkedIn, в голове сложилась самопрезентация для
                            интервью.</p>
                        <p>Все о чем вы говорили, оказалось ценными знаниями. Забираю их с собой в будущее!»</p>
                    </div>
                </div>
                <div class="veb21-reviews-slider-nav">
                    <div class="veb21-reviews-slider-next">
                        <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M15.8095 8.00065L2.18945 8.00065" stroke="white" stroke-width="2.64201"
                                stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M9.53711 1.75471L15.8104 8.00138L9.53711 14.248" stroke="white" stroke-width="2.64201"
                                stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </div>
                </div>
            </div>
        </div>`
	});
    
    blockManager.add('careerum-veb22-main', {
        label: 'Запись веба главный',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-veb22-main" data-redirect="no" data-url="" data-static="yes" data-offset=""
            data-timer-end="06/19/2024 22:05 GMT+0300" data-src="ba39-CyJS5w">
            <div>
                <div class="veb22-main-left">
                    <h1>Запись вебинара</h1>
                    <p>Доступ к записи и действие специального предложения закончится через</p>
                    <svg width="191" height="5" viewBox="0 0 191 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M2 2.99991C125.328 0.7497 99.7241 3 189 3" stroke="#FF5A00" stroke-width="3"
                            stroke-linecap="round" />
                    </svg>
                    <div class="veb22-main-timer">
                        <div>
                            <p class="timer-day-number">00</p>
                            <p class="timer-day-text"></p>
                        </div>
                        <div>
                            <p class="timer-hour-number">00</p>
                            <p class="timer-hour-text"></p>
                        </div>
                        <div>
                            <p class="timer-min-number">00</p>
                            <p class="timer-min-text"></p>
                        </div>
                        <div>
                            <p class="timer-sec-number">00</p>
                            <p class="timer-sec-text"></p>
                        </div>
                    </div>
                </div>
                <div class="veb22-main-right">
                    <div class="veb22-main-videowrapper">
                        <iframe class="veb22-main-frame" src="" frameborder="0" allowfullscreen 
                            width="600" height="338" allow="autoplay"></iframe>
                        <button class="veb22-main-button">
                            <svg width="80" height="79" viewBox="0 0 80 79" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M39.9999 76.5002C60.3792 76.5002 76.8998 59.9795 76.8998 39.6002C76.8998 19.2209 60.3792 2.7002 39.9999 2.7002C19.6205 2.7002 3.09985 19.2209 3.09985 39.6002C3.09985 59.9795 19.6205 76.5002 39.9999 76.5002Z"
                                    fill="black" fill-opacity="0.7" stroke="white" stroke-width="4.8"
                                    stroke-miterlimit="10" />
                                <path d="M52.2999 39.6008L33.8499 27.3008V51.9008L52.2999 39.6008Z" stroke="white"
                                    stroke-width="4.8" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </button>
                    </div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-veb22-main-tablet', {
        label: 'Запись веба главный (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-veb22-main-tablet" data-redirect="no" data-url="" data-static="yes" data-offset=""
            data-timer-end="06/19/2024 22:05 GMT+0300"  data-src="ba39-CyJS5w">
            <div>
                <div class="veb22-main-left">
                    <h2>Запись вебинара</h2>
                    <svg width="188" height="3" viewBox="0 0 188 3" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 1.99951C62.7578 -0.249674 146.069 2 187 2" stroke="#FF5A00" stroke-width="2"
                            stroke-linecap="round" />
                    </svg>
                    <div class="veb22-main-videowrapper">
                        <iframe class="veb22-main-frame" src="" frameborder="0" allowfullscreen width="680" height="381" allow="autoplay"></iframe>
                        <button class="veb22-main-button">
                            <svg width="80" height="79" viewBox="0 0 80 79" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M39.9999 76.5002C60.3792 76.5002 76.8998 59.9795 76.8998 39.6002C76.8998 19.2209 60.3792 2.7002 39.9999 2.7002C19.6205 2.7002 3.09985 19.2209 3.09985 39.6002C3.09985 59.9795 19.6205 76.5002 39.9999 76.5002Z"
                                    fill="black" fill-opacity="0.7" stroke="white" stroke-width="4.8"
                                    stroke-miterlimit="10" />
                                <path d="M52.2999 39.6008L33.8499 27.3008V51.9008L52.2999 39.6008Z" stroke="white"
                                    stroke-width="4.8" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </button>
                    </div>
                </div>
                <div class="veb22-main-right">
                    <div class="veb22-main-timer">
                        <p class="veb22-main-timer-subheader">Доступ к записи и действие специального предложения закончится
                            через</p>
                        <div>
                            <p class="timer-day-number">00</p>
                            <p class="timer-day-text"></p>
                        </div>
                        <div>
                            <p class="timer-hour-number">00</p>
                            <p class="timer-hour-text"></p>
                        </div>
                        <div>
                            <p class="timer-min-number">00</p>
                            <p class="timer-min-text"></p>
                        </div>
                        <div>
                            <p class="timer-sec-number">00</p>
                            <p class="timer-sec-text"></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-veb22-main-mobile', {
        label: 'Запись веба главный (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-veb22-main-mobile" data-redirect="no" data-url="" data-static="yes" data-offset=""
            data-timer-end="06/19/2024 22:05 GMT+0300" data-src="ba39-CyJS5w">
            <div>
                <div class="veb22-main-left">
                    <h2>Запись вебинара</h2>
                    <svg width="188" height="3" viewBox="0 0 188 3" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 1.99951C62.7578 -0.249674 146.069 2 187 2" stroke="#FF5A00" stroke-width="2"
                            stroke-linecap="round" />
                    </svg>
                    <div class="veb22-main-videowrapper">
                        <iframe class="veb22-main-frame" src="" frameborder="0" allowfullscreen 
                            allow="autoplay"></iframe>
                        <button class="veb22-main-button">
                            <svg width="41" height="41" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M20.7719 39.3338C31.2178 39.3338 39.6858 30.8657 39.6858 20.4198C39.6858 9.97394 31.2178 1.50586 20.7719 1.50586C10.326 1.50586 1.85788 9.97394 1.85788 20.4198C1.85788 30.8657 10.326 39.3338 20.7719 39.3338Z"
                                    fill="black" fill-opacity="0.7" stroke="white" stroke-width="2.46036"
                                    stroke-miterlimit="10" />
                                <path d="M27.0765 20.4199L17.6195 14.1152V26.7246L27.0765 20.4199Z" stroke="white"
                                    stroke-width="2.46036" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </button>
                    </div>
                </div>
                <div class="veb22-main-right">
                    <div class="veb22-main-timer">
                        <p class="veb22-main-timer-subheader">Доступ к записи и действие специального предложения закончится
                            через</p>
                        <div>
                            <p class="timer-day-number">00</p>
                            <p class="timer-day-text"></p>
                        </div>
                        <div>
                            <p class="timer-hour-number">00</p>
                            <p class="timer-hour-text"></p>
                        </div>
                        <div>
                            <p class="timer-min-number">00</p>
                            <p class="timer-min-text"></p>
                        </div>
                        <div>
                            <p class="timer-sec-number">00</p>
                            <p class="timer-sec-text"></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
	});
    
    blockManager.add('veb22-tariffs', {
        label: 'Запись веба тарифы',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div custom-anchor="" js-hide-script="" hide-by-geo="unset" custom-link-anchor="buy"
            class="careerum-club21-tariffs veb22-tariffs">
            <div>
                <div>
                    <h2>Скидки по промокоду OFFER2024</h2>
                    <p class="veb22-tariffs-subheader">Сумма пересчитается после ввода промокода на странице оформления
                        заказа</p>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1718706035943-WWA48-Vect.png" alt="">
                    <div class="club21-tariffs__swicher-block">
                        <div class="club21-tariffs__swicher-top">
                            <p class="club21-tariffs__swicher-header">Посмотреть цены в <span>RUB</span></p><svg
                                xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                                class="club21-tariffs__swicher-arrow">
                                <path d="M7 9.5L12 14.5L17 9.5H7Z" fill="black"></path>
                            </svg>
                        </div>
                        <div class="club21-tariffs__swicher-bottom">
                            <ul>
                                <li data-currency="RUB">
                                    RUB
                                </li>
                                <li data-currency="EUR" class="active">
                                    EUR
                                </li>
                            </ul>
                            <p>
                                Обратите внимание,<br> что оплата в российских рублях возможна только<br> с карты
                                российского банка. Оплата в евро — с карты зарубежного банка
                            </p>
                        </div>
                    </div>
                </div>
                <div class="club21-tariffs-wrapper">
                    <div data-tariff-switcher="" data-price-eur="€ 149" data-price-rub="&nbsp;₽ 12 900"  data-price-old-eur="€ 149" data-price-old-rub="12&nbsp;900 ₽"
                        data-link-rub="#club2-solo-rub" data-link-eur="#club2-solo-eur" class="club21-tariffs-item">
                        <p class="club21-tariffs-item__header">Тариф «Самостоятельный»</p>
                        <div class="club21-tariffs-item__rassr">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24"
                                height="24" viewBox="0 0 24 24" fill="none">
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                    d="M2 12C2 6.47784 6.47673 2 12 2C17.5222 2 22 6.47779 22 12C22 17.5222 17.5222 22 12 22C6.47673 22 2 17.5222 2 12ZM16.0898 10.1573C16.3827 9.86439 16.3827 9.38952 16.0898 9.09662C15.7969 8.80373 15.322 8.80373 15.0291 9.09662L10.8133 13.3124L8.96967 11.4695C8.67672 11.1767 8.20184 11.1768 7.90901 11.4697C7.61618 11.7627 7.61628 12.2376 7.90924 12.5304L10.2832 14.9034C10.5761 15.1962 11.0509 15.1961 11.3438 14.9033L16.0898 10.1573Z"
                                    fill="#0B70FE"></path>
                            </svg>
                            <p class="club21-tariffs-item__rassr-text-RUB" style="display: none;">Доступно в рассрочку</p>
                            <p class="club21-tariffs-item__rassr-text-EUR">Можно оплатить долями</p>
                        </div>
                        <div class="club21-tariffs-item__price">
                            <p class="club21-tariffs-item__price-text-before">до&nbsp;&nbsp;</p>
                            <p class="club21-tariffs-item__price-text">€ 149</p>
                            <p class="club21-tariffs-item__price-text-divider">/</p>
                            <p class="club21-tariffs-item__price-text-before">месяц</p>
                        </div>
                        <div class="club21-tariffs-item__content">
                            <ul>
                                <li>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1718707781201-LT95u-Play.png"
                                        alt="">
                                    <p>Курс по поиску работы «Звездный кандидат»</p>
                                </li>
                                <li><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1718707781201-LT95u-Play.png"
                                        alt="">
                                    <p>Курс «Международная карьера и релокация»</p>
                                </li>
                                <li><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1718707787277-yTcpr-Note.png"
                                        alt="">
                                    <p>Еще 18 курсов по развитию карьеры</p>
                                </li>
                                <li><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1718707784552-4q6k6-Lock.png"
                                        alt="">
                                    <p>Доступ к нетворк-платформе</p>
                                </li>
                            </ul>
                        </div>
                        <a onclick="" href="#club2-solo-eur" class="btn-color-main-dark-orange">Оформить подписку</a>
                    </div>
                    <div data-tariff-switcher="" data-price-eur="&nbsp;€ 169" data-price-rub="&nbsp;₽ 12 665"
                        data-link-rub="#club2-supports-rub" data-link-eur="#club2-supports-eur" data-price-old-eur="199" data-price-old-rub="14900" class="club21-tariffs-item">
                        <p class="club21-tariffs-item__header">Тариф<br> «С поддержкой»</p>
                        <div class="club21-tariffs-item__label">
                            <p>–15%</p>
                        </div>
                        <div class="club21-tariffs-item__rassr">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24"
                                height="24" viewBox="0 0 24 24" fill="none">
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                    d="M2 12C2 6.47784 6.47673 2 12 2C17.5222 2 22 6.47779 22 12C22 17.5222 17.5222 22 12 22C6.47673 22 2 17.5222 2 12ZM16.0898 10.1573C16.3827 9.86439 16.3827 9.38952 16.0898 9.09662C15.7969 8.80373 15.322 8.80373 15.0291 9.09662L10.8133 13.3124L8.96967 11.4695C8.67672 11.1767 8.20184 11.1768 7.90901 11.4697C7.61618 11.7627 7.61628 12.2376 7.90924 12.5304L10.2832 14.9034C10.5761 15.1962 11.0509 15.1961 11.3438 14.9033L16.0898 10.1573Z"
                                    fill="#0B70FE"></path>
                            </svg>
                            <p class="club21-tariffs-item__rassr-text-RUB" style="display: none;">Доступно в рассрочку</p>
                            <p class="club21-tariffs-item__rassr-text-EUR">Можно оплатить долями</p>
                        </div>
                        <div class="club21-tariffs-item__price">
                            <p class="club21-tariffs-item__price-text-before">до&nbsp;&nbsp;</p>
                            <p class="club21-tariffs-item__price-text-old">44444</p>
                            <p class="club21-tariffs-item__price-text">€ 149</p>
                            <p class="club21-tariffs-item__price-text-divider">/</p>
                            <p class="club21-tariffs-item__price-text-before">месяц</p>
                        </div>
                        <div class="club21-tariffs-item__content content-bold">
                            <ul>
                                <li>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1718708437051-Oh6ZP-Fram.png"
                                        alt="">
                                    <p>Разбор вашего резюме</p>
                                </li>
                                <li><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1718708437051-Oh6ZP-Fram.png"
                                        alt="">
                                    <p>Поддержка карьерного эксперта в чате</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club21-tariffs-item__content">
                            <ul>
                                <li>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1718707781201-LT95u-Play.png"
                                        alt="">
                                    <p>Курс по поиску работы «Звездный кандидат»</p>
                                </li>
                                <li><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1718707781201-LT95u-Play.png"
                                        alt="">
                                    <p>Курс «Международная карьера и релокация»</p>
                                </li>
                                <li><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1718707787277-yTcpr-Note.png"
                                        alt="">
                                    <p>Еще 18 курсов по развитию карьеры</p>
                                </li>
                                <li><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1718707784552-4q6k6-Lock.png"
                                        alt="">
                                    <p>Доступ к нетворк-платформе</p>
                                </li>
                            </ul>
                        </div>
                        <a onclick="" href="#club2-supports-eur" class="btn-color-main-dark-orange">Оформить
                            подписку</a>
                    </div>
                    <div data-tariff-switcher="" data-price-eur="&nbsp;€ 279" data-price-rub="&nbsp;₽ 20 720"
                        data-link-rub="#club2-ext-supports-rub" data-link-eur="#club2-ext-supports-eur"
                        class="club21-tariffs-item" data-price-old-eur="349" data-price-old-rub="25900">
                        <p class="club21-tariffs-item__header">Тариф «Полное<br> сопровождение»</p>
                        <div class="club21-tariffs-item__label">
                            <p>-20%</p>
                        </div>
                        <div class="club21-tariffs-item__rassr">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24"
                                height="24" viewBox="0 0 24 24" fill="none">
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                    d="M2 12C2 6.47784 6.47673 2 12 2C17.5222 2 22 6.47779 22 12C22 17.5222 17.5222 22 12 22C6.47673 22 2 17.5222 2 12ZM16.0898 10.1573C16.3827 9.86439 16.3827 9.38952 16.0898 9.09662C15.7969 8.80373 15.322 8.80373 15.0291 9.09662L10.8133 13.3124L8.96967 11.4695C8.67672 11.1767 8.20184 11.1768 7.90901 11.4697C7.61618 11.7627 7.61628 12.2376 7.90924 12.5304L10.2832 14.9034C10.5761 15.1962 11.0509 15.1961 11.3438 14.9033L16.0898 10.1573Z"
                                    fill="#0B70FE"></path>
                            </svg>
                            <p class="club21-tariffs-item__rassr-text-RUB" style="display: none;">Доступно в рассрочку</p>
                            <p class="club21-tariffs-item__rassr-text-EUR">Можно оплатить долями</p>
                        </div>
                        <div class="club21-tariffs-item__price">
                            <p class="club21-tariffs-item__price-text-before">до&nbsp;&nbsp;</p>
                            <p class="club21-tariffs-item__price-text-old">349</p>
                            <p class="club21-tariffs-item__price-text">€ 149</p>
                            <p class="club21-tariffs-item__price-text-divider">/</p>
                            <p class="club21-tariffs-item__price-text-before">месяц</p>
                        </div>
                        <div class="club21-tariffs-item__content content-bold">
                            <ul>
                                <li>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1718708437051-Oh6ZP-Fram.png"
                                        alt="">
                                    <p>2 видео консультации<br> в месяц с карьерным<br> экспертом</p>
                                </li>
                                <li>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1718708437051-Oh6ZP-Fram.png"
                                        alt="">
                                    <p>Разбор вашего резюме</p>
                                </li>
                                <li><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1718708437051-Oh6ZP-Fram.png"
                                        alt="">
                                    <p>Поддержка карьерного эксперта в чате</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club21-tariffs-item__content">
                            <ul>
                                <li>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1718707781201-LT95u-Play.png"
                                        alt="">
                                    <p>Курс по поиску работы «Звездный кандидат»</p>
                                </li>
                                <li><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1718707781201-LT95u-Play.png"
                                        alt="">
                                    <p>Курс «Международная карьера и релокация»</p>
                                </li>
                                <li><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1718707787277-yTcpr-Note.png"
                                        alt="">
                                    <p>Еще 18 курсов по развитию карьеры</p>
                                </li>
                                <li><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1718707784552-4q6k6-Lock.png"
                                        alt="">
                                    <p>Доступ к нетворк-платформе</p>
                                </li>
                            </ul>
                        </div>
                        <a onclick="" href="#club2-ext-supports-eur" class="btn-color-main-dark-orange">Оформить
                            подписку</a>
                    </div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('veb22-tariffs-tablet', {
        label: 'Запись веба тарифы (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div custom-link-anchor="buy" class="veb22-tariffs-tablet careerum-club21-tariffs-tablet">
            <div>
                <div>
                    <h2>Скидки по промокоду OFFER2024</h2>
                    <p class="veb22-tariffs-subheader">Сумма пересчитается после ввода промокода на странице оформления
                        заказа</p>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1718718901680-k0s1P-Vect.png" alt="">
                    <div class="club21-tariffs__swicher-block">
                        <div class="club21-tariffs__swicher-top">
                            <p class="club21-tariffs__swicher-header">Посмотреть цены в <span>RUB</span></p><svg
                                xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                                class="club21-tariffs__swicher-arrow">
                                <path d="M7 9.5L12 14.5L17 9.5H7Z" fill="black"></path>
                            </svg>
                        </div>
                        <div class="club21-tariffs__swicher-bottom">
                            <ul>
                                <li data-currency="RUB">
                                    RUB
                                </li>
                                <li data-currency="EUR" class="active">
                                    EUR
                                </li>
                            </ul>
                            <p>
                                Обратите внимание,<br> что оплата в российских рублях возможна только<br> с карты
                                российского банка. Оплата в евро — с карты зарубежного банка
                            </p>
                        </div>
                    </div>
                </div>
                <div class="club21-tariffs-wrapper">
                    <div>
                        <div data-tariff-switcher="" data-price-eur="&nbsp;€ 279" data-price-rub="&nbsp;₽ 20720"
                            data-link-rub="#club2-ext-supports-rub" data-link-eur="#club2-ext-supports-eur"
                            class="club21-tariffs-item" data-price-old-eur="349" data-price-old-rub="25900">
                            <p class="club21-tariffs-item__header">Тариф «Полное<br> сопровождение»</p>
                            <div class="club21-tariffs-item__label">
                                <p>-20%</p>
                            </div>
                            <div class="club21-tariffs-item__rassr">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24"
                                    height="24" viewBox="0 0 24 24" fill="none">
                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                        d="M2 12C2 6.47784 6.47673 2 12 2C17.5222 2 22 6.47779 22 12C22 17.5222 17.5222 22 12 22C6.47673 22 2 17.5222 2 12ZM16.0898 10.1573C16.3827 9.86439 16.3827 9.38952 16.0898 9.09662C15.7969 8.80373 15.322 8.80373 15.0291 9.09662L10.8133 13.3124L8.96967 11.4695C8.67672 11.1767 8.20184 11.1768 7.90901 11.4697C7.61618 11.7627 7.61628 12.2376 7.90924 12.5304L10.2832 14.9034C10.5761 15.1962 11.0509 15.1961 11.3438 14.9033L16.0898 10.1573Z"
                                        fill="#0B70FE"></path>
                                </svg>
                                <p class="club21-tariffs-item__rassr-text-RUB" style="display: none;">Доступно в рассрочку</p>
                                <p class="club21-tariffs-item__rassr-text-EUR">Можно оплатить долями</p>
                            </div>
                            <div class="club21-tariffs-item__price">
                                <p class="club21-tariffs-item__price-text-before">до&nbsp;&nbsp;</p>
                                <p class="club21-tariffs-item__price-text-old">349</p>
                                <p class="club21-tariffs-item__price-text">€ 149</p>
                                <p class="club21-tariffs-item__price-text-divider">/</p>
                                <p class="club21-tariffs-item__price-text-before">месяц</p>
                            </div>
                            <div class="club21-tariffs-item__content content-bold">
                                <ul>
                                    <li>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1718708437051-Oh6ZP-Fram.png"
                                            alt="">
                                        <p>2 видео консультации<br> в месяц с карьерным<br> экспертом</p>
                                    </li>
                                    <li>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1718708437051-Oh6ZP-Fram.png"
                                            alt="">
                                        <p>Разбор вашего резюме</p>
                                    </li>
                                    <li><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1718708437051-Oh6ZP-Fram.png"
                                            alt="">
                                        <p>Поддержка карьерного эксперта в чате</p>
                                    </li>
                                </ul>
                            </div>
                            <div class="club21-tariffs-item__content">
                                <ul>
                                    <li>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1718707781201-LT95u-Play.png"
                                            alt="">
                                        <p>Курс по поиску работы «Звездный кандидат»</p>
                                    </li>
                                    <li><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1718707781201-LT95u-Play.png"
                                            alt="">
                                        <p>Курс «Международная карьера и релокация»</p>
                                    </li>
                                    <li><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1718707787277-yTcpr-Note.png"
                                            alt="">
                                        <p>Еще 18 курсов по развитию карьеры</p>
                                    </li>
                                    <li><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1718707784552-4q6k6-Lock.png"
                                            alt="">
                                        <p>Доступ к нетворк-платформе</p>
                                    </li>
                                </ul>
                            </div>
                            <a onclick="" href="#club2-ext-supports-eur" class="btn-color-main-dark-orange">Оформить
                                подписку</a>
                        </div>
                        <div data-tariff-switcher="" data-price-eur="&nbsp;€ 169" data-price-rub="&nbsp;₽ 12665"
                            data-link-rub="#club2-supports-rub" data-link-eur="#club2-supports-eur" data-price-old-eur="199" data-price-old-rub="14900" class="club21-tariffs-item">
                            <p class="club21-tariffs-item__header">Тариф<br> «С поддержкой»</p>
                            <div class="club21-tariffs-item__label">
                                <p>–15%</p>
                            </div>
                            <div class="club21-tariffs-item__rassr">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24"
                                    height="24" viewBox="0 0 24 24" fill="none">
                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                        d="M2 12C2 6.47784 6.47673 2 12 2C17.5222 2 22 6.47779 22 12C22 17.5222 17.5222 22 12 22C6.47673 22 2 17.5222 2 12ZM16.0898 10.1573C16.3827 9.86439 16.3827 9.38952 16.0898 9.09662C15.7969 8.80373 15.322 8.80373 15.0291 9.09662L10.8133 13.3124L8.96967 11.4695C8.67672 11.1767 8.20184 11.1768 7.90901 11.4697C7.61618 11.7627 7.61628 12.2376 7.90924 12.5304L10.2832 14.9034C10.5761 15.1962 11.0509 15.1961 11.3438 14.9033L16.0898 10.1573Z"
                                        fill="#0B70FE"></path>
                                </svg>
                                <p class="club21-tariffs-item__rassr-text-RUB" style="display: none;">Доступно в рассрочку</p>
                                <p class="club21-tariffs-item__rassr-text-EUR">Можно оплатить долями</p>
                            </div>
                            <div class="club21-tariffs-item__price">
                                <p class="club21-tariffs-item__price-text-before">до&nbsp;&nbsp;</p>
                                <p class="club21-tariffs-item__price-text-old">44444</p>
                                <p class="club21-tariffs-item__price-text">€ 149</p>
                                <p class="club21-tariffs-item__price-text-divider">/</p>
                                <p class="club21-tariffs-item__price-text-before">месяц</p>
                            </div>
                            <div class="club21-tariffs-item__content content-bold">
                                <ul>
                                    <li>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1718708437051-Oh6ZP-Fram.png"
                                            alt="">
                                        <p>Разбор вашего резюме</p>
                                    </li>
                                    <li><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1718708437051-Oh6ZP-Fram.png"
                                            alt="">
                                        <p>Поддержка карьерного эксперта в чате</p>
                                    </li>
                                </ul>
                            </div>
                            <div class="club21-tariffs-item__content">
                                <ul>
                                    <li>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1718707781201-LT95u-Play.png"
                                            alt="">
                                        <p>Курс по поиску работы «Звездный кандидат»</p>
                                    </li>
                                    <li><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1718707781201-LT95u-Play.png"
                                            alt="">
                                        <p>Курс «Международная карьера и релокация»</p>
                                    </li>
                                    <li><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1718707787277-yTcpr-Note.png"
                                            alt="">
                                        <p>Еще 18 курсов по развитию карьеры</p>
                                    </li>
                                    <li><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1718707784552-4q6k6-Lock.png"
                                            alt="">
                                        <p>Доступ к нетворк-платформе</p>
                                    </li>
                                </ul>
                            </div>
                            <a onclick="" href="#club2-supports-eur" class="btn-color-main-dark-orange">Оформить
                                подписку</a>
                        </div>
                        <div data-tariff-switcher="" data-price-eur="€ 149" data-price-rub="&nbsp;₽ 12900"  data-price-old-eur="€ 149" data-price-old-rub="12&nbsp;900 ₽"
                            data-link-rub="#club2-solo-rub" data-link-eur="#club2-solo-eur" class="club21-tariffs-item">
                            <p class="club21-tariffs-item__header">Тариф «Самостоятельный»</p>
                            <div class="club21-tariffs-item__rassr">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24"
                                    height="24" viewBox="0 0 24 24" fill="none">
                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                        d="M2 12C2 6.47784 6.47673 2 12 2C17.5222 2 22 6.47779 22 12C22 17.5222 17.5222 22 12 22C6.47673 22 2 17.5222 2 12ZM16.0898 10.1573C16.3827 9.86439 16.3827 9.38952 16.0898 9.09662C15.7969 8.80373 15.322 8.80373 15.0291 9.09662L10.8133 13.3124L8.96967 11.4695C8.67672 11.1767 8.20184 11.1768 7.90901 11.4697C7.61618 11.7627 7.61628 12.2376 7.90924 12.5304L10.2832 14.9034C10.5761 15.1962 11.0509 15.1961 11.3438 14.9033L16.0898 10.1573Z"
                                        fill="#0B70FE"></path>
                                </svg>
                                <p class="club21-tariffs-item__rassr-text-RUB" style="display: none;">Доступно в рассрочку</p>
                                <p class="club21-tariffs-item__rassr-text-EUR">Можно оплатить долями</p>
                            </div>
                            <div class="club21-tariffs-item__price">
                                <p class="club21-tariffs-item__price-text-before">до&nbsp;&nbsp;</p>
                                <p class="club21-tariffs-item__price-text">€ 149</p>
                                <p class="club21-tariffs-item__price-text-divider">/</p>
                                <p class="club21-tariffs-item__price-text-before">месяц</p>
                            </div>
                            <div class="club21-tariffs-item__content">
                                <ul>
                                    <li>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1718707781201-LT95u-Play.png"
                                            alt="">
                                        <p>Курс по поиску работы «Звездный кандидат»</p>
                                    </li>
                                    <li><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1718707781201-LT95u-Play.png"
                                            alt="">
                                        <p>Курс «Международная карьера и релокация»</p>
                                    </li>
                                    <li><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1718707787277-yTcpr-Note.png"
                                            alt="">
                                        <p>Еще 18 курсов по развитию карьеры</p>
                                    </li>
                                    <li><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1718707784552-4q6k6-Lock.png"
                                            alt="">
                                        <p>Доступ к нетворк-платформе</p>
                                    </li>
                                </ul>
                            </div>
                            <a onclick="" href="#club2-solo-eur" class="btn-color-main-dark-orange">Оформить подписку</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('veb22-tariffs-mobile', {
        label: 'Запись веба тарифы (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div custom-anchor="" js-hide-script="" hide-by-geo="unset" custom-link-anchor="buy"
            class="veb22-tariffs-mobile careerum-club21-tariffs-mobile">
            <div>
                <div>
                    <h2>Скидки по промокоду OFFER2024</h2>
                    <p class="veb22-tariffs-subheader">Сумма пересчитается после ввода промокода на странице<br> оформления
                        заказа</p>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1718723318019-eu4Bs-Vect.png" alt="">
                    <div class="club21-tariffs__swicher-block">
                        <div class="club21-tariffs__swicher-top">
                            <p class="club21-tariffs__swicher-header">Посмотреть цены в <span>RUB</span></p><svg
                                xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                                class="club21-tariffs__swicher-arrow">
                                <path d="M7 9.5L12 14.5L17 9.5H7Z" fill="black"></path>
                            </svg>
                        </div>
                        <div class="club21-tariffs__swicher-bottom">
                            <ul>
                                <li data-currency="RUB">
                                    RUB
                                </li>
                                <li data-currency="EUR" class="active">
                                    EUR
                                </li>
                            </ul>
                            <p>
                                Обратите внимание,<br> что оплата в российских рублях возможна только<br> с карты
                                российского банка. Оплата в евро — с карты зарубежного банка
                            </p>
                        </div>
                    </div>
                </div>
                <div class="club21-tariffs-wrapper">
                    <div data-tariff-switcher="" data-price-eur="&nbsp;€ 279" data-price-rub="&nbsp;₽ 20720"
                        data-link-rub="#club2-ext-supports-rub" data-link-eur="#club2-ext-supports-eur"
                        class="club21-tariffs-item" data-price-old-eur="349" data-price-old-rub="25900">
                        <p class="club21-tariffs-item__header">Тариф «Полное<br> сопровождение»</p>
                        <div class="club21-tariffs-item__label">
                            <p>-20%</p>
                        </div>
                        <div class="club21-tariffs-item__rassr">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24"
                                height="24" viewBox="0 0 24 24" fill="none">
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                    d="M2 12C2 6.47784 6.47673 2 12 2C17.5222 2 22 6.47779 22 12C22 17.5222 17.5222 22 12 22C6.47673 22 2 17.5222 2 12ZM16.0898 10.1573C16.3827 9.86439 16.3827 9.38952 16.0898 9.09662C15.7969 8.80373 15.322 8.80373 15.0291 9.09662L10.8133 13.3124L8.96967 11.4695C8.67672 11.1767 8.20184 11.1768 7.90901 11.4697C7.61618 11.7627 7.61628 12.2376 7.90924 12.5304L10.2832 14.9034C10.5761 15.1962 11.0509 15.1961 11.3438 14.9033L16.0898 10.1573Z"
                                    fill="#0B70FE"></path>
                            </svg>
                            <p class="club21-tariffs-item__rassr-text-RUB" style="display: none;">Доступно в рассрочку</p>
                            <p class="club21-tariffs-item__rassr-text-EUR">Можно оплатить долями</p>
                        </div>
                        <div class="club21-tariffs-item__price">
                            <p class="club21-tariffs-item__price-text-before">до&nbsp;&nbsp;</p>
                            <p class="club21-tariffs-item__price-text-old">349</p>
                            <p class="club21-tariffs-item__price-text">€ 149</p>
                            <p class="club21-tariffs-item__price-text-divider">/</p>
                            <p class="club21-tariffs-item__price-text-before">месяц</p>
                        </div>
                        <div class="club21-tariffs-item__content content-bold">
                            <ul>
                                <li>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1718708437051-Oh6ZP-Fram.png"
                                        alt="">
                                    <p>2 видео консультации<br> в месяц с карьерным<br> экспертом</p>
                                </li>
                                <li>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1718708437051-Oh6ZP-Fram.png"
                                        alt="">
                                    <p>Разбор вашего резюме</p>
                                </li>
                                <li><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1718708437051-Oh6ZP-Fram.png"
                                        alt="">
                                    <p>Поддержка карьерного эксперта в чате</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club21-tariffs-item__content">
                            <ul>
                                <li>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1718707781201-LT95u-Play.png"
                                        alt="">
                                    <p>Курс по поиску работы «Звездный кандидат»</p>
                                </li>
                                <li><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1718707781201-LT95u-Play.png"
                                        alt="">
                                    <p>Курс «Международная карьера и релокация»</p>
                                </li>
                                <li><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1718707787277-yTcpr-Note.png"
                                        alt="">
                                    <p>Еще 18 курсов по развитию карьеры</p>
                                </li>
                                <li><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1718707784552-4q6k6-Lock.png"
                                        alt="">
                                    <p>Доступ к нетворк-платформе</p>
                                </li>
                            </ul>
                        </div>
                        <a onclick="" href="#club2-ext-supports-eur" class="btn-color-main-dark-orange">Оформить
                            подписку</a>
                    </div>
                    <div data-tariff-switcher="" data-price-eur="&nbsp;€ 169" data-price-rub="&nbsp;₽ 12665"
                        data-link-rub="#club2-supports-rub" data-link-eur="#club2-supports-eur" data-price-old-eur="199" data-price-old-rub="14900" class="club21-tariffs-item">
                        <p class="club21-tariffs-item__header">Тариф<br> «С поддержкой»</p>
                        <div class="club21-tariffs-item__label">
                            <p>–15%</p>
                        </div>
                        <div class="club21-tariffs-item__rassr">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24"
                                height="24" viewBox="0 0 24 24" fill="none">
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                    d="M2 12C2 6.47784 6.47673 2 12 2C17.5222 2 22 6.47779 22 12C22 17.5222 17.5222 22 12 22C6.47673 22 2 17.5222 2 12ZM16.0898 10.1573C16.3827 9.86439 16.3827 9.38952 16.0898 9.09662C15.7969 8.80373 15.322 8.80373 15.0291 9.09662L10.8133 13.3124L8.96967 11.4695C8.67672 11.1767 8.20184 11.1768 7.90901 11.4697C7.61618 11.7627 7.61628 12.2376 7.90924 12.5304L10.2832 14.9034C10.5761 15.1962 11.0509 15.1961 11.3438 14.9033L16.0898 10.1573Z"
                                    fill="#0B70FE"></path>
                            </svg>
                            <p class="club21-tariffs-item__rassr-text-RUB" style="display: none;">Доступно в рассрочку</p>
                            <p class="club21-tariffs-item__rassr-text-EUR">Можно оплатить долями</p>
                        </div>
                        <div class="club21-tariffs-item__price">
                            <p class="club21-tariffs-item__price-text-before">до&nbsp;&nbsp;</p>
                            <p class="club21-tariffs-item__price-text-old">44444</p>
                            <p class="club21-tariffs-item__price-text">€ 149</p>
                            <p class="club21-tariffs-item__price-text-divider">/</p>
                            <p class="club21-tariffs-item__price-text-before">месяц</p>
                        </div>
                        <div class="club21-tariffs-item__content content-bold">
                            <ul>
                                <li>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1718708437051-Oh6ZP-Fram.png"
                                        alt="">
                                    <p>Разбор вашего резюме</p>
                                </li>
                                <li><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1718708437051-Oh6ZP-Fram.png"
                                        alt="">
                                    <p>Поддержка карьерного эксперта в чате</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club21-tariffs-item__content">
                            <ul>
                                <li>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1718707781201-LT95u-Play.png"
                                        alt="">
                                    <p>Курс по поиску работы «Звездный кандидат»</p>
                                </li>
                                <li><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1718707781201-LT95u-Play.png"
                                        alt="">
                                    <p>Курс «Международная карьера и релокация»</p>
                                </li>
                                <li><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1718707787277-yTcpr-Note.png"
                                        alt="">
                                    <p>Еще 18 курсов по развитию карьеры</p>
                                </li>
                                <li><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1718707784552-4q6k6-Lock.png"
                                        alt="">
                                    <p>Доступ к нетворк-платформе</p>
                                </li>
                            </ul>
                        </div>
                        <a onclick="" href="#club2-supports-eur" class="btn-color-main-dark-orange">Оформить
                            подписку</a>
                    </div>
                    <div data-tariff-switcher="" data-price-eur="€ 149" data-price-rub="&nbsp;₽ 12900"  data-price-old-eur="€ 149" data-price-old-rub="12&nbsp;900 ₽"
                        data-link-rub="#club2-solo-rub" data-link-eur="#club2-solo-eur" class="club21-tariffs-item">
                        <p class="club21-tariffs-item__header">Тариф «Самостоятельный»</p>
                        <div class="club21-tariffs-item__rassr">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24"
                                height="24" viewBox="0 0 24 24" fill="none">
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                    d="M2 12C2 6.47784 6.47673 2 12 2C17.5222 2 22 6.47779 22 12C22 17.5222 17.5222 22 12 22C6.47673 22 2 17.5222 2 12ZM16.0898 10.1573C16.3827 9.86439 16.3827 9.38952 16.0898 9.09662C15.7969 8.80373 15.322 8.80373 15.0291 9.09662L10.8133 13.3124L8.96967 11.4695C8.67672 11.1767 8.20184 11.1768 7.90901 11.4697C7.61618 11.7627 7.61628 12.2376 7.90924 12.5304L10.2832 14.9034C10.5761 15.1962 11.0509 15.1961 11.3438 14.9033L16.0898 10.1573Z"
                                    fill="#0B70FE"></path>
                            </svg>
                            <p class="club21-tariffs-item__rassr-text-RUB" style="display: none;">Доступно в рассрочку</p>
                            <p class="club21-tariffs-item__rassr-text-EUR">Можно оплатить долями</p>
                        </div>
                        <div class="club21-tariffs-item__price">
                            <p class="club21-tariffs-item__price-text-before">до&nbsp;&nbsp;</p>
                            <p class="club21-tariffs-item__price-text">€ 149</p>
                            <p class="club21-tariffs-item__price-text-divider">/</p>
                            <p class="club21-tariffs-item__price-text-before">месяц</p>
                        </div>
                        <div class="club21-tariffs-item__content">
                            <ul>
                                <li>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1718707781201-LT95u-Play.png"
                                        alt="">
                                    <p>Курс по поиску работы «Звездный кандидат»</p>
                                </li>
                                <li><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1718707781201-LT95u-Play.png"
                                        alt="">
                                    <p>Курс «Международная карьера и релокация»</p>
                                </li>
                                <li><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1718707787277-yTcpr-Note.png"
                                        alt="">
                                    <p>Еще 18 курсов по развитию карьеры</p>
                                </li>
                                <li><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1718707784552-4q6k6-Lock.png"
                                        alt="">
                                    <p>Доступ к нетворк-платформе</p>
                                </li>
                            </ul>
                        </div>
                        <a onclick="" href="#club2-solo-eur" class="btn-color-main-dark-orange">Оформить подписку</a>
                    </div>
                </div>
            </div>
        </div>`
	});
    
    blockManager.add('careerum-veb22-form', {
        label: 'Запись веба форма',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-veb22-form">
            <div>
                <div class="veb22-form-left">
                    <div>
                        <h2>Запишитесь на карьерную диагностику</h2>
                        <p>За 30 минут на онлайн-встрече выявим<br> проблемные точки и сформируем решения</p>
                        <svg width="693" height="65" viewBox="0 0 693 65" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M2 62.7889C59.5482 56.7879 287.49 62.6994 342.5 54.9998M351 9.28902C408.548 3.28802 636.49 9.19952 691.5 1.5"
                                stroke="#FF5A00" stroke-width="3" stroke-linecap="round" />
                        </svg>
                        <svg width="192" height="64" viewBox="0 0 192 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M1.9779 16.179C20.8289 47.936 51.0734 63.0237 82.2504 62.0442C117.226 60.9453 159.273 31.3591 189.59 2.49089M179.186 30.6685C181.688 20.0585 182.767 17.1261 188.666 6.91947C194.156 -2.57802 187.567 2.02185 181.792 4.63593C173.419 8.4263 166.11 12.3255 157.365 10.6889"
                                stroke="#FF5A00" stroke-width="2" stroke-linecap="round" />
                        </svg>
                    </div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1718709866585-3l4FE-%D1%8D%D0%BA%D1%81%D0%BF.png" alt="">
                </div>
                <div class="veb22-form-right">
                    <div class="careerum-registration-form">
                        <form class="deva-form getcourse-email-signup" name="devaRegistrationForm"
                            data-gjs-type="deva-registration-form">
                            <div class="careerum-veb22-form-name">
                                <input type="text" name="name" value="" required placeholder="Имя">
                            </div>
                            <div class="careerum-veb22-form-email">
                                <input type="text" name="email" value="" required placeholder="Почта">
                            </div>
                            <div class="careerum-veb22-form-phone">
                                <input type="tel" value="" name="tel" required class="itl-input">
                            </div>
                            <div class="careerum-veb22-form-telegram">
                                <input type="text" name="telegram" value="" required placeholder="Telegram">
                            </div>
                            <div class="careerum-veb22-form-searchwork">
                                <input type="text" name="searchwork" value="" required placeholder="Вы сейчас ищете работу?">
                            </div>
                            <div class="careerum-veb22-form-searchtime">
                                <input type="text" name="searchtime" value="" required placeholder="Через сколько хотите найти работу?">
                            </div>
                            <div class="careerum-veb22-form-question">
                                <textarea type="text" name="question" value="" placeholder="Ваш вопрос" rows="4"></textarea>
                            </div>
                            <div class="careerum-veb22-form-agree">
                                <label>
                                    <input type="checkbox" name="agree">
                                    <div>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8"
                                            fill="none">
                                            <path
                                                d="M1 2.84615L3.14168 6.70118C3.21595 6.83487 3.40669 6.83912 3.48685 6.70887L7 1"
                                                stroke="white" stroke-width="1.5" stroke-linecap="round" />
                                        </svg>
                                    </div>
                                </label>
                                <p>Я даю согласие на обработку своих персональных данных в соответствии с <a
                                        href="/ru-ru/legal/privacy" target="_blank">Политикой конфиденциальности</a></p>
                            </div>
                            <a href="#" class="submit-btn btn-color-main-bright-orange button-sent" disabled>Получить
                                карьерную диагностику</a>
                        </form>
                    </div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-veb22-form-tablet', {
        label: 'Запись веба форма (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-veb22-form-tablet">
            <div>
                <div class="veb22-form-left">
                    <div>
                        <h2>Запишитесь на карьерную диагностику</h2>
                        <p>За 30 минут на онлайн-встрече выявим проблемные точки<br> и сформируем решения</p>
                        <svg width="233" height="38" viewBox="0 0 233 38" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1 35.0002C148.73 39.5006 118.06 35 225 35" stroke="#FF5A00" stroke-width="2"
                                stroke-linecap="round" />
                            <path d="M8 1.00019C155.73 5.5006 125.06 1 232 1" stroke="#FF5A00" stroke-width="2"
                                stroke-linecap="round" />
                        </svg>
                    </div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1718720668122-9PJxL-%D1%8D%D0%BA%D1%81%D0%BF.png" alt="">
                </div>
                <div class="veb22-form-right">
                    <div class="careerum-registration-form-tablet">
                        <form class="deva-form getcourse-email-signup" name="devaRegistrationForm"
                            data-gjs-type="deva-registration-form">
                            <div class="careerum-veb22-form-name">
                                <input type="text" name="name" value="" required placeholder="Имя">
                            </div>
                            <div class="careerum-veb22-form-email">
                                <input type="text" name="email" value="" required placeholder="Почта">
                            </div>
                            <div class="careerum-veb22-form-phone">
                                <input type="tel" value="" name="tel" required class="itl-input">
                            </div>
                            <div class="careerum-veb22-form-telegram">
                                <input type="text" name="telegram" value="" required placeholder="Telegram">
                            </div>
                            <div class="careerum-veb22-form-searchwork">
                                <input type="text" name="searchwork" value="" required placeholder="Вы сейчас ищете работу?">
                            </div>
                            <div class="careerum-veb22-form-searchtime">
                                <input type="text" name="searchtime" value="" required placeholder="Через сколько хотите найти работу?">
                            </div>
                            <div class="careerum-veb22-form-question">
                                <textarea type="text" name="question" value="" placeholder="Ваш вопрос" rows="4"></textarea>
                            </div>
                            <div class="careerum-veb22-form-agree">
                                <label>
                                    <input type="checkbox" name="agree">
                                    <div>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8"
                                            fill="none">
                                            <path
                                                d="M1 2.84615L3.14168 6.70118C3.21595 6.83487 3.40669 6.83912 3.48685 6.70887L7 1"
                                                stroke="white" stroke-width="1.5" stroke-linecap="round" />
                                        </svg>
                                    </div>
                                </label>
                                <p>Я даю согласие на обработку своих персональных данных в соответствии с <a
                                        href="/ru-ru/legal/privacy" target="_blank">Политикой конфиденциальности</a></p>
                            </div>
                            <a href="#" class="submit-btn btn-color-main-bright-orange button-sent" disabled>Получить
                                карьерную диагностику</a>
                        </form>
                    </div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-veb22-form-mobile', {
        label: 'Запись веба форма (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-veb22-form-mobile">
            <div>
                <div class="veb22-form-left">
                    <div>
                        <h2>Запишитесь на <br>карьерную диагностику</h2>
                        <p>За 30 минут на онлайн-встрече выявим проблемные точки и сформируем решения</p>
                        <svg width="264" height="3" viewBox="0 0 264 3" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1 1.99991C173.791 -0.2503 137.918 2 263 2" stroke="#FF5A00" stroke-width="2"
                                stroke-linecap="round" />
                        </svg>
                    </div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1718723711664-0XqaI-%D1%8D%D0%BA%D1%81%D0%BF.png" alt="">
                </div>
                <div class="veb22-form-right">
                    <div class="careerum-registration-form-mobile">
                        <form class="deva-form getcourse-email-signup" name="devaRegistrationForm"
                            data-gjs-type="deva-registration-form">
                            <div class="careerum-veb22-form-name">
                                <input type="text" name="name" value="" required placeholder="Имя">
                            </div>
                            <div class="careerum-veb22-form-email">
                                <input type="text" name="email" value="" required placeholder="Почта">
                            </div>
                            <div class="careerum-veb22-form-phone">
                                <input type="tel" value="" name="tel" required class="itl-input">
                            </div>
                            <div class="careerum-veb22-form-telegram">
                                <input type="text" name="telegram" value="" required placeholder="Телеграм">
                            </div>
                            <div class="careerum-veb22-form-searchwork">
                                <input type="text" name="searchwork" value="" required placeholder="Вы сейчас ищете работу?">
                            </div>
                            <div class="careerum-veb22-form-searchtime">
                                <input type="text" name="searchtime" value="" required placeholder="Через сколько хотите найти работу?">
                            </div>
                            <div class="careerum-veb22-form-question">
                                <textarea type="text" name="question" value="" placeholder="Ваш вопрос" rows="4"></textarea>
                            </div>
                            <div class="careerum-veb22-form-agree">
                                <label>
                                    <input type="checkbox" name="agree">
                                    <div>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8"
                                            fill="none">
                                            <path
                                                d="M1 2.84615L3.14168 6.70118C3.21595 6.83487 3.40669 6.83912 3.48685 6.70887L7 1"
                                                stroke="white" stroke-width="1.5" stroke-linecap="round" />
                                        </svg>
                                    </div>
                                </label>
                                <p>Я даю согласие на обработку своих персональных данных в соответствии с <a
                                        href="/ru-ru/legal/privacy" target="_blank">Политикой конфиденциальности</a></p>
                            </div>
                            <a href="#" class="submit-btn btn-color-main-bright-orange button-sent" disabled>Получить
                                карьерную диагностику</a>
                        </form>
                    </div>
                </div>
            </div>
        </div>`
	});
    
    blockManager.add('careerum-veb30-main', {
        label: 'Веб 3.0 главный',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-veb30-main">
            <div>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721317018618-iWYpm-ÑÐ¾.png" alt="">
                <div class="veb30-main-top">
                    <div class="veb30-main-left">
                        <div class="veb30-main-labels">
                            <div class="veb30-main-labels-orange">
                                <p>Бесплатный вебинар</p>
                            </div>
                            <div class="veb30-main-labels-transparent">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721316439061-jdFk2-Cale.png"
                                    alt="">
                                <p>21 марта в 18:00 мск </p>
                            </div>
                        </div>
                        <h1>5 ошибок, которые вредят вашему резюме</h1>
                        <div class="veb30-main-separartor"></div>
                        <div class="veb30-main-list-item">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721316636171-S7RR3-Chec.png"
                                alt="">
                            <p>Решите топ-7 главных проблем поиска работы</p>
                        </div>
                        <div class="veb30-main-list-item">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721316656323-sbXNo-Targ.png"
                                alt="">
                            <p>Определите слабые места именно в вашем резюме <br>и узнаете, как их исправить</p>
                        </div>
                        <div class="veb30-main-list-item">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721316674849-hQMSD-Note.png"
                                alt="">
                            <p>Разберёте резюме кандидатов, которые привели к офферам</p>
                        </div>
                    </div>
                    <div class="veb30-main-right">
                        <div class="careerum-registration-form">
                            <form class="deva-form getcourse-email-signup" name="devaRegistrationForm"
                                data-gjs-type="deva-registration-form">
                                <div class="careerum-veb30-form-name">
                                    <input type="text" name="name" value="" required placeholder="Имя">
                                </div>
                                <div class="careerum-veb30-form-email">
                                    <input type="text" name="email" value="" required placeholder="Почта">
                                </div>
                                <div class="careerum-veb30-form-telegram">
                                    <input type="text" name="telegram" value="" required placeholder="Telegram">
                                </div>
                                <div class="careerum-veb30-form-phone">
                                    <input type="tel" value="" name="tel" required class="itl-input">
                                </div>
                                <div class="careerum-veb30-form-agree">
                                    <label>
                                        <input type="checkbox" name="agree">
                                        <div>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8"
                                                fill="none">
                                                <path
                                                    d="M1 2.84615L3.14168 6.70118C3.21595 6.83487 3.40669 6.83912 3.48685 6.70887L7 1"
                                                    stroke="white" stroke-width="1.5" stroke-linecap="round" />
                                            </svg>
                                        </div>
                                    </label>
                                    <p>Я даю согласие на обработку своих персональных данных<br> в соответствии с <a
                                            href="/ru-ru/legal/privacy" target="_blank">Политикой конфиденциальности</a></p>
                                </div>
                                <a href="#" class="submit-btn btn-color-main-bright-orange button-sent"
                                    disabled>Зарегистрироваться бесплатно</a>
                            </form>
                        </div>
                    </div>
                </div>
                <div class="veb30-main-bottom">
                    <p>Бонусы после вебинара</p>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721317714958-mcK8U-1.pn.png"
                            alt="">
                        <p>Чек-лист для вашего резюме</p>
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721317725301-u2GNk-2.pn.png"
                            alt="">
                        <p>Прожарка резюме в прямом эфире</p>
                    </div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-veb30-main-tablet', {
        label: 'Веб 3.0 главный (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-veb30-main-tablet">
            <div>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721385226498-I8KYT-h.pn.png" alt="">
    
                <div class="veb30-main-top">
                    <div class="veb30-main-left">
                        <div class="veb30-main-labels">
                            <div class="veb30-main-labels-white">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721385591351-Y6qYU-Cale.png"
                                    alt="">
                                <p>21 марта в 18:00 мск </p>
                            </div>
                            <div class="veb30-main-labels-orange">
                                <p>Бесплатный вебинар</p>
                            </div>
                        </div>
                        <h2>5 ошибок, которые вредят вашему резюме</h2>
                        <div class="veb30-main-list-item">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721316636171-S7RR3-Chec.png"
                                alt="">
                            <p>Решите топ-7 главных проблем поиска<br> работы</p>
                        </div>
                        <div class="veb30-main-list-item">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721316656323-sbXNo-Targ.png"
                                alt="">
                            <p>Определите слабые места именно в вашем резюме и узнаете, как их исправить</p>
                        </div>
                        <div class="veb30-main-list-item">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721316674849-hQMSD-Note.png"
                                alt="">
                            <p>Разберёте резюме кандидатов, которые привели к офферам</p>
                        </div>
                    </div>
                    <div class="veb30-main-right">
                        <div class="careerum-registration-form-tablet">
                            <form class="deva-form getcourse-email-signup" name="devaRegistrationForm"
                                data-gjs-type="deva-registration-form">
                                <div class="careerum-veb30-form-name">
                                    <input type="text" name="name" value="" required placeholder="Имя">
                                </div>
                                <div class="careerum-veb30-form-email">
                                    <input type="text" name="email" value="" required placeholder="Почта">
                                </div>
                                <div class="careerum-veb30-form-telegram">
                                    <input type="text" name="telegram" value="" required placeholder="Telegram">
                                </div>
                                <div class="careerum-veb30-form-phone">
                                    <input type="tel" value="" name="tel" required class="itl-input">
                                </div>
                                <div class="careerum-veb30-form-agree">
                                    <label>
                                        <input type="checkbox" name="agree">
                                        <div>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8"
                                                fill="none">
                                                <path
                                                    d="M1 2.84615L3.14168 6.70118C3.21595 6.83487 3.40669 6.83912 3.48685 6.70887L7 1"
                                                    stroke="white" stroke-width="1.5" stroke-linecap="round" />
                                            </svg>
                                        </div>
                                    </label>
                                    <p>Я даю согласие на обработку своих персональных данных в соответствии с <a
                                            href="/ru-ru/legal/privacy" target="_blank">Политикой конфиденциальности</a></p>
                                </div>
                                <a href="#" class="submit-btn btn-color-main-bright-orange button-sent"
                                    disabled>Зарегистрироваться бесплатно</a>
                            </form>
                        </div>
                    </div>
                </div>
                <div class="veb30-main-bottom">
                    <p>Бонусы после вебинара</p>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721386578507-BwWaO-1123.png"
                            alt="">
                        <p>Чек-лист для вашего резюме</p>
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721386590798-DzDaK-312..png"
                            alt="">
                        <p>Прожарка резюме в прямом эфире</p>
                    </div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-veb30-main-mobile', {
        label: 'Веб 3.0 главный (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-veb30-main-mobile">
            <div>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721542522166-kbiXu-ÑÐ¾.png" alt="">
                <div class="veb30-main-top">
                    <div class="veb30-main-left">
                        <div class="veb30-main-labels">
                            <div class="veb30-main-labels-white">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721385591351-Y6qYU-Cale.png"
                                    alt="">
                                <p>21 марта в 18:00 мск </p>
                            </div>
                            <div class="veb30-main-labels-orange">
                                <p>Бесплатный вебинар</p>
                            </div>
                        </div>
                        <h2>5 ошибок,<br> которые вредят вашему резюме</h2>
                        <p>Определите слабые места именно в вашем резюме и узнаете, как их исправить</p>
                    </div>
                    <div class="veb30-main-right">
                        <div class="careerum-registration-form-mobile">
                            <form class="deva-form getcourse-email-signup" name="devaRegistrationForm"
                                data-gjs-type="deva-registration-form">
                                <div class="careerum-veb30-form-name">
                                    <input type="text" name="name" value="" required placeholder="Имя">
                                </div>
                                <div class="careerum-veb30-form-email">
                                    <input type="text" name="email" value="" required placeholder="Почта">
                                </div>
                                <div class="careerum-veb30-form-telegram">
                                    <input type="text" name="telegram" value="" required placeholder="Telegram">
                                </div>
                                <div class="careerum-veb30-form-phone">
                                    <input type="tel" value="" name="tel" required class="itl-input">
                                </div>
                                <div class="careerum-veb30-form-agree">
                                    <label>
                                        <input type="checkbox" name="agree">
                                        <div>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8"
                                                fill="none">
                                                <path
                                                    d="M1 2.84615L3.14168 6.70118C3.21595 6.83487 3.40669 6.83912 3.48685 6.70887L7 1"
                                                    stroke="white" stroke-width="1.5" stroke-linecap="round" />
                                            </svg>
                                        </div>
                                    </label>
                                    <p>Я даю согласие на обработку своих персональных данных в соответствии с <a
                                            href="/ru-ru/legal/privacy" target="_blank">Политикой конфиденциальности</a></p>
                                </div>
                                <a href="#" class="submit-btn btn-color-main-bright-orange button-sent"
                                    disabled>Зарегистрироваться бесплатно</a>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
	});
    
    blockManager.add('careerum-veb30-main2', {
        label: 'Веб 3.0 главный2',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-veb30-main2">
            <div>
                <div class="veb30-main-top">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721976696685-ic28i-Elli.png" alt="">
                    <div class="veb30-main-top-labels">
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721976518146-qNMfz-Cale.svg" alt="">
                            <p>24 августа, 12:00 мск</p>
                        </div>
                        <div>
                            <p>Бесплатный мастер-класс</p>
                        </div>
                        <div>
                            <p>4 часа пользы и практики</p>
                        </div>
                    </div>
                    <div class="veb30-main-top-info">
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721976591492-gL70N-Vect.svg" alt="">
                            <p>Прокачайте свое<br> резюме</p>
                        </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721976607208-JKJFA-Unio.svg" alt="">
                            <p>Не пропустите<br> сезон найма</p>
                        </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721976621767-5mXEN-Vect.svg" alt="">
                            <p>Настройте воронку<br> поиска</p>
                        </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721976638941-vJ4eC-Grou.svg" alt="">
                            <p>Станьте<br> магнитом для<br> рекрутеров</p>
                        </div>
                    </div>
                    <div class="veb30-main-top-headers">
                        <h1>Чит-коды<br> и лайфхаки<br> поиска работы</h1>
                        <p>Получите  job offer этой<br> осенью</p>
                    </div>
                    <div class="veb30-main-top-speakers">
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721976540594-nRRKN-Mask.png" alt="">
                            <p>Ольга Лермонтова,<br> фаундер Careerum,<br> Италия</p>
                        </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721976540188-u1srW-Mask.png" alt="">
                            <p>Софи Бессон,<br>карьерный эксперт,<br> Израиль</p>
                        </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721976540461-RX4IR-Mask.png" alt="">
                            <p>Надежда Община,<br>карьерный эксперт,<br> Португалия</p>
                        </div>
                    </div>
                </div>
                <div class="veb30-main-center">
                    <div class="veb30-main-left">
                        <p>На мастер-классе вы<br> узнаете</p>
                        <div class="veb30-main-list-item">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721316636171-S7RR3-Chec.png"
                                alt="">
                            <p>Как быстро найти работу в классной компании</p>
                        </div>
                        <div class="veb30-main-list-item">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721316656323-sbXNo-Targ.png"
                                alt="">
                            <p>Как получить оффер на ваших условиях, а не тот, который<br> дают</p>
                        </div>
                        <div class="veb30-main-list-item">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721316674849-hQMSD-Note.png"
                                alt="">
                            <p>Как и кого нанимают компании в РФ и за рубежом</p>
                        </div>
                        <div class="veb30-main-bottom">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721979995385-UKRrN-1111.png"
                                    alt="">
                                <p>Бонус для участников мастер-класса</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721980004536-cyOdR-2222.png"
                                    alt="">
                                <p>5 гайдов с лучшими лайфхаками для всех этапов поиска работы</p>
                            </div>
                        </div>
                    </div>
                    <div class="veb30-main-right">
                        <div class="careerum-registration-form">
                            <form class="deva-form getcourse-email-signup" name="devaRegistrationForm"
                                data-gjs-type="deva-registration-form">
                                <div class="careerum-veb30-form-name">
                                    <input type="text" name="name" value="" required placeholder="Имя">
                                </div>
                                <div class="careerum-veb30-form-email">
                                    <input type="text" name="email" value="" required placeholder="Почта">
                                </div>
                                <div class="careerum-veb30-form-telegram">
                                    <input type="text" name="telegram" value="" required placeholder="Telegram">
                                </div>
                                <div class="careerum-veb30-form-phone">
                                    <input type="tel" value="" name="tel" required class="itl-input">
                                </div>
                                <div class="careerum-veb30-form-agree">
                                    <label>
                                        <input type="checkbox" name="agree">
                                        <div>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8"
                                                fill="none">
                                                <path
                                                    d="M1 2.84615L3.14168 6.70118C3.21595 6.83487 3.40669 6.83912 3.48685 6.70887L7 1"
                                                    stroke="white" stroke-width="1.5" stroke-linecap="round" />
                                            </svg>
                                        </div>
                                    </label>
                                    <p>Я даю согласие на обработку своих персональных данных<br> в соответствии с <a
                                            href="/ru-ru/legal/privacy" target="_blank">Политикой конфиденциальности</a></p>
                                </div>
                                <a href="#" class="submit-btn btn-color-main-bright-orange button-sent"
                                    disabled>Зарегистрироваться бесплатно</a>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-veb30-main2-tablet', {
        label: 'Веб 3.0 главный2 (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-veb30-main2-tablet">
            <div>
                <div class="veb30-main-top">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721980284290-LeBjw-Elli.png" alt="">
                    <div class="veb30-main-top-labels">
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721980356163-H3Ukm-Cale.svg"
                                alt="">
                            <p>24 августа, 12:00 мск</p>
                        </div>
                        <div>
                            <p>Бесплатный мастер-класс</p>
                        </div>
                        <div>
                            <p>4 часа пользы и практики</p>
                        </div>
                    </div>
                    <div class="veb30-main-top-info">
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721980914929-tyqdv-Vect.svg"
                                alt="">
                            <p>Настройте воронку<br> поиска</p>
                        </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721980936490-6Bye3-Grou.svg"
                                alt="">
                            <p>Прокачайте<br> резюме</p>
                        </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721981125312-52lA2-Grou.svg"
                                alt="">
                            <p>Станьте<br> магнитом<br> для рекрутеров</p>
                        </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721980970088-lNvuz-Vect.svg"
                                alt="">
                            <p>Не пропустите<br> сезон найма</p>
                        </div>
                    </div>
                    <div class="veb30-main-top-headers">
                        <h2>Чит-коды<br> и лайфхаки<br> поиска работы</h2>
                        <p>Получите job offer<br> этой осенью</p>
                    </div>
                    <div class="veb30-main-top-speakers">
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721981468320-0nM63-Mask.png"
                                alt="">
                            <p>Ольга<br> Лермонтова,<br> фаундер<br> Careerum,<br> Италия</p>
                        </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721981214517-c5xOo-Mask.png"
                                alt="">
                            <p>Софи Бессон,<br>карьерный<br> эксперт,<br> Израиль</p>
                        </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721981214677-YCve9-Mask.png"
                                alt="">
                            <p>Надежда<br> Община,<br>карьерный<br> эксперт,<br> Португалия</p>
                        </div>
                    </div>
                </div>
                <div class="veb30-main-center">
                    <div class="veb30-main-left">
                        <p>На мастер-классе<br> вы узнаете</p>
                        <div class="veb30-main-list-item">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721316636171-S7RR3-Chec.png"
                                alt="">
                            <p>Как быстро найти работу в классной<br> компании</p>
                        </div>
                        <div class="veb30-main-list-item">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721316656323-sbXNo-Targ.png"
                                alt="">
                            <p>Как получить оффер на ваших условиях,<br> а не тот, который дают</p>
                        </div>
                        <div class="veb30-main-list-item">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721316674849-hQMSD-Note.png"
                                alt="">
                            <p>Как и кого нанимают компании в РФ<br> и за рубежом</p>
                        </div>
                        <div class="veb30-main-bottom">
                            <p>Бонус для участников</p>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721981881855-17RlD-2223.png"
                                    alt="">
                                <p>5 гайдов с лучшими лайфхаками<br> для всех этапов поиска работы</p>
                            </div>
                        </div>
                    </div>
                    <div class="veb30-main-right">
                        <div class="careerum-registration-form-tablet">
                            <form class="deva-form getcourse-email-signup" name="devaRegistrationForm"
                                data-gjs-type="deva-registration-form">
                                <div class="careerum-veb30-form-name">
                                    <input type="text" name="name" value="" required placeholder="Имя">
                                </div>
                                <div class="careerum-veb30-form-email">
                                    <input type="text" name="email" value="" required placeholder="Почта">
                                </div>
                                <div class="careerum-veb30-form-telegram">
                                    <input type="text" name="telegram" value="" required placeholder="Telegram">
                                </div>
                                <div class="careerum-veb30-form-phone">
                                    <input type="tel" value="" name="tel" required class="itl-input">
                                </div>
                                <div class="careerum-veb30-form-agree">
                                    <label>
                                        <input type="checkbox" name="agree">
                                        <div>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8"
                                                fill="none">
                                                <path
                                                    d="M1 2.84615L3.14168 6.70118C3.21595 6.83487 3.40669 6.83912 3.48685 6.70887L7 1"
                                                    stroke="white" stroke-width="1.5" stroke-linecap="round" />
                                            </svg>
                                        </div>
                                    </label>
                                    <p>Я даю согласие на обработку своих персональных данных в соответствии с <a
                                            href="/ru-ru/legal/privacy" target="_blank">Политикой конфиденциальности</a></p>
                                </div>
                                <a href="#" class="submit-btn btn-color-main-bright-orange button-sent"
                                    disabled>Зарегистрироваться бесплатно</a>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-veb30-main2-mobile', {
        label: 'Веб 3.0 главный2 (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-veb30-main2-mobile">
            <div>
                <div class="veb30-main-top">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721983398971-CRmno-Elli.png" alt="">
                    <div class="veb30-main-top-labels">
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721980356163-H3Ukm-Cale.svg"
                                alt="">
                            <p>24 августа, 12:00 мск</p>
                        </div>
                        <div>
                            <p>Бесплатный мастер-класс</p>
                        </div>
                        <div>
                            <p>4 часа пользы и практики</p>
                        </div>
                    </div>
                    <div class="veb30-main-top-headers">
                        <h2>Чит-коды<br> и лайфхаки<br> поиска работы</h2>
                        <p>Получите job offer этой<br> осенью</p>
                    </div>
                    <div class="veb30-main-top-info">
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721983056690-XQbix-Grou.svg"
                                alt="">
                            <p>Прокачайте<br> резюме</p>
                        </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721983075785-OFVE4-Grou.svg"
                                alt="">
                            <p>Станьте<br> магнитом<br> для рекрутеров</p>
                        </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721983108321-qTTlf-Vect.svg"
                                alt="">
                            <p>Не пропустите<br> сезон найма</p>
                        </div>
                    </div>
                    <div class="veb30-main-top-speakers">
                        <p>Спикеры</p>
                        <div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721981468320-0nM63-Mask.png"
                                    alt="">
                                <p>Ольга<br> Лермонтова,<br> фаундер<br> Careerum,<br> Италия</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721981214517-c5xOo-Mask.png"
                                    alt="">
                                <p>Софи Бессон,<br>карьерный<br> эксперт,<br> Израиль</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721981214677-YCve9-Mask.png"
                                    alt="">
                                <p>Надежда<br> Община,<br>карьерный<br> эксперт,<br> Португалия</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="veb30-main-center">
                    <div class="veb30-main-right">
                        <div class="careerum-registration-form-mobile">
                            <form class="deva-form getcourse-email-signup" name="devaRegistrationForm"
                                data-gjs-type="deva-registration-form">
                                <div class="careerum-veb30-form-name">
                                    <input type="text" name="name" value="" required placeholder="Имя">
                                </div>
                                <div class="careerum-veb30-form-email">
                                    <input type="text" name="email" value="" required placeholder="Почта">
                                </div>
                                <div class="careerum-veb30-form-telegram">
                                    <input type="text" name="telegram" value="" required placeholder="Telegram">
                                </div>
                                <div class="careerum-veb30-form-phone">
                                    <input type="tel" value="" name="tel" required class="itl-input">
                                </div>
                                <div class="careerum-veb30-form-agree">
                                    <label>
                                        <input type="checkbox" name="agree">
                                        <div>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8"
                                                fill="none">
                                                <path
                                                    d="M1 2.84615L3.14168 6.70118C3.21595 6.83487 3.40669 6.83912 3.48685 6.70887L7 1"
                                                    stroke="white" stroke-width="1.5" stroke-linecap="round" />
                                            </svg>
                                        </div>
                                    </label>
                                    <p>Я даю согласие на обработку своих персональных данных в соответствии с <a
                                            href="/ru-ru/legal/privacy" target="_blank">Политикой конфиденциальности</a></p>
                                </div>
                                <a href="#" class="submit-btn btn-color-main-bright-orange button-sent"
                                    disabled>Зарегистрироваться бесплатно</a>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
	});
    
    blockManager.add('careerum-veb30-for', {
        label: 'Веб 3.0 для кого',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-veb30-for">
            <div>
                <h2>Для кого этот вебинар</h2>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721319751528-HDnY6-Vect.png" alt="">
                <div class="veb30-for-items">
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721319742039-cXg3t-Smil.png"
                            alt="">
                        <p>Не понимаете, как составить сильное резюме, чтобы успеть найти работу в 2024 году</p>
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721319809408-2pbpK-XCir.png"
                            alt="">
                        <p>Отправляете резюме пачками, а в ответ — тишина или отказы</p>
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721319797022-vsMeL-Thum.png"
                            alt="">
                        <p>Не знаете, как выгодно презентовать собственный уникальный опыт</p>
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721319742039-cXg3t-Smil.png"
                            alt="">
                        <p>Не понимаете, почему специалистов с похожим опытом приглашают на собеседования, а вас — нет </p>
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721319809408-2pbpK-XCir.png"
                            alt="">
                        <p>Не умеете показывать свои результаты через цифры и достижения </p>
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721319762660-yCzHp-Warn.png"
                            alt="">
                        <p>Не понимаете, как показать в резюме пробелы в карьере, затяжной декрет и нерелевантный опыт</p>
                    </div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-veb30-for-tablet', {
        label: 'Веб 3.0 для кого (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-veb30-for-tablet">
            <div>
                <h2>Для кого этот вебинар</h2>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721319751528-HDnY6-Vect.png" alt="">
                <div class="veb30-for-items">
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721319742039-cXg3t-Smil.png"
                            alt="">
                        <p>Не понимаете, как составить сильное резюме, чтобы успеть найти работу в 2024 году</p>
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721319809408-2pbpK-XCir.png"
                            alt="">
                        <p>Отправляете резюме пачками, а в ответ — тишина или отказы</p>
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721319797022-vsMeL-Thum.png"
                            alt="">
                        <p>Не знаете, как выгодно презентовать собственный уникальный опыт</p>
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721319742039-cXg3t-Smil.png"
                            alt="">
                        <p>Не понимаете, почему специалистов с похожим опытом приглашают на собеседования, а вас — нет </p>
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721319809408-2pbpK-XCir.png"
                            alt="">
                        <p>Не умеете показывать свои результаты через цифры и достижения </p>
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721319762660-yCzHp-Warn.png"
                            alt="">
                        <p>Не понимаете, как показать в резюме пробелы в карьере, затяжной декрет и нерелевантный опыт</p>
                    </div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-veb30-for-mobile', {
        label: 'Веб 3.0 для кого (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-veb30-for-mobile">
            <div>
                <h2>Для кого этот вебинар</h2>
                <div class="veb30-for-items">
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721543424103-tw8Ho-Smil.png"
                            alt="">
                        <p>Не понимаете, как составить сильное резюме, чтобы успеть найти работу в 2024 году</p>
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721543424573-jXkWk-XCir.png"
                            alt="">
                        <p>Отправляете резюме пачками, а в ответ — тишина или отказы</p>
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721543424323-gOvU0-Thum.png"
                            alt="">
                        <p>Не знаете, как выгодно презентовать собственный уникальный опыт</p>
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721543424103-tw8Ho-Smil.png"
                            alt="">
                        <p>Не понимаете, почему специалистов с похожим опытом приглашают на собеседования, а вас — нет </p>
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721543424573-jXkWk-XCir.png"
                            alt="">
                        <p>Не умеете показывать свои результаты через цифры и достижения </p>
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721543424452-keV0q-Warn.png"
                            alt="">
                        <p>Не понимаете, как показать в резюме пробелы в карьере, затяжной декрет и нерелевантный опыт</p>
                    </div>
                </div>
            </div>
        </div>`
	});
    
    blockManager.add('careerum-veb30-about', {
        label: 'Веб 3.0 клубок',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-veb30-about">
            <div class="careerum-flex-fsfs">
                <div>
                    <h2>Распутаем вместе<br> ваш карьерный<br> клубок</h2>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1729489495185-PjnlQ-ÐºÐ».png" alt="">
                    <div class="veb30-about-items position-absolute">
                        <div class="veb30-about-item position-absolute">
                            <p>Точно ли я занимаюсь своим делом?</p>
                        </div>
                        <div class="veb30-about-item position-absolute">
                            <p>Стоит ли менять компанию?</p>
                        </div>
                        <div class="veb30-about-item position-absolute">
                            <p>Зачем мне все это?</p>
                        </div>
                        <div class="veb30-about-item position-absolute">
                            <p>Как зарабатывать больше?</p>
                        </div>
                        <div class="veb30-about-item position-absolute">
                            <p>Как быть востребованным?</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-veb30-about-tablet', {
        label: 'Веб 3.0 клубок (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-veb30-about-tablet">
            <div>
                <div>
                    <h2>Распутаем вместе ваш<br> карьерный клубок</h2>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1729493374487-vadPB-ÐºÐ».png" alt="">
                    <div class="veb30-about-items position-absolute">
                        <div class="veb30-about-item position-absolute">
                            <p>Зачем мне все это?</p>
                        </div>
                        <div class="veb30-about-item position-absolute">
                            <p>Точно ли я занимаюсь своим делом?</p>
                        </div>
                        <div class="veb30-about-item position-absolute">
                            <p>Стоит ли менять компанию?</p>
                        </div>
                        <div class="veb30-about-item position-absolute">
                            <p>Как зарабатывать больше?</p>
                        </div>
                        <div class="veb30-about-item position-absolute">
                            <p>Как быть востребованным?</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-veb30-about-mobile', {
        label: 'Веб 3.0 клубок (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-veb30-about-mobile">
            <div>
                <div>
                    <h2>Распутаем вместе ваш<br> карьерный клубок</h2>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1729493374487-vadPB-ÐºÐ».png" alt="">
                    <div class="veb30-about-items position-absolute">
                        <div class="veb30-about-item position-absolute">
                            <p>Зачем мне все это?</p>
                        </div>
                        <div class="veb30-about-item position-absolute">
                            <p>Точно ли я занимаюсь своим делом?</p>
                        </div>
                        <div class="veb30-about-item position-absolute">
                            <p>Стоит ли менять компанию?</p>
                        </div>
                        <div class="veb30-about-item position-absolute">
                            <p>Как зарабатывать больше?</p>
                        </div>
                        <div class="veb30-about-item position-absolute">
                            <p>Как быть востребованным?</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
	});
    
    blockManager.add('careerum-veb30-reviews', {
        label: 'Веб 3.0 отзывы',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-veb30-reviews">
            <div>
                <h2>Отзывы, как Careerum помогает<br> полюбить свою работу</h2>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1729491902726-NAWKt-Vect.png" alt="">
                <div class="veb30-reviews-items careerum-flex-sbst">
                    <div class="veb30-reviews-item">
                        <p>Помимо чисто практических советов о том, как, где и каким точно образом увидеть возможности для профессионального развития, лично для меня очень ценным оказался ваш взгляд и отношение к работе как части жизни, осознания ценности своего опыта, времени, способностей и того, как это продемонстрировать работодателю. </p>
                        <p>Спасибо вам и всей вашей команде ❤️</p>
                    </div>
                    <div class="veb30-reviews-item">
                        <p>На последнем тренинге Карьерума «Переговоры — как договариваться об Оффере» на практической части был кейс по должности «Бизнес аналитик в отдел маркетинга». У меня аж сердце ёкнуло, это прям моё! Вот над чем я работала ранее и хочу работать сейчас. Ужасно рада, что сориентировалась в пространстве и нашла, что меня зажигает.</p>
                    </div>
                    <div class="veb30-reviews-item">
                        <p>Добрый день! Я прошла успешно интервью в несколько компаний, получила 3 оффера, один оффер приняла и скоро выйду на новую работу!</p>
                        <p>Спасибо огромное вам за помощь!</p>
                    </div>
                    <div class="veb30-reviews-item">
                        <p>Я хотела на самом деле разделить свою радость) Боюсь сглазить, но очень хочется разделить радость СОВМЕСТНОЙ работы! Я откликнулась на вакансию в пт и МЕНЬШЕ ЧЕМ ЧЕРЕЗ ЧАС меня пригласили на собеседование!</p>
                    </div>
                    <div class="veb30-reviews-item">
                        <p>Если 6 можно было поставить вам звездочку, то она точно ваша! Вы мне очень помогаете не утонуть тут в пучине всего происходящего.
                        </p>
                    </div>
                    <div class="veb30-reviews-item">
                        <p>Благодаря проекту был приручен "самозванец", моя карьера вошла в правильное русло и работа теперь приносит удовольствие. Спасибо! Вы лучшие!
                        </p>
                    </div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-veb30-reviews-tablet', {
        label: 'Веб 3.0 отзывы (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-veb30-reviews-tablet">
            <div>
                <h2>Отзывы, как Careerum помогает<br> полюбить свою работу</h2>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1729494043881-gThIc-Vect.png" alt="">
                <div class="veb30-reviews-items careerum-flex-sbst">
                    <div class="veb30-reviews-item">
                        <p>Помимо чисто практических советов о том, как, где и каким точно образом увидеть возможности для профессионального развития, лично для меня очень ценным оказался ваш взгляд и отношение к работе как части жизни, осознания ценности своего опыта, времени, способностей и того, как это продемонстрировать работодателю. </p>
                        <p>Спасибо вам и всей вашей команде ❤️</p>
                    </div>
                    <div class="veb30-reviews-item">
                        <p>На последнем тренинге Карьерума «Переговоры — как договариваться об Оффере» на практической части был кейс по должности «Бизнес аналитик в отдел маркетинга». У меня аж сердце ёкнуло, это прям моё! Вот над чем я работала ранее и хочу работать сейчас. Ужасно рада, что сориентировалась в пространстве и нашла, что меня зажигает.</p>
                    </div>
                    <div class="veb30-reviews-item">
                        <p>Добрый день! Я прошла успешно интервью в несколько компаний, получила 3 оффера, один оффер приняла и скоро выйду на новую работу!</p>
                        <p>Спасибо огромное вам за помощь!</p>
                    </div>
                    <div class="veb30-reviews-item">
                        <p>Я хотела на самом деле разделить свою радость) Боюсь сглазить, но очень хочется разделить радость СОВМЕСТНОЙ работы! Я откликнулась на вакансию в пт и МЕНЬШЕ ЧЕМ ЧЕРЕЗ ЧАС меня пригласили на собеседование!</p>
                    </div>
                    <div class="veb30-reviews-item">
                        <p>Если 6 можно было поставить вам звездочку, то она точно ваша! Вы мне очень помогаете не утонуть тут в пучине всего происходящего.
                        </p>
                    </div>
                    <div class="veb30-reviews-item">
                        <p>Благодаря проекту был приручен "самозванец", моя карьера вошла в правильное русло и работа теперь приносит удовольствие. Спасибо! Вы лучшие!
                        </p>
                    </div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-veb30-reviews-mobile', {
        label: 'Веб 3.0 отзывы (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-veb30-reviews-mobile">
            <div>
                <h2>Отзывы, как Careerum помогает полюбить свою работу</h2>
                <div class="veb30-reviews-items reviews-slider">
                    <div class="veb30-reviews-item">
                        <p>Помимо чисто практических советов о том, как, где и каким точно образом увидеть возможности
                            для профессионального развития, лично для меня очень ценным оказался ваш взгляд и отношение к
                            работе как части жизни, осознания ценности своего опыта, времени, способностей и того, как это
                            продемонстрировать работодателю. </p>
                        <p>Спасибо вам и всей вашей команде ❤️</p>
                    </div>
                    <div class="veb30-reviews-item">
                        <p>На последнем тренинге Карьерума «Переговоры — как договариваться об Оффере» на практической части
                            был кейс по должности «Бизнес аналитик в отдел маркетинга». У меня аж сердце ёкнуло, это прям
                            моё! Вот над чем я работала ранее и хочу работать сейчас. Ужасно рада, что сориентировалась в
                            пространстве и нашла, что меня зажигает.</p>
                    </div>
                    <div class="veb30-reviews-item">
                        <p>Добрый день! Я прошла успешно интервью в несколько компаний, получила 3 оффера, один оффер
                            приняла и скоро выйду на новую работу!</p>
                        <p>Спасибо огромное вам за помощь!</p>
                    </div>
                    <div class="veb30-reviews-item">
                        <p>Я хотела на самом деле разделить свою радость) Боюсь сглазить, но очень хочется разделить радость
                            СОВМЕСТНОЙ работы! Я откликнулась на вакансию в пт и МЕНЬШЕ ЧЕМ ЧЕРЕЗ ЧАС меня пригласили на
                            собеседование!</p>
                    </div>
                    <div class="veb30-reviews-item">
                        <p>Если 6 можно было поставить вам звездочку, то она точно ваша! Вы мне очень помогаете не утонуть
                            тут в пучине всего происходящего.
                        </p>
                    </div>
                    <div class="veb30-reviews-item">
                        <p>Благодаря проекту был приручен "самозванец", моя карьера вошла в правильное русло и работа теперь
                            приносит удовольствие. Спасибо! Вы лучшие!
                        </p>
                    </div>
                </div>
            </div>
        </div>`
	});
    
    blockManager.add('careerum-veb30-programm', {
        label: 'Веб 3.0 программа',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-veb30-programm">
            <div>
                <h2>Программа вебинара</h2>
                <div class="veb30-programm-items">
                    <div class="veb30-programm-item">
                        <p class="veb30-programm-item-header">Часть №1: Обзор рынка труда 2024</p>
                        <div class="veb30-programm-item-labels">
                            <p>5 lessons</p>
                            <p>April 15—April 25</p>
                        </div>
                        <p class="veb30-programm-item-text">This module is designed to transform the way you think about
                            your career path. Beyond debunking popular myths that may hold you back, you'll dive deep into
                            understanding the power of strategic career planning.</p>
                        <div class="veb30-programm-item-content">
                            <p class="veb30-programm-item-subheader">Get ready to:</p>
                            <ul>
                                <li>Get rid of common career myths and unlock your true potential for professional
                                    advancement.
                                </li>
                                <li>Clarify your career vector & the power of strategic planning over winging it.</li>
                                <li>Craft a tailored career plan and set actionable goals.</li>
                                <li>Boost your career progression by mastering crucial professional skills.</li>
                                <li>Learn the skills to manage through risks with ease and tackle challenges in your career
                                    path.</li>
                            </ul>
                            <p class="veb30-programm-item-subtext">This module is designed to transform the way you think
                                about your career path. Beyond debunking popular myths that may hold you back, you'll dive
                                deep into understanding the power of strategic career planning.</p>
                        </div>
                        <div class="veb30-programm-item-button">
                            <p>Подробнее</p>
                            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M16 28C22.6274 28 28 22.6274 28 16C28 9.37258 22.6274 4 16 4C9.37258 4 4 9.37258 4 16C4 22.6274 9.37258 28 16 28Z"
                                    stroke="black" stroke-width="2" stroke-miterlimit="10" />
                                <path d="M20.5 14.5L16 19.5L11.5 14.5" stroke="black" stroke-width="2"
                                    stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </div>
                    </div>
                    <div class="veb30-programm-item">
                        <p class="veb30-programm-item-header">Часть №2: 7 самых частых ошибок в резюме и решения к ним</p>
                        <div class="veb30-programm-item-labels">
                            <p>5 lessons</p>
                            <p>April 15—April 25</p>
                        </div>
                        <p class="veb30-programm-item-text">In this module, you’ll learn how to set, plan, and achieve your
                            career aspirations with precision and clarity. We cover everything from overcoming obstacles
                            that stand in your way to methodologies that top professionals use to achieve their dreams.</p>
                        <div class="veb30-programm-item-content">
                            <p class="veb30-programm-item-subheader">Get ready to:</p>
                            <ul>
                                <li>Get rid of common career myths and unlock your true potential for professional
                                    advancement.
                                </li>
                                <li>Clarify your career vector & the power of strategic planning over winging it.</li>
                                <li>Craft a tailored career plan and set actionable goals.</li>
                                <li>Boost your career progression by mastering crucial professional skills.</li>
                                <li>Learn the skills to manage through risks with ease and tackle challenges in your career
                                    path.</li>
                            </ul>
                            <p class="veb30-programm-item-subtext">This module is designed to transform the way you think
                                about your career path. Beyond debunking popular myths that may hold you back, you'll dive
                                deep into understanding the power of strategic career planning.</p>
                        </div>
                        <div class="veb30-programm-item-button">
                            <p>Подробнее</p>
                            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M16 28C22.6274 28 28 22.6274 28 16C28 9.37258 22.6274 4 16 4C9.37258 4 4 9.37258 4 16C4 22.6274 9.37258 28 16 28Z"
                                    stroke="black" stroke-width="2" stroke-miterlimit="10" />
                                <path d="M20.5 14.5L16 19.5L11.5 14.5" stroke="black" stroke-width="2"
                                    stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </div>
                    </div>
                    <div class="veb30-programm-item">
                        <p class="veb30-programm-item-header">Часть №3: Как ускорить поиск работы</p>
                        <div class="veb30-programm-item-labels">
                            <p>5 lessons</p>
                            <p>April 15—April 25</p>
                        </div>
                        <p class="veb30-programm-item-text">This module is designed to transform the way you think about
                            your career path. Beyond debunking popular myths that may hold you back, you'll dive deep into
                            understanding the power of strategic career planning.</p>
                        <div class="veb30-programm-item-content">
                            <p class="veb30-programm-item-subheader">Get ready to:</p>
                            <ul>
                                <li>Get rid of common career myths and unlock your true potential for professional
                                    advancement.
                                </li>
                                <li>Clarify your career vector & the power of strategic planning over winging it.</li>
                                <li>Craft a tailored career plan and set actionable goals.</li>
                                <li>Boost your career progression by mastering crucial professional skills.</li>
                                <li>Learn the skills to manage through risks with ease and tackle challenges in your career
                                    path.</li>
                            </ul>
                            <p class="veb30-programm-item-subtext">This module is designed to transform the way you think
                                about your career path. Beyond debunking popular myths that may hold you back, you'll dive
                                deep into understanding the power of strategic career planning.</p>
                        </div>
                        <div class="veb30-programm-item-button">
                            <p>Подробнее</p>
                            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M16 28C22.6274 28 28 22.6274 28 16C28 9.37258 22.6274 4 16 4C9.37258 4 4 9.37258 4 16C4 22.6274 9.37258 28 16 28Z"
                                    stroke="black" stroke-width="2" stroke-miterlimit="10" />
                                <path d="M20.5 14.5L16 19.5L11.5 14.5" stroke="black" stroke-width="2"
                                    stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </div>
                    </div>
                </div>
                <div class="veb30-programm-items">
                    <div class="veb30-programm-item">
                        <p class="veb30-programm-item-header"> Прожарка ваших резюме</p>
                        <div class="veb30-programm-item-labels">
                            <p>5 lessons</p>
                            <p>April 15—April 25</p>
                        </div>
                        <p class="veb30-programm-item-text">This module is designed to transform the way you think about
                            your career path. Beyond debunking popular myths that may hold you back, you'll dive deep into
                            understanding the power of strategic career planning.</p>
                        <div class="veb30-programm-item-content">
                            <p class="veb30-programm-item-subheader">Get ready to:</p>
                            <ul>
                                <li>Get rid of common career myths and unlock your true potential for professional
                                    advancement.
                                </li>
                                <li>Clarify your career vector & the power of strategic planning over winging it.</li>
                                <li>Craft a tailored career plan and set actionable goals.</li>
                                <li>Boost your career progression by mastering crucial professional skills.</li>
                                <li>Learn the skills to manage through risks with ease and tackle challenges in your career
                                    path.</li>
                            </ul>
                            <p class="veb30-programm-item-subtext">This module is designed to transform the way you think
                                about your career path. Beyond debunking popular myths that may hold you back, you'll dive
                                deep into understanding the power of strategic career planning.</p>
                        </div>
                        <div class="veb30-programm-item-button">
                            <p>Подробнее</p>
                            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M16 28C22.6274 28 28 22.6274 28 16C28 9.37258 22.6274 4 16 4C9.37258 4 4 9.37258 4 16C4 22.6274 9.37258 28 16 28Z"
                                    stroke="black" stroke-width="2" stroke-miterlimit="10" />
                                <path d="M20.5 14.5L16 19.5L11.5 14.5" stroke="black" stroke-width="2"
                                    stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </div>
                    </div>
                    <div class="veb30-programm-item">
                        <p class="veb30-programm-item-header">Q&A</p>
                        <div class="veb30-programm-item-labels">
                            <p>5 lessons</p>
                            <p>April 15—April 25</p>
                        </div>
                        <p class="veb30-programm-item-text">In this module, you’ll learn how to set, plan, and achieve your
                            career aspirations with precision and clarity. We cover everything from overcoming obstacles
                            that stand in your way to methodologies that top professionals use to achieve their dreams.</p>
                        <div class="veb30-programm-item-content">
                            <p class="veb30-programm-item-subheader">Get ready to:</p>
                            <ul>
                                <li>Get rid of common career myths and unlock your true potential for professional
                                    advancement.
                                </li>
                                <li>Clarify your career vector & the power of strategic planning over winging it.</li>
                                <li>Craft a tailored career plan and set actionable goals.</li>
                                <li>Boost your career progression by mastering crucial professional skills.</li>
                                <li>Learn the skills to manage through risks with ease and tackle challenges in your career
                                    path.</li>
                            </ul>
                            <p class="veb30-programm-item-subtext">This module is designed to transform the way you think
                                about your career path. Beyond debunking popular myths that may hold you back, you'll dive
                                deep into understanding the power of strategic career planning.</p>
                        </div>
                        <div class="veb30-programm-item-button">
                            <p>Подробнее</p>
                            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M16 28C22.6274 28 28 22.6274 28 16C28 9.37258 22.6274 4 16 4C9.37258 4 4 9.37258 4 16C4 22.6274 9.37258 28 16 28Z"
                                    stroke="black" stroke-width="2" stroke-miterlimit="10" />
                                <path d="M20.5 14.5L16 19.5L11.5 14.5" stroke="black" stroke-width="2"
                                    stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </div>
                    </div>
                </div>
                <div class="veb30-programm-link">
                    <a href="#buy" class="btn-color-main-dark-orange">Зарегистрироваться бесплатно</a>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-veb30-programm-tablet', {
        label: 'Веб 3.0 программа (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-veb30-programm-tablet">
            <div>
                <h2>Программа вебинара</h2>
                <div class="veb30-programm-items">
                    <div class="veb30-programm-item">
                        <p class="veb30-programm-item-header">Часть №1: Обзор рынка труда 2024</p>
                        <div class="veb30-programm-item-labels">
                            <p>5 lessons</p>
                            <p>April 15—April 25</p>
                        </div>
                        <p class="veb30-programm-item-text">This module is designed to transform the way you think about
                            your career path. Beyond debunking popular myths that may hold you back, you'll dive deep into
                            understanding the power of strategic career planning.</p>
                        <div class="veb30-programm-item-content">
                            <p class="veb30-programm-item-subheader">Get ready to:</p>
                            <ul>
                                <li>Get rid of common career myths and unlock your true potential for professional
                                    advancement.
                                </li>
                                <li>Clarify your career vector & the power of strategic planning over winging it.</li>
                                <li>Craft a tailored career plan and set actionable goals.</li>
                                <li>Boost your career progression by mastering crucial professional skills.</li>
                                <li>Learn the skills to manage through risks with ease and tackle challenges in your career
                                    path.</li>
                            </ul>
                            <p class="veb30-programm-item-subtext">This module is designed to transform the way you think
                                about your career path. Beyond debunking popular myths that may hold you back, you'll dive
                                deep into understanding the power of strategic career planning.</p>
                        </div>
                        <div class="veb30-programm-item-button">
                            <p>Подробнее</p>
                            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M16 28C22.6274 28 28 22.6274 28 16C28 9.37258 22.6274 4 16 4C9.37258 4 4 9.37258 4 16C4 22.6274 9.37258 28 16 28Z"
                                    stroke="black" stroke-width="2" stroke-miterlimit="10" />
                                <path d="M20.5 14.5L16 19.5L11.5 14.5" stroke="black" stroke-width="2"
                                    stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </div>
                    </div>
                    <div class="veb30-programm-item">
                        <p class="veb30-programm-item-header">Часть №2: 7 самых частых ошибок в резюме и решения к ним</p>
                        <div class="veb30-programm-item-labels">
                            <p>5 lessons</p>
                            <p>April 15—April 25</p>
                        </div>
                        <p class="veb30-programm-item-text">In this module, you’ll learn how to set, plan, and achieve your
                            career aspirations with precision and clarity. We cover everything from overcoming obstacles
                            that stand in your way to methodologies that top professionals use to achieve their dreams.</p>
                        <div class="veb30-programm-item-content">
                            <p class="veb30-programm-item-subheader">Get ready to:</p>
                            <ul>
                                <li>Get rid of common career myths and unlock your true potential for professional
                                    advancement.
                                </li>
                                <li>Clarify your career vector & the power of strategic planning over winging it.</li>
                                <li>Craft a tailored career plan and set actionable goals.</li>
                                <li>Boost your career progression by mastering crucial professional skills.</li>
                                <li>Learn the skills to manage through risks with ease and tackle challenges in your career
                                    path.</li>
                            </ul>
                            <p class="veb30-programm-item-subtext">This module is designed to transform the way you think
                                about your career path. Beyond debunking popular myths that may hold you back, you'll dive
                                deep into understanding the power of strategic career planning.</p>
                        </div>
                        <div class="veb30-programm-item-button">
                            <p>Подробнее</p>
                            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M16 28C22.6274 28 28 22.6274 28 16C28 9.37258 22.6274 4 16 4C9.37258 4 4 9.37258 4 16C4 22.6274 9.37258 28 16 28Z"
                                    stroke="black" stroke-width="2" stroke-miterlimit="10" />
                                <path d="M20.5 14.5L16 19.5L11.5 14.5" stroke="black" stroke-width="2"
                                    stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </div>
                    </div>
                    <div class="veb30-programm-item">
                        <p class="veb30-programm-item-header">Часть №3: Как ускорить поиск работы</p>
                        <div class="veb30-programm-item-labels">
                            <p>5 lessons</p>
                            <p>April 15—April 25</p>
                        </div>
                        <p class="veb30-programm-item-text">This module is designed to transform the way you think about
                            your career path. Beyond debunking popular myths that may hold you back, you'll dive deep into
                            understanding the power of strategic career planning.</p>
                        <div class="veb30-programm-item-content">
                            <p class="veb30-programm-item-subheader">Get ready to:</p>
                            <ul>
                                <li>Get rid of common career myths and unlock your true potential for professional
                                    advancement.
                                </li>
                                <li>Clarify your career vector & the power of strategic planning over winging it.</li>
                                <li>Craft a tailored career plan and set actionable goals.</li>
                                <li>Boost your career progression by mastering crucial professional skills.</li>
                                <li>Learn the skills to manage through risks with ease and tackle challenges in your career
                                    path.</li>
                            </ul>
                            <p class="veb30-programm-item-subtext">This module is designed to transform the way you think
                                about your career path. Beyond debunking popular myths that may hold you back, you'll dive
                                deep into understanding the power of strategic career planning.</p>
                        </div>
                        <div class="veb30-programm-item-button">
                            <p>Подробнее</p>
                            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M16 28C22.6274 28 28 22.6274 28 16C28 9.37258 22.6274 4 16 4C9.37258 4 4 9.37258 4 16C4 22.6274 9.37258 28 16 28Z"
                                    stroke="black" stroke-width="2" stroke-miterlimit="10" />
                                <path d="M20.5 14.5L16 19.5L11.5 14.5" stroke="black" stroke-width="2"
                                    stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </div>
                    </div>
                    <div class="veb30-programm-item">
                        <p class="veb30-programm-item-header"> Прожарка ваших резюме</p>
                        <div class="veb30-programm-item-labels">
                            <p>5 lessons</p>
                            <p>April 15—April 25</p>
                        </div>
                        <p class="veb30-programm-item-text">This module is designed to transform the way you think about
                            your career path. Beyond debunking popular myths that may hold you back, you'll dive deep into
                            understanding the power of strategic career planning.</p>
                        <div class="veb30-programm-item-content">
                            <p class="veb30-programm-item-subheader">Get ready to:</p>
                            <ul>
                                <li>Get rid of common career myths and unlock your true potential for professional
                                    advancement.
                                </li>
                                <li>Clarify your career vector & the power of strategic planning over winging it.</li>
                                <li>Craft a tailored career plan and set actionable goals.</li>
                                <li>Boost your career progression by mastering crucial professional skills.</li>
                                <li>Learn the skills to manage through risks with ease and tackle challenges in your career
                                    path.</li>
                            </ul>
                            <p class="veb30-programm-item-subtext">This module is designed to transform the way you think
                                about your career path. Beyond debunking popular myths that may hold you back, you'll dive
                                deep into understanding the power of strategic career planning.</p>
                        </div>
                        <div class="veb30-programm-item-button">
                            <p>Подробнее</p>
                            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M16 28C22.6274 28 28 22.6274 28 16C28 9.37258 22.6274 4 16 4C9.37258 4 4 9.37258 4 16C4 22.6274 9.37258 28 16 28Z"
                                    stroke="black" stroke-width="2" stroke-miterlimit="10" />
                                <path d="M20.5 14.5L16 19.5L11.5 14.5" stroke="black" stroke-width="2"
                                    stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </div>
                    </div>
                    <div class="veb30-programm-item">
                        <p class="veb30-programm-item-header">Q&A</p>
                        <div class="veb30-programm-item-labels">
                            <p>5 lessons</p>
                            <p>April 15—April 25</p>
                        </div>
                        <p class="veb30-programm-item-text">In this module, you’ll learn how to set, plan, and achieve your
                            career aspirations with precision and clarity. We cover everything from overcoming obstacles
                            that stand in your way to methodologies that top professionals use to achieve their dreams.</p>
                        <div class="veb30-programm-item-content">
                            <p class="veb30-programm-item-subheader">Get ready to:</p>
                            <ul>
                                <li>Get rid of common career myths and unlock your true potential for professional
                                    advancement.
                                </li>
                                <li>Clarify your career vector & the power of strategic planning over winging it.</li>
                                <li>Craft a tailored career plan and set actionable goals.</li>
                                <li>Boost your career progression by mastering crucial professional skills.</li>
                                <li>Learn the skills to manage through risks with ease and tackle challenges in your career
                                    path.</li>
                            </ul>
                            <p class="veb30-programm-item-subtext">This module is designed to transform the way you think
                                about your career path. Beyond debunking popular myths that may hold you back, you'll dive
                                deep into understanding the power of strategic career planning.</p>
                        </div>
                        <div class="veb30-programm-item-button">
                            <p>Подробнее</p>
                            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M16 28C22.6274 28 28 22.6274 28 16C28 9.37258 22.6274 4 16 4C9.37258 4 4 9.37258 4 16C4 22.6274 9.37258 28 16 28Z"
                                    stroke="black" stroke-width="2" stroke-miterlimit="10" />
                                <path d="M20.5 14.5L16 19.5L11.5 14.5" stroke="black" stroke-width="2"
                                    stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </div>
                    </div>
                </div>
                <div class="veb30-product-programm-bottom  careerum-flex-sbfs">
                    <div>
                        <p>Результаты</p>
                        <p>Вы пройдете путь от поиска работы к офферу мечты </p>
                    </div>
                    <div>
                        <p>Узнаете, как: </p>
                            
                        <ul>
                            <li>Искать вакансии системно,а не хаотично</li>
                            <li>Составлять продающие резюме и сопроводительные письма</li>
                            <li>Усилите LinkedIn</li>
                            <li>Начнете успешно проходить интервью и договариваться на свои условия оффера</li>
                        </ul>
                    </div>
                </div>
                <div class="veb30-programm-bottom">
                    <p>Курс основан на глубоком понимании мотивационных факторов, которые влияют на счастье, создавая
                        гармонию между личной и профессиональной жизнью</p>
                </div>
                <div class="veb30-programm-link">
                    <a href="#buy" class="btn-color-main-dark-orange">Зарегистрироваться бесплатно</a>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-veb30-programm-mobile', {
        label: 'Веб 3.0 программа (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-veb30-programm-mobile">
            <div>
                <h2>Программа вебинара</h2>
                <div class="veb30-programm-items">
                    <div class="veb30-programm-item">
                        <p class="veb30-programm-item-header">Часть №1: Обзор рынка труда 2024</p>
                        <div class="veb30-programm-item-labels">
                            <p>5 lessons</p>
                            <p>April 15—April 25</p>
                        </div>
                        <p class="veb30-programm-item-text">This module is designed to transform the way you think about
                            your career path. Beyond debunking popular myths that may hold you back, you'll dive deep into
                            understanding the power of strategic career planning.</p>
                        <div class="veb30-programm-item-content">
                            <p class="veb30-programm-item-subheader">Get ready to:</p>
                            <ul>
                                <li>Get rid of common career myths and unlock your true potential for professional
                                    advancement.
                                </li>
                                <li>Clarify your career vector & the power of strategic planning over winging it.</li>
                                <li>Craft a tailored career plan and set actionable goals.</li>
                                <li>Boost your career progression by mastering crucial professional skills.</li>
                                <li>Learn the skills to manage through risks with ease and tackle challenges in your career
                                    path.</li>
                            </ul>
                            <p class="veb30-programm-item-subtext">This module is designed to transform the way you think
                                about your career path. Beyond debunking popular myths that may hold you back, you'll dive
                                deep into understanding the power of strategic career planning.</p>
                        </div>
                        <div class="veb30-programm-item-button">
                            <p>Подробнее</p>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
                                    stroke="black" stroke-width="1.5" stroke-miterlimit="10" />
                                <path d="M15.375 10.875L12 14.625L8.625 10.875" stroke="black" stroke-width="1.5"
                                    stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </div>
                    </div>
                    <div class="veb30-programm-item">
                        <p class="veb30-programm-item-header">Часть №2: 7 самых частых ошибок в резюме и решения к ним</p>
                        <div class="veb30-programm-item-labels">
                            <p>5 lessons</p>
                            <p>April 15—April 25</p>
                        </div>
                        <p class="veb30-programm-item-text">In this module, you’ll learn how to set, plan, and achieve your
                            career aspirations with precision and clarity. We cover everything from overcoming obstacles
                            that stand in your way to methodologies that top professionals use to achieve their dreams.</p>
                        <div class="veb30-programm-item-content">
                            <p class="veb30-programm-item-subheader">Get ready to:</p>
                            <ul>
                                <li>Get rid of common career myths and unlock your true potential for professional
                                    advancement.
                                </li>
                                <li>Clarify your career vector & the power of strategic planning over winging it.</li>
                                <li>Craft a tailored career plan and set actionable goals.</li>
                                <li>Boost your career progression by mastering crucial professional skills.</li>
                                <li>Learn the skills to manage through risks with ease and tackle challenges in your career
                                    path.</li>
                            </ul>
                            <p class="veb30-programm-item-subtext">This module is designed to transform the way you think
                                about your career path. Beyond debunking popular myths that may hold you back, you'll dive
                                deep into understanding the power of strategic career planning.</p>
                        </div>
                        <div class="veb30-programm-item-button">
                            <p>Подробнее</p>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
                                    stroke="black" stroke-width="1.5" stroke-miterlimit="10" />
                                <path d="M15.375 10.875L12 14.625L8.625 10.875" stroke="black" stroke-width="1.5"
                                    stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </div>
                    </div>
                    <div class="veb30-programm-item">
                        <p class="veb30-programm-item-header">Часть №3: Как ускорить поиск работы</p>
                        <div class="veb30-programm-item-labels">
                            <p>5 lessons</p>
                            <p>April 15—April 25</p>
                        </div>
                        <p class="veb30-programm-item-text">This module is designed to transform the way you think about
                            your career path. Beyond debunking popular myths that may hold you back, you'll dive deep into
                            understanding the power of strategic career planning.</p>
                        <div class="veb30-programm-item-content">
                            <p class="veb30-programm-item-subheader">Get ready to:</p>
                            <ul>
                                <li>Get rid of common career myths and unlock your true potential for professional
                                    advancement.
                                </li>
                                <li>Clarify your career vector & the power of strategic planning over winging it.</li>
                                <li>Craft a tailored career plan and set actionable goals.</li>
                                <li>Boost your career progression by mastering crucial professional skills.</li>
                                <li>Learn the skills to manage through risks with ease and tackle challenges in your career
                                    path.</li>
                            </ul>
                            <p class="veb30-programm-item-subtext">This module is designed to transform the way you think
                                about your career path. Beyond debunking popular myths that may hold you back, you'll dive
                                deep into understanding the power of strategic career planning.</p>
                        </div>
                        <div class="veb30-programm-item-button">
                            <p>Подробнее</p>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
                                    stroke="black" stroke-width="1.5" stroke-miterlimit="10" />
                                <path d="M15.375 10.875L12 14.625L8.625 10.875" stroke="black" stroke-width="1.5"
                                    stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </div>
                    </div>
                    <div class="veb30-programm-item">
                        <p class="veb30-programm-item-header"> Прожарка ваших резюме</p>
                        <div class="veb30-programm-item-labels">
                            <p>5 lessons</p>
                            <p>April 15—April 25</p>
                        </div>
                        <p class="veb30-programm-item-text">This module is designed to transform the way you think about
                            your career path. Beyond debunking popular myths that may hold you back, you'll dive deep into
                            understanding the power of strategic career planning.</p>
                        <div class="veb30-programm-item-content">
                            <p class="veb30-programm-item-subheader">Get ready to:</p>
                            <ul>
                                <li>Get rid of common career myths and unlock your true potential for professional
                                    advancement.
                                </li>
                                <li>Clarify your career vector & the power of strategic planning over winging it.</li>
                                <li>Craft a tailored career plan and set actionable goals.</li>
                                <li>Boost your career progression by mastering crucial professional skills.</li>
                                <li>Learn the skills to manage through risks with ease and tackle challenges in your career
                                    path.</li>
                            </ul>
                            <p class="veb30-programm-item-subtext">This module is designed to transform the way you think
                                about your career path. Beyond debunking popular myths that may hold you back, you'll dive
                                deep into understanding the power of strategic career planning.</p>
                        </div>
                        <div class="veb30-programm-item-button">
                            <p>Подробнее</p>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
                                    stroke="black" stroke-width="1.5" stroke-miterlimit="10" />
                                <path d="M15.375 10.875L12 14.625L8.625 10.875" stroke="black" stroke-width="1.5"
                                    stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </div>
                    </div>
                    <div class="veb30-programm-item">
                        <p class="veb30-programm-item-header">Q&A</p>
                        <div class="veb30-programm-item-labels">
                            <p>5 lessons</p>
                            <p>April 15—April 25</p>
                        </div>
                        <p class="veb30-programm-item-text">In this module, you’ll learn how to set, plan, and achieve your
                            career aspirations with precision and clarity. We cover everything from overcoming obstacles
                            that stand in your way to methodologies that top professionals use to achieve their dreams.</p>
                        <div class="veb30-programm-item-content">
                            <p class="veb30-programm-item-subheader">Get ready to:</p>
                            <ul>
                                <li>Get rid of common career myths and unlock your true potential for professional
                                    advancement.
                                </li>
                                <li>Clarify your career vector & the power of strategic planning over winging it.</li>
                                <li>Craft a tailored career plan and set actionable goals.</li>
                                <li>Boost your career progression by mastering crucial professional skills.</li>
                                <li>Learn the skills to manage through risks with ease and tackle challenges in your career
                                    path.</li>
                            </ul>
                            <p class="veb30-programm-item-subtext">This module is designed to transform the way you think
                                about your career path. Beyond debunking popular myths that may hold you back, you'll dive
                                deep into understanding the power of strategic career planning.</p>
                        </div>
                        <div class="veb30-programm-item-button">
                            <p>Подробнее</p>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
                                    stroke="black" stroke-width="1.5" stroke-miterlimit="10" />
                                <path d="M15.375 10.875L12 14.625L8.625 10.875" stroke="black" stroke-width="1.5"
                                    stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </div>
                    </div>
                </div>
                <div class="veb30-product-programm-bottom  careerum-flex-sbfs">
                    <div>
                        <p>Результаты</p>
                        <p>Вы пройдете путь от поиска работы к офферу мечты </p>
                    </div>
                    <div>
                        <p>Узнаете, как: </p>
                            
                        <ul>
                            <li>Искать вакансии системно,а не хаотично</li>
                            <li>Составлять продающие резюме и сопроводительные письма</li>
                            <li>Усилите LinkedIn</li>
                            <li>Начнете успешно проходить интервью и договариваться на свои условия оффера</li>
                        </ul>
                    </div>
                </div>
                <div class="veb30-programm-bottom">
                    <p>Курс основан на глубоком понимании мотивационных факторов, которые влияют на счастье, создавая
                        гармонию между личной и профессиональной жизнью</p>
                </div>
                <div class="veb30-programm-link">
                    <a href="#buy" class="btn-color-main-dark-orange">Зарегистрироваться бесплатно</a>
                </div>
            </div>
        </div>`
	});
    
    blockManager.add('careerum-veb30-speaker', {
        label: 'Веб 3.0 спикер',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-veb30-speaker" data-video-id="938102634">
            <div>
                <h2>Спикер — Софи Бессон</h2>
                <div class="veb30-speaker-content speaker-video">
                    <div class="veb30-speaker-left">
                        <div class="veb30-speaker-frame">
    
                        </div>
                        <svg width="72" height="72" viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="veb30-speaker-video-button">
                            <path
                                d="M36 63C50.9117 63 63 50.9117 63 36C63 21.0883 50.9117 9 36 9C21.0883 9 9 21.0883 9 36C9 50.9117 21.0883 63 36 63Z"
                                fill="#A1E5FF" fill-opacity="0.45" stroke="#0B70FE" stroke-width="4.5"
                                stroke-miterlimit="10" />
                            <path d="M45 36L31.5 27V45L45 36Z" stroke="#0B70FE" stroke-width="4.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>
                    </div>
                    <div class="veb30-speaker-right">
                        <div class="single-line">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721376901142-F7jCk-Brie.png"
                                alt="">
                            <p>4,5 года в карьерном консалтинге, с 2015 года в HR</p>
                        </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721376906751-iXRHS-User.png"
                                alt="">
                            <p>600+ клиентов из локальных и крупных компаний: IBM, World Bank, Microsoft, Disney, Mastercard
                                и др.</p>
                        </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721376906029-4RkWK-Eye..png"
                                alt="">
                            <p>Помогает обнаружить проблемы, которые тормозят поиск работы на международном рынке и в СНГ
                            </p>
                        </div>
                        <div class="single-line">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721376906141-Y3Z8q-Note.png"
                                alt="">
                            <p>Бакалавр и магистр психологии</p>
                        </div>
                        <div class="single-line">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721376906259-Hij0B-Star.png"
                                alt="">
                            <p>9,7 из 10: средний балл оценки работы от клиентов</p>
                        </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721376906460-y2jNG-Thum.png"
                                alt="">
                            <p>97% клиентов Софи отмечают: индивидуальный подход, отзывчивость, глубину рекомендаций и
                                искреннюю поддержку</p>
                        </div>
                    </div>
                </div>
                <div class="veb30-speaker-content speaker-one">
                    <div class="veb30-speaker-left">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721380807158-IBYBn-Fram.png"
                            alt="">
                    </div>
                    <div class="veb30-speaker-right">
                        <div class="single-line">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721376901142-F7jCk-Brie.png"
                                alt="">
                            <p>4,5 года в карьерном консалтинге, с 2015 года в HR</p>
                        </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721376906751-iXRHS-User.png"
                                alt="">
                            <p>600+ клиентов из локальных и крупных компаний: IBM, World Bank, Microsoft, Disney, Mastercard
                                и др.</p>
                        </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721376906029-4RkWK-Eye..png"
                                alt="">
                            <p>Помогает обнаружить проблемы, которые тормозят поиск работы на международном рынке и в СНГ
                            </p>
                        </div>
                        <div class="single-line">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721376906141-Y3Z8q-Note.png"
                                alt="">
                            <p>Бакалавр и магистр психологии</p>
                        </div>
                        <div class="single-line">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721376906259-Hij0B-Star.png"
                                alt="">
                            <p>9,7 из 10: средний балл оценки работы от клиентов</p>
                        </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721376906460-y2jNG-Thum.png"
                                alt="">
                            <p>97% клиентов Софи отмечают: индивидуальный подход, отзывчивость, глубину рекомендаций и
                                искреннюю поддержку</p>
                        </div>
                    </div>
                </div>
                <div class="veb30-speaker-content speakers-two">
                    <div class="veb30-speaker-wrapper">
                        <div class="veb30-speaker-left">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721381352353-MrK6d-Fram.png"
                                alt="">
                            <p>Софи Бессон</p>
                        </div>
                        <div class="veb30-speaker-right">
                            <div class="single-line">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721376901142-F7jCk-Brie.png"
                                    alt="">
                                <p>4,5 года в карьерном консалтинге, с 2015 года в HR</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721376906751-iXRHS-User.png"
                                    alt="">
                                <p>600+ клиентов из локальных и крупных компаний: IBM, World Bank, Microsoft, Disney,
                                    Mastercard
                                    и др.</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721376906029-4RkWK-Eye..png"
                                    alt="">
                                <p>Помогает обнаружить проблемы, которые тормозят поиск работы на международном рынке и в
                                    СНГ
                                </p>
                            </div>
                            <div class="single-line">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721376906141-Y3Z8q-Note.png"
                                    alt="">
                                <p>Бакалавр и магистр психологии</p>
                            </div>
                            <div class="single-line">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721376906259-Hij0B-Star.png"
                                    alt="">
                                <p>9,7 из 10: средний балл оценки работы от клиентов</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721376906460-y2jNG-Thum.png"
                                    alt="">
                                <p>97% клиентов Софи отмечают: индивидуальный подход, отзывчивость, глубину рекомендаций и
                                    искреннюю поддержку</p>
                            </div>
                        </div>
                    </div>
                    <div class="veb30-speaker-wrapper">
                        <div class="veb30-speaker-left">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721381352353-MrK6d-Fram.png"
                                alt="">
                            <p>Софи Бессон</p>
                        </div>
                        <div class="veb30-speaker-right">
                            <div class="single-line">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721376901142-F7jCk-Brie.png"
                                    alt="">
                                <p>4,5 года в карьерном консалтинге, с 2015 года в HR</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721376906751-iXRHS-User.png"
                                    alt="">
                                <p>600+ клиентов из локальных и крупных компаний: IBM, World Bank, Microsoft, Disney,
                                    Mastercard
                                    и др.</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721376906029-4RkWK-Eye..png"
                                    alt="">
                                <p>Помогает обнаружить проблемы, которые тормозят поиск работы на международном рынке и в
                                    СНГ
                                </p>
                            </div>
                            <div class="single-line">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721376906141-Y3Z8q-Note.png"
                                    alt="">
                                <p>Бакалавр и магистр психологии</p>
                            </div>
                            <div class="single-line">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721376906259-Hij0B-Star.png"
                                    alt="">
                                <p>9,7 из 10: средний балл оценки работы от клиентов</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721376906460-y2jNG-Thum.png"
                                    alt="">
                                <p>97% клиентов Софи отмечают: индивидуальный подход, отзывчивость, глубину рекомендаций и
                                    искреннюю поддержку</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-veb30-speaker-tablet', {
        label: 'Веб 3.0 спикер (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-veb30-speaker-tablet" data-video-id="938102634">
            <div>
                <h2>Спикер — Софи Бессон</h2>
                <div class="veb30-speaker-content speaker-video">
                    <div class="veb30-speaker-left">
                        <div class="veb30-speaker-frame">
    
                        </div>
                        <svg width="72" height="72" viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="veb30-speaker-video-button">
                            <path
                                d="M36 63C50.9117 63 63 50.9117 63 36C63 21.0883 50.9117 9 36 9C21.0883 9 9 21.0883 9 36C9 50.9117 21.0883 63 36 63Z"
                                fill="#A1E5FF" fill-opacity="0.45" stroke="#0B70FE" stroke-width="4.5"
                                stroke-miterlimit="10" />
                            <path d="M45 36L31.5 27V45L45 36Z" stroke="#0B70FE" stroke-width="4.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>
                    </div>
                    <div class="veb30-speaker-right">
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721389272574-jdTZX-Brie.png"
                                alt="">
                            <p>4,5 года в карьерном консалтинге, с 2015 года в HR</p>
                        </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721389273281-Lyj0c-User.png"
                                alt="">
                            <p>600+ клиентов из локальных и крупных компаний: IBM, World Bank, Microsoft, Disney, Mastercard
                                и др.</p>
                        </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721389272808-FXw8H-Eye..png"
                                alt="">
                            <p>Помогает обнаружить проблемы, которые тормозят поиск работы на международном рынке и в СНГ
                            </p>
                        </div>
                        <div class="single-line">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721389272924-iyj9x-Note.png"
                                alt="">
                            <p>Бакалавр и магистр психологии</p>
                        </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721389273043-DQCcy-Star.png"
                                alt="">
                            <p>9,7 из 10: средний балл оценки работы от клиентов</p>
                        </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721389273156-0NcIb-Thum.png"
                                alt="">
                            <p>97% клиентов Софи отмечают: индивидуальный подход, отзывчивость, глубину рекомендаций и
                                искреннюю поддержку</p>
                        </div>
                    </div>
                </div> 
                <div class="veb30-speaker-content speaker-one">
                    <div class="veb30-speaker-left">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721390221966-d113M-Fram.png"
                            alt="">
                    </div>
                    <div class="veb30-speaker-right">
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721389272574-jdTZX-Brie.png"
                                alt="">
                            <p>4,5 года в карьерном консалтинге, с 2015 года в HR</p>
                        </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721389273281-Lyj0c-User.png"
                                alt="">
                            <p>600+ клиентов из локальных и крупных компаний: IBM, World Bank, Microsoft, Disney, Mastercard
                                и др.</p>
                        </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721389272808-FXw8H-Eye..png"
                                alt="">
                            <p>Помогает обнаружить проблемы, которые тормозят поиск работы на международном рынке и в СНГ
                            </p>
                        </div>
                        <div class="single-line">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721389272924-iyj9x-Note.png"
                                alt="">
                            <p>Бакалавр и магистр психологии</p>
                        </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721389273043-DQCcy-Star.png"
                                alt="">
                            <p>9,7 из 10: средний балл оценки работы от клиентов</p>
                        </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721389273156-0NcIb-Thum.png"
                                alt="">
                            <p>97% клиентов Софи отмечают: индивидуальный подход, отзывчивость, глубину рекомендаций и
                                искреннюю поддержку</p>
                        </div>
                    </div>
                </div>
                <div class="veb30-speaker-content speakers-two">
                    <div class="veb30-speaker-wrapper">
                        <div class="veb30-speaker-left">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721390591881-G8Ub4-Fram.png"
                                alt="">
                            <p>Софи Бессон</p>
                        </div>
                        <div class="veb30-speaker-right">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721389272574-jdTZX-Brie.png"
                                    alt="">
                                <p>4,5 года в карьерном консалтинге, с 2015 года в HR</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721389273281-Lyj0c-User.png"
                                    alt="">
                                <p>600+ клиентов из IBM, World Bank, Microsoft, Disney, Mastercard и др.</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721389272808-FXw8H-Eye..png"
                                    alt="">
                                <p>Помогает обнаружить проблемы, которые тормозят поиск работы
                                </p>
                            </div>
                            <div class="single-line">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721389272924-iyj9x-Note.png"
                                    alt="">
                                <p>Бакалавр и магистр психологии</p>
                            </div>
                        </div>
                    </div>
                    <div class="veb30-speaker-wrapper">
                        <div class="veb30-speaker-left">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721390591881-G8Ub4-Fram.png"
                                alt="">
                            <p>Надежда Община</p>
                        </div>
                        <div class="veb30-speaker-right">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721389272574-jdTZX-Brie.png"
                                    alt="">
                                <p>4,5 года в карьерном консалтинге, с 2015 года в HR</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721389273281-Lyj0c-User.png"
                                    alt="">
                                <p>600+ клиентов из IBM, World Bank, Microsoft, Disney, Mastercard и др.</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721389272808-FXw8H-Eye..png"
                                    alt="">
                                <p>Помогает обнаружить проблемы, которые тормозят поиск работы
                                </p>
                            </div>
                            <div class="single-line">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721389272924-iyj9x-Note.png"
                                    alt="">
                                <p>Бакалавр и магистр психологии</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="veb30-speaker-content speaker-slider">
                    <div class="veb30-speaker-wrapper">
                        <div class="veb30-speaker-left">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721391994569-uHA9R-Fram.png"
                                alt="">
                        </div>
                        <div class="veb30-speaker-right">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721389272574-jdTZX-Brie.png"
                                    alt="">
                                <p>4,5 года в карьерном консалтинге, с 2015 года в HR</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721389273281-Lyj0c-User.png"
                                    alt="">
                                <p>600+ клиентов из IBM, World Bank, Microsoft, Disney, Mastercard и др.</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721389272808-FXw8H-Eye..png"
                                    alt="">
                                <p>Помогает обнаружить проблемы, которые тормозят поиск работы
                                </p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721389272924-iyj9x-Note.png"
                                    alt="">
                                <p>Бакалавр и магистр психологии</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721389273043-DQCcy-Star.png"
                                    alt="">
                                <p>9,7 из 10: средний балл оценки работы от клиентов</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721389273156-0NcIb-Thum.png"
                                    alt="">
                                <p>97% клиентов Софи отмечают: индивидуальный подход, отзывчивость, глубину рекомендаций и
                                    искреннюю поддержку</p>
                            </div>
                        </div>
                    </div>
                    <div class="veb30-speaker-wrapper">
                        <div class="veb30-speaker-left">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721391994569-uHA9R-Fram.png"
                                alt="">
                        </div>
                        <div class="veb30-speaker-right">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721389272574-jdTZX-Brie.png"
                                    alt="">
                                <p>4,5 года в карьерном консалтинге, с 2015 года в HR</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721389273281-Lyj0c-User.png"
                                    alt="">
                                <p>600+ клиентов из IBM, World Bank, Microsoft, Disney, Mastercard и др.</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721389272808-FXw8H-Eye..png"
                                    alt="">
                                <p>Помогает обнаружить проблемы, которые тормозят поиск работы
                                </p>
                            </div>
                            <div class="single-line">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721389272924-iyj9x-Note.png"
                                    alt="">
                                <p>Бакалавр и магистр психологии</p>
                            </div>
                        </div>
                    </div>
                    <div class="veb30-speaker-wrapper">
                        <div class="veb30-speaker-left">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721391994569-uHA9R-Fram.png"
                                alt="">
                        </div>
                        <div class="veb30-speaker-right">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721389272574-jdTZX-Brie.png"
                                    alt="">
                                <p>4,5 года в карьерном консалтинге, с 2015 года в HR</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721389273281-Lyj0c-User.png"
                                    alt="">
                                <p>600+ клиентов из IBM, World Bank, Microsoft, Disney, Mastercard и др.</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721389272808-FXw8H-Eye..png"
                                    alt="">
                                <p>Помогает обнаружить проблемы, которые тормозят поиск работы
                                </p>
                            </div>
                            <div class="single-line">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721389272924-iyj9x-Note.png"
                                    alt="">
                                <p>Бакалавр и магистр психологии</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-veb30-speaker-mobile', {
        label: 'Веб 3.0 спикер (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-veb30-speaker-mobile">
            <div>
                <h2>Спикер — Софи Бессон</h2>
                <div class="veb30-speaker-content speaker-one">
                    <div class="veb30-speaker-left">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721545325166-rkhPp-Fram.png" alt="">
                    </div>
                    <div class="veb30-speaker-right">
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721545629590-jYx5K-Brie.png"
                                alt="">
                            <p>4,5 года в карьерном консалтинге, с 2015 года в HR</p>
                        </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721545630266-rxlJV-User.png"
                                alt="">
                            <p>600+ клиентов из локальных и крупных компаний: IBM, World Bank, Microsoft, Disney, Mastercard
                                и др.</p>
                        </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721545629798-6UGIY-Eye..png"
                                alt="">
                            <p>Помогает обнаружить проблемы, которые тормозят поиск работы на международном рынке и в СНГ
                            </p>
                        </div>
                        <div class="single-line">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721545629918-CDfqR-Note.png"
                                alt="">
                            <p>Бакалавр и магистр психологии</p>
                        </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721545630045-FCg7I-Star.png"
                                alt="">
                            <p>9,7 из 10: средний балл оценки работы от клиентов</p>
                        </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721545630161-4lnTA-Thum.png"
                                alt="">
                            <p>97% клиентов Софи отмечают: индивидуальный подход, отзывчивость, глубину рекомендаций и
                                искреннюю поддержку</p>
                        </div>
                    </div>
                </div>
                <div class="veb30-speaker-content speaker-slider">
                    <div class="veb30-speaker-wrapper">
                        <div class="veb30-speaker-left">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721391994569-uHA9R-Fram.png"
                                alt="">
                        </div>
                        <div class="veb30-speaker-right">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721545629590-jYx5K-Brie.png"
                                    alt="">
                                <p>4,5 года в карьерном консалтинге, с 2015 года в HR</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721545630266-rxlJV-User.png"
                                    alt="">
                                <p>600+ клиентов из локальных и крупных компаний: IBM, World Bank, Microsoft, Disney, Mastercard
                                    и др.</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721545629798-6UGIY-Eye..png"
                                    alt="">
                                <p>Помогает обнаружить проблемы, которые тормозят поиск работы на международном рынке и в СНГ
                                </p>
                            </div>
                            <div class="single-line">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721545629918-CDfqR-Note.png"
                                    alt="">
                                <p>Бакалавр и магистр психологии</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721545630045-FCg7I-Star.png"
                                    alt="">
                                <p>9,7 из 10: средний балл оценки работы от клиентов</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721545630161-4lnTA-Thum.png"
                                    alt="">
                                <p>97% клиентов Софи отмечают: индивидуальный подход, отзывчивость, глубину рекомендаций и
                                    искреннюю поддержку</p>
                            </div>
                        </div>
                    </div>
                    <div class="veb30-speaker-wrapper">
                        <div class="veb30-speaker-left">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721391994569-uHA9R-Fram.png"
                                alt="">
                        </div>
                        <div class="veb30-speaker-right">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721545629590-jYx5K-Brie.png"
                                    alt="">
                                <p>4,5 года в карьерном консалтинге, с 2015 года в HR</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721545630266-rxlJV-User.png"
                                    alt="">
                                <p>600+ клиентов из локальных и крупных компаний: IBM, World Bank, Microsoft, Disney, Mastercard
                                    и др.</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721545629798-6UGIY-Eye..png"
                                    alt="">
                                <p>Помогает обнаружить проблемы, которые тормозят поиск работы на международном рынке и в СНГ
                                </p>
                            </div>
                            <div class="single-line">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721545629918-CDfqR-Note.png"
                                    alt="">
                                <p>Бакалавр и магистр психологии</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721545630045-FCg7I-Star.png"
                                    alt="">
                                <p>9,7 из 10: средний балл оценки работы от клиентов</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721545630161-4lnTA-Thum.png"
                                    alt="">
                                <p>97% клиентов Софи отмечают: индивидуальный подход, отзывчивость, глубину рекомендаций и
                                    искреннюю поддержку</p>
                            </div>
                        </div>
                    </div>
                    <div class="veb30-speaker-wrapper">
                        <div class="veb30-speaker-left">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721391994569-uHA9R-Fram.png"
                                alt="">
                        </div>
                        <div class="veb30-speaker-right">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721389272574-jdTZX-Brie.png"
                                    alt="">
                                <p>4,5 года в карьерном консалтинге, с 2015 года в HR</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721389273281-Lyj0c-User.png"
                                    alt="">
                                <p>600+ клиентов из IBM, World Bank, Microsoft, Disney, Mastercard и др.</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721389272808-FXw8H-Eye..png"
                                    alt="">
                                <p>Помогает обнаружить проблемы, которые тормозят поиск работы
                                </p>
                            </div>
                            <div class="single-line">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721389272924-iyj9x-Note.png"
                                    alt="">
                                <p>Бакалавр и магистр психологии</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
	});
    
    blockManager.add('careerum-veb30-how', {
        label: 'Веб 3.0 как изменит',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-veb30-how">
            <div>
                <h2>Как вебинар изменит вашу карьеру</h2>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721377367041-9floa-Vect.png" alt="">
                <div class="veb30-how-content">
                    <div class="veb30-how-content-item">
                        <div>
                            <p>Отправляете резюме пачками, а в ответ — тишина или отказы</p>
                            <p>Считаете, что найти классную работу —невозможно</p>
                        </div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721378433955-mqZx4-Unio.png"
                            alt="">
                        <div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721377462223-giMU3-Chec.png"
                                    alt="">
                                <p>После вебинара</p>
                            </div>
                            <p>Стабильно получаете приглашения на собеседования и офферы. Все у вас супер, резюме влюбляет
                                эйчаров. Строчка на всякий слуяай</p>
                        </div>
                    </div>
                    <div class="veb30-how-content-item">
                        <div>
                            <p>Хотите, чтобы резюме кто-то сделал за вас</p>
                            <p>Не понимаете, как все уместить на одну страницу</p>
                        </div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721378670800-2M0cJ-Unio.png"
                            alt="">
                        <div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721377462223-giMU3-Chec.png"
                                    alt="">
                                <p>После вебинара</p>
                            </div>
                            <p>Стабильно получаете<br> приглашения на собеседования и офферы. Все у вас супер, резюме
                                влюбляет эйчаров</p>
                        </div>
                    </div>
                    <div class="veb30-how-content-item">
                        <div>
                            <p>Никогда не писали резюме, не знаете с чего начать</p>
                            <p>Никогда не писали резюме, не знаете с чего начать</p>
                            <p>Хотите, чтобы резюме кто-то сделал за вас</p>
                        </div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721378760763-n0xGf-Unio.png"
                            alt="">
                        <div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721377462223-giMU3-Chec.png"
                                    alt="">
                                <p>После вебинара</p>
                            </div>
                            <p>Стабильно получаете<br> приглашения на собеседования и офферы. Все у вас супер, резюме
                                влюбляет эйчаров</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-veb30-how-tablet', {
        label: 'Веб 3.0 как изменит (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-veb30-how-tablet">
            <div>
                <h2>Как вебинар изменит вашу карьеру</h2>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721393453333-YZpQx-Vect.png" alt="">
                <div class="veb30-how-content">
                    <div class="veb30-how-content-item">
                        <div>
                            <p>Отправляете резюме пачками, а в ответ — тишина или отказы</p>
                            <p>Считаете, что найти классную работу —невозможно</p>
                        </div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721393094691-j1rie-Unio.png"
                            alt="">
                        <div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721377462223-giMU3-Chec.png"
                                    alt="">
                                <p>После вебинара</p>
                            </div>
                            <p>Стабильно получаете приглашения на собеседования и офферы. Все у вас супер, резюме
                                влюбляет
                                эйчаров. Строчка на всякий слуяай</p>
                        </div>
                    </div>
                    <div class="veb30-how-content-item">
                        <div>
                            <p>Хотите, чтобы резюме кто-то сделал за вас</p>
                            <p>Не понимаете, как все уместить на одну страницу</p>
                        </div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721393094691-j1rie-Unio.png"
                            alt="">
                        <div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721377462223-giMU3-Chec.png"
                                    alt="">
                                <p>После вебинара</p>
                            </div>
                            <p>Стабильно получаете<br> приглашения на собеседования и офферы. Все у вас супер, резюме
                                влюбляет эйчаров</p>
                        </div>
                    </div>
                    <div class="veb30-how-content-item">
                        <div>
                            <p>Никогда не писали резюме, не знаете с чего начать</p>
                            <p>Никогда не писали резюме, не знаете с чего начать</p>
                            <p>Хотите, чтобы резюме кто-то сделал за вас</p>
                        </div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721393117208-RNyM6-Unio.png"
                            alt="">
                        <div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721377462223-giMU3-Chec.png"
                                    alt="">
                                <p>После вебинара</p>
                            </div>
                            <p>Стабильно получаете<br> приглашения на собеседования и офферы. Все у вас супер, резюме
                                влюбляет эйчаров</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-veb30-how-mobile', {
        label: 'Веб 3.0 как изменит (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-veb30-how-mobile">
            <div>
                <div class="veb30-how-content">
                    <div class="veb30-how-content-item">
                        <div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721377462223-giMU3-Chec.png"
                                    alt="">
                                <p>После вебинара</p>
                            </div>
                            <p>Стабильно получаете приглашения на собеседования и офферы. Все у вас супер, резюме
                                влюбляет
                                эйчаров. Строчка на всякий слуяай</p>
                        </div>
                    </div>
                    <div class="veb30-how-content-item">
                        <div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721377462223-giMU3-Chec.png"
                                    alt="">
                                <p>После вебинара</p>
                            </div>
                            <p>Стабильно получаете<br> приглашения на собеседования и офферы. Все у вас супер, резюме
                                влюбляет эйчаров</p>
                        </div>
                    </div>
                    <div class="veb30-how-content-item">
                        <div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721377462223-giMU3-Chec.png"
                                    alt="">
                                <p>После вебинара</p>
                            </div>
                            <p>Стабильно получаете<br> приглашения на собеседования и офферы. Все у вас супер, резюме
                                влюбляет эйчаров</p>
                        </div>
                    </div>
                </div>
                <div class="veb30-how-bottom">
                    <p>Бонусы участникам</p>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721546189502-paa4Q-1.pn.png"
                            alt="">
                        <p>Чек-лист для вашего резюме</p>
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721546189713-ZOiXN-2.pn.png"
                            alt="">
                        <p>Прожарка резюме в прямом эфире</p>
                    </div>
                </div>
            </div>
        </div>`
	});
    
    blockManager.add('careerum-veb30-form-block', {
        label: 'Веб 3.0 форма',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-veb30-form-block">
            <div>
                <div class="veb30-form-left">
                    <p>Бесплатный вебинар, 21 марта в 18:00 МСК </p>
                    <h2>5 ошибок, которые вредят вашему резюме</h2>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721378978947-lp93y-Fram.png" alt="">
                </div>
                <div class="veb30-form-right">
                    <div class="careerum-registration-form">
                        <form class="deva-form getcourse-email-signup" name="devaRegistrationForm"
                            data-gjs-type="deva-registration-form">
                            <div class="careerum-veb30-form-name">
                                <input type="text" name="name" value="" required placeholder="Имя">
                            </div>
                            <div class="careerum-veb30-form-email">
                                <input type="text" name="email" value="" required placeholder="Почта">
                            </div>
                            <div class="careerum-veb30-form-telegram">
                                <input type="text" name="telegram" value="" required placeholder="Telegram">
                            </div>
                            <div class="careerum-veb30-form-phone">
                                <input type="tel" value="" name="tel" required class="itl-input">
                            </div>
                            <div class="careerum-veb30-form-agree">
                                <label>
                                    <input type="checkbox" name="agree">
                                    <div>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8"
                                            fill="none">
                                            <path
                                                d="M1 2.84615L3.14168 6.70118C3.21595 6.83487 3.40669 6.83912 3.48685 6.70887L7 1"
                                                stroke="black" stroke-width="1.5" stroke-linecap="round" />
                                        </svg>
                                    </div>
                                </label>
                                <p>Я даю согласие на обработку своих персональных данных<br> в соответствии с <a
                                        href="/ru-ru/legal/privacy" target="_blank">Политикой конфиденциальности</a></p>
                            </div>
                            <a href="#" class="submit-btn btn-color-main-bright-orange button-sent"
                                disabled>Зарегистрироваться бесплатно</a>
                        </form>
                    </div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-veb30-form-block-tablet', {
        label: 'Веб 3.0 форма (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-veb30-form-block-tablet">
            <div>
                <div class="veb30-form-left">
                    <div class="veb30-form-labels">
                        <div class="veb30-form-labels-white">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721385591351-Y6qYU-Cale.png"
                                alt="">
                            <p>21 марта в 18:00 мск </p>
                        </div>
                        <div class="veb30-form-labels-orange">
                            <p>Бесплатный вебинар</p>
                        </div>
                    </div>
                    <h2>5 ошибок, которые вредят вашему резюме</h2>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721393969225-LUhbE-Fram.png" alt="">
                </div>
                <div class="veb30-form-right">
                    <div class="careerum-registration-form-tablet">
                        <form class="deva-form getcourse-email-signup" name="devaRegistrationForm"
                            data-gjs-type="deva-registration-form">
                            <div class="careerum-veb30-form-name">
                                <input type="text" name="name" value="" required placeholder="Имя">
                            </div>
                            <div class="careerum-veb30-form-email">
                                <input type="text" name="email" value="" required placeholder="Почта">
                            </div>
                            <div class="careerum-veb30-form-telegram">
                                <input type="text" name="telegram" value="" required placeholder="Telegram">
                            </div>
                            <div class="careerum-veb30-form-phone">
                                <input type="tel" value="" name="tel" required class="itl-input">
                            </div>
                            <div class="careerum-veb30-form-agree">
                                <label>
                                    <input type="checkbox" name="agree">
                                    <div>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8"
                                            fill="none">
                                            <path
                                                d="M1 2.84615L3.14168 6.70118C3.21595 6.83487 3.40669 6.83912 3.48685 6.70887L7 1"
                                                stroke="black" stroke-width="1.5" stroke-linecap="round" />
                                        </svg>
                                    </div>
                                </label>
                                <p>Я даю согласие на обработку своих персональных данных в соответствии<br> с <a
                                        href="/ru-ru/legal/privacy" target="_blank">Политикой конфиденциальности</a></p>
                            </div>
                            <a href="#" class="submit-btn btn-color-main-bright-orange button-sent"
                                disabled>Зарегистрироваться бесплатно</a>
                        </form>
                    </div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('careerum-veb30-form-block-mobile', {
        label: 'Веб 3.0 форма (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="careerum-veb30-form-block-mobile">
            <div>
                <div class="veb30-form-left">
                    <div class="veb30-form-labels">
                        <div class="veb30-form-labels-white">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1721385591351-Y6qYU-Cale.png"
                                alt="">
                            <p>21 марта в 18:00 мск </p>
                        </div>
                        <div class="veb30-form-labels-orange">
                            <p>Бесплатный вебинар</p>
                        </div>
                    </div>
                    <h2>5 ошибок, которые вредят вашему резюме</h2>
                </div>
                <div class="veb30-form-right">
                    <div class="careerum-registration-form-mobile">
                        <form class="deva-form getcourse-email-signup" name="devaRegistrationForm"
                            data-gjs-type="deva-registration-form">
                            <div class="careerum-veb30-form-name">
                                <input type="text" name="name" value="" required placeholder="Имя">
                            </div>
                            <div class="careerum-veb30-form-email">
                                <input type="text" name="email" value="" required placeholder="Почта">
                            </div>
                            <div class="careerum-veb30-form-telegram">
                                <input type="text" name="telegram" value="" required placeholder="Telegram">
                            </div>
                            <div class="careerum-veb30-form-phone">
                                <input type="tel" value="" name="tel" required class="itl-input">
                            </div>
                            <div class="careerum-veb30-form-agree">
                                <label>
                                    <input type="checkbox" name="agree">
                                    <div>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8"
                                            fill="none">
                                            <path
                                                d="M1 2.84615L3.14168 6.70118C3.21595 6.83487 3.40669 6.83912 3.48685 6.70887L7 1"
                                                stroke="black" stroke-width="1.5" stroke-linecap="round" />
                                        </svg>
                                    </div>
                                </label>
                                <p>Я даю согласие на обработку своих персональных данных в соответствии с <a
                                        href="/ru-ru/legal/privacy" target="_blank">Политикой конфиденциальности</a></p>
                            </div>
                            <a href="#" class="submit-btn btn-color-main-bright-orange button-sent"
                                disabled>Зарегистрироваться бесплатно</a>
                        </form>
                    </div>
                </div>
            </div>
        </div>`
	});

    blockManager.add('cookie-banners', {
        label: 'Уведомление cookies',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="cookie-banners">
            <div class="cookie-banners_container">
                <div class="cookie-banners_head">
                <div class="cookie-banners_header">Уведомление о куки
                </div>
                <div class="cookie-banners_close" role="button" tabindex="0">
                </div>
                </div>
                <div class="cookie-banners_text">Нажимая 
                <strong>“Принять”</strong>, вы соглашаетесь на хранение файлов
                cookie.
                Ознакомьтесь с нашей 
                <a href="/privacy-policy" class="cookie-banners_text-link">Политикой
                    конфиденциальности</a> для получения дополнительной информации.
                </div>
                <div class="cookie-banners_buttons-wrapper">
                <button class="cookie-banners_button allow-cookie" tabindex="0">Принять</button>
                <button class="cookie-banners_button-bordered disallow-cookie" tabindex="0">Отклонить</button>
                <button class="cookie-banners_button allow-cookie" tabindex="0">Accept</button>
                <button class="cookie-banners_button-bordered disallow-cookie" tabindex="0">Deny</button>
                </div>
            </div>
        </div>`
	});


}